export const cities = [
	{ city: 'Abartagh (Waterford)', zip: '869428' },
	{ city: 'Abberanville (Galway)', zip: '788484' },
	{ city: 'Abbernadoorny (Donegal)', zip: '406236' },
	{ city: 'Abbert (Galway)', zip: '202467' },
	{ city: 'Abbert Demesne (Galway)', zip: '418090' },
	{ city: 'Abbeville (Tipperary)', zip: '505189' },
	{ city: 'Abbey (Cork)', zip: '464847' },
	{ city: 'Abbey (Galway)', zip: '966324' },
	{ city: 'Abbey (Limerick)', zip: '537889' },
	{ city: 'Abbeycartron (Longford)', zip: '782973' },
	{ city: 'Abbeycartron (Roscommon)', zip: '347889' },
	{ city: 'Abbeyderg (Longford)', zip: '572471' },
	{ city: 'Abbeydorney (Kerry)', zip: '146585' },
	{ city: 'Abbeydown (Wexford)', zip: '617568' },
	{ city: 'Abbey East (Clare)', zip: '139027' },
	{ city: 'Abbeyfarm (Limerick)', zip: '762361' },
	{ city: 'Abbeyfeale (Limerick)', zip: '373377' },
	{ city: 'Abbeyfeale East (Limerick)', zip: '904454' },
	{ city: 'Abbeyfeale West (Limerick)', zip: '823803' },
	{ city: 'Abbeyfield (Galway)', zip: '347149' },
	{ city: 'Abbeygormacan (Galway)', zip: '771343' },
	{ city: 'Abbeygrove (Kilkenny)', zip: '791655' },
	{ city: 'Abbeyhalfquarter (Mayo)', zip: '597898' },
	{ city: 'Abbey Island (Donegal)', zip: '304614' },
	{ city: 'Abbey Island (Kerry)', zip: '902650' },
	{ city: 'Abbeyland (Cavan)', zip: '578087' },
	{ city: 'Abbeyland (Kildare)', zip: '485223' },
	{ city: 'Abbeyland (Meath)', zip: '367630' },
	{ city: 'Abbeyland (Westmeath)', zip: '347471' },
	{ city: 'Abbey Land (Longford)', zip: '491892' },
	{ city: 'Abbeyland And Charlestown (Westmeath)', zip: '351024' },
	{ city: 'Abbeyland Great (Galway)', zip: '436770' },
	{ city: 'Abbeyland Little (Galway)', zip: '468599' },
	{ city: 'Abbeyland North (Galway)', zip: '878150' },
	{ city: 'Abbeylands (Donegal)', zip: '375504' },
	{ city: 'Abbeylands (Kerry)', zip: '548806' },
	{ city: 'Abbeylands (Kilkenny)', zip: '876448' },
	{ city: 'Abbeylands (Limerick)', zip: '273386' },
	{ city: 'Abbeylands (Mayo)', zip: '232142' },
	{ city: 'Abbeylands (Wicklow)', zip: '259749' },
	{ city: 'Abbey-Lands (Cork)', zip: '814120' },
	{ city: 'Abbeyland South (Galway)', zip: '661434' },
	{ city: 'Abbeyland South (Meath)', zip: '843440' },
	{ city: 'Abbeylara (Longford)', zip: '415121' },
	{ city: 'Abbeyleix (Laois)', zip: '580455' },
	{ city: 'Abbeyleix Demesne (Laois)', zip: '900015' },
	{ city: 'Abbeymahon (Cork)', zip: '524192' },
	{ city: 'Abbeypark (Galway)', zip: '505805' },
	{ city: 'Abbeyquarter (Mayo)', zip: '137306' },
	{ city: 'Abbeyquarter North (Sligo)', zip: '159131' },
	{ city: 'Abbeyquarter South (Sligo)', zip: '741013' },
	{ city: 'Abbeyshrule (Longford)', zip: '610613' },
	{ city: 'Abbeyside (Waterford)', zip: '421779' },
	{ city: 'Abbeystrowry (Cork)', zip: '920280' },
	{ city: 'Abbeytown (Galway)', zip: '913828' },
	{ city: 'Abbeytown (Mayo)', zip: '705197' },
	{ city: 'Abbeytown (Sligo)', zip: '101524' },
	{ city: 'Abbeyville (Dublin)', zip: '703506' },
	{ city: 'Abbeyville (Galway)', zip: '195660' },
	{ city: 'Abbeyville (Sligo)', zip: '777837' },
	{ city: 'Abbey West (Clare)', zip: '261620' },
	{ city: 'Abbotstown (Dublin)', zip: '499088' },
	{ city: 'Abelstown (Meath)', zip: '213109' },
	{ city: 'Abington (Limerick)', zip: '735936' },
	{ city: 'Ablintown (Wexford)', zip: '337435' },
	{ city: 'Acantha (Offaly)', zip: '491666' },
	{ city: 'Acarreagh (Louth)', zip: '681837' },
	{ city: 'Acaun (Carlow)', zip: '202922' },
	{ city: 'Achillbeg Island (Mayo)', zip: '486706' },
	{ city: 'Achill Sound (Mayo)', zip: '206146' },
	{ city: 'Achonry (Sligo)', zip: '411991' },
	{ city: 'Ackeys Island (Donegal)', zip: '201267' },
	{ city: 'Aclamon (Wexford)', zip: '670497' },
	{ city: 'Aclare (Carlow)', zip: '924421' },
	{ city: 'Aclare (Sligo)', zip: '488848' },
	{ city: 'Aclint (Louth)', zip: '752398' },
	{ city: 'Acraboy (Tipperary)', zip: '965048' },
	{ city: 'Acragar (Kilkenny)', zip: '411707' },
	{ city: 'Acragar (Laois)', zip: '159472' },
	{ city: 'Acraroe (Kilkenny)', zip: '160500' },
	{ city: 'Acre Beg (Galway)', zip: '425924' },
	{ city: 'Acre East (Galway)', zip: '634344' },
	{ city: 'Acre More (Galway)', zip: '734847' },
	{ city: 'Acrenakirka (Tipperary)', zip: '941928' },
	{ city: 'Acres (Cavan)', zip: '521122' },
	{ city: 'Acres (Clare)', zip: '108164' },
	{ city: 'Acres (Cork)', zip: '802888' },
	{ city: 'Acres (Galway)', zip: '429145' },
	{ city: 'Acres (Kerry)', zip: '835104' },
	{ city: 'Acres (Leitrim)', zip: '964557' },
	{ city: 'Acres (Limerick)', zip: '589496' },
	{ city: 'Acres (Longford)', zip: '584844' },
	{ city: 'Acres (Mayo)', zip: '478071' },
	{ city: 'Acres (Monaghan)', zip: '549231' },
	{ city: 'Acres (Roscommon)', zip: '169727' },
	{ city: 'Acres (Waterford)', zip: '268233' },
	{ city: 'Acre West (Galway)', zip: '357862' },
	{ city: 'Adamstown (Cork)', zip: '405901' },
	{ city: 'Adamstown (Dublin)', zip: '147605' },
	{ city: 'Adamstown (Limerick)', zip: '185880' },
	{ city: 'Adamstown (Louth)', zip: '891460' },
	{ city: 'Adamstown (Meath)', zip: '831595' },
	{ city: 'Adamstown (Tipperary)', zip: '443782' },
	{ city: 'Adamstown (Waterford)', zip: '239988' },
	{ city: 'Adamstown (Westmeath)', zip: '287426' },
	{ city: 'Adamstown (Wexford)', zip: '742116' },
	{ city: 'Adamstown Lower (Kilkenny)', zip: '127574' },
	{ city: 'Adamstown Upper (Kilkenny)', zip: '408009' },
	{ city: 'Adamswood (Limerick)', zip: '126587' },
	{ city: 'Adare (Limerick)', zip: '759460' },
	{ city: 'Addane (Tipperary)', zip: '193857' },
	{ city: 'Addanstown (Meath)', zip: '474671' },
	{ city: 'Addergoole (Clare)', zip: '126870' },
	{ city: 'Addergoole (Galway)', zip: '273011' },
	{ city: 'Addergoole (Laois)', zip: '722409' },
	{ city: 'Addergoole (Mayo)', zip: '853114' },
	{ city: 'Addergoole Beg (Galway)', zip: '949713' },
	{ city: 'Addergoole More (Galway)', zip: '383447' },
	{ city: 'Addergoole North (Galway)', zip: '278953' },
	{ city: 'Addergoole South (Galway)', zip: '124374' },
	{ city: 'Addergoole West (Galway)', zip: '203015' },
	{ city: 'Addergown (Kerry)', zip: '254970' },
	{ city: 'Adderville (Donegal)', zip: '881665' },
	{ city: 'Adderwal (Donegal)', zip: '214532' },
	{ city: 'Addinstown (Westmeath)', zip: '581309' },
	{ city: 'Addragool (Galway)', zip: '243343' },
	{ city: 'Addrigoole (Waterford)', zip: '914762' },
	{ city: 'Addroon (Clare)', zip: '294464' },
	{ city: 'Aderavoher (Sligo)', zip: '144173' },
	{ city: 'Adereen (Leitrim)', zip: '720860' },
	{ city: 'Aderg (Mayo)', zip: '415159' },
	{ city: 'Aderrig (Dublin)', zip: '333280' },
	{ city: 'Admiran (Donegal)', zip: '368184' },
	{ city: 'Adoon (Leitrim)', zip: '282513' },
	{ city: 'Adragool (Roscommon)', zip: '296534' },
	{ city: 'Adramone Beg (Waterford)', zip: '125632' },
	{ city: 'Adramone More (Waterford)', zip: '642960' },
	{ city: 'Adraval (Kerry)', zip: '244105' },
	{ city: 'Adrigole (Cork)', zip: '411549' },
	{ city: 'Adrigool (Cork)', zip: '188740' },
	{ city: 'Adrivale (Cork)', zip: '805917' },
	{ city: 'Adruel (Offaly)', zip: '728013' },
	{ city: 'Afaddy (Kilkenny)', zip: '674148' },
	{ city: 'Affane (Waterford)', zip: '785844' },
	{ city: 'Affane Hunter (Waterford)', zip: '476916' },
	{ city: 'Affick (Clare)', zip: '585725' },
	{ city: 'Affoley (Tipperary)', zip: '577691' },
	{ city: 'Affollus (Meath)', zip: '862796' },
	{ city: 'Affouley (Kerry)', zip: '636945' },
	{ city: 'Afoley (Laois)', zip: '597690' },
	{ city: 'Agall (Offaly)', zip: '321255' },
	{ city: 'Aggard Beg (Galway)', zip: '402841' },
	{ city: 'Aggard More (Galway)', zip: '215746' },
	{ city: 'Agha (Carlow)', zip: '801948' },
	{ city: 'Agha (Cork)', zip: '849984' },
	{ city: 'Agha (Kilkenny)', zip: '351081' },
	{ city: 'Aghabane (Cavan)', zip: '567565' },
	{ city: 'Aghabeg (Carlow)', zip: '256291' },
	{ city: 'Aghabeg (Cork)', zip: '318024' },
	{ city: 'Aghabeg East (Kerry)', zip: '141393' },
	{ city: 'Aghabeg Middle (Kerry)', zip: '852363' },
	{ city: 'Aghabeg West (Kerry)', zip: '837020' },
	{ city: 'Aghabehy (Roscommon)', zip: '579158' },
	{ city: 'Aghaboe (Laois)', zip: '336868' },
	{ city: 'Aghabog (Monaghan)', zip: '430702' },
	{ city: 'Aghaboneill (Leitrim)', zip: '616972' },
	{ city: 'Aghaboy (Cavan)', zip: '768475' },
	{ city: 'Aghaboy (Longford)', zip: '322235' },
	{ city: 'Aghaboy (Monaghan)', zip: '509148' },
	{ city: 'Aghaboy (Offaly)', zip: '871242' },
	{ city: 'Aghaboy North (Monaghan)', zip: '172031' },
	{ city: 'Aghaboys (Louth)', zip: '625480' },
	{ city: 'Aghaboy South (Monaghan)', zip: '566236' },
	{ city: 'Aghabrack (Longford)', zip: '589005' },
	{ city: 'Aghabrack (Westmeath)', zip: '366398' },
	{ city: 'Aghabrick (Monaghan)', zip: '705948' },
	{ city: 'Aghabullogue (Cork)', zip: '621534' },
	{ city: 'Aghaburren (Cork)', zip: '638976' },
	{ city: 'Aghacarra (Roscommon)', zip: '987445' },
	{ city: 'Aghacarrible (Kerry)', zip: '721091' },
	{ city: 'Aghacashel (Cavan)', zip: '477306' },
	{ city: 'Aghacashel (Leitrim)', zip: '319009' },
	{ city: 'Aghacashlaun (Leitrim)', zip: '880223' },
	{ city: 'Aghaclay (Monaghan)', zip: '815897' },
	{ city: 'Aghaclogha (Monaghan)', zip: '481152' },
	{ city: 'Aghacloghan (Monaghan)', zip: '270978' },
	{ city: 'Aghaclogher (Roscommon)', zip: '436527' },
	{ city: 'Aghacocara (Westmeath)', zip: '659428' },
	{ city: 'Aghaconny (Cavan)', zip: '434270' },
	{ city: 'Aghacoora (Kerry)', zip: '358841' },
	{ city: 'Aghacordrinan (Longford)', zip: '947957' },
	{ city: 'Aghacreevy (Cavan)', zip: '433847' },
	{ city: 'Aghacross (Cork)', zip: '439337' },
	{ city: 'Aghacunna (Cork)', zip: '766271' },
	{ city: 'Aghacurreen (Kerry)', zip: '872672' },
	{ city: 'Aghacurreen (Roscommon)', zip: '748411' },
	{ city: 'Aghada (Cork)', zip: '698255' },
	{ city: 'Aghadachor (Donegal)', zip: '457115' },
	{ city: 'Aghadaghly (Donegal)', zip: '225748' },
	{ city: 'Aghadangan (Roscommon)', zip: '430221' },
	{ city: 'Aghadark (Leitrim)', zip: '383380' },
	{ city: 'Aghadaugh (Westmeath)', zip: '210494' },
	{ city: 'Aghade (Carlow)', zip: '405673' },
	{ city: 'Aghadegnan (Longford)', zip: '360198' },
	{ city: 'Aghaderrard East (Leitrim)', zip: '541454' },
	{ city: 'Aghaderrard West (Leitrim)', zip: '156663' },
	{ city: 'Aghaderry (Monaghan)', zip: '402966' },
	{ city: 'Aghaderry (Roscommon)', zip: '351561' },
	{ city: 'Aghadiffin (Mayo)', zip: '674203' },
	{ city: 'Aghadoe (Cork)', zip: '617027' },
	{ city: 'Aghadonagh (Longford)', zip: '233331' },
	{ city: 'Aghadonagh (Offaly)', zip: '400847' },
	{ city: 'Aghadooey Glebe (Mayo)', zip: '346712' },
	{ city: 'Aghadoon (Cavan)', zip: '102388' },
	{ city: 'Aghadoon (Mayo)', zip: '666827' },
	{ city: 'Aghadouglas (Offaly)', zip: '637566' },
	{ city: 'Aghadowey (Donegal)', zip: '408457' },
	{ city: 'Aghadown (Cork)', zip: '685525' },
	{ city: 'Aghadowry (Longford)', zip: '893547' },
	{ city: 'Aghadreen (Laois)', zip: '524026' },
	{ city: 'Aghadreenagh (Cavan)', zip: '134161' },
	{ city: 'Aghadreenan (Donegal)', zip: '546889' },
	{ city: 'Aghadreenan (Monaghan)', zip: '992450' },
	{ city: 'Aghadrestan (Roscommon)', zip: '375926' },
	{ city: 'Aghadrinagh (Mayo)', zip: '781921' },
	{ city: 'Aghadrumcarn (Leitrim)', zip: '224608' },
	{ city: 'Aghadrumcru (Monaghan)', zip: '412906' },
	{ city: 'Aghadrumderg (Leitrim)', zip: '414838' },
	{ city: 'Aghadrumdoney (Monaghan)', zip: '873974' },
	{ city: 'Aghadrumgowna (Cavan)', zip: '261698' },
	{ city: 'Aghadrumgullin (Cavan)', zip: '480413' },
	{ city: 'Aghadruminshin (Leitrim)', zip: '882721' },
	{ city: 'Aghadrumkeen (Monaghan)', zip: '947510' },
	{ city: 'Aghaduff (Cork)', zip: '823881' },
	{ city: 'Aghadunvane (Leitrim)', zip: '152226' },
	{ city: 'Aghafad (Cavan)', zip: '695357' },
	{ city: 'Aghafad (Longford)', zip: '810242' },
	{ city: 'Aghafad (Monaghan)', zip: '500244' },
	{ city: 'Aghafadda (Galway)', zip: '707116' },
	{ city: 'Aghafadda (Mayo)', zip: '301436' },
	{ city: 'Aghafarnan (Meath)', zip: '360281' },
	{ city: 'Aghafin (Laois)', zip: '919145' },
	{ city: 'Aghafin (Longford)', zip: '621021' },
	{ city: 'Aghafin (Monaghan)', zip: '448083' },
	{ city: 'Aghafin (Offaly)', zip: '833513' },
	{ city: 'Aghafin (Roscommon)', zip: '609377' },
	{ city: 'Aghafin (Westmeath)', zip: '816076' },
	{ city: 'Aghafore (Cork)', zip: '151127' },
	{ city: 'Aghafoy (Donegal)', zip: '205814' },
	{ city: 'Aghafullim (Kildare)', zip: '442255' },
	{ city: 'Aghagad (Roscommon)', zip: '472747' },
	{ city: 'Aghagad (Sligo)', zip: '117542' },
	{ city: 'Aghagadda (Kerry)', zip: '654886' },
	{ city: 'Aghagah (Longford)', zip: '672311' },
	{ city: 'Aghagally (Monaghan)', zip: '101047' },
	{ city: 'Aghagashlan (Cavan)', zip: '548819' },
	{ city: 'Aghagaw (Monaghan)', zip: '311895' },
	{ city: 'Aghagegna (Cavan)', zip: '700636' },
	{ city: 'Aghaginny (Leitrim)', zip: '456261' },
	{ city: 'Aghaglasheen (Mayo)', zip: '645869' },
	{ city: 'Aghaglass (Monaghan)', zip: '402289' },
	{ city: 'Aghaglassan (Donegal)', zip: '448461' },
	{ city: 'Aghaglinny North (Clare)', zip: '384740' },
	{ city: 'Aghaglinny South (Clare)', zip: '464074' },
	{ city: 'Aghagolrick (Cavan)', zip: '107075' },
	{ city: 'Aghagoogy (Offaly)', zip: '757920' },
	{ city: 'Aghagooheen (Cork)', zip: '436196' },
	{ city: 'Aghagower (Mayo)', zip: '840818' },
	{ city: 'Aghagower (Roscommon)', zip: '792401' },
	{ city: 'Aghagowla (Roscommon)', zip: '776672' },
	{ city: 'Aghagowla Beg (Mayo)', zip: '289678' },
	{ city: 'Aghagowla More (Mayo)', zip: '732351' },
	{ city: 'Aghagrania (Leitrim)', zip: '507864' },
	{ city: 'Aghagreagh (Longford)', zip: '460692' },
	{ city: 'Aghagurty (Offaly)', zip: '350538' },
	{ city: 'Aghahull (Donegal)', zip: '606088' },
	{ city: 'Aghakee (Cavan)', zip: '148145' },
	{ city: 'Aghakeel (Longford)', zip: '987435' },
	{ city: 'Aghakeeran (Longford)', zip: '366586' },
	{ city: 'Aghakilbrack (Leitrim)', zip: '597142' },
	{ city: 'Aghakilconnell (Leitrim)', zip: '530871' },
	{ city: 'Aghakilfaughna (Leitrim)', zip: '860722' },
	{ city: 'Aghakilmore (Leitrim)', zip: '626765' },
	{ city: 'Aghakilmore (Longford)', zip: '164525' },
	{ city: 'Aghakilmore Lower (Cavan)', zip: '737801' },
	{ city: 'Aghakilmore Upper (Cavan)', zip: '679628' },
	{ city: 'Aghakine (Longford)', zip: '471299' },
	{ city: 'Aghakinnigh (Cavan)', zip: '515638' },
	{ city: 'Aghakista (Monaghan)', zip: '675017' },
	{ city: 'Aghaknock (Cavan)', zip: '346849' },
	{ city: 'Aghalacka (Limerick)', zip: '428038' },
	{ city: 'Aghalackan (Cavan)', zip: '156837' },
	{ city: 'Aghalahard (Mayo)', zip: '472705' },
	{ city: 'Aghalahard (Roscommon)', zip: '202519' },
	{ city: 'Aghalasty And Ankersland (Westmeath)', zip: '964143' },
	{ city: 'Aghalateeve (Galway)', zip: '651389' },
	{ city: 'Aghalateeve (Leitrim)', zip: '348703' },
	{ city: 'Aghalattafraal (Cavan)', zip: '389878' },
	{ city: 'Aghalattive (Donegal)', zip: '422934' },
	{ city: 'Aghalatty (Donegal)', zip: '131625' },
	{ city: 'Aghalaverty (Monaghan)', zip: '291110' },
	{ city: 'Aghaleague (Leitrim)', zip: '580019' },
	{ city: 'Aghaleague (Mayo)', zip: '480000' },
	{ city: 'Aghalee Beg (Kerry)', zip: '480409' },
	{ city: 'Aghalee More (Kerry)', zip: '374559' },
	{ city: 'Aghalenane (Sligo)', zip: '765285' },
	{ city: 'Aghalenty (Donegal)', zip: '614196' },
	{ city: 'Aghalile (Monaghan)', zip: '809416' },
	{ city: 'Aghalinane (Cork)', zip: '155456' },
	{ city: 'Aghalion (Cavan)', zip: '230526' },
	{ city: 'Aghalisk (Monaghan)', zip: '389334' },
	{ city: 'Aghaliskeevan (Monaghan)', zip: '286028' },
	{ city: 'Aghalissabeagh (Monaghan)', zip: '718113' },
	{ city: 'Aghaloaghan (Meath)', zip: '456056' },
	{ city: 'Aghaloonteen (Mayo)', zip: '121567' },
	{ city: 'Aghaloory (Cavan)', zip: '351961' },
	{ city: 'Aghalough (Donegal)', zip: '760280' },
	{ city: 'Aghalough (Leitrim)', zip: '310989' },
	{ city: 'Aghalough (Monaghan)', zip: '548596' },
	{ city: 'Aghaloughan (Cavan)', zip: '703803' },
	{ city: 'Aghaloughan (Longford)', zip: '356520' },
	{ city: 'Aghaloughan (Monaghan)', zip: '499309' },
	{ city: 'Aghalour (Roscommon)', zip: '670355' },
	{ city: 'Aghalusky (Mayo)', zip: '335845' },
	{ city: 'Aghalusky (Offaly)', zip: '413678' },
	{ city: 'Aghalust (Longford)', zip: '137228' },
	{ city: 'Aghalustia (Roscommon)', zip: '262103' },
	{ city: 'Aghamackalinn (Monaghan)', zip: '207602' },
	{ city: 'Aghamaddock (Laois)', zip: '229208' },
	{ city: 'Aghamafir (Laois)', zip: '130228' },
	{ city: 'Aghamannan (Roscommon)', zip: '381884' },
	{ city: 'Aghamarta (Cork)', zip: '462625' },
	{ city: 'Aghameelick (Offaly)', zip: '412561' },
	{ city: 'Aghameelta (Leitrim)', zip: '888893' },
	{ city: 'Aghameelta Barr (Leitrim)', zip: '698300' },
	{ city: 'Aghameen (Louth)', zip: '644790' },
	{ city: 'Aghameeny (Leitrim)', zip: '143186' },
	{ city: 'Aghamilla (Cork)', zip: '758566' },
	{ city: 'Aghamore (Laois)', zip: '757222' },
	{ city: 'Aghamore (Leitrim)', zip: '974332' },
	{ city: 'Aghamore (Longford)', zip: '916600' },
	{ city: 'Aghamore (Mayo)', zip: '762059' },
	{ city: 'Aghamore (Meath)', zip: '401690' },
	{ city: 'Aghamore (Offaly)', zip: '507851' },
	{ city: 'Aghamore (Roscommon)', zip: '513787' },
	{ city: 'Aghamore (Westmeath)', zip: '476949' },
	{ city: 'Aghamore Far (Sligo)', zip: '296678' },
	{ city: 'Aghamore Lower (Longford)', zip: '421255' },
	{ city: 'Aghamore Near (Sligo)', zip: '765524' },
	{ city: 'Aghamore North (Kerry)', zip: '707766' },
	{ city: 'Aghamore South (Kerry)', zip: '323301' },
	{ city: 'Aghamore Upper (Longford)', zip: '121595' },
	{ city: 'Aghamuck (Roscommon)', zip: '750357' },
	{ city: 'Aghamucky (Kilkenny)', zip: '543532' },
	{ city: 'Aghanacrinna (Kerry)', zip: '530765' },
	{ city: 'Aghanageeragh (Longford)', zip: '558250' },
	{ city: 'Aghanagh (Sligo)', zip: '306933' },
	{ city: 'Aghanagran Lower (Kerry)', zip: '424952' },
	{ city: 'Aghanagran Middle (Kerry)', zip: '732738' },
	{ city: 'Aghanagran Upper (Kerry)', zip: '230322' },
	{ city: 'Aghanahil (Galway)', zip: '535428' },
	{ city: 'Aghanahown (Longford)', zip: '494215' },
	{ city: 'Aghanameena (Monaghan)', zip: '156479' },
	{ city: 'Aghananimy (Monaghan)', zip: '491946' },
	{ city: 'Aghanapisha (Westmeath)', zip: '878500' },
	{ city: 'Aghanargit (Westmeath)', zip: '438941' },
	{ city: 'Aghanascortan (Meath)', zip: '616922' },
	{ city: 'Aghanashanamore (Westmeath)', zip: '571465' },
	{ city: 'Aghanboy (Kerry)', zip: '299415' },
	{ city: 'Aghancarnan (Offaly)', zip: '991055' },
	{ city: 'Aghancarra (Leitrim)', zip: '856523' },
	{ city: 'Aghancon (Offaly)', zip: '702922' },
	{ city: 'Aghaneenagh (Cork)', zip: '141863' },
	{ city: 'Aghangaddy Glebe (Donegal)', zip: '373621' },
	{ city: 'Aghanlish (Leitrim)', zip: '476219' },
	{ city: 'Aghanoran (Longford)', zip: '452771' },
	{ city: 'Aghanrush (Offaly)', zip: '768605' },
	{ city: 'Aghantrah (Longford)', zip: '410142' },
	{ city: 'Aghanure (Carlow)', zip: '301390' },
	{ city: 'Aghanure (Kildare)', zip: '536492' },
	{ city: 'Aghanure (Laois)', zip: '295214' },
	{ city: 'Aghanursan (Donegal)', zip: '944573' },
	{ city: 'Aghanvally (Longford)', zip: '332820' },
	{ city: 'Aghanvilla (Offaly)', zip: '302316' },
	{ city: 'Aghanvoneen (Westmeath)', zip: '184538' },
	{ city: 'Aghany (Galway)', zip: '729715' },
	{ city: 'Aghany (Mayo)', zip: '757354' },
	{ city: 'Agharah (Cavan)', zip: '922185' },
	{ city: 'Agharahan (Cavan)', zip: '321891' },
	{ city: 'Agharanagh (Longford)', zip: '177407' },
	{ city: 'Agharann (Leitrim)', zip: '831966' },
	{ city: 'Agharanny (Westmeath)', zip: '263083' },
	{ city: 'Agharaskilly (Cavan)', zip: '819431' },
	{ city: 'Aghards (Kildare)', zip: '178023' },
	{ city: 'Aghareagh (Longford)', zip: '853326' },
	{ city: 'Aghareagh (Monaghan)', zip: '149131' },
	{ city: 'Aghareagh Bog (Longford)', zip: '682289' },
	{ city: 'Aghareagh East (Monaghan)', zip: '230400' },
	{ city: 'Aghareagh West (Monaghan)', zip: '223252' },
	{ city: 'Agharevagh East (Westmeath)', zip: '815082' },
	{ city: 'Agharevagh West (Westmeath)', zip: '142668' },
	{ city: 'Aghareville Lower (Mayo)', zip: '327434' },
	{ city: 'Aghareville Upper (Mayo)', zip: '669067' },
	{ city: 'Agharickard (Longford)', zip: '612854' },
	{ city: 'Agharinagh (Cork)', zip: '594180' },
	{ city: 'Agharoosky (Leitrim)', zip: '300449' },
	{ city: 'Agharra (Longford)', zip: '862055' },
	{ city: 'Agharroo (Leitrim)', zip: '674751' },
	{ city: 'Agharrow (Sligo)', zip: '127362' },
	{ city: 'Agharue (Carlow)', zip: '135245' },
	{ city: 'Aghasheil (Donegal)', zip: '567811' },
	{ city: 'Aghataharn (Mayo)', zip: '876717' },
	{ city: 'Aghatamy (Monaghan)', zip: '623728' },
	{ city: 'Aghatawny Lower (Leitrim)', zip: '920511' },
	{ city: 'Aghatawny Upper (Leitrim)', zip: '686185' },
	{ city: 'Aghateeduff (Cavan)', zip: '730606' },
	{ city: 'Aghateemore Glebe (Cavan)', zip: '922397' },
	{ city: 'Aghateggal (Cavan)', zip: '961689' },
	{ city: 'Aghaterry (Laois)', zip: '641610' },
	{ city: 'Aghateskin (Monaghan)', zip: '198633' },
	{ city: 'Aghathomas (Meath)', zip: '699120' },
	{ city: 'Aghatotan (Cavan)', zip: '824893' },
	{ city: 'Aghatubbrid (Donegal)', zip: '522519' },
	{ city: 'Aghatubrid (Kerry)', zip: '678794' },
	{ city: 'Aghatubrid Beg (Cork)', zip: '912573' },
	{ city: 'Aghatubrid More (Cork)', zip: '574884' },
	{ city: 'Aghavadden (Leitrim)', zip: '111385' },
	{ city: 'Aghavadden (Longford)', zip: '827274' },
	{ city: 'Aghavaddy (Cavan)', zip: '536535' },
	{ city: 'Aghavadrin (Cavan)', zip: '504296' },
	{ city: 'Aghavannagh (Wicklow)', zip: '634080' },
	{ city: 'Aghavannagh Mountain (Wicklow)', zip: '792903' },
	{ city: 'Aghavannan Far (Donegal)', zip: '631687' },
	{ city: 'Aghavannan Near (Donegal)', zip: '412842' },
	{ city: 'Aghavanny (Leitrim)', zip: '309642' },
	{ city: 'Aghavas (Leitrim)', zip: '962807' },
	{ city: 'Aghaveagh (Donegal)', zip: '305776' },
	{ city: 'Aghaveans (Cavan)', zip: '192715' },
	{ city: 'Aghavilla (Cavan)', zip: '554601' },
	{ city: 'Aghavilla (Leitrim)', zip: '436009' },
	{ city: 'Aghavilla (Monaghan)', zip: '134056' },
	{ city: 'Aghaville (Cork)', zip: '726428' },
	{ city: 'Aghaviller (Kilkenny)', zip: '669301' },
	{ city: 'Aghavine (Cork)', zip: '324189' },
	{ city: 'Aghavoghil (Leitrim)', zip: '336093' },
	{ city: 'Aghavoher (Cavan)', zip: '658278' },
	{ city: 'Aghavoneen (Westmeath)', zip: '169234' },
	{ city: 'Aghavore (Leitrim)', zip: '796079' },
	{ city: 'Aghavrin (Cork)', zip: '288668' },
	{ city: 'Aghawaracahill (Roscommon)', zip: '614200' },
	{ city: 'Aghaward (Longford)', zip: '247082' },
	{ city: 'Aghaward (Mayo)', zip: '926791' },
	{ city: 'Aghaway (Cavan)', zip: '407663' },
	{ city: 'Aghawee (Cavan)', zip: '735818' },
	{ city: 'Aghawee (Donegal)', zip: '882375' },
	{ city: 'Aghaweely Lower (Cavan)', zip: '146755' },
	{ city: 'Aghaweely Upper (Cavan)', zip: '213332' },
	{ city: 'Aghaweenagh (Cavan)', zip: '985764' },
	{ city: 'Aghawerriny (Roscommon)', zip: '382530' },
	{ city: 'Aghawillin (Leitrim)', zip: '477418' },
	{ city: 'Aghawinnaun (Clare)', zip: '419694' },
	{ city: 'Aghawonan (Cavan)', zip: '308918' },
	{ city: 'Aghawoney (Donegal)', zip: '724873' },
	{ city: 'Aghayeevoge (Donegal)', zip: '341392' },
	{ city: 'Aghclare (Kilkenny)', zip: '392977' },
	{ city: 'Aghcross (Laois)', zip: '494896' },
	{ city: 'Aghduff (Laois)', zip: '751864' },
	{ city: 'Agheeshal (Monaghan)', zip: '641760' },
	{ city: 'Aghenderry (Kilkenny)', zip: '730537' },
	{ city: 'Agher (Meath)', zip: '646481' },
	{ city: 'Agheracalkill (Monaghan)', zip: '378084' },
	{ city: 'Agheragh (Meath)', zip: '601695' },
	{ city: 'Agherakeltan (Monaghan)', zip: '788300' },
	{ city: 'Agheralane (Monaghan)', zip: '357133' },
	{ city: 'Aghern East (Cork)', zip: '640282' },
	{ city: 'Aghern West (Cork)', zip: '395573' },
	{ city: 'Aghfarrell (Dublin)', zip: '360192' },
	{ city: 'Aghfarrell (Wicklow)', zip: '721324' },
	{ city: 'Aghills (Cork)', zip: '431936' },
	{ city: 'Aghilly And Lenynarnan (Donegal)', zip: '955436' },
	{ city: 'Aghinaspick (Longford)', zip: '325100' },
	{ city: 'Aghinillard (Monaghan)', zip: '999008' },
	{ city: 'Aghinish (Mayo)', zip: '610809' },
	{ city: 'Aghinraheen (Kilkenny)', zip: '286579' },
	{ city: 'Aghintamy (Monaghan)', zip: '485372' },
	{ city: 'Aghintass (Leitrim)', zip: '856713' },
	{ city: 'Aghinteeduff (Leitrim)', zip: '642368' },
	{ city: 'Aghintemple (Longford)', zip: '113307' },
	{ city: 'Aghintober (Leitrim)', zip: '194752' },
	{ city: 'Aghlacon (Leitrim)', zip: '958949' },
	{ city: 'Aghlattacru (Monaghan)', zip: '452586' },
	{ city: 'Aghleam (Mayo)', zip: '908049' },
	{ city: 'Aghlehard (Donegal)', zip: '343451' },
	{ city: 'Aghlem (Donegal)', zip: '798511' },
	{ city: 'Aghlin (Leitrim)', zip: '486629' },
	{ city: 'Aghlisk (Galway)', zip: '646523' },
	{ city: 'Aghloonagh (Roscommon)', zip: '394986' },
	{ city: 'Aghmacart (Laois)', zip: '698797' },
	{ city: 'Aghmagree (Roscommon)', zip: '533281' },
	{ city: 'Aghmakerr (Monaghan)', zip: '260213' },
	{ city: 'Aghmanister And Spital (Cork)', zip: '118573' },
	{ city: 'Aghnabohy (Westmeath)', zip: '136987' },
	{ city: 'Aghnacally (Cavan)', zip: '314403' },
	{ city: 'Aghnacally Glebe (Longford)', zip: '291355' },
	{ city: 'Aghnaclea (Monaghan)', zip: '980738' },
	{ city: 'Aghnacliff (Longford)', zip: '335550' },
	{ city: 'Aghnaclue (Cavan)', zip: '137008' },
	{ city: 'Aghnacollia (Cavan)', zip: '270284' },
	{ city: 'Aghnacor (Cavan)', zip: '111441' },
	{ city: 'Aghnacranagh (Longford)', zip: '217075' },
	{ city: 'Aghnacreevy (Cavan)', zip: '855509' },
	{ city: 'Aghnacross (Laois)', zip: '737866' },
	{ city: 'Aghnacross (Leitrim)', zip: '242286' },
	{ city: 'Aghnacross (Longford)', zip: '498066' },
	{ city: 'Aghnacue (Monaghan)', zip: '788280' },
	{ city: 'Aghnadamph (Monaghan)', zip: '661959' },
	{ city: 'Aghnadaragan (Cavan)', zip: '518008' },
	{ city: 'Aghnadrung (Cavan)', zip: '163482' },
	{ city: 'Aghnafarcan (Monaghan)', zip: '986211' },
	{ city: 'Aghnagap (Monaghan)', zip: '215859' },
	{ city: 'Aghnagarron (Longford)', zip: '615061' },
	{ city: 'Aghnagillagh (Meath)', zip: '340244' },
	{ city: 'Aghnaglear (Carlow)', zip: '632147' },
	{ city: 'Aghnaglogh (Cavan)', zip: '438988' },
	{ city: 'Aghnaglogh (Monaghan)', zip: '823138' },
	{ city: 'Aghnagollop (Leitrim)', zip: '481890' },
	{ city: 'Aghnagore (Longford)', zip: '481125' },
	{ city: 'Aghnagrange (Roscommon)', zip: '471111' },
	{ city: 'Aghnagross (Offaly)', zip: '151715' },
	{ city: 'Aghnaguig (Cavan)', zip: '462401' },
	{ city: 'Aghnaha (Monaghan)', zip: '199779' },
	{ city: 'Aghnahaha (Leitrim)', zip: '756353' },
	{ city: 'Aghnahaia Glebe (Cavan)', zip: '670307' },
	{ city: 'Aghnahederny (Cavan)', zip: '196444' },
	{ city: 'Aghnahily (Laois)', zip: '965542' },
	{ city: 'Aghnahily Bog (Laois)', zip: '838261' },
	{ city: 'Aghnahola (Monaghan)', zip: '589133' },
	{ city: 'Aghnahoo (Leitrim)', zip: '809306' },
	{ city: 'Aghnahoo Glebe (Donegal)', zip: '495209' },
	{ city: 'Aghnahunshin (Leitrim)', zip: '196139' },
	{ city: 'Aghnahunshin (Monaghan)', zip: '415481' },
	{ city: 'Aghnakeeragh (Donegal)', zip: '266952' },
	{ city: 'Aghnamaddoo (Longford)', zip: '504953' },
	{ city: 'Aghnamallagh (Monaghan)', zip: '929776' },
	{ city: 'Aghnamard (Monaghan)', zip: '539670' },
	{ city: 'Aghnameadle (Tipperary)', zip: '245280' },
	{ city: 'Aghnameal (Monaghan)', zip: '410220' },
	{ city: 'Aghnamona (Leitrim)', zip: '420526' },
	{ city: 'Aghnamullen (Monaghan)', zip: '337616' },
	{ city: 'Aghnananagh (Offaly)', zip: '531907' },
	{ city: 'Aghnaneane (Meath)', zip: '618495' },
	{ city: 'Aghnasedagh (Monaghan)', zip: '600670' },
	{ city: 'Aghnashalvy (Monaghan)', zip: '899205' },
	{ city: 'Aghnashannagh (Longford)', zip: '840705' },
	{ city: 'Aghnashingan (Longford)', zip: '103251' },
	{ city: 'Aghnasillagh (Longford)', zip: '967419' },
	{ city: 'Aghnaskea (Longford)', zip: '369676' },
	{ city: 'Aghnaskea (Monaghan)', zip: '760000' },
	{ city: 'Aghnaskeagh (Cavan)', zip: '904614' },
	{ city: 'Aghnaskeagh (Louth)', zip: '833028' },
	{ city: 'Aghnaskerry (Cavan)', zip: '194154' },
	{ city: 'Aghnaskew (Monaghan)', zip: '116641' },
	{ city: 'Aghnasullivan (Westmeath)', zip: '625622' },
	{ city: 'Aghnasurn (Roscommon)', zip: '142225' },
	{ city: 'Aghnavar (Monaghan)', zip: '155950' },
	{ city: 'Aghnavealoge (Longford)', zip: '762364' },
	{ city: 'Aghody (Offaly)', zip: '287355' },
	{ city: 'Aghoney (Laois)', zip: '775529' },
	{ city: 'Aghoo (Leitrim)', zip: '512120' },
	{ city: 'Aghoo (Mayo)', zip: '388918' },
	{ city: 'Aghoo (Roscommon)', zip: '747939' },
	{ city: 'Aghoo (Sligo)', zip: '208105' },
	{ city: 'Aghoo East (Leitrim)', zip: '312753' },
	{ city: 'Aghoos (Mayo)', zip: '437240' },
	{ city: 'Aghoo West (Leitrim)', zip: '788261' },
	{ city: 'Aghort (Kerry)', zip: '717639' },
	{ city: 'Aghoutereery (Cavan)', zip: '599714' },
	{ city: 'Aghowle Lower (Wicklow)', zip: '985816' },
	{ city: 'Aghowle Upper (Wicklow)', zip: '721428' },
	{ city: 'Aghpaudeen (Kildare)', zip: '476567' },
	{ city: 'Aghraboy (Offaly)', zip: '524239' },
	{ city: 'Aghrafinigan (Roscommon)', zip: '378829' },
	{ city: 'Aghragh (Donegal)', zip: '246440' },
	{ city: 'Aghrane (Galway)', zip: '489945' },
	{ city: 'Aghsmear (Tipperary)', zip: '257374' },
	{ city: 'Aghtaboy (Mayo)', zip: '615539' },
	{ city: 'Aghuldred (Westmeath)', zip: '455232' },
	{ city: 'Aghullaghy (Cavan)', zip: '880771' },
	{ city: 'Aghwater (Carlow)', zip: '325230' },
	{ city: 'Aghyohil Beg (Cork)', zip: '194608' },
	{ city: 'Aghyohil More (Cork)', zip: '564675' },
	{ city: 'Aghyowla (Leitrim)', zip: '612056' },
	{ city: 'Aghyrassy (Westmeath)', zip: '890751' },
	{ city: 'Aglish (Clare)', zip: '712554' },
	{ city: 'Aglish (Cork)', zip: '173587' },
	{ city: 'Aglish (Kerry)', zip: '480362' },
	{ city: 'Aglish (Tipperary)', zip: '913791' },
	{ city: 'Aglish (Waterford)', zip: '342111' },
	{ city: 'Aglish North (Kilkenny)', zip: '563250' },
	{ city: 'Aglish South (Kilkenny)', zip: '283405' },
	{ city: 'Agloragh (Mayo)', zip: '475518' },
	{ city: 'Agrimhill (Galway)', zip: '530007' },
	{ city: 'Ahabeg (Limerick)', zip: '460777' },
	{ city: 'Ahaclare (Clare)', zip: '503598' },
	{ city: 'Ahacore (Limerick)', zip: '334873' },
	{ city: 'Ahadagh (Limerick)', zip: '318493' },
	{ city: 'Ahadallane (Cork)', zip: '620784' },
	{ city: 'Ahaga (Clare)', zip: '307523' },
	{ city: 'Ahagilla (Cork)', zip: '369845' },
	{ city: 'Ahaglaslin (Cork)', zip: '300793' },
	{ city: 'Ahaglugger (Galway)', zip: '989336' },
	{ city: 'Ahakeera (Cork)', zip: '422323' },
	{ city: 'Ahakista (Cork)', zip: '673231' },
	{ city: 'Ahalahana (Kerry)', zip: '680177' },
	{ city: 'Ahalisky (Cork)', zip: '737413' },
	{ city: 'Ahanagh (Longford)', zip: '177787' },
	{ city: 'Ahanaglogh (Waterford)', zip: '747650' },
	{ city: 'Ahanduff Beg (Galway)', zip: '163466' },
	{ city: 'Ahanduff More (Galway)', zip: '126444' },
	{ city: 'Ahane (Kerry)', zip: '971481' },
	{ city: 'Ahane (Tipperary)', zip: '956813' },
	{ city: 'Ahane Beg (Cork)', zip: '889507' },
	{ city: 'Ahaneboy (Kerry)', zip: '132484' },
	{ city: 'Ahane Lower (Cork)', zip: '125680' },
	{ city: 'Ahane Upper (Cork)', zip: '276681' },
	{ city: 'Ahanroe (Mayo)', zip: '362934' },
	{ city: 'Ahanure North (Kilkenny)', zip: '285565' },
	{ city: 'Ahanure South (Kilkenny)', zip: '123261' },
	{ city: 'Ahapouleen (Galway)', zip: '928517' },
	{ city: 'Ahare (Wexford)', zip: '175773' },
	{ city: 'Aharinaghbeg (Clare)', zip: '942633' },
	{ city: 'Aharinaghmore (Clare)', zip: '238984' },
	{ city: 'Aharney (Laois)', zip: '571065' },
	{ city: 'Aharney (Offaly)', zip: '584638' },
	{ city: 'Ahascra (Kerry)', zip: '493740' },
	{ city: 'Ahascragh (Galway)', zip: '930392' },
	{ city: 'Ahascragh East (Galway)', zip: '129441' },
	{ city: 'Ahascragh West (Galway)', zip: '508018' },
	{ city: 'Ahasla (Clare)', zip: '517194' },
	{ city: 'Ahaun (Galway)', zip: '239303' },
	{ city: 'Ahaun (Kerry)', zip: '491368' },
	{ city: 'Ahaun (Waterford)', zip: '710464' },
	{ city: 'Ahaunboy North (Waterford)', zip: '488448' },
	{ city: 'Ahaunboy South (Waterford)', zip: '895720' },
	{ city: 'Ahaveheen (Limerick)', zip: '593730' },
	{ city: 'Ahawilk (Limerick)', zip: '670467' },
	{ city: 'Ahena (Mayo)', zip: '595290' },
	{ city: 'Ahenny (Tipperary)', zip: '410216' },
	{ city: 'Ahenny Little (Tipperary)', zip: '412821' },
	{ city: 'Aherla (Cork)', zip: '216581' },
	{ city: 'Aherla Beg (Cork)', zip: '201860' },
	{ city: 'Aherla More (Cork)', zip: '235613' },
	{ city: 'Ahgloragh (Galway)', zip: '867437' },
	{ city: 'Ahidelake (Cork)', zip: '627368' },
	{ city: 'Ahil Beg (Cork)', zip: '425730' },
	{ city: 'Ahildotia (Cork)', zip: '625620' },
	{ city: 'Ahil More (Cork)', zip: '400981' },
	{ city: 'Ahimma (Kerry)', zip: '283132' },
	{ city: 'Ahnagurra (Limerick)', zip: '198005' },
	{ city: 'Aighan (Donegal)', zip: '607578' },
	{ city: 'Aighe (Donegal)', zip: '870404' },
	{ city: 'Aillbrack (Clare)', zip: '283936' },
	{ city: 'Ailldavore (Clare)', zip: '927670' },
	{ city: 'Aille (Galway)', zip: '906753' },
	{ city: 'Aille (Mayo)', zip: '761969' },
	{ city: 'Aillebaun (Mayo)', zip: '255774' },
	{ city: 'Aillebrack (Galway)', zip: '181567' },
	{ city: 'Aillemore (Clare)', zip: '844279' },
	{ city: 'Aillemore (Mayo)', zip: '752197' },
	{ city: 'Aillenacally (Galway)', zip: '368652' },
	{ city: 'Aillenaveagh (Galway)', zip: '157637' },
	{ city: 'Aillroe Beg (Clare)', zip: '791400' },
	{ city: 'Aillroe More (Clare)', zip: '877626' },
	{ city: 'Aillvaun (Clare)', zip: '401194' },
	{ city: 'Aillwee (Clare)', zip: '595819' },
	{ city: 'Airgloony (Galway)', zip: '684083' },
	{ city: 'Akip (Laois)', zip: '858797' },
	{ city: 'Alasty (Kildare)', zip: '690686' },
	{ city: 'Alderborough (Offaly)', zip: '990518' },
	{ city: 'Alderford (Roscommon)', zip: '804113' },
	{ city: 'Aldridge (Wexford)', zip: '190435' },
	{ city: 'Aldworth (Cork)', zip: '312431' },
	{ city: 'Alexander Reid (Meath)', zip: '553554' },
	{ city: 'Alkill (Monaghan)', zip: '603190' },
	{ city: 'Alla (Donegal)', zip: '216094' },
	{ city: 'Allagesh (Monaghan)', zip: '557879' },
	{ city: 'Allaghee Beg (Kerry)', zip: '173498' },
	{ city: 'Allaghee More (Kerry)', zip: '761214' },
	{ city: 'Allagh Island (Donegal)', zip: '537830' },
	{ city: 'Allagour (Dublin)', zip: '650454' },
	{ city: 'Allaphreaghaun (Galway)', zip: '408907' },
	{ city: 'Allardstown (Louth)', zip: '896346' },
	{ city: 'Allcollege (Meath)', zip: '716751' },
	{ city: 'Alleen (Tipperary)', zip: '800818' },
	{ city: 'Alleendarra East (Galway)', zip: '990374' },
	{ city: 'Alleendarra West (Galway)', zip: '628191' },
	{ city: 'Allenagh (Longford)', zip: '759040' },
	{ city: 'Allengort (Tipperary)', zip: '885467' },
	{ city: 'Allenstown Big (Wexford)', zip: '694200' },
	{ city: 'Allenstown Demesne (Meath)', zip: '728369' },
	{ city: 'Allenstown Little (Wexford)', zip: '774613' },
	{ city: 'Allenswood (Dublin)', zip: '179006' },
	{ city: 'Allenswood (Kildare)', zip: '763572' },
	{ city: 'Allenwood (Kildare)', zip: '260170' },
	{ city: 'Allenwood Middle (Kildare)', zip: '502479' },
	{ city: 'Allenwood North (Kildare)', zip: '346961' },
	{ city: 'Allenwood South (Kildare)', zip: '823466' },
	{ city: 'Alliganstown (Kildare)', zip: '656908' },
	{ city: 'Allihies (Cork)', zip: '821265' },
	{ city: 'Alloonbaun (Galway)', zip: '951174' },
	{ city: 'Alloon Lower (Galway)', zip: '233068' },
	{ city: 'Alloon Upper (Galway)', zip: '573349' },
	{ city: 'Allygola (Galway)', zip: '723313' },
	{ city: 'Allykeolaun (Galway)', zip: '423528' },
	{ city: 'Almondstown (Louth)', zip: '190813' },
	{ city: 'Alohart (Kerry)', zip: '421362' },
	{ city: 'Alsmeed (Monaghan)', zip: '467424' },
	{ city: 'Alt (Mayo)', zip: '776676' },
	{ city: 'Altachullion Lower (Cavan)', zip: '927813' },
	{ city: 'Altachullion Upper (Cavan)', zip: '460877' },
	{ city: 'Altadoo (Donegal)', zip: '103342' },
	{ city: 'Altadush (Donegal)', zip: '719219' },
	{ city: 'Altaghaderry (Donegal)', zip: '588223' },
	{ city: 'Altagowlan (Roscommon)', zip: '350872' },
	{ city: 'Altahalla (Donegal)', zip: '902179' },
	{ city: 'Altakeeran (Leitrim)', zip: '321257' },
	{ city: 'Altamira (Cork)', zip: '305215' },
	{ city: 'Altamont (Carlow)', zip: '148196' },
	{ city: 'Altan (Donegal)', zip: '732743' },
	{ city: 'Altanelvick (Sligo)', zip: '646706' },
	{ city: 'Altans (Sligo)', zip: '599746' },
	{ city: 'Altar (Cork)', zip: '148696' },
	{ city: 'Altartate Glebe (Monaghan)', zip: '332567' },
	{ city: 'Altashane (Donegal)', zip: '996413' },
	{ city: 'Altaskin (Donegal)', zip: '638933' },
	{ city: 'Altateskin (Cavan)', zip: '269360' },
	{ city: 'Altatraght (Donegal)', zip: '838578' },
	{ city: 'Altavilla (Laois)', zip: '387250' },
	{ city: 'Altavilla (Limerick)', zip: '982019' },
	{ city: 'Altavra (Leitrim)', zip: '278191' },
	{ city: 'Altbaun (Mayo)', zip: '721237' },
	{ city: 'Altbeagh (Cavan)', zip: '673186' },
	{ city: 'Altbrean (Cavan)', zip: '477782' },
	{ city: 'Altclogh (Donegal)', zip: '885856' },
	{ city: 'Altcor (Donegal)', zip: '263427' },
	{ city: 'Altcrock (Cavan)', zip: '620320' },
	{ city: 'Altderg (Mayo)', zip: '162388' },
	{ city: 'Alteen (Cavan)', zip: '406360' },
	{ city: 'Alteen (Leitrim)', zip: '744906' },
	{ city: 'Alteenacres Glebe (Leitrim)', zip: '567456' },
	{ city: 'Alternan Park (Sligo)', zip: '757445' },
	{ city: 'Altidore Demesne (Wicklow)', zip: '797564' },
	{ city: 'Altilow (Donegal)', zip: '342570' },
	{ city: 'Altinierin (Donegal)', zip: '391180' },
	{ city: 'Altinure (Cavan)', zip: '420962' },
	{ city: 'Altiquin (Leitrim)', zip: '420680' },
	{ city: 'Altlahan (Donegal)', zip: '966399' },
	{ city: 'Alt Lower (Donegal)', zip: '508818' },
	{ city: 'Altmush (Meath)', zip: '319716' },
	{ city: 'Altnabrocky (Mayo)', zip: '945093' },
	{ city: 'Altnadarragh (Cavan)', zip: '790889' },
	{ city: 'Altnagapple (Donegal)', zip: '408855' },
	{ city: 'Altnapaste (Donegal)', zip: '501543' },
	{ city: 'Altnasheen (Cavan)', zip: '373561' },
	{ city: 'Altoghil (Roscommon)', zip: '604316' },
	{ city: 'Altore (Roscommon)', zip: '370002' },
	{ city: 'Alts (Monaghan)', zip: '696926' },
	{ city: 'Altshallan (Cavan)', zip: '554590' },
	{ city: 'Alt Upper (Donegal)', zip: '992684' },
	{ city: 'Altvelid (Sligo)', zip: '454683' },
	{ city: 'Alva (Clare)', zip: '695231' },
	{ city: 'Amberhill (Waterford)', zip: '227121' },
	{ city: 'Ambrosetown (Wexford)', zip: '361517' },
	{ city: 'America (Roscommon)', zip: '203385' },
	{ city: 'Amogan Beg (Limerick)', zip: '187108' },
	{ city: 'Amogan More (Limerick)', zip: '115166' },
	{ city: 'Amorset (Leitrim)', zip: '173755' },
	{ city: 'Anablaha (Kerry)', zip: '915526' },
	{ city: 'Anaglog (Louth)', zip: '490422' },
	{ city: 'Anaharlick (Cork)', zip: '233283' },
	{ city: 'Anascaul (Kerry)', zip: '978135' },
	{ city: 'Anatrim (Laois)', zip: '273443' },
	{ city: 'Anaverna (Louth)', zip: '854219' },
	{ city: 'Anbally (Galway)', zip: '177614' },
	{ city: 'Andresna (Sligo)', zip: '755388' },
	{ city: 'Anglesborough (Limerick)', zip: '656939' },
	{ city: 'Angliham (Galway)', zip: '197813' },
	{ city: 'Anglode (Limerick)', zip: '468174' },
	{ city: 'Anglont (Kerry)', zip: '892250' },
	{ city: 'Anglore (Kerry)', zip: '713297' },
	{ city: 'Angram (Cork)', zip: '472665' },
	{ city: 'Anhid East (Limerick)', zip: '666799' },
	{ city: 'Anhid West (Limerick)', zip: '658411' },
	{ city: 'Ankail (Kerry)', zip: '175774' },
	{ city: 'Ankers Bower (Westmeath)', zip: '271912' },
	{ city: 'Anna Beg (Kerry)', zip: '304900' },
	{ city: 'Annabella (Cork)', zip: '546319' },
	{ city: 'Annacarney (Wicklow)', zip: '936585' },
	{ city: 'Annacarriga (Cork)', zip: '863559' },
	{ city: 'Annacarty (Tipperary)', zip: '688142' },
	{ city: 'Annacatty (Monaghan)', zip: '652368' },
	{ city: 'Annacloghan (Roscommon)', zip: '531780' },
	{ city: 'Annacotty (Limerick)', zip: '502867' },
	{ city: 'Annacramph (Monaghan)', zip: '134700' },
	{ city: 'Annacrivey (Wicklow)', zip: '632903' },
	{ city: 'Annacroff (Monaghan)', zip: '789097' },
	{ city: 'Annadale (Kerry)', zip: '679504' },
	{ city: 'Annadrumman (Monaghan)', zip: '281476' },
	{ city: 'Annaduff (Leitrim)', zip: '343476' },
	{ city: 'Annaduff Glebe (Leitrim)', zip: '255340' },
	{ city: 'Annafarney (Cavan)', zip: '348690' },
	{ city: 'Annagally (Monaghan)', zip: '489480' },
	{ city: 'Annagannihy (Cork)', zip: '206032' },
	{ city: 'Annagap (Kerry)', zip: '174976' },
	{ city: 'Annagar (Carlow)', zip: '358368' },
	{ city: 'Annagary (Donegal)', zip: '788488' },
	{ city: 'Annagassan (Louth)', zip: '714112' },
	{ city: 'Annagelliff (Cavan)', zip: '444643' },
	{ city: 'Annagerril (Monaghan)', zip: '844817' },
	{ city: 'Annagh (Cavan)', zip: '855065' },
	{ city: 'Annagh (Clare)', zip: '703325' },
	{ city: 'Annagh (Donegal)', zip: '815499' },
	{ city: 'Annagh (Galway)', zip: '479161' },
	{ city: 'Annagh (Kerry)', zip: '120207' },
	{ city: 'Annagh (Laois)', zip: '319187' },
	{ city: 'Annagh (Leitrim)', zip: '521662' },
	{ city: 'Annagh (Limerick)', zip: '791090' },
	{ city: 'Annagh (Longford)', zip: '158640' },
	{ city: 'Annagh (Louth)', zip: '973624' },
	{ city: 'Annagh (Mayo)', zip: '785376' },
	{ city: 'Annagh (Meath)', zip: '970993' },
	{ city: 'Annagh (Monaghan)', zip: '391710' },
	{ city: 'Annagh (Roscommon)', zip: '990780' },
	{ city: 'Annagh (Sligo)', zip: '604267' },
	{ city: 'Annagh (Tipperary)', zip: '159401' },
	{ city: 'Annagh (Westmeath)', zip: '635945' },
	{ city: 'Annagh (Wexford)', zip: '203725' },
	{ city: 'Annaghaderg (Leitrim)', zip: '406745' },
	{ city: 'Annaghanerrig (Tipperary)', zip: '182564' },
	{ city: 'Annaghanmoney (Louth)', zip: '390873' },
	{ city: 'Annaghard (Cavan)', zip: '289265' },
	{ city: 'Annagharnet (Cavan)', zip: '333660' },
	{ city: 'Annagharvey (Offaly)', zip: '560260' },
	{ city: 'Annaghaskin (Dublin)', zip: '475490' },
	{ city: 'Annaghasna (Leitrim)', zip: '559518' },
	{ city: 'Annaghbeg (Galway)', zip: '843007' },
	{ city: 'Annaghbeg (Kerry)', zip: '460004' },
	{ city: 'Annaghbeg (Longford)', zip: '813681' },
	{ city: 'Annaghbeg (Monaghan)', zip: '387187' },
	{ city: 'Annaghbeg (Roscommon)', zip: '895379' },
	{ city: 'Annaghbeg (Sligo)', zip: '492271' },
	{ city: 'Annaghbeg (Tipperary)', zip: '781722' },
	{ city: 'Annagh Beg (Cork)', zip: '228400' },
	{ city: 'Annagh Beg (Kerry)', zip: '563042' },
	{ city: 'Annagh Beg (Mayo)', zip: '896582' },
	{ city: 'Annagh Beg (Sligo)', zip: '343063' },
	{ city: 'Annagh Bogs (Cork)', zip: '894479' },
	{ city: 'Annaghboy (Leitrim)', zip: '772483' },
	{ city: 'Annaghbrack (Monaghan)', zip: '303195' },
	{ city: 'Annaghbrack Glebe (Offaly)', zip: '105307' },
	{ city: 'Annaghbradican (Leitrim)', zip: '170446' },
	{ city: 'Annaghbride (Galway)', zip: '526220' },
	{ city: 'Annaghcallow (Galway)', zip: '455146' },
	{ city: 'Annaghcarthy (Sligo)', zip: '831789' },
	{ city: 'Annagh Central (Wexford)', zip: '374964' },
	{ city: 'Annaghcooleen (Longford)', zip: '981876' },
	{ city: 'Annaghcor (Sligo)', zip: '632438' },
	{ city: 'Annaghcorrib (Galway)', zip: '577686' },
	{ city: 'Annaghdaniel (Longford)', zip: '511148' },
	{ city: 'Annaghderg Lower (Leitrim)', zip: '486788' },
	{ city: 'Annaghderg Upper (Leitrim)', zip: '570510' },
	{ city: 'Annaghdown (Galway)', zip: '656465' },
	{ city: 'Annaghduff (Cavan)', zip: '194758' },
	{ city: 'Annagheane (Monaghan)', zip: '974878' },
	{ city: 'Annaghearly (Leitrim)', zip: '489613' },
	{ city: 'Annagh East (Galway)', zip: '872449' },
	{ city: 'Annaghervy (Monaghan)', zip: '690801' },
	{ city: 'Annaghfin (Wexford)', zip: '177125' },
	{ city: 'Annaghgap (Wexford)', zip: '541139' },
	{ city: 'Annaghgerry (Leitrim)', zip: '509982' },
	{ city: 'Annaghgortagh (Westmeath)', zip: '919260' },
	{ city: 'Annaghgowan (Sligo)', zip: '470310' },
	{ city: 'Annaghhill (Wexford)', zip: '452072' },
	{ city: 'Annagh Hill (Galway)', zip: '766881' },
	{ city: 'Annagh Hill (Mayo)', zip: '805507' },
	{ city: 'Annaghierin (Cavan)', zip: '197475' },
	{ city: 'Annaghilymore (Kerry)', zip: '929093' },
	{ city: 'Annagh Island (Mayo)', zip: '559854' },
	{ city: 'Annaghkeelaun (Galway)', zip: '252094' },
	{ city: 'Annaghkeen (Galway)', zip: '921177' },
	{ city: 'Annaghkeenty (Leitrim)', zip: '684810' },
	{ city: 'Annaghkilly (Monaghan)', zip: '505684' },
	{ city: 'Annaghlee (Cavan)', zip: '362723' },
	{ city: 'Annagh Long (Wexford)', zip: '261660' },
	{ city: 'Annagh Lower (Leitrim)', zip: '180258' },
	{ city: 'Annagh Lower (Wexford)', zip: '905679' },
	{ city: 'Annaghloy (Sligo)', zip: '327202' },
	{ city: 'Annaghmaconway (Leitrim)', zip: '555262' },
	{ city: 'Annaghmacullen (Leitrim)', zip: '155557' },
	{ city: 'Annaghmaghera (Roscommon)', zip: '219252' },
	{ city: 'Annaghmagurthan (Roscommon)', zip: '603494' },
	{ city: 'Annaghmartin (Monaghan)', zip: '197564' },
	{ city: 'Annagh Middle (Wexford)', zip: '418776' },
	{ city: 'Annaghminnan (Louth)', zip: '607206' },
	{ city: 'Annaghmona (Roscommon)', zip: '981678' },
	{ city: 'Annaghmore (Leitrim)', zip: '267922' },
	{ city: 'Annaghmore (Longford)', zip: '281981' },
	{ city: 'Annaghmore (Offaly)', zip: '808068' },
	{ city: 'Annaghmore (Roscommon)', zip: '231609' },
	{ city: 'Annaghmore (Sligo)', zip: '736830' },
	{ city: 'Annagh More (Cork)', zip: '933657' },
	{ city: 'Annagh More (Kerry)', zip: '824480' },
	{ city: 'Annagh More (Mayo)', zip: '937983' },
	{ city: 'Annagh More (Sligo)', zip: '397822' },
	{ city: 'Annagh More (Wexford)', zip: '446697' },
	{ city: 'Annaghmore And Annaghbeg (Offaly)', zip: '310174' },
	{ city: 'Annaghmore East (Galway)', zip: '203609' },
	{ city: 'Annaghmore West (Galway)', zip: '691643' },
	{ city: 'Annaghnamaddoo (Leitrim)', zip: '525143' },
	{ city: 'Annaghneal (Clare)', zip: '840483' },
	{ city: 'Annagh North (Cork)', zip: '944991' },
	{ city: 'Annaghoash (Cavan)', zip: '432795' },
	{ city: 'Annaghoney (Leitrim)', zip: '185293' },
	{ city: 'Annaghraw (Monaghan)', zip: '503107' },
	{ city: 'Annaghs (Kilkenny)', zip: '395749' },
	{ city: 'Annaghselherny (Leitrim)', zip: '931058' },
	{ city: 'Annagh South (Cork)', zip: '404710' },
	{ city: 'Annagh Upper (Leitrim)', zip: '967236' },
	{ city: 'Annagh Upper (Wexford)', zip: '203267' },
	{ city: 'Annaghvaan (Galway)', zip: '673819' },
	{ city: 'Annaghvacky (Louth)', zip: '793968' },
	{ city: 'Annagh West (Galway)', zip: '116354' },
	{ city: 'Annaghwood (Galway)', zip: '919810' },
	{ city: 'Annaghybane (Monaghan)', zip: '449598' },
	{ city: 'Annaghyduff (Monaghan)', zip: '381106' },
	{ city: 'Annagleve (Monaghan)', zip: '997281' },
	{ city: 'Annaglogh (Monaghan)', zip: '110990' },
	{ city: 'Annagloor (Cork)', zip: '129254' },
	{ city: 'Annagola (Monaghan)', zip: '644233' },
	{ city: 'Annagolan (Wicklow)', zip: '440945' },
	{ city: 'Annagor (Meath)', zip: '861624' },
	{ city: 'Annagose (Monaghan)', zip: '335658' },
	{ city: 'Annahagh (Monaghan)', zip: '642877' },
	{ city: 'Annahagh North (Monaghan)', zip: '871434' },
	{ city: 'Annahagh South (Monaghan)', zip: '947356' },
	{ city: 'Annahaia (Monaghan)', zip: '943694' },
	{ city: 'Annahalabog (Cork)', zip: '114213' },
	{ city: 'Annahala East (Cork)', zip: '797040' },
	{ city: 'Annahala West (Cork)', zip: '795317' },
	{ city: 'Annahale (Monaghan)', zip: '734799' },
	{ city: 'Annahean (Monaghan)', zip: '386481' },
	{ city: 'Annaholty (Tipperary)', zip: '906658' },
	{ city: 'Annahuby (Monaghan)', zip: '267251' },
	{ city: 'Anna Island (Donegal)', zip: '119931' },
	{ city: 'Annakisha (Cork)', zip: '919142' },
	{ city: 'Annakisha North (Cork)', zip: '588842' },
	{ city: 'Annakisha South (Cork)', zip: '897895' },
	{ city: 'Annalecka (Mayo)', zip: '745780' },
	{ city: 'Annaleck Lower (Kilkenny)', zip: '517202' },
	{ city: 'Annaleck Upper (Kilkenny)', zip: '826899' },
	{ city: 'Annalecky (Wicklow)', zip: '212209' },
	{ city: 'Annalittin (Monaghan)', zip: '829870' },
	{ city: 'Annalough (Kildare)', zip: '743101' },
	{ city: 'Annaloughan (Louth)', zip: '719918' },
	{ city: 'Annamacneill (Monaghan)', zip: '139107' },
	{ city: 'Annamakiff (Monaghan)', zip: '760018' },
	{ city: 'Annamarran (Monaghan)', zip: '745472' },
	{ city: 'Annamoe (Offaly)', zip: '585535' },
	{ city: 'Annamoe (Wicklow)', zip: '719746' },
	{ city: 'Anna More (Kerry)', zip: '668261' },
	{ city: 'Annamult (Kilkenny)', zip: '932145' },
	{ city: 'Annaneese (Monaghan)', zip: '720294' },
	{ city: 'Annareagh North (Monaghan)', zip: '546645' },
	{ city: 'Annareagh South (Monaghan)', zip: '445130' },
	{ city: 'Annaroe (Monaghan)', zip: '874322' },
	{ city: 'Annaseeragh (Monaghan)', zip: '704142' },
	{ city: 'Annaskinnan (Westmeath)', zip: '829208' },
	{ city: 'Annaslee (Donegal)', zip: '183633' },
	{ city: 'Annaveagh (Monaghan)', zip: '337145' },
	{ city: 'Annayalla (Monaghan)', zip: '205594' },
	{ city: 'Annees (Cork)', zip: '210413' },
	{ city: 'Annefield (Cork)', zip: '682995' },
	{ city: 'Annefield (Kilkenny)', zip: '623840' },
	{ city: 'Annefield (Mayo)', zip: '123107' },
	{ city: 'Annefield (Wexford)', zip: '987513' },
	{ city: 'Annesgift (Tipperary)', zip: '795772' },
	{ city: 'Annesgrove (Cork)', zip: '648818' },
	{ city: 'Annestown (Waterford)', zip: '581572' },
	{ city: 'Anneville (Clare)', zip: '644548' },
	{ city: 'Anneville (Laois)', zip: '877098' },
	{ city: 'Anneville (Meath)', zip: '180210' },
	{ city: 'Anneville (Westmeath)', zip: '449693' },
	{ city: 'Annfield (Dublin)', zip: '569404' },
	{ city: 'Annfield (Kilkenny)', zip: '373599' },
	{ city: 'Annfield (Tipperary)', zip: '827800' },
	{ city: 'Anngrove (Cork)', zip: '712945' },
	{ city: 'Annies (Louth)', zip: '814273' },
	{ city: 'Annies (Mayo)', zip: '226235' },
	{ city: 'Annies (Monaghan)', zip: '542783' },
	{ city: 'Annistown (Cork)', zip: '988761' },
	{ city: 'Annsbrook (Dublin)', zip: '609605' },
	{ city: 'Anny (Monaghan)', zip: '170611' },
	{ city: 'Annyalty (Monaghan)', zip: '544183' },
	{ city: 'Annyart (Monaghan)', zip: '436121' },
	{ city: 'Annyeeb (Monaghan)', zip: '554634' },
	{ city: 'Annyerk (Monaghan)', zip: '595055' },
	{ city: 'Anny Far And Near (Donegal)', zip: '151510' },
	{ city: 'Anrittabeg (Roscommon)', zip: '808326' },
	{ city: 'Anskert (Leitrim)', zip: '703235' },
	{ city: 'Anster (Laois)', zip: '651511' },
	{ city: 'Antfield (Leitrim)', zip: '551059' },
	{ city: 'Antylstown (Meath)', zip: '551319' },
	{ city: 'Anveyerg (Monaghan)', zip: '616173' },
	{ city: 'Aphort (Donegal)', zip: '951518' },
	{ city: 'Applefort (Clare)', zip: '970481' },
	{ city: 'Appletown (Limerick)', zip: '673391' },
	{ city: 'Applevale (Clare)', zip: '660948' },
	{ city: 'Ara (Mayo)', zip: '445881' },
	{ city: 'Arabela (Kerry)', zip: '223991' },
	{ city: 'Araghty (Roscommon)', zip: '867005' },
	{ city: 'Araglin (Cork)', zip: '546127' },
	{ city: 'Aran Island (Donegal)', zip: '677152' },
	{ city: 'Arbatt (Donegal)', zip: '286539' },
	{ city: 'Arbourhill (Tipperary)', zip: '311085' },
	{ city: 'Archdeaconry Glebe (Meath)', zip: '683712' },
	{ city: 'Archersgrove (Kilkenny)', zip: '969796' },
	{ city: 'Archersleas (Kilkenny)', zip: '485531' },
	{ city: 'Archersrath (Kilkenny)', zip: '253043' },
	{ city: 'Archerstown (Laois)', zip: '786549' },
	{ city: 'Archerstown (Meath)', zip: '640942' },
	{ city: 'Archerstown (Tipperary)', zip: '483683' },
	{ city: 'Archerstown (Westmeath)', zip: '590846' },
	{ city: 'Archerstreet Lot (Kilkenny)', zip: '741688' },
	{ city: 'Arch Hall (Meath)', zip: '413432' },
	{ city: 'Arclintagh (Monaghan)', zip: '947582' },
	{ city: 'Ard (Galway)', zip: '163287' },
	{ city: 'Ard (Offaly)', zip: '169192' },
	{ city: 'Ardabaun (Kerry)', zip: '453545' },
	{ city: 'Ardabrone (Sligo)', zip: '402461' },
	{ city: 'Ardacarha (Mayo)', zip: '833514' },
	{ city: 'Ardachrin (Donegal)', zip: '187438' },
	{ city: 'Ardacluckeen (Kerry)', zip: '798853' },
	{ city: 'Ardacluggin (Cork)', zip: '485561' },
	{ city: 'Ardacong (Galway)', zip: '119004' },
	{ city: 'Ardacrow (Cork)', zip: '518345' },
	{ city: 'Ardadam (Cork)', zip: '639172' },
	{ city: 'Ardagannive (Cork)', zip: '923287' },
	{ city: 'Ardaganny (Donegal)', zip: '713583' },
	{ city: 'Ardagawna (Roscommon)', zip: '684643' },
	{ city: 'Ardagh (Cork)', zip: '210819' },
	{ city: 'Ardagh (Donegal)', zip: '669604' },
	{ city: 'Ardagh (Galway)', zip: '772163' },
	{ city: 'Ardagh (Kerry)', zip: '184388' },
	{ city: 'Ardagh (Leitrim)', zip: '811362' },
	{ city: 'Ardagh (Limerick)', zip: '921493' },
	{ city: 'Ardagh (Louth)', zip: '906077' },
	{ city: 'Ardagh (Mayo)', zip: '613984' },
	{ city: 'Ardagh (Meath)', zip: '985047' },
	{ city: 'Ardagh (Roscommon)', zip: '661080' },
	{ city: 'Ardagh (Sligo)', zip: '613726' },
	{ city: 'Ardagh Demesne (Longford)', zip: '309407' },
	{ city: 'Ardagh East (Cork)', zip: '385040' },
	{ city: 'Ardagh North (Cork)', zip: '636161' },
	{ city: 'Ardagh South (Cork)', zip: '158320' },
	{ city: 'Ardagh West (Cork)', zip: '686674' },
	{ city: 'Ardaghy (Louth)', zip: '912303' },
	{ city: 'Ardaghy (Monaghan)', zip: '435945' },
	{ city: 'Ardaghy Glebe (Donegal)', zip: '222402' },
	{ city: 'Ardaghy Kill (Monaghan)', zip: '831577' },
	{ city: 'Ardagilla (Cork)', zip: '364644' },
	{ city: 'Ardagullion (Longford)', zip: '744677' },
	{ city: 'Ardahee (Donegal)', zip: '523390' },
	{ city: 'Ardahill (Cork)', zip: '531303' },
	{ city: 'Ardakillin (Roscommon)', zip: '574807' },
	{ city: 'Ardakip Beg (Leitrim)', zip: '492699' },
	{ city: 'Ardakip More (Leitrim)', zip: '580273' },
	{ city: 'Ardaloo (Kilkenny)', zip: '790856' },
	{ city: 'Ardamadane (Cork)', zip: '204993' },
	{ city: 'Ardamagh (Cavan)', zip: '829627' },
	{ city: 'Ardamore (Kerry)', zip: '499133' },
	{ city: 'Ardamullivan (Galway)', zip: '699100' },
	{ city: 'Ardan (Cavan)', zip: '431835' },
	{ city: 'Ardan (Offaly)', zip: '404531' },
	{ city: 'Ardan (Westmeath)', zip: '125466' },
	{ city: 'Ardanaffrin (Roscommon)', zip: '247424' },
	{ city: 'Ardanairy (Wicklow)', zip: '301342' },
	{ city: 'Ardane (Galway)', zip: '198418' },
	{ city: 'Ardane (Tipperary)', zip: '919749' },
	{ city: 'Ardaneanig (Kerry)', zip: '310556' },
	{ city: 'Ardaneer (Limerick)', zip: '897713' },
	{ city: 'Ardaneneen (Cork)', zip: '867602' },
	{ city: 'Ardanenig (Cork)', zip: '401179' },
	{ city: 'Ardanew (Meath)', zip: '293305' },
	{ city: 'Ardanragh (Longford)', zip: '819701' },
	{ city: 'Ardanreagh (Limerick)', zip: '503677' },
	{ city: 'Ardaprior (Cork)', zip: '687393' },
	{ city: 'Ardara (Donegal)', zip: '305912' },
	{ city: 'Ardaragh East (Cork)', zip: '742810' },
	{ city: 'Ardaragh West (Cork)', zip: '785860' },
	{ city: 'Ardaravan (Donegal)', zip: '916978' },
	{ city: 'Ardarawer (Donegal)', zip: '803612' },
	{ city: 'Ardardagh (Cavan)', zip: '501213' },
	{ city: 'Ardarostig (Cork)', zip: '716364' },
	{ city: 'Ardarou (Cork)', zip: '748681' },
	{ city: 'Ardarragh (Cavan)', zip: '460802' },
	{ city: 'Ardarrig (Cork)', zip: '584328' },
	{ city: 'Ardass (Roscommon)', zip: '199708' },
	{ city: 'Ardataggle (Clare)', zip: '330546' },
	{ city: 'Ardatedaun (Kerry)', zip: '952668' },
	{ city: 'Ardateggle (Laois)', zip: '765928' },
	{ city: 'Ardatowel (Donegal)', zip: '765063' },
	{ city: 'Ardattin (Carlow)', zip: '741461' },
	{ city: 'Ardaturr (Donegal)', zip: '958910' },
	{ city: 'Ardaturrish Beg (Cork)', zip: '470359' },
	{ city: 'Ardaturrish More (Cork)', zip: '586519' },
	{ city: 'Ardaturr Mountain (Donegal)', zip: '122969' },
	{ city: 'Ardaun (Galway)', zip: '147643' },
	{ city: 'Ardaun East (Galway)', zip: '211489' },
	{ city: 'Ardaun West (Galway)', zip: '542951' },
	{ city: 'Ardavagga (Offaly)', zip: '673584' },
	{ city: 'Ardavullane (Tipperary)', zip: '406475' },
	{ city: 'Ardawarry (Galway)', zip: '464528' },
	{ city: 'Ardballan (Louth)', zip: '168916' },
	{ city: 'Ardballymore (Westmeath)', zip: '756035' },
	{ city: 'Ardbane (Donegal)', zip: '276536' },
	{ city: 'Ardbane (Tipperary)', zip: '867911' },
	{ city: 'Ardbash (Offaly)', zip: '384065' },
	{ city: 'Ardbaun (Tipperary)', zip: '760744' },
	{ city: 'Ardbear (Galway)', zip: '165030' },
	{ city: 'Ardbearn (Carlow)', zip: '282606' },
	{ city: 'Ardbearn And Torman (Carlow)', zip: '331921' },
	{ city: 'Ardbeg (Kerry)', zip: '644391' },
	{ city: 'Ardbeg (Kilkenny)', zip: '897181' },
	{ city: 'Ardberreen (Galway)', zip: '566746' },
	{ city: 'Ardboghil (Longford)', zip: '947829' },
	{ city: 'Ardbohil (Limerick)', zip: '662078' },
	{ city: 'Ardboley North (Mayo)', zip: '743993' },
	{ city: 'Ardboley South (Mayo)', zip: '809779' },
	{ city: 'Ardbolies (Louth)', zip: '298285' },
	{ city: 'Ardbooly Lower (Clare)', zip: '146389' },
	{ city: 'Ardbooly Upper (Clare)', zip: '312864' },
	{ city: 'Ardborra (Westmeath)', zip: '663348' },
	{ city: 'Ardboy (Kilkenny)', zip: '220889' },
	{ city: 'Ardbraccan (Meath)', zip: '409847' },
	{ city: 'Ardbrack (Cork)', zip: '865959' },
	{ city: 'Ardbrackan (Meath)', zip: '588018' },
	{ city: 'Ardbrennan (Westmeath)', zip: '511526' },
	{ city: 'Ardbuckan (Westmeath)', zip: '964459' },
	{ city: 'Ardcahan (Cork)', zip: '153830' },
	{ city: 'Ardcalf (Meath)', zip: '388306' },
	{ city: 'Ardcanaght (Kerry)', zip: '102742' },
	{ city: 'Ardcandrisk (Wexford)', zip: '701667' },
	{ city: 'Ardcarn (Roscommon)', zip: '833084' },
	{ city: 'Ardcarney (Clare)', zip: '292906' },
	{ city: 'Ardcath (Meath)', zip: '873306' },
	{ city: 'Ardcavan (Wexford)', zip: '543018' },
	{ city: 'Ardchamoyle (Roscommon)', zip: '251216' },
	{ city: 'Ardchicken (Donegal)', zip: '690613' },
	{ city: 'Ardclogh (Kildare)', zip: '268264' },
	{ city: 'Ardclone (Kilkenny)', zip: '257937' },
	{ city: 'Ardcloon (Galway)', zip: '466522' },
	{ city: 'Ardcloon (Mayo)', zip: '918587' },
	{ city: 'Ardcloony (Clare)', zip: '695420' },
	{ city: 'Ardcloyne (Cork)', zip: '921943' },
	{ city: 'Ardcolagh (Roscommon)', zip: '845554' },
	{ city: 'Ardcollum (Roscommon)', zip: '474290' },
	{ city: 'Ardcolm (Wexford)', zip: '312905' },
	{ city: 'Ardcolman (Roscommon)', zip: '563663' },
	{ city: 'Ardcolum (Leitrim)', zip: '546519' },
	{ city: 'Ardconnell (Kerry)', zip: '276319' },
	{ city: 'Ardconnell (Sligo)', zip: '224547' },
	{ city: 'Ardconra (Roscommon)', zip: '998938' },
	{ city: 'Ardcoohig (Cork)', zip: '105812' },
	{ city: 'Ardcorcoran (Roscommon)', zip: '859449' },
	{ city: 'Ardcorky (Mayo)', zip: '692870' },
	{ city: 'Ardcost (Kerry)', zip: '676468' },
	{ city: 'Ardcotten (Sligo)', zip: '998062' },
	{ city: 'Ardcree (Sligo)', zip: '477140' },
	{ city: 'Ardcrone (Kerry)', zip: '308960' },
	{ city: 'Ardcrony (Tipperary)', zip: '290054' },
	{ city: 'Ardcullen (Kerry)', zip: '850493' },
	{ city: 'Ardcullen-Marshes (Kerry)', zip: '566492' },
	{ city: 'Ardcumber (Sligo)', zip: '235702' },
	{ city: 'Ardcurley (Sligo)', zip: '560745' },
	{ city: 'Ardderroo (Galway)', zip: '940887' },
	{ city: 'Ardderrynagleragh (Galway)', zip: '242402' },
	{ city: 'Arddrine (Limerick)', zip: '936072' },
	{ city: 'Ardea (Cork)', zip: '142130' },
	{ city: 'Ardea (Kerry)', zip: '553499' },
	{ city: 'Ardeamush (Clare)', zip: '516180' },
	{ city: 'Ardeash (Roscommon)', zip: '585492' },
	{ city: 'Ard East (Galway)', zip: '486506' },
	{ city: 'Ardee (Donegal)', zip: '387508' },
	{ city: 'Ardee (Louth)', zip: '710187' },
	{ city: 'Ardeelan Lower (Donegal)', zip: '778952' },
	{ city: 'Ardeelan Upper (Donegal)', zip: '115626' },
	{ city: 'Ardeen (Cork)', zip: '481488' },
	{ city: 'Ardeen (Kerry)', zip: '705415' },
	{ city: 'Ardeenloun East (Waterford)', zip: '621945' },
	{ city: 'Ardeenloun West (Waterford)', zip: '324281' },
	{ city: 'Ardeevin (Donegal)', zip: '117348' },
	{ city: 'Ardeevin (Galway)', zip: '352188' },
	{ city: 'Ardeevin (Roscommon)', zip: '579005' },
	{ city: 'Ardellis Lower (Kildare)', zip: '439370' },
	{ city: 'Ardellis Upper (Kildare)', zip: '798497' },
	{ city: 'Ardenagh Great (Wexford)', zip: '353493' },
	{ city: 'Ardenagh Little (Wexford)', zip: '595602' },
	{ city: 'Arderra (Kilkenny)', zip: '912943' },
	{ city: 'Arderrawinny (Cork)', zip: '367831' },
	{ city: 'Arderrow (Cork)', zip: '492681' },
	{ city: 'Arderry (Cavan)', zip: '926672' },
	{ city: 'Arderry (Leitrim)', zip: '966144' },
	{ city: 'Arderry (Mayo)', zip: '163709' },
	{ city: 'Ardeskin (Donegal)', zip: '631221' },
	{ city: 'Ardfarn (Donegal)', zip: '905285' },
	{ city: 'Ardfert (Kerry)', zip: '837436' },
	{ city: 'Ardfert Oughter (Kerry)', zip: '641596' },
	{ city: 'Ardfield (Cork)', zip: '313643' },
	{ city: 'Ardfinnan (Tipperary)', zip: '104177' },
	{ city: 'Ardfintan (Galway)', zip: '852901' },
	{ city: 'Ardfrail (Meath)', zip: '520130' },
	{ city: 'Ardfry (Galway)', zip: '687961' },
	{ city: 'Ardgaineen (Galway)', zip: '960333' },
	{ city: 'Ardgallagher (Roscommon)', zip: '245486' },
	{ city: 'Ardgallin (Sligo)', zip: '691049' },
	{ city: 'Ardgeeha (Tipperary)', zip: '373002' },
	{ city: 'Ardgeeha Lower (Tipperary)', zip: '641394' },
	{ city: 'Ardgeeha Upper (Tipperary)', zip: '228992' },
	{ city: 'Ardgehane (Cork)', zip: '563611' },
	{ city: 'Ardgillan Demesne (Dublin)', zip: '154096' },
	{ city: 'Ardgillew (Donegal)', zip: '391783' },
	{ city: 'Ardginny (Monaghan)', zip: '707056' },
	{ city: 'Ardgivna (Sligo)', zip: '822575' },
	{ city: 'Ardglare (Cork)', zip: '540134' },
	{ city: 'Ardglass (Cork)', zip: '611824' },
	{ city: 'Ardglass (Donegal)', zip: '256200' },
	{ city: 'Ardglass (Roscommon)', zip: '712194' },
	{ city: 'Ardglassan (Meath)', zip: '413066' },
	{ city: 'Ardglushin (Cavan)', zip: '242214' },
	{ city: 'Ardgort (Cork)', zip: '567607' },
	{ city: 'Ardgoulbeg (Limerick)', zip: '855106' },
	{ city: 'Ardgoul North (Limerick)', zip: '750227' },
	{ city: 'Ardgoul South (Limerick)', zip: '902006' },
	{ city: 'Ardgraigue (Galway)', zip: '188414' },
	{ city: 'Ardgreagh (Meath)', zip: '712723' },
	{ city: 'Ardgregane (Tipperary)', zip: '173724' },
	{ city: 'Ardgroom (Cork)', zip: '549873' },
	{ city: 'Ardgroom Inward (Cork)', zip: '322529' },
	{ city: 'Ardgroom Outward (Cork)', zip: '573936' },
	{ city: 'Ardhoom (Mayo)', zip: '827482' },
	{ city: 'Ardillaun (Galway)', zip: '745698' },
	{ city: 'Ardillon (Westmeath)', zip: '648434' },
	{ city: 'Ardinawark (Donegal)', zip: '918480' },
	{ city: 'Ardinode East (Kildare)', zip: '130717' },
	{ city: 'Ardinode West (Kildare)', zip: '137449' },
	{ city: 'Ardintenant (Cork)', zip: '382486' },
	{ city: 'Ardivaghan (Westmeath)', zip: '891811' },
	{ city: 'Ardkearagh (Kerry)', zip: '569151' },
	{ city: 'Ardkeel (Roscommon)', zip: '253262' },
	{ city: 'Ardkeen (Mayo)', zip: '101610' },
	{ city: 'Ardkeen (Tipperary)', zip: '274693' },
	{ city: 'Ardkeenagh (Roscommon)', zip: '864665' },
	{ city: 'Ardkeenan (Roscommon)', zip: '656424' },
	{ city: 'Ardkeeran (Sligo)', zip: '683724' },
	{ city: 'Ardkill (Kildare)', zip: '844922' },
	{ city: 'Ardkill (Mayo)', zip: '276948' },
	{ city: 'Ardkill (Roscommon)', zip: '323945' },
	{ city: 'Ardkill (Sligo)', zip: '706388' },
	{ city: 'Ardkill Beg (Cavan)', zip: '564200' },
	{ city: 'Ardkilleen (Cork)', zip: '689826' },
	{ city: 'Ardkill More (Cavan)', zip: '935312' },
	{ city: 'Ardkilly (Cork)', zip: '611924' },
	{ city: 'Ardkilmartin (Limerick)', zip: '102836' },
	{ city: 'Ardkirk (Monaghan)', zip: '688790' },
	{ city: 'Ardkitt East (Cork)', zip: '561726' },
	{ city: 'Ardkitt West (Cork)', zip: '599217' },
	{ city: 'Ardkyle (Clare)', zip: '140916' },
	{ city: 'Ardkyle (Galway)', zip: '172448' },
	{ city: 'Ardla (Dublin)', zip: '431355' },
	{ city: 'Ardlaghas (Kerry)', zip: '799990' },
	{ city: 'Ardlagheen Beg (Roscommon)', zip: '276367' },
	{ city: 'Ardlagheen More (Roscommon)', zip: '880360' },
	{ city: 'Ardlahan (Limerick)', zip: '414747' },
	{ city: 'Ardlaman (Limerick)', zip: '819449' },
	{ city: 'Ardlaman (Tipperary)', zip: '281287' },
	{ city: 'Ardlaraghan (Louth)', zip: '380479' },
	{ city: 'Ardlavagh (Roscommon)', zip: '397422' },
	{ city: 'Ardlea (Laois)', zip: '360797' },
	{ city: 'Ardleag (Cork)', zip: '191507' },
	{ city: 'Ardleckna (Roscommon)', zip: '146587' },
	{ city: 'Ardlee (Mayo)', zip: '232468' },
	{ city: 'Ardlee (Sligo)', zip: '750782' },
	{ city: 'Ardleebeg (Sligo)', zip: '701376' },
	{ city: 'Ardlenagh (Donegal)', zip: '327677' },
	{ city: 'Ardleny (Cavan)', zip: '950657' },
	{ city: 'Ardline (Sligo)', zip: '249612' },
	{ city: 'Ardloman (Tipperary)', zip: '199238' },
	{ city: 'Ardlona (Sligo)', zip: '122696' },
	{ city: 'Ardlonan (Meath)', zip: '325233' },
	{ city: 'Ardlougher (Cavan)', zip: '523585' },
	{ city: 'Ardlougher (Donegal)', zip: '594666' },
	{ city: 'Ardlougher (Leitrim)', zip: '784856' },
	{ city: 'Ardlougher (Roscommon)', zip: '994849' },
	{ city: 'Ardloughill (Donegal)', zip: '376845' },
	{ city: 'Ardlow (Cavan)', zip: '956532' },
	{ city: 'Ardloy (Sligo)', zip: '136935' },
	{ city: 'Ardmaclancy (Clare)', zip: '137262' },
	{ city: 'Ardmacroan (Roscommon)', zip: '717274' },
	{ city: 'Ardmaghbreague (Meath)', zip: '293340' },
	{ city: 'Ardmalin (Donegal)', zip: '865462' },
	{ city: 'Ardmanagh (Cork)', zip: '457224' },
	{ city: 'Ardmartin (Cork)', zip: '962934' },
	{ city: 'Ardmayle (Tipperary)', zip: '913587' },
	{ city: 'Ardmayle East (Tipperary)', zip: '798907' },
	{ city: 'Ardmayle West (Tipperary)', zip: '869194' },
	{ city: 'Ardmeelode (Kerry)', zip: '376315' },
	{ city: 'Ardmeen (Donegal)', zip: '254149' },
	{ city: 'Ardmeenan (Leitrim)', zip: '621048' },
	{ city: 'Ardminnan (Sligo)', zip: '125119' },
	{ city: 'Ardmone (Cavan)', zip: '931958' },
	{ city: 'Ardmone East (Cavan)', zip: '717851' },
	{ city: 'Ardmoneel (Kerry)', zip: '639938' },
	{ city: 'Ardmoneen (Cavan)', zip: '325698' },
	{ city: 'Ardmoneen (Leitrim)', zip: '213100' },
	{ city: 'Ardmone West (Cavan)', zip: '825429' },
	{ city: 'Ardmoran (Mayo)', zip: '639048' },
	{ city: 'Ardmore (Clare)', zip: '995489' },
	{ city: 'Ardmore (Cork)', zip: '163586' },
	{ city: 'Ardmore (Donegal)', zip: '348697' },
	{ city: 'Ardmore (Galway)', zip: '914094' },
	{ city: 'Ardmore (Kerry)', zip: '392095' },
	{ city: 'Ardmore (Kildare)', zip: '297209' },
	{ city: 'Ardmore (Limerick)', zip: '130760' },
	{ city: 'Ardmore (Mayo)', zip: '209720' },
	{ city: 'Ardmore (Roscommon)', zip: '667520' },
	{ city: 'Ardmore (Waterford)', zip: '920423' },
	{ city: 'Ardmore (Westmeath)', zip: '677477' },
	{ city: 'Ardmore Point (Mayo)', zip: '773377' },
	{ city: 'Ardmorney (Westmeath)', zip: '327785' },
	{ city: 'Ardmoyle (Roscommon)', zip: '143940' },
	{ city: 'Ardmoyle (Sligo)', zip: '446584' },
	{ city: 'Ardmulchan (Meath)', zip: '883001' },
	{ city: 'Ardmullan (Roscommon)', zip: '422106' },
	{ city: 'Ardnableask (Donegal)', zip: '462039' },
	{ city: 'Ardnaboha (Cork)', zip: '126120' },
	{ city: 'Ardnabourkey (Cork)', zip: '928210' },
	{ city: 'Ardnaboy (Wicklow)', zip: '929073' },
	{ city: 'Ardnacally (Mayo)', zip: '676000' },
	{ city: 'Ardnacassagh (Longford)', zip: '238432' },
	{ city: 'Ardnacloghy (Cork)', zip: '767886' },
	{ city: 'Ardnaclug (Cork)', zip: '475526' },
	{ city: 'Ardnacraa (Clare)', zip: '818848' },
	{ city: 'Ardnacrany North (Westmeath)', zip: '728154' },
	{ city: 'Ardnacrany South (Westmeath)', zip: '671068' },
	{ city: 'Ardnacrohy (Limerick)', zip: '948600' },
	{ city: 'Ardnacross Island (Galway)', zip: '844292' },
	{ city: 'Ardnacrusha (Clare)', zip: '515855' },
	{ city: 'Ardnacrushy (Cork)', zip: '643628' },
	{ city: 'Ardnacullia North (Clare)', zip: '486680' },
	{ city: 'Ardnacullia South (Clare)', zip: '681302' },
	{ city: 'Ardnaditian (Donegal)', zip: '201519' },
	{ city: 'Ardnadoman East (Galway)', zip: '723811' },
	{ city: 'Ardnadoman West (Galway)', zip: '617186' },
	{ city: 'Ardnagall (Galway)', zip: '393750' },
	{ city: 'Ardnagalliagh (Donegal)', zip: '630853' },
	{ city: 'Ardnagannagh (Donegal)', zip: '678428' },
	{ city: 'Ardnagappary (Donegal)', zip: '812839' },
	{ city: 'Ardnagashel (Cork)', zip: '835252' },
	{ city: 'Ardnagassan (Donegal)', zip: '927950' },
	{ city: 'Ardnagassane (Tipperary)', zip: '413381' },
	{ city: 'Ardnageeha (Cork)', zip: '536518' },
	{ city: 'Ardnageeha (Galway)', zip: '787327' },
	{ city: 'Ardnageehy (Cork)', zip: '560683' },
	{ city: 'Ardnageehy Beg (Cork)', zip: '370821' },
	{ city: 'Ardnageehy East (Cork)', zip: '673319' },
	{ city: 'Ardnageehy More (Cork)', zip: '263837' },
	{ city: 'Ardnageehy West (Cork)', zip: '279018' },
	{ city: 'Ardnagla (Clare)', zip: '299185' },
	{ city: 'Ardnaglass (Donegal)', zip: '929317' },
	{ city: 'Ardnaglass (Sligo)', zip: '663338' },
	{ city: 'Ardnaglass Lower (Sligo)', zip: '517956' },
	{ city: 'Ardnaglass Upper (Sligo)', zip: '366304' },
	{ city: 'Ardnaglew (Westmeath)', zip: '273101' },
	{ city: 'Ardnaglug (Roscommon)', zip: '956334' },
	{ city: 'Ardnaglug (Westmeath)', zip: '450953' },
	{ city: 'Ardnagno (Galway)', zip: '108723' },
	{ city: 'Ardnagor (Mayo)', zip: '417476' },
	{ city: 'Ardnagowna (Roscommon)', zip: '527361' },
	{ city: 'Ardnagragh (Westmeath)', zip: '392196' },
	{ city: 'Ardnagreevagh (Galway)', zip: '584184' },
	{ city: 'Ardnagrena (Cork)', zip: '198136' },
	{ city: 'Ardnagroghery (Cork)', zip: '830382' },
	{ city: 'Ardnagross (Kildare)', zip: '984307' },
	{ city: 'Ardnagross (Westmeath)', zip: '874124' },
	{ city: 'Ardnahea (Clare)', zip: '834416' },
	{ city: 'Ardnahinch (Cork)', zip: '919858' },
	{ city: 'Ardnahow (Waterford)', zip: '608976' },
	{ city: 'Ardnamanagh (Cork)', zip: '406922' },
	{ city: 'Ardnamoghill (Donegal)', zip: '245430' },
	{ city: 'Ardnamoher (Limerick)', zip: '505635' },
	{ city: 'Ardnamullagh (Roscommon)', zip: '479395' },
	{ city: 'Ardnamullan (Meath)', zip: '954541' },
	{ city: 'Ardnamweely (Kerry)', zip: '957951' },
	{ city: 'Ardnanagh (Roscommon)', zip: '670664' },
	{ city: 'Ardnanean (Limerick)', zip: '671314' },
	{ city: 'Ardnanure (Roscommon)', zip: '939992' },
	{ city: 'Ardnaponra (Westmeath)', zip: '412932' },
	{ city: 'Ardnapreaghaun (Limerick)', zip: '156036' },
	{ city: 'Ardnaree (Donegal)', zip: '527026' },
	{ city: 'Ardnaree (Mayo)', zip: '556628' },
	{ city: 'Ardnasallem (Monaghan)', zip: '932197' },
	{ city: 'Ardnasillagh (Galway)', zip: '188989' },
	{ city: 'Ardnasodan (Galway)', zip: '257422' },
	{ city: 'Ardnasool (Donegal)', zip: '382999' },
	{ city: 'Ardnaveagh (Limerick)', zip: '461712' },
	{ city: 'Ardneeskan (Sligo)', zip: '126735' },
	{ city: 'Ardnehue (Carlow)', zip: '187463' },
	{ city: 'Ardnurcher (Westmeath)', zip: '173596' },
	{ city: 'Ardnurcher Glebe (Offaly)', zip: '553992' },
	{ city: 'Ardobireen (Tipperary)', zip: '800893' },
	{ city: 'Ardocheasty (Waterford)', zip: '139632' },
	{ city: 'Ardogeena (Cork)', zip: '949841' },
	{ city: 'Ardogelly (Sligo)', zip: '205403' },
	{ city: 'Ardoghil (Longford)', zip: '264594' },
	{ city: 'Ardoginna (Waterford)', zip: '939351' },
	{ city: 'Ardogommon (Mayo)', zip: '767745' },
	{ city: 'Ardohill (Tipperary)', zip: '383624' },
	{ city: 'Ardoley (Mayo)', zip: '838045' },
	{ city: 'Ardonan (Cavan)', zip: '991200' },
	{ city: 'Ardoohy (Cavan)', zip: '220265' },
	{ city: 'Ardoslough (Galway)', zip: '974397' },
	{ city: 'Ardough (Laois)', zip: '681499' },
	{ city: 'Ardoughan (Mayo)', zip: '210194' },
	{ city: 'Ardoughter (Kerry)', zip: '206147' },
	{ city: 'Ardour (Galway)', zip: '824209' },
	{ city: 'Ardowen (Mayo)', zip: '529330' },
	{ city: 'Ardowen Common (Mayo)', zip: '155343' },
	{ city: 'Ardoyne (Wicklow)', zip: '578467' },
	{ city: 'Ardpaddin (Waterford)', zip: '516520' },
	{ city: 'Ardpatrick (Limerick)', zip: '287275' },
	{ city: 'Ardpatrick (Louth)', zip: '876103' },
	{ city: 'Ardpattan (Donegal)', zip: '206143' },
	{ city: 'Ardra (Cavan)', zip: '124091' },
	{ city: 'Ardra (Cork)', zip: '955418' },
	{ city: 'Ardra (Kilkenny)', zip: '519229' },
	{ city: 'Ardra (Offaly)', zip: '740069' },
	{ city: 'Ardra Beg (Cork)', zip: '780853' },
	{ city: 'Ardragh (Monaghan)', zip: '855370' },
	{ city: 'Ardragh (Tipperary)', zip: '270905' },
	{ city: 'Ardrah (Cork)', zip: '869451' },
	{ city: 'Ardrahan (Galway)', zip: '289948' },
	{ city: 'Ardrahan (Kerry)', zip: '196847' },
	{ city: 'Ardrahan North (Galway)', zip: '494945' },
	{ city: 'Ardrahan South (Galway)', zip: '688255' },
	{ city: 'Ardraheen Beg (Sligo)', zip: '384422' },
	{ city: 'Ardraheen More (Sligo)', zip: '591753' },
	{ city: 'Ardrahin (Limerick)', zip: '289377' },
	{ city: 'Ardraly (Cork)', zip: '866661' },
	{ city: 'Ardra More (Cork)', zip: '119461' },
	{ city: 'Ardranny Beg (Galway)', zip: '264074' },
	{ city: 'Ardranny More (Galway)', zip: '149447' },
	{ city: 'Ardrass (Mayo)', zip: '498123' },
	{ city: 'Ardrass Lower (Kildare)', zip: '304387' },
	{ city: 'Ardrass Upper (Kildare)', zip: '172805' },
	{ city: 'Ardraw (Kerry)', zip: '921799' },
	{ city: 'Ardrea (Sligo)', zip: '427161' },
	{ city: 'Ardreagh (Kilkenny)', zip: '171055' },
	{ city: 'Ardree (Kildare)', zip: '944404' },
	{ city: 'Ardree (Sligo)', zip: '136463' },
	{ city: 'Ardrew (Kildare)', zip: '720215' },
	{ city: 'Ardrinane (Kerry)', zip: '237142' },
	{ city: 'Ardristan (Carlow)', zip: '394898' },
	{ city: 'Ardroe (Kerry)', zip: '369342' },
	{ city: 'Ardroe (Limerick)', zip: '324772' },
	{ city: 'Ardroe (Mayo)', zip: '290852' },
	{ city: 'Ardros (Galway)', zip: '713536' },
	{ city: 'Ardross (Wexford)', zip: '474653' },
	{ city: 'Ardrum (Cork)', zip: '883329' },
	{ city: 'Ardrum (Leitrim)', zip: '411530' },
	{ city: 'Ardrumkilla (Galway)', zip: '104431' },
	{ city: 'Ardrumman (Donegal)', zip: '796684' },
	{ city: 'Ardrums Great (Meath)', zip: '460749' },
	{ city: 'Ardrums Little (Meath)', zip: '936109' },
	{ city: 'Ardrush (Clare)', zip: '556723' },
	{ city: 'Ards (Donegal)', zip: '656900' },
	{ city: 'Ards (Kerry)', zip: '836069' },
	{ city: 'Ards (Longford)', zip: '509543' },
	{ city: 'Ardsallagh (Meath)', zip: '399252' },
	{ city: 'Ardsallagh (Roscommon)', zip: '255263' },
	{ city: 'Ardsallagh (Sligo)', zip: '701078' },
	{ city: 'Ardsallagh (Tipperary)', zip: '947741' },
	{ city: 'Ardsallagh (Waterford)', zip: '512945' },
	{ city: 'Ardsallagh Beg (Roscommon)', zip: '881280' },
	{ city: 'Ardsallagh More (Roscommon)', zip: '229400' },
	{ city: 'Ards Beg (Cork)', zip: '842374' },
	{ city: 'Ards Beg (Donegal)', zip: '615436' },
	{ city: 'Ards Big (Donegal)', zip: '281284' },
	{ city: 'Ardscradaun (Kilkenny)', zip: '904242' },
	{ city: 'Ardscull (Kildare)', zip: '390537' },
	{ city: 'Ardshanavooly (Kerry)', zip: '929768' },
	{ city: 'Ardshanbally (Limerick)', zip: '896233' },
	{ city: 'Ardsheelhane East (Kerry)', zip: '580190' },
	{ city: 'Ardsheelhane West (Kerry)', zip: '919290' },
	{ city: 'Ardskea Beg (Galway)', zip: '244186' },
	{ city: 'Ardskeagh (Clare)', zip: '942822' },
	{ city: 'Ardskeagh (Cork)', zip: '807735' },
	{ city: 'Ardskea More (Galway)', zip: '318792' },
	{ city: 'Ards Little (Donegal)', zip: '171606' },
	{ city: 'Ards More (Cork)', zip: '650299' },
	{ city: 'Ards More (Donegal)', zip: '682597' },
	{ city: 'Ardsmore Mountain (Donegal)', zip: '697061' },
	{ city: 'Ardsollus (Clare)', zip: '614654' },
	{ city: 'Ardsoreen (Sligo)', zip: '138882' },
	{ city: 'Ardteegalvan (Kerry)', zip: '555200' },
	{ city: 'Ardtermon (Sligo)', zip: '149893' },
	{ city: 'Ardtomin (Limerick)', zip: '423692' },
	{ city: 'Ardtrasna (Sligo)', zip: '380198' },
	{ city: 'Ardtully (Kerry)', zip: '508213' },
	{ city: 'Ardtully Beg (Louth)', zip: '249022' },
	{ city: 'Ardtully More (Louth)', zip: '118174' },
	{ city: 'Ardue (Cavan)', zip: '321012' },
	{ city: 'Ardultagh (Galway)', zip: '564428' },
	{ city: 'Ardun (Donegal)', zip: '395335' },
	{ city: 'Arduns (Donegal)', zip: '402011' },
	{ city: 'Ardunsaghan (Leitrim)', zip: '867027' },
	{ city: 'Ardura Beg (Cork)', zip: '471034' },
	{ city: 'Ardura More (Cork)', zip: '598628' },
	{ city: 'Arduslough (Cork)', zip: '176860' },
	{ city: 'Ardvagh (Cavan)', zip: '704781' },
	{ city: 'Ardvally (Donegal)', zip: '754966' },
	{ city: 'Ardvally (Mayo)', zip: '179872' },
	{ city: 'Ardvarna (Galway)', zip: '799393' },
	{ city: 'Ardvarna (Limerick)', zip: '557537' },
	{ city: 'Ardvarney (Laois)', zip: '812771' },
	{ city: 'Ardvarney (Leitrim)', zip: '600046' },
	{ city: 'Ardvarney (Mayo)', zip: '832249' },
	{ city: 'Ardvarney (Sligo)', zip: '255362' },
	{ city: 'Ardvarnock Glebe (Donegal)', zip: '994414' },
	{ city: 'Ardvarny (Cavan)', zip: '757404' },
	{ city: 'Ardvone (Limerick)', zip: '177627' },
	{ city: 'Ard West (Galway)', zip: '366598' },
	{ city: 'Ardydonagan (Kerry)', zip: '251613' },
	{ city: 'Ardyduffy (Westmeath)', zip: '195955' },
	{ city: 'Ardyhoolihane (Cork)', zip: '204083' },
	{ city: 'Ardykeohane (Limerick)', zip: '391958' },
	{ city: 'Ardyoul (Limerick)', zip: '125938' },
	{ city: 'Ardywanig (Kerry)', zip: '586069' },
	{ city: 'Arigna (Roscommon)', zip: '787984' },
	{ city: 'Arignagh (Roscommon)', zip: '685419' },
	{ city: 'Arkeen Beg (Galway)', zip: '910953' },
	{ city: 'Arkeen More (Galway)', zip: '181386' },
	{ city: 'Arklow (Wexford)', zip: '342199' },
	{ city: 'Arklow (Wicklow)', zip: '557973' },
	{ city: 'Arlands (Donegal)', zip: '795790' },
	{ city: 'Arlinstown (Cork)', zip: '498895' },
	{ city: 'Arlonstown (Meath)', zip: '961227' },
	{ city: 'Arm (Roscommon)', zip: '427581' },
	{ city: 'Armyhill (Offaly)', zip: '726559' },
	{ city: 'Arnaghan (Cavan)', zip: '238280' },
	{ city: 'Arnasbrack (Sligo)', zip: '966003' },
	{ city: 'Arnestown (Wexford)', zip: '110480' },
	{ city: 'Aroddy (Leitrim)', zip: '618641' },
	{ city: 'Arodstown (Meath)', zip: '160088' },
	{ city: 'Arpinstown (Wexford)', zip: '300968' },
	{ city: 'Arraghan (Roscommon)', zip: '642759' },
	{ city: 'Arragh Beg (Tipperary)', zip: '951867' },
	{ city: 'Arragh More (Tipperary)', zip: '332455' },
	{ city: 'Arraglen (Kerry)', zip: '989989' },
	{ city: 'Arragorteen (Wexford)', zip: '691102' },
	{ city: 'Arranagh (Limerick)', zip: '406163' },
	{ city: 'Arrigal (Meath)', zip: '281346' },
	{ city: 'Arroo (Leitrim)', zip: '584750' },
	{ city: 'Arrybreaga (Limerick)', zip: '220092' },
	{ city: 'Arryheernabin (Donegal)', zip: '991859' },
	{ city: 'Artane (Dublin)', zip: '882966' },
	{ city: 'Arthurstown (Kildare)', zip: '330902' },
	{ city: 'Arthurstown (Louth)', zip: '862536' },
	{ city: 'Arthurstown (Wexford)', zip: '377871' },
	{ city: 'Arthurstown Little (Louth)', zip: '249920' },
	{ city: 'Artidowney (Cavan)', zip: '412100' },
	{ city: 'Artikellys (Donegal)', zip: '613242' },
	{ city: 'Artiteige (Cork)', zip: '159514' },
	{ city: 'Artnalevery (Louth)', zip: '536297' },
	{ city: 'Artonagh (Cavan)', zip: '411760' },
	{ city: 'Artoney (Louth)', zip: '797805' },
	{ city: 'Artramon (Wexford)', zip: '800427' },
	{ city: 'Arundelmills (Cork)', zip: '696525' },
	{ city: 'Arvagh (Cavan)', zip: '240195' },
	{ city: 'Arywee (Limerick)', zip: '234428' },
	{ city: 'Ash Big (Louth)', zip: '971393' },
	{ city: 'Ashbourne (Meath)', zip: '234024' },
	{ city: 'Ashbrook (Galway)', zip: '429844' },
	{ city: 'Ashbrook (Laois)', zip: '828994' },
	{ city: 'Ashbrook (Mayo)', zip: '566717' },
	{ city: 'Ashbrook (Roscommon)', zip: '937152' },
	{ city: 'Ashbury (Tipperary)', zip: '953588' },
	{ city: 'Ashfield (Dublin)', zip: '896660' },
	{ city: 'Ashfield (Galway)', zip: '541620' },
	{ city: 'Ashfield (Laois)', zip: '859492' },
	{ city: 'Ashfield (Meath)', zip: '404909' },
	{ city: 'Ashfield (Offaly)', zip: '151969' },
	{ city: 'Ashfield Demesne (Galway)', zip: '932226' },
	{ city: 'Ashford (Galway)', zip: '393780' },
	{ city: 'Ashford (Limerick)', zip: '991575' },
	{ city: 'Ashford (Wicklow)', zip: '625325' },
	{ city: 'Ashfort (Limerick)', zip: '840105' },
	{ city: 'Ashglen (Kilkenny)', zip: '699143' },
	{ city: 'Ashgrove (Cavan)', zip: '477537' },
	{ city: 'Ashgrove (Cork)', zip: '376410' },
	{ city: 'Ashgrove (Kildare)', zip: '222894' },
	{ city: 'Ashgrove (Limerick)', zip: '379017' },
	{ city: 'Ashgrove (Tipperary)', zip: '332881' },
	{ city: 'Ashhill (Tipperary)', zip: '768119' },
	{ city: 'Ash Hill (Limerick)', zip: '394484' },
	{ city: 'Ash-Hill (Kerry)', zip: '924915' },
	{ city: 'Ashleypark (Tipperary)', zip: '972875' },
	{ city: 'Ash Little (Louth)', zip: '837344' },
	{ city: 'Ashpark (Meath)', zip: '848753' },
	{ city: 'Ashpark (Roscommon)', zip: '827264' },
	{ city: 'Ashpark (Tipperary)', zip: '481412' },
	{ city: 'Ashroe (Limerick)', zip: '549760' },
	{ city: 'Ashtown (Dublin)', zip: '422694' },
	{ city: 'Ashtown (Kilkenny)', zip: '528072' },
	{ city: 'Ashtown (Waterford)', zip: '513750' },
	{ city: 'Ashtown (Wicklow)', zip: '732833' },
	{ city: "Ashwell's-Lot (Tipperary)", zip: '604458' },
	{ city: 'Ashwood Lower (Wexford)', zip: '183360' },
	{ city: 'Ashwood Upper (Wexford)', zip: '953369' },
	{ city: 'Ask (Wexford)', zip: '624927' },
	{ city: 'Askabeg (Wexford)', zip: '144071' },
	{ city: 'Aska Beg (Wexford)', zip: '981531' },
	{ city: 'Askaheige (Wexford)', zip: '194371' },
	{ city: 'Askakeagh (Wicklow)', zip: '246233' },
	{ city: 'Askakeel (Wexford)', zip: '867665' },
	{ city: 'Askamore (Wexford)', zip: '146830' },
	{ city: 'Aska More (Wexford)', zip: '504397' },
	{ city: 'Askanagap (Wicklow)', zip: '317420' },
	{ city: 'Askasilla (Wexford)', zip: '352712' },
	{ city: 'Aske (Dublin)', zip: '471057' },
	{ city: 'Askeaton (Limerick)', zip: '618087' },
	{ city: 'Askill (Leitrim)', zip: '474017' },
	{ city: 'Askillaun (Mayo)', zip: '706356' },
	{ city: 'Askinamoe (Wexford)', zip: '742184' },
	{ city: 'Askinch Lower (Wexford)', zip: '847039' },
	{ city: 'Askinch Upper (Wexford)', zip: '600426' },
	{ city: 'Askinfarney (Wexford)', zip: '749704' },
	{ city: 'Askingarran Lower (Wexford)', zip: '386455' },
	{ city: 'Askingarran Upper (Wexford)', zip: '726647' },
	{ city: 'Askintinny (Wicklow)', zip: '590290' },
	{ city: 'Askinvillar Lower (Wexford)', zip: '430768' },
	{ city: 'Askinvillar Upper (Wexford)', zip: '524422' },
	{ city: 'Askunshin (Wexford)', zip: '582955' },
	{ city: 'Asnagh (Longford)', zip: '473281' },
	{ city: 'Assagart (Wexford)', zip: '538910' },
	{ city: 'Assaly Great (Wexford)', zip: '393933' },
	{ city: 'Assaly Little (Wexford)', zip: '497081' },
	{ city: 'Assan (Cavan)', zip: '791976' },
	{ city: 'Assaun (Roscommon)', zip: '542577' },
	{ city: 'Assey (Meath)', zip: '620129' },
	{ city: 'Assolas (Cork)', zip: '495450' },
	{ city: 'Astagob (Dublin)', zip: '516033' },
	{ city: 'Astee (Kerry)', zip: '562599' },
	{ city: 'Astee East (Kerry)', zip: '943484' },
	{ city: 'Astee West (Kerry)', zip: '367988' },
	{ city: 'Astrish Beg (Monaghan)', zip: '702950' },
	{ city: 'Astrish More (Monaghan)', zip: '849127' },
	{ city: 'Atateemore (Kilkenny)', zip: '197282' },
	{ city: 'Athasselabbey North (Tipperary)', zip: '330414' },
	{ city: 'Athasselabbey South (Tipperary)', zip: '417421' },
	{ city: 'Athboy (Meath)', zip: '836749' },
	{ city: 'Athcarne (Meath)', zip: '635201' },
	{ city: 'Athclare (Louth)', zip: '208201' },
	{ city: 'Athdown (Wicklow)', zip: '512091' },
	{ city: 'Athea (Limerick)', zip: '712592' },
	{ city: 'Athea Lower (Limerick)', zip: '901539' },
	{ city: 'Athea Upper (Limerick)', zip: '922684' },
	{ city: 'Athenboy (Westmeath)', zip: '391852' },
	{ city: 'Athenry (Galway)', zip: '112687' },
	{ city: 'Athgaine Great (Meath)', zip: '322828' },
	{ city: 'Athgaine Little (Meath)', zip: '274096' },
	{ city: 'Athgarrett (Kildare)', zip: '416414' },
	{ city: 'Athgarvan (Kildare)', zip: '916583' },
	{ city: 'Athgarvan (Wicklow)', zip: '248702' },
	{ city: 'Athgoe (Dublin)', zip: '269247' },
	{ city: 'Athgoe North (Dublin)', zip: '215979' },
	{ city: 'Athgoe South (Dublin)', zip: '543785' },
	{ city: 'Athgreany (Wicklow)', zip: '835732' },
	{ city: 'Athlacca (Limerick)', zip: '368280' },
	{ city: 'Athlacca North (Limerick)', zip: '878992' },
	{ city: 'Athlacca South (Limerick)', zip: '470297' },
	{ city: 'Athleague (Roscommon)', zip: '309297' },
	{ city: 'Athlone (Westmeath)', zip: '835829' },
	{ city: 'Athlone And Bigmeadow (Westmeath)', zip: '242395' },
	{ city: 'Athlummon (Tipperary)', zip: '812605' },
	{ city: 'Athlumney (Meath)', zip: '397475' },
	{ city: 'Athlunkard (Clare)', zip: '856505' },
	{ city: 'Athnid Beg (Tipperary)', zip: '400836' },
	{ city: 'Athnid More (Tipperary)', zip: '824757' },
	{ city: 'Athroe (Roscommon)', zip: '765521' },
	{ city: 'Athronan (Meath)', zip: '239676' },
	{ city: 'Athry (Galway)', zip: '225823' },
	{ city: 'Athy (Kildare)', zip: '421036' },
	{ city: 'Atshanboe (Tipperary)', zip: '518495' },
	{ city: 'Attanagh (Laois)', zip: '199703' },
	{ city: 'Attatantee (Donegal)', zip: '113839' },
	{ city: 'Attateenoe Lower (Kilkenny)', zip: '117115' },
	{ city: 'Attateenoe Upper (Kilkenny)', zip: '397852' },
	{ city: 'Attavally (Mayo)', zip: '638645' },
	{ city: 'Atteagh (Roscommon)', zip: '300958' },
	{ city: 'Attiaghygrana (Roscommon)', zip: '430708' },
	{ city: 'Attiantaggart (Roscommon)', zip: '751058' },
	{ city: 'Attiappleton (Mayo)', zip: '144986' },
	{ city: 'Attiballa (Roscommon)', zip: '977281' },
	{ city: 'Attiblaney (Offaly)', zip: '155342' },
	{ city: 'Attibrassil (Galway)', zip: '450593' },
	{ city: 'Atticahill (Mayo)', zip: '983727' },
	{ city: 'Attichree (Sligo)', zip: '626604' },
	{ city: 'Atticlogh (Galway)', zip: '205111' },
	{ city: 'Atticloghy (Mayo)', zip: '901520' },
	{ city: 'Atticoffey East (Galway)', zip: '748176' },
	{ city: 'Atticoffey West (Galway)', zip: '687777' },
	{ city: 'Atticonaun (Mayo)', zip: '301223' },
	{ city: 'Atticonor (Westmeath)', zip: '542990' },
	{ city: 'Atticorra (Galway)', zip: '483489' },
	{ city: 'Atticorra (Roscommon)', zip: '179217' },
	{ city: 'Attidavock (Galway)', zip: '900697' },
	{ city: 'Attidermot (Galway)', zip: '407051' },
	{ city: 'Attiduff (Monaghan)', zip: '709491' },
	{ city: 'Attiduff (Sligo)', zip: '160096' },
	{ city: 'Attifarry (Galway)', zip: '438357' },
	{ city: 'Attifineen (Galway)', zip: '724288' },
	{ city: 'Attifinlay (Leitrim)', zip: '798464' },
	{ city: 'Attiflynn (Galway)', zip: '189763' },
	{ city: 'Attigara (Galway)', zip: '663011' },
	{ city: 'Attigoddaun (Galway)', zip: '337921' },
	{ city: 'Attikee (Galway)', zip: '604652' },
	{ city: 'Attiknockan (Roscommon)', zip: '532787' },
	{ city: 'Attimachugh (Mayo)', zip: '470593' },
	{ city: 'Attimanus (Leitrim)', zip: '314439' },
	{ city: 'Attimany (Galway)', zip: '749534' },
	{ city: 'Attimonbeg (Galway)', zip: '579495' },
	{ city: 'Attimonmore North (Galway)', zip: '704668' },
	{ city: 'Attimonmore South (Galway)', zip: '888259' },
	{ city: 'Attimurtagh (Westmeath)', zip: '134776' },
	{ city: 'Attinadague (Donegal)', zip: '138132' },
	{ city: 'Attinaskollia (Mayo)', zip: '436390' },
	{ city: 'Attinkee (Offaly)', zip: '581115' },
	{ city: 'Attiquin (Cork)', zip: '665086' },
	{ city: 'Attireesh (Mayo)', zip: '327154' },
	{ city: 'Attiregan (Galway)', zip: '902797' },
	{ city: 'Attirory (Leitrim)', zip: '367949' },
	{ city: 'Attirory (Roscommon)', zip: '195670' },
	{ city: 'Attirowerty (Galway)', zip: '117853' },
	{ city: 'Attishane (Mayo)', zip: '669296' },
	{ city: 'Attishane (Roscommon)', zip: '151840' },
	{ city: 'Attiville (Sligo)', zip: '622125' },
	{ city: 'Attybrick (Tipperary)', zip: '475310' },
	{ city: 'Attycristora (Clare)', zip: '137625' },
	{ city: 'Attyflin (Limerick)', zip: '719061' },
	{ city: 'Attyjames (Tipperary)', zip: '448024' },
	{ city: 'Attykit (Tipperary)', zip: '161777' },
	{ city: 'Attymass (Mayo)', zip: '789831' },
	{ city: 'Attymon (Galway)', zip: '321946' },
	{ city: 'Attyshonock (Galway)', zip: '439159' },
	{ city: 'Attyslany North (Clare)', zip: '385617' },
	{ city: 'Attyslany South (Clare)', zip: '490497' },
	{ city: 'Attyterrila (Clare)', zip: '217713' },
	{ city: 'Auburn (Dublin)', zip: '319660' },
	{ city: 'Auburn (Westmeath)', zip: '550685' },
	{ city: 'Aubwee (Galway)', zip: '388610' },
	{ city: 'Aucloggeen (Galway)', zip: '139181' },
	{ city: 'Augeris (Cork)', zip: '231896' },
	{ city: 'Aughabrack (Cork)', zip: '860505' },
	{ city: 'Aughacasla North (Kerry)', zip: '832388' },
	{ city: 'Aughacasla South (Kerry)', zip: '737129' },
	{ city: 'Aughagarna (Clare)', zip: '412830' },
	{ city: 'Aughagault (Donegal)', zip: '283771' },
	{ city: 'Aughagault Big (Donegal)', zip: '863420' },
	{ city: 'Aughaleigue Beg (Cork)', zip: '256524' },
	{ city: 'Aughaleigue More (Cork)', zip: '821867' },
	{ city: 'Aughalin (Limerick)', zip: '957747' },
	{ city: 'Aughall Beg (Tipperary)', zip: '145703' },
	{ city: 'Aughall Middle (Tipperary)', zip: '797584' },
	{ city: 'Aughall More (Tipperary)', zip: '810572' },
	{ city: 'Aughane (Cork)', zip: '688186' },
	{ city: 'Aughanna (Kerry)', zip: '448766' },
	{ city: 'Aughans (Laois)', zip: '714155' },
	{ city: 'Aughathlappa (Wexford)', zip: '436924' },
	{ city: 'Aughatubbrid (Kilkenny)', zip: '102704' },
	{ city: 'Aughavanlomaun (Tipperary)', zip: '300491' },
	{ city: 'Aughavehir (Tipperary)', zip: '929503' },
	{ city: 'Aughavinna (Clare)', zip: '204469' },
	{ city: 'Aughboy (Clare)', zip: '251944' },
	{ city: 'Aughclare (Wexford)', zip: '930559' },
	{ city: 'Aughermon (Wexford)', zip: '894075' },
	{ city: 'Aughernagalliagh (Mayo)', zip: '832038' },
	{ city: 'Augherskea (Meath)', zip: '976995' },
	{ city: 'Aughfad (Wexford)', zip: '201489' },
	{ city: 'Aughils (Kerry)', zip: '477357' },
	{ city: 'Aughine (Longford)', zip: '453266' },
	{ city: 'Aughinida (Cork)', zip: '701206' },
	{ city: 'Aughinish (Clare)', zip: '474117' },
	{ city: 'Aughinish East (Limerick)', zip: '702597' },
	{ city: 'Aughinish West (Limerick)', zip: '744051' },
	{ city: 'Aughiska Beg (Clare)', zip: '986160' },
	{ city: 'Aughiska More (Clare)', zip: '876534' },
	{ city: 'Aughkeely (Donegal)', zip: '486270' },
	{ city: 'Aughkiletaun (Kilkenny)', zip: '698226' },
	{ city: 'Aughmore (Waterford)', zip: '913009' },
	{ city: 'Aughmore (Wexford)', zip: '381008' },
	{ city: 'Aughnacloy (Monaghan)', zip: '173514' },
	{ city: 'Aughnacloy (Sligo)', zip: '737101' },
	{ city: 'Aughnacrumpane (Tipperary)', zip: '828240' },
	{ city: 'Aughnacurraveel (Waterford)', zip: '560769' },
	{ city: 'Aughnagalley (Wexford)', zip: '216612' },
	{ city: 'Aughnagan (Wexford)', zip: '554426' },
	{ city: 'Aughnagomaun (Tipperary)', zip: '510435' },
	{ city: 'Aughnaheela (Tipperary)', zip: '454493' },
	{ city: 'Aughnalyra (Cork)', zip: '438326' },
	{ city: 'Aughnamaulmeen (Wexford)', zip: '940578' },
	{ city: 'Aughnanure (Galway)', zip: '327245' },
	{ city: 'Aughness (Mayo)', zip: '497492' },
	{ city: 'Aughnish (Donegal)', zip: '949472' },
	{ city: 'Aughnish Isle (Donegal)', zip: '148307' },
	{ city: 'Aughrim (Cavan)', zip: '223817' },
	{ city: 'Aughrim (Clare)', zip: '214478' },
	{ city: 'Aughrim (Cork)', zip: '777265' },
	{ city: 'Aughrim (Galway)', zip: '593244' },
	{ city: 'Aughrim (Kerry)', zip: '904401' },
	{ city: 'Aughrim (Kildare)', zip: '100302' },
	{ city: 'Aughrim (Leitrim)', zip: '314564' },
	{ city: 'Aughrim (Roscommon)', zip: '236142' },
	{ city: 'Aughrim (Wicklow)', zip: '674551' },
	{ city: 'Aughriman (Leitrim)', zip: '146378' },
	{ city: 'Aughriman South (Leitrim)', zip: '803153' },
	{ city: 'Aughrim Beg (Monaghan)', zip: '360959' },
	{ city: 'Aughrim Lower (Wicklow)', zip: '258494' },
	{ city: 'Aughrim More (Monaghan)', zip: '827574' },
	{ city: 'Aughrim Upper (Wicklow)', zip: '472386' },
	{ city: 'Aughris (Sligo)', zip: '663394' },
	{ city: 'Aughrus Beg (Galway)', zip: '309472' },
	{ city: 'Aughrus More (Galway)', zip: '516192' },
	{ city: 'Aughry (Leitrim)', zip: '174240' },
	{ city: 'Aught (Donegal)', zip: '400883' },
	{ city: 'Aughtanny (Kilkenny)', zip: '380510' },
	{ city: 'Aughtreagh (Cavan)', zip: '966662' },
	{ city: 'Aughullen (Wexford)', zip: '829195' },
	{ city: 'Aughvallydeag (Tipperary)', zip: '843172' },
	{ city: 'Aughvolyshane (Tipperary)', zip: '752557' },
	{ city: 'Augullies (Donegal)', zip: '227000' },
	{ city: 'Aulanebane (Kerry)', zip: '592561' },
	{ city: 'Aulaneduff (Kerry)', zip: '707696' },
	{ city: 'Aultagh (Cork)', zip: '263641' },
	{ city: 'Aultaghreagh (Cork)', zip: '963206' },
	{ city: 'Aunamihoonagh (Cork)', zip: '174025' },
	{ city: 'Aungierstown And Ballybane (Dublin)', zip: '786109' },
	{ city: 'Aurora (Wicklow)', zip: '538745' },
	{ city: 'Auskurra Big (Waterford)', zip: '454346' },
	{ city: 'Auskurra Little (Waterford)', zip: '176817' },
	{ city: 'Avalbane (Monaghan)', zip: '426683' },
	{ city: 'Avalreagh (Monaghan)', zip: '974890' },
	{ city: 'Avaltygort (Donegal)', zip: '671914' },
	{ city: 'Avenue (Kerry)', zip: '226517' },
	{ city: 'Avery Island (Galway)', zip: '166268' },
	{ city: 'Avoca (Wicklow)', zip: '204336' },
	{ city: 'Avoley (Laois)', zip: '408545' },
	{ city: 'Avondale (Wicklow)', zip: '528259' },
	{ city: 'Awnaskirtaun (Kerry)', zip: '679901' },
	{ city: 'Ayle (Kerry)', zip: '622870' },
	{ city: 'Ayle (Tipperary)', zip: '286371' },
	{ city: 'Ayleacotty (Clare)', zip: '497816' },
	{ city: 'Ayle Lower (Clare)', zip: '221116' },
	{ city: 'Ayle Upper (Clare)', zip: '223958' },
	{ city: 'Aylmerstown (Kildare)', zip: '617601' },
	{ city: 'Aylwardstown (Kilkenny)', zip: '345936' },
	{ city: 'Ayresfields (Kilkenny)', zip: '601443' },
	{ city: 'Babeswood (Louth)', zip: '115186' },
	{ city: 'Bachelorshall (Wexford)', zip: '281410' },
	{ city: 'Back (Galway)', zip: '228046' },
	{ city: 'Backhill (Donegal)', zip: '493100' },
	{ city: 'Backland (Donegal)', zip: '319130' },
	{ city: 'Backlees (Donegal)', zip: '671537' },
	{ city: 'Back Of The Hill (Longford)', zip: '973135' },
	{ city: 'Backpark (Galway)', zip: '901116' },
	{ city: 'Backsteel (Offaly)', zip: '369928' },
	{ city: 'Backstown (Dublin)', zip: '467101' },
	{ city: 'Backwestonpark (Dublin)', zip: '143598' },
	{ city: 'Backweston Park (Kildare)', zip: '314018' },
	{ city: 'Backwood (Offaly)', zip: '480133' },
	{ city: 'Baconstown (Meath)', zip: '441587' },
	{ city: 'Badgerfort (Limerick)', zip: '757526' },
	{ city: 'Badgerhill (Dublin)', zip: '712409' },
	{ city: 'Badgerhill (Laois)', zip: '727934' },
	{ city: 'Badgerisland (Laois)', zip: '516570' },
	{ city: 'Badgerrock (Kilkenny)', zip: '583778' },
	{ city: 'Bagenalstown (Carlow)', zip: '334519' },
	{ city: 'Baggotstown (Limerick)', zip: '192281' },
	{ city: 'Baggotstown (Louth)', zip: '308490' },
	{ city: 'Baggotstown East (Limerick)', zip: '796453' },
	{ city: 'Baggotstown West (Limerick)', zip: '212470' },
	{ city: 'Baggottspark (Laois)', zip: '259192' },
	{ city: 'Baghloonagh (Sligo)', zip: '222922' },
	{ city: 'Bahagha (Tipperary)', zip: '312762' },
	{ city: 'Bahaghs (Kerry)', zip: '942337' },
	{ city: 'Bahana (Carlow)', zip: '947800' },
	{ city: 'Bahana (Wicklow)', zip: '178120' },
	{ city: 'Bailieborough (Cavan)', zip: '857517' },
	{ city: 'Bailis (Meath)', zip: '293626' },
	{ city: 'Bailyland (Louth)', zip: '425382' },
	{ city: 'Bailypark (Louth)', zip: '307485' },
	{ city: 'Bakersclose (Cork)', zip: '367541' },
	{ city: 'Balally (Dublin)', zip: '842835' },
	{ city: 'Balbane (Donegal)', zip: '798737' },
	{ city: 'Balbradagh (Meath)', zip: '499705' },
	{ city: 'Balbriggan (Dublin)', zip: '498012' },
	{ city: 'Balbrigh (Meath)', zip: '831002' },
	{ city: 'Balcarrick (Dublin)', zip: '507083' },
	{ city: 'Balcarrig (Wexford)', zip: '234361' },
	{ city: 'Balcarrighill (Wexford)', zip: '968390' },
	{ city: 'Balcultry (Dublin)', zip: '734019' },
	{ city: 'Balcunnin (Dublin)', zip: '216663' },
	{ city: 'Balcurris (Dublin)', zip: '311108' },
	{ city: 'Baldongan (Dublin)', zip: '828204' },
	{ city: 'Baldonnell Little (Dublin)', zip: '944577' },
	{ city: 'Baldonnell Lower (Dublin)', zip: '495461' },
	{ city: 'Baldonnell Upper (Dublin)', zip: '286997' },
	{ city: 'Baldoyle (Dublin)', zip: '182071' },
	{ city: 'Baldoyle (Meath)', zip: '450868' },
	{ city: 'Baldrumman (Dublin)', zip: '338018' },
	{ city: 'Baldurgan (Dublin)', zip: '721253' },
	{ city: 'Baldwinstown (Dublin)', zip: '389389' },
	{ city: 'Baldwinstown (Wexford)', zip: '370395' },
	{ city: 'Balfeaghan (Meath)', zip: '115169' },
	{ city: 'Balfeddock (Louth)', zip: '900127' },
	{ city: 'Balfeddock (Meath)', zip: '502678' },
	{ city: 'Balfestown (Meath)', zip: '102319' },
	{ city: 'Balgaddy (Dublin)', zip: '980364' },
	{ city: 'Balgarrett (Westmeath)', zip: '405599' },
	{ city: 'Balgatheran (Louth)', zip: '539448' },
	{ city: 'Balgeen (Meath)', zip: '863192' },
	{ city: 'Balgeeth (Meath)', zip: '237489' },
	{ city: 'Balgill (Meath)', zip: '109808' },
	{ city: 'Balgree (Meath)', zip: '459881' },
	{ city: 'Balgriffin (Dublin)', zip: '853558' },
	{ city: 'Balgriffin Park (Dublin)', zip: '680082' },
	{ city: 'Balheary (Dublin)', zip: '388592' },
	{ city: 'Balheary Demesne (Dublin)', zip: '724916' },
	{ city: 'Balief Lower (Kilkenny)', zip: '684987' },
	{ city: 'Balief Upper (Kilkenny)', zip: '395051' },
	{ city: 'Balisland (Wicklow)', zip: '370308' },
	{ city: 'Balkinstown (Kildare)', zip: '573694' },
	{ city: 'Balla (Mayo)', zip: '490358' },
	{ city: 'Ballabony (Louth)', zip: '330544' },
	{ city: 'Balladian (Monaghan)', zip: '749152' },
	{ city: 'Ballady (Cork)', zip: '309810' },
	{ city: 'Ballagan (Louth)', zip: '546336' },
	{ city: 'Ballagh (Clare)', zip: '164652' },
	{ city: 'Ballagh (Cork)', zip: '129197' },
	{ city: 'Ballagh (Donegal)', zip: '602826' },
	{ city: 'Ballagh (Galway)', zip: '410619' },
	{ city: 'Ballagh (Kerry)', zip: '640771' },
	{ city: 'Ballagh (Kilkenny)', zip: '214318' },
	{ city: 'Ballagh (Limerick)', zip: '311894' },
	{ city: 'Ballagh (Longford)', zip: '991624' },
	{ city: 'Ballagh (Monaghan)', zip: '818524' },
	{ city: 'Ballagh (Roscommon)', zip: '487418' },
	{ city: 'Ballagh (Tipperary)', zip: '827662' },
	{ city: 'Ballagh (Westmeath)', zip: '549450' },
	{ city: 'Ballagh (Wexford)', zip: '388692' },
	{ city: 'Ballagh (Wicklow)', zip: '166071' },
	{ city: 'Ballaghabawbeg (Roscommon)', zip: '564625' },
	{ city: 'Ballaghabawmore (Roscommon)', zip: '467151' },
	{ city: 'Ballaghablake (Wexford)', zip: '216450' },
	{ city: 'Ballaghaclay (Carlow)', zip: '625769' },
	{ city: 'Ballaghaderneen (Carlow)', zip: '130820' },
	{ city: 'Ballaghaderreen (Roscommon)', zip: '806359' },
	{ city: 'Ballaghaderry (Offaly)', zip: '103370' },
	{ city: 'Ballaghadigue (Kerry)', zip: '570138' },
	{ city: 'Ballaghadown North (Cork)', zip: '795406' },
	{ city: 'Ballaghadown South (Cork)', zip: '466830' },
	{ city: 'Ballaghafadda East (Clare)', zip: '505297' },
	{ city: 'Ballaghafadda West (Clare)', zip: '485373' },
	{ city: 'Ballaghaglash (Clare)', zip: '661295' },
	{ city: 'Ballaghaline (Clare)', zip: '248852' },
	{ city: 'Ballaghalode (Galway)', zip: '452431' },
	{ city: 'Ballaghamuck (Mayo)', zip: '443846' },
	{ city: 'Ballaghanea (Cavan)', zip: '373584' },
	{ city: 'Ballaghanna (Cavan)', zip: '635465' },
	{ city: 'Ballaghanoher (Offaly)', zip: '873794' },
	{ city: 'Ballaghanure (Cork)', zip: '350356' },
	{ city: 'Ballagharahin (Laois)', zip: '630857' },
	{ city: 'Ballagharea (Cork)', zip: '546472' },
	{ city: 'Ballaghassaan (Offaly)', zip: '685713' },
	{ city: 'Ballaghaugeag East (Galway)', zip: '882280' },
	{ city: 'Ballaghaugeag West (Galway)', zip: '948589' },
	{ city: 'Ballaghavorraga (Waterford)', zip: '493958' },
	{ city: 'Ballaghaweary (Meath)', zip: '192504' },
	{ city: 'Ballaghbaun (Galway)', zip: '247738' },
	{ city: 'Ballaghbehy (Limerick)', zip: '308376' },
	{ city: 'Ballaghbehy North (Limerick)', zip: '812819' },
	{ city: 'Ballaghbehy South (Limerick)', zip: '456898' },
	{ city: 'Ballaghboy (Clare)', zip: '904554' },
	{ city: 'Ballaghboy (Cork)', zip: '646497' },
	{ city: 'Ballaghboy (Offaly)', zip: '610115' },
	{ city: 'Ballaghboy (Sligo)', zip: '739397' },
	{ city: 'Ballaghboy (Tipperary)', zip: '102232' },
	{ city: 'Ballaghboy (Wexford)', zip: '454495' },
	{ city: 'Ballagh Burrow (Wexford)', zip: '104752' },
	{ city: 'Ballaghcloneen (Kilkenny)', zip: '602573' },
	{ city: 'Ballaghcullia (Roscommon)', zip: '951452' },
	{ city: 'Ballaghdacker (Galway)', zip: '315724' },
	{ city: 'Ballaghderg (Donegal)', zip: '143947' },
	{ city: 'Ballaghdorragh (Cavan)', zip: '836564' },
	{ city: 'Ballaghdorragha (Galway)', zip: '873475' },
	{ city: 'Ballaghduff (Galway)', zip: '725357' },
	{ city: 'Ballagh East (Galway)', zip: '604613' },
	{ city: 'Ballaghfarna (Mayo)', zip: '233491' },
	{ city: 'Ballaghgar (Tipperary)', zip: '693097' },
	{ city: 'Ballaghgowla And Froghan (Longford)', zip: '362276' },
	{ city: 'Ballaghkeen (Wexford)', zip: '815911' },
	{ city: 'Ballaghkeeran Big (Westmeath)', zip: '805513' },
	{ city: 'Ballaghkeeran Little (Westmeath)', zip: '654530' },
	{ city: 'Ballaghlyragh (Laois)', zip: '429000' },
	{ city: 'Ballaghmoon (Kildare)', zip: '505134' },
	{ city: 'Ballaghmoon Castle (Kildare)', zip: '933668' },
	{ city: 'Ballaghmore (Carlow)', zip: '360386' },
	{ city: 'Ballaghmore (Laois)', zip: '505540' },
	{ city: 'Ballaghmore Lower (Laois)', zip: '546776' },
	{ city: 'Ballaghmore Upper (Laois)', zip: '523444' },
	{ city: 'Ballaghnabehy (Leitrim)', zip: '563449' },
	{ city: 'Ballaghnagearn (Monaghan)', zip: '303188' },
	{ city: 'Ballaghnagrosheen (Galway)', zip: '202574' },
	{ city: 'Ballaghnatrillick (Sligo)', zip: '324094' },
	{ city: 'Ballaghoge (Tipperary)', zip: '893121' },
	{ city: 'Ballaghstown (Dublin)', zip: '731085' },
	{ city: 'Ballaghtalion (Meath)', zip: '876365' },
	{ city: 'Ballaghveny (Tipperary)', zip: '524038' },
	{ city: 'Ballagh West (Galway)', zip: '287192' },
	{ city: 'Ballaghymurry (Galway)', zip: '823359' },
	{ city: 'Ballahacommane (Kerry)', zip: '644280' },
	{ city: 'Ballahantouragh (Kerry)', zip: '359041' },
	{ city: 'Ballaheen (Cork)', zip: '314178' },
	{ city: 'Ballair (Meath)', zip: '671286' },
	{ city: 'Ballakelly (Monaghan)', zip: '705398' },
	{ city: 'Ballalease North (Dublin)', zip: '581177' },
	{ city: 'Ballalease South (Dublin)', zip: '450252' },
	{ city: 'Ballalease West (Dublin)', zip: '422691' },
	{ city: 'Ballallen (Westmeath)', zip: '613159' },
	{ city: 'Ballallog (Kilkenny)', zip: '124230' },
	{ city: 'Ballaman (Wexford)', zip: '223664' },
	{ city: 'Ballanagh (Wicklow)', zip: '801084' },
	{ city: 'Ballany (Meath)', zip: '183308' },
	{ city: 'Ballany (Westmeath)', zip: '290403' },
	{ city: 'Ballard (Clare)', zip: '401301' },
	{ city: 'Ballard (Cork)', zip: '988879' },
	{ city: 'Ballard (Donegal)', zip: '845168' },
	{ city: 'Ballard (Galway)', zip: '476005' },
	{ city: 'Ballard (Offaly)', zip: '737425' },
	{ city: 'Ballard (Sligo)', zip: '965018' },
	{ city: 'Ballard (Westmeath)', zip: '937359' },
	{ city: 'Ballard (Wicklow)', zip: '300076' },
	{ city: 'Ballardan Great (Meath)', zip: '748016' },
	{ city: 'Ballardan Little (Meath)', zip: '338383' },
	{ city: 'Ballardbeg (Wicklow)', zip: '697725' },
	{ city: 'Ballard Commons (Cork)', zip: '372179' },
	{ city: 'Ballard East (Galway)', zip: '269013' },
	{ city: 'Ballardiggan (Galway)', zip: '566549' },
	{ city: 'Ballard Lower (Kerry)', zip: '278448' },
	{ city: 'Ballard Lower (Wicklow)', zip: '636599' },
	{ city: 'Ballardpark (Wicklow)', zip: '966793' },
	{ city: 'Ballard Upper (Kerry)', zip: '881504' },
	{ city: 'Ballard Upper (Wicklow)', zip: '909744' },
	{ city: 'Ballard West (Galway)', zip: '256336' },
	{ city: 'Ballare (Wexford)', zip: '933508' },
	{ city: 'Ballask (Wexford)', zip: '658465' },
	{ city: 'Ballasport (Meath)', zip: '636062' },
	{ city: 'Ballastran (Meath)', zip: '226250' },
	{ city: 'Ballaverty (Louth)', zip: '905781' },
	{ city: 'Ballea (Cork)', zip: '468279' },
	{ city: 'Balleagny (Westmeath)', zip: '536914' },
	{ city: 'Balleally East (Dublin)', zip: '485824' },
	{ city: 'Balleally West (Dublin)', zip: '879256' },
	{ city: 'Balleeghan (Donegal)', zip: '896472' },
	{ city: 'Balleeghan Lower (Donegal)', zip: '947118' },
	{ city: 'Balleeghan Upper (Donegal)', zip: '500488' },
	{ city: 'Balleek (Offaly)', zip: '114406' },
	{ city: 'Balleek Beg (Offaly)', zip: '408149' },
	{ city: 'Balleelaghan (Donegal)', zip: '156371' },
	{ city: 'Balleen (Clare)', zip: '284186' },
	{ city: 'Balleen (Kerry)', zip: '682235' },
	{ city: 'Balleen Little (Kilkenny)', zip: '789671' },
	{ city: 'Balleen Lower (Kilkenny)', zip: '587227' },
	{ city: 'Balleese Lower (Wicklow)', zip: '395274' },
	{ city: 'Balleese Upper (Wicklow)', zip: '419846' },
	{ city: 'Balleese Wood (Wicklow)', zip: '582661' },
	{ city: 'Balleeshal (Wicklow)', zip: '587364' },
	{ city: 'Balleighteragh East (Waterford)', zip: '119550' },
	{ city: 'Balleighteragh West (Waterford)', zip: '503281' },
	{ city: 'Ballestran (Meath)', zip: '394210' },
	{ city: 'Balleven (Kilkenny)', zip: '669339' },
	{ city: 'Ballew (Westmeath)', zip: '182483' },
	{ city: 'Ballickmoyler (Laois)', zip: '315624' },
	{ city: 'Ballickmoyler (Offaly)', zip: '351390' },
	{ city: 'Ballickmoyler Upper (Laois)', zip: '453598' },
	{ city: 'Ballicknahee (Offaly)', zip: '623830' },
	{ city: 'Ballilogue (Kilkenny)', zip: '647900' },
	{ city: 'Ballin (Meath)', zip: '266166' },
	{ city: 'Ballina (Cavan)', zip: '747913' },
	{ city: 'Ballina (Clare)', zip: '987779' },
	{ city: 'Ballina (Cork)', zip: '717494' },
	{ city: 'Ballina (Donegal)', zip: '932512' },
	{ city: 'Ballina (Galway)', zip: '262801' },
	{ city: 'Ballina (Kildare)', zip: '381162' },
	{ city: 'Ballina (Laois)', zip: '882310' },
	{ city: 'Ballina (Longford)', zip: '397767' },
	{ city: 'Ballina (Mayo)', zip: '237039' },
	{ city: 'Ballina (Meath)', zip: '440902' },
	{ city: 'Ballina (Offaly)', zip: '912219' },
	{ city: 'Ballina (Roscommon)', zip: '146570' },
	{ city: 'Ballina (Tipperary)', zip: '525657' },
	{ city: 'Ballina (Westmeath)', zip: '672838' },
	{ city: 'Ballina (Wexford)', zip: '642156' },
	{ city: 'Ballinab (Waterford)', zip: '427441' },
	{ city: 'Ballinabanoge (Wicklow)', zip: '325735' },
	{ city: 'Ballinabarney (Kilkenny)', zip: '894518' },
	{ city: 'Ballinabarny (Wicklow)', zip: '359816' },
	{ city: 'Ballinabarny Gap (Wicklow)', zip: '719227' },
	{ city: 'Ballinabarny North (Wicklow)', zip: '938257' },
	{ city: 'Ballinabarny South (Wicklow)', zip: '333739' },
	{ city: 'Ballinaboy (Cork)', zip: '798783' },
	{ city: 'Ballinaboy (Galway)', zip: '969055' },
	{ city: 'Ballinaboy (Roscommon)', zip: '956027' },
	{ city: 'Ballinabrackey (Meath)', zip: '936343' },
	{ city: 'Ballinabrannagh (Carlow)', zip: '751842' },
	{ city: 'Ballinabrannagh (Wicklow)', zip: '508292' },
	{ city: 'Ballinacarrig (Carlow)', zip: '127797' },
	{ city: 'Ballinacarrig (Wexford)', zip: '511066' },
	{ city: 'Ballinacarrig Lower (Wicklow)', zip: '833882' },
	{ city: 'Ballinacarrig Upper (Wicklow)', zip: '252010' },
	{ city: 'Ballinaclash (Wicklow)', zip: '542788' },
	{ city: 'Ballinaclea (Wicklow)', zip: '305871' },
	{ city: 'Ballinaclogh (Cork)', zip: '669157' },
	{ city: 'Ballinaclogh (Tipperary)', zip: '837638' },
	{ city: 'Ballinaclogh (Wicklow)', zip: '254784' },
	{ city: 'Ballinaclogh Lower (Laois)', zip: '341291' },
	{ city: 'Ballinaclogh Upper (Laois)', zip: '750312' },
	{ city: 'Ballinacoola (Wexford)', zip: '728691' },
	{ city: 'Ballinacoola Beg (Wexford)', zip: '243988' },
	{ city: 'Ballinacoola More (Wexford)', zip: '713702' },
	{ city: 'Ballinacooley (Wicklow)', zip: '410033' },
	{ city: 'Ballinacor (Wicklow)', zip: '832228' },
	{ city: 'Ballinacorbeg (Wicklow)', zip: '881226' },
	{ city: 'Ballinacor East (Wicklow)', zip: '626695' },
	{ city: 'Ballinacor West (Wicklow)', zip: '820836' },
	{ city: 'Ballinacostello (Mayo)', zip: '789167' },
	{ city: 'Ballinacrane (Wexford)', zip: '593609' },
	{ city: 'Ballinacrea (Carlow)', zip: '392144' },
	{ city: 'Ballinacrow Lower (Wicklow)', zip: '472113' },
	{ city: 'Ballinacrow Upper (Wicklow)', zip: '928707' },
	{ city: 'Ballinacur (Wexford)', zip: '368884' },
	{ city: 'Ballinacurra (Cork)', zip: '943769' },
	{ city: 'Ballinadee (Cork)', zip: '477379' },
	{ city: 'Ballinadrum (Carlow)', zip: '540012' },
	{ city: 'Ballinadrummin (Wexford)', zip: '851434' },
	{ city: 'Ballinafad (Galway)', zip: '812898' },
	{ city: 'Ballinafad (Mayo)', zip: '844233' },
	{ city: 'Ballinafad (Roscommon)', zip: '944805' },
	{ city: 'Ballinafad (Sligo)', zip: '115578' },
	{ city: 'Ballinafunshoge (Wicklow)', zip: '301435' },
	{ city: 'Ballinagam Lower (Wexford)', zip: '796005' },
	{ city: 'Ballinagam Upper (Wexford)', zip: '227704' },
	{ city: 'Ballinagappoge (Wicklow)', zip: '780561' },
	{ city: 'Ballinagar (Offaly)', zip: '766612' },
	{ city: 'Ballinagard (Roscommon)', zip: '979629' },
	{ city: 'Ballinagavna (Mayo)', zip: '668840' },
	{ city: 'Ballinagee (Wicklow)', zip: '628891' },
	{ city: 'Ballinageeloge (Wexford)', zip: '965567' },
	{ city: 'Ballinagilky (Carlow)', zip: '504265' },
	{ city: 'Ballinagleragh (Leitrim)', zip: '478110' },
	{ city: 'Ballinagoneen (Wicklow)', zip: '710792' },
	{ city: 'Ballinagore (Tipperary)', zip: '291861' },
	{ city: 'Ballinagore (Wicklow)', zip: '597881' },
	{ city: 'Ballinagran (Mayo)', zip: '726456' },
	{ city: 'Ballinagrann Lower (Wexford)', zip: '966427' },
	{ city: 'Ballinagrann Upper (Wexford)', zip: '726130' },
	{ city: 'Ballinagree (Cork)', zip: '425656' },
	{ city: 'Ballinagross (Tipperary)', zip: '641306' },
	{ city: 'Ballinagroun (Kerry)', zip: '219497' },
	{ city: 'Ballinaha (Waterford)', zip: '959553' },
	{ city: 'Ballinaheese (Wicklow)', zip: '761889' },
	{ city: 'Ballinahemery (Tipperary)', zip: '285160' },
	{ city: 'Ballinahinch (Tipperary)', zip: '735557' },
	{ city: 'Ballinahinch (Wicklow)', zip: '532271' },
	{ city: 'Ballinahinch Lower (Wicklow)', zip: '409161' },
	{ city: 'Ballinahinch Middle (Wicklow)', zip: '437799' },
	{ city: 'Ballinahinch Upper (Wicklow)', zip: '398442' },
	{ city: 'Ballinahorna (Wexford)', zip: '644933' },
	{ city: 'Ballinahown (Wicklow)', zip: '974733' },
	{ city: 'Ballinakill (Laois)', zip: '236270' },
	{ city: 'Ballinakill (Wexford)', zip: '582980' },
	{ city: 'Ballinakill (Wicklow)', zip: '231004' },
	{ city: 'Ballinalack (Westmeath)', zip: '693455' },
	{ city: 'Ballinalea (Wicklow)', zip: '868768' },
	{ city: 'Ballinaleama (Galway)', zip: '862296' },
	{ city: 'Ballinalecka (Mayo)', zip: '464504' },
	{ city: 'Ballinalee (Longford)', zip: '733637' },
	{ city: 'Ballinaleucra (Waterford)', zip: '184576' },
	{ city: 'Ballina Lower (Wexford)', zip: '764856' },
	{ city: 'Ballinaltig (Cork)', zip: '754024' },
	{ city: 'Ballinaltig Beg (Cork)', zip: '885412' },
	{ city: 'Ballinameen (Roscommon)', zip: '715886' },
	{ city: 'Ballinameesda Lower (Wicklow)', zip: '376083' },
	{ city: 'Ballinameesda Upper (Wicklow)', zip: '216029' },
	{ city: 'Ballinaminton East (Offaly)', zip: '968800' },
	{ city: 'Ballinaminton West (Offaly)', zip: '858725' },
	{ city: 'Ballinamoe (Offaly)', zip: '338351' },
	{ city: 'Ballinamoe (Tipperary)', zip: '518658' },
	{ city: 'Ballinamona (Carlow)', zip: '411947' },
	{ city: 'Ballinamona (Tipperary)', zip: '812237' },
	{ city: 'Ballinamona (Waterford)', zip: '567059' },
	{ city: 'Ballinamona (Wexford)', zip: '593591' },
	{ city: 'Ballinamona (Wicklow)', zip: '268599' },
	{ city: 'Ballinamore (Leitrim)', zip: '706545' },
	{ city: 'Ballinamore (Longford)', zip: '201151' },
	{ city: 'Ballinamore (Mayo)', zip: '225161' },
	{ city: 'Ballinamore (Tipperary)', zip: '668727' },
	{ city: 'Ballinamore Bridge (Galway)', zip: '626881' },
	{ city: 'Ballinamorragh (Wexford)', zip: '397120' },
	{ city: 'Ballinamuck (Longford)', zip: '425580' },
	{ city: 'Ballinanchor (Waterford)', zip: '145476' },
	{ city: 'Ballinanima (Limerick)', zip: '869528' },
	{ city: 'Ballinanty (Wicklow)', zip: '910983' },
	{ city: 'Ballinapark (Wexford)', zip: '221899' },
	{ city: 'Ballinapark (Wicklow)', zip: '368202' },
	{ city: 'Ballinapeaka (Galway)', zip: '568904' },
	{ city: 'Ballinard (Cork)', zip: '830779' },
	{ city: 'Ballinard (Kerry)', zip: '102023' },
	{ city: 'Ballinard (Limerick)', zip: '683628' },
	{ city: 'Ballinard (Tipperary)', zip: '285434' },
	{ city: 'Ballinard (Wicklow)', zip: '308743' },
	{ city: 'Ballinascarty (Cork)', zip: '192304' },
	{ city: 'Ballinascorney Lower (Dublin)', zip: '817062' },
	{ city: 'Ballinascorney Upper (Dublin)', zip: '720256' },
	{ city: 'Ballinashinnagh (Wicklow)', zip: '924004' },
	{ city: 'Ballinasig (Kerry)', zip: '495320' },
	{ city: 'Ballinasilloge (Wexford)', zip: '215622' },
	{ city: 'Ballinasilloge (Wicklow)', zip: '594698' },
	{ city: 'Ballinaskea (Wicklow)', zip: '250122' },
	{ city: 'Ballinasloe (Galway)', zip: '470023' },
	{ city: 'Ballinasoostia (Wicklow)', zip: '636873' },
	{ city: 'Ballinaspick (Westmeath)', zip: '997495' },
	{ city: 'Ballinaspick North (Waterford)', zip: '672555' },
	{ city: 'Ballinaspick South (Waterford)', zip: '240029' },
	{ city: 'Ballinaspig More (Cork)', zip: '815864' },
	{ city: 'Ballinastack (Galway)', zip: '794767' },
	{ city: 'Ballinaster (Mayo)', zip: '641216' },
	{ city: 'Ballinastoe (Wicklow)', zip: '370981' },
	{ city: 'Ballinastraw (Carlow)', zip: '821002' },
	{ city: 'Ballinastraw (Wicklow)', zip: '868946' },
	{ city: 'Ballinastraw Lower (Wexford)', zip: '278896' },
	{ city: 'Ballinastraw Upper (Wexford)', zip: '563649' },
	{ city: 'Ballinastudd (Wexford)', zip: '222945' },
	{ city: 'Ballinatona (Cork)', zip: '770171' },
	{ city: 'Ballinatone Lower (Wicklow)', zip: '945798' },
	{ city: 'Ballinatone Upper (Wicklow)', zip: '631657' },
	{ city: 'Ballinatray Lower (Wexford)', zip: '987258' },
	{ city: 'Ballinatray Upper (Wexford)', zip: '130550' },
	{ city: 'Ballinattin (Waterford)', zip: '377487' },
	{ city: 'Ballinattin Lower (Tipperary)', zip: '478627' },
	{ city: 'Ballinattin Upper (Tipperary)', zip: '441803' },
	{ city: 'Ballina Upper (Wexford)', zip: '741540' },
	{ city: 'Ballinavary (Wexford)', zip: '195962' },
	{ city: 'Ballinaya (Mayo)', zip: '284294' },
	{ city: 'Ballinbeg (Cork)', zip: '669071' },
	{ city: 'Ballinbranhig (Kerry)', zip: '737376' },
	{ city: 'Ballinbrittig (Cork)', zip: '692883' },
	{ city: 'Ballincar (Sligo)', zip: '490670' },
	{ city: 'Ballincarroona (Limerick)', zip: '221517' },
	{ city: 'Ballincarroonig (Cork)', zip: '269009' },
	{ city: 'Ballincash Lower (Wexford)', zip: '214497' },
	{ city: 'Ballincash Upper (Wexford)', zip: '766885' },
	{ city: 'Ballincassa (Limerick)', zip: '967299' },
	{ city: 'Ballincastle (Sligo)', zip: '807054' },
	{ city: 'Ballinchalla (Mayo)', zip: '600590' },
	{ city: 'Ballinclare (Kerry)', zip: '420656' },
	{ city: 'Ballinclare (Kilkenny)', zip: '888302' },
	{ city: 'Ballinclare (Louth)', zip: '769427' },
	{ city: 'Ballinclare (Wexford)', zip: '423292' },
	{ city: 'Ballinclare (Wicklow)', zip: '950182' },
	{ city: 'Ballinclay (Wexford)', zip: '565113' },
	{ city: 'Ballinclay Lower (Wexford)', zip: '492401' },
	{ city: 'Ballinclay Upper (Wexford)', zip: '544298' },
	{ city: 'Ballinclea (Dublin)', zip: '886932' },
	{ city: 'Ballinclea (Wicklow)', zip: '879802' },
	{ city: 'Ballinclemesig (Kerry)', zip: '340291' },
	{ city: 'Ballincloghan (Offaly)', zip: '458501' },
	{ city: 'Ballincloghan Little (Offaly)', zip: '230167' },
	{ city: 'Ballincloher (Kerry)', zip: '993695' },
	{ city: 'Ballincloher East (Kerry)', zip: '628175' },
	{ city: 'Ballincloher West (Kerry)', zip: '328268' },
	{ city: 'Ballincolla (Cork)', zip: '921619' },
	{ city: 'Ballincolla (Kerry)', zip: '914451' },
	{ city: 'Ballincollig (Cork)', zip: '592095' },
	{ city: 'Ballincollig (Kerry)', zip: '124745' },
	{ city: 'Ballincolloo (Limerick)', zip: '417783' },
	{ city: 'Ballincollop (Cork)', zip: '580997' },
	{ city: 'Ballincolly (Cork)', zip: '144275' },
	{ city: 'Ballincolly (Limerick)', zip: '843567' },
	{ city: 'Ballincool (Roscommon)', zip: '272005' },
	{ city: 'Ballincor (Tipperary)', zip: '575163' },
	{ city: 'Ballincor Demesne (Offaly)', zip: '900760' },
	{ city: 'Ballincota (Kerry)', zip: '229106' },
	{ city: 'Ballincourcey (Cork)', zip: '787773' },
	{ city: 'Ballincourlea (Cork)', zip: '821461' },
	{ city: 'Ballincourneenig (Cork)', zip: '271005' },
	{ city: 'Ballincraheen (Kerry)', zip: '480395' },
	{ city: 'Ballincrana (Limerick)', zip: '123720' },
	{ city: 'Ballincranig (Cork)', zip: '495089' },
	{ city: 'Ballincrea (Kilkenny)', zip: '924305' },
	{ city: 'Ballincrick And Ballynabrocky (Donegal)', zip: '634305' },
	{ city: 'Ballincrokig (Cork)', zip: '294206' },
	{ city: 'Ballincrossig (Cork)', zip: '216353' },
	{ city: 'Ballincrossig (Kerry)', zip: '868316' },
	{ city: 'Ballinculloo (Limerick)', zip: '243970' },
	{ city: 'Ballincur (Offaly)', zip: '329633' },
	{ city: 'Ballincur (Tipperary)', zip: '998714' },
	{ city: 'Ballincurra (Kilkenny)', zip: '486011' },
	{ city: 'Ballincurra (Limerick)', zip: '225642' },
	{ city: 'Ballincurra (Tipperary)', zip: '918455' },
	{ city: 'Ballincurra (Westmeath)', zip: '351908' },
	{ city: 'Ballincurragh (Kilkenny)', zip: '907976' },
	{ city: 'Ballincurra North (Kilkenny)', zip: '747101' },
	{ city: 'Ballincurra South (Kilkenny)', zip: '760217' },
	{ city: 'Ballincurrig (Cork)', zip: '790450' },
	{ city: 'Ballincurry (Galway)', zip: '566117' },
	{ city: 'Ballincurry (Longford)', zip: '749222' },
	{ city: 'Ballincurry (Roscommon)', zip: '792784' },
	{ city: 'Ballincurry (Sligo)', zip: '447130' },
	{ city: 'Ballincurry (Tipperary)', zip: '752682' },
	{ city: 'Ballindaggan (Wexford)', zip: '932136' },
	{ city: 'Ballindagny And Cullyvore (Longford)', zip: '999078' },
	{ city: 'Ballindall (Roscommon)', zip: '815241' },
	{ city: 'Ballindangan (Cork)', zip: '553562' },
	{ city: 'Ballindarra (Offaly)', zip: '764786' },
	{ city: 'Ballindeasig (Cork)', zip: '290869' },
	{ city: 'Ballindeenisk (Cork)', zip: '376783' },
	{ city: 'Ballindell East (Mayo)', zip: '492509' },
	{ city: 'Ballindell West (Mayo)', zip: '257118' },
	{ city: 'Ballinderreen (Galway)', zip: '377489' },
	{ city: 'Ballinderrin (Meath)', zip: '132817' },
	{ city: 'Ballinderry (Galway)', zip: '479771' },
	{ city: 'Ballinderry (Kildare)', zip: '631024' },
	{ city: 'Ballinderry (Meath)', zip: '693909' },
	{ city: 'Ballinderry (Roscommon)', zip: '588532' },
	{ city: 'Ballinderry (Tipperary)', zip: '282192' },
	{ city: 'Ballinderry (Westmeath)', zip: '960429' },
	{ city: 'Ballinderry Big (Westmeath)', zip: '902572' },
	{ city: 'Ballinderry Little (Westmeath)', zip: '480904' },
	{ city: 'Ballinderry Lower (Wicklow)', zip: '724271' },
	{ city: 'Ballinderry Upper (Wicklow)', zip: '166476' },
	{ city: 'Ballindigny (Tipperary)', zip: '928470' },
	{ city: 'Ballindillanig (Cork)', zip: '695908' },
	{ city: 'Ballindinas (Wexford)', zip: '798993' },
	{ city: 'Ballindine (Mayo)', zip: '754908' },
	{ city: 'Ballindine East (Mayo)', zip: '637740' },
	{ city: 'Ballindine North (Mayo)', zip: '942224' },
	{ city: 'Ballindine West (Mayo)', zip: '642562' },
	{ city: 'Ballindinis (Cork)', zip: '429636' },
	{ city: 'Ballindollaghan (Roscommon)', zip: '913163' },
	{ city: 'Ballindoney (Tipperary)', zip: '475474' },
	{ city: 'Ballindoney (Wexford)', zip: '264165' },
	{ city: 'Ballindoney East (Tipperary)', zip: '990285' },
	{ city: 'Ballindoney West (Tipperary)', zip: '277733' },
	{ city: 'Ballindoo (Mayo)', zip: '729429' },
	{ city: 'Ballindooganig (Kerry)', zip: '263431' },
	{ city: 'Ballindoolin (Kildare)', zip: '741088' },
	{ city: 'Ballindooly (Galway)', zip: '560195' },
	{ city: 'Ballindoon (Sligo)', zip: '606041' },
	{ city: 'Ballindown (Offaly)', zip: '924924' },
	{ city: 'Ballindoyle (Wicklow)', zip: '134898' },
	{ city: 'Ballindrait (Donegal)', zip: '290885' },
	{ city: 'Ballindrehid (Mayo)', zip: '482705' },
	{ city: 'Ballindrehid (Roscommon)', zip: '761333' },
	{ city: 'Ballindresrough (Cork)', zip: '713717' },
	{ city: 'Ballindrimna (Galway)', zip: '931757' },
	{ city: 'Ballindrinan (Offaly)', zip: '678146' },
	{ city: 'Ballindrinnan (Offaly)', zip: '397242' },
	{ city: 'Ballindrum (Kildare)', zip: '472385' },
	{ city: 'Ballindrumlea (Roscommon)', zip: '687520' },
	{ city: 'Ballindrumma (Waterford)', zip: '948073' },
	{ city: 'Ballindrummeen (Tipperary)', zip: '435192' },
	{ city: 'Ballinduff (Galway)', zip: '429615' },
	{ city: 'Ballindurrow (Westmeath)', zip: '982955' },
	{ city: 'Ballindysert (Waterford)', zip: '398723' },
	{ city: 'Balline (Limerick)', zip: '242661' },
	{ city: 'Ballineadig (Cork)', zip: '265409' },
	{ city: 'Ballinealoe (Westmeath)', zip: '982386' },
	{ city: 'Ballineanig-Castlequarter (Kerry)', zip: '139887' },
	{ city: 'Ballineanig-Churchquarter (Kerry)', zip: '437014' },
	{ city: 'Ballineddan Lower (Wicklow)', zip: '408731' },
	{ city: 'Ballineddan Mountain (Wicklow)', zip: '864099' },
	{ city: 'Ballineddan Upper (Wicklow)', zip: '626375' },
	{ city: 'Ballineden (Sligo)', zip: '860328' },
	{ city: 'Ballineedora (Kerry)', zip: '574141' },
	{ city: 'Ballineen (Cork)', zip: '286425' },
	{ city: 'Ballineesteenig (Kerry)', zip: '980936' },
	{ city: 'Ballineetig (Kerry)', zip: '922674' },
	{ city: 'Ballinena (Limerick)', zip: '935229' },
	{ city: 'Ballinenagh (Tipperary)', zip: '705894' },
	{ city: 'Ballinesker (Wexford)', zip: '216009' },
	{ city: 'Ballinfoile (Galway)', zip: '294840' },
	{ city: 'Ballinfoyle Lower (Wicklow)', zip: '729568' },
	{ city: 'Ballinfoyle Upper (Wicklow)', zip: '628449' },
	{ city: 'Ballinfrase (Laois)', zip: '788755' },
	{ city: 'Ballinfreera (Limerick)', zip: '822338' },
	{ city: 'Ballinfuil (Louth)', zip: '690588' },
	{ city: 'Ballinfull (Sligo)', zip: '521667' },
	{ city: 'Balling (Galway)', zip: '569691' },
	{ city: 'Ballingaddy East (Clare)', zip: '349891' },
	{ city: 'Ballingaddy North (Limerick)', zip: '360538' },
	{ city: 'Ballingaddy South (Limerick)', zip: '783617' },
	{ city: 'Ballingaddy West (Clare)', zip: '483844' },
	{ city: 'Ballingale (Wexford)', zip: '809003' },
	{ city: 'Ballingarden (Mayo)', zip: '820170' },
	{ city: 'Ballingarra (Waterford)', zip: '347151' },
	{ city: 'Ballingarrane (Cork)', zip: '578097' },
	{ city: 'Ballingarrane (Limerick)', zip: '129990' },
	{ city: 'Ballingarrane (Tipperary)', zip: '984824' },
	{ city: 'Ballingarrane North (Tipperary)', zip: '762569' },
	{ city: 'Ballingarrane South (Tipperary)', zip: '549268' },
	{ city: 'Ballingarraun (Kerry)', zip: '882628' },
	{ city: 'Ballingarry (Galway)', zip: '325975' },
	{ city: 'Ballingarry (Limerick)', zip: '253216' },
	{ city: 'Ballingarry (Monaghan)', zip: '316111' },
	{ city: 'Ballingarry (Tipperary)', zip: '103697' },
	{ city: 'Ballingarry (Waterford)', zip: '756842' },
	{ city: 'Ballingarry East (Cork)', zip: '177884' },
	{ city: 'Ballingarry Lower (Tipperary)', zip: '561829' },
	{ city: 'Ballingarry Lower (Wexford)', zip: '189664' },
	{ city: 'Ballingarry Middle (Cork)', zip: '737970' },
	{ city: 'Ballingarry Upper (Tipperary)', zip: '870446' },
	{ city: 'Ballingarry Upper (Wexford)', zip: '471036' },
	{ city: 'Ballingarry West (Cork)', zip: '473358' },
	{ city: 'Ballingarry Wood (Wexford)', zip: '969755' },
	{ city: 'Ballingate (Wicklow)', zip: '600167' },
	{ city: 'Ballingate Lower (Wicklow)', zip: '933518' },
	{ city: 'Ballingate Upper (Wicklow)', zip: '551067' },
	{ city: 'Ballingatta (Galway)', zip: '298099' },
	{ city: 'Ballingayrour (Limerick)', zip: '239009' },
	{ city: 'Ballingeary (Cork)', zip: '724335' },
	{ city: 'Ballingeary East (Tipperary)', zip: '492368' },
	{ city: 'Ballingeary West (Tipperary)', zip: '780662' },
	{ city: 'Ballingeemanigbeg (Cork)', zip: '970734' },
	{ city: 'Ballingeer (Tipperary)', zip: '225200' },
	{ city: 'Ballinglanna (Cork)', zip: '995130' },
	{ city: 'Ballinglanna (Kerry)', zip: '534096' },
	{ city: 'Ballinglanna (Tipperary)', zip: '232394' },
	{ city: 'Ballinglanna North (Cork)', zip: '173995' },
	{ city: 'Ballinglanna South (Cork)', zip: '464834' },
	{ city: 'Ballinglen (Mayo)', zip: '824277' },
	{ city: 'Ballinglen (Wicklow)', zip: '543705' },
	{ city: 'Ballinglin (Wexford)', zip: '766167' },
	{ city: 'Ballinglinbeg (Wexford)', zip: '988537' },
	{ city: 'Ballingly (Wexford)', zip: '978491' },
	{ city: 'Ballingohig (Cork)', zip: '595715' },
	{ city: 'Ballingoola (Limerick)', zip: '383061' },
	{ city: 'Ballingorraun (Offaly)', zip: '934563' },
	{ city: 'Ballingowan (Kerry)', zip: '874943' },
	{ city: 'Ballingowan (Limerick)', zip: '494723' },
	{ city: 'Ballingowan (Waterford)', zip: '315104' },
	{ city: 'Ballingowan (Wexford)', zip: '620955' },
	{ city: 'Ballingowan East (Waterford)', zip: '396395' },
	{ city: 'Ballingowan Glebe (Offaly)', zip: '956243' },
	{ city: 'Ballingowan West (Waterford)', zip: '615250' },
	{ city: 'Ballingrogy (Mayo)', zip: '153378' },
	{ city: 'Ballinguile (Cork)', zip: '348267' },
	{ city: 'Ballinguile (Wicklow)', zip: '774180' },
	{ city: 'Ballinguilehill (Wicklow)', zip: '117097' },
	{ city: 'Ballinguilly (Cork)', zip: '533920' },
	{ city: 'Ballingurteen (Cork)', zip: '512271' },
	{ city: 'Ballinhalla (Tipperary)', zip: '355162' },
	{ city: 'Ballinhassig (Cork)', zip: '641604' },
	{ city: 'Ballinhoe (Mayo)', zip: '548228' },
	{ city: 'Ballinillane (Kerry)', zip: '800265' },
	{ city: 'Ballinillaun (Galway)', zip: '839989' },
	{ city: 'Ballinillaun (Mayo)', zip: '156521' },
	{ city: 'Ballinimlagh (Cork)', zip: '233666' },
	{ city: 'Balliniry (Kerry)', zip: '504728' },
	{ city: 'Balliniry (Wexford)', zip: '756890' },
	{ city: 'Balliniska (Limerick)', zip: '636199' },
	{ city: 'Ballinivarrig (Kerry)', zip: '577094' },
	{ city: 'Ballinive (Westmeath)', zip: '968019' },
	{ city: 'Ballinkeel (Wexford)', zip: '222226' },
	{ city: 'Ballinkeen (Cork)', zip: '813907' },
	{ city: 'Ballinkeeny (Westmeath)', zip: '578548' },
	{ city: 'Ballinkillin (Carlow)', zip: '449775' },
	{ city: 'Ballinkina (Waterford)', zip: '627059' },
	{ city: 'Ballinknock (Kerry)', zip: '370369' },
	{ city: 'Ballinknockane (Kerry)', zip: '120824' },
	{ city: 'Ballinknockane (Limerick)', zip: '449885' },
	{ city: 'Ballinla (Cork)', zip: '337376' },
	{ city: 'Ballinla (Galway)', zip: '902069' },
	{ city: 'Ballinla (Laois)', zip: '169992' },
	{ city: 'Ballinla (Offaly)', zip: '657243' },
	{ city: 'Ballinla (Westmeath)', zip: '757253' },
	{ city: 'Ballinlaban (Westmeath)', zip: '678475' },
	{ city: 'Ballinlabaun (Mayo)', zip: '526309' },
	{ city: 'Ballinlag (Mayo)', zip: '448127' },
	{ city: 'Ballinlammy (Kilkenny)', zip: '672726' },
	{ city: 'Ballinlass (Galway)', zip: '291359' },
	{ city: 'Ballinlassa (Mayo)', zip: '295442' },
	{ city: 'Ballinlassa (Tipperary)', zip: '631457' },
	{ city: 'Ballinlassy (Westmeath)', zip: '639217' },
	{ city: 'Ballinlaur (Galway)', zip: '769733' },
	{ city: 'Ballinlavan (Westmeath)', zip: '591863' },
	{ city: 'Ballinlaw (Kilkenny)', zip: '509224' },
	{ city: 'Ballinlawless (Galway)', zip: '869467' },
	{ city: 'Ballinleague (Kerry)', zip: '229131' },
	{ city: 'Ballinlee (Limerick)', zip: '567788' },
	{ city: 'Ballinlee North (Limerick)', zip: '264509' },
	{ city: 'Ballinleenty (Tipperary)', zip: '584589' },
	{ city: 'Ballinlee South (Limerick)', zip: '385899' },
	{ city: 'Ballinlegane (Cork)', zip: '160765' },
	{ city: 'Ballinlena (Mayo)', zip: '110952' },
	{ city: 'Ballinlevane East (Waterford)', zip: '357850' },
	{ city: 'Ballinlevane West (Waterford)', zip: '408401' },
	{ city: 'Ballinlig (Kildare)', zip: '194240' },
	{ city: 'Ballinlig (Meath)', zip: '100056' },
	{ city: 'Ballinlig (Roscommon)', zip: '899596' },
	{ city: 'Ballinlig (Sligo)', zip: '688121' },
	{ city: 'Ballinlig (Westmeath)', zip: '684062' },
	{ city: 'Ballinlig Lower (Westmeath)', zip: '280964' },
	{ city: 'Ballinlig Upper (Westmeath)', zip: '943297' },
	{ city: 'Ballinlina (Tipperary)', zip: '653792' },
	{ city: 'Ballinlining (Cork)', zip: '572874' },
	{ city: 'Ballinlisheen (Clare)', zip: '129415' },
	{ city: 'Ballinloghig (Kerry)', zip: '981229' },
	{ city: 'Ballinloman (Offaly)', zip: '347048' },
	{ city: 'Ballinlongig (Limerick)', zip: '491138' },
	{ city: 'Ballinlonty (Tipperary)', zip: '193055' },
	{ city: 'Ballinlough (Cavan)', zip: '599949' },
	{ city: 'Ballinlough (Cork)', zip: '190611' },
	{ city: 'Ballinlough (Donegal)', zip: '717476' },
	{ city: 'Ballinlough (Galway)', zip: '382317' },
	{ city: 'Ballinlough (Kerry)', zip: '804146' },
	{ city: 'Ballinlough (Kilkenny)', zip: '885649' },
	{ city: 'Ballinlough (Laois)', zip: '826182' },
	{ city: 'Ballinlough (Limerick)', zip: '693237' },
	{ city: 'Ballinlough (Longford)', zip: '566512' },
	{ city: 'Ballinlough (Louth)', zip: '370532' },
	{ city: 'Ballinlough (Mayo)', zip: '115827' },
	{ city: 'Ballinlough (Meath)', zip: '986005' },
	{ city: 'Ballinlough (Offaly)', zip: '733155' },
	{ city: 'Ballinlough (Roscommon)', zip: '599899' },
	{ city: 'Ballinlough (Tipperary)', zip: '380336' },
	{ city: 'Ballinlough (Waterford)', zip: '793090' },
	{ city: 'Ballinlough (Westmeath)', zip: '152803' },
	{ city: 'Ballinloughan (Louth)', zip: '940797' },
	{ city: 'Ballinloughane (Limerick)', zip: '825777' },
	{ city: 'Ballinloughaun (Galway)', zip: '595707' },
	{ city: 'Ballinloughaun (Mayo)', zip: '792069' },
	{ city: 'Ballinlough Big (Meath)', zip: '175277' },
	{ city: 'Ballinlough East (Tipperary)', zip: '771230' },
	{ city: 'Ballinlough Little (Meath)', zip: '282064' },
	{ city: 'Ballinloughquarter (Roscommon)', zip: '813611' },
	{ city: 'Ballinlough West (Tipperary)', zip: '435913' },
	{ city: 'Ballinlow (Wexford)', zip: '339856' },
	{ city: 'Ballinlug (Galway)', zip: '938667' },
	{ city: 'Ballinlug (Westmeath)', zip: '401867' },
	{ city: 'Ballinlug East (Wexford)', zip: '538321' },
	{ city: 'Ballinlug West (Wexford)', zip: '211544' },
	{ city: 'Ballinluig (Cork)', zip: '201674' },
	{ city: 'Ballinluig East (Cork)', zip: '440638' },
	{ city: 'Ballinluig West (Cork)', zip: '986836' },
	{ city: 'Ballinluska (Cork)', zip: '987512' },
	{ city: 'Ballinlyna Lower (Limerick)', zip: '444572' },
	{ city: 'Ballinlyna Upper (Limerick)', zip: '756354' },
	{ city: 'Ballinlyny (Limerick)', zip: '450627' },
	{ city: 'Ballinn (Westmeath)', zip: '291241' },
	{ city: 'Ballinookery (Cork)', zip: '975029' },
	{ city: 'Ballinooskny (Clare)', zip: '372861' },
	{ city: 'Ballinoran (Limerick)', zip: '760045' },
	{ city: 'Ballinorig East (Kerry)', zip: '131563' },
	{ city: 'Ballinorig South (Kerry)', zip: '929511' },
	{ city: 'Ballinorig West (Kerry)', zip: '244147' },
	{ city: 'Ballinoroher (Cork)', zip: '560607' },
	{ city: 'Ballinoulart (Wexford)', zip: '687350' },
	{ city: 'Ballinowlart North (Offaly)', zip: '946982' },
	{ city: 'Ballinowlart South (Offaly)', zip: '812578' },
	{ city: 'Ballinphelic (Cork)', zip: '862561' },
	{ city: 'Ballinphellic (Cork)', zip: '293467' },
	{ city: 'Ballinphile (Wexford)', zip: '156447' },
	{ city: 'Ballinphort (Westmeath)', zip: '219063' },
	{ city: 'Ballinphuil (Galway)', zip: '479486' },
	{ city: 'Ballinphuill (Galway)', zip: '220084' },
	{ city: 'Ballinphuill (Mayo)', zip: '131538' },
	{ city: 'Ballinphuill (Roscommon)', zip: '783733' },
	{ city: 'Ballinphull (Sligo)', zip: '723392' },
	{ city: 'Ballinphunta (Clare)', zip: '467787' },
	{ city: 'Ballinprior (Kerry)', zip: '299828' },
	{ city: 'Ballinra (Wexford)', zip: '216651' },
	{ city: 'Ballinrahin (Laois)', zip: '178186' },
	{ city: 'Ballinrahin (Offaly)', zip: '905742' },
	{ city: 'Ballinrally (Laois)', zip: '554673' },
	{ city: 'Ballinrannig (Kerry)', zip: '768606' },
	{ city: 'Ballinrath (Offaly)', zip: '750651' },
	{ city: 'Ballinrea (Cork)', zip: '766415' },
	{ city: 'Ballinrea (Limerick)', zip: '820759' },
	{ city: 'Ballinreaghan (Longford)', zip: '979862' },
	{ city: 'Ballinreask (Louth)', zip: '948672' },
	{ city: 'Ballinrea South (Cork)', zip: '229380' },
	{ city: 'Ballinree (Carlow)', zip: '469482' },
	{ city: 'Ballinree (Cork)', zip: '942867' },
	{ city: 'Ballinree (Laois)', zip: '233605' },
	{ city: 'Ballinree (Limerick)', zip: '254018' },
	{ city: 'Ballinree (Offaly)', zip: '892321' },
	{ city: 'Ballinree (Tipperary)', zip: '375665' },
	{ city: 'Ballinree (Wexford)', zip: '443321' },
	{ city: 'Ballinree And Ballymoat (Longford)', zip: '930614' },
	{ city: 'Ballinreenlanig (Cork)', zip: '907549' },
	{ city: 'Ballinreeshig (Cork)', zip: '157434' },
	{ city: 'Ballinrichard (Cork)', zip: '971936' },
	{ city: 'Ballinriddera (Westmeath)', zip: '954236' },
	{ city: 'Ballinrig (Meath)', zip: '677252' },
	{ city: 'Ballinrink (Meath)', zip: '692181' },
	{ city: 'Ballinroad (Waterford)', zip: '543152' },
	{ city: 'Ballinroad (Wexford)', zip: '130569' },
	{ city: 'Ballinroan Lower (Wicklow)', zip: '820710' },
	{ city: 'Ballinroan Upper (Wicklow)', zip: '936357' },
	{ city: 'Ballinrobe (Mayo)', zip: '603566' },
	{ city: 'Ballinrobe Demesne (Mayo)', zip: '922842' },
	{ city: 'Ballinroche East (Limerick)', zip: '178600' },
	{ city: 'Ballinroche North (Limerick)', zip: '877787' },
	{ city: 'Ballinroddy (Longford)', zip: '327389' },
	{ city: 'Ballinroe (Cork)', zip: '611954' },
	{ city: 'Ballinroe (Tipperary)', zip: '999528' },
	{ city: 'Ballinroe East (Cork)', zip: '904548' },
	{ city: 'Ballinrooaun (Clare)', zip: '502043' },
	{ city: 'Ballinrooaun (Galway)', zip: '947026' },
	{ city: 'Ballinrooaun (Wexford)', zip: '590246' },
	{ city: 'Ballinrooey (Longford)', zip: '112691' },
	{ city: 'Ballinross (Roscommon)', zip: '789204' },
	{ city: 'Ballinrostig (Cork)', zip: '687908' },
	{ city: 'Ballinruan (Clare)', zip: '164524' },
	{ city: 'Ballinruan (Tipperary)', zip: '502697' },
	{ city: 'Ballinruan (Wexford)', zip: '899671' },
	{ city: 'Ballinruane (Limerick)', zip: '110449' },
	{ city: 'Ballinruane (Wexford)', zip: '548782' },
	{ city: 'Ballinruddery (Kerry)', zip: '155573' },
	{ city: 'Ballinruddery (Tipperary)', zip: '460166' },
	{ city: 'Ballinrud East (Longford)', zip: '851726' },
	{ city: 'Ballinrud Glebe (Longford)', zip: '162823' },
	{ city: 'Ballinrud West (Longford)', zip: '846098' },
	{ city: 'Ballinrumpa (Mayo)', zip: '540167' },
	{ city: 'Ballinrush (Carlow)', zip: '403840' },
	{ city: 'Ballinrush (Cork)', zip: '129336' },
	{ city: 'Ballinrush (Wicklow)', zip: '472037' },
	{ city: 'Ballinscaula (Limerick)', zip: '200129' },
	{ city: 'Ballinscoola (Limerick)', zip: '192389' },
	{ city: 'Ballinscurloge (Cork)', zip: '666644' },
	{ city: 'Ballinskelligs (Kerry)', zip: '340241' },
	{ city: 'Ballinsmaul (Galway)', zip: '286641' },
	{ city: 'Ballinsmaula (Mayo)', zip: '678467' },
	{ city: 'Ballinspittle (Cork)', zip: '865489' },
	{ city: 'Ballinstona North (Limerick)', zip: '388877' },
	{ city: 'Ballinstona South (Limerick)', zip: '123064' },
	{ city: 'Ballintadder (Mayo)', zip: '967920' },
	{ city: 'Ballintaffy (Mayo)', zip: '831637' },
	{ city: 'Ballintaggart (Cork)', zip: '881531' },
	{ city: 'Ballintaggart (Kerry)', zip: '201980' },
	{ city: 'Ballintaggart (Kildare)', zip: '791450' },
	{ city: 'Ballintaggart (Laois)', zip: '408195' },
	{ city: 'Ballintaggart (Tipperary)', zip: '860368' },
	{ city: 'Ballintaggart (Wexford)', zip: '394074' },
	{ city: 'Ballintannig (Cork)', zip: '142680' },
	{ city: 'Ballintantassig (Cork)', zip: '576406' },
	{ city: 'Ballintarsna (Kilkenny)', zip: '750430' },
	{ city: 'Ballintarton (Wexford)', zip: '121265' },
	{ city: 'Ballintava (Galway)', zip: '386698' },
	{ city: 'Ballintaw (Limerick)', zip: '311960' },
	{ city: 'Ballintaylor Lower (Waterford)', zip: '641230' },
	{ city: 'Ballintaylor Upper (Waterford)', zip: '692607' },
	{ city: 'Ballinteane (Sligo)', zip: '891370' },
	{ city: 'Ballintee (Kilkenny)', zip: '957031' },
	{ city: 'Ballinteean (Mayo)', zip: '301158' },
	{ city: 'Ballinteeaun (Mayo)', zip: '436883' },
	{ city: 'Ballinteenoe (Tipperary)', zip: '336056' },
	{ city: 'Ballinteer (Dublin)', zip: '206175' },
	{ city: 'Ballintempan (Longford)', zip: '576594' },
	{ city: 'Ballintemple (Carlow)', zip: '299386' },
	{ city: 'Ballintemple (Cavan)', zip: '874558' },
	{ city: 'Ballintemple (Cork)', zip: '253551' },
	{ city: 'Ballintemple (Donegal)', zip: '404898' },
	{ city: 'Ballintemple (Galway)', zip: '554292' },
	{ city: 'Ballintemple (Kerry)', zip: '214435' },
	{ city: 'Ballintemple (Mayo)', zip: '467958' },
	{ city: 'Ballintemple (Offaly)', zip: '475711' },
	{ city: 'Ballintemple (Roscommon)', zip: '263896' },
	{ city: 'Ballintemple (Sligo)', zip: '262621' },
	{ city: 'Ballintemple (Tipperary)', zip: '782691' },
	{ city: 'Ballintemple (Wicklow)', zip: '843829' },
	{ city: 'Ballinteosig (Cork)', zip: '184148' },
	{ city: 'Ballinter (Meath)', zip: '169962' },
	{ city: 'Ballintermon (Kerry)', zip: '360210' },
	{ city: 'Ballinterry (Cork)', zip: '373164' },
	{ city: 'Ballinteskin (Kilkenny)', zip: '182756' },
	{ city: 'Ballinteskin (Laois)', zip: '407795' },
	{ city: 'Ballinteskin (Louth)', zip: '679028' },
	{ city: 'Ballinteskin (Wexford)', zip: '963648' },
	{ city: 'Ballinteskin (Wicklow)', zip: '245049' },
	{ city: 'Ballintillan (Meath)', zip: '534957' },
	{ city: 'Ballintim (Wexford)', zip: '867569' },
	{ city: 'Ballintim (Wicklow)', zip: '675840' },
	{ city: 'Ballintine (Kildare)', zip: '693834' },
	{ city: 'Ballintise (Galway)', zip: '239717' },
	{ city: 'Ballintlea (Kerry)', zip: '961866' },
	{ city: 'Ballintlea (Kilkenny)', zip: '503359' },
	{ city: 'Ballintlea (Laois)', zip: '487886' },
	{ city: 'Ballintlea (Waterford)', zip: '665736' },
	{ city: 'Ballintlea (Wexford)', zip: '329789' },
	{ city: 'Ballintlea Lower (Laois)', zip: '443873' },
	{ city: 'Ballintlea North (Clare)', zip: '766938' },
	{ city: 'Ballintlea North (Cork)', zip: '282975' },
	{ city: 'Ballintlea North (Waterford)', zip: '594636' },
	{ city: 'Ballintlea South (Clare)', zip: '351516' },
	{ city: 'Ballintlea South (Cork)', zip: '662867' },
	{ city: 'Ballintlea South (Waterford)', zip: '314592' },
	{ city: 'Ballintlea Upper (Laois)', zip: '990809' },
	{ city: 'Ballintleave (Kerry)', zip: '861372' },
	{ city: 'Ballintleave Commons (Kerry)', zip: '781592' },
	{ city: 'Ballintleva (Galway)', zip: '926129' },
	{ city: 'Ballintleva (Mayo)', zip: '672705' },
	{ city: 'Ballintlevy (Westmeath)', zip: '439585' },
	{ city: 'Ballintlieve (Donegal)', zip: '527696' },
	{ city: 'Ballintlieve (Meath)', zip: '128205' },
	{ city: 'Ballintobeenig (Kerry)', zip: '850642' },
	{ city: 'Ballintober (Cork)', zip: '740463' },
	{ city: 'Ballintober (Galway)', zip: '440832' },
	{ city: 'Ballintober (Kilkenny)', zip: '892103' },
	{ city: 'Ballintober (Limerick)', zip: '525366' },
	{ city: 'Ballintober (Longford)', zip: '635536' },
	{ city: 'Ballintober (Mayo)', zip: '759908' },
	{ city: 'Ballintober (Roscommon)', zip: '989051' },
	{ city: 'Ballintober (Westmeath)', zip: '387135' },
	{ city: 'Ballintober (Wexford)', zip: '560404' },
	{ city: 'Ballintober (Wicklow)', zip: '154147' },
	{ city: 'Ballintober East (Galway)', zip: '736600' },
	{ city: 'Ballintober East (Limerick)', zip: '993460' },
	{ city: 'Ballintober South (Limerick)', zip: '325678' },
	{ city: 'Ballintober West (Galway)', zip: '184539' },
	{ city: 'Ballintober West (Limerick)', zip: '749602' },
	{ city: 'Ballintoghee (Meath)', zip: '493010' },
	{ city: 'Ballintogher (Kerry)', zip: '615528' },
	{ city: 'Ballintogher (Laois)', zip: '695183' },
	{ city: 'Ballintogher (Meath)', zip: '798233' },
	{ city: 'Ballintogher (Offaly)', zip: '718395' },
	{ city: 'Ballintogher (Sligo)', zip: '549789' },
	{ city: 'Ballintogher (Tipperary)', zip: '446449' },
	{ city: 'Ballintombay (Wicklow)', zip: '692650' },
	{ city: 'Ballintombay Lower (Wicklow)', zip: '208786' },
	{ city: 'Ballintombay Upper (Wicklow)', zip: '289191' },
	{ city: 'Ballintooey (Donegal)', zip: '762846' },
	{ city: 'Ballintoor (Waterford)', zip: '355978' },
	{ city: 'Ballintoppan (Monaghan)', zip: '723249' },
	{ city: 'Ballintore (Wexford)', zip: '883707' },
	{ city: 'Ballintotis (Cork)', zip: '365179' },
	{ city: 'Ballintotty (Tipperary)', zip: '369244' },
	{ city: 'Ballintra (Donegal)', zip: '958486' },
	{ city: 'Ballintra (Monaghan)', zip: '943257' },
	{ city: 'Ballintra East (Cork)', zip: '779755' },
	{ city: 'Ballintrane (Carlow)', zip: '911782' },
	{ city: 'Ballintra West (Cork)', zip: '737405' },
	{ city: 'Ballintredida (Limerick)', zip: '367388' },
	{ city: 'Ballintrideen (Cork)', zip: '746752' },
	{ city: 'Ballintrim (Cork)', zip: '328239' },
	{ city: 'Ballintrofaun (Sligo)', zip: '105189' },
	{ city: 'Ballintruer Beg (Wicklow)', zip: '585380' },
	{ city: 'Ballintruer More (Wicklow)', zip: '783855' },
	{ city: 'Ballintry (Meath)', zip: '828606' },
	{ city: 'Ballintubbert (Laois)', zip: '679858' },
	{ city: 'Ballintubbrid (Limerick)', zip: '423945' },
	{ city: 'Ballintubbrid (Wexford)', zip: '444855' },
	{ city: 'Ballintubbrid East (Cork)', zip: '576652' },
	{ city: 'Ballintubbrid West (Cork)', zip: '999226' },
	{ city: 'Ballintue (Westmeath)', zip: '971147' },
	{ city: 'Ballinturly (Roscommon)', zip: '626614' },
	{ city: 'Ballinulty (Mayo)', zip: '374969' },
	{ city: 'Ballinulty (Tipperary)', zip: '362613' },
	{ city: 'Ballinulty Lower (Longford)', zip: '725043' },
	{ city: 'Ballinulty Upper (Longford)', zip: '782642' },
	{ city: 'Ballinunty (Tipperary)', zip: '854452' },
	{ city: 'Ballinurd (Louth)', zip: '164966' },
	{ city: 'Ballinure (Cork)', zip: '870864' },
	{ city: 'Ballinure (Kildare)', zip: '944788' },
	{ city: 'Ballinure (Tipperary)', zip: '276828' },
	{ city: 'Ballinure (Waterford)', zip: '886767' },
	{ city: 'Ballinure (Wexford)', zip: '345221' },
	{ city: 'Ballinurra (Tipperary)', zip: '161185' },
	{ city: 'Ballinva (Kilkenny)', zip: '603645' },
	{ city: 'Ballinvack (Wexford)', zip: '956214' },
	{ city: 'Ballinvallig (Limerick)', zip: '597333' },
	{ city: 'Ballinvally (Carlow)', zip: '922439' },
	{ city: 'Ballinvally (Kilkenny)', zip: '424618' },
	{ city: 'Ballinvally (Meath)', zip: '787470' },
	{ city: 'Ballinvally (Offaly)', zip: '504930' },
	{ city: 'Ballinvally (Sligo)', zip: '964213' },
	{ city: 'Ballinvally (Westmeath)', zip: '445880' },
	{ city: 'Ballinvally (Wexford)', zip: '820826' },
	{ city: 'Ballinvally (Wicklow)', zip: '133153' },
	{ city: 'Ballinvally And Kiltennell (Carlow)', zip: '785349' },
	{ city: 'Ballinvally East (Sligo)', zip: '807907' },
	{ city: 'Ballinvally Lower (Wicklow)', zip: '256794' },
	{ city: 'Ballinvally Upper (Wicklow)', zip: '683175' },
	{ city: 'Ballinvally West (Sligo)', zip: '542415' },
	{ city: 'Ballinvana (Limerick)', zip: '113729' },
	{ city: 'Ballinva North (Kilkenny)', zip: '980312' },
	{ city: 'Ballinvard (Cork)', zip: '179960' },
	{ city: 'Ballinvariscal (Kerry)', zip: '632316' },
	{ city: 'Ballinvarosig (Cork)', zip: '362068' },
	{ city: 'Ballinvarrig (Cork)', zip: '528435' },
	{ city: 'Ballinvarrig East (Cork)', zip: '975641' },
	{ city: 'Ballinvarrig Lower (Cork)', zip: '746060' },
	{ city: 'Ballinvarrig Upper (Cork)', zip: '170603' },
	{ city: 'Ballinvarrig West (Cork)', zip: '133109' },
	{ city: 'Ballinvarry (Kilkenny)', zip: '635490' },
	{ city: 'Ballinvarry English (Kilkenny)', zip: '176239' },
	{ city: 'Ballinvarry Irish (Kilkenny)', zip: '923228' },
	{ city: 'Ballinvasa (Tipperary)', zip: '673393' },
	{ city: 'Ballinva South (Kilkenny)', zip: '846423' },
	{ city: 'Ballinveala (Limerick)', zip: '729657' },
	{ city: 'Ballinvee (Tipperary)', zip: '665897' },
	{ city: 'Ballinveelig (Cork)', zip: '202024' },
	{ city: 'Ballinvegga (Wexford)', zip: '828836' },
	{ city: 'Ballinveiltig (Cork)', zip: '779449' },
	{ city: 'Ballinvella (Waterford)', zip: '329673' },
	{ city: 'Ballinveny (Tipperary)', zip: '595740' },
	{ city: 'Ballinvilla (Mayo)', zip: '157697' },
	{ city: 'Ballinvilla (Roscommon)', zip: '218005' },
	{ city: 'Ballinvilla (Tipperary)', zip: '216194' },
	{ city: 'Ballinvilla Demesne (Mayo)', zip: '146081' },
	{ city: 'Ballinvinny North (Cork)', zip: '398724' },
	{ city: 'Ballinvinny South (Cork)', zip: '581339' },
	{ city: 'Ballinvir (Tipperary)', zip: '103426' },
	{ city: 'Ballinvira (Limerick)', zip: '633351' },
	{ city: 'Ballinvirick (Limerick)', zip: '786440' },
	{ city: 'Ballinvoash (Mayo)', zip: '774661' },
	{ city: 'Ballinvogig (Kerry)', zip: '380692' },
	{ city: 'Ballinvoher (Cork)', zip: '925638' },
	{ city: 'Ballinvoher (Galway)', zip: '367666' },
	{ city: 'Ballinvoher (Kerry)', zip: '431271' },
	{ city: 'Ballinvoher (Kilkenny)', zip: '998854' },
	{ city: 'Ballinvoher (Limerick)', zip: '341489' },
	{ city: 'Ballinvoher (Longford)', zip: '912311' },
	{ city: 'Ballinvoher (Mayo)', zip: '984017' },
	{ city: 'Ballinvoher (Offaly)', zip: '806470' },
	{ city: 'Ballinvoher (Roscommon)', zip: '466072' },
	{ city: 'Ballinvoher (Sligo)', zip: '592746' },
	{ city: 'Ballinvoher (Tipperary)', zip: '240376' },
	{ city: 'Ballinvoher North (Galway)', zip: '193729' },
	{ city: 'Ballinvoher South (Galway)', zip: '967589' },
	{ city: 'Ballinvologe (Cork)', zip: '828147' },
	{ city: 'Ballinvonear (Cork)', zip: '167423' },
	{ city: 'Ballinvosherig East (Kerry)', zip: '690184' },
	{ city: 'Ballinvosherig West (Kerry)', zip: '813337' },
	{ city: 'Ballinvoultig (Cork)', zip: '923693' },
	{ city: 'Ballinvownig (Kerry)', zip: '447935' },
	{ city: 'Ballinvoy (Mayo)', zip: '179545' },
	{ city: 'Ballinvragnosig (Cork)', zip: '190705' },
	{ city: 'Ballinvredig (Cork)', zip: '107940' },
	{ city: 'Ballinvreena (Limerick)', zip: '695869' },
	{ city: 'Ballinvreena (Tipperary)', zip: '385771' },
	{ city: 'Ballinvrinsig (Cork)', zip: '479862' },
	{ city: 'Ballinvriskig (Cork)', zip: '861730' },
	{ city: 'Ballinvrokig (Cork)', zip: '819604' },
	{ city: 'Ballinvronig (Cork)', zip: '812160' },
	{ city: 'Ballinvulla (Limerick)', zip: '924386' },
	{ city: 'Ballinvullin (Limerick)', zip: '238261' },
	{ city: 'Ballinvunnia (Wexford)', zip: '521538' },
	{ city: 'Ballinvuskig (Cork)', zip: '470776' },
	{ city: 'Ballinvuskig East (Cork)', zip: '893112' },
	{ city: 'Ballinvuskig West (Cork)', zip: '650856' },
	{ city: 'Ballinwear (Tipperary)', zip: '770818' },
	{ city: 'Ballinwillin (Cork)', zip: '458017' },
	{ city: 'Ballinwillin (Limerick)', zip: '474028' },
	{ city: 'Ballinwillin (Waterford)', zip: '192807' },
	{ city: 'Ballinwing (Leitrim)', zip: '414617' },
	{ city: 'Ballinwire (Westmeath)', zip: '944659' },
	{ city: 'Ballinwully (Roscommon)', zip: '554707' },
	{ city: 'Balliny North (Clare)', zip: '281008' },
	{ city: 'Balliny South (Clare)', zip: '813486' },
	{ city: 'Ballisk (Dublin)', zip: '111480' },
	{ city: 'Ballisk Common (Dublin)', zip: '991297' },
	{ city: 'Ballisnahyny (Mayo)', zip: '100165' },
	{ city: 'Ballitore (Kildare)', zip: '107213' },
	{ city: 'Balliver (Offaly)', zip: '659013' },
	{ city: 'Ballivor (Meath)', zip: '637273' },
	{ city: 'Ballon (Carlow)', zip: '668497' },
	{ city: 'Ballonaghan (Sligo)', zip: '885046' },
	{ city: 'Balloo (Longford)', zip: '646384' },
	{ city: 'Ballooly (Galway)', zip: '784452' },
	{ city: 'Balloonagh (Kerry)', zip: '594380' },
	{ city: 'Balloony (Roscommon)', zip: '773346' },
	{ city: 'Balloor (Donegal)', zip: '541821' },
	{ city: 'Balloor (Mayo)', zip: '925472' },
	{ city: 'Balloorclerhy (Mayo)', zip: '211999' },
	{ city: 'Balloor East (Mayo)', zip: '423277' },
	{ city: 'Balloor West (Mayo)', zip: '351617' },
	{ city: 'Ballough (Dublin)', zip: '580092' },
	{ city: 'Balloughadalla (Mayo)', zip: '566929' },
	{ city: 'Balloughly (Cavan)', zip: '273605' },
	{ city: 'Balloughter (Wexford)', zip: '267879' },
	{ city: 'Balloughton (Wexford)', zip: '287435' },
	{ city: 'Ballowen (Wexford)', zip: '631704' },
	{ city: 'Balloy (Meath)', zip: '486619' },
	{ city: 'Ballsbridge (Dublin)', zip: '441765' },
	{ city: 'Ballsgrove (Louth)', zip: '550484' },
	{ city: 'Ballug (Louth)', zip: '927367' },
	{ city: 'Ballure (Sligo)', zip: '707605' },
	{ city: 'Ballustree (Dublin)', zip: '860221' },
	{ city: 'Ballyadack North (Cork)', zip: '818122' },
	{ city: 'Ballyadack South (Cork)', zip: '299131' },
	{ city: 'Ballyadam (Cork)', zip: '981382' },
	{ city: 'Ballyadam (Limerick)', zip: '892094' },
	{ city: 'Ballyadam (Waterford)', zip: '392490' },
	{ city: 'Ballyadam (Wexford)', zip: '691072' },
	{ city: 'Ballyadams (Kildare)', zip: '342896' },
	{ city: 'Ballyadams (Laois)', zip: '472259' },
	{ city: 'Ballyadams (Meath)', zip: '401298' },
	{ city: 'Ballyadding (Laois)', zip: '662343' },
	{ city: 'Ballyaddragh (Wexford)', zip: '685675' },
	{ city: 'Ballyadeen (Cork)', zip: '175339' },
	{ city: 'Ballyaglish (Limerick)', zip: '857316' },
	{ city: 'Ballyaglisha (Kerry)', zip: '147085' },
	{ city: 'Ballyagran (Limerick)', zip: '856129' },
	{ city: 'Ballyalla (Clare)', zip: '616162' },
	{ city: 'Ballyalla (Donegal)', zip: '310574' },
	{ city: 'Ballyalla (Tipperary)', zip: '250076' },
	{ city: 'Ballyallaban (Clare)', zip: '585951' },
	{ city: 'Ballyallavoe (Tipperary)', zip: '536406' },
	{ city: 'Ballyallia (Clare)', zip: '846046' },
	{ city: 'Ballyallinan North (Limerick)', zip: '992487' },
	{ city: 'Ballyallinan South (Limerick)', zip: '175641' },
	{ city: 'Ballyally (Cork)', zip: '719567' },
	{ city: 'Ballyameenboght (Kerry)', zip: '808067' },
	{ city: 'Ballyameentrant (Kerry)', zip: '737012' },
	{ city: 'Ballyan (Limerick)', zip: '857344' },
	{ city: 'Ballyandreen (Cork)', zip: '142758' },
	{ city: 'Ballyandreen (Kerry)', zip: '348349' },
	{ city: 'Ballyandrew (Cork)', zip: '569281' },
	{ city: 'Ballyandrew (Wexford)', zip: '594529' },
	{ city: 'Ballyane (Limerick)', zip: '573229' },
	{ city: 'Ballyaneen North (Galway)', zip: '359071' },
	{ city: 'Ballyaneen South (Galway)', zip: '192698' },
	{ city: 'Ballyania (Limerick)', zip: '202140' },
	{ city: 'Ballyanly (Cork)', zip: '109807' },
	{ city: 'Ballyannan (Cork)', zip: '931558' },
	{ city: 'Ballyannan (Donegal)', zip: '278259' },
	{ city: 'Ballyanne (Wexford)', zip: '957846' },
	{ city: 'Ballyanny Lower (Tipperary)', zip: '973844' },
	{ city: 'Ballyannymore (Tipperary)', zip: '434523' },
	{ city: 'Ballyanny Upper (Tipperary)', zip: '823884' },
	{ city: 'Ballyanrahan (Tipperary)', zip: '950023' },
	{ city: 'Ballyanrahan East (Limerick)', zip: '302583' },
	{ city: 'Ballyanrahan West (Limerick)', zip: '920562' },
	{ city: 'Ballyanthony (Cork)', zip: '576678' },
	{ city: 'Ballyara (Donegal)', zip: '791333' },
	{ city: 'Ballyara (Galway)', zip: '433869' },
	{ city: 'Ballyara (Sligo)', zip: '999723' },
	{ city: 'Ballyard (Cork)', zip: '329937' },
	{ city: 'Ballyard (Kerry)', zip: '318546' },
	{ city: 'Ballyard (Tipperary)', zip: '446237' },
	{ city: 'Ballyard (Waterford)', zip: '670213' },
	{ city: 'Ballyardan (Roscommon)', zip: '428923' },
	{ city: 'Ballyargadaun (Galway)', zip: '219866' },
	{ city: 'Ballyargadaun (Mayo)', zip: '828368' },
	{ city: 'Ballyargus (Donegal)', zip: '463804' },
	{ city: 'Ballyarkane Eighter (Kerry)', zip: '799600' },
	{ city: 'Ballyarkane Oughter (Kerry)', zip: '171329' },
	{ city: 'Ballyarr (Donegal)', zip: '756164' },
	{ city: 'Ballyarra (Cork)', zip: '410009' },
	{ city: 'Ballyarrell (Donegal)', zip: '702514' },
	{ city: 'Ballyarrell Mountain (Donegal)', zip: '387395' },
	{ city: 'Ballyarr Glebe (Donegal)', zip: '141236' },
	{ city: 'Ballyart (Limerick)', zip: '796584' },
	{ city: 'Ballyart (Mayo)', zip: '120975' },
	{ city: 'Ballyart (Wexford)', zip: '618919' },
	{ city: 'Ballyartella (Tipperary)', zip: '377667' },
	{ city: 'Ballyarthur (Cork)', zip: '552545' },
	{ city: 'Ballyarthur (Wicklow)', zip: '991865' },
	{ city: 'Ballyartney (Clare)', zip: '595956' },
	{ city: 'Ballyashea (Limerick)', zip: '240874' },
	{ city: 'Ballyasheea (Clare)', zip: '338354' },
	{ city: 'Ballyatty (Offaly)', zip: '716187' },
	{ city: 'Ballyaukeen (Kerry)', zip: '580357' },
	{ city: 'Ballyavill (Offaly)', zip: '910113' },
	{ city: 'Ballybackagh (Galway)', zip: '951997' },
	{ city: 'Ballybackagh (Mayo)', zip: '973551' },
	{ city: 'Ballybahallagh (Cork)', zip: '647072' },
	{ city: 'Ballybailie (Louth)', zip: '662470' },
	{ city: 'Ballyballinaun (Mayo)', zip: '185420' },
	{ city: 'Ballybanagher (Galway)', zip: '209157' },
	{ city: 'Ballybanaun Mountain (Mayo)', zip: '650277' },
	{ city: 'Ballybane (Cork)', zip: '251467' },
	{ city: 'Ballybane (Dublin)', zip: '200933' },
	{ city: 'Ballybane (Kerry)', zip: '893305' },
	{ city: 'Ballybane (Limerick)', zip: '884813' },
	{ city: 'Ballybane (Roscommon)', zip: '887173' },
	{ city: 'Ballybane East (Cork)', zip: '149252' },
	{ city: 'Ballybane Lower (Roscommon)', zip: '560568' },
	{ city: 'Ballybane Upper (Roscommon)', zip: '496132' },
	{ city: 'Ballybane West (Cork)', zip: '996803' },
	{ city: 'Ballybannon (Carlow)', zip: '910102' },
	{ city: 'Ballybanoge (Wexford)', zip: '814776' },
	{ city: 'Ballybar Lower (Carlow)', zip: '133680' },
	{ city: 'Ballybarney (Kildare)', zip: '439908' },
	{ city: 'Ballybarrack (Louth)', zip: '798474' },
	{ city: 'Ballybar Upper (Carlow)', zip: '904031' },
	{ city: 'Ballybatter (Meath)', zip: '705992' },
	{ city: 'Ballybaun (Clare)', zip: '481137' },
	{ city: 'Ballybaun (Galway)', zip: '820260' },
	{ city: 'Ballybaun (Limerick)', zip: '817142' },
	{ city: 'Ballybaun (Mayo)', zip: '585655' },
	{ city: 'Ballybaun (Roscommon)', zip: '907734' },
	{ city: 'Ballybaun (Wexford)', zip: '147267' },
	{ city: 'Ballybawn Lower (Wicklow)', zip: '363981' },
	{ city: 'Ballybawn Upper (Wicklow)', zip: '251096' },
	{ city: 'Ballybay (Monaghan)', zip: '486448' },
	{ city: 'Ballybeagh (Kilkenny)', zip: '334158' },
	{ city: 'Ballybeg (Clare)', zip: '825918' },
	{ city: 'Ballybeg (Cork)', zip: '526024' },
	{ city: 'Ballybeg (Kerry)', zip: '850926' },
	{ city: 'Ballybeg (Kilkenny)', zip: '526216' },
	{ city: 'Ballybeg (Laois)', zip: '601755' },
	{ city: 'Ballybeg (Limerick)', zip: '237342' },
	{ city: 'Ballybeg (Longford)', zip: '980867' },
	{ city: 'Ballybeg (Mayo)', zip: '384395' },
	{ city: 'Ballybeg (Meath)', zip: '716111' },
	{ city: 'Ballybeg (Offaly)', zip: '500654' },
	{ city: 'Ballybeg (Roscommon)', zip: '131565' },
	{ city: 'Ballybeg (Sligo)', zip: '609454' },
	{ city: 'Ballybeg (Tipperary)', zip: '674444' },
	{ city: 'Ballybeg (Westmeath)', zip: '592359' },
	{ city: 'Ballybeg (Wexford)', zip: '889102' },
	{ city: 'Ballybeg (Wicklow)', zip: '619546' },
	{ city: 'Bally Beg (Roscommon)', zip: '979903' },
	{ city: 'Ballybeg Big (Carlow)', zip: '233238' },
	{ city: 'Ballybeg East (Cork)', zip: '319459' },
	{ city: 'Ballybeggan (Kerry)', zip: '676546' },
	{ city: 'Ballybeggane (Limerick)', zip: '129837' },
	{ city: 'Ballybeg Great (Wexford)', zip: '478295' },
	{ city: 'Ballybeg Little (Carlow)', zip: '577865' },
	{ city: 'Ballybegly (Donegal)', zip: '222446' },
	{ city: 'Ballybegly Little (Donegal)', zip: '263421' },
	{ city: 'Ballybeg Middle (Cork)', zip: '221496' },
	{ city: 'Ballybeg Small (Wexford)', zip: '522631' },
	{ city: 'Ballybeg West (Cork)', zip: '993784' },
	{ city: 'Ballybetagh (Dublin)', zip: '982567' },
	{ city: 'Ballybin (Meath)', zip: '955885' },
	{ city: 'Ballybinaby (Louth)', zip: '955515' },
	{ city: 'Ballybing (Wexford)', zip: '557039' },
	{ city: 'Ballybit Big (Carlow)', zip: '288622' },
	{ city: 'Ballybit Little (Carlow)', zip: '732292' },
	{ city: 'Ballybla (Wicklow)', zip: '503115' },
	{ city: 'Ballyblake (Carlow)', zip: '804724' },
	{ city: 'Ballyblake (Limerick)', zip: '504829' },
	{ city: 'Ballyblood (Clare)', zip: '647837' },
	{ city: 'Ballybobaneen (Donegal)', zip: '761267' },
	{ city: 'Ballyboden (Dublin)', zip: '905635' },
	{ city: 'Ballybodonnell (Donegal)', zip: '821717' },
	{ city: 'Ballyboe (Donegal)', zip: '290122' },
	{ city: 'Ballyboe (Tipperary)', zip: '600782' },
	{ city: 'Ballyboe Glencar (Donegal)', zip: '339969' },
	{ city: 'Ballyboe Lisnenan (Donegal)', zip: '377989' },
	{ city: 'Ballyboe Mountain (Donegal)', zip: '277323' },
	{ city: 'Ballyboencurragh (Donegal)', zip: '648979' },
	{ city: 'Ballybofey (Donegal)', zip: '691162' },
	{ city: 'Ballybogan (Donegal)', zip: '161584' },
	{ city: 'Ballybogey (Cork)', zip: '785479' },
	{ city: 'Ballyboggan (Galway)', zip: '378444' },
	{ city: 'Ballyboggan (Meath)', zip: '278396' },
	{ city: 'Ballyboggan (Wexford)', zip: '516303' },
	{ city: 'Ballyboggan Lower (Wexford)', zip: '668503' },
	{ city: 'Ballyboggan Upper (Wexford)', zip: '440361' },
	{ city: 'Ballyboghil (Dublin)', zip: '874164' },
	{ city: 'Ballyboght (Cork)', zip: '819548' },
	{ city: 'Ballyboher (Wexford)', zip: '405381' },
	{ city: 'Ballybokeel (Donegal)', zip: '404711' },
	{ city: 'Ballybolauder (Donegal)', zip: '513275' },
	{ city: 'Ballyboneill (Cork)', zip: '963911' },
	{ city: 'Ballyboodan (Kilkenny)', zip: '103134' },
	{ city: 'Ballyboodin (Laois)', zip: '761110' },
	{ city: 'Ballybornagh (Clare)', zip: '786131' },
	{ city: 'Ballyboro (Wexford)', zip: '760571' },
	{ city: 'Ballybotemple (Donegal)', zip: '850475' },
	{ city: 'Ballybough (Tipperary)', zip: '792965' },
	{ city: 'Ballyboughan (Roscommon)', zip: '522805' },
	{ city: 'Ballyboughlin (Offaly)', zip: '630776' },
	{ city: 'Ballybought (Kildare)', zip: '702261' },
	{ city: 'Ballybought (Offaly)', zip: '447930' },
	{ city: 'Ballybought (Wexford)', zip: '630961' },
	{ city: 'Ballybowler North (Kerry)', zip: '734789' },
	{ city: 'Ballybowler South (Kerry)', zip: '738000' },
	{ city: 'Ballyboy (Galway)', zip: '350839' },
	{ city: 'Ballyboy (Longford)', zip: '252624' },
	{ city: 'Ballyboy (Meath)', zip: '173731' },
	{ city: 'Ballyboy (Offaly)', zip: '753779' },
	{ city: 'Ballyboy (Tipperary)', zip: '180874' },
	{ city: 'Ballyboy (Waterford)', zip: '803850' },
	{ city: 'Ballyboy (Westmeath)', zip: '967995' },
	{ city: 'Ballyboy (Wexford)', zip: '876593' },
	{ city: 'Ballyboy (Wicklow)', zip: '340591' },
	{ city: 'Ballyboy East (Tipperary)', zip: '297778' },
	{ city: 'Ballyboyle (Donegal)', zip: '869407' },
	{ city: 'Ballyboy West (Tipperary)', zip: '133095' },
	{ city: 'Ballybrack (Carlow)', zip: '391417' },
	{ city: 'Ballybrack (Clare)', zip: '411785' },
	{ city: 'Ballybrack (Cork)', zip: '734385' },
	{ city: 'Ballybrack (Donegal)', zip: '441140' },
	{ city: 'Ballybrack (Dublin)', zip: '320430' },
	{ city: 'Ballybrack (Kerry)', zip: '657833' },
	{ city: 'Ballybrack (Kildare)', zip: '463137' },
	{ city: 'Ballybrack (Offaly)', zip: '536521' },
	{ city: 'Ballybrack (Tipperary)', zip: '363989' },
	{ city: 'Ballybrack (Waterford)', zip: '884410' },
	{ city: 'Ballybrack (Wexford)', zip: '114829' },
	{ city: 'Ballybrackan (Offaly)', zip: '396971' },
	{ city: 'Ballybrackan Little (Offaly)', zip: '427357' },
	{ city: 'Ballybrack Beg (Wicklow)', zip: '534837' },
	{ city: 'Ballybracken (Wexford)', zip: '276538' },
	{ city: 'Ballybrack More (Wicklow)', zip: '370750' },
	{ city: 'Ballybrada (Tipperary)', zip: '125998' },
	{ city: 'Ballybraghy (Kilkenny)', zip: '998087' },
	{ city: 'Ballybraher (Cork)', zip: '913073' },
	{ city: 'Ballybraid (Wicklow)', zip: '424249' },
	{ city: 'Ballybran (Clare)', zip: '818266' },
	{ city: 'Ballybranagan (Cork)', zip: '903080' },
	{ city: 'Ballybranagan (Galway)', zip: '894587' },
	{ city: 'Ballybranagh (Cork)', zip: '780516' },
	{ city: 'Ballybranigan (Longford)', zip: '405335' },
	{ city: 'Ballybrannagh (Kerry)', zip: '201229' },
	{ city: 'Ballybrannis (Wexford)', zip: '524385' },
	{ city: 'Ballybrassil (Cork)', zip: '326207' },
	{ city: 'Ballybrassil (Kilkenny)', zip: '196190' },
	{ city: 'Ballybray (Kilkenny)', zip: '545427' },
	{ city: 'Ballybrazil (Wexford)', zip: '859979' },
	{ city: 'Ballybreen (Clare)', zip: '792219' },
	{ city: 'Ballybreen (Wexford)', zip: '850988' },
	{ city: 'Ballybregagh (Wexford)', zip: '855176' },
	{ city: 'Ballybregin (Waterford)', zip: '887854' },
	{ city: 'Ballybrennan (Limerick)', zip: '505366' },
	{ city: 'Ballybrennan (Sligo)', zip: '905290' },
	{ city: 'Ballybrennan (Westmeath)', zip: '890430' },
	{ city: 'Ballybrennan (Wexford)', zip: '401819' },
	{ city: 'Ballybrennan Big (Wexford)', zip: '984292' },
	{ city: 'Ballybrennan Little (Wexford)', zip: '199842' },
	{ city: 'Ballybrennock (Waterford)', zip: '610562' },
	{ city: 'Ballybrew (Wicklow)', zip: '157640' },
	{ city: 'Ballybrian (Galway)', zip: '155722' },
	{ city: 'Ballybricken (Cork)', zip: '165433' },
	{ city: 'Ballybricken East (Limerick)', zip: '331477' },
	{ city: 'Ballybricken North (Limerick)', zip: '329576' },
	{ city: 'Ballybricken South (Limerick)', zip: '562036' },
	{ city: 'Ballybricken West (Limerick)', zip: '714669' },
	{ city: 'Ballybrickoge (Westmeath)', zip: '116640' },
	{ city: 'Ballybride (Roscommon)', zip: '369753' },
	{ city: 'Ballybride Lower (Cork)', zip: '976726' },
	{ city: 'Ballybride Upper (Cork)', zip: '562084' },
	{ city: 'Ballybrien (Limerick)', zip: '378670' },
	{ city: 'Ballybrien (Longford)', zip: '936598' },
	{ city: 'Ballybrien (Tipperary)', zip: '231093' },
	{ city: 'Ballybrinoge (Mayo)', zip: '222437' },
	{ city: 'Ballybristy (Tipperary)', zip: '239128' },
	{ city: 'Ballybritt (Offaly)', zip: '884907' },
	{ city: 'Ballybrittan (Offaly)', zip: '141015' },
	{ city: 'Ballybrittas (Laois)', zip: '546364' },
	{ city: 'Ballybrittas (Wexford)', zip: '942607' },
	{ city: 'Ballybro (Wexford)', zip: '805729' },
	{ city: 'Ballybroder (Galway)', zip: '513826' },
	{ city: 'Ballybroder (Westmeath)', zip: '493117' },
	{ city: 'Ballybrody (Clare)', zip: '806983' },
	{ city: 'Ballybrogan (Roscommon)', zip: '893894' },
	{ city: 'Ballybroghan (Clare)', zip: '624932' },
	{ city: 'Ballybroghan (Roscommon)', zip: '127419' },
	{ city: 'Ballybrollaghan (Donegal)', zip: '827377' },
	{ city: 'Ballybroman (Kerry)', zip: '972091' },
	{ city: 'Ballybrommell (Carlow)', zip: '661363' },
	{ city: 'Ballybrone (Galway)', zip: '904463' },
	{ city: 'Ballybronoge (Tipperary)', zip: '441799' },
	{ city: 'Ballybronoge North (Limerick)', zip: '539124' },
	{ city: 'Ballybronoge South (Limerick)', zip: '722321' },
	{ city: 'Ballybrood (Limerick)', zip: '106747' },
	{ city: 'Ballybroony (Mayo)', zip: '889207' },
	{ city: 'Ballybrophy (Laois)', zip: '238169' },
	{ city: 'Ballybroughan (Clare)', zip: '859606' },
	{ city: 'Ballybrown (Limerick)', zip: '799033' },
	{ city: 'Ballybrown (Westmeath)', zip: '709749' },
	{ city: 'Ballybrowney Lower (Cork)', zip: '201498' },
	{ city: 'Ballybrowney-Mountain (Cork)', zip: '757798' },
	{ city: 'Ballybrowney Upper (Cork)', zip: '622082' },
	{ city: 'Ballybruncullin (Offaly)', zip: '154663' },
	{ city: 'Ballybrunoge (Tipperary)', zip: '625127' },
	{ city: 'Ballybrusa (Waterford)', zip: '631527' },
	{ city: 'Ballybrusa East (Waterford)', zip: '626456' },
	{ city: 'Ballybrusa West (Waterford)', zip: '112239' },
	{ city: 'Ballybryan (Offaly)', zip: '560259' },
	{ city: 'Ballybuckley (Wexford)', zip: '949496' },
	{ city: 'Ballybuck North (Galway)', zip: '247565' },
	{ city: 'Ballybuck South (Galway)', zip: '388891' },
	{ city: 'Ballybuggy (Laois)', zip: '257670' },
	{ city: 'Ballybulgan (Donegal)', zip: '165035' },
	{ city: 'Ballybun (Donegal)', zip: '600560' },
	{ city: 'Ballybuninabber (Donegal)', zip: '445511' },
	{ city: 'Ballybunnion (Kerry)', zip: '346395' },
	{ city: 'Ballybur (Kilkenny)', zip: '118691' },
	{ city: 'Ballyburden Beg (Cork)', zip: '891743' },
	{ city: 'Ballyburden More (Cork)', zip: '688749' },
	{ city: 'Ballyburke (Galway)', zip: '826122' },
	{ city: 'Ballybur Lower (Kilkenny)', zip: '566276' },
	{ city: 'Ballyburly (Offaly)', zip: '584371' },
	{ city: 'Ballyburn Lower (Kildare)', zip: '252971' },
	{ city: 'Ballyburn Upper (Kildare)', zip: '258882' },
	{ city: 'Ballybur Upper (Kilkenny)', zip: '497653' },
	{ city: 'Ballybush (Kilkenny)', zip: '975134' },
	{ city: 'Ballybutler (Cork)', zip: '727655' },
	{ city: 'Ballycabus (Kilkenny)', zip: '544281' },
	{ city: 'Ballycadden Lower (Wexford)', zip: '912494' },
	{ city: 'Ballycadden Upper (Wexford)', zip: '510544' },
	{ city: 'Ballycaghan (Kildare)', zip: '566609' },
	{ city: 'Ballycahalan (Galway)', zip: '336659' },
	{ city: 'Ballycahan (Clare)', zip: '392427' },
	{ city: 'Ballycahan (Westmeath)', zip: '749364' },
	{ city: 'Ballycahane (Cork)', zip: '430411' },
	{ city: 'Ballycahane (Limerick)', zip: '647427' },
	{ city: 'Ballycahane (Tipperary)', zip: '830249' },
	{ city: 'Ballycahane (Waterford)', zip: '924871' },
	{ city: 'Ballycahane Lower (Limerick)', zip: '557509' },
	{ city: 'Ballycahane Middle (Limerick)', zip: '165057' },
	{ city: 'Ballycahane Upper (Limerick)', zip: '193665' },
	{ city: 'Ballycahill (Clare)', zip: '872596' },
	{ city: 'Ballycahill (Galway)', zip: '440517' },
	{ city: 'Ballycahill (Limerick)', zip: '849245' },
	{ city: 'Ballycahill (Tipperary)', zip: '137541' },
	{ city: 'Ballycahillroe (Westmeath)', zip: '146983' },
	{ city: 'Ballycallaghan (Offaly)', zip: '654926' },
	{ city: 'Ballycallan (Donegal)', zip: '489644' },
	{ city: 'Ballycallan (Kilkenny)', zip: '926935' },
	{ city: 'Ballycalleen (Leitrim)', zip: '682426' },
	{ city: 'Ballycally (Clare)', zip: '438280' },
	{ city: 'Ballycally (Mayo)', zip: '895726' },
	{ city: 'Ballycampion (Limerick)', zip: '384199' },
	{ city: 'Ballycamusk (Tipperary)', zip: '703269' },
	{ city: 'Ballycanauna (Limerick)', zip: '170681' },
	{ city: 'Ballycanew (Wexford)', zip: '846485' },
	{ city: 'Ballycannan (Clare)', zip: '405356' },
	{ city: 'Ballycannan East (Clare)', zip: '823285' },
	{ city: 'Ballycannan North (Clare)', zip: '507768' },
	{ city: 'Ballycannan West (Clare)', zip: '467157' },
	{ city: 'Ballycanneen (Kerry)', zip: '170807' },
	{ city: 'Ballycannon (Cork)', zip: '557887' },
	{ city: 'Ballycannon (Kilkenny)', zip: '620452' },
	{ city: 'Ballycannon (Limerick)', zip: '925982' },
	{ city: 'Ballycanon (Kildare)', zip: '984760' },
	{ city: 'Ballycanvan Big (Waterford)', zip: '712944' },
	{ city: 'Ballycanvan Little (Waterford)', zip: '276715' },
	{ city: 'Ballycapple (Tipperary)', zip: '215851' },
	{ city: 'Ballycapple (Wicklow)', zip: '249927' },
	{ city: 'Ballycapple Hill (Wicklow)', zip: '562571' },
	{ city: 'Ballycapplewood (Tipperary)', zip: '168327' },
	{ city: 'Ballycappoge (Wexford)', zip: '854448' },
	{ city: 'Ballycar (Clare)', zip: '732107' },
	{ city: 'Ballycarbery East (Kerry)', zip: '993788' },
	{ city: 'Ballycarbery South (Kerry)', zip: '435686' },
	{ city: 'Ballycarbery West (Kerry)', zip: '248648' },
	{ city: 'Ballycardeen (Cork)', zip: '525490' },
	{ city: 'Ballycarn (Meath)', zip: '197245' },
	{ city: 'Ballycarn (Tipperary)', zip: '606587' },
	{ city: 'Ballycarnahan (Kerry)', zip: '228543' },
	{ city: 'Ballycarnan (Laois)', zip: '638152' },
	{ city: 'Ballycarnane (Cork)', zip: '539301' },
	{ city: 'Ballycarnane (Waterford)', zip: '593179' },
	{ city: 'Ballycarney (Carlow)', zip: '163047' },
	{ city: 'Ballycarney (Limerick)', zip: '798248' },
	{ city: 'Ballycarney (Wexford)', zip: '713456' },
	{ city: 'Ballycar North (Clare)', zip: '551209' },
	{ city: 'Ballycarra (Mayo)', zip: '629679' },
	{ city: 'Ballycarran (Kilkenny)', zip: '351982' },
	{ city: 'Ballycarran (Wexford)', zip: '999770' },
	{ city: 'Ballycarrane (Limerick)', zip: '832666' },
	{ city: 'Ballycarrane (Tipperary)', zip: '848006' },
	{ city: 'Ballycarran Little (Kilkenny)', zip: '882887' },
	{ city: 'Ballycarridoge (Tipperary)', zip: '939014' },
	{ city: 'Ballycarrigeen (Wicklow)', zip: '597619' },
	{ city: 'Ballycarrigeen Lower (Wexford)', zip: '247133' },
	{ city: 'Ballycarrigeen Upper (Wexford)', zip: '128414' },
	{ city: 'Ballycarroll (Clare)', zip: '170986' },
	{ city: 'Ballycarroll (Laois)', zip: '909266' },
	{ city: 'Ballycarron (Tipperary)', zip: '558257' },
	{ city: 'Ballycarroon (Mayo)', zip: '367674' },
	{ city: 'Ballycar South (Clare)', zip: '667568' },
	{ city: 'Ballycartlan (Monaghan)', zip: '783945' },
	{ city: 'Ballycarty (Kerry)', zip: '430252' },
	{ city: 'Ballycasey (Galway)', zip: '372228' },
	{ city: 'Ballycasey (Limerick)', zip: '585075' },
	{ city: 'Ballycasey (Tipperary)', zip: '182029' },
	{ city: 'Ballycasey Beg (Clare)', zip: '358420' },
	{ city: 'Ballycasey More (Clare)', zip: '329392' },
	{ city: 'Ballycasheen (Clare)', zip: '240587' },
	{ city: 'Ballycasheen (Kerry)', zip: '798253' },
	{ city: 'Ballycashin (Waterford)', zip: '441988' },
	{ city: 'Ballycaskin (Cork)', zip: '680844' },
	{ city: 'Ballycastle (Mayo)', zip: '196049' },
	{ city: 'Ballycatoo (Cork)', zip: '835010' },
	{ city: 'Ballycatteen (Cork)', zip: '838858' },
	{ city: 'Ballycharry (Donegal)', zip: '527864' },
	{ city: 'Ballychristal (Offaly)', zip: '318933' },
	{ city: 'Ballyclamasy (Cork)', zip: '365978' },
	{ city: 'Ballyclamay (Longford)', zip: '681310' },
	{ city: 'Ballyclancahill (Clare)', zip: '194433' },
	{ city: 'Ballyclare (Longford)', zip: '339199' },
	{ city: 'Ballyclare (Meath)', zip: '119010' },
	{ city: 'Ballyclare (Offaly)', zip: '984060' },
	{ city: 'Ballyclare (Roscommon)', zip: '137224' },
	{ city: 'Ballycleary (Laois)', zip: '418454' },
	{ city: 'Ballycleary (Wexford)', zip: '813297' },
	{ city: 'Ballyclement (Waterford)', zip: '353518' },
	{ city: 'Ballyclemock (Wexford)', zip: '502578' },
	{ city: 'Ballyclerahan (Tipperary)', zip: '250582' },
	{ city: 'Ballyclery (Galway)', zip: '490064' },
	{ city: 'Ballyclery (Offaly)', zip: '773028' },
	{ city: 'Ballyclider (Laois)', zip: '509947' },
	{ city: 'Ballyclogh (Cork)', zip: '694656' },
	{ city: 'Ballyclogh (Limerick)', zip: '220664' },
	{ city: 'Ballyclogh (Wexford)', zip: '800661' },
	{ city: 'Ballycloghan (Longford)', zip: '449286' },
	{ city: 'Ballycloghduff (Westmeath)', zip: '357688' },
	{ city: 'Ballyclogher (Mayo)', zip: '883796' },
	{ city: 'Ballyclogher (Westmeath)', zip: '774759' },
	{ city: 'Ballycloghessy (Clare)', zip: '862837' },
	{ city: 'Ballyclogh Lower (Limerick)', zip: '731678' },
	{ city: 'Ballyclogh North (Wicklow)', zip: '808662' },
	{ city: 'Ballyclogh South (Wicklow)', zip: '351207' },
	{ city: 'Ballyclogh Upper (Limerick)', zip: '108017' },
	{ city: 'Ballyclohy (Waterford)', zip: '460289' },
	{ city: 'Ballyclovan (Kilkenny)', zip: '683645' },
	{ city: 'Ballyclovan Meadows (Kilkenny)', zip: '926358' },
	{ city: 'Ballycluvane (Limerick)', zip: '184178' },
	{ city: 'Ballycoam (Kilkenny)', zip: '665204' },
	{ city: 'Ballycocksoost (Kilkenny)', zip: '623904' },
	{ city: 'Ballycoe (Waterford)', zip: '826545' },
	{ city: 'Ballycoghlan (Cork)', zip: '498341' },
	{ city: 'Ballycogly (Wexford)', zip: '273317' },
	{ city: 'Ballycohy (Tipperary)', zip: '395832' },
	{ city: 'Ballycolgan (Galway)', zip: '103471' },
	{ city: 'Ballycolgan (Offaly)', zip: '394388' },
	{ city: 'Ballycolla (Laois)', zip: '549343' },
	{ city: 'Ballycolla Heath (Laois)', zip: '496319' },
	{ city: 'Ballycollin (Offaly)', zip: '129065' },
	{ city: 'Ballycollin Lower (Offaly)', zip: '980101' },
	{ city: 'Ballycollin Upper (Offaly)', zip: '166650' },
	{ city: 'Ballycolliton (Tipperary)', zip: '136621' },
	{ city: 'Ballycolman (Cork)', zip: '555876' },
	{ city: 'Ballycomclone (Wexford)', zip: '819771' },
	{ city: 'Ballycomisk (Tipperary)', zip: '837176' },
	{ city: 'Ballycommane (Cork)', zip: '168243' },
	{ city: 'Ballycommon (Kildare)', zip: '700505' },
	{ city: 'Ballycommon (Kilkenny)', zip: '464440' },
	{ city: 'Ballycommon (Offaly)', zip: '879409' },
	{ city: 'Ballycommon (Tipperary)', zip: '632013' },
	{ city: 'Ballycomoyle (Westmeath)', zip: '998756' },
	{ city: 'Ballycomy (Kilkenny)', zip: '171365' },
	{ city: 'Ballycon (Offaly)', zip: '931483' },
	{ city: 'Ballyconboy (Roscommon)', zip: '493996' },
	{ city: 'Ballycondon (Waterford)', zip: '196012' },
	{ city: 'Ballycondon Commons (Waterford)', zip: '654906' },
	{ city: 'Ballycong (Mayo)', zip: '742115' },
	{ city: 'Ballyconlore (Wexford)', zip: '312550' },
	{ city: 'Ballyconlought (Galway)', zip: '850421' },
	{ city: 'Ballyconnaught (Kilkenny)', zip: '255729' },
	{ city: 'Ballyconneely (Clare)', zip: '701806' },
	{ city: 'Ballyconneely (Galway)', zip: '830015' },
	{ city: 'Ballyconnell (Cavan)', zip: '668289' },
	{ city: 'Ballyconnell (Donegal)', zip: '551931' },
	{ city: 'Ballyconnell (Galway)', zip: '439979' },
	{ city: 'Ballyconnell (Kerry)', zip: '302351' },
	{ city: 'Ballyconnell (Sligo)', zip: '548640' },
	{ city: 'Ballyconnell (Wicklow)', zip: '503607' },
	{ city: 'Ballyconnelly (Donegal)', zip: '911150' },
	{ city: 'Ballyconnery Lower (Waterford)', zip: '218283' },
	{ city: 'Ballyconnery Upper (Waterford)', zip: '413460' },
	{ city: 'Ballyconnick (Wexford)', zip: '473950' },
	{ city: 'Ballyconnigar Lower (Wexford)', zip: '118173' },
	{ city: 'Ballyconnigar Upper (Wexford)', zip: '802641' },
	{ city: 'Ballyconnoe North (Clare)', zip: '180584' },
	{ city: 'Ballyconnoe South (Clare)', zip: '680307' },
	{ city: 'Ballyconnor (Tipperary)', zip: '175205' },
	{ city: 'Ballyconor Big (Wexford)', zip: '688704' },
	{ city: 'Ballyconor Little (Wexford)', zip: '602877' },
	{ city: 'Ballyconra (Kilkenny)', zip: '686242' },
	{ city: 'Ballyconran (Wexford)', zip: '480723' },
	{ city: 'Ballyconry (Clare)', zip: '338239' },
	{ city: 'Ballyconry (Kerry)', zip: '954062' },
	{ city: 'Ballyconry (Tipperary)', zip: '586422' },
	{ city: 'Ballyconway (Kilkenny)', zip: '415425' },
	{ city: 'Ballyconway (Limerick)', zip: '888824' },
	{ city: 'Ballycoog (Wicklow)', zip: '847892' },
	{ city: 'Ballycoog Lower (Wicklow)', zip: '312652' },
	{ city: 'Ballycoog Upper (Wicklow)', zip: '503472' },
	{ city: 'Ballycook (Carlow)', zip: '777536' },
	{ city: 'Ballycoolan (Laois)', zip: '178437' },
	{ city: 'Ballycooleen (Wicklow)', zip: '285391' },
	{ city: 'Ballycoolen (Dublin)', zip: '455843' },
	{ city: 'Ballycoolid (Laois)', zip: '168789' },
	{ city: 'Ballycoony (Galway)', zip: '398746' },
	{ city: 'Ballycoppigan (Carlow)', zip: '274126' },
	{ city: 'Ballycor (Westmeath)', zip: '894700' },
	{ city: 'Ballycorban (Clare)', zip: '792722' },
	{ city: 'Ballycorban (Galway)', zip: '792045' },
	{ city: 'Ballycorboys Big (Wexford)', zip: '967315' },
	{ city: 'Ballycorboys Little (Wexford)', zip: '851502' },
	{ city: 'Ballycore (Longford)', zip: '506002' },
	{ city: 'Ballycore (Offaly)', zip: '202243' },
	{ city: 'Ballycore (Wicklow)', zip: '651125' },
	{ city: 'Ballycorey (Clare)', zip: '732287' },
	{ city: 'Ballycorick (Clare)', zip: '809543' },
	{ city: 'Ballycorkey (Westmeath)', zip: '183401' },
	{ city: 'Ballycorman (Laois)', zip: '236768' },
	{ city: 'Ballycormick (Carlow)', zip: '426677' },
	{ city: 'Ballycormick (Laois)', zip: '166454' },
	{ city: 'Ballycormick (Limerick)', zip: '443797' },
	{ city: 'Ballycormick (Offaly)', zip: '954071' },
	{ city: 'Ballycormuck (Tipperary)', zip: '848658' },
	{ city: 'Ballycornane (Tipperary)', zip: '267700' },
	{ city: 'Ballycorney (Clare)', zip: '170006' },
	{ city: 'Ballycorrigan (Tipperary)', zip: '263117' },
	{ city: 'Ballycorus (Dublin)', zip: '184644' },
	{ city: 'Ballycoshown (Limerick)', zip: '932857' },
	{ city: 'Ballycoskery (Cork)', zip: '784153' },
	{ city: 'Ballycosney (Offaly)', zip: '928564' },
	{ city: 'Ballycotteen North (Clare)', zip: '755439' },
	{ city: 'Ballycotteen South (Clare)', zip: '754935' },
	{ city: 'Ballycotton (Cork)', zip: '351797' },
	{ city: 'Ballycourcy Beg (Wexford)', zip: '928803' },
	{ city: 'Ballycourcy More (Wexford)', zip: '944064' },
	{ city: 'Ballycowan (Kildare)', zip: '322644' },
	{ city: 'Ballycowan (Offaly)', zip: '672853' },
	{ city: 'Ballycowan (Wexford)', zip: '576748' },
	{ city: 'Ballycoyle (Wicklow)', zip: '316866' },
	{ city: 'Ballycraddock (Waterford)', zip: '118017' },
	{ city: 'Ballycraggan (Tipperary)', zip: '147306' },
	{ city: 'Ballycragh (Dublin)', zip: '816042' },
	{ city: 'Ballycraheen (Cork)', zip: '505073' },
	{ city: 'Ballycramsy (Donegal)', zip: '140808' },
	{ city: 'Ballycrana (Tipperary)', zip: '935169' },
	{ city: 'Ballycrane (Wexford)', zip: '346318' },
	{ city: 'Ballycreen Lower (Wicklow)', zip: '781450' },
	{ city: 'Ballycreen Upper (Wicklow)', zip: '267478' },
	{ city: 'Ballycreggan (Roscommon)', zip: '956435' },
	{ city: 'Ballycrehane (Tipperary)', zip: '938013' },
	{ city: 'Ballycrenane (Cork)', zip: '630187' },
	{ city: 'Ballycrenane Beg (Cork)', zip: '718013' },
	{ city: 'Ballycrenode (Tipperary)', zip: '565451' },
	{ city: 'Ballycrighan (Clare)', zip: '731322' },
	{ city: 'Ballycrine (Tipperary)', zip: '920405' },
	{ city: 'Ballycrinnigan (Carlow)', zip: '827785' },
	{ city: 'Ballycrispin (Kerry)', zip: '476100' },
	{ city: 'Ballycrogue (Carlow)', zip: '583466' },
	{ city: 'Ballycrompane (Waterford)', zip: '338217' },
	{ city: 'Ballycrone (Wicklow)', zip: '590773' },
	{ city: 'Ballycroneen East (Cork)', zip: '878690' },
	{ city: 'Ballycroneen West (Cork)', zip: '584045' },
	{ city: 'Ballycronigan (Wexford)', zip: '485349' },
	{ city: 'Ballycronog (Monaghan)', zip: '556827' },
	{ city: 'Ballycrony (Kilkenny)', zip: '878029' },
	{ city: 'Ballycross (Wexford)', zip: '879945' },
	{ city: 'Ballycrossal (Laois)', zip: '823949' },
	{ city: 'Ballycrossaun (Galway)', zip: '760992' },
	{ city: 'Ballycroum (Clare)', zip: '411207' },
	{ city: 'Ballycrovane (Cork)', zip: '774698' },
	{ city: 'Ballycroy (Donegal)', zip: '207859' },
	{ city: 'Ballycroy (Mayo)', zip: '122686' },
	{ city: 'Ballycrumlin (Offaly)', zip: '676814' },
	{ city: 'Ballycrystal (Wexford)', zip: '718971' },
	{ city: 'Ballycuddahy (Laois)', zip: '999013' },
	{ city: 'Ballycuddihy (Kilkenny)', zip: '487910' },
	{ city: 'Ballycuddy (Galway)', zip: '244598' },
	{ city: 'Ballycuddy Beg (Tipperary)', zip: '133003' },
	{ city: 'Ballycuddy More (Tipperary)', zip: '602016' },
	{ city: 'Ballycue (Offaly)', zip: '232531' },
	{ city: 'Ballycuggaran (Clare)', zip: '910128' },
	{ city: 'Ballycuirke East (Galway)', zip: '453901' },
	{ city: 'Ballycuirke West (Galway)', zip: '738608' },
	{ city: 'Ballyculhane (Limerick)', zip: '385719' },
	{ city: 'Ballycullane (Cork)', zip: '880416' },
	{ city: 'Ballycullane (Kerry)', zip: '302414' },
	{ city: 'Ballycullane (Kildare)', zip: '619338' },
	{ city: 'Ballycullane (Limerick)', zip: '503975' },
	{ city: 'Ballycullane (Waterford)', zip: '712789' },
	{ city: 'Ballycullane (Wexford)', zip: '413429' },
	{ city: 'Ballycullane Beg (Waterford)', zip: '827867' },
	{ city: 'Ballycullane Lower (Kildare)', zip: '183480' },
	{ city: 'Ballycullane Lower (Limerick)', zip: '302716' },
	{ city: 'Ballycullane More (Waterford)', zip: '348130' },
	{ city: 'Ballycullane Upper (Kildare)', zip: '124452' },
	{ city: 'Ballycullane Upper (Limerick)', zip: '722038' },
	{ city: 'Ballycullaun (Clare)', zip: '637430' },
	{ city: 'Ballyculleen (Limerick)', zip: '366808' },
	{ city: 'Ballyculleen (Roscommon)', zip: '867503' },
	{ city: 'Ballyculleen (Sligo)', zip: '434852' },
	{ city: 'Ballyculleeny (Clare)', zip: '478555' },
	{ city: 'Ballycullen (Clare)', zip: '263352' },
	{ city: 'Ballycullen (Dublin)', zip: '848783' },
	{ city: 'Ballycullen (Limerick)', zip: '241699' },
	{ city: 'Ballycullen (Wicklow)', zip: '962792' },
	{ city: 'Ballycullenane (Cork)', zip: '492666' },
	{ city: 'Ballycullenbeg (Laois)', zip: '439457' },
	{ city: 'Ballycullin (Tipperary)', zip: '404456' },
	{ city: 'Ballycullinan (Clare)', zip: '751852' },
	{ city: 'Ballyculloo (Galway)', zip: '840766' },
	{ city: 'Ballycumber (Offaly)', zip: '368047' },
	{ city: 'Ballycumber North (Wicklow)', zip: '948549' },
	{ city: 'Ballycumber South (Wicklow)', zip: '231353' },
	{ city: 'Ballycummin (Limerick)', zip: '277282' },
	{ city: 'Ballycummin (Roscommon)', zip: '634270' },
	{ city: 'Ballycummin (Sligo)', zip: '457693' },
	{ city: 'Ballycummisk (Cork)', zip: '174544' },
	{ city: 'Ballycunneen (Clare)', zip: '371849' },
	{ city: 'Ballycunningham (Cork)', zip: '195560' },
	{ city: 'Ballycurkeen (Tipperary)', zip: '346470' },
	{ city: 'Ballycurragh (Carlow)', zip: '888925' },
	{ city: 'Ballycurragh (Offaly)', zip: '511082' },
	{ city: 'Ballycurragh (Wicklow)', zip: '872184' },
	{ city: 'Ballycurraghan (Kildare)', zip: '312491' },
	{ city: 'Ballycurraginny (Cork)', zip: '255087' },
	{ city: 'Ballycurrane (Kerry)', zip: '468177' },
	{ city: 'Ballycurrane (Tipperary)', zip: '430613' },
	{ city: 'Ballycurrane (Waterford)', zip: '653554' },
	{ city: 'Ballycurrane North (Waterford)', zip: '911803' },
	{ city: 'Ballycurrane South (Waterford)', zip: '552120' },
	{ city: 'Ballycurrany East (Cork)', zip: '998381' },
	{ city: 'Ballycurrany West (Cork)', zip: '213818' },
	{ city: 'Ballycurraun (Clare)', zip: '346619' },
	{ city: 'Ballycurreen (Cork)', zip: '870205' },
	{ city: 'Ballycurreen North (Waterford)', zip: '298992' },
	{ city: 'Ballycurreen South (Waterford)', zip: '784116' },
	{ city: 'Ballycurrin (Kilkenny)', zip: '323932' },
	{ city: 'Ballycurrin Demesne (Mayo)', zip: '111314' },
	{ city: 'Ballycurry Demesne (Wicklow)', zip: '464680' },
	{ city: 'Ballycusheen (Mayo)', zip: '548334' },
	{ city: 'Ballycushen (Cork)', zip: '204374' },
	{ city: 'Ballycushion (Donegal)', zip: '946332' },
	{ city: 'Ballycushlane Big (Wexford)', zip: '759168' },
	{ city: 'Ballycushlane Little (Wexford)', zip: '338319' },
	{ city: 'Ballyda (Cork)', zip: '213131' },
	{ city: 'Ballyda (Kilkenny)', zip: '181685' },
	{ city: 'Ballydaff (Tipperary)', zip: '229862' },
	{ city: 'Ballydague (Cork)', zip: '803701' },
	{ city: 'Ballydaheen (Cork)', zip: '355985' },
	{ city: 'Ballydaheen (Limerick)', zip: '616577' },
	{ city: 'Ballydahin (Cork)', zip: '246464' },
	{ city: 'Ballydallagh (Kildare)', zip: '316672' },
	{ city: 'Ballydaly (Cork)', zip: '830348' },
	{ city: 'Ballydaly (Galway)', zip: '971217' },
	{ city: 'Ballydaly (Limerick)', zip: '540855' },
	{ city: 'Ballydaly (Offaly)', zip: '592173' },
	{ city: 'Ballydaly (Roscommon)', zip: '851807' },
	{ city: 'Ballydane (Wexford)', zip: '821607' },
	{ city: 'Ballydangan (Roscommon)', zip: '750601' },
	{ city: 'Ballydaniel (Cork)', zip: '636483' },
	{ city: 'Ballydaniel (Kilkenny)', zip: '289173' },
	{ city: 'Ballydaniel (Wexford)', zip: '878530' },
	{ city: 'Ballydaniel Beg (Cork)', zip: '230763' },
	{ city: 'Ballydaniel More (Cork)', zip: '321565' },
	{ city: 'Ballydarragh (Wexford)', zip: '877280' },
	{ city: 'Ballydarrig (Kerry)', zip: '488425' },
	{ city: 'Ballydarton (Carlow)', zip: '861345' },
	{ city: 'Ballydasoon (Waterford)', zip: '762785' },
	{ city: 'Ballydavid (Cork)', zip: '284466' },
	{ city: 'Ballydavid (Galway)', zip: '875990' },
	{ city: 'Ballydavid (Kerry)', zip: '259210' },
	{ city: 'Ballydavid (Tipperary)', zip: '953125' },
	{ city: 'Ballydavid (Waterford)', zip: '222885' },
	{ city: 'Ballydavid (Westmeath)', zip: '180317' },
	{ city: 'Ballydavid Middle (Galway)', zip: '208886' },
	{ city: 'Ballydavid North (Galway)', zip: '641651' },
	{ city: 'Ballydavid South (Galway)', zip: '714267' },
	{ city: 'Ballydavin (Laois)', zip: '131419' },
	{ city: 'Ballydavis (Laois)', zip: '700201' },
	{ city: 'Ballydavock (Mayo)', zip: '675955' },
	{ city: 'Ballydaw (Cork)', zip: '326535' },
	{ city: 'Ballydaw (Kilkenny)', zip: '794829' },
	{ city: 'Ballydaw (Wexford)', zip: '866352' },
	{ city: 'Ballydawley (Sligo)', zip: '151202' },
	{ city: 'Ballydawmore (Wexford)', zip: '632018' },
	{ city: 'Ballyday (Wexford)', zip: '605485' },
	{ city: 'Ballydeely (Clare)', zip: '713155' },
	{ city: 'Ballydeenlea (Kerry)', zip: '697666' },
	{ city: 'Ballydehob (Cork)', zip: '323617' },
	{ city: 'Ballydeloughy (Cork)', zip: '329579' },
	{ city: 'Ballyderg (Mayo)', zip: '316646' },
	{ city: 'Ballydermody (Waterford)', zip: '148977' },
	{ city: 'Ballydermodybog (Waterford)', zip: '730279' },
	{ city: 'Ballydermot (Donegal)', zip: '784280' },
	{ city: 'Ballydermot (Offaly)', zip: '963038' },
	{ city: 'Ballydermot (Wexford)', zip: '166292' },
	{ city: 'Ballyderown (Cork)', zip: '297387' },
	{ city: 'Ballydesmond (Cork)', zip: '641351' },
	{ city: 'Ballydevitt (Donegal)', zip: '944551' },
	{ city: 'Ballydevitt Beg (Donegal)', zip: '780701' },
	{ city: 'Ballydicken Lower (Wexford)', zip: '734094' },
	{ city: 'Ballydicken Upper (Wexford)', zip: '186463' },
	{ city: 'Ballydine (Tipperary)', zip: '776157' },
	{ city: 'Ballydineen (Cork)', zip: '736871' },
	{ city: 'Ballydivlin (Cork)', zip: '689572' },
	{ city: 'Ballydonagh (Galway)', zip: '543302' },
	{ city: 'Ballydonagh (Offaly)', zip: '961860' },
	{ city: 'Ballydonagh (Tipperary)', zip: '122024' },
	{ city: 'Ballydonagh (Waterford)', zip: '269578' },
	{ city: 'Ballydonagh (Westmeath)', zip: '118748' },
	{ city: 'Ballydonagh (Wicklow)', zip: '894965' },
	{ city: 'Ballydonaghan (Clare)', zip: '962680' },
	{ city: 'Ballydonagh Beg (Cork)', zip: '634942' },
	{ city: 'Ballydonagh More (Cork)', zip: '260695' },
	{ city: 'Ballydonaghy (Cork)', zip: '689183' },
	{ city: 'Ballydonarea (Wicklow)', zip: '691189' },
	{ city: 'Ballydonegan (Cork)', zip: '526784' },
	{ city: 'Ballydonfin (Wexford)', zip: '789059' },
	{ city: 'Ballydonigan (Wexford)', zip: '796139' },
	{ city: 'Ballydonnell (Kilkenny)', zip: '631066' },
	{ city: 'Ballydonnell (Limerick)', zip: '766721' },
	{ city: 'Ballydonnell (Louth)', zip: '223975' },
	{ city: 'Ballydonnell (Meath)', zip: '672103' },
	{ city: 'Ballydonnell (Tipperary)', zip: '224995' },
	{ city: 'Ballydonnell (Wicklow)', zip: '378886' },
	{ city: 'Ballydonnellan (Galway)', zip: '347695' },
	{ city: 'Ballydonnellan (Mayo)', zip: '313834' },
	{ city: 'Ballydonnellan East (Galway)', zip: '901561' },
	{ city: 'Ballydonnellan West (Galway)', zip: '433235' },
	{ city: 'Ballydonnell North (Wicklow)', zip: '775595' },
	{ city: 'Ballydonnell South (Wicklow)', zip: '946825' },
	{ city: 'Ballydonohoe (Clare)', zip: '644528' },
	{ city: 'Ballydonohoe (Kerry)', zip: '542140' },
	{ city: 'Ballydonohoe (Limerick)', zip: '668686' },
	{ city: 'Ballydoogan (Galway)', zip: '487193' },
	{ city: 'Ballydoogan (Sligo)', zip: '630043' },
	{ city: 'Ballydoogan (Westmeath)', zip: '852700' },
	{ city: 'Ballydoole (Limerick)', zip: '688311' },
	{ city: 'Ballydooley (Roscommon)', zip: '108775' },
	{ city: 'Ballydoolough (Galway)', zip: '479942' },
	{ city: 'Ballydooneen (Kerry)', zip: '669115' },
	{ city: 'Ballydoora (Clare)', zip: '650144' },
	{ city: 'Ballydoorlis (Limerick)', zip: '911107' },
	{ city: 'Ballydoorty (Limerick)', zip: '573863' },
	{ city: 'Ballydoreen (Wicklow)', zip: '609584' },
	{ city: 'Ballydorey (Westmeath)', zip: '791002' },
	{ city: 'Ballydorgan (Cork)', zip: '960031' },
	{ city: 'Ballydotia (Galway)', zip: '721776' },
	{ city: 'Ballydotia East (Galway)', zip: '556798' },
	{ city: 'Ballydotia West (Galway)', zip: '624545' },
	{ city: 'Ballydowan (Kilkenny)', zip: '137959' },
	{ city: 'Ballydowane East (Waterford)', zip: '579490' },
	{ city: 'Ballydowane West (Waterford)', zip: '527667' },
	{ city: 'Ballydowd (Dublin)', zip: '683513' },
	{ city: 'Ballydowel Big (Kilkenny)', zip: '618977' },
	{ city: 'Ballydowel Little (Kilkenny)', zip: '696500' },
	{ city: 'Ballydowling (Wicklow)', zip: '153976' },
	{ city: 'Ballydowling Hill (Wicklow)', zip: '287055' },
	{ city: 'Ballydownan (Offaly)', zip: '393050' },
	{ city: 'Ballydownis (Cork)', zip: '397488' },
	{ city: 'Ballydownis East (Cork)', zip: '539066' },
	{ city: 'Ballydownis West (Cork)', zip: '373958' },
	{ city: 'Ballydowny (Kerry)', zip: '386656' },
	{ city: 'Ballydoyle (Cork)', zip: '266206' },
	{ city: 'Ballydoyle (Tipperary)', zip: '309331' },
	{ city: 'Ballydoyle (Wexford)', zip: '787954' },
	{ city: 'Ballydrane (Wexford)', zip: '461106' },
	{ city: 'Ballydrehid (Tipperary)', zip: '702803' },
	{ city: 'Ballydribbeen (Kerry)', zip: '655372' },
	{ city: 'Ballydrinan (Tipperary)', zip: '764514' },
	{ city: 'Ballydrisheen (Kerry)', zip: '856699' },
	{ city: 'Ballydrislane (Waterford)', zip: '500120' },
	{ city: 'Ballydrohid (Offaly)', zip: '384994' },
	{ city: 'Ballydrum (Longford)', zip: '639255' },
	{ city: 'Ballydrum (Mayo)', zip: '386622' },
	{ city: 'Ballyduag (Tipperary)', zip: '129627' },
	{ city: 'Ballyduagh (Tipperary)', zip: '824106' },
	{ city: 'Ballyduane (Limerick)', zip: '860814' },
	{ city: 'Ballyduane East (Cork)', zip: '918522' },
	{ city: 'Ballyduane South (Cork)', zip: '712126' },
	{ city: 'Ballyduane West (Cork)', zip: '294787' },
	{ city: 'Ballyduboy (Wexford)', zip: '819733' },
	{ city: 'Ballyduff (Carlow)', zip: '910025' },
	{ city: 'Ballyduff (Clare)', zip: '594716' },
	{ city: 'Ballyduff (Cork)', zip: '252289' },
	{ city: 'Ballyduff (Kerry)', zip: '704831' },
	{ city: 'Ballyduff (Kilkenny)', zip: '142375' },
	{ city: 'Ballyduff (Laois)', zip: '946744' },
	{ city: 'Ballyduff (Limerick)', zip: '608109' },
	{ city: 'Ballyduff (Offaly)', zip: '251940' },
	{ city: 'Ballyduff (Tipperary)', zip: '934736' },
	{ city: 'Ballyduff (Waterford)', zip: '260380' },
	{ city: 'Ballyduff (Wexford)', zip: '376419' },
	{ city: 'Ballyduff (Wicklow)', zip: '681355' },
	{ city: 'Ballyduffbeg (Wexford)', zip: '679288' },
	{ city: 'Ballyduff Beg (Clare)', zip: '138770' },
	{ city: 'Ballyduff Beg (Waterford)', zip: '195041' },
	{ city: 'Ballyduff East (Waterford)', zip: '415803' },
	{ city: 'Ballyduff Lower (Waterford)', zip: '586157' },
	{ city: 'Ballyduff Lower (Wexford)', zip: '505658' },
	{ city: 'Ballyduff Lower (Wicklow)', zip: '667156' },
	{ city: 'Ballyduff More (Clare)', zip: '704579' },
	{ city: 'Ballyduff More (Waterford)', zip: '676806' },
	{ city: 'Ballyduff North (Wicklow)', zip: '913139' },
	{ city: 'Ballyduff South (Offaly)', zip: '991246' },
	{ city: 'Ballyduff South (Wicklow)', zip: '954485' },
	{ city: 'Ballyduff Upper (Waterford)', zip: '317205' },
	{ city: 'Ballyduff Upper (Wexford)', zip: '964906' },
	{ city: 'Ballyduff Upper (Wicklow)', zip: '521173' },
	{ city: 'Ballyduff West (Waterford)', zip: '299467' },
	{ city: 'Ballyduffy (Longford)', zip: '778897' },
	{ city: 'Ballyduffy (Mayo)', zip: '805827' },
	{ city: 'Ballyduffy (Roscommon)', zip: '736275' },
	{ city: 'Ballyduggan (Tipperary)', zip: '891039' },
	{ city: 'Ballyduhig (Kerry)', zip: '212999' },
	{ city: 'Ballyduhig (Limerick)', zip: '452182' },
	{ city: 'Ballyduhig North (Cork)', zip: '753085' },
	{ city: 'Ballyduhig South (Cork)', zip: '510668' },
	{ city: 'Ballydulea (Cork)', zip: '474430' },
	{ city: 'Ballydun (Kilkenny)', zip: '901773' },
	{ city: 'Ballyduneen (Clare)', zip: '634245' },
	{ city: 'Ballydungan (Wexford)', zip: '493413' },
	{ city: 'Ballydunlea (Kerry)', zip: '536815' },
	{ city: 'Ballydurn (Waterford)', zip: '810031' },
	{ city: 'Ballydusker (Wexford)', zip: '650305' },
	{ city: 'Ballyduvane (Cork)', zip: '855416' },
	{ city: 'Ballydwyer East (Kerry)', zip: '211862' },
	{ city: 'Ballydwyer Middle (Kerry)', zip: '386422' },
	{ city: 'Ballydwyer West (Kerry)', zip: '156690' },
	{ city: 'Ballydwyre (Cork)', zip: '918126' },
	{ city: 'Ballyea (Clare)', zip: '358441' },
	{ city: 'Ballyea (Kerry)', zip: '975454' },
	{ city: 'Ballyea (Limerick)', zip: '664946' },
	{ city: 'Ballyea (Tipperary)', zip: '364395' },
	{ city: 'Ballyea East (Waterford)', zip: '456918' },
	{ city: 'Ballyeafy (Waterford)', zip: '390680' },
	{ city: 'Ballyeagh (Kerry)', zip: '440119' },
	{ city: 'Ballyealan (Offaly)', zip: '353411' },
	{ city: 'Ballyea North (Clare)', zip: '541850' },
	{ city: 'Ballyea North (Tipperary)', zip: '576763' },
	{ city: 'Ballyea South (Clare)', zip: '694213' },
	{ city: 'Ballyea South (Tipperary)', zip: '956538' },
	{ city: 'Ballyeaton (Wexford)', zip: '983740' },
	{ city: 'Ballyea West (Waterford)', zip: '297424' },
	{ city: 'Ballyeawood (Limerick)', zip: '783585' },
	{ city: 'Ballyedekin (Cork)', zip: '892220' },
	{ city: 'Ballyeden (Kilkenny)', zip: '280729' },
	{ city: 'Ballyeden (Wexford)', zip: '536829' },
	{ city: 'Ballyederlan (Donegal)', zip: '299291' },
	{ city: 'Ballyederowen (Donegal)', zip: '328416' },
	{ city: 'Ballyedmond (Carlow)', zip: '373235' },
	{ city: 'Ballyedmond (Cork)', zip: '461321' },
	{ city: 'Ballyedmond (Galway)', zip: '815520' },
	{ city: 'Ballyedmond (Laois)', zip: '566553' },
	{ city: 'Ballyedmond (Wexford)', zip: '161033' },
	{ city: 'Ballyedmond Little (Cork)', zip: '631415' },
	{ city: 'Ballyedmonduff (Dublin)', zip: '802069' },
	{ city: 'Ballyedock (Wexford)', zip: '173780' },
	{ city: 'Ballyedward (Westmeath)', zip: '175161' },
	{ city: 'Ballyeelinan (Waterford)', zip: '596972' },
	{ city: 'Ballyeeskeen (Sligo)', zip: '476819' },
	{ city: 'Ballyegan (Kerry)', zip: '721950' },
	{ city: 'Ballyegan (Offaly)', zip: '496154' },
	{ city: 'Ballyegny (Limerick)', zip: '527800' },
	{ city: 'Ballyegny Beg (Limerick)', zip: '944314' },
	{ city: 'Ballyegny More (Limerick)', zip: '191097' },
	{ city: 'Ballyeighter (Clare)', zip: '837912' },
	{ city: 'Ballyeighter (Galway)', zip: '791993' },
	{ city: 'Ballyeighter (Offaly)', zip: '544509' },
	{ city: 'Ballyeightragh (Cork)', zip: '507882' },
	{ city: 'Ballyeightragh (Kerry)', zip: '491285' },
	{ city: 'Ballyelan (Limerick)', zip: '644657' },
	{ city: 'Ballyeland (Wexford)', zip: '799847' },
	{ city: 'Ballyellane (Cork)', zip: '381147' },
	{ city: 'Ballyell Big (Wexford)', zip: '713740' },
	{ city: 'Ballyellery (Clare)', zip: '161500' },
	{ city: 'Ballyellin (Wexford)', zip: '650101' },
	{ city: 'Ballyellinan (Limerick)', zip: '827341' },
	{ city: 'Ballyellin And Tomdarragh (Carlow)', zip: '736066' },
	{ city: 'Ballyellin Lower (Wexford)', zip: '939761' },
	{ city: 'Ballyellin Upper (Wexford)', zip: '846829' },
	{ city: 'Ballyellis (Cork)', zip: '467399' },
	{ city: 'Ballyellis (Kilkenny)', zip: '593453' },
	{ city: 'Ballyellis (Wexford)', zip: '228861' },
	{ city: 'Ballyell Little (Wexford)', zip: '151523' },
	{ city: 'Ballyelly (Clare)', zip: '606875' },
	{ city: 'Ballyelly (Donegal)', zip: '145355' },
	{ city: 'Ballyenaghty (Kerry)', zip: '502807' },
	{ city: 'Ballyenahan North (Cork)', zip: '222012' },
	{ city: 'Ballyenahan South (Cork)', zip: '200571' },
	{ city: 'Ballyengland Lower (Limerick)', zip: '369311' },
	{ city: 'Ballyengland Upper (Limerick)', zip: '114868' },
	{ city: 'Ballyerk (Tipperary)', zip: '284441' },
	{ city: 'Ballyerra (Cork)', zip: '274853' },
	{ city: 'Ballyerrin (Cork)', zip: '790701' },
	{ city: 'Ballyeustace (Wicklow)', zip: '324467' },
	{ city: 'Ballyfad (Wexford)', zip: '966393' },
	{ city: 'Ballyfadeen Beg (Cork)', zip: '771573' },
	{ city: 'Ballyfadeen More (Cork)', zip: '455882' },
	{ city: 'Ballyfahy (Sligo)', zip: '979618' },
	{ city: 'Ballyfair (Kildare)', zip: '717929' },
	{ city: 'Ballyfane (Wexford)', zip: '538089' },
	{ city: 'Ballyfaris (Sligo)', zip: '112062' },
	{ city: 'Ballyfarnagh (Mayo)', zip: '495327' },
	{ city: 'Ballyfarnoge (Wexford)', zip: '646329' },
	{ city: 'Ballyfarnon (Roscommon)', zip: '450999' },
	{ city: 'Ballyfarrell (Laois)', zip: '995513' },
	{ city: 'Ballyfarrell (Offaly)', zip: '469007' },
	{ city: 'Ballyfarsoon (Kildare)', zip: '282057' },
	{ city: 'Ballyfasy Lower (Kilkenny)', zip: '286389' },
	{ city: 'Ballyfasy Upper (Kilkenny)', zip: '897396' },
	{ city: 'Ballyfaudeen (Clare)', zip: '715790' },
	{ city: 'Ballyfauskeen (Limerick)', zip: '919607' },
	{ city: 'Ballyfeanan (Carlow)', zip: '941641' },
	{ city: 'Ballyfeeny (Roscommon)', zip: '479817' },
	{ city: 'Ballyfeerode (Limerick)', zip: '124000' },
	{ city: 'Ballyfereen (Kilkenny)', zip: '724482' },
	{ city: 'Ballyfermot (Dublin)', zip: '804328' },
	{ city: 'Ballyfermot Upper (Dublin)', zip: '415512' },
	{ city: 'Ballyferriter (Kerry)', zip: '402727' },
	{ city: 'Ballyfilibeen (Cork)', zip: '324892' },
	{ city: 'Ballyfin (Cork)', zip: '556034' },
	{ city: 'Ballyfin (Laois)', zip: '119482' },
	{ city: 'Ballyfin (Wexford)', zip: '940845' },
	{ city: 'Ballyfinboy (Tipperary)', zip: '870678' },
	{ city: 'Ballyfin Demesne (Laois)', zip: '384511' },
	{ city: 'Ballyfinegan (Galway)', zip: '660025' },
	{ city: 'Ballyfinegan (Roscommon)', zip: '639131' },
	{ city: 'Ballyfinnan (Laois)', zip: '951211' },
	{ city: 'Ballyfinnane (Kerry)', zip: '401702' },
	{ city: 'Ballyfinneen (Clare)', zip: '659750' },
	{ city: 'Ballyfinoge (Kerry)', zip: '789711' },
	{ city: 'Ballyfinoge Great (Wexford)', zip: '837049' },
	{ city: 'Ballyfinoge Little (Wexford)', zip: '847809' },
	{ city: 'Ballyfintan (Galway)', zip: '811877' },
	{ city: 'Ballyfin Upper (Laois)', zip: '514085' },
	{ city: 'Ballyfireen (Cork)', zip: '854873' },
	{ city: 'Ballyfirreen North (Limerick)', zip: '899421' },
	{ city: 'Ballyfirreen South (Limerick)', zip: '169541' },
	{ city: 'Ballyflanigan (Wicklow)', zip: '659024' },
	{ city: 'Ballyfleming (Cork)', zip: '214657' },
	{ city: 'Ballyfliugh (Kilkenny)', zip: '619824' },
	{ city: 'Ballyfoile Lower (Kilkenny)', zip: '398027' },
	{ city: 'Ballyfoile Upper (Kilkenny)', zip: '438823' },
	{ city: 'Ballyfolan (Wicklow)', zip: '560985' },
	{ city: 'Ballyfoleen North (Limerick)', zip: '884300' },
	{ city: 'Ballyfoleen South (Limerick)', zip: '431580' },
	{ city: 'Ballyfoley (Wexford)', zip: '562620' },
	{ city: 'Ballyfoley Little (Wexford)', zip: '522215' },
	{ city: 'Ballyfookeen (Limerick)', zip: '648679' },
	{ city: 'Ballyfookoon (Limerick)', zip: '236296' },
	{ city: 'Ballyforan (Roscommon)', zip: '553267' },
	{ city: 'Ballyfore (Meath)', zip: '783024' },
	{ city: 'Ballyfore (Offaly)', zip: '323982' },
	{ city: 'Ballyfore Big (Offaly)', zip: '934550' },
	{ city: 'Ballyfore Little (Offaly)', zip: '554695' },
	{ city: 'Ballyformoyle (Roscommon)', zip: '727475' },
	{ city: 'Ballyfouloo (Cork)', zip: '831996' },
	{ city: 'Ballyfowloo (Tipperary)', zip: '812252' },
	{ city: 'Ballyfoyle (Cork)', zip: '112462' },
	{ city: 'Ballyfoyle (Kilkenny)', zip: '766184' },
	{ city: 'Ballyfoyle (Laois)', zip: '138065' },
	{ city: 'Ballyfoyle (Wicklow)', zip: '631845' },
	{ city: 'Ballyfraley (Limerick)', zip: '709165' },
	{ city: 'Ballyfree (Sligo)', zip: '790640' },
	{ city: 'Ballyfree East (Wicklow)', zip: '599572' },
	{ city: 'Ballyfree West (Wicklow)', zip: '345403' },
	{ city: 'Ballyfroota (Limerick)', zip: '779837' },
	{ city: 'Ballyfrory (Wexford)', zip: '924550' },
	{ city: 'Ballyfruit (Galway)', zip: '149572' },
	{ city: 'Ballyfrunk (Kilkenny)', zip: '331474' },
	{ city: 'Ballygaddy (Galway)', zip: '544574' },
	{ city: 'Ballygaddy (Kildare)', zip: '472433' },
	{ city: 'Ballygaddy (Offaly)', zip: '745736' },
	{ city: 'Ballygagin (Waterford)', zip: '833865' },
	{ city: 'Ballygahan Lower (Wicklow)', zip: '900454' },
	{ city: 'Ballygahan Upper (Wicklow)', zip: '136736' },
	{ city: 'Ballygalane (Waterford)', zip: '587750' },
	{ city: 'Ballygalane Upper (Waterford)', zip: '591147' },
	{ city: 'Ballygalda (Roscommon)', zip: '388326' },
	{ city: 'Ballygallan (Donegal)', zip: '544361' },
	{ city: 'Ballygallon (Kilkenny)', zip: '558843' },
	{ city: 'Ballygally (Galway)', zip: '948835' },
	{ city: 'Ballygally (Waterford)', zip: '362974' },
	{ city: 'Ballygally East (Waterford)', zip: '325481' },
	{ city: 'Ballygally West (Waterford)', zip: '304654' },
	{ city: 'Ballygalvert (Wexford)', zip: '411892' },
	{ city: 'Ballygambon (Tipperary)', zip: '106802' },
	{ city: 'Ballygambon Lower (Waterford)', zip: '694153' },
	{ city: 'Ballygambon Upper (Waterford)', zip: '841202' },
	{ city: 'Ballygamboon Lower (Kerry)', zip: '815194' },
	{ city: 'Ballygamboon Upper (Kerry)', zip: '578664' },
	{ city: 'Ballygammane (Tipperary)', zip: '156293' },
	{ city: 'Ballyganneen (Kerry)', zip: '436039' },
	{ city: 'Ballyganner North (Clare)', zip: '454381' },
	{ city: 'Ballyganner South (Clare)', zip: '453620' },
	{ city: 'Ballygannon (Wicklow)', zip: '131166' },
	{ city: 'Ballygannon Beg (Wicklow)', zip: '215553' },
	{ city: 'Ballygannon More (Wicklow)', zip: '828706' },
	{ city: 'Ballygar (Galway)', zip: '804768' },
	{ city: 'Ballygar (Longford)', zip: '961677' },
	{ city: 'Ballygarra (Wexford)', zip: '309188' },
	{ city: 'Ballygarran (Kerry)', zip: '316635' },
	{ city: 'Ballygarran (Waterford)', zip: '955063' },
	{ city: 'Ballygarran (Westmeath)', zip: '912743' },
	{ city: 'Ballygarran (Wexford)', zip: '405117' },
	{ city: 'Ballygarrane (Cork)', zip: '338391' },
	{ city: 'Ballygarrane (Tipperary)', zip: '193565' },
	{ city: 'Ballygarraun (Galway)', zip: '904004' },
	{ city: 'Ballygarraun North (Galway)', zip: '592753' },
	{ city: 'Ballygarraun South (Galway)', zip: '860383' },
	{ city: 'Ballygarraun West (Galway)', zip: '240598' },
	{ city: 'Ballygarreen (Clare)', zip: '817527' },
	{ city: 'Ballygarret (Carlow)', zip: '610472' },
	{ city: 'Ballygarret (Kerry)', zip: '402750' },
	{ city: 'Ballygarret (Waterford)', zip: '752629' },
	{ city: 'Ballygarret (Wicklow)', zip: '542887' },
	{ city: 'Ballygarrett (Cork)', zip: '829274' },
	{ city: 'Ballygarrett (Offaly)', zip: '334953' },
	{ city: 'Ballygarrett (Wexford)', zip: '201290' },
	{ city: 'Ballygarrett Little (Wexford)', zip: '625322' },
	{ city: 'Ballygarries (Mayo)', zip: '631178' },
	{ city: 'Ballygarriff (Galway)', zip: '473482' },
	{ city: 'Ballygarriff (Mayo)', zip: '345775' },
	{ city: 'Ballygarry (Mayo)', zip: '369825' },
	{ city: 'Ballygarth (Meath)', zip: '121231' },
	{ city: 'Ballygarvan (Cork)', zip: '900264' },
	{ city: 'Ballygarvan (Wexford)', zip: '252323' },
	{ city: 'Ballygarvan Glebe (Laois)', zip: '510224' },
	{ city: 'Ballygarve (Longford)', zip: '230252' },
	{ city: 'Ballygarvey (Westmeath)', zip: '966352' },
	{ city: 'Ballygarvey (Wexford)', zip: '811474' },
	{ city: 'Ballygarveybeg (Westmeath)', zip: '150946' },
	{ city: 'Ballygasheen (Tipperary)', zip: '228291' },
	{ city: 'Ballygassan (Clare)', zip: '447799' },
	{ city: 'Ballygastell (Clare)', zip: '881520' },
	{ city: 'Ballygasty (Galway)', zip: '646016' },
	{ city: 'Ballygate (Roscommon)', zip: '985576' },
	{ city: 'Ballygauge Beg (Laois)', zip: '435401' },
	{ city: 'Ballygauge More (Laois)', zip: '259562' },
	{ city: 'Ballygawley (Donegal)', zip: '499626' },
	{ city: 'Ballygawley (Sligo)', zip: '317658' },
	{ city: 'Ballygay (Donegal)', zip: '277443' },
	{ city: 'Ballygeagin (Galway)', zip: '318136' },
	{ city: 'Ballygeagoge (Limerick)', zip: '187812' },
	{ city: 'Ballygeale (Limerick)', zip: '148218' },
	{ city: 'Ballygeana (Limerick)', zip: '566551' },
	{ city: 'Ballygeany (Cork)', zip: '836835' },
	{ city: 'Ballygeardra (Kilkenny)', zip: '929150' },
	{ city: 'Ballygeehin Lower (Laois)', zip: '645448' },
	{ city: 'Ballygeehin Upper (Laois)', zip: '989369' },
	{ city: 'Ballygeel (Limerick)', zip: '840601' },
	{ city: 'Ballygeery East (Clare)', zip: '757414' },
	{ city: 'Ballygeery West (Clare)', zip: '452773' },
	{ city: 'Ballygegan (Kilkenny)', zip: '592502' },
	{ city: 'Ballygerald East (Tipperary)', zip: '596758' },
	{ city: 'Ballygerald West (Tipperary)', zip: '639326' },
	{ city: 'Ballygerry (Wexford)', zip: '820986' },
	{ city: 'Ballygibbagh (Longford)', zip: '674635' },
	{ city: 'Ballygibbon (Cork)', zip: '247885' },
	{ city: 'Ballygibbon (Tipperary)', zip: '133542' },
	{ city: 'Ballygibbon (Wexford)', zip: '489839' },
	{ city: 'Ballygibbon East (Kildare)', zip: '979805' },
	{ city: 'Ballygibbon West (Kildare)', zip: '404485' },
	{ city: 'Ballygiblin (Cork)', zip: '119408' },
	{ city: 'Ballygilcash (Sligo)', zip: '886116' },
	{ city: 'Ballygilchrist (Longford)', zip: '830854' },
	{ city: 'Ballygilgan (Sligo)', zip: '191965' },
	{ city: 'Ballygillaheen (Laois)', zip: '194679' },
	{ city: 'Ballygillane (Limerick)', zip: '643661' },
	{ city: 'Ballygillane Big (Wexford)', zip: '539890' },
	{ city: 'Ballygillane Little (Wexford)', zip: '511625' },
	{ city: 'Ballygillaroe (Wicklow)', zip: '635531' },
	{ city: 'Ballygillin (Westmeath)', zip: '281384' },
	{ city: 'Ballygillistown (Wexford)', zip: '592731' },
	{ city: 'Ballygiltenan Lower (Limerick)', zip: '272708' },
	{ city: 'Ballygiltenan North (Limerick)', zip: '518684' },
	{ city: 'Ballygiltenan Upper (Limerick)', zip: '337876' },
	{ city: 'Ballyginnane (Cork)', zip: '879203' },
	{ city: 'Ballygirreen (Clare)', zip: '418151' },
	{ city: 'Ballygirriha (Cork)', zip: '148448' },
	{ city: 'Ballyglan (Waterford)', zip: '183445' },
	{ city: 'Ballyglasheen (Kerry)', zip: '918375' },
	{ city: 'Ballyglasheen (Tipperary)', zip: '672229' },
	{ city: 'Ballyglasheen Little (Tipperary)', zip: '196331' },
	{ city: 'Ballyglass (Clare)', zip: '692680' },
	{ city: 'Ballyglass (Cork)', zip: '559705' },
	{ city: 'Ballyglass (Galway)', zip: '561186' },
	{ city: 'Ballyglass (Laois)', zip: '858067' },
	{ city: 'Ballyglass (Leitrim)', zip: '368569' },
	{ city: 'Ballyglass (Mayo)', zip: '213321' },
	{ city: 'Ballyglass (Roscommon)', zip: '627521' },
	{ city: 'Ballyglass (Sligo)', zip: '232479' },
	{ city: 'Ballyglass (Westmeath)', zip: '585668' },
	{ city: 'Ballyglass East (Galway)', zip: '183440' },
	{ city: 'Ballyglass East (Mayo)', zip: '778145' },
	{ city: 'Ballyglass East (Roscommon)', zip: '473105' },
	{ city: 'Ballyglassin (Cork)', zip: '929754' },
	{ city: 'Ballyglassin (Longford)', zip: '884562' },
	{ city: 'Ballyglass Lower (Mayo)', zip: '208263' },
	{ city: 'Ballyglass Lower (Roscommon)', zip: '912224' },
	{ city: 'Ballyglass Lower (Tipperary)', zip: '302965' },
	{ city: 'Ballyglass Middle (Galway)', zip: '886507' },
	{ city: 'Ballyglass Middle (Mayo)', zip: '215338' },
	{ city: 'Ballyglass North (Galway)', zip: '718594' },
	{ city: 'Ballyglassoon (Kilkenny)', zip: '383765' },
	{ city: 'Ballyglass South (Galway)', zip: '651250' },
	{ city: 'Ballyglass Upper (Roscommon)', zip: '277768' },
	{ city: 'Ballyglass Upper (Tipperary)', zip: '876032' },
	{ city: 'Ballyglass West (Galway)', zip: '687574' },
	{ city: 'Ballyglass West (Mayo)', zip: '901317' },
	{ city: 'Ballyglass West (Roscommon)', zip: '247012' },
	{ city: 'Ballyglavin (Cork)', zip: '589565' },
	{ city: 'Ballyglisheen (Carlow)', zip: '535109' },
	{ city: 'Ballyglishen (Laois)', zip: '832557' },
	{ city: 'Ballyglissane (Cork)', zip: '329558' },
	{ city: 'Ballyglooneen (Galway)', zip: '383215' },
	{ city: 'Ballyglunin (Galway)', zip: '320122' },
	{ city: 'Ballygobban (Wicklow)', zip: '934033' },
	{ city: 'Ballygodoon (Tipperary)', zip: '725146' },
	{ city: 'Ballygoghlan (Limerick)', zip: '375927' },
	{ city: 'Ballygolman (Mayo)', zip: '553154' },
	{ city: 'Ballygoly (Louth)', zip: '344333' },
	{ city: 'Ballygoman (Wexford)', zip: '489154' },
	{ city: 'Ballygommon (Mayo)', zip: '568393' },
	{ city: 'Ballygonigan (Donegal)', zip: '869414' },
	{ city: 'Ballygonnell (Wicklow)', zip: '209497' },
	{ city: 'Ballygoonaun (Clare)', zip: '657837' },
	{ city: 'Ballygoran (Kildare)', zip: '936612' },
	{ city: 'Ballygorey (Kilkenny)', zip: '826089' },
	{ city: 'Ballygorman (Donegal)', zip: '945467' },
	{ city: 'Ballygormill North (Laois)', zip: '654354' },
	{ city: 'Ballygormill South (Laois)', zip: '521416' },
	{ city: 'Ballygortagh (Meath)', zip: '767725' },
	{ city: 'Ballygortagh (Roscommon)', zip: '663474' },
	{ city: 'Ballygorteen (Kilkenny)', zip: '895921' },
	{ city: 'Ballygorteen (Tipperary)', zip: '432757' },
	{ city: 'Ballygortin (Wexford)', zip: '393684' },
	{ city: 'Ballygow (Wexford)', zip: '342105' },
	{ city: 'Ballygowan (Carlow)', zip: '978508' },
	{ city: 'Ballygowan (Galway)', zip: '589305' },
	{ city: 'Ballygowan (Kilkenny)', zip: '399427' },
	{ city: 'Ballygowan (Louth)', zip: '449052' },
	{ city: 'Ballygowan (Mayo)', zip: '216437' },
	{ city: 'Ballygowdan (Laois)', zip: '426346' },
	{ city: 'Ballygowlan (Westmeath)', zip: '974516' },
	{ city: 'Ballygowloge (Kerry)', zip: '825996' },
	{ city: 'Ballygown (Cork)', zip: '930717' },
	{ city: 'Ballygown (Kilkenny)', zip: '568873' },
	{ city: 'Ballygowney (Kilkenny)', zip: '294041' },
	{ city: 'Ballygown North (Tipperary)', zip: '570077' },
	{ city: 'Ballygown South (Tipperary)', zip: '376955' },
	{ city: 'Ballygowny (Wexford)', zip: '806981' },
	{ city: 'Ballygrace (Cork)', zip: '880216' },
	{ city: 'Ballygrady North (Cork)', zip: '577430' },
	{ city: 'Ballygrady South (Cork)', zip: '724389' },
	{ city: 'Ballygraigue (Tipperary)', zip: '311910' },
	{ city: 'Ballygraney (Carlow)', zip: '229946' },
	{ city: 'Ballygrangans (Wexford)', zip: '821464' },
	{ city: 'Ballygrania (Sligo)', zip: '782138' },
	{ city: 'Ballygrany (Galway)', zip: '958799' },
	{ city: 'Ballygreany (Kildare)', zip: '729224' },
	{ city: 'Ballygreany (Monaghan)', zip: '666156' },
	{ city: 'Ballygree (Kerry)', zip: '127115' },
	{ city: 'Ballygreek (Kilkenny)', zip: '563677' },
	{ city: 'Ballygreen (Donegal)', zip: '177704' },
	{ city: 'Ballygreighan (Sligo)', zip: '234268' },
	{ city: 'Ballygreighan Barr (Sligo)', zip: '359806' },
	{ city: 'Ballygrenane (Kerry)', zip: '299394' },
	{ city: 'Ballygrennan (Limerick)', zip: '564752' },
	{ city: 'Ballygriffin (Cork)', zip: '637673' },
	{ city: 'Ballygriffin (Kerry)', zip: '208143' },
	{ city: 'Ballygriffin (Kilkenny)', zip: '816909' },
	{ city: 'Ballygriffin (Limerick)', zip: '252063' },
	{ city: 'Ballygriffin (Tipperary)', zip: '859193' },
	{ city: 'Ballygriffin (Wicklow)', zip: '212684' },
	{ city: 'Ballygriffy North (Clare)', zip: '447658' },
	{ city: 'Ballygriffy South (Clare)', zip: '471815' },
	{ city: 'Ballygriggan (Cork)', zip: '383486' },
	{ city: 'Ballygrillihan (Cork)', zip: '936422' },
	{ city: 'Ballygrissane (Cork)', zip: '900220' },
	{ city: 'Ballygrogan (Cork)', zip: '267435' },
	{ city: 'Ballygrohan (Cork)', zip: '971105' },
	{ city: 'Ballygroman Lower (Cork)', zip: '330084' },
	{ city: 'Ballygroman Upper (Cork)', zip: '560256' },
	{ city: 'Ballygrunna (Cork)', zip: '357089' },
	{ city: 'Ballygubba North (Limerick)', zip: '717725' },
	{ city: 'Ballygubba South (Limerick)', zip: '816609' },
	{ city: 'Ballygub New (Kilkenny)', zip: '720344' },
	{ city: 'Ballygub Old (Kilkenny)', zip: '573727' },
	{ city: 'Ballyguileataggle (Limerick)', zip: '574044' },
	{ city: 'Ballyguilebeg (Limerick)', zip: '796134' },
	{ city: 'Ballyguile Beg (Wicklow)', zip: '835511' },
	{ city: 'Ballyguile More (Wicklow)', zip: '121234' },
	{ city: 'Ballyguin (Mayo)', zip: '384267' },
	{ city: 'Ballyguiry (Waterford)', zip: '810937' },
	{ city: 'Ballyguiry East (Waterford)', zip: '207998' },
	{ city: 'Ballyguiry West (Waterford)', zip: '362652' },
	{ city: 'Ballygulleen (Limerick)', zip: '972520' },
	{ city: 'Ballygullen (Wexford)', zip: '452555' },
	{ city: 'Ballygullick (Wexford)', zip: '666769' },
	{ city: 'Ballygunneen (Galway)', zip: '659272' },
	{ city: 'Ballygunnercastle (Waterford)', zip: '533761' },
	{ city: 'Ballygunnermore (Waterford)', zip: '187863' },
	{ city: 'Ballygunnertemple (Waterford)', zip: '327094' },
	{ city: 'Ballyguy (Limerick)', zip: '513977' },
	{ city: 'Ballyguyroe North (Cork)', zip: '383135' },
	{ city: 'Ballyguyroe South (Cork)', zip: '304112' },
	{ city: 'Ballyhack (Dublin)', zip: '258175' },
	{ city: 'Ballyhack (Kilkenny)', zip: '355377' },
	{ city: 'Ballyhack (Meath)', zip: '690851' },
	{ city: 'Ballyhack (Wexford)', zip: '888576' },
	{ city: 'Ballyhackbeg (Wexford)', zip: '134294' },
	{ city: 'Ballyhacket Lower (Carlow)', zip: '517840' },
	{ city: 'Ballyhacket Upper (Carlow)', zip: '354084' },
	{ city: 'Ballyhaddock (Wexford)', zip: '233794' },
	{ city: 'Ballyhade (Kildare)', zip: '630307' },
	{ city: 'Ballyhaden (Tipperary)', zip: '579885' },
	{ city: 'Ballyhad Lower (Wicklow)', zip: '573702' },
	{ city: 'Ballyhad Upper (Wicklow)', zip: '436233' },
	{ city: 'Ballyhagan (Kildare)', zip: '894296' },
	{ city: 'Ballyhaght (Limerick)', zip: '455771' },
	{ city: 'Ballyhahil (Limerick)', zip: '372665' },
	{ city: 'Ballyhahill (Limerick)', zip: '854635' },
	{ city: 'Ballyhaise (Cavan)', zip: '625334' },
	{ city: 'Ballyhale (Galway)', zip: '399893' },
	{ city: 'Ballyhale (Kilkenny)', zip: '139298' },
	{ city: 'Ballyhall (Kilkenny)', zip: '983831' },
	{ city: 'Ballyhally (Cavan)', zip: '116322' },
	{ city: 'Ballyhalwick (Cork)', zip: '396476' },
	{ city: 'Ballyhamilton (Wexford)', zip: '257233' },
	{ city: 'Ballyhamlet (Waterford)', zip: '171133' },
	{ city: 'Ballyhammon (Roscommon)', zip: '944460' },
	{ city: 'Ballyhamsane (Cork)', zip: '103959' },
	{ city: 'Ballyhamsherry (Cork)', zip: '920700' },
	{ city: 'Ballyhander (Cork)', zip: '818372' },
	{ city: 'Ballyhander (Waterford)', zip: '725902' },
	{ city: 'Ballyhandle (Cork)', zip: '704838' },
	{ city: 'Ballyhandy (Westmeath)', zip: '609913' },
	{ city: 'Ballyhane (Tipperary)', zip: '719334' },
	{ city: 'Ballyhane (Waterford)', zip: '829866' },
	{ city: 'Ballyhane East (Tipperary)', zip: '645063' },
	{ city: 'Ballyhane Lower (Cork)', zip: '643227' },
	{ city: 'Ballyhane Upper (Cork)', zip: '450013' },
	{ city: 'Ballyhane West (Tipperary)', zip: '581412' },
	{ city: 'Ballyhank (Cork)', zip: '527193' },
	{ city: 'Ballyhankeen (Mayo)', zip: '844471' },
	{ city: 'Ballyhanna (Donegal)', zip: '104786' },
	{ city: 'Ballyhannan North (Clare)', zip: '172433' },
	{ city: 'Ballyhannan South (Clare)', zip: '811870' },
	{ city: 'Ballyhanruck (Mayo)', zip: '699072' },
	{ city: 'Ballyhanry (Galway)', zip: '525708' },
	{ city: 'Ballyhar (Kerry)', zip: '851324' },
	{ city: 'Ballyhara (Wicklow)', zip: '538030' },
	{ city: 'Ballyhard (Galway)', zip: '791552' },
	{ city: 'Ballyharmon (Laois)', zip: '509365' },
	{ city: 'Ballyharney (Westmeath)', zip: '820525' },
	{ city: 'Ballyharoon (Cork)', zip: '563713' },
	{ city: 'Ballyharraghan (Clare)', zip: '700104' },
	{ city: 'Ballyharrahan (Waterford)', zip: '314573' },
	{ city: 'Ballyharran Lower (Wexford)', zip: '962626' },
	{ city: 'Ballyharran Upper (Wexford)', zip: '709699' },
	{ city: 'Ballyharty (Wexford)', zip: '693711' },
	{ city: 'Ballyhasky (Donegal)', zip: '876652' },
	{ city: 'Ballyhass (Cork)', zip: '296391' },
	{ city: 'Ballyhast (Westmeath)', zip: '617383' },
	{ city: 'Ballyhast (Wexford)', zip: '663592' },
	{ city: 'Ballyhasty (Tipperary)', zip: '805858' },
	{ city: 'Ballyhattan (Westmeath)', zip: '304141' },
	{ city: 'Ballyhaugh (Tipperary)', zip: '507488' },
	{ city: 'Ballyhaukish (Limerick)', zip: '769279' },
	{ city: 'Ballyhaunis (Mayo)', zip: '849416' },
	{ city: 'Ballyhavil (Dublin)', zip: '133602' },
	{ city: 'Ballyhaw (Westmeath)', zip: '915891' },
	{ city: 'Ballyhay (Cork)', zip: '838292' },
	{ city: 'Ballyhays (Kildare)', zip: '993244' },
	{ city: 'Ballyheabought (Kerry)', zip: '617902' },
	{ city: 'Ballyheadon (Waterford)', zip: '709823' },
	{ city: 'Ballyhealy (Sligo)', zip: '644261' },
	{ city: 'Ballyhealy (Westmeath)', zip: '726313' },
	{ city: 'Ballyhealycastle (Wexford)', zip: '143554' },
	{ city: 'Ballyhealy North (Wexford)', zip: '849288' },
	{ city: 'Ballyhealy South (Wexford)', zip: '991467' },
	{ city: 'Ballyhean (Mayo)', zip: '694552' },
	{ city: 'Ballyhearny East (Kerry)', zip: '610551' },
	{ city: 'Ballyhearny West (Kerry)', zip: '871732' },
	{ city: 'Ballyheashill (Offaly)', zip: '813111' },
	{ city: 'Ballyhee (Clare)', zip: '659454' },
	{ city: 'Ballyheean (Clare)', zip: '728318' },
	{ city: 'Ballyheedy (Cork)', zip: '759459' },
	{ city: 'Ballyheefy (Clare)', zip: '291826' },
	{ city: 'Ballyheelan (Cavan)', zip: '952661' },
	{ city: 'Ballyheen (Tipperary)', zip: '117173' },
	{ city: 'Ballyheen Middle (Cork)', zip: '624155' },
	{ city: 'Ballyheen North (Cork)', zip: '790915' },
	{ city: 'Ballyheens (Tipperary)', zip: '864333' },
	{ city: 'Ballyheen South (Cork)', zip: '704448' },
	{ city: 'Ballyheeny (Waterford)', zip: '636402' },
	{ city: 'Ballyheer (Mayo)', zip: '345918' },
	{ city: 'Ballyheeragh (Mayo)', zip: '833533' },
	{ city: 'Ballyheerin (Donegal)', zip: '355133' },
	{ city: 'Ballyhegadon Glebe (Laois)', zip: '645606' },
	{ city: 'Ballyhegan (Carlow)', zip: '173748' },
	{ city: 'Ballyhehan (Clare)', zip: '113813' },
	{ city: 'Ballyheige (Kerry)', zip: '213378' },
	{ city: 'Ballyheige (Wexford)', zip: '893919' },
	{ city: 'Ballyhemiken (Cork)', zip: '298430' },
	{ city: 'Ballyhemikin (Kerry)', zip: '523430' },
	{ city: 'Ballyhendricken (Kilkenny)', zip: '236635' },
	{ city: 'Ballyhenebery (Kilkenny)', zip: '394099' },
	{ city: 'Ballyhenebery (Tipperary)', zip: '105726' },
	{ city: 'Ballyhenna (Clare)', zip: '631733' },
	{ city: 'Ballyhennessy (Clare)', zip: '879347' },
	{ city: 'Ballyhennessy (Cork)', zip: '300199' },
	{ city: 'Ballyhennessy (Kerry)', zip: '185711' },
	{ city: 'Ballyhennick (Cork)', zip: '739155' },
	{ city: 'Ballyhennigan (Wexford)', zip: '450539' },
	{ city: 'Ballyhenry (Kerry)', zip: '928625' },
	{ city: 'Ballyhenry (Mayo)', zip: '812927' },
	{ city: 'Ballyhenry (Tipperary)', zip: '257176' },
	{ city: 'Ballyhenry (Wicklow)', zip: '850213' },
	{ city: 'Ballyherberry (Tipperary)', zip: '841185' },
	{ city: 'Ballyherkin Lower (Cork)', zip: '496876' },
	{ city: 'Ballyherkin Upper (Cork)', zip: '373416' },
	{ city: 'Ballyherragh (Clare)', zip: '913035' },
	{ city: 'Ballyherrig (Wicklow)', zip: '514457' },
	{ city: 'Ballyhest (Waterford)', zip: '605203' },
	{ city: 'Ballyhest East (Cork)', zip: '399796' },
	{ city: 'Ballyhest West (Cork)', zip: '364502' },
	{ city: 'Ballyhesty (Cork)', zip: '437034' },
	{ city: 'Ballyhetterick (Cork)', zip: '531140' },
	{ city: 'Ballyheyland (Laois)', zip: '824667' },
	{ city: 'Ballyhibbin (Limerick)', zip: '302658' },
	{ city: 'Ballyhickey (Clare)', zip: '862704' },
	{ city: 'Ballyhickey (Tipperary)', zip: '858791' },
	{ city: 'Ballyhide (Laois)', zip: '980448' },
	{ city: 'Ballyhiernan (Donegal)', zip: '286691' },
	{ city: 'Ballyhiernaun (Mayo)', zip: '251568' },
	{ city: 'Ballyhigeen (Cork)', zip: '775709' },
	{ city: 'Ballyhigh (Wexford)', zip: '870786' },
	{ city: 'Ballyhighland (Wexford)', zip: '444918' },
	{ city: 'Ballyhiho (Wexford)', zip: '123556' },
	{ city: 'Ballyhilloge (Cork)', zip: '483219' },
	{ city: 'Ballyhimikin (Cork)', zip: '419953' },
	{ city: 'Ballyhimikin (Tipperary)', zip: '500509' },
	{ city: 'Ballyhimmin (Kilkenny)', zip: '872368' },
	{ city: 'Ballyhimock (Cork)', zip: '647751' },
	{ city: 'Ballyhinch (Clare)', zip: '645911' },
	{ city: 'Ballyhindon (Cork)', zip: '970147' },
	{ city: 'Ballyhine (Mayo)', zip: '792666' },
	{ city: 'Ballyhine (Wexford)', zip: '401931' },
	{ city: 'Ballyhinnaught (Limerick)', zip: '625180' },
	{ city: 'Ballyhinode (Laois)', zip: '682779' },
	{ city: 'Ballyhire (Wexford)', zip: '983399' },
	{ city: 'Ballyhisky (Tipperary)', zip: '977668' },
	{ city: 'Ballyhist (Meath)', zip: '964518' },
	{ city: 'Ballyhist (Tipperary)', zip: '112070' },
	{ city: 'Ballyhistbeg (Tipperary)', zip: '888560' },
	{ city: 'Ballyhit (Wexford)', zip: '970244' },
	{ city: 'Ballyhitt (Wexford)', zip: '492513' },
	{ city: 'Ballyhobert (Cork)', zip: '706204' },
	{ city: 'Ballyhobin (Limerick)', zip: '447327' },
	{ city: 'Ballyhobuck (Kilkenny)', zip: '374799' },
	{ city: 'Ballyhoe (Meath)', zip: '602425' },
	{ city: 'Ballyhogan (Galway)', zip: '400774' },
	{ city: 'Ballyhogan (Tipperary)', zip: '289772' },
	{ city: 'Ballyhoge (Wexford)', zip: '107737' },
	{ city: 'Ballyhohan (Tipperary)', zip: '129830' },
	{ city: 'Ballyholahan East (Tipperary)', zip: '233806' },
	{ city: 'Ballyholahan West (Tipperary)', zip: '659076' },
	{ city: 'Ballyholan (Mayo)', zip: '697975' },
	{ city: 'Ballyholey Far (Donegal)', zip: '871361' },
	{ city: 'Ballyholey Near (Donegal)', zip: '256460' },
	{ city: 'Ballyhollaghan (Roscommon)', zip: '335364' },
	{ city: 'Ballyhomin (Limerick)', zip: '418535' },
	{ city: 'Ballyhomock (Limerick)', zip: '936768' },
	{ city: 'Ballyhomuck (Kilkenny)', zip: '331608' },
	{ city: 'Ballyhomuck (Tipperary)', zip: '793974' },
	{ city: 'Ballyhomulta (Clare)', zip: '574755' },
	{ city: 'Ballyhone (Tipperary)', zip: '198645' },
	{ city: 'Ballyhoneen (Kerry)', zip: '410563' },
	{ city: 'Ballyhonock (Cork)', zip: '992120' },
	{ city: 'Ballyhoodane (Limerick)', zip: '842220' },
	{ city: 'Ballyhook (Cork)', zip: '398086' },
	{ city: 'Ballyhook (Wicklow)', zip: '301874' },
	{ city: 'Ballyhook Demesne (Wicklow)', zip: '809044' },
	{ city: 'Ballyhook Hill (Wicklow)', zip: '627753' },
	{ city: 'Ballyhoolahan (Galway)', zip: '791463' },
	{ city: 'Ballyhoolahan (Limerick)', zip: '638702' },
	{ city: 'Ballyhoolahan East (Cork)', zip: '163060' },
	{ city: 'Ballyhoolahan Middle (Cork)', zip: '927268' },
	{ city: 'Ballyhoolahan West (Cork)', zip: '228710' },
	{ city: 'Ballyhooleen (Cork)', zip: '357861' },
	{ city: 'Ballyhoolivan (Longford)', zip: '855492' },
	{ city: 'Ballyhooly (Cork)', zip: '583676' },
	{ city: 'Ballyhooly North (Cork)', zip: '286770' },
	{ city: 'Ballyhooly South (Cork)', zip: '792062' },
	{ city: 'Ballyhoorisky (Donegal)', zip: '385785' },
	{ city: 'Ballyhoorisky Island (Donegal)', zip: '737054' },
	{ city: 'Ballyhoose (Galway)', zip: '264534' },
	{ city: 'Ballyhorahan (Laois)', zip: '661449' },
	{ city: 'Ballyhoreen (Westmeath)', zip: '678990' },
	{ city: 'Ballyhorgan (Kerry)', zip: '410658' },
	{ city: 'Ballyhorgan East (Kerry)', zip: '967017' },
	{ city: 'Ballyhorgan-Marshes (Kerry)', zip: '133389' },
	{ city: 'Ballyhorgan South (Kerry)', zip: '920460' },
	{ city: 'Ballyhorgan West (Kerry)', zip: '874091' },
	{ city: 'Ballyhork (Donegal)', zip: '932658' },
	{ city: 'Ballyhorsey (Wicklow)', zip: '699535' },
	{ city: 'Ballyhote (Wexford)', zip: '522615' },
	{ city: 'Ballyhought (Wexford)', zip: '736405' },
	{ city: 'Ballyhoulahan (Cork)', zip: '907368' },
	{ city: 'Ballyhoura (Cork)', zip: '539638' },
	{ city: 'Ballyhourigan (Tipperary)', zip: '431891' },
	{ city: 'Ballyhourode (Cork)', zip: '615580' },
	{ city: 'Ballyhow (Tipperary)', zip: '333712' },
	{ city: 'Ballyhowbeg (Wexford)', zip: '654596' },
	{ city: 'Ballyhow Lower (Wexford)', zip: '820483' },
	{ city: 'Ballyhowly (Mayo)', zip: '452976' },
	{ city: 'Ballyhow Middle (Wexford)', zip: '345052' },
	{ city: 'Ballyhubbo (Cork)', zip: '757821' },
	{ city: 'Ballyhubbock (Wexford)', zip: '430130' },
	{ city: 'Ballyhubbock Lower (Wicklow)', zip: '982436' },
	{ city: 'Ballyhubbock Upper (Wicklow)', zip: '214405' },
	{ city: 'Ballyhubert (Roscommon)', zip: '284343' },
	{ city: 'Ballyhudda (Tipperary)', zip: '258356' },
	{ city: 'Ballyhug (Westmeath)', zip: '112491' },
	{ city: 'Ballyhugh (Cavan)', zip: '608325' },
	{ city: 'Ballyhugh (Galway)', zip: '243803' },
	{ city: 'Ballyhugh (Offaly)', zip: '190044' },
	{ city: 'Ballyhugh (Roscommon)', zip: '964441' },
	{ city: 'Ballyhullenkeague (Cork)', zip: '996677' },
	{ city: 'Ballyhuppahane (Laois)', zip: '433094' },
	{ city: 'Ballyhurly (Clare)', zip: '935476' },
	{ city: 'Ballyhurrow (Tipperary)', zip: '698035' },
	{ city: 'Ballyhurst (Limerick)', zip: '669869' },
	{ city: 'Ballyhurtim (Wicklow)', zip: '764199' },
	{ city: 'Ballyhussa (Waterford)', zip: '150004' },
	{ city: 'Ballyhust (Wexford)', zip: '445991' },
	{ city: 'Ballyhusty (Tipperary)', zip: '502882' },
	{ city: 'Ballyhutch (Cork)', zip: '105766' },
	{ city: 'Ballyickeen (Kerry)', zip: '285930' },
	{ city: 'Ballyickeen Commons (Kerry)', zip: '292824' },
	{ city: 'Ballyieragh (Cork)', zip: '257428' },
	{ city: 'Ballyieragh North (Cork)', zip: '382145' },
	{ city: 'Ballyieragh South (Cork)', zip: '620106' },
	{ city: 'Ballyillaun (Clare)', zip: '783599' },
	{ city: 'Ballyine (Carlow)', zip: '137185' },
	{ city: 'Ballyine (Limerick)', zip: '342135' },
	{ city: 'Ballyin Lower (Waterford)', zip: '276954' },
	{ city: 'Ballyinsheen Beg (Clare)', zip: '772020' },
	{ city: 'Ballyinsheen More (Clare)', zip: '823265' },
	{ city: 'Ballyin Upper (Waterford)', zip: '188160' },
	{ city: 'Ballyiriston (Donegal)', zip: '348312' },
	{ city: 'Ballyisland (Cork)', zip: '919689' },
	{ city: 'Ballyjamesduff (Cavan)', zip: '986307' },
	{ city: 'Ballyjennings (Mayo)', zip: '864486' },
	{ city: 'Ballyjohnboy (Kilkenny)', zip: '998991' },
	{ city: 'Ballykale (Wexford)', zip: '300017' },
	{ city: 'Ballykea (Dublin)', zip: '586492' },
	{ city: 'Ballykeaghra (Galway)', zip: '660436' },
	{ city: 'Ballykealey (Carlow)', zip: '117676' },
	{ city: 'Ballykealy (Kerry)', zip: '162460' },
	{ city: 'Ballykealy (Laois)', zip: '507206' },
	{ city: 'Ballykealy (Limerick)', zip: '663537' },
	{ city: 'Ballykealy (Offaly)', zip: '423790' },
	{ city: 'Ballykean (Offaly)', zip: '110774' },
	{ city: 'Ballykean (Wicklow)', zip: '746007' },
	{ city: 'Ballykearney (Cork)', zip: '820774' },
	{ city: 'Ballykeating (Cork)', zip: '528856' },
	{ city: 'Ballykeefe (Kilkenny)', zip: '391251' },
	{ city: 'Ballykeefe Bog (Kilkenny)', zip: '255629' },
	{ city: 'Ballykeefecastle (Kilkenny)', zip: '700150' },
	{ city: 'Ballykeefe Hill (Kilkenny)', zip: '960845' },
	{ city: 'Ballykeeffe (Limerick)', zip: '342010' },
	{ city: 'Ballykeelan (Kildare)', zip: '687585' },
	{ city: 'Ballykeelaun (Clare)', zip: '992330' },
	{ city: 'Ballykeel North (Clare)', zip: '479656' },
	{ city: 'Ballykeel South (Clare)', zip: '442482' },
	{ city: 'Ballykeenaghan (Offaly)', zip: '484008' },
	{ city: 'Ballykeenan (Carlow)', zip: '560130' },
	{ city: 'Ballykeeran (Donegal)', zip: '757775' },
	{ city: 'Ballykeeran (Galway)', zip: '715233' },
	{ city: 'Ballykeeran (Westmeath)', zip: '298031' },
	{ city: 'Ballykeeroge (Wexford)', zip: '283775' },
	{ city: 'Ballykeerogebeg (Wexford)', zip: '917850' },
	{ city: 'Ballykeerogemore (Wexford)', zip: '897248' },
	{ city: 'Ballykeevan (Laois)', zip: '107721' },
	{ city: 'Ballykeevican (Roscommon)', zip: '139781' },
	{ city: 'Ballykeevin (Tipperary)', zip: '822285' },
	{ city: 'Ballykelly (Clare)', zip: '841967' },
	{ city: 'Ballykelly (Kildare)', zip: '865709' },
	{ city: 'Ballykelly (Offaly)', zip: '655989' },
	{ city: 'Ballykelly (Tipperary)', zip: '790039' },
	{ city: 'Ballykelly (Wexford)', zip: '414363' },
	{ city: 'Ballykelly (Wicklow)', zip: '380352' },
	{ city: 'Ballykelsh (Wexford)', zip: '814509' },
	{ city: 'Ballykenefick (Cork)', zip: '924514' },
	{ city: 'Ballykenly (Cork)', zip: '853426' },
	{ city: 'Ballykenna (Kilkenny)', zip: '227043' },
	{ city: 'Ballykennedy (Waterford)', zip: '330621' },
	{ city: 'Ballykennedy North (Limerick)', zip: '141434' },
	{ city: 'Ballykennedy South (Limerick)', zip: '758567' },
	{ city: 'Ballykenneen Lower (Laois)', zip: '502127' },
	{ city: 'Ballykenneen Upper (Laois)', zip: '984476' },
	{ city: 'Ballykenny (Donegal)', zip: '100152' },
	{ city: 'Ballykenny (Limerick)', zip: '636631' },
	{ city: 'Ballykenny (Longford)', zip: '489016' },
	{ city: 'Ballykenry (Limerick)', zip: '433184' },
	{ city: 'Ballykeoghan (Kilkenny)', zip: '948667' },
	{ city: 'Ballykeppoge (Wicklow)', zip: '609487' },
	{ city: 'Ballykereen (Wexford)', zip: '157395' },
	{ city: 'Ballykergan (Donegal)', zip: '392972' },
	{ city: 'Ballykerin (Tipperary)', zip: '227081' },
	{ city: 'Ballykerin Lower (Waterford)', zip: '706876' },
	{ city: 'Ballykerin Middle (Waterford)', zip: '297548' },
	{ city: 'Ballykerin Upper (Waterford)', zip: '527348' },
	{ city: 'Ballykeroge Big (Waterford)', zip: '367013' },
	{ city: 'Ballykeroge Little (Waterford)', zip: '101906' },
	{ city: 'Ballykerrigan (Mayo)', zip: '949106' },
	{ city: 'Ballykerwick (Cork)', zip: '889795' },
	{ city: 'Ballykett (Clare)', zip: '500665' },
	{ city: 'Ballykevan East (Limerick)', zip: '387452' },
	{ city: 'Ballykevan West (Limerick)', zip: '203383' },
	{ city: 'Ballykilcavan (Laois)', zip: '492824' },
	{ city: 'Ballykilcline (Roscommon)', zip: '980841' },
	{ city: 'Ballykilcross (Offaly)', zip: '214392' },
	{ city: 'Ballykildea (Clare)', zip: '229890' },
	{ city: 'Ballykildevin (Westmeath)', zip: '634001' },
	{ city: 'Ballykilduff Lower (Carlow)', zip: '243121' },
	{ city: 'Ballykilduff Upper (Carlow)', zip: '290485' },
	{ city: 'Ballykillaboy (Kilkenny)', zip: '278414' },
	{ city: 'Ballykilladea (Galway)', zip: '401440' },
	{ city: 'Ballykillageer Lower (Wicklow)', zip: '218164' },
	{ city: 'Ballykillageer Upper (Wicklow)', zip: '335247' },
	{ city: 'Ballykillane (Carlow)', zip: '803268' },
	{ city: 'Ballykillane (Laois)', zip: '846691' },
	{ city: 'Ballykillavane (Wicklow)', zip: '273084' },
	{ city: 'Ballykilleen (Mayo)', zip: '881133' },
	{ city: 'Ballykilleen (Offaly)', zip: '490808' },
	{ city: 'Ballykillen (Laois)', zip: '164732' },
	{ city: 'Ballykilliane (Wexford)', zip: '181697' },
	{ city: 'Ballykill Lower (Mayo)', zip: '126748' },
	{ city: 'Ballykillowen (Donegal)', zip: '233323' },
	{ city: 'Ballykill Upper (Mayo)', zip: '356599' },
	{ city: 'Ballykilmore (Westmeath)', zip: '287582' },
	{ city: 'Ballykilmurry (Offaly)', zip: '304158' },
	{ city: 'Ballykilmurry (Waterford)', zip: '856262' },
	{ city: 'Ballykilmurry Lower (Wicklow)', zip: '890157' },
	{ city: 'Ballykilmurry Upper (Wicklow)', zip: '950883' },
	{ city: 'Ballykilroe (Westmeath)', zip: '226954' },
	{ city: 'Ballykilty (Clare)', zip: '327840' },
	{ city: 'Ballykilty (Cork)', zip: '696732' },
	{ city: 'Ballykilty Lower (Wexford)', zip: '705721' },
	{ city: 'Ballykilty Upper (Wexford)', zip: '768516' },
	{ city: 'Ballykinard (Donegal)', zip: '814952' },
	{ city: 'Ballykinash (Tipperary)', zip: '242338' },
	{ city: 'Ballykinava (Mayo)', zip: '851543' },
	{ city: 'Ballykinealy (Cork)', zip: '666488' },
	{ city: 'Ballykine Lower (Mayo)', zip: '429981' },
	{ city: 'Ballykine Upper (Mayo)', zip: '978031' },
	{ city: 'Ballyking (Laois)', zip: '631921' },
	{ city: 'Ballykinlalee (Tipperary)', zip: '226226' },
	{ city: 'Ballykinlettragh (Mayo)', zip: '396874' },
	{ city: 'Ballykinnacora North (Clare)', zip: '295686' },
	{ city: 'Ballykinnacora South (Clare)', zip: '618950' },
	{ city: 'Ballykinsella (Waterford)', zip: '344794' },
	{ city: 'Ballykinvarga (Clare)', zip: '432340' },
	{ city: 'Ballykissane (Kerry)', zip: '137982' },
	{ city: 'Ballykisteen (Tipperary)', zip: '280422' },
	{ city: 'Ballykitt (Cork)', zip: '244180' },
	{ city: 'Ballyknavin (Clare)', zip: '204726' },
	{ city: 'Ballyknock (Carlow)', zip: '847874' },
	{ city: 'Ballyknock (Clare)', zip: '381840' },
	{ city: 'Ballyknock (Cork)', zip: '747608' },
	{ city: 'Ballyknock (Galway)', zip: '188938' },
	{ city: 'Ballyknock (Kilkenny)', zip: '511632' },
	{ city: 'Ballyknock (Longford)', zip: '989340' },
	{ city: 'Ballyknock (Mayo)', zip: '197620' },
	{ city: 'Ballyknock (Tipperary)', zip: '154952' },
	{ city: 'Ballyknock (Waterford)', zip: '188488' },
	{ city: 'Ballyknock (Wexford)', zip: '728845' },
	{ city: 'Ballyknockan (Carlow)', zip: '988278' },
	{ city: 'Ballyknockan (Laois)', zip: '708940' },
	{ city: 'Ballyknockan (Offaly)', zip: '334529' },
	{ city: 'Ballyknockan (Wexford)', zip: '248846' },
	{ city: 'Ballyknockan (Wicklow)', zip: '196292' },
	{ city: 'Ballyknockan Beg (Wicklow)', zip: '100068' },
	{ city: 'Ballyknockane (Cork)', zip: '444588' },
	{ city: 'Ballyknockane (Limerick)', zip: '740349' },
	{ city: 'Ballyknockane (Tipperary)', zip: '411611' },
	{ city: 'Ballyknockan Lower (Wicklow)', zip: '794522' },
	{ city: 'Ballyknockan More (Wicklow)', zip: '928844' },
	{ city: 'Ballyknockan Upper (Wicklow)', zip: '287798' },
	{ city: 'Ballyknockbeg (Kilkenny)', zip: '952563' },
	{ city: 'Ballyknockcrumpin (Carlow)', zip: '997555' },
	{ city: 'Ballyknocker (Wicklow)', zip: '794179' },
	{ city: 'Ballyknocker East (Wicklow)', zip: '666448' },
	{ city: 'Ballyknocker West (Wicklow)', zip: '193115' },
	{ city: 'Ballyknock Lower (Waterford)', zip: '937199' },
	{ city: 'Ballyknockmore (Kilkenny)', zip: '407545' },
	{ city: 'Ballyknock North (Cork)', zip: '784676' },
	{ city: 'Ballyknock South (Cork)', zip: '358801' },
	{ city: 'Ballyknock Upper (Waterford)', zip: '766828' },
	{ city: 'Ballyla (Wexford)', zip: '439392' },
	{ city: 'Ballylaan (Clare)', zip: '981500' },
	{ city: 'Ballylacy (Wexford)', zip: '226459' },
	{ city: 'Ballylaffin (Tipperary)', zip: '846267' },
	{ city: 'Ballylaffin (Wicklow)', zip: '784283' },
	{ city: 'Ballylaghnan (Clare)', zip: '749099' },
	{ city: 'Ballylahan (Mayo)', zip: '779124' },
	{ city: 'Ballylahiff (Kerry)', zip: '419466' },
	{ city: 'Ballylahiff (Limerick)', zip: '840675' },
	{ city: 'Ballylahy (Galway)', zip: '228099' },
	{ city: 'Ballylahy (Tipperary)', zip: '755190' },
	{ city: 'Ballylanders (Cork)', zip: '999967' },
	{ city: 'Ballylanders (Limerick)', zip: '698753' },
	{ city: 'Ballylane (Waterford)', zip: '591072' },
	{ city: 'Ballylane East (Wexford)', zip: '735849' },
	{ city: 'Ballylaneen (Waterford)', zip: '926455' },
	{ city: 'Ballylane West (Wexford)', zip: '663427' },
	{ city: 'Ballylangadon (Waterford)', zip: '190902' },
	{ city: 'Ballylangley (Cork)', zip: '609096' },
	{ city: 'Ballylangy (Cork)', zip: '526316' },
	{ city: 'Ballylanigan (Limerick)', zip: '353288' },
	{ city: 'Ballylanigan (Tipperary)', zip: '122597' },
	{ city: 'Ballylannan (Wexford)', zip: '796849' },
	{ city: 'Ballylannidy (Clare)', zip: '211259' },
	{ city: 'Ballylara (Galway)', zip: '723469' },
	{ city: 'Ballylarkin (Kilkenny)', zip: '954616' },
	{ city: 'Ballylarkin (Wexford)', zip: '787306' },
	{ city: 'Ballylarkin Lower (Kilkenny)', zip: '883596' },
	{ city: 'Ballylarkin Upper (Kilkenny)', zip: '992961' },
	{ city: 'Ballylast (Donegal)', zip: '979118' },
	{ city: 'Ballylawn (Donegal)', zip: '207520' },
	{ city: 'Ballylea (Wicklow)', zip: '213272' },
	{ city: 'Ballyleaan (Clare)', zip: '464687' },
	{ city: 'Ballyleagh (Cork)', zip: '389782' },
	{ city: 'Ballyleague (Roscommon)', zip: '940805' },
	{ city: 'Ballyleakin (Offaly)', zip: '319156' },
	{ city: 'Ballyleary (Cork)', zip: '219506' },
	{ city: 'Ballyleck (Monaghan)', zip: '953396' },
	{ city: 'Ballyledder (Kerry)', zip: '556139' },
	{ city: 'Ballylee (Galway)', zip: '824419' },
	{ city: 'Ballyleen (Carlow)', zip: '567530' },
	{ city: 'Ballyleen (Galway)', zip: '154365' },
	{ city: 'Ballyleen (Waterford)', zip: '182160' },
	{ city: 'Ballylegan (Cork)', zip: '800107' },
	{ city: 'Ballylegan (Tipperary)', zip: '406577' },
	{ city: 'Ballylegat (Waterford)', zip: '215014' },
	{ city: 'Ballylehane Lower (Laois)', zip: '101291' },
	{ city: 'Ballylehane Upper (Laois)', zip: '416298' },
	{ city: 'Ballylehaun (Kilkenny)', zip: '807018' },
	{ city: 'Ballyleigh (Cork)', zip: '953146' },
	{ city: 'Ballyleigh (Wexford)', zip: '687025' },
	{ city: 'Ballylemin (Wexford)', zip: '647165' },
	{ city: 'Ballylemon (Waterford)', zip: '243839' },
	{ city: 'Ballylemon Lower (Waterford)', zip: '954734' },
	{ city: 'Ballylemon Upper (Waterford)', zip: '128708' },
	{ city: 'Ballylemonwood (Waterford)', zip: '526174' },
	{ city: 'Ballylenane (Waterford)', zip: '375111' },
	{ city: 'Ballylennan (Donegal)', zip: '796799' },
	{ city: 'Ballylennan (Galway)', zip: '464837' },
	{ city: 'Ballylennon (Carlow)', zip: '498919' },
	{ city: 'Ballylennon (Offaly)', zip: '252717' },
	{ city: 'Ballylerane (Wicklow)', zip: '779111' },
	{ city: 'Ballylevin (Donegal)', zip: '755981' },
	{ city: 'Ballylevin (Offaly)', zip: '131130' },
	{ city: 'Ballyliamgow (Wexford)', zip: '760361' },
	{ city: 'Ballylibernagh (Wexford)', zip: '126877' },
	{ city: 'Ballylibert (Cork)', zip: '746085' },
	{ city: 'Ballylicky (Cork)', zip: '673652' },
	{ city: 'Ballyliddan East (Clare)', zip: '297570' },
	{ city: 'Ballyliddan West (Clare)', zip: '762571' },
	{ city: 'Ballylier (Offaly)', zip: '285004' },
	{ city: 'Ballyliffin (Donegal)', zip: '839808' },
	{ city: 'Ballylin (Donegal)', zip: '618819' },
	{ city: 'Ballylin (Limerick)', zip: '554455' },
	{ city: 'Ballylin (Offaly)', zip: '903934' },
	{ city: 'Ballylina (Tipperary)', zip: '485962' },
	{ city: 'Ballylina East (Tipperary)', zip: '252135' },
	{ city: 'Ballylinane (Limerick)', zip: '779603' },
	{ city: 'Ballylina West (Tipperary)', zip: '823095' },
	{ city: 'Ballylinch (Waterford)', zip: '800783' },
	{ city: 'Ballylinch Demesne (Kilkenny)', zip: '690467' },
	{ city: 'Ballylinchy (Cork)', zip: '314513' },
	{ city: 'Ballyline (Clare)', zip: '739527' },
	{ city: 'Ballyline (Kilkenny)', zip: '577743' },
	{ city: 'Ballylin East (Galway)', zip: '237167' },
	{ city: 'Ballyline East (Kerry)', zip: '491381' },
	{ city: 'Ballyline West (Kerry)', zip: '769083' },
	{ city: 'Ballyling (Carlow)', zip: '865037' },
	{ city: 'Ballyling (Cork)', zip: '837102' },
	{ city: 'Ballylinnen (Kilkenny)', zip: '232406' },
	{ city: 'Ballylin West (Galway)', zip: '153868' },
	{ city: 'Ballylion (Roscommon)', zip: '879381' },
	{ city: 'Ballylion Bawn (Wicklow)', zip: '768634' },
	{ city: 'Ballylion Lower (Wicklow)', zip: '430726' },
	{ city: 'Ballylion Upper (Wicklow)', zip: '497132' },
	{ city: 'Ballylisheen (Tipperary)', zip: '467811' },
	{ city: 'Ballylongane (Cork)', zip: '532032' },
	{ city: 'Ballylongane (Kerry)', zip: '821066' },
	{ city: 'Ballylongford (Kerry)', zip: '865963' },
	{ city: 'Ballylongford (Limerick)', zip: '586872' },
	{ city: 'Ballylonnan (Offaly)', zip: '748917' },
	{ city: 'Ballyloo (Carlow)', zip: '851591' },
	{ city: 'Ballylooby (Limerick)', zip: '199178' },
	{ city: 'Ballylooby (Tipperary)', zip: '898909' },
	{ city: 'Ballyloohane (Cork)', zip: '546314' },
	{ city: 'Ballylopen (Cork)', zip: '566277' },
	{ city: 'Ballylosky (Donegal)', zip: '981437' },
	{ city: 'Ballylough (Wexford)', zip: '175222' },
	{ city: 'Ballyloughan (Carlow)', zip: '249258' },
	{ city: 'Ballyloughan (Donegal)', zip: '586452' },
	{ city: 'Ballyloughan (Kildare)', zip: '957271' },
	{ city: 'Ballyloughan (Monaghan)', zip: '946885' },
	{ city: 'Ballyloughan (Offaly)', zip: '746390' },
	{ city: 'Ballyloughan (Wexford)', zip: '425802' },
	{ city: 'Ballyloughaun (Galway)', zip: '942953' },
	{ city: 'Ballyloughbeg (Waterford)', zip: '384223' },
	{ city: 'Ballyloughlin (Wexford)', zip: '839358' },
	{ city: 'Ballyloughlin (Wicklow)', zip: '119850' },
	{ city: 'Ballyloughmore (Waterford)', zip: '201628' },
	{ city: 'Ballyloughnaan (Limerick)', zip: '339369' },
	{ city: 'Ballyloughnane (Tipperary)', zip: '122791' },
	{ city: 'Ballyloughran (Kerry)', zip: '465067' },
	{ city: 'Ballyloundash (Limerick)', zip: '704528' },
	{ city: 'Ballylow (Wicklow)', zip: '572425' },
	{ city: 'Ballylower (Carlow)', zip: '236944' },
	{ city: 'Ballylowra (Kilkenny)', zip: '436776' },
	{ city: 'Ballylucas (Wexford)', zip: '936580' },
	{ city: 'Ballyluck (Cork)', zip: '360121' },
	{ city: 'Ballyluddy (Limerick)', zip: '780126' },
	{ city: 'Ballylug (Wicklow)', zip: '883506' },
	{ city: 'Ballylugnagon (Roscommon)', zip: '273096' },
	{ city: 'Ballyluoge (Galway)', zip: '424530' },
	{ city: 'Ballylurkin (Wexford)', zip: '909824' },
	{ city: 'Ballylusk (Laois)', zip: '760735' },
	{ city: 'Ballylusk (Wexford)', zip: '576693' },
	{ city: 'Ballylusk (Wicklow)', zip: '944971' },
	{ city: 'Ballylusky (Cork)', zip: '145622' },
	{ city: 'Ballylusky (Kerry)', zip: '580425' },
	{ city: 'Ballylusky (Kilkenny)', zip: '800078' },
	{ city: 'Ballylusky (Limerick)', zip: '307233' },
	{ city: 'Ballylusky (Tipperary)', zip: '515277' },
	{ city: 'Ballylynan (Laois)', zip: '683162' },
	{ city: 'Ballylynch (Tipperary)', zip: '545991' },
	{ city: 'Ballymabilla (Galway)', zip: '674717' },
	{ city: 'Ballymabin (Waterford)', zip: '634323' },
	{ city: 'Ballymacad (Meath)', zip: '595572' },
	{ city: 'Ballymacadam (Kerry)', zip: '677867' },
	{ city: 'Ballymacadam (Tipperary)', zip: '980669' },
	{ city: 'Ballymacadam East (Tipperary)', zip: '558147' },
	{ city: 'Ballymacadam West (Tipperary)', zip: '967653' },
	{ city: 'Ballymacadoyle (Kerry)', zip: '221456' },
	{ city: 'Ballymacady (Tipperary)', zip: '702263' },
	{ city: 'Ballymacahara (Wicklow)', zip: '291816' },
	{ city: 'Ballymacahil (Donegal)', zip: '965490' },
	{ city: 'Ballymacahil And Derries (Westmeath)', zip: '163688' },
	{ city: 'Ballymacahill (Clare)', zip: '846212' },
	{ city: 'Ballymacallen (Cork)', zip: '804858' },
	{ city: 'Ballymacallen (Westmeath)', zip: '243103' },
	{ city: 'Ballymacan (Meath)', zip: '959028' },
	{ city: 'Ballymacandrew North (Kerry)', zip: '828364' },
	{ city: 'Ballymacandrew South (Kerry)', zip: '247826' },
	{ city: 'Ballymacandrick (Cork)', zip: '669497' },
	{ city: 'Ballymacandy (Kerry)', zip: '835695' },
	{ city: 'Ballymacane (Wexford)', zip: '461375' },
	{ city: 'Ballymacaquim East (Kerry)', zip: '402948' },
	{ city: 'Ballymacaquim West (Kerry)', zip: '147291' },
	{ city: 'Ballymacar (Wexford)', zip: '381127' },
	{ city: 'Ballymacarbry (Waterford)', zip: '114671' },
	{ city: 'Ballymacarney (Meath)', zip: '248399' },
	{ city: 'Ballymacarry (Donegal)', zip: '522952' },
	{ city: 'Ballymacarry Lower (Donegal)', zip: '886715' },
	{ city: 'Ballymacartan (Westmeath)', zip: '196810' },
	{ city: 'Ballymacarthur (Donegal)', zip: '549384' },
	{ city: 'Ballymacartle (Dublin)', zip: '509125' },
	{ city: 'Ballymacart Lower (Waterford)', zip: '923792' },
	{ city: 'Ballymacart Upper (Waterford)', zip: '645126' },
	{ city: 'Ballymacashel (Limerick)', zip: '788476' },
	{ city: 'Ballymacask (Cork)', zip: '368096' },
	{ city: 'Ballymacasy (Kerry)', zip: '435223' },
	{ city: 'Ballymacaula (Clare)', zip: '819328' },
	{ city: 'Ballymacavany (Donegal)', zip: '163685' },
	{ city: 'Ballymacave (Limerick)', zip: '205148' },
	{ city: 'Ballymacaw (Cork)', zip: '434774' },
	{ city: 'Ballymacaw (Waterford)', zip: '935376' },
	{ city: 'Ballymacaward (Donegal)', zip: '552768' },
	{ city: 'Ballymacdonagh (Limerick)', zip: '884829' },
	{ city: 'Ballymacdonnell (Clare)', zip: '784172' },
	{ city: 'Ballymacdonnell (Kerry)', zip: '236314' },
	{ city: 'Ballymacegan (Tipperary)', zip: '274025' },
	{ city: 'Ballymacelligott (Kerry)', zip: '459088' },
	{ city: 'Ballymacfarrane (Roscommon)', zip: '936033' },
	{ city: 'Ballymacforban (Monaghan)', zip: '666960' },
	{ city: 'Ballymacgibbon North (Mayo)', zip: '374620' },
	{ city: 'Ballymacgibbon South (Mayo)', zip: '643540' },
	{ city: 'Ballymachugh (Mayo)', zip: '220612' },
	{ city: 'Ballymachugh (Westmeath)', zip: '753168' },
	{ city: 'Ballymacjordan (Kerry)', zip: '893132' },
	{ city: 'Ballymack (Kilkenny)', zip: '118739' },
	{ city: 'Ballymackan (Laois)', zip: '527265' },
	{ city: 'Ballymackane (Tipperary)', zip: '113784' },
	{ city: 'Ballymackea Beg (Clare)', zip: '404525' },
	{ city: 'Ballymackeamore (Limerick)', zip: '448470' },
	{ city: 'Ballymackea More (Clare)', zip: '968895' },
	{ city: 'Ballymackean (Cork)', zip: '776209' },
	{ city: 'Ballymackeehola (Mayo)', zip: '884792' },
	{ city: 'Ballymackeogh (Mayo)', zip: '739470' },
	{ city: 'Ballymackeogh (Tipperary)', zip: '669819' },
	{ city: 'Ballymackesy (Limerick)', zip: '294858' },
	{ city: 'Ballymackesy (Wexford)', zip: '840795' },
	{ city: 'Ballymackey (Tipperary)', zip: '560191' },
	{ city: 'Ballymackibbot (Cork)', zip: '675971' },
	{ city: 'Ballymackilduff (Donegal)', zip: '168138' },
	{ city: 'Ballymackillagill (Kilkenny)', zip: '396958' },
	{ city: 'Ballymackinroe (Cavan)', zip: '596777' },
	{ city: 'Ballymackney (Monaghan)', zip: '137322' },
	{ city: 'Ballymacky (Wexford)', zip: '458090' },
	{ city: 'Ballymaclare (Wexford)', zip: '795983' },
	{ city: 'Ballymaclawrence (Cork)', zip: '878410' },
	{ city: 'Ballymaclifford (Longford)', zip: '555617' },
	{ city: 'Ballymaclinaun (Clare)', zip: '415741' },
	{ city: 'Ballymacloon East (Clare)', zip: '742330' },
	{ city: 'Ballymacloon North (Clare)', zip: '913521' },
	{ city: 'Ballymacloon West (Clare)', zip: '583433' },
	{ city: 'Ballymacloughlin (Mayo)', zip: '810101' },
	{ city: 'Ballymacmague East (Waterford)', zip: '200756' },
	{ city: 'Ballymacmague North (Waterford)', zip: '984390' },
	{ city: 'Ballymacmague South (Waterford)', zip: '607235' },
	{ city: 'Ballymacmague West (Waterford)', zip: '252655' },
	{ city: 'Ballymacmoriarty (Donegal)', zip: '709887' },
	{ city: 'Ballymacmorris (Westmeath)', zip: '229870' },
	{ city: 'Ballymacmoy (Cork)', zip: '278523' },
	{ city: 'Ballymacmurragh (Cork)', zip: '519652' },
	{ city: 'Ballymacmurragh (Offaly)', zip: '690761' },
	{ city: 'Ballymacnevin (Clare)', zip: '638158' },
	{ city: 'Ballymacoda (Cork)', zip: '199850' },
	{ city: 'Ballymacolgan (Meath)', zip: '428851' },
	{ city: 'Ballymacoll (Meath)', zip: '963593' },
	{ city: 'Ballymacoll Little (Meath)', zip: '355670' },
	{ city: 'Ballymaconey (Wicklow)', zip: '333640' },
	{ city: 'Ballymaconna (Clare)', zip: '383763' },
	{ city: 'Ballymacoo (Cork)', zip: '476793' },
	{ city: 'Ballymacooda (Clare)', zip: '336266' },
	{ city: 'Ballymacool (Donegal)', zip: '301251' },
	{ city: 'Ballymacoolaghan (Offaly)', zip: '670877' },
	{ city: 'Ballymacooly Beg (Cork)', zip: '412219' },
	{ city: 'Ballymacooly More (Cork)', zip: '957894' },
	{ city: 'Ballymacoonoge (Wexford)', zip: '318505' },
	{ city: 'Ballymacorcoran (Cork)', zip: '121933' },
	{ city: 'Ballymacotter (Cork)', zip: '741159' },
	{ city: 'Ballymacowen (Cork)', zip: '767785' },
	{ city: 'Ballymacphadin (Donegal)', zip: '245036' },
	{ city: 'Ballymacphilip (Cork)', zip: '537776' },
	{ city: 'Ballymacpierce (Cork)', zip: '730571' },
	{ city: 'Ballymacpierce (Kerry)', zip: '575744' },
	{ city: 'Ballymacprior (Kerry)', zip: '629615' },
	{ city: 'Ballymacquin Lower (Kerry)', zip: '634650' },
	{ city: 'Ballymacquin Upper (Kerry)', zip: '783455' },
	{ city: 'Ballymacrah (Mayo)', zip: '306800' },
	{ city: 'Ballymacraheen (Cork)', zip: '319529' },
	{ city: 'Ballymacravan (Clare)', zip: '223607' },
	{ city: 'Ballymacredmond (Cork)', zip: '846770' },
	{ city: 'Ballymacredmond (Mayo)', zip: '284865' },
	{ city: 'Ballymacreese (Limerick)', zip: '906092' },
	{ city: 'Ballymacrinan (Clare)', zip: '152376' },
	{ city: 'Ballymacrogan East (Clare)', zip: '627833' },
	{ city: 'Ballymacrogan West (Clare)', zip: '457402' },
	{ city: 'Ballymacroly (Longford)', zip: '820990' },
	{ city: 'Ballymacrory (Laois)', zip: '260172' },
	{ city: 'Ballymacrory (Limerick)', zip: '145389' },
	{ city: 'Ballymacrossan (Offaly)', zip: '773882' },
	{ city: 'Ballymacrown (Cork)', zip: '480870' },
	{ city: 'Ballymacshane (Longford)', zip: '519530' },
	{ city: 'Ballymacshaneboy (Limerick)', zip: '371344' },
	{ city: 'Ballymacsherron (Mayo)', zip: '454441' },
	{ city: 'Ballymacshoneen (Cork)', zip: '744204' },
	{ city: 'Ballymacshoneen (Wexford)', zip: '649029' },
	{ city: 'Ballymacsimon (Cork)', zip: '110226' },
	{ city: 'Ballymacsimon (Wexford)', zip: '298302' },
	{ city: 'Ballymacsimon (Wicklow)', zip: '370763' },
	{ city: 'Ballymacsliney (Cork)', zip: '367861' },
	{ city: 'Ballymacsradeen East (Limerick)', zip: '154315' },
	{ city: 'Ballymacsradeen West (Limerick)', zip: '457245' },
	{ city: 'Ballymacthomas (Kerry)', zip: '663203' },
	{ city: 'Ballymacue (Tipperary)', zip: '946896' },
	{ city: 'Ballymacurly (Roscommon)', zip: '475555' },
	{ city: 'Ballymacurly North (Roscommon)', zip: '558348' },
	{ city: 'Ballymacurly South (Roscommon)', zip: '473773' },
	{ city: 'Ballymacurtaun (Clare)', zip: '869894' },
	{ city: 'Ballymacus (Cork)', zip: '746034' },
	{ city: 'Ballymacushin (Wexford)', zip: '953827' },
	{ city: 'Ballymacward (Galway)', zip: '482308' },
	{ city: 'Ballymacwilliam (Longford)', zip: '182810' },
	{ city: 'Ballymacwilliam (Offaly)', zip: '712294' },
	{ city: 'Ballymacwilliam East (Cork)', zip: '954983' },
	{ city: 'Ballymacwilliam South (Cork)', zip: '593682' },
	{ city: 'Ballymacwilliam West (Cork)', zip: '883170' },
	{ city: 'Ballymad (Meath)', zip: '369550' },
	{ city: 'Ballymadder (Wexford)', zip: '832840' },
	{ city: 'Ballymaddock (Laois)', zip: '355533' },
	{ city: 'Ballymaddock (Offaly)', zip: '913966' },
	{ city: 'Ballymadeer (Kildare)', zip: '735131' },
	{ city: 'Ballymadog (Cork)', zip: '907968' },
	{ city: 'Ballymadrough (Dublin)', zip: '462471' },
	{ city: 'Ballymadun (Dublin)', zip: '136422' },
	{ city: 'Ballymagahy Mountain (Donegal)', zip: '363289' },
	{ city: 'Ballymagahy North (Donegal)', zip: '411067' },
	{ city: 'Ballymagahy South (Donegal)', zip: '888895' },
	{ city: 'Ballymagan Upper And Lower And Clonblosk (Donegal)', zip: '842097' },
	{ city: 'Ballymagaraghy (Donegal)', zip: '800953' },
	{ city: 'Ballymagarvey (Meath)', zip: '767370' },
	{ city: 'Ballymagauran (Cavan)', zip: '796403' },
	{ city: 'Ballymageragh (Louth)', zip: '415401' },
	{ city: 'Ballymageraghty (Galway)', zip: '838805' },
	{ city: 'Ballymaghery (Westmeath)', zip: '833739' },
	{ city: 'Ballymaghroe (Wicklow)', zip: '867554' },
	{ city: 'Ballymagillin (Meath)', zip: '246918' },
	{ city: 'Ballymaging (Roscommon)', zip: '891605' },
	{ city: 'Ballymagirril (Cavan)', zip: '819630' },
	{ city: 'Ballymaglancy (Galway)', zip: '118343' },
	{ city: 'Ballymaglancy (Roscommon)', zip: '721759' },
	{ city: 'Ballymaglane (Louth)', zip: '490101' },
	{ city: 'Ballymaglassan (Meath)', zip: '393622' },
	{ city: 'Ballymaglavy (Westmeath)', zip: '435728' },
	{ city: 'Ballymagooly (Cork)', zip: '483004' },
	{ city: 'Ballymagowan (Donegal)', zip: '383509' },
	{ city: 'Ballymagowan Lower (Donegal)', zip: '731862' },
	{ city: 'Ballymagowan Upper (Donegal)', zip: '191083' },
	{ city: 'Ballymagree (Tipperary)', zip: '291445' },
	{ city: 'Ballymagrine (Roscommon)', zip: '891070' },
	{ city: 'Ballymagrorty (Donegal)', zip: '651868' },
	{ city: 'Ballymagrorty Irish (Donegal)', zip: '320994' },
	{ city: 'Ballymagrorty Scotch (Donegal)', zip: '175872' },
	{ city: 'Ballymague (Cork)', zip: '975259' },
	{ city: 'Ballymaguire (Dublin)', zip: '202654' },
	{ city: 'Ballymah (Cork)', zip: '945359' },
	{ city: 'Ballymahon (Longford)', zip: '574717' },
	{ city: 'Ballymahon (Meath)', zip: '830711' },
	{ city: 'Ballymahony (Clare)', zip: '698030' },
	{ city: 'Ballymaice (Dublin)', zip: '994865' },
	{ city: 'Ballymakaily (Dublin)', zip: '398732' },
	{ city: 'Ballymakane (Meath)', zip: '712021' },
	{ city: 'Ballymakeagh (Cork)', zip: '408197' },
	{ city: 'Ballymakeagh Beg (Cork)', zip: '382993' },
	{ city: 'Ballymakeagh More (Cork)', zip: '237754' },
	{ city: 'Ballymakealy Lower (Kildare)', zip: '292669' },
	{ city: 'Ballymakealy Upper (Kildare)', zip: '980449' },
	{ city: 'Ballymakee (Waterford)', zip: '638611' },
	{ city: 'Ballymakeegan (Longford)', zip: '348084' },
	{ city: 'Ballymakeery (Cork)', zip: '247481' },
	{ city: 'Ballymakeery (Limerick)', zip: '754352' },
	{ city: 'Ballymakegoge (Kerry)', zip: '766502' },
	{ city: 'Ballymakellett (Louth)', zip: '701157' },
	{ city: 'Ballymakenny (Louth)', zip: '451329' },
	{ city: 'Ballymaleel (Donegal)', zip: '799609' },
	{ city: 'Ballymaley (Clare)', zip: '625269' },
	{ city: 'Ballymalis (Kerry)', zip: '581347' },
	{ city: 'Ballymaloe Beg (Cork)', zip: '410281' },
	{ city: 'Ballymaloe More (Cork)', zip: '262827' },
	{ city: 'Ballymalone (Clare)', zip: '559596' },
	{ city: 'Ballymalone Beg (Tipperary)', zip: '728791' },
	{ city: 'Ballymalone More (Tipperary)', zip: '965891' },
	{ city: 'Ballyman (Dublin)', zip: '530266' },
	{ city: 'Ballymana (Dublin)', zip: '877437' },
	{ city: 'Ballymanaggin (Dublin)', zip: '330215' },
	{ city: 'Ballymanagh (Galway)', zip: '993550' },
	{ city: 'Ballymanagh (Kerry)', zip: '391761' },
	{ city: 'Ballymanagh (Mayo)', zip: '745007' },
	{ city: 'Ballymangan (Mayo)', zip: '999684' },
	{ city: 'Ballymanus (Laois)', zip: '436353' },
	{ city: 'Ballymanus (Westmeath)', zip: '963584' },
	{ city: 'Ballymanus (Wicklow)', zip: '778098' },
	{ city: 'Ballymanus Lower (Wicklow)', zip: '457648' },
	{ city: 'Ballymanus Upper (Wicklow)', zip: '124371' },
	{ city: 'Ballymany (Kildare)', zip: '695146' },
	{ city: 'Ballymaquiff North (Galway)', zip: '929467' },
	{ city: 'Ballymaquiff South (Galway)', zip: '418957' },
	{ city: 'Ballymaquiggin (Clare)', zip: '562916' },
	{ city: 'Ballymaquin (Donegal)', zip: '657276' },
	{ city: 'Ballymaquirk (Cork)', zip: '783942' },
	{ city: 'Ballymarcahaun (Galway)', zip: '806715' },
	{ city: 'Ballymariscal (Galway)', zip: '498287' },
	{ city: 'Ballymarkahan (Clare)', zip: '844657' },
	{ city: 'Ballymarroge (Wicklow)', zip: '398905' },
	{ city: 'Ballymartin (Carlow)', zip: '170411' },
	{ city: 'Ballymartin (Cork)', zip: '306817' },
	{ city: 'Ballymartin (Galway)', zip: '672870' },
	{ city: 'Ballymartin (Kilkenny)', zip: '972275' },
	{ city: 'Ballymartin (Limerick)', zip: '630832' },
	{ city: 'Ballymartin (Mayo)', zip: '166578' },
	{ city: 'Ballymartin (Roscommon)', zip: '114045' },
	{ city: 'Ballymartin (Wexford)', zip: '856132' },
	{ city: 'Ballymartin Beg (Roscommon)', zip: '452767' },
	{ city: 'Ballymartin More (Roscommon)', zip: '854795' },
	{ city: 'Ballymartin North (Waterford)', zip: '977189' },
	{ city: 'Ballymartin South (Waterford)', zip: '691075' },
	{ city: 'Ballymartle (Cork)', zip: '895874' },
	{ city: 'Ballymary (Galway)', zip: '268620' },
	{ city: 'Ballymascanlan (Louth)', zip: '464631' },
	{ city: 'Ballymassy (Tipperary)', zip: '207259' },
	{ city: 'Ballymassy Little (Tipperary)', zip: '272126' },
	{ city: 'Ballymastone (Dublin)', zip: '209789' },
	{ city: 'Ballymaurice (Longford)', zip: '226065' },
	{ city: 'Ballymee (Cork)', zip: '628426' },
	{ city: 'Ballymeelish (Laois)', zip: '719783' },
	{ city: 'Ballymeeny (Sligo)', zip: '863198' },
	{ city: 'Ballymerret (Galway)', zip: '396055' },
	{ city: 'Ballymerrigan (Wicklow)', zip: '499657' },
	{ city: 'Ballymichael (Cork)', zip: '266971' },
	{ city: 'Ballymichael (Donegal)', zip: '356514' },
	{ city: 'Ballymichael (Wexford)', zip: '210406' },
	{ city: 'Ballymichan (Longford)', zip: '187577' },
	{ city: 'Ballymihil (Clare)', zip: '555151' },
	{ city: 'Ballymiles (Mayo)', zip: '494267' },
	{ city: 'Ballyminaun (Wexford)', zip: '487125' },
	{ city: 'Ballyminaun Big (Wexford)', zip: '969054' },
	{ city: 'Ballyminaunhill (Wexford)', zip: '978919' },
	{ city: 'Ballyminaun Little (Wexford)', zip: '486757' },
	{ city: 'Ballyminion (Longford)', zip: '333578' },
	{ city: 'Ballyminoge (Clare)', zip: '759467' },
	{ city: 'Ballymintan (Roscommon)', zip: '546678' },
	{ city: 'Ballymitty (Wexford)', zip: '333399' },
	{ city: 'Ballymoat (Galway)', zip: '100480' },
	{ city: 'Ballymoat (Waterford)', zip: '150711' },
	{ city: 'Ballymoat (Wicklow)', zip: '812991' },
	{ city: 'Ballymoat Lower (Waterford)', zip: '409756' },
	{ city: 'Ballymoat Upper (Waterford)', zip: '960315' },
	{ city: 'Ballymoe (Galway)', zip: '812190' },
	{ city: 'Ballymoghany (Sligo)', zip: '952000' },
	{ city: 'Ballymogue (Carlow)', zip: '302749' },
	{ city: 'Ballymoheen (Tipperary)', zip: '312346' },
	{ city: 'Ballymoloney (Clare)', zip: '435277' },
	{ city: 'Ballymona (Tipperary)', zip: '709182' },
	{ city: 'Ballymonaster (Donegal)', zip: '994347' },
	{ city: 'Ballymoneen (Galway)', zip: '142505' },
	{ city: 'Ballymoneen (Mayo)', zip: '182669' },
	{ city: 'Ballymoneen (Sligo)', zip: '465331' },
	{ city: 'Ballymoneen (Wicklow)', zip: '961920' },
	{ city: 'Ballymoneen East (Galway)', zip: '409664' },
	{ city: 'Ballymoneen West (Galway)', zip: '113317' },
	{ city: 'Ballymoney (Donegal)', zip: '580720' },
	{ city: 'Ballymoney (Wicklow)', zip: '760145' },
	{ city: 'Ballymoney Lower (Wexford)', zip: '482892' },
	{ city: 'Ballymoney North (Galway)', zip: '977666' },
	{ city: 'Ballymoney South (Galway)', zip: '893517' },
	{ city: 'Ballymoney Upper (Wexford)', zip: '445523' },
	{ city: 'Ballymongaun (Clare)', zip: '853118' },
	{ city: 'Ballymongaun (Limerick)', zip: '522918' },
	{ city: 'Ballymonteen (Cork)', zip: '694488' },
	{ city: 'Ballymoodranagh (Waterford)', zip: '399593' },
	{ city: 'Ballymoon (Carlow)', zip: '990582' },
	{ city: 'Ballymoon (Donegal)', zip: '196221' },
	{ city: 'Ballymooney (Laois)', zip: '377491' },
	{ city: 'Ballymooney (Offaly)', zip: '508839' },
	{ city: 'Ballymooney (Wicklow)', zip: '863252' },
	{ city: 'Ballymoran (Offaly)', zip: '564557' },
	{ city: 'Ballymore (Cork)', zip: '320887' },
	{ city: 'Ballymore (Donegal)', zip: '456731' },
	{ city: 'Ballymore (Galway)', zip: '749098' },
	{ city: 'Ballymore (Kerry)', zip: '252612' },
	{ city: 'Ballymore (Leitrim)', zip: '823661' },
	{ city: 'Ballymore (Longford)', zip: '628942' },
	{ city: 'Ballymore (Mayo)', zip: '304653' },
	{ city: 'Ballymore (Meath)', zip: '856967' },
	{ city: 'Ballymore (Tipperary)', zip: '812453' },
	{ city: 'Ballymore (Westmeath)', zip: '974539' },
	{ city: 'Ballymore (Wexford)', zip: '745475' },
	{ city: 'Bally More (Roscommon)', zip: '501704' },
	{ city: 'Ballymore Demense (Wexford)', zip: '951425' },
	{ city: 'Ballymore East (Kerry)', zip: '255884' },
	{ city: 'Ballymore East (Roscommon)', zip: '486449' },
	{ city: 'Ballymore Eustace (Kildare)', zip: '891301' },
	{ city: 'Ballymore Eustace East (Kildare)', zip: '597617' },
	{ city: 'Ballymore Eustace West (Kildare)', zip: '579427' },
	{ city: 'Ballymorefinn (Dublin)', zip: '374778' },
	{ city: 'Ballymore Lower (Donegal)', zip: '834115' },
	{ city: 'Ballymore Lower (Galway)', zip: '206388' },
	{ city: 'Ballymorereagh (Kerry)', zip: '788625' },
	{ city: 'Ballymore Upper (Donegal)', zip: '228504' },
	{ city: 'Ballymore Upper (Galway)', zip: '946574' },
	{ city: 'Ballymore West (Kerry)', zip: '959018' },
	{ city: 'Ballymore West (Roscommon)', zip: '543917' },
	{ city: 'Ballymorgan (Wexford)', zip: '958471' },
	{ city: 'Ballymorin (Westmeath)', zip: '481632' },
	{ city: 'Ballymorisheen (Cork)', zip: '536386' },
	{ city: 'Ballymorris (Clare)', zip: '820863' },
	{ city: 'Ballymorris (Kilkenny)', zip: '512388' },
	{ city: 'Ballymorris (Laois)', zip: '887746' },
	{ city: 'Ballymorris (Tipperary)', zip: '585530' },
	{ city: 'Ballymorris (Waterford)', zip: '521523' },
	{ city: 'Ballymorris (Wexford)', zip: '114297' },
	{ city: 'Ballymorris (Wicklow)', zip: '516762' },
	{ city: 'Ballymorrisheen (Limerick)', zip: '355449' },
	{ city: 'Ballymorris Lower (Wicklow)', zip: '501439' },
	{ city: 'Ballymorris Upper (Wicklow)', zip: '474934' },
	{ city: 'Ballymot (Cork)', zip: '456840' },
	{ city: 'Ballymote (Sligo)', zip: '633466' },
	{ city: 'Ballymoty Beg (Wexford)', zip: '511073' },
	{ city: 'Ballymoty More (Wexford)', zip: '220126' },
	{ city: 'Ballymount (Kildare)', zip: '569358' },
	{ city: 'Ballymountain (Cork)', zip: '221423' },
	{ city: 'Ballymountain (Kilkenny)', zip: '188324' },
	{ city: 'Ballymount Great (Dublin)', zip: '158382' },
	{ city: 'Ballymount Little (Dublin)', zip: '542948' },
	{ city: 'Ballymoyle (Laois)', zip: '698063' },
	{ city: 'Ballymoyle (Wicklow)', zip: '963610' },
	{ city: 'Ballymoylin (Roscommon)', zip: '528644' },
	{ city: 'Ballymoylin (Tipperary)', zip: '581906' },
	{ city: 'Ballymoyock (Mayo)', zip: '698522' },
	{ city: 'Ballymuddy (Waterford)', zip: '509095' },
	{ city: 'Ballymulalla East (Waterford)', zip: '728279' },
	{ city: 'Ballymulalla West (Waterford)', zip: '336426' },
	{ city: 'Ballymulcashel (Clare)', zip: '745714' },
	{ city: 'Ballymuldorry (Sligo)', zip: '292597' },
	{ city: 'Ballymulfaig (Galway)', zip: '394335' },
	{ city: 'Ballymullanny (Sligo)', zip: '713041' },
	{ city: 'Ballymullavil (Mayo)', zip: '773801' },
	{ city: 'Ballymullavill (Roscommon)', zip: '526431' },
	{ city: 'Ballymullen (Galway)', zip: '261814' },
	{ city: 'Ballymullen (Kerry)', zip: '337605' },
	{ city: 'Ballymullen (Laois)', zip: '426314' },
	{ city: 'Ballymullen (Offaly)', zip: '397148' },
	{ city: 'Ballymulmore (Meath)', zip: '310609' },
	{ city: 'Ballymulqueeny (Clare)', zip: '543647' },
	{ city: 'Ballymulrennan (Roscommon)', zip: '729779' },
	{ city: 'Ballymulvey (Longford)', zip: '280505' },
	{ city: 'Ballymun (Dublin)', zip: '627689' },
	{ city: 'Ballymunterhiggin (Donegal)', zip: '430887' },
	{ city: 'Ballymurn (Wexford)', zip: '187557' },
	{ city: 'Ballymurn Lower (Wexford)', zip: '461403' },
	{ city: 'Ballymurn Upper (Wexford)', zip: '535748' },
	{ city: 'Ballymurphy (Carlow)', zip: '294649' },
	{ city: 'Ballymurphy (Clare)', zip: '847859' },
	{ city: 'Ballymurphy (Galway)', zip: '652403' },
	{ city: 'Ballymurphy (Limerick)', zip: '316218' },
	{ city: 'Ballymurphy (Mayo)', zip: '620760' },
	{ city: 'Ballymurphy (Meath)', zip: '727563' },
	{ city: 'Ballymurphy Lower (Cork)', zip: '907392' },
	{ city: 'Ballymurphy North (Cork)', zip: '398248' },
	{ city: 'Ballymurphy South (Cork)', zip: '565546' },
	{ city: 'Ballymurphy Upper (Cork)', zip: '569067' },
	{ city: 'Ballymurragh (Kilkenny)', zip: '761488' },
	{ city: 'Ballymurragh (Wexford)', zip: '172567' },
	{ city: 'Ballymurragh East (Limerick)', zip: '624021' },
	{ city: 'Ballymurragh West (Limerick)', zip: '872658' },
	{ city: 'Ballymurray (Roscommon)', zip: '326295' },
	{ city: 'Ballymurray (Sligo)', zip: '334237' },
	{ city: 'Ballymurreen (Tipperary)', zip: '833454' },
	{ city: 'Ballymurrin (Waterford)', zip: '359304' },
	{ city: 'Ballymurrin Lower (Wicklow)', zip: '534854' },
	{ city: 'Ballymurrin Upper (Wicklow)', zip: '875354' },
	{ city: 'Ballymurry (Galway)', zip: '158510' },
	{ city: 'Ballymurry (Westmeath)', zip: '221396' },
	{ city: 'Ballymurry (Wexford)', zip: '592596' },
	{ city: 'Ballymurtagh (Clare)', zip: '663897' },
	{ city: 'Ballymurtagh (Wexford)', zip: '545645' },
	{ city: 'Ballymurtagh (Wicklow)', zip: '601078' },
	{ city: 'Ballynaas Great (Wexford)', zip: '501710' },
	{ city: 'Ballynaas Little (Wexford)', zip: '910029' },
	{ city: 'Ballynabanaba (Galway)', zip: '816670' },
	{ city: 'Ballynabanoge (Limerick)', zip: '147312' },
	{ city: 'Ballynabanoge (Wexford)', zip: '485554' },
	{ city: 'Ballynabanoge North (Waterford)', zip: '325149' },
	{ city: 'Ballynabanoge South (Waterford)', zip: '396491' },
	{ city: 'Ballynabarna (Kildare)', zip: '882773' },
	{ city: 'Ballynabarney (Wexford)', zip: '451048' },
	{ city: 'Ballynabarny (Meath)', zip: '138319' },
	{ city: 'Ballynabarny (Wexford)', zip: '314861' },
	{ city: 'Ballynabarny (Wicklow)', zip: '444172' },
	{ city: 'Ballynabearna (Cork)', zip: '674237' },
	{ city: 'Ballynabearna (Limerick)', zip: '980386' },
	{ city: 'Ballynabearna (Wexford)', zip: '824493' },
	{ city: 'Ballynaberny (Wexford)', zip: '917789' },
	{ city: 'Ballynabinnia (Clare)', zip: '204667' },
	{ city: 'Ballynabloun (Kerry)', zip: '549004' },
	{ city: 'Ballynabointra (Cork)', zip: '805135' },
	{ city: 'Ballynabola (Waterford)', zip: '875500' },
	{ city: 'Ballynabola (Wexford)', zip: '946546' },
	{ city: 'Ballynaboley (Carlow)', zip: '795438' },
	{ city: 'Ballynaboley (Kildare)', zip: '795779' },
	{ city: 'Ballynaboley (Kilkenny)', zip: '424371' },
	{ city: 'Ballynaboll (Leitrim)', zip: '740644' },
	{ city: 'Ballynaboll (Mayo)', zip: '856006' },
	{ city: 'Ballynaboll (Sligo)', zip: '666380' },
	{ city: 'Ballynaboll North (Mayo)', zip: '758173' },
	{ city: 'Ballynaboll South (Mayo)', zip: '768487' },
	{ city: 'Ballynaboola (Cork)', zip: '158070' },
	{ city: 'Ballynaboola West (Cork)', zip: '758151' },
	{ city: 'Ballynabooly (Cork)', zip: '810755' },
	{ city: 'Ballynabooly (Kerry)', zip: '511841' },
	{ city: 'Ballynaboorkagh (Galway)', zip: '214397' },
	{ city: 'Ballynabortagh (Cork)', zip: '636085' },
	{ city: 'Ballynaboul (Cork)', zip: '987156' },
	{ city: 'Ballynaboul (Kerry)', zip: '426888' },
	{ city: 'Ballynabrannagh East (Cork)', zip: '500637' },
	{ city: 'Ballynabrannagh West (Cork)', zip: '416162' },
	{ city: 'Ballynabreen (Donegal)', zip: '681146' },
	{ city: 'Ballynabrehon North (Mayo)', zip: '926727' },
	{ city: 'Ballynabrehon South (Mayo)', zip: '994553' },
	{ city: 'Ballynabrennagh Lower (Kerry)', zip: '618001' },
	{ city: 'Ballynabrennagh Upper (Kerry)', zip: '494682' },
	{ city: 'Ballynabrigadane (Wexford)', zip: '106521' },
	{ city: 'Ballynabrock (Cork)', zip: '648421' },
	{ city: 'Ballynabrock (Sligo)', zip: '800968' },
	{ city: 'Ballynabrocky (Wicklow)', zip: '488965' },
	{ city: 'Ballynabrone (Clare)', zip: '997347' },
	{ city: 'Ballynabuck (Kerry)', zip: '573756' },
	{ city: 'Ballynabucky (Galway)', zip: '510240' },
	{ city: 'Ballynacaheragh (Cork)', zip: '420737' },
	{ city: 'Ballynacaheragh (Limerick)', zip: '549942' },
	{ city: 'Ballynacallagh (Cork)', zip: '937958' },
	{ city: 'Ballynacally (Clare)', zip: '977361' },
	{ city: 'Ballynacally (Limerick)', zip: '126892' },
	{ city: 'Ballynacanty (Offaly)', zip: '313608' },
	{ city: 'Ballynacard (Offaly)', zip: '993338' },
	{ city: 'Ballynacarhagh (Clare)', zip: '494088' },
	{ city: 'Ballynacarragh (Mayo)', zip: '312547' },
	{ city: 'Ballynacarrick (Donegal)', zip: '793348' },
	{ city: 'Ballynacarrick (Mayo)', zip: '277152' },
	{ city: 'Ballynacarrick Lower (Kildare)', zip: '396856' },
	{ city: 'Ballynacarrick Upper (Kildare)', zip: '236604' },
	{ city: 'Ballynacarrig (Offaly)', zip: '663457' },
	{ city: 'Ballynacarrig (Wexford)', zip: '917971' },
	{ city: 'Ballynacarrig (Wicklow)', zip: '551977' },
	{ city: 'Ballynacarriga (Cork)', zip: '524400' },
	{ city: 'Ballynacarriga (Limerick)', zip: '287264' },
	{ city: 'Ballynacarriga (Mayo)', zip: '623580' },
	{ city: 'Ballynacarriga (Sligo)', zip: '203274' },
	{ city: 'Ballynacarrig East (Kerry)', zip: '751856' },
	{ city: 'Ballynacarrig West (Kerry)', zip: '757847' },
	{ city: 'Ballynacarrigy (Westmeath)', zip: '248613' },
	{ city: 'Ballynacarrigy Old (Westmeath)', zip: '191419' },
	{ city: 'Ballynacarrow (Sligo)', zip: '578966' },
	{ city: 'Ballynacarrow (Westmeath)', zip: '334576' },
	{ city: 'Ballynacarrow North (Sligo)', zip: '530023' },
	{ city: 'Ballynacarrow South (Sligo)', zip: '506093' },
	{ city: 'Ballynaclash (Waterford)', zip: '884107' },
	{ city: 'Ballynaclash (Wexford)', zip: '452981' },
	{ city: 'Ballynaclashy (Cork)', zip: '556387' },
	{ city: 'Ballynacleigh (Leitrim)', zip: '539118' },
	{ city: 'Ballynaclera (Tipperary)', zip: '579248' },
	{ city: 'Ballynacliffy (Westmeath)', zip: '342916' },
	{ city: 'Ballynaclin (Westmeath)', zip: '736899' },
	{ city: 'Ballynaclogh (Galway)', zip: '158587' },
	{ city: 'Ballynaclogh (Limerick)', zip: '496217' },
	{ city: 'Ballynaclogh (Tipperary)', zip: '813303' },
	{ city: 'Ballynaclogh North (Waterford)', zip: '913738' },
	{ city: 'Ballynaclogh South (Waterford)', zip: '981689' },
	{ city: 'Ballynacloghy (Galway)', zip: '146430' },
	{ city: 'Ballynacloghy (Tipperary)', zip: '612314' },
	{ city: 'Ballynaclonagh (Westmeath)', zip: '266472' },
	{ city: 'Ballynacloona (Tipperary)', zip: '622042' },
	{ city: 'Ballynaclose (Meath)', zip: '813664' },
	{ city: 'Ballynacloy (Mayo)', zip: '894572' },
	{ city: 'Ballynacole (Cork)', zip: '271012' },
	{ city: 'Ballynacoolagh (Wexford)', zip: '925859' },
	{ city: 'Ballynacooly (Kilkenny)', zip: '798637' },
	{ city: 'Ballynacor (Donegal)', zip: '304754' },
	{ city: 'Ballynacor (Westmeath)', zip: '533601' },
	{ city: 'Ballynacorra (Cork)', zip: '491602' },
	{ city: 'Ballynacorra (Galway)', zip: '847100' },
	{ city: 'Ballynacorra (Westmeath)', zip: '567963' },
	{ city: 'Ballynacorra East (Cork)', zip: '532153' },
	{ city: 'Ballynacorra West (Cork)', zip: '178831' },
	{ city: 'Ballynacoska (Westmeath)', zip: '371417' },
	{ city: 'Ballynacourty (Cork)', zip: '581859' },
	{ city: 'Ballynacourty (Galway)', zip: '832229' },
	{ city: 'Ballynacourty (Kerry)', zip: '553490' },
	{ city: 'Ballynacourty (Limerick)', zip: '469763' },
	{ city: 'Ballynacourty (Tipperary)', zip: '826541' },
	{ city: 'Ballynacourty (Waterford)', zip: '879416' },
	{ city: 'Ballynacourty North (Waterford)', zip: '592399' },
	{ city: 'Ballynacourty South (Waterford)', zip: '759266' },
	{ city: 'Ballynacragga (Clare)', zip: '223945' },
	{ city: 'Ballynacragga (Limerick)', zip: '367542' },
	{ city: 'Ballynacragga North (Limerick)', zip: '129376' },
	{ city: 'Ballynacragga South (Limerick)', zip: '264019' },
	{ city: 'Ballynacraig (Donegal)', zip: '265460' },
	{ city: 'Ballynacree (Meath)', zip: '514140' },
	{ city: 'Ballynacree (Tipperary)', zip: '215367' },
	{ city: 'Ballynacree (Wexford)', zip: '848030' },
	{ city: 'Ballynacregga (Galway)', zip: '791262' },
	{ city: 'Ballynacreg North (Galway)', zip: '877025' },
	{ city: 'Ballynacreg South (Galway)', zip: '233358' },
	{ city: 'Ballynacroghy (Westmeath)', zip: '957407' },
	{ city: 'Ballynacronny (Kilkenny)', zip: '305285' },
	{ city: 'Ballynacross (Longford)', zip: '367805' },
	{ city: 'Ballynacrusha (Cork)', zip: '710414' },
	{ city: 'Ballynacubby (Cork)', zip: '839801' },
	{ city: 'Ballynacullia (Roscommon)', zip: '367571' },
	{ city: 'Ballynacurra (Offaly)', zip: '954030' },
	{ city: 'Ballynacurra (Waterford)', zip: '455837' },
	{ city: 'Ballynacurragh (Galway)', zip: '862317' },
	{ city: 'Ballynadeige (Waterford)', zip: '570374' },
	{ city: 'Ballynadrideen (Cork)', zip: '282761' },
	{ city: 'Ballynadrimna (Meath)', zip: '379619' },
	{ city: 'Ballynadrishoge (Wexford)', zip: '822603' },
	{ city: 'Ballynadruckilly (Tipperary)', zip: '375312' },
	{ city: 'Ballynadrumny (Kildare)', zip: '723544' },
	{ city: 'Ballynafagh (Kildare)', zip: '191585' },
	{ city: 'Ballynafarsid (Cork)', zip: '577525' },
	{ city: 'Ballynafauna (Cork)', zip: '551393' },
	{ city: 'Ballynafeaha (Cork)', zip: '384042' },
	{ city: 'Ballynafearagh (Westmeath)', zip: '852659' },
	{ city: 'Ballynafeeragh (Meath)', zip: '292799' },
	{ city: 'Ballynafid (Westmeath)', zip: '543218' },
	{ city: 'Ballynafina (Waterford)', zip: '201045' },
	{ city: 'Ballynafineshoge (Waterford)', zip: '415886' },
	{ city: 'Ballynafullia (Kerry)', zip: '938736' },
	{ city: 'Ballynafunshin (Laois)', zip: '650830' },
	{ city: 'Ballynagale (Wexford)', zip: '767234' },
	{ city: 'Ballynagall (Laois)', zip: '176646' },
	{ city: 'Ballynagall (Westmeath)', zip: '706377' },
	{ city: 'Ballynagallagh (Limerick)', zip: '724373' },
	{ city: 'Ballynagalliagh (Sligo)', zip: '456722' },
	{ city: 'Ballynagall Little (Westmeath)', zip: '776654' },
	{ city: 'Ballynagally (Limerick)', zip: '601556' },
	{ city: 'Ballynagalshy (Meath)', zip: '637742' },
	{ city: 'Ballynagappagh (Kildare)', zip: '945867' },
	{ city: 'Ballynagar (Galway)', zip: '174449' },
	{ city: 'Ballynagaragh (Cork)', zip: '689227' },
	{ city: 'Ballynagarbragh (Cork)', zip: '356121' },
	{ city: 'Ballynagarbry (Westmeath)', zip: '313533' },
	{ city: 'Ballynagard (Clare)', zip: '644605' },
	{ city: 'Ballynagarde (Limerick)', zip: '768787' },
	{ city: 'Ballynagare (Kerry)', zip: '898039' },
	{ city: 'Ballynagarha (Mayo)', zip: '117736' },
	{ city: 'Ballynagarr (Laois)', zip: '614963' },
	{ city: 'Ballynagarry (Monaghan)', zip: '113160' },
	{ city: 'Ballynagassan (Louth)', zip: '331831' },
	{ city: 'Ballynagaul (Cork)', zip: '350612' },
	{ city: 'Ballynagaul (Limerick)', zip: '885094' },
	{ city: 'Ballynagaul Beg (Waterford)', zip: '221498' },
	{ city: 'Ballynagaul More (Waterford)', zip: '467752' },
	{ city: 'Ballynagee (Wexford)', zip: '512876' },
	{ city: 'Ballynageeha (Galway)', zip: '901335' },
	{ city: 'Ballynageehy (Cork)', zip: '538021' },
	{ city: 'Ballynageeragh (Galway)', zip: '606778' },
	{ city: 'Ballynageeragh (Waterford)', zip: '109920' },
	{ city: 'Ballynageragh (Cork)', zip: '456707' },
	{ city: 'Ballynageragh (Kerry)', zip: '302659' },
	{ city: 'Ballynagh (Offaly)', zip: '964781' },
	{ city: 'Ballynagigla (Waterford)', zip: '360514' },
	{ city: 'Ballynagittagh (Galway)', zip: '778818' },
	{ city: 'Ballynaglack (Donegal)', zip: '975501' },
	{ city: 'Ballynaglea (Mayo)', zip: '802016' },
	{ city: 'Ballynagleragh (Clare)', zip: '142235' },
	{ city: 'Ballynagleragh (Tipperary)', zip: '658675' },
	{ city: 'Ballynagleragh (Waterford)', zip: '444132' },
	{ city: 'Ballynaglogh (Cork)', zip: '190868' },
	{ city: 'Ballynaglogh (Donegal)', zip: '728497' },
	{ city: 'Ballynaglogh (Sligo)', zip: '661577' },
	{ city: 'Ballynaglogh (Wexford)', zip: '669469' },
	{ city: 'Ballynaglogh East (Cork)', zip: '809719' },
	{ city: 'Ballynaglogh West (Cork)', zip: '504198' },
	{ city: 'Ballynagonnaghtagh (Clare)', zip: '160301' },
	{ city: 'Ballynagool (Limerick)', zip: '516616' },
	{ city: 'Ballynagor (Mayo)', zip: '696275' },
	{ city: 'Ballynagore (Cork)', zip: '522153' },
	{ city: 'Ballynagore (Westmeath)', zip: '823222' },
	{ city: 'Ballynagore (Wexford)', zip: '291633' },
	{ city: 'Ballynagorkagh (Waterford)', zip: '422527' },
	{ city: 'Ballynagoshen (Longford)', zip: '747846' },
	{ city: 'Ballynagoul (Limerick)', zip: '674110' },
	{ city: 'Ballynagowan (Limerick)', zip: '734257' },
	{ city: 'Ballynagraigue (Kerry)', zip: '481753' },
	{ city: 'Ballynagrallagh (Wexford)', zip: '536934' },
	{ city: 'Ballynagran (Galway)', zip: '699786' },
	{ city: 'Ballynagran (Wicklow)', zip: '190657' },
	{ city: 'Ballynagrana (Tipperary)', zip: '144995' },
	{ city: 'Ballynagranagh (Clare)', zip: '983364' },
	{ city: 'Ballynagranagh (Limerick)', zip: '303739' },
	{ city: 'Ballynagrane (Carlow)', zip: '114106' },
	{ city: 'Ballynagranshy (Meath)', zip: '668889' },
	{ city: 'Ballynagreanagh (Limerick)', zip: '971760' },
	{ city: 'Ballynagree East (Cork)', zip: '716886' },
	{ city: 'Ballynagreeve (Galway)', zip: '562305' },
	{ city: 'Ballynagree West (Cork)', zip: '475890' },
	{ city: 'Ballynagrena (Louth)', zip: '653562' },
	{ city: 'Ballynagrenia (Westmeath)', zip: '503606' },
	{ city: 'Ballynagrumoolia (Cork)', zip: '323252' },
	{ city: 'Ballynaguila (Limerick)', zip: '682277' },
	{ city: 'Ballynaguilkee Lower (Waterford)', zip: '826351' },
	{ city: 'Ballynaguilkee Upper (Waterford)', zip: '787804' },
	{ city: 'Ballynaguilla (Cork)', zip: '901077' },
	{ city: 'Ballynaguilsha (Offaly)', zip: '129635' },
	{ city: 'Ballynagun East (Clare)', zip: '371122' },
	{ city: 'Ballynagun West (Clare)', zip: '157663' },
	{ city: 'Ballynagussaun (Kildare)', zip: '946095' },
	{ city: 'Ballynahaglish (Mayo)', zip: '410948' },
	{ city: 'Ballynahaha (Limerick)', zip: '907187' },
	{ city: 'Ballynahaia (Cavan)', zip: '380944' },
	{ city: 'Ballynahalisk (Cork)', zip: '202413' },
	{ city: 'Ballynahallee (Limerick)', zip: '507560' },
	{ city: 'Ballynahallia (Galway)', zip: '177989' },
	{ city: 'Ballynahallia (Kerry)', zip: '515251' },
	{ city: 'Ballynahallin (Wexford)', zip: '525478' },
	{ city: 'Ballynaharda (Waterford)', zip: '766819' },
	{ city: 'Ballynahask (Wexford)', zip: '808082' },
	{ city: 'Ballynahattin (Louth)', zip: '202442' },
	{ city: 'Ballynahattina (Galway)', zip: '310983' },
	{ city: 'Ballynaheglish (Roscommon)', zip: '938465' },
	{ city: 'Ballynaheila (Cork)', zip: '103746' },
	{ city: 'Ballynahemery (Waterford)', zip: '516675' },
	{ city: 'Ballynaheskeragh (Galway)', zip: '310722' },
	{ city: 'Ballynahila (Waterford)', zip: '443805' },
	{ city: 'Ballynahillen (Wexford)', zip: '397896' },
	{ city: 'Ballynahimmy (Laois)', zip: '651731' },
	{ city: 'Ballynahina (Cork)', zip: '303235' },
	{ city: 'Ballynahinch (Clare)', zip: '701265' },
	{ city: 'Ballynahinch (Galway)', zip: '539730' },
	{ city: 'Ballynahinch (Kerry)', zip: '192431' },
	{ city: 'Ballynahinch (Limerick)', zip: '948246' },
	{ city: 'Ballynahinch (Longford)', zip: '888684' },
	{ city: 'Ballynahinch (Offaly)', zip: '919951' },
	{ city: 'Ballynahinch (Tipperary)', zip: '404868' },
	{ city: 'Ballynahistil (Galway)', zip: '923209' },
	{ city: 'Ballynahivnia (Galway)', zip: '639947' },
	{ city: 'Ballynahone (Donegal)', zip: '924622' },
	{ city: 'Ballynahone (Monaghan)', zip: '640004' },
	{ city: 'Ballynahoulort (Kerry)', zip: '689201' },
	{ city: 'Ballynahow (Cork)', zip: '106386' },
	{ city: 'Ballynahow (Kerry)', zip: '986101' },
	{ city: 'Ballynahow (Tipperary)', zip: '601716' },
	{ city: 'Ballynahow Beg (Kerry)', zip: '374780' },
	{ city: 'Ballynahow Commons (Kerry)', zip: '812972' },
	{ city: 'Ballynahow More (Kerry)', zip: '710978' },
	{ city: 'Ballynahown (Clare)', zip: '648177' },
	{ city: 'Ballynahown (Cork)', zip: '843555' },
	{ city: 'Ballynahown (Galway)', zip: '846135' },
	{ city: 'Ballynahown (Laois)', zip: '608346' },
	{ city: 'Ballynahown (Limerick)', zip: '655690' },
	{ city: 'Ballynahown (Westmeath)', zip: '842826' },
	{ city: 'Ballynahown (Wexford)', zip: '365380' },
	{ city: 'Ballynahowna (Galway)', zip: '990864' },
	{ city: 'Ballynahowna (Roscommon)', zip: '156084' },
	{ city: 'Ballynahowna (Sligo)', zip: '277484' },
	{ city: 'Ballynahown East (Galway)', zip: '414686' },
	{ city: 'Ballynahown North (Galway)', zip: '718537' },
	{ city: 'Ballynahown South (Galway)', zip: '626066' },
	{ city: 'Ballynahownwood (Westmeath)', zip: '582136' },
	{ city: 'Ballynahulla (Kerry)', zip: '169884' },
	{ city: 'Ballynahunt (Kerry)', zip: '966981' },
	{ city: 'Ballynakeeloge (Donegal)', zip: '325973' },
	{ city: 'Ballynakelly (Dublin)', zip: '664618' },
	{ city: 'Ballynakill (Carlow)', zip: '727438' },
	{ city: 'Ballynakill (Galway)', zip: '895103' },
	{ city: 'Ballynakill (Kildare)', zip: '580727' },
	{ city: 'Ballynakill (Kilkenny)', zip: '821890' },
	{ city: 'Ballynakill (Laois)', zip: '454760' },
	{ city: 'Ballynakill (Limerick)', zip: '801933' },
	{ city: 'Ballynakill (Longford)', zip: '394940' },
	{ city: 'Ballynakill (Meath)', zip: '968934' },
	{ city: 'Ballynakill (Offaly)', zip: '381791' },
	{ city: 'Ballynakill (Sligo)', zip: '453005' },
	{ city: 'Ballynakill (Tipperary)', zip: '925691' },
	{ city: 'Ballynakill (Waterford)', zip: '667721' },
	{ city: 'Ballynakill (Westmeath)', zip: '916081' },
	{ city: 'Ballynakill (Wexford)', zip: '747614' },
	{ city: 'Ballynakilla (Cork)', zip: '870281' },
	{ city: 'Ballynakilla (Galway)', zip: '558912' },
	{ city: 'Ballynakilla East (Cork)', zip: '951826' },
	{ city: 'Ballynakilla West (Cork)', zip: '312069' },
	{ city: 'Ballynakillbeg (Carlow)', zip: '783675' },
	{ city: 'Ballynakill Beg (Limerick)', zip: '165204' },
	{ city: 'Ballynakill Big (Offaly)', zip: '230879' },
	{ city: 'Ballynakillew (Clare)', zip: '720179' },
	{ city: 'Ballynakillew (Galway)', zip: '882875' },
	{ city: 'Ballynakillew (Mayo)', zip: '729614' },
	{ city: 'Ballynakillew (Sligo)', zip: '438043' },
	{ city: 'Ballynakillew Mountain (Donegal)', zip: '238651' },
	{ city: 'Ballynakill Little (Offaly)', zip: '515039' },
	{ city: 'Ballynakill Lower (Kildare)', zip: '178582' },
	{ city: 'Ballynakill More (Limerick)', zip: '903610' },
	{ city: 'Ballynakill Upper (Kildare)', zip: '390718' },
	{ city: 'Ballynakill Upper (Westmeath)', zip: '834149' },
	{ city: 'Ballynakilly (Donegal)', zip: '931779' },
	{ city: 'Ballynakilly (Kerry)', zip: '566837' },
	{ city: 'Ballynakilly Lower (Kerry)', zip: '771175' },
	{ city: 'Ballynakilly Upper (Kerry)', zip: '642754' },
	{ city: 'Ballynalack (Offaly)', zip: '278712' },
	{ city: 'Ballynalacka (Galway)', zip: '970314' },
	{ city: 'Ballynalackan (Clare)', zip: '409393' },
	{ city: 'Ballynalacken (Cork)', zip: '485629' },
	{ city: 'Ballynalacken (Kerry)', zip: '869022' },
	{ city: 'Ballynalacken (Kilkenny)', zip: '771212' },
	{ city: 'Ballynalacken (Limerick)', zip: '521372' },
	{ city: 'Ballynalahagh (Cork)', zip: '545225' },
	{ city: 'Ballynalahagh (Limerick)', zip: '339405' },
	{ city: 'Ballynalahessery North (Waterford)', zip: '555667' },
	{ city: 'Ballynalahessery South (Waterford)', zip: '324669' },
	{ city: 'Ballynalahy (Galway)', zip: '149283' },
	{ city: 'Ballynaleck (Mayo)', zip: '476139' },
	{ city: 'Ballynaleck (Wexford)', zip: '215878' },
	{ city: 'Ballynalick (Tipperary)', zip: '244990' },
	{ city: 'Ballynalina (Kilkenny)', zip: '641976' },
	{ city: 'Ballynalinagh (Kilkenny)', zip: '187870' },
	{ city: 'Ballynally (Donegal)', zip: '531187' },
	{ city: 'Ballynalone (Westmeath)', zip: '304893' },
	{ city: 'Ballynalost (Donegal)', zip: '971111' },
	{ city: 'Ballynalougha (Cork)', zip: '559130' },
	{ city: 'Ballynalouhy (Cork)', zip: '747288' },
	{ city: 'Ballynalour (Carlow)', zip: '713819' },
	{ city: 'Ballynalty (Mayo)', zip: '556594' },
	{ city: 'Ballynalug (Laois)', zip: '339683' },
	{ city: 'Ballynalurgan (Meath)', zip: '193599' },
	{ city: 'Ballynalynagh (Mayo)', zip: '583023' },
	{ city: 'Ballynamaddoo (Cavan)', zip: '354122' },
	{ city: 'Ballynamaddree (Cork)', zip: '306344' },
	{ city: 'Ballynamaghery (Louth)', zip: '890822' },
	{ city: 'Ballynaman (Donegal)', zip: '308310' },
	{ city: 'Ballynamanagh (Longford)', zip: '687078' },
	{ city: 'Ballynamanagh East (Galway)', zip: '975084' },
	{ city: 'Ballynamanagh West (Galway)', zip: '469169' },
	{ city: 'Ballynamannan (Cavan)', zip: '515230' },
	{ city: 'Ballynamannin (Galway)', zip: '677675' },
	{ city: 'Ballynamanoge (Wicklow)', zip: '759843' },
	{ city: 'Ballynamantan (Galway)', zip: '362028' },
	{ city: 'Ballynamarroge (Mayo)', zip: '513632' },
	{ city: 'Ballynamaul (Cork)', zip: '698852' },
	{ city: 'Ballynamaunagh (Kerry)', zip: '901194' },
	{ city: 'Ballynameagh (Westmeath)', zip: '765184' },
	{ city: 'Ballynameelagh (Waterford)', zip: '449622' },
	{ city: 'Ballynameeltoge (Leitrim)', zip: '569132' },
	{ city: 'Ballynamertinagh (Waterford)', zip: '141575' },
	{ city: 'Ballynametagh (Cork)', zip: '864226' },
	{ city: 'Ballynametagh (Kilkenny)', zip: '763456' },
	{ city: 'Ballynaminnan (Wexford)', zip: '162868' },
	{ city: 'Ballynamintra Lower (Waterford)', zip: '931864' },
	{ city: 'Ballynamintra Middle (Waterford)', zip: '220051' },
	{ city: 'Ballynamintra Upper (Waterford)', zip: '445244' },
	{ city: 'Ballynamire (Carlow)', zip: '809533' },
	{ city: 'Ballynamire (Offaly)', zip: '135528' },
	{ city: 'Ballynamire (Wexford)', zip: '982356' },
	{ city: 'Ballynamockagh (Galway)', zip: '839780' },
	{ city: 'Ballynamoe (Tipperary)', zip: '354194' },
	{ city: 'Ballynamoloogh (Limerick)', zip: '383607' },
	{ city: 'Ballynamona (Cavan)', zip: '314176' },
	{ city: 'Ballynamona (Clare)', zip: '225273' },
	{ city: 'Ballynamona (Cork)', zip: '989951' },
	{ city: 'Ballynamona (Galway)', zip: '285813' },
	{ city: 'Ballynamona (Kilkenny)', zip: '437359' },
	{ city: 'Ballynamona (Limerick)', zip: '229778' },
	{ city: 'Ballynamona (Mayo)', zip: '994427' },
	{ city: 'Ballynamona (Meath)', zip: '374604' },
	{ city: 'Ballynamona (Offaly)', zip: '954451' },
	{ city: 'Ballynamona (Sligo)', zip: '303793' },
	{ city: 'Ballynamona (Tipperary)', zip: '912030' },
	{ city: 'Ballynamona (Waterford)', zip: '935235' },
	{ city: 'Ballynamona (Wexford)', zip: '611081' },
	{ city: 'Ballynamona (Wicklow)', zip: '425158' },
	{ city: 'Ballynamonabeg (Wexford)', zip: '746917' },
	{ city: 'Ballynamona Glebe (Offaly)', zip: '235029' },
	{ city: 'Ballynamona Lower (Kerry)', zip: '959965' },
	{ city: 'Ballynamona Lower (Waterford)', zip: '172205' },
	{ city: 'Ballynamona Upper (Kerry)', zip: '329849' },
	{ city: 'Ballynamona Upper (Waterford)', zip: '771018' },
	{ city: 'Ballynamongaree (Cork)', zip: '660782' },
	{ city: 'Ballynamony (Cavan)', zip: '545450' },
	{ city: 'Ballynamony (Kildare)', zip: '102731' },
	{ city: 'Ballynamony (Leitrim)', zip: '628711' },
	{ city: 'Ballynamony (Louth)', zip: '296033' },
	{ city: 'Ballynamony (Wexford)', zip: '656540' },
	{ city: 'Ballynamorahan (Kilkenny)', zip: '741039' },
	{ city: 'Ballynamought (Cork)', zip: '572735' },
	{ city: 'Ballynamountain (Kilkenny)', zip: '903753' },
	{ city: 'Ballynamoyntragh (Waterford)', zip: '239582' },
	{ city: 'Ballynamrossagh (Tipperary)', zip: '926263' },
	{ city: 'Ballynamuck (Cork)', zip: '799328' },
	{ city: 'Ballynamucka (Galway)', zip: '795939' },
	{ city: 'Ballynamuck East (Waterford)', zip: '635979' },
	{ city: 'Ballynamuck Middle (Waterford)', zip: '570858' },
	{ city: 'Ballynamuck West (Waterford)', zip: '134843' },
	{ city: 'Ballynamucky (Limerick)', zip: '248920' },
	{ city: 'Ballynamuddagh (Cork)', zip: '488022' },
	{ city: 'Ballynamuddagh (Galway)', zip: '520877' },
	{ city: 'Ballynamuddagh (Kerry)', zip: '424700' },
	{ city: 'Ballynamuddagh (Laois)', zip: '937139' },
	{ city: 'Ballynamuddagh (Limerick)', zip: '344599' },
	{ city: 'Ballynamuddagh (Mayo)', zip: '224983' },
	{ city: 'Ballynamuddagh (Tipperary)', zip: '808478' },
	{ city: 'Ballynamuddagh (Westmeath)', zip: '983682' },
	{ city: 'Ballynamuddagh (Wexford)', zip: '152542' },
	{ city: 'Ballynamuddagh (Wicklow)', zip: '593267' },
	{ city: 'Ballynamullagh (Kildare)', zip: '517647' },
	{ city: 'Ballynamullen (Westmeath)', zip: '770277' },
	{ city: 'Ballynamult (Waterford)', zip: '712943' },
	{ city: 'Ballynamultina (Waterford)', zip: '835891' },
	{ city: 'Ballynamurdoon (Galway)', zip: '158353' },
	{ city: 'Ballynamurragh North (Tipperary)', zip: '600827' },
	{ city: 'Ballynamurragh South (Tipperary)', zip: '131148' },
	{ city: 'Ballynana (Kerry)', zip: '115742' },
	{ city: 'Ballynancoran (Wexford)', zip: '902850' },
	{ city: 'Ballynane (Kerry)', zip: '806231' },
	{ city: 'Ballynaneening (Cork)', zip: '705187' },
	{ city: 'Ballynanelagh (Cork)', zip: '142657' },
	{ city: 'Ballynanerroon Beg (Mayo)', zip: '675823' },
	{ city: 'Ballynanerroon More (Mayo)', zip: '701923' },
	{ city: 'Ballynanoose (Tipperary)', zip: '557346' },
	{ city: 'Ballynanty (Limerick)', zip: '587450' },
	{ city: 'Ballynanultagh (Roscommon)', zip: '420886' },
	{ city: 'Ballynanulty (Galway)', zip: '376706' },
	{ city: 'Ballynanum (Offaly)', zip: '338891' },
	{ city: 'Ballynapark (Galway)', zip: '775668' },
	{ city: 'Ballynapark (Wicklow)', zip: '438580' },
	{ city: 'Ballynaparka (Waterford)', zip: '947900' },
	{ city: 'Ballynaparka North (Cork)', zip: '714576' },
	{ city: 'Ballynaparka South (Cork)', zip: '905817' },
	{ city: 'Ballynaparson (Cork)', zip: '336849' },
	{ city: 'Ballynapierce (Wexford)', zip: '391248' },
	{ city: 'Ballynaraha (Cork)', zip: '787058' },
	{ city: 'Ballynaraha (Kilkenny)', zip: '616742' },
	{ city: 'Ballynaraha (Mayo)', zip: '174458' },
	{ city: 'Ballynaraha (Tipperary)', zip: '526238' },
	{ city: 'Ballynaraha (Waterford)', zip: '835069' },
	{ city: 'Ballynaraha North (Kerry)', zip: '805581' },
	{ city: 'Ballynaraha North (Kilkenny)', zip: '218487' },
	{ city: 'Ballynaraha South (Kerry)', zip: '480303' },
	{ city: 'Ballynaraha South (Kilkenny)', zip: '781891' },
	{ city: 'Ballynaraw North (Sligo)', zip: '774362' },
	{ city: 'Ballynaraw South (Sligo)', zip: '979731' },
	{ city: 'Ballynare (Meath)', zip: '546379' },
	{ city: 'Ballynarooga Beg (Limerick)', zip: '316726' },
	{ city: 'Ballynarooga More (Limerick)', zip: '357828' },
	{ city: 'Ballynaroon (Cork)', zip: '508230' },
	{ city: 'Ballynarrid (Waterford)', zip: '119805' },
	{ city: 'Ballynarry (Donegal)', zip: '527609' },
	{ city: 'Ballynary (Sligo)', zip: '811875' },
	{ city: 'Ballynasare (Kerry)', zip: '185042' },
	{ city: 'Ballynasare Beg (Kerry)', zip: '118125' },
	{ city: 'Ballynasare Lower (Kerry)', zip: '886799' },
	{ city: 'Ballynasare-Mountain (Kerry)', zip: '830182' },
	{ city: 'Ballynascall (Donegal)', zip: '805289' },
	{ city: 'Ballynascarry (Kilkenny)', zip: '182562' },
	{ city: 'Ballynascarry (Westmeath)', zip: '985002' },
	{ city: 'Ballynascarty (Cork)', zip: '354361' },
	{ city: 'Ballynascragh (Galway)', zip: '818470' },
	{ city: 'Ballynascraw (Longford)', zip: '271580' },
	{ city: 'Ballynascubbig (Cork)', zip: '323401' },
	{ city: 'Ballynasculloge (Kildare)', zip: '172916' },
	{ city: 'Ballynasculloge Lower (Wicklow)', zip: '288554' },
	{ city: 'Ballynasculloge Upper (Wicklow)', zip: '299162' },
	{ city: 'Ballynash (Limerick)', zip: '122579' },
	{ city: 'Ballynashannagh (Donegal)', zip: '339080' },
	{ city: 'Ballynashee (Sligo)', zip: '518462' },
	{ city: 'Ballynasheeoge (Galway)', zip: '621144' },
	{ city: 'Ballynashig (Limerick)', zip: '267287' },
	{ city: 'Ballynasilloge (Carlow)', zip: '548029' },
	{ city: 'Ballynasissala (Waterford)', zip: '628213' },
	{ city: 'Ballynaskea (Meath)', zip: '396883' },
	{ city: 'Ballynaskeagh (Westmeath)', zip: '562604' },
	{ city: 'Ballynaskeha (Cork)', zip: '339885' },
	{ city: 'Ballynaskeha Beg (Waterford)', zip: '141182' },
	{ city: 'Ballynaskeha More (Waterford)', zip: '668838' },
	{ city: 'Ballynaskreena (Kerry)', zip: '190548' },
	{ city: 'Ballynaslaney (Wexford)', zip: '531041' },
	{ city: 'Ballynaslee (Kilkenny)', zip: '723531' },
	{ city: 'Ballynaslee (Mayo)', zip: '144294' },
	{ city: 'Ballynasooragh Eighter (Galway)', zip: '307331' },
	{ city: 'Ballynasooragh Oughter (Galway)', zip: '459287' },
	{ city: 'Ballynasrah (Offaly)', zip: '317326' },
	{ city: 'Ballynastaig (Galway)', zip: '859754' },
	{ city: 'Ballynastangford Lower (Mayo)', zip: '882950' },
	{ city: 'Ballynastangford Upper (Mayo)', zip: '385033' },
	{ city: 'Ballynastick (Tipperary)', zip: '234149' },
	{ city: 'Ballynastockagh (Mayo)', zip: '146009' },
	{ city: 'Ballynastockan (Wicklow)', zip: '519796' },
	{ city: 'Ballynastraw (Wexford)', zip: '252885' },
	{ city: 'Ballynastuckaun (Galway)', zip: '632277' },
	{ city: 'Ballynatona (Cork)', zip: '854023' },
	{ city: 'Ballynatona (Limerick)', zip: '460103' },
	{ city: 'Ballynatona (Tipperary)', zip: '865856' },
	{ city: 'Ballynatona (Wicklow)', zip: '652863' },
	{ city: 'Ballynatone (Donegal)', zip: '882055' },
	{ city: 'Ballynatone (Wicklow)', zip: '109273' },
	{ city: 'Ballynatra (Cork)', zip: '243272' },
	{ city: 'Ballynatray Commons (Waterford)', zip: '406030' },
	{ city: 'Ballynatray Demesne (Waterford)', zip: '681412' },
	{ city: 'Ballynatrilla (Cork)', zip: '446128' },
	{ city: 'Ballynattin (Carlow)', zip: '953258' },
	{ city: 'Ballynattin (Cork)', zip: '204541' },
	{ city: 'Ballynattin (Wicklow)', zip: '759010' },
	{ city: 'Ballynaule (Cork)', zip: '180486' },
	{ city: 'Ballynavaddog (Meath)', zip: '791238' },
	{ city: 'Ballynaveen (Tipperary)', zip: '551728' },
	{ city: 'Ballynavenooragh (Kerry)', zip: '650923' },
	{ city: 'Ballynavin (Tipperary)', zip: '854517' },
	{ city: 'Ballynavortha (Wicklow)', zip: '685420' },
	{ city: 'Ballyneague (Cork)', zip: '870305' },
	{ city: 'Ballyneal (Waterford)', zip: '333620' },
	{ city: 'Ballyneale (Kilkenny)', zip: '713125' },
	{ city: 'Ballyneale (Limerick)', zip: '267770' },
	{ city: 'Ballynearla (Kilkenny)', zip: '176503' },
	{ city: 'Ballyneary (Cavan)', zip: '952828' },
	{ city: 'Ballyneena (Offaly)', zip: '168361' },
	{ city: 'Ballyneety (Limerick)', zip: '427623' },
	{ city: 'Ballyneety (Mayo)', zip: '928027' },
	{ city: 'Ballyneety (Tipperary)', zip: '358343' },
	{ city: 'Ballyneety (Waterford)', zip: '495804' },
	{ city: 'Ballyneety North (Limerick)', zip: '619634' },
	{ city: 'Ballyneety South (Limerick)', zip: '677149' },
	{ city: 'Ballyneggin (Mayo)', zip: '462983' },
	{ city: 'Ballyneill (Tipperary)', zip: '653748' },
	{ city: 'Ballyneillan (Clare)', zip: '573526' },
	{ city: 'Ballynelahillan (Wexford)', zip: '345063' },
	{ city: 'Ballynella (Cork)', zip: '303494' },
	{ city: 'Ballynellard (Wexford)', zip: '941566' },
	{ city: 'Ballynelligan Glebe (Waterford)', zip: '879423' },
	{ city: 'Ballynennan (Tipperary)', zip: '814464' },
	{ city: 'Ballynera (Tipperary)', zip: '377226' },
	{ city: 'Ballynerrin (Wicklow)', zip: '496916' },
	{ city: 'Ballynerrin Lower (Wicklow)', zip: '605909' },
	{ city: 'Ballynerrin Upper (Wicklow)', zip: '549303' },
	{ city: 'Ballynerroon East (Waterford)', zip: '871343' },
	{ city: 'Ballynerroon West (Waterford)', zip: '518620' },
	{ city: 'Ballyness (Donegal)', zip: '656760' },
	{ city: 'Ballyness Mountain (Donegal)', zip: '234957' },
	{ city: 'Ballynestragh (Wexford)', zip: '745651' },
	{ city: 'Ballynestragh Demesne (Wexford)', zip: '317827' },
	{ city: 'Ballynevan (Clare)', zip: '157102' },
	{ city: 'Ballynevin (Laois)', zip: '127610' },
	{ city: 'Ballynevin (Tipperary)', zip: '875776' },
	{ city: 'Ballynevin (Waterford)', zip: '611968' },
	{ city: 'Ballynevoga (Waterford)', zip: '318909' },
	{ city: 'Ballynew (Clare)', zip: '594767' },
	{ city: 'Ballynew (Galway)', zip: '351722' },
	{ city: 'Ballynew (Mayo)', zip: '574981' },
	{ city: 'Ballynicole (Waterford)', zip: '933633' },
	{ city: 'Ballynidon (Cork)', zip: '618117' },
	{ city: 'Ballynilard (Tipperary)', zip: '404753' },
	{ city: 'Ballynisky (Limerick)', zip: '988355' },
	{ city: 'Ballynoe (Carlow)', zip: '553534' },
	{ city: 'Ballynoe (Clare)', zip: '990239' },
	{ city: 'Ballynoe (Cork)', zip: '381808' },
	{ city: 'Ballynoe (Kerry)', zip: '343487' },
	{ city: 'Ballynoe (Limerick)', zip: '458259' },
	{ city: 'Ballynoe (Waterford)', zip: '117679' },
	{ city: 'Ballynoe East (Cork)', zip: '650307' },
	{ city: 'Ballynoe East (Waterford)', zip: '643386' },
	{ city: 'Ballynoe West (Cork)', zip: '993750' },
	{ city: 'Ballynoe West (Waterford)', zip: '275191' },
	{ city: 'Ballynolan (Carlow)', zip: '490088' },
	{ city: 'Ballynolan (Kilkenny)', zip: '805038' },
	{ city: 'Ballynolan (Limerick)', zip: '572864' },
	{ city: 'Ballynomasna (Tipperary)', zip: '132106' },
	{ city: 'Ballynona North (Cork)', zip: '396199' },
	{ city: 'Ballynona South (Cork)', zip: '378553' },
	{ city: 'Ballynoneen (Kerry)', zip: '870656' },
	{ city: 'Ballynookery (Cork)', zip: '893274' },
	{ city: 'Ballynoony East (Kilkenny)', zip: '453433' },
	{ city: 'Ballynoony West (Kilkenny)', zip: '918687' },
	{ city: 'Ballynora (Cork)', zip: '465304' },
	{ city: 'Ballynoran (Cork)', zip: '366043' },
	{ city: 'Ballynoran (Tipperary)', zip: '271730' },
	{ city: 'Ballynorig East (Kerry)', zip: '685111' },
	{ city: 'Ballynorig West (Kerry)', zip: '357671' },
	{ city: 'Ballynort (Limerick)', zip: '485060' },
	{ city: 'Ballynote East (Clare)', zip: '764460' },
	{ city: 'Ballynote West (Clare)', zip: '636739' },
	{ city: 'Ballynough (Tipperary)', zip: '665541' },
	{ city: 'Ballynowlan (Laois)', zip: '602667' },
	{ city: 'Ballynultagh (Wicklow)', zip: '366341' },
	{ city: 'Ballynunnery (Carlow)', zip: '280304' },
	{ city: 'Ballynunry (Kilkenny)', zip: '202211' },
	{ city: 'Ballynure (Monaghan)', zip: '149272' },
	{ city: 'Ballynure (Wexford)', zip: '709650' },
	{ city: 'Ballynure (Wicklow)', zip: '379448' },
	{ city: 'Ballynure Demesne (Wicklow)', zip: '344744' },
	{ city: 'Ballynure Park (Wicklow)', zip: '999044' },
	{ city: 'Ballyoban (Westmeath)', zip: '670362' },
	{ city: 'Ballyogaha East (Cork)', zip: '146973' },
	{ city: 'Ballyogaha North (Cork)', zip: '465262' },
	{ city: 'Ballyogaha West (Cork)', zip: '913847' },
	{ city: 'Ballyogan (Clare)', zip: '395171' },
	{ city: 'Ballyogan (Dublin)', zip: '819364' },
	{ city: 'Ballyogan (Kilkenny)', zip: '924079' },
	{ city: 'Ballyogan (Sligo)', zip: '577357' },
	{ city: 'Ballyogan Beg (Clare)', zip: '982852' },
	{ city: 'Ballyogan More (Clare)', zip: '940021' },
	{ city: 'Ballyogartha (Limerick)', zip: '719140' },
	{ city: 'Ballyogarty (Waterford)', zip: '780145' },
	{ city: 'Ballyoghagan (Donegal)', zip: '863232' },
	{ city: 'Ballyoliver (Carlow)', zip: '376813' },
	{ city: 'Ballyonan (Clare)', zip: '881109' },
	{ city: 'Ballyonan (Kildare)', zip: '635725' },
	{ city: 'Ballyonan (Louth)', zip: '718728' },
	{ city: 'Ballyonane (Cork)', zip: '635872' },
	{ city: 'Ballyoneen (Cork)', zip: '343679' },
	{ city: 'Ballyoran (Cork)', zip: '106916' },
	{ city: 'Ballyoran (Louth)', zip: '225783' },
	{ city: 'Ballyoran (Offaly)', zip: '646346' },
	{ city: 'Ballyorban (Cork)', zip: '897657' },
	{ city: 'Ballyorgan (Limerick)', zip: '970287' },
	{ city: 'Ballyorley Lower (Wexford)', zip: '546246' },
	{ city: 'Ballyorley Upper (Wexford)', zip: '962412' },
	{ city: 'Ballyorney (Wicklow)', zip: '151938' },
	{ city: 'Ballyorril (Wexford)', zip: '661718' },
	{ city: 'Ballyortla North (Clare)', zip: '130048' },
	{ city: 'Ballyortla South (Clare)', zip: '909017' },
	{ city: 'Ballyoskill (Kilkenny)', zip: '850249' },
	{ city: 'Ballyote (Westmeath)', zip: '591505' },
	{ city: 'Ballyoughna (Wexford)', zip: '485470' },
	{ city: 'Ballyoughter (Roscommon)', zip: '929053' },
	{ city: 'Ballyoughter (Tipperary)', zip: '330784' },
	{ city: 'Ballyoughtera (Cork)', zip: '701348' },
	{ city: 'Ballyoughteragh North (Kerry)', zip: '340477' },
	{ city: 'Ballyoughteragh South (Kerry)', zip: '791661' },
	{ city: 'Ballyoughtra (Clare)', zip: '837311' },
	{ city: 'Ballyoughtragh North (Kerry)', zip: '862073' },
	{ city: 'Ballyoughtragh South (Kerry)', zip: '718596' },
	{ city: 'Ballyoulster (Kildare)', zip: '679296' },
	{ city: 'Ballyouneen (Kerry)', zip: '478208' },
	{ city: 'Ballyouragan (Limerick)', zip: '903694' },
	{ city: 'Ballyourane (Cork)', zip: '494075' },
	{ city: 'Ballyowen (Dublin)', zip: '573364' },
	{ city: 'Ballyowen (Laois)', zip: '899668' },
	{ city: 'Ballyowen (Limerick)', zip: '899703' },
	{ city: 'Ballyowen (Offaly)', zip: '544256' },
	{ city: 'Ballyowen (Westmeath)', zip: '921556' },
	{ city: 'Ballyowen (Wexford)', zip: '130237' },
	{ city: 'Ballypadeen (Tipperary)', zip: '894071' },
	{ city: 'Ballypatrick (Kilkenny)', zip: '838418' },
	{ city: 'Ballypatrick (Tipperary)', zip: '364363' },
	{ city: 'Ballypheasan (Roscommon)', zip: '290187' },
	{ city: 'Ballypherode (Cork)', zip: '602353' },
	{ city: 'Ballyphilibeen (Cork)', zip: '141758' },
	{ city: 'Ballyphilip (Cork)', zip: '718639' },
	{ city: 'Ballyphilip (Kilkenny)', zip: '639778' },
	{ city: 'Ballyphilip (Limerick)', zip: '731536' },
	{ city: 'Ballyphilip (Offaly)', zip: '531170' },
	{ city: 'Ballyphilip (Tipperary)', zip: '405855' },
	{ city: 'Ballyphilip (Waterford)', zip: '872383' },
	{ city: 'Ballyphilip (Wexford)', zip: '966421' },
	{ city: 'Ballyphilip (Wicklow)', zip: '997078' },
	{ city: 'Ballyphilip East (Waterford)', zip: '651087' },
	{ city: 'Ballyphilip West (Waterford)', zip: '759153' },
	{ city: 'Ballyphillips (Tipperary)', zip: '713189' },
	{ city: 'Ballypickas Lower (Laois)', zip: '414374' },
	{ city: 'Ballypickas Upper (Laois)', zip: '762617' },
	{ city: 'Ballypierce (Carlow)', zip: '306648' },
	{ city: 'Ballypierce (Cork)', zip: '815016' },
	{ city: 'Ballypierce (Limerick)', zip: '887559' },
	{ city: 'Ballyplimoth (Kerry)', zip: '326713' },
	{ city: 'Ballyporeen (Tipperary)', zip: '920228' },
	{ city: 'Ballyportry North (Clare)', zip: '901011' },
	{ city: 'Ballyportry South (Clare)', zip: '638878' },
	{ city: 'Ballyprecas (Wexford)', zip: '776698' },
	{ city: 'Ballyprior (Laois)', zip: '108689' },
	{ city: 'Ballyquaid Glebe (Laois)', zip: '866694' },
	{ city: 'Ballyquane (Cork)', zip: '484992' },
	{ city: 'Ballyquin (Clare)', zip: '327643' },
	{ city: 'Ballyquin (Kerry)', zip: '530957' },
	{ city: 'Ballyquin (Kilkenny)', zip: '342543' },
	{ city: 'Ballyquin (Waterford)', zip: '565271' },
	{ city: 'Ballyquin Beg (Clare)', zip: '928477' },
	{ city: 'Ballyquinlevan Lower (Tipperary)', zip: '761127' },
	{ city: 'Ballyquinlevan Upper (Tipperary)', zip: '183398' },
	{ city: 'Ballyquin More (Clare)', zip: '822205' },
	{ city: 'Ballyquirk (Cork)', zip: '506065' },
	{ city: 'Ballyquirk (Kilkenny)', zip: '619472' },
	{ city: 'Ballyquirk (Limerick)', zip: '627221' },
	{ city: 'Ballyquirk (Tipperary)', zip: '142703' },
	{ city: 'Ballyquiveen (Tipperary)', zip: '370197' },
	{ city: 'Ballyrafter (Waterford)', zip: '918617' },
	{ city: 'Ballyrafter Flats (Waterford)', zip: '954278' },
	{ city: 'Ballyrafton (Kilkenny)', zip: '914669' },
	{ city: 'Ballyraggan (Kildare)', zip: '565628' },
	{ city: 'Ballyragget (Kilkenny)', zip: '783591' },
	{ city: 'Ballyrahan (Kilkenny)', zip: '797568' },
	{ city: 'Ballyrahan (Wexford)', zip: '942461' },
	{ city: 'Ballyraheen (Wicklow)', zip: '681010' },
	{ city: 'Ballyrahin (Wexford)', zip: '164824' },
	{ city: 'Ballyraine (Donegal)', zip: '461459' },
	{ city: 'Ballyraine Lower (Wicklow)', zip: '760804' },
	{ city: 'Ballyraine Middle (Wicklow)', zip: '818475' },
	{ city: 'Ballyraine Upper (Wicklow)', zip: '941595' },
	{ city: 'Ballyrandle (Waterford)', zip: '836731' },
	{ city: 'Ballyrane (Wexford)', zip: '425092' },
	{ city: 'Ballyrankin (Wexford)', zip: '362534' },
	{ city: 'Ballyrannel (Wexford)', zip: '464932' },
	{ city: 'Ballyrattan (Donegal)', zip: '925434' },
	{ city: 'Ballyraymeen Lower (Kerry)', zip: '237504' },
	{ city: 'Ballyraymeen Upper (Kerry)', zip: '714197' },
	{ city: 'Ballyre (Cork)', zip: '279852' },
	{ city: 'Ballyrea (Wexford)', zip: '488640' },
	{ city: 'Ballyready (Cork)', zip: '639669' },
	{ city: 'Ballyreagh (Wicklow)', zip: '295438' },
	{ city: 'Ballyreaghan (Longford)', zip: '374801' },
	{ city: 'Ballyreardon (Cork)', zip: '708529' },
	{ city: 'Ballyreask (Wicklow)', zip: '212775' },
	{ city: 'Ballyredding North (Kilkenny)', zip: '400945' },
	{ city: 'Ballyredding South (Kilkenny)', zip: '672916' },
	{ city: 'Ballyredding West (Kilkenny)', zip: '106979' },
	{ city: 'Ballyreddy (Kilkenny)', zip: '685558' },
	{ city: 'Ballyredmond (Carlow)', zip: '569904' },
	{ city: 'Ballyreehan East (Kerry)', zip: '371472' },
	{ city: 'Ballyreehan West (Kerry)', zip: '442204' },
	{ city: 'Ballyreesode (Limerick)', zip: '699589' },
	{ city: 'Ballyregan (Cork)', zip: '201413' },
	{ city: 'Ballyregan (Limerick)', zip: '631308' },
	{ city: 'Ballyregan (Louth)', zip: '700923' },
	{ city: 'Ballyregan (Wexford)', zip: '912382' },
	{ city: 'Ballyregan Beg (Cork)', zip: '846790' },
	{ city: 'Ballyregan More (Cork)', zip: '141662' },
	{ city: 'Ballyreilly (Laois)', zip: '463401' },
	{ city: 'Ballyreilly (Waterford)', zip: '646579' },
	{ city: 'Ballyreilly (Wexford)', zip: '603847' },
	{ city: 'Ballyremon Commons (Wicklow)', zip: '507734' },
	{ city: 'Ballyrevagh (Longford)', zip: '903357' },
	{ city: 'Ballyrichard (Tipperary)', zip: '519220' },
	{ city: 'Ballyrichard (Wicklow)', zip: '946794' },
	{ city: 'Ballyrichard Beg (Cork)', zip: '730600' },
	{ city: 'Ballyrichard More (Cork)', zip: '864813' },
	{ city: 'Ballyrickane (Tipperary)', zip: '369467' },
	{ city: 'Ballyrickard Beg (Offaly)', zip: '941868' },
	{ city: 'Ballyrickard More (Offaly)', zip: '498376' },
	{ city: 'Ballyrickard North (Tipperary)', zip: '168701' },
	{ city: 'Ballyrickard South (Tipperary)', zip: '676489' },
	{ city: 'Ballyrider (Laois)', zip: '393178' },
	{ city: 'Ballyriggin (Limerick)', zip: '986683' },
	{ city: 'Ballyrihy (Offaly)', zip: '186786' },
	{ city: 'Ballyring Lower (Kilkenny)', zip: '502833' },
	{ city: 'Ballyring Upper (Kilkenny)', zip: '437957' },
	{ city: 'Ballyriorthy (Cork)', zip: '868832' },
	{ city: 'Ballyriree (Cork)', zip: '622325' },
	{ city: 'Ballyrishteen (Kerry)', zip: '165575' },
	{ city: 'Ballyrisode (Cork)', zip: '372734' },
	{ city: 'Ballyristeen (Waterford)', zip: '208755' },
	{ city: 'Ballyroan (Dublin)', zip: '794062' },
	{ city: 'Ballyroan (Laois)', zip: '623208' },
	{ city: 'Ballyroan (Tipperary)', zip: '678456' },
	{ city: 'Ballyrobert (Cork)', zip: '574556' },
	{ city: 'Ballyrobert (Kerry)', zip: '899992' },
	{ city: 'Ballyroberts (Kilkenny)', zip: '427365' },
	{ city: 'Ballyrobin (Kilkenny)', zip: '908562' },
	{ city: 'Ballyrobin (Limerick)', zip: '803262' },
	{ city: 'Ballyrobin (Tipperary)', zip: '851615' },
	{ city: 'Ballyrobin (Waterford)', zip: '224125' },
	{ city: 'Ballyrobin North (Cork)', zip: '131362' },
	{ city: 'Ballyrobin South (Cork)', zip: '442779' },
	{ city: 'Ballyroddy (Roscommon)', zip: '520645' },
	{ city: 'Ballyroe (Clare)', zip: '531357' },
	{ city: 'Ballyroe (Cork)', zip: '531555' },
	{ city: 'Ballyroe (Galway)', zip: '286905' },
	{ city: 'Ballyroe (Kerry)', zip: '984871' },
	{ city: 'Ballyroe (Kildare)', zip: '390015' },
	{ city: 'Ballyroe (Kilkenny)', zip: '543403' },
	{ city: 'Ballyroe (Limerick)', zip: '328709' },
	{ city: 'Ballyroe (Mayo)', zip: '133426' },
	{ city: 'Ballyroe (Offaly)', zip: '288990' },
	{ city: 'Ballyroe (Tipperary)', zip: '905154' },
	{ city: 'Ballyroe (Waterford)', zip: '456640' },
	{ city: 'Ballyroe (Wexford)', zip: '890142' },
	{ city: 'Ballyroebeg (Wexford)', zip: '870118' },
	{ city: 'Ballyroebuck (Wexford)', zip: '816446' },
	{ city: 'Ballyroe East (Limerick)', zip: '769111' },
	{ city: 'Ballyroe Lower (Limerick)', zip: '616855' },
	{ city: 'Ballyroe Lower (Wexford)', zip: '669203' },
	{ city: 'Ballyroe Upper (Limerick)', zip: '872475' },
	{ city: 'Ballyroe Upper (Wexford)', zip: '534679' },
	{ city: 'Ballyroe West (Limerick)', zip: '453372' },
	{ city: 'Ballyrogan Lower (Wicklow)', zip: '988588' },
	{ city: 'Ballyrogan Upper (Wicklow)', zip: '344017' },
	{ city: 'Ballyrohan (Waterford)', zip: '451499' },
	{ city: 'Ballyronan (Kerry)', zip: '603895' },
	{ city: 'Ballyronan (Wicklow)', zip: '678439' },
	{ city: 'Ballyrooaun (Wexford)', zip: '502178' },
	{ city: 'Ballyrooaun (Wicklow)', zip: '539443' },
	{ city: 'Ballyroon (Cork)', zip: '510086' },
	{ city: 'Ballyroon Mountain (Cork)', zip: '582587' },
	{ city: 'Ballyrory (Wexford)', zip: '323809' },
	{ city: 'Ballyross (Wicklow)', zip: '547241' },
	{ city: 'Ballyroughan Big (Carlow)', zip: '979528' },
	{ city: 'Ballyroughan Little (Carlow)', zip: '916749' },
	{ city: 'Ballyroughan North (Clare)', zip: '129486' },
	{ city: 'Ballyroughan South (Clare)', zip: '329553' },
	{ city: 'Ballyrourke (Mayo)', zip: '201143' },
	{ city: 'Ballyrourke (Tipperary)', zip: '769388' },
	{ city: 'Ballyrowragh (Kilkenny)', zip: '809193' },
	{ city: 'Ballyrub (Cork)', zip: '851750' },
	{ city: 'Ballyruin (Laois)', zip: '274476' },
	{ city: 'Ballyrune (Limerick)', zip: '390748' },
	{ city: 'Ballyrush (Monaghan)', zip: '437160' },
	{ city: 'Ballyrush (Wicklow)', zip: '689007' },
	{ city: 'Ballyrusheen (Cork)', zip: '550361' },
	{ city: 'Ballyrusheen (Tipperary)', zip: '186022' },
	{ city: 'Ballyrussel (Waterford)', zip: '475331' },
	{ city: 'Ballyrussell (Cork)', zip: '388067' },
	{ city: 'Ballyryan (Carlow)', zip: '605931' },
	{ city: 'Ballyryan (Clare)', zip: '740957' },
	{ city: 'Ballyryan East (Tipperary)', zip: '706049' },
	{ city: 'Ballyryan West (Tipperary)', zip: '631819' },
	{ city: 'Ballysadare (Sligo)', zip: '999327' },
	{ city: 'Ballysaggart (Donegal)', zip: '412907' },
	{ city: 'Ballysaggart Beg (Waterford)', zip: '378398' },
	{ city: 'Ballysaggart Beg Glebe (Waterford)', zip: '822833' },
	{ city: 'Ballysaggartbeghill (Waterford)', zip: '844998' },
	{ city: 'Ballysaggart More (Waterford)', zip: '206212' },
	{ city: 'Ballysakeery (Mayo)', zip: '671279' },
	{ city: 'Ballysalla (Limerick)', zip: '811338' },
	{ city: 'Ballysallagh (Clare)', zip: '464991' },
	{ city: 'Ballysallagh (Cork)', zip: '727092' },
	{ city: 'Ballysallagh (Kilkenny)', zip: '723207' },
	{ city: 'Ballysallagh (Limerick)', zip: '531044' },
	{ city: 'Ballysallagh (Waterford)', zip: '637600' },
	{ city: 'Ballysallagh (Westmeath)', zip: '824069' },
	{ city: 'Ballysallagh East (Clare)', zip: '266385' },
	{ city: 'Ballysallagh East (Wicklow)', zip: '604214' },
	{ city: 'Ballysallagh Lower (Carlow)', zip: '877987' },
	{ city: 'Ballysallagh Upper (Carlow)', zip: '539324' },
	{ city: 'Ballysallagh West (Clare)', zip: '247980' },
	{ city: 'Ballysallagh West (Wicklow)', zip: '927939' },
	{ city: 'Ballysampson (Wexford)', zip: '969349' },
	{ city: 'Ballysax Great (Kildare)', zip: '972336' },
	{ city: 'Ballysaxhills (Kildare)', zip: '659066' },
	{ city: 'Ballysax Little (Kildare)', zip: '717157' },
	{ city: 'Ballysaxplain (Kildare)', zip: '762011' },
	{ city: 'Ballyscanlan (Clare)', zip: '161073' },
	{ city: 'Ballyscanlan (Mayo)', zip: '635871' },
	{ city: 'Ballyscanlan (Tipperary)', zip: '250783' },
	{ city: 'Ballyscanlan (Waterford)', zip: '330125' },
	{ city: 'Ballyscanlan Lower (Donegal)', zip: '608529' },
	{ city: 'Ballyscanlan Upper (Donegal)', zip: '214925' },
	{ city: 'Ballyscannel (Sligo)', zip: '128976' },
	{ city: 'Ballyscartin (Wexford)', zip: '491867' },
	{ city: 'Ballyscarvan (Westmeath)', zip: '720977' },
	{ city: 'Ballyscough (Wexford)', zip: '539127' },
	{ city: 'Ballyscully (Galway)', zip: '111807' },
	{ city: 'Ballyseedy (Kerry)', zip: '272391' },
	{ city: 'Ballyseskin (Wexford)', zip: '306916' },
	{ city: 'Ballyshancarragh (Carlow)', zip: '336839' },
	{ city: 'Ballyshane (Carlow)', zip: '823730' },
	{ city: 'Ballyshane (Cork)', zip: '634346' },
	{ city: 'Ballyshane (Kilkenny)', zip: '121305' },
	{ city: 'Ballyshane (Limerick)', zip: '842501' },
	{ city: 'Ballyshane (Mayo)', zip: '357424' },
	{ city: 'Ballyshane (Offaly)', zip: '614573' },
	{ city: 'Ballyshane (Wexford)', zip: '292380' },
	{ city: 'Ballyshane (Wicklow)', zip: '235157' },
	{ city: 'Ballyshanedehey (Limerick)', zip: '385908' },
	{ city: 'Ballyshaneduff (Laois)', zip: '299350' },
	{ city: 'Ballyshannon (Donegal)', zip: '832722' },
	{ city: 'Ballyshannon (Kildare)', zip: '613209' },
	{ city: 'Ballyshannon (Wexford)', zip: '430966' },
	{ city: 'Ballyshannon Demesne (Kildare)', zip: '666611' },
	{ city: 'Ballyshanny (Clare)', zip: '879554' },
	{ city: 'Ballyshaun (Wexford)', zip: '847904' },
	{ city: 'Ballyshea (Galway)', zip: '853093' },
	{ city: 'Ballysheeda (Tipperary)', zip: '202629' },
	{ city: 'Ballysheedy (Galway)', zip: '207604' },
	{ city: 'Ballysheedy East (Limerick)', zip: '546707' },
	{ city: 'Ballysheedy West (Limerick)', zip: '240484' },
	{ city: 'Ballysheehan (Tipperary)', zip: '701193' },
	{ city: 'Ballysheehy (Cork)', zip: '509522' },
	{ city: 'Ballysheeman (Wicklow)', zip: '880694' },
	{ city: 'Ballysheen (Kerry)', zip: '744176' },
	{ city: 'Ballysheen (Wexford)', zip: '980218' },
	{ city: 'Ballysheen Beg (Clare)', zip: '880825' },
	{ city: 'Ballysheen More (Clare)', zip: '987489' },
	{ city: 'Ballyshehan (Cork)', zip: '567903' },
	{ city: 'Ballysheil (Offaly)', zip: '167783' },
	{ city: 'Ballyshelin (Wexford)', zip: '627990' },
	{ city: 'Ballyshingadaun (Mayo)', zip: '486206' },
	{ city: 'Ballyshoneen (Cork)', zip: '224792' },
	{ city: 'Ballyshoneen (Limerick)', zip: '381444' },
	{ city: 'Ballyshoneen (Waterford)', zip: '802319' },
	{ city: 'Ballyshonickbane (Limerick)', zip: '563204' },
	{ city: 'Ballyshonikin (Limerick)', zip: '563007' },
	{ city: 'Ballyshonock (Cork)', zip: '588331' },
	{ city: 'Ballyshonock (Waterford)', zip: '974910' },
	{ city: 'Ballyshonock (Wexford)', zip: '224993' },
	{ city: 'Ballyshonog (Wicklow)', zip: '502480' },
	{ city: 'Ballyshrule (Galway)', zip: '312399' },
	{ city: 'Ballyshurdane (Cork)', zip: '221950' },
	{ city: 'Ballysilla (Wexford)', zip: '821297' },
	{ city: 'Ballysillagh (Wexford)', zip: '431238' },
	{ city: 'Ballysimon (Cork)', zip: '307998' },
	{ city: 'Ballysimon (Limerick)', zip: '649045' },
	{ city: 'Ballysimon (Tipperary)', zip: '152903' },
	{ city: 'Ballysimon (Wexford)', zip: '722769' },
	{ city: 'Ballysimon Commons (Limerick)', zip: '932663' },
	{ city: 'Ballysize (Kildare)', zip: '521061' },
	{ city: 'Ballysize Lower (Wicklow)', zip: '249241' },
	{ city: 'Ballysize Upper (Wicklow)', zip: '782300' },
	{ city: 'Ballyskeagh (Galway)', zip: '871446' },
	{ city: 'Ballyskerdane (Cork)', zip: '587197' },
	{ city: 'Ballyskibbole (Cork)', zip: '636288' },
	{ city: 'Ballyslatteen (Tipperary)', zip: '887475' },
	{ city: 'Ballyslattery (Clare)', zip: '513589' },
	{ city: 'Ballyslavin (Offaly)', zip: '918807' },
	{ city: 'Ballyslea (Tipperary)', zip: '216696' },
	{ city: 'Ballyslough (Waterford)', zip: '197963' },
	{ city: 'Ballysmuttan Lower (Wicklow)', zip: '643653' },
	{ city: 'Ballysmuttan Upper (Wicklow)', zip: '883424' },
	{ city: 'Ballysooghan North (Kildare)', zip: '701612' },
	{ city: 'Ballysooghan South (Kildare)', zip: '168672' },
	{ city: 'Ballysop (Wexford)', zip: '693496' },
	{ city: 'Ballysorrell Big (Tipperary)', zip: '272740' },
	{ city: 'Ballysorrell Little (Tipperary)', zip: '685681' },
	{ city: 'Ballysovane (Cork)', zip: '341708' },
	{ city: 'Ballyspellan (Kilkenny)', zip: '819627' },
	{ city: 'Ballyspellane North (Tipperary)', zip: '849649' },
	{ city: 'Ballyspellane South (Tipperary)', zip: '394122' },
	{ city: 'Ballyspillane (Kerry)', zip: '910396' },
	{ city: 'Ballyspillane East (Cork)', zip: '907490' },
	{ city: 'Ballyspillane West (Cork)', zip: '846591' },
	{ city: 'Ballystanly (Offaly)', zip: '817508' },
	{ city: 'Ballysteen (Clare)', zip: '381535' },
	{ city: 'Ballysteen (Limerick)', zip: '138444' },
	{ city: 'Ballysteena (Tipperary)', zip: '978017' },
	{ city: 'Ballystrahan (Dublin)', zip: '236947' },
	{ city: 'Ballystrane (Dublin)', zip: '554766' },
	{ city: 'Ballystrang (Donegal)', zip: '772265' },
	{ city: 'Ballystraw (Wexford)', zip: '848134' },
	{ city: 'Ballystrig (Offaly)', zip: '960931' },
	{ city: 'Ballystruan (Dublin)', zip: '147654' },
	{ city: 'Ballysumaghan (Sligo)', zip: '800606' },
	{ city: 'Ballysundrivan (Roscommon)', zip: '637756' },
	{ city: 'Ballytarsna (Carlow)', zip: '335614' },
	{ city: 'Ballytarsna (Clare)', zip: '449049' },
	{ city: 'Ballytarsna (Kilkenny)', zip: '682207' },
	{ city: 'Ballytarsna (Laois)', zip: '868389' },
	{ city: 'Ballytarsna (Tipperary)', zip: '882763' },
	{ city: 'Ballytarsna (Wexford)', zip: '587125' },
	{ city: 'Ballytarsna Little (Wexford)', zip: '395795' },
	{ city: 'Ballytarsney (Kilkenny)', zip: '764973' },
	{ city: 'Ballyteernan (Clare)', zip: '771084' },
	{ city: 'Ballytegan (Laois)', zip: '322635' },
	{ city: 'Ballytegan (Wexford)', zip: '492904' },
	{ city: 'Ballyteganpark (Wexford)', zip: '776926' },
	{ city: 'Ballyteige (Clare)', zip: '420222' },
	{ city: 'Ballyteige (Kildare)', zip: '163725' },
	{ city: 'Ballyteige (Mayo)', zip: '992609' },
	{ city: 'Ballyteige (Wexford)', zip: '633800' },
	{ city: 'Ballyteige (Wicklow)', zip: '430348' },
	{ city: 'Ballyteige Big (Offaly)', zip: '912607' },
	{ city: 'Ballyteige Burrow (Wexford)', zip: '675239' },
	{ city: 'Ballyteige East (Clare)', zip: '404276' },
	{ city: 'Ballyteigelea (Carlow)', zip: '266881' },
	{ city: 'Ballyteige Little (Offaly)', zip: '988368' },
	{ city: 'Ballyteige Lower (Limerick)', zip: '101493' },
	{ city: 'Ballyteige North (Kildare)', zip: '414095' },
	{ city: 'Ballyteige South (Kildare)', zip: '740659' },
	{ city: 'Ballyteige Upper (Limerick)', zip: '898319' },
	{ city: 'Ballyteige West (Clare)', zip: '480002' },
	{ city: 'Ballyterrim (Galway)', zip: '759062' },
	{ city: 'Ballythomas (Cork)', zip: '287891' },
	{ city: 'Ballythomas (Laois)', zip: '619424' },
	{ city: 'Ballythomas (Tipperary)', zip: '507512' },
	{ city: 'Ballythomas (Waterford)', zip: '590347' },
	{ city: 'Ballythomas (Wexford)', zip: '802264' },
	{ city: 'Ballythomas East (Cork)', zip: '455496' },
	{ city: 'Ballythomashill (Wexford)', zip: '554536' },
	{ city: 'Ballythomas West (Cork)', zip: '573157' },
	{ city: 'Ballytibbot (Cork)', zip: '431174' },
	{ city: 'Ballytigeen (Cork)', zip: '338557' },
	{ city: 'Ballytimmin (Carlow)', zip: '886476' },
	{ city: 'Ballytivnan (Sligo)', zip: '646025' },
	{ city: 'Ballytobin (Kilkenny)', zip: '529213' },
	{ city: 'Ballytohil (Tipperary)', zip: '528864' },
	{ city: 'Ballytoohey (Roscommon)', zip: '687775' },
	{ city: 'Ballytoohy Beg (Mayo)', zip: '642093' },
	{ city: 'Ballytoohy More (Mayo)', zip: '179892' },
	{ city: 'Ballytoole Lower (Wicklow)', zip: '427028' },
	{ city: 'Ballytoole Upper (Wicklow)', zip: '459159' },
	{ city: 'Ballytoran (Offaly)', zip: '776787' },
	{ city: 'Ballytory Lower (Wexford)', zip: '322860' },
	{ city: 'Ballytory Upper (Wexford)', zip: '891658' },
	{ city: 'Ballytra (Wexford)', zip: '720429' },
	{ city: 'Ballytracey (Wexford)', zip: '965835' },
	{ city: 'Ballytramon (Wexford)', zip: '236429' },
	{ city: 'Ballytrasna (Cork)', zip: '191364' },
	{ city: 'Ballytrasna (Galway)', zip: '934493' },
	{ city: 'Ballytrasna (Kerry)', zip: '878934' },
	{ city: 'Ballytrasna (Limerick)', zip: '312634' },
	{ city: 'Ballytrasna (Louth)', zip: '313614' },
	{ city: 'Ballytrasna (Mayo)', zip: '297236' },
	{ city: 'Ballytrasna (Roscommon)', zip: '941978' },
	{ city: 'Ballytrasna (Wicklow)', zip: '281612' },
	{ city: 'Ballytrehy (Tipperary)', zip: '514458' },
	{ city: 'Ballytrent (Wexford)', zip: '790783' },
	{ city: 'Ballytrisnane (Waterford)', zip: '417756' },
	{ city: 'Ballytrust (Cavan)', zip: '980184' },
	{ city: 'Ballytrust Lower (Cavan)', zip: '154452' },
	{ city: 'Ballytunny (Wicklow)', zip: '645731' },
	{ city: 'Ballyturick (Galway)', zip: '201365' },
	{ city: 'Ballyturin (Galway)', zip: '729887' },
	{ city: 'Ballyurra (Clare)', zip: '766497' },
	{ city: 'Ballyva (Cork)', zip: '413754' },
	{ city: 'Ballyvackey (Cork)', zip: '425205' },
	{ city: 'Ballyvada (Tipperary)', zip: '400469' },
	{ city: 'Ballyvadd (Waterford)', zip: '689335' },
	{ city: 'Ballyvadden (Waterford)', zip: '698274' },
	{ city: 'Ballyvadden (Wexford)', zip: '163065' },
	{ city: 'Ballyvaddock (Limerick)', zip: '905235' },
	{ city: 'Ballyvade (Westmeath)', zip: '252921' },
	{ city: 'Ballyvadin (Tipperary)', zip: '125057' },
	{ city: 'Ballyvadlea (Tipperary)', zip: '646219' },
	{ city: 'Ballyvadona (Cork)', zip: '411053' },
	{ city: 'Ballyvaghan (Clare)', zip: '247297' },
	{ city: 'Ballyvaheen (Cork)', zip: '934921' },
	{ city: 'Ballyvaheen (Galway)', zip: '590280' },
	{ city: 'Ballyvaheen (Tipperary)', zip: '344984' },
	{ city: 'Ballyvake (Wexford)', zip: '473854' },
	{ city: 'Ballyvalden (Kilkenny)', zip: '739825' },
	{ city: 'Ballyvaldon (Wexford)', zip: '709807' },
	{ city: 'Ballyvallikin (Waterford)', zip: '214451' },
	{ city: 'Ballyvalloge (Wexford)', zip: '699487' },
	{ city: 'Ballyvalloo Lower (Wexford)', zip: '234000' },
	{ city: 'Ballyvalloona (Waterford)', zip: '197592' },
	{ city: 'Ballyvalloo Upper (Wexford)', zip: '431001' },
	{ city: 'Ballyvally (Clare)', zip: '599656' },
	{ city: 'Ballyvalode (Limerick)', zip: '800483' },
	{ city: 'Ballyvaloon (Cork)', zip: '548792' },
	{ city: 'Ballyvaltron (Wicklow)', zip: '956816' },
	{ city: 'Ballyvangour (Carlow)', zip: '369693' },
	{ city: 'Ballyvanna (Clare)', zip: '838967' },
	{ city: 'Ballyvannan (Clare)', zip: '389481' },
	{ city: 'Ballyvannan (Kildare)', zip: '846087' },
	{ city: 'Ballyvanran (Tipperary)', zip: '656561' },
	{ city: 'Ballyvara (Clare)', zip: '967160' },
	{ city: 'Ballyvareen (Limerick)', zip: '887953' },
	{ city: 'Ballyvarney (Kildare)', zip: '271099' },
	{ city: 'Ballyvaroge (Wexford)', zip: '690978' },
	{ city: 'Ballyvarra (Limerick)', zip: '554261' },
	{ city: 'Ballyvarra (Tipperary)', zip: '183142' },
	{ city: 'Ballyvarra Wood (Limerick)', zip: '944800' },
	{ city: 'Ballyvarring (Kilkenny)', zip: '275875' },
	{ city: 'Ballyvaskin North (Clare)', zip: '113214' },
	{ city: 'Ballyvaskin South (Clare)', zip: '928017' },
	{ city: 'Ballyvass (Kildare)', zip: '428341' },
	{ city: 'Ballyvatheen (Kilkenny)', zip: '255398' },
	{ city: 'Ballyvatta (Cork)', zip: '807778' },
	{ city: 'Ballyvaughan (Tipperary)', zip: '569087' },
	{ city: 'Ballyveal (Carlow)', zip: '128693' },
	{ city: 'Ballyvecane Lower (Waterford)', zip: '137319' },
	{ city: 'Ballyvecane Upper (Waterford)', zip: '226043' },
	{ city: 'Ballyveelick (Cork)', zip: '702799' },
	{ city: 'Ballyveelish (Limerick)', zip: '149980' },
	{ city: 'Ballyveelish North (Tipperary)', zip: '494967' },
	{ city: 'Ballyveelish South (Tipperary)', zip: '265497' },
	{ city: 'Ballyveera (Tipperary)', zip: '399861' },
	{ city: 'Ballyveerane (Cork)', zip: '547424' },
	{ city: 'Ballyvelaghan (Clare)', zip: '889408' },
	{ city: 'Ballyvelig (Wexford)', zip: '490717' },
	{ city: 'Ballyvellon (Waterford)', zip: '259582' },
	{ city: 'Ballyvelly (Kerry)', zip: '168877' },
	{ city: 'Ballyveloge (Limerick)', zip: '758836' },
	{ city: 'Ballyvelone East (Cork)', zip: '796481' },
	{ city: 'Ballyvelone West (Cork)', zip: '923838' },
	{ city: 'Ballyverassa (Tipperary)', zip: '232173' },
	{ city: 'Ballyvergal (Carlow)', zip: '258729' },
	{ city: 'Ballyvergan East (Cork)', zip: '469885' },
	{ city: 'Ballyvergan West (Cork)', zip: '525193' },
	{ city: 'Ballyvergin (Clare)', zip: '261039' },
	{ city: 'Ballyvergin (Wexford)', zip: '364687' },
	{ city: 'Ballyverneen (Kilkenny)', zip: '404536' },
	{ city: 'Ballyverroge (Wexford)', zip: '329530' },
	{ city: 'Ballyveskil (Clare)', zip: '583509' },
	{ city: 'Ballyvicmaha (Mayo)', zip: '534996' },
	{ city: 'Ballyviggane (Tipperary)', zip: '938852' },
	{ city: 'Ballyvillane (Tipperary)', zip: '260746' },
	{ city: 'Ballyviniter Lower (Cork)', zip: '979087' },
	{ city: 'Ballyviniter Middle (Cork)', zip: '739162' },
	{ city: 'Ballyviniter Upper (Cork)', zip: '263831' },
	{ city: 'Ballyvirane (Tipperary)', zip: '858294' },
	{ city: 'Ballyvireen (Cork)', zip: '139904' },
	{ city: 'Ballyvirrane (Kerry)', zip: '544430' },
	{ city: 'Ballyvistea (Tipperary)', zip: '538991' },
	{ city: 'Ballyvisteale (Cork)', zip: '467344' },
	{ city: 'Ballyvisteale Demesne (Cork)', zip: '373044' },
	{ city: 'Ballyvisteen (Cork)', zip: '484914' },
	{ city: 'Ballyvlin (Offaly)', zip: '534693' },
	{ city: 'Ballyvockoge (Limerick)', zip: '773986' },
	{ city: 'Ballyvodane (Cork)', zip: '768314' },
	{ city: 'Ballyvoddy (Cork)', zip: '540973' },
	{ city: 'Ballyvodock East (Cork)', zip: '920567' },
	{ city: 'Ballyvodock West (Cork)', zip: '619447' },
	{ city: 'Ballyvoe (Clare)', zip: '156491' },
	{ city: 'Ballyvoge (Cork)', zip: '298855' },
	{ city: 'Ballyvoge Beg (Cork)', zip: '561774' },
	{ city: 'Ballyvoge More (Cork)', zip: '150314' },
	{ city: 'Ballyvoghan (Limerick)', zip: '561212' },
	{ city: 'Ballyvoghan (Wicklow)', zip: '170371' },
	{ city: 'Ballyvogue (Limerick)', zip: '965254' },
	{ city: 'Ballyvohalane (Waterford)', zip: '153558' },
	{ city: 'Ballyvohane (Clare)', zip: '693468' },
	{ city: 'Ballyvoher (Galway)', zip: '492919' },
	{ city: 'Ballyvoige (Cork)', zip: '850630' },
	{ city: 'Ballyvolane (Cork)', zip: '914641' },
	{ city: 'Ballyvolan Lower (Wicklow)', zip: '470458' },
	{ city: 'Ballyvolan Upper (Wicklow)', zip: '344991' },
	{ city: 'Ballyvolden (Carlow)', zip: '632297' },
	{ city: 'Ballyvollane (Limerick)', zip: '654173' },
	{ city: 'Ballyvolock (Cork)', zip: '861741' },
	{ city: 'Ballyvologe (Limerick)', zip: '235410' },
	{ city: 'Ballyvoloon (Cork)', zip: '459313' },
	{ city: 'Ballyvonane (Cork)', zip: '912884' },
	{ city: 'Ballyvoneen (Galway)', zip: '834695' },
	{ city: 'Ballyvoneen (Kildare)', zip: '575119' },
	{ city: 'Ballyvoneen (Limerick)', zip: '682622' },
	{ city: 'Ballyvoneen (Tipperary)', zip: '367288' },
	{ city: 'Ballyvongane (Cork)', zip: '821187' },
	{ city: 'Ballyvonnavaun (Clare)', zip: '315869' },
	{ city: 'Ballyvoodane (Limerick)', zip: '581225' },
	{ city: 'Ballyvoodock (Wexford)', zip: '197527' },
	{ city: 'Ballyvoodrane (Wexford)', zip: '207819' },
	{ city: 'Ballyvool (Kilkenny)', zip: '598674' },
	{ city: 'Ballyvoony (Waterford)', zip: '778463' },
	{ city: 'Ballyvora (Offaly)', zip: '907884' },
	{ city: 'Ballyvorane (Cork)', zip: '175237' },
	{ city: 'Ballyvorane North (Cork)', zip: '983555' },
	{ city: 'Ballyvorane South (Cork)', zip: '809130' },
	{ city: 'Ballyvorda (Clare)', zip: '822109' },
	{ city: 'Ballyvoreen (Waterford)', zip: '683339' },
	{ city: 'Ballyvorgal Beg (Clare)', zip: '467469' },
	{ city: 'Ballyvorgal North (Clare)', zip: '995189' },
	{ city: 'Ballyvorgal South (Clare)', zip: '830373' },
	{ city: 'Ballyvorheen (Limerick)', zip: '773694' },
	{ city: 'Ballyvorisheen (Cork)', zip: '747763' },
	{ city: 'Ballyvorisheen East (Cork)', zip: '212091' },
	{ city: 'Ballyvorisheen West (Cork)', zip: '821548' },
	{ city: 'Ballyvorneen (Limerick)', zip: '165623' },
	{ city: 'Ballyvoskillakeen (Cork)', zip: '852708' },
	{ city: 'Ballyvouden (Limerick)', zip: '854353' },
	{ city: 'Ballyvoughallan (Clare)', zip: '595383' },
	{ city: 'Ballyvoulera (Kilkenny)', zip: '982832' },
	{ city: 'Ballyvourney (Cork)', zip: '960414' },
	{ city: 'Ballyvouskill (Cork)', zip: '673032' },
	{ city: 'Ballyvoyle (Waterford)', zip: '184808' },
	{ city: 'Ballyvraghan (Wicklow)', zip: '625579' },
	{ city: 'Ballyvranneen (Clare)', zip: '687456' },
	{ city: 'Ballyvrin Lower (Cork)', zip: '611389' },
	{ city: 'Ballyvrin Upper (Cork)', zip: '940664' },
	{ city: 'Ballyvrislaun (Clare)', zip: '445005' },
	{ city: 'Ballyvroghaun Eighter (Clare)', zip: '935520' },
	{ city: 'Ballyvroghaun Oughter (Clare)', zip: '629413' },
	{ city: 'Ballyvulhane (Limerick)', zip: '898284' },
	{ city: 'Ballyvullagan (Clare)', zip: '192712' },
	{ city: 'Ballyvullaun (Galway)', zip: '476881' },
	{ city: 'Ballywairy (Kilkenny)', zip: '676565' },
	{ city: 'Ballywalter (Cork)', zip: '718226' },
	{ city: 'Ballywalter (Kilkenny)', zip: '926712' },
	{ city: 'Ballywalter (Longford)', zip: '225380' },
	{ city: 'Ballywalter (Mayo)', zip: '761195' },
	{ city: 'Ballywalter (Tipperary)', zip: '245758' },
	{ city: 'Ballywalter (Wexford)', zip: '347305' },
	{ city: 'Ballywalter Beg (Wexford)', zip: '731267' },
	{ city: 'Ballywalter Demesne (Cork)', zip: '315361' },
	{ city: 'Ballywalter More (Wexford)', zip: '589158' },
	{ city: 'Ballywaltrin (Wicklow)', zip: '643526' },
	{ city: 'Ballyward (Wicklow)', zip: '380308' },
	{ city: 'Ballywataire (Galway)', zip: '159800' },
	{ city: 'Ballywater (Wexford)', zip: '627912' },
	{ city: 'Ballywater Lower (Wexford)', zip: '779342' },
	{ city: 'Ballywater Upper (Wexford)', zip: '585412' },
	{ city: 'Ballyweeaun (Galway)', zip: '170955' },
	{ city: 'Ballyweela (Mayo)', zip: '703003' },
	{ city: 'Ballyweelin (Sligo)', zip: '481736' },
	{ city: 'Ballywelligan (Waterford)', zip: '599982' },
	{ city: 'Ballywether (Wexford)', zip: '182874' },
	{ city: 'Ballywiheen (Kerry)', zip: '461433' },
	{ city: 'Ballywilliam (Cork)', zip: '969288' },
	{ city: 'Ballywilliam (Offaly)', zip: '898565' },
	{ city: 'Ballywilliam (Tipperary)', zip: '110033' },
	{ city: 'Ballywilliam (Wexford)', zip: '151226' },
	{ city: 'Ballywilliam Demesne (Limerick)', zip: '968734' },
	{ city: 'Ballywilliam North (Limerick)', zip: '119518' },
	{ city: 'Ballywilliamreagh (Offaly)', zip: '370908' },
	{ city: 'Ballywilliamroe (Carlow)', zip: '610843' },
	{ city: 'Ballywilliamroe (Wexford)', zip: '841229' },
	{ city: 'Ballywilliam South (Limerick)', zip: '922647' },
	{ city: 'Ballywillin (Longford)', zip: '173373' },
	{ city: 'Ballywinna (Galway)', zip: '927158' },
	{ city: 'Ballywinterrourke (Limerick)', zip: '699027' },
	{ city: 'Ballywinterrourkewood (Limerick)', zip: '891661' },
	{ city: 'Ballywire (Tipperary)', zip: '405551' },
	{ city: 'Ballywish (Wexford)', zip: '146723' },
	{ city: 'Ballywitch (Wexford)', zip: '555304' },
	{ city: 'Balnagall (Longford)', zip: '787508' },
	{ city: 'Balnagon Lower (Meath)', zip: '444474' },
	{ city: 'Balnagon Upper (Meath)', zip: '554363' },
	{ city: 'Balnamona (Westmeath)', zip: '640969' },
	{ city: 'Balnavine (Westmeath)', zip: '455683' },
	{ city: 'Bal Of Dookinelly (Mayo)', zip: '942533' },
	{ city: 'Balrath (Meath)', zip: '720460' },
	{ city: 'Balrath (Westmeath)', zip: '140318' },
	{ city: 'Balrathboyne Glebe (Meath)', zip: '949326' },
	{ city: 'Balrath Demesne (Meath)', zip: '157749' },
	{ city: 'Balrath East (Westmeath)', zip: '303098' },
	{ city: 'Balrath North (Westmeath)', zip: '565779' },
	{ city: 'Balrath South (Westmeath)', zip: '104334' },
	{ city: 'Balrath West (Westmeath)', zip: '668255' },
	{ city: 'Balreagh (Westmeath)', zip: '537214' },
	{ city: 'Balreask (Meath)', zip: '417287' },
	{ city: 'Balreask Old (Meath)', zip: '543569' },
	{ city: 'Balregan (Louth)', zip: '987863' },
	{ city: 'Balrenny (Meath)', zip: '315225' },
	{ city: 'Balrickard (Dublin)', zip: '717685' },
	{ city: 'Balrickard (Galway)', zip: '186287' },
	{ city: 'Balriggan (Louth)', zip: '156701' },
	{ city: 'Balrinnet (Kildare)', zip: '248614' },
	{ city: 'Balrobin (Louth)', zip: '928671' },
	{ city: 'Balrobuck Beg (Galway)', zip: '582225' },
	{ city: 'Balrobuck More (Galway)', zip: '764158' },
	{ city: 'Balroe (Westmeath)', zip: '407670' },
	{ city: 'Balrothery (Dublin)', zip: '281760' },
	{ city: 'Balrowan (Westmeath)', zip: '327786' },
	{ city: 'Balruntagh (Meath)', zip: '593732' },
	{ city: 'Balsaran (Meath)', zip: '934808' },
	{ city: 'Balsaw (Meath)', zip: '630890' },
	{ city: 'Balscaddan (Dublin)', zip: '303524' },
	{ city: 'Balscott (Kildare)', zip: '567797' },
	{ city: 'Balseskin (Dublin)', zip: '780372' },
	{ city: 'Balsitric (Meath)', zip: '544126' },
	{ city: 'Balsoon (Meath)', zip: '244567' },
	{ city: 'Balteen (Cork)', zip: '348514' },
	{ city: 'Balteenbrack (Cork)', zip: '858845' },
	{ city: 'Baltigeer (Meath)', zip: '388422' },
	{ city: 'Baltimore (Cork)', zip: '594621' },
	{ city: 'Baltinakin (Cork)', zip: '104328' },
	{ city: 'Baltinglass (Wicklow)', zip: '197331' },
	{ city: 'Baltinglass East (Wicklow)', zip: '252702' },
	{ city: 'Baltinglass West (Wicklow)', zip: '512898' },
	{ city: 'Baltinoran (Meath)', zip: '818703' },
	{ city: 'Baltovin (Kerry)', zip: '118878' },
	{ city: 'Baltracey (Kildare)', zip: '883900' },
	{ city: 'Baltrasna (Dublin)', zip: '526661' },
	{ city: 'Baltrasna (Louth)', zip: '839478' },
	{ city: 'Baltrasna (Meath)', zip: '235070' },
	{ city: 'Baltrasna (Westmeath)', zip: '506537' },
	{ city: 'Baltray (Louth)', zip: '716555' },
	{ city: 'Baltydaniel East (Cork)', zip: '270257' },
	{ city: 'Baltydaniel West (Cork)', zip: '345175' },
	{ city: 'Baltyfarrell (Wexford)', zip: '506557' },
	{ city: 'Baltynanima (Wicklow)', zip: '240536' },
	{ city: 'Balwoges (Donegal)', zip: '154737' },
	{ city: 'Banada (Roscommon)', zip: '198478' },
	{ city: 'Banada (Sligo)', zip: '343379' },
	{ city: 'Banagher (Cavan)', zip: '403147' },
	{ city: 'Banagher (Galway)', zip: '248339' },
	{ city: 'Banagher (Kilkenny)', zip: '206668' },
	{ city: 'Banagher (Leitrim)', zip: '363688' },
	{ city: 'Banagher (Mayo)', zip: '850105' },
	{ city: 'Banagher (Offaly)', zip: '634186' },
	{ city: 'Banagher (Westmeath)', zip: '958991' },
	{ city: 'Bananstown (Westmeath)', zip: '623557' },
	{ city: 'Banard (Kerry)', zip: '558374' },
	{ city: 'Bandon (Cork)', zip: '340335' },
	{ city: 'Banduff (Cork)', zip: '132645' },
	{ city: 'Baneena North (Cork)', zip: '254384' },
	{ city: 'Baneena South (Cork)', zip: '839091' },
	{ city: 'Banefune (Cork)', zip: '720910' },
	{ city: 'Banemore (Kerry)', zip: '624837' },
	{ city: 'Banemore (Limerick)', zip: '237368' },
	{ city: 'Baneshane (Cork)', zip: '626658' },
	{ city: 'Banestown (Meath)', zip: '214892' },
	{ city: 'Banganboy (Donegal)', zip: '185001' },
	{ city: 'Banghill (Longford)', zip: '677744' },
	{ city: 'Bangor (Mayo)', zip: '118700' },
	{ city: 'Bangort (Donegal)', zip: '311951' },
	{ city: 'Bank (Cork)', zip: '225490' },
	{ city: 'Bankerstown (Louth)', zip: '716647' },
	{ city: 'Banktown (Louth)', zip: '509600' },
	{ city: 'Banna East (Kerry)', zip: '820994' },
	{ city: 'Bannagagole (Carlow)', zip: '646011' },
	{ city: 'Bannagh (Cork)', zip: '669636' },
	{ city: 'Bannaghbane (Monaghan)', zip: '445821' },
	{ city: 'Bannaghroe (Monaghan)', zip: '301424' },
	{ city: 'Bannagroe (Wicklow)', zip: '482433' },
	{ city: 'Bannamore (Tipperary)', zip: '718536' },
	{ city: 'Banna-Mountain (Kerry)', zip: '172357' },
	{ city: 'Banna South (Kerry)', zip: '301178' },
	{ city: 'Banna West (Kerry)', zip: '875989' },
	{ city: 'Bannixtown (Tipperary)', zip: '466107' },
	{ city: 'Bannow (Wexford)', zip: '629081' },
	{ city: 'Bannow Island (Wexford)', zip: '295753' },
	{ city: 'Bannow Moor (Wexford)', zip: '806303' },
	{ city: 'Bannpark (Wexford)', zip: '549073' },
	{ city: 'Banntown (Wexford)', zip: '361752' },
	{ city: 'Bannus (Donegal)', zip: '622055' },
	{ city: 'Banoge (Limerick)', zip: '869339' },
	{ city: 'Banoge (Wexford)', zip: '568314' },
	{ city: 'Banoge Beg (Kerry)', zip: '650473' },
	{ city: 'Banogehill (Wexford)', zip: '648684' },
	{ city: 'Banoge North (Kerry)', zip: '834117' },
	{ city: 'Banoge South (Kerry)', zip: '655184' },
	{ city: 'Banraghbaun North (Galway)', zip: '248378' },
	{ city: 'Banraghbaun South (Galway)', zip: '411442' },
	{ city: 'Banse Glebe (Kilkenny)', zip: '447366' },
	{ city: 'Bansha (Clare)', zip: '818840' },
	{ city: 'Bansha (Limerick)', zip: '749756' },
	{ city: 'Bansha (Tipperary)', zip: '230616' },
	{ city: 'Bansha East (Tipperary)', zip: '737364' },
	{ city: 'Banshagh (Kerry)', zip: '646013' },
	{ city: 'Bansha West (Tipperary)', zip: '622571' },
	{ city: 'Banshee (Dublin)', zip: '659709' },
	{ city: 'Banshy (Cork)', zip: '218288' },
	{ city: 'Banteer (Cork)', zip: '858934' },
	{ city: 'Bantis (Tipperary)', zip: '327084' },
	{ city: 'Bantry (Cork)', zip: '323716' },
	{ city: 'Bantry Commons (Wexford)', zip: '695656' },
	{ city: 'Baptistgrange (Tipperary)', zip: '226295' },
	{ city: 'Barabona (Louth)', zip: '926392' },
	{ city: 'Baraghy (Cavan)', zip: '615457' },
	{ city: 'Baralty (Mayo)', zip: '255799' },
	{ city: 'Baravore (Wicklow)', zip: '307290' },
	{ city: 'Barbaha (Tipperary)', zip: '898759' },
	{ city: 'Barbane (Clare)', zip: '236447' },
	{ city: 'Barbavilla Demesne (Westmeath)', zip: '680526' },
	{ city: 'Barbersfort (Galway)', zip: '643996' },
	{ city: 'Barberstown (Dublin)', zip: '774330' },
	{ city: 'Barberstown (Kildare)', zip: '899313' },
	{ city: 'Barberstown Lower (Kildare)', zip: '335985' },
	{ city: 'Barberstown Upper (Kildare)', zip: '748830' },
	{ city: 'Barcam (Offaly)', zip: '291983' },
	{ city: 'Barchuillia Commons (Wicklow)', zip: '837787' },
	{ city: 'Barconny (Cavan)', zip: '833527' },
	{ city: 'Barcull (Mayo)', zip: '983465' },
	{ city: 'Barcullin (Roscommon)', zip: '579649' },
	{ city: 'Bardanstown (Westmeath)', zip: '435165' },
	{ city: 'Bardinch (Cork)', zip: '421061' },
	{ city: 'Barefield (Clare)', zip: '197177' },
	{ city: 'Bare Rock (Galway)', zip: '914237' },
	{ city: 'Barfordstown (Meath)', zip: '313311' },
	{ city: 'Bargarriff (Clare)', zip: '655593' },
	{ city: 'Bargarriff (Cork)', zip: '595214' },
	{ city: 'Bargarriff (Mayo)', zip: '151955' },
	{ city: 'Bargowla (Leitrim)', zip: '490544' },
	{ city: 'Bargy (Wexford)', zip: '434387' },
	{ city: 'Bargy Commons (Wexford)', zip: '399487' },
	{ city: 'Barheen (Mayo)', zip: '944934' },
	{ city: 'Barkersford (Kildare)', zip: '395132' },
	{ city: 'Barkillew (Donegal)', zip: '128189' },
	{ city: 'Barkmill (Laois)', zip: '935841' },
	{ city: 'Barlahan (Offaly)', zip: '451757' },
	{ city: 'Barlear (Leitrim)', zip: '822667' },
	{ city: 'Barleyfield (Cork)', zip: '411755' },
	{ city: 'Barleyhill (Cork)', zip: '609912' },
	{ city: 'Barleyhill (Mayo)', zip: '438649' },
	{ city: 'Barleyhill (Meath)', zip: '468977' },
	{ city: 'Barleyhill East (Cork)', zip: '301494' },
	{ city: 'Barleyhill West (Cork)', zip: '291778' },
	{ city: 'Barleymount East (Kerry)', zip: '409287' },
	{ city: 'Barleymount Middle (Kerry)', zip: '218264' },
	{ city: 'Barleymount West (Kerry)', zip: '311241' },
	{ city: 'Barloughra (Clare)', zip: '541467' },
	{ city: 'Barmeath (Louth)', zip: '974592' },
	{ city: 'Barmona (Wexford)', zip: '142534' },
	{ city: 'Barmoney (Wexford)', zip: '951918' },
	{ city: 'Barna (Cork)', zip: '135873' },
	{ city: 'Barna (Galway)', zip: '935239' },
	{ city: 'Barna (Kerry)', zip: '991030' },
	{ city: 'Barna (Kilkenny)', zip: '265827' },
	{ city: 'Barna (Limerick)', zip: '860007' },
	{ city: 'Barna (Mayo)', zip: '772104' },
	{ city: 'Barna (Offaly)', zip: '413913' },
	{ city: 'Barna (Tipperary)', zip: '712232' },
	{ city: 'Barnabah (Cork)', zip: '743887' },
	{ city: 'Barnabaun (Mayo)', zip: '222988' },
	{ city: 'Barnabaun (Tipperary)', zip: '390897' },
	{ city: 'Barnaboy (Galway)', zip: '823578' },
	{ city: 'Barnaboy (Laois)', zip: '592546' },
	{ city: 'Barnaboy (Offaly)', zip: '594900' },
	{ city: 'Barnaboy (Roscommon)', zip: '958077' },
	{ city: 'Barnabrack (Sligo)', zip: '677763' },
	{ city: 'Barnabrow (Cork)', zip: '581425' },
	{ city: 'Barnacahoge (Mayo)', zip: '639189' },
	{ city: 'Barnacashel (Wicklow)', zip: '692408' },
	{ city: 'Barnacawley (Roscommon)', zip: '541142' },
	{ city: 'Barnacleagh East (Wicklow)', zip: '619823' },
	{ city: 'Barnacleagh North (Wicklow)', zip: '887331' },
	{ city: 'Barnacleagh South (Wicklow)', zip: '473574' },
	{ city: 'Barnacoghil (Sligo)', zip: '875573' },
	{ city: 'Barnacole (Kilkenny)', zip: '313617' },
	{ city: 'Barnacor (Longford)', zip: '821907' },
	{ city: 'Barnacoyle Big (Wicklow)', zip: '501285' },
	{ city: 'Barnacoyle Little (Wicklow)', zip: '110811' },
	{ city: 'Barnacragh (Galway)', zip: '100573' },
	{ city: 'Barnacrow (Kildare)', zip: '389359' },
	{ city: 'Barnacuillew (Mayo)', zip: '974067' },
	{ city: 'Barnacullen (Roscommon)', zip: '913438' },
	{ city: 'Barnacullia (Dublin)', zip: '428622' },
	{ city: 'Barnacurra (Cork)', zip: '887335' },
	{ city: 'Barnacurra (Galway)', zip: '418575' },
	{ city: 'Barnacurragh (Galway)', zip: '458441' },
	{ city: 'Barnadarrig (Kerry)', zip: '622302' },
	{ city: 'Barnadarrig (Laois)', zip: '736077' },
	{ city: 'Barnaderg (Galway)', zip: '395659' },
	{ city: 'Barnaderg (Mayo)', zip: '246477' },
	{ city: 'Barnaderg (Sligo)', zip: '620342' },
	{ city: 'Barnaderg North (Galway)', zip: '487695' },
	{ city: 'Barnaderg South (Galway)', zip: '341423' },
	{ city: 'Barnadivane (Cork)', zip: '588674' },
	{ city: 'Barnadown (Kilkenny)', zip: '325038' },
	{ city: 'Barnadown (Wexford)', zip: '576836' },
	{ city: 'Barnadown Lower (Wexford)', zip: '317724' },
	{ city: 'Barnadown Upper (Wexford)', zip: '274252' },
	{ city: 'Barnagarrane (Limerick)', zip: '515751' },
	{ city: 'Barnagearagh (Cork)', zip: '990216' },
	{ city: 'Barnageehy East (Cork)', zip: '821642' },
	{ city: 'Barnageehy West (Cork)', zip: '703448' },
	{ city: 'Barnageeragh (Dublin)', zip: '462057' },
	{ city: 'Barnagore (Cork)', zip: '310888' },
	{ city: 'Barnagore (Tipperary)', zip: '572926' },
	{ city: 'Barnagorteeny (Galway)', zip: '254382' },
	{ city: 'Barnagouloge (Tipperary)', zip: '368125' },
	{ city: 'Barnagowlane (Cork)', zip: '427491' },
	{ city: 'Barnagowlane East (Cork)', zip: '387284' },
	{ city: 'Barnagowlane West (Cork)', zip: '697071' },
	{ city: 'Barnagree (Tipperary)', zip: '599441' },
	{ city: 'Barnagreggaun (Mayo)', zip: '858778' },
	{ city: 'Barnagrotty (Offaly)', zip: '226253' },
	{ city: 'Barnagrow (Cavan)', zip: '271364' },
	{ city: 'Barnagurry (Mayo)', zip: '266731' },
	{ city: 'Barnahallia (Galway)', zip: '496014' },
	{ city: 'Barnahask (Carlow)', zip: '720315' },
	{ city: 'Barnahask (Wexford)', zip: '429746' },
	{ city: 'Barnahaskin (Carlow)', zip: '176666' },
	{ city: 'Barnahely (Cork)', zip: '404195' },
	{ city: 'Barnahesker (Mayo)', zip: '780752' },
	{ city: 'Barnahown (Tipperary)', zip: '768084' },
	{ city: 'Barnahowna (Mayo)', zip: '353895' },
	{ city: 'Barnakillew (Mayo)', zip: '536563' },
	{ city: 'Barnakyle (Limerick)', zip: '726485' },
	{ city: 'Barnalascaw (Tipperary)', zip: '270072' },
	{ city: 'Barnalisheen (Tipperary)', zip: '148770' },
	{ city: 'Barnalyra (Mayo)', zip: '163051' },
	{ city: 'Barnameelia (Wicklow)', zip: '707955' },
	{ city: 'Barnameenagh (Leitrim)', zip: '201080' },
	{ city: 'Barnameenagh West (Leitrim)', zip: '914239' },
	{ city: 'Barnamire (Wicklow)', zip: '250776' },
	{ city: 'Barnamuinga (Wicklow)', zip: '462725' },
	{ city: 'Barnan (Offaly)', zip: '853387' },
	{ city: 'Barnanageeha (Clare)', zip: '945752' },
	{ city: 'Barnanalleen (Tipperary)', zip: '635767' },
	{ city: 'Barnanang (Galway)', zip: '491896' },
	{ city: 'Barnane (Tipperary)', zip: '347182' },
	{ city: 'Barnankile (Waterford)', zip: '427132' },
	{ city: 'Barnanoraun (Galway)', zip: '880629' },
	{ city: 'Barnanstown (Dublin)', zip: '153588' },
	{ city: 'Barnaran (Kildare)', zip: '240948' },
	{ city: 'Barnaree (Wexford)', zip: '730722' },
	{ city: 'Barnariddery (Wexford)', zip: '608000' },
	{ city: 'Barnarobin (Sligo)', zip: '117692' },
	{ city: 'Barnasallagh (Laois)', zip: '632680' },
	{ city: 'Barnashillane (Cork)', zip: '703837' },
	{ city: 'Barnaslingan (Dublin)', zip: '471860' },
	{ city: 'Barnasrahy (Sligo)', zip: '347547' },
	{ city: 'Barnastang (Mayo)', zip: '632244' },
	{ city: 'Barnastooka (Kerry)', zip: '922595' },
	{ city: 'Barnatonicane (Cork)', zip: '840608' },
	{ city: 'Barnatra (Mayo)', zip: '738843' },
	{ city: 'Barnaveddoge (Louth)', zip: '595102' },
	{ city: 'Barnaviddane (Cork)', zip: '123143' },
	{ city: 'Barnaviddaun North (Kilkenny)', zip: '556426' },
	{ city: 'Barnaviddaun South (Kilkenny)', zip: '795731' },
	{ city: 'Barnavihall (Galway)', zip: '372605' },
	{ city: 'Barnawheel (Wexford)', zip: '136830' },
	{ city: 'Barnbawn (Wicklow)', zip: '180328' },
	{ city: 'Barn Demesne (Tipperary)', zip: '315295' },
	{ city: 'Barndonagh (Monaghan)', zip: '618074' },
	{ city: 'Barne (Longford)', zip: '382608' },
	{ city: 'Barnes Lower (Donegal)', zip: '681372' },
	{ city: 'Barnesmore (Donegal)', zip: '702650' },
	{ city: 'Barnes Upper (Donegal)', zip: '511058' },
	{ city: 'Barnesyneilly (Donegal)', zip: '973787' },
	{ city: 'Barnetstown (Cork)', zip: '624032' },
	{ city: 'Barney (Longford)', zip: '683773' },
	{ city: 'Barney (Mayo)', zip: '949710' },
	{ city: 'Barneygole (Longford)', zip: '236579' },
	{ city: 'Barnfield (Cork)', zip: '549274' },
	{ city: 'Barnhall (Kildare)', zip: '977268' },
	{ city: 'Barnhill (Carlow)', zip: '333440' },
	{ city: 'Barnhill (Dublin)', zip: '614087' },
	{ city: 'Barnhill (Kildare)', zip: '498716' },
	{ city: 'Barnhill (Roscommon)', zip: '738161' },
	{ city: 'Barnhill East (Kildare)', zip: '232495' },
	{ city: 'Barnhill Lower (Mayo)', zip: '375672' },
	{ city: 'Barnhill Upper (Mayo)', zip: '517012' },
	{ city: 'Barnhill West (Kildare)', zip: '172607' },
	{ city: 'Barnland (Wexford)', zip: '106589' },
	{ city: 'Barnlough (Tipperary)', zip: '447005' },
	{ city: 'Barnora (Tipperary)', zip: '855133' },
	{ city: 'Barnpark (Galway)', zip: '699227' },
	{ city: 'Barntick (Clare)', zip: '760533' },
	{ city: 'Barntown (Wexford)', zip: '728884' },
	{ city: 'Barnwellsgrove (Galway)', zip: '777835' },
	{ city: 'Barnwellstown (Meath)', zip: '355490' },
	{ city: 'Barny And Bealady (Laois)', zip: '217105' },
	{ city: 'Barnycarroll (Mayo)', zip: '672280' },
	{ city: 'Baronrath (Kildare)', zip: '124125' },
	{ city: 'Baronsland (Kildare)', zip: '408834' },
	{ city: 'Baronsland (Kilkenny)', zip: '799625' },
	{ city: 'Baronstown (Meath)', zip: '914530' },
	{ city: 'Baronstown (Tipperary)', zip: '607904' },
	{ city: 'Baronstown (Westmeath)', zip: '738708' },
	{ city: 'Baronstown Demesne (Westmeath)', zip: '398832' },
	{ city: 'Baronstown East (Kildare)', zip: '126897' },
	{ city: 'Baronstown Lower (Wicklow)', zip: '443508' },
	{ city: 'Baronstown Upper (Wicklow)', zip: '139923' },
	{ city: 'Baronstown West (Kildare)', zip: '936050' },
	{ city: 'Barrabehy (Kilkenny)', zip: '875554' },
	{ city: 'Barracashlaun (Leitrim)', zip: '822629' },
	{ city: 'Barrack (Donegal)', zip: '444041' },
	{ city: 'Barrack (Kerry)', zip: '922337' },
	{ city: 'Barrackcroghan (Wexford)', zip: '208430' },
	{ city: 'Barrack Green (Cork)', zip: '449641' },
	{ city: 'Barrackhill (Kilkenny)', zip: '713855' },
	{ city: 'Barrackhill (Mayo)', zip: '386475' },
	{ city: 'Barrackland (Mayo)', zip: '734453' },
	{ city: 'Barrack North (Mayo)', zip: '113382' },
	{ city: 'Barrackpark (Leitrim)', zip: '529017' },
	{ city: 'Barrackquarter (Laois)', zip: '898334' },
	{ city: 'Barrack South (Mayo)', zip: '163646' },
	{ city: 'Barracree (Waterford)', zip: '354307' },
	{ city: 'Barracreemountain Lower (Waterford)', zip: '446130' },
	{ city: 'Barracreemountain Upper (Waterford)', zip: '540222' },
	{ city: 'Barracurragh (Tipperary)', zip: '764302' },
	{ city: 'Barracurragh (Wexford)', zip: '921718' },
	{ city: 'Barradaw (Cork)', zip: '269019' },
	{ city: 'Barraderra (Kildare)', zip: '583709' },
	{ city: 'Barraderry (Galway)', zip: '111183' },
	{ city: 'Barraderry (Tipperary)', zip: '503958' },
	{ city: 'Barraderry East (Wicklow)', zip: '179089' },
	{ city: 'Barraderry North (Wicklow)', zip: '118599' },
	{ city: 'Barraderry West (Wicklow)', zip: '788698' },
	{ city: 'Barradoos (Laois)', zip: '479578' },
	{ city: 'Barradrum (Westmeath)', zip: '141514' },
	{ city: 'Barraduff (Kerry)', zip: '161024' },
	{ city: 'Barrafohona (Cork)', zip: '908253' },
	{ city: 'Barragarraun (Galway)', zip: '728315' },
	{ city: 'Barragh (Carlow)', zip: '203870' },
	{ city: 'Barragh (Cavan)', zip: '609040' },
	{ city: 'Barragh Beg (Leitrim)', zip: '945287' },
	{ city: 'Barragh Beg (Longford)', zip: '209992' },
	{ city: 'Barragh More (Leitrim)', zip: '750223' },
	{ city: 'Barragh More (Longford)', zip: '759274' },
	{ city: 'Barraglan (Wexford)', zip: '480982' },
	{ city: 'Barraglanna (Mayo)', zip: '356516' },
	{ city: 'Barrahaurin (Cork)', zip: '562248' },
	{ city: 'Barrahill (Laois)', zip: '256543' },
	{ city: 'Barrakilla (Kerry)', zip: '683082' },
	{ city: 'Barran (Cavan)', zip: '200751' },
	{ city: 'Barranafaddock (Waterford)', zip: '583630' },
	{ city: 'Barranagh East (Mayo)', zip: '606386' },
	{ city: 'Barranagh Island (Mayo)', zip: '882347' },
	{ city: 'Barranaghs (Offaly)', zip: '374820' },
	{ city: 'Barranagh West (Mayo)', zip: '106377' },
	{ city: 'Barranahash (Cork)', zip: '685099' },
	{ city: 'Barranaleaha (Waterford)', zip: '745083' },
	{ city: 'Barranalira (Waterford)', zip: '684869' },
	{ city: 'Barranamanoge (Waterford)', zip: '649946' },
	{ city: 'Barranarran Lower (Mayo)', zip: '426602' },
	{ city: 'Barranarran Upper (Mayo)', zip: '596436' },
	{ city: 'Barranashingaun (Waterford)', zip: '705492' },
	{ city: 'Barranastook (Waterford)', zip: '562858' },
	{ city: 'Barranastook Lower (Waterford)', zip: '481169' },
	{ city: 'Barranastook Upper (Waterford)', zip: '788691' },
	{ city: 'Barranisky East (Wicklow)', zip: '322520' },
	{ city: 'Barranisky West (Wicklow)', zip: '178544' },
	{ city: 'Barranny (Galway)', zip: '921647' },
	{ city: 'Barratitoppy Lower (Monaghan)', zip: '813590' },
	{ city: 'Barratitoppy Upper (Monaghan)', zip: '854231' },
	{ city: 'Barratleva (Galway)', zip: '223191' },
	{ city: 'Barratogher (Westmeath)', zip: '480150' },
	{ city: 'Barratoor (Galway)', zip: '873364' },
	{ city: 'Barratreana (Galway)', zip: '404563' },
	{ city: 'Barravakeen (Waterford)', zip: '438029' },
	{ city: 'Barravally (Kilkenny)', zip: '884250' },
	{ city: 'Barravally (Roscommon)', zip: '167196' },
	{ city: 'Barravie (Tipperary)', zip: '541512' },
	{ city: 'Barravilla (Galway)', zip: '413487' },
	{ city: 'Barrawinga (Laois)', zip: '324982' },
	{ city: 'Barreel (Mayo)', zip: '881684' },
	{ city: 'Barreen (Kildare)', zip: '355816' },
	{ city: 'Barrees (Cork)', zip: '823197' },
	{ city: 'Barreragh (Cork)', zip: '772129' },
	{ city: 'Barretstown (Kildare)', zip: '718035' },
	{ city: 'Barrettsgrange (Tipperary)', zip: '654403' },
	{ city: 'Barrettspark (Galway)', zip: '236739' },
	{ city: 'Barrettspark (Wexford)', zip: '644782' },
	{ city: 'Barrettsplot East (Mayo)', zip: '660520' },
	{ city: 'Barrettsplot West (Mayo)', zip: '346310' },
	{ city: 'Barrettstown (Kildare)', zip: '985272' },
	{ city: 'Barrettstown (Kilkenny)', zip: '928243' },
	{ city: 'Barrettstown (Tipperary)', zip: '975600' },
	{ city: 'Barrettstown (Westmeath)', zip: '584276' },
	{ city: 'Barrevagh (Galway)', zip: '101658' },
	{ city: 'Barrinagh (Roscommon)', zip: '142501' },
	{ city: 'Barrinclay (Cork)', zip: '721924' },
	{ city: 'Barringtonsbridge (Limerick)', zip: '577226' },
	{ city: 'Barristown (Waterford)', zip: '364394' },
	{ city: 'Barrockstown (Meath)', zip: '989668' },
	{ city: 'Barroe (Longford)', zip: '210145' },
	{ city: 'Barroe (Mayo)', zip: '956021' },
	{ city: 'Barroe (Sligo)', zip: '678970' },
	{ city: 'Barroe Lower (Sligo)', zip: '674823' },
	{ city: 'Barroe North (Sligo)', zip: '535279' },
	{ city: 'Barroe South (Sligo)', zip: '678226' },
	{ city: 'Barroe Upper (Sligo)', zip: '923175' },
	{ city: 'Barr Of Ballynacarrick (Donegal)', zip: '243972' },
	{ city: 'Barr Of Farrow (Leitrim)', zip: '906730' },
	{ city: 'Barroge (Wexford)', zip: '679025' },
	{ city: 'Barrogstown (Kildare)', zip: '820682' },
	{ city: 'Barrogstown East (Kildare)', zip: '844896' },
	{ city: 'Barrogstown West (Kildare)', zip: '615053' },
	{ city: 'Barronsknock (Kilkenny)', zip: '865770' },
	{ city: 'Barronstown (Louth)', zip: '469701' },
	{ city: 'Barronstown (Tipperary)', zip: '613321' },
	{ city: 'Barroosky (Mayo)', zip: '200650' },
	{ city: 'Barrow (Kerry)', zip: '716139' },
	{ city: 'Barrowford (Kildare)', zip: '806824' },
	{ city: 'Barrowhouse (Laois)', zip: '668217' },
	{ city: 'Barrowmount (Kilkenny)', zip: '673397' },
	{ city: 'Barrs East (Leitrim)', zip: '582171' },
	{ city: 'Barrslievenaroy (Galway)', zip: '962951' },
	{ city: 'Barrs West (Leitrim)', zip: '296199' },
	{ city: 'Barrusheen (Galway)', zip: '764676' },
	{ city: 'Barry (Longford)', zip: '911582' },
	{ city: 'Barry Beg (Roscommon)', zip: '818971' },
	{ city: 'Barry More (Roscommon)', zip: '302772' },
	{ city: 'Barryroe (Cork)', zip: '154508' },
	{ city: 'Barrysbrook (Offaly)', zip: '820216' },
	{ city: 'Barryscourt (Cork)', zip: '560477' },
	{ city: 'Barrysfarm (Limerick)', zip: '457545' },
	{ city: 'Barryshall (Cork)', zip: '827338' },
	{ city: 'Barrysmountain (Waterford)', zip: '463888' },
	{ city: 'Barrysparks (Dublin)', zip: '970375' },
	{ city: 'Barrystown (Wexford)', zip: '596357' },
	{ city: 'Barstown (Meath)', zip: '969077' },
	{ city: 'Bartlemy (Cork)', zip: '675919' },
	{ city: 'Bartleystown (Clare)', zip: '526615' },
	{ city: 'Bartonsfarm (Kilkenny)', zip: '966771' },
	{ city: 'Bartoose (Tipperary)', zip: '781807' },
	{ city: 'Bartragh (Sligo)', zip: '198697' },
	{ city: 'Bartragh Island (Mayo)', zip: '497982' },
	{ city: 'Bartramstown (Meath)', zip: '432024' },
	{ city: 'Bartrauve (Mayo)', zip: '681157' },
	{ city: 'Baskethill (Limerick)', zip: '364416' },
	{ city: 'Basketstown (Meath)', zip: '205154' },
	{ city: 'Baskill (Donegal)', zip: '879385' },
	{ city: 'Baskin (Dublin)', zip: '938706' },
	{ city: 'Baskinagh Lower (Meath)', zip: '306084' },
	{ city: 'Baskinagh Upper (Meath)', zip: '976265' },
	{ city: 'Baskin High (Westmeath)', zip: '106907' },
	{ city: 'Baskin Low (Westmeath)', zip: '138812' },
	{ city: 'Baslick (Roscommon)', zip: '867980' },
	{ city: 'Baslickane (Kerry)', zip: '988097' },
	{ city: 'Bastardstown (Wexford)', zip: '750120' },
	{ city: 'Batestown (Meath)', zip: '314260' },
	{ city: 'Batterjohn (Meath)', zip: '268813' },
	{ city: 'Batterstown (Meath)', zip: '272069' },
	{ city: 'Battlefield (Sligo)', zip: '122802' },
	{ city: 'Battlemount (Kildare)', zip: '527607' },
	{ city: 'Battlestown (Wexford)', zip: '406503' },
	{ city: 'Battsland (Louth)', zip: '521353' },
	{ city: 'Battstown (Westmeath)', zip: '286550' },
	{ city: 'Bauck (Carlow)', zip: '122562' },
	{ city: 'Baulbrack (Cork)', zip: '540451' },
	{ city: 'Baun (Kilkenny)', zip: '782576' },
	{ city: 'Baunacloka (Limerick)', zip: '548978' },
	{ city: 'Baunaghra (Laois)', zip: '611823' },
	{ city: 'Baunanattin (Kilkenny)', zip: '280338' },
	{ city: 'Baunaniska (Kilkenny)', zip: '746020' },
	{ city: 'Baunastackaun (Kilkenny)', zip: '625578' },
	{ city: 'Baunatillaun (Kilkenny)', zip: '352075' },
	{ city: 'Baunatlea (Limerick)', zip: '536983' },
	{ city: 'Baunavollaboy (Kilkenny)', zip: '918146' },
	{ city: 'Baunballinlough (Kilkenny)', zip: '189023' },
	{ city: 'Baunbrack (Laois)', zip: '720972' },
	{ city: 'Bauneen (Kilkenny)', zip: '757439' },
	{ city: 'Baunemon (Kilkenny)', zip: '420058' },
	{ city: 'Baunfree (Kilkenny)', zip: '848113' },
	{ city: 'Baungarriff (Kilkenny)', zip: '858714' },
	{ city: 'Baungarrow (Kilkenny)', zip: '130374' },
	{ city: 'Baunkyle (Clare)', zip: '290390' },
	{ city: 'Baunleath (Carlow)', zip: '998896' },
	{ city: 'Baunlusk (Kilkenny)', zip: '627576' },
	{ city: 'Baunmore (Clare)', zip: '835527' },
	{ city: 'Baunmore (Galway)', zip: '286178' },
	{ city: 'Baunmore (Kilkenny)', zip: '522905' },
	{ city: 'Baunmore (Limerick)', zip: '311022' },
	{ city: 'Baunnageeragh (Limerick)', zip: '856900' },
	{ city: 'Baunnageloge (Kilkenny)', zip: '887412' },
	{ city: 'Baunnanooneeny (Cork)', zip: '635744' },
	{ city: 'Baunnaraha (Kilkenny)', zip: '820537' },
	{ city: 'Baunoge (Galway)', zip: '285221' },
	{ city: 'Baunoge (Kilkenny)', zip: '556743' },
	{ city: 'Baunoge (Laois)', zip: '427174' },
	{ city: 'Baunogemeely (Laois)', zip: '894385' },
	{ city: 'Baunogenasraid (Carlow)', zip: '725263' },
	{ city: 'Baunogephlure (Carlow)', zip: '786319' },
	{ city: 'Baunoges (Galway)', zip: '872438' },
	{ city: 'Baunoges (Mayo)', zip: '261134' },
	{ city: 'Baunoges North (Galway)', zip: '973783' },
	{ city: 'Baunoges South (Galway)', zip: '903161' },
	{ city: 'Baunoulagh (Cork)', zip: '686333' },
	{ city: 'Baunragh (Galway)', zip: '157190' },
	{ city: 'Baunreagh (Carlow)', zip: '342128' },
	{ city: 'Baunreagh (Cork)', zip: '178148' },
	{ city: 'Baunreagh (Kilkenny)', zip: '212513' },
	{ city: 'Baunreagh (Laois)', zip: '758762' },
	{ city: 'Baunreagh (Limerick)', zip: '269012' },
	{ city: 'Baunree (Laois)', zip: '278005' },
	{ city: 'Baunrickeen (Kilkenny)', zip: '879513' },
	{ city: 'Baunskeha (Kilkenny)', zip: '551758' },
	{ city: 'Baunta (Kilkenny)', zip: '430737' },
	{ city: 'Bauntabarna (Kilkenny)', zip: '773548' },
	{ city: 'Baunta Commons (Kilkenny)', zip: '921211' },
	{ city: 'Baunteen (Limerick)', zip: '651751' },
	{ city: 'Bauntia (Galway)', zip: '189277' },
	{ city: 'Bauntlieve (Clare)', zip: '834166' },
	{ city: 'Baunyknav (Galway)', zip: '921724' },
	{ city: 'Bauragegaun (Clare)', zip: '563115' },
	{ city: 'Bauraglanna (Tipperary)', zip: '585218' },
	{ city: 'Bauragoogeen (Kerry)', zip: '283086' },
	{ city: 'Bauraneag (Limerick)', zip: '709815' },
	{ city: 'Bauravilla (Cork)', zip: '776689' },
	{ city: 'Baurearagh (Kerry)', zip: '777356' },
	{ city: 'Baurela (Wexford)', zip: '293493' },
	{ city: 'Baurgarriff (Cork)', zip: '461706' },
	{ city: 'Baurgorm (Cork)', zip: '590975' },
	{ city: 'Baurleigh (Cork)', zip: '657051' },
	{ city: 'Baurnadomeeny (Tipperary)', zip: '306773' },
	{ city: 'Baurnafea (Kilkenny)', zip: '544827' },
	{ city: 'Baurnagurrahy (Limerick)', zip: '345472' },
	{ city: 'Baurnahulla (Cork)', zip: '535574' },
	{ city: 'Baurnalicka (Limerick)', zip: '657019' },
	{ city: 'Baur North (Clare)', zip: '212276' },
	{ city: 'Baurroe (Clare)', zip: '233635' },
	{ city: 'Baurroe (Tipperary)', zip: '333343' },
	{ city: 'Baur South (Clare)', zip: '118193' },
	{ city: 'Baurstookeen (Tipperary)', zip: '441192' },
	{ city: 'Bausheen (Kerry)', zip: '824161' },
	{ city: 'Bauteogue (Laois)', zip: '330882' },
	{ city: 'Bauttagh (Galway)', zip: '255715' },
	{ city: 'Bauville Keeloges And Clonglash (Donegal)', zip: '982850' },
	{ city: 'Bavan (Donegal)', zip: '443220' },
	{ city: 'Bavan (Louth)', zip: '245113' },
	{ city: 'Bawn (Cavan)', zip: '150988' },
	{ city: 'Bawn (Cork)', zip: '142748' },
	{ city: 'Bawn (Kildare)', zip: '171802' },
	{ city: 'Bawn (Laois)', zip: '765947' },
	{ city: 'Bawn (Leitrim)', zip: '192973' },
	{ city: 'Bawn (Longford)', zip: '665647' },
	{ city: 'Bawn (Louth)', zip: '769711' },
	{ city: 'Bawn (Mayo)', zip: '212180' },
	{ city: 'Bawn (Meath)', zip: '294130' },
	{ city: 'Bawn (Tipperary)', zip: '356305' },
	{ city: 'Bawn (Westmeath)', zip: '117378' },
	{ city: 'Bawnabraher (Waterford)', zip: '603485' },
	{ city: 'Bawnacarrigaun (Waterford)', zip: '322772' },
	{ city: 'Bawnachaulig (Kerry)', zip: '650421' },
	{ city: 'Bawnacommera (Waterford)', zip: '651848' },
	{ city: 'Bawnacouma (Limerick)', zip: '964866' },
	{ city: 'Bawnadoune (Cork)', zip: '688736' },
	{ city: 'Bawnagappul (Waterford)', zip: '789356' },
	{ city: 'Bawnagarrane (Waterford)', zip: '164159' },
	{ city: 'Bawnagh (Limerick)', zip: '964808' },
	{ city: 'Bawnaglanna (Kerry)', zip: '180174' },
	{ city: 'Bawnagoynig (Cork)', zip: '760241' },
	{ city: 'Bawnahila (Waterford)', zip: '248658' },
	{ city: 'Bawnakey (Tipperary)', zip: '274544' },
	{ city: 'Bawnaknockane (Cork)', zip: '191547' },
	{ city: 'Bawnanattin (Tipperary)', zip: '242822' },
	{ city: 'Bawnanearla (Cork)', zip: '376733' },
	{ city: 'Bawnaneel (Cork)', zip: '755931' },
	{ city: 'Bawnard (Cork)', zip: '308473' },
	{ city: 'Bawnard (Kerry)', zip: '882637' },
	{ city: 'Bawnard (Waterford)', zip: '894622' },
	{ city: 'Bawnard East (Cork)', zip: '815389' },
	{ city: 'Bawnard West (Cork)', zip: '930078' },
	{ city: 'Bawnaree (Laois)', zip: '953374' },
	{ city: 'Bawnaskehy (Kerry)', zip: '535486' },
	{ city: 'Bawnatanaknock (Cork)', zip: '467178' },
	{ city: 'Bawnatanavoher (Waterford)', zip: '233840' },
	{ city: 'Bawnatanvoher (Tipperary)', zip: '964253' },
	{ city: 'Bawnatemple (Cork)', zip: '199759' },
	{ city: 'Bawnavota (Cork)', zip: '163104' },
	{ city: 'Bawnavrona Lower (Tipperary)', zip: '181194' },
	{ city: 'Bawnavrona Upper (Tipperary)', zip: '133278' },
	{ city: 'Bawnboy (Cavan)', zip: '564448' },
	{ city: 'Bawnboy (Cork)', zip: '941615' },
	{ city: 'Bawnboy (Kerry)', zip: '769757' },
	{ city: 'Bawnbrack (Tipperary)', zip: '386003' },
	{ city: 'Bawnbrack (Waterford)', zip: '448739' },
	{ city: 'Bawnbreakey (Meath)', zip: '287143' },
	{ city: 'Bawnea (Cork)', zip: '149391' },
	{ city: 'Bawnfoun (Waterford)', zip: '860652' },
	{ city: 'Bawnfune (Cork)', zip: '464922' },
	{ city: 'Bawnfune (Waterford)', zip: '153717' },
	{ city: 'Bawngare (Cork)', zip: '136104' },
	{ city: 'Bawngoula (Cork)', zip: '717699' },
	{ city: 'Bawnhubbamaddereen (Kilkenny)', zip: '704635' },
	{ city: 'Bawnishal (Cork)', zip: '183863' },
	{ city: 'Bawnishall (Cork)', zip: '170082' },
	{ city: 'Bawnkeal (Tipperary)', zip: '737291' },
	{ city: 'Bawnlahan (Cork)', zip: '759172' },
	{ city: 'Bawnlaur (Waterford)', zip: '858908' },
	{ city: 'Bawnlea (Tipperary)', zip: '583922' },
	{ city: 'Bawnleigh (Cork)', zip: '222419' },
	{ city: 'Bawnluskaha (Kerry)', zip: '437178' },
	{ city: 'Bawnmacshane (Tipperary)', zip: '628952' },
	{ city: 'Bawnmadrum (Tipperary)', zip: '129495' },
	{ city: 'Bawnmadrum North (Tipperary)', zip: '635453' },
	{ city: 'Bawnmore (Cork)', zip: '489522' },
	{ city: 'Bawnmore (Kerry)', zip: '758271' },
	{ city: 'Bawnmore (Offaly)', zip: '229375' },
	{ city: 'Bawnmore (Tipperary)', zip: '827434' },
	{ city: 'Bawnmore (Waterford)', zip: '166285' },
	{ city: 'Bawnmore (Wexford)', zip: '977760' },
	{ city: 'Bawnmore North (Cork)', zip: '993622' },
	{ city: 'Bawnmore South (Cork)', zip: '438517' },
	{ city: 'Bawn Mountain (Longford)', zip: '124379' },
	{ city: 'Bawnnafinny (Cork)', zip: '796397' },
	{ city: 'Bawnnaglogh (Cork)', zip: '834145' },
	{ city: 'Bawnnagollopy (Cork)', zip: '417489' },
	{ city: 'Bawnnahow North (Cork)', zip: '212488' },
	{ city: 'Bawnnahow South (Cork)', zip: '273583' },
	{ city: 'Bawnnavinnoge (Waterford)', zip: '966418' },
	{ city: 'Bawnoge (Kildare)', zip: '269450' },
	{ city: 'Bawnoge (Wicklow)', zip: '860638' },
	{ city: 'Bawnoges (Dublin)', zip: '995245' },
	{ city: 'Bawnoges (Kildare)', zip: '460266' },
	{ city: 'Bawnoges (Westmeath)', zip: '162492' },
	{ city: 'Bawnreagh (Tipperary)', zip: '979924' },
	{ city: 'Bawnrickard (Tipperary)', zip: '179493' },
	{ city: 'Bawnshanaclogh (Cork)', zip: '219046' },
	{ city: 'Bawntaaffe (Louth)', zip: '274652' },
	{ city: 'Bawntameena (Tipperary)', zip: '628128' },
	{ city: 'Bawntanameenagh (Kilkenny)', zip: '577750' },
	{ city: 'Bawntard North (Limerick)', zip: '915124' },
	{ city: 'Bawntard South (Limerick)', zip: '902261' },
	{ city: 'Bay (Dublin)', zip: '447605' },
	{ city: 'Baybush (Kildare)', zip: '162883' },
	{ city: 'Bayhill (Donegal)', zip: '646618' },
	{ city: 'Bayland (Wexford)', zip: '290531' },
	{ city: 'Baylestown (Wexford)', zip: '514480' },
	{ city: 'Baylet (Donegal)', zip: '590237' },
	{ city: 'Baynanagh (Tipperary)', zip: '941047' },
	{ city: 'Baysland (Kildare)', zip: '143565' },
	{ city: 'Baysrath (Kilkenny)', zip: '304595' },
	{ city: 'Bayswell (Kilkenny)', zip: '693614' },
	{ city: 'Baytown (Meath)', zip: '157655' },
	{ city: 'Baytownpark (Meath)', zip: '717638' },
	{ city: 'Beabus (Limerick)', zip: '608578' },
	{ city: 'Beach (Cork)', zip: '358247' },
	{ city: 'Beaconstown (Kildare)', zip: '684807' },
	{ city: 'Beagh (Donegal)', zip: '108680' },
	{ city: 'Beagh (Galway)', zip: '746418' },
	{ city: 'Beagh (Leitrim)', zip: '718019' },
	{ city: 'Beagh (Limerick)', zip: '199300' },
	{ city: 'Beagh (Monaghan)', zip: '352303' },
	{ city: 'Beagh (Offaly)', zip: '616792' },
	{ city: 'Beagh (Roscommon)', zip: '729478' },
	{ city: 'Beagha (Galway)', zip: '197776' },
	{ city: 'Beaghbaun (Galway)', zip: '133045' },
	{ city: 'Beaghbeg (Roscommon)', zip: '389258' },
	{ city: 'Beagh Beg (Galway)', zip: '487841' },
	{ city: 'Beagh Beg (Leitrim)', zip: '216212' },
	{ city: 'Beaghcauneen (Galway)', zip: '417709' },
	{ city: 'Beagh Glebe (Cavan)', zip: '228205' },
	{ city: 'Beaghmore (Donegal)', zip: '368247' },
	{ city: 'Beagh More (Galway)', zip: '499966' },
	{ city: 'Beagh More (Leitrim)', zip: '838472' },
	{ city: 'Beaghroe (Galway)', zip: '664212' },
	{ city: 'Beaghy (Cavan)', zip: '626057' },
	{ city: 'Beaghy (Clare)', zip: '932011' },
	{ city: 'Beaghy Island (Galway)', zip: '226763' },
	{ city: 'Beaghy North (Galway)', zip: '925923' },
	{ city: 'Beak (Wexford)', zip: '618854' },
	{ city: 'Beakeen (Cork)', zip: '433512' },
	{ city: 'Beakstown (Tipperary)', zip: '888373' },
	{ city: 'Bealaclave (Tipperary)', zip: '529435' },
	{ city: 'Bealaclugga (Clare)', zip: '167332' },
	{ city: 'Bealad (Cork)', zip: '144177' },
	{ city: 'Bealadangan (Galway)', zip: '693516' },
	{ city: 'Bealad East (Cork)', zip: '466311' },
	{ city: 'Bealad West (Cork)', zip: '682527' },
	{ city: 'Bealagrellagh (Kerry)', zip: '338417' },
	{ city: 'Bealalaw (Carlow)', zip: '932332' },
	{ city: 'Bealcragga (Clare)', zip: '410217' },
	{ city: 'Bealdarrig (Kerry)', zip: '665651' },
	{ city: 'Bealduvroga (Limerick)', zip: '857902' },
	{ city: 'Beal East (Kerry)', zip: '351051' },
	{ city: 'Bealick (Cork)', zip: '455793' },
	{ city: 'Bealickania (Clare)', zip: '725106' },
	{ city: 'Bealin (Westmeath)', zip: '168600' },
	{ city: 'Bealkelly (Clare)', zip: '956210' },
	{ city: 'Bealkelly (Kerry)', zip: '266925' },
	{ city: 'Beallough (Waterford)', zip: '590282' },
	{ city: 'Beal Middle (Kerry)', zip: '451993' },
	{ city: 'Bealnalappa (Galway)', zip: '338904' },
	{ city: 'Bealnalicka (Clare)', zip: '537284' },
	{ city: 'Bealragh (Roscommon)', zip: '881235' },
	{ city: 'Beal West (Kerry)', zip: '293848' },
	{ city: 'Beanfield (Cork)', zip: '415805' },
	{ city: 'Beanfield (Sligo)', zip: '595983' },
	{ city: 'Beanhill North (Cork)', zip: '743940' },
	{ city: 'Beanhill South (Cork)', zip: '747671' },
	{ city: 'Bearforest Lower (Cork)', zip: '879400' },
	{ city: 'Bearforest Upper (Cork)', zip: '158680' },
	{ city: 'Bearlough (Sligo)', zip: '471156' },
	{ city: 'Bearlough (Wexford)', zip: '292098' },
	{ city: 'Bearnafunshin (Clare)', zip: '902193' },
	{ city: 'Bearvaish (Sligo)', zip: '340705' },
	{ city: 'Beatin (Kilkenny)', zip: '815960' },
	{ city: 'Beau (Dublin)', zip: '302284' },
	{ city: 'Beaufield (Wexford)', zip: '867543' },
	{ city: 'Beaufort (Kerry)', zip: '792591' },
	{ city: 'Beaugreen Glebe (Donegal)', zip: '856097' },
	{ city: 'Beaulieu (Louth)', zip: '422821' },
	{ city: 'Beaumont (Dublin)', zip: '599618' },
	{ city: 'Beaumont (Meath)', zip: '453994' },
	{ city: 'Beaverstown (Dublin)', zip: '114163' },
	{ city: 'Beckfield (Laois)', zip: '944188' },
	{ city: 'Beckfield North (Laois)', zip: '911121' },
	{ city: 'Beckfield South (Laois)', zip: '895556' },
	{ city: 'Beckscourt (Cavan)', zip: '953281' },
	{ city: 'Beckville (Wexford)', zip: '705200' },
	{ city: 'Bective (Meath)', zip: '991922' },
	{ city: 'Bedfanstown (Meath)', zip: '173426' },
	{ city: 'Bedford (Kerry)', zip: '607538' },
	{ city: 'Bedlesshill (Dublin)', zip: '677403' },
	{ city: 'Beech Hill (Galway)', zip: '302633' },
	{ city: 'Beechmount Demesne (Limerick)', zip: '473345' },
	{ city: 'Beechwood (Dublin)', zip: '866707' },
	{ city: 'Beefan (Donegal)', zip: '542198' },
	{ city: 'Beefan And Garveross Mountain (Donegal)', zip: '300746' },
	{ city: 'Beefield (Galway)', zip: '778096' },
	{ city: 'Beefpark (Donegal)', zip: '495459' },
	{ city: 'Beenalaght (Cork)', zip: '982070' },
	{ city: 'Beenateevaun (Kerry)', zip: '383262' },
	{ city: 'Beenbane (Kerry)', zip: '136797' },
	{ city: 'Beennageeha (Kerry)', zip: '761393' },
	{ city: 'Beennameelane (Kerry)', zip: '762010' },
	{ city: 'Beennamweel East (Cork)', zip: '801989' },
	{ city: 'Beennamweel West (Cork)', zip: '487028' },
	{ city: 'Beennanaspuck (Kerry)', zip: '653073' },
	{ city: 'Beennaskehy (Cork)', zip: '446644' },
	{ city: 'Beenreagh (Cork)', zip: '630573' },
	{ city: 'Beeverstown (Tipperary)', zip: '679475' },
	{ city: 'Befflaght (Donegal)', zip: '176608' },
	{ city: 'Begerin (Wexford)', zip: '671830' },
	{ city: 'Beggarstown (Offaly)', zip: '489132' },
	{ city: 'Beggerin Island (Wexford)', zip: '467245' },
	{ city: 'Beggstown (Meath)', zip: '572075' },
	{ city: 'Beggstown (Westmeath)', zip: '598239' },
	{ city: 'Beginish (Kerry)', zip: '593771' },
	{ city: 'Beglieve (Cavan)', zip: '124531' },
	{ city: 'Begnagh (Longford)', zip: '564003' },
	{ city: 'Begrath (Louth)', zip: '984604' },
	{ city: 'Begsreeve (Meath)', zip: '573233' },
	{ city: 'Behabane (Westmeath)', zip: '478373' },
	{ city: 'Behagh (Clare)', zip: '595302' },
	{ city: 'Behagh (Cork)', zip: '546929' },
	{ city: 'Behaghane (Kerry)', zip: '554462' },
	{ city: 'Behaghglass (Tipperary)', zip: '238188' },
	{ city: 'Behagullane (Cork)', zip: '584322' },
	{ city: 'Behamore (Tipperary)', zip: '174782' },
	{ city: 'Behanagh (Limerick)', zip: '161183' },
	{ city: 'Beheena (Cork)', zip: '992235' },
	{ city: 'Beheenagh (Kerry)', zip: '844171' },
	{ city: 'Beheens East (Kerry)', zip: '508883' },
	{ city: 'Beheens West (Kerry)', zip: '208436' },
	{ city: 'Behernagh (Cavan)', zip: '135361' },
	{ city: 'Behernagh (Offaly)', zip: '398907' },
	{ city: 'Behernagh Lower (Cork)', zip: '280926' },
	{ city: 'Behernagh Upper (Cork)', zip: '915918' },
	{ city: 'Behy (Cavan)', zip: '898293' },
	{ city: 'Behy (Donegal)', zip: '134600' },
	{ city: 'Behy (Mayo)', zip: '362025' },
	{ city: 'Behy (Roscommon)', zip: '121983' },
	{ city: 'Behy (Sligo)', zip: '595735' },
	{ city: 'Behybaun (Mayo)', zip: '316797' },
	{ city: 'Behy Beg (Mayo)', zip: '838299' },
	{ city: 'Behy More (Mayo)', zip: '869509' },
	{ city: 'Beihy (Leitrim)', zip: '465861' },
	{ city: 'Bekan (Mayo)', zip: '345392' },
	{ city: 'Beladd (Laois)', zip: '689132' },
	{ city: 'Belalt (Donegal)', zip: '509495' },
	{ city: 'Belalt North (Donegal)', zip: '654625' },
	{ city: 'Belalt South (Donegal)', zip: '250938' },
	{ city: 'Belan (Kildare)', zip: '624926' },
	{ city: 'Belan (Laois)', zip: '168678' },
	{ city: 'Belcamp (Dublin)', zip: '437515' },
	{ city: 'Belclare (Galway)', zip: '752836' },
	{ city: 'Belclare (Mayo)', zip: '969859' },
	{ city: 'Belclare (Sligo)', zip: '589587' },
	{ city: 'Belcruit (Donegal)', zip: '662416' },
	{ city: 'Beldaragh (Dublin)', zip: '122185' },
	{ city: 'Belderg (Mayo)', zip: '109818' },
	{ city: 'Belderg (Monaghan)', zip: '856183' },
	{ city: 'Belderg (Roscommon)', zip: '589620' },
	{ city: 'Belderg Beg (Mayo)', zip: '783486' },
	{ city: 'Belderg More (Mayo)', zip: '993730' },
	{ city: 'Belderny North (Galway)', zip: '688560' },
	{ city: 'Belderny South (Galway)', zip: '502792' },
	{ city: 'Belesker (Mayo)', zip: '222089' },
	{ city: 'Belfarsad (Mayo)', zip: '549708' },
	{ city: 'Belgard (Dublin)', zip: '734323' },
	{ city: 'Belgard (Kildare)', zip: '100705' },
	{ city: 'Belgard Deer Park (Dublin)', zip: '165113' },
	{ city: 'Belgarrow (Mayo)', zip: '961399' },
	{ city: 'Belgee (Dublin)', zip: '646015' },
	{ city: 'Belgooly (Cork)', zip: '433046' },
	{ city: 'Belgree (Dublin)', zip: '357292' },
	{ city: 'Belgree (Meath)', zip: '373274' },
	{ city: 'Belgrove (Cork)', zip: '848821' },
	{ city: 'Belhavel (Leitrim)', zip: '589003' },
	{ city: 'Belinstown (Dublin)', zip: '429961' },
	{ city: 'Bella (Roscommon)', zip: '163722' },
	{ city: 'Bellaburke (Mayo)', zip: '882722' },
	{ city: 'Bellacagher (Roscommon)', zip: '560091' },
	{ city: 'Bellaconeen (Galway)', zip: '412006' },
	{ city: 'Bellacorick (Mayo)', zip: '650390' },
	{ city: 'Belladaff (Mayo)', zip: '204287' },
	{ city: 'Belladooan (Mayo)', zip: '371076' },
	{ city: 'Belladrihid (Sligo)', zip: '413679' },
	{ city: 'Bellafa (Galway)', zip: '420516' },
	{ city: 'Bellafarney (Sligo)', zip: '348489' },
	{ city: 'Bellaganny (Donegal)', zip: '899763' },
	{ city: 'Bellagart (Leitrim)', zip: '719421' },
	{ city: 'Bellagarvaun (Mayo)', zip: '374891' },
	{ city: 'Bellageeher (Leitrim)', zip: '394343' },
	{ city: 'Bellagelly North (Mayo)', zip: '530667' },
	{ city: 'Bellagelly South (Mayo)', zip: '881497' },
	{ city: 'Bellagill (Roscommon)', zip: '731423' },
	{ city: 'Bellaheady (Cavan)', zip: '276311' },
	{ city: 'Bellaheen (Waterford)', zip: '519311' },
	{ city: 'Bellahy (Sligo)', zip: '518230' },
	{ city: 'Bellair (Laois)', zip: '283030' },
	{ city: 'Bellair (Offaly)', zip: '534176' },
	{ city: 'Bellakiltyfea (Leitrim)', zip: '908874' },
	{ city: 'Bellakip (Mayo)', zip: '327197' },
	{ city: 'Bellaleenan (Cavan)', zip: '725862' },
	{ city: 'Bellalegaun (Galway)', zip: '460517' },
	{ city: 'Bellamont Forest (Cavan)', zip: '200426' },
	{ city: 'Bellanaboy (Leitrim)', zip: '713541' },
	{ city: 'Bellanaboy (Mayo)', zip: '830426' },
	{ city: 'Bellanaboy (Sligo)', zip: '647676' },
	{ city: 'Bellanabriscaun (Mayo)', zip: '212763' },
	{ city: 'Bellanacargy (Cavan)', zip: '849289' },
	{ city: 'Bellanacarrow (Roscommon)', zip: '964511' },
	{ city: 'Bellanacurra (Mayo)', zip: '339330' },
	{ city: 'Bellanagall (Monaghan)', zip: '660214' },
	{ city: 'Bellanagare (Roscommon)', zip: '344544' },
	{ city: 'Bellanagarraun (Galway)', zip: '297773' },
	{ city: 'Bellanagarrigeeny (Sligo)', zip: '392866' },
	{ city: 'Bellanalack (Sligo)', zip: '834612' },
	{ city: 'Bellanalack (Westmeath)', zip: '745611' },
	{ city: 'Bellanaloob (Mayo)', zip: '776173' },
	{ city: 'Bellanaman (Monaghan)', zip: '419029' },
	{ city: 'Bellanamore (Donegal)', zip: '183300' },
	{ city: 'Bellanamullia (Roscommon)', zip: '434336' },
	{ city: 'Bellananagh (Cavan)', zip: '453555' },
	{ city: 'Bellanasally (Mayo)', zip: '289039' },
	{ city: 'Bellanascaddan (Donegal)', zip: '701703' },
	{ city: 'Bellanascarrow East (Sligo)', zip: '876882' },
	{ city: 'Bellanascarrow West (Sligo)', zip: '985296' },
	{ city: 'Bellanascarva (Sligo)', zip: '992369' },
	{ city: 'Bellaneeny (Roscommon)', zip: '747178' },
	{ city: 'Bellanierin (Mayo)', zip: '584600' },
	{ city: 'Bellanira (Mayo)', zip: '583552' },
	{ city: 'Bellanode (Monaghan)', zip: '593867' },
	{ city: 'Bellanode (Sligo)', zip: '810951' },
	{ city: 'Bellanumera (Mayo)', zip: '575911' },
	{ city: 'Bellanurly (Sligo)', zip: '193336' },
	{ city: 'Bellarush (Sligo)', zip: '299452' },
	{ city: 'Bellary (Wexford)', zip: '487459' },
	{ city: 'Bellasallagh (Mayo)', zip: '659301' },
	{ city: 'Bellass (Mayo)', zip: '747443' },
	{ city: 'Bellataleen (Mayo)', zip: '734155' },
	{ city: 'Bellaugh (Roscommon)', zip: '967192' },
	{ city: 'Bellaugh (Westmeath)', zip: '778563' },
	{ city: 'Bellavally Lower (Cavan)', zip: '531585' },
	{ city: 'Bellavally Upper (Cavan)', zip: '223080' },
	{ city: 'Bellavary (Mayo)', zip: '948876' },
	{ city: 'Bellavaum (Mayo)', zip: '511335' },
	{ city: 'Bellaveel (Mayo)', zip: '124460' },
	{ city: 'Bellaveeny (Mayo)', zip: '161282' },
	{ city: 'Bellawillinbeg (Sligo)', zip: '184822' },
	{ city: 'Bellayarha North (Galway)', zip: '314988' },
	{ city: 'Bellayarha South (Galway)', zip: '209477' },
	{ city: 'Bellcotton (Louth)', zip: '222218' },
	{ city: 'Belleek (Galway)', zip: '354280' },
	{ city: 'Belleek (Mayo)', zip: '961944' },
	{ city: 'Belleek (Meath)', zip: '922147' },
	{ city: 'Belleen Lower (Tipperary)', zip: '805888' },
	{ city: 'Belleen Upper (Tipperary)', zip: '756015' },
	{ city: 'Bellegrove (Laois)', zip: '616492' },
	{ city: 'Belleville (Tipperary)', zip: '625920' },
	{ city: 'Belleville (Waterford)', zip: '566491' },
	{ city: 'Belleville Demesne (Galway)', zip: '170778' },
	{ city: 'Bellevue (Tipperary)', zip: '939718' },
	{ city: 'Bellevue Demesne (Wicklow)', zip: '667233' },
	{ city: 'Bellew (Meath)', zip: '594451' },
	{ city: 'Bellewstown (Meath)', zip: '790422' },
	{ city: 'Bellfield (Mayo)', zip: '735076' },
	{ city: 'Bellfield (Westmeath)', zip: '923544' },
	{ city: 'Bellgrove (Tipperary)', zip: '583619' },
	{ city: 'Bellgrove (Wexford)', zip: '798287' },
	{ city: 'Bellgrovecross (Wexford)', zip: '842767' },
	{ city: 'Bellhill (Offaly)', zip: '649953' },
	{ city: 'Bellia (Clare)', zip: '772198' },
	{ city: 'Bellina (Donegal)', zip: '988473' },
	{ city: 'Belline And Rogerstown (Kilkenny)', zip: '707203' },
	{ city: 'Bellmount (Carlow)', zip: '273705' },
	{ city: 'Bellmount (Offaly)', zip: '699390' },
	{ city: 'Bellmount (Roscommon)', zip: '995352' },
	{ city: 'Bellmount Lower (Cork)', zip: '353197' },
	{ city: 'Bellmount Upper (Cork)', zip: '161271' },
	{ city: 'Bellpark (Tipperary)', zip: '702153' },
	{ city: 'Bellpark (Wicklow)', zip: '160307' },
	{ city: 'Bellsgrove (Cavan)', zip: '916888' },
	{ city: 'Bellshill (Carlow)', zip: '572576' },
	{ city: 'Bellspark (Roscommon)', zip: '594880' },
	{ city: 'Bellurgan (Louth)', zip: '247611' },
	{ city: 'Bellview (Westmeath)', zip: '958966' },
	{ city: 'Bellville (Cavan)', zip: '435072' },
	{ city: 'Bellville (Donegal)', zip: '681140' },
	{ city: 'Belmont (Galway)', zip: '413313' },
	{ city: 'Belmont (Offaly)', zip: '151006' },
	{ city: 'Belmont Demesne (Wicklow)', zip: '955278' },
	{ city: 'Belmount (Kilkenny)', zip: '929789' },
	{ city: 'Belmullet (Mayo)', zip: '154325' },
	{ city: 'Belpatrick (Louth)', zip: '735547' },
	{ city: 'Belpere (Meath)', zip: '772375' },
	{ city: 'Belra (Sligo)', zip: '105605' },
	{ city: 'Belrea (Roscommon)', zip: '997780' },
	{ city: 'Belrose (Cork)', zip: '534786' },
	{ city: 'Belrose Lower (Cork)', zip: '296060' },
	{ city: 'Belrose Upper (Cork)', zip: '764163' },
	{ city: 'Belshamstown (Meath)', zip: '447263' },
	{ city: 'Beltacken (Westmeath)', zip: '127211' },
	{ city: 'Beltany (Donegal)', zip: '714086' },
	{ city: 'Beltany Lower (Donegal)', zip: '907883' },
	{ city: 'Beltany Mountain (Donegal)', zip: '385092' },
	{ city: 'Beltany Upper (Donegal)', zip: '528137' },
	{ city: 'Beltichburne (Louth)', zip: '839024' },
	{ city: 'Beltra (Mayo)', zip: '799036' },
	{ city: 'Beltra (Sligo)', zip: '514008' },
	{ city: 'Belturbet (Cavan)', zip: '103922' },
	{ city: 'Belvelly (Cork)', zip: '450516' },
	{ city: 'Belvidere (Cork)', zip: '101957' },
	{ city: 'Belvidere (Westmeath)', zip: '536498' },
	{ city: 'Belview (Galway)', zip: '642009' },
	{ city: 'Belview (Kildare)', zip: '694599' },
	{ city: 'Belview (Meath)', zip: '127583' },
	{ city: 'Belville (Kilkenny)', zip: '943065' },
	{ city: 'Belville (Sligo)', zip: '291459' },
	{ city: 'Belville (Westmeath)', zip: '954048' },
	{ city: 'Belvoir (Clare)', zip: '481025' },
	{ city: 'Belvoir Demesne (Clare)', zip: '876955' },
	{ city: 'Ben (Westmeath)', zip: '487587' },
	{ city: 'Benagh (Louth)', zip: '869794' },
	{ city: 'Benalbit And Derryroe (Westmeath)', zip: '264026' },
	{ city: 'Benamore (Tipperary)', zip: '630097' },
	{ city: 'Ben Beg (Galway)', zip: '646188' },
	{ city: 'Bendinstown (Carlow)', zip: '905630' },
	{ city: 'Benduff (Cork)', zip: '886990' },
	{ city: 'Beneden (Clare)', zip: '726078' },
	{ city: 'Benedin (Tipperary)', zip: '577254' },
	{ city: 'Benfield (Offaly)', zip: '307208' },
	{ city: 'Bengeery (Mayo)', zip: '582414' },
	{ city: 'Bengour East (Cork)', zip: '769208' },
	{ city: 'Bengour West (Cork)', zip: '685838' },
	{ city: 'Benisonlodge (Westmeath)', zip: '376118' },
	{ city: 'Benjerstown (Meath)', zip: '126797' },
	{ city: 'Benmore (Kerry)', zip: '563393' },
	{ city: 'Benmore (Roscommon)', zip: '790950' },
	{ city: 'Ben More (Galway)', zip: '111592' },
	{ city: 'Bennekerry (Carlow)', zip: '375868' },
	{ city: 'Bennetsbridge (Kildare)', zip: '220630' },
	{ city: 'Bennetstown (Meath)', zip: '709751' },
	{ city: 'Bennettsbridge (Kilkenny)', zip: '128123' },
	{ city: 'Bennettsknock (Wexford)', zip: '281778' },
	{ city: 'Bennettsmeadow (Kilkenny)', zip: '381265' },
	{ city: 'Bennettstown (Wexford)', zip: '962045' },
	{ city: 'Bent Island (Donegal)', zip: '226519' },
	{ city: 'Benvoy (Waterford)', zip: '530242' },
	{ city: 'Benwilt (Cavan)', zip: '812111' },
	{ city: 'Berkeley (Wexford)', zip: '914246' },
	{ city: 'Bernagh (Wicklow)', zip: '209200' },
	{ city: 'Berneens (Clare)', zip: '619902' },
	{ city: 'Bernyhill (Cavan)', zip: '569540' },
	{ city: 'Berrillstown (Meath)', zip: '243323' },
	{ city: 'Berrings (Cork)', zip: '300111' },
	{ city: 'Berrymount (Cavan)', zip: '622595' },
	{ city: 'Bert Demesne (Kildare)', zip: '697776' },
	{ city: 'Beshellstown (Meath)', zip: '763860' },
	{ city: 'Bessborough (Tipperary)', zip: '561815' },
	{ city: 'Bessbrook (Cavan)', zip: '898209' },
	{ city: 'Bessmount (Wexford)', zip: '340212' },
	{ city: 'Bessville (Westmeath)', zip: '133733' },
	{ city: 'Bestfield (Carlow)', zip: '695817' },
	{ city: 'Betaghstown (Kildare)', zip: '986953' },
	{ city: 'Betaghstown (Louth)', zip: '115613' },
	{ city: 'Betaghstown (Meath)', zip: '949214' },
	{ city: 'Betal (Roscommon)', zip: '981398' },
	{ city: 'Bethlehem (Westmeath)', zip: '304150' },
	{ city: 'Bettyspark (Galway)', zip: '897060' },
	{ city: 'Bettystown (Meath)', zip: '158785' },
	{ city: 'Bettyville (Cork)', zip: '808013' },
	{ city: 'Bettyville (Dublin)', zip: '719635' },
	{ city: 'Bewley (Waterford)', zip: '267978' },
	{ city: 'Bey Beg (Meath)', zip: '445726' },
	{ city: 'Bey More (Meath)', zip: '230354' },
	{ city: 'Biddyford (Limerick)', zip: '989126' },
	{ city: 'Bigbog (Kildare)', zip: '985975' },
	{ city: 'Bigbog (Kilkenny)', zip: '652451' },
	{ city: 'Bigbog (Laois)', zip: '548295' },
	{ city: 'Bigfurze (Westmeath)', zip: '395928' },
	{ city: 'Biggera Beg (Galway)', zip: '569870' },
	{ city: 'Biggera More (Galway)', zip: '120508' },
	{ city: 'Bigisland (Galway)', zip: '370925' },
	{ city: 'Bigisland (Meath)', zip: '653893' },
	{ city: 'Big Island (Galway)', zip: '490818' },
	{ city: 'Big Island (Wexford)', zip: '876841' },
	{ city: 'Big Isle (Donegal)', zip: '914278' },
	{ city: 'Bigmarsh (Cork)', zip: '432927' },
	{ city: 'Bigmeadow (Kilkenny)', zip: '278857' },
	{ city: 'Bigpark (Donegal)', zip: '314074' },
	{ city: 'Bigpark (Tipperary)', zip: '186382' },
	{ city: 'Bigsland (Louth)', zip: '360515' },
	{ city: 'Bigstown (Meath)', zip: '918151' },
	{ city: 'Bigwood (Offaly)', zip: '571652' },
	{ city: 'Bigwood (Westmeath)', zip: '890983' },
	{ city: 'Bigwood (Wexford)', zip: '909165' },
	{ city: 'Bilberry (Cork)', zip: '865402' },
	{ city: 'Bilberry Island (Galway)', zip: '408021' },
	{ city: 'Bilboa (Carlow)', zip: '843866' },
	{ city: 'Bilboa (Limerick)', zip: '383840' },
	{ city: 'Billa (Sligo)', zip: '979563' },
	{ city: 'Billary (Donegal)', zip: '612224' },
	{ city: 'Billary (Monaghan)', zip: '226101' },
	{ city: 'Billeady (Monaghan)', zip: '996590' },
	{ city: 'Billeragh (Cork)', zip: '461245' },
	{ city: 'Billeragh (Kerry)', zip: '496716' },
	{ city: 'Billeragh East (Cork)', zip: '475562' },
	{ city: 'Billeragh West (Cork)', zip: '154292' },
	{ city: 'Billis (Cavan)', zip: '960791' },
	{ city: 'Billis (Monaghan)', zip: '596419' },
	{ city: 'Billises (Monaghan)', zip: '203902' },
	{ city: 'Billistown (Westmeath)', zip: '439184' },
	{ city: 'Billoos (Mayo)', zip: '872514' },
	{ city: 'Billymore (Galway)', zip: '842059' },
	{ city: 'Billywood (Meath)', zip: '132523' },
	{ city: 'Bin (Donegal)', zip: '111187' },
	{ city: 'Binbane (Cavan)', zip: '607731' },
	{ city: 'Binbawn (Laois)', zip: '369118' },
	{ city: 'Bindoo (Cavan)', zip: '681687' },
	{ city: 'Bindoo (Donegal)', zip: '639932' },
	{ city: 'Bing (Wexford)', zip: '332366' },
	{ city: 'Binganagh (Sligo)', zip: '635449' },
	{ city: 'Bingarra (Galway)', zip: '256199' },
	{ city: 'Binghamstown (Mayo)', zip: '557378' },
	{ city: 'Bingorms (Donegal)', zip: '664045' },
	{ city: 'Binkeeragh (Cavan)', zip: '251765' },
	{ city: 'Binmore (Donegal)', zip: '966673' },
	{ city: 'Binmore (Monaghan)', zip: '157906' },
	{ city: 'Binmuck (Roscommon)', zip: '185861' },
	{ city: 'Binn (Galway)', zip: '250029' },
	{ city: 'Binnion (Donegal)', zip: '136099' },
	{ city: 'Binroe (Donegal)', zip: '251475' },
	{ city: 'Binvoran (Clare)', zip: '852328' },
	{ city: 'Birbeg Island (Galway)', zip: '927047' },
	{ city: 'Birchfield (Kilkenny)', zip: '212756' },
	{ city: 'Birchfield (Mayo)', zip: '434189' },
	{ city: 'Birchgrove (Tipperary)', zip: '250240' },
	{ city: 'Birchhill (Donegal)', zip: '524177' },
	{ city: 'Birchhill (Tipperary)', zip: '997750' },
	{ city: 'Birchpark (Clare)', zip: '281963' },
	{ city: 'Birchwood (Kilkenny)', zip: '150340' },
	{ city: 'Birchwood (Laois)', zip: '607263' },
	{ city: 'Birchwood (Wicklow)', zip: '791374' },
	{ city: 'Bircog (Donegal)', zip: '812599' },
	{ city: 'Birdhill (Meath)', zip: '915530' },
	{ city: 'Birdhill (Tipperary)', zip: '546211' },
	{ city: 'Birdstown (Donegal)', zip: '818538' },
	{ city: 'Birdstown (Wexford)', zip: '594740' },
	{ city: 'Birdstown Demesne (Donegal)', zip: '700379' },
	{ city: 'Birmingham Demesne (Galway)', zip: '482668' },
	{ city: 'Birmore Island (Galway)', zip: '846855' },
	{ city: 'Birmore Rock (Galway)', zip: '950005' },
	{ city: 'Birr (Offaly)', zip: '616308' },
	{ city: 'Birra (Donegal)', zip: '428242' },
	{ city: 'Birragh (Cavan)', zip: '812291' },
	{ city: 'Birrinagh (Longford)', zip: '584913' },
	{ city: 'Bishopland (Dublin)', zip: '209030' },
	{ city: 'Bishopland (Wexford)', zip: '865474' },
	{ city: 'Bishopscourt Lower (Kildare)', zip: '893163' },
	{ city: 'Bishopscourt North (Kerry)', zip: '630117' },
	{ city: 'Bishopscourt South (Kerry)', zip: '554317' },
	{ city: 'Bishopscourt Upper (Kildare)', zip: '728903' },
	{ city: "Bishop's Demesne (Kilkenny)", zip: '923390' },
	{ city: 'Bishopsfield (Limerick)', zip: '570291' },
	{ city: 'Bishopsfurze (Kilkenny)', zip: '247521' },
	{ city: 'Bishopshall (Kilkenny)', zip: '485228' },
	{ city: 'Bishopshill Commons (Kildare)', zip: '116477' },
	{ city: "Bishop's-Island (Cork)", zip: '946189' },
	{ city: 'Bishops Islands (Galway)', zip: '128440' },
	{ city: 'Bishopsknock (Kilkenny)', zip: '557414' },
	{ city: 'Bishopsland (Kildare)', zip: '724211' },
	{ city: 'Bishopsland (Kilkenny)', zip: '588890' },
	{ city: 'Bishopsland (Wexford)', zip: '356577' },
	{ city: 'Bishopslane (Kildare)', zip: '544401' },
	{ city: 'Bishopslough East (Kilkenny)', zip: '459373' },
	{ city: 'Bishopslough Newtown (Kilkenny)', zip: '926681' },
	{ city: 'Bishopslough South (Kilkenny)', zip: '639704' },
	{ city: 'Bishopslough West (Kilkenny)', zip: '570067' },
	{ city: 'Bishopsmeadows (Kilkenny)', zip: '941702' },
	{ city: 'Bishopsmountain (Kilkenny)', zip: '852274' },
	{ city: 'Bishopsquarter (Clare)', zip: '774599' },
	{ city: 'Bishopstown (Waterford)', zip: '842456' },
	{ city: 'Bishopswood (Dublin)', zip: '711110' },
	{ city: 'Bishopswood (Offaly)', zip: '373644' },
	{ city: 'Bishopswood (Tipperary)', zip: '718072' },
	{ city: 'Blabreenagh (Donegal)', zip: '830126' },
	{ city: 'Black (Waterford)', zip: '255199' },
	{ city: 'Blackabbey (Limerick)', zip: '992969' },
	{ city: 'Blackacre (Galway)', zip: '790871' },
	{ city: 'Blackbog (Kilkenny)', zip: '320775' },
	{ city: 'Blackbog (Waterford)', zip: '225245' },
	{ city: 'Blackbottom (Kilkenny)', zip: '763342' },
	{ city: 'Blackbull (Offaly)', zip: '463483' },
	{ city: 'Blackcastle (Kildare)', zip: '213654' },
	{ city: 'Blackcastle (Meath)', zip: '215442' },
	{ city: 'Blackcastle (Tipperary)', zip: '684836' },
	{ city: 'Blackcastle Demesne (Meath)', zip: '182233' },
	{ city: 'Blackchurch (Kildare)', zip: '945659' },
	{ city: 'Blackcommon (Tipperary)', zip: '617454' },
	{ city: 'Blackcut (Meath)', zip: '637463' },
	{ city: 'Blackditch (Kildare)', zip: '307576' },
	{ city: 'Blackditch (Meath)', zip: '339191' },
	{ city: 'Blackditch (Wicklow)', zip: '986834' },
	{ city: 'Blackditches Lower (Wicklow)', zip: '580827' },
	{ city: 'Blackditches Upper (Wicklow)', zip: '174379' },
	{ city: 'Blackdown (Kildare)', zip: '748840' },
	{ city: 'Blackfallow (Roscommon)', zip: '161637' },
	{ city: 'Blackford (Kildare)', zip: '719730' },
	{ city: 'Blackford (Laois)', zip: '822153' },
	{ city: 'Blackfort (Tipperary)', zip: '306681' },
	{ city: 'Blackfriary (Meath)', zip: '826084' },
	{ city: 'Blackgarden (Galway)', zip: '908329' },
	{ city: 'Blackgardens (Leitrim)', zip: '529758' },
	{ city: 'Blackhall (Dublin)', zip: '545950' },
	{ city: 'Blackhall (Kildare)', zip: '215816' },
	{ city: 'Blackhall (Louth)', zip: '607456' },
	{ city: 'Blackhall (Wexford)', zip: '478010' },
	{ city: 'Blackhall Big (Meath)', zip: '631731' },
	{ city: 'Blackhall Little (Meath)', zip: '631894' },
	{ city: 'Blackhill (Carlow)', zip: '189938' },
	{ city: 'Blackhill (Kildare)', zip: '651365' },
	{ city: 'Blackhill (Wicklow)', zip: '920579' },
	{ city: 'Blackhills (Laois)', zip: '634852' },
	{ city: 'Blackhills Lower (Cavan)', zip: '935853' },
	{ city: 'Blackhills Upper (Cavan)', zip: '959797' },
	{ city: 'Blackhorse (Wexford)', zip: '351601' },
	{ city: 'Blackhorsefield (Cork)', zip: '942491' },
	{ city: 'Black Island (Monaghan)', zip: '974567' },
	{ city: 'Blackknock (Waterford)', zip: '496040' },
	{ city: 'Blackland (Donegal)', zip: '122532' },
	{ city: 'Blackland (Dublin)', zip: '541402' },
	{ city: 'Blacklion (Cavan)', zip: '170985' },
	{ city: 'Blackmiles (Westmeath)', zip: '781647' },
	{ city: 'Blackmillershill (Kildare)', zip: '836610' },
	{ city: 'Blackmoor (Wexford)', zip: '572561' },
	{ city: 'Blackmoor (Wicklow)', zip: '181129' },
	{ city: 'Blackmountain (Leitrim)', zip: '238678' },
	{ city: 'Blackories (Westmeath)', zip: '472625' },
	{ city: 'Blackparks (Kerry)', zip: '457886' },
	{ city: 'Blackparks (Kildare)', zip: '822376' },
	{ city: 'Blackpatch (Mayo)', zip: '158010' },
	{ city: 'Blackpits (Wicklow)', zip: '572640' },
	{ city: 'Blackpool (Cork)', zip: '460920' },
	{ city: 'Blackrath (Kildare)', zip: '667111' },
	{ city: 'Blackrath And Athgarvan (Kildare)', zip: '378521' },
	{ city: 'Blackraw (Monaghan)', zip: '701554' },
	{ city: 'Blackrepentance (Donegal)', zip: '305229' },
	{ city: 'Blackrock (Donegal)', zip: '739030' },
	{ city: 'Blackrock (Dublin)', zip: '222367' },
	{ city: 'Blackrock (Galway)', zip: '941782' },
	{ city: 'Blackrock (Leitrim)', zip: '802626' },
	{ city: 'Blackrock (Louth)', zip: '601914' },
	{ city: 'Blackrock (Wicklow)', zip: '267317' },
	{ city: 'Black Rock (Mayo)', zip: '976606' },
	{ city: 'Black Rocks (Kerry)', zip: '977546' },
	{ city: 'Blacks Glen (Donegal)', zip: '539364' },
	{ city: 'Blackshade (Meath)', zip: '378962' },
	{ city: 'Blacksod (Mayo)', zip: '161132' },
	{ city: 'Blackstaff (Kilkenny)', zip: '922202' },
	{ city: 'Blackstairs (Tipperary)', zip: '673453' },
	{ city: 'Blackstairs Commons (Wexford)', zip: '306801' },
	{ city: 'Blackstep (Cavan)', zip: '382819' },
	{ city: 'Blackstick (Louth)', zip: '793587' },
	{ city: 'Blacksticks (Galway)', zip: '386471' },
	{ city: 'Blackstone (Wexford)', zip: '421786' },
	{ city: 'Blackstoops (Wexford)', zip: '317187' },
	{ city: 'Blackthorn (Dublin)', zip: '387921' },
	{ city: 'Blacktrench (Kildare)', zip: '164411' },
	{ city: 'Blackwater (Clare)', zip: '291982' },
	{ city: 'Blackwater (Meath)', zip: '642606' },
	{ city: 'Blackwater (Wexford)', zip: '647288' },
	{ city: 'Blackwater Bridge (Kerry)', zip: '451154' },
	{ city: 'Blackwell (Kilkenny)', zip: '821206' },
	{ city: 'Blackwood (Kildare)', zip: '992167' },
	{ city: 'Blackwood (Kilkenny)', zip: '427982' },
	{ city: 'Blackwood (Offaly)', zip: '722417' },
	{ city: 'Blainroe Lower (Wicklow)', zip: '723233' },
	{ city: 'Blainroe Upper (Wicklow)', zip: '189027' },
	{ city: 'Blairstown (Donegal)', zip: '159208' },
	{ city: 'Blakefield (Tipperary)', zip: '636054' },
	{ city: 'Blakesmountain (Clare)', zip: '578892' },
	{ city: 'Blakestown (Dublin)', zip: '574523' },
	{ city: 'Blakestown (Kildare)', zip: '429052' },
	{ city: 'Blakestown (Louth)', zip: '969580' },
	{ city: 'Blakestown Lower (Wicklow)', zip: '557924' },
	{ city: 'Blakestown Upper (Wicklow)', zip: '496266' },
	{ city: 'Blanchardstown (Dublin)', zip: '863116' },
	{ city: 'Blanchfieldsbog (Kilkenny)', zip: '815146' },
	{ city: 'Blanchfieldsland (Kilkenny)', zip: '358997' },
	{ city: 'Blanchville Demesne (Kilkenny)', zip: '428673' },
	{ city: 'Blanchvilleskill (Kilkenny)', zip: '613641' },
	{ city: 'Blanchvillespark (Kilkenny)', zip: '710095' },
	{ city: 'Blanchvillestown (Kilkenny)', zip: '101048' },
	{ city: 'Blane (Wicklow)', zip: '983665' },
	{ city: 'Blanket Nook (Donegal)', zip: '304130' },
	{ city: 'Blarney (Cork)', zip: '968367' },
	{ city: 'Blastknock (Wexford)', zip: '876521' },
	{ city: 'Bleach (Kildare)', zip: '632207' },
	{ city: 'Bleach (Waterford)', zip: '171858' },
	{ city: 'Bleachgreen (Sligo)', zip: '665147' },
	{ city: 'Bleach Green (Kilkenny)', zip: '544706' },
	{ city: 'Bleachlands (Wexford)', zip: '897687' },
	{ city: 'Bleachlawn (Westmeath)', zip: '645060' },
	{ city: 'Bleachyard (Mayo)', zip: '311693' },
	{ city: 'Blean (Clare)', zip: '269366' },
	{ city: 'Blean (Galway)', zip: '163961' },
	{ city: 'Blean (Tipperary)', zip: '110003' },
	{ city: 'Bleanahouree (Waterford)', zip: '590407' },
	{ city: 'Bleanavoher (Longford)', zip: '866035' },
	{ city: 'Bleanbeg (Tipperary)', zip: '313776' },
	{ city: 'Bleancup (Cavan)', zip: '680434' },
	{ city: 'Bleanmore (Clare)', zip: '869640' },
	{ city: 'Bleannagloos (Galway)', zip: '818178' },
	{ city: 'Bleanphuttoge (Westmeath)', zip: '511900' },
	{ city: 'Bleantasour (Waterford)', zip: '444914' },
	{ city: 'Bleantasourmountain (Waterford)', zip: '403946' },
	{ city: 'Bleenaleen Lower (Tipperary)', zip: '344669' },
	{ city: 'Bleenaleen Upper (Tipperary)', zip: '566531' },
	{ city: 'Blennerville (Kerry)', zip: '103503' },
	{ city: 'Blessington (Kilkenny)', zip: '210673' },
	{ city: 'Blessington (Wicklow)', zip: '228476' },
	{ city: 'Blessington Demesne (Wicklow)', zip: '238611' },
	{ city: 'Blessingtown (Mayo)', zip: '512774' },
	{ city: 'Blindennis (Carlow)', zip: '951909' },
	{ city: 'Blindwell (Galway)', zip: '723830' },
	{ city: 'Blindwood (Wicklow)', zip: '713535' },
	{ city: 'Blittoge (Monaghan)', zip: '287404' },
	{ city: 'Bloomfield (Mayo)', zip: '650541' },
	{ city: 'Bloomfield (Roscommon)', zip: '738800' },
	{ city: 'Bloomfield (Wexford)', zip: '581323' },
	{ city: 'Bloomhill (Wexford)', zip: '779654' },
	{ city: 'Bloomsberry (Meath)', zip: '243021' },
	{ city: 'Blossomfort (Cork)', zip: '239898' },
	{ city: 'Blossomgrove (Cork)', zip: '374912' },
	{ city: 'Blossomhill (Kilkenny)', zip: '699884' },
	{ city: 'Blossomhill (Limerick)', zip: '566677' },
	{ city: 'Blue Ball (Offaly)', zip: '527274' },
	{ city: 'Bluebell (Dublin)', zip: '194464' },
	{ city: 'Bluebell (Kildare)', zip: '740482' },
	{ city: 'Blueford (Cork)', zip: '917338' },
	{ city: 'Bluepool (Cork)', zip: '812131' },
	{ city: 'Bluid East (Cork)', zip: '329739' },
	{ city: 'Bluid West (Cork)', zip: '425366' },
	{ city: 'Blundelstown (Dublin)', zip: '955490' },
	{ city: 'Blundelstown (Meath)', zip: '660937' },
	{ city: 'Blunsheens (Wexford)', zip: '618455' },
	{ city: 'Blyry Lower (Westmeath)', zip: '597293' },
	{ city: 'Blyry Upper (Westmeath)', zip: '774865' },
	{ city: 'Boadaun (Galway)', zip: '814033' },
	{ city: 'Boagh (Cavan)', zip: '500108' },
	{ city: 'Boardee (Cork)', zip: '145748' },
	{ city: 'Boardsland (Westmeath)', zip: '201352' },
	{ city: 'Boardstown (Westmeath)', zip: '332604' },
	{ city: 'Boarheeny (Limerick)', zip: '206807' },
	{ city: 'Boarmanshill (Limerick)', zip: '123353' },
	{ city: 'Boarmona (Wexford)', zip: '848304' },
	{ city: 'Bobsgrove (Cavan)', zip: '755320' },
	{ city: 'Bobsville (Meath)', zip: '659138' },
	{ city: 'Bocade Glebe (Cavan)', zip: '548512' },
	{ city: 'Bocarnagh (Cork)', zip: '238027' },
	{ city: 'Bockagh (Laois)', zip: '373750' },
	{ city: 'Bockagh (Roscommon)', zip: '481239' },
	{ city: 'Bocks Lower (Monaghan)', zip: '306901' },
	{ city: 'Bocks Middle (Monaghan)', zip: '183190' },
	{ city: 'Bocks Upper (Monaghan)', zip: '229280' },
	{ city: 'Bocullin (Mayo)', zip: '429285' },
	{ city: 'Bodal (Kilkenny)', zip: '891095' },
	{ city: 'Bodalmore (Kilkenny)', zip: '616364' },
	{ city: 'Bodeen (Meath)', zip: '211378' },
	{ city: 'Bodenstown (Kildare)', zip: '671460' },
	{ city: 'Boderan (Wexford)', zip: '246081' },
	{ city: 'Bodingtown (Meath)', zip: '909549' },
	{ city: 'Bodorragha (Roscommon)', zip: '509490' },
	{ city: 'Bodyke (Clare)', zip: '451906' },
	{ city: 'Boeeshil (Donegal)', zip: '240984' },
	{ city: 'Boeeshil (Leitrim)', zip: '289110' },
	{ city: 'Bofara (Mayo)', zip: '578137' },
	{ city: 'Bofealan (Cavan)', zip: '222619' },
	{ city: 'Bofeenaun (Mayo)', zip: '825447' },
	{ city: 'Bofickil (Cork)', zip: '109784' },
	{ city: 'Bog (Waterford)', zip: '522005' },
	{ city: 'Bogagh (Donegal)', zip: '655865' },
	{ city: 'Bogagh Glebe (Donegal)', zip: '372517' },
	{ city: 'Bog And Warren (Wexford)', zip: '529078' },
	{ city: 'Bogare (Kerry)', zip: '543716' },
	{ city: 'Bogay (Donegal)', zip: '982576' },
	{ city: 'Bogay Glebe (Donegal)', zip: '557457' },
	{ city: 'Bog Commons (Kilkenny)', zip: '474697' },
	{ city: 'Bogderries (Offaly)', zip: '537734' },
	{ city: 'Bog East (Wexford)', zip: '483963' },
	{ city: 'Bogesky (Cavan)', zip: '668050' },
	{ city: 'Boggagh (Waterford)', zip: '362336' },
	{ city: 'Boggagh (Westmeath)', zip: '134081' },
	{ city: 'Boggaghbaun (Waterford)', zip: '397231' },
	{ city: 'Boggaghduff (Waterford)', zip: '292539' },
	{ city: 'Boggagh Eighter (Westmeath)', zip: '767247' },
	{ city: 'Boggan (Carlow)', zip: '848561' },
	{ city: 'Boggan (Kilkenny)', zip: '971499' },
	{ city: 'Boggan (Meath)', zip: '707421' },
	{ city: 'Bogganfin (Roscommon)', zip: '775845' },
	{ city: 'Bogganfin (Westmeath)', zip: '165186' },
	{ city: 'Bogganstown (Meath)', zip: '965649' },
	{ city: 'Bogganstown Lower (Wexford)', zip: '564024' },
	{ city: 'Bogganstown Upper (Wexford)', zip: '379999' },
	{ city: 'Boggaun (Galway)', zip: '711424' },
	{ city: 'Boggaun (Leitrim)', zip: '302973' },
	{ city: 'Boggaun (Tipperary)', zip: '544917' },
	{ city: 'Boggaunreagh (Offaly)', zip: '413943' },
	{ city: 'Boggauns (Galway)', zip: '535169' },
	{ city: 'Boggra (Cork)', zip: '619801' },
	{ city: 'Boggy (Mayo)', zip: '177255' },
	{ city: 'Boggyheary (Dublin)', zip: '267338' },
	{ city: 'Boghadoon (Mayo)', zip: '963408' },
	{ city: 'Boghall (Kildare)', zip: '182520' },
	{ city: 'Boghil (Clare)', zip: '836904' },
	{ city: 'Boghlone (Laois)', zip: '269660' },
	{ city: 'Boghouse (Carlow)', zip: '413940' },
	{ city: 'Boghtaduff (Roscommon)', zip: '737712' },
	{ city: 'Bogland (Wicklow)', zip: '679105' },
	{ city: 'Bogpark (Galway)', zip: '864161' },
	{ city: 'Bogside (Donegal)', zip: '991825' },
	{ city: 'Bogtown (Louth)', zip: '567399' },
	{ city: 'Bogtown (Offaly)', zip: '553600' },
	{ city: 'Bog West (Wexford)', zip: '771019' },
	{ city: 'Bogwood (Roscommon)', zip: '415439' },
	{ city: 'Bohaboy (Galway)', zip: '178404' },
	{ city: 'Bohacogram (Kerry)', zip: '437120' },
	{ city: 'Bohacullia (Kerry)', zip: '468847' },
	{ city: 'Bohadoonmountain (Waterford)', zip: '597230' },
	{ city: 'Bohadoon North (Waterford)', zip: '969363' },
	{ city: 'Bohadoon South (Waterford)', zip: '878339' },
	{ city: 'Bohagh (Roscommon)', zip: '958418' },
	{ city: 'Bohalas (Roscommon)', zip: '801682' },
	{ city: 'Bohammer (Dublin)', zip: '242791' },
	{ city: 'Bohamore (Mayo)', zip: '227095' },
	{ city: 'Bohanboy (Donegal)', zip: '811406' },
	{ city: 'Bohard (Limerick)', zip: '360084' },
	{ city: 'Boharnamoe (Louth)', zip: '168534' },
	{ city: 'Bohateh North (Clare)', zip: '829261' },
	{ city: 'Bohateh South (Clare)', zip: '751297' },
	{ city: 'Bohaun (Galway)', zip: '187050' },
	{ city: 'Bohaun (Mayo)', zip: '359579' },
	{ city: 'Bohaun North (Mayo)', zip: '710957' },
	{ city: 'Bohaun South (Mayo)', zip: '496887' },
	{ city: 'Boheeshal (Galway)', zip: '650996' },
	{ city: 'Boheeshil (Kerry)', zip: '353483' },
	{ city: 'Boheh (Mayo)', zip: '941666' },
	{ city: 'Bohehs (Mayo)', zip: '719588' },
	{ city: 'Boheolan (Donegal)', zip: '835329' },
	{ city: 'Boher (Cork)', zip: '150175' },
	{ city: 'Boher (Limerick)', zip: '925751' },
	{ city: 'Boher (Tipperary)', zip: '938144' },
	{ city: 'Boher (Wexford)', zip: '626068' },
	{ city: 'Boheradurrow (Offaly)', zip: '267592' },
	{ city: 'Boheragaddy (Kilkenny)', zip: '704775' },
	{ city: 'Boheraphuca (Offaly)', zip: '573113' },
	{ city: 'Boherard (Cork)', zip: '554055' },
	{ city: 'Boherard (Laois)', zip: '609334' },
	{ city: 'Boherard (Meath)', zip: '860104' },
	{ city: 'Boherard (Waterford)', zip: '285018' },
	{ city: 'Boheraroan (Clare)', zip: '287389' },
	{ city: 'Boherascrub East (Cork)', zip: '911905' },
	{ city: 'Boherascrub West (Cork)', zip: '117149' },
	{ city: 'Boherash (Cork)', zip: '619392' },
	{ city: 'Boheravendrum (Tipperary)', zip: '949235' },
	{ city: 'Boherawarraga (Kilkenny)', zip: '188338' },
	{ city: 'Boherawillin (Waterford)', zip: '907521' },
	{ city: 'Boherbannagh (Galway)', zip: '774352' },
	{ city: 'Boherbaun Lower (Kildare)', zip: '180480' },
	{ city: 'Boherbaun Upper (Kildare)', zip: '325820' },
	{ city: 'Boherboy (Clare)', zip: '483723' },
	{ city: 'Boherboy (Cork)', zip: '129058' },
	{ city: 'Boherboy (Dublin)', zip: '953019' },
	{ city: 'Boherboy (Kerry)', zip: '846362' },
	{ city: 'Boherboy (Limerick)', zip: '338560' },
	{ city: 'Boherboy (Offaly)', zip: '298087' },
	{ city: 'Boherboy (Tipperary)', zip: '526558' },
	{ city: 'Boherboy (Waterford)', zip: '644580' },
	{ city: 'Boherboy (Wicklow)', zip: '887857' },
	{ city: 'Boherboyrea (Waterford)', zip: '999581' },
	{ city: 'Boherbrack (Kerry)', zip: '718991' },
	{ city: 'Boherbraddagh (Limerick)', zip: '401334' },
	{ city: 'Boherbullog (Clare)', zip: '958939' },
	{ city: 'Bohercarron (Limerick)', zip: '737870' },
	{ city: 'Boherclogh (Tipperary)', zip: '402010' },
	{ city: 'Bohercreen (Wexford)', zip: '734146' },
	{ city: 'Bohercrow (Tipperary)', zip: '247602' },
	{ city: 'Bohercuill (Galway)', zip: '618603' },
	{ city: 'Boherdeel (Offaly)', zip: '687762' },
	{ city: 'Boherderroge (Cork)', zip: '315559' },
	{ city: 'Boherdotia (Limerick)', zip: '547100' },
	{ city: 'Boherduff (Carlow)', zip: '598735' },
	{ city: 'Boherduff (Galway)', zip: '604673' },
	{ city: 'Boherduff (Limerick)', zip: '392703' },
	{ city: 'Boherduff (Mayo)', zip: '410771' },
	{ city: 'Boherduff (Tipperary)', zip: '296639' },
	{ city: 'Bohereen (Limerick)', zip: '277429' },
	{ city: 'Bohereenkyle (Limerick)', zip: '403963' },
	{ city: 'Bohereens (Kerry)', zip: '447864' },
	{ city: 'Bohergar (Limerick)', zip: '573483' },
	{ city: 'Bohergarve (Roscommon)', zip: '219880' },
	{ city: 'Bohergoy Lower (Kildare)', zip: '700089' },
	{ city: 'Bohergoy Upper (Kildare)', zip: '446247' },
	{ city: 'Boherhallagh (Mayo)', zip: '483351' },
	{ city: 'Boherhole (Kildare)', zip: '384470' },
	{ city: 'Boherkill (Kildare)', zip: '693111' },
	{ city: 'Boherkyle (Kilkenny)', zip: '897222' },
	{ city: 'Boherlahan (Tipperary)', zip: '556305' },
	{ city: 'Boherlea (Meath)', zip: '666295' },
	{ city: 'Boherleigh (Tipperary)', zip: '365336' },
	{ city: 'Boherload (Limerick)', zip: '598721' },
	{ city: 'Boherlody (Tipperary)', zip: '264965' },
	{ city: 'Bohermeen (Meath)', zip: '578797' },
	{ city: 'Bohermore (Carlow)', zip: '820294' },
	{ city: 'Bohermore (Kilkenny)', zip: '521389' },
	{ city: 'Bohermore (Longford)', zip: '144542' },
	{ city: 'Bohernabredagh (Cork)', zip: '373197' },
	{ city: 'Bohernabreena (Dublin)', zip: '172386' },
	{ city: 'Bohernacross (Longford)', zip: '866577' },
	{ city: 'Bohernaghty (Laois)', zip: '282509' },
	{ city: 'Bohernagore (Limerick)', zip: '669854' },
	{ city: 'Bohernagore East (Tipperary)', zip: '197276' },
	{ city: 'Bohernagore West (Tipperary)', zip: '601383' },
	{ city: 'Bohernagraga (Limerick)', zip: '624194' },
	{ city: 'Bohernagrisna (Offaly)', zip: '215733' },
	{ city: 'Bohernameeltoge (Longford)', zip: '609652' },
	{ city: 'Bohernamona (Tipperary)', zip: '194530' },
	{ city: 'Bohernarnane (Tipperary)', zip: '503927' },
	{ city: 'Bohernarude (Tipperary)', zip: '714379' },
	{ city: 'Bohernasear (Laois)', zip: '718659' },
	{ city: 'Bohernastrekaun (Kilkenny)', zip: '983127' },
	{ city: 'Bohernoe (Cork)', zip: '973647' },
	{ city: 'Boherphilip (Kildare)', zip: '400560' },
	{ city: 'Boherquill (Westmeath)', zip: '384885' },
	{ city: 'Boherroe (Kerry)', zip: '425030' },
	{ city: 'Boherroe (Limerick)', zip: '294280' },
	{ city: 'Boherroe (Roscommon)', zip: '777585' },
	{ city: 'Boherstooka (Wexford)', zip: '688242' },
	{ city: 'Boherygeela (Limerick)', zip: '297297' },
	{ city: 'Bohilla (Kilkenny)', zip: '710863' },
	{ city: 'Bohillane (Cork)', zip: '496905' },
	{ city: 'Bohirril (Donegal)', zip: '323542' },
	{ city: 'Bohirril Park (Donegal)', zip: '971761' },
	{ city: 'Bohoge (Mayo)', zip: '282029' },
	{ city: 'Bohogerawer (Mayo)', zip: '385305' },
	{ city: 'Bohola (Mayo)', zip: '616979' },
	{ city: 'Bohona (Cork)', zip: '142060' },
	{ city: 'Bohonagh (Cork)', zip: '111643' },
	{ city: 'Bohoona East (Galway)', zip: '425350' },
	{ city: 'Bohoona West (Galway)', zip: '275681' },
	{ city: 'Bohora (Cavan)', zip: '713337' },
	{ city: 'Bohullion Lower (Donegal)', zip: '814746' },
	{ city: 'Bohullion Upper (Donegal)', zip: '789921' },
	{ city: 'Bohyodaun (Clare)', zip: '489530' },
	{ city: 'Boihy (Leitrim)', zip: '437861' },
	{ city: 'Boira North (Wexford)', zip: '858570' },
	{ city: 'Boira South (Wexford)', zip: '844460' },
	{ city: 'Bo Island (Donegal)', zip: '384300' },
	{ city: 'Bolabaun (Wexford)', zip: '592209' },
	{ city: 'Bola Beg (Wexford)', zip: '220990' },
	{ city: 'Bolaboy Beg (Wexford)', zip: '273248' },
	{ city: 'Bolaboy More (Wexford)', zip: '152060' },
	{ city: 'Bolabradda (Wexford)', zip: '138188' },
	{ city: 'Bolacaheer (Wexford)', zip: '343219' },
	{ city: 'Bolacreen (Wexford)', zip: '501466' },
	{ city: 'Boladurragh (Wexford)', zip: '682564' },
	{ city: 'Bolag (Galway)', zip: '144683' },
	{ city: 'Bolagh Lower (Wicklow)', zip: '662848' },
	{ city: 'Bolagh Upper (Wicklow)', zip: '145830' },
	{ city: 'Bolakeale (Tipperary)', zip: '499131' },
	{ city: 'Bola More (Wexford)', zip: '930328' },
	{ city: 'Bolandstown (Westmeath)', zip: '687895' },
	{ city: 'Bolane (Limerick)', zip: '290074' },
	{ city: 'Bolany (Wexford)', zip: '383074' },
	{ city: 'Bolarry (Roscommon)', zip: '247867' },
	{ city: 'Bolart North (Offaly)', zip: '357151' },
	{ city: 'Bolart South (Offaly)', zip: '748725' },
	{ city: 'Boleagh (Cork)', zip: '765265' },
	{ city: 'Boleany (Wexford)', zip: '729498' },
	{ city: 'Boley (Cavan)', zip: '597013' },
	{ city: 'Boley (Galway)', zip: '769578' },
	{ city: 'Boley (Laois)', zip: '510781' },
	{ city: 'Boley (Wexford)', zip: '605282' },
	{ city: 'Boley (Wicklow)', zip: '307655' },
	{ city: 'Boleyard (Mayo)', zip: '233340' },
	{ city: 'Boleybaun (Leitrim)', zip: '754332' },
	{ city: 'Boleybaun (Wexford)', zip: '695454' },
	{ city: 'Boleybawn (Laois)', zip: '694031' },
	{ city: 'Boleybawn (Wicklow)', zip: '662460' },
	{ city: 'Boleybeg (Galway)', zip: '332808' },
	{ city: 'Boleybeg (Kildare)', zip: '677747' },
	{ city: 'Boleybeg (Laois)', zip: '603756' },
	{ city: 'Boleybeg (Mayo)', zip: '835320' },
	{ city: 'Boleybeg East (Galway)', zip: '457092' },
	{ city: 'Boleybeg West (Galway)', zip: '736730' },
	{ city: 'Boleyboy (Leitrim)', zip: '701520' },
	{ city: 'Boleyboy (Mayo)', zip: '480163' },
	{ city: 'Boleybrack (Leitrim)', zip: '626486' },
	{ city: 'Boleybrian (Mayo)', zip: '655147' },
	{ city: 'Boleycarrigeen (Wicklow)', zip: '415225' },
	{ city: 'Boleycurheen (Galway)', zip: '222805' },
	{ city: 'Boleydorragha (Galway)', zip: '712129' },
	{ city: 'Boleyduff (Roscommon)', zip: '898556' },
	{ city: 'Boleyglass (Mayo)', zip: '779218' },
	{ city: 'Boley Great (Kildare)', zip: '894250' },
	{ city: 'Boleylaan (Galway)', zip: '850056' },
	{ city: 'Boley Little (Kildare)', zip: '424879' },
	{ city: 'Boley Lower (Laois)', zip: '637640' },
	{ city: 'Boley Lower (Wexford)', zip: '292307' },
	{ city: 'Boleylug (Wicklow)', zip: '389050' },
	{ city: 'Boleymaguire (Leitrim)', zip: '537712' },
	{ city: 'Boleymeelagh (Mayo)', zip: '966091' },
	{ city: 'Boleymore (Galway)', zip: '409899' },
	{ city: 'Boleymount (Sligo)', zip: '815798' },
	{ city: 'Boleynagoagh North (Clare)', zip: '908058' },
	{ city: 'Boleynagoagh South (Clare)', zip: '220887' },
	{ city: 'Boleynaminna (Galway)', zip: '169981' },
	{ city: 'Boleynanollag (Galway)', zip: '654687' },
	{ city: 'Boleynanoultagh (Cork)', zip: '647248' },
	{ city: 'Boleynasruhaun (Galway)', zip: '104211' },
	{ city: 'Boleynass Lower (Wicklow)', zip: '981888' },
	{ city: 'Boleynass Upper (Wicklow)', zip: '343610' },
	{ city: 'Boleyneendorrish (Galway)', zip: '860633' },
	{ city: 'Boleyphaudeen (Galway)', zip: '382703' },
	{ city: 'Boleyroe (Galway)', zip: '520847' },
	{ city: 'Boleysillagh (Roscommon)', zip: '573776' },
	{ city: 'Boleythomas (Galway)', zip: '147877' },
	{ city: 'Boley Upper (Laois)', zip: '836286' },
	{ city: 'Boley Upper (Wexford)', zip: '118861' },
	{ city: 'Boleyvaunaun (Galway)', zip: '543182' },
	{ city: 'Boleyvogue (Wexford)', zip: '212273' },
	{ city: 'Bolganard (Leitrim)', zip: '887627' },
	{ city: 'Bolgerstown (Wexford)', zip: '543060' },
	{ city: 'Bolies (Louth)', zip: '731193' },
	{ city: 'Bolinahaney (Wexford)', zip: '325171' },
	{ city: 'Bolinarra (Westmeath)', zip: '666112' },
	{ city: 'Bolinaspick (Wexford)', zip: '932045' },
	{ city: 'Bolingbrook (Tipperary)', zip: '378189' },
	{ city: 'Bolinglanna (Mayo)', zip: '614232' },
	{ city: 'Bolinready (Wexford)', zip: '350122' },
	{ city: 'Bolinree (Mayo)', zip: '636011' },
	{ city: 'Bolinree (Roscommon)', zip: '176481' },
	{ city: 'Bolinrush (Wexford)', zip: '130739' },
	{ city: 'Bolintlea (Tipperary)', zip: '897523' },
	{ city: 'Bolisheen (Galway)', zip: '824608' },
	{ city: 'Boliska Eighter (Galway)', zip: '515571' },
	{ city: 'Boliska Oughter (Galway)', zip: '357268' },
	{ city: 'Bollarney Murragh (Wicklow)', zip: '622468' },
	{ city: 'Bollarney North (Wicklow)', zip: '990868' },
	{ city: 'Bollarney South (Wicklow)', zip: '104727' },
	{ city: 'Bolnagree (Laois)', zip: '817985' },
	{ city: 'Bolooghra (Clare)', zip: '560564' },
	{ city: 'Boloona (Clare)', zip: '276227' },
	{ city: 'Bolton (Kildare)', zip: '173919' },
	{ city: 'Bolton (Kilkenny)', zip: '689368' },
	{ city: 'Boltown (Meath)', zip: '490176' },
	{ city: 'Bolus (Kerry)', zip: '138397' },
	{ city: 'Bolyconor (Westmeath)', zip: '688263' },
	{ city: 'Bomahas (Leitrim)', zip: '233919' },
	{ city: 'Bomany (Donegal)', zip: '243524' },
	{ city: 'Bonabrocka (Wicklow)', zip: '512407' },
	{ city: 'Bonaghmore (Kildare)', zip: '168025' },
	{ city: 'Bonagooga (Tipperary)', zip: '519068' },
	{ city: 'Bonagortbaun (Tipperary)', zip: '360220' },
	{ city: 'Bonagrew (Wicklow)', zip: '421615' },
	{ city: 'Bonagrew Little (Wicklow)', zip: '148254' },
	{ city: 'Bonarea (Tipperary)', zip: '460371' },
	{ city: 'Bonatouk (Waterford)', zip: '395605' },
	{ city: 'Boneill (Leitrim)', zip: '508678' },
	{ city: 'Bonestown (Meath)', zip: '399549' },
	{ city: 'Bonfield (Meath)', zip: '741409' },
	{ city: 'Bonnetsrath (Kilkenny)', zip: '631993' },
	{ city: 'Bonnetstown (Kilkenny)', zip: '442605' },
	{ city: 'Bonnyglen (Donegal)', zip: '744678' },
	{ city: 'Boocaun (Galway)', zip: '121267' },
	{ city: 'Booey (Galway)', zip: '891991' },
	{ city: 'Booeybeg (Galway)', zip: '217323' },
	{ city: 'Bookalagh (Galway)', zip: '599165' },
	{ city: 'Bookaun (Sligo)', zip: '464081' },
	{ city: 'Bookeen (Galway)', zip: '278804' },
	{ city: 'Bookeen North (Galway)', zip: '960403' },
	{ city: 'Bookeen South (Galway)', zip: '424386' },
	{ city: 'Boola (Cork)', zip: '164203' },
	{ city: 'Boola (Kerry)', zip: '832270' },
	{ city: 'Boola (Limerick)', zip: '108243' },
	{ city: 'Boola (Tipperary)', zip: '175676' },
	{ city: 'Boola (Waterford)', zip: '479762' },
	{ city: 'Boolabane (Tipperary)', zip: '125770' },
	{ city: 'Boolabaun (Tipperary)', zip: '407124' },
	{ city: 'Boolabaun (Wexford)', zip: '720824' },
	{ city: 'Boolabeg (Waterford)', zip: '797553' },
	{ city: 'Boolabeha (Tipperary)', zip: '349720' },
	{ city: 'Boolabrien Lower (Waterford)', zip: '441379' },
	{ city: 'Boolabrien Upper (Waterford)', zip: '571748' },
	{ city: 'Boolabwee (Cork)', zip: '674826' },
	{ city: 'Boolacloghagh (Waterford)', zip: '220716' },
	{ city: 'Boolacullane (Kerry)', zip: '402535' },
	{ city: 'Booladurragha (Cork)', zip: '198167' },
	{ city: 'Booladurragha North (Cork)', zip: '258655' },
	{ city: 'Booladurragha South (Cork)', zip: '594714' },
	{ city: 'Boolagare (Galway)', zip: '609085' },
	{ city: 'Boolagelagh (Tipperary)', zip: '125060' },
	{ city: 'Boolagh (Tipperary)', zip: '179378' },
	{ city: 'Boolaglass (Limerick)', zip: '980121' },
	{ city: 'Boolaglass (Tipperary)', zip: '933298' },
	{ city: 'Boolahallagh (Tipperary)', zip: '868002' },
	{ city: 'Boolakeel (Kerry)', zip: '478256' },
	{ city: 'Boolakeel (Offaly)', zip: '351377' },
	{ city: 'Boolakelly (Cork)', zip: '302966' },
	{ city: 'Boolakennedy (Tipperary)', zip: '646164' },
	{ city: 'Boolakiley (Waterford)', zip: '618935' },
	{ city: 'Boolanacausk (Clare)', zip: '726498' },
	{ city: 'Boolananave (Kerry)', zip: '241725' },
	{ city: 'Boolanlisheen (Limerick)', zip: '794032' },
	{ city: 'Boolanunane (Tipperary)', zip: '665005' },
	{ city: 'Boolard (Cork)', zip: '350317' },
	{ city: 'Boolard (Galway)', zip: '981567' },
	{ city: 'Boolareagh (Tipperary)', zip: '714710' },
	{ city: 'Boolaree (Tipperary)', zip: '276604' },
	{ city: 'Boolaroe (Tipperary)', zip: '723067' },
	{ city: 'Boolasallagh (Kerry)', zip: '230372' },
	{ city: 'Boolatin (Tipperary)', zip: '261572' },
	{ city: 'Boolattin (Waterford)', zip: '963559' },
	{ city: 'Boolavaun (Clare)', zip: '352502' },
	{ city: 'Boolavonteen (Waterford)', zip: '626611' },
	{ city: 'Boolavoord (Limerick)', zip: '804752' },
	{ city: 'Booldurragh (Carlow)', zip: '229791' },
	{ city: 'Booleen (Tipperary)', zip: '869398' },
	{ city: 'Booleenshare (Kerry)', zip: '184235' },
	{ city: 'Booley (Wexford)', zip: '787770' },
	{ city: 'Booleycreen (Wexford)', zip: '680218' },
	{ city: 'Boolies (Meath)', zip: '784423' },
	{ city: 'Boolies Great (Meath)', zip: '934370' },
	{ city: 'Boolies Little (Meath)', zip: '147479' },
	{ city: 'Boolinarig Big (Offaly)', zip: '158040' },
	{ city: 'Boolinarig Little (Offaly)', zip: '920781' },
	{ city: 'Boolinarig School Land (Offaly)', zip: '364268' },
	{ city: 'Boolinrudda (Clare)', zip: '334309' },
	{ city: 'Boolnadrum (Wexford)', zip: '890369' },
	{ city: 'Boolteenagh (Cork)', zip: '250357' },
	{ city: 'Boolteens East (Kerry)', zip: '505447' },
	{ city: 'Boolteens West (Kerry)', zip: '272524' },
	{ city: 'Boolteeny (Tipperary)', zip: '662660' },
	{ city: 'Booltiagh (Clare)', zip: '862311' },
	{ city: 'Booltiaghadine (Clare)', zip: '760815' },
	{ city: 'Booltydoolan (Clare)', zip: '364748' },
	{ city: 'Booly (Kilkenny)', zip: '322268' },
	{ city: 'Boolybane (Cork)', zip: '275298' },
	{ city: 'Boolybeg (Cork)', zip: '334551' },
	{ city: 'Boolybrien (Clare)', zip: '609976' },
	{ city: 'Boolyduff (Clare)', zip: '503122' },
	{ city: 'Boolyglass (Kilkenny)', zip: '143489' },
	{ city: 'Boolykeagh (Meath)', zip: '862080' },
	{ city: 'Boolymore (Cork)', zip: '761895' },
	{ city: 'Boolynagleragh (Clare)', zip: '991767' },
	{ city: 'Boolynaknockaun (Clare)', zip: '323297' },
	{ city: 'Boolynamiscaun (Clare)', zip: '434978' },
	{ city: 'Boolynamweel (Clare)', zip: '495331' },
	{ city: 'Boolynavoughran (Wexford)', zip: '596912' },
	{ city: 'Boolyneaska (Clare)', zip: '245320' },
	{ city: 'Boolypatrick (Cork)', zip: '721622' },
	{ city: 'Boolyrathornan (Carlow)', zip: '392805' },
	{ city: 'Boolyshea (Kilkenny)', zip: '386721' },
	{ city: 'Boolyvannanan (Carlow)', zip: '252588' },
	{ city: 'Booragh (Donegal)', zip: '399605' },
	{ city: 'Booterstown (Dublin)', zip: '958743' },
	{ city: 'Bootstown (Kilkenny)', zip: '604607' },
	{ city: 'Boraghy (Monaghan)', zip: '280602' },
	{ city: 'Boraheen (Meath)', zip: '999474' },
	{ city: 'Boranaraltry (Dublin)', zip: '245131' },
	{ city: 'Borderreen (Offaly)', zip: '264875' },
	{ city: 'Bordowin (Laois)', zip: '544390' },
	{ city: 'Bordwell Big (Laois)', zip: '400479' },
	{ city: 'Bordwell Little (Laois)', zip: '602121' },
	{ city: 'Boreen (Tipperary)', zip: '256484' },
	{ city: 'Borehovel (Wexford)', zip: '625894' },
	{ city: 'Borheen (Waterford)', zip: '359451' },
	{ city: 'Borheenduff (Tipperary)', zip: '356870' },
	{ city: 'Borim (Cavan)', zip: '329940' },
	{ city: 'Borkill Beg (Wicklow)', zip: '419488' },
	{ city: 'Borkill More (Wicklow)', zip: '882894' },
	{ city: 'Borleagh (Wexford)', zip: '347523' },
	{ city: 'Borleagh Demesne (Wexford)', zip: '266299' },
	{ city: 'Bornacourtia (Wexford)', zip: '763493' },
	{ city: 'Borough (Carlow)', zip: '497171' },
	{ city: 'Borough (Kildare)', zip: '146135' },
	{ city: 'Borraghaun (Laois)', zip: '910799' },
	{ city: 'Borranstown (Dublin)', zip: '819671' },
	{ city: 'Borris (Carlow)', zip: '804916' },
	{ city: 'Borris (Tipperary)', zip: '288978' },
	{ city: 'Borris (Wexford)', zip: '242752' },
	{ city: 'Borrisbeg (Kilkenny)', zip: '790509' },
	{ city: 'Borrisbeg (Tipperary)', zip: '567141' },
	{ city: 'Borris Big (Kilkenny)', zip: '446362' },
	{ city: 'Borris Great (Laois)', zip: '493709' },
	{ city: 'Borris In Ossory (Laois)', zip: '205174' },
	{ city: 'Borrisland North (Tipperary)', zip: '623135' },
	{ city: 'Borrisland South (Tipperary)', zip: '782030' },
	{ city: 'Borris Little (Kilkenny)', zip: '471082' },
	{ city: 'Borris Little (Laois)', zip: '653302' },
	{ city: 'Borrismore (Kilkenny)', zip: '324515' },
	{ city: 'Borrisnafarney (Tipperary)', zip: '420030' },
	{ city: 'Borrisnoe (Tipperary)', zip: '814901' },
	{ city: 'Borrisokane (Tipperary)', zip: '385318' },
	{ city: 'Borrisoleigh (Tipperary)', zip: '804077' },
	{ city: 'Borrmount (Wexford)', zip: '175094' },
	{ city: 'Boscabell (Tipperary)', zip: '959703' },
	{ city: 'Boskill (Limerick)', zip: '578544' },
	{ city: 'Bosnetstown (Limerick)', zip: '329602' },
	{ city: 'Boston (Kildare)', zip: '126559' },
	{ city: 'Boston (Laois)', zip: '753432' },
	{ city: 'Boston (Tipperary)', zip: '952223' },
	{ city: 'Bostoncommon (Kildare)', zip: '944228' },
	{ city: 'Bothaul (Mayo)', zip: '631855' },
	{ city: 'Botinny (Mayo)', zip: '940729' },
	{ city: 'Bottom (Galway)', zip: '829184' },
	{ city: 'Bottomstown (Limerick)', zip: '187795' },
	{ city: 'Bottomy (Westmeath)', zip: '866341' },
	{ city: 'Bough (Carlow)', zip: '931381' },
	{ city: 'Bough (Monaghan)', zip: '640586' },
	{ city: 'Boughil (Galway)', zip: '888057' },
	{ city: 'Boughilbo (Limerick)', zip: '187458' },
	{ city: 'Boughill (Monaghan)', zip: '853221' },
	{ city: 'Boughkeel (Monaghan)', zip: '879898' },
	{ city: 'Boulabally (Limerick)', zip: '702203' },
	{ city: 'Bouladuff (Tipperary)', zip: '844141' },
	{ city: 'Boulaling (Cork)', zip: '250320' },
	{ city: 'Boulanimrish (Kerry)', zip: '403017' },
	{ city: 'Bouleevin (Clare)', zip: '867104' },
	{ city: 'Boulerdah (Kerry)', zip: '791565' },
	{ city: 'Boulteen (Cork)', zip: '249177' },
	{ city: 'Boultry (Offaly)', zip: '393569' },
	{ city: 'Boultypatrick (Donegal)', zip: '214752' },
	{ city: 'Bouluskeagh (Galway)', zip: '951962' },
	{ city: 'Boulysallagh (Cork)', zip: '990895' },
	{ city: 'Boveen (Offaly)', zip: '278846' },
	{ city: 'Bovinion (Galway)', zip: '728683' },
	{ city: 'Bovroughaun (Galway)', zip: '558567' },
	{ city: 'Bowelk (Monaghan)', zip: '337418' },
	{ city: 'Bowersacre (Kilkenny)', zip: '473504' },
	{ city: 'Bowhill (Dublin)', zip: '949931' },
	{ city: 'Bowling Green (Tipperary)', zip: '731762' },
	{ city: 'Bowling Green (Wexford)', zip: '616191' },
	{ city: 'Boyagh (Donegal)', zip: '488499' },
	{ city: 'Boyanagh (Roscommon)', zip: '268765' },
	{ city: 'Boyanagh (Westmeath)', zip: '244037' },
	{ city: 'Boyanaghcalry (Westmeath)', zip: '637659' },
	{ city: 'Boyannagh (Leitrim)', zip: '829836' },
	{ city: 'Boycestown (Cork)', zip: '632971' },
	{ city: 'Boycetown (Kildare)', zip: '338920' },
	{ city: 'Boycetown (Louth)', zip: '256189' },
	{ city: 'Boycetown (Meath)', zip: '132662' },
	{ city: 'Boyerstown (Meath)', zip: '897741' },
	{ city: 'Boyher (Monaghan)', zip: '749683' },
	{ city: 'Boyhill (Galway)', zip: '331078' },
	{ city: 'Boyhollagh (Mayo)', zip: '717272' },
	{ city: 'Boyle (Laois)', zip: '613882' },
	{ city: 'Boyle (Roscommon)', zip: '905655' },
	{ city: "Boyle's Island (Donegal)", zip: '374454' },
	{ city: 'Boynagh (Meath)', zip: '747829' },
	{ city: 'Boynaghbought (Meath)', zip: '673806' },
	{ city: 'Boynehill (Meath)', zip: '137838' },
	{ city: 'Boyogonnell (Mayo)', zip: '957364' },
	{ city: 'Boyoughter (Donegal)', zip: '127841' },
	{ city: 'Boyounagh (Galway)', zip: '961202' },
	{ city: 'Boyounagh Beg (Galway)', zip: '927187' },
	{ city: 'Boyounagh More (Galway)', zip: '735582' },
	{ city: 'Boystown (Wicklow)', zip: '284763' },
	{ city: 'Boytonrath (Tipperary)', zip: '740686' },
	{ city: 'Braade (Donegal)', zip: '341702' },
	{ city: 'Braade Lower (Donegal)', zip: '527303' },
	{ city: 'Braade Upper (Donegal)', zip: '564209' },
	{ city: 'Brabstown (Kilkenny)', zip: '659523' },
	{ city: 'Braccas (Laois)', zip: '485610' },
	{ city: 'Bracetown (Meath)', zip: '970737' },
	{ city: 'Brackagh (Kildare)', zip: '187017' },
	{ city: 'Brackagh (Monaghan)', zip: '466511' },
	{ city: 'Brackagh (Offaly)', zip: '382732' },
	{ city: 'Brackagh (Westmeath)', zip: '870995' },
	{ city: 'Brackagh Castle (Westmeath)', zip: '722942' },
	{ city: 'Brackaharagh (Kerry)', zip: '426821' },
	{ city: 'Brackanrainey (Meath)', zip: '397914' },
	{ city: 'Brackary Beg (Leitrim)', zip: '386647' },
	{ city: 'Brackary More (Leitrim)', zip: '868787' },
	{ city: 'Brackbaun (Limerick)', zip: '420775' },
	{ city: 'Brackcloon (Cork)', zip: '247734' },
	{ city: 'Brackcloonagh (Sligo)', zip: '923204' },
	{ city: 'Brackenstown (Dublin)', zip: '729625' },
	{ city: 'Brackernagh (Galway)', zip: '777362' },
	{ city: 'Brackernagh (Wexford)', zip: '585770' },
	{ city: 'Brackery (Galway)', zip: '333303' },
	{ city: 'Brackery North (Galway)', zip: '613022' },
	{ city: 'Brackery South (Galway)', zip: '253959' },
	{ city: 'Brackhill (Kerry)', zip: '549169' },
	{ city: 'Brackin (Kilkenny)', zip: '689461' },
	{ city: 'Bracklagh (Cavan)', zip: '930613' },
	{ city: 'Bracklagh (Galway)', zip: '366058' },
	{ city: 'Bracklagh (Mayo)', zip: '323554' },
	{ city: 'Bracklaghboy (Mayo)', zip: '312658' },
	{ city: 'Bracklagh Grange (Galway)', zip: '608753' },
	{ city: 'Brackley (Cavan)', zip: '806128' },
	{ city: 'Bracklin (Cavan)', zip: '470139' },
	{ city: 'Bracklin (Roscommon)', zip: '489981' },
	{ city: 'Bracklin (Westmeath)', zip: '823158' },
	{ city: 'Bracklin Big (Offaly)', zip: '569124' },
	{ city: 'Bracklin Little (Offaly)', zip: '768896' },
	{ city: 'Bracklon (Longford)', zip: '763333' },
	{ city: 'Bracklone (Laois)', zip: '990822' },
	{ city: 'Brackloney (Cavan)', zip: '961779' },
	{ city: 'Brackloon (Galway)', zip: '456804' },
	{ city: 'Brackloon (Kerry)', zip: '343124' },
	{ city: 'Brackloon (Limerick)', zip: '723102' },
	{ city: 'Brackloon (Mayo)', zip: '305413' },
	{ city: 'Brackloon (Roscommon)', zip: '508304' },
	{ city: 'Brackloonagh (Mayo)', zip: '445924' },
	{ city: 'Brackloonagh North (Mayo)', zip: '326055' },
	{ city: 'Brackloonagh South (Mayo)', zip: '219389' },
	{ city: 'Brackloonbeg (Galway)', zip: '252134' },
	{ city: 'Brackloon East (Mayo)', zip: '540519' },
	{ city: 'Brackloon North (Mayo)', zip: '364525' },
	{ city: 'Brackloon South (Mayo)', zip: '463170' },
	{ city: 'Brackloon West (Mayo)', zip: '499747' },
	{ city: 'Brackly (Monaghan)', zip: '828435' },
	{ city: 'Bracklyn (Westmeath)', zip: '878493' },
	{ city: 'Bracknagh (Offaly)', zip: '745273' },
	{ city: 'Bracknahevla (Westmeath)', zip: '496559' },
	{ city: 'Brackney (Kildare)', zip: '566419' },
	{ city: 'Brackvoan (Limerick)', zip: '469092' },
	{ city: 'Brackwanshagh (Mayo)', zip: '980031' },
	{ city: 'Bracky (Donegal)', zip: '564722' },
	{ city: 'Brackyle (Limerick)', zip: '136618' },
	{ city: 'Braddocks (Monaghan)', zip: '471551' },
	{ city: 'Brade (Cork)', zip: '600890' },
	{ city: 'Bradystown (Meath)', zip: '212274' },
	{ city: 'Braehead (Donegal)', zip: '960974' },
	{ city: 'Braestown (Wexford)', zip: '602081' },
	{ city: 'Bragan (Monaghan)', zip: '198154' },
	{ city: 'Braganstown (Louth)', zip: '479263' },
	{ city: 'Braghan (Louth)', zip: '752296' },
	{ city: 'Brahalish (Cork)', zip: '776992' },
	{ city: 'Brallistown (Kildare)', zip: '191071' },
	{ city: 'Brallistown Commons (Kildare)', zip: '783908' },
	{ city: 'Brallistown Little (Kildare)', zip: '666133' },
	{ city: 'Bramblestown (Kilkenny)', zip: '333939' },
	{ city: 'Branchfield (Sligo)', zip: '341165' },
	{ city: 'Brandane (Wexford)', zip: '927604' },
	{ city: 'Brandon (Kerry)', zip: '337510' },
	{ city: 'Brandondale (Kilkenny)', zip: '343588' },
	{ city: 'Brandonhill (Kilkenny)', zip: '483836' },
	{ city: 'Brandonwell (Kerry)', zip: '514675' },
	{ city: 'Brandra (Laois)', zip: '275002' },
	{ city: 'Brandrum (Monaghan)', zip: '909956' },
	{ city: 'Branganstown (Kildare)', zip: '763009' },
	{ city: 'Branganstown (Meath)', zip: '785139' },
	{ city: 'Brankill (Cavan)', zip: '489991' },
	{ city: 'Brannanstown (Meath)', zip: '453124' },
	{ city: 'Brannock Island (Galway)', zip: '117944' },
	{ city: 'Brannock Island East (Galway)', zip: '228339' },
	{ city: 'Brannock Island Middle (Galway)', zip: '315811' },
	{ city: 'Brannock Island South (Galway)', zip: '451512' },
	{ city: 'Brannockstown (Kildare)', zip: '899251' },
	{ city: 'Brannockstown (Meath)', zip: '677810' },
	{ city: 'Branra (Leitrim)', zip: '419904' },
	{ city: 'Branraduff (Mayo)', zip: '218744' },
	{ city: 'Branstown (Meath)', zip: '897811' },
	{ city: 'Braudphark (Leitrim)', zip: '912352' },
	{ city: 'Braumaddra (Kerry)', zip: '157706' },
	{ city: 'Bray (Kerry)', zip: '841340' },
	{ city: 'Bray (Wicklow)', zip: '865824' },
	{ city: 'Bray Commons (Wicklow)', zip: '864101' },
	{ city: 'Bray Lower (Kildare)', zip: '373026' },
	{ city: 'Braysland (Meath)', zip: '187203' },
	{ city: 'Braystown (Meath)', zip: '181831' },
	{ city: 'Bray Upper (Kildare)', zip: '562541' },
	{ city: 'Brazil (Dublin)', zip: '301915' },
	{ city: 'Bready (Donegal)', zip: '961702' },
	{ city: 'Breaffy North (Clare)', zip: '794030' },
	{ city: 'Breaffy South (Clare)', zip: '245616' },
	{ city: 'Breaghmore (Offaly)', zip: '124775' },
	{ city: 'Breaghna (Cork)', zip: '794003' },
	{ city: 'Breaghva (Clare)', zip: '786924' },
	{ city: 'Breaghva East (Clare)', zip: '234296' },
	{ city: 'Breaghva West (Clare)', zip: '238724' },
	{ city: 'Breaghwy (Mayo)', zip: '133629' },
	{ city: 'Breaghwy (Sligo)', zip: '187054' },
	{ city: 'Breaghwyanteean (Mayo)', zip: '577193' },
	{ city: 'Breaghwyanurlaur (Mayo)', zip: '339613' },
	{ city: 'Breaghy (Donegal)', zip: '666302' },
	{ city: 'Breaghy (Longford)', zip: '283446' },
	{ city: 'Breagura (Wicklow)', zip: '991300' },
	{ city: 'Breahig (Kerry)', zip: '761372' },
	{ city: 'Breanabeg (Roscommon)', zip: '550989' },
	{ city: 'Breanamore (Roscommon)', zip: '912289' },
	{ city: 'Breandrim (Galway)', zip: '938109' },
	{ city: 'Breandrum (Cavan)', zip: '665125' },
	{ city: 'Breandrum (Leitrim)', zip: '512999' },
	{ city: 'Breandrum (Mayo)', zip: '760040' },
	{ city: 'Breandrum (Roscommon)', zip: '683307' },
	{ city: 'Breanlee (Kerry)', zip: '829512' },
	{ city: 'Breanletter (Roscommon)', zip: '881791' },
	{ city: 'Breanloughaun (Galway)', zip: '773852' },
	{ city: 'Breanra (Galway)', zip: '533940' },
	{ city: 'Breanrisk (Longford)', zip: '541660' },
	{ city: 'Breanriskcullew (Longford)', zip: '341553' },
	{ city: 'Breanross (Leitrim)', zip: '100769' },
	{ city: 'Breanross North (Leitrim)', zip: '886484' },
	{ city: 'Breanross South (Leitrim)', zip: '603959' },
	{ city: 'Breansha (Tipperary)', zip: '117294' },
	{ city: 'Breansha Beg (Tipperary)', zip: '754986' },
	{ city: 'Breanshagh (Kerry)', zip: '752717' },
	{ city: 'Breansha More (Tipperary)', zip: '533223' },
	{ city: 'Breany (Longford)', zip: '945861' },
	{ city: 'Breastagh (Mayo)', zip: '397607' },
	{ city: 'Breckinish (Clare)', zip: '670358' },
	{ city: 'Bredagh (Galway)', zip: '527344' },
	{ city: 'Bredagh (Leitrim)', zip: '941378' },
	{ city: 'Bredagh (Offaly)', zip: '339442' },
	{ city: 'Bredagh (Roscommon)', zip: '885465' },
	{ city: 'Bredagh (Tipperary)', zip: '740234' },
	{ city: 'Bredagh (Westmeath)', zip: '634373' },
	{ city: 'Bredagh Glen (Donegal)', zip: '996521' },
	{ city: 'Bree (Donegal)', zip: '575011' },
	{ city: 'Bree (Monaghan)', zip: '427936' },
	{ city: 'Bree (Wexford)', zip: '550052' },
	{ city: 'Breeda (Cork)', zip: '687946' },
	{ city: 'Breen (Donegal)', zip: '203404' },
	{ city: 'Breenagh (Donegal)', zip: '704154' },
	{ city: 'Breenaun (Galway)', zip: '277266' },
	{ city: 'Breeny Beg (Cork)', zip: '755345' },
	{ city: 'Breeny More (Cork)', zip: '696956' },
	{ city: 'Breeoge (Sligo)', zip: '898202' },
	{ city: 'Breeole (Roscommon)', zip: '448151' },
	{ city: 'Breeole West (Roscommon)', zip: '702043' },
	{ city: 'Brees (Mayo)', zip: '919298' },
	{ city: 'Breesheen North (Limerick)', zip: '184819' },
	{ city: 'Breesheen South (Limerick)', zip: '190609' },
	{ city: 'Bregaun (Kilkenny)', zip: '234960' },
	{ city: 'Bregoge (Cork)', zip: '748351' },
	{ city: 'Bregorteen (Wexford)', zip: '651014' },
	{ city: 'Brehaun (Cork)', zip: '420018' },
	{ city: 'Brehoge (Offaly)', zip: '710117' },
	{ city: 'Bremore (Dublin)', zip: '781289' },
	{ city: 'Brenan (Waterford)', zip: '317674' },
	{ city: 'Brenanstown (Dublin)', zip: '651573' },
	{ city: 'Brenar (Kilkenny)', zip: '299268' },
	{ city: 'Brennanshill (Laois)', zip: '435367' },
	{ city: 'Brenormore (Tipperary)', zip: '114911' },
	{ city: 'Brenter (Donegal)', zip: '955144' },
	{ city: 'Breslanstown (Meath)', zip: '696204' },
	{ city: 'Brewel East (Kildare)', zip: '356713' },
	{ city: 'Brewel West (Kildare)', zip: '253499' },
	{ city: 'Brewershill (Wicklow)', zip: '564801' },
	{ city: 'Brewsterfield (Kerry)', zip: '487031' },
	{ city: 'Brianstown (Longford)', zip: '299634' },
	{ city: 'Briarhill (Louth)', zip: '234742' },
	{ city: 'Briarleas (Meath)', zip: '747696' },
	{ city: 'Brick (Tipperary)', zip: '853924' },
	{ city: 'Brickana (Kilkenny)', zip: '507436' },
	{ city: 'Brickanagh (Offaly)', zip: '736070' },
	{ city: 'Brickeen (Sligo)', zip: '403962' },
	{ city: 'Brickeen Island (Kerry)', zip: '989354' },
	{ city: 'Brickeens (Longford)', zip: '624956' },
	{ city: 'Brickeens (Mayo)', zip: '880464' },
	{ city: 'Brickendown (Tipperary)', zip: '515562' },
	{ city: 'Bricketstown (Wexford)', zip: '300401' },
	{ city: 'Brickfield (Limerick)', zip: '820636' },
	{ city: 'Brickhill East (Clare)', zip: '792486' },
	{ city: 'Brickhill West (Clare)', zip: '231622' },
	{ city: 'Bricklieve (Sligo)', zip: '157862' },
	{ city: 'Brickpark (Wexford)', zip: '830663' },
	{ city: 'Bridane Lower (Waterford)', zip: '185729' },
	{ city: 'Bridane Upper (Waterford)', zip: '984766' },
	{ city: 'Bridebridge (Cork)', zip: '354288' },
	{ city: 'Bridepark (Cork)', zip: '860987' },
	{ city: 'Bridestown (Cork)', zip: '892580' },
	{ city: 'Brideswell (Roscommon)', zip: '113711' },
	{ city: 'Brideswell (Wexford)', zip: '988681' },
	{ city: 'Brideswell Big (Wexford)', zip: '515580' },
	{ city: 'Brideswell Commons (Dublin)', zip: '977541' },
	{ city: 'Brideswell Little (Wexford)', zip: '438608' },
	{ city: 'Bridetree (Dublin)', zip: '918286' },
	{ city: 'Bridgecartron (Roscommon)', zip: '306762' },
	{ city: 'Bridge End (Donegal)', zip: '311352' },
	{ city: 'Bridgefield (Cork)', zip: '280004' },
	{ city: 'Bridgeland (Wicklow)', zip: '348670' },
	{ city: 'Bridgeland East (Cork)', zip: '729697' },
	{ city: 'Bridgeland West (Cork)', zip: '824681' },
	{ city: 'Bridgepark (Galway)', zip: '511061' },
	{ city: 'Bridgequarter (Waterford)', zip: '738715' },
	{ city: 'Bridgestown (Cork)', zip: '174218' },
	{ city: 'Bridgetown (Clare)', zip: '965672' },
	{ city: 'Bridgetown (Cork)', zip: '202486' },
	{ city: 'Bridgetown (Donegal)', zip: '793491' },
	{ city: 'Bridgetown (Waterford)', zip: '685198' },
	{ city: 'Bridgetown (Wexford)', zip: '495586' },
	{ city: 'Bridgetown Lower (Cork)', zip: '498629' },
	{ city: 'Bridgetown North (Wexford)', zip: '424121' },
	{ city: 'Bridgetown South (Wexford)', zip: '815751' },
	{ city: 'Bridgetown Upper (Cork)', zip: '901636' },
	{ city: 'Bridia (Kerry)', zip: '216242' },
	{ city: 'Briencan (Kildare)', zip: '177492' },
	{ city: 'Brierfield (Galway)', zip: '455419' },
	{ city: 'Brierfield (Roscommon)', zip: '197665' },
	{ city: 'Brierfield North (Galway)', zip: '885146' },
	{ city: 'Brierfield South (Galway)', zip: '504065' },
	{ city: 'Brierfort (Galway)', zip: '407682' },
	{ city: 'Brigown (Cork)', zip: '969163' },
	{ city: 'Brinlack (Donegal)', zip: '835758' },
	{ city: 'Brinny (Cork)', zip: '912877' },
	{ city: 'Briscarnagh (Monaghan)', zip: '801275' },
	{ city: 'Briscloonagh (Leitrim)', zip: '962061' },
	{ city: 'Briscula (Laois)', zip: '364362' },
	{ city: 'Brisha (Laois)', zip: '532899' },
	{ city: 'Briska (Mayo)', zip: '935701' },
	{ city: 'Briska Beg (Limerick)', zip: '449413' },
	{ city: 'Briskagh (Limerick)', zip: '734455' },
	{ city: 'Briskalagh (Kilkenny)', zip: '254393' },
	{ city: 'Briska Lower (Waterford)', zip: '301196' },
	{ city: 'Briska More (Limerick)', zip: '752035' },
	{ city: 'Briska Upper (Waterford)', zip: '535528' },
	{ city: 'Briskil (Longford)', zip: '914720' },
	{ city: 'Brisla East (Clare)', zip: '493071' },
	{ city: 'Brislagh (Roscommon)', zip: '723823' },
	{ city: 'Brisla West (Clare)', zip: '595348' },
	{ city: 'Britfieldstown (Cork)', zip: '688727' },
	{ city: 'Britonstown (Wicklow)', zip: '258690' },
	{ city: 'Brittas (Cork)', zip: '713097' },
	{ city: 'Brittas (Kilkenny)', zip: '119709' },
	{ city: 'Brittas (Laois)', zip: '154296' },
	{ city: 'Brittas (Limerick)', zip: '652647' },
	{ city: 'Brittas (Louth)', zip: '115493' },
	{ city: 'Brittas (Mayo)', zip: '103735' },
	{ city: 'Brittas (Meath)', zip: '395501' },
	{ city: 'Brittas (Tipperary)', zip: '308781' },
	{ city: 'Brittas (Westmeath)', zip: '268047' },
	{ city: 'Brittas (Wexford)', zip: '536416' },
	{ city: 'Brittas (Wicklow)', zip: '113443' },
	{ city: 'Brittas Big (Dublin)', zip: '967343' },
	{ city: 'Brittasdryland (Kilkenny)', zip: '653901' },
	{ city: 'Brittas Little (Dublin)', zip: '628441' },
	{ city: 'Brittas North (Cork)', zip: '909749' },
	{ city: 'Brittasroad (Tipperary)', zip: '657173' },
	{ city: 'Brittas South (Cork)', zip: '420912' },
	{ city: 'Brittstown (Meath)', zip: '792162' },
	{ city: 'Britway (Cork)', zip: '298985' },
	{ city: 'Broad (Meath)', zip: '690563' },
	{ city: 'Broadfield (Kildare)', zip: '184796' },
	{ city: 'Broadford (Clare)', zip: '310984' },
	{ city: 'Broadford (Kildare)', zip: '827899' },
	{ city: 'Broadford (Limerick)', zip: '380379' },
	{ city: 'Broadlands Of Knockafarson (Mayo)', zip: '749730' },
	{ city: 'Broadlea (Donegal)', zip: '581837' },
	{ city: 'Broadleas Commons (Kildare)', zip: '357079' },
	{ city: 'Broadlough (Louth)', zip: '223413' },
	{ city: 'Broadmeadow (Dublin)', zip: '966648' },
	{ city: 'Broadmore (Kilkenny)', zip: '122496' },
	{ city: 'Broadpath (Donegal)', zip: '482869' },
	{ city: 'Broadstown (Kildare)', zip: '322997' },
	{ city: 'Brocka (Laois)', zip: '689489' },
	{ city: 'Brockagh (Donegal)', zip: '776706' },
	{ city: 'Brockagh (Galway)', zip: '729624' },
	{ city: 'Brockagh (Kildare)', zip: '332421' },
	{ city: 'Brockagh (Laois)', zip: '205740' },
	{ city: 'Brockagh (Leitrim)', zip: '899586' },
	{ city: 'Brockagh (Mayo)', zip: '268798' },
	{ city: 'Brockagh (Sligo)', zip: '753427' },
	{ city: 'Brockagh (Tipperary)', zip: '108550' },
	{ city: 'Brockagh (Westmeath)', zip: '426137' },
	{ city: 'Brockagh (Wicklow)', zip: '871659' },
	{ city: 'Brockaghbeg (Laois)', zip: '385623' },
	{ city: 'Brockagh Lower (Leitrim)', zip: '269128' },
	{ city: 'Brockagh Upper (Leitrim)', zip: '627306' },
	{ city: 'Brockernagh (Offaly)', zip: '973514' },
	{ city: 'Brockey (Dublin)', zip: '958269' },
	{ city: 'Brocklagh (Longford)', zip: '251862' },
	{ city: 'Brockley Park (Laois)', zip: '349759' },
	{ city: 'Brockly (Cavan)', zip: '873466' },
	{ city: 'Brockna (Wicklow)', zip: '541372' },
	{ city: 'Brockra (Laois)', zip: '230598' },
	{ city: 'Brockry (Laois)', zip: '552314' },
	{ city: 'Brocorrow (Wexford)', zip: '134872' },
	{ city: 'Brodeen (Tipperary)', zip: '189599' },
	{ city: 'Brodullagh North (Mayo)', zip: '121874' },
	{ city: 'Brodullagh South (Mayo)', zip: '796053' },
	{ city: 'Broemountain (Waterford)', zip: '751687' },
	{ city: 'Broghan (Dublin)', zip: '615939' },
	{ city: 'Brogher (Roscommon)', zip: '255483' },
	{ city: 'Brogherla Big (Laois)', zip: '882341' },
	{ city: 'Brogherla Little (Laois)', zip: '981703' },
	{ city: 'Broghill North (Cork)', zip: '685831' },
	{ city: 'Broghill South (Cork)', zip: '754090' },
	{ city: 'Broguestown (Kildare)', zip: '761817' },
	{ city: 'Bromley (Wicklow)', zip: '316867' },
	{ city: 'Bromore East (Kerry)', zip: '847024' },
	{ city: 'Bromore West (Kerry)', zip: '657463' },
	{ city: 'Bronagh (Leitrim)', zip: '279744' },
	{ city: 'Brookfield (Donegal)', zip: '171902' },
	{ city: 'Brookfield (Offaly)', zip: '232547' },
	{ city: 'Brookfield (Tipperary)', zip: '987314' },
	{ city: 'Brookfield (Wexford)', zip: '883205' },
	{ city: 'Brookhill (Cork)', zip: '957294' },
	{ city: 'Brookhill (Kerry)', zip: '771131' },
	{ city: 'Brookhill (Mayo)', zip: '199094' },
	{ city: 'Brooklawn (Dublin)', zip: '141120' },
	{ city: 'Brookley (Tipperary)', zip: '202100' },
	{ city: 'Brooklodge (Cork)', zip: '893826' },
	{ city: 'Brooklodge (Waterford)', zip: '204396' },
	{ city: 'Brooklodge Demesne (Galway)', zip: '105962' },
	{ city: 'Brookpark (Cork)', zip: '149397' },
	{ city: 'Brookvale (Monaghan)', zip: '992702' },
	{ city: 'Brookville (Cork)', zip: '881878' },
	{ city: 'Broomfield (Dublin)', zip: '947088' },
	{ city: 'Broomfield (Meath)', zip: '639746' },
	{ city: 'Broomfield (Monaghan)', zip: '417174' },
	{ city: 'Broomfield (Wicklow)', zip: '690736' },
	{ city: 'Broomfield East (Cork)', zip: '605573' },
	{ city: 'Broomfields (Wicklow)', zip: '809149' },
	{ city: 'Broomfield West (Cork)', zip: '127410' },
	{ city: 'Broomhall (Wicklow)', zip: '395182' },
	{ city: 'Broomhill (Cork)', zip: '806840' },
	{ city: 'Broomhill (Tipperary)', zip: '771167' },
	{ city: 'Broomhill (Wexford)', zip: '261925' },
	{ city: 'Broomville (Carlow)', zip: '833624' },
	{ city: 'Brosna (Kerry)', zip: '135211' },
	{ city: 'Brosna (Offaly)', zip: '709869' },
	{ city: 'Brosna East (Kerry)', zip: '558856' },
	{ city: 'Brosna West (Kerry)', zip: '805904' },
	{ city: 'Brottonstown (Westmeath)', zip: '997146' },
	{ city: 'Brottonstown Little (Westmeath)', zip: '580107' },
	{ city: 'Brough (Cork)', zip: '973959' },
	{ city: 'Broughal (Offaly)', zip: '805669' },
	{ city: 'Broughane (Kerry)', zip: '525064' },
	{ city: 'Broughattin (Louth)', zip: '984846' },
	{ city: 'Broughderg (Cavan)', zip: '547459' },
	{ city: 'Brougher (Sligo)', zip: '803278' },
	{ city: 'Broughills Hill (Wicklow)', zip: '964051' },
	{ city: 'Broughillstown (Carlow)', zip: '352782' },
	{ city: 'Brownbog (Carlow)', zip: '207539' },
	{ city: 'Brownbog (Longford)', zip: '134767' },
	{ city: 'Brownbog (Tipperary)', zip: '152889' },
	{ city: 'Brownes Island (Galway)', zip: '732746' },
	{ city: 'Brownespark (Mayo)', zip: '425014' },
	{ city: 'Brownhall (Donegal)', zip: '450302' },
	{ city: 'Brownhall Demesne (Donegal)', zip: '310909' },
	{ city: 'Brownhall Demesne (Mayo)', zip: '180449' },
	{ city: 'Brownhills (Offaly)', zip: '725820' },
	{ city: 'Brownknowe (Donegal)', zip: '862617' },
	{ city: 'Brownmountain (Kilkenny)', zip: '999805' },
	{ city: 'Brownrath (Meath)', zip: '928344' },
	{ city: 'Brownsbarn (Dublin)', zip: '843283' },
	{ city: 'Brownsbarn (Kilkenny)', zip: '762922' },
	{ city: 'Brownscastle (Wexford)', zip: '391979' },
	{ city: 'Brownscross (Dublin)', zip: '246391' },
	{ city: 'Brownscurragh (Westmeath)', zip: '240995' },
	{ city: 'Brownsford (Kilkenny)', zip: '325140' },
	{ city: 'Brownsgrove (Galway)', zip: '502292' },
	{ city: 'Brownsisland (Mayo)', zip: '442916' },
	{ city: 'Brownsmills (Cork)', zip: '879634' },
	{ city: 'Brownstown (Cork)', zip: '349966' },
	{ city: 'Brownstown (Dublin)', zip: '183347' },
	{ city: 'Brownstown (Kildare)', zip: '604989' },
	{ city: 'Brownstown (Kilkenny)', zip: '287325' },
	{ city: 'Brownstown (Louth)', zip: '774945' },
	{ city: 'Brownstown (Mayo)', zip: '811410' },
	{ city: 'Brownstown (Meath)', zip: '113591' },
	{ city: 'Brownstown (Offaly)', zip: '605257' },
	{ city: 'Brownstown (Tipperary)', zip: '496382' },
	{ city: 'Brownstown (Waterford)', zip: '950595' },
	{ city: 'Brownstown (Westmeath)', zip: '259868' },
	{ city: 'Brownstown (Wexford)', zip: '305571' },
	{ city: 'Brownstown Great (Kildare)', zip: '339270' },
	{ city: 'Brownstown Little (Kildare)', zip: '959271' },
	{ city: 'Brownstown Lower (Kildare)', zip: '233575' },
	{ city: 'Brownstown Upper (Kildare)', zip: '915136' },
	{ city: 'Brownswood (Waterford)', zip: '580605' },
	{ city: 'Brownswood (Wexford)', zip: '490528' },
	{ city: 'Brownville (Galway)', zip: '141449' },
	{ city: 'Bruce (Wexford)', zip: '709817' },
	{ city: 'Bruckana (Kilkenny)', zip: '794289' },
	{ city: 'Brucken (Galway)', zip: '386518' },
	{ city: 'Bruckless (Donegal)', zip: '423632' },
	{ city: 'Brufea (Limerick)', zip: '957612' },
	{ city: 'Bruff (Limerick)', zip: '372089' },
	{ city: 'Bruff (Mayo)', zip: '639588' },
	{ city: 'Bruis (Tipperary)', zip: '332931' },
	{ city: 'Brulea (Cork)', zip: '187210' },
	{ city: 'Brumlin (Kildare)', zip: '619643' },
	{ city: 'Brunswick (Tipperary)', zip: '917423' },
	{ city: 'Bruree (Limerick)', zip: '931988' },
	{ city: 'Bruse (Cavan)', zip: '400399' },
	{ city: 'Brusk (Galway)', zip: '883298' },
	{ city: 'Brusky (Cavan)', zip: '709325' },
	{ city: 'Brusselstown (Wicklow)', zip: '992119' },
	{ city: 'Brutonstown (Westmeath)', zip: '324541' },
	{ city: 'Brutonstown Little (Westmeath)', zip: '535354' },
	{ city: 'Bryan Beg (Roscommon)', zip: '109524' },
	{ city: 'Bryanbeg Lower (Westmeath)', zip: '937354' },
	{ city: 'Bryanbeg Upper (Westmeath)', zip: '177081' },
	{ city: 'Bryanlitter (Monaghan)', zip: '517579' },
	{ city: 'Bryan More (Roscommon)', zip: '185683' },
	{ city: 'Bryanmore Lower (Westmeath)', zip: '557450' },
	{ city: 'Bryanmore Upper (Westmeath)', zip: '849558' },
	{ city: 'Bryanstown (Kildare)', zip: '637349' },
	{ city: 'Bryanstown (Louth)', zip: '597466' },
	{ city: 'Bryanstown (Meath)', zip: '965232' },
	{ city: 'Bryanstown (Westmeath)', zip: '845996' },
	{ city: 'Bryanstown (Wexford)', zip: '502097' },
	{ city: 'Buavanagh (Cork)', zip: '334349' },
	{ city: 'Buckandhounds (Dublin)', zip: '871669' },
	{ city: 'Buckfield (Mayo)', zip: '132453' },
	{ city: 'Buckhill Barr (Leitrim)', zip: '608459' },
	{ city: 'Buckill (Roscommon)', zip: '309820' },
	{ city: 'Buckode (Leitrim)', zip: '587743' },
	{ city: 'Buckree (Cork)', zip: '270534' },
	{ city: 'Buckstown (Cork)', zip: '259380' },
	{ city: 'Buckstown (Wexford)', zip: '981564' },
	{ city: 'Buckwaria (Mayo)', zip: '789534' },
	{ city: 'Buddaghauns (Kerry)', zip: '431476' },
	{ city: 'Buddrimeen (Cork)', zip: '604416' },
	{ city: 'Budellagh And Cloghbrack (Galway)', zip: '490262' },
	{ city: 'Buffanagh (Tipperary)', zip: '671735' },
	{ city: 'Buffanoky (Limerick)', zip: '374038' },
	{ city: 'Buffy (Galway)', zip: '656416' },
	{ city: 'Bughorn (Laois)', zip: '352701' },
	{ city: 'Bulcaun (Galway)', zip: '522422' },
	{ city: 'Bulcaun (Mayo)', zip: '318670' },
	{ city: 'Bulgaden (Limerick)', zip: '728850' },
	{ city: 'Bulgaden Eady (Limerick)', zip: '224723' },
	{ city: 'Bulgadenhall (Limerick)', zip: '565481' },
	{ city: 'Bulgan (Wexford)', zip: '964366' },
	{ city: 'Bullaun (Galway)', zip: '134237' },
	{ city: 'Bullaun (Limerick)', zip: '207220' },
	{ city: 'Bullaun (Mayo)', zip: '962321' },
	{ city: 'Bullaun (Sligo)', zip: '322012' },
	{ city: 'Bullaunagh (Galway)', zip: '925977' },
	{ city: 'Bullaunmeneen (Mayo)', zip: '638273' },
	{ city: 'Bullford (Wicklow)', zip: '744468' },
	{ city: 'Bullhill (Kildare)', zip: '684434' },
	{ city: 'Bulligs (Cavan)', zip: '671719' },
	{ city: 'Bullock (Dublin)', zip: '206822' },
	{ city: 'Bullockhill (Kilkenny)', zip: '106189' },
	{ city: 'Bullock Island (Offaly)', zip: '250571' },
	{ city: 'Bullockpark (Kildare)', zip: '696626' },
	{ city: 'Bullockpark (Tipperary)', zip: '436903' },
	{ city: 'Bullogbrean (Monaghan)', zip: '963663' },
	{ city: 'Bullsfarm (Clare)', zip: '563106' },
	{ city: 'Bullstown (Meath)', zip: '682156' },
	{ city: 'Bumlin (Roscommon)', zip: '644833' },
	{ city: 'Bun (Cavan)', zip: '232654' },
	{ city: 'Bun (Offaly)', zip: '281723' },
	{ city: 'Bunacloy (Longford)', zip: '805117' },
	{ city: 'Bunacrower (Mayo)', zip: '318811' },
	{ city: 'Bunacum (Tipperary)', zip: '343345' },
	{ city: 'Bunacurry (Mayo)', zip: '810490' },
	{ city: 'Bunaderreen (Kerry)', zip: '995812' },
	{ city: 'Bunagarha (Kerry)', zip: '997333' },
	{ city: 'Bunagarraun (Galway)', zip: '453079' },
	{ city: 'Bunaglanna (Cork)', zip: '655511' },
	{ city: 'Bunakeeran (Offaly)', zip: '550231' },
	{ city: 'Bunalough (Longford)', zip: '242900' },
	{ city: 'Bunalty (Mayo)', zip: '324747' },
	{ city: 'Bunalunn (Cork)', zip: '386855' },
	{ city: 'Bunanagh (Westmeath)', zip: '248491' },
	{ city: 'Bunanass (Longford)', zip: '788465' },
	{ city: 'Bunane (Kerry)', zip: '237625' },
	{ city: 'Bunaneraghtish (Mayo)', zip: '338754' },
	{ city: 'Bunanioo (Mayo)', zip: '964332' },
	{ city: 'Bunanraun (Galway)', zip: '405885' },
	{ city: 'Bunanumera (Cork)', zip: '898530' },
	{ city: 'Bunanumery (Cavan)', zip: '237496' },
	{ city: 'Bunargate (Wexford)', zip: '251169' },
	{ city: 'Bunargate Strand (Wexford)', zip: '538083' },
	{ city: 'Bunarge (Wexford)', zip: '416778' },
	{ city: 'Bunastick (Laois)', zip: '179836' },
	{ city: 'Bunaterin (Offaly)', zip: '117468' },
	{ city: 'Bunatober (Galway)', zip: '227519' },
	{ city: 'Bunavan (Galway)', zip: '371099' },
	{ city: 'Bunavaunish (Mayo)', zip: '766791' },
	{ city: 'Bunaveela (Mayo)', zip: '388021' },
	{ city: 'Bunavie (Limerick)', zip: '939079' },
	{ city: 'Bunavory (Clare)', zip: '247974' },
	{ city: 'Bunawack (Donegal)', zip: '301644' },
	{ city: 'Bunawillin (Mayo)', zip: '105643' },
	{ city: 'Bunbeg (Donegal)', zip: '480925' },
	{ city: 'Bunbinnia (Kerry)', zip: '499540' },
	{ city: 'Bunboggan (Meath)', zip: '962422' },
	{ city: 'Bunbrosna (Westmeath)', zip: '509452' },
	{ city: 'Buncam (Galway)', zip: '922184' },
	{ city: 'Buncam East (Mayo)', zip: '453863' },
	{ city: 'Buncam North (Mayo)', zip: '891596' },
	{ city: 'Buncam West (Mayo)', zip: '559226' },
	{ city: 'Buncarrick (Wexford)', zip: '573950' },
	{ city: 'Bunclody (Wexford)', zip: '541643' },
	{ city: 'Buncraggy (Clare)', zip: '113173' },
	{ city: 'Buncrana (Donegal)', zip: '863357' },
	{ city: 'Buncronan (Donegal)', zip: '902084' },
	{ city: 'Buncroobog (Donegal)', zip: '523453' },
	{ city: 'Buncrowey (Sligo)', zip: '213278' },
	{ city: 'Buncurrig (Kerry)', zip: '763000' },
	{ city: 'Bundarragh (Leitrim)', zip: '768844' },
	{ city: 'Bundeeleen (Mayo)', zip: '258659' },
	{ city: 'Bundiveen (Leitrim)', zip: '474512' },
	{ city: 'Bundoon (Longford)', zip: '230302' },
	{ city: 'Bundoran (Donegal)', zip: '609576' },
	{ city: 'Bundorragha (Mayo)', zip: '370619' },
	{ city: 'Bundouglas (Galway)', zip: '349664' },
	{ city: 'Bunduff (Leitrim)', zip: '416453' },
	{ city: 'Bunduff (Mayo)', zip: '280854' },
	{ city: 'Bunduff (Sligo)', zip: '230777' },
	{ city: 'Bunduvowen (Mayo)', zip: '129398' },
	{ city: 'Bunglasha (Kerry)', zip: '667748' },
	{ city: 'Bunglasha North (Kerry)', zip: '426288' },
	{ city: 'Bunglasha South (Kerry)', zip: '345895' },
	{ city: 'Bungosteen (Donegal)', zip: '747161' },
	{ city: 'Buninna (Sligo)', zip: '662599' },
	{ city: 'Bunkey (Limerick)', zip: '973147' },
	{ city: 'Bunkilla (Cork)', zip: '636828' },
	{ city: 'Bunkilleen (Leitrim)', zip: '690276' },
	{ city: 'Bunkimalta (Tipperary)', zip: '309635' },
	{ city: 'Bunlacken (Laois)', zip: '831987' },
	{ city: 'Bunlahy (Longford)', zip: '694655' },
	{ city: 'Bunlick (Cork)', zip: '127980' },
	{ city: 'Bunlicky (Limerick)', zip: '361023' },
	{ city: 'Bunmahon (Waterford)', zip: '839294' },
	{ city: 'Bunmore East (Mayo)', zip: '205147' },
	{ city: 'Bunmore West (Mayo)', zip: '556413' },
	{ city: 'Bunnabinnia North (Clare)', zip: '734047' },
	{ city: 'Bunnabinnia South (Clare)', zip: '531921' },
	{ city: 'Bunnaconeen (Galway)', zip: '373977' },
	{ city: 'Bunnacranagh (Sligo)', zip: '508717' },
	{ city: 'Bunnadober (Mayo)', zip: '642200' },
	{ city: 'Bunnadober (Sligo)', zip: '110905' },
	{ city: 'Bunnadober (Tipperary)', zip: '902827' },
	{ city: 'Bunnafedia (Sligo)', zip: '257295' },
	{ city: 'Bunnafinglas (Mayo)', zip: '966053' },
	{ city: 'Bunnafollistran (Mayo)', zip: '970853' },
	{ city: 'Bunnagappagh (Offaly)', zip: '511472' },
	{ city: 'Bunnageddy (Roscommon)', zip: '797194' },
	{ city: 'Bunnagee (Donegal)', zip: '866804' },
	{ city: 'Bunnagippaun (Galway)', zip: '681746' },
	{ city: 'Bunnaglass (Galway)', zip: '598562' },
	{ city: 'Bunnagurragh (Carlow)', zip: '406145' },
	{ city: 'Bunnahevelly Beg (Galway)', zip: '878952' },
	{ city: 'Bunnahevelly More (Galway)', zip: '686549' },
	{ city: 'Bunnahinly (Westmeath)', zip: '462339' },
	{ city: 'Bunnahow (Clare)', zip: '216332' },
	{ city: 'Bunnahowen (Mayo)', zip: '760407' },
	{ city: 'Bunnahown (Galway)', zip: '757016' },
	{ city: 'Bunnahowna (Mayo)', zip: '207722' },
	{ city: 'Bunnakill (Galway)', zip: '567041' },
	{ city: 'Bunnamayne (Donegal)', zip: '967058' },
	{ city: 'Bunnamohaun (Mayo)', zip: '544786' },
	{ city: 'Bunnamuck (Sligo)', zip: '795674' },
	{ city: 'Bunnamucka (Roscommon)', zip: '848122' },
	{ city: 'Bunnanaddan (Sligo)', zip: '835038' },
	{ city: 'Bunnanagat North (Clare)', zip: '547769' },
	{ city: 'Bunnanagat South (Clare)', zip: '220094' },
	{ city: 'Bunnanilra (Sligo)', zip: '254526' },
	{ city: 'Bunnaribba (Roscommon)', zip: '393947' },
	{ city: 'Bunnaruddee (Kerry)', zip: '615504' },
	{ city: 'Bunnasillagh (Galway)', zip: '940401' },
	{ city: 'Bunnasrah (Galway)', zip: '936317' },
	{ city: 'Bunnaton (Donegal)', zip: '817370' },
	{ city: 'Bunnatreesruhan (Donegal)', zip: '493912' },
	{ city: 'Bunnavally (Westmeath)', zip: '773337' },
	{ city: 'Bunnaviskaun (Galway)', zip: '678491' },
	{ city: 'Bunnianstown (Meath)', zip: '441828' },
	{ city: 'Bunnoe (Cavan)', zip: '923643' },
	{ city: 'Bunnow (Clare)', zip: '824329' },
	{ city: 'Bunny Beg (Leitrim)', zip: '714178' },
	{ city: 'Bunnyconnellan (Mayo)', zip: '578303' },
	{ city: 'Bunnyconnellan East (Mayo)', zip: '496414' },
	{ city: 'Bunnyconnellan West (Mayo)', zip: '546449' },
	{ city: 'Bunny More Lower (Leitrim)', zip: '416786' },
	{ city: 'Bunny More Upper (Leitrim)', zip: '922928' },
	{ city: 'Bunoghanaun (Galway)', zip: '548609' },
	{ city: 'Bunowen (Galway)', zip: '690975' },
	{ city: 'Bunowen (Mayo)', zip: '265258' },
	{ city: 'Bunowen Beg (Galway)', zip: '554044' },
	{ city: 'Bunowen More (Galway)', zip: '485460' },
	{ city: 'Bunown (Westmeath)', zip: '727081' },
	{ city: 'Bunowna (Sligo)', zip: '810452' },
	{ city: 'Bunratty (Clare)', zip: '769645' },
	{ city: 'Bunratty East (Clare)', zip: '142089' },
	{ city: 'Bunratty West (Clare)', zip: '291870' },
	{ city: 'Bunrawer (Mayo)', zip: '676860' },
	{ city: 'Bunreagh (Roscommon)', zip: '267827' },
	{ city: 'Bunree (Mayo)', zip: '596116' },
	{ city: 'Bunrevagh (Leitrim)', zip: '982564' },
	{ city: 'Bunrevan (Offaly)', zip: '577041' },
	{ city: 'Bunrower (Kerry)', zip: '832207' },
	{ city: 'Bunsallagh (Offaly)', zip: '411867' },
	{ city: 'Bunscanniff (Galway)', zip: '530533' },
	{ city: 'Bunskellig (Cork)', zip: '744370' },
	{ city: 'Buntalloon (Kerry)', zip: '889090' },
	{ city: 'Buolick (Tipperary)', zip: '391253' },
	{ city: 'Burdautien (Monaghan)', zip: '849989' },
	{ city: 'Burgage (Carlow)', zip: '671239' },
	{ city: 'Burgage (Dublin)', zip: '292179' },
	{ city: 'Burgage More (Wicklow)', zip: '448180' },
	{ city: 'Burgage Moyle (Wicklow)', zip: '848613' },
	{ city: 'Burgagery-Lands East (Tipperary)', zip: '405083' },
	{ city: 'Burgagery-Lands West (Tipperary)', zip: '942434' },
	{ city: 'Burgary (Cork)', zip: '428656' },
	{ city: 'Burgatia (Cork)', zip: '590537' },
	{ city: 'Burgery (Waterford)', zip: '497458' },
	{ city: 'Burges (Tipperary)', zip: '355033' },
	{ city: 'Burgesbeg (Tipperary)', zip: '408743' },
	{ city: 'Burgesland (Cork)', zip: '409238' },
	{ city: 'Burgesland (Tipperary)', zip: '950815' },
	{ city: 'Burgesland (Westmeath)', zip: '574140' },
	{ city: 'Burges Lower (Cork)', zip: '800469' },
	{ city: 'Burges Mansion (Tipperary)', zip: '685622' },
	{ city: 'Burges New (Tipperary)', zip: '279707' },
	{ city: 'Burgess (Wexford)', zip: '142820' },
	{ city: 'Burgessacre (Cavan)', zip: '150140' },
	{ city: 'Burgess Anchor (Waterford)', zip: '214384' },
	{ city: 'Burges Upper (Cork)', zip: '300877' },
	{ city: 'Burges West (Tipperary)', zip: '614184' },
	{ city: 'Burkeen (Wicklow)', zip: '795114' },
	{ city: 'Burkestown (Wexford)', zip: '505144' },
	{ city: 'Burnafaunia (Mayo)', zip: '636571' },
	{ city: 'Burnchurch (Kilkenny)', zip: '359167' },
	{ city: 'Burnchurch (Tipperary)', zip: '479634' },
	{ city: 'Burnchurch Viper (Kilkenny)', zip: '266967' },
	{ city: 'Burncourt (Tipperary)', zip: '864948' },
	{ city: 'Burnellstown (Westmeath)', zip: '877126' },
	{ city: 'Burnew (Cavan)', zip: '806733' },
	{ city: 'Burnfoot (Donegal)', zip: '647603' },
	{ city: 'Burnfort (Cork)', zip: '181088' },
	{ city: 'Burnham East (Kerry)', zip: '345924' },
	{ city: 'Burnham West (Kerry)', zip: '608625' },
	{ city: 'Burnside (Donegal)', zip: '235345' },
	{ city: 'Burns Mountain (Donegal)', zip: '808110' },
	{ city: 'Burntfurze (Kildare)', zip: '376790' },
	{ city: 'Burntfurze (Kilkenny)', zip: '281259' },
	{ city: 'Burnthaw (Donegal)', zip: '889453' },
	{ city: 'Burnthouse (Galway)', zip: '148484' },
	{ city: 'Burntwood Big (Tipperary)', zip: '401713' },
	{ city: 'Burntwood Little (Tipperary)', zip: '539913' },
	{ city: 'Burrane (Cork)', zip: '884083' },
	{ city: 'Burrane Lower (Clare)', zip: '484497' },
	{ city: 'Burrane Upper (Clare)', zip: '338337' },
	{ city: 'Burrellspark (Kilkenny)', zip: '428279' },
	{ city: 'Burren (Cavan)', zip: '169732' },
	{ city: 'Burren (Clare)', zip: '787216' },
	{ city: 'Burren (Cork)', zip: '616426' },
	{ city: 'Burren (Louth)', zip: '767142' },
	{ city: 'Burren (Mayo)', zip: '453852' },
	{ city: 'Burrencarragh (Cavan)', zip: '949151' },
	{ city: 'Burrenfadda (Clare)', zip: '990131' },
	{ city: 'Burrenrea (Cavan)', zip: '965618' },
	{ city: 'Burrenwee (Clare)', zip: '598352' },
	{ city: 'Burris (Mayo)', zip: '496339' },
	{ city: 'Burriscarra (Mayo)', zip: '933891' },
	{ city: 'Burr Island (Galway)', zip: '619008' },
	{ city: 'Burroge (Galway)', zip: '576632' },
	{ city: 'Burrow (Dublin)', zip: '677367' },
	{ city: 'Burrow (Offaly)', zip: '302270' },
	{ city: 'Burrow (Wexford)', zip: '946272' },
	{ city: 'Burrow (Wicklow)', zip: '991709' },
	{ city: 'Bursan (Cavan)', zip: '149787' },
	{ city: 'Burtonhall Demesne (Carlow)', zip: '252067' },
	{ city: 'Burtonhall Demesne (Kildare)', zip: '856508' },
	{ city: 'Burtonhill (Clare)', zip: '883111' },
	{ city: 'Burton Park (Cork)', zip: '151338' },
	{ city: 'Burtonport (Donegal)', zip: '301656' },
	{ city: 'Burtonstown (Meath)', zip: '140378' },
	{ city: 'Burtown Big (Kildare)', zip: '381509' },
	{ city: 'Burtown Little (Kildare)', zip: '300143' },
	{ city: 'Bush (Wexford)', zip: '310524' },
	{ city: 'Bushelloaf (Dublin)', zip: '151125' },
	{ city: 'Busherstown (Carlow)', zip: '929259' },
	{ city: 'Busherstown (Kilkenny)', zip: '609412' },
	{ city: 'Busherstown (Offaly)', zip: '586155' },
	{ city: 'Busherstown (Wexford)', zip: '691976' },
	{ city: 'Bushfield (Galway)', zip: '118604' },
	{ city: 'Bushfield (Laois)', zip: '857367' },
	{ city: 'Bushfield (Mayo)', zip: '129302' },
	{ city: 'Bushfield (Roscommon)', zip: '767671' },
	{ city: 'Bushfield (Wicklow)', zip: '196539' },
	{ city: 'Bush Island (Galway)', zip: '236495' },
	{ city: 'Bushmount (Kerry)', zip: '193277' },
	{ city: 'Bushpark (Wexford)', zip: '980955' },
	{ city: 'Bushtameen (Kilkenny)', zip: '477885' },
	{ city: 'Bushtown (Galway)', zip: '304571' },
	{ city: 'Bushyisland (Limerick)', zip: '289257' },
	{ city: 'Bushypark (Clare)', zip: '358083' },
	{ city: 'Bushypark (Cork)', zip: '627033' },
	{ city: 'Bushypark (Kildare)', zip: '669661' },
	{ city: 'Bustyhill (Dublin)', zip: '423854' },
	{ city: 'Butlers Bridge (Cavan)', zip: '165356' },
	{ city: 'Butlersfarm (Tipperary)', zip: '997395' },
	{ city: 'Butlersgrange (Carlow)', zip: '697712' },
	{ city: 'Butlersgrove (Kilkenny)', zip: '741640' },
	{ city: 'Butlersland (Wexford)', zip: '455294' },
	{ city: "Butler's-Land (Tipperary)", zip: '488494' },
	{ city: 'Butlers Lodge (Tipperary)', zip: '454970' },
	{ city: 'Butlerstown (Cork)', zip: '110279' },
	{ city: 'Butlerstown (Meath)', zip: '550124' },
	{ city: 'Butlerstown (Tipperary)', zip: '974256' },
	{ city: 'Butlerstown (Wexford)', zip: '269174' },
	{ city: 'Butlerstown Great (Cork)', zip: '609116' },
	{ city: 'Butlerstown Little (Cork)', zip: '228705' },
	{ city: 'Butlerstown North (Waterford)', zip: '684229' },
	{ city: 'Butlerstown South (Waterford)', zip: '229428' },
	{ city: 'Butlerswood (Kilkenny)', zip: '153260' },
	{ city: 'Butterfield (Dublin)', zip: '502880' },
	{ city: 'Butterhill (Wicklow)', zip: '309583' },
	{ city: 'Butterisland (Laois)', zip: '174273' },
	{ city: 'Butter Mountain (Wicklow)', zip: '724752' },
	{ city: 'Butterstream Commons (Kildare)', zip: '660456' },
	{ city: 'Buttevant (Cork)', zip: '484062' },
	{ city: 'Buzzardstown (Dublin)', zip: '398742' },
	{ city: 'Bweeng (Cork)', zip: '882058' },
	{ city: 'Byblox (Cork)', zip: '669653' },
	{ city: 'Byrnesgrove (Kilkenny)', zip: '156458' },
	{ city: 'Byrneshill (Wicklow)', zip: '552870' },
	{ city: 'Byrneskill (Tipperary)', zip: '507887' },
	{ city: 'Caad Island (Galway)', zip: '571818' },
	{ city: 'Cabinhill (Dublin)', zip: '865853' },
	{ city: 'Cabinhill (Meath)', zip: '499907' },
	{ city: 'Cabinteely (Dublin)', zip: '384084' },
	{ city: 'Cabintown (Mayo)', zip: '840333' },
	{ city: 'Cabra (Cavan)', zip: '553949' },
	{ city: 'Cabra (Dublin)', zip: '246995' },
	{ city: 'Cabra Brook (Donegal)', zip: '767290' },
	{ city: 'Cabragh (Cavan)', zip: '741778' },
	{ city: 'Cabragh (Cork)', zip: '934107' },
	{ city: 'Cabragh (Dublin)', zip: '816812' },
	{ city: 'Cabragh (Mayo)', zip: '134553' },
	{ city: 'Cabragh (Meath)', zip: '912990' },
	{ city: 'Cabragh (Monaghan)', zip: '542333' },
	{ city: 'Cabragh (Sligo)', zip: '518409' },
	{ city: 'Cabragh (Tipperary)', zip: '464968' },
	{ city: 'Cabraghkeel (Sligo)', zip: '189530' },
	{ city: 'Cabra Glebe (Donegal)', zip: '238761' },
	{ city: 'Cabry (Donegal)', zip: '520756' },
	{ city: 'Cackanode (Cork)', zip: '434721' },
	{ city: 'Cadamstown (Kildare)', zip: '362219' },
	{ city: 'Cadamstown (Offaly)', zip: '599589' },
	{ city: 'Caddagh (Monaghan)', zip: '982111' },
	{ city: 'Caddagh (Westmeath)', zip: '306498' },
	{ city: 'Caddagh Glebe (Leitrim)', zip: '605914' },
	{ city: 'Caddellbrook (Roscommon)', zip: '139030' },
	{ city: 'Caddelstown (Meath)', zip: '385813' },
	{ city: 'Caddlestown (Tipperary)', zip: '272264' },
	{ city: 'Caffoley (Mayo)', zip: '922948' },
	{ city: 'Cahanagh (Longford)', zip: '781837' },
	{ city: 'Caher (Clare)', zip: '167776' },
	{ city: 'Caher (Cork)', zip: '251465' },
	{ city: 'Caher (Galway)', zip: '681876' },
	{ city: 'Caher (Kerry)', zip: '559807' },
	{ city: 'Caher (Laois)', zip: '940393' },
	{ city: 'Caher (Limerick)', zip: '887411' },
	{ city: 'Caher (Mayo)', zip: '936384' },
	{ city: 'Caher (Roscommon)', zip: '162351' },
	{ city: 'Caher (Tipperary)', zip: '904459' },
	{ city: 'Caher (Waterford)', zip: '128176' },
	{ city: 'Caherabbey Lower (Tipperary)', zip: '106539' },
	{ city: 'Caherabbey Upper (Tipperary)', zip: '695057' },
	{ city: 'Caheracruttera (Kerry)', zip: '655447' },
	{ city: 'Caheradangan (Galway)', zip: '457668' },
	{ city: 'Caheraderry (Clare)', zip: '384257' },
	{ city: 'Caheradine (Galway)', zip: '462688' },
	{ city: 'Caheragh (Cork)', zip: '158727' },
	{ city: 'Caheragh (Kerry)', zip: '526605' },
	{ city: 'Caheragh (Limerick)', zip: '768047' },
	{ city: 'Caheraghacullin (Clare)', zip: '726284' },
	{ city: 'Caherakeeny (Galway)', zip: '315109' },
	{ city: 'Caherakilleen (Galway)', zip: '944806' },
	{ city: 'Caheraloggy East (Galway)', zip: '457055' },
	{ city: 'Caheraloggy West (Galway)', zip: '755879' },
	{ city: 'Caheranardrish (Limerick)', zip: '597878' },
	{ city: 'Caherapheepa (Galway)', zip: '517828' },
	{ city: 'Caheraphuca (Clare)', zip: '351863' },
	{ city: 'Caherard (Kerry)', zip: '800750' },
	{ city: 'Caherass (Limerick)', zip: '317008' },
	{ city: 'Caherateemore North (Galway)', zip: '639972' },
	{ city: 'Caherateemore South (Galway)', zip: '786730' },
	{ city: 'Caherateige (Galway)', zip: '222833' },
	{ city: 'Caheratrant (Kerry)', zip: '295232' },
	{ city: 'Caheratrim (Galway)', zip: '439702' },
	{ city: 'Caheravart (Cork)', zip: '971725' },
	{ city: 'Caheraveelane (Cork)', zip: '411529' },
	{ city: 'Caheravirane (Cork)', zip: '776653' },
	{ city: 'Caheravoley (Galway)', zip: '303000' },
	{ city: 'Caheravoostia (Mayo)', zip: '784422' },
	{ city: 'Caherawoneen North (Galway)', zip: '324568' },
	{ city: 'Caherawoneen South (Galway)', zip: '551062' },
	{ city: 'Caherbannagh (Clare)', zip: '148950' },
	{ city: 'Caherbarnagh (Clare)', zip: '511893' },
	{ city: 'Caherbarnagh (Cork)', zip: '262081' },
	{ city: 'Caherbarnagh (Kerry)', zip: '105985' },
	{ city: 'Caherbaroul (Cork)', zip: '316578' },
	{ city: 'Caherbaun (Tipperary)', zip: '617421' },
	{ city: 'Caherbaun (Waterford)', zip: '532941' },
	{ city: 'Caherbeg (Cork)', zip: '158835' },
	{ city: 'Caherbirrane (Cork)', zip: '235733' },
	{ city: 'Caherblonick North (Clare)', zip: '768944' },
	{ city: 'Caherblonick South (Clare)', zip: '941964' },
	{ city: 'Caherboshina (Kerry)', zip: '140913' },
	{ city: 'Caherbrack (Waterford)', zip: '760559' },
	{ city: 'Caherbreagh (Kerry)', zip: '622294' },
	{ city: 'Caherbrian (Galway)', zip: '133617' },
	{ city: 'Caherbriskaun (Galway)', zip: '567327' },
	{ city: 'Caherbroder (Galway)', zip: '358460' },
	{ city: 'Caherbullaun (Clare)', zip: '592644' },
	{ city: 'Caherbullig (Kerry)', zip: '348845' },
	{ city: 'Caherbulligin (Galway)', zip: '514822' },
	{ city: 'Caherbullog (Clare)', zip: '539639' },
	{ city: 'Cahercalla (Clare)', zip: '967484' },
	{ city: 'Cahercannavan (Clare)', zip: '663168' },
	{ city: 'Cahercarney (Cork)', zip: '145457' },
	{ city: 'Cahercarney (Galway)', zip: '353688' },
	{ city: 'Caherclanchy (Clare)', zip: '194969' },
	{ city: 'Cahercloggaun (Clare)', zip: '555468' },
	{ city: 'Caherclogh (Limerick)', zip: '975016' },
	{ city: 'Caherclogh (Tipperary)', zip: '738513' },
	{ city: 'Cahercon (Galway)', zip: '773951' },
	{ city: 'Caherconlish (Limerick)', zip: '563708' },
	{ city: 'Caherconnell (Clare)', zip: '556550' },
	{ city: 'Caherconnor (Cork)', zip: '117031' },
	{ city: 'Caherconreafy (Limerick)', zip: '570642' },
	{ city: 'Cahercorcaun (Clare)', zip: '849356' },
	{ city: 'Cahercormick (Galway)', zip: '735692' },
	{ city: 'Cahercorney (Limerick)', zip: '114797' },
	{ city: 'Cahercrea East (Galway)', zip: '381604' },
	{ city: 'Cahercrea West (Galway)', zip: '503155' },
	{ city: 'Cahercrin (Galway)', zip: '775279' },
	{ city: 'Cahercroobeen (Mayo)', zip: '552528' },
	{ city: 'Cahercullenagh Lower (Kerry)', zip: '122865' },
	{ city: 'Cahercullenagh Upper (Kerry)', zip: '146486' },
	{ city: 'Caherdague (Longford)', zip: '452996' },
	{ city: 'Caherdaha (Cork)', zip: '451522' },
	{ city: 'Caherdaly (Galway)', zip: '720473' },
	{ city: 'Caherdaniel (Kerry)', zip: '895318' },
	{ city: 'Caherdaniel East (Cork)', zip: '347951' },
	{ city: 'Caherdaniel West (Cork)', zip: '875357' },
	{ city: 'Caherdavin (Limerick)', zip: '167961' },
	{ city: 'Caherdean (Kerry)', zip: '712284' },
	{ city: 'Caherdesert (Cork)', zip: '707443' },
	{ city: 'Caherdorgan North (Kerry)', zip: '392093' },
	{ city: 'Caherdorgan South (Kerry)', zip: '701548' },
	{ city: 'Caherdowney (Cork)', zip: '297303' },
	{ city: 'Caherdrinny (Cork)', zip: '387020' },
	{ city: 'Caherduff (Galway)', zip: '381325' },
	{ city: 'Caherduff (Mayo)', zip: '743016' },
	{ city: 'Caherduggan (Cork)', zip: '844090' },
	{ city: 'Caherduggan Demesne (Cork)', zip: '737185' },
	{ city: 'Caherduggan East (Cork)', zip: '170800' },
	{ city: 'Caherduggan North (Cork)', zip: '784719' },
	{ city: 'Caherduggan South (Cork)', zip: '782482' },
	{ city: 'Caherduggan West (Cork)', zip: '507646' },
	{ city: 'Caherea (Clare)', zip: '189570' },
	{ city: 'Cahereamore (Clare)', zip: '481671' },
	{ city: 'Caher East (Kerry)', zip: '747573' },
	{ city: 'Caheredmond (Mayo)', zip: '145767' },
	{ city: 'Cahereen East (Kerry)', zip: '295806' },
	{ city: 'Cahereen West (Kerry)', zip: '928726' },
	{ city: 'Cahereighterrush (Kerry)', zip: '686596' },
	{ city: 'Caherelly (Limerick)', zip: '559996' },
	{ city: 'Caherelly East (Limerick)', zip: '739114' },
	{ city: 'Caherelly West (Limerick)', zip: '832703' },
	{ city: 'Cahererillan (Galway)', zip: '688653' },
	{ city: 'Caherfadda (Clare)', zip: '259520' },
	{ city: 'Caherfealane (Kerry)', zip: '536740' },
	{ city: 'Caherfealane-Marsh (Kerry)', zip: '787848' },
	{ city: 'Caherfeenick North (Clare)', zip: '281251' },
	{ city: 'Caherfeenick South (Clare)', zip: '246170' },
	{ city: 'Caherfinesker (Galway)', zip: '440178' },
	{ city: 'Caherfurvaus (Galway)', zip: '452661' },
	{ city: 'Cahergal (Cork)', zip: '419442' },
	{ city: 'Cahergal (Galway)', zip: '750085' },
	{ city: 'Cahergal (Mayo)', zip: '373548' },
	{ city: 'Cahergal (Waterford)', zip: '854000' },
	{ city: 'Cahergarriff (Cork)', zip: '461550' },
	{ city: 'Caherglassaun (Galway)', zip: '764047' },
	{ city: 'Cahergowan (Galway)', zip: '989533' },
	{ city: 'Cahergrillaun (Clare)', zip: '145581' },
	{ city: 'Caherhemush (Mayo)', zip: '646666' },
	{ city: 'Caherhenesy (Limerick)', zip: '764410' },
	{ city: 'Caherhenryhoe (Galway)', zip: '742168' },
	{ city: 'Caherhoereigh (Tipperary)', zip: '140047' },
	{ city: 'Caherhugh (Galway)', zip: '554939' },
	{ city: 'Caherhurly (Clare)', zip: '126251' },
	{ city: 'Caher Island (Mayo)', zip: '343412' },
	{ city: 'Caherkeegane (Cork)', zip: '535772' },
	{ city: 'Caherkeen (Cork)', zip: '344254' },
	{ city: 'Caherkelly (Galway)', zip: '378548' },
	{ city: 'Caherkereen (Cork)', zip: '113845' },
	{ city: 'Caherkinallia (Clare)', zip: '710373' },
	{ city: 'Caherkine (Clare)', zip: '776504' },
	{ city: 'Caherkinmonwee (Galway)', zip: '192359' },
	{ city: 'Caherkirky (Cork)', zip: '844001' },
	{ city: 'Caherlarhig (Cork)', zip: '892587' },
	{ city: 'Caherlavine (Galway)', zip: '499177' },
	{ city: 'Caherlea (Galway)', zip: '536250' },
	{ city: 'Caherlean (Clare)', zip: '693231' },
	{ city: 'Caherleheen (Kerry)', zip: '328826' },
	{ city: 'Caherlehillan (Kerry)', zip: '229324' },
	{ city: 'Caherlesk (Kilkenny)', zip: '357289' },
	{ city: 'Caherlevoy (Limerick)', zip: '307265' },
	{ city: 'Caherline (Limerick)', zip: '360484' },
	{ city: 'Caherlinny (Galway)', zip: '496039' },
	{ city: 'Caherlissakill (Galway)', zip: '310480' },
	{ city: 'Caherlistrane (Galway)', zip: '405641' },
	{ city: 'Caherloghan (Clare)', zip: '438543' },
	{ city: 'Caherlooskaun (Clare)', zip: '932394' },
	{ city: 'Caherlough (Clare)', zip: '934906' },
	{ city: 'Caherloughlin (Mayo)', zip: '280954' },
	{ city: 'Caherlusky (Cork)', zip: '660035' },
	{ city: 'Caherlustraun (Galway)', zip: '132563' },
	{ city: 'Cahermaan (Clare)', zip: '381829' },
	{ city: 'Cahermacanally (Galway)', zip: '330235' },
	{ city: 'Cahermackateer (Clare)', zip: '298037' },
	{ city: 'Cahermackirilla (Clare)', zip: '286552' },
	{ city: 'Cahermaclanchy (Clare)', zip: '876670' },
	{ city: 'Cahermacnaghten (Clare)', zip: '896617' },
	{ city: 'Cahermacon (Clare)', zip: '505006' },
	{ city: 'Cahermacrea (Clare)', zip: '370273' },
	{ city: 'Cahermacrusheen (Clare)', zip: '390834' },
	{ city: 'Cahermaculick (Mayo)', zip: '379835' },
	{ city: 'Cahermacun (Clare)', zip: '954047' },
	{ city: 'Cahermakerrila (Clare)', zip: '492680' },
	{ city: 'Cahermee (Cork)', zip: '921713' },
	{ city: 'Cahermeeleboe (Cork)', zip: '635504' },
	{ city: 'Caherminnaun East (Clare)', zip: '199954' },
	{ city: 'Caherminnaun West (Clare)', zip: '524914' },
	{ city: 'Cahermoanteen (Cork)', zip: '416648' },
	{ city: 'Cahermone (Cork)', zip: '713499' },
	{ city: 'Cahermoneen (Kerry)', zip: '386654' },
	{ city: 'Cahermore (Clare)', zip: '536009' },
	{ city: 'Cahermore (Cork)', zip: '200595' },
	{ city: 'Cahermore (Galway)', zip: '929070' },
	{ city: 'Cahermore (Kerry)', zip: '444250' },
	{ city: 'Cahermorris (Galway)', zip: '265774' },
	{ city: 'Caher-Mountain (Cork)', zip: '766387' },
	{ city: 'Cahermoyle (Limerick)', zip: '628840' },
	{ city: 'Cahermuckee (Cork)', zip: '530029' },
	{ city: 'Cahermurphy (Clare)', zip: '678369' },
	{ city: 'Cahernabane (Kerry)', zip: '218907' },
	{ city: 'Cahernablauhy (Mayo)', zip: '443780' },
	{ city: 'Cahernabrock (Mayo)', zip: '741943' },
	{ city: 'Cahernabudogy (Mayo)', zip: '214621' },
	{ city: 'Cahernacaha (Cork)', zip: '479210' },
	{ city: 'Cahernacreevy (Mayo)', zip: '532728' },
	{ city: 'Cahernacrin (Cork)', zip: '588979' },
	{ city: 'Cahernaduv (Kerry)', zip: '416314' },
	{ city: 'Cahernagarry (Galway)', zip: '783210' },
	{ city: 'Cahernageeha (Kerry)', zip: '887771' },
	{ city: 'Cahernagh (Cork)', zip: '119100' },
	{ city: 'Cahernagh (Limerick)', zip: '760702' },
	{ city: 'Cahernagh East (Cork)', zip: '610362' },
	{ city: 'Cahernaglass (Galway)', zip: '824585' },
	{ city: 'Cahernagollum (Mayo)', zip: '967217' },
	{ city: 'Cahernagormuck (Galway)', zip: '716161' },
	{ city: 'Cahernagry (Galway)', zip: '364550' },
	{ city: 'Cahernagry East (Mayo)', zip: '698895' },
	{ city: 'Cahernagry West (Mayo)', zip: '200134' },
	{ city: 'Cahernahallia (Tipperary)', zip: '560188' },
	{ city: 'Cahernaheeny (Galway)', zip: '785584' },
	{ city: 'Cahernahoon (Galway)', zip: '827931' },
	{ city: 'Cahernaleague (Waterford)', zip: '740197' },
	{ city: 'Cahernalee (Galway)', zip: '824477' },
	{ city: 'Cahernalinsky (Galway)', zip: '130604' },
	{ city: 'Cahernalough (Clare)', zip: '544160' },
	{ city: 'Cahernamallaght (Mayo)', zip: '117213' },
	{ city: 'Cahernaman (Galway)', zip: '801719' },
	{ city: 'Cahernaman (Kerry)', zip: '869420' },
	{ city: 'Cahernamart (Mayo)', zip: '669060' },
	{ city: 'Cahernamona (Clare)', zip: '203982' },
	{ city: 'Cahernamona (Galway)', zip: '245932' },
	{ city: 'Cahernamuck East (Galway)', zip: '460701' },
	{ city: 'Cahernamuck West (Galway)', zip: '561006' },
	{ city: 'Cahernane (Kerry)', zip: '997346' },
	{ city: 'Cahernarry (Limerick)', zip: '165087' },
	{ city: 'Cahernashilleeny (Galway)', zip: '511999' },
	{ city: 'Cahernead (Kerry)', zip: '132138' },
	{ city: 'Cahernichole East (Mayo)', zip: '262855' },
	{ city: 'Cahernichole West (Mayo)', zip: '829888' },
	{ city: 'Caherogan (Clare)', zip: '746628' },
	{ city: 'Caherogullane (Cork)', zip: '656771' },
	{ city: 'Caherolickane (Cork)', zip: '856875' },
	{ city: 'Caheronaun (Galway)', zip: '273721' },
	{ city: 'Caherpeak East (Galway)', zip: '255073' },
	{ city: 'Caherpeak West (Galway)', zip: '378441' },
	{ city: 'Caherphuca (Galway)', zip: '676714' },
	{ city: 'Caherpierce (Kerry)', zip: '712891' },
	{ city: 'Caherquin (Kerry)', zip: '834096' },
	{ city: 'Caherrevagh And Cloonnameeltoge (Mayo)', zip: '559151' },
	{ city: 'Caherrobert (Mayo)', zip: '170180' },
	{ city: 'Caherroyn (Galway)', zip: '427237' },
	{ city: 'Caherrush (Clare)', zip: '599078' },
	{ city: 'Cahersavane (Kerry)', zip: '153922' },
	{ city: 'Caherscooby (Clare)', zip: '529644' },
	{ city: 'Caherscullibeen (Kerry)', zip: '611910' },
	{ city: 'Cahershaughnessy (Clare)', zip: '466352' },
	{ city: 'Cahersherkin (Clare)', zip: '738282' },
	{ city: 'Cahersiveen (Kerry)', zip: '511624' },
	{ city: 'Caherskeehaun (Galway)', zip: '955463' },
	{ city: 'Caherslee (Kerry)', zip: '445335' },
	{ city: 'Caherteige (Clare)', zip: '134518' },
	{ city: 'Cahertinny (Galway)', zip: '920414' },
	{ city: 'Caheruane (Waterford)', zip: '944919' },
	{ city: 'Caherulla (Kerry)', zip: '119168' },
	{ city: 'Caherultan (Cork)', zip: '912925' },
	{ city: 'Caherurlagh (Cork)', zip: '806743' },
	{ city: 'Caherurlagh Mountain North (Cork)', zip: '790610' },
	{ city: 'Caherurlagh Mountain South (Cork)', zip: '119804' },
	{ city: 'Cahervally (Limerick)', zip: '291432' },
	{ city: 'Cahervillahowe (Tipperary)', zip: '982856' },
	{ city: 'Caherwalter (Galway)', zip: '218656' },
	{ city: 'Caherweelder (Galway)', zip: '812424' },
	{ city: 'Caherweesheen (Kerry)', zip: '696848' },
	{ city: 'Caher West (Kerry)', zip: '881072' },
	{ city: 'Caherwiclaun (Mayo)', zip: '572723' },
	{ city: 'Caherycahill (Clare)', zip: '750654' },
	{ city: 'Caherycoosaun (Clare)', zip: '567408' },
	{ city: 'Cahiracon (Clare)', zip: '909297' },
	{ city: 'Cahircalla Beg (Clare)', zip: '891380' },
	{ city: 'Cahircalla More (Clare)', zip: '827788' },
	{ city: 'Cahirduff (Limerick)', zip: '541899' },
	{ city: 'Cahirguillamore (Limerick)', zip: '418169' },
	{ city: 'Cahore (Wexford)', zip: '934987' },
	{ city: 'Cahore Point (Wexford)', zip: '776528' },
	{ city: 'Caim (Wexford)', zip: '566525' },
	{ city: 'Cain (Wexford)', zip: '107341' },
	{ city: 'Cakestown Glebe (Meath)', zip: '783064' },
	{ city: 'Calary Lower (Wicklow)', zip: '425353' },
	{ city: 'Calary Upper (Wicklow)', zip: '823086' },
	{ city: 'Caldavnet (Monaghan)', zip: '683822' },
	{ city: 'Caldragh (Cavan)', zip: '529536' },
	{ city: 'Caldragh (Leitrim)', zip: '794968' },
	{ city: 'Caldragh (Longford)', zip: '130109' },
	{ city: 'Caldragh (Mayo)', zip: '186049' },
	{ city: 'Caldragh (Roscommon)', zip: '457861' },
	{ city: 'Caldraghmore (Longford)', zip: '517709' },
	{ city: 'Caldrymoran (Roscommon)', zip: '172712' },
	{ city: 'Calehane (Cork)', zip: '248590' },
	{ city: 'Calf Field (Kildare)', zip: '425480' },
	{ city: 'Calf Island (Donegal)', zip: '557619' },
	{ city: 'Calf Island East (Cork)', zip: '531726' },
	{ city: 'Calf Island Middle (Cork)', zip: '241040' },
	{ city: 'Calf Island West (Cork)', zip: '448377' },
	{ city: 'Calfpark (Longford)', zip: '532245' },
	{ city: 'Calfstown (Kildare)', zip: '710290' },
	{ city: 'Calga (Louth)', zip: '463667' },
	{ city: 'Calgath (Meath)', zip: '167370' },
	{ city: 'Calhame (Donegal)', zip: '489755' },
	{ city: 'Calla (Mayo)', zip: '169687' },
	{ city: 'Callacoon (Mayo)', zip: '542479' },
	{ city: 'Callaghane (Waterford)', zip: '930536' },
	{ city: 'Callaghs (Cavan)', zip: '940219' },
	{ city: 'Callahaniska (Kerry)', zip: '242064' },
	{ city: 'Callahow (Limerick)', zip: '626281' },
	{ city: 'Callahy (Clare)', zip: '860073' },
	{ city: 'Callan (Donegal)', zip: '760253' },
	{ city: 'Callan (Kilkenny)', zip: '130841' },
	{ city: 'Callanacor (Donegal)', zip: '283524' },
	{ city: 'Callanafersy East (Kerry)', zip: '500551' },
	{ city: 'Callanafersy West (Kerry)', zip: '214528' },
	{ city: 'Callanagh Lower (Cavan)', zip: '924956' },
	{ city: 'Callanagh Middle (Cavan)', zip: '943463' },
	{ city: 'Callanagh Upper (Cavan)', zip: '954997' },
	{ city: 'Callancruck (Galway)', zip: '388131' },
	{ city: 'Callan North (Kilkenny)', zip: '287742' },
	{ city: 'Callan South (Kilkenny)', zip: '259535' },
	{ city: 'Callaros Eighter (Cork)', zip: '952510' },
	{ city: 'Callaros Oughter (Cork)', zip: '651413' },
	{ city: 'Callas (Cork)', zip: '795059' },
	{ city: 'Callatra (Galway)', zip: '406604' },
	{ city: 'Callatrim (Cork)', zip: '623380' },
	{ city: 'Calliagh (Monaghan)', zip: '400947' },
	{ city: 'Calliaghadoo (Mayo)', zip: '503208' },
	{ city: 'Calliaghstown (Dublin)', zip: '714523' },
	{ city: 'Calliaghstown (Meath)', zip: '646794' },
	{ city: 'Calliaghstown (Westmeath)', zip: '228265' },
	{ city: 'Calliaghstown Lower (Dublin)', zip: '320683' },
	{ city: 'Calliaghstown Upper (Dublin)', zip: '542751' },
	{ city: 'Calliaghwee (Meath)', zip: '653185' },
	{ city: 'Calloughs (Leitrim)', zip: '177249' },
	{ city: 'Callow (Galway)', zip: '387420' },
	{ city: 'Callow (Limerick)', zip: '913184' },
	{ city: 'Callow (Mayo)', zip: '665834' },
	{ city: 'Callow (Roscommon)', zip: '122937' },
	{ city: 'Callowbeg (Roscommon)', zip: '772519' },
	{ city: 'Callow Beg (Galway)', zip: '388330' },
	{ city: 'Callowbrack (Mayo)', zip: '379526' },
	{ city: 'Callowfinish (Galway)', zip: '869460' },
	{ city: 'Callowhill (Leitrim)', zip: '494437' },
	{ city: 'Callowhill (Monaghan)', zip: '343228' },
	{ city: 'Callowhill Lower (Wicklow)', zip: '452984' },
	{ city: 'Callowhill Upper (Wicklow)', zip: '819074' },
	{ city: 'Callow More (Galway)', zip: '676928' },
	{ city: 'Callownamuck (Galway)', zip: '140901' },
	{ city: 'Calluragh (Clare)', zip: '958430' },
	{ city: 'Calluragh East (Clare)', zip: '144639' },
	{ city: 'Calluragh South (Clare)', zip: '881346' },
	{ city: 'Calluragh West (Clare)', zip: '768865' },
	{ city: 'Callystown (Louth)', zip: '780515' },
	{ city: 'Calry (Sligo)', zip: '240554' },
	{ city: 'Calteraun (Sligo)', zip: '925715' },
	{ city: 'Caltra (Galway)', zip: '572045' },
	{ city: 'Caltragh (Galway)', zip: '740081' },
	{ city: 'Caltragh (Mayo)', zip: '198111' },
	{ city: 'Caltragh (Roscommon)', zip: '568298' },
	{ city: 'Caltragh (Sligo)', zip: '379569' },
	{ city: 'Caltraghbeg (Roscommon)', zip: '230423' },
	{ city: 'Caltragh Beg (Longford)', zip: '210741' },
	{ city: 'Caltraghbreedy (Galway)', zip: '240448' },
	{ city: 'Caltraghcreen (Galway)', zip: '214545' },
	{ city: 'Caltraghduff (Galway)', zip: '289327' },
	{ city: 'Caltraghlea (Galway)', zip: '739713' },
	{ city: 'Caltragh More (Longford)', zip: '142648' },
	{ city: 'Caltrapallas (Galway)', zip: '463481' },
	{ city: 'Calveagh Lower (Roscommon)', zip: '647401' },
	{ city: 'Calveagh Upper (Roscommon)', zip: '626542' },
	{ city: 'Calverstown (Kildare)', zip: '864760' },
	{ city: 'Calverstown (Westmeath)', zip: '627806' },
	{ city: 'Calverstown Demesne (Kildare)', zip: '405486' },
	{ city: 'Calverstown Little (Kildare)', zip: '170767' },
	{ city: 'Cam (Longford)', zip: '711830' },
	{ city: 'Cam (Roscommon)', zip: '305505' },
	{ city: 'Camagh (Cavan)', zip: '509791' },
	{ city: 'Camagh (Leitrim)', zip: '763990' },
	{ city: 'Camagh (Longford)', zip: '763337' },
	{ city: 'Camagh (Westmeath)', zip: '856411' },
	{ city: 'Camaghy (Monaghan)', zip: '276580' },
	{ city: 'Camalier (Cavan)', zip: '493289' },
	{ city: 'Camalt (Leitrim)', zip: '760779' },
	{ city: 'Camara (Wicklow)', zip: '996545' },
	{ city: 'Camarahill North (Wicklow)', zip: '905056' },
	{ city: 'Camarahill South (Wicklow)', zip: '830136' },
	{ city: 'Camaross (Wexford)', zip: '320626' },
	{ city: 'Camas (Limerick)', zip: '195224' },
	{ city: 'Camas North (Limerick)', zip: '911471' },
	{ city: 'Camas South (Limerick)', zip: '332361' },
	{ city: 'Camblestown (Donegal)', zip: '821298' },
	{ city: 'Cambrickville (Louth)', zip: '416056' },
	{ city: 'Camcloon (Laois)', zip: '713558' },
	{ city: 'Camcloon (Roscommon)', zip: '367634' },
	{ city: 'Camcloon Beg (Mayo)', zip: '544608' },
	{ city: 'Camcloon More (Mayo)', zip: '128818' },
	{ city: 'Camcuill (Sligo)', zip: '588785' },
	{ city: 'Camderry (Galway)', zip: '637012' },
	{ city: 'Camderry (Leitrim)', zip: '172306' },
	{ city: 'Camderrynabinnia (Mayo)', zip: '854559' },
	{ city: 'Camea (Tipperary)', zip: '635656' },
	{ city: 'Camenabologue (Wicklow)', zip: '267882' },
	{ city: 'Cameron (Tipperary)', zip: '754186' },
	{ city: 'Cametringane (Cork)', zip: '454003' },
	{ city: 'Camheen (Limerick)', zip: '234237' },
	{ city: 'Caminches (Cork)', zip: '213744' },
	{ city: 'Camira Glebe (Laois)', zip: '718178' },
	{ city: 'Camla (Monaghan)', zip: '794351' },
	{ city: 'Camlagh (Roscommon)', zip: '347620' },
	{ city: 'Camlin (Donegal)', zip: '670538' },
	{ city: 'Camlin (Roscommon)', zip: '459193' },
	{ city: 'Camlin (Tipperary)', zip: '271671' },
	{ city: 'Camlin (Wexford)', zip: '240435' },
	{ city: 'Camlisk Beg (Longford)', zip: '274193' },
	{ city: 'Camlisk More (Longford)', zip: '745237' },
	{ city: 'Cammanagh (Galway)', zip: '328839' },
	{ city: 'Cammoge (Clare)', zip: '227537' },
	{ city: 'Cammoge (Roscommon)', zip: '168693' },
	{ city: 'Camolin (Wexford)', zip: '426212' },
	{ city: 'Camolin Park (Wexford)', zip: '294205' },
	{ city: 'Camp (Donegal)', zip: '989705' },
	{ city: 'Camp (Kerry)', zip: '335696' },
	{ city: 'Camp East (Kerry)', zip: '183170' },
	{ city: 'Camphill (Cork)', zip: '183167' },
	{ city: 'Camphill (Laois)', zip: '480092' },
	{ city: 'Camphire (Waterford)', zip: '425896' },
	{ city: 'Camphirehill (Waterford)', zip: '606600' },
	{ city: 'Campile (Wexford)', zip: '957425' },
	{ city: 'Campstown (Cavan)', zip: '710294' },
	{ city: 'Camross (Laois)', zip: '825144' },
	{ city: 'Camross (Sligo)', zip: '574081' },
	{ city: 'Cams (Roscommon)', zip: '760509' },
	{ city: 'Cams (Sligo)', zip: '864469' },
	{ city: 'Camteige (Wexford)', zip: '964649' },
	{ city: 'Camus (Cork)', zip: '108952' },
	{ city: 'Camus (Donegal)', zip: '370097' },
	{ city: 'Camus (Galway)', zip: '754164' },
	{ city: 'Camus (Offaly)', zip: '867760' },
	{ city: 'Camus (Tipperary)', zip: '756469' },
	{ city: 'Camus Eighter (Galway)', zip: '820240' },
	{ city: 'Camus Oughter (Galway)', zip: '699256' },
	{ city: 'Canagullen (Kerry)', zip: '905554' },
	{ city: 'Canal And Banks (Westmeath)', zip: '659312' },
	{ city: 'Canalmore (Cork)', zip: '794567' },
	{ city: 'Canalough (Cork)', zip: '634917' },
	{ city: 'Canbeg (Leitrim)', zip: '788977' },
	{ city: 'Canbo (Roscommon)', zip: '338722' },
	{ city: 'Canbrack (Mayo)', zip: '181956' },
	{ city: 'Canburrin (Kerry)', zip: '928903' },
	{ city: 'Candlefield (Roscommon)', zip: '845459' },
	{ city: 'Candlefort (Monaghan)', zip: '282391' },
	{ city: 'Candroma (Cork)', zip: '118141' },
	{ city: 'Canearagh (Kerry)', zip: '497160' },
	{ city: 'Canfee (Kerry)', zip: '793154' },
	{ city: 'Cangarrow (Galway)', zip: '137363' },
	{ city: 'Cangort Demesne (Offaly)', zip: '429401' },
	{ city: 'Cangort Park (Offaly)', zip: '965775' },
	{ city: 'Cangullia (Kerry)', zip: '341166' },
	{ city: 'Cangy (Louth)', zip: '710843' },
	{ city: 'Cankeel (Leitrim)', zip: '458681' },
	{ city: 'Cankilly (Galway)', zip: '932121' },
	{ city: 'Canknoogheda (Kerry)', zip: '356373' },
	{ city: 'Cannaboe (Leitrim)', zip: '894213' },
	{ city: 'Cannafahy (Kilkenny)', zip: '843117' },
	{ city: 'Cannaghanally (Sligo)', zip: '275032' },
	{ city: 'Cannakill (Offaly)', zip: '639350' },
	{ city: 'Cannaver Island (Galway)', zip: '390325' },
	{ city: 'Cannawee (Cork)', zip: '463708' },
	{ city: 'Canningstown (Cavan)', zip: '982593' },
	{ city: 'Cannonsfield (Westmeath)', zip: '775661' },
	{ city: 'Cannonsquarter (Carlow)', zip: '180259' },
	{ city: 'Cannonstown (Kildare)', zip: '236406' },
	{ city: 'Cannonstown (Meath)', zip: '974421' },
	{ city: 'Cannonswood (Laois)', zip: '726431' },
	{ city: 'Cannorstown (Westmeath)', zip: '796854' },
	{ city: 'Cannow (Wicklow)', zip: '895273' },
	{ city: 'Cannow Mountain (Wicklow)', zip: '691073' },
	{ city: 'Canon Island (Clare)', zip: '319192' },
	{ city: 'Canonstown (Louth)', zip: '661770' },
	{ city: 'Canower (Galway)', zip: '580350' },
	{ city: 'Canrawer East (Galway)', zip: '830049' },
	{ city: 'Canrawer West (Galway)', zip: '647202' },
	{ city: 'Canrooska (Cork)', zip: '635228' },
	{ city: 'Canshanavoe (Cork)', zip: '383481' },
	{ city: 'Cant (Clare)', zip: '311674' },
	{ city: 'Canteeny (Galway)', zip: '180420' },
	{ city: 'Cantogher (Limerick)', zip: '103518' },
	{ city: 'Cantra (Kerry)', zip: '559491' },
	{ city: 'Canty (Waterford)', zip: '406822' },
	{ city: 'Canuig (Kerry)', zip: '699686' },
	{ city: 'Canvarstown (Kilkenny)', zip: '184067' },
	{ city: 'Capard (Laois)', zip: '375524' },
	{ city: 'Capdoo (Kildare)', zip: '653123' },
	{ city: 'Capdoo Commons (Kildare)', zip: '573076' },
	{ city: 'Capira (Galway)', zip: '534695' },
	{ city: 'Caplahard (Westmeath)', zip: '973626' },
	{ city: 'Caplevane (Offaly)', zip: '394762' },
	{ city: 'Capnagower (Mayo)', zip: '287266' },
	{ city: 'Cappa (Kerry)', zip: '104742' },
	{ city: 'Cappa (Tipperary)', zip: '106401' },
	{ city: 'Cappabeg (Laois)', zip: '713370' },
	{ city: 'Cappaboggan (Meath)', zip: '274967' },
	{ city: 'Cappaboy Beg (Cork)', zip: '154693' },
	{ city: 'Cappaboy More (Cork)', zip: '973614' },
	{ city: 'Cappacannaun (Clare)', zip: '889559' },
	{ city: 'Cappacasheen (Galway)', zip: '206294' },
	{ city: 'Cappacharnaun (Mayo)', zip: '659050' },
	{ city: 'Cappaclogh (Tipperary)', zip: '688750' },
	{ city: 'Cappaclogh East (Kerry)', zip: '609648' },
	{ city: 'Cappaclogh West (Kerry)', zip: '163788' },
	{ city: 'Cappacorcoge (Galway)', zip: '915871' },
	{ city: 'Cappacuilla (Galway)', zip: '538580' },
	{ city: 'Cappacur (Galway)', zip: '767964' },
	{ city: 'Cappacurry (Mayo)', zip: '976026' },
	{ city: 'Cappadavock (Galway)', zip: '727574' },
	{ city: 'Cappadine (Tipperary)', zip: '881984' },
	{ city: 'Cappadineen (Cork)', zip: '757037' },
	{ city: 'Cappadrummin (Tipperary)', zip: '670550' },
	{ city: 'Cappaduff (Clare)', zip: '306675' },
	{ city: 'Cappaduff (Westmeath)', zip: '254949' },
	{ city: 'Cappafaulish (Kilkenny)', zip: '887208' },
	{ city: 'Cappafeean (Clare)', zip: '698469' },
	{ city: 'Cappaganneen (Kerry)', zip: '254944' },
	{ city: 'Cappagarraun (Clare)', zip: '953298' },
	{ city: 'Cappagarriff (Galway)', zip: '384862' },
	{ city: 'Cappagh (Carlow)', zip: '158622' },
	{ city: 'Cappagh (Cavan)', zip: '183493' },
	{ city: 'Cappagh (Clare)', zip: '495736' },
	{ city: 'Cappagh (Cork)', zip: '983693' },
	{ city: 'Cappagh (Donegal)', zip: '634537' },
	{ city: 'Cappagh (Dublin)', zip: '121378' },
	{ city: 'Cappagh (Galway)', zip: '666945' },
	{ city: 'Cappagh (Kerry)', zip: '586883' },
	{ city: 'Cappagh (Kildare)', zip: '353656' },
	{ city: 'Cappagh (Kilkenny)', zip: '209774' },
	{ city: 'Cappagh (Laois)', zip: '954716' },
	{ city: 'Cappagh (Leitrim)', zip: '702124' },
	{ city: 'Cappagh (Limerick)', zip: '586270' },
	{ city: 'Cappagh (Mayo)', zip: '756305' },
	{ city: 'Cappagh (Monaghan)', zip: '777021' },
	{ city: 'Cappagh (Offaly)', zip: '855881' },
	{ city: 'Cappagh (Roscommon)', zip: '576706' },
	{ city: 'Cappagh (Sligo)', zip: '614613' },
	{ city: 'Cappagh (Tipperary)', zip: '628047' },
	{ city: 'Cappagh (Waterford)', zip: '683589' },
	{ city: 'Cappagh (Westmeath)', zip: '751082' },
	{ city: 'Cappagh (Wicklow)', zip: '119397' },
	{ city: 'Cappagha (Clare)', zip: '551778' },
	{ city: 'Cappaghabaun Mountain (Clare)', zip: '539566' },
	{ city: 'Cappaghabaunpark (Clare)', zip: '467218' },
	{ city: 'Cappaghauneen (Westmeath)', zip: '774250' },
	{ city: 'Cappaghavuckee (Cork)', zip: '158616' },
	{ city: 'Cappagh Beg (Clare)', zip: '796160' },
	{ city: 'Cappagh Beg (Cork)', zip: '450465' },
	{ city: 'Cappagh Beg (Galway)', zip: '546362' },
	{ city: 'Cappaghbrack (Westmeath)', zip: '479236' },
	{ city: 'Cappaghcastle (Clare)', zip: '488402' },
	{ city: 'Cappaghcon (Galway)', zip: '344673' },
	{ city: 'Cappaghconbeg (Galway)', zip: '393140' },
	{ city: 'Cappaghcon East (Galway)', zip: '124109' },
	{ city: 'Cappaghcon West (Galway)', zip: '152613' },
	{ city: 'Cappaghcreen (Meath)', zip: '936810' },
	{ city: 'Cappaghduff East (Mayo)', zip: '257345' },
	{ city: 'Cappaghduff West (Mayo)', zip: '556600' },
	{ city: 'Cappagh East (Cork)', zip: '815914' },
	{ city: 'Cappaghglass (Cork)', zip: '617052' },
	{ city: 'Cappaghjuan (Westmeath)', zip: '186623' },
	{ city: 'Cappaghkennedy (Clare)', zip: '532059' },
	{ city: 'Cappaghlodge (Clare)', zip: '172008' },
	{ city: 'Cappaghmore (Cork)', zip: '576682' },
	{ city: 'Cappaghmore (Tipperary)', zip: '241352' },
	{ city: 'Cappagh More (Clare)', zip: '939706' },
	{ city: 'Cappagh More (Galway)', zip: '579569' },
	{ city: 'Cappaghmoyle (Galway)', zip: '566603' },
	{ city: 'Cappaghnacallee (Cork)', zip: '432934' },
	{ city: 'Cappaghnagapple (Galway)', zip: '345398' },
	{ city: 'Cappaghnagarrane (Tipperary)', zip: '808008' },
	{ city: 'Cappaghnanool (Galway)', zip: '740342' },
	{ city: 'Cappagh North (Clare)', zip: '996989' },
	{ city: 'Cappagh North (Galway)', zip: '693766' },
	{ city: 'Cappagh North (Laois)', zip: '371662' },
	{ city: 'Cappagh North (Mayo)', zip: '320246' },
	{ city: 'Cappaghoosh (Galway)', zip: '812088' },
	{ city: 'Cappaghrattin (Tipperary)', zip: '198151' },
	{ city: 'Cappagh South (Clare)', zip: '832535' },
	{ city: 'Cappagh South (Galway)', zip: '757894' },
	{ city: 'Cappagh South (Laois)', zip: '760389' },
	{ city: 'Cappagh South (Mayo)', zip: '783735' },
	{ city: 'Cappagh West (Cork)', zip: '548523' },
	{ city: 'Cappagh White (Tipperary)', zip: '198551' },
	{ city: 'Cappagowlan (Offaly)', zip: '976885' },
	{ city: 'Cappahard (Clare)', zip: '177141' },
	{ city: 'Cappahayden (Kilkenny)', zip: '666099' },
	{ city: 'Cappahenry (Kilkenny)', zip: '526938' },
	{ city: 'Cappahenry East (Kilkenny)', zip: '719190' },
	{ city: 'Cappakea (Clare)', zip: '642303' },
	{ city: 'Cappakeel (Laois)', zip: '216341' },
	{ city: 'Cappakeela (Galway)', zip: '392562' },
	{ city: 'Cappakilleen (Tipperary)', zip: '849234' },
	{ city: 'Cappaknockane (Cork)', zip: '280536' },
	{ city: 'Cappalahan (Tipperary)', zip: '783682' },
	{ city: 'Cappalaheen (Clare)', zip: '221136' },
	{ city: 'Cappalahy (Westmeath)', zip: '631676' },
	{ city: 'Cappalane (Laois)', zip: '488086' },
	{ city: 'Cappalauna (Kilkenny)', zip: '704541' },
	{ city: 'Cappalea (Clare)', zip: '289013' },
	{ city: 'Cappalea North (Clare)', zip: '694108' },
	{ city: 'Cappalea South (Clare)', zip: '353191' },
	{ city: 'Cappaleigh North (Cork)', zip: '154050' },
	{ city: 'Cappaleigh South (Cork)', zip: '126132' },
	{ city: 'Cappaleitrim (Roscommon)', zip: '409394' },
	{ city: 'Cappalinnan (Laois)', zip: '808873' },
	{ city: 'Cappalisheen (Roscommon)', zip: '387847' },
	{ city: 'Cappalough (Laois)', zip: '735706' },
	{ city: 'Cappaloughan (Offaly)', zip: '251821' },
	{ city: 'Cappaluane (Galway)', zip: '264389' },
	{ city: 'Cappalug (Laois)', zip: '710052' },
	{ city: 'Cappamore (Clare)', zip: '379475' },
	{ city: 'Cappamore (Kerry)', zip: '936007' },
	{ city: 'Cappamore (Limerick)', zip: '678302' },
	{ city: 'Cappamurragh (Tipperary)', zip: '755293' },
	{ city: 'Cappanaboe (Laois)', zip: '590907' },
	{ city: 'Cappanabohy (Cork)', zip: '520497' },
	{ city: 'Cappanabornia (Galway)', zip: '759743' },
	{ city: 'Cappanaboul (Cork)', zip: '206901' },
	{ city: 'Cappanabrick (Cork)', zip: '527472' },
	{ city: 'Cappanacleare (Laois)', zip: '962142' },
	{ city: 'Cappanacloghy (Laois)', zip: '531072' },
	{ city: 'Cappanacreha (Mayo)', zip: '913652' },
	{ city: 'Cappanacush East (Kerry)', zip: '230713' },
	{ city: 'Cappanacush West (Kerry)', zip: '222145' },
	{ city: 'Cappanafaraha (Limerick)', zip: '661500' },
	{ city: 'Cappanafeacle (Laois)', zip: '490229' },
	{ city: 'Cappanageeragh (Clare)', zip: '585877' },
	{ city: 'Cappanageeragh (Offaly)', zip: '138072' },
	{ city: 'Cappanaghtan (Galway)', zip: '882328' },
	{ city: 'Cappanaglogh (Mayo)', zip: '151854' },
	{ city: 'Cappanagoul (Cork)', zip: '198083' },
	{ city: 'Cappanagraigue (Laois)', zip: '971329' },
	{ city: 'Cappanagraun (Cork)', zip: '121325' },
	{ city: 'Cappanagroun (Kerry)', zip: '987879' },
	{ city: 'Cappanahanagh (Limerick)', zip: '701392' },
	{ city: 'Cappanakeady (Tipperary)', zip: '264494' },
	{ city: 'Cappanakilla (Clare)', zip: '162784' },
	{ city: 'Cappanalaght (Clare)', zip: '984288' },
	{ city: 'Cappanalaurabaun (Galway)', zip: '936248' },
	{ city: 'Cappanaleigh (Tipperary)', zip: '598288' },
	{ city: 'Cappanaloha East (Cork)', zip: '342131' },
	{ city: 'Cappanaloha West (Cork)', zip: '564632' },
	{ city: 'Cappanalosset (Offaly)', zip: '678359' },
	{ city: 'Cappanaminna (Cork)', zip: '832277' },
	{ city: 'Cappanamorath (Offaly)', zip: '521161' },
	{ city: 'Cappanamrogue (Laois)', zip: '437232' },
	{ city: 'Cappanamuck (Tipperary)', zip: '476462' },
	{ city: 'Cappananee (Kerry)', zip: '800919' },
	{ city: 'Cappananty (Limerick)', zip: '941486' },
	{ city: 'Cappanaparka East (Cork)', zip: '596339' },
	{ city: 'Cappanaparka West (Cork)', zip: '220895' },
	{ city: 'Cappanapeasta (Clare)', zip: '737979' },
	{ city: 'Cappanapisha North (Galway)', zip: '452285' },
	{ city: 'Cappanapisha South (Galway)', zip: '447452' },
	{ city: 'Cappanargid (Kildare)', zip: '605972' },
	{ city: 'Cappanarrow (Laois)', zip: '273151' },
	{ city: 'Cappanashannagh (Laois)', zip: '694543' },
	{ city: 'Cappanaslish (Clare)', zip: '144909' },
	{ city: 'Cappanasmear (Tipperary)', zip: '300189' },
	{ city: 'Cappanasruhaun (Galway)', zip: '378224' },
	{ city: 'Cappanavar (Cork)', zip: '172551' },
	{ city: 'Cappanavarnoge (Clare)', zip: '784877' },
	{ city: 'Cappanavilla (Tipperary)', zip: '340825' },
	{ city: 'Cappanclare (Cork)', zip: '672948' },
	{ city: 'Cappancur (Offaly)', zip: '538561' },
	{ city: 'Cappaneary (Laois)', zip: '951448' },
	{ city: 'Cappanihane (Limerick)', zip: '428770' },
	{ city: 'Cappanilly (Tipperary)', zip: '175297' },
	{ city: 'Cappankelly (Westmeath)', zip: '586497' },
	{ city: 'Cappanlivane (Kerry)', zip: '503441' },
	{ city: 'Cappanlug (Laois)', zip: '620635' },
	{ city: 'Cappanouk (Limerick)', zip: '811358' },
	{ city: 'Cappanraheen (Galway)', zip: '791177' },
	{ city: 'Cappanrush (Laois)', zip: '773343' },
	{ city: 'Cappanrush (Westmeath)', zip: '834270' },
	{ city: 'Cappantack (Westmeath)', zip: '785362' },
	{ city: 'Cappanthlarig (Kerry)', zip: '782429' },
	{ city: 'Cappantogher (Roscommon)', zip: '341232' },
	{ city: 'Cappantruhaun (Clare)', zip: '780182' },
	{ city: 'Cappantruhaun (Galway)', zip: '600666' },
	{ city: 'Cappaphaudeen (Cork)', zip: '255854' },
	{ city: 'Capparanny (Mayo)', zip: '935687' },
	{ city: 'Cappard Demesne (Galway)', zip: '608614' },
	{ city: 'Capparoe (Clare)', zip: '278587' },
	{ city: 'Capparoe (Kerry)', zip: '461270' },
	{ city: 'Capparoe (Limerick)', zip: '977341' },
	{ city: 'Capparoe (Tipperary)', zip: '718014' },
	{ city: 'Capparogan (Laois)', zip: '937319' },
	{ city: 'Cappasallagh (Galway)', zip: '848853' },
	{ city: 'Cappass (Kilkenny)', zip: '129799' },
	{ city: 'Cappataggle (Galway)', zip: '517663' },
	{ city: 'Cappateemore East (Clare)', zip: '300630' },
	{ city: 'Cappateemore West (Clare)', zip: '461003' },
	{ city: 'Cappateige (Kerry)', zip: '742205' },
	{ city: 'Cappauniac (Tipperary)', zip: '827761' },
	{ city: 'Cappavarna (Galway)', zip: '226848' },
	{ city: 'Cappaveha (Galway)', zip: '264041' },
	{ city: 'Cappavicar North (Mayo)', zip: '909312' },
	{ city: 'Cappavicar South (Mayo)', zip: '222947' },
	{ city: 'Cappavilla North (Clare)', zip: '831745' },
	{ city: 'Cappavilla South (Clare)', zip: '477325' },
	{ city: 'Cappawater (Carlow)', zip: '177898' },
	{ city: 'Cappawee (Kerry)', zip: '794850' },
	{ city: 'Cappayuse (Roscommon)', zip: '148768' },
	{ city: 'Cappeen (Cork)', zip: '131807' },
	{ city: 'Cappeen East (Cork)', zip: '735152' },
	{ city: 'Cappeen West (Cork)', zip: '727543' },
	{ city: 'Cappercullen (Limerick)', zip: '733027' },
	{ city: 'Cappocksgreen (Louth)', zip: '213508' },
	{ city: 'Cappog (Cavan)', zip: '283146' },
	{ city: 'Cappog (Monaghan)', zip: '755031' },
	{ city: 'Cappoge (Dublin)', zip: '718415' },
	{ city: 'Cappoge (Louth)', zip: '652654' },
	{ city: 'Cappoge (Tipperary)', zip: '290565' },
	{ city: 'Cappoley (Laois)', zip: '862783' },
	{ city: 'Capponellan (Laois)', zip: '954226' },
	{ city: 'Cappoquin (Waterford)', zip: '386640' },
	{ city: 'Cappoquin Demesne (Waterford)', zip: '553545' },
	{ city: 'Cappry (Donegal)', zip: '198530' },
	{ city: 'Cappulcorragh (Mayo)', zip: '328597' },
	{ city: 'Cappusteen (Laois)', zip: '817324' },
	{ city: 'Cappyantanvally (Kerry)', zip: '187385' },
	{ city: 'Cappyaughna (Cork)', zip: '201637' },
	{ city: 'Cappydonnell Big (Offaly)', zip: '100105' },
	{ city: 'Cappydonnell Little (Offaly)', zip: '299292' },
	{ city: 'Cappyroe (Offaly)', zip: '442161' },
	{ city: 'Capragh (Cavan)', zip: '645113' },
	{ city: 'Capragh (Monaghan)', zip: '127535' },
	{ city: 'Capranny (Meath)', zip: '576672' },
	{ city: 'Caran (Roscommon)', zip: '587799' },
	{ city: 'Caranavoodaun (Galway)', zip: '821185' },
	{ city: 'Caran Bog (Roscommon)', zip: '189668' },
	{ city: 'Caranlea (Roscommon)', zip: '159420' },
	{ city: 'Caraun (Galway)', zip: '196717' },
	{ city: 'Caraun (Mayo)', zip: '274150' },
	{ city: 'Caraun Beg (Galway)', zip: '160678' },
	{ city: 'Caraunduff (Galway)', zip: '366087' },
	{ city: 'Caraunkeelwy (Galway)', zip: '852818' },
	{ city: 'Caraun More (Galway)', zip: '458028' },
	{ city: 'Carbad Beg (Mayo)', zip: '982253' },
	{ city: 'Carbad More (Mayo)', zip: '804896' },
	{ city: 'Carberrystown (Meath)', zip: '708554' },
	{ city: 'Carbury (Kildare)', zip: '340713' },
	{ city: 'Cardiffsbridge (Dublin)', zip: '636225' },
	{ city: 'Cardington (Kildare)', zip: '598850' },
	{ city: 'Cardington Demesne (Kildare)', zip: '737320' },
	{ city: 'Cardistown (Louth)', zip: '477465' },
	{ city: 'Cardrath (Meath)', zip: '738934' },
	{ city: 'Cardtown (Laois)', zip: '494908' },
	{ city: 'Carew (Tipperary)', zip: '336741' },
	{ city: 'Carewswood (Cork)', zip: '647045' },
	{ city: 'Careysville (Cork)', zip: '789334' },
	{ city: 'Cargagh (Cavan)', zip: '437875' },
	{ city: 'Cargaghbane (Monaghan)', zip: '362003' },
	{ city: 'Cargaghdoo (Monaghan)', zip: '441548' },
	{ city: 'Cargaghlisnanarney (Monaghan)', zip: '861022' },
	{ city: 'Cargaghmore (Monaghan)', zip: '388988' },
	{ city: 'Cargaghoge (Monaghan)', zip: '673402' },
	{ city: 'Cargaghramer (Monaghan)', zip: '219005' },
	{ city: 'Cargin (Galway)', zip: '749991' },
	{ city: 'Cargin Demesne (Roscommon)', zip: '537619' },
	{ city: 'Carha (Cavan)', zip: '502930' },
	{ city: 'Carha (Mayo)', zip: '967324' },
	{ city: 'Carha (Sligo)', zip: '301512' },
	{ city: 'Carhan Lower (Kerry)', zip: '955371' },
	{ city: 'Carhan Upper (Kerry)', zip: '857580' },
	{ city: 'Carheen (Clare)', zip: '812199' },
	{ city: 'Carheen (Galway)', zip: '149564' },
	{ city: 'Carheen (Mayo)', zip: '109490' },
	{ city: 'Carheenadiveane (Galway)', zip: '299730' },
	{ city: 'Carheenard (Galway)', zip: '565255' },
	{ city: 'Carheenbrack (Mayo)', zip: '344397' },
	{ city: 'Carheendoo (Galway)', zip: '509942' },
	{ city: 'Carheenlea (Galway)', zip: '306200' },
	{ city: 'Carheennascovoge (Galway)', zip: '588166' },
	{ city: 'Carheens (Galway)', zip: '917699' },
	{ city: 'Carheens (Mayo)', zip: '979573' },
	{ city: 'Carheenshowagh (Galway)', zip: '460776' },
	{ city: 'Carheeny (Galway)', zip: '601640' },
	{ city: 'Carheeny (Limerick)', zip: '889322' },
	{ city: 'Carheenybaun (Galway)', zip: '953248' },
	{ city: 'Carheeny Beg (Galway)', zip: '137557' },
	{ city: 'Carheeny More (Galway)', zip: '643299' },
	{ city: 'Carhoo (Clare)', zip: '173150' },
	{ city: 'Carhoo (Cork)', zip: '844338' },
	{ city: 'Carhoobeg (Kerry)', zip: '112882' },
	{ city: 'Carhooearagh (Kerry)', zip: '866225' },
	{ city: 'Carhoo East (Kerry)', zip: '927113' },
	{ city: 'Carhoogarriff (Cork)', zip: '619068' },
	{ city: 'Carhookeal (Cork)', zip: '667117' },
	{ city: 'Carhoo Lower (Cork)', zip: '337342' },
	{ city: 'Carhoomeengar East (Kerry)', zip: '324631' },
	{ city: 'Carhoomeengar West (Kerry)', zip: '908365' },
	{ city: 'Carhoon (Galway)', zip: '652003' },
	{ city: 'Carhoona (Cork)', zip: '294065' },
	{ city: 'Carhoona (Kerry)', zip: '530412' },
	{ city: 'Carhoonahone (Kerry)', zip: '166903' },
	{ city: 'Carhoonakilla (Kerry)', zip: '404782' },
	{ city: 'Carhoonakineely (Kerry)', zip: '826392' },
	{ city: 'Carhoonaknock East (Kerry)', zip: '978514' },
	{ city: 'Carhoonaknock West (Kerry)', zip: '848985' },
	{ city: 'Carhoonaphuca (Kerry)', zip: '417566' },
	{ city: 'Carhoon East (Cork)', zip: '515786' },
	{ city: 'Carhoonoe (Kerry)', zip: '377105' },
	{ city: 'Carhoo North (Cork)', zip: '912712' },
	{ city: 'Carhoon West (Cork)', zip: '975297' },
	{ city: 'Carhoo South (Cork)', zip: '472631' },
	{ city: 'Carhoo Upper (Cork)', zip: '482095' },
	{ city: 'Carhoovauler (Cork)', zip: '569992' },
	{ city: 'Carhoo West (Kerry)', zip: '467566' },
	{ city: 'Carhue (Cork)', zip: '332949' },
	{ city: 'Cark (Donegal)', zip: '169778' },
	{ city: 'Carker (Cork)', zip: '164598' },
	{ city: 'Carker (Kerry)', zip: '146048' },
	{ city: 'Carkerbeg (Cork)', zip: '242524' },
	{ city: 'Carker Middle (Cork)', zip: '530138' },
	{ city: 'Carker North (Cork)', zip: '548690' },
	{ city: 'Carkfree (Roscommon)', zip: '685836' },
	{ city: 'Carks (Kerry)', zip: '738668' },
	{ city: 'Carlan Lower (Donegal)', zip: '839051' },
	{ city: 'Carlanstown (Meath)', zip: '564979' },
	{ city: 'Carlanstown (Westmeath)', zip: '424866' },
	{ city: 'Carlan Upper (Donegal)', zip: '989472' },
	{ city: 'Carlingford (Louth)', zip: '291541' },
	{ city: 'Carlislefort (Cork)', zip: '597442' },
	{ city: 'Carlow (Carlow)', zip: '434601' },
	{ city: 'Carmanhall (Dublin)', zip: '566067' },
	{ city: 'Carmanhall And Leopardstown (Dublin)', zip: '174242' },
	{ city: 'Carmoney (Donegal)', zip: '386700' },
	{ city: 'Carn (Cavan)', zip: '165816' },
	{ city: 'Carn (Donegal)', zip: '491020' },
	{ city: 'Carn (Galway)', zip: '466686' },
	{ city: 'Carn (Kildare)', zip: '237812' },
	{ city: 'Carn (Laois)', zip: '749878' },
	{ city: 'Carn (Longford)', zip: '202452' },
	{ city: 'Carn (Mayo)', zip: '312591' },
	{ city: 'Carn (Monaghan)', zip: '738561' },
	{ city: 'Carn (Westmeath)', zip: '959141' },
	{ city: 'Carna (Galway)', zip: '619658' },
	{ city: 'Carna (Wexford)', zip: '362289' },
	{ city: 'Carnacally (Meath)', zip: '388980' },
	{ city: 'Carnacop (Meath)', zip: '573398' },
	{ city: 'Carnafeagh (Donegal)', zip: '363722' },
	{ city: 'Carnagarve (Cavan)', zip: '110195' },
	{ city: 'Carnagarve (Donegal)', zip: '168901' },
	{ city: 'Carnagh (Wexford)', zip: '799305' },
	{ city: 'Carnaghan (Donegal)', zip: '855575' },
	{ city: 'Carnagh East (Roscommon)', zip: '449969' },
	{ city: 'Carnagh Lower (Cavan)', zip: '678097' },
	{ city: 'Carnagh Upper (Cavan)', zip: '778037' },
	{ city: 'Carnagh West (Roscommon)', zip: '532900' },
	{ city: 'Carnagore (Donegal)', zip: '958722' },
	{ city: 'Carnakelly (Galway)', zip: '537338' },
	{ city: 'Carnakelly North (Galway)', zip: '651917' },
	{ city: 'Carnakelly South (Galway)', zip: '998244' },
	{ city: 'Carnakit (Roscommon)', zip: '396273' },
	{ city: 'Carnalughoge (Louth)', zip: '705701' },
	{ city: 'Carnalway (Kildare)', zip: '955914' },
	{ city: 'Carnalynch (Cavan)', zip: '280071' },
	{ city: 'Carnamogagh Lower (Donegal)', zip: '566214' },
	{ city: 'Carnamogagh Upper (Donegal)', zip: '941179' },
	{ city: 'Carnamoyle (Donegal)', zip: '267468' },
	{ city: 'Carnan (Longford)', zip: '478219' },
	{ city: 'Carnanbregagh (Louth)', zip: '368561' },
	{ city: 'Carnane (Limerick)', zip: '447048' },
	{ city: 'Carnans Lower (Cavan)', zip: '988942' },
	{ city: 'Carnans Upper (Cavan)', zip: '914563' },
	{ city: 'Carnanthomas (Galway)', zip: '277441' },
	{ city: 'Carnaross (Meath)', zip: '655477' },
	{ city: 'Carnashannagh (Donegal)', zip: '298485' },
	{ city: 'Carnatreantagh (Donegal)', zip: '980513' },
	{ city: 'Carnaun (Clare)', zip: '859000' },
	{ city: 'Carnaun (Galway)', zip: '387710' },
	{ city: 'Carnaveagh (Monaghan)', zip: '130626' },
	{ city: 'Carnaweeleen (Sligo)', zip: '952724' },
	{ city: 'Carnbane (Meath)', zip: '995202' },
	{ city: 'Carnbane (Monaghan)', zip: '244985' },
	{ city: 'Carnbeagh North (Donegal)', zip: '297470' },
	{ city: 'Carnbeagh South (Donegal)', zip: '133922' },
	{ city: 'Carn Beg (Louth)', zip: '646778' },
	{ city: 'Carn Beg (Mayo)', zip: '870296' },
	{ city: 'Carn Beg Glebe (Donegal)', zip: '712100' },
	{ city: 'Carnboy (Donegal)', zip: '856040' },
	{ city: 'Carncash (Sligo)', zip: '176551' },
	{ city: 'Carnclogh (Mayo)', zip: '242982' },
	{ city: 'Carncreagh (Clare)', zip: '269970' },
	{ city: 'Carndoagh (Donegal)', zip: '881923' },
	{ city: 'Carndonagh (Donegal)', zip: '708713' },
	{ city: 'Carnelrussel (Meath)', zip: '395781' },
	{ city: 'Carnes East (Meath)', zip: '304013' },
	{ city: 'Carnes West (Meath)', zip: '745165' },
	{ city: 'Carnew (Wicklow)', zip: '561389' },
	{ city: 'Carney (Sligo)', zip: '210289' },
	{ city: 'Carneybeg (Tipperary)', zip: '883303' },
	{ city: 'Carneybrack (Tipperary)', zip: '428162' },
	{ city: 'Carneycastle (Tipperary)', zip: '137997' },
	{ city: "Carney's Island (Monaghan)", zip: '212255' },
	{ city: 'Carneywoodlands (Tipperary)', zip: '150046' },
	{ city: 'Carnfyan (Westmeath)', zip: '255759' },
	{ city: 'Carngarrow (Donegal)', zip: '979115' },
	{ city: 'Carnglass (Waterford)', zip: '804464' },
	{ city: 'Carn High (Donegal)', zip: '358833' },
	{ city: 'Carnhill (Donegal)', zip: '699349' },
	{ city: 'Carnhill (Dublin)', zip: '412979' },
	{ city: 'Carnhill (Mayo)', zip: '221784' },
	{ city: 'Carnin (Cavan)', zip: '423592' },
	{ city: 'Carnisk (Donegal)', zip: '795113' },
	{ city: 'Carn Low (Donegal)', zip: '236765' },
	{ city: 'Carnmaclean (Cavan)', zip: '805454' },
	{ city: 'Carnmallow (Clare)', zip: '823911' },
	{ city: 'Carnmore (Galway)', zip: '717996' },
	{ city: 'Carn More (Louth)', zip: '158831' },
	{ city: 'Carn More (Mayo)', zip: '164723' },
	{ city: 'Carnmore East (Galway)', zip: '696086' },
	{ city: 'Carn More Glebe (Donegal)', zip: '417347' },
	{ city: 'Carnmore West (Galway)', zip: '142434' },
	{ city: 'Carnoge (Cavan)', zip: '227456' },
	{ city: 'Carnowen (Donegal)', zip: '563306' },
	{ city: 'Carnowen (Monaghan)', zip: '967009' },
	{ city: 'Carnpark (Westmeath)', zip: '606304' },
	{ city: 'Carnquill (Monaghan)', zip: '965814' },
	{ city: 'Carnroe (Louth)', zip: '862421' },
	{ city: 'Carnroe (Monaghan)', zip: '372863' },
	{ city: 'Carns (Roscommon)', zip: '754178' },
	{ city: 'Carns (Sligo)', zip: '202341' },
	{ city: 'Carnshannagh (Donegal)', zip: '694854' },
	{ city: 'Carntown (Louth)', zip: '283429' },
	{ city: 'Carntressy (Donegal)', zip: '634145' },
	{ city: 'Carntullagh (Donegal)', zip: '312466' },
	{ city: 'Carntullagh (Leitrim)', zip: '247311' },
	{ city: 'Carnyara (Sligo)', zip: '410108' },
	{ city: 'Carnybrogan (Westmeath)', zip: '693762' },
	{ city: 'Carolina (Cavan)', zip: '488070' },
	{ city: 'Carolina (Monaghan)', zip: '957937' },
	{ city: 'Carpenterstown (Dublin)', zip: '201574' },
	{ city: 'Carpenterstown (Westmeath)', zip: '217250' },
	{ city: 'Carra (Galway)', zip: '106385' },
	{ city: 'Carracastle (Mayo)', zip: '719260' },
	{ city: 'Carrachor (Monaghan)', zip: '850501' },
	{ city: 'Carracloghan (Louth)', zip: '834159' },
	{ city: 'Carradoan (Donegal)', zip: '978493' },
	{ city: 'Carradooan (Roscommon)', zip: '845302' },
	{ city: 'Carraduffy (Donegal)', zip: '573370' },
	{ city: 'Carragaun (Tipperary)', zip: '132345' },
	{ city: 'Carragh (Galway)', zip: '816163' },
	{ city: 'Carragh (Kildare)', zip: '941806' },
	{ city: 'Carragh (Longford)', zip: '285731' },
	{ city: 'Carraghadoo (Galway)', zip: '410496' },
	{ city: 'Carraghs East (Roscommon)', zip: '753167' },
	{ city: 'Carraghs West (Roscommon)', zip: '167014' },
	{ city: 'Carraghy (Galway)', zip: '176824' },
	{ city: 'Carragraigue (Cork)', zip: '889321' },
	{ city: 'Carrahan (Clare)', zip: '534194' },
	{ city: 'Carrahane Lower (Kerry)', zip: '705816' },
	{ city: 'Carrahane Upper (Kerry)', zip: '738607' },
	{ city: 'Carrahil (Clare)', zip: '334106' },
	{ city: 'Carraholly (Mayo)', zip: '933282' },
	{ city: 'Carra Island (Galway)', zip: '413027' },
	{ city: 'Carrakeel (Donegal)', zip: '856551' },
	{ city: 'Carrakeelty Beg (Cavan)', zip: '579449' },
	{ city: 'Carrakeelty More (Cavan)', zip: '774849' },
	{ city: 'Carraleena (Donegal)', zip: '684368' },
	{ city: 'Carramoreen (Cavan)', zip: '904742' },
	{ city: 'Carran (Clare)', zip: '575006' },
	{ city: 'Carran (Cork)', zip: '585778' },
	{ city: 'Carran (Kerry)', zip: '534335' },
	{ city: 'Carran (Kilkenny)', zip: '249983' },
	{ city: 'Carranadore (Donegal)', zip: '737589' },
	{ city: 'Carranduff (Sligo)', zip: '595029' },
	{ city: 'Carranroe (Wexford)', zip: '386205' },
	{ city: 'Carranroe Lower (Kilkenny)', zip: '882049' },
	{ city: 'Carranroe Upper (Kilkenny)', zip: '508175' },
	{ city: 'Carranstown (Meath)', zip: '562365' },
	{ city: 'Carranstown Great (Meath)', zip: '736272' },
	{ city: 'Carranstown Little (Meath)', zip: '319125' },
	{ city: 'Carran Upper And Lower (Donegal)', zip: '102072' },
	{ city: 'Carrarea (Carlow)', zip: '828656' },
	{ city: 'Carraroe (Galway)', zip: '584241' },
	{ city: 'Carraun (Leitrim)', zip: '254035' },
	{ city: 'Carraun (Sligo)', zip: '903155' },
	{ city: 'Carraunrevagh (Galway)', zip: '870646' },
	{ city: 'Carravilleen (Cork)', zip: '609232' },
	{ city: 'Carrawaystick (Wicklow)', zip: '984172' },
	{ city: 'Carrhill (Wexford)', zip: '681525' },
	{ city: 'Carrick (Cavan)', zip: '176851' },
	{ city: 'Carrick (Donegal)', zip: '714386' },
	{ city: 'Carrick (Kildare)', zip: '812574' },
	{ city: 'Carrick (Leitrim)', zip: '242936' },
	{ city: 'Carrick (Mayo)', zip: '733032' },
	{ city: 'Carrick (Meath)', zip: '923652' },
	{ city: 'Carrick (Offaly)', zip: '848822' },
	{ city: 'Carrick (Roscommon)', zip: '158260' },
	{ city: 'Carrick (Tipperary)', zip: '876656' },
	{ city: 'Carrick (Westmeath)', zip: '782148' },
	{ city: 'Carrick (Wexford)', zip: '365225' },
	{ city: 'Carrick (Wicklow)', zip: '989348' },
	{ city: 'Carrickabane (Cavan)', zip: '404703' },
	{ city: 'Carrickaboy (Cavan)', zip: '286334' },
	{ city: 'Carrickaboy Glebe (Cavan)', zip: '658845' },
	{ city: 'Carrickabraghy (Donegal)', zip: '623864' },
	{ city: 'Carrickacat (Mayo)', zip: '360037' },
	{ city: 'Carrickacreagh (Louth)', zip: '415664' },
	{ city: 'Carrickacroghery (Leitrim)', zip: '483517' },
	{ city: 'Carrickacroman (Cavan)', zip: '793490' },
	{ city: 'Carrickacroy (Cavan)', zip: '563496' },
	{ city: 'Carrickadawson (Donegal)', zip: '505838' },
	{ city: 'Carrickaderry (Monaghan)', zip: '300040' },
	{ city: 'Carrickadooan (Louth)', zip: '808747' },
	{ city: 'Carrickadooey (Monaghan)', zip: '483024' },
	{ city: 'Carrickadorrish (Longford)', zip: '637837' },
	{ city: 'Carrickadraan (Roscommon)', zip: '993092' },
	{ city: 'Carrickadustara (Waterford)', zip: '864769' },
	{ city: 'Carrickafodan (Donegal)', zip: '581282' },
	{ city: 'Carrickagarvan (Monaghan)', zip: '302256' },
	{ city: 'Carrickahilla (Waterford)', zip: '201853' },
	{ city: 'Carrickaholan (Donegal)', zip: '191528' },
	{ city: 'Carrickakillew (Cavan)', zip: '189575' },
	{ city: 'Carrickalangan (Donegal)', zip: '325537' },
	{ city: 'Carrickaldragh (Monaghan)', zip: '483576' },
	{ city: 'Carrickallan (Louth)', zip: '402337' },
	{ city: 'Carrickallen (Cavan)', zip: '863722' },
	{ city: 'Carrickalust (Louth)', zip: '741792' },
	{ city: 'Carrickalwy (Cavan)', zip: '289102' },
	{ city: 'Carrickanass (Mayo)', zip: '428733' },
	{ city: 'Carrickane (Cavan)', zip: '688927' },
	{ city: 'Carrickaneady (Mayo)', zip: '501211' },
	{ city: 'Carrickaneagh (Tipperary)', zip: '592605' },
	{ city: 'Carrickanearla (Kildare)', zip: '387425' },
	{ city: 'Carrickanee (Donegal)', zip: '435252' },
	{ city: 'Carrickaneena (Louth)', zip: '527575' },
	{ city: 'Carrickaneha (Westmeath)', zip: '931879' },
	{ city: 'Carrickanoran (Kilkenny)', zip: '404943' },
	{ city: 'Carrickanoran (Monaghan)', zip: '427465' },
	{ city: 'Carrickanure (Monaghan)', zip: '335291' },
	{ city: 'Carrickanure (Waterford)', zip: '225696' },
	{ city: 'Carrickanurroo (Leitrim)', zip: '315489' },
	{ city: 'Carrickaport (Leitrim)', zip: '271952' },
	{ city: 'Carrickard (Sligo)', zip: '662483' },
	{ city: 'Carrickarea (Waterford)', zip: '215802' },
	{ city: 'Carrickaready (Waterford)', zip: '881756' },
	{ city: 'Carrickart (Donegal)', zip: '491682' },
	{ city: 'Carrickartagh (Monaghan)', zip: '504966' },
	{ city: 'Carrickashedoge (Monaghan)', zip: '181545' },
	{ city: 'Carrickaslane (Monaghan)', zip: '312775' },
	{ city: 'Carrickaslin (Galway)', zip: '540342' },
	{ city: 'Carrickaslin Rock (Galway)', zip: '624366' },
	{ city: 'Carrickastuck (Louth)', zip: '294663' },
	{ city: 'Carrickataggart (Donegal)', zip: '329941' },
	{ city: 'Carrickateane (Cavan)', zip: '347011' },
	{ city: 'Carrickateane (Leitrim)', zip: '793634' },
	{ city: 'Carrickateane (Longford)', zip: '860077' },
	{ city: 'Carrickatee (Monaghan)', zip: '252338' },
	{ city: 'Carrickatimpan (Donegal)', zip: '752960' },
	{ city: 'Carrickatlieve Glebe (Donegal)', zip: '845181' },
	{ city: 'Carrickatober (Cavan)', zip: '135942' },
	{ city: 'Carrickavallan (Louth)', zip: '842888' },
	{ city: 'Carrickavarahane (Waterford)', zip: '405990' },
	{ city: 'Carrickavee (Cavan)', zip: '551494' },
	{ city: 'Carrickaveilty (Monaghan)', zip: '104011' },
	{ city: 'Carrickaveril (Leitrim)', zip: '996394' },
	{ city: 'Carrickavoher (Leitrim)', zip: '642541' },
	{ city: 'Carrickavoley (Monaghan)', zip: '407118' },
	{ city: 'Carrickavrantry (Waterford)', zip: '504929' },
	{ city: 'Carrickavrantry North (Waterford)', zip: '816037' },
	{ city: 'Carrickavrantry South (Waterford)', zip: '804031' },
	{ city: 'Carrickawilt (Mayo)', zip: '563504' },
	{ city: 'Carrickbaggot (Louth)', zip: '411841' },
	{ city: 'Carrickballydooey (Donegal)', zip: '135174' },
	{ city: 'Carrickballydooey Glebe (Donegal)', zip: '593029' },
	{ city: 'Carrickbanagher (Sligo)', zip: '239765' },
	{ city: 'Carrickbarrahane (Waterford)', zip: '401759' },
	{ city: 'Carrickbarrett (Mayo)', zip: '952756' },
	{ city: 'Carrickbaun (Leitrim)', zip: '914537' },
	{ city: 'Carrickbeg (Longford)', zip: '654300' },
	{ city: 'Carrickbeg (Roscommon)', zip: '148094' },
	{ city: 'Carrickbeg (Tipperary)', zip: '894856' },
	{ city: 'Carrickbeg (Waterford)', zip: '850533' },
	{ city: 'Carrickboy (Donegal)', zip: '213997' },
	{ city: 'Carrickboy (Longford)', zip: '638712' },
	{ city: 'Carrickbrack (Donegal)', zip: '600921' },
	{ city: 'Carrickbrannan (Cavan)', zip: '754368' },
	{ city: 'Carrickbreeny (Donegal)', zip: '751566' },
	{ city: 'Carrickcarnan (Louth)', zip: '734304' },
	{ city: 'Carrickclevan (Cavan)', zip: '606704' },
	{ city: 'Carrickcloney (Kilkenny)', zip: '207320' },
	{ city: 'Carrickconeen (Tipperary)', zip: '919239' },
	{ city: 'Carrickcoola (Sligo)', zip: '611847' },
	{ city: 'Carrickcreeny (Cavan)', zip: '734333' },
	{ city: 'Carrickdexter (Meath)', zip: '123243' },
	{ city: 'Carrickduff (Carlow)', zip: '666979' },
	{ city: 'Carrickduff (Longford)', zip: '937439' },
	{ city: 'Carrick East (Cavan)', zip: '366413' },
	{ city: 'Carrick East (Donegal)', zip: '684004' },
	{ city: 'Carrick East (Galway)', zip: '185256' },
	{ city: 'Carrickedmond (Longford)', zip: '434163' },
	{ city: 'Carrickedmond (Louth)', zip: '832800' },
	{ city: 'Carrickeeny (Leitrim)', zip: '267481' },
	{ city: 'Carrickeeshil (Cavan)', zip: '614044' },
	{ city: 'Carrickevy (Leitrim)', zip: '573603' },
	{ city: 'Carrickfad (Leitrim)', zip: '830216' },
	{ city: 'Carrickfin (Donegal)', zip: '211110' },
	{ city: 'Carrickfin (Westmeath)', zip: '175845' },
	{ city: 'Carrickglass (Sligo)', zip: '476381' },
	{ city: 'Carrickglass Demesne (Longford)', zip: '870560' },
	{ city: 'Carrickgooan (Leitrim)', zip: '269999' },
	{ city: 'Carrickgorman (Cavan)', zip: '617369' },
	{ city: 'Carrickhawna (Sligo)', zip: '836403' },
	{ city: 'Carrickhenry (Sligo)', zip: '114755' },
	{ city: 'Carrickhill (Dublin)', zip: '588402' },
	{ city: 'Carrick Hill (Mayo)', zip: '765059' },
	{ city: 'Carrickilla (Roscommon)', zip: '868490' },
	{ city: 'Carrickinare (Monaghan)', zip: '314387' },
	{ city: 'Carrickinnane (Kilkenny)', zip: '894468' },
	{ city: 'Carrickirragh (Donegal)', zip: '546333' },
	{ city: 'Carrickittle (Limerick)', zip: '186842' },
	{ city: 'Carrickkildavnet (Mayo)', zip: '992644' },
	{ city: 'Carricklane (Monaghan)', zip: '967025' },
	{ city: 'Carricklawn (Wexford)', zip: '350493' },
	{ city: 'Carrickleagh (Galway)', zip: '296442' },
	{ city: 'Carrickleagh (Louth)', zip: '137233' },
	{ city: 'Carrickleck (Meath)', zip: '418531' },
	{ city: 'Carrickleitrim (Leitrim)', zip: '159419' },
	{ city: 'Carricklom (Roscommon)', zip: '939186' },
	{ city: 'Carrickloughmore (Tipperary)', zip: '979744' },
	{ city: 'Carrick Lower (Donegal)', zip: '517064' },
	{ city: 'Carrickmacantire (Mayo)', zip: '982099' },
	{ city: 'Carrickmaclim (Monaghan)', zip: '362053' },
	{ city: 'Carrickmacross (Monaghan)', zip: '912365' },
	{ city: 'Carrickmagrath (Donegal)', zip: '270744' },
	{ city: 'Carrickmaguirk (Longford)', zip: '980409' },
	{ city: 'Carrickmahon (Donegal)', zip: '279062' },
	{ city: 'Carrickmakeegan (Leitrim)', zip: '303385' },
	{ city: 'Carrickmaquigley (Donegal)', zip: '506091' },
	{ city: 'Carrickmerlin (Kilkenny)', zip: '280248' },
	{ city: 'Carrick Middle (Galway)', zip: '773920' },
	{ city: 'Carrickmines (Dublin)', zip: '631001' },
	{ city: 'Carrickmines Great (Dublin)', zip: '200183' },
	{ city: 'Carrickmines Little (Dublin)', zip: '773389' },
	{ city: 'Carrickmoran (Longford)', zip: '983050' },
	{ city: 'Carrickmore (Cavan)', zip: '846120' },
	{ city: 'Carrickmore (Donegal)', zip: '872110' },
	{ city: 'Carrickmore (Monaghan)', zip: '709689' },
	{ city: 'Carrickmore (Roscommon)', zip: '945740' },
	{ city: 'Carrickmourne (Kilkenny)', zip: '956482' },
	{ city: 'Carrickmoylenacurhoga (Mayo)', zip: '578581' },
	{ city: 'Carrickmoyragh (Longford)', zip: '690344' },
	{ city: 'Carrickmullan (Louth)', zip: '753261' },
	{ city: 'Carrickmurray (Leitrim)', zip: '183437' },
	{ city: 'Carricknabrack (Leitrim)', zip: '938493' },
	{ city: 'Carricknabrick (Cavan)', zip: '209490' },
	{ city: 'Carricknabrone (Waterford)', zip: '927652' },
	{ city: 'Carricknagat (Roscommon)', zip: '186045' },
	{ city: 'Carricknagat (Sligo)', zip: '322436' },
	{ city: 'Carricknagoan (Monaghan)', zip: '127623' },
	{ city: 'Carricknagore (Donegal)', zip: '597918' },
	{ city: 'Carricknagower (Westmeath)', zip: '340129' },
	{ city: 'Carricknagrip (Sligo)', zip: '540901' },
	{ city: 'Carricknagrow (Cavan)', zip: '506364' },
	{ city: 'Carricknahorna (Donegal)', zip: '194431' },
	{ city: 'Carricknahorna East (Sligo)', zip: '936838' },
	{ city: 'Carricknahorna West (Sligo)', zip: '890001' },
	{ city: 'Carricknamaddoo (Cavan)', zip: '912183' },
	{ city: 'Carricknamanna (Donegal)', zip: '728726' },
	{ city: 'Carricknamart (Donegal)', zip: '838325' },
	{ city: 'Carricknamoghil (Donegal)', zip: '524591' },
	{ city: 'Carricknaronty (Mayo)', zip: '579790' },
	{ city: 'Carricknaronty North (Mayo)', zip: '215007' },
	{ city: 'Carricknaronty Rocks (Mayo)', zip: '706483' },
	{ city: 'Carricknashanagh (Louth)', zip: '560986' },
	{ city: 'Carricknashane (Donegal)', zip: '718493' },
	{ city: 'Carricknashee (Roscommon)', zip: '552555' },
	{ city: 'Carricknashoke (Cavan)', zip: '925198' },
	{ city: 'Carricknaslate (Donegal)', zip: '722833' },
	{ city: 'Carricknasrugh (Galway)', zip: '559618' },
	{ city: 'Carricknaveagh (Cavan)', zip: '649742' },
	{ city: 'Carricknaveddan (Cavan)', zip: '170506' },
	{ city: 'Carrickobreen (Westmeath)', zip: '499256' },
	{ city: 'Carrickoghil (Leitrim)', zip: '281580' },
	{ city: 'Carrickoneilleen (Sligo)', zip: '520657' },
	{ city: 'Carrick-On-Shannon (Leitrim)', zip: '498110' },
	{ city: 'Carrick-On-Suir (Tipperary)', zip: '613453' },
	{ city: 'Carrickphilip (Waterford)', zip: '199180' },
	{ city: 'Carrickrathmullin (Sligo)', zip: '894498' },
	{ city: 'Carrickrevagh (Leitrim)', zip: '383997' },
	{ city: 'Carrickrobin (Louth)', zip: '167227' },
	{ city: 'Carrickroe (Monaghan)', zip: '554621' },
	{ city: 'Carrickrory (Donegal)', zip: '933626' },
	{ city: 'Carricksaggart (Waterford)', zip: '672190' },
	{ city: 'Carricksalia (Mayo)', zip: '282165' },
	{ city: 'Carricksallagh (Laois)', zip: '526765' },
	{ city: 'Carrickshandrum (Donegal)', zip: '796284' },
	{ city: 'Carrickshock Commons (Kilkenny)', zip: '823048' },
	{ city: 'Carrickslaney (Carlow)', zip: '481243' },
	{ city: 'Carrickslavan (Leitrim)', zip: '708782' },
	{ city: 'Carrickspringan (Meath)', zip: '616933' },
	{ city: 'Carrick Upper (Donegal)', zip: '143039' },
	{ city: 'Carrick Upper And Lower Barr (Donegal)', zip: '156969' },
	{ city: 'Carrick West (Cavan)', zip: '566811' },
	{ city: 'Carrick West (Donegal)', zip: '325660' },
	{ city: 'Carrick West (Galway)', zip: '269445' },
	{ city: 'Carrickybressil (Donegal)', zip: '216382' },
	{ city: 'Carrickykelly (Monaghan)', zip: '948947' },
	{ city: 'Carrickynaghtan (Roscommon)', zip: '244752' },
	{ city: 'Carrickynaghtan And Garrynagawna Bog (Roscommon)', zip: '573994' },
	{ city: 'Carrickyscanlan (Donegal)', zip: '176744' },
	{ city: 'Carriff Island (Donegal)', zip: '800220' },
	{ city: 'Carrig (Cork)', zip: '471528' },
	{ city: 'Carrig (Kerry)', zip: '229321' },
	{ city: 'Carrig (Tipperary)', zip: '910519' },
	{ city: 'Carrig (Wexford)', zip: '939308' },
	{ city: 'Carrig (Wicklow)', zip: '565733' },
	{ city: 'Carrigabrick (Cork)', zip: '782427' },
	{ city: 'Carrigabruse (Cavan)', zip: '119964' },
	{ city: 'Carrigabruse (Wexford)', zip: '736207' },
	{ city: 'Carrigacat And Milleen (Cork)', zip: '984719' },
	{ city: 'Carrigacooleen (Cork)', zip: '522683' },
	{ city: 'Carrigacrump (Cork)', zip: '891250' },
	{ city: 'Carrigacunna (Cork)', zip: '261169' },
	{ city: 'Carrigacurra (Wicklow)', zip: '580980' },
	{ city: 'Carrigacurriheen (Cork)', zip: '329597' },
	{ city: 'Carrigadaggan (Wexford)', zip: '214562' },
	{ city: 'Carrigadav (Kerry)', zip: '934122' },
	{ city: 'Carrigadrohid (Cork)', zip: '549633' },
	{ city: 'Carrigafoyle (Kerry)', zip: '597920' },
	{ city: 'Carrigafreaghane (Kerry)', zip: '313225' },
	{ city: 'Carrigafroca (Cork)', zip: '971948' },
	{ city: 'Carrigagh (Meath)', zip: '364967' },
	{ city: 'Carrigagh (Westmeath)', zip: '695016' },
	{ city: 'Carrigagour (Cork)', zip: '751202' },
	{ city: 'Carrigagown North (Tipperary)', zip: '257024' },
	{ city: 'Carrigagown South (Tipperary)', zip: '681069' },
	{ city: 'Carrigagrenane (Cork)', zip: '979569' },
	{ city: 'Carrigagulla (Cork)', zip: '371487' },
	{ city: 'Carrigaha (Kerry)', zip: '251546' },
	{ city: 'Carrigaholt (Clare)', zip: '552279' },
	{ city: 'Carrigahorig (Tipperary)', zip: '611927' },
	{ city: 'Carrigaline (Cork)', zip: '644831' },
	{ city: 'Carrigaline East (Cork)', zip: '534267' },
	{ city: 'Carrigaline Middle (Cork)', zip: '870647' },
	{ city: 'Carrigaline West (Cork)', zip: '196740' },
	{ city: 'Carrigallen (Leitrim)', zip: '964628' },
	{ city: 'Carrigaloe (Tipperary)', zip: '569246' },
	{ city: 'Carrigan (Cavan)', zip: '624516' },
	{ city: 'Carriganagh (Tipperary)', zip: '985146' },
	{ city: 'Carriganass (Cork)', zip: '109796' },
	{ city: 'Carriganattin (Limerick)', zip: '439786' },
	{ city: 'Carrigan Beg (Roscommon)', zip: '414819' },
	{ city: 'Carrigane (Cork)', zip: '118113' },
	{ city: 'Carrigane (Kerry)', zip: '527545' },
	{ city: 'Carrigane (Waterford)', zip: '211012' },
	{ city: 'Carriganeagh (Wexford)', zip: '232804' },
	{ city: 'Carriganes (Cork)', zip: '872147' },
	{ city: 'Carriganimmy (Cork)', zip: '495887' },
	{ city: 'Carriganine (Cork)', zip: '637264' },
	{ city: 'Carriganish (Cork)', zip: '956511' },
	{ city: 'Carriganleigh (Cork)', zip: '599333' },
	{ city: 'Carrigan More (Roscommon)', zip: '361038' },
	{ city: 'Carriganookery (Cork)', zip: '592733' },
	{ city: 'Carriganroe (Tipperary)', zip: '113245' },
	{ city: 'Carrigans (Donegal)', zip: '211557' },
	{ city: 'Carrigans (Monaghan)', zip: '383645' },
	{ city: 'Carrigans Lower (Sligo)', zip: '379140' },
	{ city: 'Carrigans Park (Roscommon)', zip: '748658' },
	{ city: 'Carrigans Upper (Sligo)', zip: '810126' },
	{ city: 'Carriganurra (Kilkenny)', zip: '992881' },
	{ city: 'Carrigaphooca (Cork)', zip: '976738' },
	{ city: 'Carrigarostig (Cork)', zip: '626596' },
	{ city: 'Carrigarreely (Limerick)', zip: '578393' },
	{ city: 'Carrigasimon (Cavan)', zip: '607552' },
	{ city: 'Carrigataha (Tipperary)', zip: '206157' },
	{ city: 'Carrigatheme (Wicklow)', zip: '835198' },
	{ city: 'Carrigathou (Cork)', zip: '824051' },
	{ city: 'Carrigatna (Kilkenny)', zip: '484838' },
	{ city: 'Carrigatogher (Cork)', zip: '651930' },
	{ city: 'Carrigatogher (Tipperary)', zip: '779580' },
	{ city: 'Carrigatogher Bog (Tipperary)', zip: '737430' },
	{ city: 'Carrigatoortane (Cork)', zip: '881452' },
	{ city: 'Carrigaun (Waterford)', zip: '983610' },
	{ city: 'Carrigaunroe (Cork)', zip: '231633' },
	{ city: 'Carrigaveema (Kerry)', zip: '896243' },
	{ city: 'Carrigavisteal (Tipperary)', zip: '616578' },
	{ city: 'Carrigavulleen (Cork)', zip: '681716' },
	{ city: 'Carrigawannia (Kerry)', zip: '936829' },
	{ city: 'Carrigawillin (Tipperary)', zip: '202862' },
	{ city: 'Carrigbaun (Cork)', zip: '252347' },
	{ city: 'Carrigbeg (Wexford)', zip: '820791' },
	{ city: 'Carrig Beg (Carlow)', zip: '474806' },
	{ city: 'Carrig Beg (Limerick)', zip: '724862' },
	{ city: 'Carrigboy (Cork)', zip: '345046' },
	{ city: 'Carrigbrack (Waterford)', zip: '325333' },
	{ city: 'Carrigbrean (Kerry)', zip: '852963' },
	{ city: 'Carrigcam (Kerry)', zip: '690746' },
	{ city: 'Carrigcannon (Cork)', zip: '818094' },
	{ city: 'Carrigcannon (Kerry)', zip: '690116' },
	{ city: 'Carrigcastle (Cork)', zip: '180418' },
	{ city: 'Carrigcastle (Waterford)', zip: '719539' },
	{ city: 'Carrigcleena Beg (Cork)', zip: '615370' },
	{ city: 'Carrigcleena More (Cork)', zip: '859308' },
	{ city: 'Carrigdangan (Cork)', zip: '797743' },
	{ city: 'Carrigdarrery (Cork)', zip: '706233' },
	{ city: 'Carrig Demesne (Cork)', zip: '324318' },
	{ city: 'Carrigdownane Lower (Cork)', zip: '540151' },
	{ city: 'Carrigdownane Upper (Cork)', zip: '625844' },
	{ city: 'Carrigduff (Cork)', zip: '541001' },
	{ city: 'Carrigduff (Kerry)', zip: '959087' },
	{ city: 'Carrig East (Kerry)', zip: '378874' },
	{ city: 'Carrig East (Limerick)', zip: '266486' },
	{ city: 'Carrigee (Mayo)', zip: '223295' },
	{ city: 'Carrigeen (Cork)', zip: '240117' },
	{ city: 'Carrigeen (Dublin)', zip: '841417' },
	{ city: 'Carrigeen (Kerry)', zip: '945147' },
	{ city: 'Carrigeen (Kildare)', zip: '509821' },
	{ city: 'Carrigeen (Kilkenny)', zip: '169785' },
	{ city: 'Carrigeen (Laois)', zip: '107202' },
	{ city: 'Carrigeen (Leitrim)', zip: '867701' },
	{ city: 'Carrigeen (Limerick)', zip: '241586' },
	{ city: 'Carrigeen (Longford)', zip: '653080' },
	{ city: 'Carrigeen (Offaly)', zip: '258213' },
	{ city: 'Carrigeen (Roscommon)', zip: '430575' },
	{ city: 'Carrigeen (Sligo)', zip: '495893' },
	{ city: 'Carrigeen (Tipperary)', zip: '694339' },
	{ city: 'Carrigeen (Waterford)', zip: '614744' },
	{ city: 'Carrigeen (Wexford)', zip: '548649' },
	{ city: 'Carrigeenacreeha (Roscommon)', zip: '850088' },
	{ city: 'Carrigeenagappul (Roscommon)', zip: '758548' },
	{ city: 'Carrigeenagowna (Roscommon)', zip: '589838' },
	{ city: 'Carrigeenagowna (Sligo)', zip: '339381' },
	{ city: 'Carrigeenblike (Sligo)', zip: '940284' },
	{ city: 'Carrigeenboy (Sligo)', zip: '542032' },
	{ city: 'Carrigeencarragh (Roscommon)', zip: '890974' },
	{ city: 'Carrigeencor (Leitrim)', zip: '987018' },
	{ city: 'Carrigeencullia (Kerry)', zip: '954294' },
	{ city: 'Carrigeendaniel (Kerry)', zip: '422038' },
	{ city: 'Carrigeendauv (Mayo)', zip: '269846' },
	{ city: 'Carrigeenduff (Roscommon)', zip: '556823' },
	{ city: 'Carrigeenduff (Wicklow)', zip: '792547' },
	{ city: 'Carrigeen East (Cork)', zip: '535272' },
	{ city: 'Carrigeen East (Galway)', zip: '908806' },
	{ city: 'Carrigeenfair Island (Mayo)', zip: '564127' },
	{ city: 'Carrigeengeare (Leitrim)', zip: '321999' },
	{ city: 'Carrigeengour (Cork)', zip: '129074' },
	{ city: 'Carrigeenhill (Cork)', zip: '191202' },
	{ city: 'Carrigeenhill (Kildare)', zip: '374846' },
	{ city: 'Carrigeen Inishowen (Mayo)', zip: '239420' },
	{ city: 'Carrigeenmore (Sligo)', zip: '959931' },
	{ city: 'Carrigeen Mountain (Limerick)', zip: '311959' },
	{ city: 'Carrigeennageragh Big (Waterford)', zip: '456827' },
	{ city: 'Carrigeennageragh Little (Waterford)', zip: '790575' },
	{ city: 'Carrigeennagur (Mayo)', zip: '243434' },
	{ city: 'Carrigeennahaha (Waterford)', zip: '609395' },
	{ city: 'Carrigeennamoe (Cork)', zip: '807902' },
	{ city: 'Carrigeennamuck Islands (Galway)', zip: '743239' },
	{ city: 'Carrigeennaweelaun (Mayo)', zip: '806654' },
	{ city: 'Carrigeen North (Kildare)', zip: '380715' },
	{ city: 'Carrigeens (Longford)', zip: '350981' },
	{ city: 'Carrigeens (Roscommon)', zip: '396363' },
	{ city: 'Carrigeens (Sligo)', zip: '579947' },
	{ city: 'Carrigeensallagh (Sligo)', zip: '175920' },
	{ city: 'Carrigeensharragh (Tipperary)', zip: '834038' },
	{ city: 'Carrigeenshinnagh (Wicklow)', zip: '877796' },
	{ city: 'Carrigeen South (Kildare)', zip: '884225' },
	{ city: 'Carrigeen West (Cork)', zip: '525819' },
	{ city: 'Carrigeen West (Galway)', zip: '248684' },
	{ city: 'Carrigeenwood (Kerry)', zip: '904659' },
	{ city: 'Carrigeeny (Cork)', zip: '861132' },
	{ city: 'Carrigeenynaghtan (Roscommon)', zip: '608834' },
	{ city: 'Carrigerry (Clare)', zip: '520335' },
	{ city: 'Carrigfadda (Cork)', zip: '372012' },
	{ city: 'Carrigfadda (Kerry)', zip: '604183' },
	{ city: 'Carrigfadeen (Cork)', zip: '654190' },
	{ city: 'Carriggal (Tipperary)', zip: '848391' },
	{ city: 'Carriggower (Wicklow)', zip: '831009' },
	{ city: 'Carrighill Lower (Kildare)', zip: '422525' },
	{ city: 'Carrighill Upper (Kildare)', zip: '647079' },
	{ city: 'Carrigillihy (Cork)', zip: '555346' },
	{ city: 'Carriginane (Kerry)', zip: '129517' },
	{ city: 'Carrig Island (Kerry)', zip: '771959' },
	{ city: 'Carrigkerry (Limerick)', zip: '430684' },
	{ city: 'Carrigkilter (Cork)', zip: '502543' },
	{ city: 'Carriglea (Waterford)', zip: '223425' },
	{ city: 'Carriglead (Carlow)', zip: '340607' },
	{ city: 'Carrigleagh (Cork)', zip: '183490' },
	{ city: 'Carriglegan (Wexford)', zip: '842711' },
	{ city: 'Carrigleigh (Cork)', zip: '520308' },
	{ city: 'Carriglinneen (Wicklow)', zip: '521349' },
	{ city: 'Carriglong (Waterford)', zip: '512465' },
	{ city: 'Carrig Lower (Wicklow)', zip: '916293' },
	{ city: 'Carriglusky (Cork)', zip: '859372' },
	{ city: 'Carrigmacoge (Wexford)', zip: '260934' },
	{ city: 'Carrigmadden (Tipperary)', zip: '742694' },
	{ city: 'Carrigmannon (Wexford)', zip: '835825' },
	{ city: 'Carrigmanus (Cork)', zip: '620104' },
	{ city: 'Carrigmartin (Limerick)', zip: '250506' },
	{ city: 'Carrigmoorna (Waterford)', zip: '745226' },
	{ city: 'Carrigmore (Cork)', zip: '418448' },
	{ city: 'Carrigmore (Tipperary)', zip: '449751' },
	{ city: 'Carrigmore (Wicklow)', zip: '223377' },
	{ city: 'Carrig More (Carlow)', zip: '312126' },
	{ city: 'Carrig More (Limerick)', zip: '862789' },
	{ city: 'Carrig Mountain (Wicklow)', zip: '471951' },
	{ city: 'Carrignacurra (Cork)', zip: '530601' },
	{ city: 'Carrignadoura (Cork)', zip: '106712' },
	{ city: 'Carrignafecka (Carlow)', zip: '730187' },
	{ city: 'Carrignafeela (Kerry)', zip: '720796' },
	{ city: 'Carrignafoy (Cork)', zip: '154636' },
	{ city: 'Carrignagat (Cork)', zip: '179861' },
	{ city: 'Carrignagower (Wicklow)', zip: '789142' },
	{ city: 'Carrignagower East (Waterford)', zip: '373146' },
	{ city: 'Carrignagower West (Waterford)', zip: '934448' },
	{ city: 'Carrignagroghera (Cork)', zip: '645607' },
	{ city: 'Carrignahihilan (Kerry)', zip: '114859' },
	{ city: 'Carrignakeedu (Kerry)', zip: '521792' },
	{ city: 'Carrignamaddry (Cork)', zip: '681470' },
	{ city: 'Carrignamuck (Cork)', zip: '175212' },
	{ city: 'Carrignamuck (Wicklow)', zip: '161390' },
	{ city: 'Carrignamuck Lower (Wicklow)', zip: '549954' },
	{ city: 'Carrignamuck Upper (Wicklow)', zip: '757081' },
	{ city: 'Carrignamweel (Wicklow)', zip: '455174' },
	{ city: 'Carrignanean (Waterford)', zip: '722476' },
	{ city: 'Carrignaneelagh (Cork)', zip: '973323' },
	{ city: 'Carrignanonshagh (Waterford)', zip: '881212' },
	{ city: 'Carrignashinny (Cork)', zip: '482160' },
	{ city: 'Carrignavar (Cork)', zip: '819960' },
	{ city: 'Carrigogna (Cork)', zip: '101330' },
	{ city: 'Carrigogunnel (Limerick)', zip: '313913' },
	{ city: 'Carrigonirtane (Cork)', zip: '772744' },
	{ city: 'Carrigoon (Cork)', zip: '518659' },
	{ city: 'Carrigoona Commons East (Wicklow)', zip: '978502' },
	{ city: 'Carrigoona Commons West (Wicklow)', zip: '327993' },
	{ city: 'Carrigoon Beg (Cork)', zip: '815313' },
	{ city: 'Carrigoon More (Cork)', zip: '919594' },
	{ city: 'Carrigoran (Clare)', zip: '254297' },
	{ city: 'Carrigpark (Carlow)', zip: '550853' },
	{ city: 'Carrigpark (Cork)', zip: '279965' },
	{ city: 'Carrigparson (Limerick)', zip: '337768' },
	{ city: 'Carrigrenan (Cork)', zip: '597893' },
	{ city: 'Carrigroe (Cork)', zip: '122716' },
	{ city: 'Carrigroe (Waterford)', zip: '979811' },
	{ city: 'Carrigroe (Wicklow)', zip: '408187' },
	{ city: 'Carrigrohane (Cork)', zip: '319736' },
	{ city: 'Carrigrohanebeg (Cork)', zip: '261512' },
	{ city: 'Carrigrour (Cork)', zip: '293822' },
	{ city: 'Carrigshane (Cork)', zip: '854948' },
	{ city: 'Carrigskeewaun (Mayo)', zip: '539743' },
	{ city: 'Carrigskullihy (Cork)', zip: '110556' },
	{ city: 'Carrigthomas (Cork)', zip: '266042' },
	{ city: 'Carrigtishane (Cork)', zip: '605138' },
	{ city: 'Carrigtohill (Cork)', zip: '687302' },
	{ city: 'Carrigunane (Wexford)', zip: '387413' },
	{ city: 'Carrig Upper (Wicklow)', zip: '507976' },
	{ city: 'Carrig West (Kerry)', zip: '835373' },
	{ city: 'Carrig West (Limerick)', zip: '291183' },
	{ city: 'Carrigyknaveen (Cork)', zip: '396994' },
	{ city: 'Carrivetragh (Monaghan)', zip: '999099' },
	{ city: 'Carroghill (Donegal)', zip: '158315' },
	{ city: 'Carrollspark (Tipperary)', zip: '493778' },
	{ city: 'Carron (Tipperary)', zip: '641772' },
	{ city: 'Carronadavderg (Waterford)', zip: '314584' },
	{ city: 'Carronahyla (Waterford)', zip: '573877' },
	{ city: 'Carronbeg (Waterford)', zip: '953536' },
	{ city: 'Carrons (Limerick)', zip: '452172' },
	{ city: 'Carrontlieve (Donegal)', zip: '723925' },
	{ city: 'Carrow (Clare)', zip: '371444' },
	{ city: 'Carrow (Limerick)', zip: '473839' },
	{ city: 'Carrow (Tipperary)', zip: '831198' },
	{ city: 'Carrowaneeragh (Mayo)', zip: '157035' },
	{ city: 'Carrowanree (Wexford)', zip: '936087' },
	{ city: 'Carroward (Mayo)', zip: '251240' },
	{ city: 'Carroward (Roscommon)', zip: '888408' },
	{ city: 'Carroward (Sligo)', zip: '119083' },
	{ city: 'Carroward East (Limerick)', zip: '593939' },
	{ city: 'Carroward West (Limerick)', zip: '769292' },
	{ city: 'Carrowbane (Clare)', zip: '168328' },
	{ city: 'Carrowbane (Roscommon)', zip: '145168' },
	{ city: 'Carrowbane (Tipperary)', zip: '886101' },
	{ city: 'Carrowbane Beg (Limerick)', zip: '444236' },
	{ city: 'Carrowbane More (Limerick)', zip: '495259' },
	{ city: 'Carrowbarra (Monaghan)', zip: '420601' },
	{ city: 'Carrowbarra Island (Monaghan)', zip: '143509' },
	{ city: 'Carrowbaun (Clare)', zip: '876996' },
	{ city: 'Carrowbaun (Galway)', zip: '572049' },
	{ city: 'Carrowbaun (Mayo)', zip: '490854' },
	{ city: 'Carrowbaun (Roscommon)', zip: '619225' },
	{ city: 'Carrowbaun East (Galway)', zip: '740094' },
	{ city: 'Carrowbaun West (Galway)', zip: '433671' },
	{ city: 'Carrowbawn (Wicklow)', zip: '806080' },
	{ city: 'Carrowbeg (Donegal)', zip: '237472' },
	{ city: 'Carrowbeg (Galway)', zip: '400844' },
	{ city: 'Carrowbeg (Longford)', zip: '860689' },
	{ city: 'Carrowbeg (Mayo)', zip: '123695' },
	{ city: 'Carrow Beg (Longford)', zip: '763854' },
	{ city: 'Carrow Beg (Mayo)', zip: '662931' },
	{ city: 'Carrow Beg (Roscommon)', zip: '619497' },
	{ city: 'Carrowbeg East (Mayo)', zip: '835930' },
	{ city: 'Carrowbeg North (Galway)', zip: '204414' },
	{ city: 'Carrowbeg North (Mayo)', zip: '431414' },
	{ city: 'Carrowbeg South (Galway)', zip: '994783' },
	{ city: 'Carrowbeg South (Mayo)', zip: '787926' },
	{ city: 'Carrowbeg West (Mayo)', zip: '976969' },
	{ city: 'Carrowbehy (Roscommon)', zip: '774108' },
	{ city: 'Carrowblagh (Donegal)', zip: '487744' },
	{ city: 'Carrowbleagh East (Sligo)', zip: '117783' },
	{ city: 'Carrowbleagh West (Sligo)', zip: '575875' },
	{ city: 'Carrowblough Beg (Clare)', zip: '448113' },
	{ city: 'Carrowblough More (Clare)', zip: '615765' },
	{ city: 'Carrowboy (Leitrim)', zip: '534926' },
	{ city: 'Carrowboy (Roscommon)', zip: '371268' },
	{ city: 'Carrowbrack (Mayo)', zip: '421046' },
	{ city: 'Carrowbreedoge (Limerick)', zip: '706077' },
	{ city: 'Carrowbrickeen (Sligo)', zip: '494487' },
	{ city: 'Carrowbrinoge (Mayo)', zip: '756497' },
	{ city: 'Carrowbrowne (Galway)', zip: '359659' },
	{ city: 'Carrowbunnaun (Sligo)', zip: '913670' },
	{ city: 'Carrowcally (Mayo)', zip: '700081' },
	{ city: 'Carrowcanada (Mayo)', zip: '291543' },
	{ city: 'Carrowcannon (Donegal)', zip: '200510' },
	{ city: 'Carrowcanon (Donegal)', zip: '418955' },
	{ city: 'Carrowcardin (Sligo)', zip: '681886' },
	{ city: 'Carrowcarragh (Sligo)', zip: '936508' },
	{ city: 'Carrowcashel (Donegal)', zip: '225849' },
	{ city: 'Carrowcashel (Sligo)', zip: '697797' },
	{ city: 'Carrowcaslan (Sligo)', zip: '513416' },
	{ city: 'Carrowcastle (Mayo)', zip: '989289' },
	{ city: 'Carrowcauly (Sligo)', zip: '388852' },
	{ city: 'Carrowclaggan (Mayo)', zip: '164744' },
	{ city: 'Carrowclare (Sligo)', zip: '999221' },
	{ city: 'Carrowclogh (Galway)', zip: '396414' },
	{ city: 'Carrowclogh (Limerick)', zip: '903579' },
	{ city: 'Carrowclogh (Tipperary)', zip: '305045' },
	{ city: 'Carrowcloghagh (Mayo)', zip: '520017' },
	{ city: 'Carrowclogher (Mayo)', zip: '483615' },
	{ city: 'Carrowclogher (Roscommon)', zip: '404971' },
	{ city: 'Carrowclooneen (Sligo)', zip: '880573' },
	{ city: 'Carrowclough (Waterford)', zip: '439026' },
	{ city: 'Carrowcoller (Sligo)', zip: '183088' },
	{ city: 'Carrowconeen (Mayo)', zip: '719510' },
	{ city: 'Carrowconlaun (Galway)', zip: '178226' },
	{ city: 'Carrowconnell (Mayo)', zip: '846946' },
	{ city: 'Carrowconor (Mayo)', zip: '985240' },
	{ city: 'Carrowconor (Sligo)', zip: '546955' },
	{ city: 'Carrowcor (Mayo)', zip: '152893' },
	{ city: 'Carrowcor (Sligo)', zip: '771692' },
	{ city: 'Carrowcore (Clare)', zip: '285672' },
	{ city: 'Carrowcraheen (Clare)', zip: '842846' },
	{ city: 'Carrowcreevanagh (Galway)', zip: '244699' },
	{ city: 'Carrowcrin (Galway)', zip: '259158' },
	{ city: 'Carrowcrin (Leitrim)', zip: '547759' },
	{ city: 'Carrowcrin (Mayo)', zip: '814359' },
	{ city: 'Carrowcrin (Roscommon)', zip: '846490' },
	{ city: 'Carrowcrin (Sligo)', zip: '542482' },
	{ city: 'Carrowcrom (Mayo)', zip: '616919' },
	{ city: 'Carrowcrory (Sligo)', zip: '725295' },
	{ city: 'Carrowcuill (Roscommon)', zip: '748707' },
	{ city: 'Carrowcuilleen (Mayo)', zip: '264473' },
	{ city: 'Carrowculleen (Galway)', zip: '540339' },
	{ city: 'Carrowculleen (Sligo)', zip: '493669' },
	{ city: 'Carrowcushcly (Sligo)', zip: '240946' },
	{ city: 'Carrowcushlaun (Mayo)', zip: '417019' },
	{ city: 'Carrowcushlaun West (Mayo)', zip: '340496' },
	{ city: 'Carrowdoogan (Mayo)', zip: '997798' },
	{ city: 'Carrowdotia (Clare)', zip: '391533' },
	{ city: 'Carrowdotia North (Clare)', zip: '852385' },
	{ city: 'Carrowdotia South (Clare)', zip: '864210' },
	{ city: 'Carrowdough (Sligo)', zip: '882547' },
	{ city: 'Carrowduff (Clare)', zip: '201965' },
	{ city: 'Carrowduff (Leitrim)', zip: '586080' },
	{ city: 'Carrowduff And Garbally (Roscommon)', zip: '925970' },
	{ city: 'Carrowduff Lower (Roscommon)', zip: '669538' },
	{ city: 'Carrowduff Upper (Roscommon)', zip: '789203' },
	{ city: 'Carrowdunican (Longford)', zip: '168209' },
	{ city: 'Carrowdurneen (Sligo)', zip: '990394' },
	{ city: 'Carrowea (Tipperary)', zip: '416688' },
	{ city: 'Carroweeny (Mayo)', zip: '648286' },
	{ city: 'Carroweighter (Roscommon)', zip: '810228' },
	{ city: 'Carrowen (Donegal)', zip: '872436' },
	{ city: 'Carrowena (Clare)', zip: '663286' },
	{ city: 'Carroweragh (Clare)', zip: '739992' },
	{ city: 'Carrowfarnaghan (Cavan)', zip: '839092' },
	{ city: 'Carrowferrikeen (Galway)', zip: '508166' },
	{ city: 'Carrowflatley (Sligo)', zip: '478087' },
	{ city: 'Carrowfree (Clare)', zip: '864074' },
	{ city: 'Carrowgallda (Mayo)', zip: '781348' },
	{ city: 'Carrowgar (Clare)', zip: '500520' },
	{ city: 'Carrowgar (Limerick)', zip: '208363' },
	{ city: 'Carrowgarriff (Galway)', zip: '413325' },
	{ city: 'Carrowgarriff (Waterford)', zip: '527156' },
	{ city: 'Carrowgarriff Beg (Waterford)', zip: '742723' },
	{ city: 'Carrowgarriff More (Waterford)', zip: '259413' },
	{ city: 'Carrowgarriff North (Galway)', zip: '788872' },
	{ city: 'Carrowgarriff South (Galway)', zip: '964556' },
	{ city: 'Carrowgarry (Sligo)', zip: '222152' },
	{ city: 'Carrowgarve (Mayo)', zip: '988883' },
	{ city: 'Carrowgarve (Roscommon)', zip: '333125' },
	{ city: 'Carrowgarve North (Mayo)', zip: '957950' },
	{ city: 'Carrowgarve South (Mayo)', zip: '813023' },
	{ city: 'Carrowgavneen (Sligo)', zip: '499990' },
	{ city: 'Carrowgilhooly (Sligo)', zip: '664449' },
	{ city: 'Carrowgilpatrick (Sligo)', zip: '586885' },
	{ city: 'Carrowgobbadagh (Roscommon)', zip: '887045' },
	{ city: 'Carrowgobbadagh (Sligo)', zip: '479983' },
	{ city: 'Carrowgorm (Galway)', zip: '602171' },
	{ city: 'Carrowgowan (Mayo)', zip: '388634' },
	{ city: 'Carrowgun (Sligo)', zip: '194576' },
	{ city: 'Carrowhall (Mayo)', zip: '278697' },
	{ city: 'Carrowhatta (Monaghan)', zip: '282124' },
	{ city: 'Carrowhawny (Mayo)', zip: '848809' },
	{ city: 'Carrowhekeen (Galway)', zip: '632988' },
	{ city: 'Carrowholla (Galway)', zip: '596413' },
	{ city: 'Carrowhubbuck North (Sligo)', zip: '549485' },
	{ city: 'Carrowhubbuck South (Sligo)', zip: '609271' },
	{ city: 'Carrowhugh (Donegal)', zip: '112412' },
	{ city: 'Carrowjames (Mayo)', zip: '811243' },
	{ city: 'Carrowkeale (Tipperary)', zip: '379994' },
	{ city: 'Carrowkeel (Clare)', zip: '423285' },
	{ city: 'Carrowkeel (Donegal)', zip: '597295' },
	{ city: 'Carrowkeel (Galway)', zip: '410979' },
	{ city: 'Carrowkeel (Leitrim)', zip: '791453' },
	{ city: 'Carrowkeel (Limerick)', zip: '166691' },
	{ city: 'Carrowkeel (Mayo)', zip: '138537' },
	{ city: 'Carrowkeel (Monaghan)', zip: '666067' },
	{ city: 'Carrowkeel (Offaly)', zip: '154822' },
	{ city: 'Carrowkeel (Roscommon)', zip: '847695' },
	{ city: 'Carrowkeel (Sligo)', zip: '896745' },
	{ city: 'Carrowkeelanahglass (Galway)', zip: '941812' },
	{ city: 'Carrowkeel Beg (Clare)', zip: '849116' },
	{ city: 'Carrowkeel East (Clare)', zip: '342744' },
	{ city: 'Carrowkeel East (Mayo)', zip: '432833' },
	{ city: 'Carrowkeel Glebe (Donegal)', zip: '863334' },
	{ city: 'Carrowkeel More (Clare)', zip: '834565' },
	{ city: 'Carrowkeel North (Mayo)', zip: '443492' },
	{ city: 'Carrowkeel South (Mayo)', zip: '765181' },
	{ city: 'Carrowkeel Upper (Roscommon)', zip: '605013' },
	{ city: 'Carrowkeel West (Clare)', zip: '205902' },
	{ city: 'Carrowkeel West (Mayo)', zip: '395375' },
	{ city: 'Carrowkeeny (Roscommon)', zip: '292978' },
	{ city: 'Carrowkeeran (Mayo)', zip: '589568' },
	{ city: 'Carrowkeeran (Roscommon)', zip: '133112' },
	{ city: 'Carrowkelly (Mayo)', zip: '715185' },
	{ city: 'Carrowkennedy (Mayo)', zip: '328480' },
	{ city: 'Carrowkeribly (Mayo)', zip: '187925' },
	{ city: 'Carrowkibbock Lower (Mayo)', zip: '724518' },
	{ city: 'Carrowkibbock Upper (Mayo)', zip: '187262' },
	{ city: 'Carrowkilla (Clare)', zip: '862264' },
	{ city: 'Carrowkilleen (Galway)', zip: '291593' },
	{ city: 'Carrowkilleen (Mayo)', zip: '166963' },
	{ city: 'Carrowlagan (Clare)', zip: '257921' },
	{ city: 'Carrowlaur (Leitrim)', zip: '451759' },
	{ city: 'Carrowleagh (Mayo)', zip: '924025' },
	{ city: 'Carrowleana (Galway)', zip: '787761' },
	{ city: 'Carrowleigh (Waterford)', zip: '711146' },
	{ city: 'Carrowlena (Mayo)', zip: '955346' },
	{ city: 'Carrowliam Beg (Mayo)', zip: '451261' },
	{ city: 'Carrowliam More (Mayo)', zip: '340298' },
	{ city: 'Carrowlinan (Longford)', zip: '451308' },
	{ city: 'Carrowlisdooaun (Mayo)', zip: '324846' },
	{ city: 'Carrowloughan East (Sligo)', zip: '759382' },
	{ city: 'Carrowloughan West (Sligo)', zip: '241271' },
	{ city: 'Carrowloughlin (Sligo)', zip: '854484' },
	{ city: 'Carrowlustia (Sligo)', zip: '402184' },
	{ city: 'Carrowlustraun (Galway)', zip: '225074' },
	{ city: 'Carrowmably (Sligo)', zip: '272551' },
	{ city: 'Carrowmacbryan (Sligo)', zip: '544651' },
	{ city: 'Carrowmaclenany (Sligo)', zip: '534630' },
	{ city: 'Carrowmacloughlin (Mayo)', zip: '830706' },
	{ city: 'Carrowmacowan (Galway)', zip: '286464' },
	{ city: 'Carrowmacrory (Sligo)', zip: '788968' },
	{ city: 'Carrowmacshane (Mayo)', zip: '147498' },
	{ city: 'Carrowmanagh (Galway)', zip: '442380' },
	{ city: 'Carrowmanagh (Longford)', zip: '511070' },
	{ city: 'Carrowmanagh (Offaly)', zip: '532448' },
	{ city: 'Carrowmanagh North (Clare)', zip: '920160' },
	{ city: 'Carrowmanagh South (Clare)', zip: '895358' },
	{ city: 'Carrowmaneen (Galway)', zip: '897725' },
	{ city: 'Carrowmarley (Mayo)', zip: '145565' },
	{ city: 'Carrowmeer (Clare)', zip: '983534' },
	{ city: 'Carrowmenagh (Donegal)', zip: '888995' },
	{ city: 'Carrowmoneash (Galway)', zip: '743208' },
	{ city: 'Carrowmoneen (Galway)', zip: '103701' },
	{ city: 'Carrowmoneen (Roscommon)', zip: '259652' },
	{ city: 'Carrowmoney (Mayo)', zip: '640042' },
	{ city: 'Carrowmoney (Roscommon)', zip: '674665' },
	{ city: 'Carrowmoran (Sligo)', zip: '447317' },
	{ city: 'Carrowmore (Cavan)', zip: '933984' },
	{ city: 'Carrowmore (Clare)', zip: '173260' },
	{ city: 'Carrowmore (Donegal)', zip: '974431' },
	{ city: 'Carrowmore (Galway)', zip: '767259' },
	{ city: 'Carrowmore (Limerick)', zip: '238016' },
	{ city: 'Carrowmore (Mayo)', zip: '494085' },
	{ city: 'Carrowmore (Roscommon)', zip: '932588' },
	{ city: 'Carrowmore (Sligo)', zip: '258629' },
	{ city: 'Carrow More (Longford)', zip: '586231' },
	{ city: 'Carrow More (Mayo)', zip: '803196' },
	{ city: 'Carrow More (Roscommon)', zip: '195554' },
	{ city: 'Carrowmore East (Galway)', zip: '776978' },
	{ city: 'Carrowmoreknock (Galway)', zip: '386220' },
	{ city: 'Carrowmoremoy (Mayo)', zip: '167757' },
	{ city: 'Carrowmore North (Clare)', zip: '154310' },
	{ city: 'Carrowmore North (Mayo)', zip: '426730' },
	{ city: 'Carrowmore South (Clare)', zip: '475227' },
	{ city: 'Carrowmore South (Mayo)', zip: '243020' },
	{ city: 'Carrowmore West (Galway)', zip: '646773' },
	{ city: 'Carrowmore West (Mayo)', zip: '662167' },
	{ city: 'Carrowmorris (Sligo)', zip: '594633' },
	{ city: 'Carrowmullin (Donegal)', zip: '526017' },
	{ city: 'Carrowmunna (Galway)', zip: '404332' },
	{ city: 'Carrowmunniagh (Galway)', zip: '866633' },
	{ city: 'Carrowmurragh (Roscommon)', zip: '552763' },
	{ city: 'Carrowmurray (Sligo)', zip: '631609' },
	{ city: 'Carrownabanny (Sligo)', zip: '635712' },
	{ city: 'Carrownabinna (Sligo)', zip: '122429' },
	{ city: 'Carrownabo (Galway)', zip: '945363' },
	{ city: 'Carrownaboll (Sligo)', zip: '748325' },
	{ city: 'Carrownabrickna (Roscommon)', zip: '126545' },
	{ city: 'Carrownacarrick (Sligo)', zip: '842219' },
	{ city: 'Carrownaclea (Mayo)', zip: '815628' },
	{ city: 'Carrownacleigha (Sligo)', zip: '364487' },
	{ city: 'Carrownaclogh (Clare)', zip: '754342' },
	{ city: 'Carrownaclogh North (Tipperary)', zip: '827118' },
	{ city: 'Carrownaclogh South (Tipperary)', zip: '435875' },
	{ city: 'Carrownacloghy (Clare)', zip: '263814' },
	{ city: 'Carrownacon (Mayo)', zip: '499152' },
	{ city: 'Carrownacreevy (Sligo)', zip: '451717' },
	{ city: 'Carrownacreggaun (Galway)', zip: '837759' },
	{ city: 'Carrownacregg East (Galway)', zip: '214587' },
	{ city: 'Carrownacregg West (Galway)', zip: '875528' },
	{ city: 'Carrownacroagh (Galway)', zip: '877199' },
	{ city: 'Carrownacross (Mayo)', zip: '486943' },
	{ city: 'Carrownaculla (Mayo)', zip: '971668' },
	{ city: 'Carrownadargny (Sligo)', zip: '407484' },
	{ city: 'Carrownadurly (Roscommon)', zip: '869348' },
	{ city: 'Carrownaff (Donegal)', zip: '875383' },
	{ city: 'Carrownafinnoge (Galway)', zip: '503166' },
	{ city: 'Carrownafreevy (Galway)', zip: '389970' },
	{ city: 'Carrownagannive (Galway)', zip: '198365' },
	{ city: 'Carrownaganonagh (Donegal)', zip: '311751' },
	{ city: 'Carrownagappul (Galway)', zip: '609879' },
	{ city: 'Carrownagappul (Roscommon)', zip: '252324' },
	{ city: 'Carrownagappul (Sligo)', zip: '954657' },
	{ city: 'Carrownagark (Sligo)', zip: '903530' },
	{ city: 'Carrownagarraun (Clare)', zip: '686473' },
	{ city: 'Carrownagarraun (Galway)', zip: '212569' },
	{ city: 'Carrownagarry (Galway)', zip: '210618' },
	{ city: 'Carrownagashel (Roscommon)', zip: '233821' },
	{ city: 'Carrownageeha (Galway)', zip: '275612' },
	{ city: 'Carrownageelaun (Roscommon)', zip: '319038' },
	{ city: 'Carrownageeloge (Roscommon)', zip: '181461' },
	{ city: 'Carrownageeragh (Mayo)', zip: '417658' },
	{ city: 'Carrownageeragh (Roscommon)', zip: '374865' },
	{ city: 'Carrownagh (Sligo)', zip: '685720' },
	{ city: 'Carrownagilty (Sligo)', zip: '659133' },
	{ city: 'Carrownaglearagh (Roscommon)', zip: '525744' },
	{ city: 'Carrownagleragh (Sligo)', zip: '340096' },
	{ city: 'Carrownaglogh (Galway)', zip: '535497' },
	{ city: 'Carrownaglogh (Mayo)', zip: '543812' },
	{ city: 'Carrownaglogh (Roscommon)', zip: '628689' },
	{ city: 'Carrownaglogh (Tipperary)', zip: '134771' },
	{ city: 'Carrownagoul (Clare)', zip: '283736' },
	{ city: 'Carrownagowan (Clare)', zip: '737882' },
	{ city: 'Carrownagower (Galway)', zip: '433054' },
	{ city: 'Carrownagreggaun (Mayo)', zip: '485434' },
	{ city: 'Carrownagry North (Clare)', zip: '380943' },
	{ city: 'Carrownagry South (Clare)', zip: '671087' },
	{ city: 'Carrownaguivna East (Sligo)', zip: '460114' },
	{ city: 'Carrownaguivna West (Sligo)', zip: '892060' },
	{ city: 'Carrownagullagh (Roscommon)', zip: '690995' },
	{ city: 'Carrownagur (Galway)', zip: '838042' },
	{ city: 'Carrownagurraun (Mayo)', zip: '879405' },
	{ city: 'Carrownahaltore (Mayo)', zip: '906630' },
	{ city: 'Carrownahaun (Mayo)', zip: '763622' },
	{ city: 'Carrownaherick East (Galway)', zip: '725356' },
	{ city: 'Carrownaherick West (Galway)', zip: '568954' },
	{ city: 'Carrownahooan East (Clare)', zip: '445238' },
	{ city: 'Carrownahooan West (Clare)', zip: '961653' },
	{ city: 'Carrownakelly (Galway)', zip: '948020' },
	{ city: 'Carrownakib (Galway)', zip: '293161' },
	{ city: 'Carrownakilly (Clare)', zip: '531964' },
	{ city: 'Carrownakilly (Mayo)', zip: '463514' },
	{ city: 'Carrownaknockan (Sligo)', zip: '944930' },
	{ city: 'Carrownaknockaun (Roscommon)', zip: '900023' },
	{ city: 'Carrownalassan (Roscommon)', zip: '612779' },
	{ city: 'Carrownaleck (Sligo)', zip: '139876' },
	{ city: 'Carrownalecka (Mayo)', zip: '963257' },
	{ city: 'Carrownalegaun (Clare)', zip: '159528' },
	{ city: 'Carrownaltore (Mayo)', zip: '463175' },
	{ city: 'Carrownalurgan (Mayo)', zip: '530455' },
	{ city: 'Carrownamaddoo (Sligo)', zip: '246289' },
	{ city: 'Carrownamaddra (Clare)', zip: '649229' },
	{ city: 'Carrownamaddra (Galway)', zip: '833694' },
	{ city: 'Carrownamaddy (Donegal)', zip: '397536' },
	{ city: 'Carrownamaddy (Roscommon)', zip: '919629' },
	{ city: 'Carrownamallaght (Mayo)', zip: '938330' },
	{ city: 'Carrownamona (Galway)', zip: '253114' },
	{ city: 'Carrownamorheeny (Roscommon)', zip: '751923' },
	{ city: 'Carrownamorrissy (Galway)', zip: '772675' },
	{ city: 'Carrownanalt (Roscommon)', zip: '134109' },
	{ city: 'Carrownanelly (Clare)', zip: '845109' },
	{ city: 'Carrownanty (Sligo)', zip: '667483' },
	{ city: 'Carrownaraha (Mayo)', zip: '192358' },
	{ city: 'Carrownasaul (Donegal)', zip: '840488' },
	{ city: 'Carrownaseer North (Galway)', zip: '197698' },
	{ city: 'Carrownaseer South (Galway)', zip: '546789' },
	{ city: 'Carrownaskeagh (Roscommon)', zip: '847699' },
	{ city: 'Carrownaskeagh (Sligo)', zip: '975010' },
	{ city: 'Carrownaskeha (Mayo)', zip: '724318' },
	{ city: 'Carrownateewaun (Sligo)', zip: '530963' },
	{ city: 'Carrownaun (Sligo)', zip: '286652' },
	{ city: 'Carrownavohanaun (Galway)', zip: '744754' },
	{ city: 'Carrownaweelaun (Clare)', zip: '818888' },
	{ city: 'Carrownaworan (Sligo)', zip: '358112' },
	{ city: 'Carrowncalla North (Clare)', zip: '692853' },
	{ city: 'Carrowncalla South (Clare)', zip: '859161' },
	{ city: 'Carrowncaran (Roscommon)', zip: '442389' },
	{ city: 'Carrowncashlane (Waterford)', zip: '863371' },
	{ city: 'Carrowncloghan (Roscommon)', zip: '921402' },
	{ city: 'Carrowncully (Roscommon)', zip: '884702' },
	{ city: 'Carrowncurry (Mayo)', zip: '768433' },
	{ city: 'Carrowndangan (Mayo)', zip: '554697' },
	{ city: 'Carrowndangan (Roscommon)', zip: '195895' },
	{ city: 'Carrownderry (Galway)', zip: '304216' },
	{ city: 'Carrownderry (Roscommon)', zip: '500677' },
	{ city: 'Carrowndrisha (Roscommon)', zip: '197580' },
	{ city: 'Carrowndulla (Galway)', zip: '440006' },
	{ city: 'Carrownea (Galway)', zip: '931463' },
	{ city: 'Carrownea Lower (Galway)', zip: '207238' },
	{ city: 'Carrowneany (Galway)', zip: '108845' },
	{ city: 'Carrownea Upper (Galway)', zip: '905780' },
	{ city: 'Carrowneden (Mayo)', zip: '619755' },
	{ city: 'Carrowneden (Sligo)', zip: '370429' },
	{ city: 'Carrownerribul (Clare)', zip: '758099' },
	{ city: 'Carrowngarry (Roscommon)', zip: '765640' },
	{ city: 'Carrowniska North (Clare)', zip: '992075' },
	{ city: 'Carrowniska South (Clare)', zip: '699556' },
	{ city: 'Carrownisky (Mayo)', zip: '819338' },
	{ city: 'Carrownlabaun (Mayo)', zip: '255526' },
	{ city: 'Carrownlacka (Mayo)', zip: '230106' },
	{ city: 'Carrownleam (Sligo)', zip: '937051' },
	{ city: 'Carrownlisheen (Galway)', zip: '257441' },
	{ city: 'Carrownlobaun (Sligo)', zip: '109423' },
	{ city: 'Carrownlough (Mayo)', zip: '749645' },
	{ city: 'Carrownloughan (Sligo)', zip: '539779' },
	{ city: 'Carrownluggaun (Mayo)', zip: '744751' },
	{ city: 'Carrownolan (Roscommon)', zip: '637480' },
	{ city: 'Carrownoona (Leitrim)', zip: '916406' },
	{ city: 'Carrownphull (Longford)', zip: '505089' },
	{ city: 'Carrownreddy (Tipperary)', zip: '138154' },
	{ city: 'Carrownree (Sligo)', zip: '827297' },
	{ city: 'Carrownrinny (Roscommon)', zip: '851145' },
	{ city: 'Carrownrod (Sligo)', zip: '620230' },
	{ city: 'Carrownrooaun (Galway)', zip: '589442' },
	{ city: 'Carrownrush (Sligo)', zip: '985035' },
	{ city: 'Carrownskehaun (Mayo)', zip: '817494' },
	{ city: 'Carrownskeheen (Roscommon)', zip: '443837' },
	{ city: 'Carrownspurraun (Sligo)', zip: '568972' },
	{ city: 'Carrowntanlis (Galway)', zip: '197769' },
	{ city: 'Carrowntarriff (Roscommon)', zip: '479392' },
	{ city: 'Carrowntassona (Waterford)', zip: '479701' },
	{ city: 'Carrowntawa (Sligo)', zip: '924362' },
	{ city: 'Carrowntawy (Sligo)', zip: '446622' },
	{ city: 'Carrownteane (Sligo)', zip: '504472' },
	{ city: 'Carrowntedaun (Clare)', zip: '244968' },
	{ city: 'Carrownteeaun (Mayo)', zip: '823796' },
	{ city: 'Carrowntemple (Galway)', zip: '703157' },
	{ city: 'Carrowntemple (Roscommon)', zip: '816998' },
	{ city: 'Carrowntemple (Sligo)', zip: '397754' },
	{ city: 'Carrowntleva (Mayo)', zip: '620858' },
	{ city: 'Carrowntlieve (Roscommon)', zip: '536254' },
	{ city: 'Carrowntober (Galway)', zip: '423676' },
	{ city: 'Carrowntober (Mayo)', zip: '528386' },
	{ city: 'Carrowntober (Sligo)', zip: '988633' },
	{ city: 'Carrowntober East (Galway)', zip: '746629' },
	{ city: 'Carrowntober Eighter (Mayo)', zip: '166008' },
	{ city: 'Carrowntober Oughter (Mayo)', zip: '872460' },
	{ city: 'Carrowntober West (Galway)', zip: '975291' },
	{ city: 'Carrowntogher (Roscommon)', zip: '453554' },
	{ city: 'Carrowntomush (Galway)', zip: '578746' },
	{ city: 'Carrowntoosan (Roscommon)', zip: '635014' },
	{ city: 'Carrowntootagh (Galway)', zip: '933925' },
	{ city: 'Carrowntornan (Roscommon)', zip: '492239' },
	{ city: 'Carrowntreila (Mayo)', zip: '749476' },
	{ city: 'Carrowntryla (Galway)', zip: '969916' },
	{ city: 'Carrowntryla (Roscommon)', zip: '833156' },
	{ city: 'Carrownturly (Mayo)', zip: '795812' },
	{ city: 'Carrownure (Roscommon)', zip: '107208' },
	{ city: 'Carrownure Lower (Roscommon)', zip: '707707' },
	{ city: 'Carrownure Upper (Roscommon)', zip: '452611' },
	{ city: 'Carrownurlar (Roscommon)', zip: '731595' },
	{ city: 'Carrownurlar (Sligo)', zip: '677531' },
	{ city: 'Carrownurlaur (Galway)', zip: '983697' },
	{ city: 'Carrownurlaur (Mayo)', zip: '130350' },
	{ city: 'Carrownurlaur (Sligo)', zip: '714922' },
	{ city: 'Carrownvally (Roscommon)', zip: '428064' },
	{ city: 'Carrownycleary (Clare)', zip: '725473' },
	{ city: 'Carrownyclowan (Sligo)', zip: '749076' },
	{ city: 'Carrowoughteragh (Mayo)', zip: '910300' },
	{ city: 'Carrowpadeen (Sligo)', zip: '164085' },
	{ city: 'Carrowpadeen East (Galway)', zip: '475666' },
	{ city: 'Carrowpadeen West (Galway)', zip: '494369' },
	{ city: 'Carrowpeter (Galway)', zip: '118551' },
	{ city: 'Carrowphadeen (Roscommon)', zip: '994395' },
	{ city: 'Carrowreagh (Cavan)', zip: '325654' },
	{ city: 'Carrowreagh (Donegal)', zip: '234385' },
	{ city: 'Carrowreagh (Galway)', zip: '980187' },
	{ city: 'Carrowreagh (Laois)', zip: '525523' },
	{ city: 'Carrowreagh (Mayo)', zip: '240522' },
	{ city: 'Carrowreagh (Roscommon)', zip: '868816' },
	{ city: 'Carrowreagh (Sligo)', zip: '344145' },
	{ city: 'Carrowreagh (Wexford)', zip: '201712' },
	{ city: 'Carrowreagh East (Clare)', zip: '481900' },
	{ city: 'Carrowreagh East (Galway)', zip: '994170' },
	{ city: 'Carrowreaghmony (Mayo)', zip: '360125' },
	{ city: 'Carrowreagh West (Clare)', zip: '126431' },
	{ city: 'Carrowreagh West (Galway)', zip: '633917' },
	{ city: 'Carrowreilly (Sligo)', zip: '590872' },
	{ city: 'Carrowrevagh (Galway)', zip: '951945' },
	{ city: 'Carrowrevagh (Leitrim)', zip: '135096' },
	{ city: 'Carrowrevagh (Mayo)', zip: '350394' },
	{ city: 'Carrowrevagh Beg (Galway)', zip: '337927' },
	{ city: 'Carrowrevagh More (Galway)', zip: '100814' },
	{ city: 'Carrowroe (Clare)', zip: '989469' },
	{ city: 'Carrowroe (Galway)', zip: '389773' },
	{ city: 'Carrowroe (Longford)', zip: '530216' },
	{ city: 'Carrowroe (Roscommon)', zip: '607562' },
	{ city: 'Carrowroe (Sligo)', zip: '603745' },
	{ city: 'Carrowroe East (Galway)', zip: '539261' },
	{ city: 'Carrowroe North (Galway)', zip: '754644' },
	{ city: 'Carrowroe South (Galway)', zip: '540373' },
	{ city: 'Carrowroe West (Galway)', zip: '784309' },
	{ city: 'Carrowroger (Mayo)', zip: '681910' },
	{ city: 'Carrowrory (Longford)', zip: '998517' },
	{ city: 'Carrowsallagh (Mayo)', zip: '567410' },
	{ city: 'Carrowscoltia (Mayo)', zip: '867357' },
	{ city: 'Carrowshanbally (Galway)', zip: '105556' },
	{ city: 'Carrowskeheen (Mayo)', zip: '545548' },
	{ city: 'Carrowslattery (Mayo)', zip: '407975' },
	{ city: 'Carrowsteelagh (Galway)', zip: '194132' },
	{ city: 'Carrowsteelagh (Mayo)', zip: '159381' },
	{ city: 'Carrowsteelaun (Mayo)', zip: '632634' },
	{ city: 'Carrowstellan (Roscommon)', zip: '156050' },
	{ city: 'Carrowstrawly (Longford)', zip: '753051' },
	{ city: 'Carrowteige (Mayo)', zip: '793208' },
	{ city: 'Carrowtootagh (Mayo)', zip: '169614' },
	{ city: 'Carrowtrasna (Donegal)', zip: '592670' },
	{ city: 'Carrowtrasna (Mayo)', zip: '787616' },
	{ city: 'Carrowvaneen (Mayo)', zip: '263643' },
	{ city: 'Carrowvere (Clare)', zip: '690679' },
	{ city: 'Carrowwilkin (Sligo)', zip: '743900' },
	{ city: 'Carryblagh (Donegal)', zip: '869368' },
	{ city: 'Carrycole (Wicklow)', zip: '554963' },
	{ city: 'Carrygally (Donegal)', zip: '279416' },
	{ city: 'Carrygalt (Donegal)', zip: '284514' },
	{ city: 'Carsan (Monaghan)', zip: '397560' },
	{ city: 'Carsrock (Wicklow)', zip: '907290' },
	{ city: 'Carstown (Louth)', zip: '652794' },
	{ city: 'Carta (Galway)', zip: '455197' },
	{ city: 'Cartanstown (Louth)', zip: '468343' },
	{ city: 'Cartenstown (Westmeath)', zip: '221060' },
	{ city: 'Cartersbog (Kildare)', zip: '457844' },
	{ city: 'Carthage (Donegal)', zip: '985202' },
	{ city: 'Carton Demesne (Kildare)', zip: '762185' },
	{ city: 'Cartoon (Longford)', zip: '569774' },
	{ city: 'Cartoon (Mayo)', zip: '137636' },
	{ city: 'Cartoor (Galway)', zip: '312493' },
	{ city: 'Cartoor (Mayo)', zip: '370769' },
	{ city: 'Cartoorbeg (Galway)', zip: '312872' },
	{ city: 'Cartown (Leitrim)', zip: '396959' },
	{ city: 'Cartown (Limerick)', zip: '931494' },
	{ city: 'Cartron (Clare)', zip: '197272' },
	{ city: 'Cartron (Galway)', zip: '560414' },
	{ city: 'Cartron (Leitrim)', zip: '180432' },
	{ city: 'Cartron (Longford)', zip: '796241' },
	{ city: 'Cartron (Mayo)', zip: '956357' },
	{ city: 'Cartron (Offaly)', zip: '616263' },
	{ city: 'Cartron (Roscommon)', zip: '337970' },
	{ city: 'Cartron (Sligo)', zip: '934318' },
	{ city: 'Cartron (Westmeath)', zip: '978250' },
	{ city: 'Cartronabree (Sligo)', zip: '721377' },
	{ city: 'Cartronageeragh (Longford)', zip: '394502' },
	{ city: 'Cartronaglogh (Roscommon)', zip: '356190' },
	{ city: 'Cartronagor (Roscommon)', zip: '756215' },
	{ city: 'Cartronamarkey (Longford)', zip: '611460' },
	{ city: 'Cartronatemple (Leitrim)', zip: '398187' },
	{ city: 'Cartronavally (Roscommon)', zip: '614518' },
	{ city: 'Cartronavally (Sligo)', zip: '493085' },
	{ city: 'Cartronawar (Longford)', zip: '161748' },
	{ city: 'Cartronbeg (Leitrim)', zip: '550490' },
	{ city: 'Cartron Beg (Roscommon)', zip: '318235' },
	{ city: 'Cartron Big (Longford)', zip: '521778' },
	{ city: 'Cartronbore (Longford)', zip: '685636' },
	{ city: 'Cartronbower (Mayo)', zip: '453534' },
	{ city: 'Cartronboy (Longford)', zip: '318755' },
	{ city: 'Cartronbrack (Longford)', zip: '691246' },
	{ city: 'Cartroncar (Longford)', zip: '753818' },
	{ city: 'Cartroncaran (Roscommon)', zip: '822294' },
	{ city: 'Cartroncarrowntogher (Roscommon)', zip: '293016' },
	{ city: 'Cartroncoragh (Westmeath)', zip: '631932' },
	{ city: 'Cartroncroy (Westmeath)', zip: '518361' },
	{ city: 'Cartrondoogan (Galway)', zip: '856678' },
	{ city: 'Cartronduff (Mayo)', zip: '314972' },
	{ city: 'Cartronduffy (Sligo)', zip: '494081' },
	{ city: 'Cartronearl (Galway)', zip: '710628' },
	{ city: 'Cartron East (Galway)', zip: '783938' },
	{ city: 'Cartron East (Offaly)', zip: '818105' },
	{ city: 'Cartronfin (Longford)', zip: '343747' },
	{ city: 'Cartronfree (Cavan)', zip: '364012' },
	{ city: 'Cartronganny (Westmeath)', zip: '806965' },
	{ city: 'Cartrongar (Longford)', zip: '183876' },
	{ city: 'Cartrongarrow (Longford)', zip: '166921' },
	{ city: 'Cartrongibbagh (Leitrim)', zip: '946641' },
	{ city: 'Cartrongilbert (Mayo)', zip: '481556' },
	{ city: 'Cartron Glebe (Offaly)', zip: '243573' },
	{ city: 'Cartrongolan (Longford)', zip: '538887' },
	{ city: 'Cartronhugh (Sligo)', zip: '382087' },
	{ city: 'Cartronkeel (Westmeath)', zip: '929273' },
	{ city: 'Cartronkillerdoo (Sligo)', zip: '206280' },
	{ city: 'Cartronkilly (Roscommon)', zip: '781423' },
	{ city: 'Cartronlahan (Galway)', zip: '518694' },
	{ city: 'Cartronlebagh (Longford)', zip: '470932' },
	{ city: 'Cartron Little (Longford)', zip: '151624' },
	{ city: 'Cartronmacmanus (Mayo)', zip: '552438' },
	{ city: 'Cartronmore (Sligo)', zip: '982905' },
	{ city: 'Cartron More (Roscommon)', zip: '411276' },
	{ city: 'Cartronnacross (Mayo)', zip: '321760' },
	{ city: 'Cartronnagilta (Cavan)', zip: '840229' },
	{ city: 'Cartron North (Galway)', zip: '338482' },
	{ city: 'Cartron North (Mayo)', zip: '972396' },
	{ city: 'Cartronofarry East (Sligo)', zip: '127031' },
	{ city: 'Cartronofarry South (Sligo)', zip: '462034' },
	{ city: 'Cartronofarry West (Sligo)', zip: '409283' },
	{ city: 'Cartronperagh (Roscommon)', zip: '163945' },
	{ city: 'Cartronplank (Sligo)', zip: '887686' },
	{ city: 'Cartronrathroe (Mayo)', zip: '859438' },
	{ city: 'Cartronreagh (Longford)', zip: '523683' },
	{ city: 'Cartronroe (Galway)', zip: '697658' },
	{ city: 'Cartronroe (Sligo)', zip: '487718' },
	{ city: 'Cartrons (Longford)', zip: '204762' },
	{ city: 'Cartrons (Westmeath)', zip: '389343' },
	{ city: 'Cartronsheela (Galway)', zip: '636104' },
	{ city: 'Cartron South (Galway)', zip: '247667' },
	{ city: 'Cartronstanton (Mayo)', zip: '503894' },
	{ city: 'Cartrontaylor (Sligo)', zip: '996455' },
	{ city: 'Cartrontonlena (Sligo)', zip: '685130' },
	{ city: 'Cartrontrellick (Galway)', zip: '285016' },
	{ city: 'Cartrontroy (Westmeath)', zip: '578245' },
	{ city: 'Cartron West (Galway)', zip: '248109' },
	{ city: 'Cartron West (Offaly)', zip: '455490' },
	{ city: 'Cartronwilliamoge (Sligo)', zip: '526128' },
	{ city: 'Carysfort (Dublin)', zip: '899521' },
	{ city: 'Casey Glebe (Donegal)', zip: '983900' },
	{ city: 'Cashel (Carlow)', zip: '358444' },
	{ city: 'Cashel (Cavan)', zip: '138705' },
	{ city: 'Cashel (Cork)', zip: '165483' },
	{ city: 'Cashel (Donegal)', zip: '764869' },
	{ city: 'Cashel (Galway)', zip: '814979' },
	{ city: 'Cashel (Kilkenny)', zip: '392021' },
	{ city: 'Cashel (Laois)', zip: '912045' },
	{ city: 'Cashel (Leitrim)', zip: '195792' },
	{ city: 'Cashel (Longford)', zip: '597183' },
	{ city: 'Cashel (Mayo)', zip: '469059' },
	{ city: 'Cashel (Meath)', zip: '837767' },
	{ city: 'Cashel (Monaghan)', zip: '301339' },
	{ city: 'Cashel (Roscommon)', zip: '614515' },
	{ city: 'Cashel (Sligo)', zip: '218119' },
	{ city: 'Cashel (Tipperary)', zip: '842075' },
	{ city: 'Cashel (Wexford)', zip: '607004' },
	{ city: 'Cashelard (Donegal)', zip: '932127' },
	{ city: 'Cashelard (Roscommon)', zip: '405143' },
	{ city: 'Cashelaveela (Leitrim)', zip: '264369' },
	{ city: 'Cashelbane (Cavan)', zip: '923746' },
	{ city: 'Cashelbeg (Longford)', zip: '169199' },
	{ city: 'Cashel Beg (Cork)', zip: '209254' },
	{ city: 'Cashelboy (Sligo)', zip: '458791' },
	{ city: 'Cashelcarn (Donegal)', zip: '238624' },
	{ city: 'Cashelcolaun (Roscommon)', zip: '207161' },
	{ city: 'Cashel Commons (Cork)', zip: '903224' },
	{ city: 'Cashelcummin (Donegal)', zip: '828471' },
	{ city: 'Cashelduff (Mayo)', zip: '930926' },
	{ city: 'Casheleenan (Donegal)', zip: '708448' },
	{ city: 'Cashelenny (Donegal)', zip: '756532' },
	{ city: 'Cashelfean (Cork)', zip: '266713' },
	{ city: 'Cashelfean (Donegal)', zip: '959090' },
	{ city: 'Cashelfinoge (Roscommon)', zip: '554428' },
	{ city: 'Cashelgarran (Sligo)', zip: '882000' },
	{ city: 'Cashelgay (Donegal)', zip: '730765' },
	{ city: 'Cashel Glebe (Donegal)', zip: '348971' },
	{ city: 'Cashelgolan (Donegal)', zip: '540221' },
	{ city: 'Cashelin (Donegal)', zip: '107496' },
	{ city: 'Cashelisky (Cork)', zip: '705849' },
	{ city: 'Cashelkeelty (Kerry)', zip: '716158' },
	{ city: 'Cashellackan (Donegal)', zip: '619349' },
	{ city: 'Cashellahenny (Mayo)', zip: '141352' },
	{ city: 'Cashel Lower (Mayo)', zip: '592899' },
	{ city: 'Cashelmeehan (Roscommon)', zip: '299423' },
	{ city: 'Cashelmore (Donegal)', zip: '746866' },
	{ city: 'Cashel More (Cork)', zip: '750207' },
	{ city: 'Cashelnagole (Roscommon)', zip: '488877' },
	{ city: 'Cashelnagor (Donegal)', zip: '481635' },
	{ city: 'Cashelnavean (Donegal)', zip: '205028' },
	{ city: 'Cashel North (Sligo)', zip: '343906' },
	{ city: 'Cashelodogherty (Donegal)', zip: '198261' },
	{ city: 'Casheloogary (Donegal)', zip: '124663' },
	{ city: 'Cashelpreaghan (Donegal)', zip: '936392' },
	{ city: 'Cashelreagh (Donegal)', zip: '352263' },
	{ city: 'Cashelreagh Glebe (Donegal)', zip: '760723' },
	{ city: 'Cashels (Mayo)', zip: '990615' },
	{ city: 'Cashelshanaghan (Donegal)', zip: '696096' },
	{ city: 'Cashel South (Sligo)', zip: '664710' },
	{ city: 'Casheltauna (Roscommon)', zip: '549207' },
	{ city: 'Casheltourly (Mayo)', zip: '907278' },
	{ city: 'Casheltown (Donegal)', zip: '645654' },
	{ city: 'Casheltown Mountain (Donegal)', zip: '907058' },
	{ city: 'Cashel Upper (Mayo)', zip: '550512' },
	{ city: 'Cashla (Galway)', zip: '449082' },
	{ city: 'Cashlagh (Kerry)', zip: '723977' },
	{ city: 'Cashlan (Monaghan)', zip: '409263' },
	{ city: 'Cashlancran (Mayo)', zip: '205286' },
	{ city: 'Cashlan East (Monaghan)', zip: '247541' },
	{ city: 'Cashlan West (Monaghan)', zip: '336174' },
	{ city: 'Cashlaundarragh (Galway)', zip: '110026' },
	{ city: 'Cashleen (Galway)', zip: '804068' },
	{ city: 'Cashlieve (Roscommon)', zip: '934723' },
	{ city: 'Cashloura (Cork)', zip: '595301' },
	{ city: 'Caslanakirka (Westmeath)', zip: '473002' },
	{ city: 'Cassagh (Kilkenny)', zip: '497225' },
	{ city: 'Cassarnagh (Clare)', zip: '895418' },
	{ city: 'Cassestown (Tipperary)', zip: '571113' },
	{ city: 'Castaheany (Dublin)', zip: '416376' },
	{ city: 'Castle (Galway)', zip: '427885' },
	{ city: 'Castleaffy (Mayo)', zip: '361347' },
	{ city: 'Castleannesley (Wexford)', zip: '588113' },
	{ city: 'Castlearmstrong (Offaly)', zip: '856748' },
	{ city: 'Castlebaldwin (Sligo)', zip: '613234' },
	{ city: 'Castlebane (Donegal)', zip: '137802' },
	{ city: 'Castlebank (Clare)', zip: '736960' },
	{ city: 'Castlebanny (Kilkenny)', zip: '514601' },
	{ city: 'Castlebar (Mayo)', zip: '365892' },
	{ city: 'Castlebarnagh (Mayo)', zip: '263186' },
	{ city: 'Castlebarnagh Big (Offaly)', zip: '243341' },
	{ city: 'Castlebarnagh Little (Offaly)', zip: '484988' },
	{ city: 'Castlebarrett (Cork)', zip: '533669' },
	{ city: 'Castlebaun (Longford)', zip: '318517' },
	{ city: 'Castlebellew (Galway)', zip: '632954' },
	{ city: 'Castlebellingham (Louth)', zip: '913330' },
	{ city: 'Castlebernard (Cork)', zip: '481558' },
	{ city: 'Castlebin East (Galway)', zip: '171223' },
	{ city: 'Castlebin North (Galway)', zip: '555799' },
	{ city: 'Castlebin South (Galway)', zip: '129937' },
	{ city: 'Castleblagh (Cork)', zip: '307976' },
	{ city: 'Castleblake (Tipperary)', zip: '214802' },
	{ city: 'Castleblakeney (Galway)', zip: '261859' },
	{ city: 'Castleblaugh (Donegal)', zip: '166717' },
	{ city: 'Castleblayney (Monaghan)', zip: '913566' },
	{ city: 'Castleblunden (Kilkenny)', zip: '749213' },
	{ city: 'Castleboro Demesne (Wexford)', zip: '185142' },
	{ city: 'Castleboy (Galway)', zip: '414475' },
	{ city: 'Castleboy (Meath)', zip: '377663' },
	{ city: 'Castlebrack (Laois)', zip: '238775' },
	{ city: 'Castlebridge (Wexford)', zip: '873796' },
	{ city: 'Castlebrock (Longford)', zip: '301154' },
	{ city: 'Castlebrown (Kildare)', zip: '667359' },
	{ city: 'Castleburke (Mayo)', zip: '182661' },
	{ city: 'Castlecarra (Mayo)', zip: '426795' },
	{ city: 'Castlecarragh (Louth)', zip: '447572' },
	{ city: 'Castlecluggin (Limerick)', zip: '981820' },
	{ city: 'Castlecolumb (Kilkenny)', zip: '389264' },
	{ city: 'Castlecomer (Kilkenny)', zip: '159462' },
	{ city: 'Castleconnell (Limerick)', zip: '356736' },
	{ city: 'Castleconor (Laois)', zip: '244710' },
	{ city: 'Castleconor (Mayo)', zip: '600007' },
	{ city: 'Castleconway (Kerry)', zip: '849252' },
	{ city: 'Castlecooke (Cork)', zip: '385034' },
	{ city: 'Castlecooly (Donegal)', zip: '207627' },
	{ city: 'Castlecoote (Roscommon)', zip: '459255' },
	{ city: 'Castlecor (Cork)', zip: '367256' },
	{ city: 'Castlecor (Meath)', zip: '554190' },
	{ city: 'Castlecor Demesne (Cork)', zip: '363395' },
	{ city: 'Castlecore (Longford)', zip: '291999' },
	{ city: 'Castlecosker (Kilkenny)', zip: '262760' },
	{ city: 'Castle Cove (Kerry)', zip: '481639' },
	{ city: 'Castlecoyne (Tipperary)', zip: '487754' },
	{ city: 'Castlecraddock (Waterford)', zip: '695747' },
	{ city: 'Castlecraddockbog (Waterford)', zip: '246045' },
	{ city: 'Castlecranna (Tipperary)', zip: '243052' },
	{ city: 'Castlecreagh (Limerick)', zip: '623628' },
	{ city: 'Castlecreevy (Galway)', zip: '177595' },
	{ city: 'Castlecrine (Clare)', zip: '754005' },
	{ city: 'Castlecrunnoge (Mayo)', zip: '292183' },
	{ city: 'Castlecuffe (Laois)', zip: '760628' },
	{ city: 'Castledaly (Galway)', zip: '109897' },
	{ city: 'Castledargan (Sligo)', zip: '593153' },
	{ city: 'Castle Demesne (Limerick)', zip: '417335' },
	{ city: 'Castledermot (Kildare)', zip: '388176' },
	{ city: 'Castlederry (Cork)', zip: '182002' },
	{ city: 'Castledillon Lower (Kildare)', zip: '803386' },
	{ city: 'Castledillon Upper (Kildare)', zip: '210668' },
	{ city: 'Castledoe (Donegal)', zip: '407857' },
	{ city: 'Castledonovan (Cork)', zip: '806835' },
	{ city: 'Castledowey (Donegal)', zip: '643218' },
	{ city: 'Castledown (Westmeath)', zip: '503577' },
	{ city: 'Castledrum (Kerry)', zip: '271552' },
	{ city: 'Castledurrow Demesne (Laois)', zip: '737751' },
	{ city: 'Castle Ellen (Galway)', zip: '964773' },
	{ city: 'Castleellis (Wexford)', zip: '802118' },
	{ city: 'Castle Ellis (Kilkenny)', zip: '850746' },
	{ city: 'Castle-Erkin North (Limerick)', zip: '610529' },
	{ city: 'Castle-Erkin South (Limerick)', zip: '632936' },
	{ city: 'Castle Eve (Kilkenny)', zip: '977152' },
	{ city: 'Castlefarm (Dublin)', zip: '298335' },
	{ city: 'Castlefarm (Galway)', zip: '237526' },
	{ city: 'Castlefarm (Kerry)', zip: '768550' },
	{ city: 'Castlefarm (Kildare)', zip: '628601' },
	{ city: 'Castlefarm (Limerick)', zip: '399574' },
	{ city: 'Castlefarm (Meath)', zip: '438829' },
	{ city: 'Castlefergus (Clare)', zip: '301787' },
	{ city: 'Castle Ffrench (Galway)', zip: '646071' },
	{ city: 'Castle Ffrench East (Galway)', zip: '221022' },
	{ city: 'Castle Ffrench West (Galway)', zip: '894512' },
	{ city: 'Castlefield (Galway)', zip: '273553' },
	{ city: 'Castlefield (Kilkenny)', zip: '901137' },
	{ city: 'Castlefield (Offaly)', zip: '699966' },
	{ city: 'Castlefinn (Donegal)', zip: '875319' },
	{ city: 'Castlefish (Kildare)', zip: '230877' },
	{ city: 'Castlefleming (Laois)', zip: '758171' },
	{ city: 'Castlefogarty (Tipperary)', zip: '555111' },
	{ city: 'Castleforbes Demesne (Longford)', zip: '554974' },
	{ city: 'Castleforward Demesne (Donegal)', zip: '946588' },
	{ city: 'Castlefreke (Cork)', zip: '159984' },
	{ city: 'Castlefreke-Island (Cork)', zip: '999751' },
	{ city: 'Castlefreke-Warren (Cork)', zip: '382607' },
	{ city: 'Castlegaddery (Westmeath)', zip: '830282' },
	{ city: 'Castlegal (Sligo)', zip: '112539' },
	{ city: 'Castlegannon (Kilkenny)', zip: '821556' },
	{ city: 'Castlegar (Galway)', zip: '888312' },
	{ city: 'Castlegar (Mayo)', zip: '128715' },
	{ city: 'Castlegarde (Limerick)', zip: '873866' },
	{ city: 'Castlegarden (Kilkenny)', zip: '707731' },
	{ city: 'Castlegar East (Galway)', zip: '684382' },
	{ city: 'Castlegar West (Galway)', zip: '712808' },
	{ city: 'Castlegowan (Sligo)', zip: '336068' },
	{ city: 'Castlegrace (Carlow)', zip: '870426' },
	{ city: 'Castlegrace (Tipperary)', zip: '543503' },
	{ city: 'Castlegrange (Wicklow)', zip: '668330' },
	{ city: 'Castlegregory (Kerry)', zip: '869802' },
	{ city: 'Castlegrey (Limerick)', zip: '570873' },
	{ city: 'Castlegrogan (Laois)', zip: '143935' },
	{ city: 'Castlegrove East (Galway)', zip: '169484' },
	{ city: 'Castlegrove West (Galway)', zip: '592904' },
	{ city: 'Castlehacket (Galway)', zip: '251884' },
	{ city: 'Castleharrison (Cork)', zip: '179857' },
	{ city: 'Castlehaven (Cork)', zip: '485441' },
	{ city: 'Castlehaystown (Wexford)', zip: '827771' },
	{ city: 'Castlehiggins (Tipperary)', zip: '191028' },
	{ city: 'Castlehill (Mayo)', zip: '659046' },
	{ city: 'Castlehill (Tipperary)', zip: '377072' },
	{ city: 'Castleholding (Tipperary)', zip: '777700' },
	{ city: 'Castlehoward (Wicklow)', zip: '933898' },
	{ city: 'Castlehyde (Cork)', zip: '588764' },
	{ city: 'Castlehyde East (Cork)', zip: '891728' },
	{ city: 'Castlehyde West (Cork)', zip: '396776' },
	{ city: 'Castleinch (Cork)', zip: '371569' },
	{ city: 'Castleinch (Kilkenny)', zip: '934086' },
	{ city: 'Castleisland (Kerry)', zip: '143724' },
	{ city: 'Castle Island (Cork)', zip: '165104' },
	{ city: 'Castlejohn (Tipperary)', zip: '163355' },
	{ city: 'Castlejordan (Meath)', zip: '433173' },
	{ city: 'Castlekeale (Tipperary)', zip: '365871' },
	{ city: 'Castlekeely (Kildare)', zip: '820549' },
	{ city: 'Castlekeeran (Meath)', zip: '362006' },
	{ city: 'Castlekelly (Dublin)', zip: '773530' },
	{ city: 'Castlekelly (Kilkenny)', zip: '194512' },
	{ city: 'Castlekevin (Cork)', zip: '803434' },
	{ city: 'Castlekevin (Wicklow)', zip: '269636' },
	{ city: 'Castleknock (Dublin)', zip: '233216' },
	{ city: 'Castlelackan Demesne (Mayo)', zip: '271291' },
	{ city: 'Castlelake (Clare)', zip: '847294' },
	{ city: 'Castlelake (Tipperary)', zip: '966275' },
	{ city: 'Castlelambert (Galway)', zip: '537747' },
	{ city: 'Castleland (Dublin)', zip: '413673' },
	{ city: 'Castleland (Roscommon)', zip: '711434' },
	{ city: 'Castleland (Wexford)', zip: '263092' },
	{ city: 'Castle-Land (Cork)', zip: '563738' },
	{ city: 'Castlelands (Cork)', zip: '765107' },
	{ city: 'Castlelands (Waterford)', zip: '423143' },
	{ city: 'Castleleiny (Tipperary)', zip: '916183' },
	{ city: 'Castlelishen (Cork)', zip: '819242' },
	{ city: 'Castlelloyd (Limerick)', zip: '763982' },
	{ city: 'Castlelohort Demesne (Cork)', zip: '804125' },
	{ city: 'Castlelost (Westmeath)', zip: '476435' },
	{ city: 'Castlelost West (Westmeath)', zip: '135847' },
	{ city: 'Castlelough (Kerry)', zip: '332527' },
	{ city: 'Castlelough (Tipperary)', zip: '628127' },
	{ city: 'Castle Lower (Cork)', zip: '706082' },
	{ city: 'Castleloye (Sligo)', zip: '318942' },
	{ city: 'Castlelucas (Mayo)', zip: '419417' },
	{ city: 'Castlelumny (Louth)', zip: '604715' },
	{ city: 'Castlelyons (Cork)', zip: '545030' },
	{ city: 'Castlemacadam (Wicklow)', zip: '785505' },
	{ city: 'Castlemacauliffe (Cork)', zip: '393613' },
	{ city: 'Castlemagarret North (Mayo)', zip: '752123' },
	{ city: 'Castlemagarretpark New (Mayo)', zip: '713062' },
	{ city: 'Castlemagarretpark Old (Mayo)', zip: '436204' },
	{ city: 'Castlemagner (Cork)', zip: '292204' },
	{ city: 'Castlemaine (Kerry)', zip: '844594' },
	{ city: 'Castlemarket (Kilkenny)', zip: '296684' },
	{ city: 'Castlemarket East (Kilkenny)', zip: '258599' },
	{ city: 'Castlemarket West (Kilkenny)', zip: '989694' },
	{ city: 'Castlemartin (Kildare)', zip: '434651' },
	{ city: 'Castlemartin (Meath)', zip: '308913' },
	{ city: 'Castlemartyr (Cork)', zip: '863415' },
	{ city: 'Castlemary (Cork)', zip: '595906' },
	{ city: 'Castlematrix (Limerick)', zip: '598453' },
	{ city: 'Castlemehigan (Cork)', zip: '776975' },
	{ city: 'Castlemiles (Waterford)', zip: '410347' },
	{ city: 'Castlemitchell North (Kildare)', zip: '913285' },
	{ city: 'Castlemitchell South (Kildare)', zip: '289404' },
	{ city: 'Castlemore (Carlow)', zip: '265320' },
	{ city: 'Castlemore (Cork)', zip: '771622' },
	{ city: 'Castlemorris (Kilkenny)', zip: '531203' },
	{ city: 'Castlemoyle (Galway)', zip: '895611' },
	{ city: 'Castlemoyle (Wexford)', zip: '563573' },
	{ city: 'Castlemoyle North (Tipperary)', zip: '166194' },
	{ city: 'Castlemoyle South (Tipperary)', zip: '498823' },
	{ city: 'Castlemungret (Limerick)', zip: '401863' },
	{ city: 'Castlenageeha (Mayo)', zip: '675039' },
	{ city: 'Castlenalact (Cork)', zip: '367939' },
	{ city: 'Castlenancy (Galway)', zip: '353025' },
	{ city: 'Castlenode (Roscommon)', zip: '896706' },
	{ city: 'Castlenugent (Longford)', zip: '460696' },
	{ city: 'Castleoliver (Limerick)', zip: '227746' },
	{ city: 'Castleore (Sligo)', zip: '400596' },
	{ city: 'Castlepaliser (Wexford)', zip: '476824' },
	{ city: 'Castlepark (Clare)', zip: '400475' },
	{ city: 'Castlepark (Cork)', zip: '861337' },
	{ city: 'Castlepark (Galway)', zip: '805690' },
	{ city: 'Castlepark (Tipperary)', zip: '524241' },
	{ city: 'Castleparks (Meath)', zip: '240882' },
	{ city: 'Castleplunket (Roscommon)', zip: '508720' },
	{ city: 'Castlepoint (Cork)', zip: '141907' },
	{ city: 'Castlepole (Meath)', zip: '438538' },
	{ city: 'Castlepoles (Cavan)', zip: '459448' },
	{ city: 'Castlepollard (Westmeath)', zip: '339894' },
	{ city: 'Castlepook North (Cork)', zip: '627682' },
	{ city: 'Castlepook South (Cork)', zip: '480902' },
	{ city: 'Castlequarter (Clare)', zip: '466793' },
	{ city: 'Castlequarter (Cork)', zip: '667759' },
	{ city: 'Castlequarter (Donegal)', zip: '624465' },
	{ city: 'Castlequarter (Galway)', zip: '454577' },
	{ city: 'Castlequarter (Kerry)', zip: '699304' },
	{ city: 'Castlequarter (Laois)', zip: '718199' },
	{ city: 'Castlequarter (Limerick)', zip: '986190' },
	{ city: 'Castlequarter (Roscommon)', zip: '766969' },
	{ city: 'Castlequarter (Tipperary)', zip: '693694' },
	{ city: 'Castlequarter (Waterford)', zip: '330405' },
	{ city: 'Castlequarter (Wexford)', zip: '380803' },
	{ city: 'Castlequarter (Wicklow)', zip: '594653' },
	{ city: 'Castlequarter Kilkeedy (Clare)', zip: '581528' },
	{ city: 'Castlequin (Kerry)', zip: '817277' },
	{ city: 'Castlerahan (Cavan)', zip: '364292' },
	{ city: 'Castlerea (Longford)', zip: '386791' },
	{ city: 'Castlerea (Roscommon)', zip: '881142' },
	{ city: 'Castlereagh (Mayo)', zip: '705285' },
	{ city: 'Castlereagh (Offaly)', zip: '466396' },
	{ city: 'Castlereagh (Roscommon)', zip: '923772' },
	{ city: 'Castlereagh (Waterford)', zip: '681820' },
	{ city: 'Castlerea Mountain (Longford)', zip: '450614' },
	{ city: 'Castlereban North (Kildare)', zip: '321854' },
	{ city: 'Castlereban South (Kildare)', zip: '838447' },
	{ city: 'Castleredmond (Cork)', zip: '737184' },
	{ city: 'Castlerichard (Cork)', zip: '895747' },
	{ city: 'Castlerickard (Meath)', zip: '910611' },
	{ city: 'Castlering (Louth)', zip: '955217' },
	{ city: 'Castleroan (Offaly)', zip: '210012' },
	{ city: 'Castleroberts (Limerick)', zip: '229681' },
	{ city: 'Castlerock (Sligo)', zip: '890012' },
	{ city: 'Castleroe East (Kildare)', zip: '935548' },
	{ city: 'Castleroe West (Kildare)', zip: '977925' },
	{ city: 'Castlerogy (Leitrim)', zip: '173688' },
	{ city: 'Castleroyan (Mayo)', zip: '333945' },
	{ city: 'Castleruby (Roscommon)', zip: '157316' },
	{ city: 'Castleruddery Lower (Wicklow)', zip: '944134' },
	{ city: 'Castleruddery Upper (Wicklow)', zip: '658798' },
	{ city: 'Castlesaffron (Cork)', zip: '960099' },
	{ city: 'Castlesallagh (Wicklow)', zip: '317751' },
	{ city: 'Castlesampson (Roscommon)', zip: '251927' },
	{ city: 'Castlesaunderson Demesne (Cavan)', zip: '872284' },
	{ city: 'Castleshane (Monaghan)', zip: '976694' },
	{ city: 'Castleshane Demesne (Monaghan)', zip: '185964' },
	{ city: 'Castleshannon (Kerry)', zip: '295404' },
	{ city: 'Castlesheela (Tipperary)', zip: '209775' },
	{ city: 'Castlesheenaghan (Mayo)', zip: '996634' },
	{ city: 'Castlesize (Kildare)', zip: '975564' },
	{ city: 'Castlesow (Wexford)', zip: '906956' },
	{ city: 'Castlestrange (Roscommon)', zip: '547513' },
	{ city: 'Castletalbot (Wexford)', zip: '206115' },
	{ city: 'Castletate (Louth)', zip: '898063' },
	{ city: 'Castletaylor North (Galway)', zip: '922076' },
	{ city: 'Castletaylor South (Galway)', zip: '779511' },
	{ city: 'Castleteheen (Roscommon)', zip: '574417' },
	{ city: 'Castletenison Demesne (Roscommon)', zip: '539960' },
	{ city: 'Castleterra (Cavan)', zip: '246163' },
	{ city: 'Castleterry (Cork)', zip: '473776' },
	{ city: 'Castlethird (Donegal)', zip: '195928' },
	{ city: 'Castletimon (Wicklow)', zip: '896650' },
	{ city: 'Castletobin (Kilkenny)', zip: '929059' },
	{ city: 'Castletobin East (Kilkenny)', zip: '702572' },
	{ city: 'Castletobin West (Kilkenny)', zip: '577720' },
	{ city: 'Castletogher (Galway)', zip: '316966' },
	{ city: 'Castletorrison (Donegal)', zip: '980722' },
	{ city: 'Castletown (Carlow)', zip: '811842' },
	{ city: 'Castletown (Clare)', zip: '204756' },
	{ city: 'Castletown (Cork)', zip: '770421' },
	{ city: 'Castletown (Donegal)', zip: '131577' },
	{ city: 'Castletown (Galway)', zip: '794423' },
	{ city: 'Castletown (Kerry)', zip: '730307' },
	{ city: 'Castletown (Kildare)', zip: '642442' },
	{ city: 'Castletown (Kilkenny)', zip: '954682' },
	{ city: 'Castletown (Laois)', zip: '360583' },
	{ city: 'Castletown (Leitrim)', zip: '329101' },
	{ city: 'Castletown (Limerick)', zip: '198797' },
	{ city: 'Castletown (Louth)', zip: '558299' },
	{ city: 'Castletown (Mayo)', zip: '248150' },
	{ city: 'Castletown (Meath)', zip: '784735' },
	{ city: 'Castletown (Offaly)', zip: '200141' },
	{ city: 'Castletown (Roscommon)', zip: '101785' },
	{ city: 'Castletown (Sligo)', zip: '157921' },
	{ city: 'Castletown (Tipperary)', zip: '940536' },
	{ city: 'Castletown (Waterford)', zip: '994782' },
	{ city: 'Castletown (Westmeath)', zip: '895218' },
	{ city: 'Castletown (Wexford)', zip: '740378' },
	{ city: 'Castletown And Glinsk (Offaly)', zip: '673046' },
	{ city: 'Castletown Bearhaven (Cork)', zip: '675247' },
	{ city: 'Castletowncooley (Louth)', zip: '793098' },
	{ city: 'Castletowndelvin (Westmeath)', zip: '785204' },
	{ city: 'Castletown Geoghegan (Westmeath)', zip: '664577' },
	{ city: 'Castletown Kilberry (Meath)', zip: '602449' },
	{ city: 'Castletown Lower (Westmeath)', zip: '179193' },
	{ city: 'Castletownmoor (Meath)', zip: '110025' },
	{ city: 'Castletownroche (Cork)', zip: '473564' },
	{ city: 'Castletownsend (Cork)', zip: '368191' },
	{ city: 'Castletownshend (Cork)', zip: '648283' },
	{ city: 'Castletown Tara (Meath)', zip: '405886' },
	{ city: 'Castletown Upper (Westmeath)', zip: '138903' },
	{ city: 'Castletreasure (Cork)', zip: '387281' },
	{ city: 'Castletrench (Laois)', zip: '921341' },
	{ city: 'Castletroy (Limerick)', zip: '357890' },
	{ city: 'Castleturvin (Galway)', zip: '948025' },
	{ city: 'Castle Upper (Cork)', zip: '683141' },
	{ city: 'Castleventry (Cork)', zip: '155651' },
	{ city: 'Castleview (Cork)', zip: '668090' },
	{ city: 'Castleview (Kerry)', zip: '499016' },
	{ city: 'Castleview (Laois)', zip: '528968' },
	{ city: 'Castlewaller (Tipperary)', zip: '530523' },
	{ city: 'Castlewarden (Dublin)', zip: '446816' },
	{ city: 'Castlewarden North (Kildare)', zip: '644274' },
	{ city: 'Castlewarden South (Kildare)', zip: '787532' },
	{ city: 'Castlewarren (Kilkenny)', zip: '181021' },
	{ city: 'Castlewhite (Wexford)', zip: '429838' },
	{ city: 'Castlewidenham (Cork)', zip: '989518' },
	{ city: 'Castlewilder (Longford)', zip: '318995' },
	{ city: 'Castlewood (Laois)', zip: '752358' },
	{ city: 'Castleworkhouse (Wexford)', zip: '360181' },
	{ city: 'Castlewray (Donegal)', zip: '496385' },
	{ city: 'Castlewrixon (Cork)', zip: '263217' },
	{ city: 'Castlewrixon South (Cork)', zip: '253095' },
	{ city: 'Castruse (Donegal)', zip: '353365' },
	{ city: 'Catfort (Mayo)', zip: '908027' },
	{ city: 'Cathaganstown (Tipperary)', zip: '352603' },
	{ city: 'Catherinestown (Kildare)', zip: '744354' },
	{ city: 'Catherinestown (Westmeath)', zip: '321070' },
	{ city: 'Catsrock (Kilkenny)', zip: '503674' },
	{ city: 'Catstown (Kilkenny)', zip: '389413' },
	{ city: 'Cattan (Leitrim)', zip: '911321' },
	{ city: 'Cauhoo (Cavan)', zip: '550262' },
	{ city: 'Caul (Roscommon)', zip: '700844' },
	{ city: 'Caulicaun (Mayo)', zip: '466473' },
	{ city: 'Caulstown (Meath)', zip: '694951' },
	{ city: 'Caum (Cork)', zip: '812939' },
	{ city: 'Caumglen (Waterford)', zip: '426002' },
	{ city: 'Caunteens (Kerry)', zip: '551878' },
	{ city: 'Cauran (Westmeath)', zip: '477167' },
	{ city: 'Caurans Lower (Mayo)', zip: '829162' },
	{ city: 'Caurans Upper (Mayo)', zip: '690440' },
	{ city: 'Caureen (Kildare)', zip: '999354' },
	{ city: 'Causestown (Dublin)', zip: '250520' },
	{ city: 'Causestown (Meath)', zip: '115849' },
	{ city: 'Causeway (Kerry)', zip: '480338' },
	{ city: 'Cauteen (Tipperary)', zip: '415195' },
	{ city: 'Cavan (Cavan)', zip: '648415' },
	{ city: 'Cavan (Donegal)', zip: '649499' },
	{ city: 'Cavan (Leitrim)', zip: '479791' },
	{ city: 'Cavan (Longford)', zip: '153915' },
	{ city: 'Cavan (Louth)', zip: '590231' },
	{ city: 'Cavan (Mayo)', zip: '322682' },
	{ city: 'Cavan (Monaghan)', zip: '486102' },
	{ city: 'Cavanacaw (Donegal)', zip: '585776' },
	{ city: 'Cavanacor (Donegal)', zip: '730396' },
	{ city: 'Cavanacross (Monaghan)', zip: '191840' },
	{ city: 'Cavanagarvan (Monaghan)', zip: '528601' },
	{ city: 'Cavanageeragh (Monaghan)', zip: '293703' },
	{ city: 'Cavanagh (Cavan)', zip: '793311' },
	{ city: 'Cavanaguillagh (Monaghan)', zip: '774727' },
	{ city: 'Cavananore (Louth)', zip: '749444' },
	{ city: 'Cavanaquill (Cavan)', zip: '815068' },
	{ city: 'Cavanarainy (Cavan)', zip: '159710' },
	{ city: 'Cavanavally (Monaghan)', zip: '604263' },
	{ city: 'Cavanaweery (Donegal)', zip: '599790' },
	{ city: 'Cavancoulter (Cavan)', zip: '273677' },
	{ city: 'Cavancreevy (Monaghan)', zip: '535452' },
	{ city: 'Cavanfin (Cavan)', zip: '735452' },
	{ city: 'Cavangarden (Donegal)', zip: '234883' },
	{ city: 'Cavanleckagh (Monaghan)', zip: '482154' },
	{ city: 'Cavan Lower (Donegal)', zip: '295465' },
	{ city: 'Cavanmore (Monaghan)', zip: '320213' },
	{ city: 'Cavanquarter (Mayo)', zip: '235629' },
	{ city: 'Cavanreagh (Monaghan)', zip: '742837' },
	{ city: 'Cavanrobert (Louth)', zip: '782491' },
	{ city: 'Cavansheath (Laois)', zip: '524457' },
	{ city: 'Cavanskeldragh (Cavan)', zip: '538190' },
	{ city: 'Cavantimahon (Cavan)', zip: '253468' },
	{ city: 'Cavan Upper (Donegal)', zip: '574071' },
	{ city: 'Cavany (Monaghan)', zip: '239809' },
	{ city: 'Cave (Galway)', zip: '927533' },
	{ city: 'Cave (Mayo)', zip: '135143' },
	{ city: 'Cavestown And Rosmead (Westmeath)', zip: '610537' },
	{ city: 'Cavetown (Roscommon)', zip: '111822' },
	{ city: 'Ceancullig (Cork)', zip: '172730' },
	{ city: 'Cecilstown (Cork)', zip: '241863' },
	{ city: 'Celbridge (Kildare)', zip: '910344' },
	{ city: 'Celbridge Abbey (Kildare)', zip: '139061' },
	{ city: 'Cellarstown East (Kilkenny)', zip: '113108' },
	{ city: 'Cellarstown Lower (Kilkenny)', zip: '994739' },
	{ city: 'Cellarstown Upper (Kilkenny)', zip: '676520' },
	{ city: 'Cellarstown West (Kilkenny)', zip: '398064' },
	{ city: 'Censure (Dublin)', zip: '147964' },
	{ city: 'Chacefield (Sligo)', zip: '598690' },
	{ city: 'Chadville (Tipperary)', zip: '483091' },
	{ city: 'Chaffpool (Sligo)', zip: '644090' },
	{ city: 'Chalkhill (Tipperary)', zip: '636646' },
	{ city: 'Chamberlainstown (Meath)', zip: '268675' },
	{ city: 'Chamberlainstown (Tipperary)', zip: '236663' },
	{ city: 'Chambersland (Wexford)', zip: '252815' },
	{ city: 'Chamberstown (Meath)', zip: '602243' },
	{ city: 'Chancellorsland (Tipperary)', zip: '233192' },
	{ city: 'Chancellorstown Lower (Tipperary)', zip: '812277' },
	{ city: 'Chancellorstown Upper (Tipperary)', zip: '427562' },
	{ city: 'Chancery (Westmeath)', zip: '637500' },
	{ city: 'Chanonrock (Louth)', zip: '436415' },
	{ city: 'Chanonstown (Westmeath)', zip: '721514' },
	{ city: 'Chanterland (Roscommon)', zip: '746975' },
	{ city: 'Chanterlands (Kildare)', zip: '334703' },
	{ city: 'Chantersland (Tipperary)', zip: '166389' },
	{ city: 'Chapel (Wexford)', zip: '639003' },
	{ city: 'Chapel (Wicklow)', zip: '450601' },
	{ city: 'Chapelbride (Meath)', zip: '629596' },
	{ city: 'Chapelfarm (Kildare)', zip: '593580' },
	{ city: 'Chapelfield (Galway)', zip: '629653' },
	{ city: 'Chapelhill (Laois)', zip: '962418' },
	{ city: 'Chapelizod (Dublin)', zip: '793666' },
	{ city: 'Chapel Land (Meath)', zip: '606940' },
	{ city: 'Chapelpark (Galway)', zip: '315217' },
	{ city: 'Chapel Quarter (Kerry)', zip: '386377' },
	{ city: 'Chapelstown (Carlow)', zip: '155695' },
	{ city: 'Chapeltown (Kerry)', zip: '468301' },
	{ city: 'Charlesfield (Cork)', zip: '344167' },
	{ city: 'Charlesland (Wicklow)', zip: '666320' },
	{ city: 'Charlestown (Dublin)', zip: '515169' },
	{ city: 'Charlestown (Galway)', zip: '602656' },
	{ city: 'Charlestown (Kilkenny)', zip: '827522' },
	{ city: 'Charlestown (Louth)', zip: '523900' },
	{ city: 'Charlestown (Mayo)', zip: '560548' },
	{ city: 'Charlestown (Offaly)', zip: '577753' },
	{ city: 'Charlestown (Roscommon)', zip: '112778' },
	{ city: 'Charleville (Cork)', zip: '808634' },
	{ city: 'Charleville (Louth)', zip: '297630' },
	{ city: 'Charleville Demesne (Offaly)', zip: '604134' },
	{ city: 'Charleville Demesne (Wicklow)', zip: '760073' },
	{ city: 'Charstown (Dublin)', zip: '957693' },
	{ city: 'Charterschoolland (Meath)', zip: '299032' },
	{ city: 'Charterschool Land (Kilkenny)', zip: '563746' },
	{ city: 'Charterschool Land (Tipperary)', zip: '693140' },
	{ city: 'Cheekpoint (Waterford)', zip: '956621' },
	{ city: 'Cheesemount (Tipperary)', zip: '524552' },
	{ city: 'Cheeverstown (Dublin)', zip: '598636' },
	{ city: 'Cheeverstown (Meath)', zip: '962249' },
	{ city: 'Chelsea (Galway)', zip: '248457' },
	{ city: 'Cherriestown (Wexford)', zip: '682436' },
	{ city: 'Cherrybrook (Leitrim)', zip: '970660' },
	{ city: 'Cherryfield (Mayo)', zip: '141055' },
	{ city: 'Cherryfield (Roscommon)', zip: '312752' },
	{ city: 'Cherryhound (Dublin)', zip: '528609' },
	{ city: 'Cherrymills (Kildare)', zip: '564893' },
	{ city: 'Cherrymount (Donegal)', zip: '228466' },
	{ city: 'Cherrymount (Kilkenny)', zip: '843682' },
	{ city: 'Cherrymount (Waterford)', zip: '702968' },
	{ city: 'Cherrymount (Wicklow)', zip: '704739' },
	{ city: 'Cherryorchard (Wexford)', zip: '704512' },
	{ city: 'Cherryvalley (Meath)', zip: '363042' },
	{ city: 'Cherryville (Kildare)', zip: '817584' },
	{ city: 'Cherrywood (Dublin)', zip: '523777' },
	{ city: 'Chetwynd (Cork)', zip: '877371' },
	{ city: 'Chevychase (Offaly)', zip: '487115' },
	{ city: 'Chimneyfield (Cork)', zip: '966065' },
	{ city: 'Chour (Wexford)', zip: '134626' },
	{ city: 'Christendom (Kilkenny)', zip: '192495' },
	{ city: 'Christianstown (Kildare)', zip: '295351' },
	{ city: 'Christianstown (Louth)', zip: '302548' },
	{ city: 'Christianstown (Westmeath)', zip: '452886' },
	{ city: 'Churchacres (Roscommon)', zip: '606599' },
	{ city: 'Churchclara (Kilkenny)', zip: '651856' },
	{ city: 'Church Cross (Cork)', zip: '252714' },
	{ city: 'Churchfield (Kerry)', zip: '282826' },
	{ city: 'Churchfield (Laois)', zip: '306543' },
	{ city: 'Churchfield (Leitrim)', zip: '770926' },
	{ city: 'Churchfield (Limerick)', zip: '746137' },
	{ city: 'Churchfield (Mayo)', zip: '741474' },
	{ city: 'Churchfield (Tipperary)', zip: '875482' },
	{ city: 'Churchfield Lower (Mayo)', zip: '583359' },
	{ city: 'Churchfield Upper (Mayo)', zip: '138365' },
	{ city: 'Churchground (Kerry)', zip: '668492' },
	{ city: 'Church Hill (Cork)', zip: '330857' },
	{ city: 'Church Hill (Donegal)', zip: '420946' },
	{ city: 'Church Hill (Kilkenny)', zip: '151093' },
	{ city: 'Church Hill (Monaghan)', zip: '555832' },
	{ city: 'Church Hill (Offaly)', zip: '259117' },
	{ city: 'Church Hill (Roscommon)', zip: '494319' },
	{ city: 'Church Hill (Sligo)', zip: '247608' },
	{ city: 'Church Hill Glebe (Meath)', zip: '754776' },
	{ city: 'Church Island (Donegal)', zip: '486491' },
	{ city: 'Churchland (Offaly)', zip: '808835' },
	{ city: 'Churchland (Wicklow)', zip: '342821' },
	{ city: 'Churchland East (Kildare)', zip: '515707' },
	{ city: 'Churchlands (Wexford)', zip: '427609' },
	{ city: 'Churchland South (Kildare)', zip: '423944' },
	{ city: 'Churchland West (Kildare)', zip: '176798' },
	{ city: 'Churchlanquarters (Donegal)', zip: '384354' },
	{ city: 'Churchpark (Mayo)', zip: '664967' },
	{ city: 'Churchquarter (Limerick)', zip: '995441' },
	{ city: 'Churchquarter (Longford)', zip: '596686' },
	{ city: 'Churchquarter (Roscommon)', zip: '933221' },
	{ city: 'Churchquarter (Tipperary)', zip: '613823' },
	{ city: 'Churchquarter (Waterford)', zip: '764558' },
	{ city: 'Churchstreet (Roscommon)', zip: '407540' },
	{ city: 'Churchtown (Cork)', zip: '697770' },
	{ city: 'Churchtown (Donegal)', zip: '693705' },
	{ city: 'Churchtown (Dublin)', zip: '388977' },
	{ city: 'Churchtown (Kerry)', zip: '227314' },
	{ city: 'Churchtown (Laois)', zip: '625586' },
	{ city: 'Churchtown (Limerick)', zip: '662293' },
	{ city: 'Churchtown (Louth)', zip: '338474' },
	{ city: 'Churchtown (Meath)', zip: '497487' },
	{ city: 'Churchtown (Waterford)', zip: '640432' },
	{ city: 'Churchtown (Westmeath)', zip: '894285' },
	{ city: 'Churchtown (Wexford)', zip: '857448' },
	{ city: 'Church Town (Donegal)', zip: '105509' },
	{ city: 'Churchtownhill (Waterford)', zip: '668059' },
	{ city: 'Churchtown Lower (Dublin)', zip: '708295' },
	{ city: 'Churchtown North (Kildare)', zip: '962236' },
	{ city: 'Churchtown South (Kildare)', zip: '651399' },
	{ city: 'Churchtown Upper (Dublin)', zip: '649476' },
	{ city: 'Clab (Clare)', zip: '837877' },
	{ city: 'Cladagh (Waterford)', zip: '884700' },
	{ city: 'Claddagh (Cavan)', zip: '164859' },
	{ city: 'Claddagh (Sligo)', zip: '714603' },
	{ city: 'Claddaghduff (Galway)', zip: '897351' },
	{ city: 'Claddagh East (Galway)', zip: '302412' },
	{ city: 'Claddagh West (Galway)', zip: '274267' },
	{ city: 'Claddanure East (Kerry)', zip: '120670' },
	{ city: 'Claddanure West (Kerry)', zip: '560171' },
	{ city: 'Claddy (Mayo)', zip: '727480' },
	{ city: 'Cladowen (Monaghan)', zip: '508949' },
	{ city: 'Claggan (Donegal)', zip: '406581' },
	{ city: 'Claggan (Galway)', zip: '859787' },
	{ city: 'Claggan (Mayo)', zip: '168198' },
	{ city: 'Clagganmountain (Mayo)', zip: '598925' },
	{ city: 'Claggan Mountain (Donegal)', zip: '971812' },
	{ city: 'Claggan Mountain North (Donegal)', zip: '472607' },
	{ city: 'Claggan Mountain South (Donegal)', zip: '967059' },
	{ city: 'Claggan North (Donegal)', zip: '472168' },
	{ city: 'Claggan South (Donegal)', zip: '235874' },
	{ city: 'Claggarnagh East (Mayo)', zip: '451949' },
	{ city: 'Claggarnagh West (Mayo)', zip: '844017' },
	{ city: 'Claggernagh East (Galway)', zip: '341322' },
	{ city: 'Claggernagh West (Galway)', zip: '729912' },
	{ city: 'Clagnagh (Mayo)', zip: '169543' },
	{ city: 'Clahane (Kerry)', zip: '756846' },
	{ city: 'Clamperpark (Galway)', zip: '291343' },
	{ city: 'Clanagh (Carlow)', zip: '901203' },
	{ city: 'Clanboorhin (Donegal)', zip: '468369' },
	{ city: 'Clancool Beg (Cork)', zip: '437155' },
	{ city: 'Clancool More (Cork)', zip: '245321' },
	{ city: 'Clane (Kildare)', zip: '436546' },
	{ city: 'Clanhugh Demesne (Westmeath)', zip: '129551' },
	{ city: 'Clanickny (Monaghan)', zip: '128882' },
	{ city: 'Clara (Offaly)', zip: '896029' },
	{ city: 'Clarabeg North (Wicklow)', zip: '301804' },
	{ city: 'Clarabeg South (Wicklow)', zip: '153253' },
	{ city: 'Clarabricken (Kilkenny)', zip: '670524' },
	{ city: 'Claragh (Cavan)', zip: '822396' },
	{ city: 'Claragh (Donegal)', zip: '933886' },
	{ city: 'Claragh (Offaly)', zip: '588658' },
	{ city: 'Claraghatlea North (Cork)', zip: '310142' },
	{ city: 'Claraghatlea South (Cork)', zip: '868996' },
	{ city: 'Claragh Beg (Cork)', zip: '598702' },
	{ city: 'Claragh Irish (Sligo)', zip: '529512' },
	{ city: 'Claragh More (Cork)', zip: '153171' },
	{ city: 'Claraghpottle Glebe (Cavan)', zip: '794307' },
	{ city: 'Claragh Scotch (Sligo)', zip: '282948' },
	{ city: 'Claraghy (Monaghan)', zip: '593237' },
	{ city: 'Clarahill (Laois)', zip: '643537' },
	{ city: 'Clara More (Wicklow)', zip: '596988' },
	{ city: 'Clarary (Galway)', zip: '158830' },
	{ city: 'Clarary (Roscommon)', zip: '308584' },
	{ city: 'Claras (Longford)', zip: '362045' },
	{ city: 'Clarashinnagh (Leitrim)', zip: '929923' },
	{ city: 'Clara Upper (Kilkenny)', zip: '219162' },
	{ city: 'Clarbally (Cavan)', zip: '978947' },
	{ city: 'Clarbarracum (Laois)', zip: '775318' },
	{ city: 'Clarcam (Donegal)', zip: '455189' },
	{ city: 'Clarcarricknagun (Donegal)', zip: '625239' },
	{ city: 'Clarderry (Monaghan)', zip: '910665' },
	{ city: 'Clardrumbarren (Donegal)', zip: '319569' },
	{ city: 'Clardrumnagahan (Donegal)', zip: '759963' },
	{ city: 'Clare (Cavan)', zip: '523811' },
	{ city: 'Clare (Donegal)', zip: '318334' },
	{ city: 'Clare (Galway)', zip: '141647' },
	{ city: 'Clare (Mayo)', zip: '306676' },
	{ city: 'Clare (Roscommon)', zip: '840762' },
	{ city: 'Clare (Westmeath)', zip: '754297' },
	{ city: 'Clareabbey (Clare)', zip: '231693' },
	{ city: 'Clarebane (Cavan)', zip: '635726' },
	{ city: 'Clare Beg (Tipperary)', zip: '964348' },
	{ city: 'Clareboy (Cavan)', zip: '461627' },
	{ city: 'Clarecastle (Clare)', zip: '650261' },
	{ city: 'Clare Commons (Clare)', zip: '870335' },
	{ city: 'Clareen (Mayo)', zip: '549994' },
	{ city: 'Clareen (Offaly)', zip: '588034' },
	{ city: 'Clareen (Tipperary)', zip: '759761' },
	{ city: 'Clarefield (Clare)', zip: '503265' },
	{ city: 'Claregalway (Galway)', zip: '123655' },
	{ city: 'Clarehill (Clare)', zip: '406169' },
	{ city: 'Clareisland (Westmeath)', zip: '628333' },
	{ city: 'Clare Island (Mayo)', zip: '818187' },
	{ city: 'Claremadden (Galway)', zip: '749449' },
	{ city: 'Clare More (Tipperary)', zip: '656672' },
	{ city: 'Claremorris (Mayo)', zip: '645936' },
	{ city: 'Claremount (Clare)', zip: '346092' },
	{ city: 'Claremount (Galway)', zip: '353046' },
	{ city: 'Claremount (Kildare)', zip: '511223' },
	{ city: 'Claremount (Mayo)', zip: '244112' },
	{ city: 'Claremount (Offaly)', zip: '871499' },
	{ city: 'Claremount (Westmeath)', zip: '675209' },
	{ city: 'Clare Oghill (Monaghan)', zip: '819345' },
	{ city: 'Claretuam (Galway)', zip: '780356' },
	{ city: 'Clarey (Kildare)', zip: '219706' },
	{ city: 'Clarina (Limerick)', zip: '560094' },
	{ city: 'Claristown (Meath)', zip: '867864' },
	{ city: 'Clarkill (Tipperary)', zip: '432010' },
	{ city: 'Clarkstown (Dublin)', zip: '106728' },
	{ city: 'Clarkstown (Meath)', zip: '554407' },
	{ city: 'Clarkville (Offaly)', zip: '996367' },
	{ city: 'Clarlougheask (Donegal)', zip: '141668' },
	{ city: 'Clash (Cork)', zip: '848954' },
	{ city: 'Clash (Kerry)', zip: '168270' },
	{ city: 'Clash (Laois)', zip: '660343' },
	{ city: 'Clash (Tipperary)', zip: '942278' },
	{ city: 'Clashabreeda (Tipperary)', zip: '635876' },
	{ city: 'Clashacollare (Kilkenny)', zip: '642184' },
	{ city: 'Clashacrow (Kilkenny)', zip: '113353' },
	{ city: 'Clashadoo (Cork)', zip: '807284' },
	{ city: 'Clashadunna East (Cork)', zip: '801099' },
	{ city: 'Clashadunna West (Cork)', zip: '508743' },
	{ city: 'Clashafree (Cork)', zip: '806235' },
	{ city: 'Clashagad Lower (Offaly)', zip: '755232' },
	{ city: 'Clashagad Upper (Offaly)', zip: '772819' },
	{ city: 'Clashaganniv (Cork)', zip: '822765' },
	{ city: 'Clashaganny (Galway)', zip: '175488' },
	{ city: 'Clashaganny (Roscommon)', zip: '987292' },
	{ city: 'Clashalaher (Tipperary)', zip: '188354' },
	{ city: 'Clashanaffrin (Cork)', zip: '713854' },
	{ city: 'Clashanahy (Waterford)', zip: '227686' },
	{ city: 'Clashanea (Limerick)', zip: '906448' },
	{ city: 'Clashanimud (Cork)', zip: '388890' },
	{ city: 'Clashaniska Lower (Tipperary)', zip: '271297' },
	{ city: 'Clashaniska Upper (Tipperary)', zip: '692373' },
	{ city: 'Clashaniskera (Tipperary)', zip: '526126' },
	{ city: 'Clashanisky (Tipperary)', zip: '569808' },
	{ city: 'Clashanure (Cork)', zip: '310194' },
	{ city: 'Clashaphuca (Kerry)', zip: '916451' },
	{ city: 'Clasharaggy (Cork)', zip: '116370' },
	{ city: 'Clashard (Galway)', zip: '568436' },
	{ city: 'Clasharinka (Cork)', zip: '365176' },
	{ city: 'Clasharoe (Kilkenny)', zip: '510051' },
	{ city: 'Clasharusheen (Cork)', zip: '939135' },
	{ city: 'Clashatarriff (Cork)', zip: '674921' },
	{ city: 'Clashateeaun (Tipperary)', zip: '862850' },
	{ city: 'Clashatlea (Kerry)', zip: '507955' },
	{ city: 'Clashavaddra (Tipperary)', zip: '875885' },
	{ city: 'Clashavaha (Kilkenny)', zip: '314246' },
	{ city: 'Clashavickteery (Tipperary)', zip: '664750' },
	{ city: 'Clashavougha (Tipperary)', zip: '495830' },
	{ city: 'Clashbane (Limerick)', zip: '410888' },
	{ city: 'Clashbeg (Tipperary)', zip: '507717' },
	{ city: 'Clashboy (Laois)', zip: '978553' },
	{ city: 'Clashbrack (Waterford)', zip: '180278' },
	{ city: 'Clashbredane (Cork)', zip: '163767' },
	{ city: 'Clashcame (Mayo)', zip: '577886' },
	{ city: 'Clashcarragh (Roscommon)', zip: '675146' },
	{ city: 'Clashdermot East (Cork)', zip: '823528' },
	{ city: 'Clashdermot West (Cork)', zip: '894249' },
	{ city: 'Clashdrumsmith (Tipperary)', zip: '203680' },
	{ city: 'Clashduff (Clare)', zip: '280139' },
	{ city: 'Clashduff (Cork)', zip: '991005' },
	{ city: 'Clashduff (Kilkenny)', zip: '730531' },
	{ city: 'Clashduff (Tipperary)', zip: '369530' },
	{ city: 'Clashduff Lower (Kilkenny)', zip: '749804' },
	{ city: 'Clashduff Upper (Kilkenny)', zip: '228355' },
	{ city: 'Clash East (Cork)', zip: '594071' },
	{ city: 'Clash East (Kerry)', zip: '545182' },
	{ city: 'Clashedmond (Kerry)', zip: '441214' },
	{ city: 'Clasheel (Cork)', zip: '992827' },
	{ city: 'Clasheen (Kerry)', zip: '435463' },
	{ city: 'Clasheen (Wexford)', zip: '637259' },
	{ city: 'Clasheenanierin (Waterford)', zip: '740238' },
	{ city: 'Clashelane (Cork)', zip: '679491' },
	{ city: 'Clasheleesha (Tipperary)', zip: '633563' },
	{ city: 'Clashganniff (Limerick)', zip: '236840' },
	{ city: 'Clashganniv (Cork)', zip: '728600' },
	{ city: 'Clashganniv (Kerry)', zip: '168247' },
	{ city: 'Clashganny (Carlow)', zip: '529199' },
	{ city: 'Clashganny (Waterford)', zip: '852268' },
	{ city: 'Clashganny East (Tipperary)', zip: '252030' },
	{ city: 'Clashganny West (Tipperary)', zip: '606018' },
	{ city: 'Clashgortmore (Limerick)', zip: '136049' },
	{ city: 'Clashmagrath (Kilkenny)', zip: '408056' },
	{ city: 'Clashmaguire (Cork)', zip: '755260' },
	{ city: 'Clashmalea (Waterford)', zip: '205657' },
	{ city: 'Clashmelcon (Kerry)', zip: '398531' },
	{ city: 'Clashmore (Clare)', zip: '772075' },
	{ city: 'Clashmore (Cork)', zip: '647125' },
	{ city: 'Clashmore (Waterford)', zip: '898374' },
	{ city: 'Clashmorgan (Cork)', zip: '480766' },
	{ city: 'Clashnabuttry (Cork)', zip: '536362' },
	{ city: 'Clashnacrona East (Cork)', zip: '987905' },
	{ city: 'Clashnacrona West (Cork)', zip: '234064' },
	{ city: 'Clashnacrony (Tipperary)', zip: '349088' },
	{ city: 'Clashnadarriv (Waterford)', zip: '348392' },
	{ city: 'Clashnagarrane (Kerry)', zip: '316328' },
	{ city: 'Clashnagoneen (Waterford)', zip: '657722' },
	{ city: 'Clashnagraun (Tipperary)', zip: '982535' },
	{ city: 'Clashnamonadee (Waterford)', zip: '806693' },
	{ city: 'Clashnamrock (Waterford)', zip: '348143' },
	{ city: 'Clashnamuck (Laois)', zip: '215208' },
	{ city: 'Clashnasmut (Tipperary)', zip: '520872' },
	{ city: 'Clashnevin (Tipperary)', zip: '622991' },
	{ city: 'Clash North (Limerick)', zip: '288337' },
	{ city: 'Clashoquirk (Tipperary)', zip: '709077' },
	{ city: 'Clashreagh (Cork)', zip: '149160' },
	{ city: 'Clashroe (Cork)', zip: '346031' },
	{ city: 'Clashroe (Offaly)', zip: '574265' },
	{ city: 'Clashroe (Waterford)', zip: '247350' },
	{ city: 'Clash South (Limerick)', zip: '959942' },
	{ city: 'Clash West (Cork)', zip: '812986' },
	{ city: 'Clash West (Kerry)', zip: '421682' },
	{ city: 'Clashwilliam (Kilkenny)', zip: '772954' },
	{ city: 'Clashwilliam Upper (Kilkenny)', zip: '615197' },
	{ city: 'Clashygowan (Donegal)', zip: '161932' },
	{ city: 'Clashykinleen East (Cork)', zip: '874916' },
	{ city: 'Clashykinleen West (Cork)', zip: '794177' },
	{ city: 'Classagh (Clare)', zip: '712999' },
	{ city: 'Classaghroe (Galway)', zip: '795185' },
	{ city: 'Classaghroe (Mayo)', zip: '366497' },
	{ city: 'Classes (Cork)', zip: '860695' },
	{ city: 'Clatterstown (Meath)', zip: '741144' },
	{ city: 'Claureen (Clare)', zip: '475148' },
	{ city: 'Claureen (Galway)', zip: '190520' },
	{ city: 'Clavass (Wexford)', zip: '305102' },
	{ city: 'Claycastle (Cork)', zip: '154948' },
	{ city: 'Cleaboy (Roscommon)', zip: '612177' },
	{ city: 'Cleaghbeg (Galway)', zip: '411942' },
	{ city: 'Cleaghgarve (Galway)', zip: '443094' },
	{ city: 'Cleaghmore (Galway)', zip: '484966' },
	{ city: 'Cleaheen (Roscommon)', zip: '254303' },
	{ city: 'Cleanagh (Laois)', zip: '728508' },
	{ city: 'Cleanderry (Kerry)', zip: '136244' },
	{ city: 'Cleanglass North (Limerick)', zip: '765650' },
	{ city: 'Cleanglass South (Limerick)', zip: '108422' },
	{ city: 'Cleanrath (Cork)', zip: '307643' },
	{ city: 'Cleanrath North (Cork)', zip: '467744' },
	{ city: 'Cleanrath South (Cork)', zip: '743869' },
	{ city: 'Clearagh (Cork)', zip: '277255' },
	{ city: "Clear's-Land (Tipperary)", zip: '771204' },
	{ city: 'Cleaveragh Demesne (Sligo)', zip: '121125' },
	{ city: 'Cleavry (Sligo)', zip: '484395' },
	{ city: 'Cleedagh (Kerry)', zip: '601407' },
	{ city: 'Cleen (Leitrim)', zip: '777998' },
	{ city: 'Cleen (Roscommon)', zip: '135758' },
	{ city: 'Cleenagh (Donegal)', zip: '994960' },
	{ city: 'Cleenaghoo (Leitrim)', zip: '680411' },
	{ city: 'Cleendargan (Leitrim)', zip: '305954' },
	{ city: 'Cleenderry (Donegal)', zip: '709668' },
	{ city: 'Cleengort (Donegal)', zip: '815123' },
	{ city: 'Cleenillaun (Galway)', zip: '237834' },
	{ city: 'Cleenrah (Longford)', zip: '966487' },
	{ city: 'Cleenraugh (Roscommon)', zip: '790633' },
	{ city: 'Cleeny (Kerry)', zip: '262796' },
	{ city: 'Cleffin (Cavan)', zip: '535776' },
	{ city: 'Clegarrow (Meath)', zip: '353880' },
	{ city: 'Cleggan (Cavan)', zip: '936224' },
	{ city: 'Cleggan (Galway)', zip: '861470' },
	{ city: 'Cleggan (Leitrim)', zip: '102288' },
	{ city: 'Cleggarnagh (Westmeath)', zip: '315774' },
	{ city: 'Cleggill (Longford)', zip: '156644' },
	{ city: 'Cleghile (Tipperary)', zip: '620810' },
	{ city: 'Clegna (Roscommon)', zip: '629357' },
	{ city: 'Clehagh (Donegal)', zip: '997386' },
	{ city: 'Clehile (Tipperary)', zip: '889996' },
	{ city: 'Cleighragh (Leitrim)', zip: '345449' },
	{ city: 'Cleighran (Leitrim)', zip: '756990' },
	{ city: 'Cleighran Beg (Leitrim)', zip: '621120' },
	{ city: 'Cleighran More (Leitrim)', zip: '169497' },
	{ city: 'Clenagh (Clare)', zip: '981393' },
	{ city: 'Clenlough (Monaghan)', zip: '773215' },
	{ city: 'Clenor North (Cork)', zip: '529348' },
	{ city: 'Clenor South (Cork)', zip: '925020' },
	{ city: 'Cleraun (Longford)', zip: '372776' },
	{ city: 'Clerhaun (Galway)', zip: '254733' },
	{ city: 'Clerhaun (Mayo)', zip: '862723' },
	{ city: 'Cleristown (Wexford)', zip: '735951' },
	{ city: 'Cleristown North (Wexford)', zip: '388812' },
	{ city: 'Cleristown South (Wexford)', zip: '917190' },
	{ city: 'Clerkstown (Tipperary)', zip: '865727' },
	{ city: 'Clermont (Tipperary)', zip: '522293' },
	{ city: 'Clerragh (Roscommon)', zip: '253622' },
	{ city: 'Clerran (Monaghan)', zip: '761377' },
	{ city: 'Clery (Monaghan)', zip: '470049' },
	{ city: 'Cletty (Sligo)', zip: '777593' },
	{ city: 'Cliddaun (Kerry)', zip: '612190' },
	{ city: 'Clievragh (Kerry)', zip: '739616' },
	{ city: 'Clifden (Clare)', zip: '661438' },
	{ city: 'Clifden (Galway)', zip: '795837' },
	{ city: 'Clifden Commons (Kilkenny)', zip: '792521' },
	{ city: 'Clifden Demesne (Galway)', zip: '228782' },
	{ city: 'Clifferna (Cavan)', zip: '985594' },
	{ city: 'Cliffony (Sligo)', zip: '828473' },
	{ city: 'Clifford (Cork)', zip: '273978' },
	{ city: 'Clifton (Cavan)', zip: '297987' },
	{ city: 'Clincaun (Kilkenny)', zip: '299108' },
	{ city: 'Clinstown (Meath)', zip: '919705' },
	{ city: 'Clintstown (Kilkenny)', zip: '966372' },
	{ city: 'Cliven (Louth)', zip: '223073' },
	{ city: 'Cloan (Cork)', zip: '818027' },
	{ city: 'Clobanna (Tipperary)', zip: '542202' },
	{ city: 'Clobemon (Wexford)', zip: '130421' },
	{ city: 'Clocully (Tipperary)', zip: '966113' },
	{ city: 'Clodagh (Cork)', zip: '308850' },
	{ city: 'Clodah (Cork)', zip: '154006' },
	{ city: 'Cloddagh (Cork)', zip: '665549' },
	{ city: 'Clodragh (Kerry)', zip: '847628' },
	{ city: 'Clodrum (Cavan)', zip: '741871' },
	{ city: 'Clogagh North (Cork)', zip: '729773' },
	{ city: 'Clogagh South (Cork)', zip: '293976' },
	{ city: 'Clogaralt (Kilkenny)', zip: '811899' },
	{ city: 'Clogga (Clare)', zip: '890901' },
	{ city: 'Clogga (Kilkenny)', zip: '806710' },
	{ city: 'Clogga (Wicklow)', zip: '489886' },
	{ city: 'Cloggagh (Cavan)', zip: '522244' },
	{ city: 'Cloggarnagh (Roscommon)', zip: '352237' },
	{ city: 'Cloggy (Cavan)', zip: '808627' },
	{ city: 'Clogh (Galway)', zip: '183701' },
	{ city: 'Clogh (Kilkenny)', zip: '191624' },
	{ city: 'Clogh (Laois)', zip: '406086' },
	{ city: 'Clogh (Longford)', zip: '122559' },
	{ city: 'Clogh (Offaly)', zip: '278342' },
	{ city: 'Clogh (Sligo)', zip: '862219' },
	{ city: 'Clogh (Waterford)', zip: '198824' },
	{ city: 'Clogh (Wexford)', zip: '466701' },
	{ city: 'Cloghabrack (Offaly)', zip: '320041' },
	{ city: 'Cloghabreedy (Tipperary)', zip: '152302' },
	{ city: 'Cloghabrody (Kilkenny)', zip: '633586' },
	{ city: 'Cloghacloka (Limerick)', zip: '945251' },
	{ city: 'Cloghadalton (Limerick)', zip: '115463' },
	{ city: 'Cloghaderreen (Limerick)', zip: '947478' },
	{ city: 'Cloghadockan (Mayo)', zip: '396525' },
	{ city: 'Cloghadoolarty North (Limerick)', zip: '157994' },
	{ city: 'Cloghadoolarty South (Limerick)', zip: '268333' },
	{ city: 'Cloghagalla Eighter (Galway)', zip: '581284' },
	{ city: 'Cloghagalla Oughter (Galway)', zip: '984078' },
	{ city: 'Cloghala (Kilkenny)', zip: '532825' },
	{ city: 'Cloghalahard (Galway)', zip: '175605' },
	{ city: 'Cloghal Beg (Offaly)', zip: '589418' },
	{ city: 'Cloghal More (Offaly)', zip: '612566' },
	{ city: 'Cloghan (Donegal)', zip: '672352' },
	{ city: 'Cloghan (Leitrim)', zip: '206275' },
	{ city: 'Cloghan (Longford)', zip: '276920' },
	{ city: 'Cloghan (Mayo)', zip: '966729' },
	{ city: 'Cloghan (Meath)', zip: '824485' },
	{ city: 'Cloghan (Monaghan)', zip: '637700' },
	{ city: 'Cloghan (Offaly)', zip: '718012' },
	{ city: 'Cloghan (Roscommon)', zip: '357306' },
	{ city: 'Cloghanacody (Tipperary)', zip: '238489' },
	{ city: 'Cloghanaculleen (Cork)', zip: '329838' },
	{ city: 'Cloghanalehid (Cork)', zip: '389031' },
	{ city: 'Cloghanamina (Offaly)', zip: '491192' },
	{ city: 'Cloghanarold (Limerick)', zip: '369037' },
	{ city: 'Cloghanaskaw (Westmeath)', zip: '244215' },
	{ city: 'Cloghanbane (Offaly)', zip: '793664' },
	{ city: 'Cloghan Beg (Donegal)', zip: '253038' },
	{ city: 'Cloghan Beg (Offaly)', zip: '894902' },
	{ city: 'Cloghanboy (Westmeath)', zip: '868930' },
	{ city: 'Cloghanboy West (Westmeath)', zip: '315533' },
	{ city: 'Cloghan Demesne (Offaly)', zip: '801822' },
	{ city: 'Cloghane (Cork)', zip: '189423' },
	{ city: 'Cloghane (Kerry)', zip: '884105' },
	{ city: 'Cloghane (Tipperary)', zip: '600656' },
	{ city: 'Cloghaneanode (Kerry)', zip: '813445' },
	{ city: 'Cloghaneanua (Kerry)', zip: '623616' },
	{ city: 'Cloghanebane (Kerry)', zip: '641994' },
	{ city: 'Cloghane Beg (Cork)', zip: '215134' },
	{ city: 'Cloghanecanuig (Kerry)', zip: '507158' },
	{ city: 'Cloghanecarhan (Kerry)', zip: '286323' },
	{ city: 'Cloghaneduff (Kerry)', zip: '938323' },
	{ city: 'Cloghaneleesh (Kerry)', zip: '217211' },
	{ city: 'Cloghaneleskirt (Kerry)', zip: '864213' },
	{ city: 'Cloghanelinaghan (Kerry)', zip: '387590' },
	{ city: 'Cloghane Lower (Cork)', zip: '267899' },
	{ city: 'Cloghane More (Cork)', zip: '598200' },
	{ city: 'Cloghanenagleragh (Kerry)', zip: '535319' },
	{ city: 'Cloghanesheskeen (Kerry)', zip: '480717' },
	{ city: 'Cloghane Upper (Cork)', zip: '783084' },
	{ city: 'Cloghanlucas North (Mayo)', zip: '552765' },
	{ city: 'Cloghanmore (Offaly)', zip: '455044' },
	{ city: 'Cloghan More (Donegal)', zip: '559254' },
	{ city: 'Cloghanmoyle (Louth)', zip: '971745' },
	{ city: 'Cloghannagarragh (Westmeath)', zip: '122580' },
	{ city: 'Cloghannageeragh (Mayo)', zip: '600959' },
	{ city: 'Cloghanower (Galway)', zip: '544722' },
	{ city: 'Cloghans (Mayo)', zip: '258197' },
	{ city: 'Cloghans Beg (Mayo)', zip: '170840' },
	{ city: 'Cloghans Glebe (Roscommon)', zip: '822530' },
	{ city: 'Cloghans Hill (Mayo)', zip: '366853' },
	{ city: 'Cloghans More (Mayo)', zip: '226553' },
	{ city: 'Cloghanstown (Westmeath)', zip: '528511' },
	{ city: 'Cloghanughera (Cork)', zip: '329193' },
	{ city: 'Cloghanumera (Westmeath)', zip: '428263' },
	{ city: 'Cloghapistole (Tipperary)', zip: '157692' },
	{ city: 'Clogharaily Beg (Tipperary)', zip: '811319' },
	{ city: 'Clogharaily More (Tipperary)', zip: '245919' },
	{ city: 'Cloghard (Donegal)', zip: '167283' },
	{ city: 'Cloghardeen (Tipperary)', zip: '397589' },
	{ city: 'Cloghaready (Tipperary)', zip: '296353' },
	{ city: 'Cloghaready North (Limerick)', zip: '186422' },
	{ city: 'Cloghaready South (Limerick)', zip: '123930' },
	{ city: 'Clogharee (Kerry)', zip: '495576' },
	{ city: 'Clogharevaun (Galway)', zip: '782721' },
	{ city: 'Clogharinka (Kilkenny)', zip: '226116' },
	{ city: 'Clogharoasty (Galway)', zip: '227938' },
	{ city: 'Cloghast (Limerick)', zip: '993645' },
	{ city: 'Cloghastookeen (Galway)', zip: '376322' },
	{ city: 'Cloghasty North (Kilkenny)', zip: '172628' },
	{ city: 'Cloghasty South (Kilkenny)', zip: '148934' },
	{ city: 'Cloghatacka (Limerick)', zip: '883914' },
	{ city: 'Cloghatanna (Galway)', zip: '508659' },
	{ city: 'Cloghatanny (Offaly)', zip: '396871' },
	{ city: 'Cloghateana (Tipperary)', zip: '437235' },
	{ city: 'Cloghatrida (Limerick)', zip: '453795' },
	{ city: 'Cloghaun (Clare)', zip: '627824' },
	{ city: 'Cloghaun (Galway)', zip: '106854' },
	{ city: 'Cloghaun (Waterford)', zip: '126017' },
	{ city: 'Cloghaunard (Galway)', zip: '816079' },
	{ city: 'Cloghaunbeg (Clare)', zip: '700515' },
	{ city: 'Cloghaun Beg (Clare)', zip: '893267' },
	{ city: 'Cloghaundine (Clare)', zip: '167445' },
	{ city: 'Cloghauninchy (Clare)', zip: '826127' },
	{ city: 'Cloghaun More (Clare)', zip: '924850' },
	{ city: 'Cloghaunnatinny (Clare)', zip: '383582' },
	{ city: 'Cloghaunsavaun (Clare)', zip: '365870' },
	{ city: 'Cloghaviller (Limerick)', zip: '476797' },
	{ city: 'Cloghavoola (Kerry)', zip: '230475' },
	{ city: 'Cloghballybeg (Cavan)', zip: '493554' },
	{ city: 'Cloghbally Lower (Cavan)', zip: '201527' },
	{ city: 'Cloghballymore (Galway)', zip: '725417' },
	{ city: 'Cloghbally Upper (Cavan)', zip: '422186' },
	{ city: 'Cloghbane (Westmeath)', zip: '953845' },
	{ city: 'Cloghbog (Waterford)', zip: '448778' },
	{ city: 'Cloghboley (Galway)', zip: '359447' },
	{ city: 'Cloghboley (Mayo)', zip: '920964' },
	{ city: 'Cloghboley (Sligo)', zip: '587302' },
	{ city: 'Cloghbolie (Donegal)', zip: '102561' },
	{ city: 'Cloghboola (Cork)', zip: '328374' },
	{ city: 'Cloghboola (Kerry)', zip: '881728' },
	{ city: 'Cloghboola Beg (Cork)', zip: '636437' },
	{ city: 'Cloghboola More (Cork)', zip: '800957' },
	{ city: 'Cloghboy (Donegal)', zip: '593832' },
	{ city: 'Cloghbrack (Galway)', zip: '949249' },
	{ city: 'Cloghbrack (Mayo)', zip: '643395' },
	{ city: 'Cloghbrack Far (Mayo)', zip: '961938' },
	{ city: 'Cloghbrack Lower (Galway)', zip: '345890' },
	{ city: 'Cloghbrack Middle (Galway)', zip: '943007' },
	{ city: 'Cloghbrack Near (Mayo)', zip: '291932' },
	{ city: 'Cloghbrack Upper (Galway)', zip: '755585' },
	{ city: 'Cloghbreen (Westmeath)', zip: '333850' },
	{ city: 'Cloghcarrigeen East (Tipperary)', zip: '277746' },
	{ city: 'Cloghcarrigeen West (Tipperary)', zip: '889462' },
	{ city: 'Cloghcastle (Wicklow)', zip: '871255' },
	{ city: 'Cloghchurnel (Longford)', zip: '980547' },
	{ city: 'Cloghcor (Donegal)', zip: '355683' },
	{ city: 'Cloghcor (Sligo)', zip: '846372' },
	{ city: 'Cloghduff (Cork)', zip: '499037' },
	{ city: 'Clogh East (Limerick)', zip: '562467' },
	{ city: 'Clogheder (Dublin)', zip: '560807' },
	{ city: 'Clogheen (Cork)', zip: '726574' },
	{ city: 'Clogheen (Kildare)', zip: '678038' },
	{ city: 'Clogheen (Tipperary)', zip: '695881' },
	{ city: 'Clogheen (Waterford)', zip: '959614' },
	{ city: 'Clogheenavodig (Cork)', zip: '488624' },
	{ city: 'Clogheenduane (Cork)', zip: '313590' },
	{ city: 'Clogheen Market (Tipperary)', zip: '412635' },
	{ city: 'Clogheenmilcon (Cork)', zip: '253694' },
	{ city: 'Clogher (Clare)', zip: '826908' },
	{ city: 'Clogher (Cork)', zip: '162924' },
	{ city: 'Clogher (Donegal)', zip: '227683' },
	{ city: 'Clogher (Galway)', zip: '301484' },
	{ city: 'Clogher (Kerry)', zip: '949483' },
	{ city: 'Clogher (Leitrim)', zip: '842310' },
	{ city: 'Clogher (Limerick)', zip: '432185' },
	{ city: 'Clogher (Louth)', zip: '624910' },
	{ city: 'Clogher (Mayo)', zip: '995306' },
	{ city: 'Clogher (Monaghan)', zip: '195689' },
	{ city: 'Clogher (Roscommon)', zip: '226619' },
	{ city: 'Clogher (Sligo)', zip: '491536' },
	{ city: 'Clogher (Tipperary)', zip: '492319' },
	{ city: 'Clogher (Westmeath)', zip: '896906' },
	{ city: 'Cloghera (Clare)', zip: '467117' },
	{ city: 'Cloghera Beg (Kerry)', zip: '241263' },
	{ city: 'Clogherachullion (Donegal)', zip: '376922' },
	{ city: 'Cloghera More (Kerry)', zip: '686357' },
	{ city: 'Clogher And Rinn (Longford)', zip: '704215' },
	{ city: 'Clogherane (Kerry)', zip: '748970' },
	{ city: 'Clogherane (Waterford)', zip: '361839' },
	{ city: 'Clogheravaddy (Donegal)', zip: '888047' },
	{ city: 'Clogher Beg (Mayo)', zip: '629650' },
	{ city: 'Clogher Beg (Roscommon)', zip: '595484' },
	{ city: 'Clogher Beg (Sligo)', zip: '229196' },
	{ city: 'Clogherboy (Galway)', zip: '313983' },
	{ city: 'Clogherboy (Meath)', zip: '113768' },
	{ city: 'Clogherbrien (Kerry)', zip: '896400' },
	{ city: 'Clogherclemin (Kerry)', zip: '207085' },
	{ city: 'Cloghercor (Donegal)', zip: '523886' },
	{ city: 'Clogher Demesne (Cork)', zip: '196166' },
	{ city: 'Clogherdillure (Donegal)', zip: '682747' },
	{ city: 'Clogherduff (Mayo)', zip: '648176' },
	{ city: 'Clogher East (Donegal)', zip: '128008' },
	{ city: 'Clogher East (Limerick)', zip: '423711' },
	{ city: 'Cloghereen Lower (Kerry)', zip: '890819' },
	{ city: 'Cloghereen Upper (Kerry)', zip: '969704' },
	{ city: 'Cloghergoole (Cavan)', zip: '172119' },
	{ city: 'Clogherhead (Louth)', zip: '208626' },
	{ city: 'Clogher Lower (Roscommon)', zip: '837034' },
	{ city: 'Cloghermore (Galway)', zip: '290162' },
	{ city: 'Cloghermore (Kerry)', zip: '792667' },
	{ city: 'Clogher More (Mayo)', zip: '236847' },
	{ city: 'Clogher More (Roscommon)', zip: '503715' },
	{ city: 'Clogher More (Sligo)', zip: '228555' },
	{ city: 'Cloghernagh (Donegal)', zip: '152349' },
	{ city: 'Cloghernagh (Monaghan)', zip: '718924' },
	{ city: 'Cloghernagore (Donegal)', zip: '803032' },
	{ city: 'Cloghernagun (Galway)', zip: '832413' },
	{ city: 'Cloghernalaura (Galway)', zip: '769799' },
	{ city: 'Cloghernoosh (Kerry)', zip: '104746' },
	{ city: 'Clogherowan (Mayo)', zip: '545765' },
	{ city: 'Clogherrevagh (Sligo)', zip: '823289' },
	{ city: 'Cloghers (Kerry)', zip: '224137' },
	{ city: 'Clogherstown (Meath)', zip: '150884' },
	{ city: 'Clogher Upper (Roscommon)', zip: '841636' },
	{ city: 'Cloghervaddy (Donegal)', zip: '925634' },
	{ city: 'Clogher West (Donegal)', zip: '243486' },
	{ city: 'Clogher West (Limerick)', zip: '860743' },
	{ city: 'Cloghfin (Donegal)', zip: '915277' },
	{ city: 'Cloghfin (Monaghan)', zip: '508819' },
	{ city: 'Cloghfin (Sligo)', zip: '594532' },
	{ city: 'Cloghfune (Cork)', zip: '380465' },
	{ city: 'Cloghfune (Kerry)', zip: '538726' },
	{ city: 'Cloghgarrett Glebe (Kildare)', zip: '838659' },
	{ city: 'Cloghglass (Donegal)', zip: '723051' },
	{ city: 'Cloghgore (Donegal)', zip: '592464' },
	{ city: 'Cloghgriffin (Cork)', zip: '560245' },
	{ city: 'Cloghilawarreela (Limerick)', zip: '636083' },
	{ city: 'Cloghinch (Tipperary)', zip: '126463' },
	{ city: 'Cloghjordan (Tipperary)', zip: '303168' },
	{ city: 'Cloghjordanpark (Tipperary)', zip: '397984' },
	{ city: 'Cloghkeating (Limerick)', zip: '699134' },
	{ city: 'Cloghkeating (Tipperary)', zip: '920497' },
	{ city: 'Cloghlea (Clare)', zip: '303824' },
	{ city: 'Cloghlea (Louth)', zip: '209874' },
	{ city: 'Cloghleafin (Cork)', zip: '556929' },
	{ city: 'Cloghleagh (Clare)', zip: '937766' },
	{ city: 'Cloghleagh (Kerry)', zip: '856855' },
	{ city: 'Cloghleagh (Wicklow)', zip: '722823' },
	{ city: 'Cloghleigh (Tipperary)', zip: '979899' },
	{ city: 'Cloghlough (Leitrim)', zip: '418695' },
	{ city: 'Clogh Lower (Wicklow)', zip: '670215' },
	{ city: 'Cloghlucas North (Cork)', zip: '346832' },
	{ city: 'Cloghlucas South (Cork)', zip: '484237' },
	{ city: 'Cloghmackirkeen (Kerry)', zip: '480920' },
	{ city: 'Cloghmacoo (Meath)', zip: '563152' },
	{ city: 'Cloghmacow (Cork)', zip: '427150' },
	{ city: 'Cloghmacsimon (Cork)', zip: '704192' },
	{ city: 'Cloghmartin (Tipperary)', zip: '130958' },
	{ city: 'Cloghmeen (Leitrim)', zip: '668145' },
	{ city: 'Cloghmine (Sligo)', zip: '458217' },
	{ city: 'Cloghmore (Mayo)', zip: '561192' },
	{ city: 'Cloghmore North (Galway)', zip: '414315' },
	{ city: 'Cloghmore South (Galway)', zip: '611293' },
	{ city: 'Cloghmoyle (Offaly)', zip: '187427' },
	{ city: 'Cloghmoyne (Mayo)', zip: '614887' },
	{ city: 'Cloghna (Carlow)', zip: '564007' },
	{ city: 'Cloghnadromin (Limerick)', zip: '212418' },
	{ city: 'Cloghnagaune (Wicklow)', zip: '435301' },
	{ city: 'Cloghnakeava (Galway)', zip: '450600' },
	{ city: 'Cloghnamallaght (Wexford)', zip: '529862' },
	{ city: 'Cloghnamanagh (Limerick)', zip: '405968' },
	{ city: 'Cloghnart (Monaghan)', zip: '647006' },
	{ city: 'Cloghnashade (Roscommon)', zip: '703194' },
	{ city: 'Clogh North (Galway)', zip: '824114' },
	{ city: 'Cloghoge (Cavan)', zip: '494585' },
	{ city: 'Cloghoge (Kilkenny)', zip: '364992' },
	{ city: 'Cloghoge (Laois)', zip: '347135' },
	{ city: 'Cloghoge (Wicklow)', zip: '258399' },
	{ city: 'Cloghoge And Tievadinna (Monaghan)', zip: '847986' },
	{ city: 'Cloghoge Lower (Sligo)', zip: '374510' },
	{ city: 'Cloghoge Upper (Sligo)', zip: '917107' },
	{ city: 'Cloghonan (Tipperary)', zip: '511181' },
	{ city: 'Cloghoolia (Clare)', zip: '715765' },
	{ city: 'Cloghore (Donegal)', zip: '505161' },
	{ city: 'Cloghphilip (Cork)', zip: '344022' },
	{ city: 'Cloghpook (Kilkenny)', zip: '212019' },
	{ city: 'Cloghprior (Tipperary)', zip: '949333' },
	{ city: 'Cloghran (Dublin)', zip: '765152' },
	{ city: 'Cloghraun (Waterford)', zip: '205575' },
	{ city: 'Cloghreagh (Meath)', zip: '441090' },
	{ city: 'Cloghristick (Carlow)', zip: '658853' },
	{ city: 'Cloghroak (Galway)', zip: '724222' },
	{ city: 'Cloghroe (Cork)', zip: '742754' },
	{ city: 'Cloghroe (Donegal)', zip: '102045' },
	{ city: 'Cloghscoltia (Galway)', zip: '714919' },
	{ city: 'Cloghscregg (Kilkenny)', zip: '746486' },
	{ city: 'Clogh South (Galway)', zip: '306398' },
	{ city: 'Cloghstuckagh (Cavan)', zip: '837488' },
	{ city: 'Cloghulatagh (Wexford)', zip: '776630' },
	{ city: 'Clogh Upper (Wicklow)', zip: '761955' },
	{ city: 'Cloghvally Lower (Monaghan)', zip: '267265' },
	{ city: 'Cloghvally Upper (Monaghan)', zip: '506791' },
	{ city: 'Cloghvoley (Galway)', zip: '312027' },
	{ city: 'Cloghvoley (Mayo)', zip: '363743' },
	{ city: 'Cloghvoola (Kerry)', zip: '305820' },
	{ city: 'Cloghvoolia North (Cork)', zip: '154552' },
	{ city: 'Cloghvoolia South (Cork)', zip: '728194' },
	{ city: 'Cloghvoula (Cork)', zip: '256991' },
	{ city: 'Clogh West (Limerick)', zip: '551598' },
	{ city: 'Clogorrow (Kildare)', zip: '265123' },
	{ city: 'Clogrenan (Carlow)', zip: '120433' },
	{ city: 'Clogrenan (Laois)', zip: '952387' },
	{ city: 'Clohamon (Wexford)', zip: '396537' },
	{ city: 'Clohaskin (Tipperary)', zip: '637297' },
	{ city: 'Clohass (Wexford)', zip: '241571' },
	{ city: 'Cloheden (Wexford)', zip: '363868' },
	{ city: 'Cloheen (Cork)', zip: '120939' },
	{ city: 'Cloheena (Cork)', zip: '216839' },
	{ city: 'Cloheenafishoge (Tipperary)', zip: '944826' },
	{ city: 'Cloheen Strand Intake (Cork)', zip: '464194' },
	{ city: 'Clohernagh (Tipperary)', zip: '252358' },
	{ city: 'Clohernagh (Wicklow)', zip: '173697' },
	{ city: 'Clohoge (Kilkenny)', zip: '572376' },
	{ city: 'Clohoge (Tipperary)', zip: '904407' },
	{ city: 'Clologe (Wexford)', zip: '317430' },
	{ city: 'Clologe Little (Wexford)', zip: '665889' },
	{ city: 'Clologe Lower (Wexford)', zip: '215668' },
	{ city: 'Clologe Upper (Wexford)', zip: '153190' },
	{ city: 'Clolourish (Wexford)', zip: '170725' },
	{ city: 'Clomantagh (Kilkenny)', zip: '790691' },
	{ city: 'Clomantagh Lower (Kilkenny)', zip: '647151' },
	{ city: 'Clomantagh Upper (Kilkenny)', zip: '959869' },
	{ city: 'Clomoney (Carlow)', zip: '744357' },
	{ city: 'Clonaboy (Westmeath)', zip: '566291' },
	{ city: 'Clonabreany (Meath)', zip: '350017' },
	{ city: 'Clonacody (Tipperary)', zip: '877963' },
	{ city: 'Clonacullan (Monaghan)', zip: '315695' },
	{ city: 'Clonacullion (Monaghan)', zip: '828083' },
	{ city: 'Clonacur (Carlow)', zip: '755675' },
	{ city: 'Clonad (Offaly)', zip: '398550' },
	{ city: 'Clonadacasey (Laois)', zip: '927479' },
	{ city: 'Clonaddadoran (Laois)', zip: '600424' },
	{ city: 'Clonaderg (Offaly)', zip: '203288' },
	{ city: 'Clonagam (Waterford)', zip: '458907' },
	{ city: 'Clonagannagh (Offaly)', zip: '792080' },
	{ city: 'Clonagara (Meath)', zip: '270303' },
	{ city: 'Clonageera (Laois)', zip: '458199' },
	{ city: 'Clonagh (Kildare)', zip: '713883' },
	{ city: 'Clonagh (Laois)', zip: '736751' },
	{ city: 'Clonagh (Limerick)', zip: '834496' },
	{ city: 'Clonagh (Offaly)', zip: '839365' },
	{ city: 'Clonagh (Westmeath)', zip: '517897' },
	{ city: 'Clonaghadoo (Laois)', zip: '904519' },
	{ city: 'Clonagh East (Offaly)', zip: '598682' },
	{ city: 'Clonaghlis (Kildare)', zip: '967238' },
	{ city: 'Clonagh West (Offaly)', zip: '345334' },
	{ city: 'Clonaglin (Westmeath)', zip: '744424' },
	{ city: 'Clonagonnell (Cavan)', zip: '163325' },
	{ city: 'Clonagooden (Laois)', zip: '299152' },
	{ city: 'Clonagoose (Tipperary)', zip: '208158' },
	{ city: 'Clonaheen (Laois)', zip: '891847' },
	{ city: 'Clonahenoge (Offaly)', zip: '506543' },
	{ city: 'Clonakenny (Tipperary)', zip: '696600' },
	{ city: 'Clonakilty (Cork)', zip: '567216' },
	{ city: 'Clonalea (Tipperary)', zip: '915393' },
	{ city: 'Clonaleenaghan (Louth)', zip: '284859' },
	{ city: 'Clonalough (Tipperary)', zip: '979652' },
	{ city: 'Clonaltra (Westmeath)', zip: '645432' },
	{ city: 'Clonaltra West (Westmeath)', zip: '207173' },
	{ city: 'Clonalvy (Meath)', zip: '665665' },
	{ city: 'Clonamery (Kilkenny)', zip: '911720' },
	{ city: 'Clonamicklon (Tipperary)', zip: '913471' },
	{ city: 'Clonamona Lower (Wexford)', zip: '634845' },
	{ city: 'Clonamona Upper (Wexford)', zip: '487650' },
	{ city: 'Clonamondra (Tipperary)', zip: '775685' },
	{ city: 'Clonamuckoge Beg (Tipperary)', zip: '660094' },
	{ city: 'Clonamuckoge More (Tipperary)', zip: '362544' },
	{ city: 'Clonamullig (Cavan)', zip: '139060' },
	{ city: 'Clonamully (Monaghan)', zip: '579240' },
	{ city: 'Clonamunsha (Monaghan)', zip: '353545' },
	{ city: 'Clonanagh (Waterford)', zip: '931452' },
	{ city: 'Clonanav (Waterford)', zip: '999696' },
	{ city: 'Clonandra (Cavan)', zip: '403163' },
	{ city: 'Clonaneor (Monaghan)', zip: '339985' },
	{ city: 'Clonanny (Laois)', zip: '186957' },
	{ city: 'Clonard (Dublin)', zip: '699423' },
	{ city: 'Clonard (Kilkenny)', zip: '121413' },
	{ city: 'Clonard (Laois)', zip: '924906' },
	{ city: 'Clonard (Meath)', zip: '814706' },
	{ city: 'Clonard East (Cork)', zip: '675638' },
	{ city: 'Clonard Great (Wexford)', zip: '471855' },
	{ city: 'Clonard Little (Wexford)', zip: '758217' },
	{ city: 'Clonard New (Kildare)', zip: '569757' },
	{ city: 'Clonardran (Meath)', zip: '834443' },
	{ city: 'Clonard West (Cork)', zip: '322489' },
	{ city: 'Clonarney (Cavan)', zip: '389564' },
	{ city: 'Clonarney (Westmeath)', zip: '513649' },
	{ city: 'Clonarrow (Offaly)', zip: '748734' },
	{ city: 'Clonascra (Offaly)', zip: '893780' },
	{ city: 'Clonasillagh (Meath)', zip: '640725' },
	{ city: 'Clonaslee (Laois)', zip: '843010' },
	{ city: 'Clonaspoe (Tipperary)', zip: '556504' },
	{ city: 'Clonassy (Kilkenny)', zip: '841887' },
	{ city: 'Clonatin Lower (Wexford)', zip: '583686' },
	{ city: 'Clonatin Upper (Wexford)', zip: '456209' },
	{ city: 'Clonava (Westmeath)', zip: '818055' },
	{ city: 'Clonavarn (Monaghan)', zip: '676662' },
	{ city: 'Clonavilla (Monaghan)', zip: '955495' },
	{ city: 'Clonavoe (Offaly)', zip: '723553' },
	{ city: 'Clonavogy (Monaghan)', zip: '596765' },
	{ city: 'Clonavrick (Cork)', zip: '163721' },
	{ city: 'Clonawoolan (Laois)', zip: '197607' },
	{ city: 'Clonbane (Laois)', zip: '445746' },
	{ city: 'Clonbara (Donegal)', zip: '850406' },
	{ city: 'Clonbarrow (Laois)', zip: '826621' },
	{ city: 'Clonbartan (Meath)', zip: '864929' },
	{ city: 'Clonbeale Beg Glebe (Offaly)', zip: '400736' },
	{ city: 'Clonbeale More (Offaly)', zip: '259253' },
	{ city: 'Clonbealy (Tipperary)', zip: '797923' },
	{ city: 'Clonbeg (Offaly)', zip: '239683' },
	{ city: 'Clon Beg (Tipperary)', zip: '793577' },
	{ city: 'Clonbeg Glebe (Donegal)', zip: '758735' },
	{ city: 'Clonbern (Galway)', zip: '617064' },
	{ city: 'Clonbockoge (Cavan)', zip: '141488' },
	{ city: 'Clonbonane (Tipperary)', zip: '750569' },
	{ city: 'Clonbonniff (Offaly)', zip: '857353' },
	{ city: 'Clonbore (Westmeath)', zip: '997774' },
	{ city: 'Clonbouig (Cork)', zip: '485620' },
	{ city: 'Clonboy (Clare)', zip: '492445' },
	{ city: 'Clonboy (Monaghan)', zip: '598724' },
	{ city: 'Clonboy (Westmeath)', zip: '577366' },
	{ city: 'Clonboyne (Laois)', zip: '783186' },
	{ city: 'Clonbrassil (Tipperary)', zip: '947943' },
	{ city: 'Clonbrennan (Offaly)', zip: '951055' },
	{ city: 'Clonbrick (Clare)', zip: '264274' },
	{ city: 'Clonbrick (Tipperary)', zip: '136477' },
	{ city: 'Clonbrin (Offaly)', zip: '999550' },
	{ city: 'Clonbrock (Galway)', zip: '149196' },
	{ city: 'Clonbrock (Laois)', zip: '855284' },
	{ city: 'Clonbrock Demesne (Galway)', zip: '436742' },
	{ city: 'Clonbrock Lower (Offaly)', zip: '828574' },
	{ city: 'Clonbrock Upper (Offaly)', zip: '345714' },
	{ city: 'Clonbrogan (Tipperary)', zip: '535172' },
	{ city: 'Clonbrone (Offaly)', zip: '915900' },
	{ city: 'Clonbroney (Longford)', zip: '675520' },
	{ city: 'Clonbrown (Offaly)', zip: '949493' },
	{ city: 'Clonbrusk (Westmeath)', zip: '650273' },
	{ city: 'Clonbulloge (Carlow)', zip: '855546' },
	{ city: 'Clonbulloge (Offaly)', zip: '915419' },
	{ city: 'Clonbunny (Tipperary)', zip: '724780' },
	{ city: 'Clonbuogh (Tipperary)', zip: '154728' },
	{ city: 'Clonbur (Galway)', zip: '680938' },
	{ city: 'Clonburren (Laois)', zip: '704249' },
	{ city: 'Clonburris Great (Dublin)', zip: '553129' },
	{ city: 'Clonburris Little (Dublin)', zip: '386675' },
	{ city: 'Clonca (Donegal)', zip: '331416' },
	{ city: 'Clonca (Longford)', zip: '428702' },
	{ city: 'Cloncagh (Limerick)', zip: '849276' },
	{ city: 'Cloncallick (Monaghan)', zip: '888669' },
	{ city: 'Cloncannon (Tipperary)', zip: '358004' },
	{ city: 'Cloncanon (Offaly)', zip: '982798' },
	{ city: 'Cloncanon Lower (Laois)', zip: '671227' },
	{ city: 'Cloncanon Upper (Laois)', zip: '284799' },
	{ city: 'Cloncant (Offaly)', zip: '133346' },
	{ city: 'Cloncarban (Offaly)', zip: '207310' },
	{ city: 'Cloncarneel (Meath)', zip: '665631' },
	{ city: 'Cloncarney (Donegal)', zip: '591723' },
	{ city: 'Cloncassan (Offaly)', zip: '612824' },
	{ city: 'Cloncat (Meath)', zip: '533142' },
	{ city: 'Cloncaw (Monaghan)', zip: '573775' },
	{ city: 'Clonclayagh (Donegal)', zip: '829860' },
	{ city: 'Clonclud (Cork)', zip: '182977' },
	{ city: 'Clonco (Galway)', zip: '271663' },
	{ city: 'Cloncoher (Offaly)', zip: '923227' },
	{ city: 'Cloncollog (Offaly)', zip: '699363' },
	{ city: 'Cloncollow (Cavan)', zip: '381920' },
	{ city: 'Cloncon (Offaly)', zip: '783715' },
	{ city: 'Clonconane (Limerick)', zip: '364539' },
	{ city: 'Clonconey (Kilkenny)', zip: '864985' },
	{ city: 'Clonconnell (Westmeath)', zip: '180782' },
	{ city: 'Clonconor Glebe (Cavan)', zip: '172721' },
	{ city: 'Clonconwal (Donegal)', zip: '488223' },
	{ city: 'Cloncorig (Tipperary)', zip: '331437' },
	{ city: 'Cloncose (Cavan)', zip: '102187' },
	{ city: 'Cloncoskoran (Waterford)', zip: '745540' },
	{ city: 'Cloncosney (Laois)', zip: '212917' },
	{ city: 'Cloncough (Laois)', zip: '256988' },
	{ city: 'Cloncourse (Laois)', zip: '836707' },
	{ city: 'Cloncouse (Cork)', zip: '617647' },
	{ city: 'Cloncovet (Cavan)', zip: '860278' },
	{ city: 'Cloncowan (Meath)', zip: '159123' },
	{ city: 'Cloncowley (Longford)', zip: '944031' },
	{ city: 'Cloncracken (Tipperary)', zip: '566201' },
	{ city: 'Cloncraff (Offaly)', zip: '302753' },
	{ city: 'Cloncrave (Westmeath)', zip: '504444' },
	{ city: 'Cloncreen (Offaly)', zip: '519557' },
	{ city: 'Cloncrew (Limerick)', zip: '287300' },
	{ city: 'Cloncrow (Westmeath)', zip: '154167' },
	{ city: 'Cloncullane (Laois)', zip: '529313' },
	{ city: 'Cloncullen (Laois)', zip: '776936' },
	{ city: 'Cloncullen (Meath)', zip: '942574' },
	{ city: 'Cloncullen (Westmeath)', zip: '258699' },
	{ city: 'Cloncully (Laois)', zip: '620797' },
	{ city: 'Cloncumber (Kildare)', zip: '231075' },
	{ city: 'Cloncumber (Monaghan)', zip: '371078' },
	{ city: 'Cloncurkney (Cavan)', zip: '392062' },
	{ city: 'Cloncurrin (Monaghan)', zip: '576314' },
	{ city: 'Cloncurry (Kildare)', zip: '112319' },
	{ city: 'Cloncurry (Tipperary)', zip: '965503' },
	{ city: 'Clondalee Beg (Meath)', zip: '694245' },
	{ city: 'Clondalee More (Meath)', zip: '709729' },
	{ city: 'Clondalever (Westmeath)', zip: '900289' },
	{ city: 'Clondalkin (Dublin)', zip: '549766' },
	{ city: 'Clondallan (Donegal)', zip: '593438' },
	{ city: 'Clondallow (Offaly)', zip: '372601' },
	{ city: 'Clondardis (Westmeath)', zip: '482382' },
	{ city: 'Clondargan (Cavan)', zip: '114175' },
	{ city: 'Clondargan Glebe (Cavan)', zip: '575538' },
	{ city: 'Clondarragh (Wexford)', zip: '167928' },
	{ city: 'Clondarrig (Laois)', zip: '552727' },
	{ city: 'Clondavaddog (Donegal)', zip: '252192' },
	{ city: 'Clondavan (Meath)', zip: '344192' },
	{ city: 'Clondaw (Wexford)', zip: '719550' },
	{ city: 'Clondelara (Offaly)', zip: '262687' },
	{ city: 'Clonderalaw (Clare)', zip: '473945' },
	{ city: 'Clondinnery (Monaghan)', zip: '239551' },
	{ city: 'Clondonnell (Waterford)', zip: '556130' },
	{ city: 'Clondonnell Glebe (Offaly)', zip: '808957' },
	{ city: 'Clondoogan (Meath)', zip: '464146' },
	{ city: 'Clondoolagh (Laois)', zip: '807017' },
	{ city: 'Clondoolusk (Offaly)', zip: '946687' },
	{ city: 'Clondoty (Tipperary)', zip: '482219' },
	{ city: 'Clondouglas (Kerry)', zip: '448676' },
	{ city: 'Clondouglas (Laois)', zip: '825263' },
	{ city: 'Clondown (Kildare)', zip: '763120' },
	{ city: 'Clondrinagh (Limerick)', zip: '565687' },
	{ city: 'Clondrohid (Cork)', zip: '455305' },
	{ city: 'Clonduff (Kildare)', zip: '565589' },
	{ city: 'Clonduff (Laois)', zip: '527566' },
	{ city: 'Clondulane (Cork)', zip: '796878' },
	{ city: 'Clondulane North (Cork)', zip: '638863' },
	{ city: 'Clondulane South (Cork)', zip: '228611' },
	{ city: 'Clone (Kilkenny)', zip: '216273' },
	{ city: 'Clone (Tipperary)', zip: '270595' },
	{ city: 'Clone (Wexford)', zip: '978904' },
	{ city: 'Clone (Wicklow)', zip: '994101' },
	{ city: 'Clonea (Waterford)', zip: '977230' },
	{ city: 'Clonea Lower (Waterford)', zip: '108129' },
	{ city: 'Clonea Middle (Waterford)', zip: '138021' },
	{ city: 'Clonearl (Offaly)', zip: '475099' },
	{ city: 'Clonearl Demesne (Offaly)', zip: '539750' },
	{ city: 'Cloneary (Cavan)', zip: '980550' },
	{ city: 'Clonea Upper (Waterford)', zip: '436214' },
	{ city: 'Clonedarby (Tipperary)', zip: '819734' },
	{ city: 'Clonedergole (Monaghan)', zip: '431906' },
	{ city: 'Clonee (Meath)', zip: '462742' },
	{ city: 'Clone East (Wexford)', zip: '355669' },
	{ city: 'Cloneeb (Laois)', zip: '151000' },
	{ city: 'Clonee East (Carlow)', zip: '886022' },
	{ city: 'Clonee Lower (Wexford)', zip: '796350' },
	{ city: 'Cloneen (Carlow)', zip: '364280' },
	{ city: 'Cloneen (Cork)', zip: '121399' },
	{ city: 'Cloneen (Kilkenny)', zip: '605593' },
	{ city: 'Cloneen (Offaly)', zip: '936979' },
	{ city: 'Cloneen (Tipperary)', zip: '854361' },
	{ city: 'Cloneen (Wicklow)', zip: '391658' },
	{ city: 'Cloneens (Meath)', zip: '308886' },
	{ city: 'Cloneety (Waterford)', zip: '757616' },
	{ city: 'Clonee Upper (Wexford)', zip: '724506' },
	{ city: 'Clonee West (Carlow)', zip: '313868' },
	{ city: 'Clonegah (Carlow)', zip: '656591' },
	{ city: 'Clonegall (Carlow)', zip: '580919' },
	{ city: 'Clonegath (Kildare)', zip: '265536' },
	{ city: 'Clonehurk (Laois)', zip: '793927' },
	{ city: 'Clonely (Tipperary)', zip: '571212' },
	{ city: 'Clonenagh (Laois)', zip: '999655' },
	{ city: 'Cloneranny (Wexford)', zip: '110115' },
	{ city: 'Clonerkin (Wicklow)', zip: '598502' },
	{ city: 'Clonervy (Cavan)', zip: '785191' },
	{ city: 'Clones (Monaghan)', zip: '479012' },
	{ city: 'Cloneska (Tipperary)', zip: '735432' },
	{ city: 'Clones Lower (Wexford)', zip: '852579' },
	{ city: 'Clones Middle (Wexford)', zip: '325031' },
	{ city: 'Clones Upper (Wexford)', zip: '338267' },
	{ city: 'Clonetoose (Carlow)', zip: '469084' },
	{ city: 'Clonever (Offaly)', zip: '749292' },
	{ city: 'Cloneveran (Meath)', zip: '785177' },
	{ city: 'Clonevin (Wexford)', zip: '952747' },
	{ city: 'Clone West (Wexford)', zip: '284661' },
	{ city: 'Cloney (Kildare)', zip: '399908' },
	{ city: 'Cloney (Meath)', zip: '275346' },
	{ city: 'Cloneybeg (Kildare)', zip: '304438' },
	{ city: 'Cloneybrien (Tipperary)', zip: '685698' },
	{ city: 'Cloneygowny (Tipperary)', zip: '414228' },
	{ city: 'Clonfad (Laois)', zip: '362816' },
	{ city: 'Clonfad (Monaghan)', zip: '358899' },
	{ city: 'Clonfad (Westmeath)', zip: '821719' },
	{ city: 'Clonfadda (Cork)', zip: '257702' },
	{ city: 'Clonfadda (Waterford)', zip: '671224' },
	{ city: 'Clonfane (Meath)', zip: '718345' },
	{ city: 'Clonfert (Cork)', zip: '113196' },
	{ city: 'Clonfert (Galway)', zip: '201689' },
	{ city: 'Clonfert Demesne (Galway)', zip: '880031' },
	{ city: 'Clonfert Demesne Bog (Galway)', zip: '594388' },
	{ city: 'Clonfert North (Galway)', zip: '165544' },
	{ city: 'Clonfert North (Kildare)', zip: '138468' },
	{ city: 'Clonfert South (Galway)', zip: '515791' },
	{ city: 'Clonfert South (Kildare)', zip: '311096' },
	{ city: 'Clonfinane (Tipperary)', zip: '610433' },
	{ city: 'Clonfinlough (Offaly)', zip: '650602' },
	{ city: 'Clonfinnan (Meath)', zip: '179344' },
	{ city: 'Clonfree (Tipperary)', zip: '822812' },
	{ city: 'Clongaddy (Wexford)', zip: '944141' },
	{ city: 'Clongall (Meath)', zip: '228127' },
	{ city: 'Clonganhue (Tipperary)', zip: '672002' },
	{ city: 'Clonganny (Wexford)', zip: '552119' },
	{ city: 'Clongarran (Carlow)', zip: '647523' },
	{ city: 'Clongarret (Offaly)', zip: '949234' },
	{ city: 'Clongawny (Offaly)', zip: '716442' },
	{ city: 'Clongawny (Westmeath)', zip: '949044' },
	{ city: 'Clongawny Beg (Offaly)', zip: '354529' },
	{ city: 'Clongawny More (Offaly)', zip: '669966' },
	{ city: 'Clongeen (Wexford)', zip: '321197' },
	{ city: 'Clongill (Meath)', zip: '712533' },
	{ city: 'Clonglaskan (Cork)', zip: '818514' },
	{ city: 'Clongorey (Kildare)', zip: '838297' },
	{ city: 'Clongower (Tipperary)', zip: '984325' },
	{ city: 'Clongowly (Westmeath)', zip: '863570' },
	{ city: 'Clongowna (Tipperary)', zip: '460242' },
	{ city: 'Clongownagh (Kildare)', zip: '906570' },
	{ city: 'Clongowny (Meath)', zip: '373113' },
	{ city: 'Clonguiffin (Meath)', zip: '300222' },
	{ city: 'Clongutery (Meath)', zip: '390531' },
	{ city: 'Clonhasten (Wexford)', zip: '757927' },
	{ city: 'Clonhenret (Wexford)', zip: '449385' },
	{ city: 'Clonickilroe (Westmeath)', zip: '909907' },
	{ city: 'Clonickilvant (Westmeath)', zip: '623420' },
	{ city: 'Cloniff (Offaly)', zip: '828979' },
	{ city: 'Cloniffeen (Offaly)', zip: '823610' },
	{ city: 'Clonin (Laois)', zip: '181575' },
	{ city: 'Clonin (Offaly)', zip: '240132' },
	{ city: 'Clonincurragh (Laois)', zip: '975120' },
	{ city: 'Clonisboyle (Monaghan)', zip: '685821' },
	{ city: 'Clonismullen (Tipperary)', zip: '398663' },
	{ city: 'Clonjordan (Wexford)', zip: '158101' },
	{ city: 'Clonkeady (Monaghan)', zip: '948275' },
	{ city: 'Clonkeehan (Louth)', zip: '328735' },
	{ city: 'Clonkeelan (Monaghan)', zip: '894729' },
	{ city: 'Clonkeen (Cavan)', zip: '631900' },
	{ city: 'Clonkeen (Kildare)', zip: '375634' },
	{ city: 'Clonkeen (Laois)', zip: '890825' },
	{ city: 'Clonkeen (Limerick)', zip: '165116' },
	{ city: 'Clonkeen (Monaghan)', zip: '679519' },
	{ city: 'Clonkeen (Offaly)', zip: '655562' },
	{ city: 'Clonkeen (Westmeath)', zip: '921110' },
	{ city: 'Clonkeen (Wicklow)', zip: '106832' },
	{ city: 'Clonkeenkerrill (Galway)', zip: '363886' },
	{ city: 'Clonkeeran (Kildare)', zip: '743112' },
	{ city: 'Clonkeiffy (Cavan)', zip: '871059' },
	{ city: 'Clonkelly (Offaly)', zip: '197121' },
	{ city: 'Clonkelly (Tipperary)', zip: '694957' },
	{ city: 'Clonkerdin (Waterford)', zip: '308156' },
	{ city: 'Clonkill (Westmeath)', zip: '950508' },
	{ city: 'Clonkilly Beg (Donegal)', zip: '219473' },
	{ city: 'Clonkilly More (Donegal)', zip: '673567' },
	{ city: 'Clonkirk (Monaghan)', zip: '783519' },
	{ city: 'Clonlack (Offaly)', zip: '583772' },
	{ city: 'Clonlahy (Tipperary)', zip: '329812' },
	{ city: 'Clonlahy Corporation Land (Laois)', zip: '236133' },
	{ city: 'Clonlard (Wexford)', zip: '344469' },
	{ city: 'Clonlea (Clare)', zip: '875770' },
	{ city: 'Clonlea (Cork)', zip: '301446' },
	{ city: 'Clonleame (Westmeath)', zip: '442529' },
	{ city: 'Clonleasan (Meath)', zip: '206811' },
	{ city: 'Clonlee (Offaly)', zip: '694528' },
	{ city: 'Clonleek (Monaghan)', zip: '444581' },
	{ city: 'Clonleigh (Cork)', zip: '154380' },
	{ city: 'Clonleigh (Wexford)', zip: '745281' },
	{ city: 'Clonlisk (Offaly)', zip: '534424' },
	{ city: 'Clonloaghan (Cavan)', zip: '247238' },
	{ city: 'Clonloghan (Clare)', zip: '298185' },
	{ city: 'Clonlonan (Monaghan)', zip: '982158' },
	{ city: 'Clonlonan (Westmeath)', zip: '358372' },
	{ city: 'Clonloskan (Cavan)', zip: '419498' },
	{ city: 'Clonlost (Westmeath)', zip: '386632' },
	{ city: 'Clonloughna (Limerick)', zip: '127120' },
	{ city: 'Clonlura (Monaghan)', zip: '807842' },
	{ city: 'Clonlusk (Meath)', zip: '481553' },
	{ city: 'Clonlusk (Tipperary)', zip: '884551' },
	{ city: 'Clonlyon (Laois)', zip: '863602' },
	{ city: 'Clonlyon (Meath)', zip: '694045' },
	{ city: 'Clonlyon (Offaly)', zip: '897314' },
	{ city: 'Clonlyon Castlequarter (Offaly)', zip: '883671' },
	{ city: 'Clonlyon Glebe (Offaly)', zip: '885830' },
	{ city: 'Clonmacken (Limerick)', zip: '855021' },
	{ city: 'Clonmacmara (Cavan)', zip: '800865' },
	{ city: 'Clonmacnoise (Offaly)', zip: '356193' },
	{ city: 'Clonmacshane (Carlow)', zip: '679820' },
	{ city: 'Clonmagaddan (Meath)', zip: '867379' },
	{ city: 'Clonmahon (Meath)', zip: '745397' },
	{ city: 'Clonmaine (Cork)', zip: '670437' },
	{ city: 'Clonmaine (Tipperary)', zip: '354865' },
	{ city: 'Clonmakilladuff (Tipperary)', zip: '306122' },
	{ city: 'Clonmalevin (Meath)', zip: '320242' },
	{ city: 'Clonmannan (Wicklow)', zip: '812534' },
	{ city: 'Clonmany (Donegal)', zip: '646570' },
	{ city: 'Clonmany Glebe (Donegal)', zip: '610294' },
	{ city: 'Clonmaskill (Westmeath)', zip: '314412' },
	{ city: 'Clonmass (Donegal)', zip: '801034' },
	{ city: 'Clonmeen (Offaly)', zip: '790277' },
	{ city: 'Clonmeenan (Monaghan)', zip: '340919' },
	{ city: 'Clonmeen North (Cork)', zip: '442327' },
	{ city: 'Clonmeen North (Laois)', zip: '881586' },
	{ city: 'Clonmeen South (Cork)', zip: '649827' },
	{ city: 'Clonmeen South (Laois)', zip: '161862' },
	{ city: 'Clonmeenwood (Laois)', zip: '442148' },
	{ city: 'Clonmel (Offaly)', zip: '973097' },
	{ city: 'Clonmel (Tipperary)', zip: '676151' },
	{ city: 'Clonmellon (Westmeath)', zip: '269447' },
	{ city: 'Clonmelsh (Carlow)', zip: '742286' },
	{ city: 'Clonmethan (Dublin)', zip: '759562' },
	{ city: 'Clonminam (Laois)', zip: '971639' },
	{ city: 'Clonminch (Offaly)', zip: '948131' },
	{ city: 'Clonmines (Wexford)', zip: '714296' },
	{ city: 'Clonmoher (Clare)', zip: '656728' },
	{ city: 'Clonmona (Tipperary)', zip: '731551' },
	{ city: 'Clonmoney North (Clare)', zip: '824312' },
	{ city: 'Clonmoney South (Clare)', zip: '456036' },
	{ city: 'Clonmoney West (Clare)', zip: '696104' },
	{ city: 'Clonmoran (Kilkenny)', zip: '884145' },
	{ city: 'Clonmore (Carlow)', zip: '628249' },
	{ city: 'Clonmore (Donegal)', zip: '171112' },
	{ city: 'Clonmore (Kilkenny)', zip: '396884' },
	{ city: 'Clonmore (Laois)', zip: '662301' },
	{ city: 'Clonmore (Louth)', zip: '112643' },
	{ city: 'Clonmore (Meath)', zip: '439180' },
	{ city: 'Clonmore (Monaghan)', zip: '744922' },
	{ city: 'Clonmore (Offaly)', zip: '466993' },
	{ city: 'Clonmore (Tipperary)', zip: '387499' },
	{ city: 'Clonmore (Waterford)', zip: '522961' },
	{ city: 'Clonmore (Westmeath)', zip: '239826' },
	{ city: 'Clonmore (Wexford)', zip: '291823' },
	{ city: 'Clon More (Tipperary)', zip: '585074' },
	{ city: 'Clonmore Lower (Wexford)', zip: '308571' },
	{ city: 'Clonmore North (Tipperary)', zip: '139004' },
	{ city: 'Clonmore South (Tipperary)', zip: '351305' },
	{ city: 'Clonmore Upper (Wexford)', zip: '510495' },
	{ city: 'Clonmorewalk (Tipperary)', zip: '407270' },
	{ city: 'Clonmorrill (Westmeath)', zip: '585710' },
	{ city: 'Clonmowley (Meath)', zip: '140008' },
	{ city: 'Clonmoyle (Cork)', zip: '391381' },
	{ city: 'Clonmoyle (Kildare)', zip: '943839' },
	{ city: 'Clonmoyle (Waterford)', zip: '649394' },
	{ city: 'Clonmoyle (Westmeath)', zip: '602122' },
	{ city: 'Clonmoyle East (Cork)', zip: '162805' },
	{ city: 'Clonmoyle West (Cork)', zip: '407996' },
	{ city: 'Clonmoyle West (Kildare)', zip: '975256' },
	{ city: 'Clonmullen (Carlow)', zip: '247357' },
	{ city: 'Clonmullin (Kildare)', zip: '656199' },
	{ city: 'Clonmult (Cavan)', zip: '756556' },
	{ city: 'Clonmult (Cork)', zip: '147031' },
	{ city: 'Clonmurragha (Tipperary)', zip: '384274' },
	{ city: 'Clonnagapple (Westmeath)', zip: '800511' },
	{ city: 'Clonnageeragh (Westmeath)', zip: '667147' },
	{ city: 'Clonnagore (Monaghan)', zip: '739033' },
	{ city: 'Clonnalynagh (Westmeath)', zip: '214038' },
	{ city: 'Clonnamanagh (Westmeath)', zip: '733112' },
	{ city: 'Clonnasheeoge (Wexford)', zip: '247747' },
	{ city: 'Clonnestin (Monaghan)', zip: '750677' },
	{ city: 'Clonogan (Carlow)', zip: '405684' },
	{ city: 'Clonoghil (Laois)', zip: '760009' },
	{ city: 'Clonoghill (Laois)', zip: '383229' },
	{ city: 'Clonoghil Lower (Offaly)', zip: '564431' },
	{ city: 'Clonoghil Upper (Offaly)', zip: '542500' },
	{ city: 'Clonomara (Cork)', zip: '324898' },
	{ city: 'Clononeen (Laois)', zip: '305108' },
	{ city: 'Clonony Beg (Offaly)', zip: '766435' },
	{ city: 'Clonony More (Offaly)', zip: '790621' },
	{ city: 'Clonoonagh (Laois)', zip: '612333' },
	{ city: 'Clonoony (Monaghan)', zip: '909602' },
	{ city: 'Clonoose Big (Cavan)', zip: '731689' },
	{ city: 'Clonoose Little (Cavan)', zip: '700076' },
	{ city: 'Clonosey (Cavan)', zip: '351176' },
	{ city: 'Clonough (Wexford)', zip: '635099' },
	{ city: 'Clonoula (Monaghan)', zip: '119857' },
	{ city: 'Clonoulty (Tipperary)', zip: '366519' },
	{ city: 'Clonoulty Churchquarter (Tipperary)', zip: '917676' },
	{ city: 'Clonoulty Curragh (Tipperary)', zip: '570182' },
	{ city: 'Clonoulty Hill (Tipperary)', zip: '922428' },
	{ city: 'Clonoura (Tipperary)', zip: '142718' },
	{ city: 'Clonownmore (Westmeath)', zip: '218982' },
	{ city: 'Clonpadden (Wicklow)', zip: '355577' },
	{ city: 'Clonpet (Tipperary)', zip: '980862' },
	{ city: 'Clonpierce (Laois)', zip: '109259' },
	{ city: 'Clonpriest East (Cork)', zip: '308892' },
	{ city: 'Clonpriest West (Cork)', zip: '575727' },
	{ city: 'Clonrah And Glaster (Offaly)', zip: '550726' },
	{ city: 'Clonraskin (Tipperary)', zip: '111458' },
	{ city: 'Clonraw (Cavan)', zip: '383488' },
	{ city: 'Clonreagh (Westmeath)', zip: '720885' },
	{ city: 'Clonreher (Laois)', zip: '213735' },
	{ city: 'Clonrelick (Westmeath)', zip: '714742' },
	{ city: 'Clonroad Beg (Clare)', zip: '202857' },
	{ city: 'Clonroad More (Clare)', zip: '873182' },
	{ city: 'Clonrobert (Westmeath)', zip: '617095' },
	{ city: 'Clonrobin (Cork)', zip: '723693' },
	{ city: 'Clonroche (Wexford)', zip: '692503' },
	{ city: 'Clonroe Lower (Wexford)', zip: '590674' },
	{ city: 'Clonroe Upper (Wexford)', zip: '122382' },
	{ city: 'Clonroosk (Laois)', zip: '924090' },
	{ city: 'Clonroosk Big (Offaly)', zip: '447848' },
	{ city: 'Clonroosk Little (Laois)', zip: '577319' },
	{ city: 'Clonroosk Little (Offaly)', zip: '707722' },
	{ city: 'Clonross (Meath)', zip: '986356' },
	{ city: 'Clonrud (Laois)', zip: '807173' },
	{ city: 'Clonrush (Clare)', zip: '569557' },
	{ city: 'Clonrye (Monaghan)', zip: '327002' },
	{ city: 'Clonsast (Kildare)', zip: '204536' },
	{ city: 'Clonsast Lower (Offaly)', zip: '121449' },
	{ city: 'Clonsast Upper (Offaly)', zip: '628662' },
	{ city: 'Clonsedy (Monaghan)', zip: '154734' },
	{ city: 'Clonseer (Offaly)', zip: '867231' },
	{ city: 'Clonshagh (Dublin)', zip: '281713' },
	{ city: 'Clonshanbo (Kildare)', zip: '611690' },
	{ city: 'Clonshannagh (Offaly)', zip: '879656' },
	{ city: 'Clonshannon (Offaly)', zip: '173004' },
	{ city: 'Clonshannon (Wicklow)', zip: '339144' },
	{ city: 'Clonshanny (Offaly)', zip: '542664' },
	{ city: 'Clonshanvo (Monaghan)', zip: '274200' },
	{ city: 'Clonsharragh (Wexford)', zip: '960342' },
	{ city: 'Clonshavoy (Limerick)', zip: '290908' },
	{ city: 'Clonsheever (Westmeath)', zip: '433019' },
	{ city: 'Clonshire Beg (Limerick)', zip: '485336' },
	{ city: 'Clonshire More (Limerick)', zip: '609782' },
	{ city: 'Clonsilla (Dublin)', zip: '645602' },
	{ city: 'Clonsilla East (Wexford)', zip: '396020' },
	{ city: 'Clonsilla West (Wexford)', zip: '175329' },
	{ city: 'Clonsingle (Tipperary)', zip: '691244' },
	{ city: 'Clonsingle (Westmeath)', zip: '109704' },
	{ city: 'Clonskeagh (Dublin)', zip: '361314' },
	{ city: 'Clonsoghey (Laois)', zip: '255856' },
	{ city: 'Clonsura (Westmeath)', zip: '234604' },
	{ city: 'Clonswords (Dublin)', zip: '240332' },
	{ city: 'Clontaaffe (Tipperary)', zip: '177728' },
	{ city: 'Clontaff (Cork)', zip: '222556' },
	{ city: 'Clontaglass (Offaly)', zip: '331154' },
	{ city: 'Clontail (Meath)', zip: '964743' },
	{ city: 'Clontallagh (Donegal)', zip: '831486' },
	{ city: 'Clontarf (Dublin)', zip: '631469' },
	{ city: 'Clontask (Monaghan)', zip: '632839' },
	{ city: 'Clontead Beg (Cork)', zip: '547286' },
	{ city: 'Clontead More (Cork)', zip: '746165' },
	{ city: 'Clonteens (Westmeath)', zip: '771797' },
	{ city: 'Clonteige (Tipperary)', zip: '882145' },
	{ city: 'Clonterlough (Offaly)', zip: '171317' },
	{ city: 'Clonterry (Laois)', zip: '524482' },
	{ city: 'Clonthread (Westmeath)', zip: '554424' },
	{ city: 'Clontibret (Monaghan)', zip: '131692' },
	{ city: 'Clontinteen (Westmeath)', zip: '595205' },
	{ city: 'Clontinty (Cork)', zip: '115204' },
	{ city: 'Clontoe (Monaghan)', zip: '745655' },
	{ city: 'Clontotan (Offaly)', zip: '933376' },
	{ city: 'Clontrain (Monaghan)', zip: '423494' },
	{ city: 'Clontreat (Monaghan)', zip: '183688' },
	{ city: 'Clontubbrid (Kilkenny)', zip: '824604' },
	{ city: 'Clontumpher (Longford)', zip: '890228' },
	{ city: 'Clonturk (Monaghan)', zip: '709931' },
	{ city: 'Clonturkan (Cavan)', zip: '437478' },
	{ city: 'Clontuskert (Galway)', zip: '620015' },
	{ city: 'Clontybunnia (Monaghan)', zip: '267219' },
	{ city: 'Clontycarnaghan (Cavan)', zip: '905725' },
	{ city: 'Clontycasta (Monaghan)', zip: '365027' },
	{ city: 'Clontycoe (Laois)', zip: '193031' },
	{ city: 'Clontycoo (Cavan)', zip: '530992' },
	{ city: 'Clontyduffy (Cavan)', zip: '684510' },
	{ city: 'Clontyglass (Laois)', zip: '457139' },
	{ city: 'Clontygrigny (Cavan)', zip: '878021' },
	{ city: 'Clontymullan (Longford)', zip: '632254' },
	{ city: 'Clontyseer (Donegal)', zip: '793129' },
	{ city: 'Clontytallon (Westmeath)', zip: '767815' },
	{ city: 'Clonuff (Kildare)', zip: '368319' },
	{ city: 'Clonwalsh (Tipperary)', zip: '467358' },
	{ city: 'Clonwhelan (Longford)', zip: '831651' },
	{ city: 'Clonwilliam (Wicklow)', zip: '933962' },
	{ city: 'Clonybane (Westmeath)', zip: '318767' },
	{ city: 'Clonybecan (Laois)', zip: '861275' },
	{ city: 'Clonyburn (Wexford)', zip: '508932' },
	{ city: 'Clonycavan (Meath)', zip: '694075' },
	{ city: 'Clonycurry (Meath)', zip: '633272' },
	{ city: 'Clonydonnin (Westmeath)', zip: '793160' },
	{ city: 'Clonyegan (Westmeath)', zip: '177631' },
	{ city: 'Clonygaheen (Tipperary)', zip: '756291' },
	{ city: 'Clonygarra (Kilkenny)', zip: '140659' },
	{ city: 'Clonygoose (Carlow)', zip: '466260' },
	{ city: 'Clonygowan (Laois)', zip: '309329' },
	{ city: 'Clonygowan (Offaly)', zip: '865232' },
	{ city: 'Clonygrange (Meath)', zip: '424147' },
	{ city: 'Clonyhague (Westmeath)', zip: '481322' },
	{ city: 'Clonyharp (Tipperary)', zip: '332779' },
	{ city: 'Clonyhurk (Offaly)', zip: '408178' },
	{ city: 'Clonylogan (Meath)', zip: '621033' },
	{ city: 'Clonymeath (Meath)', zip: '399789' },
	{ city: 'Clonymohan (Offaly)', zip: '697750' },
	{ city: 'Clonymore (Meath)', zip: '291569' },
	{ city: 'Clonymurtagh (Westmeath)', zip: '963594' },
	{ city: 'Clonyn (Westmeath)', zip: '771384' },
	{ city: 'Clonyquin (Offaly)', zip: '965407' },
	{ city: 'Clonyrina (Westmeath)', zip: '946902' },
	{ city: 'Clonyveey (Westmeath)', zip: '322460' },
	{ city: 'Cloodrevagh (Leitrim)', zip: '143619' },
	{ city: 'Cloodrumman Beg (Leitrim)', zip: '820568' },
	{ city: 'Cloodrumman More (Leitrim)', zip: '665940' },
	{ city: 'Cloon (Cork)', zip: '169209' },
	{ city: 'Cloon (Donegal)', zip: '906261' },
	{ city: 'Cloon (Galway)', zip: '594002' },
	{ city: 'Cloon (Kerry)', zip: '860382' },
	{ city: 'Cloon (Tipperary)', zip: '711402' },
	{ city: 'Cloon (Wexford)', zip: '928192' },
	{ city: 'Cloon (Wicklow)', zip: '987896' },
	{ city: 'Cloona (Clare)', zip: '383412' },
	{ city: 'Cloonacalleen (Galway)', zip: '471287' },
	{ city: 'Cloonacaltry (Roscommon)', zip: '525865' },
	{ city: 'Cloonacaltry (Sligo)', zip: '475037' },
	{ city: 'Cloonacannana (Mayo)', zip: '174998' },
	{ city: 'Cloonacarrow (Roscommon)', zip: '335281' },
	{ city: 'Cloonacastle (Galway)', zip: '718412' },
	{ city: 'Cloonacauna (Mayo)', zip: '798666' },
	{ city: 'Cloonacauneen (Galway)', zip: '127669' },
	{ city: 'Cloonacleigha (Sligo)', zip: '978632' },
	{ city: 'Cloonacolly (Roscommon)', zip: '799858' },
	{ city: 'Cloonacool (Sligo)', zip: '276679' },
	{ city: 'Cloonacullina (Offaly)', zip: '507046' },
	{ city: 'Cloonacurra (Sligo)', zip: '576811' },
	{ city: 'Cloonacurrig (Kerry)', zip: '970536' },
	{ city: 'Cloonacurry (Mayo)', zip: '415075' },
	{ city: 'Cloonadarragh (Galway)', zip: '994540' },
	{ city: 'Cloonadarragh East (Roscommon)', zip: '796288' },
	{ city: 'Cloonaddra (Roscommon)', zip: '438008' },
	{ city: 'Cloonaddron (Roscommon)', zip: '986665' },
	{ city: 'Cloonaderavally (Sligo)', zip: '361136' },
	{ city: 'Cloonadrum (Clare)', zip: '867700' },
	{ city: 'Cloonaduff (Limerick)', zip: '336062' },
	{ city: 'Cloonaff (Roscommon)', zip: '744712' },
	{ city: 'Cloonagahaun (Sligo)', zip: '493663' },
	{ city: 'Cloonagalloon (Mayo)', zip: '238236' },
	{ city: 'Cloonagashel (Sligo)', zip: '432339' },
	{ city: 'Cloonagawnagh (Galway)', zip: '862741' },
	{ city: 'Cloonageeher (Longford)', zip: '701706' },
	{ city: 'Cloonageeragh (Roscommon)', zip: '722126' },
	{ city: 'Cloonagh (Galway)', zip: '181988' },
	{ city: 'Cloonagh (Laois)', zip: '562126' },
	{ city: 'Cloonagh (Leitrim)', zip: '676952' },
	{ city: 'Cloonagh (Longford)', zip: '983418' },
	{ city: 'Cloonagh (Mayo)', zip: '848928' },
	{ city: 'Cloonagh (Roscommon)', zip: '604223' },
	{ city: 'Cloonagh (Sligo)', zip: '295046' },
	{ city: 'Cloonagh (Tipperary)', zip: '245797' },
	{ city: 'Cloonagh (Westmeath)', zip: '574554' },
	{ city: 'Cloonagh (Wexford)', zip: '346138' },
	{ city: 'Cloonaghbaun (Roscommon)', zip: '605149' },
	{ city: 'Cloonagh Beg (Laois)', zip: '996958' },
	{ city: 'Cloonaghboy (Mayo)', zip: '835327' },
	{ city: 'Cloonaghbrack (Roscommon)', zip: '269139' },
	{ city: 'Cloonaghduff (Mayo)', zip: '246153' },
	{ city: 'Cloonaghgarve (Galway)', zip: '533692' },
	{ city: 'Cloonaghlin (Kerry)', zip: '309279' },
	{ city: 'Cloonaghlin Lower (Cork)', zip: '898955' },
	{ city: 'Cloonaghlin Upper (Cork)', zip: '653651' },
	{ city: 'Cloonaghlin West (Cork)', zip: '542681' },
	{ city: 'Cloonaghmanagh (Mayo)', zip: '217071' },
	{ city: 'Cloonaghmore (Galway)', zip: '590539' },
	{ city: 'Cloonaghmore (Leitrim)', zip: '215576' },
	{ city: 'Cloonaghmore (Longford)', zip: '498785' },
	{ city: 'Cloonaghmore (Mayo)', zip: '166344' },
	{ city: 'Cloonagh More (Laois)', zip: '302218' },
	{ city: 'Cloonagh More (Mayo)', zip: '893520' },
	{ city: 'Cloonagleavragh (Sligo)', zip: '675106' },
	{ city: 'Cloonagleavragh Park (Sligo)', zip: '974759' },
	{ city: 'Cloonagowan (Clare)', zip: '298687' },
	{ city: 'Cloonagower (Galway)', zip: '455696' },
	{ city: 'Cloonagrassan (Roscommon)', zip: '651054' },
	{ city: 'Cloonagrouna (Meath)', zip: '208754' },
	{ city: 'Cloonagun (Sligo)', zip: '924682' },
	{ city: 'Cloonahard (Longford)', zip: '616106' },
	{ city: 'Cloonahee (Roscommon)', zip: '631524' },
	{ city: 'Cloonaheen (Offaly)', zip: '199342' },
	{ city: 'Cloonaherna (Clare)', zip: '130590' },
	{ city: 'Cloonahinch (Galway)', zip: '915993' },
	{ city: 'Cloonahinshin (Sligo)', zip: '476353' },
	{ city: 'Cloonahussey (Longford)', zip: '260829' },
	{ city: 'Cloonainra (Mayo)', zip: '412566' },
	{ city: 'Cloonakeemoge (Sligo)', zip: '775114' },
	{ city: 'Cloonakille (Roscommon)', zip: '436258' },
	{ city: 'Cloonakilleg (Roscommon)', zip: '113046' },
	{ city: 'Cloonakillina (Mayo)', zip: '297119' },
	{ city: 'Cloonakilly Beg (Roscommon)', zip: '429286' },
	{ city: 'Cloonakilly More (Roscommon)', zip: '575681' },
	{ city: 'Cloonalaghan (Mayo)', zip: '774561' },
	{ city: 'Cloonalassan (Kerry)', zip: '661186' },
	{ city: 'Cloonaleary (Clare)', zip: '321892' },
	{ city: 'Cloonaleedin (Mayo)', zip: '484233' },
	{ city: 'Cloonalis (Roscommon)', zip: '425766' },
	{ city: 'Cloonalisk (Offaly)', zip: '286586' },
	{ city: 'Cloonalison (Mayo)', zip: '174953' },
	{ city: 'Cloonaloo (Laois)', zip: '887228' },
	{ city: 'Cloonalough (Mayo)', zip: '222134' },
	{ city: 'Cloonalough (Roscommon)', zip: '838781' },
	{ city: 'Cloonaloughan (Offaly)', zip: '309823' },
	{ city: 'Cloonalour (Kerry)', zip: '783274' },
	{ city: 'Cloonamahan (Sligo)', zip: '917167' },
	{ city: 'Cloonaman (Kerry)', zip: '760821' },
	{ city: 'Cloonamanagh (Sligo)', zip: '454516' },
	{ city: 'Cloonameehan North (Sligo)', zip: '596438' },
	{ city: 'Cloonameehan South (Sligo)', zip: '748323' },
	{ city: 'Cloonameragaun (Galway)', zip: '930658' },
	{ city: 'Cloonametagh (Kerry)', zip: '514120' },
	{ city: 'Cloonamirran (Clare)', zip: '196107' },
	{ city: 'Cloonamore (Galway)', zip: '424999' },
	{ city: 'Cloonamuinia (Roscommon)', zip: '374552' },
	{ city: 'Cloonamurgal (Leitrim)', zip: '411172' },
	{ city: 'Cloonan (Mayo)', zip: '124240' },
	{ city: 'Cloonanaff (Mayo)', zip: '163401' },
	{ city: 'Cloonanagh (Tipperary)', zip: '444801' },
	{ city: 'Cloonanaha (Clare)', zip: '579965' },
	{ city: 'Cloonanart Beg (Roscommon)', zip: '712686' },
	{ city: 'Cloonanart More (Roscommon)', zip: '696632' },
	{ city: 'Cloonanass (Clare)', zip: '611330' },
	{ city: 'Cloonanass (Mayo)', zip: '733911' },
	{ city: 'Cloon And Commons (Limerick)', zip: '675266' },
	{ city: 'Cloonanearla (Galway)', zip: '417582' },
	{ city: 'Cloonanna (Limerick)', zip: '331301' },
	{ city: 'Cloonanny (Longford)', zip: '186809' },
	{ city: 'Cloonanny Glebe (Longford)', zip: '457513' },
	{ city: 'Cloonanorig (Kerry)', zip: '279727' },
	{ city: 'Cloonanure (Sligo)', zip: '270598' },
	{ city: 'Cloonapisha (Mayo)', zip: '608841' },
	{ city: 'Cloonaquin (Leitrim)', zip: '845382' },
	{ city: 'Cloonaraher (Sligo)', zip: '752109' },
	{ city: 'Cloonarara (Sligo)', zip: '188403' },
	{ city: 'Cloonarass (Clare)', zip: '215560' },
	{ city: 'Cloonard (Longford)', zip: '113621' },
	{ city: 'Cloonard (Roscommon)', zip: '811585' },
	{ city: 'Cloonareague (Cork)', zip: '588936' },
	{ city: 'Cloonargid (Roscommon)', zip: '419815' },
	{ city: 'Cloonark (Mayo)', zip: '555969' },
	{ city: 'Cloonark (Roscommon)', zip: '468051' },
	{ city: 'Cloonarkan (Galway)', zip: '457555' },
	{ city: 'Cloonarragh (Roscommon)', zip: '525555' },
	{ city: 'Cloonarrell (Donegal)', zip: '487437' },
	{ city: 'Cloonart North (Longford)', zip: '900388' },
	{ city: 'Cloonart South (Longford)', zip: '967677' },
	{ city: 'Cloonascarberry (Galway)', zip: '348189' },
	{ city: 'Cloonascarberry North (Galway)', zip: '110174' },
	{ city: 'Cloonascarberry South (Galway)', zip: '288217' },
	{ city: 'Cloonascoffagh (Sligo)', zip: '785981' },
	{ city: 'Cloonascragh (Galway)', zip: '544106' },
	{ city: 'Cloonastiallas (Roscommon)', zip: '663434' },
	{ city: 'Cloonatleva Lower (Galway)', zip: '885359' },
	{ city: 'Cloonatleva Upper (Galway)', zip: '524803' },
	{ city: 'Cloonatloukaun (Galway)', zip: '929126' },
	{ city: 'Cloonaufill (Roscommon)', zip: '463840' },
	{ city: 'Cloonavarry (Mayo)', zip: '783286' },
	{ city: 'Cloonaveigh (Clare)', zip: '270606' },
	{ city: 'Cloonaverry (Roscommon)', zip: '297869' },
	{ city: 'Cloonavihony (Galway)', zip: '264075' },
	{ city: 'Cloonavindin (Roscommon)', zip: '152901' },
	{ city: 'Cloonavullaun (Roscommon)', zip: '417982' },
	{ city: 'Cloonawee (Clare)', zip: '242539' },
	{ city: 'Cloonaweema (Mayo)', zip: '973989' },
	{ city: 'Cloonawillin (Clare)', zip: '123237' },
	{ city: 'Cloonawillin (Leitrim)', zip: '772958' },
	{ city: 'Cloonawillin (Mayo)', zip: '403088' },
	{ city: 'Cloonawillin (Tipperary)', zip: '267480' },
	{ city: 'Cloonback (Longford)', zip: '255308' },
	{ city: 'Cloonbalt (Longford)', zip: '392054' },
	{ city: 'Cloonbanaun (Mayo)', zip: '587505' },
	{ city: 'Cloonbane (Cork)', zip: '964998' },
	{ city: 'Cloonbaniff (Sligo)', zip: '110071' },
	{ city: 'Cloonbannan (Sligo)', zip: '374317' },
	{ city: 'Cloonbannin East (Cork)', zip: '264122' },
	{ city: 'Cloonbannin West (Cork)', zip: '647295' },
	{ city: 'Cloonbanniv (Galway)', zip: '410509' },
	{ city: 'Cloonbannive (Leitrim)', zip: '625410' },
	{ city: 'Cloonbar (Galway)', zip: '431566' },
	{ city: 'Cloonbard (Roscommon)', zip: '150936' },
	{ city: 'Cloonbarry (Sligo)', zip: '178974' },
	{ city: 'Cloonbaul (Mayo)', zip: '310940' },
	{ city: 'Cloonbearla (Longford)', zip: '523073' },
	{ city: 'Cloonbeg (Galway)', zip: '606009' },
	{ city: 'Cloonbeg (Kerry)', zip: '244498' },
	{ city: 'Cloonbeg (Waterford)', zip: '410067' },
	{ city: 'Cloon Beg (Kerry)', zip: '452537' },
	{ city: 'Cloonbeggaun (Roscommon)', zip: '120988' },
	{ city: 'Cloonbenes (Galway)', zip: '687849' },
	{ city: 'Cloonbigny (Roscommon)', zip: '745284' },
	{ city: 'Cloonbo (Leitrim)', zip: '348560' },
	{ city: 'Cloonboley (Roscommon)', zip: '247626' },
	{ city: 'Cloonboniagh North (Leitrim)', zip: '857292' },
	{ city: 'Cloonboniagh South (Leitrim)', zip: '156010' },
	{ city: 'Cloonbonniff (Mayo)', zip: '987130' },
	{ city: 'Cloonbonniff (Roscommon)', zip: '123059' },
	{ city: 'Cloonbonny (Westmeath)', zip: '653528' },
	{ city: 'Cloonbony (Clare)', zip: '432642' },
	{ city: 'Cloonbony (Longford)', zip: '877533' },
	{ city: 'Cloonbony (Roscommon)', zip: '822791' },
	{ city: 'Cloonboo (Galway)', zip: '676827' },
	{ city: 'Cloonboo Beg (Galway)', zip: '812729' },
	{ city: 'Cloonbookeighter (Mayo)', zip: '963487' },
	{ city: 'Cloonbookoughter (Mayo)', zip: '564215' },
	{ city: 'Cloonbooly (Clare)', zip: '438734' },
	{ city: 'Cloonboo More (Galway)', zip: '251860' },
	{ city: 'Cloonboorhy (Mayo)', zip: '168051' },
	{ city: 'Cloonbornia (Galway)', zip: '697152' },
	{ city: 'Cloonboy (Mayo)', zip: '267806' },
	{ city: 'Cloonboygher (Leitrim)', zip: '501796' },
	{ city: 'Cloonboyoge (Roscommon)', zip: '735396' },
	{ city: 'Cloonbrackna (Roscommon)', zip: '412068' },
	{ city: 'Cloonbrane (Kerry)', zip: '390176' },
	{ city: 'Cloonbreany (Longford)', zip: '793453' },
	{ city: 'Cloonbrien (Limerick)', zip: '493216' },
	{ city: 'Cloonbrin (Longford)', zip: '421288' },
	{ city: 'Cloonbrock (Longford)', zip: '330382' },
	{ city: 'Cloonbrone (Galway)', zip: '203829' },
	{ city: 'Cloonbrone (Mayo)', zip: '120568' },
	{ city: 'Cloonbrusk (Galway)', zip: '717093' },
	{ city: 'Cloonbulban (Mayo)', zip: '221710' },
	{ city: 'Cloonbullig (Mayo)', zip: '874635' },
	{ city: 'Cloonbunny (Roscommon)', zip: '241192' },
	{ city: 'Cloonbur (Galway)', zip: '128273' },
	{ city: 'Cloonburren (Roscommon)', zip: '691481' },
	{ city: 'Cloonca (Roscommon)', zip: '613147' },
	{ city: 'Cloonca (Sligo)', zip: '556855' },
	{ city: 'Clooncah (Galway)', zip: '458133' },
	{ city: 'Clooncah (Mayo)', zip: '644875' },
	{ city: 'Clooncah (Roscommon)', zip: '760956' },
	{ city: 'Clooncahir (Leitrim)', zip: '476366' },
	{ city: 'Clooncalgy (Roscommon)', zip: '616887' },
	{ city: 'Clooncalgy Beg (Roscommon)', zip: '219608' },
	{ city: 'Clooncalgy More (Roscommon)', zip: '775206' },
	{ city: 'Clooncalla Beg (Cork)', zip: '836057' },
	{ city: 'Clooncallaga (Galway)', zip: '593025' },
	{ city: 'Clooncalla More (Cork)', zip: '646314' },
	{ city: 'Clooncallis (Galway)', zip: '900155' },
	{ city: 'Clooncallow (Longford)', zip: '543987' },
	{ city: 'Clooncan (Mayo)', zip: '242613' },
	{ city: 'Clooncan (Roscommon)', zip: '113481' },
	{ city: 'Clooncanavan (Mayo)', zip: '646201' },
	{ city: 'Clooncannon (Galway)', zip: '723623' },
	{ city: 'Clooncarha (Mayo)', zip: '280347' },
	{ city: 'Clooncarhy (Clare)', zip: '579266' },
	{ city: 'Clooncarrabaun (Mayo)', zip: '706928' },
	{ city: 'Clooncarreen (Leitrim)', zip: '704901' },
	{ city: 'Clooncarrig (Kerry)', zip: '618880' },
	{ city: 'Clooncashel Beg (Roscommon)', zip: '745962' },
	{ city: 'Clooncashel More (Roscommon)', zip: '301258' },
	{ city: 'Clooncaulfield (Longford)', zip: '362932' },
	{ city: 'Clooncaura (Limerick)', zip: '683334' },
	{ city: 'Clooncaurha (Clare)', zip: '323424' },
	{ city: 'Cloonchambers (Roscommon)', zip: '282758' },
	{ city: 'Cloonclare (Leitrim)', zip: '697980' },
	{ city: 'Clooncleagh (Tipperary)', zip: '364503' },
	{ city: 'Clooncleevragh (Mayo)', zip: '644884' },
	{ city: 'Cloonclivvy (Leitrim)', zip: '616302' },
	{ city: 'Cloonclogh (Kerry)', zip: '378035' },
	{ city: 'Clooncoe (Leitrim)', zip: '247487' },
	{ city: 'Clooncogaile (Waterford)', zip: '521622' },
	{ city: 'Clooncolla (Kerry)', zip: '627213' },
	{ city: 'Clooncolligan (Longford)', zip: '754941' },
	{ city: 'Clooncolman (Clare)', zip: '109242' },
	{ city: 'Clooncolry (Leitrim)', zip: '225136' },
	{ city: 'Clooncommon Beg (Roscommon)', zip: '569105' },
	{ city: 'Clooncommon More (Roscommon)', zip: '469305' },
	{ city: 'Clooncon (Limerick)', zip: '163953' },
	{ city: 'Clooncona (Galway)', zip: '199946' },
	{ city: 'Cloonconabeg (Galway)', zip: '588732' },
	{ city: 'Clooncon East (Galway)', zip: '601051' },
	{ city: 'Cloonconeen (Clare)', zip: '465066' },
	{ city: 'Cloonconlan (Mayo)', zip: '391221' },
	{ city: 'Cloonconneelaun (Mayo)', zip: '573366' },
	{ city: 'Cloonconny (Roscommon)', zip: '987539' },
	{ city: 'Cloonconor (Mayo)', zip: '464677' },
	{ city: 'Cloonconore (Galway)', zip: '133953' },
	{ city: 'Cloonconra (Galway)', zip: '775954' },
	{ city: 'Cloonconra (Mayo)', zip: '179865' },
	{ city: 'Cloonconra (Roscommon)', zip: '763380' },
	{ city: 'Cloonconragh East (Mayo)', zip: '944192' },
	{ city: 'Cloonconragh West (Mayo)', zip: '828053' },
	{ city: 'Cloonconway (Mayo)', zip: '985550' },
	{ city: 'Clooncon West (Galway)', zip: '888737' },
	{ city: 'Clooncool (Clare)', zip: '640150' },
	{ city: 'Clooncooravane North (Limerick)', zip: '228507' },
	{ city: 'Clooncooravane South (Limerick)', zip: '475056' },
	{ city: 'Clooncoose (Clare)', zip: '579952' },
	{ city: 'Clooncoose (Longford)', zip: '300570' },
	{ city: 'Clooncoose (Roscommon)', zip: '549209' },
	{ city: 'Clooncoose North (Roscommon)', zip: '426151' },
	{ city: 'Clooncoose South (Roscommon)', zip: '861744' },
	{ city: 'Clooncor (Roscommon)', zip: '114696' },
	{ city: 'Clooncoran (Roscommon)', zip: '801961' },
	{ city: 'Clooncorban (Cork)', zip: '738627' },
	{ city: 'Clooncorick (Leitrim)', zip: '873759' },
	{ city: 'Clooncormick (Mayo)', zip: '537571' },
	{ city: 'Clooncorraun (Mayo)', zip: '687296' },
	{ city: 'Clooncose (Leitrim)', zip: '221364' },
	{ city: 'Clooncose (Sligo)', zip: '284120' },
	{ city: 'Clooncosker (Roscommon)', zip: '127202' },
	{ city: 'Clooncoul (Clare)', zip: '119829' },
	{ city: 'Clooncous (Mayo)', zip: '320515' },
	{ city: 'Clooncraff (Roscommon)', zip: '121715' },
	{ city: 'Clooncraffield (Roscommon)', zip: '655840' },
	{ city: 'Clooncran (Roscommon)', zip: '782490' },
	{ city: 'Clooncree (Galway)', zip: '227940' },
	{ city: 'Clooncreestane (Kerry)', zip: '836138' },
	{ city: 'Clooncrim (Roscommon)', zip: '724616' },
	{ city: 'Clooncrippa (Limerick)', zip: '582987' },
	{ city: 'Clooncrooeel (Mayo)', zip: '864706' },
	{ city: 'Clooncruffer (Roscommon)', zip: '160358' },
	{ city: 'Clooncugger (Cork)', zip: '803592' },
	{ city: 'Clooncullaan (Roscommon)', zip: '564576' },
	{ city: 'Clooncullaun (Galway)', zip: '525634' },
	{ city: 'Clooncullen (Longford)', zip: '455144' },
	{ city: 'Clooncullin (Clare)', zip: '752712' },
	{ city: 'Clooncumber (Leitrim)', zip: '448394' },
	{ city: 'Clooncunna North (Limerick)', zip: '411212' },
	{ city: 'Clooncunna South (Limerick)', zip: '402857' },
	{ city: 'Clooncunnig (Cork)', zip: '139553' },
	{ city: 'Clooncunny (Galway)', zip: '685778' },
	{ city: 'Clooncunny (Roscommon)', zip: '666582' },
	{ city: 'Clooncunny (Sligo)', zip: '624972' },
	{ city: 'Clooncurra (Kerry)', zip: '451572' },
	{ city: 'Clooncurreen (Galway)', zip: '111270' },
	{ city: 'Cloondacarra (Roscommon)', zip: '306748' },
	{ city: 'Cloondacarra Beg (Roscommon)', zip: '941617' },
	{ city: 'Cloondace (Mayo)', zip: '614397' },
	{ city: 'Cloondacon (Mayo)', zip: '270443' },
	{ city: 'Cloondadauv (Galway)', zip: '170773' },
	{ city: 'Cloondaff (Mayo)', zip: '937480' },
	{ city: 'Cloondahamper (Galway)', zip: '701181' },
	{ city: 'Cloondalin (Westmeath)', zip: '314916' },
	{ city: 'Cloondanagh (Clare)', zip: '128383' },
	{ city: 'Cloondara (Longford)', zip: '421963' },
	{ city: 'Cloondarah (Roscommon)', zip: '196334' },
	{ city: 'Cloondarone (Galway)', zip: '682274' },
	{ city: 'Cloondart (Roscommon)', zip: '926235' },
	{ city: 'Cloondaver (Mayo)', zip: '117874' },
	{ city: 'Cloondeash (Mayo)', zip: '645246' },
	{ city: 'Cloondergan (Galway)', zip: '784991' },
	{ city: 'Cloonderreen (Cork)', zip: '412924' },
	{ city: 'Cloonderry (Sligo)', zip: '684613' },
	{ city: 'Cloondine (Galway)', zip: '238958' },
	{ city: 'Cloondinnaire (Mayo)', zip: '714631' },
	{ city: 'Cloondoolough (Mayo)', zip: '907560' },
	{ city: 'Cloondoorney Beg (Clare)', zip: '527532' },
	{ city: 'Cloondoorney More (Clare)', zip: '117965' },
	{ city: 'Cloondorragha (Sligo)', zip: '847788' },
	{ city: 'Cloondoyle Beg (Galway)', zip: '845927' },
	{ city: 'Cloondoyle More (Galway)', zip: '398845' },
	{ city: 'Cloondrihara (Sligo)', zip: '540276' },
	{ city: 'Cloondrinagh (Clare)', zip: '158450' },
	{ city: 'Cloondroon (Galway)', zip: '951516' },
	{ city: 'Cloondroon (Mayo)', zip: '919477' },
	{ city: 'Cloone (Cavan)', zip: '677122' },
	{ city: 'Cloone (Kilkenny)', zip: '623587' },
	{ city: 'Cloone (Leitrim)', zip: '343208' },
	{ city: 'Cloone (Tipperary)', zip: '993633' },
	{ city: 'Clooneagh (Kerry)', zip: '677226' },
	{ city: 'Clooneagh (Leitrim)', zip: '419686' },
	{ city: 'Clooneagh (Sligo)', zip: '331265' },
	{ city: 'Clooneally (Sligo)', zip: '245577' },
	{ city: 'Cloonean (Mayo)', zip: '276109' },
	{ city: 'Cloonearagh (Kerry)', zip: '204556' },
	{ city: 'Cloonearagh (Roscommon)', zip: '484039' },
	{ city: 'Cloon East (Kerry)', zip: '901777' },
	{ city: 'Cloonederowen (Galway)', zip: '510246' },
	{ city: 'Cloonee (Cork)', zip: '927554' },
	{ city: 'Cloonee (Galway)', zip: '308777' },
	{ city: 'Cloonee (Kerry)', zip: '734354' },
	{ city: 'Cloonee (Leitrim)', zip: '847060' },
	{ city: 'Cloonee (Limerick)', zip: '609805' },
	{ city: 'Cloonee (Longford)', zip: '541110' },
	{ city: 'Cloonee (Mayo)', zip: '628279' },
	{ city: 'Clooneen (Cavan)', zip: '249560' },
	{ city: 'Clooneen (Clare)', zip: '758953' },
	{ city: 'Clooneen (Galway)', zip: '962606' },
	{ city: 'Clooneen (Kerry)', zip: '355820' },
	{ city: 'Clooneen (Leitrim)', zip: '459603' },
	{ city: 'Clooneen (Longford)', zip: '596280' },
	{ city: 'Clooneen (Mayo)', zip: '838145' },
	{ city: 'Clooneen (Offaly)', zip: '279298' },
	{ city: 'Clooneen (Roscommon)', zip: '736188' },
	{ city: 'Clooneen (Sligo)', zip: '441198' },
	{ city: 'Clooneenagh (Clare)', zip: '946819' },
	{ city: 'Clooneenbaun (Roscommon)', zip: '569443' },
	{ city: 'Clooneencapullagh (Offaly)', zip: '471003' },
	{ city: 'Clooneencarra (Mayo)', zip: '428126' },
	{ city: 'Clooneenhugh (Sligo)', zip: '349414' },
	{ city: 'Clooneenkillew (Mayo)', zip: '927365' },
	{ city: 'Clooneen Lower (Tipperary)', zip: '983175' },
	{ city: 'Clooneen Middle (Tipperary)', zip: '654936' },
	{ city: 'Clooneenroe (Sligo)', zip: '340265' },
	{ city: 'Clooneen Upper (Tipperary)', zip: '479929' },
	{ city: 'Clooneeny (Longford)', zip: '132751' },
	{ city: 'Clooneigh (Mayo)', zip: '556739' },
	{ city: 'Clooneigh (Roscommon)', zip: '364733' },
	{ city: 'Clooneish (Roscommon)', zip: '175408' },
	{ city: 'Cloonellan (Longford)', zip: '298007' },
	{ city: 'Cloonelly (Longford)', zip: '930868' },
	{ city: 'Cloonelly (Roscommon)', zip: '702732' },
	{ city: 'Cloonelly (Sligo)', zip: '954266' },
	{ city: 'Cloonelt (Roscommon)', zip: '131666' },
	{ city: 'Cloonena (Sligo)', zip: '594351' },
	{ city: 'Cloonenagh (Mayo)', zip: '771077' },
	{ city: 'Cloonerane (Wexford)', zip: '977777' },
	{ city: 'Cloonerco (Sligo)', zip: '387460' },
	{ city: 'Cloonerk (Roscommon)', zip: '363492' },
	{ city: 'Cloonerkaun (Roscommon)', zip: '360427' },
	{ city: 'Cloonerneen (Mayo)', zip: '233699' },
	{ city: 'Cloonerra (Roscommon)', zip: '698846' },
	{ city: 'Clooneshil (Mayo)', zip: '608537' },
	{ city: 'Clooneskert (Roscommon)', zip: '696310' },
	{ city: 'Cloonevit (Longford)', zip: '238579' },
	{ city: 'Clooney (Clare)', zip: '823623' },
	{ city: 'Clooney (Donegal)', zip: '909507' },
	{ city: 'Clooney (Leitrim)', zip: '102762' },
	{ city: 'Clooney (Meath)', zip: '294788' },
	{ city: 'Clooney And Gortnamona (Donegal)', zip: '890272' },
	{ city: 'Clooneybreen (Clare)', zip: '243364' },
	{ city: 'Clooneylissaun (Clare)', zip: '294576' },
	{ city: 'Clooney More (Donegal)', zip: '229436' },
	{ city: 'Clooney North (Clare)', zip: '909860' },
	{ city: 'Clooneyogan North (Clare)', zip: '251517' },
	{ city: 'Clooneyogan South (Clare)', zip: '346357' },
	{ city: 'Clooney South (Clare)', zip: '811215' },
	{ city: 'Cloonfad (Roscommon)', zip: '880820' },
	{ city: 'Cloonfad Beg (Roscommon)', zip: '574816' },
	{ city: 'Cloonfadda (Clare)', zip: '788532' },
	{ city: 'Cloonfadda (Mayo)', zip: '108646' },
	{ city: 'Cloonfad East (Roscommon)', zip: '789237' },
	{ city: 'Cloonfad More (Roscommon)', zip: '340890' },
	{ city: 'Cloonfad West (Roscommon)', zip: '263686' },
	{ city: 'Cloonfaghna (Galway)', zip: '765489' },
	{ city: 'Cloonfallagh (Mayo)', zip: '954349' },
	{ city: 'Cloonfane (Galway)', zip: '782133' },
	{ city: 'Cloonfane (Mayo)', zip: '827238' },
	{ city: 'Cloonfaughna (Mayo)', zip: '244700' },
	{ city: 'Cloonfaulus (Mayo)', zip: '650815' },
	{ city: 'Cloonfeacle (Leitrim)', zip: '625888' },
	{ city: 'Cloonfeagh (Clare)', zip: '659646' },
	{ city: 'Cloonfeaghra (Clare)', zip: '737170' },
	{ city: 'Cloonfeaghra (Mayo)', zip: '860458' },
	{ city: 'Cloonfeightrin (Mayo)', zip: '596930' },
	{ city: 'Cloonfelliv (Roscommon)', zip: '934050' },
	{ city: 'Cloonfert (Mayo)', zip: '162076' },
	{ city: 'Cloonfide (Longford)', zip: '811046' },
	{ city: 'Cloonfin (Longford)', zip: '289770' },
	{ city: 'Cloonfineen (Roscommon)', zip: '807877' },
	{ city: 'Cloonfinfy (Longford)', zip: '873011' },
	{ city: 'Cloonfinglas (Roscommon)', zip: '554900' },
	{ city: 'Cloonfinglass (Tipperary)', zip: '131808' },
	{ city: 'Cloonfinish (Mayo)', zip: '160704' },
	{ city: 'Cloonfinlough (Roscommon)', zip: '469218' },
	{ city: 'Cloonfinnan (Leitrim)', zip: '245693' },
	{ city: 'Cloonfinnaun (Mayo)', zip: '164099' },
	{ city: 'Cloonfinnoge (Galway)', zip: '544039' },
	{ city: 'Cloonfiugh (Longford)', zip: '987730' },
	{ city: 'Cloonflyn (Mayo)', zip: '897749' },
	{ city: 'Cloonfoher (Mayo)', zip: '220207' },
	{ city: 'Cloonfore (Longford)', zip: '131978' },
	{ city: 'Cloonfower (Roscommon)', zip: '977321' },
	{ city: 'Cloonfree (Roscommon)', zip: '649712' },
	{ city: 'Cloonfurrihis (Clare)', zip: '401195' },
	{ city: 'Cloonfush (Galway)', zip: '214550' },
	{ city: 'Cloongad (Sligo)', zip: '125351' },
	{ city: 'Cloongaheen East (Clare)', zip: '948820' },
	{ city: 'Cloongaheen West (Clare)', zip: '942466' },
	{ city: 'Cloongarvan (Roscommon)', zip: '504576' },
	{ city: 'Cloongarve (Clare)', zip: '897993' },
	{ city: 'Cloongawna (Galway)', zip: '711687' },
	{ city: 'Cloongawnagh (Mayo)', zip: '619753' },
	{ city: 'Cloongee (Mayo)', zip: '596957' },
	{ city: 'Cloongeel (Cork)', zip: '820357' },
	{ city: 'Cloonglasney (Mayo)', zip: '584422' },
	{ city: 'Cloonglasny Beg (Roscommon)', zip: '453625' },
	{ city: 'Cloonglasny More (Roscommon)', zip: '297266' },
	{ city: 'Cloon Glebe (Kerry)', zip: '246273' },
	{ city: 'Cloongoonagh (Sligo)', zip: '353993' },
	{ city: 'Cloongowla (Mayo)', zip: '676019' },
	{ city: 'Cloongown (Cork)', zip: '511943' },
	{ city: 'Cloongowna (Clare)', zip: '301005' },
	{ city: 'Cloongowna (Roscommon)', zip: '796872' },
	{ city: 'Cloongownagh (Limerick)', zip: '770932' },
	{ city: 'Cloongownagh (Roscommon)', zip: '607879' },
	{ city: 'Cloongreaghan (Roscommon)', zip: '593386' },
	{ city: 'Cloongullaun (Mayo)', zip: '315527' },
	{ city: 'Cloonierin (Mayo)', zip: '522689' },
	{ city: 'Clooniff (Galway)', zip: '866686' },
	{ city: 'Clooniff (Roscommon)', zip: '409887' },
	{ city: 'Cloonigny (Galway)', zip: '252452' },
	{ city: 'Clooniher (Longford)', zip: '221972' },
	{ city: 'Cloonillan (Roscommon)', zip: '563722' },
	{ city: 'Clooninagh (Galway)', zip: '672965' },
	{ city: 'Cloonineen (Galway)', zip: '450881' },
	{ city: 'Clooningan (Sligo)', zip: '847152' },
	{ city: 'Clooninihy (Tipperary)', zip: '996121' },
	{ city: 'Clooninisclin (Roscommon)', zip: '792975' },
	{ city: 'Clooninshin (Mayo)', zip: '594202' },
	{ city: 'Cloonisle (Galway)', zip: '268245' },
	{ city: 'Cloonkea (Galway)', zip: '277499' },
	{ city: 'Cloonkedagh (Mayo)', zip: '639823' },
	{ city: 'Cloonkee (Mayo)', zip: '854672' },
	{ city: 'Cloonkeeghan (Mayo)', zip: '797110' },
	{ city: 'Cloonkeeghan Commons (Mayo)', zip: '120247' },
	{ city: 'Cloonkeehan East (Roscommon)', zip: '952897' },
	{ city: 'Cloonkeehan West (Roscommon)', zip: '858328' },
	{ city: 'Cloonkeel (Longford)', zip: '379876' },
	{ city: 'Cloonkeelaun (Sligo)', zip: '838395' },
	{ city: 'Cloonkeely (Galway)', zip: '829837' },
	{ city: 'Cloonkeen (Cork)', zip: '515235' },
	{ city: 'Cloonkeen (Galway)', zip: '560330' },
	{ city: 'Cloonkeen (Kerry)', zip: '877382' },
	{ city: 'Cloonkeen (Longford)', zip: '409071' },
	{ city: 'Cloonkeen (Mayo)', zip: '873841' },
	{ city: 'Cloonkeen (Roscommon)', zip: '155591' },
	{ city: 'Cloonkeenbeg (Galway)', zip: '895235' },
	{ city: 'Cloonkeenclare (Galway)', zip: '780570' },
	{ city: 'Cloonkeen East (Cork)', zip: '556982' },
	{ city: 'Cloonkeen East (Galway)', zip: '731905' },
	{ city: 'Cloonkeen Eighter (Galway)', zip: '193146' },
	{ city: 'Cloonkeenleananode (Galway)', zip: '709539' },
	{ city: 'Cloonkeenmore North (Galway)', zip: '186642' },
	{ city: 'Cloonkeenmore South (Galway)', zip: '647882' },
	{ city: 'Cloonkeennagran (Galway)', zip: '156167' },
	{ city: 'Cloonkeen North (Galway)', zip: '701225' },
	{ city: 'Cloonkeen Oughter (Galway)', zip: '665085' },
	{ city: 'Cloonkeen South (Galway)', zip: '209010' },
	{ city: 'Cloonkeen West (Galway)', zip: '597597' },
	{ city: 'Cloonkeevy (Sligo)', zip: '413953' },
	{ city: 'Cloonkelly (Mayo)', zip: '434616' },
	{ city: 'Cloonker (Longford)', zip: '445102' },
	{ city: 'Cloonkerin (Roscommon)', zip: '835869' },
	{ city: 'Cloonkerry (Clare)', zip: '237294' },
	{ city: 'Cloonkerry (Mayo)', zip: '848544' },
	{ city: 'Cloonkerry East (Clare)', zip: '571299' },
	{ city: 'Cloonkerry West (Clare)', zip: '909599' },
	{ city: 'Cloonkesh (Mayo)', zip: '435597' },
	{ city: 'Cloonkett (Clare)', zip: '769069' },
	{ city: 'Cloonkilla (Cork)', zip: '308598' },
	{ city: 'Cloonkirgeen (Cork)', zip: '619894' },
	{ city: 'Cloonlagheen (Mayo)', zip: '110239' },
	{ city: 'Cloonlahan (Galway)', zip: '125308' },
	{ city: 'Cloonlahard East (Limerick)', zip: '363568' },
	{ city: 'Cloonlahard West (Limerick)', zip: '216250' },
	{ city: 'Cloonlaheen (Clare)', zip: '135512' },
	{ city: 'Cloonlaheen (Sligo)', zip: '281702' },
	{ city: 'Cloonlaheen East (Clare)', zip: '870537' },
	{ city: 'Cloonlaheen Middle (Clare)', zip: '310238' },
	{ city: 'Cloonlaheen West (Clare)', zip: '329863' },
	{ city: 'Cloonlara (Clare)', zip: '987259' },
	{ city: 'Cloonlara (Kerry)', zip: '505394' },
	{ city: 'Cloonlara (Limerick)', zip: '910655' },
	{ city: 'Cloonlara (Mayo)', zip: '267913' },
	{ city: 'Cloonlara North (Galway)', zip: '688769' },
	{ city: 'Cloonlara South (Galway)', zip: '496585' },
	{ city: 'Cloonlarge (Roscommon)', zip: '400329' },
	{ city: 'Cloonlarhan (Mayo)', zip: '182572' },
	{ city: 'Cloonlatieve (Roscommon)', zip: '172022' },
	{ city: 'Cloonlaughil (Leitrim)', zip: '733281' },
	{ city: 'Cloonlaughil (Sligo)', zip: '232017' },
	{ city: 'Cloonlaughnan (Roscommon)', zip: '614591' },
	{ city: 'Cloonlaur (Mayo)', zip: '594392' },
	{ city: 'Cloonlavis Lower (Mayo)', zip: '783616' },
	{ city: 'Cloonlavis Upper (Mayo)', zip: '151847' },
	{ city: 'Cloonleagh North (Cork)', zip: '355815' },
	{ city: 'Cloonleagh South (Cork)', zip: '678632' },
	{ city: 'Cloonlee (Galway)', zip: '723476' },
	{ city: 'Cloonlee (Mayo)', zip: '344181' },
	{ city: 'Cloonlee (Roscommon)', zip: '810746' },
	{ city: 'Cloonleenaun (Galway)', zip: '856070' },
	{ city: 'Cloonliffen (Mayo)', zip: '174482' },
	{ city: 'Cloonlish (Roscommon)', zip: '802732' },
	{ city: 'Cloonlogher (Kerry)', zip: '334848' },
	{ city: 'Cloonlogher (Leitrim)', zip: '830476' },
	{ city: 'Cloonlogue (Limerick)', zip: '792344' },
	{ city: 'Cloonlooaun (Galway)', zip: '548128' },
	{ city: 'Cloonloogh (Sligo)', zip: '787752' },
	{ city: 'Cloonlough (Cork)', zip: '370714' },
	{ city: 'Cloonloum Beg (Clare)', zip: '710190' },
	{ city: 'Cloonloum More (Clare)', zip: '121671' },
	{ city: 'Cloonlumney (Mayo)', zip: '944445' },
	{ city: 'Cloonlumney (Roscommon)', zip: '355739' },
	{ city: 'Cloonlurg (Sligo)', zip: '552797' },
	{ city: 'Cloonlusk (Galway)', zip: '846510' },
	{ city: 'Cloonlusk (Limerick)', zip: '443272' },
	{ city: 'Cloonlynchaghaun (Mayo)', zip: '572348' },
	{ city: 'Cloonlyon (Galway)', zip: '179044' },
	{ city: 'Cloonlyon (Mayo)', zip: '544006' },
	{ city: 'Cloonmaan (Mayo)', zip: '653324' },
	{ city: 'Cloonmaan (Roscommon)', zip: '644596' },
	{ city: 'Cloonmacart (Longford)', zip: '726251' },
	{ city: 'Cloonmacduff (Sligo)', zip: '613156' },
	{ city: 'Cloonmackan (Clare)', zip: '254871' },
	{ city: 'Cloonmackon (Kerry)', zip: '782141' },
	{ city: 'Cloonmacmullan (Roscommon)', zip: '332292' },
	{ city: 'Cloonmaghaura (Galway)', zip: '175574' },
	{ city: 'Cloonmagunnaun (Roscommon)', zip: '729992' },
	{ city: 'Cloonmahaan (Roscommon)', zip: '131500' },
	{ city: 'Cloonmain (Galway)', zip: '179046' },
	{ city: 'Cloonmalonga (Tipperary)', zip: '140887' },
	{ city: 'Cloonmanagh (Tipperary)', zip: '187357' },
	{ city: 'Cloonmartin (Clare)', zip: '668534' },
	{ city: 'Cloonmaul (Roscommon)', zip: '465602' },
	{ city: 'Cloonmealane (Kerry)', zip: '469666' },
	{ city: 'Cloonmeane (Roscommon)', zip: '384739' },
	{ city: 'Cloonmee (Longford)', zip: '111828' },
	{ city: 'Cloonmeen (Roscommon)', zip: '493083' },
	{ city: 'Cloonmeen East (Mayo)', zip: '894482' },
	{ city: 'Cloonmeen West (Mayo)', zip: '608442' },
	{ city: 'Cloonmeone Lower (Leitrim)', zip: '890233' },
	{ city: 'Cloonmeone Upper (Leitrim)', zip: '372026' },
	{ city: 'Cloonminda (Galway)', zip: '400389' },
	{ city: 'Cloonmohaun (Clare)', zip: '641082' },
	{ city: 'Cloonmonad (Mayo)', zip: '609661' },
	{ city: 'Cloonmoney (Clare)', zip: '123956' },
	{ city: 'Cloonmore (Clare)', zip: '682247' },
	{ city: 'Cloonmore (Cork)', zip: '190006' },
	{ city: 'Cloonmore (Galway)', zip: '621182' },
	{ city: 'Cloonmore (Kerry)', zip: '202241' },
	{ city: 'Cloonmore (Limerick)', zip: '607157' },
	{ city: 'Cloonmore (Longford)', zip: '955744' },
	{ city: 'Cloonmore (Mayo)', zip: '380699' },
	{ city: 'Cloonmore (Roscommon)', zip: '405005' },
	{ city: 'Cloonmore (Tipperary)', zip: '730222' },
	{ city: 'Cloon More (Kerry)', zip: '123365' },
	{ city: 'Cloonmore Lower (Mayo)', zip: '934799' },
	{ city: 'Cloonmore Upper (Mayo)', zip: '976296' },
	{ city: 'Cloonmorris (Galway)', zip: '907680' },
	{ city: 'Cloonmorris (Leitrim)', zip: '597234' },
	{ city: 'Cloonmoylan (Galway)', zip: '742243' },
	{ city: 'Cloonmoyle (Galway)', zip: '291449' },
	{ city: 'Cloonmucker (Longford)', zip: '355557' },
	{ city: 'Cloonmull (Sligo)', zip: '249481' },
	{ city: 'Cloonmullenan (Roscommon)', zip: '651456' },
	{ city: 'Cloonmulligan (Leitrim)', zip: '488010' },
	{ city: 'Cloonmullin (Roscommon)', zip: '312730' },
	{ city: 'Cloonmung (Mayo)', zip: '346111' },
	{ city: 'Cloonmunnia (Clare)', zip: '606992' },
	{ city: 'Cloonmurly (Roscommon)', zip: '360506' },
	{ city: 'Cloonmurray (Roscommon)', zip: '515858' },
	{ city: 'Cloonmustra (Roscommon)', zip: '253520' },
	{ city: 'Cloonmweelaun (Galway)', zip: '125904' },
	{ city: 'Cloonnabinnia (Galway)', zip: '826504' },
	{ city: 'Cloonnabricka (Galway)', zip: '446865' },
	{ city: 'Cloonnacartan (Galway)', zip: '896571' },
	{ city: 'Cloonnacat (Galway)', zip: '566300' },
	{ city: 'Cloonnacorra (Galway)', zip: '520786' },
	{ city: 'Cloonnacross (Galway)', zip: '936237' },
	{ city: 'Cloonnacusha (Galway)', zip: '821137' },
	{ city: 'Cloonnafinneela (Kerry)', zip: '152607' },
	{ city: 'Cloonnafunshin (Galway)', zip: '837147' },
	{ city: 'Cloonnagalleen (Limerick)', zip: '987420' },
	{ city: 'Cloonnagark (Galway)', zip: '584519' },
	{ city: 'Cloonnagarnaun (Clare)', zip: '274700' },
	{ city: 'Cloonnagashel (Mayo)', zip: '504616' },
	{ city: 'Cloonnaglasha (Galway)', zip: '526025' },
	{ city: 'Cloonnagleragh (Mayo)', zip: '732660' },
	{ city: 'Cloonnagloghaun (Clare)', zip: '354317' },
	{ city: 'Cloonnagoppoge (Mayo)', zip: '228102' },
	{ city: 'Cloonnagro (Clare)', zip: '659031' },
	{ city: 'Cloonnahaha (Galway)', zip: '851754' },
	{ city: 'Cloonnahulty (Mayo)', zip: '483253' },
	{ city: 'Cloonnakilla (Clare)', zip: '625053' },
	{ city: 'Cloonnamarve (Galway)', zip: '911486' },
	{ city: 'Cloonnamaskry (Galway)', zip: '456077' },
	{ city: 'Cloonnamna (Mayo)', zip: '281614' },
	{ city: 'Cloonnasee (Galway)', zip: '837441' },
	{ city: 'Cloonnavaddoge (Galway)', zip: '782327' },
	{ city: 'Cloonnavarnoge (Galway)', zip: '206220' },
	{ city: 'Cloonoghil (Roscommon)', zip: '646379' },
	{ city: 'Cloonomra (Clare)', zip: '556544' },
	{ city: 'Cloononaghaun (Galway)', zip: '248923' },
	{ city: 'Cloonoo East (Galway)', zip: '487398' },
	{ city: 'Cloonoolia North (Clare)', zip: '332475' },
	{ city: 'Cloonoolia South (Clare)', zip: '730742' },
	{ city: 'Cloonoolish (Galway)', zip: '475516' },
	{ city: 'Cloonoon (Galway)', zip: '508867' },
	{ city: 'Cloonooragh (Mayo)', zip: '324109' },
	{ city: 'Cloonoo West (Galway)', zip: '709212' },
	{ city: 'Cloonoran (Galway)', zip: '376667' },
	{ city: 'Cloonoranoughter (Galway)', zip: '663466' },
	{ city: 'Cloonoughter (Clare)', zip: '615898' },
	{ city: 'Cloonoughter (Limerick)', zip: '395647' },
	{ city: 'Cloonoul (Limerick)', zip: '294909' },
	{ city: 'Cloonown (Roscommon)', zip: '240268' },
	{ city: 'Cloonpasteen (Limerick)', zip: '366649' },
	{ city: 'Cloonpee (Galway)', zip: '313751' },
	{ city: 'Cloonprask (Galway)', zip: '863987' },
	{ city: 'Cloonprohus (Kerry)', zip: '406264' },
	{ city: 'Cloonrabrackan (Roscommon)', zip: '713949' },
	{ city: 'Cloonradoon (Roscommon)', zip: '160152' },
	{ city: 'Cloonrallagh (Longford)', zip: '718724' },
	{ city: 'Cloonrane (Galway)', zip: '973102' },
	{ city: 'Cloonrane (Roscommon)', zip: '310666' },
	{ city: 'Cloonreask (Limerick)', zip: '937479' },
	{ city: 'Cloonreddan (Clare)', zip: '366297' },
	{ city: 'Cloonree (Roscommon)', zip: '249474' },
	{ city: 'Cloonregan (Limerick)', zip: '504919' },
	{ city: 'Cloonreleagh (Galway)', zip: '891611' },
	{ city: 'Cloonreleagh East (Galway)', zip: '904674' },
	{ city: 'Cloonreleagh West (Galway)', zip: '713277' },
	{ city: 'Cloonreliagh (Roscommon)', zip: '912738' },
	{ city: 'Cloonriddia (Galway)', zip: '263890' },
	{ city: 'Cloonrollagh (Roscommon)', zip: '529134' },
	{ city: 'Cloonroosk (Limerick)', zip: '332407' },
	{ city: 'Cloonroughan (Roscommon)', zip: '422010' },
	{ city: 'Cloonruff (Galway)', zip: '414061' },
	{ city: 'Cloonscott (Longford)', zip: '688256' },
	{ city: 'Cloonselherny (Clare)', zip: '320511' },
	{ city: 'Cloonsellan (Longford)', zip: '363345' },
	{ city: 'Cloonsellan (Roscommon)', zip: '216916' },
	{ city: 'Cloonshaghan (Roscommon)', zip: '119079' },
	{ city: 'Cloonshanbally (Sligo)', zip: '488552' },
	{ city: 'Cloonshanbo (Mayo)', zip: '423253' },
	{ city: 'Cloonshannagh (Longford)', zip: '453672' },
	{ city: 'Cloonshannagh (Roscommon)', zip: '740761' },
	{ city: 'Cloonshanville (Roscommon)', zip: '508797' },
	{ city: 'Cloonsharragh (Kerry)', zip: '111406' },
	{ city: 'Cloonshask (Roscommon)', zip: '173576' },
	{ city: 'Cloonshear Beg (Cork)', zip: '724528' },
	{ city: 'Cloonshear More (Cork)', zip: '336401' },
	{ city: 'Cloonshease (Galway)', zip: '767845' },
	{ city: 'Cloonshee (Galway)', zip: '575499' },
	{ city: 'Cloonshee (Roscommon)', zip: '614155' },
	{ city: 'Cloonsheebane (Leitrim)', zip: '922862' },
	{ city: 'Cloonsheecahill (Galway)', zip: '277291' },
	{ city: 'Cloonsheen (Galway)', zip: '678036' },
	{ city: 'Cloonsheerea (Clare)', zip: '508391' },
	{ city: 'Cloonsheerevagh (Leitrim)', zip: '623493' },
	{ city: 'Cloonsheerin (Longford)', zip: '432360' },
	{ city: 'Cloonsheever (Roscommon)', zip: '773193' },
	{ city: 'Cloonsherick (Limerick)', zip: '891883' },
	{ city: 'Cloonshinnagh (Mayo)', zip: '523798' },
	{ city: 'Cloonshivna (Galway)', zip: '875443' },
	{ city: 'Cloonsillagh (Cork)', zip: '663410' },
	{ city: 'Cloonsillagh (Kerry)', zip: '124740' },
	{ city: 'Cloonsillagh (Roscommon)', zip: '927884' },
	{ city: 'Cloonsillagh (Sligo)', zip: '615256' },
	{ city: 'Cloonskeagh (Mayo)', zip: '304105' },
	{ city: 'Cloonskeeveen (Roscommon)', zip: '424632' },
	{ city: 'Cloonskill (Mayo)', zip: '454899' },
	{ city: 'Cloonskirtaun (Mayo)', zip: '830564' },
	{ city: 'Cloonslanor (Roscommon)', zip: '821923' },
	{ city: 'Cloonslaun (Mayo)', zip: '881165' },
	{ city: 'Cloonsnaghta (Clare)', zip: '581567' },
	{ city: 'Cloonsnaghta (Mayo)', zip: '972376' },
	{ city: 'Cloonsreane (Roscommon)', zip: '230412' },
	{ city: 'Cloonsuck (Roscommon)', zip: '124444' },
	{ city: 'Cloonsunna (Mayo)', zip: '586668' },
	{ city: 'Cloonta (Mayo)', zip: '209611' },
	{ city: 'Cloontabeg (Longford)', zip: '580267' },
	{ city: 'Cloontabonniv (Clare)', zip: '637725' },
	{ city: 'Cloontagh (Donegal)', zip: '123285' },
	{ city: 'Cloontagh (Longford)', zip: '528084' },
	{ city: 'Cloontakilla (Mayo)', zip: '468705' },
	{ city: 'Cloontakillew (Mayo)', zip: '439428' },
	{ city: 'Cloontally (Mayo)', zip: '987574' },
	{ city: 'Cloontamore (Longford)', zip: '139295' },
	{ city: 'Cloontarriff (Mayo)', zip: '548163' },
	{ city: 'Cloontarriv (Kerry)', zip: '418091' },
	{ city: 'Cloontarsna (Roscommon)', zip: '599458' },
	{ city: 'Cloonteem (Roscommon)', zip: '240683' },
	{ city: 'Cloonteen (Clare)', zip: '240007' },
	{ city: 'Cloonteen (Galway)', zip: '180517' },
	{ city: 'Cloonteen (Limerick)', zip: '374135' },
	{ city: 'Cloonteens (Cork)', zip: '532149' },
	{ city: 'Cloonteens (Kerry)', zip: '813964' },
	{ city: 'Cloontemple (Limerick)', zip: '407477' },
	{ city: 'Cloontia (Mayo)', zip: '928386' },
	{ city: 'Cloonties (Cork)', zip: '261749' },
	{ city: 'Cloonties (Kerry)', zip: '148365' },
	{ city: 'Cloonties East (Cork)', zip: '259052' },
	{ city: 'Cloonties West (Cork)', zip: '113325' },
	{ city: 'Cloontimullan (Roscommon)', zip: '567657' },
	{ city: 'Cloontiquirk (Cork)', zip: '513698' },
	{ city: 'Cloontirm (Longford)', zip: '475723' },
	{ city: 'Cloontogher (Roscommon)', zip: '611069' },
	{ city: 'Cloontohil (Clare)', zip: '701473' },
	{ city: 'Cloontooa (Galway)', zip: '551512' },
	{ city: 'Cloontooa (Mayo)', zip: '513862' },
	{ city: 'Cloontowart (Roscommon)', zip: '892633' },
	{ city: 'Cloontra (Clare)', zip: '466009' },
	{ city: 'Cloontra East (Clare)', zip: '647561' },
	{ city: 'Cloontrask (Roscommon)', zip: '184548' },
	{ city: 'Cloontra West (Clare)', zip: '824323' },
	{ city: 'Cloontreem (Cork)', zip: '316678' },
	{ city: 'Cloonts (Kerry)', zip: '413975' },
	{ city: 'Cloontubbrid (Leitrim)', zip: '339139' },
	{ city: 'Cloontubbrid (Mayo)', zip: '410668' },
	{ city: 'Cloontubbrid North (Kerry)', zip: '826836' },
	{ city: 'Cloontubbrid South (Kerry)', zip: '384174' },
	{ city: 'Cloontumper (Mayo)', zip: '586060' },
	{ city: 'Cloontumpher (Leitrim)', zip: '998746' },
	{ city: 'Cloonturk (Leitrim)', zip: '563297' },
	{ city: 'Cloonturk (Longford)', zip: '975194' },
	{ city: 'Cloonturk (Mayo)', zip: '498618' },
	{ city: 'Cloonturnaun (Mayo)', zip: '883084' },
	{ city: 'Cloontuskert (Roscommon)', zip: '276554' },
	{ city: 'Cloonty (Leitrim)', zip: '343151' },
	{ city: 'Cloonty (Limerick)', zip: '516006' },
	{ city: 'Cloonty (Mayo)', zip: '840419' },
	{ city: 'Cloontybaunan (Mayo)', zip: '831652' },
	{ city: 'Cloontycarn (Sligo)', zip: '696511' },
	{ city: 'Cloontycarthy (Cork)', zip: '503488' },
	{ city: 'Cloontycommade (Cork)', zip: '527698' },
	{ city: 'Cloontyconnaught (Clare)', zip: '805861' },
	{ city: 'Cloontykillew (Mayo)', zip: '359818' },
	{ city: 'Cloontymurphy (Clare)', zip: '568144' },
	{ city: 'Cloontymweenagh (Clare)', zip: '676308' },
	{ city: 'Cloontyprocklis (Sligo)', zip: '548254' },
	{ city: 'Cloontyprughlish (Leitrim)', zip: '225504' },
	{ city: 'Cloontysmarra (Clare)', zip: '290619' },
	{ city: 'Cloonulla (Clare)', zip: '105481' },
	{ city: 'Cloonulty (Roscommon)', zip: '980163' },
	{ city: 'Cloonusker (Clare)', zip: '373627' },
	{ city: 'Cloon West (Kerry)', zip: '470655' },
	{ city: 'Cloonwhite North (Clare)', zip: '752340' },
	{ city: 'Cloonwhite South (Clare)', zip: '617587' },
	{ city: 'Cloonyarigaun (Mayo)', zip: '621201' },
	{ city: 'Cloonybeirne (Roscommon)', zip: '911265' },
	{ city: 'Cloonybrennan (Roscommon)', zip: '529962' },
	{ city: 'Cloonybrien (Roscommon)', zip: '605332' },
	{ city: 'Cloonycarron Beg (Roscommon)', zip: '989438' },
	{ city: 'Cloonycarron More (Roscommon)', zip: '856512' },
	{ city: 'Cloonycattan (Roscommon)', zip: '772995' },
	{ city: 'Cloonyclohassy (Limerick)', zip: '924045' },
	{ city: 'Cloonycolgan (Roscommon)', zip: '364855' },
	{ city: 'Cloonycollaran (Mayo)', zip: '159790' },
	{ city: 'Cloonyconaun (Galway)', zip: '364830' },
	{ city: 'Cloonyconry Beg (Clare)', zip: '749633' },
	{ city: 'Cloonyconry More (Clare)', zip: '465554' },
	{ city: 'Cloonydiveen (Sligo)', zip: '945704' },
	{ city: 'Cloonydonigan Lower (Kerry)', zip: '131965' },
	{ city: 'Cloonydonigan Upper (Kerry)', zip: '515118' },
	{ city: 'Cloonyeffer (Roscommon)', zip: '926680' },
	{ city: 'Cloonygarra (Limerick)', zip: '773816' },
	{ city: 'Cloonygorman (Cork)', zip: '727337' },
	{ city: 'Cloonygowan (Mayo)', zip: '274728' },
	{ city: 'Cloonygunnaun (Mayo)', zip: '465906' },
	{ city: 'Cloonyhea (Tipperary)', zip: '970173' },
	{ city: 'Cloonykeevan (Galway)', zip: '189208' },
	{ city: 'Cloonykelly (Roscommon)', zip: '885760' },
	{ city: 'Cloonykerny (Roscommon)', zip: '733102' },
	{ city: 'Cloonylyon (Roscommon)', zip: '798519' },
	{ city: 'Cloonymeenaghan (Sligo)', zip: '230326' },
	{ city: 'Cloonymorris (Galway)', zip: '191070' },
	{ city: 'Cloonymurrikin (Westmeath)', zip: '463793' },
	{ city: 'Cloonyogan (Roscommon)', zip: '792359' },
	{ city: 'Cloonyourish (Roscommon)', zip: '491223' },
	{ city: 'Cloonyquin (Roscommon)', zip: '549649' },
	{ city: 'Cloonyross (Tipperary)', zip: '460053' },
	{ city: 'Cloonyscrehane (Limerick)', zip: '933892' },
	{ city: 'Cloonyvollow (Mayo)', zip: '940914' },
	{ city: 'Cloosecullen (Laois)', zip: '286097' },
	{ city: 'Cloosguire (Kerry)', zip: '746331' },
	{ city: 'Cloosh (Galway)', zip: '247600' },
	{ city: 'Clooshgereen (Galway)', zip: '577240' },
	{ city: 'Clooskirt (Sligo)', zip: '800983' },
	{ city: 'Cloosmore (Kerry)', zip: '682106' },
	{ city: 'Clopook (Laois)', zip: '230496' },
	{ city: 'Clora (Wicklow)', zip: '760837' },
	{ city: 'Cloran (Galway)', zip: '298776' },
	{ city: 'Cloran And Corcullentry (Westmeath)', zip: '524947' },
	{ city: 'Clorane (Limerick)', zip: '250760' },
	{ city: 'Cloran New (Tipperary)', zip: '370956' },
	{ city: 'Cloran Old (Tipperary)', zip: '814315' },
	{ city: 'Cloranshea (Kilkenny)', zip: '675561' },
	{ city: 'Clorhane (Limerick)', zip: '111288' },
	{ city: 'Clorhane (Offaly)', zip: '909579' },
	{ city: 'Clorhaun (Laois)', zip: '841492' },
	{ city: 'Clornagh (Wicklow)', zip: '379169' },
	{ city: 'Cloroge Beg (Wexford)', zip: '554518' },
	{ city: 'Cloroge More (Wexford)', zip: '604704' },
	{ city: 'Clorusk Lower (Carlow)', zip: '592395' },
	{ city: 'Clorusk Upper (Carlow)', zip: '738156' },
	{ city: 'Closdaw (Monaghan)', zip: '308723' },
	{ city: 'Close (Cork)', zip: '683166' },
	{ city: 'Close (Waterford)', zip: '348203' },
	{ city: 'Closeland (Laois)', zip: '711407' },
	{ city: 'Closh (Carlow)', zip: '456169' },
	{ city: 'Clossagh Beg (Monaghan)', zip: '925900' },
	{ city: 'Clossagh More (Monaghan)', zip: '865631' },
	{ city: 'Clossaghroe (Mayo)', zip: '156394' },
	{ city: 'Closutton (Carlow)', zip: '258299' },
	{ city: 'Clough (Wexford)', zip: '755664' },
	{ city: 'Cloughduv (Cork)', zip: '586323' },
	{ city: 'Clougheast (Wexford)', zip: '687621' },
	{ city: 'Clouracaun (Cork)', zip: '505181' },
	{ city: 'Cloustoge (Cork)', zip: '793655' },
	{ city: 'Clover (Kilkenny)', zip: '264471' },
	{ city: 'Cloverfield (Galway)', zip: '808183' },
	{ city: 'Cloverfield (Limerick)', zip: '504008' },
	{ city: 'Cloverhill (Cavan)', zip: '311551' },
	{ city: 'Cloverhill (Clare)', zip: '987174' },
	{ city: 'Cloverhill (Donegal)', zip: '808902' },
	{ city: 'Cloverhill (Leitrim)', zip: '213445' },
	{ city: 'Cloverhill Demesne (Cavan)', zip: '377060' },
	{ city: 'Cloverpark (Galway)', zip: '194142' },
	{ city: 'Clovers (Limerick)', zip: '339612' },
	{ city: 'Clowanstown (Meath)', zip: '432293' },
	{ city: 'Clowater (Carlow)', zip: '135700' },
	{ city: 'Clowney (Cavan)', zip: '302354' },
	{ city: 'Clownings (Kildare)', zip: '980475' },
	{ city: 'Clowninny (Cavan)', zip: '735020' },
	{ city: 'Clownstown (Westmeath)', zip: '572628' },
	{ city: 'Cloyne (Cork)', zip: '649333' },
	{ city: 'Cloyragh (Sligo)', zip: '987802' },
	{ city: 'Cloyrawer (Mayo)', zip: '185334' },
	{ city: 'Cloysparra (Sligo)', zip: '414331' },
	{ city: 'Cloystuckera (Sligo)', zip: '957810' },
	{ city: 'Clucka North (Offaly)', zip: '174358' },
	{ city: 'Clucka South (Offaly)', zip: '285210' },
	{ city: 'Cluddaun (Mayo)', zip: '116571' },
	{ city: 'Cluggin (Limerick)', zip: '983521' },
	{ city: 'Cluid (Galway)', zip: '170127' },
	{ city: 'Cluid (Sligo)', zip: '177602' },
	{ city: 'Cluide (Louth)', zip: '902915' },
	{ city: 'Cluidrevagh (Galway)', zip: '710106' },
	{ city: 'Cluttahina (Waterford)', zip: '125594' },
	{ city: 'Clutterland (Dublin)', zip: '617664' },
	{ city: 'Clyard (Mayo)', zip: '610083' },
	{ city: 'Clybanane (Tipperary)', zip: '341296' },
	{ city: 'Clyda (Cork)', zip: '538070' },
	{ city: 'Clydagh (Cork)', zip: '670967' },
	{ city: 'Clydagh (Galway)', zip: '434787' },
	{ city: 'Clydagh (Kerry)', zip: '283398' },
	{ city: 'Clydagh (Mayo)', zip: '809627' },
	{ city: 'Clydagh Lower (Roscommon)', zip: '346936' },
	{ city: 'Clydaghroe (Kerry)', zip: '576866' },
	{ city: 'Clydagh Upper (Roscommon)', zip: '906646' },
	{ city: 'Clydaville (Cork)', zip: '773229' },
	{ city: 'Clyderragh (Cork)', zip: '425130' },
	{ city: 'Clyduff (Cork)', zip: '586752' },
	{ city: 'Clyduff (Offaly)', zip: '227959' },
	{ city: 'Clyduff East (Limerick)', zip: '221215' },
	{ city: 'Clyduff West (Limerick)', zip: '450468' },
	{ city: 'Clygeen (Longford)', zip: '458888' },
	{ city: 'Clyglass (Westmeath)', zip: '657262' },
	{ city: 'Clykeel North (Cork)', zip: '869908' },
	{ city: 'Clykeel South (Cork)', zip: '396772' },
	{ city: 'Clynabroga (Limerick)', zip: '712498' },
	{ city: 'Clynagh (Galway)', zip: '799703' },
	{ city: 'Clynagh Island (Galway)', zip: '897970' },
	{ city: 'Clynan (Longford)', zip: '600909' },
	{ city: 'Clynish (Mayo)', zip: '905552' },
	{ city: 'Clynoe (Offaly)', zip: '300136' },
	{ city: 'Clyroe (Cork)', zip: '631893' },
	{ city: 'Coachford (Cork)', zip: '418171' },
	{ city: 'Coad (Clare)', zip: '110187' },
	{ city: 'Coad (Galway)', zip: '103364' },
	{ city: 'Coad (Kerry)', zip: '644593' },
	{ city: 'Coagh (Sligo)', zip: '216550' },
	{ city: 'Coaghen (Monaghan)', zip: '178616' },
	{ city: 'Coagh Lower (Offaly)', zip: '968433' },
	{ city: 'Coaghmill (Donegal)', zip: '165146' },
	{ city: 'Coagh Upper (Offaly)', zip: '473789' },
	{ city: 'Coalbrook (Tipperary)', zip: '988882' },
	{ city: 'Coalpitparks (Kilkenny)', zip: '248054' },
	{ city: 'Coalpits (Cork)', zip: '195499' },
	{ city: 'Coalpits (Galway)', zip: '276105' },
	{ city: 'Coalpits (Meath)', zip: '377372' },
	{ city: 'Coalsfarm (Kilkenny)', zip: '121858' },
	{ city: 'Coalspit (Wexford)', zip: '799206' },
	{ city: 'Coan (Kilkenny)', zip: '601781' },
	{ city: 'Coan (Wicklow)', zip: '543666' },
	{ city: 'Coan East (Kilkenny)', zip: '858658' },
	{ city: 'Coan West (Kilkenny)', zip: '532410' },
	{ city: 'Coarha Beg (Kerry)', zip: '605254' },
	{ city: 'Coarha More (Kerry)', zip: '648245' },
	{ city: 'Coarliss (Cork)', zip: '835559' },
	{ city: 'Coars (Kerry)', zip: '926082' },
	{ city: 'Coarsefield (Galway)', zip: '206348' },
	{ city: 'Coarsefield (Mayo)', zip: '743712' },
	{ city: 'Coarsepark (Galway)', zip: '657536' },
	{ city: 'Coarsepark (Mayo)', zip: '507781' },
	{ city: 'Coarseparks (Galway)', zip: '897410' },
	{ city: 'Cobbs (Tipperary)', zip: '499808' },
	{ city: 'Cobh (Cork)', zip: '403716' },
	{ city: 'Cock-And-The-Bull (Cork)', zip: '470506' },
	{ city: 'Cockhill (Kerry)', zip: '311421' },
	{ city: 'Cockow (Kerry)', zip: '355298' },
	{ city: 'Cockstown (Westmeath)', zip: '642001' },
	{ city: 'Cockstown East (Galway)', zip: '309116' },
	{ city: 'Cockstown West (Galway)', zip: '577922' },
	{ city: 'Codd (Offaly)', zip: '338072' },
	{ city: 'Coddstown Great (Wexford)', zip: '313978' },
	{ city: 'Coddstown Little (Wexford)', zip: '228777' },
	{ city: 'Codrum (Cork)', zip: '147924' },
	{ city: 'Cogaula (Galway)', zip: '944195' },
	{ city: 'Cogaula (Mayo)', zip: '962687' },
	{ city: 'Coggalbeg (Roscommon)', zip: '759827' },
	{ city: 'Coggalfortyacres (Roscommon)', zip: '967328' },
	{ city: 'Coggalkeenagh (Roscommon)', zip: '416284' },
	{ city: 'Coggalmore (Roscommon)', zip: '559209' },
	{ city: 'Coggalstack (Roscommon)', zip: '519343' },
	{ city: 'Coggaltonroe (Roscommon)', zip: '126350' },
	{ city: 'Coghalstown (Meath)', zip: '302488' },
	{ city: 'Coghlanstown East (Kildare)', zip: '190420' },
	{ city: 'Coghlanstown West (Kildare)', zip: '141942' },
	{ city: 'Cogran (Offaly)', zip: '592466' },
	{ city: 'Coguish (Donegal)', zip: '565114' },
	{ city: 'Cohaw (Cavan)', zip: '580071' },
	{ city: 'Cohy (Clare)', zip: '299886' },
	{ city: 'Colbinstown (Kildare)', zip: '776557' },
	{ city: 'Coldblow (Dublin)', zip: '485324' },
	{ city: 'Coldblow (Offaly)', zip: '347278' },
	{ city: 'Coldblow (Wexford)', zip: '705973' },
	{ city: 'Coldcut (Dublin)', zip: '529343' },
	{ city: 'Coldfields (Tipperary)', zip: '376559' },
	{ city: 'Coldharbour (Kilkenny)', zip: '183026' },
	{ city: 'Coldmanscurragh (Laois)', zip: '383211' },
	{ city: 'Coldrumman (Leitrim)', zip: '423796' },
	{ city: 'Coldwater Commons (Dublin)', zip: '194895' },
	{ city: 'Coldwells (Kildare)', zip: '272736' },
	{ city: 'Coldwinters (Dublin)', zip: '929226' },
	{ city: 'Coldwood (Galway)', zip: '899279' },
	{ city: 'Colecot (Dublin)', zip: '487302' },
	{ city: 'Colehill (Donegal)', zip: '603168' },
	{ city: 'Colehill (Longford)', zip: '955932' },
	{ city: 'Colehill (Offaly)', zip: '972846' },
	{ city: 'Coleman (Monaghan)', zip: '696435' },
	{ city: 'Coleman (Wexford)', zip: '661928' },
	{ city: 'Coleraine (Offaly)', zip: '679048' },
	{ city: 'Coleraine (Tipperary)', zip: '114527' },
	{ city: 'Colerenagh (Cork)', zip: '283912' },
	{ city: 'Colesgrove (Galway)', zip: '579801' },
	{ city: 'Colestown (Wexford)', zip: '890205' },
	{ city: 'Colgagh (Monaghan)', zip: '159886' },
	{ city: 'Colgagh (Offaly)', zip: '744084' },
	{ city: 'Colgagh (Sligo)', zip: '738950' },
	{ city: 'Colganstown (Dublin)', zip: '987828' },
	{ city: 'Colla (Cork)', zip: '817655' },
	{ city: 'Colladussaun (Mayo)', zip: '306839' },
	{ city: 'Collagh (Mayo)', zip: '447151' },
	{ city: 'Collaghknock Glebe (Kildare)', zip: '271907' },
	{ city: 'Collan More (Mayo)', zip: '481990' },
	{ city: 'Collatrum Beg (Cork)', zip: '175326' },
	{ city: 'Collatrum More (Cork)', zip: '261986' },
	{ city: 'College (Meath)', zip: '100978' },
	{ city: 'College (Wexford)', zip: '748189' },
	{ city: 'Collegefield (Kerry)', zip: '656280' },
	{ city: 'Collegeland (Dublin)', zip: '575790' },
	{ city: 'Collegeland (Kildare)', zip: '971352' },
	{ city: 'Collegeland (Meath)', zip: '475726' },
	{ city: 'Collegeland (Tipperary)', zip: '457173' },
	{ city: 'Collegeland (Westmeath)', zip: '427376' },
	{ city: 'Collegepark (Kilkenny)', zip: '883327' },
	{ city: 'Colliersland North (Meath)', zip: '519651' },
	{ city: 'Colliersland South (Meath)', zip: '622811' },
	{ city: 'Collierstown (Meath)', zip: '159040' },
	{ city: 'Colliga (Wicklow)', zip: '110993' },
	{ city: 'Colligan Beg (Waterford)', zip: '400102' },
	{ city: 'Colligan More (Waterford)', zip: '597691' },
	{ city: 'Colliganmountain (Waterford)', zip: '470982' },
	{ city: 'Colliganwood (Waterford)', zip: '816717' },
	{ city: 'Collin (Kildare)', zip: '674255' },
	{ city: 'Collinsford (Sligo)', zip: '581887' },
	{ city: 'Collinstown (Dublin)', zip: '203963' },
	{ city: 'Collinstown (Kildare)', zip: '925737' },
	{ city: 'Collinstown (Westmeath)', zip: '880084' },
	{ city: 'Collistown (Meath)', zip: '644021' },
	{ city: 'Collon (Louth)', zip: '120262' },
	{ city: 'Collooney (Sligo)', zip: '689086' },
	{ city: 'Collops (Cavan)', zip: '581125' },
	{ city: 'Collorus (Kerry)', zip: '134100' },
	{ city: 'Collum (Longford)', zip: '300925' },
	{ city: 'Colman (Tipperary)', zip: '387596' },
	{ city: 'Colmanstown (Clare)', zip: '204591' },
	{ city: 'Colmanstown (Dublin)', zip: '226252' },
	{ city: 'Colmanstown (Galway)', zip: '510923' },
	{ city: 'Colmanstown (Offaly)', zip: '305682' },
	{ city: 'Colp East (Meath)', zip: '664992' },
	{ city: 'Colp West (Meath)', zip: '539157' },
	{ city: 'Colt (Laois)', zip: '136899' },
	{ city: 'Colt Island (Galway)', zip: '195475' },
	{ city: 'Coltstown (Kildare)', zip: '109323' },
	{ city: 'Columbkille (Kilkenny)', zip: '655637' },
	{ city: 'Colvinstown (Meath)', zip: '309768' },
	{ city: 'Colvinstown Lower (Wicklow)', zip: '156253' },
	{ city: 'Colvinstown Upper (Wicklow)', zip: '208335' },
	{ city: 'Com (Kilkenny)', zip: '489524' },
	{ city: 'Comaghy (Monaghan)', zip: '303332' },
	{ city: 'Comeragh (Waterford)', zip: '459793' },
	{ city: 'Comeraghhouse (Waterford)', zip: '889018' },
	{ city: 'Comeraghmountain (Waterford)', zip: '807162' },
	{ city: "Comerford's-Lot (Tipperary)", zip: '765551' },
	{ city: 'Comertagh (Monaghan)', zip: '244724' },
	{ city: 'Comillane (Cork)', zip: '925100' },
	{ city: 'Cominch (Mayo)', zip: '570749' },
	{ city: 'Commanealine (Tipperary)', zip: '683574' },
	{ city: 'Commanes (Kerry)', zip: '122972' },
	{ city: 'Commas (Cavan)', zip: '147488' },
	{ city: 'Commaun (Kerry)', zip: '945722' },
	{ city: 'Commaun Beg (Tipperary)', zip: '862180' },
	{ city: 'Commaun More (Tipperary)', zip: '442707' },
	{ city: 'Commauns (Mayo)', zip: '528398' },
	{ city: 'Commeen (Cork)', zip: '139266' },
	{ city: 'Commeen (Donegal)', zip: '633524' },
	{ city: 'Commeen (Roscommon)', zip: '527655' },
	{ city: 'Commeenaplaw (Cork)', zip: '302073' },
	{ city: 'Commeenlonagh (Westmeath)', zip: '924551' },
	{ city: 'Commock (Longford)', zip: '684913' },
	{ city: 'Commoge (Cork)', zip: '792015' },
	{ city: 'Commoge (Kilkenny)', zip: '939395' },
	{ city: 'Common (Donegal)', zip: '189717' },
	{ city: 'Common (Dublin)', zip: '730327' },
	{ city: 'Common (Galway)', zip: '247101' },
	{ city: 'Common (Kildare)', zip: '950504' },
	{ city: 'Common (Kilkenny)', zip: '211069' },
	{ city: 'Common (Limerick)', zip: '949340' },
	{ city: 'Common (Waterford)', zip: '727926' },
	{ city: 'Common (Wexford)', zip: '374271' },
	{ city: 'Commonage (Clare)', zip: '375621' },
	{ city: 'Commonage (Cork)', zip: '559862' },
	{ city: 'Common Mountain (Donegal)', zip: '395258' },
	{ city: 'Common North (Kildare)', zip: '507959' },
	{ city: 'Commons (Carlow)', zip: '750534' },
	{ city: 'Commons (Clare)', zip: '130388' },
	{ city: 'Commons (Cork)', zip: '794800' },
	{ city: 'Commons (Dublin)', zip: '908172' },
	{ city: 'Commons (Galway)', zip: '668703' },
	{ city: 'Commons (Kerry)', zip: '699064' },
	{ city: 'Commons (Kildare)', zip: '604231' },
	{ city: 'Commons (Kilkenny)', zip: '535499' },
	{ city: 'Commons (Leitrim)', zip: '838502' },
	{ city: 'Commons (Limerick)', zip: '305939' },
	{ city: 'Commons (Longford)', zip: '654557' },
	{ city: 'Commons (Louth)', zip: '343221' },
	{ city: 'Commons (Mayo)', zip: '493391' },
	{ city: 'Commons (Meath)', zip: '380323' },
	{ city: 'Commons (Roscommon)', zip: '737819' },
	{ city: 'Commons (Sligo)', zip: '463697' },
	{ city: 'Commons (Tipperary)', zip: '186746' },
	{ city: 'Commons (Waterford)', zip: '681912' },
	{ city: 'Commons (Westmeath)', zip: '521201' },
	{ city: 'Commons (Wexford)', zip: '203986' },
	{ city: 'Commons (Wicklow)', zip: '670322' },
	{ city: 'Commons East (Cork)', zip: '710725' },
	{ city: 'Commons East (Dublin)', zip: '288275' },
	{ city: 'Commons East (Galway)', zip: '643513' },
	{ city: 'Commons East (Kerry)', zip: '498472' },
	{ city: 'Commons East (Kildare)', zip: '748801' },
	{ city: 'Commons-Entire East (Tipperary)', zip: '686479' },
	{ city: 'Commons-Entire West (Tipperary)', zip: '776641' },
	{ city: 'Commons Little (Dublin)', zip: '483687' },
	{ city: 'Commons Lower (Dublin)', zip: '532420' },
	{ city: 'Commons Lower (Kildare)', zip: '637446' },
	{ city: 'Commons North (Clare)', zip: '591638' },
	{ city: 'Commons North (Cork)', zip: '857739' },
	{ city: 'Commons North (Kerry)', zip: '696471' },
	{ city: 'Commons North (Kilkenny)', zip: '503017' },
	{ city: 'Commons North (Longford)', zip: '827457' },
	{ city: 'Commons Of Carney (Tipperary)', zip: '576375' },
	{ city: 'Commons Of Dingle (Kerry)', zip: '835998' },
	{ city: 'Commons Of Lloyd (Meath)', zip: '312154' },
	{ city: 'Commons Of Milltown (Kerry)', zip: '587752' },
	{ city: 'Common South (Kildare)', zip: '821593' },
	{ city: 'Commons South (Clare)', zip: '725549' },
	{ city: 'Commons South (Cork)', zip: '863775' },
	{ city: 'Commons South (Kerry)', zip: '977623' },
	{ city: 'Commons South (Kildare)', zip: '742800' },
	{ city: 'Commons South (Kilkenny)', zip: '480084' },
	{ city: 'Commons South (Longford)', zip: '501623' },
	{ city: 'Commonstown (Kildare)', zip: '660401' },
	{ city: 'Commons Upper (Dublin)', zip: '645929' },
	{ city: 'Commons Upper (Kildare)', zip: '947379' },
	{ city: 'Commons West (Cork)', zip: '866138' },
	{ city: 'Commons West (Dublin)', zip: '642956' },
	{ city: 'Commons West (Galway)', zip: '438019' },
	{ city: 'Commons West (Kerry)', zip: '874817' },
	{ city: 'Commons West (Kildare)', zip: '821485' },
	{ city: 'Comraghs (Monaghan)', zip: '727194' },
	{ city: 'Conagher (Galway)', zip: '790681' },
	{ city: 'Conaghil (Leitrim)', zip: '527883' },
	{ city: 'Conaghoo (Cavan)', zip: '557671' },
	{ city: 'Conaghra (Mayo)', zip: '465820' },
	{ city: 'Conaghrud (Donegal)', zip: '249998' },
	{ city: 'Conaghy (Monaghan)', zip: '224206' },
	{ city: 'Conavalla (Wicklow)', zip: '499387' },
	{ city: 'Concealment (Cork)', zip: '995682' },
	{ city: 'Concealment (Kildare)', zip: '328927' },
	{ city: 'Concra (Monaghan)', zip: '821577' },
	{ city: 'Condonstown (Cork)', zip: '761277' },
	{ city: 'Condonstown (Kilkenny)', zip: '418886' },
	{ city: 'Condonstown North (Cork)', zip: '651243' },
	{ city: 'Condonstown South (Cork)', zip: '599110' },
	{ city: 'Condry (Cavan)', zip: '679327' },
	{ city: 'Cones (Laois)', zip: '957524' },
	{ city: 'Coneybeg (Cork)', zip: '497002' },
	{ city: 'Coneyburrow (Donegal)', zip: '885205' },
	{ city: 'Coneyburrow (Kildare)', zip: '646674' },
	{ city: 'Coneyburrow (Louth)', zip: '124965' },
	{ city: 'Coneygar (Kilkenny)', zip: '231042' },
	{ city: 'Coney Island (Clare)', zip: '153929' },
	{ city: 'Coney Island (Donegal)', zip: '445808' },
	{ city: 'Coneykeare (Carlow)', zip: '781391' },
	{ city: 'Confey (Kildare)', zip: '197315' },
	{ city: 'Cong (Mayo)', zip: '630226' },
	{ city: 'Cong North (Mayo)', zip: '398366' },
	{ city: 'Cong South (Mayo)', zip: '938958' },
	{ city: 'Conicar (Galway)', zip: '245459' },
	{ city: 'Conicker (Offaly)', zip: '793573' },
	{ city: 'Conigar (Limerick)', zip: '881102' },
	{ city: 'Coniker (Offaly)', zip: '943510' },
	{ city: 'Conlans Hill (Wicklow)', zip: '493371' },
	{ city: 'Conlanstown (Kildare)', zip: '419198' },
	{ city: 'Conlanstown (Westmeath)', zip: '229674' },
	{ city: 'Conleen (Cavan)', zip: '876936' },
	{ city: 'Conloon (Mayo)', zip: '105036' },
	{ city: 'Conna (Cork)', zip: '264588' },
	{ city: 'Connaberry (Cork)', zip: '253531' },
	{ city: 'Connabury (Monaghan)', zip: '950543' },
	{ city: 'Connagh (Cork)', zip: '152949' },
	{ city: 'Connagh (Wexford)', zip: '483480' },
	{ city: 'Connaghkinnagoe (Donegal)', zip: '660437' },
	{ city: 'Connahill (Wexford)', zip: '350928' },
	{ city: 'Connahy (Kilkenny)', zip: '437722' },
	{ city: 'Connary Lower (Wicklow)', zip: '706216' },
	{ city: 'Connary Upper (Wicklow)', zip: '979369' },
	{ city: 'Connellstown (Meath)', zip: '438786' },
	{ city: 'Connet (Galway)', zip: '766778' },
	{ city: 'Connigar (Kerry)', zip: '599661' },
	{ city: 'Connolly (Clare)', zip: '909294' },
	{ city: "Conor's Island (Galway)", zip: '679683' },
	{ city: "Conor's Island (Sligo)", zip: '648649' },
	{ city: 'Conorspark (Galway)', zip: '122484' },
	{ city: 'Conranstown (Westmeath)', zip: '829456' },
	{ city: 'Conray (Leitrim)', zip: '658788' },
	{ city: 'Conrea (Mayo)', zip: '334210' },
	{ city: 'Conspark (Offaly)', zip: '463244' },
	{ city: 'Constablehill (Carlow)', zip: '240580' },
	{ city: 'Controversy (Tipperary)', zip: '494684' },
	{ city: 'Contycro (Donegal)', zip: '998214' },
	{ city: 'Conva (Cork)', zip: '281462' },
	{ city: 'Convoy (Donegal)', zip: '861600' },
	{ city: 'Convoy Demesne (Donegal)', zip: '569300' },
	{ city: 'Convoy Townparks (Donegal)', zip: '356167' },
	{ city: 'Conwal (Donegal)', zip: '796547' },
	{ city: 'Conwal North (Leitrim)', zip: '665065' },
	{ city: 'Conwal South (Leitrim)', zip: '288975' },
	{ city: 'Cooga (Clare)', zip: '563357' },
	{ city: 'Cooga (Sligo)', zip: '515705' },
	{ city: 'Cooga (Tipperary)', zip: '966711' },
	{ city: 'Cooga Lower (Limerick)', zip: '117019' },
	{ city: 'Coogaun (Clare)', zip: '557511' },
	{ city: 'Cooga Upper (Limerick)', zip: '844610' },
	{ city: 'Coogue Middle (Mayo)', zip: '828217' },
	{ city: 'Coogue North (Mayo)', zip: '578017' },
	{ city: 'Coogue South (Mayo)', zip: '137772' },
	{ city: 'Coogulla (Tipperary)', zip: '517279' },
	{ city: 'Cooguquid (Clare)', zip: '252288' },
	{ city: 'Coogypark (Clare)', zip: '483947' },
	{ city: 'Coogyulla (Clare)', zip: '104672' },
	{ city: 'Coohey (Monaghan)', zip: '748775' },
	{ city: 'Cookesfield (Laois)', zip: '184427' },
	{ city: 'Cooksborough (Westmeath)', zip: '802705' },
	{ city: 'Cooksgrove (Meath)', zip: '594277' },
	{ city: 'Cooksland (Meath)', zip: '865167' },
	{ city: 'Cookspark (Louth)', zip: '785673' },
	{ city: 'Cookstown (Dublin)', zip: '275902' },
	{ city: 'Cookstown (Louth)', zip: '522980' },
	{ city: 'Cookstown (Meath)', zip: '748286' },
	{ city: 'Cookstown (Wexford)', zip: '841474' },
	{ city: 'Cookstown (Wicklow)', zip: '664878' },
	{ city: 'Cookstown Great (Meath)', zip: '842926' },
	{ city: 'Cookstown Little (Meath)', zip: '164116' },
	{ city: 'Cool (Galway)', zip: '738626' },
	{ city: 'Cool (Kerry)', zip: '934950' },
	{ city: 'Cool (Laois)', zip: '441743' },
	{ city: 'Cool (Limerick)', zip: '558475' },
	{ city: 'Cool (Waterford)', zip: '163003' },
	{ city: 'Coola (Westmeath)', zip: '925365' },
	{ city: 'Coolabaun (Cork)', zip: '494556' },
	{ city: 'Coolabaun (Leitrim)', zip: '779533' },
	{ city: 'Coolaboghlan (Laois)', zip: '700823' },
	{ city: 'Coolaboy (Limerick)', zip: '739053' },
	{ city: 'Coolacareen (Cork)', zip: '349037' },
	{ city: 'Coolacheesker (Cork)', zip: '859959' },
	{ city: 'Coolaclamper (Tipperary)', zip: '289474' },
	{ city: 'Coolaclarig (Kerry)', zip: '356994' },
	{ city: 'Coolaclevane (Cork)', zip: '245214' },
	{ city: 'Coolacloy (Galway)', zip: '871074' },
	{ city: 'Coolacokery (Limerick)', zip: '303482' },
	{ city: 'Coolacoosane (Cork)', zip: '614080' },
	{ city: 'Coolacork (Wicklow)', zip: '826862' },
	{ city: 'Coolacrease (Offaly)', zip: '351877' },
	{ city: 'Coolacresig (Cork)', zip: '519197' },
	{ city: 'Coolaculla (Tipperary)', zip: '829832' },
	{ city: 'Coolacullig (Cork)', zip: '456630' },
	{ city: 'Coolacurn North (Galway)', zip: '820123' },
	{ city: 'Coolacurn South (Galway)', zip: '367995' },
	{ city: 'Coolacurragh (Laois)', zip: '856443' },
	{ city: 'Coolacussane (Tipperary)', zip: '150031' },
	{ city: 'Cooladalane Lower (Waterford)', zip: '185936' },
	{ city: 'Cooladalane Upper (Waterford)', zip: '887692' },
	{ city: 'Cooladangan (Wicklow)', zip: '690136' },
	{ city: 'Cooladawson (Donegal)', zip: '867895' },
	{ city: 'Cooladerreen (Cork)', zip: '599762' },
	{ city: 'Cooladerry (Donegal)', zip: '225117' },
	{ city: 'Cooladerry (Tipperary)', zip: '173117' },
	{ city: 'Cooladerry Mountain (Donegal)', zip: '194131' },
	{ city: 'Cooladine (Wexford)', zip: '907235' },
	{ city: 'Cooladooaun (Galway)', zip: '278408' },
	{ city: 'Cooladoyle (Wicklow)', zip: '123681' },
	{ city: 'Cooladurragh (Cork)', zip: '985721' },
	{ city: 'Cooladye (Roscommon)', zip: '867673' },
	{ city: 'Coolafancy (Wicklow)', zip: '248603' },
	{ city: 'Coolaflake (Wicklow)', zip: '586731' },
	{ city: 'Coolafullaun (Wexford)', zip: '277361' },
	{ city: 'Coolafunshoge (Wicklow)', zip: '286493' },
	{ city: 'Coolagad (Wicklow)', zip: '219064' },
	{ city: 'Coolagadden (Waterford)', zip: '513511' },
	{ city: 'Coolagarranroe (Tipperary)', zip: '353832' },
	{ city: 'Coolagarraun (Galway)', zip: '170510' },
	{ city: 'Coolagarry (Roscommon)', zip: '409713' },
	{ city: 'Coolagary (Offaly)', zip: '801408' },
	{ city: 'Coolageela East (Cork)', zip: '809775' },
	{ city: 'Coolageela West (Cork)', zip: '756922' },
	{ city: 'Coolagh (Clare)', zip: '200187' },
	{ city: 'Coolagh (Cork)', zip: '748403' },
	{ city: 'Coolagh (Galway)', zip: '333500' },
	{ city: 'Coolagh (Kildare)', zip: '674324' },
	{ city: 'Coolagh (Laois)', zip: '696316' },
	{ city: 'Coolagh (Tipperary)', zip: '234441' },
	{ city: 'Coolaghansglaster (Offaly)', zip: '792288' },
	{ city: 'Coolaghbaun (Mayo)', zip: '572092' },
	{ city: 'Coolagh Beg (Cork)', zip: '354345' },
	{ city: 'Coolagherty (Longford)', zip: '334807' },
	{ city: 'Coolaghflags (Kilkenny)', zip: '392723' },
	{ city: 'Coolaghmore (Kilkenny)', zip: '962007' },
	{ city: 'Coolagh More (Cork)', zip: '116500' },
	{ city: 'Coolaght (Kildare)', zip: '735544' },
	{ city: 'Coolaght (Mayo)', zip: '846465' },
	{ city: 'Coolaghtane (Roscommon)', zip: '451785' },
	{ city: 'Coolaghy (Donegal)', zip: '665230' },
	{ city: 'Coolaghy Glebe (Donegal)', zip: '514215' },
	{ city: 'Coolagorane Lower (Tipperary)', zip: '356282' },
	{ city: 'Coolagorane Upper (Tipperary)', zip: '435770' },
	{ city: 'Coolagortboy (Waterford)', zip: '404754' },
	{ city: 'Coolagowan (Kerry)', zip: '557751' },
	{ city: 'Coolagowan (Limerick)', zip: '713890' },
	{ city: 'Coolagraffy (Sligo)', zip: '294185' },
	{ city: 'Coolaha (Cork)', zip: '361722' },
	{ city: 'Coolaha (Monaghan)', zip: '920036' },
	{ city: 'Coolahest (Waterford)', zip: '246123' },
	{ city: 'Coolahocka (Kildare)', zip: '501969' },
	{ city: 'Coolaholloga (Tipperary)', zip: '918841' },
	{ city: 'Coolahullin (Wicklow)', zip: '936150' },
	{ city: 'Coolakay (Wicklow)', zip: '550236' },
	{ city: 'Coolakip (Wexford)', zip: '245841' },
	{ city: 'Coolaknick (Wexford)', zip: '370299' },
	{ city: 'Coolaknickbeg (Wexford)', zip: '259642' },
	{ city: 'Coolalaw (Carlow)', zip: '709726' },
	{ city: 'Coolaleen (Limerick)', zip: '862812' },
	{ city: 'Coolaleena (Westmeath)', zip: '721787' },
	{ city: 'Coolalisheen (Cork)', zip: '878494' },
	{ city: 'Coolalong (Kilkenny)', zip: '545310' },
	{ city: 'Coolalough (Limerick)', zip: '494735' },
	{ city: 'Coolalough (Westmeath)', zip: '959283' },
	{ city: 'Coolalta (Cork)', zip: '333794' },
	{ city: 'Coolalug (Wicklow)', zip: '719637' },
	{ city: 'Coolamaddra (Wicklow)', zip: '118012' },
	{ city: 'Coolamain (Wexford)', zip: '987221' },
	{ city: 'Coolamber (Longford)', zip: '570209' },
	{ city: 'Coolamber (Westmeath)', zip: '390689' },
	{ city: 'Coolamurry (Wexford)', zip: '237988' },
	{ city: 'Coolanagh (Cork)', zip: '794114' },
	{ city: 'Coolanagh (Laois)', zip: '503918' },
	{ city: 'Coolanarney (Cork)', zip: '543684' },
	{ city: 'Coolanarney (Offaly)', zip: '313562' },
	{ city: 'Coolanarroo (Kerry)', zip: '321102' },
	{ city: 'Coolane (Kildare)', zip: '626160' },
	{ city: 'Coolaneague (Cork)', zip: '758425' },
	{ city: 'Coolanearl (Wicklow)', zip: '754446' },
	{ city: 'Coolaneelig (Kerry)', zip: '188218' },
	{ city: 'Coolaney (Sligo)', zip: '282868' },
	{ city: 'Coolanga Lower (Tipperary)', zip: '255315' },
	{ city: 'Coolanga Upper (Tipperary)', zip: '653376' },
	{ city: 'Coolanheen (Waterford)', zip: '128318' },
	{ city: 'Coolaniddane (Cork)', zip: '109747' },
	{ city: 'Coolanillaun (Galway)', zip: '294226' },
	{ city: 'Coolanimod North (Kilkenny)', zip: '964191' },
	{ city: 'Coolanimod South (Kilkenny)', zip: '333316' },
	{ city: 'Coolanoran (Limerick)', zip: '773680' },
	{ city: 'Coolanowle (Laois)', zip: '595367' },
	{ city: 'Coolantallagh (Tipperary)', zip: '157805' },
	{ city: 'Coolanure (Offaly)', zip: '763069' },
	{ city: 'Coolanure (Tipperary)', zip: '912613' },
	{ city: 'Coolaphubble (Roscommon)', zip: '967584' },
	{ city: 'Coolapoge (Kilkenny)', zip: '889406' },
	{ city: 'Coolapreavan (Tipperary)', zip: '811639' },
	{ city: 'Coolaran (Galway)', zip: '865057' },
	{ city: 'Coolard (Kerry)', zip: '530000' },
	{ city: 'Coolarkin (Tipperary)', zip: '754448' },
	{ city: 'Coolartragh (Monaghan)', zip: '944371' },
	{ city: 'Coolaruane (Kerry)', zip: '917829' },
	{ city: 'Coolasmuttane (Cork)', zip: '818690' },
	{ city: 'Coolasnaghta (Carlow)', zip: '304987' },
	{ city: 'Coolaspaddaun (Galway)', zip: '174790' },
	{ city: 'Coolastingan (Wicklow)', zip: '399705' },
	{ city: 'Coolataggle (Tipperary)', zip: '169582' },
	{ city: 'Coolatanavally (Cork)', zip: '580522' },
	{ city: 'Coolatee (Donegal)', zip: '801809' },
	{ city: 'Coolateggart (Wexford)', zip: '357185' },
	{ city: 'Coolatinny (Roscommon)', zip: '823899' },
	{ city: 'Coolatober (Roscommon)', zip: '361003' },
	{ city: 'Coolatogher (Kildare)', zip: '508484' },
	{ city: 'Coolatogher (Kilkenny)', zip: '218020' },
	{ city: 'Coolatooder (Cork)', zip: '267796' },
	{ city: 'Coolatoor (Waterford)', zip: '345606' },
	{ city: 'Coolatoor (Westmeath)', zip: '717327' },
	{ city: 'Coolatoosane (Kerry)', zip: '328129' },
	{ city: 'Coolatore (Wexford)', zip: '311646' },
	{ city: 'Coolatrath East (Dublin)', zip: '674004' },
	{ city: 'Coolatrath West (Dublin)', zip: '195352' },
	{ city: 'Coolatrindle (Wexford)', zip: '674604' },
	{ city: 'Coolattin (Limerick)', zip: '719743' },
	{ city: 'Coolattin (Wexford)', zip: '369402' },
	{ city: 'Coolattin (Wicklow)', zip: '459983' },
	{ city: 'Coolattin Park (Wicklow)', zip: '762315' },
	{ city: 'Coolatty (Monaghan)', zip: '393270' },
	{ city: 'Coolatubbrid (Cork)', zip: '800162' },
	{ city: 'Coolaught (Wexford)', zip: '785487' },
	{ city: 'Coolaun (Tipperary)', zip: '711431' },
	{ city: 'Coolavacoose (Kildare)', zip: '563176' },
	{ city: 'Coolavally (Mayo)', zip: '468338' },
	{ city: 'Coolavanny (Kerry)', zip: '959680' },
	{ city: 'Coolavehy (Limerick)', zip: '185144' },
	{ city: 'Coolavoher (Cork)', zip: '821722' },
	{ city: 'Coolavokig (Cork)', zip: '920298' },
	{ city: 'Coolavoran Coolagh And Derrymullen (Laois)', zip: '814719' },
	{ city: 'Coolavorheen (Kerry)', zip: '452944' },
	{ city: 'Coolaw (Wexford)', zip: '265430' },
	{ city: 'Coolawaleen (Cork)', zip: '352924' },
	{ city: 'Coolawinnia (Wicklow)', zip: '910401' },
	{ city: 'Coolback (Donegal)', zip: '655775' },
	{ city: 'Coolback (Wexford)', zip: '814304' },
	{ city: 'Coolbagh (Waterford)', zip: '457911' },
	{ city: 'Coolballintaggart (Wicklow)', zip: '688077' },
	{ city: 'Coolballow (Wexford)', zip: '702864' },
	{ city: 'Coolbally (Laois)', zip: '560735' },
	{ city: 'Coolballyshane (Limerick)', zip: '258305' },
	{ city: 'Coolbanagher (Laois)', zip: '464967' },
	{ city: 'Coolbane (Cavan)', zip: '122078' },
	{ city: 'Coolbane (Cork)', zip: '579209' },
	{ city: 'Coolbane (Kerry)', zip: '846023' },
	{ city: 'Coolbane (Limerick)', zip: '179452' },
	{ city: 'Coolbane East (Kerry)', zip: '335561' },
	{ city: 'Coolbane West (Kerry)', zip: '248598' },
	{ city: 'Coolbarreen (Mayo)', zip: '239454' },
	{ city: 'Coolbaun (Clare)', zip: '815051' },
	{ city: 'Coolbaun (Cork)', zip: '896652' },
	{ city: 'Coolbaun (Galway)', zip: '330844' },
	{ city: 'Coolbaun (Kerry)', zip: '572336' },
	{ city: 'Coolbaun (Kilkenny)', zip: '957216' },
	{ city: 'Coolbaun (Limerick)', zip: '838255' },
	{ city: 'Coolbaun (Tipperary)', zip: '879086' },
	{ city: 'Coolbaun (Wexford)', zip: '116885' },
	{ city: 'Coolbaun West (Galway)', zip: '707506' },
	{ city: 'Coolbawn (Wicklow)', zip: '116936' },
	{ city: 'Coolbawn Demesne (Wexford)', zip: '349789' },
	{ city: 'Coolbea (Cork)', zip: '209686' },
	{ city: 'Coolbeg (Galway)', zip: '351471' },
	{ city: 'Coolbeg (Limerick)', zip: '424058' },
	{ city: 'Coolbeg (Sligo)', zip: '510527' },
	{ city: 'Coolbeg (Wicklow)', zip: '427478' },
	{ city: 'Cool Beg (Donegal)', zip: '405765' },
	{ city: 'Coolbeggan East (Waterford)', zip: '338484' },
	{ city: 'Coolbeggan West (Waterford)', zip: '732947' },
	{ city: 'Coolbeha (Kerry)', zip: '110471' },
	{ city: 'Coolberrin (Monaghan)', zip: '836622' },
	{ city: 'Coolbock (Sligo)', zip: '187631' },
	{ city: 'Coolbooa (Waterford)', zip: '445012' },
	{ city: 'Coolboreen (Tipperary)', zip: '808781' },
	{ city: 'Coolboy (Cork)', zip: '991683' },
	{ city: 'Coolboy (Donegal)', zip: '337870' },
	{ city: 'Coolboy (Limerick)', zip: '706173' },
	{ city: 'Coolboy (Sligo)', zip: '451730' },
	{ city: 'Coolboy (Tipperary)', zip: '687731' },
	{ city: 'Coolboy (Wexford)', zip: '335354' },
	{ city: 'Coolboy (Wicklow)', zip: '980105' },
	{ city: 'Coolboy Big (Donegal)', zip: '298239' },
	{ city: 'Coolboy Little (Donegal)', zip: '825811' },
	{ city: 'Coolboyoge (Cavan)', zip: '240091' },
	{ city: 'Coolbreedeen (Limerick)', zip: '952690' },
	{ city: 'Coolbricken (Kilkenny)', zip: '796444' },
	{ city: 'Coolbrock (Wexford)', zip: '544169' },
	{ city: 'Coolbunnia (Waterford)', zip: '478343' },
	{ city: 'Coolcaha (Cork)', zip: '141038' },
	{ city: 'Coolcahan (Westmeath)', zip: '963602' },
	{ city: 'Coolcair (Monaghan)', zip: '743134' },
	{ city: 'Coolcam (Roscommon)', zip: '113687' },
	{ city: 'Coolcam (Wexford)', zip: '223853' },
	{ city: 'Coolcanadas (Cavan)', zip: '282905' },
	{ city: 'Coolcap (Cork)', zip: '653454' },
	{ city: 'Coolcappagh (Limerick)', zip: '174009' },
	{ city: 'Coolcarrigan (Kildare)', zip: '629838' },
	{ city: 'Coolcarron (Cork)', zip: '783806' },
	{ city: 'Coolcarta East (Galway)', zip: '924483' },
	{ city: 'Coolcarta West (Galway)', zip: '659180' },
	{ city: 'Coolcashin (Kilkenny)', zip: '742288' },
	{ city: 'Coolcashla (Mayo)', zip: '332766' },
	{ city: 'Coolcaslagh (Kerry)', zip: '767360' },
	{ city: 'Coolcaum (Cork)', zip: '449705' },
	{ city: 'Coolcaw (Longford)', zip: '729928' },
	{ city: 'Coolcholly (Donegal)', zip: '947134' },
	{ city: 'Coolclieve (Kerry)', zip: '165389' },
	{ city: 'Coolcliffe (Wexford)', zip: '358864' },
	{ city: 'Coolclogh (Cork)', zip: '993115' },
	{ city: 'Coolclogher (Kerry)', zip: '808273' },
	{ city: 'Coolcloher East (Cork)', zip: '901907' },
	{ city: 'Coolcloher South (Cork)', zip: '160017' },
	{ city: 'Coolcloher West (Cork)', zip: '506272' },
	{ city: 'Coolcollid (Monaghan)', zip: '588372' },
	{ city: 'Coolcon (Mayo)', zip: '919286' },
	{ city: 'Coolcor (Kildare)', zip: '703283' },
	{ city: 'Coolcor (Longford)', zip: '721360' },
	{ city: 'Coolcor (Offaly)', zip: '171254' },
	{ city: 'Coolcorberry (Laois)', zip: '784199' },
	{ city: 'Coolcorcoran (Kerry)', zip: '312766' },
	{ city: 'Coolcormack (Tipperary)', zip: '397809' },
	{ city: 'Coolcormuck (Waterford)', zip: '528183' },
	{ city: 'Coolcorragh (Monaghan)', zip: '686092' },
	{ city: 'Coolcots (Wexford)', zip: '873241' },
	{ city: 'Coolcoulaghta (Cork)', zip: '141368' },
	{ city: 'Coolcour (Cork)', zip: '500202' },
	{ city: 'Coolcraff (Longford)', zip: '758401' },
	{ city: 'Coolcraheen (Cork)', zip: '938050' },
	{ city: 'Coolcran (Mayo)', zip: '128872' },
	{ city: 'Coolcreedan (Louth)', zip: '502582' },
	{ city: 'Coolcreen (Kerry)', zip: '463627' },
	{ city: 'Coolcreen (Offaly)', zip: '514728' },
	{ city: 'Coolcreeve (Leitrim)', zip: '167715' },
	{ city: 'Coolcronaun (Mayo)', zip: '217663' },
	{ city: 'Coolcronoge (Limerick)', zip: '805334' },
	{ city: 'Coolcroo (Tipperary)', zip: '616898' },
	{ city: 'Coolcull (Wexford)', zip: '982448' },
	{ city: 'Coolcull Big (Wexford)', zip: '426160' },
	{ city: 'Coolcullen (Kilkenny)', zip: '594866' },
	{ city: 'Coolcullitha (Cork)', zip: '245443' },
	{ city: 'Coolcummisk (Kerry)', zip: '532644' },
	{ city: 'Coolcurtoga (Kerry)', zip: '608569' },
	{ city: 'Coolcuttia (Kilkenny)', zip: '288600' },
	{ city: 'Cooldaniel (Cork)', zip: '322094' },
	{ city: 'Cooldarragh (Monaghan)', zip: '418522' },
	{ city: 'Coolderry (Clare)', zip: '990297' },
	{ city: 'Coolderry (Laois)', zip: '140530' },
	{ city: 'Coolderry (Meath)', zip: '555174' },
	{ city: 'Coolderry (Monaghan)', zip: '665640' },
	{ city: 'Coolderry (Offaly)', zip: '673014' },
	{ city: 'Coolderry (Roscommon)', zip: '561155' },
	{ city: 'Coolderry (Tipperary)', zip: '912497' },
	{ city: 'Cooldine (Tipperary)', zip: '454886' },
	{ city: 'Cooldoney (Longford)', zip: '771555' },
	{ city: 'Cooldorragh (Offaly)', zip: '674681' },
	{ city: 'Cooldorragh (Roscommon)', zip: '537972' },
	{ city: 'Cooldorragha (Clare)', zip: '508392' },
	{ city: 'Cooldorragha (Cork)', zip: '676076' },
	{ city: 'Cooldorragha (Galway)', zip: '823165' },
	{ city: 'Cooldorragh Glebe (Offaly)', zip: '609833' },
	{ city: 'Cooldotia (Tipperary)', zip: '841880' },
	{ city: 'Cooldown Commons (Dublin)', zip: '158005' },
	{ city: 'Cooldrinagh (Dublin)', zip: '566273' },
	{ city: 'Cooldrishoge (Waterford)', zip: '318261' },
	{ city: 'Cooldrisla (Tipperary)', zip: '965253' },
	{ city: 'Cooldross Lower (Wicklow)', zip: '864058' },
	{ city: 'Cooldross Middle (Wicklow)', zip: '414108' },
	{ city: 'Cooldross Upper (Wicklow)', zip: '778182' },
	{ city: 'Cooldrum (Cork)', zip: '231216' },
	{ city: 'Cooldrumman Lower (Sligo)', zip: '207178' },
	{ city: 'Cooldrumman Upper (Sligo)', zip: '663516' },
	{ city: 'Coolduff (Cork)', zip: '117011' },
	{ city: 'Cooldurragha (Cork)', zip: '893872' },
	{ city: 'Coole (Carlow)', zip: '635179' },
	{ city: 'Coole (Cork)', zip: '743301' },
	{ city: 'Coole (Kilkenny)', zip: '812573' },
	{ city: 'Coole (Laois)', zip: '314162' },
	{ city: 'Coole (Louth)', zip: '213933' },
	{ city: 'Coole (Meath)', zip: '516711' },
	{ city: 'Coole (Offaly)', zip: '629619' },
	{ city: 'Coole (Tipperary)', zip: '309129' },
	{ city: 'Coole (Westmeath)', zip: '855642' },
	{ city: 'Coole (Wexford)', zip: '704478' },
	{ city: 'Coolea (Cork)', zip: '909915' },
	{ city: 'Cooleabeg (Clare)', zip: '721157' },
	{ city: 'Cooleagh (Tipperary)', zip: '489770' },
	{ city: 'Cooleamore (Clare)', zip: '356262' },
	{ city: 'Cooleanig (Kerry)', zip: '849425' },
	{ city: 'Coolearagh East (Kildare)', zip: '416062' },
	{ city: 'Coolearagh West (Kildare)', zip: '240282' },
	{ city: 'Cool East (Kerry)', zip: '812899' },
	{ city: 'Cool East (Limerick)', zip: '765827' },
	{ city: 'Coole Demesne (Galway)', zip: '130620' },
	{ city: 'Coole East (Cork)', zip: '445468' },
	{ city: 'Cooleen (Cork)', zip: '525904' },
	{ city: 'Cooleen (Kilkenny)', zip: '626936' },
	{ city: 'Cooleen (Limerick)', zip: '124097' },
	{ city: 'Cooleen (Mayo)', zip: '578596' },
	{ city: 'Cooleen (Tipperary)', zip: '475838' },
	{ city: 'Cooleen (Westmeath)', zip: '951299' },
	{ city: 'Cooleenagow (Cork)', zip: '966912' },
	{ city: 'Cooleenaree (Cork)', zip: '280202' },
	{ city: 'Cooleenlemane (Cork)', zip: '515232' },
	{ city: 'Cooleens (Cork)', zip: '432582' },
	{ city: 'Cooleens (Tipperary)', zip: '507380' },
	{ city: 'Cooleeny (Galway)', zip: '469673' },
	{ city: 'Cooleeny (Longford)', zip: '285035' },
	{ city: 'Cooleeny (Tipperary)', zip: '751462' },
	{ city: 'Cooleeny East (Galway)', zip: '990289' },
	{ city: 'Cooleeny West (Galway)', zip: '893615' },
	{ city: 'Cooleeshal (Kilkenny)', zip: '810759' },
	{ city: 'Cooleeshal Beg (Kilkenny)', zip: '837400' },
	{ city: 'Cooleeshal More (Kilkenny)', zip: '665292' },
	{ city: 'Cooleeshil (Longford)', zip: '107870' },
	{ city: 'Cooleeshill (Offaly)', zip: '492413' },
	{ city: 'Cooleeshill (Tipperary)', zip: '354639' },
	{ city: 'Coolehill Lower (Kilkenny)', zip: '781641' },
	{ city: 'Coolehill Upper (Kilkenny)', zip: '140204' },
	{ city: 'Cooleighter (Westmeath)', zip: '937721' },
	{ city: 'Coolelan (Kildare)', zip: '303988' },
	{ city: 'Coole Lower (Cork)', zip: '516556' },
	{ city: 'Coolerin (Wexford)', zip: '224215' },
	{ city: 'Coolerin North (Wexford)', zip: '109434' },
	{ city: 'Coolerin South (Wexford)', zip: '952771' },
	{ city: 'Cooles (Cork)', zip: '117318' },
	{ city: 'Coole Upper (Cork)', zip: '381798' },
	{ city: 'Coole West (Cork)', zip: '757361' },
	{ city: 'Cooley (Mayo)', zip: '555954' },
	{ city: 'Coolfadda (Cork)', zip: '763490' },
	{ city: 'Coolfarnamanagh (Kilkenny)', zip: '121212' },
	{ city: 'Coolfin (Galway)', zip: '868890' },
	{ city: 'Coolfin (Laois)', zip: '448435' },
	{ city: 'Coolfin (Offaly)', zip: '214304' },
	{ city: 'Coolfin (Westmeath)', zip: '102272' },
	{ city: 'Coolfin Glebe (Offaly)', zip: '124101' },
	{ city: 'Coolfinn (Waterford)', zip: '201925' },
	{ city: 'Coolfitch (Kildare)', zip: '691309' },
	{ city: 'Coolflugh (Cork)', zip: '853429' },
	{ city: 'Coolfore (Louth)', zip: '752386' },
	{ city: 'Coolfore (Meath)', zip: '103428' },
	{ city: 'Coolfore (Monaghan)', zip: '148736' },
	{ city: 'Coolfores (Dublin)', zip: '754708' },
	{ city: 'Coolfowerbeg (Galway)', zip: '942980' },
	{ city: 'Coolfree (Limerick)', zip: '935259' },
	{ city: 'Coolfree (Roscommon)', zip: '684749' },
	{ city: 'Coolfune (Limerick)', zip: '882251' },
	{ city: 'Coolgarragh (Laois)', zip: '592142' },
	{ city: 'Coolgarran (Tipperary)', zip: '277833' },
	{ city: 'Coolgarrane (Tipperary)', zip: '514474' },
	{ city: 'Coolgarriff (Cork)', zip: '384645' },
	{ city: 'Coolgarriv (Kerry)', zip: '250348' },
	{ city: 'Coolgarrow (Wexford)', zip: '571524' },
	{ city: 'Coolgarrow (Wicklow)', zip: '206731' },
	{ city: 'Coolglass (Laois)', zip: '537952' },
	{ city: 'Coolgort (Tipperary)', zip: '468058' },
	{ city: 'Coolgower (Waterford)', zip: '939212' },
	{ city: 'Coolgrange (Kilkenny)', zip: '236219' },
	{ city: 'Coolgreany (Kilkenny)', zip: '989047' },
	{ city: 'Coolgreany (Wexford)', zip: '109922' },
	{ city: 'Coolgreany Demesne (Wexford)', zip: '478823' },
	{ city: 'Coolgreen (Cork)', zip: '701467' },
	{ city: 'Coolguerisk (Cork)', zip: '899761' },
	{ city: 'Coolharbour (Wexford)', zip: '866052' },
	{ city: 'Coolharbour Lower (Wicklow)', zip: '978611' },
	{ city: 'Coolharbour Upper (Wicklow)', zip: '449535' },
	{ city: 'Coolhenry (Laois)', zip: '976908' },
	{ city: 'Coolhill (Kilkenny)', zip: '375566' },
	{ city: 'Coolhull (Wexford)', zip: '182107' },
	{ city: 'Coolier (Kildare)', zip: '487160' },
	{ city: 'Coolieragh (Cork)', zip: '983528' },
	{ city: 'Coolierher (Cork)', zip: '621498' },
	{ city: 'Coolierin (Kilkenny)', zip: '866671' },
	{ city: 'Coolies (Kerry)', zip: '265147' },
	{ city: 'Cooligboy (Cork)', zip: '346384' },
	{ city: 'Coolin (Galway)', zip: '707257' },
	{ city: 'Coolinarrig Lower (Wicklow)', zip: '619990' },
	{ city: 'Coolinarrig Upper (Wicklow)', zip: '372527' },
	{ city: 'Coolineagh (Cork)', zip: '294051' },
	{ city: 'Cooliney (Cork)', zip: '364007' },
	{ city: 'Coolinny (Cork)', zip: '933582' },
	{ city: 'Coolintaggart (Wexford)', zip: '585862' },
	{ city: 'Coolintaggarthill (Wexford)', zip: '396828' },
	{ city: 'Coolishal (Limerick)', zip: '256415' },
	{ city: 'Coolishal (Waterford)', zip: '441147' },
	{ city: 'Coolishal (Wexford)', zip: '667099' },
	{ city: 'Coolishal Lower (Wexford)', zip: '716789' },
	{ city: 'Coolishal Upper (Wexford)', zip: '200578' },
	{ city: 'Cooliska (Limerick)', zip: '754619' },
	{ city: 'Coolistoonan (Clare)', zip: '999323' },
	{ city: 'Cooljohn (Meath)', zip: '709365' },
	{ city: 'Coolkeeran (Wexford)', zip: '842335' },
	{ city: 'Coolkellure (Cork)', zip: '431256' },
	{ city: 'Coolkenna (Wicklow)', zip: '744395' },
	{ city: 'Coolkennedy (Tipperary)', zip: '615606' },
	{ city: 'Coolkeragh (Kerry)', zip: '890780' },
	{ city: 'Coolkereen (Tipperary)', zip: '549404' },
	{ city: 'Coolkerry (Laois)', zip: '441827' },
	{ city: 'Coolkill (Cavan)', zip: '193968' },
	{ city: 'Coolkill (Tipperary)', zip: '702235' },
	{ city: 'Coolkill East (Monaghan)', zip: '658588' },
	{ city: 'Coolkill West (Monaghan)', zip: '410841' },
	{ city: 'Coolkip (Tipperary)', zip: '543936' },
	{ city: 'Coolkirky (Cork)', zip: '814362' },
	{ city: 'Coolkisha (Cork)', zip: '963818' },
	{ city: 'Coolknedane North (Cork)', zip: '492514' },
	{ city: 'Coolknedane South (Cork)', zip: '497059' },
	{ city: 'Coolknoohil (Kerry)', zip: '321513' },
	{ city: 'Coollagagh (Mayo)', zip: '880204' },
	{ city: 'Coollegrean (Kerry)', zip: '924763' },
	{ city: 'Coollegreane (Leitrim)', zip: '515155' },
	{ city: 'Coollemoneen (Sligo)', zip: '131026' },
	{ city: 'Coollena (Roscommon)', zip: '931904' },
	{ city: 'Coollick (Kerry)', zip: '313606' },
	{ city: 'Coollicka (Cork)', zip: '293711' },
	{ city: 'Coollicknalea (Galway)', zip: '774182' },
	{ city: 'Coollisduff (Mayo)', zip: '687830' },
	{ city: 'Coollisteige (Clare)', zip: '793780' },
	{ city: 'Cool Lodge (Mayo)', zip: '680781' },
	{ city: 'Coolloughra (Mayo)', zip: '717782' },
	{ city: 'Cool Lower (Donegal)', zip: '370599' },
	{ city: 'Coollusty (Roscommon)', zip: '803617' },
	{ city: 'Coolmagort (Kerry)', zip: '660828' },
	{ city: 'Coolmahane (Cork)', zip: '700124' },
	{ city: 'Coolmain (Cork)', zip: '606978' },
	{ city: 'Coolmain (Monaghan)', zip: '685152' },
	{ city: 'Coolmakean (Mayo)', zip: '741386' },
	{ city: 'Coolmanagh Lower (Carlow)', zip: '417667' },
	{ city: 'Coolmanagh Upper (Carlow)', zip: '210214' },
	{ city: 'Coolmannan (Monaghan)', zip: '827689' },
	{ city: 'Coolmarks (Kilkenny)', zip: '617832' },
	{ city: 'Coolmeen (Clare)', zip: '232532' },
	{ city: 'Coolmeen (Kilkenny)', zip: '551463' },
	{ city: 'Coolmeen (Roscommon)', zip: '337555' },
	{ city: 'Coolmeen (Sligo)', zip: '825355' },
	{ city: 'Coolmela (Wexford)', zip: '839805' },
	{ city: 'Coolmine (Dublin)', zip: '240050' },
	{ city: 'Coolmona (Cork)', zip: '644305' },
	{ city: 'Coolmoney (Wicklow)', zip: '677546' },
	{ city: 'Coolmoohan (Cork)', zip: '244212' },
	{ city: 'Coolmore (Cork)', zip: '110916' },
	{ city: 'Coolmore (Donegal)', zip: '812024' },
	{ city: 'Coolmore (Kilkenny)', zip: '818838' },
	{ city: 'Coolmore (Tipperary)', zip: '655017' },
	{ city: 'Coolmore (Wicklow)', zip: '268462' },
	{ city: 'Cool More (Donegal)', zip: '325148' },
	{ city: 'Coolmoreen (Cork)', zip: '202138' },
	{ city: 'Coolmountain (Cork)', zip: '427169' },
	{ city: 'Coolmoyne (Tipperary)', zip: '301937' },
	{ city: 'Coolmuckbane (Monaghan)', zip: '794325' },
	{ city: 'Coolmucky (Cork)', zip: '795124' },
	{ city: 'Coolmuinga (Clare)', zip: '259472' },
	{ city: 'Coolmurly (Sligo)', zip: '466331' },
	{ city: 'Coolnabacky (Laois)', zip: '256245' },
	{ city: 'Coolnabanch (Laois)', zip: '141573' },
	{ city: 'Coolnabeasoon (Waterford)', zip: '112146' },
	{ city: 'Coolnabehy (Laois)', zip: '784928' },
	{ city: 'Coolnabinnia (Mayo)', zip: '232903' },
	{ city: 'Coolnaboul East (Laois)', zip: '913074' },
	{ city: 'Coolnaboul West (Laois)', zip: '703054' },
	{ city: 'Coolnaboy (Wexford)', zip: '890697' },
	{ city: 'Coolnabrone (Kilkenny)', zip: '824861' },
	{ city: 'Coolnacaha (Cork)', zip: '989258' },
	{ city: 'Coolnacaheragh (Cork)', zip: '641765' },
	{ city: 'Coolnacalla (Tipperary)', zip: '754086' },
	{ city: 'Coolnacalliagh (Kerry)', zip: '131785' },
	{ city: 'Coolnacarrick (Cavan)', zip: '269558' },
	{ city: 'Coolnacarrick (Laois)', zip: '802802' },
	{ city: 'Coolnacarriga (Cork)', zip: '534580' },
	{ city: 'Coolnacartan (Laois)', zip: '701773' },
	{ city: 'Coolnacarte (Monaghan)', zip: '828770' },
	{ city: 'Coolnaclehy (Cork)', zip: '673948' },
	{ city: 'Coolnacloghafinna (Cork)', zip: '147585' },
	{ city: 'Coolnacola (Cavan)', zip: '668604' },
	{ city: 'Coolnacon (Wexford)', zip: '601568' },
	{ city: 'Coolnaconarty (Cork)', zip: '669754' },
	{ city: 'Coolnacrannagh (Cork)', zip: '281647' },
	{ city: 'Coolnacreena (Waterford)', zip: '431283' },
	{ city: 'Coolnacrutta (Kilkenny)', zip: '347981' },
	{ city: 'Coolnacuppoge (Carlow)', zip: '374171' },
	{ city: 'Coolnadead (Kerry)', zip: '495467' },
	{ city: 'Coolnadornory (Tipperary)', zip: '619187' },
	{ city: 'Coolnadown (Limerick)', zip: '788784' },
	{ city: 'Coolnafarna (Mayo)', zip: '100497' },
	{ city: 'Coolnafearagh (Kildare)', zip: '715040' },
	{ city: 'Coolnafinnoge (Longford)', zip: '714137' },
	{ city: 'Coolnagarrahy (Kerry)', zip: '565106' },
	{ city: 'Coolnagarrane (Cork)', zip: '793206' },
	{ city: 'Coolnagaug (Cork)', zip: '628842' },
	{ city: 'Coolnagay (Cork)', zip: '884912' },
	{ city: 'Coolnagearagh (Cork)', zip: '445145' },
	{ city: 'Coolnageer (Roscommon)', zip: '781846' },
	{ city: 'Coolnageeragh (Galway)', zip: '138775' },
	{ city: 'Coolnageragh (Kerry)', zip: '890978' },
	{ city: 'Coolnagillagh Lower (Cork)', zip: '556636' },
	{ city: 'Coolnagillagh Upper (Cork)', zip: '174142' },
	{ city: 'Coolnagloose (Wexford)', zip: '501738' },
	{ city: 'Coolnagoppoge (Kerry)', zip: '361317' },
	{ city: 'Coolnagoppoge (Waterford)', zip: '223515' },
	{ city: 'Coolnagor (Cavan)', zip: '782132' },
	{ city: 'Coolnagour (Cork)', zip: '258719' },
	{ city: 'Coolnagour (Laois)', zip: '226994' },
	{ city: 'Coolnagour (Waterford)', zip: '581638' },
	{ city: 'Coolnagraigue (Kerry)', zip: '653299' },
	{ city: 'Coolnagranshy (Roscommon)', zip: '659816' },
	{ city: 'Coolnagrattan (Monaghan)', zip: '794474' },
	{ city: 'Coolnagree (Wexford)', zip: '857577' },
	{ city: 'Coolnagrower (Offaly)', zip: '961810' },
	{ city: 'Coolnagrower (Tipperary)', zip: '660769' },
	{ city: 'Coolnagun (Tipperary)', zip: '853041' },
	{ city: 'Coolnagun (Westmeath)', zip: '645575' },
	{ city: 'Coolnahane (Cork)', zip: '806063' },
	{ city: 'Coolnaha North (Mayo)', zip: '852807' },
	{ city: 'Coolnaharragill Lower (Kerry)', zip: '757251' },
	{ city: 'Coolnaharragill Upper (Kerry)', zip: '190583' },
	{ city: 'Coolnaha South (Mayo)', zip: '555652' },
	{ city: 'Coolnahau (Kilkenny)', zip: '776959' },
	{ city: 'Coolnahay (Westmeath)', zip: '292707' },
	{ city: 'Coolnahella (Clare)', zip: '511382' },
	{ city: 'Coolnahely (Offaly)', zip: '522140' },
	{ city: 'Coolnaherin (Tipperary)', zip: '741092' },
	{ city: 'Coolnahila (Limerick)', zip: '632682' },
	{ city: 'Coolnahilla (Cork)', zip: '381584' },
	{ city: 'Coolnahinch (Longford)', zip: '892870' },
	{ city: 'Coolnahinch (Meath)', zip: '246756' },
	{ city: 'Coolnahinch (Offaly)', zip: '267990' },
	{ city: 'Coolnahinch (Wexford)', zip: '347914' },
	{ city: 'Coolnahorna (Waterford)', zip: '997357' },
	{ city: 'Coolnahorna (Wexford)', zip: '338685' },
	{ city: 'Coolnakeeran (Carlow)', zip: '655901' },
	{ city: 'Coolnakilla (Cork)', zip: '949343' },
	{ city: 'Coolnakilly (Wicklow)', zip: '401262' },
	{ city: 'Coolnakisha (Carlow)', zip: '419321' },
	{ city: 'Coolnaknockane (Limerick)', zip: '426767' },
	{ city: 'Coolnalaght (Kerry)', zip: '519170' },
	{ city: 'Coolnaleen (Kilkenny)', zip: '171736' },
	{ city: 'Coolnaleen (Wexford)', zip: '195595' },
	{ city: 'Coolnaleen Lower (Kerry)', zip: '582867' },
	{ city: 'Coolnaleen Upper (Kerry)', zip: '695501' },
	{ city: 'Coolnalingady (Waterford)', zip: '865219' },
	{ city: 'Coolnalira (Clare)', zip: '895072' },
	{ city: 'Coolnalitteragh (Cavan)', zip: '432320' },
	{ city: 'Coolnalong (Monaghan)', zip: '416555' },
	{ city: 'Coolnamagh (Cork)', zip: '722747' },
	{ city: 'Coolnamara (Carlow)', zip: '862287' },
	{ city: 'Coolnambrisklaun (Kilkenny)', zip: '485888' },
	{ city: 'Coolnamohoge (Limerick)', zip: '880853' },
	{ city: 'Coolnamona (Laois)', zip: '580614' },
	{ city: 'Coolnamona (Limerick)', zip: '956291' },
	{ city: 'Coolnamoney (Tipperary)', zip: '170597' },
	{ city: 'Coolnamony Lower (Laois)', zip: '813516' },
	{ city: 'Coolnamony Upper (Laois)', zip: '963279' },
	{ city: 'Coolnamuck (Kilkenny)', zip: '187309' },
	{ city: 'Coolnamuck Demesne (Waterford)', zip: '562516' },
	{ city: 'Coolnamuck East (Waterford)', zip: '917661' },
	{ city: 'Coolnamuck West (Waterford)', zip: '110963' },
	{ city: 'Coolnamunna (Tipperary)', zip: '408856' },
	{ city: 'Coolnanav (Waterford)', zip: '746069' },
	{ city: 'Coolnanave (Cork)', zip: '368497' },
	{ city: 'Coolnaneagh (Waterford)', zip: '774893' },
	{ city: 'Coolnanoglagh (Limerick)', zip: '835136' },
	{ city: 'Coolnanoonagh (Kerry)', zip: '424462' },
	{ city: 'Coolnapish (Carlow)', zip: '781657' },
	{ city: 'Coolnapisha (Kilkenny)', zip: '765288' },
	{ city: 'Coolnapisha (Limerick)', zip: '174558' },
	{ city: 'Coolnashamroge (Cork)', zip: '481056' },
	{ city: 'Coolnashamroge (Limerick)', zip: '301748' },
	{ city: 'Coolnasheegan (Carlow)', zip: '504911' },
	{ city: 'Coolnashinnagh (Tipperary)', zip: '227550' },
	{ city: 'Coolnashinny (Cavan)', zip: '370190' },
	{ city: 'Coolnaskeagh (Wicklow)', zip: '451178' },
	{ city: 'Coolnasmear Lower (Waterford)', zip: '996432' },
	{ city: 'Coolnasmearmountain (Waterford)', zip: '175446' },
	{ city: 'Coolnasmear Upper (Waterford)', zip: '820786' },
	{ city: 'Coolnasmuttaun (Waterford)', zip: '797260' },
	{ city: 'Coolnasoon (Cork)', zip: '772832' },
	{ city: 'Coolnastudd (Wexford)', zip: '668011' },
	{ city: 'Coolnatullagh (Clare)', zip: '888527' },
	{ city: 'Coolnavarnoge And Coolaghy (Laois)', zip: '329045' },
	{ city: 'Coolnaveagh (Wexford)', zip: '177687' },
	{ city: 'Coolock (Dublin)', zip: '968645' },
	{ city: 'Coolodonnell (Leitrim)', zip: '340376' },
	{ city: 'Coologe (Cavan)', zip: '258468' },
	{ city: 'Coologe (Kilkenny)', zip: '199293' },
	{ city: 'Coologe (Limerick)', zip: '818319' },
	{ city: 'Coologe (Offaly)', zip: '652244' },
	{ city: 'Coologe (Tipperary)', zip: '833679' },
	{ city: 'Coologes (Kerry)', zip: '495301' },
	{ city: 'Coologmartin (Kildare)', zip: '941829' },
	{ city: 'Coologory (Clare)', zip: '596226' },
	{ city: 'Coololla (Galway)', zip: '947223' },
	{ city: 'Cooloo (Galway)', zip: '141659' },
	{ city: 'Coolook Beg (Wexford)', zip: '416382' },
	{ city: 'Coolook More (Wexford)', zip: '711552' },
	{ city: 'Cooloo Mountain (Galway)', zip: '208986' },
	{ city: 'Cooloorta (Clare)', zip: '476993' },
	{ city: 'Cooloorta (Galway)', zip: '512273' },
	{ city: 'Cooloran (Tipperary)', zip: '975684' },
	{ city: 'Coolougher (Roscommon)', zip: '213698' },
	{ city: 'Cooloughter (Wexford)', zip: '111721' },
	{ city: 'Cooloultha (Kilkenny)', zip: '161186' },
	{ city: 'Coolowen (Cork)', zip: '610219' },
	{ city: 'Coolowen (Waterford)', zip: '234126' },
	{ city: 'Coolowen Little (Waterford)', zip: '552817' },
	{ city: 'Coolowley (Laois)', zip: '164910' },
	{ city: 'Coolownig (Kerry)', zip: '499227' },
	{ city: 'Coolpark (Galway)', zip: '637393' },
	{ city: 'Coolpeach (Wexford)', zip: '815407' },
	{ city: 'Coolpeekaun (Clare)', zip: '468756' },
	{ city: 'Coolpowra (Galway)', zip: '174236' },
	{ city: 'Coolpuck (Wexford)', zip: '541371' },
	{ city: 'Coolquane (Cork)', zip: '405261' },
	{ city: 'Coolquill (Tipperary)', zip: '879935' },
	{ city: 'Coolquoy (Dublin)', zip: '159435' },
	{ city: 'Coolquoy Common (Dublin)', zip: '771928' },
	{ city: 'Coolraheen (Kilkenny)', zip: '979700' },
	{ city: 'Coolraheen (Wexford)', zip: '545465' },
	{ city: 'Coolraheen North (Kilkenny)', zip: '401930' },
	{ city: 'Coolraheen South (Kilkenny)', zip: '134941' },
	{ city: 'Coolrahnee (Limerick)', zip: '153985' },
	{ city: 'Coolrain (Laois)', zip: '452863' },
	{ city: 'Coolrainey (Wexford)', zip: '677992' },
	{ city: 'Coolrainy (Kilkenny)', zip: '901735' },
	{ city: 'Coolrake (Kildare)', zip: '880091' },
	{ city: 'Coolrath (Louth)', zip: '848631' },
	{ city: 'Coolrattin (Waterford)', zip: '401859' },
	{ city: 'Coolraugh (Galway)', zip: '408635' },
	{ city: 'Coolrawer (Sligo)', zip: '463914' },
	{ city: 'Coolready (Clare)', zip: '208035' },
	{ city: 'Coolready (Limerick)', zip: '858300' },
	{ city: 'Coolreagh (Clare)', zip: '941286' },
	{ city: 'Coolreagh (Kildare)', zip: '240835' },
	{ city: 'Coolreagh (Limerick)', zip: '279660' },
	{ city: 'Coolreagh (Monaghan)', zip: '605718' },
	{ city: 'Coolreagh (Offaly)', zip: '919392' },
	{ city: 'Coolreagh Beg (Clare)', zip: '246932' },
	{ city: 'Coolreagh Glebe (Offaly)', zip: '752280' },
	{ city: 'Coolreagh More (Clare)', zip: '374276' },
	{ city: 'Coolrecuill (Sligo)', zip: '931816' },
	{ city: 'Coolree (Kildare)', zip: '661316' },
	{ city: 'Coolree (Wexford)', zip: '670700' },
	{ city: 'Coolreiry (Limerick)', zip: '215496' },
	{ city: 'Coolremony (Monaghan)', zip: '985697' },
	{ city: 'Coolrevagh (Galway)', zip: '543267' },
	{ city: 'Coolroe (Carlow)', zip: '553532' },
	{ city: 'Coolroe (Cork)', zip: '899709' },
	{ city: 'Coolroe (Kerry)', zip: '950403' },
	{ city: 'Coolroe (Kildare)', zip: '726322' },
	{ city: 'Coolroe (Kilkenny)', zip: '598805' },
	{ city: 'Coolroe (Laois)', zip: '270170' },
	{ city: 'Coolroe (Limerick)', zip: '803315' },
	{ city: 'Coolroe (Mayo)', zip: '382917' },
	{ city: 'Coolroe (Offaly)', zip: '883355' },
	{ city: 'Coolroe (Waterford)', zip: '262425' },
	{ city: 'Coolroe (Wexford)', zip: '730254' },
	{ city: 'Coolroe (Wicklow)', zip: '437269' },
	{ city: 'Coolroebeg (Kilkenny)', zip: '619358' },
	{ city: 'Coolroe Beg (Cork)', zip: '414629' },
	{ city: 'Coolroe East (Cork)', zip: '833168' },
	{ city: 'Coolroe East (Kerry)', zip: '678235' },
	{ city: 'Coolroe Great (Wexford)', zip: '483540' },
	{ city: 'Coolroe Little (Wexford)', zip: '752049' },
	{ city: 'Coolroe Lower (Kerry)', zip: '213817' },
	{ city: 'Coolroe More (Cork)', zip: '329552' },
	{ city: 'Coolroe North (Kerry)', zip: '316130' },
	{ city: 'Coolroe South (Kerry)', zip: '623528' },
	{ city: 'Coolroe Upper (Kerry)', zip: '468776' },
	{ city: 'Coolroe West (Cork)', zip: '709228' },
	{ city: 'Coolroe West (Kerry)', zip: '706708' },
	{ city: 'Coolroghaun (Roscommon)', zip: '909389' },
	{ city: 'Coolronan (Meath)', zip: '307905' },
	{ city: 'Coolross (Tipperary)', zip: '368060' },
	{ city: 'Coolross (Wicklow)', zip: '925741' },
	{ city: 'Coolruntha (Tipperary)', zip: '678862' },
	{ city: 'Coolrus (Limerick)', zip: '296114' },
	{ city: 'Coolrusk (Laois)', zip: '917209' },
	{ city: 'Cools (Cork)', zip: '317230' },
	{ city: 'Cools (Kerry)', zip: '659027' },
	{ city: 'Cools (Wexford)', zip: '192697' },
	{ city: 'Coolsallagh (Cork)', zip: '626507' },
	{ city: 'Coolsallagh (Wexford)', zip: '612443' },
	{ city: 'Coolscart (Limerick)', zip: '217217' },
	{ city: 'Coolscuddan (Dublin)', zip: '516603' },
	{ city: 'Coolseskin (Wexford)', zip: '719751' },
	{ city: 'Coolshaghtena (Roscommon)', zip: '365060' },
	{ city: 'Coolshamroge (Clare)', zip: '501853' },
	{ city: 'Coolshangan (Donegal)', zip: '881584' },
	{ city: 'Coolshannagh (Monaghan)', zip: '560453' },
	{ city: 'Coolsheskin (Cork)', zip: '903258' },
	{ city: 'Coolshinagh (Cork)', zip: '461260' },
	{ city: 'Coolshingaun (Clare)', zip: '553383' },
	{ city: 'Coolsickin (Kildare)', zip: '689191' },
	{ city: 'Coolsillagh (Kilkenny)', zip: '918156' },
	{ city: 'Coolskeagh (Monaghan)', zip: '743010' },
	{ city: 'Coolskeagh (Sligo)', zip: '800311' },
	{ city: 'Coolsnaghtig (Cork)', zip: '242585' },
	{ city: 'Coolsrahra (Galway)', zip: '886833' },
	{ city: 'Coolstuff (Wexford)', zip: '733177' },
	{ city: 'Coolsuppeen (Clare)', zip: '758802' },
	{ city: 'Cooltacker (Roscommon)', zip: '956675' },
	{ city: 'Cooltederry (Laois)', zip: '290467' },
	{ city: 'Coolteen (Sligo)', zip: '425000' },
	{ city: 'Coolteen (Wexford)', zip: '778036' },
	{ city: 'Coolteengowan (Clare)', zip: '937513' },
	{ city: 'Cooltegin (Waterford)', zip: '578342' },
	{ city: 'Coolteige (Roscommon)', zip: '526265' },
	{ city: 'Coolteige (Wexford)', zip: '644371' },
	{ city: 'Coolthawn (Wexford)', zip: '133588' },
	{ city: 'Cooltomin (Limerick)', zip: '595369' },
	{ city: 'Cooltona (Roscommon)', zip: '242829' },
	{ city: 'Cooltoran (Laois)', zip: '445801' },
	{ city: 'Cooltrim (Monaghan)', zip: '591593' },
	{ city: 'Cooltrimegish (Monaghan)', zip: '794720' },
	{ city: 'Cooltrim North (Kildare)', zip: '698266' },
	{ city: 'Cooltrim South (Kildare)', zip: '564005' },
	{ city: 'Cooltubbrid East (Waterford)', zip: '473767' },
	{ city: 'Cooltubbrid West (Waterford)', zip: '982956' },
	{ city: 'Coolturk (Mayo)', zip: '763197' },
	{ city: 'Cooltycanon (Offaly)', zip: '176325' },
	{ city: 'Cooltymurraghy (Galway)', zip: '298969' },
	{ city: 'Coolum (Waterford)', zip: '197489' },
	{ city: 'Coolumber (Roscommon)', zip: '439472' },
	{ city: 'Cool Upper (Donegal)', zip: '882069' },
	{ city: 'Coolure Demesne (Westmeath)', zip: '392091' },
	{ city: 'Coolvackagh (Kerry)', zip: '538592' },
	{ city: 'Coolvallanane Beg (Cork)', zip: '296743' },
	{ city: 'Coolville (Offaly)', zip: '543757' },
	{ city: 'Coolvin (Westmeath)', zip: '622907' },
	{ city: 'Coolvoy (Donegal)', zip: '787194' },
	{ city: 'Coolvuck Lower (Westmeath)', zip: '542784' },
	{ city: 'Coolvuck Upper (Westmeath)', zip: '258505' },
	{ city: 'Cool West (Kerry)', zip: '208981' },
	{ city: 'Cool West (Limerick)', zip: '327611' },
	{ city: 'Coolwoneen (Galway)', zip: '819004' },
	{ city: 'Cooly (Donegal)', zip: '554931' },
	{ city: 'Cooly (Roscommon)', zip: '956234' },
	{ city: 'Coolybrown (Limerick)', zip: '112889' },
	{ city: 'Coolycall (Wexford)', zip: '554365' },
	{ city: 'Coolycarney (Wexford)', zip: '254714' },
	{ city: 'Coolycasey (Clare)', zip: '745958' },
	{ city: 'Coolydoody (Waterford)', zip: '399002' },
	{ city: 'Coolydoody North (Waterford)', zip: '960949' },
	{ city: 'Coolydoody South (Waterford)', zip: '841714' },
	{ city: 'Coolyduff (Cork)', zip: '718767' },
	{ city: 'Coolygagan (Offaly)', zip: '388997' },
	{ city: 'Coolygorman (Limerick)', zip: '379517' },
	{ city: 'Coolyhane (Cork)', zip: '587687' },
	{ city: 'Coolyhenan (Limerick)', zip: '758053' },
	{ city: 'Coolyhune (Carlow)', zip: '292107' },
	{ city: 'Coolykeerane (Cork)', zip: '926312' },
	{ city: 'Coolykereen (Cork)', zip: '622868' },
	{ city: 'Coolylaughnan (Mayo)', zip: '241728' },
	{ city: 'Coolymurraghue (Cork)', zip: '426488' },
	{ city: 'Coolyphullagh (Kildare)', zip: '471781' },
	{ city: 'Coolyrahilly (Cork)', zip: '438143' },
	{ city: 'Coolyregan (Cork)', zip: '799308' },
	{ city: 'Coolyroe (Limerick)', zip: '610028' },
	{ city: 'Coolyslin (Donegal)', zip: '508729' },
	{ city: 'Coom (Cork)', zip: '660212' },
	{ city: 'Coom (Kerry)', zip: '427727' },
	{ city: 'Coomacheo (Cork)', zip: '170605' },
	{ city: 'Coomacroobeg (Cork)', zip: '209771' },
	{ city: 'Coomacullen (Kerry)', zip: '754672' },
	{ city: 'Coomakeoge (Kerry)', zip: '399058' },
	{ city: 'Coomanaspig (Kerry)', zip: '654178' },
	{ city: 'Coomanore North (Cork)', zip: '361716' },
	{ city: 'Coomanore South (Cork)', zip: '807247' },
	{ city: 'Coomarkane (Cork)', zip: '312103' },
	{ city: 'Coomasaharn (Kerry)', zip: '852430' },
	{ city: 'Coomaspeara (Kerry)', zip: '333315' },
	{ city: 'Coomastow (Kerry)', zip: '516790' },
	{ city: 'Coomatallin (Cork)', zip: '888770' },
	{ city: 'Coomatloukane (Kerry)', zip: '319697' },
	{ city: 'Coomavarrodig (Cork)', zip: '746974' },
	{ city: 'Coomavoher (Kerry)', zip: '693591' },
	{ city: 'Coomavoon (Kerry)', zip: '956333' },
	{ city: 'Coombaha (Kerry)', zip: '552579' },
	{ city: 'Coombs (Limerick)', zip: '131608' },
	{ city: 'Coomcallee (Kerry)', zip: '170299' },
	{ city: 'Coomclogh (Cork)', zip: '427049' },
	{ city: 'Coomclogherane (Kerry)', zip: '384872' },
	{ city: 'Coomdeeween (Kerry)', zip: '616558' },
	{ city: 'Coomdorragha (Cork)', zip: '218792' },
	{ city: 'Coomduff (Kerry)', zip: '482169' },
	{ city: 'Coom East (Cork)', zip: '818397' },
	{ city: 'Coomfarna (Cork)', zip: '876091' },
	{ city: 'Coomgira (Cork)', zip: '705905' },
	{ city: 'Coomkeen (Cork)', zip: '701387' },
	{ city: 'Coomleagh (Kerry)', zip: '820017' },
	{ city: 'Coomleagh East (Cork)', zip: '580668' },
	{ city: 'Coomleagh West (Cork)', zip: '619792' },
	{ city: 'Coomlettra (Kerry)', zip: '790291' },
	{ city: 'Coomlibane (Cork)', zip: '967153' },
	{ city: 'Coomlogane (Cork)', zip: '178872' },
	{ city: 'Coomlumminy (Kerry)', zip: '703332' },
	{ city: 'Coomnaclohy (Cork)', zip: '371111' },
	{ city: 'Coomnafanida (Kerry)', zip: '759884' },
	{ city: 'Coomnageehy (Cork)', zip: '386521' },
	{ city: 'Coomnagire (Cork)', zip: '444251' },
	{ city: 'Coomnahincha (Kerry)', zip: '752978' },
	{ city: 'Coomnahorna East (Kerry)', zip: '481502' },
	{ city: 'Coomnahorna West (Kerry)', zip: '830144' },
	{ city: 'Coomnakilla North (Kerry)', zip: '747070' },
	{ city: 'Coomnakilla South (Kerry)', zip: '511708' },
	{ city: 'Coomroe (Cork)', zip: '182359' },
	{ city: 'Coomshanna (Kerry)', zip: '376218' },
	{ city: 'Coomura (Kerry)', zip: '140522' },
	{ city: 'Coom West (Cork)', zip: '743157' },
	{ city: 'Coomyanna (Kerry)', zip: '999191' },
	{ city: 'Coonagh (Kildare)', zip: '576390' },
	{ city: 'Coonagh East (Limerick)', zip: '575737' },
	{ city: 'Coonagh West (Limerick)', zip: '957574' },
	{ city: 'Coonane (Cork)', zip: '423940' },
	{ city: 'Coonanstown (Wicklow)', zip: '188320' },
	{ city: 'Coonbeg (Laois)', zip: '632948' },
	{ city: 'Coonealcauraun (Mayo)', zip: '208119' },
	{ city: 'Coonealmore (Mayo)', zip: '969691' },
	{ city: 'Cooneen (Tipperary)', zip: '249314' },
	{ city: 'Cooneen South (Tipperary)', zip: '498912' },
	{ city: 'Cooney (Sligo)', zip: '962430' },
	{ city: 'Coonmore (Tipperary)', zip: '130259' },
	{ city: 'Coonmore (Wicklow)', zip: '441417' },
	{ city: 'Coonoge (Wexford)', zip: '990832' },
	{ city: 'Coonogue (Carlow)', zip: '359002' },
	{ city: 'Coontraght (Kilkenny)', zip: '479603' },
	{ city: 'Cooperhill (Limerick)', zip: '241787' },
	{ city: 'Cooperhill (Sligo)', zip: '331769' },
	{ city: 'Cooperhill Demesne (Laois)', zip: '983606' },
	{ city: "Cooper's-Lot (Tipperary)", zip: '282768' },
	{ city: 'Cooperstown (Wexford)', zip: '241437' },
	{ city: 'Coor (Clare)', zip: '585026' },
	{ city: 'Cooraclare (Clare)', zip: '525399' },
	{ city: 'Cooracoosane (Kerry)', zip: '715506' },
	{ city: 'Cooracurkia (Galway)', zip: '834063' },
	{ city: 'Cooradarrigan (Cork)', zip: '609292' },
	{ city: 'Cooradowny (Cork)', zip: '299731' },
	{ city: 'Cooragannive (Cork)', zip: '829557' },
	{ city: 'Cooragreenane (Cork)', zip: '789247' },
	{ city: 'Cooragurteen (Cork)', zip: '161859' },
	{ city: 'Cooragweanish (Kerry)', zip: '441390' },
	{ city: 'Cooranig (Cork)', zip: '923664' },
	{ city: 'Coorannel (Cork)', zip: '576992' },
	{ city: 'Cooranuller (Cork)', zip: '289336' },
	{ city: 'Cooraun (Wexford)', zip: '224994' },
	{ city: 'Coorbaun (Galway)', zip: '634869' },
	{ city: 'Coorduff (Wexford)', zip: '551689' },
	{ city: 'Coor East (Clare)', zip: '392573' },
	{ city: 'Coorevin (Tipperary)', zip: '453687' },
	{ city: 'Coorlacka (Cork)', zip: '954760' },
	{ city: 'Coorlaghan (Laois)', zip: '811741' },
	{ city: 'Coorleagh (Kerry)', zip: '331936' },
	{ city: 'Coorleagh (Kilkenny)', zip: '235692' },
	{ city: 'Coorleigh North (Cork)', zip: '789331' },
	{ city: 'Coorleigh South (Cork)', zip: '556665' },
	{ city: 'Coorloum East (Cork)', zip: '196743' },
	{ city: 'Coorloum North (Cork)', zip: '967110' },
	{ city: 'Coorloum West (Cork)', zip: '521594' },
	{ city: 'Coornacaragh (Kerry)', zip: '748035' },
	{ city: 'Coornagillagh (Kerry)', zip: '180128' },
	{ city: 'Coornahahilly (Cork)', zip: '591459' },
	{ city: 'Coornameana (Kerry)', zip: '950602' },
	{ city: 'Coornariska (Laois)', zip: '370198' },
	{ city: 'Coornishal (Cork)', zip: '700543' },
	{ city: 'Coorolagh (Cork)', zip: '692332' },
	{ city: 'Coor West (Clare)', zip: '332803' },
	{ city: 'Coorycommane (Cork)', zip: '770297' },
	{ city: 'Coorycullane (Cork)', zip: '842930' },
	{ city: 'Cooryeen (Kerry)', zip: '739537' },
	{ city: 'Cooryleary (Cork)', zip: '391446' },
	{ city: 'Cooryvanaheen (Kerry)', zip: '461981' },
	{ city: 'Coosan (Westmeath)', zip: '773842' },
	{ city: 'Coosane (Cork)', zip: '274176' },
	{ city: 'Coosaun (Galway)', zip: '568731' },
	{ city: 'Coosaun (Roscommon)', zip: '843860' },
	{ city: 'Cooscroneen (Cork)', zip: '722460' },
	{ city: 'Coose (Monaghan)', zip: '933845' },
	{ city: 'Coosheen (Cork)', zip: '204929' },
	{ city: 'Cooslughoga (Mayo)', zip: '642393' },
	{ city: 'Coos North (Galway)', zip: '940057' },
	{ city: 'Coos South (Galway)', zip: '111298' },
	{ city: 'Cootehall (Roscommon)', zip: '471458' },
	{ city: 'Cootehill (Cavan)', zip: '429326' },
	{ city: 'Coothagh (Galway)', zip: '924223' },
	{ city: 'Copany (Donegal)', zip: '376859' },
	{ city: 'Copay (Limerick)', zip: '999952' },
	{ city: 'Coppanagh (Cavan)', zip: '153290' },
	{ city: 'Coppanagh (Galway)', zip: '842012' },
	{ city: 'Coppanagh (Kilkenny)', zip: '536214' },
	{ city: 'Coppanaghbane (Cavan)', zip: '983021' },
	{ city: 'Coppanagh Glebe (Cavan)', zip: '892478' },
	{ city: 'Coppanaghmore (Cavan)', zip: '685881' },
	{ city: 'Coppenagh (Carlow)', zip: '654909' },
	{ city: 'Copperalley (Cork)', zip: '608204' },
	{ city: 'Coppingerstown (Cork)', zip: '348068' },
	{ city: 'Copse (Roscommon)', zip: '941604' },
	{ city: 'Copse (Wicklow)', zip: '853499' },
	{ city: 'Copsefield (Cork)', zip: '104747' },
	{ city: 'Copsetown (Cork)', zip: '755591' },
	{ city: 'Cor (Cavan)', zip: '247352' },
	{ city: 'Cor (Donegal)', zip: '950127' },
	{ city: 'Coracow (Kerry)', zip: '689949' },
	{ city: 'Coragh (Cavan)', zip: '126106' },
	{ city: 'Coragh (Leitrim)', zip: '956050' },
	{ city: 'Coraghbrack (Monaghan)', zip: '462092' },
	{ city: 'Coragh Glebe (Cavan)', zip: '872125' },
	{ city: 'Coraghy (Monaghan)', zip: '778946' },
	{ city: 'Corah (Wexford)', zip: '358249' },
	{ city: 'Coraknock Glebe (Offaly)', zip: '343855' },
	{ city: 'Coranagh (Leitrim)', zip: '509996' },
	{ city: 'Coras Point (Cavan)', zip: '998725' },
	{ city: 'Coraughrim (Leitrim)', zip: '371595' },
	{ city: 'Corballis (Dublin)', zip: '909037' },
	{ city: 'Corballis (Kildare)', zip: '706782' },
	{ city: 'Corballis (Meath)', zip: '253748' },
	{ city: 'Corballis Lower (Wicklow)', zip: '888954' },
	{ city: 'Corballis Upper (Wicklow)', zip: '670081' },
	{ city: 'Corbally (Clare)', zip: '564822' },
	{ city: 'Corbally (Cork)', zip: '931602' },
	{ city: 'Corbally (Dublin)', zip: '684862' },
	{ city: 'Corbally (Galway)', zip: '893399' },
	{ city: 'Corbally (Kerry)', zip: '915583' },
	{ city: 'Corbally (Kildare)', zip: '356604' },
	{ city: 'Corbally (Kilkenny)', zip: '120583' },
	{ city: 'Corbally (Laois)', zip: '695889' },
	{ city: 'Corbally (Leitrim)', zip: '525650' },
	{ city: 'Corbally (Limerick)', zip: '577870' },
	{ city: 'Corbally (Mayo)', zip: '280789' },
	{ city: 'Corbally (Roscommon)', zip: '492007' },
	{ city: 'Corbally (Sligo)', zip: '414361' },
	{ city: 'Corbally (Tipperary)', zip: '616819' },
	{ city: 'Corbally (Westmeath)', zip: '870224' },
	{ city: 'Corbally (Wexford)', zip: '665173' },
	{ city: 'Corballybane (Cork)', zip: '989881' },
	{ city: 'Corbally Beg (Galway)', zip: '655681' },
	{ city: 'Corbally Beg (Waterford)', zip: '857693' },
	{ city: 'Corbally East (Roscommon)', zip: '891048' },
	{ city: 'Corbally Middle (Roscommon)', zip: '985685' },
	{ city: 'Corbally More (Galway)', zip: '176991' },
	{ city: 'Corbally More (Waterford)', zip: '535647' },
	{ city: 'Corballymore And Camgort (Galway)', zip: '632367' },
	{ city: 'Corbally North (Cork)', zip: '111048' },
	{ city: 'Corbally North (Galway)', zip: '392436' },
	{ city: 'Corballyquill (Cavan)', zip: '326403' },
	{ city: 'Corbally South (Cork)', zip: '980594' },
	{ city: 'Corbally South (Galway)', zip: '644086' },
	{ city: 'Corbally West (Roscommon)', zip: '196117' },
	{ city: 'Corbane (Monaghan)', zip: '241562' },
	{ city: 'Corbane (Offaly)', zip: '584133' },
	{ city: 'Corbaun (Galway)', zip: '608917' },
	{ city: 'Corbaun (Longford)', zip: '328512' },
	{ city: 'Corbaun (Roscommon)', zip: '218608' },
	{ city: 'Corbeagh (Cavan)', zip: '892487' },
	{ city: 'Corbeagh (Longford)', zip: '586362' },
	{ city: 'Corbeg (Leitrim)', zip: '410413' },
	{ city: 'Corbeg (Monaghan)', zip: '811902' },
	{ city: 'Corbehagh (Clare)', zip: '958631' },
	{ city: 'Corbetstown (Kilkenny)', zip: '947480' },
	{ city: 'Corbetstown (Offaly)', zip: '276489' },
	{ city: 'Corbetstown (Westmeath)', zip: '810713' },
	{ city: 'Corbetstown (Wexford)', zip: '604795' },
	{ city: 'Corblonog (Monaghan)', zip: '662113' },
	{ city: 'Corbo (Roscommon)', zip: '733840' },
	{ city: 'Corboggy (Meath)', zip: '772294' },
	{ city: 'Corboghil (Leitrim)', zip: '903699' },
	{ city: 'Corboghil (Roscommon)', zip: '377728' },
	{ city: 'Corboley (Galway)', zip: '298518' },
	{ city: 'Corboley (Roscommon)', zip: '601418' },
	{ city: 'Corbollis (Louth)', zip: '671098' },
	{ city: 'Corboy (Longford)', zip: '813914' },
	{ city: 'Corboy Glebe (Cavan)', zip: '685584' },
	{ city: 'Corbrack (Monaghan)', zip: '593270' },
	{ city: 'Corbrack (Westmeath)', zip: '267817' },
	{ city: 'Corcaghan (Monaghan)', zip: '383112' },
	{ city: 'Corcam (Donegal)', zip: '245298' },
	{ city: 'Corcamore (Limerick)', zip: '583637' },
	{ city: 'Corcanadas (Cavan)', zip: '466304' },
	{ city: 'Corcanon (Wexford)', zip: '625468' },
	{ city: 'Corcarra (Meath)', zip: '919345' },
	{ city: 'Corcas And Sandhills (Kerry)', zip: '184799' },
	{ city: 'Corcashel (Cavan)', zip: '126229' },
	{ city: 'Corcashy (Donegal)', zip: '827261' },
	{ city: 'Corcaskea (Monaghan)', zip: '500888' },
	{ city: 'Corchuill Lower (Leitrim)', zip: '443592' },
	{ city: 'Corchuill Upper (Leitrim)', zip: '973080' },
	{ city: 'Corclaragh (Longford)', zip: '160144' },
	{ city: 'Corclare (Cavan)', zip: '859265' },
	{ city: 'Corclare (Monaghan)', zip: '447628' },
	{ city: 'Corclogh (Mayo)', zip: '672544' },
	{ city: 'Corclogh (Offaly)', zip: '108437' },
	{ city: 'Corcloghan (Cavan)', zip: '855824' },
	{ city: 'Corcloon (Westmeath)', zip: '699431' },
	{ city: 'Corconnelly (Monaghan)', zip: '769277' },
	{ city: 'Corcoransacres (Sligo)', zip: '487709' },
	{ city: 'Corcoranstown (Kildare)', zip: '324793' },
	{ city: 'Corcormick (Leitrim)', zip: '212707' },
	{ city: 'Corcovety (Cavan)', zip: '548392' },
	{ city: 'Corcraff (Cavan)', zip: '412231' },
	{ city: 'Corcreeghagh (Cavan)', zip: '562627' },
	{ city: 'Corcreeghagh (Louth)', zip: '149764' },
	{ city: 'Corcreeghagh (Monaghan)', zip: '491962' },
	{ city: 'Corcreeghy (Monaghan)', zip: '740575' },
	{ city: 'Corcreggan (Donegal)', zip: '764044' },
	{ city: 'Corcrin (Monaghan)', zip: '376330' },
	{ city: 'Corcuilloge (Monaghan)', zip: '676612' },
	{ city: 'Corcullen (Galway)', zip: '930244' },
	{ city: 'Corcullin (Mayo)', zip: '682201' },
	{ city: 'Corcullion (Donegal)', zip: '588847' },
	{ city: 'Corcullioncrew (Monaghan)', zip: '454815' },
	{ city: 'Corcullionglish (Monaghan)', zip: '300214' },
	{ city: 'Corcummins (Monaghan)', zip: '835847' },
	{ city: 'Corcusconny (Leitrim)', zip: '383541' },
	{ city: 'Corcush (Offaly)', zip: '137644' },
	{ city: 'Cordal (Kerry)', zip: '606404' },
	{ city: 'Cordalea (Cavan)', zip: '776441' },
	{ city: 'Cordal East (Kerry)', zip: '762412' },
	{ city: 'Cordal West (Kerry)', zip: '755430' },
	{ city: 'Cordangan (Tipperary)', zip: '326796' },
	{ city: 'Cordarragh (Galway)', zip: '288797' },
	{ city: 'Cordarragh (Mayo)', zip: '663695' },
	{ city: 'Cordarragh North (Mayo)', zip: '766567' },
	{ city: 'Cordarragh South (Mayo)', zip: '410603' },
	{ city: 'Corderraun (Wexford)', zip: '461651' },
	{ city: 'Corderry (Donegal)', zip: '494340' },
	{ city: 'Corderry (Leitrim)', zip: '669369' },
	{ city: 'Corderry (Louth)', zip: '636367' },
	{ city: 'Corderry (Roscommon)', zip: '806770' },
	{ city: 'Corderry (Tipperary)', zip: '701829' },
	{ city: 'Corderrybane (Monaghan)', zip: '346606' },
	{ city: 'Corderryduff (Monaghan)', zip: '250541' },
	{ city: 'Corderryhugh (Roscommon)', zip: '245286' },
	{ city: 'Cordevlis (Cavan)', zip: '983498' },
	{ city: 'Cordevlis (Monaghan)', zip: '168400' },
	{ city: 'Cordevlis North (Monaghan)', zip: '768399' },
	{ city: 'Cordevlis South (Monaghan)', zip: '603098' },
	{ city: 'Cordingin (Cavan)', zip: '191353' },
	{ city: 'Cordiver (Leitrim)', zip: '977770' },
	{ city: 'Cordivin (Longford)', zip: '137115' },
	{ city: 'Cordoagh (Cavan)', zip: '675283' },
	{ city: 'Cordoagh Glebe Upper (Cavan)', zip: '295859' },
	{ city: 'Cordoagh Lower (Cavan)', zip: '249973' },
	{ city: 'Cordonaghy (Cavan)', zip: '969904' },
	{ city: 'Cordooey (Meath)', zip: '974630' },
	{ city: 'Cordoogan (Louth)', zip: '671939' },
	{ city: 'Cordoolough (Monaghan)', zip: '225545' },
	{ city: 'Cordrehid (Roscommon)', zip: '692903' },
	{ city: 'Cordressigo (Monaghan)', zip: '380932' },
	{ city: 'Cordressogagh (Cavan)', zip: '158840' },
	{ city: 'Cordroon (Mayo)', zip: '324990' },
	{ city: 'Cordrumman (Roscommon)', zip: '369338' },
	{ city: 'Cordrummans Lower (Monaghan)', zip: '696308' },
	{ city: 'Cordrummans Middle (Monaghan)', zip: '832200' },
	{ city: 'Cordrummans Upper (Monaghan)', zip: '603309' },
	{ city: 'Corduff (Cavan)', zip: '579690' },
	{ city: 'Corduff (Dublin)', zip: '476109' },
	{ city: 'Corduff (Kildare)', zip: '768938' },
	{ city: 'Corduff (Leitrim)', zip: '762688' },
	{ city: 'Corduff (Monaghan)', zip: '745967' },
	{ city: 'Corduff Common (Dublin)', zip: '930985' },
	{ city: 'Corduffhall (Dublin)', zip: '359896' },
	{ city: 'Corduffhill (Leitrim)', zip: '321298' },
	{ city: 'Corduff North (Leitrim)', zip: '502647' },
	{ city: 'Corduff South (Leitrim)', zip: '564212' },
	{ city: 'Core (Clare)', zip: '916526' },
	{ city: 'Corebeg (Clare)', zip: '668977' },
	{ city: 'Corelish East (Limerick)', zip: '342767' },
	{ city: 'Corelish West (Limerick)', zip: '474492' },
	{ city: 'Cores (Kerry)', zip: '639098' },
	{ city: 'Corfad (Cavan)', zip: '395751' },
	{ city: 'Corfad (Monaghan)', zip: '387209' },
	{ city: 'Corfeehone (Cavan)', zip: '709387' },
	{ city: 'Corfinlough (Monaghan)', zip: '133907' },
	{ city: 'Corfree (Cavan)', zip: '805321' },
	{ city: 'Corgallion (Leitrim)', zip: '670473' },
	{ city: 'Corgannive Glebe (Donegal)', zip: '530071' },
	{ city: 'Corgar (Leitrim)', zip: '611818' },
	{ city: 'Corgarran (Cavan)', zip: '764338' },
	{ city: 'Corgarriff (Mayo)', zip: '650445' },
	{ city: 'Corgarrow (Roscommon)', zip: '198933' },
	{ city: 'Corgarry (Cavan)', zip: '319661' },
	{ city: 'Corgarve (Cavan)', zip: '627940' },
	{ city: 'Corgarve (Galway)', zip: '808586' },
	{ city: 'Corgarve (Mayo)', zip: '941653' },
	{ city: 'Corgarve (Roscommon)', zip: '887078' },
	{ city: 'Corgarve (Westmeath)', zip: '343653' },
	{ city: 'Corgarve North (Offaly)', zip: '823838' },
	{ city: 'Corgarve South (Offaly)', zip: '823685' },
	{ city: 'Corgary (Donegal)', zip: '209682' },
	{ city: 'Corgerry Eighter (Galway)', zip: '838766' },
	{ city: 'Corgerry Oughter (Galway)', zip: '863102' },
	{ city: 'Corglancey (Leitrim)', zip: '203914' },
	{ city: 'Corglass (Cavan)', zip: '848604' },
	{ city: 'Corglass (Leitrim)', zip: '845575' },
	{ city: 'Corglass (Longford)', zip: '516736' },
	{ city: 'Corglass (Monaghan)', zip: '804132' },
	{ city: 'Corglass (Roscommon)', zip: '394799' },
	{ city: 'Corgloghan (Leitrim)', zip: '573956' },
	{ city: 'Corgorman (Roscommon)', zip: '798804' },
	{ city: 'Corgowan (Roscommon)', zip: '646319' },
	{ city: 'Corgreagh (Cavan)', zip: '355385' },
	{ city: 'Corgreagh (Meath)', zip: '473405' },
	{ city: 'Corgreagh (Monaghan)', zip: '496175' },
	{ city: 'Corgreenan (Monaghan)', zip: '497715' },
	{ city: 'Corgrig (Limerick)', zip: '358188' },
	{ city: 'Corgullion (Roscommon)', zip: '643647' },
	{ city: 'Corhanagh (Cavan)', zip: '640712' },
	{ city: 'Corhawnagh (Leitrim)', zip: '803699' },
	{ city: 'Corhawnagh (Mayo)', zip: '902232' },
	{ city: 'Corhawnagh (Sligo)', zip: '274458' },
	{ city: 'Corhawny (Roscommon)', zip: '634962' },
	{ city: 'Corhelshinagh (Monaghan)', zip: '273470' },
	{ city: 'Corhober (Sligo)', zip: '289756' },
	{ city: 'Corhollan (Monaghan)', zip: '568242' },
	{ city: 'Corhoogan (Cavan)', zip: '109236' },
	{ city: 'Corick (Cavan)', zip: '518466' },
	{ city: 'Corillaun (Galway)', zip: '811553' },
	{ city: 'Corimla North (Mayo)', zip: '761618' },
	{ city: 'Corimla South (Mayo)', zip: '708658' },
	{ city: 'Cork (Cork)', zip: '595076' },
	{ city: 'Corkaboy (Kerry)', zip: '623387' },
	{ city: 'Corkagh (Dublin)', zip: '578192' },
	{ city: 'Corkagh Beg (Sligo)', zip: '609316' },
	{ city: 'Corkagh Demesne (Dublin)', zip: '347651' },
	{ city: 'Corkagh More (Sligo)', zip: '134788' },
	{ city: 'Corkan (Westmeath)', zip: '658347' },
	{ city: 'Corkanaknockaun (Clare)', zip: '953497' },
	{ city: 'Corkan Isle (Donegal)', zip: '427427' },
	{ city: 'Corkashybane (Monaghan)', zip: '289062' },
	{ city: 'Corkashyduff (Monaghan)', zip: '707153' },
	{ city: 'Corkbeg (Cork)', zip: '923378' },
	{ city: 'Corkeenagh (Roscommon)', zip: '630284' },
	{ city: 'Corkeeran (Monaghan)', zip: '572357' },
	{ city: 'Corker (Galway)', zip: '971133' },
	{ city: 'Corker (Roscommon)', zip: '559030' },
	{ city: 'Corkeragh (Kildare)', zip: '140883' },
	{ city: 'Corker Beg (Donegal)', zip: '767261' },
	{ city: 'Corker More (Donegal)', zip: '246750' },
	{ city: 'Corkey (Donegal)', zip: '322567' },
	{ city: 'Cork Great (Dublin)', zip: '553465' },
	{ city: 'Corkip (Roscommon)', zip: '665353' },
	{ city: 'Corkish (Cavan)', zip: '193622' },
	{ city: 'Corkish (Monaghan)', zip: '804783' },
	{ city: 'Cork Little (Dublin)', zip: '156041' },
	{ city: 'Corknock (Monaghan)', zip: '855110' },
	{ city: 'Corlack (Clare)', zip: '796404' },
	{ city: 'Corlackan (Galway)', zip: '543289' },
	{ city: 'Corlacky (Donegal)', zip: '922406' },
	{ city: 'Corlagan (Longford)', zip: '342665' },
	{ city: 'Corlagan North (Monaghan)', zip: '506012' },
	{ city: 'Corlagan South (Monaghan)', zip: '799956' },
	{ city: 'Corlaghaloo (Cavan)', zip: '356312' },
	{ city: 'Corlaskagh (Leitrim)', zip: '248333' },
	{ city: 'Corlat (Cavan)', zip: '879950' },
	{ city: 'Corlat (Monaghan)', zip: '192054' },
	{ city: 'Corlateerin (Cavan)', zip: '461206' },
	{ city: 'Corlattallan (Monaghan)', zip: '953260' },
	{ city: 'Corlattan (Monaghan)', zip: '413729' },
	{ city: 'Corlattycarroll (Cavan)', zip: '493876' },
	{ city: 'Corlattylannan (Cavan)', zip: '174728' },
	{ city: 'Corlea (Cavan)', zip: '176266' },
	{ city: 'Corlea (Clare)', zip: '866849' },
	{ city: 'Corlea (Donegal)', zip: '987679' },
	{ city: 'Corlea (Leitrim)', zip: '869507' },
	{ city: 'Corlea (Longford)', zip: '284259' },
	{ city: 'Corlea (Monaghan)', zip: '290768' },
	{ city: 'Corlea Beg (Clare)', zip: '662624' },
	{ city: 'Corleacommons North (Clare)', zip: '784683' },
	{ city: 'Corleacommons South (Clare)', zip: '765925' },
	{ city: 'Corleadargan (Monaghan)', zip: '534877' },
	{ city: 'Corlealackagh (Monaghan)', zip: '809647' },
	{ city: 'Corlea More (Clare)', zip: '568156' },
	{ city: 'Corleanamaddy (Monaghan)', zip: '298473' },
	{ city: 'Corleck (Cavan)', zip: '208951' },
	{ city: 'Corleck (Monaghan)', zip: '718586' },
	{ city: 'Corleckagh Lower (Cavan)', zip: '372794' },
	{ city: 'Corleckagh Upper (Cavan)', zip: '865184' },
	{ city: 'Corleckduff (Cavan)', zip: '226535' },
	{ city: 'Corlee (Mayo)', zip: '976668' },
	{ city: 'Corleggy (Cavan)', zip: '771676' },
	{ city: 'Corlican (Wexford)', zip: '786618' },
	{ city: 'Corlis (Cavan)', zip: '704946' },
	{ city: 'Corlis (Roscommon)', zip: '954145' },
	{ city: 'Corlis (Westmeath)', zip: '702013' },
	{ city: 'Corlisalee (Cavan)', zip: '256297' },
	{ city: 'Corlisbane (Louth)', zip: '775878' },
	{ city: 'Corlisbannan (Cavan)', zip: '535483' },
	{ city: 'Corlisbrattan (Cavan)', zip: '866452' },
	{ city: 'Corlisheen (Leitrim)', zip: '806164' },
	{ city: 'Corlisheen (Sligo)', zip: '434486' },
	{ city: 'Corliskea (Galway)', zip: '812234' },
	{ city: 'Corlisland (Mayo)', zip: '208653' },
	{ city: 'Corlislea (Cavan)', zip: '223841' },
	{ city: 'Corlismore (Cavan)', zip: '657386' },
	{ city: 'Corlona (Leitrim)', zip: '447220' },
	{ city: 'Corlongford (Monaghan)', zip: '833494' },
	{ city: 'Corlough (Cavan)', zip: '628411' },
	{ city: 'Corlough (Leitrim)', zip: '158240' },
	{ city: 'Corloughan (Kilkenny)', zip: '981327' },
	{ city: 'Corlougharoe (Monaghan)', zip: '106587' },
	{ city: 'Corloughcahill (Leitrim)', zip: '289937' },
	{ city: 'Corloughlin (Leitrim)', zip: '780951' },
	{ city: 'Corloughtomalty (Leitrim)', zip: '322873' },
	{ city: 'Corluddy (Kilkenny)', zip: '196625' },
	{ city: 'Corlummin (Mayo)', zip: '439860' },
	{ city: 'Corlurgan (Cavan)', zip: '918217' },
	{ city: 'Corlust (Monaghan)', zip: '777510' },
	{ city: 'Corlygorm (Monaghan)', zip: '274484' },
	{ city: 'Cormackstown (Tipperary)', zip: '206439' },
	{ city: 'Cormaclew (Westmeath)', zip: '799598' },
	{ city: 'Cormacmullan (Cavan)', zip: '836043' },
	{ city: 'Cormacuagh East (Galway)', zip: '878163' },
	{ city: 'Cormacuagh West (Galway)', zip: '775518' },
	{ city: 'Cormaddyduff (Cavan)', zip: '113719' },
	{ city: 'Cormaglava (Longford)', zip: '697033' },
	{ city: 'Cormakilly (Donegal)', zip: '530738' },
	{ city: 'Cormeelick North (Galway)', zip: '173232' },
	{ city: 'Cormeelick South (Galway)', zip: '263724' },
	{ city: 'Cormeeltan (Leitrim)', zip: '425557' },
	{ city: 'Cormeen (Cavan)', zip: '164758' },
	{ city: 'Cormeen (Meath)', zip: '217647' },
	{ city: 'Cormeen (Monaghan)', zip: '952209' },
	{ city: 'Cormeen (Offaly)', zip: '411988' },
	{ city: 'Cormeen Glebe (Cavan)', zip: '879399' },
	{ city: 'Cormey (Cavan)', zip: '342650' },
	{ city: 'Cormick (Galway)', zip: '440313' },
	{ city: 'Cormickstown (Kildare)', zip: '869993' },
	{ city: 'Cormongan (Leitrim)', zip: '854829' },
	{ city: 'Cormore (Leitrim)', zip: '723604' },
	{ city: 'Cor More And Cor Beg (Offaly)', zip: '597640' },
	{ city: 'Cormoy (Monaghan)', zip: '335515' },
	{ city: 'Cormoy Lower (Monaghan)', zip: '112603' },
	{ city: 'Cormoy Upper (Monaghan)', zip: '909618' },
	{ city: 'Cormullin (Donegal)', zip: '750539' },
	{ city: 'Cormurphy (Monaghan)', zip: '156584' },
	{ city: 'Cornabanny (Roscommon)', zip: '529743' },
	{ city: 'Cornabaste (Cavan)', zip: '434888' },
	{ city: 'Cornabeagh (Cavan)', zip: '593715' },
	{ city: 'Cornabraher (Cavan)', zip: '252868' },
	{ city: 'Cornabrandy (Monaghan)', zip: '606148' },
	{ city: 'Cornabrogue (Donegal)', zip: '297687' },
	{ city: 'Cornabroher (Leitrim)', zip: '644937' },
	{ city: 'Cornabrone (Leitrim)', zip: '150067' },
	{ city: 'Cornacahan (Donegal)', zip: '208428' },
	{ city: 'Cornacarrow (Cavan)', zip: '536436' },
	{ city: 'Cornacarrow (Meath)', zip: '831560' },
	{ city: 'Cornacarrow (Monaghan)', zip: '679498' },
	{ city: 'Cornacarta (Longford)', zip: '421564' },
	{ city: 'Cornacarta (Mayo)', zip: '992348' },
	{ city: 'Cornacarta (Roscommon)', zip: '478992' },
	{ city: 'Cornacartan (Galway)', zip: '538811' },
	{ city: 'Cornacartan (Mayo)', zip: '303707' },
	{ city: 'Cornacausk (Westmeath)', zip: '291195' },
	{ city: 'Cornaclea (Cavan)', zip: '816217' },
	{ city: 'Cornacleigh (Cavan)', zip: '362776' },
	{ city: 'Cornacloy (Leitrim)', zip: '462868' },
	{ city: 'Cornacorroo (Leitrim)', zip: '402178' },
	{ city: 'Cornacoyntia (Galway)', zip: '879272' },
	{ city: 'Cornacranaghy (Leitrim)', zip: '107234' },
	{ city: 'Cornacrea (Cavan)', zip: '873719' },
	{ city: 'Cornacreegh (Leitrim)', zip: '476908' },
	{ city: 'Cornacreeve (Cavan)', zip: '337248' },
	{ city: 'Cornacreeve (Leitrim)', zip: '553115' },
	{ city: 'Cornacreeve (Monaghan)', zip: '519180' },
	{ city: 'Cornacreevy (Westmeath)', zip: '542557' },
	{ city: 'Cornacrew (Monaghan)', zip: '631197' },
	{ city: 'Cornacrum (Cavan)', zip: '205116' },
	{ city: 'Cornacullew (Longford)', zip: '889155' },
	{ city: 'Cornadarragh (Cavan)', zip: '436476' },
	{ city: 'Cornadimpan Glebe (Cavan)', zip: '373497' },
	{ city: 'Cornadowagh (Longford)', zip: '756175' },
	{ city: 'Cornadrum (Galway)', zip: '108736' },
	{ city: 'Cornadrung (Longford)', zip: '970803' },
	{ city: 'Cornafaghy (Monaghan)', zip: '730574' },
	{ city: 'Cornafean (Cavan)', zip: '645873' },
	{ city: 'Cornaferst (Leitrim)', zip: '915217' },
	{ city: 'Cornafostra (Leitrim)', zip: '482254' },
	{ city: 'Cornafulla (Roscommon)', zip: '817530' },
	{ city: 'Cornafunshin (Longford)', zip: '265308' },
	{ city: 'Cornafurrish And Corrabeg (Offaly)', zip: '201142' },
	{ city: 'Cornagall (Cavan)', zip: '572110' },
	{ city: 'Cornagall (Monaghan)', zip: '837428' },
	{ city: 'Cornagark (Offaly)', zip: '595404' },
	{ city: 'Cornagarrow (Cavan)', zip: '290755' },
	{ city: 'Cornagarvoge (Monaghan)', zip: '763555' },
	{ city: 'Cornagashlaun (Mayo)', zip: '988012' },
	{ city: 'Cornagawna (Leitrim)', zip: '693585' },
	{ city: 'Cornageaghta (Mayo)', zip: '557865' },
	{ city: 'Cornagee (Cavan)', zip: '256250' },
	{ city: 'Cornagee (Roscommon)', zip: '706409' },
	{ city: 'Cornageeha (Leitrim)', zip: '337854' },
	{ city: 'Cornageeha (Mayo)', zip: '857603' },
	{ city: 'Cornageeha (Roscommon)', zip: '809760' },
	{ city: 'Cornageeha (Sligo)', zip: '396911' },
	{ city: 'Cornageeragh (Leitrim)', zip: '883317' },
	{ city: 'Cornagher (Leitrim)', zip: '926705' },
	{ city: 'Cornaghy (Leitrim)', zip: '532132' },
	{ city: 'Cornagill (Donegal)', zip: '603989' },
	{ city: 'Cornagillagh (Donegal)', zip: '212336' },
	{ city: 'Cornagillagh (Leitrim)', zip: '415460' },
	{ city: 'Cornagilty (Monaghan)', zip: '385383' },
	{ city: 'Cornaglah (Leitrim)', zip: '537172' },
	{ city: 'Cornaglare (Cavan)', zip: '177855' },
	{ city: 'Cornaglare (Monaghan)', zip: '561498' },
	{ city: 'Cornaglea Lower (Cavan)', zip: '298834' },
	{ city: 'Cornaglea Upper (Cavan)', zip: '247139' },
	{ city: 'Cornagleragh (Cavan)', zip: '574555' },
	{ city: 'Cornaglia (Roscommon)', zip: '412088' },
	{ city: 'Cornagon (Leitrim)', zip: '355007' },
	{ city: 'Cornagower East (Wicklow)', zip: '126564' },
	{ city: 'Cornagower West (Wicklow)', zip: '791028' },
	{ city: 'Cornagran (Cavan)', zip: '513520' },
	{ city: 'Cornagrea (Roscommon)', zip: '861298' },
	{ city: 'Cornagresha North (Leitrim)', zip: '803502' },
	{ city: 'Cornagresha South (Leitrim)', zip: '760877' },
	{ city: 'Cornagrillagh (Donegal)', zip: '793245' },
	{ city: 'Cornagrow (Cavan)', zip: '502641' },
	{ city: 'Cornaguillagh (Leitrim)', zip: '567799' },
	{ city: 'Cornaguillagh (Longford)', zip: '989448' },
	{ city: 'Cornaguillagh (Monaghan)', zip: '785519' },
	{ city: 'Cornagullion (Donegal)', zip: '364350' },
	{ city: 'Cornagunleog (Cavan)', zip: '761153' },
	{ city: 'Cornahaia (Cavan)', zip: '105557' },
	{ city: 'Cornahavoley (Mayo)', zip: '113504' },
	{ city: 'Cornahaw (Cavan)', zip: '204364' },
	{ city: 'Cornahawla (Monaghan)', zip: '765540' },
	{ city: 'Cornaheive (Monaghan)', zip: '854830' },
	{ city: 'Cornaher (Westmeath)', zip: '848897' },
	{ city: 'Cornahilt (Cavan)', zip: '414483' },
	{ city: 'Cornahinch (Cork)', zip: '586764' },
	{ city: 'Cornahoe (Monaghan)', zip: '801129' },
	{ city: 'Cornahoe Lower (Monaghan)', zip: '778834' },
	{ city: 'Cornahoe Upper (Monaghan)', zip: '547244' },
	{ city: 'Cornahoo (Longford)', zip: '504398' },
	{ city: 'Cornahoova (Meath)', zip: '714292' },
	{ city: 'Cornakill (Cavan)', zip: '882021' },
	{ city: 'Cornakilly (Cavan)', zip: '483432' },
	{ city: 'Cornalack (Tipperary)', zip: '300346' },
	{ city: 'Cornalaghta (Leitrim)', zip: '461134' },
	{ city: 'Cornalara (Cavan)', zip: '699618' },
	{ city: 'Cornalaragh (Monaghan)', zip: '494015' },
	{ city: 'Cornalassan (Mayo)', zip: '124622' },
	{ city: 'Cornalaur (Offaly)', zip: '565304' },
	{ city: 'Cornaleck (Cavan)', zip: '191722' },
	{ city: 'Cornaleck (Leitrim)', zip: '252839' },
	{ city: 'Cornalee (Roscommon)', zip: '386973' },
	{ city: 'Cornaleen (Cavan)', zip: '986679' },
	{ city: 'Cornalon (Cavan)', zip: '156045' },
	{ city: 'Cornalough (Monaghan)', zip: '676730' },
	{ city: 'Cornamaddy (Roscommon)', zip: '363488' },
	{ city: 'Cornamaddy (Westmeath)', zip: '803707' },
	{ city: 'Cornamagh (Cavan)', zip: '597771' },
	{ city: 'Cornamagh (Westmeath)', zip: '501200' },
	{ city: 'Cornamahan (Cavan)', zip: '476089' },
	{ city: 'Cornaman (Cavan)', zip: '834677' },
	{ city: 'Cornaman (Leitrim)', zip: '262057' },
	{ city: 'Cornamarrow (Mayo)', zip: '130353' },
	{ city: 'Cornamart (Roscommon)', zip: '904115' },
	{ city: 'Cornamarve (Leitrim)', zip: '808376' },
	{ city: 'Cornameelta (Roscommon)', zip: '463959' },
	{ city: 'Cornaminaun (Galway)', zip: '500059' },
	{ city: 'Cornamona (Galway)', zip: '282591' },
	{ city: 'Cornamona (Offaly)', zip: '293380' },
	{ city: 'Cornamonaster (Mayo)', zip: '819593' },
	{ city: 'Cornamucklagh (Cavan)', zip: '576149' },
	{ city: 'Cornamucklagh (Galway)', zip: '658406' },
	{ city: 'Cornamucklagh (Kildare)', zip: '162101' },
	{ city: 'Cornamucklagh (Leitrim)', zip: '768229' },
	{ city: 'Cornamucklagh (Longford)', zip: '922553' },
	{ city: 'Cornamucklagh (Louth)', zip: '640787' },
	{ city: 'Cornamucklagh (Roscommon)', zip: '653489' },
	{ city: 'Cornamucklagh (Sligo)', zip: '964280' },
	{ city: 'Cornamucklagh And Falmore (Roscommon)', zip: '173750' },
	{ city: 'Cornamucklagh North (Leitrim)', zip: '945269' },
	{ city: 'Cornamucklagh North (Monaghan)', zip: '759388' },
	{ city: 'Cornamucklagh South (Leitrim)', zip: '981070' },
	{ city: 'Cornamucklagh South (Monaghan)', zip: '405033' },
	{ city: 'Cornamucklaglass (Monaghan)', zip: '762451' },
	{ city: 'Cornamuddagh (Leitrim)', zip: '982176' },
	{ city: 'Cornamult (Tipperary)', zip: '350894' },
	{ city: 'Cornamunady (Monaghan)', zip: '578442' },
	{ city: 'Cornanaff (Cavan)', zip: '208262' },
	{ city: 'Cornanaff (Galway)', zip: '163085' },
	{ city: 'Cornanaff (Mayo)', zip: '400496' },
	{ city: 'Cornanagh (Mayo)', zip: '851701' },
	{ city: 'Cornanagh (Monaghan)', zip: '432419' },
	{ city: 'Cornananta Beg (Galway)', zip: '774060' },
	{ city: 'Cornananta More (Galway)', zip: '648467' },
	{ city: 'Cornaneane (Leitrim)', zip: '296160' },
	{ city: 'Cornan East (Wicklow)', zip: '498294' },
	{ city: 'Cornanerriff (Monaghan)', zip: '720517' },
	{ city: 'Cornanool (Mayo)', zip: '521633' },
	{ city: 'Cornanure (Monaghan)', zip: '137539' },
	{ city: 'Cornanurney (Cavan)', zip: '127428' },
	{ city: 'Cornan West (Wicklow)', zip: '863017' },
	{ city: 'Cornapallis (Roscommon)', zip: '576937' },
	{ city: 'Cornapark (Longford)', zip: '430711' },
	{ city: 'Cornapaste (Monaghan)', zip: '157653' },
	{ city: 'Cornarona (Galway)', zip: '582006' },
	{ city: 'Cornaroy (Leitrim)', zip: '825359' },
	{ city: 'Cornaroya (Mayo)', zip: '912358' },
	{ city: 'Cornasassonagh (Monaghan)', zip: '706014' },
	{ city: 'Cornasaus (Cavan)', zip: '452418' },
	{ city: 'Cornasaus (Meath)', zip: '915194' },
	{ city: 'Cornaseer (Cavan)', zip: '251954' },
	{ city: 'Cornaseer (Roscommon)', zip: '268746' },
	{ city: 'Cornashamsoge (Leitrim)', zip: '952633' },
	{ city: 'Cornashesk (Cavan)', zip: '177637' },
	{ city: 'Cornashinnagh (Roscommon)', zip: '577832' },
	{ city: 'Cornasker (Cavan)', zip: '631027' },
	{ city: 'Cornasleehan (Roscommon)', zip: '109359' },
	{ city: 'Cornasleeve (Monaghan)', zip: '532779' },
	{ city: 'Cornaslieve (Cavan)', zip: '529346' },
	{ city: 'Cornaslieve (Leitrim)', zip: '617812' },
	{ city: 'Cornasoo (Monaghan)', zip: '565452' },
	{ city: 'Cornastauk (Leitrim)', zip: '967848' },
	{ city: 'Cornavad (Leitrim)', zip: '419074' },
	{ city: 'Cornavannoge (Leitrim)', zip: '992240' },
	{ city: 'Cornaveagh (Cavan)', zip: '625217' },
	{ city: 'Cornaveagh (Donegal)', zip: '173665' },
	{ city: 'Cornaveagh (Mayo)', zip: '706254' },
	{ city: 'Cornaveagh (Roscommon)', zip: '841282' },
	{ city: 'Cornaveigh (Cork)', zip: '756752' },
	{ city: 'Cornaville North (Meath)', zip: '170370' },
	{ city: 'Cornaville South (Meath)', zip: '518195' },
	{ city: 'Cornawall (Monaghan)', zip: '312705' },
	{ city: 'Corncamble (Donegal)', zip: '823190' },
	{ city: 'Corndarragh (Offaly)', zip: '801459' },
	{ city: 'Corndog (Wicklow)', zip: '923429' },
	{ city: 'Cornecassa Demesne (Monaghan)', zip: '944486' },
	{ city: 'Corneddan (Longford)', zip: '551730' },
	{ city: 'Cornee (Leitrim)', zip: '626705' },
	{ city: 'Corneen (Cavan)', zip: '384770' },
	{ city: 'Corneenflynn (Cavan)', zip: '231495' },
	{ city: 'Cornelscourt (Dublin)', zip: '984792' },
	{ city: 'Cornelscourt (Kildare)', zip: '545020' },
	{ city: 'Cornelstown (Meath)', zip: '353128' },
	{ city: 'Cornerpark (Dublin)', zip: '322137' },
	{ city: 'Cornerstown (Wexford)', zip: '558286' },
	{ city: 'Cornery (Cork)', zip: '186015' },
	{ city: 'Corness (Monaghan)', zip: '673692' },
	{ city: 'Cornfield (Clare)', zip: '997979' },
	{ city: 'Cornfield (Mayo)', zip: '714842' },
	{ city: 'Cornhill (Cork)', zip: '199257' },
	{ city: 'Cornhill (Tipperary)', zip: '349627' },
	{ city: 'Cornode (Tipperary)', zip: '432084' },
	{ city: 'Cornollen (Longford)', zip: '457234' },
	{ city: 'Cornstown (Dublin)', zip: '724927' },
	{ city: 'Cornulla (Leitrim)', zip: '891377' },
	{ city: 'Cornwall (Wexford)', zip: '857641' },
	{ city: 'Cornyeal (Kilkenny)', zip: '556686' },
	{ city: 'Coronea (Cork)', zip: '481500' },
	{ city: 'Corporation (Donegal)', zip: '579493' },
	{ city: 'Corporationland (Meath)', zip: '270020' },
	{ city: 'Corporation Land (Wicklow)', zip: '587976' },
	{ city: 'Corporation Land 1st Division (Laois)', zip: '251750' },
	{ city: 'Corporation Land 2nd Division (Laois)', zip: '676710' },
	{ city: 'Corporation Land 3rd Division (Laois)', zip: '616366' },
	{ city: 'Corporationland North (Meath)', zip: '968454' },
	{ city: 'Corporation Lands (Cavan)', zip: '678981' },
	{ city: 'Corporation Lands (Wicklow)', zip: '217861' },
	{ city: 'Corporation Murragh (Wicklow)', zip: '789125' },
	{ city: 'Corr (Cavan)', zip: '860013' },
	{ city: 'Corr (Galway)', zip: '628666' },
	{ city: 'Corr (Westmeath)', zip: '368032' },
	{ city: 'Corraback (Cavan)', zip: '806817' },
	{ city: 'Corrabally (Cork)', zip: '219973' },
	{ city: 'Corrabarrack (Leitrim)', zip: '858931' },
	{ city: 'Corrabaun (Galway)', zip: '419052' },
	{ city: 'Corrabaun (Longford)', zip: '996906' },
	{ city: 'Corrabaun (Mayo)', zip: '586501' },
	{ city: 'Corrabaun (Roscommon)', zip: '498500' },
	{ city: 'Corrabeagh (Leitrim)', zip: '293884' },
	{ city: 'Corrabeegher (Leitrim)', zip: '946539' },
	{ city: 'Corrabeg (Roscommon)', zip: '924889' },
	{ city: 'Corra Beg (Roscommon)', zip: '807258' },
	{ city: 'Corrabella (Tipperary)', zip: '348719' },
	{ city: 'Corrabofin (Monaghan)', zip: '138634' },
	{ city: 'Corrabola (Longford)', zip: '265477' },
	{ city: 'Corrabul (Limerick)', zip: '512119' },
	{ city: 'Corrabulbeg (Limerick)', zip: '953012' },
	{ city: 'Corracaboon (Leitrim)', zip: '899254' },
	{ city: 'Corracanvy (Cavan)', zip: '612018' },
	{ city: 'Corracar (Leitrim)', zip: '160767' },
	{ city: 'Corracarrow (Cavan)', zip: '921263' },
	{ city: 'Corracharra (Monaghan)', zip: '991876' },
	{ city: 'Corrachole (Leitrim)', zip: '723113' },
	{ city: 'Corracholia Beg (Cavan)', zip: '403464' },
	{ city: 'Corracholia More (Cavan)', zip: '526967' },
	{ city: 'Corrachomera (Cavan)', zip: '173067' },
	{ city: 'Corrachoosaun (Leitrim)', zip: '684248' },
	{ city: 'Corrachuill (Leitrim)', zip: '584691' },
	{ city: 'Corrachulter (Monaghan)', zip: '811231' },
	{ city: 'Corrackan (Monaghan)', zip: '607389' },
	{ city: 'Corraclassy (Cavan)', zip: '191942' },
	{ city: 'Corracleigh (Cavan)', zip: '878749' },
	{ city: 'Corraclevin (Offaly)', zip: '526856' },
	{ city: 'Corraclogh (Roscommon)', zip: '902616' },
	{ city: 'Corracloghan (Monaghan)', zip: '391982' },
	{ city: 'Corracloon (Clare)', zip: '176175' },
	{ city: 'Corracloona (Leitrim)', zip: '644177' },
	{ city: 'Corracloon Beg (Clare)', zip: '229703' },
	{ city: 'Corracloon More (Clare)', zip: '375544' },
	{ city: 'Corracoggil North (Roscommon)', zip: '540372' },
	{ city: 'Corracoggil South (Roscommon)', zip: '154472' },
	{ city: 'Corracommeen (Roscommon)', zip: '367996' },
	{ city: 'Corracoolia (Galway)', zip: '794127' },
	{ city: 'Corracramph (Donegal)', zip: '805900' },
	{ city: 'Corracramph North (Leitrim)', zip: '704024' },
	{ city: 'Corracramph South (Leitrim)', zip: '706731' },
	{ city: 'Corracreeny (Cavan)', zip: '191276' },
	{ city: 'Corracreeny (Leitrim)', zip: '258714' },
	{ city: 'Corracreigh (Roscommon)', zip: '714489' },
	{ city: 'Corracrin (Monaghan)', zip: '793010' },
	{ city: 'Corracrow (Mayo)', zip: '332994' },
	{ city: 'Corracullin (Galway)', zip: '550062' },
	{ city: 'Corracullin (Offaly)', zip: '309799' },
	{ city: 'Corracunna (Cork)', zip: '907107' },
	{ city: 'Corradarren (Cavan)', zip: '252197' },
	{ city: 'Corradeverrid (Cavan)', zip: '254272' },
	{ city: 'Corradoo (Sligo)', zip: '643892' },
	{ city: 'Corradooa (Cavan)', zip: '130956' },
	{ city: 'Corradoo East (Sligo)', zip: '873012' },
	{ city: 'Corradooey (Donegal)', zip: '275442' },
	{ city: 'Corradooey (Longford)', zip: '736224' },
	{ city: 'Corradoon (Waterford)', zip: '569685' },
	{ city: 'Corradoo West (Sligo)', zip: '730124' },
	{ city: 'Corradoran (Louth)', zip: '945279' },
	{ city: 'Corradownan (Cavan)', zip: '635432' },
	{ city: 'Corradrehid (Roscommon)', zip: '104780' },
	{ city: 'Corradrish (Mayo)', zip: '922794' },
	{ city: 'Corradrishy (Mayo)', zip: '972600' },
	{ city: 'Corraduff (Tipperary)', zip: '176636' },
	{ city: 'Corrafaireen (Galway)', zip: '322807' },
	{ city: 'Corraffrin (Donegal)', zip: '899438' },
	{ city: 'Corragarrow (Longford)', zip: '411772' },
	{ city: 'Corragarry (Cavan)', zip: '609374' },
	{ city: 'Corragarry (Monaghan)', zip: '966964' },
	{ city: 'Corragarta (Monaghan)', zip: '144397' },
	{ city: 'Corragarve (Roscommon)', zip: '692223' },
	{ city: 'Corragaun (Kilkenny)', zip: '555069' },
	{ city: 'Corragaun (Mayo)', zip: '613835' },
	{ city: 'Corrageen (Dublin)', zip: '356343' },
	{ city: 'Corrageen (Wexford)', zip: '664367' },
	{ city: 'Corragh (Monaghan)', zip: '861605' },
	{ city: 'Corragh (Wexford)', zip: '542464' },
	{ city: 'Corragh (Wicklow)', zip: '506141' },
	{ city: 'Corraghbrack (Monaghan)', zip: '606268' },
	{ city: 'Corraghdown (Monaghan)', zip: '461606' },
	{ city: 'Corraghduff (Monaghan)', zip: '170793' },
	{ city: 'Corragho (Cavan)', zip: '753993' },
	{ city: 'Corraghy (Cavan)', zip: '492559' },
	{ city: 'Corragina (Waterford)', zip: '319997' },
	{ city: 'Corragloon (Cavan)', zip: '565161' },
	{ city: 'Corragoly (Leitrim)', zip: '956627' },
	{ city: 'Corragooly (Mayo)', zip: '506765' },
	{ city: 'Corragore (Monaghan)', zip: '579559' },
	{ city: 'Corrahoash (Cavan)', zip: '126371' },
	{ city: 'Corrahoor (Mayo)', zip: '354098' },
	{ city: 'Corraige (Clare)', zip: '754351' },
	{ city: 'Corraine (Donegal)', zip: '856460' },
	{ city: 'Corrakane (Cavan)', zip: '281494' },
	{ city: 'Corrakeeldrum (Cavan)', zip: '604336' },
	{ city: 'Corrakeen (Monaghan)', zip: '416351' },
	{ city: 'Corrakeeran (Cavan)', zip: '724396' },
	{ city: 'Corrakeeran (Meath)', zip: '189987' },
	{ city: 'Corrakit (Louth)', zip: '411335' },
	{ city: 'Corrakyle (Clare)', zip: '342974' },
	{ city: 'Corrala (Leitrim)', zip: '670966' },
	{ city: 'Corralahan (Leitrim)', zip: '348346' },
	{ city: 'Corralanna (Westmeath)', zip: '746940' },
	{ city: 'Corralara (Roscommon)', zip: '563909' },
	{ city: 'Corralea (Galway)', zip: '434758' },
	{ city: 'Corralea (Roscommon)', zip: '958513' },
	{ city: 'Corralea West (Galway)', zip: '100902' },
	{ city: 'Corraleehan (Leitrim)', zip: '459434' },
	{ city: 'Corraleehanbeg (Cavan)', zip: '330154' },
	{ city: 'Corralena (Westmeath)', zip: '114582' },
	{ city: 'Corraleskin (Leitrim)', zip: '677163' },
	{ city: 'Corralough (Galway)', zip: '755469' },
	{ city: 'Corralough (Longford)', zip: '301338' },
	{ city: 'Corralough (Tipperary)', zip: '322975' },
	{ city: 'Corralough South (Galway)', zip: '966077' },
	{ city: 'Corralustia (Leitrim)', zip: '494063' },
	{ city: 'Corramacorra (Wexford)', zip: '898619' },
	{ city: 'Corramaeeagh (Galway)', zip: '138778' },
	{ city: 'Corramagrine (Roscommon)', zip: '207879' },
	{ city: 'Corramahan (Leitrim)', zip: '407244' },
	{ city: 'Corramartin (Leitrim)', zip: '550280' },
	{ city: 'Corramegan (Monaghan)', zip: '976102' },
	{ city: 'Corramore (Roscommon)', zip: '974311' },
	{ city: 'Corran (Cavan)', zip: '217282' },
	{ city: 'Corran (Cork)', zip: '467474' },
	{ city: 'Corranagh (Donegal)', zip: '179418' },
	{ city: 'Corrananagh (Meath)', zip: '186895' },
	{ city: 'Corran Beg (Cork)', zip: '766914' },
	{ city: 'Corrandoo (Galway)', zip: '666075' },
	{ city: 'Corrandrum (Galway)', zip: '809532' },
	{ city: 'Corrandulla (Galway)', zip: '688209' },
	{ city: 'Corranea Glebe (Cavan)', zip: '641295' },
	{ city: 'Corranearty (Cavan)', zip: '683458' },
	{ city: 'Corraneary (Cavan)', zip: '611745' },
	{ city: 'Corraneary (Leitrim)', zip: '154989' },
	{ city: 'Corraneden (Cavan)', zip: '352534' },
	{ city: 'Corraneena (Galway)', zip: '877326' },
	{ city: 'Corranellistrum (Galway)', zip: '973244' },
	{ city: 'Corraness Glebe (Donegal)', zip: '277975' },
	{ city: 'Corranewy (Monaghan)', zip: '411073' },
	{ city: 'Corranierna (Cavan)', zip: '857102' },
	{ city: 'Corran Middle (Cork)', zip: '630297' },
	{ city: 'Corran More (Cork)', zip: '741824' },
	{ city: 'Corrannaskeha (Waterford)', zip: '167495' },
	{ city: 'Corrannaskeha North (Waterford)', zip: '348162' },
	{ city: 'Corrannaskeha South (Waterford)', zip: '494895' },
	{ city: 'Corran North (Cork)', zip: '140888' },
	{ city: 'Corranroo (Clare)', zip: '420561' },
	{ city: 'Corran South (Cork)', zip: '304759' },
	{ city: 'Corrantarramud (Galway)', zip: '570965' },
	{ city: 'Corrantotan (Roscommon)', zip: '380729' },
	{ city: 'Corranure (Cavan)', zip: '461044' },
	{ city: 'Corraphort (Leitrim)', zip: '487100' },
	{ city: 'Corraquigley (Cavan)', zip: '570861' },
	{ city: 'Corraquill (Cavan)', zip: '776186' },
	{ city: 'Corraquill (Tipperary)', zip: '514263' },
	{ city: 'Corrard (Cavan)', zip: '557489' },
	{ city: 'Corraree And Ballygatta (Roscommon)', zip: '914534' },
	{ city: 'Corrarod (Cavan)', zip: '860525' },
	{ city: 'Corrascoffy (Leitrim)', zip: '359297' },
	{ city: 'Corrasillagh (Wicklow)', zip: '697377' },
	{ city: 'Corraskea (Monaghan)', zip: '118683' },
	{ city: 'Corraskealy (Monaghan)', zip: '662169' },
	{ city: 'Corraslira (Roscommon)', zip: '189253' },
	{ city: 'Corrasluastia (Roscommon)', zip: '698776' },
	{ city: 'Corrasmaghooil (Leitrim)', zip: '236601' },
	{ city: 'Corrasmongan (Cavan)', zip: '620923' },
	{ city: 'Corrasra (Leitrim)', zip: '447650' },
	{ city: 'Corrastoona Beg (Roscommon)', zip: '631550' },
	{ city: 'Corrastoona More (Roscommon)', zip: '924489' },
	{ city: 'Corrataghart (Monaghan)', zip: '987318' },
	{ city: 'Corratanty (Monaghan)', zip: '387385' },
	{ city: 'Corratanvally (Mayo)', zip: '843322' },
	{ city: 'Corratawy (Cavan)', zip: '646298' },
	{ city: 'Corratawy (Leitrim)', zip: '264727' },
	{ city: 'Corrateean (Monaghan)', zip: '612447' },
	{ city: 'Corrateemore (Monaghan)', zip: '562117' },
	{ city: 'Corraterriff North (Leitrim)', zip: '486809' },
	{ city: 'Corraterriff South (Leitrim)', zip: '721656' },
	{ city: 'Corratillan (Cavan)', zip: '418073' },
	{ city: 'Corratimore Glebe (Leitrim)', zip: '969787' },
	{ city: 'Corratinner (Cavan)', zip: '573703' },
	{ city: 'Corratirrim (Cavan)', zip: '732903' },
	{ city: 'Corratober (Cavan)', zip: '295017' },
	{ city: 'Corratober (Meath)', zip: '990851' },
	{ city: 'Corratober Lower (Cavan)', zip: '279158' },
	{ city: 'Corratober Upper (Cavan)', zip: '586838' },
	{ city: 'Corratowick (Mayo)', zip: '802797' },
	{ city: 'Corratrasna (Monaghan)', zip: '940678' },
	{ city: 'Corratrench (Roscommon)', zip: '154714' },
	{ city: 'Corraun (Laois)', zip: '187126' },
	{ city: 'Corraun (Mayo)', zip: '367308' },
	{ city: 'Corraun (Roscommon)', zip: '784807' },
	{ city: 'Corraunboy (Mayo)', zip: '493620' },
	{ city: 'Corravacan (Monaghan)', zip: '585817' },
	{ city: 'Corravaddy (Donegal)', zip: '742009' },
	{ city: 'Corravahan (Cavan)', zip: '429948' },
	{ city: 'Corravally (Tipperary)', zip: '607615' },
	{ city: 'Corravarry (Cavan)', zip: '975476' },
	{ city: 'Corraveaty (Cavan)', zip: '745881' },
	{ city: 'Corraveggaun East (Mayo)', zip: '761412' },
	{ city: 'Corraveggaun West (Mayo)', zip: '501494' },
	{ city: 'Corravilla (Cavan)', zip: '315536' },
	{ city: 'Corravilla (Monaghan)', zip: '357996' },
	{ city: 'Corraviller (Monaghan)', zip: '597578' },
	{ city: 'Corravoggy (Cavan)', zip: '225723' },
	{ city: 'Corravogy (Cavan)', zip: '822499' },
	{ city: 'Corravohy (Cavan)', zip: '174847' },
	{ city: 'Corravokeen (Mayo)', zip: '729827' },
	{ city: 'Corravoley (Cork)', zip: '310600' },
	{ city: 'Corravoo (Monaghan)', zip: '434674' },
	{ city: 'Corravreeda East (Cork)', zip: '224029' },
	{ city: 'Corravreeda West (Cork)', zip: '586320' },
	{ city: 'Corrawaddy (Cavan)', zip: '132189' },
	{ city: 'Corrawaleen (Leitrim)', zip: '679092' },
	{ city: 'Corraweehil Glebe (Leitrim)', zip: '577912' },
	{ city: 'Corraweelis (Cavan)', zip: '428528' },
	{ city: 'Corrawillin (Cavan)', zip: '155431' },
	{ city: 'Corrawillin (Monaghan)', zip: '653953' },
	{ city: 'Corray (Sligo)', zip: '945555' },
	{ city: 'Correagh (Roscommon)', zip: '215147' },
	{ city: 'Correagh (Sligo)', zip: '590476' },
	{ city: 'Correagh (Westmeath)', zip: '313746' },
	{ city: 'Correagh Glebe (Cavan)', zip: '941227' },
	{ city: 'Correal (Roscommon)', zip: '813542' },
	{ city: 'Correaly (Westmeath)', zip: '560764' },
	{ city: 'Correel (Laois)', zip: '514641' },
	{ city: 'Correen (Leitrim)', zip: '171603' },
	{ city: 'Correen (Roscommon)', zip: '327485' },
	{ city: 'Correenbeg (Roscommon)', zip: '443042' },
	{ city: 'Correenfeeradda (Limerick)', zip: '270989' },
	{ city: 'Correens (Mayo)', zip: '401841' },
	{ city: 'Correish (Leitrim)', zip: '260086' },
	{ city: 'Correllstown (Westmeath)', zip: '677828' },
	{ city: 'Correvan (Cavan)', zip: '207883' },
	{ city: 'Correvan (Monaghan)', zip: '548801' },
	{ city: 'Corries (Carlow)', zip: '708497' },
	{ city: 'Corries Cross (Carlow)', zip: '388531' },
	{ city: 'Corriga (Leitrim)', zip: '445509' },
	{ city: 'Corriga (Tipperary)', zip: '351994' },
	{ city: 'Corrigeen (Laois)', zip: '942032' },
	{ city: 'Corrin (Cork)', zip: '835828' },
	{ city: 'Corrinagh (Longford)', zip: '844035' },
	{ city: 'Corrinary (Monaghan)', zip: '371474' },
	{ city: 'Corrinenty (Monaghan)', zip: '429938' },
	{ city: 'Corrinshigagh (Monaghan)', zip: '411935' },
	{ city: 'Corrinshigo (Cavan)', zip: '766393' },
	{ city: 'Corrinshigo (Monaghan)', zip: '587003' },
	{ city: 'Corrintra (Monaghan)', zip: '240013' },
	{ city: 'Corrofin (Clare)', zip: '391844' },
	{ city: 'Corrofin (Galway)', zip: '385359' },
	{ city: 'Corrogebeg (Tipperary)', zip: '770627' },
	{ city: 'Corrogemore (Tipperary)', zip: '559192' },
	{ city: 'Corronagh (Cavan)', zip: '462598' },
	{ city: 'Corrool (Longford)', zip: '896640' },
	{ city: 'Corrower (Mayo)', zip: '312635' },
	{ city: 'Corrowle (Tipperary)', zip: '930322' },
	{ city: 'Corroy (Mayo)', zip: '749964' },
	{ city: 'Corroy (Roscommon)', zip: '758396' },
	{ city: 'Corrspark (Galway)', zip: '681576' },
	{ city: 'Corrstown (Dublin)', zip: '569448' },
	{ city: 'Corrudda (Leitrim)', zip: '760615' },
	{ city: 'Corruragh (Cork)', zip: '779149' },
	{ city: 'Corry (Donegal)', zip: '710940' },
	{ city: 'Corry (Galway)', zip: '879314' },
	{ city: 'Corry (Leitrim)', zip: '239384' },
	{ city: 'Corry (Longford)', zip: '792947' },
	{ city: 'Corry (Monaghan)', zip: '135362' },
	{ city: 'Corry (Roscommon)', zip: '396066' },
	{ city: 'Corry (Westmeath)', zip: '643123' },
	{ city: 'Corryagan (Monaghan)', zip: '255357' },
	{ city: 'Corryarbeg (Monaghan)', zip: '741627' },
	{ city: 'Corryard (Leitrim)', zip: '276075' },
	{ city: 'Corryaughany (Mayo)', zip: '308533' },
	{ city: 'Corrybrackan (Monaghan)', zip: '606682' },
	{ city: 'Corrybrannan (Monaghan)', zip: '740011' },
	{ city: 'Corrycholman (Cavan)', zip: '970546' },
	{ city: 'Corrycorka (Longford)', zip: '934305' },
	{ city: 'Corrycullen (Leitrim)', zip: '288744' },
	{ city: 'Corrydavit (Mayo)', zip: '485002' },
	{ city: 'Corrydonnellan (Westmeath)', zip: '810160' },
	{ city: 'Corry East (Roscommon)', zip: '700513' },
	{ city: 'Corryena (Longford)', zip: '866885' },
	{ city: 'Corryhagan (Monaghan)', zip: '729679' },
	{ city: 'Corryloan (Monaghan)', zip: '499656' },
	{ city: 'Corrymailley (Mayo)', zip: '530375' },
	{ city: 'Corryolus (Leitrim)', zip: '799141' },
	{ city: 'Corryrourke (Cavan)', zip: '437323' },
	{ city: 'Corry West (Roscommon)', zip: '108726' },
	{ city: 'Corsallagh (Sligo)', zip: '497943' },
	{ city: 'Corsillagh (Wicklow)', zip: '537755' },
	{ city: 'Corsilloga (Monaghan)', zip: '226542' },
	{ city: 'Corskeagh (Galway)', zip: '996892' },
	{ city: 'Corskeagh (Mayo)', zip: '189810' },
	{ city: 'Corskeagh (Roscommon)', zip: '462152' },
	{ city: 'Corskeagh (Sligo)', zip: '453107' },
	{ city: 'Corskeagh Beg (Galway)', zip: '651646' },
	{ city: 'Corskeagh More (Galway)', zip: '518158' },
	{ city: 'Corstown (Kilkenny)', zip: '471038' },
	{ city: 'Corstown (Louth)', zip: '199239' },
	{ city: 'Corstown (Meath)', zip: '463085' },
	{ city: 'Corstruce (Cavan)', zip: '130536' },
	{ city: 'Cortaghart (Monaghan)', zip: '349403' },
	{ city: 'Cortannel (Monaghan)', zip: '439705' },
	{ city: 'Cortial (Louth)', zip: '481886' },
	{ city: 'Cortober (Cavan)', zip: '679334' },
	{ city: 'Cortober (Leitrim)', zip: '207917' },
	{ city: 'Cortober (Monaghan)', zip: '940455' },
	{ city: 'Cortober (Roscommon)', zip: '991808' },
	{ city: 'Cortolvin (Monaghan)', zip: '670249' },
	{ city: 'Cortown (Meath)', zip: '810413' },
	{ city: 'Cortrasna (Cavan)', zip: '806484' },
	{ city: 'Cortrasna (Roscommon)', zip: '818730' },
	{ city: 'Cortreane (Monaghan)', zip: '806293' },
	{ city: 'Cortullagh (Offaly)', zip: '886793' },
	{ city: 'Corvackan (Monaghan)', zip: '153736' },
	{ city: 'Corvaghan (Monaghan)', zip: '536208' },
	{ city: 'Corvally (Monaghan)', zip: '786148' },
	{ city: 'Corveagh Lower (Mayo)', zip: '131182' },
	{ city: 'Corveagh Upper (Mayo)', zip: '472764' },
	{ city: 'Corveen (Donegal)', zip: '990007' },
	{ city: 'Corvickremon (Mayo)', zip: '817161' },
	{ city: 'Corville (Tipperary)', zip: '898698' },
	{ city: 'Corvoam (Monaghan)', zip: '607053' },
	{ city: 'Corvoderry (Mayo)', zip: '603371' },
	{ city: 'Corvoley (Mayo)', zip: '790416' },
	{ city: 'Corvoy (Monaghan)', zip: '936027' },
	{ city: 'Corweelis (Cavan)', zip: '770608' },
	{ city: 'Corwig (Kildare)', zip: '210053' },
	{ city: 'Corwillick (Sligo)', zip: '296922' },
	{ city: 'Corwillin (Monaghan)', zip: '557496' },
	{ city: 'Corwin (Cavan)', zip: '118574' },
	{ city: 'Cosha North (Kerry)', zip: '142101' },
	{ city: 'Cosha South (Kerry)', zip: '663671' },
	{ city: 'Coshcummeragh (Kerry)', zip: '933219' },
	{ city: 'Cosher (Wexford)', zip: '386660' },
	{ city: 'Coskeam (Clare)', zip: '869020' },
	{ city: 'Coskemduff (Cavan)', zip: '855403' },
	{ city: 'Cosmona (Galway)', zip: '998289' },
	{ city: 'Coss (Kerry)', zip: '324210' },
	{ city: 'Cossallagh (Mayo)', zip: '666168' },
	{ city: 'Cossaun (Galway)', zip: '136077' },
	{ city: 'Cossaunaclamper (Galway)', zip: '125545' },
	{ city: 'Costelloe (Galway)', zip: '868939' },
	{ city: 'Costellospark (Galway)', zip: '545703' },
	{ city: 'Costrea (Leitrim)', zip: '357582' },
	{ city: 'Coteenty (Galway)', zip: '855695' },
	{ city: 'Cotlerstown (Louth)', zip: '738483' },
	{ city: 'Cott (Kildare)', zip: '731886' },
	{ city: 'Cottage (Clare)', zip: '345336' },
	{ city: 'Cottage (Donegal)', zip: '618041' },
	{ city: 'Cottage (Galway)', zip: '244640' },
	{ city: 'Cottage (Kerry)', zip: '916352' },
	{ city: 'Cottage (Limerick)', zip: '995623' },
	{ city: 'Cottage (Mayo)', zip: '542386' },
	{ city: 'Cottage (Tipperary)', zip: '713474' },
	{ city: 'Cottage (Wexford)', zip: '835928' },
	{ city: 'Cottagefarm (Laois)', zip: '219603' },
	{ city: 'Cotterellsbooly (Kilkenny)', zip: '114072' },
	{ city: 'Cotterellsrath (Kilkenny)', zip: '732610' },
	{ city: 'Cottian (Donegal)', zip: '812275' },
	{ city: 'Cottlestown (Sligo)', zip: '750313' },
	{ city: 'Cottown (Donegal)', zip: '860594' },
	{ city: 'Cottrellstown (Kilkenny)', zip: '623749' },
	{ city: 'Cottrelstown (Dublin)', zip: '794689' },
	{ city: 'Cotts (Wexford)', zip: '652931' },
	{ city: 'Cottstown (Cork)', zip: '574907' },
	{ city: 'Coulagh (Cork)', zip: '277090' },
	{ city: 'Coulagh (Kerry)', zip: '968727' },
	{ city: 'Coultry (Dublin)', zip: '167981' },
	{ city: 'Coum (Tipperary)', zip: '704466' },
	{ city: 'Coumaclavlig (Cork)', zip: '204378' },
	{ city: 'Coumaclovane (Cork)', zip: '950259' },
	{ city: 'Coumaleague (Kerry)', zip: '502028' },
	{ city: 'Coumanare (Kerry)', zip: '307551' },
	{ city: 'Coumaraglinmountain (Waterford)', zip: '802366' },
	{ city: 'Coumbeg (Tipperary)', zip: '896680' },
	{ city: 'Coumbowler (Kerry)', zip: '743381' },
	{ city: 'Coumbrack (Clare)', zip: '215471' },
	{ city: 'Coumduff (Kerry)', zip: '553030' },
	{ city: 'Coumeenoole North (Kerry)', zip: '446525' },
	{ city: 'Coumeenoole South (Kerry)', zip: '195769' },
	{ city: 'Coumeenycorraun (Kerry)', zip: '539344' },
	{ city: 'Coumgagh (Kerry)', zip: '669973' },
	{ city: 'Coumlanders (Kerry)', zip: '144028' },
	{ city: 'Coummahon (Waterford)', zip: '132719' },
	{ city: 'Coumnagappul (Waterford)', zip: '382907' },
	{ city: 'Coumnageeha (Tipperary)', zip: '965365' },
	{ city: 'Coumnagillagh (Tipperary)', zip: '604860' },
	{ city: 'Coumnagun (Clare)', zip: '293024' },
	{ city: 'Coumreagh (Kerry)', zip: '206694' },
	{ city: 'Coumroe (Tipperary)', zip: '442500' },
	{ city: 'Councambeg (Cork)', zip: '308757' },
	{ city: 'Countenan (Cavan)', zip: '446514' },
	{ city: 'Countygate (Waterford)', zip: '594673' },
	{ city: 'Couragh (Cork)', zip: '798295' },
	{ city: 'Couravoughil (Galway)', zip: '133442' },
	{ city: 'Courhoor (Galway)', zip: '121385' },
	{ city: 'Cournageeha (Galway)', zip: '742614' },
	{ city: 'Cournellan (Carlow)', zip: '317823' },
	{ city: 'Course (Galway)', zip: '446380' },
	{ city: 'Course (Laois)', zip: '633303' },
	{ city: 'Court (Donegal)', zip: '571809' },
	{ city: 'Court (Dublin)', zip: '184322' },
	{ city: 'Court (Laois)', zip: '608358' },
	{ city: 'Court (Limerick)', zip: '161489' },
	{ city: 'Court (Meath)', zip: '295224' },
	{ city: 'Courtaparteen (Cork)', zip: '110373' },
	{ city: 'Courtballyedmond (Wexford)', zip: '155167' },
	{ city: 'Courtbane (Louth)', zip: '792347' },
	{ city: 'Courtbrack (Cork)', zip: '862371' },
	{ city: 'Courtbrown (Limerick)', zip: '468417' },
	{ city: 'Courtclogh Lower (Wexford)', zip: '443516' },
	{ city: 'Courtclogh Upper (Wexford)', zip: '792485' },
	{ city: 'Courteencurragh (Wexford)', zip: '482537' },
	{ city: 'Courtfoyle (Wicklow)', zip: '114891' },
	{ city: 'Courthill (Tipperary)', zip: '784347' },
	{ city: 'Courthoyle New (Wexford)', zip: '213879' },
	{ city: 'Courthoyle Old (Wexford)', zip: '886043' },
	{ city: 'Courtland (Offaly)', zip: '669972' },
	{ city: 'Courtlands East (Wexford)', zip: '573024' },
	{ city: 'Courtlands West (Wexford)', zip: '654695' },
	{ city: 'Courtleigh (Cork)', zip: '707041' },
	{ city: 'Courtlough (Dublin)', zip: '112394' },
	{ city: 'Courtmacsherry (Cork)', zip: '159731' },
	{ city: 'Courtmatrix (Limerick)', zip: '784157' },
	{ city: 'Courtnaboghilla (Kilkenny)', zip: '440615' },
	{ city: 'Courtnabooly (Kilkenny)', zip: '296337' },
	{ city: 'Courtnabooly East (Kilkenny)', zip: '718034' },
	{ city: 'Courtnabooly West (Kilkenny)', zip: '735146' },
	{ city: 'Courtnacuddy (Wexford)', zip: '903146' },
	{ city: 'Courtown (Wexford)', zip: '376309' },
	{ city: 'Courtown Great (Kildare)', zip: '251548' },
	{ city: 'Courtown Little (Kildare)', zip: '335805' },
	{ city: 'Courtstown (Cork)', zip: '237447' },
	{ city: 'Courtstown (Kilkenny)', zip: '472538' },
	{ city: 'Courttown East (Kildare)', zip: '462986' },
	{ city: 'Courttown West (Kildare)', zip: '796099' },
	{ city: 'Courtwood (Laois)', zip: '377651' },
	{ city: 'Cousane (Cork)', zip: '941706' },
	{ city: 'Cousinstown (Wexford)', zip: '311799' },
	{ city: 'Cove (Cork)', zip: '777649' },
	{ city: 'Cowanstown (Kildare)', zip: '306394' },
	{ city: 'Cowbawn (Tipperary)', zip: '738747' },
	{ city: 'Cow Island (Galway)', zip: '279434' },
	{ city: 'Cowpark (Donegal)', zip: '819628' },
	{ city: 'Cowpark (Limerick)', zip: '911441' },
	{ city: 'Cowpasture (Kildare)', zip: '320927' },
	{ city: 'Cowpasture (Wicklow)', zip: '282586' },
	{ city: 'Cow Rock (Galway)', zip: '776284' },
	{ city: "Cox's Fields (Kilkenny)", zip: '920958' },
	{ city: 'Coxtown (Donegal)', zip: '187833' },
	{ city: 'Coxtown (Galway)', zip: '281468' },
	{ city: 'Coxtown East (Waterford)', zip: '810029' },
	{ city: 'Coxtown West (Waterford)', zip: '417023' },
	{ city: 'Coyne (Westmeath)', zip: '308773' },
	{ city: 'Craan (Carlow)', zip: '933972' },
	{ city: 'Craan (Wexford)', zip: '247903' },
	{ city: 'Craanagam (Wexford)', zip: '447129' },
	{ city: 'Craanaha (Carlow)', zip: '640390' },
	{ city: 'Craanatore (Wexford)', zip: '789546' },
	{ city: 'Craane (Longford)', zip: '767127' },
	{ city: 'Craane (Wexford)', zip: '312677' },
	{ city: 'Craanhill (Wexford)', zip: '358106' },
	{ city: 'Craan Lower (Wexford)', zip: '826014' },
	{ city: 'Craanlusky (Carlow)', zip: '117401' },
	{ city: 'Craanpursheen (Carlow)', zip: '328633' },
	{ city: 'Craanroe (Wexford)', zip: '519322' },
	{ city: 'Craans (Carlow)', zip: '759532' },
	{ city: 'Craan Upper (Wexford)', zip: '176549' },
	{ city: 'Crab (Tipperary)', zip: '350488' },
	{ city: "Crabb's-Land (Limerick)", zip: '241643' },
	{ city: 'Craddanstown (Westmeath)', zip: '246442' },
	{ city: 'Craddockstown (Kilkenny)', zip: '615192' },
	{ city: 'Cradockstown (Meath)', zip: '543075' },
	{ city: 'Cradockstown Demesne (Kildare)', zip: '869661' },
	{ city: 'Cradockstown East (Kildare)', zip: '707793' },
	{ city: 'Cradockstown North (Kildare)', zip: '115378' },
	{ city: 'Cradockstown West (Kildare)', zip: '367658' },
	{ city: 'Craffield (Wicklow)', zip: '962138' },
	{ city: 'Crag (Clare)', zip: '780909' },
	{ city: 'Crag (Kerry)', zip: '832106' },
	{ city: 'Crag (Limerick)', zip: '607020' },
	{ city: 'Cragagh (Mayo)', zip: '786789' },
	{ city: 'Cragard (Clare)', zip: '376451' },
	{ city: 'Cragaweelcross (Clare)', zip: '412583' },
	{ city: 'Cragballyconoal (Clare)', zip: '620614' },
	{ city: 'Cragbeg (Limerick)', zip: '786258' },
	{ city: 'Cragbrien (Clare)', zip: '341134' },
	{ city: 'Cragbwee (Clare)', zip: '112537' },
	{ city: 'Cragg (Clare)', zip: '734474' },
	{ city: 'Cragg (Tipperary)', zip: '763626' },
	{ city: 'Craggagh (Clare)', zip: '855999' },
	{ city: 'Craggagh (Mayo)', zip: '638452' },
	{ city: 'Craggaknock East (Clare)', zip: '206876' },
	{ city: 'Craggaknock West (Clare)', zip: '226892' },
	{ city: 'Cragganacree (Limerick)', zip: '979422' },
	{ city: 'Craggane (Kerry)', zip: '132155' },
	{ city: 'Craggard (Limerick)', zip: '980521' },
	{ city: 'Craggataska (Clare)', zip: '878080' },
	{ city: 'Craggaun (Clare)', zip: '566499' },
	{ city: 'Craggaunboy (Clare)', zip: '771307' },
	{ city: 'Craggaunkeel (Clare)', zip: '856194' },
	{ city: 'Craggaunoonia (Kerry)', zip: '683297' },
	{ city: 'Craggaunowen (Clare)', zip: '113984' },
	{ city: 'Craggera (Mayo)', zip: '946431' },
	{ city: 'Craggs (Limerick)', zip: '863468' },
	{ city: 'Craggs (Waterford)', zip: '976398' },
	{ city: 'Craggy (Mayo)', zip: '685539' },
	{ city: 'Craggycorradan East (Clare)', zip: '611725' },
	{ city: 'Craggycorradan West (Clare)', zip: '539570' },
	{ city: 'Craggykerrivan (Clare)', zip: '964990' },
	{ city: 'Craghera (Clare)', zip: '499354' },
	{ city: 'Craghy (Donegal)', zip: '653291' },
	{ city: 'Craglea (Clare)', zip: '419753' },
	{ city: 'Cragleagh (Clare)', zip: '456037' },
	{ city: 'Cragmore (Limerick)', zip: '316097' },
	{ city: 'Cragnagower (Clare)', zip: '307684' },
	{ city: 'Cragnarooan (Clare)', zip: '404346' },
	{ city: 'Cragreagh (Clare)', zip: '768922' },
	{ city: 'Cragreagh (Limerick)', zip: '782243' },
	{ city: 'Cragroe (Clare)', zip: '864544' },
	{ city: 'Crahard (Cavan)', zip: '354182' },
	{ city: 'Craig (Donegal)', zip: '811124' },
	{ city: 'Craigdoo (Donegal)', zip: '913958' },
	{ city: 'Craigmaddyroe Far (Donegal)', zip: '582324' },
	{ city: 'Craigmaddyroe Near (Donegal)', zip: '637227' },
	{ city: 'Craigroe (Donegal)', zip: '411607' },
	{ city: 'Craigs (Donegal)', zip: '329747' },
	{ city: 'Craigtown (Donegal)', zip: '141308' },
	{ city: 'Craigue (Kilkenny)', zip: '918980' },
	{ city: 'Craiguedarg (Tipperary)', zip: '173175' },
	{ city: 'Craigue Little (Wexford)', zip: '811839' },
	{ city: 'Crakenstown (Meath)', zip: '177120' },
	{ city: 'Cramersvalley (Kildare)', zip: '632093' },
	{ city: 'Crampcastle (Tipperary)', zip: '896756' },
	{ city: 'Cran (Cavan)', zip: '816587' },
	{ city: 'Cranacrower (Wexford)', zip: '148127' },
	{ city: 'Cranagh (Tipperary)', zip: '308882' },
	{ city: 'Cranagh (Wicklow)', zip: '307398' },
	{ city: 'Cranaghan (Cavan)', zip: '877553' },
	{ city: 'Cranagher (Clare)', zip: '518098' },
	{ city: 'Cranahurt (Tipperary)', zip: '187564' },
	{ city: 'Cranalagh Beg (Longford)', zip: '314546' },
	{ city: 'Cranalagh More (Longford)', zip: '510722' },
	{ city: 'Cranally (Longford)', zip: '322887' },
	{ city: 'Cranareen (Mayo)', zip: '604161' },
	{ city: 'Cranareen (Wicklow)', zip: '839782' },
	{ city: 'Cranasallagh (Offaly)', zip: '442019' },
	{ city: 'Cranavaneen (Tipperary)', zip: '125214' },
	{ city: 'Cranavonane (Carlow)', zip: '542062' },
	{ city: 'Cranberry Island (Roscommon)', zip: '123026' },
	{ city: 'Crancam (Roscommon)', zip: '428056' },
	{ city: 'Crancreagh (Offaly)', zip: '163078' },
	{ city: 'Crandaniel (Wexford)', zip: '331412' },
	{ city: 'Crandaniel Great (Wexford)', zip: '355149' },
	{ city: 'Crandaniel Little (Wexford)', zip: '856606' },
	{ city: 'Crandonnell (Wexford)', zip: '492203' },
	{ city: 'Crane (Wexford)', zip: '202254' },
	{ city: 'Cranemore (Carlow)', zip: '924989' },
	{ city: 'Cranford (Donegal)', zip: '935355' },
	{ city: 'Cranmore (Mayo)', zip: '514282' },
	{ city: 'Cranna (Tipperary)', zip: '347791' },
	{ city: 'Crannadillon (Cavan)', zip: '938412' },
	{ city: 'Crannagh (Carlow)', zip: '862431' },
	{ city: 'Crannagh (Galway)', zip: '909738' },
	{ city: 'Crannagh (Laois)', zip: '601829' },
	{ city: 'Crannagh (Mayo)', zip: '683402' },
	{ city: 'Crannagh (Roscommon)', zip: '891288' },
	{ city: 'Crannagh (Tipperary)', zip: '401615' },
	{ city: 'Crannagh Beg (Roscommon)', zip: '471071' },
	{ city: 'Crannagh More (Roscommon)', zip: '813489' },
	{ city: 'Crannaghtown (Meath)', zip: '572902' },
	{ city: 'Crannavone (Tipperary)', zip: '755549' },
	{ city: 'Crannogeboy (Donegal)', zip: '532542' },
	{ city: 'Cranny (Clare)', zip: '951821' },
	{ city: 'Cranny Lower (Donegal)', zip: '276135' },
	{ city: 'Cranny Upper (Donegal)', zip: '468251' },
	{ city: 'Crantahar (Mayo)', zip: '985160' },
	{ city: 'Crappagh (Galway)', zip: '352842' },
	{ city: 'Crappagh (Monaghan)', zip: '113449' },
	{ city: 'Crataloe East (Limerick)', zip: '356915' },
	{ city: 'Crataloe West (Limerick)', zip: '380378' },
	{ city: 'Cratlagh (Donegal)', zip: '794280' },
	{ city: 'Cratloe (Clare)', zip: '781782' },
	{ city: 'Cratloekeel (Clare)', zip: '231763' },
	{ city: 'Cratloemoyle (Clare)', zip: '946148' },
	{ city: 'Craughwell (Galway)', zip: '554009' },
	{ city: 'Crawhill (Sligo)', zip: '922476' },
	{ city: 'Crawnglass (Kildare)', zip: '103907' },
	{ city: 'Craystown (Meath)', zip: '277019' },
	{ city: 'Craywell (Wexford)', zip: '561888' },
	{ city: 'Creadan (Waterford)', zip: '976213' },
	{ city: 'Creagh (Cork)', zip: '347756' },
	{ city: 'Creagh (Galway)', zip: '295610' },
	{ city: 'Creagh (Longford)', zip: '234612' },
	{ city: 'Creagh (Roscommon)', zip: '520956' },
	{ city: 'Creaghadoo (Sligo)', zip: '746934' },
	{ city: 'Creaghadoos (Donegal)', zip: '738440' },
	{ city: 'Creaghan (Monaghan)', zip: '236943' },
	{ city: 'Creaghanboy (Mayo)', zip: '572163' },
	{ city: 'Creaghanroe (Monaghan)', zip: '241515' },
	{ city: 'Creagh Beg (Cork)', zip: '767549' },
	{ city: 'Creagh Demesne (Mayo)', zip: '642701' },
	{ city: 'Creagh Demesne (Wexford)', zip: '586526' },
	{ city: 'Creaghduff (Westmeath)', zip: '127317' },
	{ city: 'Creaghduff South (Westmeath)', zip: '236373' },
	{ city: 'Creagh Lower (Wexford)', zip: '293394' },
	{ city: 'Creagh More (Cork)', zip: '733604' },
	{ city: 'Creaghnakirka (Roscommon)', zip: '417117' },
	{ city: 'Creagh Upper (Wexford)', zip: '881214' },
	{ city: 'Creakan Lower (Wexford)', zip: '114773' },
	{ city: 'Creakan Upper (Wexford)', zip: '117044' },
	{ city: 'Crean (Clare)', zip: '715987' },
	{ city: 'Crean (Limerick)', zip: '612994' },
	{ city: 'Creatland (Donegal)', zip: '446339' },
	{ city: 'Creboy (Cork)', zip: '185247' },
	{ city: 'Crecora (Limerick)', zip: '987970' },
	{ city: 'Crecrin (Carlow)', zip: '173131' },
	{ city: 'Cree (Offaly)', zip: '103868' },
	{ city: 'Creea (Cavan)', zip: '916766' },
	{ city: 'Creegh (Clare)', zip: '295472' },
	{ city: 'Creeghassaun (Sligo)', zip: '696175' },
	{ city: 'Creegh North (Clare)', zip: '348595' },
	{ city: 'Creegh South (Clare)', zip: '734785' },
	{ city: 'Creegooane (Kerry)', zip: '761004' },
	{ city: 'Creeharmore (Roscommon)', zip: '989745' },
	{ city: 'Creehaun (Clare)', zip: '836979' },
	{ city: 'Creehennan (Donegal)', zip: '377340' },
	{ city: 'Creelagh (Laois)', zip: '111845' },
	{ city: 'Creelaghta (Longford)', zip: '702684' },
	{ city: 'Creelogh (Galway)', zip: '916130' },
	{ city: 'Creemore (Meath)', zip: '928933' },
	{ city: 'Creemore (Wexford)', zip: '703275' },
	{ city: 'Creemully And Aghagad Beg (Roscommon)', zip: '532917' },
	{ city: 'Creenagh (Leitrim)', zip: '469069' },
	{ city: 'Creenagh (Longford)', zip: '538296' },
	{ city: 'Creenagh Glebe (Cavan)', zip: '590577' },
	{ city: 'Creenary (Donegal)', zip: '995318' },
	{ city: 'Creenasmear (Donegal)', zip: '980045' },
	{ city: 'Creenkill Beg (Kilkenny)', zip: '684685' },
	{ city: 'Creenkill More (Kilkenny)', zip: '695856' },
	{ city: 'Creenow (Cavan)', zip: '475696' },
	{ city: 'Creenveen (Donegal)', zip: '762319' },
	{ city: 'Creeny (Cavan)', zip: '498282' },
	{ city: 'Creeragh (Mayo)', zip: '387967' },
	{ city: 'Creeragh (Tipperary)', zip: '876274' },
	{ city: 'Creeran (Monaghan)', zip: '472191' },
	{ city: 'Creeraun (Galway)', zip: '735819' },
	{ city: 'Creesil (Monaghan)', zip: '807073' },
	{ city: 'Creeslough (Donegal)', zip: '649385' },
	{ city: 'Creevagh (Clare)', zip: '791358' },
	{ city: 'Creevagh (Donegal)', zip: '195878' },
	{ city: 'Creevagh (Galway)', zip: '895488' },
	{ city: 'Creevagh (Mayo)', zip: '563159' },
	{ city: 'Creevagh (Meath)', zip: '321132' },
	{ city: 'Creevagh (Monaghan)', zip: '139539' },
	{ city: 'Creevagh (Offaly)', zip: '333001' },
	{ city: 'Creevagh (Sligo)', zip: '268756' },
	{ city: 'Creevaghaun (Mayo)', zip: '722015' },
	{ city: 'Creevaghbaun (Galway)', zip: '252114' },
	{ city: 'Creevagh Beg (Clare)', zip: '922844' },
	{ city: 'Creevagh Beg (Longford)', zip: '688048' },
	{ city: 'Creevagh Beg (Mayo)', zip: '406003' },
	{ city: 'Creevagh Middle (Mayo)', zip: '412666' },
	{ city: 'Creevagh More (Clare)', zip: '282144' },
	{ city: 'Creevagh More (Longford)', zip: '855082' },
	{ city: 'Creevagh More (Mayo)', zip: '274775' },
	{ city: 'Creevagh North (Mayo)', zip: '212542' },
	{ city: 'Creevagh South (Mayo)', zip: '322317' },
	{ city: 'Creevaghy (Monaghan)', zip: '406597' },
	{ city: 'Creevard (Mayo)', zip: '872195' },
	{ city: 'Creevaroddaun (Mayo)', zip: '313797' },
	{ city: 'Creevaun (Sligo)', zip: '328135' },
	{ city: 'Creeve (Cavan)', zip: '234002' },
	{ city: 'Creeve (Donegal)', zip: '908042' },
	{ city: 'Creeve (Longford)', zip: '354668' },
	{ city: 'Creeve (Monaghan)', zip: '968609' },
	{ city: 'Creeve (Roscommon)', zip: '902350' },
	{ city: 'Creeve (Westmeath)', zip: '164274' },
	{ city: 'Creevebeg (Limerick)', zip: '777922' },
	{ city: 'Creevebeg (Westmeath)', zip: '152756' },
	{ city: 'Creeveen (Kerry)', zip: '403373' },
	{ city: 'Creeveeshel (Mayo)', zip: '867545' },
	{ city: 'Creeve Glebe (Donegal)', zip: '273669' },
	{ city: 'Creevelea (Leitrim)', zip: '751476' },
	{ city: 'Creevelea (Monaghan)', zip: '446920' },
	{ city: 'Creevelea (Roscommon)', zip: '493615' },
	{ city: 'Creevenamanagh (Westmeath)', zip: '101532' },
	{ city: 'Creeveoughter (Donegal)', zip: '299110' },
	{ city: 'Creeveroe (Clare)', zip: '130290' },
	{ city: 'Creeveroe (Galway)', zip: '888589' },
	{ city: 'Creeves (Limerick)', zip: '235304' },
	{ city: 'Creevins (Donegal)', zip: '725195' },
	{ city: 'Creevolan (Roscommon)', zip: '308412' },
	{ city: 'Creevy (Donegal)', zip: '815674' },
	{ city: 'Creevy (Leitrim)', zip: '101829' },
	{ city: 'Creevy (Longford)', zip: '709577' },
	{ city: 'Creevy (Mayo)', zip: '454564' },
	{ city: 'Creevy (Monaghan)', zip: '614188' },
	{ city: 'Creevy (Roscommon)', zip: '773534' },
	{ city: 'Creevykeel (Sligo)', zip: '291488' },
	{ city: 'Creevymore (Sligo)', zip: '127671' },
	{ city: 'Creevyquin (Roscommon)', zip: '278044' },
	{ city: 'Creewood (Meath)', zip: '125076' },
	{ city: 'Crefoge (Wexford)', zip: '907180' },
	{ city: 'Cregaclare Demesne (Galway)', zip: '575015' },
	{ city: 'Cregaree (Mayo)', zip: '472819' },
	{ city: 'Cregavockoge (Clare)', zip: '260637' },
	{ city: 'Cregballymore (Galway)', zip: '152655' },
	{ city: 'Cregboy (Galway)', zip: '120815' },
	{ city: 'Cregcarragh (Galway)', zip: '979186' },
	{ city: 'Cregdotia (Galway)', zip: '828678' },
	{ city: 'Cregduff (Galway)', zip: '280592' },
	{ city: 'Cregduff (Mayo)', zip: '474545' },
	{ city: 'Cregg (Clare)', zip: '511921' },
	{ city: 'Cregg (Cork)', zip: '722854' },
	{ city: 'Cregg (Galway)', zip: '553291' },
	{ city: 'Cregg (Mayo)', zip: '107399' },
	{ city: 'Cregg (Meath)', zip: '556286' },
	{ city: 'Cregg (Sligo)', zip: '840632' },
	{ city: 'Cregg (Tipperary)', zip: '269983' },
	{ city: 'Cregg (Wexford)', zip: '333633' },
	{ city: 'Cregga (Roscommon)', zip: '955662' },
	{ city: 'Creggaballagh (Mayo)', zip: '768776' },
	{ city: 'Creggagh (Mayo)', zip: '926368' },
	{ city: 'Creggameen (Roscommon)', zip: '222757' },
	{ city: 'Creggan (Donegal)', zip: '378580' },
	{ city: 'Creggan (Offaly)', zip: '353533' },
	{ city: 'Creggan (Roscommon)', zip: '395165' },
	{ city: 'Creggan (Westmeath)', zip: '416325' },
	{ city: 'Cregganabeaka (Roscommon)', zip: '342227' },
	{ city: 'Creggan And Glosterboy (Offaly)', zip: '617414' },
	{ city: 'Creggananta (Galway)', zip: '992736' },
	{ city: 'Cregganawoddy (Mayo)', zip: '357519' },
	{ city: 'Cregganbaun (Mayo)', zip: '107334' },
	{ city: 'Cregganbeg (Mayo)', zip: '467604' },
	{ city: 'Cregganbell (Mayo)', zip: '339046' },
	{ city: 'Cregganbrack (Mayo)', zip: '469262' },
	{ city: 'Creggancor (Roscommon)', zip: '745772' },
	{ city: 'Creggane (Cork)', zip: '533736' },
	{ city: 'Creggane (Limerick)', zip: '347715' },
	{ city: 'Creggane (Tipperary)', zip: '115016' },
	{ city: 'Creggane (Waterford)', zip: '136680' },
	{ city: 'Creggan Lower (Westmeath)', zip: '871455' },
	{ city: 'Cregganmacar (Westmeath)', zip: '715198' },
	{ city: 'Cregganmore (Mayo)', zip: '613961' },
	{ city: 'Cregganna Beg (Galway)', zip: '500507' },
	{ city: 'Creggannacourty (Cork)', zip: '901566' },
	{ city: 'Creggannagappul (Mayo)', zip: '340486' },
	{ city: 'Cregganna More (Galway)', zip: '910061' },
	{ city: 'Creggannaseer (Mayo)', zip: '765401' },
	{ city: 'Creggannavar (Mayo)', zip: '295533' },
	{ city: 'Cregganore (Galway)', zip: '441108' },
	{ city: 'Cregganroe (Mayo)', zip: '243838' },
	{ city: 'Creggan Upper (Westmeath)', zip: '580143' },
	{ city: 'Cregganycarna (Roscommon)', zip: '788783' },
	{ city: 'Creggaree (Galway)', zip: '356042' },
	{ city: 'Creggarve (Mayo)', zip: '736715' },
	{ city: 'Creggaslin (Roscommon)', zip: '561267' },
	{ city: 'Creggaturlough (Galway)', zip: '504483' },
	{ city: 'Creggaun (Clare)', zip: '609378' },
	{ city: 'Creggaun (Galway)', zip: '676026' },
	{ city: 'Creggaun (Mayo)', zip: '192983' },
	{ city: 'Creggaunnagroagh (Galway)', zip: '342763' },
	{ city: 'Creggaunnahilla (Clare)', zip: '706222' },
	{ city: 'Creggaunnahorna (Mayo)', zip: '199208' },
	{ city: 'Creggauns (Galway)', zip: '253375' },
	{ city: 'Creggaunycahill (Clare)', zip: '108239' },
	{ city: 'Creggawatta (Mayo)', zip: '342218' },
	{ city: 'Cregg Demesne (Galway)', zip: '623169' },
	{ city: 'Creggeen (Galway)', zip: '480034' },
	{ city: 'Creggeen (Kerry)', zip: '913296' },
	{ city: 'Cregg North (Cork)', zip: '512060' },
	{ city: 'Creggoduff (Galway)', zip: '745878' },
	{ city: 'Creggolympry North (Cork)', zip: '425147' },
	{ city: 'Creggolympry South (Cork)', zip: '165657' },
	{ city: 'Creggpark (Galway)', zip: '933850' },
	{ city: 'Creggs (Galway)', zip: '424345' },
	{ city: 'Cregg South (Cork)', zip: '360269' },
	{ city: 'Creggstown (Westmeath)', zip: '173327' },
	{ city: 'Creggy (Westmeath)', zip: '976619' },
	{ city: 'Creggyconnell (Sligo)', zip: '411733' },
	{ city: 'Creggymulgreny (Galway)', zip: '130429' },
	{ city: 'Creglahan (Roscommon)', zip: '206587' },
	{ city: 'Creglucas (Galway)', zip: '345989' },
	{ city: 'Cregmahon (Galway)', zip: '653744' },
	{ city: 'Cregmoher (Clare)', zip: '688166' },
	{ city: 'Cregmore (Galway)', zip: '594586' },
	{ city: 'Cregmore (Mayo)', zip: '832814' },
	{ city: 'Cregnafyla (Mayo)', zip: '688276' },
	{ city: 'Cregnanagh (Mayo)', zip: '269614' },
	{ city: 'Crehanagh North (Tipperary)', zip: '742032' },
	{ city: 'Crehanagh South (Tipperary)', zip: '485807' },
	{ city: 'Crehanagh South (Waterford)', zip: '352664' },
	{ city: 'Crehaun (Limerick)', zip: '844824' },
	{ city: 'Crehelp (Wicklow)', zip: '918906' },
	{ city: 'Creighan (Cavan)', zip: '311950' },
	{ city: 'Creighans (Monaghan)', zip: '855610' },
	{ city: 'Creighmore (Cork)', zip: '584393' },
	{ city: 'Cremartin (Monaghan)', zip: '208325' },
	{ city: 'Cremona (Dublin)', zip: '639424' },
	{ city: 'Cremorgan (Laois)', zip: '714653' },
	{ city: 'Cremoyle (Monaghan)', zip: '368007' },
	{ city: 'Crenard (Cavan)', zip: '889458' },
	{ city: 'Creowen (Wicklow)', zip: '296506' },
	{ city: 'Creroge (Meath)', zip: '661708' },
	{ city: 'Creta (Roscommon)', zip: '395661' },
	{ city: 'Crettyard (Laois)', zip: '112471' },
	{ city: 'Crevary Lower (Donegal)', zip: '930571' },
	{ city: 'Crevary Upper (Donegal)', zip: '662942' },
	{ city: 'Creveadornan (Monaghan)', zip: '831879' },
	{ city: 'Crewbane (Meath)', zip: '758248' },
	{ city: 'Crewhill (Kildare)', zip: '658949' },
	{ city: 'Crewmeige (Monaghan)', zip: '914398' },
	{ city: 'Crey (Leitrim)', zip: '999388' },
	{ city: 'Cribstown (Wexford)', zip: '631055' },
	{ city: 'Crickawn (Wicklow)', zip: '484641' },
	{ city: 'Crickeen (Leitrim)', zip: '531583' },
	{ city: 'Crickstown (Meath)', zip: '805817' },
	{ city: 'Crilea (Cavan)', zip: '332514' },
	{ city: 'Crillaun (Mayo)', zip: '626086' },
	{ city: 'Crilly (Donegal)', zip: '108495' },
	{ city: 'Crinagort (Kerry)', zip: '291942' },
	{ city: 'Crinalisk (Waterford)', zip: '790727' },
	{ city: 'Crininish (Clare)', zip: '671564' },
	{ city: 'Crinkill (Monaghan)', zip: '915704' },
	{ city: 'Crinkill (Offaly)', zip: '451938' },
	{ city: 'Crinnage (Galway)', zip: '255791' },
	{ city: 'Crinnagh (Kerry)', zip: '172365' },
	{ city: 'Crinnaghtane (Cork)', zip: '259354' },
	{ city: 'Crinnaghtaun East (Waterford)', zip: '896256' },
	{ city: 'Crinnaghtaun West (Waterford)', zip: '153557' },
	{ city: 'Crinnaloo North (Cork)', zip: '151223' },
	{ city: 'Crinnaloo South (Cork)', zip: '964578' },
	{ city: 'Crinnish (Mayo)', zip: '400775' },
	{ city: 'Crinny East (Kerry)', zip: '772820' },
	{ city: 'Crinny West (Kerry)', zip: '195052' },
	{ city: 'Crinstown (Kildare)', zip: '523761' },
	{ city: 'Crippaun (Kildare)', zip: '379915' },
	{ city: 'Cripplehill (Cork)', zip: '681137' },
	{ city: 'Crislaghkeel (Donegal)', zip: '989875' },
	{ city: 'Crislaghmore (Donegal)', zip: '833988' },
	{ city: 'Crissadaun (Wicklow)', zip: '477130' },
	{ city: 'Crissard (Laois)', zip: '843546' },
	{ city: 'Crissaun (Westmeath)', zip: '197471' },
	{ city: 'Croagh (Cork)', zip: '485760' },
	{ city: 'Croagh (Donegal)', zip: '469050' },
	{ city: 'Croagh (Limerick)', zip: '694992' },
	{ city: 'Croaghacullion (Donegal)', zip: '998025' },
	{ city: 'Croaghan (Cavan)', zip: '524984' },
	{ city: 'Croaghan (Donegal)', zip: '666633' },
	{ city: 'Croaghan (Monaghan)', zip: '600197' },
	{ city: 'Croaghanarget (Donegal)', zip: '967623' },
	{ city: 'Croaghane (Limerick)', zip: '133099' },
	{ city: 'Croaghaun (Clare)', zip: '297440' },
	{ city: 'Croaghaun (Mayo)', zip: '976274' },
	{ city: 'Croaghaun East (Mayo)', zip: '242005' },
	{ city: 'Croaghaun West (Mayo)', zip: '226949' },
	{ city: 'Croaghbeg (Donegal)', zip: '642873' },
	{ city: 'Croaghbrack (Donegal)', zip: '585719' },
	{ city: 'Croaghbreesy (Donegal)', zip: '115648' },
	{ city: 'Croagh Commons (Limerick)', zip: '350575' },
	{ city: 'Croaghill (Galway)', zip: '743358' },
	{ city: 'Croaghlin (Donegal)', zip: '484942' },
	{ city: 'Croaghnacree (Cork)', zip: '862972' },
	{ city: 'Croaghnakeela Island (Galway)', zip: '142859' },
	{ city: 'Croaghnakern (Donegal)', zip: '861549' },
	{ city: 'Croaghnamaddy (Donegal)', zip: '799186' },
	{ city: 'Croaghnameal (Donegal)', zip: '674686' },
	{ city: 'Croaghnashallog (Donegal)', zip: '919623' },
	{ city: 'Croagh North (Clare)', zip: '677439' },
	{ city: 'Croaghonagh (Donegal)', zip: '674111' },
	{ city: 'Croaghrim (Galway)', zip: '641867' },
	{ city: 'Croaghrimbeg (Mayo)', zip: '393037' },
	{ city: 'Croaghrimcarra (Mayo)', zip: '272657' },
	{ city: 'Croaghross (Donegal)', zip: '928112' },
	{ city: 'Croagh South (Clare)', zip: '342986' },
	{ city: 'Croaghubbrid (Donegal)', zip: '799900' },
	{ city: 'Croan (Kilkenny)', zip: '993046' },
	{ city: 'Croan (Tipperary)', zip: '480357' },
	{ city: 'Croane (Tipperary)', zip: '747694' },
	{ city: 'Croankeeran (Donegal)', zip: '377941' },
	{ city: 'Croan Lower (Tipperary)', zip: '109203' },
	{ city: 'Croan Lower (Waterford)', zip: '241766' },
	{ city: 'Croanrea (Cork)', zip: '869374' },
	{ city: 'Croanruss (Carlow)', zip: '939611' },
	{ city: 'Croan Upper (Waterford)', zip: '172458' },
	{ city: 'Croase (Wexford)', zip: '531829' },
	{ city: 'Crobally Lower (Waterford)', zip: '827926' },
	{ city: 'Crobally Upper (Waterford)', zip: '546242' },
	{ city: 'Croboy (Meath)', zip: '678600' },
	{ city: 'Crocam (Donegal)', zip: '172800' },
	{ city: 'Crocane (Cork)', zip: '338545' },
	{ city: 'Crockacapple (Donegal)', zip: '459142' },
	{ city: 'Crockacullion (Sligo)', zip: '758322' },
	{ city: 'Crockahenny (Donegal)', zip: '508482' },
	{ city: 'Crockanure Glebe (Kildare)', zip: '313948' },
	{ city: 'Crockastoller (Donegal)', zip: '818001' },
	{ city: 'Crockaun (Kildare)', zip: '846452' },
	{ city: 'Crockaun (Longford)', zip: '502706' },
	{ city: 'Crockaunadreenagh (Dublin)', zip: '253430' },
	{ city: 'Crockaun Commons (Kildare)', zip: '249761' },
	{ city: 'Crockaunrannell (Mayo)', zip: '383454' },
	{ city: 'Crockawaddy (Leitrim)', zip: '818309' },
	{ city: 'Crockcumberland (Monaghan)', zip: '401093' },
	{ city: 'Crockeen (Leitrim)', zip: '553752' },
	{ city: 'Crockglass (Donegal)', zip: '908047' },
	{ city: 'Crocklusty (Cavan)', zip: '292553' },
	{ city: 'Crocknacally (Mayo)', zip: '549648' },
	{ city: 'Crocknacunny (Donegal)', zip: '449762' },
	{ city: 'Crocknafeola (Donegal)', zip: '481464' },
	{ city: 'Crocknagapple (Donegal)', zip: '531540' },
	{ city: 'Crocknageeragh (Donegal)', zip: '227557' },
	{ city: 'Crocknahattin (Cavan)', zip: '482657' },
	{ city: 'Crocknamurleog (Donegal)', zip: '797839' },
	{ city: 'Crocknaraw (Galway)', zip: '614895' },
	{ city: 'Crockraw (Donegal)', zip: '788707' },
	{ city: 'Crockshane (Dublin)', zip: '572551' },
	{ city: 'Crodaun (Kildare)', zip: '234540' },
	{ city: 'Croftonpark (Mayo)', zip: '960153' },
	{ city: 'Croghan (Mayo)', zip: '950526' },
	{ city: 'Croghan (Roscommon)', zip: '340135' },
	{ city: 'Croghan (Tipperary)', zip: '454429' },
	{ city: 'Croghan Demesne (Offaly)', zip: '791282' },
	{ city: 'Croghanhill (Offaly)', zip: '461038' },
	{ city: 'Croghan Middle (Wexford)', zip: '992127' },
	{ city: 'Croghan Mountain (Wexford)', zip: '188092' },
	{ city: 'Croghan Upper (Wexford)', zip: '603078' },
	{ city: 'Croghnut (Galway)', zip: '238513' },
	{ city: 'Croghtabeg (Kilkenny)', zip: '583792' },
	{ city: 'Croghteen (Limerick)', zip: '394179' },
	{ city: 'Croghtenclogh (Kilkenny)', zip: '822107' },
	{ city: 'Croha East (Cork)', zip: '676153' },
	{ city: 'Crohan (Tipperary)', zip: '410942' },
	{ city: 'Crohane (Cork)', zip: '724011' },
	{ city: 'Crohane (Kerry)', zip: '815259' },
	{ city: 'Crohane East (Cork)', zip: '294691' },
	{ city: 'Crohane Lower (Tipperary)', zip: '589878' },
	{ city: 'Crohane Upper (Tipperary)', zip: '144974' },
	{ city: 'Crohane West (Cork)', zip: '707194' },
	{ city: 'Crohanree (Kildare)', zip: '727863' },
	{ city: 'Croha West (Cork)', zip: '378307' },
	{ city: 'Crohy (Donegal)', zip: '391731' },
	{ city: 'Crohyboyle (Donegal)', zip: '496229' },
	{ city: 'Crokershill (Kilkenny)', zip: '203417' },
	{ city: 'Crokerspark (Limerick)', zip: '571628' },
	{ city: 'Crolack (Donegal)', zip: '430676' },
	{ city: 'Croley (Cavan)', zip: '337544' },
	{ city: 'Crolly (Donegal)', zip: '520948' },
	{ city: 'Cromagloun (Cork)', zip: '158780' },
	{ city: 'Cromane (Kerry)', zip: '539332' },
	{ city: 'Cromane Lower (Kerry)', zip: '840683' },
	{ city: 'Cromane Upper (Kerry)', zip: '624672' },
	{ city: 'Cromlin (Leitrim)', zip: '400904' },
	{ city: 'Cromoge (Cork)', zip: '404789' },
	{ city: 'Cromoge (Laois)', zip: '622661' },
	{ city: 'Cromoge (Wexford)', zip: '869441' },
	{ city: 'Cromwell (Limerick)', zip: '813994' },
	{ city: 'Cromwellsfort (Wexford)', zip: '542749' },
	{ city: 'Cromwellstown (Kildare)', zip: '858586' },
	{ city: 'Cromwellstownhill (Kildare)', zip: '829922' },
	{ city: 'Cronacarkfree (Donegal)', zip: '613066' },
	{ city: 'Cronadun (Donegal)', zip: '422254' },
	{ city: 'Cronagort East (Clare)', zip: '104975' },
	{ city: 'Cronagort West (Clare)', zip: '738268' },
	{ city: 'Cronaguiggy (Donegal)', zip: '876374' },
	{ city: 'Cronakerny (Donegal)', zip: '166510' },
	{ city: 'Cronakip (Wicklow)', zip: '816817' },
	{ city: 'Cronalaghy (Donegal)', zip: '264498' },
	{ city: 'Cronaliegh (Carlow)', zip: '504350' },
	{ city: 'Cronamuck (Donegal)', zip: '131353' },
	{ city: 'Cronaslieve (Donegal)', zip: '260943' },
	{ city: 'Cronavan (Cork)', zip: '766645' },
	{ city: 'Cronavone (Tipperary)', zip: '577321' },
	{ city: 'Cronawinnia (Wicklow)', zip: '768673' },
	{ city: 'Crone (Wicklow)', zip: '124511' },
	{ city: 'Cronebane (Wicklow)', zip: '861024' },
	{ city: 'Crone Beg (Wicklow)', zip: '569226' },
	{ city: 'Cronecribbin (Wexford)', zip: '893585' },
	{ city: 'Croneenlaun (Kilkenny)', zip: '168102' },
	{ city: 'Cronekill (Tipperary)', zip: '212846' },
	{ city: 'Cronelea (Wicklow)', zip: '127123' },
	{ city: 'Cronellard (Wexford)', zip: '549786' },
	{ city: 'Crone Lower (Wicklow)', zip: '633384' },
	{ city: 'Cronelusk (Wicklow)', zip: '155575' },
	{ city: 'Crone More (Wicklow)', zip: '901026' },
	{ city: 'Cronery (Cavan)', zip: '251845' },
	{ city: 'Cronesallagh (Wicklow)', zip: '914226' },
	{ city: 'Croneskagh Lower (Carlow)', zip: '303788' },
	{ city: 'Croneskagh Upper (Carlow)', zip: '251976' },
	{ city: 'Crone Upper (Wicklow)', zip: '474210' },
	{ city: 'Cronin (Roscommon)', zip: '805927' },
	{ city: 'Cronkeeran (Donegal)', zip: '890817' },
	{ city: 'Cronody (Cork)', zip: '633033' },
	{ city: 'Cronoge (Kilkenny)', zip: '516185' },
	{ city: 'Cronohill (Cork)', zip: '690514' },
	{ city: 'Cronroe (Wicklow)', zip: '751521' },
	{ city: 'Cronybyrne (Wicklow)', zip: '945589' },
	{ city: 'Cronybyrne Demesne (Wicklow)', zip: '757574' },
	{ city: 'Cronyhorn (Wexford)', zip: '634664' },
	{ city: 'Cronyhorn Lower (Wicklow)', zip: '116814' },
	{ city: 'Cronyhorn Upper (Wicklow)', zip: '164969' },
	{ city: 'Cronykeery (Wicklow)', zip: '911095' },
	{ city: 'Crooderry (Roscommon)', zip: '668722' },
	{ city: 'Croogorts (Kerry)', zip: '661521' },
	{ city: 'Crooha East (Cork)', zip: '984798' },
	{ city: 'Crooha Middle (Cork)', zip: '203499' },
	{ city: 'Crooha West (Cork)', zip: '398461' },
	{ city: 'Crooke (Waterford)', zip: '650600' },
	{ city: 'Crookedwood (Westmeath)', zip: '415338' },
	{ city: 'Crooket (Kildare)', zip: '667337' },
	{ city: 'Crookhaven (Cork)', zip: '766582' },
	{ city: 'Crooksling (Dublin)', zip: '733440' },
	{ city: 'Crookstown (Cork)', zip: '425932' },
	{ city: 'Crookstown East (Kildare)', zip: '506217' },
	{ city: 'Crookstown Lower (Kildare)', zip: '819938' },
	{ city: 'Crookstown Upper (Kildare)', zip: '971022' },
	{ city: 'Croom (Limerick)', zip: '444947' },
	{ city: 'Crooroe Park (Galway)', zip: '374879' },
	{ city: 'Crophill (Kildare)', zip: '177283' },
	{ city: 'Crory (Wexford)', zip: '171408' },
	{ city: 'Crory Lower (Wexford)', zip: '289050' },
	{ city: 'Crory Middle (Wexford)', zip: '390776' },
	{ city: 'Crory Upper (Wexford)', zip: '851286' },
	{ city: 'Crosheen (Galway)', zip: '282977' },
	{ city: 'Cross (Cavan)', zip: '251474' },
	{ city: 'Cross (Clare)', zip: '727620' },
	{ city: 'Cross (Donegal)', zip: '531143' },
	{ city: 'Cross (Galway)', zip: '161997' },
	{ city: 'Cross (Laois)', zip: '545113' },
	{ city: 'Cross (Limerick)', zip: '750254' },
	{ city: 'Cross (Longford)', zip: '186340' },
	{ city: 'Cross (Mayo)', zip: '361788' },
	{ city: 'Cross (Sligo)', zip: '924779' },
	{ city: 'Cross (Waterford)', zip: '683282' },
	{ city: 'Cross (Westmeath)', zip: '290000' },
	{ city: 'Cross (Wicklow)', zip: '922243' },
	{ city: 'Crossabeagh (Louth)', zip: '866400' },
	{ city: 'Crossabeg (Wexford)', zip: '225654' },
	{ city: 'Crossafehin (Cavan)', zip: '597027' },
	{ city: 'Crossagalla (Limerick)', zip: '846486' },
	{ city: 'Crossagh (Clare)', zip: '266195' },
	{ city: 'Crossaghy (Monaghan)', zip: '877874' },
	{ city: 'Crossakeel (Meath)', zip: '910934' },
	{ city: 'Crossalare (Monaghan)', zip: '754597' },
	{ city: 'Crossanagh (Tipperary)', zip: '428061' },
	{ city: 'Crossane (Meath)', zip: '963179' },
	{ city: 'Crossanstown (Meath)', zip: '251260' },
	{ city: 'Crossanstown (Westmeath)', zip: '820954' },
	{ city: 'Crossard (Clare)', zip: '181212' },
	{ city: 'Crossard (Mayo)', zip: '685521' },
	{ city: 'Crossard (Tipperary)', zip: '531859' },
	{ city: 'Crossayle (Tipperary)', zip: '551497' },
	{ city: 'Crossbane (Cavan)', zip: '564919' },
	{ city: 'Crossbane (Monaghan)', zip: '642255' },
	{ city: 'Cross Barry (Cork)', zip: '991334' },
	{ city: 'Crossbeg (Mayo)', zip: '250500' },
	{ city: 'Cross Beg (Clare)', zip: '322178' },
	{ city: 'Crossboy (Sligo)', zip: '937237' },
	{ city: 'Crossboyne (Mayo)', zip: '791689' },
	{ city: 'Crosscannon (Tipperary)', zip: '708753' },
	{ city: 'Crosscarn (Cavan)', zip: '606462' },
	{ city: 'Cross Common (Mayo)', zip: '438808' },
	{ city: 'Crossconnell (Donegal)', zip: '550869' },
	{ city: 'Crossconnell Beg (Galway)', zip: '854367' },
	{ city: 'Crossconnell More (Galway)', zip: '576180' },
	{ city: 'Crosscoolharbour (Kildare)', zip: '531954' },
	{ city: 'Crosscoolharbour (Wicklow)', zip: '842546' },
	{ city: 'Crosscornaun (Clare)', zip: '488878' },
	{ city: 'Crossderry (Clare)', zip: '404845' },
	{ city: 'Crossderry (Galway)', zip: '818128' },
	{ city: 'Crossderry (Kerry)', zip: '683656' },
	{ city: 'Crossdoney (Cavan)', zip: '516572' },
	{ city: 'Crossdrum Lower (Meath)', zip: '335038' },
	{ city: 'Crossdrumman (Leitrim)', zip: '571745' },
	{ city: 'Crossdrum Upper (Meath)', zip: '684079' },
	{ city: 'Crossduff (Monaghan)', zip: '595277' },
	{ city: 'Crossea North (Longford)', zip: '963718' },
	{ city: 'Crossea South (Longford)', zip: '772727' },
	{ city: 'Cross East (Mayo)', zip: '655111' },
	{ city: 'Cross Eighter (Galway)', zip: '466588' },
	{ city: 'Crosserdree (Westmeath)', zip: '450327' },
	{ city: 'Crosserlough (Cavan)', zip: '718394' },
	{ city: 'Crosserule (Cavan)', zip: '858938' },
	{ city: 'Crossery (Waterford)', zip: '566253' },
	{ city: 'Crosses (Cork)', zip: '215203' },
	{ city: 'Crosses (Monaghan)', zip: '953930' },
	{ city: 'Crossfarnoge (Wexford)', zip: '184475' },
	{ city: 'Crossfield (Laois)', zip: '907443' },
	{ city: 'Crossford (Waterford)', zip: '647047' },
	{ city: 'Crosshaven (Cork)', zip: '750521' },
	{ city: 'Crosshavenhill (Cork)', zip: '604826' },
	{ city: 'Crosshill (Roscommon)', zip: '829076' },
	{ city: 'Crosshue (Wexford)', zip: '237298' },
	{ city: 'Crosshugh (Monaghan)', zip: '395949' },
	{ city: 'Cross Keys (Cavan)', zip: '850603' },
	{ city: 'Crosslands (Wexford)', zip: '643893' },
	{ city: 'Crosslea (Cork)', zip: '219284' },
	{ city: 'Crosslea (Monaghan)', zip: '655914' },
	{ city: 'Crossmacrin (Galway)', zip: '867374' },
	{ city: 'Crossmahon (Cork)', zip: '565201' },
	{ city: 'Crossmakeelan (Cavan)', zip: '118960' },
	{ city: 'Crossmakelagher (Cavan)', zip: '554523' },
	{ city: 'Crossmolina (Mayo)', zip: '308684' },
	{ city: 'Crossmore (Monaghan)', zip: '328225' },
	{ city: 'Cross More (Clare)', zip: '601540' },
	{ city: 'Crossmorris (Kildare)', zip: '760117' },
	{ city: 'Crossmoyle (Monaghan)', zip: '663362' },
	{ city: 'Crossna (Roscommon)', zip: '979241' },
	{ city: 'Crossnacaldoo (Monaghan)', zip: '577940' },
	{ city: 'Crossnacole (Wicklow)', zip: '374428' },
	{ city: 'Crossneen (Laois)', zip: '566415' },
	{ city: 'Cross North (Roscommon)', zip: '260177' },
	{ city: 'Crossoge (Cork)', zip: '842962' },
	{ city: 'Crossoge (Kilkenny)', zip: '531764' },
	{ city: 'Crossoge (Tipperary)', zip: '904835' },
	{ city: 'Crossoge (Wicklow)', zip: '912468' },
	{ city: 'Crossoges (Tipperary)', zip: '564349' },
	{ city: 'Crossogs (Donegal)', zip: '856392' },
	{ city: 'Crossooha (Galway)', zip: '321982' },
	{ city: 'Cross Oughter (Galway)', zip: '272061' },
	{ city: 'Crosspatrick (Kilkenny)', zip: '974814' },
	{ city: 'Crosspatrick (Mayo)', zip: '504124' },
	{ city: 'Crossrah (Cavan)', zip: '882964' },
	{ city: 'Crossreagh (Cavan)', zip: '214771' },
	{ city: 'Crossreagh (Monaghan)', zip: '345725' },
	{ city: 'Cross Scales (Wexford)', zip: '537182' },
	{ city: 'Cross South (Roscommon)', zip: '168816' },
	{ city: 'Crossterry East (Cork)', zip: '453096' },
	{ city: 'Crossterry West (Cork)', zip: '789463' },
	{ city: 'Crosstown (Kerry)', zip: '867589' },
	{ city: 'Crosstown (Wexford)', zip: '745383' },
	{ city: 'Crossursa (Galway)', zip: '332990' },
	{ city: 'Cross West (Mayo)', zip: '423517' },
	{ city: 'Crosswood (Westmeath)', zip: '149690' },
	{ city: 'Crossybrennan (Kilkenny)', zip: '606612' },
	{ city: 'Crotanstown (Kildare)', zip: '825621' },
	{ city: 'Crott (Longford)', zip: '510838' },
	{ city: 'Crott (Mayo)', zip: '239872' },
	{ city: 'Crotta (Kerry)', zip: '148160' },
	{ city: 'Crotta (Tipperary)', zip: '832871' },
	{ city: 'Crottees (Cork)', zip: '760545' },
	{ city: 'Crott Mountain (Mayo)', zip: '964916' },
	{ city: 'Crough (Waterford)', zip: '805039' },
	{ city: 'Croughal (Westmeath)', zip: '664747' },
	{ city: 'Croughil (Offaly)', zip: '262150' },
	{ city: 'Croughta (Cork)', zip: '967320' },
	{ city: 'Croughta (Tipperary)', zip: '847459' },
	{ city: 'Croughtanaul (Waterford)', zip: '130284' },
	{ city: 'Croveenananta (Donegal)', zip: '605001' },
	{ city: 'Crovehy (Donegal)', zip: '422389' },
	{ city: 'Crover (Cavan)', zip: '759726' },
	{ city: 'Crover (Monaghan)', zip: '437546' },
	{ city: 'Crovraghan (Clare)', zip: '844470' },
	{ city: 'Crowagh (Sligo)', zip: '747140' },
	{ city: 'Crowanrudda (Donegal)', zip: '528514' },
	{ city: 'Crowanrudda Beg (Donegal)', zip: '290435' },
	{ city: 'Crowbally (Cork)', zip: '877023' },
	{ city: 'Crowbally (Kilkenny)', zip: '392193' },
	{ city: 'Crowbane (Donegal)', zip: '193429' },
	{ city: 'Crowdoo (Donegal)', zip: '771916' },
	{ city: 'Crowdrumman (Longford)', zip: '357879' },
	{ city: 'Croweighter (Donegal)', zip: '918695' },
	{ city: 'Crowey (Monaghan)', zip: '249996' },
	{ city: 'Crowhill (Kilkenny)', zip: '393286' },
	{ city: 'Crowhill (Mayo)', zip: '460243' },
	{ city: 'Crowinstown Great (Westmeath)', zip: '729077' },
	{ city: 'Crowinstown Little (Westmeath)', zip: '868492' },
	{ city: 'Crow Island (Galway)', zip: '213853' },
	{ city: 'Crowkeeragh (Donegal)', zip: '860769' },
	{ city: 'Crowkingle (Cork)', zip: '235264' },
	{ city: 'Crowlar (Donegal)', zip: '351802' },
	{ city: 'Crowmartin (Louth)', zip: '810342' },
	{ city: 'Crownasillagh (Donegal)', zip: '958532' },
	{ city: 'Crowpark (Meath)', zip: '176445' },
	{ city: 'Crowscastle (Dublin)', zip: '399434' },
	{ city: 'Crowsgap (Roscommon)', zip: '792437' },
	{ city: 'Crowsgrove (Carlow)', zip: '816316' },
	{ city: 'Crowsnest (Galway)', zip: '188028' },
	{ city: 'Cruagh (Dublin)', zip: '382669' },
	{ city: 'Cruagh (Galway)', zip: '277607' },
	{ city: 'Cruan (Kilkenny)', zip: '185789' },
	{ city: 'Cruary East (Cork)', zip: '950994' },
	{ city: 'Cruary West (Cork)', zip: '468566' },
	{ city: 'Crubany (Cavan)', zip: '645899' },
	{ city: 'Crubeen (Laois)', zip: '255388' },
	{ city: 'Cruboge (Tipperary)', zip: '459299' },
	{ city: 'Cruell (Laois)', zip: '991451' },
	{ city: 'Crufty (Meath)', zip: '996320' },
	{ city: 'Crughwill (Clare)', zip: '367628' },
	{ city: 'Cruicerath (Meath)', zip: '914540' },
	{ city: 'Cruicetown (Meath)', zip: '871671' },
	{ city: 'Cruickaghmore (Donegal)', zip: '916703' },
	{ city: 'Cruiserath (Dublin)', zip: '818445' },
	{ city: 'Cruisetown (Louth)', zip: '942401' },
	{ city: 'Cruit (Offaly)', zip: '222891' },
	{ city: 'Cruit (Roscommon)', zip: '363227' },
	{ city: 'Cruit Lower (Donegal)', zip: '329754' },
	{ city: 'Cruit Upper (Donegal)', zip: '420808' },
	{ city: 'Crumlin (Cavan)', zip: '328369' },
	{ city: 'Crumlin (Clare)', zip: '668191' },
	{ city: 'Crumlin (Donegal)', zip: '255427' },
	{ city: 'Crumlin (Dublin)', zip: '462086' },
	{ city: 'Crumlin (Galway)', zip: '163880' },
	{ city: 'Crumlin (Louth)', zip: '159352' },
	{ city: 'Crumlin (Mayo)', zip: '862225' },
	{ city: 'Crumlin (Monaghan)', zip: '805211' },
	{ city: 'Crumlin (Westmeath)', zip: '733498' },
	{ city: 'Crumlin Big (Tipperary)', zip: '903025' },
	{ city: 'Crumlin East (Galway)', zip: '716605' },
	{ city: 'Crumlin Little (Tipperary)', zip: '233114' },
	{ city: 'Crumlin West (Galway)', zip: '137391' },
	{ city: 'Crummagh (Galway)', zip: '465584' },
	{ city: 'Crummy (Leitrim)', zip: '172554' },
	{ city: 'Crumpane (Cork)', zip: '162866' },
	{ city: 'Crumpaun (Leitrim)', zip: '302672' },
	{ city: 'Crumpstown (Meath)', zip: '363392' },
	{ city: 'Crunaun (Roscommon)', zip: '826880' },
	{ city: 'Crunkill (Roscommon)', zip: '913592' },
	{ city: 'Crushea (Waterford)', zip: '178512' },
	{ city: 'Crusheen (Clare)', zip: '477300' },
	{ city: 'Crusheenkeenoge (Limerick)', zip: '720965' },
	{ city: 'Crusheeny (Galway)', zip: '418132' },
	{ city: 'Crushterra (Cork)', zip: '888441' },
	{ city: 'Crushyriree (Cork)', zip: '751176' },
	{ city: 'Crussera (Waterford)', zip: '918936' },
	{ city: 'Crutt (Kilkenny)', zip: '926639' },
	{ city: 'Crutta North (Tipperary)', zip: '789441' },
	{ city: 'Crutta South (Tipperary)', zip: '898760' },
	{ city: 'Crylough (Wexford)', zip: '243608' },
	{ city: 'Cuba (Offaly)', zip: '852914' },
	{ city: 'Cubslough (Wexford)', zip: '669793' },
	{ city: 'Cuckoohill (Tipperary)', zip: '296850' },
	{ city: 'Cuddagh (Laois)', zip: '396409' },
	{ city: 'Cuddoo East (Galway)', zip: '708027' },
	{ city: 'Cuddoo West (Galway)', zip: '397138' },
	{ city: 'Cuffsborough (Laois)', zip: '259737' },
	{ city: 'Cuhig (Kerry)', zip: '642274' },
	{ city: 'Cuilbalkeen (Roscommon)', zip: '358909' },
	{ city: 'Cuilbeg (Galway)', zip: '469695' },
	{ city: 'Cuilbeg (Mayo)', zip: '972044' },
	{ city: 'Cuilbeg (Roscommon)', zip: '242035' },
	{ city: 'Cuilbeg (Sligo)', zip: '564018' },
	{ city: 'Cuilcagh (Cavan)', zip: '163654' },
	{ city: 'Cuildoo (Mayo)', zip: '539676' },
	{ city: 'Cuildooish (Galway)', zip: '111343' },
	{ city: 'Cuilfadda And Derrinshin (Roscommon)', zip: '567743' },
	{ city: 'Cuilgar (Mayo)', zip: '605818' },
	{ city: 'Cuilglass (Roscommon)', zip: '778447' },
	{ city: 'Cuilkeel (Roscommon)', zip: '862701' },
	{ city: 'Cuilkillew (Mayo)', zip: '780526' },
	{ city: 'Cuillagh (Leitrim)', zip: '177925' },
	{ city: 'Cuillaghan (Cavan)', zip: '388399' },
	{ city: 'Cuillalea (Mayo)', zip: '729581' },
	{ city: 'Cuillaloughaun (Mayo)', zip: '972714' },
	{ city: 'Cuillard (Roscommon)', zip: '601871' },
	{ city: 'Cuillare (Mayo)', zip: '515324' },
	{ city: 'Cuillatinny (Mayo)', zip: '405616' },
	{ city: 'Cuillaun (Mayo)', zip: '249739' },
	{ city: 'Cuillawinnia (Roscommon)', zip: '342928' },
	{ city: 'Cuilleen (Galway)', zip: '742992' },
	{ city: 'Cuilleen (Mayo)', zip: '212012' },
	{ city: 'Cuilleen (Roscommon)', zip: '976884' },
	{ city: 'Cuilleendaeagh (Galway)', zip: '774344' },
	{ city: 'Cuilleenirwan (Roscommon)', zip: '148798' },
	{ city: 'Cuilleenoolagh (Roscommon)', zip: '345949' },
	{ city: 'Cuillenstown (Louth)', zip: '918737' },
	{ city: 'Cuillonaghtan (Mayo)', zip: '238086' },
	{ city: 'Cuilly (Donegal)', zip: '427660' },
	{ city: 'Cuilmore (Galway)', zip: '291038' },
	{ city: 'Cuilmore (Leitrim)', zip: '337705' },
	{ city: 'Cuilmore (Mayo)', zip: '396300' },
	{ city: 'Cuilmore (Roscommon)', zip: '579295' },
	{ city: 'Cuilmore (Sligo)', zip: '848934' },
	{ city: 'Cuilmullagh (Mayo)', zip: '907985' },
	{ city: 'Cuilnacappy (Galway)', zip: '259316' },
	{ city: 'Cuilnagleragh (Sligo)', zip: '899979' },
	{ city: 'Cuilnakeava (Roscommon)', zip: '823062' },
	{ city: 'Cuilprughlish (Sligo)', zip: '883811' },
	{ city: 'Cuilrevagh (Roscommon)', zip: '183649' },
	{ city: 'Cuilsallagh (Galway)', zip: '808383' },
	{ city: 'Cuilsheeghary Beg (Sligo)', zip: '210354' },
	{ city: 'Cuilsheeghary More (Sligo)', zip: '580189' },
	{ city: 'Cuiltaboolia (Roscommon)', zip: '162261' },
	{ city: 'Cuiltia (Leitrim)', zip: '482872' },
	{ city: 'Cuilties (Leitrim)', zip: '270503' },
	{ city: 'Cuiltrasna (Mayo)', zip: '401807' },
	{ city: 'Cuiltrean (Mayo)', zip: '429489' },
	{ city: 'Cuiltybo (Mayo)', zip: '751863' },
	{ city: 'Cuiltyboe (Roscommon)', zip: '512539' },
	{ city: 'Cuiltyconeen (Roscommon)', zip: '113982' },
	{ city: 'Cuiltyconway (Roscommon)', zip: '751417' },
	{ city: 'Cuiltycreaghan (Mayo)', zip: '125202' },
	{ city: 'Cuiltydangan (Sligo)', zip: '199182' },
	{ city: 'Cuiltygower (Roscommon)', zip: '267018' },
	{ city: 'Cuiltylough (Sligo)', zip: '889308' },
	{ city: 'Cuiltyshinnoge (Roscommon)', zip: '594820' },
	{ city: 'Cuingareen (Longford)', zip: '991569' },
	{ city: 'Cuing Beg (Mayo)', zip: '226783' },
	{ city: 'Cuing More (Mayo)', zip: '604780' },
	{ city: 'Culcommon (Meath)', zip: '278278' },
	{ city: 'Culcor (Meath)', zip: '981304' },
	{ city: 'Culdaff (Donegal)', zip: '139859' },
	{ city: 'Culdaff Glebe (Donegal)', zip: '690380' },
	{ city: 'Culdaloo (Monaghan)', zip: '804854' },
	{ city: 'Culdaly (Sligo)', zip: '664163' },
	{ city: 'Culfadda (Sligo)', zip: '402405' },
	{ city: 'Culfin (Galway)', zip: '116953' },
	{ city: 'Culfore (Louth)', zip: '264022' },
	{ city: 'Culineen (Donegal)', zip: '566388' },
	{ city: 'Culkeen (Roscommon)', zip: '912828' },
	{ city: 'Culkeeny (Donegal)', zip: '136268' },
	{ city: 'Cull (Wexford)', zip: '774234' },
	{ city: 'Cullaboy Lower (Cavan)', zip: '702910' },
	{ city: 'Cullaboy Upper (Cavan)', zip: '384231' },
	{ city: 'Cullagh (Mayo)', zip: '305829' },
	{ city: 'Cullagh (Tipperary)', zip: '195312' },
	{ city: 'Cullagh Beg (Sligo)', zip: '468419' },
	{ city: 'Cullagh More (Sligo)', zip: '278308' },
	{ city: 'Cullaghreeva (Kildare)', zip: '222823' },
	{ city: 'Cullahill (Laois)', zip: '197007' },
	{ city: 'Cullahill (Tipperary)', zip: '932321' },
	{ city: 'Cullahill Mountain (Laois)', zip: '737428' },
	{ city: 'Cullairbaun (Galway)', zip: '955096' },
	{ city: 'Cullamus (Limerick)', zip: '891532' },
	{ city: 'Cullane East (Cork)', zip: '748129' },
	{ city: 'Cullane Middle (Limerick)', zip: '968879' },
	{ city: 'Cullane North (Limerick)', zip: '613616' },
	{ city: 'Cullane South (Limerick)', zip: '228646' },
	{ city: 'Cullane West (Cork)', zip: '595158' },
	{ city: 'Cullaun (Clare)', zip: '648332' },
	{ city: 'Cullaun (Kilkenny)', zip: '954167' },
	{ city: 'Cullaun (Tipperary)', zip: '536749' },
	{ city: 'Culleen (Clare)', zip: '291951' },
	{ city: 'Culleen (Galway)', zip: '461782' },
	{ city: 'Culleen (Offaly)', zip: '784154' },
	{ city: 'Culleen (Tipperary)', zip: '521649' },
	{ city: 'Culleenabohoge (Westmeath)', zip: '828880' },
	{ city: 'Culleenagh (Tipperary)', zip: '986611' },
	{ city: 'Culleenaghamore (Roscommon)', zip: '194870' },
	{ city: 'Culleenagower (Westmeath)', zip: '486014' },
	{ city: 'Culleenalena (Galway)', zip: '527353' },
	{ city: 'Culleenamore (Sligo)', zip: '352450' },
	{ city: 'Culleenanory (Roscommon)', zip: '543286' },
	{ city: 'Culleenatreen (Roscommon)', zip: '682353' },
	{ city: 'Culleen Beg (Westmeath)', zip: '669269' },
	{ city: 'Culleendarragh (Westmeath)', zip: '517966' },
	{ city: 'Culleenduff (Sligo)', zip: '385925' },
	{ city: 'Culleenmore (Longford)', zip: '801631' },
	{ city: 'Culleen More (Westmeath)', zip: '504614' },
	{ city: 'Culleens (Mayo)', zip: '766411' },
	{ city: 'Culleens (Sligo)', zip: '796739' },
	{ city: 'Culleeny Beg (Kerry)', zip: '454501' },
	{ city: 'Culleeny More (Kerry)', zip: '778661' },
	{ city: 'Cullen (Cork)', zip: '118680' },
	{ city: 'Cullen (Meath)', zip: '398211' },
	{ city: 'Cullen (Tipperary)', zip: '896263' },
	{ city: 'Cullenagh (Clare)', zip: '493913' },
	{ city: 'Cullenagh (Cork)', zip: '267786' },
	{ city: 'Cullenagh (Galway)', zip: '642969' },
	{ city: 'Cullenagh (Kerry)', zip: '467267' },
	{ city: 'Cullenagh (Laois)', zip: '504926' },
	{ city: 'Cullenagh (Limerick)', zip: '893508' },
	{ city: 'Cullenagh (Tipperary)', zip: '791773' },
	{ city: 'Cullenagh (Waterford)', zip: '856813' },
	{ city: 'Cullenagh Beg (Galway)', zip: '611507' },
	{ city: 'Cullenagh Lower (Kerry)', zip: '959947' },
	{ city: 'Cullenagh More (Galway)', zip: '424453' },
	{ city: 'Cullenagh South (Tipperary)', zip: '734096' },
	{ city: 'Cullenagh Upper (Kerry)', zip: '278491' },
	{ city: 'Cullen And Brownhill (Leitrim)', zip: '759892' },
	{ city: 'Cullencastle (Waterford)', zip: '942444' },
	{ city: 'Cullendragh (Meath)', zip: '654266' },
	{ city: 'Cullen Hill (Dublin)', zip: '592930' },
	{ city: 'Cullenhugh (Westmeath)', zip: '180052' },
	{ city: 'Cullen Lower (Wicklow)', zip: '949767' },
	{ city: 'Cullenmore (Wicklow)', zip: '902056' },
	{ city: 'Cullenoge (Wexford)', zip: '177272' },
	{ city: 'Cullenrevagh (Roscommon)', zip: '954927' },
	{ city: 'Cullenstown (Wexford)', zip: '828930' },
	{ city: 'Cullentra (Wexford)', zip: '842041' },
	{ city: 'Cullentragh (Cavan)', zip: '530805' },
	{ city: 'Cullentragh (Kilkenny)', zip: '344750' },
	{ city: 'Cullentragh (Leitrim)', zip: '467777' },
	{ city: 'Cullentragh (Longford)', zip: '907684' },
	{ city: 'Cullentragh (Mayo)', zip: '222931' },
	{ city: 'Cullentragh (Wexford)', zip: '343727' },
	{ city: 'Cullentraghbane (Monaghan)', zip: '355464' },
	{ city: 'Cullentragh Big (Wicklow)', zip: '223305' },
	{ city: 'Cullentraghduff (Monaghan)', zip: '196648' },
	{ city: 'Cullentragh Little (Wicklow)', zip: '828516' },
	{ city: 'Cullentragh Park (Wicklow)', zip: '248240' },
	{ city: 'Cullentry (Meath)', zip: '820156' },
	{ city: 'Cullen Upper (Wicklow)', zip: '612809' },
	{ city: 'Cullenwaine (Offaly)', zip: '881699' },
	{ city: 'Culliagh (Cavan)', zip: '154534' },
	{ city: 'Culliagh (Donegal)', zip: '558008' },
	{ city: 'Culliagh (Mayo)', zip: '855740' },
	{ city: 'Culliagharny (Roscommon)', zip: '928780' },
	{ city: 'Culliaghbeg (Roscommon)', zip: '399802' },
	{ city: 'Culliagh Beg (Galway)', zip: '435567' },
	{ city: 'Culliagh Lower (Roscommon)', zip: '424608' },
	{ city: 'Culliaghmore (Roscommon)', zip: '603436' },
	{ city: 'Culliagh More (Galway)', zip: '654183' },
	{ city: 'Culliagh North (Galway)', zip: '927622' },
	{ city: 'Culliagh South (Galway)', zip: '314759' },
	{ city: 'Culliagh Upper (Roscommon)', zip: '940217' },
	{ city: 'Culliaghy (Roscommon)', zip: '698915' },
	{ city: 'Cullies (Cavan)', zip: '787507' },
	{ city: 'Cullies (Leitrim)', zip: '694294' },
	{ city: 'Cullig (Cork)', zip: '979215' },
	{ city: 'Cullin (Cavan)', zip: '120487' },
	{ city: 'Cullin (Mayo)', zip: '392670' },
	{ city: 'Cullinagh (Kerry)', zip: '989721' },
	{ city: 'Cullion (Cavan)', zip: '706724' },
	{ city: 'Cullion (Donegal)', zip: '736572' },
	{ city: 'Cullionboy (Donegal)', zip: '848220' },
	{ city: 'Cullionboy (Leitrim)', zip: '193781' },
	{ city: 'Culloge (Longford)', zip: '118983' },
	{ city: 'Cullomane East (Cork)', zip: '350669' },
	{ city: 'Cullomane West (Cork)', zip: '141903' },
	{ city: 'Cullow (Cavan)', zip: '866926' },
	{ city: 'Cully (Leitrim)', zip: '319907' },
	{ city: 'Cully (Offaly)', zip: '336661' },
	{ city: 'Cully (Sligo)', zip: '969021' },
	{ city: 'Cullyleenan (Cavan)', zip: '597736' },
	{ city: 'Culmullin (Meath)', zip: '716437' },
	{ city: 'Culnacleha (Mayo)', zip: '738901' },
	{ city: 'Culnagore (Galway)', zip: '221245' },
	{ city: 'Culnagore (Longford)', zip: '524281' },
	{ city: 'Culoort (Donegal)', zip: '174429' },
	{ city: 'Culray (Longford)', zip: '638333' },
	{ city: 'Cultiafadda (Galway)', zip: '451164' },
	{ city: 'Cultromer (Meath)', zip: '850863' },
	{ city: 'Culvin (Westmeath)', zip: '101551' },
	{ city: 'Cum (Mayo)', zip: '268639' },
	{ city: 'Cumask (Tipperary)', zip: '746016' },
	{ city: 'Cumber Lower (Offaly)', zip: '585305' },
	{ city: 'Cumber Upper (Offaly)', zip: '518122' },
	{ city: 'Cummeen (Cork)', zip: '560415' },
	{ city: 'Cummeen (Kerry)', zip: '154895' },
	{ city: 'Cummeen (Limerick)', zip: '918357' },
	{ city: 'Cummeen (Offaly)', zip: '549531' },
	{ city: 'Cummeen (Sligo)', zip: '369880' },
	{ city: 'Cummeen (Waterford)', zip: '396309' },
	{ city: 'Cummeenavrick (Kerry)', zip: '988073' },
	{ city: 'Cummeenboy (Kerry)', zip: '106374' },
	{ city: 'Cummeenduvasig (Kerry)', zip: '726544' },
	{ city: 'Cummeengeera (Kerry)', zip: '319964' },
	{ city: 'Cummeen Lower (Kerry)', zip: '896550' },
	{ city: 'Cummeennabuddoge (Kerry)', zip: '131222' },
	{ city: 'Cummeenshrule (Kerry)', zip: '836062' },
	{ city: 'Cummeen Upper (Kerry)', zip: '890787' },
	{ city: 'Cummer (Galway)', zip: '435843' },
	{ city: 'Cummer (Laois)', zip: '604558' },
	{ city: 'Cummer (Mayo)', zip: '984464' },
	{ city: 'Cummer (Tipperary)', zip: '850264' },
	{ city: 'Cummer (Wexford)', zip: '780106' },
	{ city: 'Cummer Beg (Tipperary)', zip: '191009' },
	{ city: 'Cummerduff (Cork)', zip: '405125' },
	{ city: 'Cummerduff (Wexford)', zip: '112922' },
	{ city: 'Cummer More (Tipperary)', zip: '501823' },
	{ city: 'Cummers East (Kerry)', zip: '714330' },
	{ city: 'Cummerstown (Westmeath)', zip: '876927' },
	{ city: 'Cummers West (Kerry)', zip: '260967' },
	{ city: 'Cummery Connell (Cork)', zip: '510826' },
	{ city: 'Cumminstown (Westmeath)', zip: '123245' },
	{ city: 'Cummirk (Donegal)', zip: '145721' },
	{ city: 'Cumry (Monaghan)', zip: '460959' },
	{ city: 'Cumshinstown (Wexford)', zip: '398016' },
	{ city: 'Cunaberry (Carlow)', zip: '262158' },
	{ city: 'Cunard (Dublin)', zip: '685053' },
	{ city: 'Cunghill (Sligo)', zip: '534310' },
	{ city: 'Cunlaghfadda (Mayo)', zip: '325319' },
	{ city: 'Cunlin (Donegal)', zip: '464535' },
	{ city: 'Cunnagare (Kerry)', zip: '612229' },
	{ city: 'Cunnagavale (Limerick)', zip: '394431' },
	{ city: 'Cunnagher North (Mayo)', zip: '140153' },
	{ city: 'Cunnagher South (Mayo)', zip: '956440' },
	{ city: 'Cunnahurt East (Tipperary)', zip: '684575' },
	{ city: 'Cunnahurt West (Tipperary)', zip: '628042' },
	{ city: 'Cunnaker (Mayo)', zip: '793148' },
	{ city: 'Cunnamore (Cork)', zip: '453698' },
	{ city: 'Cunnavoola (Kerry)', zip: '212066' },
	{ city: 'Cunniamstown Big (Wicklow)', zip: '564743' },
	{ city: 'Cunniamstown Little (Wicklow)', zip: '422142' },
	{ city: 'Cunnicar (Louth)', zip: '378433' },
	{ city: 'Cunnigar (Waterford)', zip: '411327' },
	{ city: 'Cunnihee (Limerick)', zip: '404177' },
	{ city: 'Cunnion (Leitrim)', zip: '178339' },
	{ city: 'Cupidstown (Kildare)', zip: '355330' },
	{ city: 'Cupidstownhill (Kildare)', zip: '899004' },
	{ city: 'Cuppage (Cork)', zip: '652658' },
	{ city: 'Cuppanagh (Sligo)', zip: '672389' },
	{ city: 'Cur (Galway)', zip: '979574' },
	{ city: 'Curclogh (Wexford)', zip: '236114' },
	{ city: 'Curheen (Galway)', zip: '431340' },
	{ city: 'Curhoor (Galway)', zip: '667250' },
	{ city: 'Curhownagh (Galway)', zip: '780315' },
	{ city: 'Curkacrone (Kilkenny)', zip: '289785' },
	{ city: 'Curkeen (Meath)', zip: '853675' },
	{ city: 'Curkin (Monaghan)', zip: '357318' },
	{ city: 'Curleyland And Mill Land (Meath)', zip: '913460' },
	{ city: 'Curneen (Mayo)', zip: '793216' },
	{ city: 'Curniaghanstown (Meath)', zip: '468477' },
	{ city: 'Curra (Cork)', zip: '582157' },
	{ city: 'Curra (Galway)', zip: '315611' },
	{ city: 'Curra (Kerry)', zip: '357242' },
	{ city: 'Currabaha (Tipperary)', zip: '661356' },
	{ city: 'Currabaha (Waterford)', zip: '902975' },
	{ city: 'Currabaha East (Waterford)', zip: '161926' },
	{ city: 'Currabaha West (Waterford)', zip: '989686' },
	{ city: 'Currabally (Cork)', zip: '501954' },
	{ city: 'Currabanefield (Kerry)', zip: '901343' },
	{ city: 'Currabeg (Cork)', zip: '619362' },
	{ city: 'Currabeg (Kerry)', zip: '602026' },
	{ city: 'Currabeg (Offaly)', zip: '747690' },
	{ city: 'Curra Beg (Limerick)', zip: '729808' },
	{ city: 'Currabeha (Cork)', zip: '637365' },
	{ city: 'Curraboy (Mayo)', zip: '146982' },
	{ city: 'Currabwee (Cork)', zip: '396155' },
	{ city: 'Curracahill (Cork)', zip: '992535' },
	{ city: 'Curracitty (Kerry)', zip: '897372' },
	{ city: 'Curracloe (Wexford)', zip: '318994' },
	{ city: 'Curraclogh (Cork)', zip: '660248' },
	{ city: 'Curracloghan (Cavan)', zip: '827287' },
	{ city: 'Curraclone (Laois)', zip: '190641' },
	{ city: 'Curracullenagh (Kerry)', zip: '155509' },
	{ city: 'Curradarra (Waterford)', zip: '110815' },
	{ city: 'Curraderra (Clare)', zip: '515914' },
	{ city: 'Curradonohoe (Cork)', zip: '326204' },
	{ city: 'Curradrinagh (Cork)', zip: '212857' },
	{ city: 'Curraduff (Cork)', zip: '430404' },
	{ city: 'Curraduff (Kerry)', zip: '725145' },
	{ city: 'Curraduff (Tipperary)', zip: '763031' },
	{ city: 'Curraduff (Wexford)', zip: '873283' },
	{ city: 'Currafarry (Galway)', zip: '954392' },
	{ city: 'Curraflugh (Kerry)', zip: '903925' },
	{ city: 'Curragh (Carlow)', zip: '468971' },
	{ city: 'Curragh (Clare)', zip: '129297' },
	{ city: 'Curragh (Cork)', zip: '375612' },
	{ city: 'Curragh (Donegal)', zip: '639646' },
	{ city: 'Curragh (Galway)', zip: '590230' },
	{ city: 'Curragh (Kerry)', zip: '218284' },
	{ city: 'Curragh (Kildare)', zip: '554746' },
	{ city: 'Curragh (Kilkenny)', zip: '725092' },
	{ city: 'Curragh (Laois)', zip: '604588' },
	{ city: 'Curragh (Limerick)', zip: '998436' },
	{ city: 'Curragh (Mayo)', zip: '683391' },
	{ city: 'Curragh (Meath)', zip: '253340' },
	{ city: 'Curragh (Offaly)', zip: '211935' },
	{ city: 'Curragh (Roscommon)', zip: '159649' },
	{ city: 'Curragh (Tipperary)', zip: '290561' },
	{ city: 'Curragh (Waterford)', zip: '148380' },
	{ city: 'Curragh (Westmeath)', zip: '751356' },
	{ city: 'Curragh (Wexford)', zip: '212822' },
	{ city: 'Curragha (Leitrim)', zip: '222233' },
	{ city: 'Curraghaboy (Leitrim)', zip: '392390' },
	{ city: 'Curraghabreedin (Cavan)', zip: '732210' },
	{ city: 'Curraghabweehan (Cavan)', zip: '651161' },
	{ city: 'Curraghacnav (Waterford)', zip: '730947' },
	{ city: 'Curraghacronacon (Laois)', zip: '244585' },
	{ city: 'Curraghacruit (Carlow)', zip: '222689' },
	{ city: 'Curraghaderry (Galway)', zip: '500386' },
	{ city: 'Curraghaderry (Mayo)', zip: '681721' },
	{ city: 'Curraghadobbin (Tipperary)', zip: '465983' },
	{ city: 'Curraghadoo (Clare)', zip: '123803' },
	{ city: 'Curraghadooey (Mayo)', zip: '701845' },
	{ city: 'Curraghadoon (Roscommon)', zip: '636486' },
	{ city: 'Curraghafeaghan (Donegal)', zip: '980831' },
	{ city: 'Curraghafoil (Limerick)', zip: '731391' },
	{ city: 'Curraghagalla North (Cork)', zip: '393017' },
	{ city: 'Curraghagalla South (Cork)', zip: '585313' },
	{ city: 'Curraghagower (Roscommon)', zip: '752299' },
	{ city: 'Curraghakerry (Cork)', zip: '302300' },
	{ city: 'Curraghakimikeen (Limerick)', zip: '743738' },
	{ city: 'Curraghalaher (Roscommon)', zip: '646214' },
	{ city: 'Curraghalane (Donegal)', zip: '977754' },
	{ city: 'Curraghalassa (Offaly)', zip: '772257' },
	{ city: 'Curraghaleen (Roscommon)', zip: '330432' },
	{ city: 'Curraghalehane (Cork)', zip: '804330' },
	{ city: 'Curraghalicky (Cork)', zip: '503668' },
	{ city: 'Curraghan (Leitrim)', zip: '369552' },
	{ city: 'Curraghanaltig (Cork)', zip: '509899' },
	{ city: 'Curraghanana (Offaly)', zip: '731214' },
	{ city: 'Curraghanearla (Cork)', zip: '759352' },
	{ city: 'Curraghaneety (Tipperary)', zip: '541972' },
	{ city: 'Curraghanoe (Cavan)', zip: '765154' },
	{ city: 'Curraghanolomer (Cork)', zip: '218463' },
	{ city: 'Curraghanuddy (Tipperary)', zip: '114654' },
	{ city: 'Curraghard (Cork)', zip: '742987' },
	{ city: 'Curraghard (Roscommon)', zip: '548120' },
	{ city: 'Curragharneen (Tipperary)', zip: '137238' },
	{ city: 'Curraghashillaun (Leitrim)', zip: '331648' },
	{ city: 'Curraghataggart (Waterford)', zip: '345332' },
	{ city: 'Curraghatawy (Leitrim)', zip: '645076' },
	{ city: 'Curraghateskin (Waterford)', zip: '862197' },
	{ city: 'Curraghatoor (Tipperary)', zip: '262775' },
	{ city: 'Curraghatoosane (Kerry)', zip: '911115' },
	{ city: 'Curraghatouk (Kerry)', zip: '898838' },
	{ city: 'Curraghaun (Galway)', zip: '254806' },
	{ city: 'Curraghavaddra (Cork)', zip: '988528' },
	{ city: 'Curraghavarna And Portavolla (Offaly)', zip: '319731' },
	{ city: 'Curraghaveara (Limerick)', zip: '679526' },
	{ city: 'Curraghaviller (Tipperary)', zip: '761570' },
	{ city: 'Curraghavoe (Cork)', zip: '841507' },
	{ city: 'Curraghavogy (Donegal)', zip: '273867' },
	{ city: 'Curraghavoke (Tipperary)', zip: '291585' },
	{ city: 'Curraghawaddra (Cork)', zip: '492171' },
	{ city: 'Curraghbaghla (Galway)', zip: '322190' },
	{ city: 'Curraghballintlea (Waterford)', zip: '580602' },
	{ city: 'Curraghbane (Westmeath)', zip: '432204' },
	{ city: 'Curraghbaun (Mayo)', zip: '441688' },
	{ city: 'Curraghbaun (Tipperary)', zip: '812122' },
	{ city: 'Curraghbeg (Cork)', zip: '620935' },
	{ city: 'Curraghbeg (Limerick)', zip: '242509' },
	{ city: 'Curraghbeg (Louth)', zip: '587676' },
	{ city: 'Curraghbeg (Westmeath)', zip: '825610' },
	{ city: 'Curragh Beg (Galway)', zip: '449382' },
	{ city: 'Curragh Beg (Kerry)', zip: '741923' },
	{ city: 'Curraghbehy (Kilkenny)', zip: '238473' },
	{ city: 'Curraghbinny (Cork)', zip: '891102' },
	{ city: 'Curraghbog (Galway)', zip: '768791' },
	{ city: 'Curraghbonaun (Sligo)', zip: '432377' },
	{ city: 'Curraghbowen (Cork)', zip: '129501' },
	{ city: 'Curraghbower (Cork)', zip: '782290' },
	{ city: 'Curraghboy (Cork)', zip: '167785' },
	{ city: 'Curraghboy (Galway)', zip: '670022' },
	{ city: 'Curraghboy (Mayo)', zip: '994862' },
	{ city: 'Curraghboy (Offaly)', zip: '760428' },
	{ city: 'Curraghboy (Roscommon)', zip: '979023' },
	{ city: 'Curraghboy (Sligo)', zip: '661276' },
	{ city: 'Curraghboy (Westmeath)', zip: '565862' },
	{ city: 'Curraghbrack (Westmeath)', zip: '259002' },
	{ city: 'Curraghbridge (Limerick)', zip: '148551' },
	{ city: 'Curragh Camp (Kildare)', zip: '529077' },
	{ city: 'Curraghcarroll (Tipperary)', zip: '746695' },
	{ city: 'Curraghcloney (Tipperary)', zip: '477433' },
	{ city: 'Curraghcloonabro East (Cork)', zip: '908125' },
	{ city: 'Curraghcloonabro West (Cork)', zip: '967650' },
	{ city: 'Curraghcondon (Cork)', zip: '929524' },
	{ city: 'Curraghconway (Cork)', zip: '562723' },
	{ city: 'Curraghcreen (Cork)', zip: '620409' },
	{ city: 'Curraghcreen (Galway)', zip: '525901' },
	{ city: 'Curraghcroneen (Kerry)', zip: '610549' },
	{ city: 'Curraghcrowly East (Cork)', zip: '863000' },
	{ city: 'Curraghcrowly West (Cork)', zip: '908124' },
	{ city: 'Curraghdermot (Cork)', zip: '587794' },
	{ city: 'Curraghderrig (Kerry)', zip: '673329' },
	{ city: 'Curraghdoo (Meath)', zip: '919498' },
	{ city: 'Curraghduff (Kilkenny)', zip: '628904' },
	{ city: 'Curraghduff (Tipperary)', zip: '228791' },
	{ city: 'Curraghduff (Waterford)', zip: '995077' },
	{ city: 'Curraghduff (Wexford)', zip: '637272' },
	{ city: 'Curraghduff East (Galway)', zip: '756911' },
	{ city: 'Curraghduff Middle (Galway)', zip: '366517' },
	{ city: 'Curraghduff West (Galway)', zip: '956893' },
	{ city: 'Curraghduffy (Roscommon)', zip: '627058' },
	{ city: 'Curragh East (Cork)', zip: '321151' },
	{ city: 'Curragh East (Dublin)', zip: '732254' },
	{ city: 'Curragh East (Galway)', zip: '620553' },
	{ city: 'Curragheenbrien (Cork)', zip: '237434' },
	{ city: 'Curraghfarm (Kildare)', zip: '101586' },
	{ city: 'Curraghfore (Leitrim)', zip: '141323' },
	{ city: 'Curraghfurnisha (Tipperary)', zip: '510850' },
	{ city: 'Curraghglass (Cavan)', zip: '837367' },
	{ city: 'Curraghglass (Tipperary)', zip: '323057' },
	{ city: 'Curraghgorm (Cork)', zip: '236378' },
	{ city: 'Curraghgraigue (Tipperary)', zip: '747228' },
	{ city: 'Curraghgraigue (Wexford)', zip: '450863' },
	{ city: 'Curraghgraigue Lower (Tipperary)', zip: '548097' },
	{ city: 'Curraghgraigue Upper (Tipperary)', zip: '632807' },
	{ city: 'Curraghgrane Beg (Cork)', zip: '690729' },
	{ city: 'Curraghgrane More (Cork)', zip: '667107' },
	{ city: 'Curraghishal (Cork)', zip: '494209' },
	{ city: 'Curraghkeal (Tipperary)', zip: '470968' },
	{ city: 'Curraghkeel (Cavan)', zip: '560672' },
	{ city: 'Curraghkeel (Clare)', zip: '425144' },
	{ city: 'Curraghkehoe (Kilkenny)', zip: '625734' },
	{ city: 'Curraghkiely (Waterford)', zip: '910363' },
	{ city: 'Curraghkilbran (Limerick)', zip: '714538' },
	{ city: 'Curraghkilleen (Clare)', zip: '898574' },
	{ city: 'Curraghlahan (Limerick)', zip: '919120' },
	{ city: 'Curraghlahan (Mayo)', zip: '354167' },
	{ city: 'Curraghlahan (Offaly)', zip: '520171' },
	{ city: 'Curraghlane (Kilkenny)', zip: '587948' },
	{ city: 'Curraghlane Lower (Kilkenny)', zip: '996448' },
	{ city: 'Curraghlane Upper (Kilkenny)', zip: '953434' },
	{ city: 'Curraghlawn (Wicklow)', zip: '770009' },
	{ city: 'Curraghlea (Donegal)', zip: '119163' },
	{ city: 'Curraghleagh (Cork)', zip: '552498' },
	{ city: 'Curraghleha East (Kerry)', zip: '885686' },
	{ city: 'Curraghlehanagh (Galway)', zip: '168803' },
	{ city: 'Curraghleha West (Kerry)', zip: '694841' },
	{ city: 'Curraghleigh (Tipperary)', zip: '990306' },
	{ city: 'Curragh Lower (Cork)', zip: '883418' },
	{ city: 'Curragh Lower (Offaly)', zip: '618275' },
	{ city: 'Curraghmacdonagh (Kerry)', zip: '475421' },
	{ city: 'Curraghmarky (Tipperary)', zip: '108620' },
	{ city: 'Curraghmartin (Kilkenny)', zip: '102524' },
	{ city: 'Curraghmartin (Leitrim)', zip: '328253' },
	{ city: 'Curraghmeelagh (Offaly)', zip: '649439' },
	{ city: 'Curraghmoghaun (Clare)', zip: '180590' },
	{ city: 'Curraghmore (Cavan)', zip: '951251' },
	{ city: 'Curraghmore (Galway)', zip: '413302' },
	{ city: 'Curraghmore (Kilkenny)', zip: '158696' },
	{ city: 'Curraghmore (Laois)', zip: '314973' },
	{ city: 'Curraghmore (Longford)', zip: '685462' },
	{ city: 'Curraghmore (Mayo)', zip: '192601' },
	{ city: 'Curraghmore (Offaly)', zip: '991786' },
	{ city: 'Curraghmore (Sligo)', zip: '314451' },
	{ city: 'Curraghmore (Tipperary)', zip: '106634' },
	{ city: 'Curraghmore (Waterford)', zip: '110910' },
	{ city: 'Curraghmore (Westmeath)', zip: '888637' },
	{ city: 'Curraghmore (Wexford)', zip: '477905' },
	{ city: 'Curragh More (Cork)', zip: '827304' },
	{ city: 'Curragh More (Galway)', zip: '320195' },
	{ city: 'Curragh More (Kerry)', zip: '488873' },
	{ city: 'Curraghmore East (Kerry)', zip: '802864' },
	{ city: 'Curraghmoreen (Waterford)', zip: '299473' },
	{ city: 'Curraghmore West (Kerry)', zip: '417181' },
	{ city: 'Curraghmulmurry (Galway)', zip: '820902' },
	{ city: 'Curraghnabania (Leitrim)', zip: '436396' },
	{ city: 'Curraghnabola (Wexford)', zip: '784362' },
	{ city: 'Curraghnaboley (Roscommon)', zip: '681689' },
	{ city: 'Curraghnaboll (Roscommon)', zip: '407579' },
	{ city: 'Curraghnaboola (Tipperary)', zip: '924304' },
	{ city: 'Curraghnaboul (Limerick)', zip: '292884' },
	{ city: 'Curraghnadeely (Limerick)', zip: '446470' },
	{ city: 'Curraghnadeige (Laois)', zip: '444317' },
	{ city: 'Curraghnadimpaun (Kilkenny)', zip: '516960' },
	{ city: 'Curraghnagap (Sligo)', zip: '172121' },
	{ city: 'Curraghnagarraha (Waterford)', zip: '388773' },
	{ city: 'Curraghnagree (Waterford)', zip: '166306' },
	{ city: 'Curraghnalaght (Cork)', zip: '870137' },
	{ city: 'Curraghnaloughra (Cork)', zip: '562935' },
	{ city: 'Curraghnamaddree (Waterford)', zip: '645955' },
	{ city: 'Curraghnamoe (Tipperary)', zip: '416268' },
	{ city: 'Curraghnanav (Kerry)', zip: '329158' },
	{ city: 'Curraghnatinny (Tipperary)', zip: '938029' },
	{ city: 'Curraghnaveen (Roscommon)', zip: '573176' },
	{ city: 'Curraghnawall (Leitrim)', zip: '508929' },
	{ city: 'Curragho (Cavan)', zip: '129560' },
	{ city: 'Curraghoaghry (Leitrim)', zip: '202805' },
	{ city: 'Curraghodea (Clare)', zip: '911664' },
	{ city: 'Curraghomongan (Donegal)', zip: '647053' },
	{ city: 'Curraghoo Beg (Cork)', zip: '880634' },
	{ city: 'Curraghoo More (Cork)', zip: '307864' },
	{ city: 'Curraghphadeen (Cork)', zip: '295996' },
	{ city: 'Curraghphilipeen (Waterford)', zip: '916867' },
	{ city: 'Curraghphlibbode (Cork)', zip: '476393' },
	{ city: 'Curraghpoor (Tipperary)', zip: '601006' },
	{ city: 'Curraghprevin (Cork)', zip: '698441' },
	{ city: 'Curraghreigh North (Waterford)', zip: '636341' },
	{ city: 'Curraghreigh South (Waterford)', zip: '223284' },
	{ city: 'Curraghrevagh (Galway)', zip: '834446' },
	{ city: 'Curraghroche (Limerick)', zip: '503073' },
	{ city: 'Curraghroche (Waterford)', zip: '725355' },
	{ city: 'Curraghroe (Galway)', zip: '472350' },
	{ city: 'Curraghroe (Roscommon)', zip: '830056' },
	{ city: 'Curraghroodle (Westmeath)', zip: '799425' },
	{ city: 'Curraghrour East (Cork)', zip: '891081' },
	{ city: 'Curraghrour West (Cork)', zip: '342524' },
	{ city: 'Curraghs (Cork)', zip: '776010' },
	{ city: 'Curraghs (Galway)', zip: '955775' },
	{ city: 'Curraghsallagh (Roscommon)', zip: '483905' },
	{ city: 'Curraghscarteen (Kilkenny)', zip: '256703' },
	{ city: 'Curraghscarteen (Tipperary)', zip: '373716' },
	{ city: 'Curraghslagh (Tipperary)', zip: '806986' },
	{ city: 'Curraghs North (Leitrim)', zip: '861382' },
	{ city: 'Curraghs South (Leitrim)', zip: '526797' },
	{ city: 'Curraghtarsna (Tipperary)', zip: '966992' },
	{ city: 'Curraghteemore (Cork)', zip: '722036' },
	{ city: 'Curraghteemore (Mayo)', zip: '299381' },
	{ city: 'Curraghtemple (Tipperary)', zip: '893490' },
	{ city: 'Curraghtown (Meath)', zip: '896736' },
	{ city: 'Curraghturk (Limerick)', zip: '850721' },
	{ city: 'Curragh Upper (Cork)', zip: '292671' },
	{ city: 'Curragh Upper (Offaly)', zip: '443999' },
	{ city: 'Curraghvah (Cavan)', zip: '700551' },
	{ city: 'Curraghwalls (Meath)', zip: '709952' },
	{ city: 'Curraghweesha (Kerry)', zip: '122361' },
	{ city: 'Curragh West (Cork)', zip: '370674' },
	{ city: 'Curragh West (Dublin)', zip: '877024' },
	{ city: 'Curragh West (Galway)', zip: '941655' },
	{ city: 'Curraghwheery (Offaly)', zip: '813782' },
	{ city: 'Curraghwood (Wexford)', zip: '807984' },
	{ city: 'Curraglass (Cork)', zip: '845093' },
	{ city: 'Curraglass (Kerry)', zip: '107566' },
	{ city: 'Curraglass East (Cork)', zip: '172307' },
	{ city: 'Curraglass North (Kerry)', zip: '744225' },
	{ city: 'Curraglass South (Kerry)', zip: '353536' },
	{ city: 'Curraglass West (Cork)', zip: '701205' },
	{ city: 'Curragraig (Waterford)', zip: '933689' },
	{ city: 'Curragraigue (Kerry)', zip: '862112' },
	{ city: 'Curragrine (Cork)', zip: '945629' },
	{ city: 'Curragunneen (Tipperary)', zip: '687282' },
	{ city: 'Currahaly (Cork)', zip: '702412' },
	{ city: 'Currahchase (Limerick)', zip: '634398' },
	{ city: 'Currahchase North (Limerick)', zip: '183568' },
	{ city: 'Curraheen (Cork)', zip: '295460' },
	{ city: 'Curraheen (Kerry)', zip: '955155' },
	{ city: 'Curraheen (Limerick)', zip: '422448' },
	{ city: 'Curraheen (Tipperary)', zip: '425735' },
	{ city: 'Curraheen (Waterford)', zip: '427131' },
	{ city: 'Curraheenaris (Waterford)', zip: '780705' },
	{ city: 'Curraheenavoher (Waterford)', zip: '291899' },
	{ city: 'Curraheen Commons (Waterford)', zip: '430244' },
	{ city: 'Curraheenduff (Tipperary)', zip: '719590' },
	{ city: 'Curraheen Little (Kerry)', zip: '472152' },
	{ city: 'Curraheen North (Limerick)', zip: '760949' },
	{ city: 'Curraheen North (Waterford)', zip: '179127' },
	{ city: 'Curraheen South (Limerick)', zip: '265341' },
	{ city: 'Curraheen South (Waterford)', zip: '263560' },
	{ city: 'Currahevern East (Cork)', zip: '684006' },
	{ city: 'Currahevern West (Cork)', zip: '522500' },
	{ city: 'Currahill Lower (Kilkenny)', zip: '895524' },
	{ city: 'Currahill Upper (Kilkenny)', zip: '711017' },
	{ city: 'Currahoo (Cork)', zip: '450021' },
	{ city: 'Currahy (Cork)', zip: '712654' },
	{ city: 'Currakeal (Cork)', zip: '901133' },
	{ city: 'Currakillane (Cork)', zip: '845899' },
	{ city: 'Curraknockaun (Kerry)', zip: '332918' },
	{ city: 'Curralane (Wexford)', zip: '874078' },
	{ city: 'Curralane Oldtown (Wexford)', zip: '861419' },
	{ city: 'Curralanty (Offaly)', zip: '760591' },
	{ city: 'Curraleagh (Cork)', zip: '625588' },
	{ city: 'Curraleigh (Cork)', zip: '208033' },
	{ city: 'Curraleigh East (Tipperary)', zip: '151608' },
	{ city: 'Curraleigh West (Tipperary)', zip: '556378' },
	{ city: 'Curramore (Cork)', zip: '261679' },
	{ city: 'Curramore (Mayo)', zip: '664752' },
	{ city: 'Curra More (Limerick)', zip: '500373' },
	{ city: 'Curranashingane (Cork)', zip: '679392' },
	{ city: 'Currane (Carlow)', zip: '930808' },
	{ city: 'Currane (Cork)', zip: '463100' },
	{ city: 'Currane (Waterford)', zip: '242205' },
	{ city: 'Curranny (Mayo)', zip: '203420' },
	{ city: 'Curranstown Lower (Wicklow)', zip: '816586' },
	{ city: 'Curranstown Upper (Wicklow)', zip: '145013' },
	{ city: 'Currantawy (Mayo)', zip: '141590' },
	{ city: 'Curranure (Cork)', zip: '837620' },
	{ city: 'Currarane (Cork)', zip: '579323' },
	{ city: 'Currarevagh (Galway)', zip: '452517' },
	{ city: 'Curraross (Kerry)', zip: '725532' },
	{ city: 'Currasilla Lower (Tipperary)', zip: '134047' },
	{ city: 'Currasilla Upper (Tipperary)', zip: '180100' },
	{ city: 'Curratober (Clare)', zip: '312104' },
	{ city: 'Curratubbin Lower (Wexford)', zip: '292272' },
	{ city: 'Curratubbin Upper (Wexford)', zip: '868288' },
	{ city: 'Currauly (Kerry)', zip: '957534' },
	{ city: 'Curraun (Leitrim)', zip: '770478' },
	{ city: 'Curraun (Waterford)', zip: '469286' },
	{ city: 'Curraun (Wexford)', zip: '989958' },
	{ city: 'Curraun Beg (Galway)', zip: '583956' },
	{ city: 'Curraunboy (Mayo)', zip: '123879' },
	{ city: 'Curraun Hill (Galway)', zip: '777626' },
	{ city: 'Curraun More (Galway)', zip: '900836' },
	{ city: 'Curravaha (Kerry)', zip: '418976' },
	{ city: 'Curravally (Cork)', zip: '996837' },
	{ city: 'Curravanish (Wicklow)', zip: '188680' },
	{ city: 'Curravarahane (Cork)', zip: '933576' },
	{ city: 'Curraveha (Galway)', zip: '372124' },
	{ city: 'Curravogh North (Kerry)', zip: '634523' },
	{ city: 'Curravogh South (Kerry)', zip: '250208' },
	{ city: 'Curravohill (Cork)', zip: '255756' },
	{ city: 'Curravoola (Kerry)', zip: '392792' },
	{ city: 'Curravordy (Cork)', zip: '892261' },
	{ city: 'Currawatia (Galway)', zip: '319604' },
	{ city: 'Curreal (Kerry)', zip: '933799' },
	{ city: 'Curreen (Longford)', zip: '119192' },
	{ city: 'Curreentorpan (Roscommon)', zip: '292167' },
	{ city: 'Curreeny (Tipperary)', zip: '455816' },
	{ city: 'Curreeny Commons (Tipperary)', zip: '744318' },
	{ city: 'Currenree (Carlow)', zip: '440019' },
	{ city: 'Currenstown (Tipperary)', zip: '628811' },
	{ city: 'Curriersbog (Laois)', zip: '647539' },
	{ city: 'Curries (Galway)', zip: '685107' },
	{ city: 'Curries (Mayo)', zip: '482143' },
	{ city: 'Curries (Westmeath)', zip: '966878' },
	{ city: 'Currin (Donegal)', zip: '441705' },
	{ city: 'Currinah (Roscommon)', zip: '565302' },
	{ city: 'Curristeen (Westmeath)', zip: '319117' },
	{ city: 'Curristown (Westmeath)', zip: '722855' },
	{ city: 'Currow (Kerry)', zip: '987452' },
	{ city: 'Curry (Galway)', zip: '330821' },
	{ city: 'Curry (Leitrim)', zip: '734976' },
	{ city: 'Curry (Longford)', zip: '612032' },
	{ city: 'Curry (Mayo)', zip: '276431' },
	{ city: 'Curry (Roscommon)', zip: '518019' },
	{ city: 'Curry (Sligo)', zip: '107849' },
	{ city: 'Curry (Westmeath)', zip: '476354' },
	{ city: 'Curryaun (Mayo)', zip: '472179' },
	{ city: 'Currycahill (Longford)', zip: '146600' },
	{ city: 'Curryclogh (Cork)', zip: '242094' },
	{ city: 'Currycreaghan (Longford)', zip: '796307' },
	{ city: 'Curryeallaun (Mayo)', zip: '512385' },
	{ city: 'Curry Eighter (Galway)', zip: '265091' },
	{ city: 'Curryglass (Cork)', zip: '972551' },
	{ city: 'Currygrane (Longford)', zip: '492912' },
	{ city: 'Currygranny (Longford)', zip: '930917' },
	{ city: 'Currygurry (Offaly)', zip: '989927' },
	{ city: 'Curryhills (Kildare)', zip: '715414' },
	{ city: 'Currylaur (Galway)', zip: '741457' },
	{ city: 'Currymount (Cork)', zip: '214772' },
	{ city: 'Currynanerriagh (Donegal)', zip: '378761' },
	{ city: 'Curry Oughter (Galway)', zip: '895915' },
	{ city: 'Curryquin (Tipperary)', zip: '809484' },
	{ city: 'Curryroe (Roscommon)', zip: '902366' },
	{ city: 'Currywongaun (Galway)', zip: '970731' },
	{ city: 'Curstown (Louth)', zip: '349150' },
	{ city: 'Curtaun (Galway)', zip: '983490' },
	{ city: 'Curtistown (Tipperary)', zip: '910777' },
	{ city: 'Curtistown Upper (Meath)', zip: '432285' },
	{ city: 'Curtiswood (Waterford)', zip: '328301' },
	{ city: 'Curtlestown Lower (Wicklow)', zip: '927945' },
	{ city: 'Curtlestown Upper (Wicklow)', zip: '699318' },
	{ city: 'Cusackstown (Meath)', zip: '958217' },
	{ city: 'Cuscarrick (Galway)', zip: '478258' },
	{ city: 'Cusduff (Cork)', zip: '724214' },
	{ city: 'Cush (Kildare)', zip: '941788' },
	{ city: 'Cush (Limerick)', zip: '434053' },
	{ city: 'Cush (Offaly)', zip: '527030' },
	{ city: 'Cushacorra (Clare)', zip: '981276' },
	{ city: 'Cushaling (Kildare)', zip: '227564' },
	{ city: 'Cushaling (Offaly)', zip: '587498' },
	{ city: 'Cushalogurt (Mayo)', zip: '269481' },
	{ city: 'Cushatrough (Galway)', zip: '115260' },
	{ city: 'Cushatrower (Galway)', zip: '594134' },
	{ city: 'Cushcallow (Offaly)', zip: '164559' },
	{ city: 'Cushcam (Waterford)', zip: '359294' },
	{ city: 'Cush East (Offaly)', zip: '556526' },
	{ city: 'Cushenstown (Wexford)', zip: '836385' },
	{ city: 'Cushina (Offaly)', zip: '609518' },
	{ city: 'Cushinkeel (Mayo)', zip: '748327' },
	{ city: 'Cushinsheeaun (Mayo)', zip: '684298' },
	{ city: 'Cushinstown (Meath)', zip: '628068' },
	{ city: 'Cushinstown (Westmeath)', zip: '729089' },
	{ city: 'Cushinyen (Mayo)', zip: '919981' },
	{ city: 'Cushlecka (Mayo)', zip: '313342' },
	{ city: 'Cush Lower (Laois)', zip: '597255' },
	{ city: 'Cushmaigmore (Galway)', zip: '303197' },
	{ city: 'Cushmona (Tipperary)', zip: '507752' },
	{ city: 'Cush Of Grange (Waterford)', zip: '330792' },
	{ city: 'Cush Upper (Laois)', zip: '957279' },
	{ city: 'Cuskernagh (Sligo)', zip: '150350' },
	{ city: 'Cuskinny (Cork)', zip: '200869' },
	{ city: 'Cuskry Glebe (Donegal)', zip: '461851' },
	{ city: 'Cuslough Demesne (Mayo)', zip: '783799' },
	{ city: 'Cusloura (Cork)', zip: '292106' },
	{ city: 'Cusovinna (Cork)', zip: '594643' },
	{ city: 'Cuss (Kerry)', zip: '310649' },
	{ city: 'Cussaboy (Monaghan)', zip: '590871' },
	{ city: 'Cussan (Kilkenny)', zip: '396680' },
	{ city: 'Cussana (Kilkenny)', zip: '852448' },
	{ city: 'Cussee (Monaghan)', zip: '668664' },
	{ city: 'Custodium (Wexford)', zip: '930973' },
	{ city: 'Custorum (Westmeath)', zip: '197542' },
	{ city: 'Cut Bush (Kildare)', zip: '228889' },
	{ city: 'Cutteanta (Sligo)', zip: '657359' },
	{ city: 'Cutteen (Clare)', zip: '415451' },
	{ city: 'Cutteen (Kerry)', zip: '388381' },
	{ city: 'Cutteen Beg (Clare)', zip: '672800' },
	{ city: 'Cutteen More (Clare)', zip: '618508' },
	{ city: 'Cutteen North (Waterford)', zip: '659862' },
	{ city: 'Cutteen South (Waterford)', zip: '707991' },
	{ city: 'Cuttragh (Cavan)', zip: '993169' },
	{ city: 'Cuttymanhill (Donegal)', zip: '117685' },
	{ city: 'Daars North (Kildare)', zip: '474725' },
	{ city: 'Daars South (Kildare)', zip: '257432' },
	{ city: 'Dabrian (Clare)', zip: '702354' },
	{ city: 'Dacklin (Roscommon)', zip: '205693' },
	{ city: 'Dadreen (Mayo)', zip: '669044' },
	{ city: 'Daggan (Cavan)', zip: '990588' },
	{ city: 'Daghloonagh (Sligo)', zip: '397959' },
	{ city: 'Daingean (Offaly)', zip: '403487' },
	{ city: 'Dairies (Cork)', zip: '152627' },
	{ city: 'Dairyfarm (Kildare)', zip: '696858' },
	{ city: 'Dairyhill (Kilkenny)', zip: '123728' },
	{ city: 'Dairyhill (Laois)', zip: '164002' },
	{ city: 'Dales (Louth)', zip: '991382' },
	{ city: "Daley's Island (Galway)", zip: '276113' },
	{ city: 'Dalgan (Offaly)', zip: '458696' },
	{ city: 'Dalgan Demesne (Mayo)', zip: '943831' },
	{ city: 'Dalgin (Galway)', zip: '640964' },
	{ city: 'Dalkey (Dublin)', zip: '579111' },
	{ city: 'Dalkey Commons (Dublin)', zip: '635307' },
	{ city: 'Dalkey Island (Dublin)', zip: '259940' },
	{ city: 'Dalkinstown (Kildare)', zip: '439773' },
	{ city: 'Dalraghan Beg (Donegal)', zip: '586027' },
	{ city: 'Dalraghan More (Donegal)', zip: '308729' },
	{ city: 'Dalteen (Mayo)', zip: '214698' },
	{ city: 'Dalysgrove (Galway)', zip: '322079' },
	{ city: 'Dalystown (Longford)', zip: '123303' },
	{ city: 'Dalystown (Meath)', zip: '287920' },
	{ city: 'Dalystown (Westmeath)', zip: '264129' },
	{ city: 'Dalystown Demesne (Galway)', zip: '949500' },
	{ city: 'Damastown (Dublin)', zip: '342807' },
	{ city: 'Damerstown East (Kilkenny)', zip: '574722' },
	{ city: 'Damerstown West (Kilkenny)', zip: '896581' },
	{ city: 'Damma Lower (Kilkenny)', zip: '968593' },
	{ city: 'Damma Upper (Kilkenny)', zip: '357802' },
	{ city: 'Damptown (Wexford)', zip: '760287' },
	{ city: 'Damselstown (Meath)', zip: '462987' },
	{ city: 'Danescastle (Wexford)', zip: '416126' },
	{ city: 'Danesfort (Kilkenny)', zip: '144207' },
	{ city: 'Danesfort (Roscommon)', zip: '999048' },
	{ city: 'Danesfort Lower (Wicklow)', zip: '919672' },
	{ city: 'Danesfort Upper (Wicklow)', zip: '483210' },
	{ city: 'Danesrath (Kilkenny)', zip: '771202' },
	{ city: 'Danestown (Meath)', zip: '344093' },
	{ city: 'Dangan (Clare)', zip: '819644' },
	{ city: 'Dangan (Kildare)', zip: '814016' },
	{ city: 'Dangan (Kilkenny)', zip: '915573' },
	{ city: 'Dangan (Meath)', zip: '931662' },
	{ city: 'Dangan (Roscommon)', zip: '100179' },
	{ city: 'Dangan (Tipperary)', zip: '941346' },
	{ city: 'Dangananella East (Clare)', zip: '200584' },
	{ city: 'Dangananella West (Clare)', zip: '537817' },
	{ city: 'Danganbeg (Galway)', zip: '391335' },
	{ city: 'Danganbeg (Kilkenny)', zip: '934068' },
	{ city: 'Danganbeg (Limerick)', zip: '977826' },
	{ city: 'Danganbeg (Offaly)', zip: '818222' },
	{ city: 'Dangan Beg (Cork)', zip: '582506' },
	{ city: 'Danganbrack (Clare)', zip: '669483' },
	{ city: 'Dangandargan (Tipperary)', zip: '869939' },
	{ city: 'Dangan Eighter (Galway)', zip: '478685' },
	{ city: 'Danganmore (Kilkenny)', zip: '796577' },
	{ city: 'Danganmore (Mayo)', zip: '163744' },
	{ city: 'Dangan More (Cork)', zip: '959913' },
	{ city: 'Dangan Oughter (Galway)', zip: '844878' },
	{ city: 'Danganreagh (Offaly)', zip: '536572' },
	{ city: 'Danganroe (Laois)', zip: '132849' },
	{ city: 'Dangans (Laois)', zip: '855405' },
	{ city: 'Dangansallagh (Cork)', zip: '339909' },
	{ city: 'Dangansallagh (Tipperary)', zip: '307606' },
	{ city: 'Danielstown (Kildare)', zip: '623753' },
	{ city: 'Dannanstown (Cork)', zip: '172418' },
	{ city: 'Danville (Kilkenny)', zip: '662201' },
	{ city: 'Daphney (Wexford)', zip: '498993' },
	{ city: 'Darbyshill (Kilkenny)', zip: '470225' },
	{ city: 'Darbystown (Kilkenny)', zip: '630337' },
	{ city: 'Darcystown (Dublin)', zip: '435050' },
	{ city: 'Dardisrath (Louth)', zip: '174395' },
	{ city: 'Dardistown (Dublin)', zip: '122166' },
	{ city: 'Dardistown (Meath)', zip: '844523' },
	{ city: 'Dardistown (Westmeath)', zip: '829250' },
	{ city: 'Dargan (Donegal)', zip: '881812' },
	{ city: 'Darhanagh (Mayo)', zip: '172979' },
	{ city: 'Darkisland (Limerick)', zip: '952858' },
	{ city: 'Darkley (Cavan)', zip: '868620' },
	{ city: 'Darkvalley (Leitrim)', zip: '402920' },
	{ city: 'Darkwood (Cork)', zip: '520166' },
	{ city: 'Darndale (Dublin)', zip: '438263' },
	{ city: 'Darney (Donegal)', zip: '372806' },
	{ city: 'Daroge (Longford)', zip: '663772' },
	{ city: 'Darragh Beg (Limerick)', zip: '210557' },
	{ city: 'Darraghlan (Monaghan)', zip: '691277' },
	{ city: 'Darragh More (Limerick)', zip: '947781' },
	{ city: 'Darragh North (Clare)', zip: '903265' },
	{ city: 'Darragh South (Clare)', zip: '799864' },
	{ city: 'Darranstown (Limerick)', zip: '315602' },
	{ city: 'Darraragh (Mayo)', zip: '281825' },
	{ city: 'Darrary (Cork)', zip: '949027' },
	{ city: 'Darrary North (Galway)', zip: '123186' },
	{ city: 'Darrary South (Galway)', zip: '928892' },
	{ city: 'Darrery (Limerick)', zip: '940912' },
	{ city: 'Darrigal (Waterford)', zip: '510429' },
	{ city: 'Darrynane Beg (Kerry)', zip: '170325' },
	{ city: 'Darrynane More (Kerry)', zip: '470113' },
	{ city: 'Dartfield (Galway)', zip: '278880' },
	{ city: 'Dartrey (Monaghan)', zip: '817669' },
	{ city: 'Darver (Louth)', zip: '431875' },
	{ city: 'Dary (Tipperary)', zip: '131178' },
	{ city: 'Dash Island (Mayo)', zip: '183456' },
	{ city: 'Davagh (Monaghan)', zip: '728806' },
	{ city: 'Davagh Etra (Monaghan)', zip: '950044' },
	{ city: 'Davagh Otra (Monaghan)', zip: '182869' },
	{ city: 'Davidstown (Kildare)', zip: '605781' },
	{ city: 'Davidstown (Kilkenny)', zip: '731183' },
	{ city: 'Davidstown (Meath)', zip: '846821' },
	{ city: 'Davidstown (Westmeath)', zip: '563774' },
	{ city: 'Davidstown (Wexford)', zip: '691497' },
	{ city: 'Davidstown (Wicklow)', zip: '428940' },
	{ city: 'Davidstown Demesne (Kildare)', zip: '121888' },
	{ city: 'Davidstown Lower (Kildare)', zip: '987993' },
	{ city: 'Davidstown Upper (Kildare)', zip: '413526' },
	{ city: 'Davillaun (Galway)', zip: '588719' },
	{ city: 'Davisshill (Carlow)', zip: '770895' },
	{ city: "Davis's Island (Roscommon)", zip: '835050' },
	{ city: 'Davistown (Offaly)', zip: '133257' },
	{ city: 'Davros (Mayo)', zip: '111993' },
	{ city: 'Daw (Meath)', zip: '519835' },
	{ city: 'Dawros (Donegal)', zip: '292358' },
	{ city: 'Dawros (Galway)', zip: '247234' },
	{ city: 'Dawros (Kerry)', zip: '438114' },
	{ city: 'Dawros (Sligo)', zip: '953764' },
	{ city: 'Dawros Beg (Galway)', zip: '979576' },
	{ city: 'Dawros Lower (Galway)', zip: '146332' },
	{ city: 'Dawros More (Galway)', zip: '179668' },
	{ city: 'Dawros Upper (Galway)', zip: '573562' },
	{ city: 'Dawson Grove Demesne (Monaghan)', zip: '953551' },
	{ city: 'Dawsonsbog (Tipperary)', zip: '617431' },
	{ city: 'Dawsonsdemesne (Louth)', zip: '449230' },
	{ city: 'Dawstown (Cork)', zip: '740984' },
	{ city: 'Dean And Chapter Land Of Cloyne (Cork)', zip: '181448' },
	{ city: 'Deanery (Roscommon)', zip: '587443' },
	{ city: 'Deanestown (Dublin)', zip: '942125' },
	{ city: 'Deanscurragh (Longford)', zip: '672954' },
	{ city: 'Deansgrange (Dublin)', zip: '776309' },
	{ city: 'Deansground (Kilkenny)', zip: '722255' },
	{ city: 'Deansgrove (Tipperary)', zip: '139059' },
	{ city: 'Deansrath (Dublin)', zip: '729274' },
	{ city: 'Deanstown (Limerick)', zip: '286503' },
	{ city: 'Debicot (Laois)', zip: '308893' },
	{ city: 'Decoy (Tipperary)', zip: '988264' },
	{ city: 'Decoy (Wicklow)', zip: '690272' },
	{ city: 'Deebert (Limerick)', zip: '960134' },
	{ city: 'Deechomade (Sligo)', zip: '331789' },
	{ city: 'Deegerty (Limerick)', zip: '528626' },
	{ city: 'Deelcastle (Mayo)', zip: '117923' },
	{ city: 'Deelin Beg (Clare)', zip: '834704' },
	{ city: 'Deelin More (Clare)', zip: '423171' },
	{ city: 'Deelis (Kerry)', zip: '608354' },
	{ city: 'Deelish (Cork)', zip: '861824' },
	{ city: 'Deelish (Limerick)', zip: '760570' },
	{ city: 'Deelish (Waterford)', zip: '119955' },
	{ city: 'Deelishmountain (Waterford)', zip: '539827' },
	{ city: 'Deenes (Meath)', zip: '554210' },
	{ city: 'Deenish (Kerry)', zip: '153662' },
	{ city: 'Deenodes (Sligo)', zip: '862676' },
	{ city: 'Deenystown (Donegal)', zip: '476246' },
	{ city: 'Deeps (Wexford)', zip: '746656' },
	{ city: 'Deerfield (Galway)', zip: '498627' },
	{ city: 'Deerpark (Cavan)', zip: '436808' },
	{ city: 'Deerpark (Clare)', zip: '234212' },
	{ city: 'Deerpark (Cork)', zip: '595530' },
	{ city: 'Deerpark (Donegal)', zip: '315681' },
	{ city: 'Deerpark (Galway)', zip: '358303' },
	{ city: 'Deerpark (Kerry)', zip: '174027' },
	{ city: 'Deerpark (Kildare)', zip: '866392' },
	{ city: 'Deerpark (Kilkenny)', zip: '267375' },
	{ city: 'Deerpark (Laois)', zip: '867090' },
	{ city: 'Deerpark (Leitrim)', zip: '987037' },
	{ city: 'Deerpark (Limerick)', zip: '721392' },
	{ city: 'Deerpark (Longford)', zip: '627988' },
	{ city: 'Deerpark (Louth)', zip: '266527' },
	{ city: 'Deerpark (Mayo)', zip: '955911' },
	{ city: 'Deerpark (Meath)', zip: '189726' },
	{ city: 'Deerpark (Offaly)', zip: '840631' },
	{ city: 'Deerpark (Roscommon)', zip: '570750' },
	{ city: 'Deerpark (Sligo)', zip: '929012' },
	{ city: 'Deerpark (Tipperary)', zip: '405279' },
	{ city: 'Deerpark (Waterford)', zip: '367088' },
	{ city: 'Deerpark (Westmeath)', zip: '460536' },
	{ city: 'Deerpark (Wexford)', zip: '515012' },
	{ city: 'Deerpark (Wicklow)', zip: '186372' },
	{ city: 'Deer Park (Cork)', zip: '612188' },
	{ city: 'Deer Park (Kerry)', zip: '115230' },
	{ city: 'Deerpark East (Mayo)', zip: '355503' },
	{ city: 'Deerpark East (Waterford)', zip: '374311' },
	{ city: 'Deerparkhill (Waterford)', zip: '131028' },
	{ city: 'Deerparklodge (Tipperary)', zip: '965497' },
	{ city: 'Deerpark Lower (Clare)', zip: '667504' },
	{ city: 'Deerpark Lower (Mayo)', zip: '801671' },
	{ city: 'Deerpark Middle (Clare)', zip: '395266' },
	{ city: 'Deerpark Mountain (Waterford)', zip: '735088' },
	{ city: 'Deerpark New (Carlow)', zip: '597979' },
	{ city: 'Deerpark North (Clare)', zip: '646181' },
	{ city: 'Deerpark North (Waterford)', zip: '438916' },
	{ city: 'Deerpark Old (Carlow)', zip: '227763' },
	{ city: 'Deerpark South (Clare)', zip: '433176' },
	{ city: 'Deerpark Upper (Clare)', zip: '848424' },
	{ city: 'Deerpark Upper (Mayo)', zip: '146533' },
	{ city: 'Deerpark West (Clare)', zip: '939307' },
	{ city: 'Deerpark West (Mayo)', zip: '245629' },
	{ city: 'Deer Park West (Donegal)', zip: '755813' },
	{ city: 'Deesert (Kerry)', zip: '577550' },
	{ city: 'Deeshart (Cork)', zip: '767018' },
	{ city: 'Deffier (Leitrim)', zip: '405475' },
	{ city: 'Dehomad (Clare)', zip: '353811' },
	{ city: 'Delamain (Kildare)', zip: '690540' },
	{ city: 'Delgany (Wicklow)', zip: '355675' },
	{ city: 'Dellabrown (Dublin)', zip: '735099' },
	{ city: 'Delliga (Cork)', zip: '848623' },
	{ city: 'Delligabaun (Laois)', zip: '221467' },
	{ city: 'Dellin (Louth)', zip: '998676' },
	{ city: 'Delvin (Westmeath)', zip: '689893' },
	{ city: 'Demailestown (Meath)', zip: '816885' },
	{ city: 'Demesne (Carlow)', zip: '876362' },
	{ city: 'Demesne (Cork)', zip: '390884' },
	{ city: 'Demesne (Donegal)', zip: '430317' },
	{ city: 'Demesne (Galway)', zip: '720402' },
	{ city: 'Demesne (Kerry)', zip: '394693' },
	{ city: 'Demesne (Kildare)', zip: '666211' },
	{ city: 'Demesne (Longford)', zip: '124955' },
	{ city: 'Demesne (Louth)', zip: '530152' },
	{ city: 'Demesne (Mayo)', zip: '241130' },
	{ city: 'Demesne (Roscommon)', zip: '157446' },
	{ city: 'Demesne (Tipperary)', zip: '706169' },
	{ city: 'Demesne (Westmeath)', zip: '804120' },
	{ city: 'Demone (Tipperary)', zip: '431575' },
	{ city: 'Denhamstown (Meath)', zip: '937590' },
	{ city: 'Dennbane (Cavan)', zip: '237494' },
	{ city: 'Denn Glebe (Cavan)', zip: '873265' },
	{ city: "Dennis' Fields (Dublin)", zip: '890480' },
	{ city: 'Dennistown (Wexford)', zip: '618694' },
	{ city: 'Dennmore (Cavan)', zip: '743164' },
	{ city: 'Deralk (Cavan)', zip: '450598' },
	{ city: 'Deramfield (Cavan)', zip: '624771' },
	{ city: 'Derawley (Longford)', zip: '764668' },
	{ city: 'Derdimus (Kilkenny)', zip: '958795' },
	{ city: 'Dergraw (Roscommon)', zip: '514131' },
	{ city: 'Dergroagh (Donegal)', zip: '162338' },
	{ city: 'Dergvone (Leitrim)', zip: '571039' },
	{ city: 'Derinch Island (Sligo)', zip: '264620' },
	{ city: 'Derinish Beg (Cavan)', zip: '470990' },
	{ city: 'Derinish More (Cavan)', zip: '163690' },
	{ city: 'Derk (Kerry)', zip: '981684' },
	{ city: 'Derk (Limerick)', zip: '723984' },
	{ city: 'Derk Beg (Donegal)', zip: '299254' },
	{ city: 'Derk Beg (Sligo)', zip: '299341' },
	{ city: 'Derk More (Donegal)', zip: '767299' },
	{ city: 'Derk More (Sligo)', zip: '798088' },
	{ city: 'Derlangan (Meath)', zip: '846857' },
	{ city: 'Dermotstown (Dublin)', zip: '330242' },
	{ city: 'Dernacally (Donegal)', zip: '926600' },
	{ city: 'Dernacart (Laois)', zip: '122564' },
	{ city: 'Dernacoo (Monaghan)', zip: '255645' },
	{ city: 'Dernadarriff (Monaghan)', zip: '152641' },
	{ city: 'Dernafanny (Offaly)', zip: '950690' },
	{ city: 'Dernaferst (Cavan)', zip: '537794' },
	{ city: 'Dernaglug (Monaghan)', zip: '907845' },
	{ city: 'Dernaglush (Cavan)', zip: '673486' },
	{ city: 'Dernagola (Monaghan)', zip: '294718' },
	{ city: 'Dernagree (Cork)', zip: '936794' },
	{ city: 'Dernahamsha (Monaghan)', zip: '249413' },
	{ city: 'Dernahatten (Monaghan)', zip: '113995' },
	{ city: 'Dernahelty Beg (Leitrim)', zip: '436823' },
	{ city: 'Dernahelty More (Leitrim)', zip: '325089' },
	{ city: 'Dernahinch (Monaghan)', zip: '923877' },
	{ city: 'Dernakesh (Cavan)', zip: '949314' },
	{ city: 'Dernalosset (Monaghan)', zip: '634999' },
	{ city: 'Dernamanagh (Laois)', zip: '396289' },
	{ city: 'Dernamoyle (Monaghan)', zip: '453150' },
	{ city: 'Dernamuck (Monaghan)', zip: '927888' },
	{ city: 'Dernaroy (Monaghan)', zip: '269582' },
	{ city: 'Dernaskeagh (Cavan)', zip: '682682' },
	{ city: 'Dernaskeagh (Sligo)', zip: '216865' },
	{ city: 'Dernasmallan (Leitrim)', zip: '316619' },
	{ city: 'Dernaved (Monaghan)', zip: '362422' },
	{ city: 'Dernaweel (Cavan)', zip: '700772' },
	{ city: 'Dernish Island (Sligo)', zip: '591152' },
	{ city: 'Derra (Kerry)', zip: '432183' },
	{ city: 'Derradd (Westmeath)', zip: '963050' },
	{ city: 'Derradda (Galway)', zip: '568657' },
	{ city: 'Derradda (Leitrim)', zip: '434249' },
	{ city: 'Derradda (Mayo)', zip: '980951' },
	{ city: 'Derradda South (Galway)', zip: '987995' },
	{ city: 'Derra East (Kerry)', zip: '334280' },
	{ city: 'Derragh (Clare)', zip: '495535' },
	{ city: 'Derragh (Cork)', zip: '133930' },
	{ city: 'Derragh (Longford)', zip: '320004' },
	{ city: 'Derragh (Mayo)', zip: '263029' },
	{ city: 'Derraghan Beg (Longford)', zip: '218442' },
	{ city: 'Derraghan More (Longford)', zip: '224674' },
	{ city: 'Derrainy (Clare)', zip: '649943' },
	{ city: 'Derrakillew (Mayo)', zip: '532924' },
	{ city: 'Derrane (Roscommon)', zip: '281535' },
	{ city: 'Derrartan (Mayo)', zip: '107813' },
	{ city: 'Derrassa (Mayo)', zip: '901483' },
	{ city: 'Derrassa Commons (Mayo)', zip: '435071' },
	{ city: 'Derraugh (Laois)', zip: '932924' },
	{ city: 'Derraulin (Limerick)', zip: '145145' },
	{ city: 'Derraun (Roscommon)', zip: '804610' },
	{ city: 'Derravoher (Tipperary)', zip: '234431' },
	{ city: 'Derravoher Lower (Tipperary)', zip: '490135' },
	{ city: 'Derravonniff (Galway)', zip: '931637' },
	{ city: 'Derra West (Kerry)', zip: '997723' },
	{ city: 'Derreary (Cavan)', zip: '434578' },
	{ city: 'Derredis Lower (Cavan)', zip: '169019' },
	{ city: 'Derredis Upper (Cavan)', zip: '354015' },
	{ city: 'Derree (Cork)', zip: '149184' },
	{ city: 'Derreen (Clare)', zip: '892571' },
	{ city: 'Derreen (Cork)', zip: '751021' },
	{ city: 'Derreen (Galway)', zip: '511220' },
	{ city: 'Derreen (Kerry)', zip: '280876' },
	{ city: 'Derreen (Kilkenny)', zip: '738541' },
	{ city: 'Derreen (Leitrim)', zip: '411576' },
	{ city: 'Derreen (Limerick)', zip: '288810' },
	{ city: 'Derreen (Mayo)', zip: '920920' },
	{ city: 'Derreen (Offaly)', zip: '926937' },
	{ city: 'Derreen (Roscommon)', zip: '404874' },
	{ city: 'Derreen (Tipperary)', zip: '774126' },
	{ city: 'Derreenabourky (Cork)', zip: '742548' },
	{ city: 'Derreenacahill (Kerry)', zip: '622405' },
	{ city: 'Derreenacallaha (Kerry)', zip: '900743' },
	{ city: 'Derreenacarrin (Cork)', zip: '615312' },
	{ city: 'Derreenaclaurig (Kerry)', zip: '117349' },
	{ city: 'Derreenacoosan (Roscommon)', zip: '598007' },
	{ city: 'Derreenacrinnig East (Cork)', zip: '121403' },
	{ city: 'Derreenacrinnig West (Cork)', zip: '329373' },
	{ city: 'Derreenacullig (Kerry)', zip: '405776' },
	{ city: 'Derreenaculling (Cork)', zip: '454176' },
	{ city: 'Derreenadouglas (Roscommon)', zip: '496215' },
	{ city: 'Derreenafoyle (Kerry)', zip: '283038' },
	{ city: 'Derreenagan (Roscommon)', zip: '175764' },
	{ city: 'Derreenagarig (Cork)', zip: '473258' },
	{ city: 'Derreenageer (Leitrim)', zip: '476769' },
	{ city: 'Derreenahinch (Roscommon)', zip: '446568' },
	{ city: 'Derreenaling (Cork)', zip: '243321' },
	{ city: 'Derreenamackaun (Roscommon)', zip: '608562' },
	{ city: 'Derreenanarry (Roscommon)', zip: '368449' },
	{ city: 'Derreenanaryagh (Kerry)', zip: '260655' },
	{ city: 'Derreen And Carrowreagh (Laois)', zip: '994168' },
	{ city: 'Derreenannagh (Roscommon)', zip: '215396' },
	{ city: 'Derreenard (Cork)', zip: '518815' },
	{ city: 'Derreenargan (Roscommon)', zip: '697351' },
	{ city: 'Derreenasalt (Roscommon)', zip: '208026' },
	{ city: 'Derreenaseer (Roscommon)', zip: '712546' },
	{ city: 'Derreenasoo (Roscommon)', zip: '474065' },
	{ city: 'Derreenaspeeg (Cork)', zip: '895618' },
	{ city: 'Derreenataggart Commons (Cork)', zip: '608545' },
	{ city: 'Derreenataggart East (Cork)', zip: '472521' },
	{ city: 'Derreenataggart Middle (Cork)', zip: '957310' },
	{ city: 'Derreenataggart West (Cork)', zip: '694849' },
	{ city: 'Derreenatawy (Roscommon)', zip: '923393' },
	{ city: 'Derreenathirigy (Cork)', zip: '419278' },
	{ city: 'Derreenatloghtan (Clare)', zip: '220211' },
	{ city: 'Derreenatlooig (Kerry)', zip: '795103' },
	{ city: 'Derreenauliff (Kerry)', zip: '695590' },
	{ city: 'Derreenavarrihy (Cork)', zip: '865012' },
	{ city: 'Derreenavicara (Roscommon)', zip: '116003' },
	{ city: 'Derreenavoggy (Longford)', zip: '363070' },
	{ city: 'Derreenavoggy (Roscommon)', zip: '438429' },
	{ city: 'Derreenavroonig (Cork)', zip: '377044' },
	{ city: 'Derreenavurrig (Kerry)', zip: '985545' },
	{ city: 'Derreenboy (Galway)', zip: '702353' },
	{ city: 'Derreenboy Lower (Cork)', zip: '151477' },
	{ city: 'Derreenboy Upper (Cork)', zip: '555889' },
	{ city: 'Derreenclodig (Cork)', zip: '437838' },
	{ city: 'Derreencollig (Cork)', zip: '415710' },
	{ city: 'Derreendangan (Cork)', zip: '853756' },
	{ city: 'Derreendarragh (Kerry)', zip: '620990' },
	{ city: 'Derreendonee (Cork)', zip: '651679' },
	{ city: 'Derreendooagh (Clare)', zip: '878941' },
	{ city: 'Derreendooey (Roscommon)', zip: '971727' },
	{ city: 'Derreendorragh (Roscommon)', zip: '253610' },
	{ city: 'Derreendrislagh (Kerry)', zip: '738507' },
	{ city: 'Derreen East (Clare)', zip: '253915' },
	{ city: 'Derreenfinlehid (Kerry)', zip: '415333' },
	{ city: 'Derreengarrinshagh (Kerry)', zip: '158788' },
	{ city: 'Derreenglass (Cork)', zip: '787211' },
	{ city: 'Derreengreanagh (Cork)', zip: '744702' },
	{ city: 'Derreenine (Roscommon)', zip: '626164' },
	{ city: 'Derreenkealig (Cork)', zip: '648385' },
	{ city: 'Derreen Lower (Cork)', zip: '505905' },
	{ city: 'Derreen Lower (Galway)', zip: '938090' },
	{ city: 'Derreenlunnig (Cork)', zip: '548313' },
	{ city: 'Derreenmanus (Mayo)', zip: '522761' },
	{ city: 'Derreenmeel (Galway)', zip: '177390' },
	{ city: 'Derreenmoria (Kerry)', zip: '791810' },
	{ city: 'Derreenmulroy (Mayo)', zip: '213252' },
	{ city: 'Derreennacarton (Cork)', zip: '653734' },
	{ city: 'Derreennaclogh (Cork)', zip: '993677' },
	{ city: 'Derreennacno (Cork)', zip: '565629' },
	{ city: 'Derreennacusha (Cork)', zip: '160281' },
	{ city: 'Derreennageeha (Kerry)', zip: '985726' },
	{ city: 'Derreennagough (Cork)', zip: '113998' },
	{ city: 'Derreennagreer (Kerry)', zip: '559603' },
	{ city: 'Derreennagusfoor (Galway)', zip: '382506' },
	{ city: 'Derreennalomane (Cork)', zip: '742645' },
	{ city: 'Derreennamucka (Galway)', zip: '910491' },
	{ city: 'Derreennamucklagh (Kerry)', zip: '898603' },
	{ city: 'Derreennanalbanagh (Mayo)', zip: '681239' },
	{ city: 'Derreennascooba (Mayo)', zip: '736703' },
	{ city: 'Derreennatra (Cork)', zip: '949087' },
	{ city: 'Derreennawinshin (Mayo)', zip: '113299' },
	{ city: 'Derreens (Cork)', zip: '114046' },
	{ city: 'Derreens (Kildare)', zip: '535732' },
	{ city: 'Derreens (Leitrim)', zip: '195810' },
	{ city: 'Derreens (Mayo)', zip: '260314' },
	{ city: 'Derreens (Sligo)', zip: '133858' },
	{ city: 'Derreensillagh (Kerry)', zip: '298836' },
	{ city: 'Derreens Island (Mayo)', zip: '220449' },
	{ city: 'Derreen South (Clare)', zip: '491683' },
	{ city: 'Derreenteige (Roscommon)', zip: '487598' },
	{ city: 'Derreentunny (Roscommon)', zip: '552933' },
	{ city: 'Derreen Upper (Cork)', zip: '587223' },
	{ city: 'Derreen Upper (Galway)', zip: '584306' },
	{ city: 'Derreen West (Clare)', zip: '938696' },
	{ city: 'Derreeny (Cork)', zip: '294641' },
	{ city: 'Derreeny (Kerry)', zip: '220781' },
	{ city: 'Derreenyanimna (Mayo)', zip: '530846' },
	{ city: 'Derreighter (Galway)', zip: '304885' },
	{ city: 'Derreskit (Cavan)', zip: '485295' },
	{ city: 'Derrew (Galway)', zip: '749494' },
	{ city: 'Derrew (Mayo)', zip: '264975' },
	{ city: 'Derrew Old (Mayo)', zip: '756234' },
	{ city: 'Derriana (Kerry)', zip: '369078' },
	{ city: 'Derrica Beg (Offaly)', zip: '869882' },
	{ city: 'Derrica More (Offaly)', zip: '393868' },
	{ city: 'Derricknew (Tipperary)', zip: '415839' },
	{ city: 'Derries (Cavan)', zip: '472620' },
	{ city: 'Derries (Donegal)', zip: '130212' },
	{ city: 'Derries (Offaly)', zip: '438858' },
	{ city: 'Derries (Tipperary)', zip: '421451' },
	{ city: 'Derries (Westmeath)', zip: '578663' },
	{ city: 'Derries Lower (Cavan)', zip: '653555' },
	{ city: 'Derries Upper (Cavan)', zip: '636987' },
	{ city: 'Derrigimlagh (Galway)', zip: '705463' },
	{ city: 'Derrigra (Cork)', zip: '202176' },
	{ city: 'Derrigra West (Cork)', zip: '936192' },
	{ city: 'Derrilla (Monaghan)', zip: '432027' },
	{ city: 'Derrin (Laois)', zip: '931564' },
	{ city: 'Derrinaher (Leitrim)', zip: '489462' },
	{ city: 'Derrinboy (Offaly)', zip: '753785' },
	{ city: 'Derrinclare (Offaly)', zip: '352861' },
	{ city: 'Derrincullig (Kerry)', zip: '752994' },
	{ city: 'Derrindaff (Kerry)', zip: '661351' },
	{ city: 'Derrindaffderg (Mayo)', zip: '713293' },
	{ city: 'Derrindaffderg Commons (Mayo)', zip: '588956' },
	{ city: 'Derrindangan (Leitrim)', zip: '614984' },
	{ city: 'Derrindiff (Longford)', zip: '480191' },
	{ city: 'Derrindrehid (Cavan)', zip: '813847' },
	{ city: 'Derrindrehid (Leitrim)', zip: '799258' },
	{ city: 'Derrinduff (Laois)', zip: '223244' },
	{ city: 'Derrinduff (Offaly)', zip: '422347' },
	{ city: 'Derrinea (Roscommon)', zip: '239832' },
	{ city: 'Derrineanig (Cork)', zip: '434619' },
	{ city: 'Derrineden (Kerry)', zip: '852528' },
	{ city: 'Derrineel (Roscommon)', zip: '122071' },
	{ city: 'Derriniddane (Clare)', zip: '621360' },
	{ city: 'Derrinisky (Roscommon)', zip: '879799' },
	{ city: 'Derrinivver (Leitrim)', zip: '410138' },
	{ city: 'Derrinkee (Mayo)', zip: '252083' },
	{ city: 'Derrinkeher (Leitrim)', zip: '266374' },
	{ city: 'Derrinkip (Leitrim)', zip: '219715' },
	{ city: 'Derrinknow (Kerry)', zip: '269313' },
	{ city: 'Derrinlaur Lower (Waterford)', zip: '101319' },
	{ city: 'Derrinlaur Upper (Waterford)', zip: '918942' },
	{ city: 'Derrinlee (Tipperary)', zip: '301310' },
	{ city: 'Derrinlester (Cavan)', zip: '918320' },
	{ city: 'Derrinlevaun (Mayo)', zip: '591807' },
	{ city: 'Derrinlieragh (Tipperary)', zip: '879439' },
	{ city: 'Derrinlig (Meath)', zip: '323871' },
	{ city: 'Derrinlough (Galway)', zip: '936858' },
	{ city: 'Derrinlough (Offaly)', zip: '533650' },
	{ city: 'Derrinloughan (Leitrim)', zip: '112758' },
	{ city: 'Derrin Lower (Cavan)', zip: '111603' },
	{ city: 'Derrinlurg (Roscommon)', zip: '211321' },
	{ city: 'Derrinoghran (Sligo)', zip: '416646' },
	{ city: 'Derrinoliver (Laois)', zip: '437692' },
	{ city: 'Derrins (Monaghan)', zip: '295692' },
	{ city: 'Derrinsallagh (Laois)', zip: '353721' },
	{ city: 'Derrinsallow (Tipperary)', zip: '285467' },
	{ city: 'Derrinstown (Kildare)', zip: '356117' },
	{ city: 'Derrintaggart (Mayo)', zip: '237416' },
	{ city: 'Derrintawny (Leitrim)', zip: '898703' },
	{ city: 'Derrintawy Glebe (Leitrim)', zip: '753604' },
	{ city: 'Derrintin (Mayo)', zip: '214465' },
	{ city: 'Derrintinny (Cavan)', zip: '895420' },
	{ city: 'Derrintloura (Mayo)', zip: '402156' },
	{ city: 'Derrintober (Leitrim)', zip: '240236' },
	{ city: 'Derrintogher (Cork)', zip: '768636' },
	{ city: 'Derrintogher (Mayo)', zip: '135485' },
	{ city: 'Derrintonny (Leitrim)', zip: '376918' },
	{ city: 'Derrintonny (Monaghan)', zip: '889053' },
	{ city: 'Derrintray Glebe (Laois)', zip: '205465' },
	{ city: 'Derrinturk (Roscommon)', zip: '611165' },
	{ city: 'Derrinturn (Kildare)', zip: '716876' },
	{ city: 'Derrinumera (Mayo)', zip: '322492' },
	{ city: 'Derrin Upper (Cavan)', zip: '853443' },
	{ city: 'Derrinurn (Leitrim)', zip: '700489' },
	{ city: 'Derrinvoher (Leitrim)', zip: '443962' },
	{ city: 'Derrinvohil (Tipperary)', zip: '330280' },
	{ city: 'Derrinvoney Lower (Leitrim)', zip: '635860' },
	{ city: 'Derrinvoney Upper (Leitrim)', zip: '405838' },
	{ city: 'Derrinvullig (Offaly)', zip: '301541' },
	{ city: 'Derrinweer (Leitrim)', zip: '115647' },
	{ city: 'Derrinwillin (Leitrim)', zip: '606936' },
	{ city: 'Derrinwillin Glebe (Leitrim)', zip: '174209' },
	{ city: 'Derrinydaly (Meath)', zip: '823058' },
	{ city: 'Derriscligh (Donegal)', zip: '635413' },
	{ city: 'Derrishal (Cork)', zip: '418553' },
	{ city: 'Derrockstown (Meath)', zip: '530421' },
	{ city: 'Derroogh (Galway)', zip: '551978' },
	{ city: 'Derroogh North (Galway)', zip: '112187' },
	{ city: 'Derrooghs (Galway)', zip: '736107' },
	{ city: 'Derroogh South (Galway)', zip: '126711' },
	{ city: 'Derroograne (Cork)', zip: '355556' },
	{ city: 'Derroolagh (Clare)', zip: '850449' },
	{ city: 'Derrooly (Offaly)', zip: '446416' },
	{ city: 'Derroon (Sligo)', zip: '215436' },
	{ city: 'Derrora (Donegal)', zip: '780684' },
	{ city: 'Derroran East (Clare)', zip: '382427' },
	{ city: 'Derroran West (Clare)', zip: '726378' },
	{ city: 'Derroura (Galway)', zip: '153264' },
	{ city: 'Derrowel Beg (Mayo)', zip: '785939' },
	{ city: 'Derrowel More (Mayo)', zip: '318402' },
	{ city: 'Derry (Cavan)', zip: '201887' },
	{ city: 'Derry (Clare)', zip: '696837' },
	{ city: 'Derry (Cork)', zip: '137356' },
	{ city: 'Derry (Galway)', zip: '473008' },
	{ city: 'Derry (Kerry)', zip: '831528' },
	{ city: 'Derry (Laois)', zip: '596241' },
	{ city: 'Derry (Limerick)', zip: '255457' },
	{ city: 'Derry (Mayo)', zip: '897209' },
	{ city: 'Derry (Monaghan)', zip: '572572' },
	{ city: 'Derry (Roscommon)', zip: '311267' },
	{ city: 'Derry (Sligo)', zip: '193048' },
	{ city: 'Derry (Tipperary)', zip: '478761' },
	{ city: 'Derry (Westmeath)', zip: '978192' },
	{ city: 'Derry (Wexford)', zip: '804994' },
	{ city: 'Derrya (Westmeath)', zip: '898983' },
	{ city: 'Derryabbert (Clare)', zip: '852501' },
	{ city: 'Derryad (Longford)', zip: '532860' },
	{ city: 'Derryad (Offaly)', zip: '532577' },
	{ city: 'Derryadda (Mayo)', zip: '816859' },
	{ city: 'Derryadd East (Galway)', zip: '283613' },
	{ city: 'Derryadd West (Galway)', zip: '349558' },
	{ city: 'Derryallaghan (Monaghan)', zip: '627257' },
	{ city: 'Derryard (Kerry)', zip: '988439' },
	{ city: 'Derryarkane (Cork)', zip: '548204' },
	{ city: 'Derryarkin (Offaly)', zip: '476328' },
	{ city: 'Derryarmush (Cavan)', zip: '657803' },
	{ city: 'Derryaroge (Longford)', zip: '239057' },
	{ city: 'Derryarrilly (Monaghan)', zip: '524743' },
	{ city: 'Derryarrit (Monaghan)', zip: '345660' },
	{ city: 'Derryarrow (Laois)', zip: '127421' },
	{ city: 'Derryart (Donegal)', zip: '926272' },
	{ city: 'Derryart (Kildare)', zip: '201246' },
	{ city: 'Derryart (Longford)', zip: '842027' },
	{ city: 'Derryartry (Monaghan)', zip: '494898' },
	{ city: 'Derryaun (Mayo)', zip: '181376' },
	{ city: 'Derrybanane (Kerry)', zip: '628346' },
	{ city: 'Derrybane (Tipperary)', zip: '159379' },
	{ city: 'Derrybaun (Cork)', zip: '298095' },
	{ city: 'Derrybaun (Galway)', zip: '136082' },
	{ city: 'Derrybawn (Wicklow)', zip: '928535' },
	{ city: 'Derrybeg (Clare)', zip: '804043' },
	{ city: 'Derrybeg (Donegal)', zip: '325642' },
	{ city: 'Derrybeg (Galway)', zip: '559115' },
	{ city: 'Derrybeg (Limerick)', zip: '950424' },
	{ city: 'Derrybeg (Monaghan)', zip: '708923' },
	{ city: 'Derrybeg (Offaly)', zip: '897533' },
	{ city: 'Derrybeg (Sligo)', zip: '387838' },
	{ city: 'Derrybeg (Tipperary)', zip: '265301' },
	{ city: 'Derry Beg (Cavan)', zip: '517187' },
	{ city: 'Derry Beg (Laois)', zip: '321439' },
	{ city: 'Derry Beg (Sligo)', zip: '807479' },
	{ city: 'Derrybehagh (Clare)', zip: '396350' },
	{ city: 'Derrybofin (Leitrim)', zip: '108020' },
	{ city: 'Derryboy (Westmeath)', zip: '867598' },
	{ city: 'Derrybrack (Leitrim)', zip: '471576' },
	{ city: 'Derrybrack (Mayo)', zip: '409179' },
	{ city: 'Derrybreen (Tipperary)', zip: '892774' },
	{ city: 'Derrybrennan (Kildare)', zip: '617029' },
	{ city: 'Derrybrick (Cavan)', zip: '475118' },
	{ city: 'Derrybrick (Clare)', zip: '490576' },
	{ city: 'Derrybrien East (Galway)', zip: '176280' },
	{ city: 'Derrybrien North (Galway)', zip: '448805' },
	{ city: 'Derrybrien South (Galway)', zip: '979492' },
	{ city: 'Derrybrien West (Galway)', zip: '894463' },
	{ city: 'Derrybrisk (Leitrim)', zip: '794359' },
	{ city: 'Derrybrock (Laois)', zip: '521568' },
	{ city: 'Derrybrock (Mayo)', zip: '752065' },
	{ city: 'Derrycahill (Roscommon)', zip: '645388' },
	{ city: 'Derrycallaghan (Tipperary)', zip: '335873' },
	{ city: 'Derrycallan Commons (Galway)', zip: '264221' },
	{ city: 'Derrycallan North (Galway)', zip: '296497' },
	{ city: 'Derrycallan South (Galway)', zip: '738612' },
	{ city: 'Derrycalliff (Clare)', zip: '706471' },
	{ city: 'Derrycammagh (Louth)', zip: '175761' },
	{ city: 'Derrycanan (Roscommon)', zip: '836270' },
	{ city: 'Derrycanton (Laois)', zip: '948607' },
	{ city: 'Derrycarbry (Roscommon)', zip: '674028' },
	{ city: 'Derrycarhoon (Cork)', zip: '170210' },
	{ city: 'Derrycark (Cavan)', zip: '270831' },
	{ city: 'Derrycarna (Kerry)', zip: '631519' },
	{ city: 'Derrycarne Demesne (Leitrim)', zip: '758828' },
	{ city: 'Derrycarney (Offaly)', zip: '107178' },
	{ city: 'Derrycarney (Tipperary)', zip: '738127' },
	{ city: 'Derrycarran (Clare)', zip: '171428' },
	{ city: 'Derrycarrow (Laois)', zip: '947953' },
	{ city: 'Derrycashel (Mayo)', zip: '690958' },
	{ city: 'Derrycashel (Roscommon)', zip: '591108' },
	{ city: 'Derrycassan (Cavan)', zip: '592660' },
	{ city: 'Derrycassan (Donegal)', zip: '831565' },
	{ city: 'Derrycassan (Longford)', zip: '130133' },
	{ city: 'Derryclaha (Mayo)', zip: '184014' },
	{ city: 'Derryclare (Galway)', zip: '703329' },
	{ city: 'Derryclare (Meath)', zip: '984348' },
	{ city: 'Derrycleetagh (Mayo)', zip: '821300' },
	{ city: 'Derryclogher (Cork)', zip: '651579' },
	{ city: 'Derryclogh Lower (Cork)', zip: '295999' },
	{ city: 'Derryclogh Upper (Cork)', zip: '977983' },
	{ city: 'Derrycloney (Laois)', zip: '611158' },
	{ city: 'Derrycloney (Tipperary)', zip: '585546' },
	{ city: 'Derryclure (Offaly)', zip: '777771' },
	{ city: 'Derrycluvane (Cork)', zip: '926490' },
	{ city: 'Derrycnaw (Clare)', zip: '221265' },
	{ city: 'Derryco (Kerry)', zip: '578729' },
	{ city: 'Derrycoagh (Roscommon)', zip: '719418' },
	{ city: 'Derrycoffey (Offaly)', zip: '452372' },
	{ city: 'Derrycolumb (Longford)', zip: '524022' },
	{ city: 'Derrycon (Laois)', zip: '620446' },
	{ city: 'Derrycon Lower (Clare)', zip: '643950' },
	{ city: 'Derryconnell (Cork)', zip: '445535' },
	{ city: 'Derryconnery (Cork)', zip: '764414' },
	{ city: 'Derryconnery (Kerry)', zip: '688236' },
	{ city: 'Derryconnessy (Cavan)', zip: '558882' },
	{ city: 'Derryconny (Roscommon)', zip: '956389' },
	{ city: 'Derryconor (Donegal)', zip: '516022' },
	{ city: 'Derryconor (Meath)', zip: '558070' },
	{ city: 'Derrycontoort East (Mayo)', zip: '228852' },
	{ city: 'Derrycontoort West (Mayo)', zip: '262088' },
	{ city: 'Derrycon Upper (Clare)', zip: '184096' },
	{ city: 'Derrycoogh (Tipperary)', zip: '845789' },
	{ city: 'Derrycool (Cork)', zip: '572363' },
	{ city: 'Derrycooldrim (Mayo)', zip: '613028' },
	{ city: 'Derrycooly (Offaly)', zip: '849124' },
	{ city: 'Derrycooraun (Mayo)', zip: '871949' },
	{ city: 'Derrycoosh (Mayo)', zip: '396603' },
	{ city: 'Derrycorrib (Mayo)', zip: '862653' },
	{ city: 'Derrycraff (Mayo)', zip: '370756' },
	{ city: 'Derrycrag (Galway)', zip: '425684' },
	{ city: 'Derrycramph (Cavan)', zip: '213625' },
	{ city: 'Derrycrave (Westmeath)', zip: '462322' },
	{ city: 'Derrycreeve (Mayo)', zip: '978865' },
	{ city: 'Derrycreeveen (Cork)', zip: '495938' },
	{ city: 'Derrycreevy (Monaghan)', zip: '477440' },
	{ city: 'Derrycreigh (Cork)', zip: '571581' },
	{ city: 'Derrycrib (Kildare)', zip: '399857' },
	{ city: 'Derrycricket (Offaly)', zip: '324748' },
	{ city: 'Derrycrih (Galway)', zip: '985337' },
	{ city: 'Derrycrossan (Monaghan)', zip: '935826' },
	{ city: 'Derrycullinan (Leitrim)', zip: '604646' },
	{ city: 'Derrycullinan Beg (Leitrim)', zip: '452216' },
	{ city: 'Derrycunihy (Kerry)', zip: '729155' },
	{ city: 'Derrycunlagh (Galway)', zip: '653560' },
	{ city: 'Derrydamph (Cavan)', zip: '292617' },
	{ city: 'Derrydarragh (Longford)', zip: '407226' },
	{ city: 'Derrydarragh (Sligo)', zip: '658814' },
	{ city: 'Derrydavy (Laois)', zip: '178304' },
	{ city: 'Derry Demesne (Tipperary)', zip: '326137' },
	{ city: 'Derrydolney (Offaly)', zip: '252523' },
	{ city: 'Derrydonnell (Roscommon)', zip: '664862' },
	{ city: 'Derrydonnell Beg (Galway)', zip: '926733' },
	{ city: 'Derrydonnell More (Galway)', zip: '222104' },
	{ city: 'Derrydonnell North (Galway)', zip: '630306' },
	{ city: 'Derrydooan Lower (Westmeath)', zip: '114814' },
	{ city: 'Derrydooan Middle (Westmeath)', zip: '921578' },
	{ city: 'Derrydooan Upper (Westmeath)', zip: '199426' },
	{ city: 'Derrydorneen (Mayo)', zip: '289720' },
	{ city: 'Derrydorragh (Mayo)', zip: '745856' },
	{ city: 'Derrydorraghy (Monaghan)', zip: '819793' },
	{ city: 'Derrydruel Lower (Donegal)', zip: '483851' },
	{ city: 'Derrydruel Upper (Donegal)', zip: '468848' },
	{ city: 'Derryduff (Cork)', zip: '799940' },
	{ city: 'Derryduff (Laois)', zip: '388018' },
	{ city: 'Derryduff (Leitrim)', zip: '432255' },
	{ city: 'Derryduff Beg (Cork)', zip: '569174' },
	{ city: 'Derryduff More (Cork)', zip: '298400' },
	{ city: 'Derryeaghra (Clare)', zip: '440510' },
	{ city: 'Derry East (Kerry)', zip: '274084' },
	{ city: 'Derryeighter (Galway)', zip: '509499' },
	{ city: 'Derryerglinna (Galway)', zip: '376415' },
	{ city: 'Derryesker (Offaly)', zip: '136600' },
	{ city: 'Derryevin (Cavan)', zip: '941240' },
	{ city: 'Derryfad (Donegal)', zip: '568918' },
	{ city: 'Derryfadda (Clare)', zip: '213351' },
	{ city: 'Derryfadda (Cork)', zip: '831852' },
	{ city: 'Derryfadda (Galway)', zip: '854775' },
	{ city: 'Derryfadda (Mayo)', zip: '419398' },
	{ city: 'Derryfadda (Tipperary)', zip: '991952' },
	{ city: 'Derryfaddagh Lower (Mayo)', zip: '757665' },
	{ city: 'Derryfadda Upper (Mayo)', zip: '698680' },
	{ city: 'Derryfalone (Louth)', zip: '187873' },
	{ city: 'Derryfeacle (Roscommon)', zip: '307232' },
	{ city: 'Derryfineen (Cork)', zip: '212847' },
	{ city: 'Derryfore (Laois)', zip: '143526' },
	{ city: 'Derryfrench (Galway)', zip: '377553' },
	{ city: 'Derryfunshion (Cork)', zip: '552332' },
	{ city: 'Derrygalun (Cork)', zip: '860055' },
	{ city: 'Derrygareen (Tipperary)', zip: '489679' },
	{ city: 'Derrygarra Lower (Cavan)', zip: '250053' },
	{ city: 'Derrygarran (Laois)', zip: '622546' },
	{ city: 'Derrygarran (Offaly)', zip: '426199' },
	{ city: 'Derrygarrane North (Kerry)', zip: '158071' },
	{ city: 'Derrygarrane South (Kerry)', zip: '863852' },
	{ city: 'Derrygarra Upper (Cavan)', zip: '375036' },
	{ city: 'Derrygarriff (Clare)', zip: '473111' },
	{ city: 'Derrygarriff (Galway)', zip: '552776' },
	{ city: 'Derrygarriv (Kerry)', zip: '363552' },
	{ city: 'Derrygarve (Mayo)', zip: '436559' },
	{ city: 'Derrygarve Beg (Mayo)', zip: '393414' },
	{ city: 'Derrygarve East (Mayo)', zip: '932866' },
	{ city: 'Derrygarve More (Mayo)', zip: '321308' },
	{ city: 'Derrygarve West (Mayo)', zip: '170475' },
	{ city: 'Derrygassan Lower (Monaghan)', zip: '764367' },
	{ city: 'Derrygassan Upper (Monaghan)', zip: '286441' },
	{ city: 'Derrygaury (Mayo)', zip: '702918' },
	{ city: 'Derrygay (Mayo)', zip: '158880' },
	{ city: 'Derrygeeha (Clare)', zip: '349389' },
	{ city: 'Derrygeel (Longford)', zip: '653798' },
	{ city: 'Derrygeeraghan (Cavan)', zip: '953188' },
	{ city: 'Derrygereen (Cork)', zip: '285062' },
	{ city: 'Derrygid (Cavan)', zip: '542812' },
	{ city: 'Derrygile (Laois)', zip: '434598' },
	{ city: 'Derrygill (Galway)', zip: '204006' },
	{ city: 'Derryginagh East (Cork)', zip: '260527' },
	{ city: 'Derryginagh Middle (Cork)', zip: '893455' },
	{ city: 'Derryginagh West (Cork)', zip: '715315' },
	{ city: 'Derryginny (Cavan)', zip: '367664' },
	{ city: 'Derrygirraun (Roscommon)', zip: '572792' },
	{ city: 'Derryglad (Roscommon)', zip: '294515' },
	{ city: 'Derryglash (Longford)', zip: '700759' },
	{ city: 'Derryglassaun (Galway)', zip: '710532' },
	{ city: 'Derryglen (Cavan)', zip: '237775' },
	{ city: 'Derryglogher (Longford)', zip: '525077' },
	{ city: 'Derrygoan (Leitrim)', zip: '908260' },
	{ city: 'Derrygola (Monaghan)', zip: '334981' },
	{ city: 'Derrygolagh (Sligo)', zip: '304559' },
	{ city: 'Derrygolan (Offaly)', zip: '571328' },
	{ city: 'Derrygolan (Westmeath)', zip: '134122' },
	{ city: 'Derrygool (Cork)', zip: '786434' },
	{ city: 'Derrygoolin North (Galway)', zip: '135126' },
	{ city: 'Derrygoolin South (Galway)', zip: '728155' },
	{ city: 'Derrygoony (Monaghan)', zip: '465728' },
	{ city: 'Derrygorman (Kerry)', zip: '227126' },
	{ city: 'Derrygorman (Mayo)', zip: '172824' },
	{ city: 'Derrygorry (Monaghan)', zip: '328890' },
	{ city: 'Derrygortnacloghy (Cork)', zip: '966904' },
	{ city: 'Derrygoss (Cavan)', zip: '815982' },
	{ city: 'Derrygowla (Mayo)', zip: '736099' },
	{ city: 'Derrygowna (Cork)', zip: '957330' },
	{ city: 'Derrygowna (Longford)', zip: '960590' },
	{ city: 'Derrygrath Lower (Tipperary)', zip: '187137' },
	{ city: 'Derrygrath Upper (Tipperary)', zip: '812145' },
	{ city: 'Derrygravaun (Clare)', zip: '947034' },
	{ city: 'Derrygreenagh (Offaly)', zip: '293450' },
	{ city: 'Derrygreenia (Kerry)', zip: '979412' },
	{ city: 'Derrygrogan Big (Offaly)', zip: '252610' },
	{ city: 'Derrygrogan Little (Offaly)', zip: '263689' },
	{ city: 'Derrygullinaun (Mayo)', zip: '561457' },
	{ city: 'Derrygunnigan (Offaly)', zip: '854793' },
	{ city: 'Derryhall (Westmeath)', zip: '554187' },
	{ city: 'Derryhallagh (Leitrim)', zip: '203641' },
	{ city: 'Derryhallagh (Monaghan)', zip: '679868' },
	{ city: 'Derryhanee (Roscommon)', zip: '366830' },
	{ city: 'Derryharney (Offaly)', zip: '916619' },
	{ city: 'Derryharraun East (Roscommon)', zip: '258620' },
	{ city: 'Derryharraun West (Roscommon)', zip: '464007' },
	{ city: 'Derryharriff Glebe (Donegal)', zip: '831955' },
	{ city: 'Derryharriff North (Mayo)', zip: '188481' },
	{ city: 'Derryharriff South (Mayo)', zip: '191304' },
	{ city: 'Derryharriv (Clare)', zip: '667617' },
	{ city: 'Derryharrow (Longford)', zip: '887685' },
	{ city: 'Derryhask (Offaly)', zip: '596971' },
	{ city: 'Derryhasna (Limerick)', zip: '826653' },
	{ city: 'Derryhawna (Mayo)', zip: '410356' },
	{ city: 'Derryhay (Laois)', zip: '290038' },
	{ city: 'Derryhee (Monaghan)', zip: '265001' },
	{ city: 'Derryheeagh (Mayo)', zip: '350151' },
	{ city: 'Derryheelan (Longford)', zip: '225939' },
	{ city: 'Derryheen (Cavan)', zip: '687575' },
	{ city: 'Derryhellan (Monaghan)', zip: '444305' },
	{ city: 'Derryherbert (Galway)', zip: '631914' },
	{ city: 'Derryherbert (Mayo)', zip: '326334' },
	{ city: 'Derryherk (Leitrim)', zip: '191790' },
	{ city: 'Derryherk (Roscommon)', zip: '832431' },
	{ city: 'Derryhick (Mayo)', zip: '893243' },
	{ city: 'Derryhillagh (Mayo)', zip: '279643' },
	{ city: 'Derryhinch (Meath)', zip: '753374' },
	{ city: 'Derryhippoo (Roscommon)', zip: '606017' },
	{ city: 'Derryhirk (Donegal)', zip: '467695' },
	{ city: 'Derryhiveny North (Galway)', zip: '614754' },
	{ city: 'Derryhiveny South (Galway)', zip: '127523' },
	{ city: 'Derryhogan (Tipperary)', zip: '309530' },
	{ city: 'Derryholmes (Offaly)', zip: '405498' },
	{ city: 'Derryhoo (Cavan)', zip: '130199' },
	{ city: 'Derryhoosh (Monaghan)', zip: '753285' },
	{ city: 'Derryhoyle Beg (Galway)', zip: '563965' },
	{ city: 'Derryhoyle More (Galway)', zip: '995686' },
	{ city: 'Derryhum (Cavan)', zip: '222969' },
	{ city: 'Derryilan (Monaghan)', zip: '864744' },
	{ city: 'Derryilra (Mayo)', zip: '661450' },
	{ city: 'Derryinver (Galway)', zip: '197992' },
	{ city: 'Derryiron (Offaly)', zip: '380714' },
	{ city: 'Derryishal (Cork)', zip: '966848' },
	{ city: 'Derryisland (Monaghan)', zip: '660793' },
	{ city: 'Derrykeadgran (Clare)', zip: '487392' },
	{ city: 'Derrykearn (Laois)', zip: '423539' },
	{ city: 'Derrykeel (Galway)', zip: '339999' },
	{ city: 'Derrykeel (Offaly)', zip: '521436' },
	{ city: 'Derrykill East (Mayo)', zip: '252208' },
	{ city: 'Derrykillew (Donegal)', zip: '769493' },
	{ city: 'Derrykill West (Mayo)', zip: '912190' },
	{ city: 'Derrykinard (Monaghan)', zip: '561048' },
	{ city: 'Derrykinlough (Mayo)', zip: '379679' },
	{ city: 'Derrykinnigh Beg (Monaghan)', zip: '645812' },
	{ city: 'Derrykinnigh More (Monaghan)', zip: '985498' },
	{ city: 'Derryknockane (Limerick)', zip: '865267' },
	{ city: 'Derrykyle (Galway)', zip: '211261' },
	{ city: 'Derrylacky (Kilkenny)', zip: '688506' },
	{ city: 'Derrylahan (Cavan)', zip: '298751' },
	{ city: 'Derrylahan (Cork)', zip: '860012' },
	{ city: 'Derrylahan (Donegal)', zip: '904183' },
	{ city: 'Derrylahan (Galway)', zip: '241383' },
	{ city: 'Derrylahan (Kerry)', zip: '721251' },
	{ city: 'Derrylahan (Laois)', zip: '602349' },
	{ city: 'Derrylahan (Leitrim)', zip: '553069' },
	{ city: 'Derrylahan (Mayo)', zip: '955835' },
	{ city: 'Derrylahan (Offaly)', zip: '365447' },
	{ city: 'Derrylahan (Roscommon)', zip: '509188' },
	{ city: 'Derrylahan (Tipperary)', zip: '676659' },
	{ city: 'Derrylahard (Cork)', zip: '432604' },
	{ city: 'Derrylane (Cavan)', zip: '230289' },
	{ city: 'Derrylaughta (Tipperary)', zip: '719433' },
	{ city: 'Derrylaur (Leitrim)', zip: '260502' },
	{ city: 'Derrylaura (Galway)', zip: '522372' },
	{ city: 'Derrylavan (Monaghan)', zip: '168971' },
	{ city: 'Derrylea (Cavan)', zip: '611131' },
	{ city: 'Derrylea (Clare)', zip: '823862' },
	{ city: 'Derrylea (Galway)', zip: '797734' },
	{ city: 'Derrylea (Kerry)', zip: '905437' },
	{ city: 'Derrylea (Kildare)', zip: '819522' },
	{ city: 'Derrylea (Mayo)', zip: '964683' },
	{ city: 'Derrylea (Monaghan)', zip: '518170' },
	{ city: 'Derrylea (Sligo)', zip: '972782' },
	{ city: 'Derrylea Beg (Monaghan)', zip: '729400' },
	{ city: 'Derryleagh (Cork)', zip: '255875' },
	{ city: 'Derryleagh (Kerry)', zip: '572407' },
	{ city: 'Derryleague (Cavan)', zip: '846161' },
	{ city: 'Derrylea More (Monaghan)', zip: '397091' },
	{ city: 'Derryleary (Cork)', zip: '268554' },
	{ city: 'Derryleconnell Far (Donegal)', zip: '789459' },
	{ city: 'Derryleconnell Near (Donegal)', zip: '741775' },
	{ city: 'Derryleedigan (Monaghan)', zip: '152421' },
	{ city: 'Derryleeg (Monaghan)', zip: '969615' },
	{ city: 'Derryleggan (Monaghan)', zip: '775031' },
	{ city: 'Derrylehan (Sligo)', zip: '155655' },
	{ city: 'Derryleigh (Cork)', zip: '750063' },
	{ city: 'Derryleigh (Tipperary)', zip: '991924' },
	{ city: 'Derrylemoge (Laois)', zip: '225396' },
	{ city: 'Derrylevick (Monaghan)', zip: '511385' },
	{ city: 'Derrylicka (Kerry)', zip: '227399' },
	{ city: 'Derrylina (Cavan)', zip: '143514' },
	{ city: 'Derrylinneen (Laois)', zip: '244685' },
	{ city: 'Derryloaghan (Donegal)', zip: '636747' },
	{ city: 'Derrylooscaunagh (Kerry)', zip: '186008' },
	{ city: 'Derrylosset (Monaghan)', zip: '213549' },
	{ city: 'Derrylough (Clare)', zip: '211256' },
	{ city: 'Derrylough (Cork)', zip: '206386' },
	{ city: 'Derrylough (Kerry)', zip: '613704' },
	{ city: 'Derrylough (Longford)', zip: '135197' },
	{ city: 'Derryloughan Beg (Mayo)', zip: '414603' },
	{ city: 'Derryloughan East (Mayo)', zip: '121431' },
	{ city: 'Derryloughan More (Mayo)', zip: '403777' },
	{ city: 'Derryloughan North (Mayo)', zip: '845907' },
	{ city: 'Derryloughan South (Mayo)', zip: '620537' },
	{ city: 'Derryloughaun East (Galway)', zip: '670579' },
	{ city: 'Derryloughaun West (Galway)', zip: '787697' },
	{ city: 'Derryloughbannow (Longford)', zip: '790034' },
	{ city: 'Derrylow (Roscommon)', zip: '940265' },
	{ city: 'Derry Lower (Mayo)', zip: '592273' },
	{ city: 'Derry Lower (Offaly)', zip: '341352' },
	{ city: 'Derry Lower (Waterford)', zip: '599185' },
	{ city: 'Derrylugga (Cork)', zip: '413786' },
	{ city: 'Derrylumman (Clare)', zip: '151687' },
	{ city: 'Derrylurgan (Cavan)', zip: '491783' },
	{ city: 'Derrylusk (Laois)', zip: '242269' },
	{ city: 'Derrylusk (Limerick)', zip: '223750' },
	{ city: 'Derrylusk (Monaghan)', zip: '820300' },
	{ city: 'Derryluskan (Tipperary)', zip: '585425' },
	{ city: 'Derrylustia (Leitrim)', zip: '863585' },
	{ city: 'Derrymacar (Longford)', zip: '103924' },
	{ city: 'Derrymacedmond (Offaly)', zip: '234640' },
	{ city: 'Derrymaclaughna (Galway)', zip: '148751' },
	{ city: 'Derrymaclavlode (Kerry)', zip: '623845' },
	{ city: 'Derrymacoffin (Leitrim)', zip: '692552' },
	{ city: 'Derrymacstur (Roscommon)', zip: '990995' },
	{ city: 'Derrymannin (Mayo)', zip: '606496' },
	{ city: 'Derrymany (Longford)', zip: '905326' },
	{ city: 'Derrymaquirk (Roscommon)', zip: '158903' },
	{ city: 'Derrymartin (Mayo)', zip: '758970' },
	{ city: 'Derrymeeleen (Cork)', zip: '183746' },
	{ city: 'Derrymihin East (Cork)', zip: '536458' },
	{ city: 'Derrymihin West (Cork)', zip: '811888' },
	{ city: 'Derrymony (Cavan)', zip: '338538' },
	{ city: 'Derrymore (Clare)', zip: '230683' },
	{ city: 'Derrymore (Donegal)', zip: '543486' },
	{ city: 'Derrymore (Galway)', zip: '430852' },
	{ city: 'Derrymore (Kerry)', zip: '639441' },
	{ city: 'Derrymore (Longford)', zip: '168567' },
	{ city: 'Derrymore (Mayo)', zip: '573393' },
	{ city: 'Derrymore (Offaly)', zip: '217308' },
	{ city: 'Derrymore (Tipperary)', zip: '514789' },
	{ city: 'Derrymore (Westmeath)', zip: '788457' },
	{ city: 'Derry More (Cavan)', zip: '619852' },
	{ city: 'Derry More (Clare)', zip: '555366' },
	{ city: 'Derry More (Laois)', zip: '613964' },
	{ city: 'Derry More (Sligo)', zip: '883718' },
	{ city: 'Derrymore East (Clare)', zip: '368636' },
	{ city: 'Derrymore East (Kerry)', zip: '169520' },
	{ city: 'Derrymore West (Clare)', zip: '819427' },
	{ city: 'Derrymore West (Kerry)', zip: '521954' },
	{ city: 'Derrymoyle (Laois)', zip: '503423' },
	{ city: 'Derrymoylin (Roscommon)', zip: '969013' },
	{ city: 'Derrymullan (Galway)', zip: '153268' },
	{ city: 'Derrymullen (Kildare)', zip: '524797' },
	{ city: 'Derrymullin And Loughderry (Offaly)', zip: '379428' },
	{ city: 'Derryna (Cavan)', zip: '674780' },
	{ city: 'Derrynabaunshy (Mayo)', zip: '454714' },
	{ city: 'Derrynablaha (Kerry)', zip: '676116' },
	{ city: 'Derrynablunnaga (Kerry)', zip: '812800' },
	{ city: 'Derrynabrack (Kerry)', zip: '959393' },
	{ city: 'Derrynabrin (Galway)', zip: '883360' },
	{ city: 'Derrynabrock (Mayo)', zip: '899261' },
	{ city: 'Derrynabuntale (Longford)', zip: '648995' },
	{ city: 'Derrynacaheragh (Cork)', zip: '667248' },
	{ city: 'Derrynacaheragh (Kerry)', zip: '785016' },
	{ city: 'Derrynacannana (Mayo)', zip: '400907' },
	{ city: 'Derrynacarragh (Clare)', zip: '924512' },
	{ city: 'Derrynacarrow (Donegal)', zip: '762242' },
	{ city: 'Derrynacarrow East (Donegal)', zip: '940095' },
	{ city: 'Derrynacleigh (Galway)', zip: '427210' },
	{ city: 'Derrynacong (Mayo)', zip: '378695' },
	{ city: 'Derrynacoulagh (Kerry)', zip: '798090' },
	{ city: 'Derrynacreeve (Cavan)', zip: '242786' },
	{ city: 'Derrynacrit (Longford)', zip: '400809' },
	{ city: 'Derrynacross (Cavan)', zip: '457815' },
	{ city: 'Derrynacross (Longford)', zip: '161066' },
	{ city: 'Derrynacross (Mayo)', zip: '385806' },
	{ city: 'Derrynacross (Roscommon)', zip: '868834' },
	{ city: 'Derrynadivva (Mayo)', zip: '746567' },
	{ city: 'Derrynadooey (Roscommon)', zip: '882952' },
	{ city: 'Derrynafeana (Kerry)', zip: '631717' },
	{ city: 'Derrynafinchin (Cork)', zip: '635967' },
	{ city: 'Derrynafinnia (Kerry)', zip: '523661' },
	{ city: 'Derrynafulla (Cork)', zip: '405573' },
	{ city: 'Derrynafunsha (Kerry)', zip: '993566' },
	{ city: 'Derrynafunshion (Laois)', zip: '471234' },
	{ city: 'Derrynagad (Monaghan)', zip: '332937' },
	{ city: 'Derrynagall (Offaly)', zip: '626462' },
	{ city: 'Derrynagalliagh (Longford)', zip: '543408' },
	{ city: 'Derrynagallion (Roscommon)', zip: '686163' },
	{ city: 'Derrynagan (Cavan)', zip: '883934' },
	{ city: 'Derrynagarragh (Westmeath)', zip: '407143' },
	{ city: 'Derrynagasha (Cork)', zip: '431532' },
	{ city: 'Derrynageeha (Clare)', zip: '211703' },
	{ city: 'Derrynagittagh (Clare)', zip: '280500' },
	{ city: 'Derrynaglah (Monaghan)', zip: '537125' },
	{ city: 'Derrynagleragh (Clare)', zip: '445922' },
	{ city: 'Derrynagooley (Mayo)', zip: '286133' },
	{ city: 'Derrynagower (Mayo)', zip: '617434' },
	{ city: 'Derrynagran (Galway)', zip: '535714' },
	{ city: 'Derrynagran (Longford)', zip: '542069' },
	{ city: 'Derrynagran (Mayo)', zip: '566213' },
	{ city: 'Derrynagraug (Sligo)', zip: '348949' },
	{ city: 'Derrynagree (Cork)', zip: '213858' },
	{ city: 'Derrynagree (Kerry)', zip: '459733' },
	{ city: 'Derrynagree East (Cork)', zip: '486768' },
	{ city: 'Derrynagree West (Cork)', zip: '280303' },
	{ city: 'Derrynagrew (Monaghan)', zip: '431361' },
	{ city: 'Derrynagrial (Donegal)', zip: '978667' },
	{ city: 'Derrynagun (Offaly)', zip: '382980' },
	{ city: 'Derrynagur (Roscommon)', zip: '196286' },
	{ city: 'Derrynaheila (Clare)', zip: '828978' },
	{ city: 'Derrynaheilla (Clare)', zip: '588817' },
	{ city: 'Derrynahesco (Monaghan)', zip: '970080' },
	{ city: 'Derrynahimmirk (Leitrim)', zip: '665263' },
	{ city: 'Derrynahinch (Kilkenny)', zip: '323150' },
	{ city: 'Derrynahinch (Leitrim)', zip: '291422' },
	{ city: 'Derrynahona (Leitrim)', zip: '192926' },
	{ city: 'Derrynakilla (Cork)', zip: '182464' },
	{ city: 'Derrynaleck (Mayo)', zip: '258661' },
	{ city: 'Derrynalecka (Clare)', zip: '498305' },
	{ city: 'Derrynalester (Cavan)', zip: '665054' },
	{ city: 'Derrynaloobinagh (Monaghan)', zip: '214572' },
	{ city: 'Derrynalurgan (Leitrim)', zip: '679647' },
	{ city: 'Derrynamanagh (Galway)', zip: '532384' },
	{ city: 'Derrynamansher (Donegal)', zip: '642547' },
	{ city: 'Derrynameel (Mayo)', zip: '488198' },
	{ city: 'Derrynamona (Cork)', zip: '125045' },
	{ city: 'Derrynamraher (Mayo)', zip: '988616' },
	{ city: 'Derrynamuck (Mayo)', zip: '412705' },
	{ city: 'Derrynamuck (Wicklow)', zip: '441650' },
	{ city: 'Derrynamucklagh (Kerry)', zip: '652895' },
	{ city: 'Derrynanaff (Mayo)', zip: '808338' },
	{ city: 'Derrynanaff (Roscommon)', zip: '457451' },
	{ city: 'Derrynanagh (Offaly)', zip: '536961' },
	{ city: 'Derrynanamph (Monaghan)', zip: '882922' },
	{ city: 'Derrynananta Lower (Cavan)', zip: '821612' },
	{ city: 'Derrynananta Upper (Cavan)', zip: '718503' },
	{ city: 'Derrynanaspol (Donegal)', zip: '615469' },
	{ city: 'Derrynaneal (Clare)', zip: '608383' },
	{ city: 'Derrynaneane (Sligo)', zip: '166463' },
	{ city: 'Derrynaned (Mayo)', zip: '101357' },
	{ city: 'Derrynanool (Cork)', zip: '402969' },
	{ city: 'Derrynaraw (Mayo)', zip: '485111' },
	{ city: 'Derrynarget (Monaghan)', zip: '784466' },
	{ city: 'Derrynarud (Mayo)', zip: '494856' },
	{ city: 'Derrynasafagh (Cork)', zip: '629386' },
	{ city: 'Derrynasaggart (Cork)', zip: '977783' },
	{ city: 'Derrynascobe (Monaghan)', zip: '885342' },
	{ city: 'Derrynasee (Roscommon)', zip: '681517' },
	{ city: 'Derrynaseer (Cavan)', zip: '292505' },
	{ city: 'Derrynaseer (Leitrim)', zip: '832708' },
	{ city: 'Derrynaseera (Laois)', zip: '347734' },
	{ city: 'Derrynasell East (Monaghan)', zip: '417439' },
	{ city: 'Derrynasell West (Monaghan)', zip: '285155' },
	{ city: 'Derrynashallog (Monaghan)', zip: '956473' },
	{ city: 'Derrynashask (Mayo)', zip: '418665' },
	{ city: 'Derrynaskea (Longford)', zip: '291657' },
	{ city: 'Derrynaskeagh (Mayo)', zip: '316009' },
	{ city: 'Derrynaskineen (Roscommon)', zip: '477031' },
	{ city: 'Derrynaslieve (Cavan)', zip: '746221' },
	{ city: 'Derrynaslieve (Sligo)', zip: '293788' },
	{ city: 'Derrynasling (Tipperary)', zip: '656281' },
	{ city: 'Derrynatuan (Cavan)', zip: '645187' },
	{ city: 'Derrynatubbrid (Cork)', zip: '769678' },
	{ city: 'Derrynavahagh (Clare)', zip: '597575' },
	{ city: 'Derrynaveagh (Clare)', zip: '117246' },
	{ city: 'Derrynavglaun (Galway)', zip: '242310' },
	{ city: 'Derrynawana (Leitrim)', zip: '466197' },
	{ city: 'Derrynea (Galway)', zip: '186076' },
	{ city: 'Derryneel (Longford)', zip: '935076' },
	{ city: 'Derryneen (Galway)', zip: '319894' },
	{ city: 'Derryness (Donegal)', zip: '513495' },
	{ city: 'Derrynid (Kerry)', zip: '290831' },
	{ city: 'Derryniggin (Leitrim)', zip: '599226' },
	{ city: 'Derrynine (Kildare)', zip: '994637' },
	{ city: 'Derrynure (Cavan)', zip: '284454' },
	{ city: 'Derryoghil (Longford)', zip: '443402' },
	{ city: 'Derryola (Cavan)', zip: '660113' },
	{ city: 'Derryolam (Monaghan)', zip: '522561' },
	{ city: 'Derryonogh (Roscommon)', zip: '223117' },
	{ city: 'Derryoober East (Galway)', zip: '631365' },
	{ city: 'Derryoober West (Galway)', zip: '203318' },
	{ city: 'Derryool (Mayo)', zip: '110925' },
	{ city: 'Derryoran (Mayo)', zip: '843587' },
	{ city: 'Derryorgan (Cork)', zip: '675257' },
	{ city: 'Derryoughter (Galway)', zip: '386520' },
	{ city: 'Derryoughter (Leitrim)', zip: '862620' },
	{ city: 'Derryoughter East (Kildare)', zip: '625833' },
	{ city: 'Derryoughter West (Kildare)', zip: '589937' },
	{ city: 'Derryounce (Offaly)', zip: '371253' },
	{ city: 'Derryowen (Clare)', zip: '262483' },
	{ city: 'Derrypark (Mayo)', zip: '532931' },
	{ city: 'Derrypatrick (Meath)', zip: '219185' },
	{ city: 'Derrypatrick Grange (Meath)', zip: '463817' },
	{ city: 'Derryphatten (Roscommon)', zip: '762802' },
	{ city: 'Derryquin (Kerry)', zip: '921244' },
	{ city: 'Derryquirk (Roscommon)', zip: '426729' },
	{ city: 'Derryra Beg (Kerry)', zip: '590381' },
	{ city: 'Derryragh (Cavan)', zip: '222476' },
	{ city: 'Derryra More (Kerry)', zip: '940737' },
	{ city: 'Derryreag (Kerry)', zip: '278684' },
	{ city: 'Derryrealt (Cavan)', zip: '171919' },
	{ city: 'Derryreel (Donegal)', zip: '905193' },
	{ city: 'Derryrellan (Monaghan)', zip: '864722' },
	{ city: 'Derryribbeen (Mayo)', zip: '493730' },
	{ city: 'Derryriordane North (Cork)', zip: '231623' },
	{ city: 'Derryriordane South (Cork)', zip: '595142' },
	{ city: 'Derry Rock South (Galway)', zip: '492351' },
	{ city: 'Derryroe (Cork)', zip: '576854' },
	{ city: 'Derryroe (Laois)', zip: '761259' },
	{ city: 'Derryronan (Mayo)', zip: '300875' },
	{ city: 'Derryroosk (Monaghan)', zip: '352823' },
	{ city: 'Derryrush (Galway)', zip: '843556' },
	{ city: 'Derryrush (Kerry)', zip: '293010' },
	{ city: 'Derrysallagh (Kerry)', zip: '134688' },
	{ city: 'Derrysallagh (Sligo)', zip: '125720' },
	{ city: 'Derryshaan (Clare)', zip: '540400' },
	{ city: 'Derryshannoge (Longford)', zip: '199787' },
	{ city: 'Derrysheridan (Meath)', zip: '218444' },
	{ city: 'Derrysillagh (Galway)', zip: '776450' },
	{ city: 'Derrysiskal (Galway)', zip: '742176' },
	{ city: 'Derryteigeroe (Leitrim)', zip: '927147' },
	{ city: 'Derrytrasna (Laois)', zip: '334000' },
	{ city: 'Derryulk (Clare)', zip: '555849' },
	{ city: 'Derryulk Lower (Clare)', zip: '680598' },
	{ city: 'Derryulk Middle (Clare)', zip: '739357' },
	{ city: 'Derryulk Upper (Clare)', zip: '462175' },
	{ city: 'Derry Upper (Mayo)', zip: '263013' },
	{ city: 'Derry Upper (Offaly)', zip: '743402' },
	{ city: 'Derry Upper (Waterford)', zip: '828332' },
	{ city: 'Derryvackny (Cavan)', zip: '800160' },
	{ city: 'Derryvacorneen (Cork)', zip: '936982' },
	{ city: 'Derryvahalla (Cork)', zip: '592403' },
	{ city: 'Derryvahan (Cavan)', zip: '915763' },
	{ city: 'Derryvalannagher Glebe (Leitrim)', zip: '397443' },
	{ city: 'Derryvale (Tipperary)', zip: '949541' },
	{ city: 'Derryvaleen (Cork)', zip: '916829' },
	{ city: 'Derryvally (Monaghan)', zip: '665830' },
	{ city: 'Derryvane (Cork)', zip: '110275' },
	{ city: 'Derryvane (Donegal)', zip: '276979' },
	{ city: 'Derryvarroge (Kildare)', zip: '853229' },
	{ city: 'Derryveagh (Longford)', zip: '303611' },
	{ city: 'Derryveagh (Monaghan)', zip: '342226' },
	{ city: 'Derryvealawauma (Galway)', zip: '765841' },
	{ city: 'Derryveen (Monaghan)', zip: '980734' },
	{ city: 'Derryveeny (Mayo)', zip: '267764' },
	{ city: 'Derryvehil (Cavan)', zip: '351531' },
	{ city: 'Derryvella (Cavan)', zip: '434532' },
	{ city: 'Derryvella (Tipperary)', zip: '641680' },
	{ city: 'Derryvet (Clare)', zip: '760589' },
	{ city: 'Derryvickrune (Galway)', zip: '366152' },
	{ city: 'Derryvicneill (Mayo)', zip: '814712' },
	{ city: 'Derryvilla (Offaly)', zip: '491812' },
	{ city: 'Derryvillane (Cork)', zip: '726499' },
	{ city: 'Derryville (Tipperary)', zip: '554215' },
	{ city: 'Derryvinna (Clare)', zip: '347021' },
	{ city: 'Derryvinnaan (Clare)', zip: '940705' },
	{ city: 'Derryvinnane (Limerick)', zip: '685641' },
	{ city: 'Derryvoghil (Galway)', zip: '324941' },
	{ city: 'Derryvohy (Mayo)', zip: '798364' },
	{ city: 'Derryvokeel (Galway)', zip: '786983' },
	{ city: 'Derryvony (Cavan)', zip: '641139' },
	{ city: 'Derryvorahig (Kerry)', zip: '422979' },
	{ city: 'Derryvoreada (Galway)', zip: '510287' },
	{ city: 'Derryvorrigan (Laois)', zip: '165364' },
	{ city: 'Derryvreen (Cork)', zip: '572263' },
	{ city: 'Derryvrin (Kerry)', zip: '402418' },
	{ city: 'Derryvrisk (Galway)', zip: '711542' },
	{ city: 'Derryvulcaun (Mayo)', zip: '512193' },
	{ city: 'Derryvung (Roscommon)', zip: '883893' },
	{ city: 'Derryvunlam (Galway)', zip: '740481' },
	{ city: 'Derryvunny (Roscommon)', zip: '647586' },
	{ city: 'Derrywanna (Roscommon)', zip: '991167' },
	{ city: 'Derrywee East (Galway)', zip: '229906' },
	{ city: 'Derryweelan (Offaly)', zip: '432195' },
	{ city: 'Derrywee West (Galway)', zip: '442770' },
	{ city: 'Derry West (Kerry)', zip: '439029' },
	{ city: 'Derrywillin (Clare)', zip: '556793' },
	{ city: 'Derrywillow (Leitrim)', zip: '206877' },
	{ city: 'Derrywinny (Cavan)', zip: '302909' },
	{ city: 'Derrywode (Galway)', zip: '930223' },
	{ city: 'Derver (Meath)', zip: '737983' },
	{ city: 'Dervin (Mayo)', zip: '549281' },
	{ city: 'Dervotstown (Westmeath)', zip: '889252' },
	{ city: 'Desart Demesne (Kilkenny)', zip: '831993' },
	{ city: 'Descart (Monaghan)', zip: '932714' },
	{ city: 'Desert (Cork)', zip: '425944' },
	{ city: 'Desert (Monaghan)', zip: '595421' },
	{ city: 'Deshure (Cork)', zip: '777439' },
	{ city: 'Destinrath (Meath)', zip: '439045' },
	{ city: 'Devally (Cavan)', zip: '901847' },
	{ city: 'Devinstown (Meath)', zip: '222100' },
	{ city: 'Devleash (Mayo)', zip: '995619' },
	{ city: 'Devleash East (Mayo)', zip: '764503' },
	{ city: 'Devleash West (Mayo)', zip: '107096' },
	{ city: 'Devlin (Donegal)', zip: '404394' },
	{ city: 'Devlin (Mayo)', zip: '293649' },
	{ city: 'Devlin (Monaghan)', zip: '381809' },
	{ city: 'Devlinmore (Donegal)', zip: '930910' },
	{ city: 'Devlin North (Mayo)', zip: '243770' },
	{ city: 'Devlinreagh (Donegal)', zip: '435986' },
	{ city: 'Devlin South (Mayo)', zip: '683511' },
	{ city: 'Devlis (Mayo)', zip: '372399' },
	{ city: 'Diamor (Meath)', zip: '512498' },
	{ city: 'Dian (Monaghan)', zip: '492461' },
	{ city: 'Dicksborough (Kilkenny)', zip: '643039' },
	{ city: 'Dicksgrove (Kerry)', zip: '721117' },
	{ city: 'Diffin (Leitrim)', zip: '709388' },
	{ city: 'Difflin (Donegal)', zip: '319339' },
	{ city: 'Diffreen (Leitrim)', zip: '309916' },
	{ city: 'Dillagh (Cavan)', zip: '356107' },
	{ city: 'Dillonsdown (Wicklow)', zip: '930569' },
	{ city: 'Dillonsland (Meath)', zip: '938134' },
	{ city: 'Dillonstown (Louth)', zip: '455277' },
	{ city: 'Dimanistown East (Meath)', zip: '600026' },
	{ city: 'Dimanistown West (Meath)', zip: '196928' },
	{ city: 'Dingin (Cavan)', zip: '569544' },
	{ city: 'Dinginavanty (Cavan)', zip: '553769' },
	{ city: 'Dingins (Cavan)', zip: '673552' },
	{ city: 'Dingle (Kerry)', zip: '920832' },
	{ city: 'Dinish (Galway)', zip: '847441' },
	{ city: 'Dinish Island (Kerry)', zip: '477638' },
	{ city: 'Dinneens (Kerry)', zip: '301599' },
	{ city: 'Diralagh (Meath)', zip: '632455' },
	{ city: 'Dirkbeg (Mayo)', zip: '964007' },
	{ city: 'Dirtane (Kerry)', zip: '384283' },
	{ city: 'Dirtystep (Kilkenny)', zip: '718968' },
	{ city: 'Disert (Cavan)', zip: '745640' },
	{ city: 'Disert (Cork)', zip: '932954' },
	{ city: 'Disert (Donegal)', zip: '383423' },
	{ city: 'Diswellstown (Dublin)', zip: '123047' },
	{ city: 'Divish (Mayo)', zip: '648686' },
	{ city: "D'Loughtane (Waterford)", zip: '871065' },
	{ city: 'Doagh (Donegal)', zip: '383250' },
	{ city: 'Doagh (Monaghan)', zip: '877155' },
	{ city: 'Doagh Beg (Donegal)', zip: '574190' },
	{ city: 'Doaghcrabbin (Donegal)', zip: '587189' },
	{ city: 'Doagheys (Monaghan)', zip: '254832' },
	{ city: 'Doagh More (Donegal)', zip: '591639' },
	{ city: 'Doddsborough (Dublin)', zip: '744385' },
	{ city: 'Doghtog (Meath)', zip: '261600' },
	{ city: 'Dog Island (Galway)', zip: '635951' },
	{ city: 'Dogstown (Meath)', zip: '751041' },
	{ city: 'Dogstown (Tipperary)', zip: '621684' },
	{ city: 'Dohilla (Kerry)', zip: '579236' },
	{ city: 'Dohora (Limerick)', zip: '881299' },
	{ city: 'Dolan (Galway)', zip: '177124' },
	{ city: 'Dolanstown (Meath)', zip: '411421' },
	{ city: 'Dolanstown Kilcashel (Roscommon)', zip: '100450' },
	{ city: 'Dolla (Tipperary)', zip: '125539' },
	{ city: 'Dollards (Dublin)', zip: '816846' },
	{ city: 'Dollardstown (Kildare)', zip: '398756' },
	{ city: 'Dollardstown (Meath)', zip: '932543' },
	{ city: 'Dollas (Limerick)', zip: '495201' },
	{ city: 'Dollas Lower (Limerick)', zip: '369028' },
	{ city: 'Dollas Upper (Limerick)', zip: '155090' },
	{ city: 'Dollymount (Dublin)', zip: '653356' },
	{ city: 'Dolphins Barn (Dublin)', zip: '621379' },
	{ city: 'Donabate (Dublin)', zip: '730737' },
	{ city: 'Donacarney Great (Meath)', zip: '668169' },
	{ city: 'Donacarney Little (Meath)', zip: '205004' },
	{ city: 'Donadea (Kildare)', zip: '347405' },
	{ city: 'Donadea Demesne (Kildare)', zip: '215254' },
	{ city: 'Donagh (Monaghan)', zip: '633676' },
	{ city: 'Donagh Beg (Leitrim)', zip: '650502' },
	{ city: 'Donaghcumper (Kildare)', zip: '453463' },
	{ city: 'Donaghintraine (Sligo)', zip: '571880' },
	{ city: 'Donaghmede (Dublin)', zip: '884118' },
	{ city: 'Donaghmore (Cork)', zip: '460249' },
	{ city: 'Donaghmore (Kildare)', zip: '256081' },
	{ city: 'Donaghmore (Kilkenny)', zip: '383747' },
	{ city: 'Donaghmore (Laois)', zip: '481153' },
	{ city: 'Donaghmore (Louth)', zip: '269161' },
	{ city: 'Donaghmore (Meath)', zip: '219963' },
	{ city: 'Donaghmore (Tipperary)', zip: '509507' },
	{ city: 'Donaghmore (Wexford)', zip: '406629' },
	{ city: 'Donaghmore (Wicklow)', zip: '272890' },
	{ city: 'Donagh More (Leitrim)', zip: '780166' },
	{ city: 'Donaghmore Glebe (Donegal)', zip: '136228' },
	{ city: 'Donaghmore Lower (Kilkenny)', zip: '826327' },
	{ city: 'Donaghmore Upper (Kilkenny)', zip: '197805' },
	{ city: 'Donaghmoyne (Monaghan)', zip: '216268' },
	{ city: 'Donaghpatrick (Galway)', zip: '870855' },
	{ city: 'Donaghpatrick (Meath)', zip: '642444' },
	{ city: 'Donaghstown (Kildare)', zip: '152838' },
	{ city: 'Donaguile (Kilkenny)', zip: '650747' },
	{ city: 'Donard (Wexford)', zip: '277058' },
	{ city: 'Donard (Wicklow)', zip: '911153' },
	{ city: 'Donard Demesne East (Wicklow)', zip: '820058' },
	{ city: 'Donard Demesne West (Wicklow)', zip: '972128' },
	{ city: 'Donard Lower (Wicklow)', zip: '786474' },
	{ city: 'Donard Mountain (Wicklow)', zip: '733618' },
	{ city: 'Donard Upper (Wicklow)', zip: '441835' },
	{ city: 'Donaskeagh (Tipperary)', zip: '364234' },
	{ city: 'Donegal (Cork)', zip: '761035' },
	{ city: 'Donegal (Donegal)', zip: '689269' },
	{ city: 'Donegal (Tipperary)', zip: '780604' },
	{ city: 'Donegall East (Cork)', zip: '434110' },
	{ city: 'Donegall Middle (Cork)', zip: '240101' },
	{ city: 'Donegall West (Cork)', zip: '867463' },
	{ city: 'Doneraile (Cork)', zip: '185698' },
	{ city: 'Donickmore (Cork)', zip: '782213' },
	{ city: 'Donnellystown (Louth)', zip: '243817' },
	{ city: 'Donnybrook (Clare)', zip: '217965' },
	{ city: 'Donnybrook (Dublin)', zip: '945443' },
	{ city: 'Donnybrook (Tipperary)', zip: '827473' },
	{ city: 'Donnycarney (Dublin)', zip: '482391' },
	{ city: 'Donode Big (Kildare)', zip: '704549' },
	{ city: 'Donode Little (Kildare)', zip: '426280' },
	{ city: 'Donohill (Tipperary)', zip: '924822' },
	{ city: 'Donohill Lands (Tipperary)', zip: '543162' },
	{ city: 'Donore (Carlow)', zip: '358038' },
	{ city: 'Donore (Kildare)', zip: '297404' },
	{ city: 'Donore (Laois)', zip: '359287' },
	{ city: 'Donore (Meath)', zip: '689345' },
	{ city: 'Donore (Westmeath)', zip: '212499' },
	{ city: 'Donore Demesne (Westmeath)', zip: '887039' },
	{ city: 'Donoughmore (Cork)', zip: '881023' },
	{ city: 'Donoure (Cork)', zip: '595990' },
	{ city: 'Donoure East (Cork)', zip: '696978' },
	{ city: 'Donoure Middle (Cork)', zip: '802843' },
	{ city: 'Donoure West (Cork)', zip: '661169' },
	{ city: 'Dooagh (Mayo)', zip: '364642' },
	{ city: 'Dooaghs (Kerry)', zip: '254673' },
	{ city: 'Dooaghs Commons (Kerry)', zip: '559075' },
	{ city: 'Dooaghtry (Mayo)', zip: '540531' },
	{ city: 'Dooally (Limerick)', zip: '721857' },
	{ city: 'Dooan (Roscommon)', zip: '147215' },
	{ city: 'Dooard (Leitrim)', zip: '206183' },
	{ city: 'Dooary (Laois)', zip: '589626' },
	{ city: 'Dooballagh (Donegal)', zip: '589874' },
	{ city: 'Doobally (Donegal)', zip: '127258' },
	{ city: 'Doobally (Leitrim)', zip: '493664' },
	{ city: 'Doobeg (Sligo)', zip: '774648' },
	{ city: 'Doobehy (Mayo)', zip: '154359' },
	{ city: 'Doobin (Donegal)', zip: '823982' },
	{ city: 'Doocarrick (Cavan)', zip: '937502' },
	{ city: 'Doocarrick (Donegal)', zip: '445695' },
	{ city: 'Doocarrig Beg (Kerry)', zip: '340109' },
	{ city: 'Doocarrig More (Kerry)', zip: '306149' },
	{ city: 'Doocashel Glebe (Donegal)', zip: '590180' },
	{ city: 'Doocassan (Cavan)', zip: '164443' },
	{ city: 'Doocastle (Mayo)', zip: '818755' },
	{ city: 'Doocatteen (Limerick)', zip: '229535' },
	{ city: 'Doocharn (Monaghan)', zip: '728543' },
	{ city: 'Doocharry (Donegal)', zip: '764574' },
	{ city: 'Doochill North (Donegal)', zip: '347687' },
	{ city: 'Doochorran (Leitrim)', zip: '497579' },
	{ city: 'Doocreggaun (Galway)', zip: '338357' },
	{ city: 'Doocrow (Donegal)', zip: '732535' },
	{ city: 'Doodys Bottoms (Wicklow)', zip: '904200' },
	{ city: 'Dooega (Mayo)', zip: '873972' },
	{ city: 'Dooey (Donegal)', zip: '739984' },
	{ city: 'Doogans Warren (Wexford)', zip: '648216' },
	{ city: 'Doogarraun (Galway)', zip: '945523' },
	{ city: 'Doogary (Cavan)', zip: '926766' },
	{ city: 'Doogary (Kerry)', zip: '824904' },
	{ city: 'Doogary (Mayo)', zip: '455675' },
	{ city: 'Doogary (Monaghan)', zip: '165863' },
	{ city: 'Doogary (Roscommon)', zip: '771563' },
	{ city: 'Doogarymore (Roscommon)', zip: '327079' },
	{ city: 'Dooghan (Donegal)', zip: '527795' },
	{ city: 'Dooghan (Roscommon)', zip: '362984' },
	{ city: 'Dooghbeg (Mayo)', zip: '550618' },
	{ city: 'Dooghcloon (Galway)', zip: '292774' },
	{ city: 'Dooghill (Mayo)', zip: '696029' },
	{ city: 'Dooghmakeon (Mayo)', zip: '499541' },
	{ city: 'Dooghta (Galway)', zip: '847685' },
	{ city: 'Dooglaun (Clare)', zip: '833047' },
	{ city: 'Doogort (Mayo)', zip: '699708' },
	{ city: 'Doogort East (Mayo)', zip: '158275' },
	{ city: 'Doogort West (Mayo)', zip: '461587' },
	{ city: 'Doohallat (Cavan)', zip: '427206' },
	{ city: 'Doohamlat (Monaghan)', zip: '852948' },
	{ city: 'Doohat (Monaghan)', zip: '457162' },
	{ city: 'Doohatty (Monaghan)', zip: '288908' },
	{ city: 'Dooherty (Roscommon)', zip: '178262' },
	{ city: 'Doohooma (Mayo)', zip: '717673' },
	{ city: 'Doohulla (Galway)', zip: '142231' },
	{ city: 'Doohyle Beg (Limerick)', zip: '920359' },
	{ city: 'Doohyle More (Limerick)', zip: '711019' },
	{ city: 'Dooish (Donegal)', zip: '274428' },
	{ city: 'Dookinelly (Mayo)', zip: '514772' },
	{ city: 'Doolagh (Dublin)', zip: '230337' },
	{ city: 'Doolahig (Kerry)', zip: '295789' },
	{ city: 'Doolaig North (Kerry)', zip: '434530' },
	{ city: 'Doolaig South (Kerry)', zip: '663140' },
	{ city: 'Doolargy (Louth)', zip: '921640' },
	{ city: 'Doolargy Glebe (Leitrim)', zip: '978089' },
	{ city: 'Dooleague (Mayo)', zip: '388117' },
	{ city: 'Dooleeg (Mayo)', zip: '111836' },
	{ city: 'Dooleeg Beg (Mayo)', zip: '409454' },
	{ city: 'Dooleeg More (Mayo)', zip: '938471' },
	{ city: 'Dooletter (Mayo)', zip: '618298' },
	{ city: 'Dooletter East (Galway)', zip: '534885' },
	{ city: 'Dooletter West (Galway)', zip: '949730' },
	{ city: 'Doolin (Clare)', zip: '161102' },
	{ city: 'Doolis (Tipperary)', zip: '631963' },
	{ city: 'Doolough (Clare)', zip: '789231' },
	{ city: 'Doolough (Laois)', zip: '359468' },
	{ city: 'Doolough (Mayo)', zip: '950128' },
	{ city: 'Doolystown (Meath)', zip: '872478' },
	{ city: 'Doomore (Sligo)', zip: '559045' },
	{ city: 'Doon (Cavan)', zip: '445839' },
	{ city: 'Doon (Clare)', zip: '150234' },
	{ city: 'Doon (Donegal)', zip: '116134' },
	{ city: 'Doon (Galway)', zip: '709487' },
	{ city: 'Doon (Kerry)', zip: '582522' },
	{ city: 'Doon (Laois)', zip: '839397' },
	{ city: 'Doon (Limerick)', zip: '366600' },
	{ city: 'Doon (Mayo)', zip: '162285' },
	{ city: 'Doon (Meath)', zip: '765195' },
	{ city: 'Doon (Roscommon)', zip: '927173' },
	{ city: 'Doon (Sligo)', zip: '956437' },
	{ city: 'Doon (Tipperary)', zip: '641149' },
	{ city: 'Doon (Waterford)', zip: '467510' },
	{ city: 'Doon (Westmeath)', zip: '895174' },
	{ city: 'Doona (Mayo)', zip: '500554' },
	{ city: 'Doonacurry (Longford)', zip: '382879' },
	{ city: 'Doonadoba (Mayo)', zip: '370823' },
	{ city: 'Doonaha (Clare)', zip: '977337' },
	{ city: 'Doonaha East (Clare)', zip: '893072' },
	{ city: 'Doonahaha (Roscommon)', zip: '723137' },
	{ city: 'Doonaha West (Clare)', zip: '824436' },
	{ city: 'Doonakenna (Limerick)', zip: '259361' },
	{ city: 'Doonally (Sligo)', zip: '428283' },
	{ city: 'Doonally East (Galway)', zip: '932962' },
	{ city: 'Doonally West (Galway)', zip: '456311' },
	{ city: 'Doonalt (Donegal)', zip: '704586' },
	{ city: 'Doonaltan (Sligo)', zip: '342039' },
	{ city: 'Doonameran (Longford)', zip: '358852' },
	{ city: 'Doonamona (Mayo)', zip: '365684' },
	{ city: 'Doonamona (Westmeath)', zip: '658277' },
	{ city: 'Doonamontane (Kerry)', zip: '628322' },
	{ city: 'Doonamurray (Sligo)', zip: '499564' },
	{ city: 'Doonan (Donegal)', zip: '695379' },
	{ city: 'Doonanarroo Lower (Mayo)', zip: '434695' },
	{ city: 'Doonanarroo Upper (Mayo)', zip: '423294' },
	{ city: 'Doonane (Laois)', zip: '526286' },
	{ city: 'Doonane (Tipperary)', zip: '673084' },
	{ city: 'Doonarah (Leitrim)', zip: '163260' },
	{ city: 'Doonard (Galway)', zip: '105256' },
	{ city: 'Doonard Beg (Roscommon)', zip: '231530' },
	{ city: 'Doonard Lower (Kerry)', zip: '285713' },
	{ city: 'Doonard More (Roscommon)', zip: '115511' },
	{ city: 'Doonard Upper (Kerry)', zip: '797660' },
	{ city: 'Doonaree (Galway)', zip: '564794' },
	{ city: 'Doonaroya (Mayo)', zip: '542421' },
	{ city: 'Doonasleen East (Cork)', zip: '387783' },
	{ city: 'Doonasleen North (Cork)', zip: '509084' },
	{ city: 'Doonasleen South (Cork)', zip: '311140' },
	{ city: 'Doonass (Clare)', zip: '172203' },
	{ city: 'Doonass Demesne (Clare)', zip: '842447' },
	{ city: 'Doonaun (Clare)', zip: '862171' },
	{ city: 'Doonaun (Galway)', zip: '621857' },
	{ city: 'Doonavanig (Cork)', zip: '797530' },
	{ city: 'Doonaveeragh (Sligo)', zip: '491977' },
	{ city: 'Doonawanly (Cork)', zip: '821315' },
	{ city: 'Doonbeakin (Sligo)', zip: '746214' },
	{ city: 'Doonbeg (Clare)', zip: '454454' },
	{ city: 'Doonbeg (Galway)', zip: '693015' },
	{ city: 'Doonbeirne (Limerick)', zip: '539268' },
	{ city: 'Doonbreedia (Mayo)', zip: '239539' },
	{ city: 'Doonbreedia Mountain (Mayo)', zip: '819788' },
	{ city: 'Dooncaha (Kerry)', zip: '803603' },
	{ city: 'Dooncaha (Limerick)', zip: '760584' },
	{ city: 'Dooncarton (Mayo)', zip: '596579' },
	{ city: 'Dooncastle (Mayo)', zip: '377005' },
	{ city: 'Doon Demesne (Offaly)', zip: '233869' },
	{ city: 'Doon East (Kerry)', zip: '964545' },
	{ city: 'Dooneen (Clare)', zip: '342999' },
	{ city: 'Dooneen (Cork)', zip: '228076' },
	{ city: 'Dooneen (Galway)', zip: '984345' },
	{ city: 'Dooneen (Kerry)', zip: '824790' },
	{ city: 'Dooneen (Limerick)', zip: '352232' },
	{ city: 'Dooneen (Roscommon)', zip: '349830' },
	{ city: 'Dooneen (Sligo)', zip: '767729' },
	{ city: 'Dooneen (Waterford)', zip: '593482' },
	{ city: 'Dooneen Lower (Cork)', zip: '124573' },
	{ city: 'Dooneenmacotter (Cork)', zip: '352876' },
	{ city: 'Dooneen North (Cork)', zip: '583680' },
	{ city: 'Dooneens (Cork)', zip: '511512' },
	{ city: 'Dooneen South (Cork)', zip: '743015' },
	{ city: 'Dooneen Upper (Cork)', zip: '948816' },
	{ city: 'Dooneen Upper (Limerick)', zip: '537060' },
	{ city: 'Doonfeeny Lower (Mayo)', zip: '492617' },
	{ city: 'Doonfeeny Upper (Mayo)', zip: '600755' },
	{ city: 'Doonflin Lower (Sligo)', zip: '339186' },
	{ city: 'Doonflin Upper (Sligo)', zip: '726112' },
	{ city: 'Doonfore (Sligo)', zip: '167985' },
	{ city: 'Doongelagh (Sligo)', zip: '501360' },
	{ city: 'Doon Glebe (Donegal)', zip: '774067' },
	{ city: 'Doonierin (Sligo)', zip: '738375' },
	{ city: 'Doonimlaghbeg (Kerry)', zip: '297973' },
	{ city: 'Doonis (Westmeath)', zip: '751788' },
	{ city: 'Dooniver (Mayo)', zip: '375657' },
	{ city: 'Doonkelly (Leitrim)', zip: '498242' },
	{ city: 'Doonkinane (Kerry)', zip: '677592' },
	{ city: 'Doonloughan (Galway)', zip: '920138' },
	{ city: 'Doon Lower (Galway)', zip: '738958' },
	{ city: 'Doonmacfelim (Clare)', zip: '341865' },
	{ city: 'Doonmacreena (Mayo)', zip: '346549' },
	{ city: 'Doonmadden (Sligo)', zip: '233742' },
	{ city: 'Doonmanagh (Kerry)', zip: '607844' },
	{ city: 'Doonmaynor (Mayo)', zip: '510375' },
	{ city: 'Doonmeegin (Sligo)', zip: '516011' },
	{ city: 'Doonmoon (Limerick)', zip: '956229' },
	{ city: 'Doonmore (Clare)', zip: '192462' },
	{ city: 'Doonmorgan (Leitrim)', zip: '494582' },
	{ city: 'Doonnagore (Clare)', zip: '328295' },
	{ city: 'Doonnagurroge (Clare)', zip: '752829' },
	{ city: 'Doonnamona (Mayo)', zip: '626288' },
	{ city: 'Doon North (Kerry)', zip: '394717' },
	{ city: 'Doon North (Limerick)', zip: '648917' },
	{ city: 'Doonogan (Clare)', zip: '209139' },
	{ city: 'Doonooney (Wexford)', zip: '925139' },
	{ city: 'Doonoor (Tipperary)', zip: '226293' },
	{ city: 'Doonore North (Kerry)', zip: '580812' },
	{ city: 'Doonore South (Kerry)', zip: '259019' },
	{ city: 'Doonour (Cork)', zip: '910187' },
	{ city: 'Doonowen (Galway)', zip: '917544' },
	{ city: 'Doonowney (Sligo)', zip: '255993' },
	{ city: 'Doonpeter (Cork)', zip: '454560' },
	{ city: 'Doonreaghan (Galway)', zip: '223143' },
	{ city: 'Doonryan (Kerry)', zip: '282931' },
	{ city: 'Doonsallagh East (Clare)', zip: '939201' },
	{ city: 'Doonsallagh West (Clare)', zip: '440763' },
	{ city: 'Doonshaskin (Sligo)', zip: '604274' },
	{ city: 'Doonsheane (Kerry)', zip: '419724' },
	{ city: 'Doonsheheen (Sligo)', zip: '643458' },
	{ city: 'Doonskerdeen (Limerick)', zip: '223992' },
	{ city: 'Doon South (Kerry)', zip: '466285' },
	{ city: 'Doon South (Limerick)', zip: '921555' },
	{ city: 'Doonties Commons (Kerry)', zip: '318965' },
	{ city: 'Doonties East (Kerry)', zip: '288315' },
	{ city: 'Doonties West (Kerry)', zip: '422597' },
	{ city: 'Doontrusk (Mayo)', zip: '553991' },
	{ city: 'Doonty (Mayo)', zip: '764700' },
	{ city: 'Doonty Eighter (Mayo)', zip: '154374' },
	{ city: 'Doon Upper (Galway)', zip: '767887' },
	{ city: 'Doonvullen Lower (Limerick)', zip: '495283' },
	{ city: 'Doonvullen Upper (Limerick)', zip: '997225' },
	{ city: 'Doon West (Kerry)', zip: '337902' },
	{ city: 'Doonwood (Galway)', zip: '734765' },
	{ city: 'Doony (Cork)', zip: '213016' },
	{ city: 'Doonycoy (Sligo)', zip: '756333' },
	{ city: 'Doonyvardan (Clare)', zip: '649842' },
	{ city: 'Doora (Leitrim)', zip: '105898' },
	{ city: 'Dooraa (Monaghan)', zip: '652124' },
	{ city: 'Doorabble (Donegal)', zip: '446905' },
	{ city: 'Dooradoyle (Limerick)', zip: '467977' },
	{ city: 'Doorah (Kerry)', zip: '384947' },
	{ city: 'Dooraheen (Westmeath)', zip: '280273' },
	{ city: 'Doorath (Kilkenny)', zip: '136823' },
	{ city: 'Doorath (Mayo)', zip: '911559' },
	{ city: 'Dooreagh (Cavan)', zip: '510558' },
	{ city: 'Dooree Commons (Tipperary)', zip: '102413' },
	{ city: 'Dooreel (Mayo)', zip: '740102' },
	{ city: 'Doorian (Donegal)', zip: '757467' },
	{ city: 'Doorish (Tipperary)', zip: '734962' },
	{ city: 'Doorlus (Limerick)', zip: '848701' },
	{ city: 'Doorly (Sligo)', zip: '361997' },
	{ city: 'Doornane (Kilkenny)', zip: '739875' },
	{ city: 'Dooroc (Longford)', zip: '938443' },
	{ city: 'Dooroge (Dublin)', zip: '755643' },
	{ city: 'Dooros (Clare)', zip: '514000' },
	{ city: 'Dooros (Donegal)', zip: '155785' },
	{ city: 'Dooros (Galway)', zip: '609153' },
	{ city: 'Dooros (Mayo)', zip: '674319' },
	{ city: 'Doorosheath (Offaly)', zip: '700540' },
	{ city: 'Dooroy (Galway)', zip: '880361' },
	{ city: 'Doorus (Clare)', zip: '370558' },
	{ city: 'Doorus (Cork)', zip: '704688' },
	{ city: 'Doorus (Galway)', zip: '904796' },
	{ city: 'Doorus Demesne (Galway)', zip: '897332' },
	{ city: 'Doorus East (Clare)', zip: '325017' },
	{ city: 'Dooruspark (Galway)', zip: '455116' },
	{ city: 'Doorus West (Clare)', zip: '905882' },
	{ city: 'Doory (Kerry)', zip: '520762' },
	{ city: 'Doory (Longford)', zip: '202765' },
	{ city: 'Doory (Offaly)', zip: '610779' },
	{ city: 'Doosky (Monaghan)', zip: '575148' },
	{ city: 'Dooslattagh (Roscommon)', zip: '289657' },
	{ city: 'Doostroke (Leitrim)', zip: '314840' },
	{ city: 'Doovilra (Mayo)', zip: '635703' },
	{ city: 'Doovoge (Roscommon)', zip: '240335' },
	{ city: 'Doovoge (Westmeath)', zip: '133229' },
	{ city: 'Dooyeaghny (Mayo)', zip: '578124' },
	{ city: 'Dooyeher (Galway)', zip: '468508' },
	{ city: 'Dooyork (Mayo)', zip: '175889' },
	{ city: 'Dore (Donegal)', zip: '218630' },
	{ city: 'Dorneyswell (Tipperary)', zip: '351358' },
	{ city: 'Dorrary (Roscommon)', zip: '414515' },
	{ city: 'Dorrusawillin (Leitrim)', zip: '686670' },
	{ city: 'Dough (Clare)', zip: '551358' },
	{ city: 'Dough (Cork)', zip: '455982' },
	{ city: 'Doughal (Wexford)', zip: '572668' },
	{ city: 'Doughcloyne (Cork)', zip: '719813' },
	{ city: 'Doughil (Roscommon)', zip: '539152' },
	{ city: 'Doughill (Kerry)', zip: '840774' },
	{ city: 'Doughill (Tipperary)', zip: '683956' },
	{ city: 'Doughill South (Donegal)', zip: '217891' },
	{ city: 'Doughkill (Tipperary)', zip: '112572' },
	{ city: 'Doughloon (Roscommon)', zip: '355443' },
	{ city: 'Douglas (Cork)', zip: '163550' },
	{ city: 'Douglas (Kerry)', zip: '244040' },
	{ city: 'Dovea (Tipperary)', zip: '271146' },
	{ city: 'Dovea Lower (Tipperary)', zip: '371659' },
	{ city: 'Dovea Upper (Tipperary)', zip: '103149' },
	{ city: 'Dovegrove (Offaly)', zip: '203877' },
	{ city: 'Dovehill (Offaly)', zip: '610438' },
	{ city: 'Dovepark (Galway)', zip: '333156' },
	{ city: 'Dowagh East (Mayo)', zip: '811923' },
	{ city: 'Dowagh West (Mayo)', zip: '267936' },
	{ city: 'Dowdallshill (Louth)', zip: '686331' },
	{ city: 'Dowdenstown Great (Kildare)', zip: '186911' },
	{ city: 'Dowdenstown Little (Kildare)', zip: '434683' },
	{ city: 'Dowdingstown (Kildare)', zip: '742542' },
	{ city: 'Dowdstown (Kildare)', zip: '821391' },
	{ city: 'Dowdstown (Louth)', zip: '758844' },
	{ city: 'Dowdstown (Meath)', zip: '437794' },
	{ city: 'Dower (Cork)', zip: '894742' },
	{ city: 'Dower (Roscommon)', zip: '830121' },
	{ city: 'Dowling (Kilkenny)', zip: '423254' },
	{ city: 'Down (Offaly)', zip: '319191' },
	{ city: 'Down (Westmeath)', zip: '167647' },
	{ city: 'Downamona (Tipperary)', zip: '249585' },
	{ city: 'Downeen (Cork)', zip: '372534' },
	{ city: 'Downestown (Meath)', zip: '765054' },
	{ city: 'Downies (Donegal)', zip: '527935' },
	{ city: 'Downies Barr (Donegal)', zip: '612246' },
	{ city: 'Downing North (Cork)', zip: '362375' },
	{ city: 'Downings (Carlow)', zip: '109899' },
	{ city: 'Downings (Wicklow)', zip: '833821' },
	{ city: 'Downings North (Kildare)', zip: '104470' },
	{ city: 'Downing South (Cork)', zip: '747950' },
	{ city: 'Downings South (Kildare)', zip: '402624' },
	{ city: 'Downmacpatrick (Cork)', zip: '106748' },
	{ city: 'Downs (Laois)', zip: '415331' },
	{ city: 'Downs (Limerick)', zip: '355939' },
	{ city: 'Downs (Monaghan)', zip: '570328' },
	{ city: 'Downs (Westmeath)', zip: '675417' },
	{ city: 'Downs (Wicklow)', zip: '205865' },
	{ city: 'Downshill (Wicklow)', zip: '398518' },
	{ city: 'Dowra (Cavan)', zip: '173468' },
	{ city: 'Dowrea (Sligo)', zip: '222599' },
	{ city: 'Dowth (Meath)', zip: '712198' },
	{ city: 'Dowthstown (Meath)', zip: '492589' },
	{ city: 'Draghanstown (Louth)', zip: '654447' },
	{ city: 'Dragoonhill (Wicklow)', zip: '589765' },
	{ city: 'Drakeland Lower (Kilkenny)', zip: '852690' },
	{ city: 'Drakeland Middle (Kilkenny)', zip: '981003' },
	{ city: 'Drakeland Upper (Kilkenny)', zip: '539742' },
	{ city: 'Drakerath (Meath)', zip: '152730' },
	{ city: 'Drakestown (Louth)', zip: '532229' },
	{ city: 'Drakestown (Meath)', zip: '831806' },
	{ city: 'Dranagh (Carlow)', zip: '343406' },
	{ city: 'Dranagh (Wexford)', zip: '377203' },
	{ city: 'Drangan (Sligo)', zip: '141941' },
	{ city: 'Drangan (Tipperary)', zip: '489145' },
	{ city: 'Drangan Beg (Tipperary)', zip: '946541' },
	{ city: 'Drangan More (Tipperary)', zip: '183413' },
	{ city: 'Drean (Donegal)', zip: '311776' },
	{ city: 'Dreelingstown (Kilkenny)', zip: '138192' },
	{ city: 'Dreenaan (Limerick)', zip: '148388' },
	{ city: 'Dreenagh (Kerry)', zip: '585325' },
	{ city: 'Dreenagh East (Cork)', zip: '295184' },
	{ city: 'Dreenagh West (Cork)', zip: '344324' },
	{ city: 'Dreenan (Cavan)', zip: '692830' },
	{ city: 'Dreenan (Donegal)', zip: '491792' },
	{ city: 'Dreenan (Kildare)', zip: '316060' },
	{ city: 'Drehid (Kildare)', zip: '296238' },
	{ city: 'Drehidtarsna (Limerick)', zip: '574157' },
	{ city: 'Dreminstown (Meath)', zip: '692691' },
	{ city: 'Dresnagh (Donegal)', zip: '219632' },
	{ city: 'Dresternagh (Cavan)', zip: '632410' },
	{ city: 'Drewsborough (Clare)', zip: '278740' },
	{ city: 'Drewscourt East (Limerick)', zip: '337780' },
	{ city: 'Drewscourt West (Limerick)', zip: '331207' },
	{ city: 'Drewstown Great (Meath)', zip: '958994' },
	{ city: 'Drewstown Little (Meath)', zip: '229322' },
	{ city: 'Drillistown (Wexford)', zip: '528801' },
	{ city: 'Drim (Clare)', zip: '609859' },
	{ city: 'Drim (Laois)', zip: '224476' },
	{ city: 'Drim (Wicklow)', zip: '538931' },
	{ city: 'Drimagh (Wexford)', zip: '243663' },
	{ city: 'Drimaterril (Laois)', zip: '708124' },
	{ city: 'Drimcong (Galway)', zip: '535326' },
	{ city: 'Drimeen (Kilkenny)', zip: '870447' },
	{ city: 'Drimeen North (Kilkenny)', zip: '830748' },
	{ city: 'Drimeen South (Kilkenny)', zip: '677263' },
	{ city: 'Drimhill (Laois)', zip: '168667' },
	{ city: 'Drimina (Sligo)', zip: '791166' },
	{ city: 'Driminidy North (Cork)', zip: '590515' },
	{ city: 'Driminidy South (Cork)', zip: '912053' },
	{ city: 'Drimmavohaun (Galway)', zip: '449452' },
	{ city: 'Drimmeen (Clare)', zip: '422692' },
	{ city: 'Drimmeen (Galway)', zip: '682750' },
	{ city: 'Drimmeennagun (Clare)', zip: '401137' },
	{ city: 'Drimmo (Laois)', zip: '409066' },
	{ city: 'Drimna (Clare)', zip: '956886' },
	{ city: 'Drimna (Leitrim)', zip: '235594' },
	{ city: 'Drimna Beg (Kerry)', zip: '781282' },
	{ city: 'Drimna East (Galway)', zip: '850571' },
	{ city: 'Drimnagh (Dublin)', zip: '358129' },
	{ city: 'Drimnagh (Roscommon)', zip: '330246' },
	{ city: 'Drimnahoon (Galway)', zip: '460786' },
	{ city: 'Drimna More (Kerry)', zip: '953335' },
	{ city: 'Drimna West (Galway)', zip: '263122' },
	{ city: 'Drimneen (Galway)', zip: '798424' },
	{ city: 'Drimoleague (Cork)', zip: '203402' },
	{ city: 'Drin (Galway)', zip: '430466' },
	{ city: 'Drinagh (Clare)', zip: '525212' },
	{ city: 'Drinagh (Cork)', zip: '151251' },
	{ city: 'Drinagh (Galway)', zip: '247578' },
	{ city: 'Drinagh (Laois)', zip: '327709' },
	{ city: 'Drinagh (Offaly)', zip: '803963' },
	{ city: 'Drinagh (Roscommon)', zip: '764597' },
	{ city: 'Drinagh (Wexford)', zip: '276158' },
	{ city: 'Drinaghan (Mayo)', zip: '415559' },
	{ city: 'Drinaghan (Sligo)', zip: '948080' },
	{ city: 'Drinaghan Beg (Sligo)', zip: '989934' },
	{ city: 'Drinaghan More (Sligo)', zip: '975378' },
	{ city: 'Drinagh East (Cork)', zip: '956086' },
	{ city: 'Drinagh Intake (Wexford)', zip: '921530' },
	{ city: 'Drinagh North (Wexford)', zip: '619859' },
	{ city: 'Drinagh South (Wexford)', zip: '421520' },
	{ city: 'Drinagh West (Cork)', zip: '515676' },
	{ city: 'Drinan (Dublin)', zip: '652521' },
	{ city: 'Drinan (Longford)', zip: '603344' },
	{ city: 'Drinane (Cork)', zip: '695271' },
	{ city: 'Drinaun (Galway)', zip: '617798' },
	{ city: 'Drinaun (Roscommon)', zip: '189760' },
	{ city: 'Drinaun (Sligo)', zip: '677611' },
	{ city: 'Drinaun Bog (Sligo)', zip: '467130' },
	{ city: 'Driney (Roscommon)', zip: '471546' },
	{ city: 'Dring (Cavan)', zip: '872494' },
	{ city: 'Dring (Longford)', zip: '174768' },
	{ city: 'Dringeen Eighter (Mayo)', zip: '341100' },
	{ city: 'Dringeen Middle (Mayo)', zip: '589793' },
	{ city: 'Dringeen Oughter (Mayo)', zip: '156886' },
	{ city: 'Drinmore (Westmeath)', zip: '318770' },
	{ city: 'Drinnanstown North (Kildare)', zip: '836881' },
	{ city: 'Drinnanstown South (Kildare)', zip: '468529' },
	{ city: 'Driny (Leitrim)', zip: '844983' },
	{ city: 'Dripsey (Cork)', zip: '946575' },
	{ city: 'Drish (Tipperary)', zip: '872245' },
	{ city: 'Drishaghaun (Galway)', zip: '709476' },
	{ city: 'Drishaghaun (Mayo)', zip: '573725' },
	{ city: 'Drishaghaun (Roscommon)', zip: '987950' },
	{ city: 'Drishaghaun East (Roscommon)', zip: '728569' },
	{ city: 'Drishaghaun West (Roscommon)', zip: '579353' },
	{ city: 'Drishane (Cork)', zip: '668495' },
	{ city: 'Drishane (Tipperary)', zip: '868152' },
	{ city: 'Drishanebeg (Cork)', zip: '116959' },
	{ city: 'Drishane Beg (Cork)', zip: '618248' },
	{ city: 'Drishanemore (Cork)', zip: '630806' },
	{ city: 'Drishane More (Cork)', zip: '403941' },
	{ city: 'Drisheen (Cork)', zip: '204986' },
	{ city: 'Drishoge (Dublin)', zip: '580195' },
	{ city: 'Drishoge (Leitrim)', zip: '636889' },
	{ city: 'Drishoge (Offaly)', zip: '538301' },
	{ city: 'Drishoge (Roscommon)', zip: '594189' },
	{ city: 'Drishoge (Tipperary)', zip: '747213' },
	{ city: 'Drisoge (Carlow)', zip: '781065' },
	{ city: 'Drissoge (Meath)', zip: '920619' },
	{ city: 'Dristernan (Donegal)', zip: '334724' },
	{ city: 'Dristernan (Leitrim)', zip: '745775' },
	{ city: 'Dristernaun (Leitrim)', zip: '903198' },
	{ city: 'Drogheda (Louth)', zip: '326086' },
	{ city: 'Droghill (Cavan)', zip: '556518' },
	{ city: 'Drokaghbane (Cavan)', zip: '725052' },
	{ city: 'Drollagh (Monaghan)', zip: '415558' },
	{ city: 'Drom (Cork)', zip: '885451' },
	{ city: 'Drom (Kerry)', zip: '714825' },
	{ city: 'Drom (Tipperary)', zip: '795695' },
	{ city: 'Dromacappul (Cork)', zip: '445283' },
	{ city: 'Dromaclarig (Cork)', zip: '949444' },
	{ city: 'Dromaclaurig (Kerry)', zip: '615618' },
	{ city: 'Dromacommer (Limerick)', zip: '294170' },
	{ city: 'Dromacoosane (Cork)', zip: '131274' },
	{ city: 'Dromacoosh (Kerry)', zip: '237569' },
	{ city: 'Dromacullen (Cork)', zip: '153853' },
	{ city: 'Dromacummer East (Limerick)', zip: '315940' },
	{ city: 'Dromacummer West (Limerick)', zip: '431807' },
	{ city: 'Dromada (Limerick)', zip: '271389' },
	{ city: 'Dromada (Mayo)', zip: '227229' },
	{ city: 'Dromadda Beg (Cork)', zip: '164803' },
	{ city: 'Dromadda Beg (Kerry)', zip: '417012' },
	{ city: 'Dromadda East (Cork)', zip: '666621' },
	{ city: 'Dromadda More (Cork)', zip: '200880' },
	{ city: 'Dromadda More (Kerry)', zip: '224361' },
	{ city: 'Dromadeesirt (Kerry)', zip: '958452' },
	{ city: 'Dromadoon (Cork)', zip: '371965' },
	{ city: 'Dromagarraun (Limerick)', zip: '537672' },
	{ city: 'Dromagarry (Cork)', zip: '654583' },
	{ city: 'Dromagh (Cork)', zip: '763054' },
	{ city: 'Dromagorteen (Kerry)', zip: '193359' },
	{ city: 'Dromagowlane (Cork)', zip: '354173' },
	{ city: 'Dromahair (Leitrim)', zip: '659821' },
	{ city: 'Dromahoe (Cork)', zip: '989002' },
	{ city: 'Dromalivaun (Kerry)', zip: '934819' },
	{ city: 'Dromalonhurt (Kerry)', zip: '715990' },
	{ city: 'Dromaloughane (Kerry)', zip: '861798' },
	{ city: 'Dromalour (Cork)', zip: '338175' },
	{ city: 'Dromalta (Limerick)', zip: '355674' },
	{ city: 'Dromalught (Kerry)', zip: '176979' },
	{ city: 'Dromana (Waterford)', zip: '321934' },
	{ city: 'Dromanallig (Cork)', zip: '649030' },
	{ city: 'Dromanarrigle (Cork)', zip: '551418' },
	{ city: 'Dromanassa (Cork)', zip: '308567' },
	{ city: 'Dromanassig (Kerry)', zip: '818732' },
	{ city: 'Dromaneen (Cork)', zip: '792023' },
	{ city: 'Dromanig (Cork)', zip: '403023' },
	{ city: 'Dromaragh (Kerry)', zip: '702734' },
	{ city: 'Dromard (Sligo)', zip: '242251' },
	{ city: 'Dromard Beg (Tipperary)', zip: '325643' },
	{ city: 'Dromard Demesne (Limerick)', zip: '930967' },
	{ city: 'Dromard More (Tipperary)', zip: '439248' },
	{ city: 'Dromasmole (Cork)', zip: '829064' },
	{ city: 'Dromasta (Cork)', zip: '806367' },
	{ city: 'Dromataniheen (Cork)', zip: '825560' },
	{ city: 'Dromateebara (Cork)', zip: '904412' },
	{ city: 'Dromatimore (Cork)', zip: '240873' },
	{ city: 'Dromatoor (Kerry)', zip: '880467' },
	{ city: 'Dromatouk (Kerry)', zip: '392321' },
	{ city: 'Dromavally (Kerry)', zip: '306396' },
	{ city: 'Dromavane (Cork)', zip: '611336' },
	{ city: 'Dromavrauka (Kerry)', zip: '884119' },
	{ city: 'Drombane (Kerry)', zip: '942927' },
	{ city: 'Drombane (Limerick)', zip: '217149' },
	{ city: 'Drombanny (Limerick)', zip: '146557' },
	{ city: 'Drombeg (Cork)', zip: '517270' },
	{ city: 'Drombeg (Kerry)', zip: '295499' },
	{ city: 'Drombeg (Limerick)', zip: '944874' },
	{ city: 'Drombofinny (Cork)', zip: '682875' },
	{ city: 'Drombohilly Lower (Kerry)', zip: '448637' },
	{ city: 'Drombohilly Upper (Kerry)', zip: '978390' },
	{ city: 'Dromboy North (Cork)', zip: '836004' },
	{ city: 'Dromboy South (Cork)', zip: '210310' },
	{ city: 'Drombrane (Kerry)', zip: '106725' },
	{ city: 'Drombrick (Kerry)', zip: '362127' },
	{ city: 'Drombrow (Cork)', zip: '781358' },
	{ city: 'Dromcahan East (Kerry)', zip: '107097' },
	{ city: 'Dromcahan West (Kerry)', zip: '923826' },
	{ city: 'Dromcarban (Kerry)', zip: '956792' },
	{ city: 'Dromcarra North (Cork)', zip: '174102' },
	{ city: 'Dromcarra South (Cork)', zip: '531775' },
	{ city: 'Dromclogh (Cork)', zip: '387708' },
	{ city: 'Dromclogh (Kerry)', zip: '979836' },
	{ city: 'Dromclogh East (Cork)', zip: '143903' },
	{ city: 'Dromclogh West (Cork)', zip: '874913' },
	{ city: 'Dromcluher (Limerick)', zip: '380297' },
	{ city: 'Dromcolliher (Limerick)', zip: '126653' },
	{ city: 'Dromcondra (Dublin)', zip: '338874' },
	{ city: 'Dromcorragh (Cork)', zip: '743362' },
	{ city: 'Dromcummer Beg (Cork)', zip: '832949' },
	{ city: 'Dromcummer More (Cork)', zip: '590897' },
	{ city: 'Dromcunnia (Kerry)', zip: '890204' },
	{ city: 'Dromcunnig (Kerry)', zip: '789391' },
	{ city: 'Dromdaleague (Cork)', zip: '519663' },
	{ city: 'Dromdaniel (Cork)', zip: '235680' },
	{ city: 'Dromdarragh (Kerry)', zip: '220981' },
	{ city: 'Dromdarrig (Limerick)', zip: '215923' },
	{ city: 'Dromdeegy (Cork)', zip: '653954' },
	{ city: 'Dromdeer (Cork)', zip: '682802' },
	{ city: 'Dromdeer East (Cork)', zip: '121268' },
	{ city: 'Dromdeer West (Cork)', zip: '557952' },
	{ city: 'Dromdeeveen (Limerick)', zip: '742878' },
	{ city: 'Dromderaown (Cork)', zip: '138784' },
	{ city: 'Dromderrig (Cork)', zip: '390001' },
	{ city: 'Dromdihy (Cork)', zip: '356505' },
	{ city: 'Dromdiralough (Kerry)', zip: '628250' },
	{ city: 'Dromdiraowen (Kerry)', zip: '716623' },
	{ city: 'Dromdoneen (Cork)', zip: '183798' },
	{ city: 'Dromdoneen East (Cork)', zip: '213045' },
	{ city: 'Dromdoneen West (Cork)', zip: '418811' },
	{ city: 'Dromdoohig Beg (Kerry)', zip: '778163' },
	{ city: 'Dromdoohig More (Kerry)', zip: '637464' },
	{ city: 'Dromdoory (Kerry)', zip: '254231' },
	{ city: 'Dromdough (Cork)', zip: '738076' },
	{ city: 'Dromdour (Cork)', zip: '704470' },
	{ city: 'Dromdowney (Cork)', zip: '949393' },
	{ city: 'Dromdowney Lower (Cork)', zip: '217630' },
	{ city: 'Dromdowney Upper (Cork)', zip: '277846' },
	{ city: 'Dromdrasdil (Cork)', zip: '100083' },
	{ city: 'Dromduff (Cork)', zip: '494012' },
	{ city: 'Dromduff East (Cork)', zip: '253766' },
	{ city: 'Dromduff West (Cork)', zip: '952061' },
	{ city: 'Dromduvane (Cork)', zip: '366095' },
	{ city: 'Drom East (Kerry)', zip: '166819' },
	{ city: 'Dromeen (Clare)', zip: '431078' },
	{ city: 'Dromeenboy (Limerick)', zip: '887179' },
	{ city: 'Dromeliagh (Limerick)', zip: '121891' },
	{ city: 'Dromerk (Cork)', zip: '172529' },
	{ city: 'Dromerkeen (Kerry)', zip: '800766' },
	{ city: 'Dromfeagh (Cork)', zip: '536923' },
	{ city: 'Dromgare (Cork)', zip: '917921' },
	{ city: 'Dromgarriff (Cork)', zip: '867049' },
	{ city: 'Dromgarriff East (Cork)', zip: '405810' },
	{ city: 'Dromgarriff North (Cork)', zip: '801744' },
	{ city: 'Dromgarriff South (Cork)', zip: '182903' },
	{ city: 'Dromgarriff West (Cork)', zip: '456455' },
	{ city: 'Dromgarvan (Cork)', zip: '961725' },
	{ city: 'Dromgoolestown (Louth)', zip: '119194' },
	{ city: 'Dromgower (Kerry)', zip: '734645' },
	{ city: 'Dromgownagh (Cork)', zip: '742256' },
	{ city: 'Dromhale (Kerry)', zip: '618500' },
	{ city: 'Dromhumper (Kerry)', zip: '878001' },
	{ city: 'Dromickbane (Kerry)', zip: '956503' },
	{ city: 'Dromidiclogh (Cork)', zip: '446153' },
	{ city: 'Dromidiclogh West (Cork)', zip: '504581' },
	{ city: 'Dromillihy (Cork)', zip: '652470' },
	{ city: 'Dromin (Cork)', zip: '778908' },
	{ city: 'Dromin (Kerry)', zip: '364973' },
	{ city: 'Dromin (Limerick)', zip: '332911' },
	{ city: 'Dromin (Louth)', zip: '180669' },
	{ city: 'Dromin (Tipperary)', zip: '454645' },
	{ city: 'Dromina (Cork)', zip: '333743' },
	{ city: 'Dromina (Waterford)', zip: '973837' },
	{ city: 'Drominaclara (Limerick)', zip: '292845' },
	{ city: 'Drominacreen (Limerick)', zip: '730296' },
	{ city: 'Drominagh (Tipperary)', zip: '333000' },
	{ city: 'Drominagh Demesne (Tipperary)', zip: '984450' },
	{ city: 'Drominagh North (Cork)', zip: '198349' },
	{ city: 'Drominagh South (Cork)', zip: '371782' },
	{ city: 'Drominagh Wood (Tipperary)', zip: '713268' },
	{ city: 'Drominagore (Cork)', zip: '343621' },
	{ city: 'Drominaharee (Kerry)', zip: '733879' },
	{ city: 'Drominahilla (Cork)', zip: '240704' },
	{ city: 'Drominane (Cork)', zip: '871007' },
	{ city: 'Drominboy (Limerick)', zip: '642435' },
	{ city: 'Drominboy Lower (Limerick)', zip: '777577' },
	{ city: 'Drominboy Upper (Limerick)', zip: '262238' },
	{ city: 'Dromin East (Kerry)', zip: '916799' },
	{ city: 'Dromineer (Tipperary)', zip: '263877' },
	{ city: 'Dromin Lower (Kerry)', zip: '317922' },
	{ city: 'Dromin North (Limerick)', zip: '484859' },
	{ city: 'Drominoona (Limerick)', zip: '838309' },
	{ city: 'Dromin South (Limerick)', zip: '739244' },
	{ city: 'Dromintobin North (Clare)', zip: '991160' },
	{ city: 'Dromintobin South (Clare)', zip: '520962' },
	{ city: 'Dromin Upper (Kerry)', zip: '353968' },
	{ city: 'Dromin West (Kerry)', zip: '390797' },
	{ city: 'Drominycarra (Limerick)', zip: '845637' },
	{ city: 'Drominycullane (Limerick)', zip: '601527' },
	{ city: 'Dromiskin (Louth)', zip: '966076' },
	{ city: 'Dromkeal (Cork)', zip: '910169' },
	{ city: 'Dromkeare (Kerry)', zip: '975952' },
	{ city: 'Dromkeen (Cork)', zip: '274400' },
	{ city: 'Dromkeen (Limerick)', zip: '865827' },
	{ city: 'Dromkeen East (Kerry)', zip: '383242' },
	{ city: 'Dromkeen North (Limerick)', zip: '977720' },
	{ city: 'Dromkeen South (Limerick)', zip: '566251' },
	{ city: 'Dromkeen West (Kerry)', zip: '209214' },
	{ city: 'Dromkerry (Kerry)', zip: '723086' },
	{ city: 'Dromlara (Limerick)', zip: '899872' },
	{ city: 'Dromleagh (Kerry)', zip: '881386' },
	{ city: 'Dromleena (Cork)', zip: '344779' },
	{ city: 'Dromlegagh (Kerry)', zip: '699530' },
	{ city: 'Dromlegagh Demesne (Kerry)', zip: '199132' },
	{ city: 'Dromleigh (Cork)', zip: '433281' },
	{ city: 'Dromleigh North (Cork)', zip: '274472' },
	{ city: 'Dromleigh South (Cork)', zip: '565391' },
	{ city: 'Dromlickacrue (Cork)', zip: '806721' },
	{ city: 'Dromline (Tipperary)', zip: '563655' },
	{ city: 'Dromlohan (Limerick)', zip: '998823' },
	{ city: 'Dromlough (Cork)', zip: '882951' },
	{ city: 'Dromloughan North (Limerick)', zip: '308872' },
	{ city: 'Dromloughan South (Limerick)', zip: '105729' },
	{ city: 'Dromloughlin (Cork)', zip: '670600' },
	{ city: 'Dromloughra (Kerry)', zip: '598482' },
	{ city: 'Dromlusk (Kerry)', zip: '835581' },
	{ city: 'Dromluska (Kerry)', zip: '241785' },
	{ city: 'Drommahane (Cork)', zip: '808200' },
	{ city: 'Drommakee (Kerry)', zip: '364202' },
	{ city: 'Drommartin (Kerry)', zip: '110640' },
	{ city: 'Drommoher (Limerick)', zip: '345112' },
	{ city: 'Drommurher (Kerry)', zip: '515237' },
	{ city: 'Drommurrin (Kerry)', zip: '400754' },
	{ city: 'Dromnacaheragh (Cork)', zip: '650528' },
	{ city: 'Dromnacarra (Kerry)', zip: '887407' },
	{ city: 'Dromnafinshin (Cork)', zip: '142336' },
	{ city: 'Dromnagapple (Cork)', zip: '113001' },
	{ city: 'Dromnakilly (Kerry)', zip: '821641' },
	{ city: 'Dromnea (Cork)', zip: '273168' },
	{ city: 'Dromneavane (Kerry)', zip: '796853' },
	{ city: 'Drom North (Cork)', zip: '472289' },
	{ city: 'Dromnycolman (Kerry)', zip: '963253' },
	{ city: 'Dromod (Kerry)', zip: '793837' },
	{ city: 'Dromoland (Clare)', zip: '401233' },
	{ city: 'Dromomarka (Tipperary)', zip: '109653' },
	{ city: 'Dromonig (Cork)', zip: '552457' },
	{ city: 'Dromore (Cavan)', zip: '843901' },
	{ city: 'Dromore (Clare)', zip: '879105' },
	{ city: 'Dromore (Cork)', zip: '759318' },
	{ city: 'Dromore (Donegal)', zip: '801787' },
	{ city: 'Dromore (Kerry)', zip: '575362' },
	{ city: 'Dromore (Leitrim)', zip: '167733' },
	{ city: 'Dromore (Limerick)', zip: '615882' },
	{ city: 'Dromore (Mayo)', zip: '253068' },
	{ city: 'Dromore (Monaghan)', zip: '623497' },
	{ city: 'Dromore (Roscommon)', zip: '428629' },
	{ city: 'Dromore (Sligo)', zip: '264670' },
	{ city: 'Dromore (Waterford)', zip: '706193' },
	{ city: 'Dromore (Westmeath)', zip: '218429' },
	{ city: 'Dromore Big (Donegal)', zip: '238180' },
	{ city: 'Dromore East (Monaghan)', zip: '313045' },
	{ city: 'Dromorehill (Galway)', zip: '767050' },
	{ city: 'Dromore Little (Donegal)', zip: '502063' },
	{ city: 'Dromore North (Cork)', zip: '440246' },
	{ city: 'Dromore Old (Kerry)', zip: '871572' },
	{ city: 'Dromore South (Cork)', zip: '448186' },
	{ city: 'Dromore West (Monaghan)', zip: '556558' },
	{ city: 'Dromore West (Sligo)', zip: '406902' },
	{ city: 'Dromourneen (Cork)', zip: '371063' },
	{ city: 'Dromoyle (Offaly)', zip: '213757' },
	{ city: 'Drompeesh (Cork)', zip: '373074' },
	{ city: 'Dromrahan (Cork)', zip: '715101' },
	{ city: 'Dromrahnee (Limerick)', zip: '305692' },
	{ city: 'Dromrastill (Cork)', zip: '104626' },
	{ city: 'Dromreag (Kerry)', zip: '132715' },
	{ city: 'Dromreagh (Cork)', zip: '175868' },
	{ city: 'Dromreague (Cork)', zip: '961142' },
	{ city: 'Dromreask (Limerick)', zip: '485979' },
	{ city: 'Dromree (Cork)', zip: '746878' },
	{ city: 'Dromroe (Kerry)', zip: '329367' },
	{ city: 'Dromroe (Limerick)', zip: '291270' },
	{ city: 'Dromroe Commons (Cork)', zip: '366312' },
	{ city: 'Dromruagh (Cork)', zip: '113075' },
	{ city: 'Dromsallagh (Limerick)', zip: '349589' },
	{ city: 'Dromsarane (Cork)', zip: '149485' },
	{ city: 'Dromsicane (Cork)', zip: '712660' },
	{ city: 'Dromsiveen (Cork)', zip: '272143' },
	{ city: 'Dromskarragh Beg (Cork)', zip: '244844' },
	{ city: 'Dromskarragh More (Cork)', zip: '805983' },
	{ city: 'Dromskehy (Cork)', zip: '334783' },
	{ city: 'Dromsligo (Cork)', zip: '920123' },
	{ city: 'Drom South (Cork)', zip: '424379' },
	{ city: 'Dromstabla (Kerry)', zip: '311142' },
	{ city: 'Dromsullivan North (Cork)', zip: '504939' },
	{ city: 'Dromsullivan South (Cork)', zip: '385037' },
	{ city: 'Dromtarriff (Cork)', zip: '415150' },
	{ city: 'Dromtea (Kerry)', zip: '487452' },
	{ city: 'Dromteewakeen (Kerry)', zip: '502335' },
	{ city: 'Dromthacker (Kerry)', zip: '545268' },
	{ city: 'Dromtine (Kerry)', zip: '310115' },
	{ city: 'Dromtrasna (Limerick)', zip: '124487' },
	{ city: 'Dromtrasna North (Limerick)', zip: '722309' },
	{ city: 'Dromtrasna South (Limerick)', zip: '932200' },
	{ city: 'Dromturk (Limerick)', zip: '983675' },
	{ city: 'Dromultan (Kerry)', zip: '781593' },
	{ city: 'Drom West (Cork)', zip: '146629' },
	{ city: 'Drom West (Kerry)', zip: '547108' },
	{ city: 'Dromyrourk (Kerry)', zip: '698596' },
	{ city: 'Drough (Cork)', zip: '428040' },
	{ city: 'Droughill (Laois)', zip: '676075' },
	{ city: 'Drought (Galway)', zip: '155649' },
	{ city: 'Droughtville (Offaly)', zip: '885837' },
	{ city: 'Drum (Donegal)', zip: '910883' },
	{ city: 'Drum (Galway)', zip: '119819' },
	{ city: 'Drum (Mayo)', zip: '526333' },
	{ city: 'Drum (Monaghan)', zip: '979037' },
	{ city: 'Drum (Roscommon)', zip: '416035' },
	{ city: 'Drum (Tipperary)', zip: '527851' },
	{ city: 'Drumabodan (Donegal)', zip: '991964' },
	{ city: 'Drumacappul Island (Mayo)', zip: '486720' },
	{ city: 'Drumacarrow (Cavan)', zip: '169847' },
	{ city: 'Drumacaslan (Monaghan)', zip: '447525' },
	{ city: 'Drumachon (Cavan)', zip: '585571' },
	{ city: 'Drumaclan (Monaghan)', zip: '198587' },
	{ city: 'Drumaclarig (Cork)', zip: '608963' },
	{ city: 'Drumacleeskin (Cavan)', zip: '795288' },
	{ city: 'Drumacloghan (Donegal)', zip: '705687' },
	{ city: 'Drumacolla (Leitrim)', zip: '259599' },
	{ city: 'Drumacon (Cavan)', zip: '828157' },
	{ city: 'Drumacon (Monaghan)', zip: '343106' },
	{ city: 'Drumaconvern (Monaghan)', zip: '152755' },
	{ city: 'Drumacoo (Galway)', zip: '113260' },
	{ city: 'Drumacoo (Roscommon)', zip: '243769' },
	{ city: 'Drumacoon (Monaghan)', zip: '651278' },
	{ city: 'Drumacreeve (Monaghan)', zip: '312503' },
	{ city: 'Drumacrib (Monaghan)', zip: '928992' },
	{ city: 'Drumacrin (Donegal)', zip: '391302' },
	{ city: 'Drumacruttan (Monaghan)', zip: '706201' },
	{ city: 'Drumacullion (Cavan)', zip: '790073' },
	{ city: 'Drumad (Cavan)', zip: '232785' },
	{ city: 'Drumad (Leitrim)', zip: '662405' },
	{ city: 'Drumad (Louth)', zip: '379790' },
	{ city: 'Drumadart (Donegal)', zip: '945207' },
	{ city: 'Drumaddagorry (Monaghan)', zip: '411128' },
	{ city: 'Drumaddarainy (Monaghan)', zip: '447796' },
	{ city: 'Drumaderry (Mayo)', zip: '443882' },
	{ city: 'Drumadoney (Donegal)', zip: '891615' },
	{ city: 'Drumadooey (Donegal)', zip: '143302' },
	{ city: 'Drumadoon (Mayo)', zip: '598399' },
	{ city: 'Drumadorn (Leitrim)', zip: '982104' },
	{ city: 'Drumadrehid (Clare)', zip: '776306' },
	{ city: 'Drumady (Mayo)', zip: '954084' },
	{ city: 'Drumadykey (Leitrim)', zip: '279769' },
	{ city: 'Drumagelvin (Monaghan)', zip: '747969' },
	{ city: 'Drumagh (Laois)', zip: '811096' },
	{ city: 'Drumagh (Mayo)', zip: '640088' },
	{ city: 'Drumaghakeel (Monaghan)', zip: '248483' },
	{ city: 'Drumaghy (Donegal)', zip: '671307' },
	{ city: 'Drumagissaun (Roscommon)', zip: '121239' },
	{ city: 'Drumagolan (Cavan)', zip: '305768' },
	{ city: 'Drumagraa (Donegal)', zip: '846428' },
	{ city: 'Drumahaire (Leitrim)', zip: '611569' },
	{ city: 'Drumahira (Leitrim)', zip: '708712' },
	{ city: 'Drumahurk (Cavan)', zip: '817537' },
	{ city: 'Drumakeenan (Cavan)', zip: '387122' },
	{ city: 'Drumakeenan (Offaly)', zip: '381015' },
	{ city: 'Drumakill (Monaghan)', zip: '131586' },
	{ city: 'Drumakinneo (Cavan)', zip: '154907' },
	{ city: 'Drumalagagh (Roscommon)', zip: '110641' },
	{ city: 'Drumaleague (Leitrim)', zip: '167956' },
	{ city: 'Drumalee (Cavan)', zip: '444953' },
	{ city: 'Drumaleheen (Mayo)', zip: '554450' },
	{ city: 'Drumaliss (Monaghan)', zip: '656219' },
	{ city: 'Drumalooaun (Mayo)', zip: '705090' },
	{ city: 'Drumalough (Donegal)', zip: '607148' },
	{ city: 'Drumalough (Roscommon)', zip: '597107' },
	{ city: 'Drumalt (Cavan)', zip: '726190' },
	{ city: 'Drumalt (Monaghan)', zip: '152844' },
	{ city: 'Drumalure Beg (Cavan)', zip: '335102' },
	{ city: 'Drumalure More (Cavan)', zip: '858382' },
	{ city: 'Drumamoodan (Roscommon)', zip: '553237' },
	{ city: 'Drumamry (Cavan)', zip: '971377' },
	{ city: 'Drumamuck Glebe (Cavan)', zip: '369935' },
	{ city: 'Drumanaffrin (Mayo)', zip: '738842' },
	{ city: 'Drumanagh (Dublin)', zip: '494920' },
	{ city: 'Drumanalaragh (Cavan)', zip: '418608' },
	{ city: 'Drumanan (Monaghan)', zip: '416115' },
	{ city: 'Drumanaraher (Sligo)', zip: '240870' },
	{ city: 'Drumanaught (Donegal)', zip: '802028' },
	{ city: 'Drumandoora (Clare)', zip: '260303' },
	{ city: 'Drumane (Cavan)', zip: '975650' },
	{ city: 'Drumaneany (Donegal)', zip: '220585' },
	{ city: 'Drumaneary (Donegal)', zip: '963420' },
	{ city: 'Drumaneber (Meath)', zip: '522355' },
	{ city: 'Drumaneel (Donegal)', zip: '710639' },
	{ city: 'Drumaneel (Sligo)', zip: '526397' },
	{ city: 'Drumanespick (Cavan)', zip: '970703' },
	{ city: 'Drumanilra (Roscommon)', zip: '816593' },
	{ city: 'Drumanny (Monaghan)', zip: '648855' },
	{ city: 'Drumanone (Roscommon)', zip: '736396' },
	{ city: 'Drumanoo (Donegal)', zip: '934537' },
	{ city: 'Drumanure (Clare)', zip: '278103' },
	{ city: 'Drumanure (Leitrim)', zip: '624328' },
	{ city: 'Drumanure (Longford)', zip: '553466' },
	{ city: 'Drumany (Donegal)', zip: '691145' },
	{ city: 'Drumany (Leitrim)', zip: '711807' },
	{ city: 'Drumany Glebe (Leitrim)', zip: '949159' },
	{ city: 'Drumar (Monaghan)', zip: '575861' },
	{ city: 'Drumaragh (Leitrim)', zip: '952837' },
	{ city: 'Drumaraw (Cavan)', zip: '708945' },
	{ city: 'Drumard (Cavan)', zip: '345318' },
	{ city: 'Drumard (Donegal)', zip: '981691' },
	{ city: 'Drumard (Leitrim)', zip: '407658' },
	{ city: 'Drumard (Longford)', zip: '624306' },
	{ city: 'Drumard (Louth)', zip: '435275' },
	{ city: 'Drumard (Mayo)', zip: '749817' },
	{ city: 'Drumard (Meath)', zip: '553478' },
	{ city: 'Drumard (Monaghan)', zip: '296839' },
	{ city: 'Drumard (Sligo)', zip: '994678' },
	{ city: 'Drumardagh (Donegal)', zip: '478378' },
	{ city: 'Drumarigna (Leitrim)', zip: '596710' },
	{ city: 'Drumark (Donegal)', zip: '231326' },
	{ city: 'Drumarrell (Monaghan)', zip: '234808' },
	{ city: 'Drumartigan (Monaghan)', zip: '944180' },
	{ city: 'Drumary (Monaghan)', zip: '798277' },
	{ city: 'Drumashellig (Laois)', zip: '309284' },
	{ city: 'Drumask (Mayo)', zip: '859966' },
	{ city: 'Drumaskibbole (Sligo)', zip: '189068' },
	{ city: 'Drumaskin (Galway)', zip: '431205' },
	{ city: 'Drumasladdy (Cavan)', zip: '232816' },
	{ city: 'Drumass (Monaghan)', zip: '911052' },
	{ city: 'Drumate (Monaghan)', zip: '804674' },
	{ city: 'Drumatehy (Clare)', zip: '522232' },
	{ city: 'Drumatemple (Roscommon)', zip: '134951' },
	{ city: 'Drumatober (Galway)', zip: '477655' },
	{ city: 'Drumatoland (Donegal)', zip: '821652' },
	{ city: 'Drumatrumman (Donegal)', zip: '579915' },
	{ city: 'Drumatumpher (Donegal)', zip: '722420' },
	{ city: 'Drumatybonniff (Roscommon)', zip: '399612' },
	{ city: 'Drumauna (Cavan)', zip: '673507' },
	{ city: 'Drumavaddy (Cavan)', zip: '428195' },
	{ city: 'Drumavaddy (Monaghan)', zip: '434472' },
	{ city: 'Drumavan (Monaghan)', zip: '655816' },
	{ city: 'Drumavanagh (Cavan)', zip: '225347' },
	{ city: 'Drumaveale (Monaghan)', zip: '124836' },
	{ city: 'Drumaveil North (Cavan)', zip: '137376' },
	{ city: 'Drumaveil South (Cavan)', zip: '181092' },
	{ city: 'Drumaville (Donegal)', zip: '883631' },
	{ city: 'Drumavish (Donegal)', zip: '486864' },
	{ city: 'Drumavohy (Donegal)', zip: '421663' },
	{ city: 'Drumavohy And Ballybolagan (Donegal)', zip: '423389' },
	{ city: 'Drumavrack (Cavan)', zip: '581771' },
	{ city: 'Drumawark (Donegal)', zip: '477251' },
	{ city: 'Drumaweel Glebe (Leitrim)', zip: '166576' },
	{ city: 'Drumaweer (Donegal)', zip: '288327' },
	{ city: 'Drumbad (Leitrim)', zip: '373803' },
	{ city: 'Drumbad (Longford)', zip: '489256' },
	{ city: 'Drumbagh (Cavan)', zip: '614049' },
	{ city: 'Drumballycaslan (Donegal)', zip: '346500' },
	{ city: 'Drumbanagher (Monaghan)', zip: '599904' },
	{ city: 'Drumbane (Donegal)', zip: '811492' },
	{ city: 'Drumbane (Galway)', zip: '697771' },
	{ city: 'Drumbane (Offaly)', zip: '831104' },
	{ city: 'Drumbane (Tipperary)', zip: '667274' },
	{ city: 'Drumbannan (Cavan)', zip: '381254' },
	{ city: 'Drumbannow (Cavan)', zip: '635835' },
	{ city: 'Drumbar (Cavan)', zip: '838186' },
	{ city: 'Drumbar (Donegal)', zip: '253807' },
	{ city: 'Drumbaragh (Meath)', zip: '941563' },
	{ city: 'Drumbaragh (Monaghan)', zip: '104321' },
	{ city: 'Drumbaran (Donegal)', zip: '947461' },
	{ city: 'Drumbarity (Donegal)', zip: '816569' },
	{ city: 'Drumbarkey (Cavan)', zip: '333562' },
	{ city: 'Drumbarlom (Cavan)', zip: '276245' },
	{ city: 'Drumbarnet (Donegal)', zip: '996441' },
	{ city: 'Drumbarnet (Monaghan)', zip: '643688' },
	{ city: 'Drumbarnet Lower (Donegal)', zip: '618181' },
	{ city: 'Drumbarnet Middle (Donegal)', zip: '993020' },
	{ city: 'Drumbarnet Upper (Donegal)', zip: '774657' },
	{ city: 'Drumbarren (Donegal)', zip: '897825' },
	{ city: 'Drumbarry (Cavan)', zip: '154027' },
	{ city: 'Drumbartagh (Cavan)', zip: '563282' },
	{ city: 'Drumbaun (Clare)', zip: '647805' },
	{ city: 'Drumbaun (Galway)', zip: '911952' },
	{ city: 'Drumbaun (Longford)', zip: '706064' },
	{ city: 'Drumbaun (Mayo)', zip: '999178' },
	{ city: 'Drumbaun (Sligo)', zip: '503069' },
	{ city: 'Drumbaun (Tipperary)', zip: '171157' },
	{ city: 'Drumbawn (Wicklow)', zip: '601892' },
	{ city: 'Drumbeagh (Cavan)', zip: '652221' },
	{ city: 'Drumbeagh (Donegal)', zip: '859271' },
	{ city: 'Drumbear (Monaghan)', zip: '897345' },
	{ city: 'Drumbee (Cavan)', zip: '345991' },
	{ city: 'Drumbeg (Donegal)', zip: '935976' },
	{ city: 'Drumbeg North (Sligo)', zip: '257198' },
	{ city: 'Drumbeg South (Sligo)', zip: '795202' },
	{ city: 'Drumbeg West (Sligo)', zip: '961790' },
	{ city: 'Drumbeighra (Leitrim)', zip: '239567' },
	{ city: 'Drumbenagh (Monaghan)', zip: '491193' },
	{ city: 'Drumbeo (Monaghan)', zip: '797712' },
	{ city: 'Drumberagh (Monaghan)', zip: '160848' },
	{ city: 'Drumbern (Donegal)', zip: '727246' },
	{ city: 'Drumberry (Cavan)', zip: '838885' },
	{ city: 'Drumbess (Cavan)', zip: '209293' },
	{ city: 'Drumbibe (Leitrim)', zip: '925008' },
	{ city: 'Drumbier (Monaghan)', zip: '486177' },
	{ city: 'Drumbiggil (Clare)', zip: '855167' },
	{ city: 'Drumbilla (Louth)', zip: '962388' },
	{ city: 'Drumbin (Monaghan)', zip: '478293' },
	{ city: 'Drumbinnis (Cavan)', zip: '340553' },
	{ city: 'Drumbinnis (Leitrim)', zip: '266484' },
	{ city: 'Drumbirn (Monaghan)', zip: '252549' },
	{ city: 'Drumbo (Cavan)', zip: '354264' },
	{ city: 'Drumbo (Monaghan)', zip: '836801' },
	{ city: 'Drumboarty (Donegal)', zip: '241479' },
	{ city: 'Drumboat (Monaghan)', zip: '521336' },
	{ city: 'Drumboe Lower (Donegal)', zip: '138763' },
	{ city: 'Drumboe Upper (Donegal)', zip: '194478' },
	{ city: 'Drumboghill (Donegal)', zip: '575488' },
	{ city: 'Drumboher (Leitrim)', zip: '476341' },
	{ city: 'Drumbologe (Donegal)', zip: '400050' },
	{ city: 'Drumbonniv (Clare)', zip: '250905' },
	{ city: 'Drumboory (Cavan)', zip: '512426' },
	{ city: 'Drumboory (Monaghan)', zip: '753413' },
	{ city: 'Drumborisk (Monaghan)', zip: '862811' },
	{ city: 'Drumboy (Donegal)', zip: '843766' },
	{ city: 'Drumboy (Leitrim)', zip: '656636' },
	{ city: 'Drumboylan (Roscommon)', zip: '645898' },
	{ city: 'Drumbrackan (Monaghan)', zip: '917208' },
	{ city: 'Drumbrade (Cavan)', zip: '275207' },
	{ city: 'Drumbrahade (Leitrim)', zip: '163292' },
	{ city: 'Drumbranned (Leitrim)', zip: '743825' },
	{ city: 'Drumbrastle East (Mayo)', zip: '702419' },
	{ city: 'Drumbrastle West (Mayo)', zip: '965401' },
	{ city: 'Drumbrawn (Cavan)', zip: '761716' },
	{ city: 'Drumbrean (Monaghan)', zip: '183903' },
	{ city: 'Drumbreanlis (Leitrim)', zip: '242654' },
	{ city: 'Drumbrick (Donegal)', zip: '385805' },
	{ city: 'Drumbrick (Leitrim)', zip: '318392' },
	{ city: 'Drumbrick (Roscommon)', zip: '425971' },
	{ city: 'Drumbrickaun (Clare)', zip: '679166' },
	{ city: 'Drumbride (Meath)', zip: '297529' },
	{ city: 'Drumbriskan (Cavan)', zip: '785866' },
	{ city: 'Drumbrisny (Roscommon)', zip: '751080' },
	{ city: 'Drumbristan (Monaghan)', zip: '779721' },
	{ city: 'Drumbristan Glebe (Donegal)', zip: '970316' },
	{ city: 'Drumbroagh (Monaghan)', zip: '139440' },
	{ city: 'Drumbrollisk (Cavan)', zip: '854016' },
	{ city: 'Drumbrone (Monaghan)', zip: '538493' },
	{ city: 'Drumbrucklis (Cavan)', zip: '182442' },
	{ city: 'Drumbrughas (Cavan)', zip: '837847' },
	{ city: 'Drumbulcaun (Galway)', zip: '641982' },
	{ city: 'Drumbullion (Cavan)', zip: '383846' },
	{ city: 'Drumbullog (Leitrim)', zip: '907406' },
	{ city: 'Drumbulrisk (Meath)', zip: '447932' },
	{ city: 'Drumbure (Monaghan)', zip: '525207' },
	{ city: 'Drumcah (Louth)', zip: '829128' },
	{ city: 'Drumcah (Monaghan)', zip: '837426' },
	{ city: 'Drumcall (Monaghan)', zip: '607298' },
	{ city: 'Drumcalpin (Cavan)', zip: '559735' },
	{ city: 'Drumcamill (Louth)', zip: '635836' },
	{ city: 'Drumcannon (Donegal)', zip: '467220' },
	{ city: 'Drumcannon (Waterford)', zip: '602869' },
	{ city: 'Drumcanon (Cavan)', zip: '124270' },
	{ city: 'Drumcanon (Leitrim)', zip: '240298' },
	{ city: 'Drumcanon (Monaghan)', zip: '841539' },
	{ city: 'Drumcar (Cavan)', zip: '320207' },
	{ city: 'Drumcar (Louth)', zip: '793291' },
	{ city: 'Drumcaran Beg (Clare)', zip: '880872' },
	{ city: 'Drumcaran More (Clare)', zip: '720572' },
	{ city: 'Drumcarban (Cavan)', zip: '967283' },
	{ city: 'Drumcarbit (Donegal)', zip: '405073' },
	{ city: 'Drumcarey (Cavan)', zip: '684675' },
	{ city: 'Drumcargy (Monaghan)', zip: '405410' },
	{ city: 'Drumcarn (Cavan)', zip: '603389' },
	{ city: 'Drumcarn (Donegal)', zip: '831171' },
	{ city: 'Drumcarna (Clare)', zip: '563360' },
	{ city: 'Drumcarra (Leitrim)', zip: '183367' },
	{ city: 'Drumcarrow (Monaghan)', zip: '381710' },
	{ city: 'Drumcartagh (Cavan)', zip: '513101' },
	{ city: 'Drumcase (Cavan)', zip: '593658' },
	{ city: 'Drumcashel (Leitrim)', zip: '345066' },
	{ city: 'Drumcashel (Louth)', zip: '315907' },
	{ city: 'Drumcashlagh (Leitrim)', zip: '776213' },
	{ city: 'Drumcask (Cavan)', zip: '717701' },
	{ city: 'Drumcassidy (Cavan)', zip: '861431' },
	{ city: 'Drumcattan (Leitrim)', zip: '859569' },
	{ city: 'Drumcattan (Monaghan)', zip: '753020' },
	{ city: 'Drumcavan (Clare)', zip: '261385' },
	{ city: 'Drumcavany (Donegal)', zip: '228044' },
	{ city: 'Drumcaw (Monaghan)', zip: '354574' },
	{ city: 'Drumcaw (Offaly)', zip: '883978' },
	{ city: 'Drumcharley (Clare)', zip: '563947' },
	{ city: 'Drumchoe (Cavan)', zip: '141613' },
	{ city: 'Drumchory Glebe (Donegal)', zip: '218009' },
	{ city: 'Drumchrin (Donegal)', zip: '647393' },
	{ city: 'Drumcleavry (Roscommon)', zip: '322692' },
	{ city: 'Drumclieve (Tipperary)', zip: '966512' },
	{ city: 'Drumcliff (Clare)', zip: '263906' },
	{ city: 'Drumcliff (Donegal)', zip: '609414' },
	{ city: 'Drumcliff (Sligo)', zip: '374986' },
	{ city: 'Drumcliff Glebe (Sligo)', zip: '111672' },
	{ city: 'Drumcliff North (Sligo)', zip: '941295' },
	{ city: 'Drumcliff South (Sligo)', zip: '303041' },
	{ city: 'Drumcliff West (Sligo)', zip: '222503' },
	{ city: 'Drumcoe (Donegal)', zip: '558209' },
	{ city: 'Drumcoggy Mountain (Mayo)', zip: '718989' },
	{ city: 'Drumcoghill Lower (Cavan)', zip: '403048' },
	{ city: 'Drumcoghill Upper (Cavan)', zip: '769707' },
	{ city: 'Drumcole (Cavan)', zip: '872860' },
	{ city: 'Drumcollagan (Leitrim)', zip: '601047' },
	{ city: 'Drumcollop (Leitrim)', zip: '937096' },
	{ city: 'Drumcolumb (Sligo)', zip: '381135' },
	{ city: 'Drumcomoge (Tipperary)', zip: '353509' },
	{ city: 'Drumcon (Cavan)', zip: '372963' },
	{ city: 'Drumconcoose (Donegal)', zip: '190079' },
	{ city: 'Drumcondra (Cavan)', zip: '664326' },
	{ city: 'Drumcondra (Meath)', zip: '656539' },
	{ city: 'Drumcondra (Monaghan)', zip: '215710' },
	{ city: 'Drumcondra (Sligo)', zip: '898376' },
	{ city: 'Drumcong (Leitrim)', zip: '477931' },
	{ city: 'Drumconlan (Mayo)', zip: '763313' },
	{ city: 'Drumconlester (Cavan)', zip: '568434' },
	{ city: 'Drumconlevan (Leitrim)', zip: '783322' },
	{ city: 'Drumconnelly (Monaghan)', zip: '549636' },
	{ city: 'Drumconnick (Cavan)', zip: '973435' },
	{ city: 'Drumconny (Leitrim)', zip: '808159' },
	{ city: 'Drumconor (Donegal)', zip: '900316' },
	{ city: 'Drumconor (Leitrim)', zip: '989523' },
	{ city: 'Drumconra (Cavan)', zip: '489208' },
	{ city: 'Drumcoo (Monaghan)', zip: '187061' },
	{ city: 'Drumcooly (Offaly)', zip: '491952' },
	{ city: 'Drumcoora (Leitrim)', zip: '163793' },
	{ city: 'Drumcor (Cavan)', zip: '201461' },
	{ city: 'Drumcore (Clare)', zip: '636474' },
	{ city: 'Drumcormick (Roscommon)', zip: '520740' },
	{ city: 'Drumcormick (Sligo)', zip: '373399' },
	{ city: 'Drumcorrabaun (Mayo)', zip: '457246' },
	{ city: 'Drumcoura (Leitrim)', zip: '737721' },
	{ city: 'Drumcrauve (Cavan)', zip: '687383' },
	{ city: 'Drumcree (Leitrim)', zip: '245583' },
	{ city: 'Drumcree (Westmeath)', zip: '190139' },
	{ city: 'Drumcreeghan (Monaghan)', zip: '703071' },
	{ city: 'Drumcrew (Monaghan)', zip: '417555' },
	{ city: 'Drumcrin (Cavan)', zip: '222697' },
	{ city: 'Drumcroagh (Donegal)', zip: '482672' },
	{ city: 'Drumcroman (Leitrim)', zip: '188545' },
	{ city: 'Drumcromaun (Leitrim)', zip: '598395' },
	{ city: 'Drumcrow (Cavan)', zip: '358045' },
	{ city: 'Drumcrow (Donegal)', zip: '636492' },
	{ city: 'Drumcrow (Monaghan)', zip: '528353' },
	{ city: 'Drumcrow North (Cavan)', zip: '192678' },
	{ city: 'Drumcrow South (Cavan)', zip: '678628' },
	{ city: 'Drumcroy (Leitrim)', zip: '785937' },
	{ city: 'Drumcru (Monaghan)', zip: '739861' },
	{ city: 'Drumcullaun (Clare)', zip: '128422' },
	{ city: 'Drumcullion (Cavan)', zip: '467066' },
	{ city: 'Drumcullion (Leitrim)', zip: '415733' },
	{ city: 'Drumcunnion (Monaghan)', zip: '108197' },
	{ city: 'Drumcurreen (Clare)', zip: '761370' },
	{ city: 'Drumdaff (Mayo)', zip: '934166' },
	{ city: 'Drumdaff (Roscommon)', zip: '164580' },
	{ city: 'Drumdangan (Wicklow)', zip: '304176' },
	{ city: 'Drumdarkan (Leitrim)', zip: '250445' },
	{ city: 'Drumdart (Leitrim)', zip: '476105' },
	{ city: 'Drumdart (Monaghan)', zip: '332707' },
	{ city: 'Drumdartan Glebe (Leitrim)', zip: '488039' },
	{ city: 'Drumdeel (Tipperary)', zip: '438324' },
	{ city: 'Drumdeevin (Donegal)', zip: '446037' },
	{ city: 'Drumderg (Cavan)', zip: '718624' },
	{ city: 'Drumderg (Leitrim)', zip: '859022' },
	{ city: 'Drumderg (Longford)', zip: '478164' },
	{ city: 'Drumderg Glebe (Cavan)', zip: '305439' },
	{ city: 'Drumderglin (Leitrim)', zip: '726489' },
	{ city: 'Drumderry (Sligo)', zip: '570908' },
	{ city: 'Drumderry (Wexford)', zip: '289845' },
	{ city: 'Drumderrydonan (Donegal)', zip: '111593' },
	{ city: 'Drumdesco (Monaghan)', zip: '906673' },
	{ city: 'Drumdiffer (Leitrim)', zip: '840700' },
	{ city: 'Drumdigus (Clare)', zip: '887032' },
	{ city: 'Drumdiha (Tipperary)', zip: '832074' },
	{ city: 'Drumdillure (Leitrim)', zip: '440282' },
	{ city: 'Drumdiveen (Sligo)', zip: '955778' },
	{ city: 'Drumdoe (Roscommon)', zip: '534020' },
	{ city: 'Drumdoit (Donegal)', zip: '116601' },
	{ city: 'Drumdoney (Sligo)', zip: '103239' },
	{ city: 'Drumdoo (Leitrim)', zip: '766812' },
	{ city: 'Drumdoogh (Mayo)', zip: '537930' },
	{ city: 'Drumdoolaghty (Clare)', zip: '843005' },
	{ city: 'Drumdowney Lower (Kilkenny)', zip: '889059' },
	{ city: 'Drumdowney Upper (Kilkenny)', zip: '408097' },
	{ city: 'Drumdreeny (Monaghan)', zip: '991170' },
	{ city: 'Drumdrishaghaun (Mayo)', zip: '246807' },
	{ city: 'Drumduff (Clare)', zip: '102345' },
	{ city: 'Drumduff (Donegal)', zip: '735711' },
	{ city: 'Drumduff (Leitrim)', zip: '281894' },
	{ city: 'Drumduff North (Leitrim)', zip: '993767' },
	{ city: 'Drumduff South (Leitrim)', zip: '249043' },
	{ city: 'Drumduffy (Leitrim)', zip: '989070' },
	{ city: 'Drumdutton (Donegal)', zip: '479989' },
	{ city: 'Drumeague (Cavan)', zip: '695438' },
	{ city: 'Drumeanan Beg (Leitrim)', zip: '615699' },
	{ city: 'Drumeanan More (Leitrim)', zip: '948228' },
	{ city: 'Drumearn (Donegal)', zip: '358798' },
	{ city: 'Drumeasan (Donegal)', zip: '748167' },
	{ city: 'Drum East (Galway)', zip: '955211' },
	{ city: 'Drum East (Sligo)', zip: '534720' },
	{ city: 'Drumederalena (Sligo)', zip: '586344' },
	{ city: 'Drumederglass (Cavan)', zip: '941248' },
	{ city: 'Drumee (Monaghan)', zip: '149618' },
	{ city: 'Drumee (Sligo)', zip: '567396' },
	{ city: 'Drumeela (Leitrim)', zip: '942192' },
	{ city: 'Drumeena (Cavan)', zip: '999998' },
	{ city: 'Drumeeny (Cavan)', zip: '190751' },
	{ city: 'Drumeevin (Clare)', zip: '144771' },
	{ city: 'Drumegil (Cavan)', zip: '508057' },
	{ city: 'Drumelis (Cavan)', zip: '840461' },
	{ city: 'Drumellihy (Clare)', zip: '945813' },
	{ city: 'Drumellis (Cavan)', zip: '123135' },
	{ city: 'Drumelly (Mayo)', zip: '204568' },
	{ city: 'Drumeltan (Cavan)', zip: '879285' },
	{ city: 'Drumenan (Donegal)', zip: '189560' },
	{ city: 'Drumercool (Roscommon)', zip: '837397' },
	{ city: 'Drumercross (Leitrim)', zip: '343903' },
	{ city: 'Drumerdannan (Cavan)', zip: '761770' },
	{ city: 'Drumergoole (Leitrim)', zip: '949831' },
	{ city: 'Drumerhin (Kilkenny)', zip: '104541' },
	{ city: 'Drumerkeane (Leitrim)', zip: '334835' },
	{ city: 'Drumerkillew (Cavan)', zip: '242356' },
	{ city: 'Drumerlough Beg (Monaghan)', zip: '270094' },
	{ city: 'Drumerlough More (Monaghan)', zip: '321352' },
	{ city: 'Drumerr (Roscommon)', zip: '798427' },
	{ city: 'Drumersee (Cavan)', zip: '267279' },
	{ city: 'Drumersnaw (Cavan)', zip: '361890' },
	{ city: 'Drumestagh (Cavan)', zip: '472045' },
	{ city: 'Drumever (Monaghan)', zip: '419594' },
	{ city: 'Drumeyre (Galway)', zip: '334654' },
	{ city: 'Drumfad (Donegal)', zip: '821436' },
	{ city: 'Drumfad (Sligo)', zip: '617973' },
	{ city: 'Drumfad Lower (Donegal)', zip: '855763' },
	{ city: 'Drumfad Upper (Donegal)', zip: '372047' },
	{ city: 'Drumfaldra (Monaghan)', zip: '434108' },
	{ city: 'Drumfarnoght (Sligo)', zip: '317855' },
	{ city: 'Drumfea (Carlow)', zip: '958119' },
	{ city: 'Drumfergus (Donegal)', zip: '550580' },
	{ city: 'Drumfernasky (Monaghan)', zip: '835799' },
	{ city: 'Drumfin (Donegal)', zip: '987600' },
	{ city: 'Drumfin (Sligo)', zip: '451243' },
	{ city: 'Drumfomina (Cavan)', zip: '518498' },
	{ city: 'Drumfree (Donegal)', zip: '139444' },
	{ city: 'Drumfurban (Mayo)', zip: '929135' },
	{ city: 'Drumfurrer (Monaghan)', zip: '244185' },
	{ city: 'Drumgaghan (Monaghan)', zip: '509151' },
	{ city: 'Drumgallan (Monaghan)', zip: '598673' },
	{ city: 'Drumgallon (Cavan)', zip: '839017' },
	{ city: 'Drumgane (Leitrim)', zip: '426997' },
	{ city: 'Drumganny (Monaghan)', zip: '204695' },
	{ city: 'Drumganus Lower (Monaghan)', zip: '995459' },
	{ city: 'Drumganus Upper (Monaghan)', zip: '280558' },
	{ city: 'Drumgar (Mayo)', zip: '184715' },
	{ city: 'Drumgarkin (Monaghan)', zip: '989855' },
	{ city: 'Drumgarly (Monaghan)', zip: '514656' },
	{ city: 'Drumgarn (Leitrim)', zip: '331199' },
	{ city: 'Drumgarn (Monaghan)', zip: '632969' },
	{ city: 'Drumgarra (Monaghan)', zip: '273322' },
	{ city: 'Drumgarran (Monaghan)', zip: '429521' },
	{ city: 'Drumgart (Cavan)', zip: '712134' },
	{ city: 'Drumgarve (Mayo)', zip: '501343' },
	{ city: 'Drumgarve (Monaghan)', zip: '295670' },
	{ city: 'Drumgavny (Monaghan)', zip: '275831' },
	{ city: 'Drumgaze (Monaghan)', zip: '337896' },
	{ city: 'Drumgeaglom (Leitrim)', zip: '751154' },
	{ city: 'Drumgeely (Clare)', zip: '767182' },
	{ city: 'Drumgeeny (Monaghan)', zip: '250060' },
	{ city: 'Drumgerd (Cavan)', zip: '391883' },
	{ city: 'Drumgesh (Cavan)', zip: '823636' },
	{ city: 'Drumgill (Cavan)', zip: '663548' },
	{ city: 'Drumgill (Meath)', zip: '375374' },
	{ city: 'Drumgill (Tipperary)', zip: '328356' },
	{ city: 'Drumgill Lower (Meath)', zip: '699939' },
	{ city: 'Drumgill Upper (Meath)', zip: '548420' },
	{ city: 'Drumgilra (Leitrim)', zip: '858629' },
	{ city: 'Drumgloon (Clare)', zip: '872263' },
	{ city: 'Drumgoa (Cavan)', zip: '834512' },
	{ city: 'Drumgoan (Monaghan)', zip: '853948' },
	{ city: 'Drumgoask (Monaghan)', zip: '151829' },
	{ city: 'Drumgoast (Monaghan)', zip: '726298' },
	{ city: 'Drumgoff (Wicklow)', zip: '717108' },
	{ city: 'Drumgola (Cavan)', zip: '498359' },
	{ city: 'Drumgolat (Monaghan)', zip: '831702' },
	{ city: 'Drumgold (Wexford)', zip: '156844' },
	{ city: 'Drumgole (Monaghan)', zip: '934088' },
	{ city: 'Drumgollagh (Mayo)', zip: '580905' },
	{ city: 'Drumgoney (Cavan)', zip: '710667' },
	{ city: 'Drumgoney (Mayo)', zip: '299501' },
	{ city: 'Drumgonnelly (Louth)', zip: '183191' },
	{ city: 'Drumgooaun (Galway)', zip: '104272' },
	{ city: 'Drumgoohy (Cavan)', zip: '466862' },
	{ city: 'Drumgoolan (Louth)', zip: '200318' },
	{ city: 'Drumgoole (Kilkenny)', zip: '470354' },
	{ city: 'Drumgoole (Monaghan)', zip: '760595' },
	{ city: 'Drumgoon (Cavan)', zip: '877445' },
	{ city: 'Drumgoosat (Monaghan)', zip: '582060' },
	{ city: 'Drumgoose (Monaghan)', zip: '173121' },
	{ city: 'Drumgooter (Louth)', zip: '758109' },
	{ city: 'Drumgor (Cavan)', zip: '162663' },
	{ city: 'Drumgor (Monaghan)', zip: '656594' },
	{ city: 'Drumgora (Cavan)', zip: '181202' },
	{ city: 'Drumgore (Cavan)', zip: '532264' },
	{ city: 'Drumgorey (Waterford)', zip: '894272' },
	{ city: 'Drumgorman (Donegal)', zip: '967111' },
	{ city: 'Drumgorman (Leitrim)', zip: '963823' },
	{ city: 'Drumgorman Barr (Donegal)', zip: '488355' },
	{ city: 'Drumgornan (Donegal)', zip: '309783' },
	{ city: 'Drumgorry (Cavan)', zip: '824894' },
	{ city: 'Drumgowan (Donegal)', zip: '457985' },
	{ city: 'Drumgower (Tipperary)', zip: '702947' },
	{ city: 'Drumgowla (Leitrim)', zip: '839947' },
	{ city: 'Drumgowna (Louth)', zip: '792827' },
	{ city: 'Drumgowna (Monaghan)', zip: '658622' },
	{ city: 'Drumgownagh (Leitrim)', zip: '479648' },
	{ city: 'Drumgramph (Monaghan)', zip: '866496' },
	{ city: 'Drumgranagh (Clare)', zip: '792648' },
	{ city: 'Drumgrania (Leitrim)', zip: '166094' },
	{ city: 'Drumgreen (Cavan)', zip: '911302' },
	{ city: 'Drumgreeny (Monaghan)', zip: '482963' },
	{ city: 'Drumgreggan (Donegal)', zip: '774626' },
	{ city: 'Drumgriffin (Galway)', zip: '310919' },
	{ city: 'Drumgristin (Monaghan)', zip: '994126' },
	{ city: 'Drumgristin Lower (Monaghan)', zip: '262409' },
	{ city: 'Drumgristin Upper (Monaghan)', zip: '164977' },
	{ city: 'Drumgrole (Monaghan)', zip: '849328' },
	{ city: 'Drumgrone (Monaghan)', zip: '747019' },
	{ city: 'Drumgud (Leitrim)', zip: '278937' },
	{ city: 'Drumguff (Monaghan)', zip: '685549' },
	{ city: 'Drumguill (Monaghan)', zip: '339521' },
	{ city: 'Drumguillew Lower (Monaghan)', zip: '785884' },
	{ city: 'Drumguillew Upper (Monaghan)', zip: '490151' },
	{ city: 'Drumguilly (Monaghan)', zip: '349136' },
	{ city: 'Drumguin (Carlow)', zip: '385399' },
	{ city: 'Drumgullane East (Waterford)', zip: '258143' },
	{ city: 'Drumgullane West (Waterford)', zip: '782108' },
	{ city: 'Drumgumberland (Donegal)', zip: '388480' },
	{ city: 'Drumgun (Donegal)', zip: '770521' },
	{ city: 'Drumgunny (Leitrim)', zip: '732933' },
	{ city: 'Drumgur (Cavan)', zip: '447614' },
	{ city: 'Drumgur (Louth)', zip: '838625' },
	{ city: 'Drumgurra (Monaghan)', zip: '183958' },
	{ city: 'Drumhaggart (Donegal)', zip: '434747' },
	{ city: 'Drumhallagh (Cavan)', zip: '851392' },
	{ city: 'Drumhallagh (Leitrim)', zip: '863847' },
	{ city: 'Drumhallagh Lower (Donegal)', zip: '815783' },
	{ city: 'Drumhallagh Upper (Donegal)', zip: '658312' },
	{ city: 'Drumhalry (Leitrim)', zip: '115265' },
	{ city: 'Drumhalry (Longford)', zip: '155391' },
	{ city: 'Drumhalwy (Leitrim)', zip: '862579' },
	{ city: 'Drumhaman (Monaghan)', zip: '951741' },
	{ city: 'Drumhany (Leitrim)', zip: '537104' },
	{ city: 'Drumhany North (Leitrim)', zip: '375807' },
	{ city: 'Drumhany South (Leitrim)', zip: '977212' },
	{ city: 'Drumharid (Cavan)', zip: '652829' },
	{ city: 'Drumharkan (Leitrim)', zip: '528877' },
	{ city: 'Drumharkan Glebe (Leitrim)', zip: '228094' },
	{ city: 'Drumharlow (Roscommon)', zip: '756212' },
	{ city: 'Drumharriff (Donegal)', zip: '428950' },
	{ city: 'Drumharriff (Monaghan)', zip: '568577' },
	{ city: 'Drumharriff North (Monaghan)', zip: '789992' },
	{ city: 'Drumharsna North (Galway)', zip: '578857' },
	{ city: 'Drumharsna South (Galway)', zip: '932659' },
	{ city: 'Drumhart (Cavan)', zip: '717715' },
	{ city: 'Drumhasket (Monaghan)', zip: '710189' },
	{ city: 'Drumhass (Leitrim)', zip: '321960' },
	{ city: 'Drumhaughly (Longford)', zip: '995840' },
	{ city: 'Drumhauver (Leitrim)', zip: '809083' },
	{ city: 'Drumhawan (Monaghan)', zip: '293963' },
	{ city: 'Drumhawnagh (Cavan)', zip: '381091' },
	{ city: 'Drumhawragh (Cavan)', zip: '522441' },
	{ city: 'Drumhay (Monaghan)', zip: '843193' },
	{ city: 'Drumheckil (Leitrim)', zip: '752037' },
	{ city: 'Drumhecknagh (Cavan)', zip: '783863' },
	{ city: 'Drumheel (Cavan)', zip: '378816' },
	{ city: 'Drumherriff (Cavan)', zip: '734482' },
	{ city: 'Drumherriff (Leitrim)', zip: '278694' },
	{ city: 'Drumherriff North (Cavan)', zip: '648690' },
	{ city: 'Drumherriff South (Cavan)', zip: '717899' },
	{ city: 'Drumherrish (Cavan)', zip: '554525' },
	{ city: 'Drumherrive (Donegal)', zip: '310922' },
	{ city: 'Drumhierny (Leitrim)', zip: '905036' },
	{ city: 'Drumhillagh (Cavan)', zip: '747937' },
	{ city: 'Drumhillagh (Monaghan)', zip: '531629' },
	{ city: 'Drumhillagh North (Cavan)', zip: '633671' },
	{ city: 'Drumhillagh South (Cavan)', zip: '111372' },
	{ city: 'Drumhirk (Cavan)', zip: '844947' },
	{ city: 'Drumhirk (Leitrim)', zip: '541795' },
	{ city: 'Drumhirk (Monaghan)', zip: '495511' },
	{ city: 'Drumhogan (Galway)', zip: '697837' },
	{ city: 'Drumhome (Cavan)', zip: '742725' },
	{ city: 'Drumhome (Donegal)', zip: '302014' },
	{ city: 'Drumhose (Cavan)', zip: '972089' },
	{ city: 'Drumhubbrid (Leitrim)', zip: '156797' },
	{ city: 'Drumhurrin (Cavan)', zip: '135583' },
	{ city: 'Drumhurt (Cavan)', zip: '435777' },
	{ city: 'Drumhuskert (Mayo)', zip: '426432' },
	{ city: 'Drumilkin (Monaghan)', zip: '567735' },
	{ city: 'Drumillard (Monaghan)', zip: '522393' },
	{ city: 'Drumillard Big (Monaghan)', zip: '393227' },
	{ city: 'Drumillard Little (Monaghan)', zip: '929029' },
	{ city: 'Drumiller (Cavan)', zip: '276968' },
	{ city: 'Drumillion (Leitrim)', zip: '875345' },
	{ city: 'Drumilra (Mayo)', zip: '401831' },
	{ city: 'Drumin (Louth)', zip: '748130' },
	{ city: 'Druminacrehir (Longford)', zip: '385214' },
	{ city: 'Druminagh (Roscommon)', zip: '421849' },
	{ city: 'Druminalass (Leitrim)', zip: '248828' },
	{ city: 'Druminane (Monaghan)', zip: '878005' },
	{ city: 'Druminardagh (Donegal)', zip: '689692' },
	{ city: 'Druminargid (Leitrim)', zip: '286981' },
	{ city: 'Druminaw (Donegal)', zip: '981167' },
	{ city: 'Druminda (Tipperary)', zip: '666362' },
	{ city: 'Druminderry Upper And Lower (Donegal)', zip: '194761' },
	{ city: 'Druminduff (Offaly)', zip: '639491' },
	{ city: 'Drumineigh Glebe (Leitrim)', zip: '301026' },
	{ city: 'Drumineney (Donegal)', zip: '453665' },
	{ city: 'Druming (Longford)', zip: '481167' },
	{ city: 'Drumingna (Leitrim)', zip: '186375' },
	{ city: 'Druminiscal (Donegal)', zip: '962128' },
	{ city: 'Druminisclin (Cavan)', zip: '493715' },
	{ city: 'Druminiskill (Cavan)', zip: '514487' },
	{ city: 'Druminiskin (Meath)', zip: '929387' },
	{ city: 'Druminnick (Cavan)', zip: '867035' },
	{ city: 'Druminnin (Donegal)', zip: '722902' },
	{ city: 'Druminshin (Clare)', zip: '168780' },
	{ city: 'Druminshin (Leitrim)', zip: '607881' },
	{ city: 'Druminshin (Meath)', zip: '779781' },
	{ city: 'Druminshin Glebe (Leitrim)', zip: '662783' },
	{ city: 'Druminshingore (Leitrim)', zip: '290814' },
	{ city: 'Drumintin (Monaghan)', zip: '982786' },
	{ city: 'Druminuff (Leitrim)', zip: '560267' },
	{ city: 'Druminure (Tipperary)', zip: '264858' },
	{ city: 'Drumirril (Monaghan)', zip: '735065' },
	{ city: 'Drumirrin (Donegal)', zip: '580853' },
	{ city: 'Drumkeaghta (Mayo)', zip: '294233' },
	{ city: 'Drumkeary East (Galway)', zip: '217911' },
	{ city: 'Drumkeary West (Galway)', zip: '350758' },
	{ city: 'Drumkeeghan (Donegal)', zip: '554819' },
	{ city: 'Drumkeel (Leitrim)', zip: '745629' },
	{ city: 'Drumkeelan (Donegal)', zip: '824252' },
	{ city: 'Drumkeelan (Leitrim)', zip: '123283' },
	{ city: 'Drumkeelan Beg (Leitrim)', zip: '683941' },
	{ city: 'Drumkeelan More (Leitrim)', zip: '513184' },
	{ city: 'Drumkeelwick (Leitrim)', zip: '548848' },
	{ city: 'Drumkeen (Cavan)', zip: '276563' },
	{ city: 'Drumkeen (Donegal)', zip: '235405' },
	{ city: 'Drumkeen (Leitrim)', zip: '714600' },
	{ city: 'Drumkeen (Mayo)', zip: '521856' },
	{ city: 'Drumkeeran (Cavan)', zip: '339968' },
	{ city: 'Drumkeeran (Leitrim)', zip: '177703' },
	{ city: 'Drumkeeran Beg (Cavan)', zip: '530364' },
	{ city: 'Drumkeeran Black (Cavan)', zip: '472920' },
	{ city: 'Drumkeeran More (Cavan)', zip: '986086' },
	{ city: 'Drumkeery (Cavan)', zip: '150324' },
	{ city: 'Drumkeilvy (Leitrim)', zip: '222877' },
	{ city: 'Drumkerril (Cavan)', zip: '846492' },
	{ city: 'Drumkilla (Leitrim)', zip: '289412' },
	{ city: 'Drumkilleen (Leitrim)', zip: '388416' },
	{ city: 'Drumkilly (Cavan)', zip: '968920' },
	{ city: 'Drumkilroosk (Cavan)', zip: '162500' },
	{ city: 'Drumkilsellagh (Sligo)', zip: '410213' },
	{ city: 'Drumkirwan (Leitrim)', zip: '796977' },
	{ city: 'Drumlackagh (Donegal)', zip: '110388' },
	{ city: 'Drumlaggagh (Leitrim)', zip: '885962' },
	{ city: 'Drumlaghdrid (Donegal)', zip: '811087' },
	{ city: 'Drumlaght (Donegal)', zip: '319016' },
	{ city: 'Drumlaghtafin (Donegal)', zip: '427260' },
	{ city: 'Drumlahard (Roscommon)', zip: '201520' },
	{ city: 'Drumlaheen (Leitrim)', zip: '603313' },
	{ city: 'Drumlandrick (Monaghan)', zip: '538012' },
	{ city: 'Drumlane (Cavan)', zip: '797134' },
	{ city: 'Drumlane (Monaghan)', zip: '805705' },
	{ city: 'Drumlara (Leitrim)', zip: '746888' },
	{ city: 'Drumlara (Monaghan)', zip: '611848' },
	{ city: 'Drumlarah (Cavan)', zip: '219709' },
	{ city: 'Drumlargan (Meath)', zip: '310219' },
	{ city: 'Drumlark (Cavan)', zip: '624258' },
	{ city: 'Drumlarney (Cavan)', zip: '600535' },
	{ city: 'Drumlask (Donegal)', zip: '603669' },
	{ city: 'Drumlattery (Dublin)', zip: '983748' },
	{ city: 'Drumlaunaght (Cavan)', zip: '753718' },
	{ city: 'Drumlave (Cork)', zip: '327080' },
	{ city: 'Drumlaydan (Cavan)', zip: '645009' },
	{ city: 'Drumlayne (Meath)', zip: '497094' },
	{ city: 'Drumlea (Leitrim)', zip: '412122' },
	{ city: 'Drumleagh (Tipperary)', zip: '123115' },
	{ city: 'Drumleague (Cavan)', zip: '374474' },
	{ city: 'Drumleague (Leitrim)', zip: '588317' },
	{ city: 'Drumlease (Leitrim)', zip: '961208' },
	{ city: 'Drumleavalliagh (Donegal)', zip: '132120' },
	{ city: 'Drumleck (Louth)', zip: '384914' },
	{ city: 'Drumlee (Donegal)', zip: '964177' },
	{ city: 'Drumleek North (Monaghan)', zip: '258794' },
	{ city: 'Drumleek South (Monaghan)', zip: '145423' },
	{ city: 'Drumleene (Donegal)', zip: '792373' },
	{ city: 'Drumleevan (Leitrim)', zip: '670035' },
	{ city: 'Drumleny (Cavan)', zip: '990909' },
	{ city: 'Drumleny (Monaghan)', zip: '544368' },
	{ city: 'Drumlerry (Meath)', zip: '940212' },
	{ city: 'Drumlesh (Clare)', zip: '523905' },
	{ city: 'Drumlester (Monaghan)', zip: '856043' },
	{ city: 'Drumliff (Cavan)', zip: '617594' },
	{ city: 'Drumliffin Glebe (Leitrim)', zip: '879173' },
	{ city: 'Drumlina (Monaghan)', zip: '656952' },
	{ city: 'Drumline (Clare)', zip: '538917' },
	{ city: 'Drumlinny (Monaghan)', zip: '297726' },
	{ city: 'Drumlion (Cavan)', zip: '481476' },
	{ city: 'Drumlion (Roscommon)', zip: '832721' },
	{ city: 'Drumlish (Longford)', zip: '722385' },
	{ city: 'Drumlish (Monaghan)', zip: '819453' },
	{ city: 'Drumlish (Roscommon)', zip: '381088' },
	{ city: 'Drumlitten (Leitrim)', zip: '361372' },
	{ city: 'Drumloaghan (Cavan)', zip: '114368' },
	{ city: 'Drumlohan (Waterford)', zip: '836674' },
	{ city: 'Drumlom (Cavan)', zip: '830271' },
	{ city: 'Drumlom (Leitrim)', zip: '179638' },
	{ city: 'Drumloman (Cavan)', zip: '934278' },
	{ city: 'Drumlon (Cavan)', zip: '255892' },
	{ city: 'Drumlona (Monaghan)', zip: '235738' },
	{ city: 'Drumlonagher (Donegal)', zip: '506465' },
	{ city: 'Drumlonan (Leitrim)', zip: '733760' },
	{ city: 'Drumlong (Mayo)', zip: '415542' },
	{ city: 'Drumlongfield (Monaghan)', zip: '223590' },
	{ city: 'Drumloo (Monaghan)', zip: '440153' },
	{ city: 'Drumlood (Monaghan)', zip: '355860' },
	{ city: 'Drumloona (Leitrim)', zip: '789994' },
	{ city: 'Drumloo North (Monaghan)', zip: '439041' },
	{ city: 'Drumloose (Westmeath)', zip: '363616' },
	{ city: 'Drumloo South (Monaghan)', zip: '952065' },
	{ city: 'Drumlosh (Roscommon)', zip: '307852' },
	{ city: 'Drumlough (Donegal)', zip: '227629' },
	{ city: 'Drumlougher (Cavan)', zip: '628927' },
	{ city: 'Drumlougher (Donegal)', zip: '593951' },
	{ city: 'Drumlougher (Longford)', zip: '949799' },
	{ city: 'Drumloughlin (Monaghan)', zip: '113422' },
	{ city: 'Drumloughra (Mayo)', zip: '777655' },
	{ city: 'Drumlowan (Leitrim)', zip: '779190' },
	{ city: 'Drumlumman (Cavan)', zip: '463524' },
	{ city: 'Drumlumman (Leitrim)', zip: '142204' },
	{ city: 'Drumlumman Glebe (Leitrim)', zip: '751065' },
	{ city: 'Drumlummin (Tipperary)', zip: '676316' },
	{ city: 'Drumlurg (Monaghan)', zip: '270001' },
	{ city: 'Drumlurgagh (Donegal)', zip: '253722' },
	{ city: 'Drumlusty (Monaghan)', zip: '168449' },
	{ city: 'Drummaanadeevan (Clare)', zip: '890692' },
	{ city: 'Drummaan East (Clare)', zip: '526422' },
	{ city: 'Drummaan South (Clare)', zip: '245484' },
	{ city: 'Drummaan West (Clare)', zip: '858494' },
	{ city: 'Drummacachapple (Donegal)', zip: '492977' },
	{ city: 'Drummacacullen (Donegal)', zip: '751063' },
	{ city: 'Drummacaladdery (Donegal)', zip: '332781' },
	{ city: 'Drummacanoo (Donegal)', zip: '281959' },
	{ city: 'Drummacavoy (Monaghan)', zip: '289600' },
	{ city: 'Drummaconor (Monaghan)', zip: '388093' },
	{ city: 'Drummacool (Sligo)', zip: '109133' },
	{ city: 'Drummad (Roscommon)', zip: '840739' },
	{ city: 'Drummagh (Leitrim)', zip: '917880' },
	{ city: 'Drummaghmartin (Clare)', zip: '957976' },
	{ city: 'Drummahan (Leitrim)', zip: '645827' },
	{ city: 'Drummallaght (Cavan)', zip: '980133' },
	{ city: 'Drumman (Cavan)', zip: '408995' },
	{ city: 'Drumman (Donegal)', zip: '765595' },
	{ city: 'Drumman (Longford)', zip: '117226' },
	{ city: 'Drumman (Meath)', zip: '780080' },
	{ city: 'Drumman (Roscommon)', zip: '622170' },
	{ city: 'Drumman (Westmeath)', zip: '408900' },
	{ city: 'Drummanacappul (Leitrim)', zip: '702090' },
	{ city: 'Drummanasooan (Leitrim)', zip: '308685' },
	{ city: 'Drummanbane (Cavan)', zip: '656572' },
	{ city: 'Drummanbane (Leitrim)', zip: '354777' },
	{ city: 'Drumman Beg (Roscommon)', zip: '377862' },
	{ city: 'Drummanduff (Cavan)', zip: '183851' },
	{ city: 'Drummanfaughnan (Leitrim)', zip: '246862' },
	{ city: 'Drummangarvagh (Leitrim)', zip: '354209' },
	{ city: 'Drumman More (Roscommon)', zip: '988631' },
	{ city: 'Drummannaglieve (Mayo)', zip: '894240' },
	{ city: 'Drummanneen (Clare)', zip: '252576' },
	{ city: 'Drummanreagh (Monaghan)', zip: '435922' },
	{ city: 'Drummans (Dublin)', zip: '777942' },
	{ city: 'Drummans (Leitrim)', zip: '890784' },
	{ city: 'Drummans (Monaghan)', zip: '239282' },
	{ city: 'Drummans Lower (Leitrim)', zip: '634634' },
	{ city: 'Drummans Upper (Leitrim)', zip: '623959' },
	{ city: 'Drummanus Glebe (Donegal)', zip: '389714' },
	{ city: 'Drummany (Cavan)', zip: '126953' },
	{ city: 'Drummany Beg (Cavan)', zip: '247025' },
	{ city: 'Drummany Glebe (Cavan)', zip: '697080' },
	{ city: 'Drummany Montiaghs (Cavan)', zip: '217779' },
	{ city: 'Drummany Rahan (Cavan)', zip: '306228' },
	{ city: 'Drummartin (Cavan)', zip: '320974' },
	{ city: 'Drummartin (Dublin)', zip: '242605' },
	{ city: 'Drummartin (Sligo)', zip: '259224' },
	{ city: 'Drummaunroe (Leitrim)', zip: '601787' },
	{ city: 'Drummaveg (Galway)', zip: '543526' },
	{ city: 'Drummay (Donegal)', zip: '998587' },
	{ city: 'Drummeel (Longford)', zip: '121459' },
	{ city: 'Drummeen (Clare)', zip: '317051' },
	{ city: 'Drummeen (Leitrim)', zip: '714757' },
	{ city: 'Drummeenagh (Louth)', zip: '289040' },
	{ city: 'Drummeenanagh (Donegal)', zip: '934355' },
	{ city: 'Drummeen East (Clare)', zip: '229129' },
	{ city: 'Drummeennavaddoge (Mayo)', zip: '690035' },
	{ city: 'Drummeen West (Clare)', zip: '208472' },
	{ city: 'Drummeer (Clare)', zip: '530718' },
	{ city: 'Drummenny Lower (Donegal)', zip: '938709' },
	{ city: 'Drummenny Middle (Donegal)', zip: '442724' },
	{ city: 'Drummenny Upper (Donegal)', zip: '624822' },
	{ city: 'Drummeva (Cavan)', zip: '890200' },
	{ city: 'Drummig (Cork)', zip: '139660' },
	{ city: 'Drummin (Carlow)', zip: '370520' },
	{ city: 'Drummin (Clare)', zip: '756048' },
	{ city: 'Drummin (Galway)', zip: '489358' },
	{ city: 'Drummin (Mayo)', zip: '928239' },
	{ city: 'Drummin (Offaly)', zip: '447776' },
	{ city: 'Drummin (Roscommon)', zip: '876252' },
	{ city: 'Drummin (Tipperary)', zip: '166125' },
	{ city: 'Drummin (Wicklow)', zip: '710135' },
	{ city: 'Drummina (Clare)', zip: '631666' },
	{ city: 'Drumminabo (Mayo)', zip: '544884' },
	{ city: 'Drumminacknew (Clare)', zip: '523128' },
	{ city: 'Drumminacloghaun (Galway)', zip: '836571' },
	{ city: 'Drumminacoosaun (Galway)', zip: '347496' },
	{ city: 'Drumminacroahy (Tipperary)', zip: '996318' },
	{ city: 'Drumminacunna (Tipperary)', zip: '217974' },
	{ city: 'Drumminagower (Tipperary)', zip: '641940' },
	{ city: 'Drumminaguncan (Mayo)', zip: '815808' },
	{ city: 'Drumminahaha (Mayo)', zip: '131662' },
	{ city: 'Drumminakela (Clare)', zip: '438644' },
	{ city: 'Drumminalough (Galway)', zip: '633193' },
	{ city: 'Drumminascart (Tipperary)', zip: '356610' },
	{ city: 'Drumminaweelaun (Mayo)', zip: '940355' },
	{ city: 'Drummindoo (Mayo)', zip: '108819' },
	{ city: 'Drummin East (Mayo)', zip: '573403' },
	{ city: 'Drummin East (Wicklow)', zip: '509643' },
	{ city: 'Drumminick (Cavan)', zip: '712946' },
	{ city: 'Drumminnagleagh (Tipperary)', zip: '130349' },
	{ city: 'Drumminnagran (Clare)', zip: '923728' },
	{ city: 'Drumminnakill (Galway)', zip: '790707' },
	{ city: 'Drumminnamuckla North (Galway)', zip: '410580' },
	{ city: 'Drumminnamuckla South (Galway)', zip: '493899' },
	{ city: 'Drumminnanav (Clare)', zip: '309841' },
	{ city: 'Drumminnion (Cavan)', zip: '977243' },
	{ city: 'Drummin North (Mayo)', zip: '431363' },
	{ city: 'Drumminphilip (Tipperary)', zip: '124199' },
	{ city: 'Drumminracahill (Mayo)', zip: '622129' },
	{ city: 'Drumminroe East (Mayo)', zip: '596798' },
	{ city: 'Drumminroe West (Mayo)', zip: '343914' },
	{ city: 'Drummin South (Mayo)', zip: '885876' },
	{ city: 'Drummin West (Mayo)', zip: '674141' },
	{ city: 'Drummin West (Wicklow)', zip: '962862' },
	{ city: 'Drumminwonagh (Mayo)', zip: '662418' },
	{ city: 'Drummod (Clare)', zip: '454278' },
	{ city: 'Drummod (Roscommon)', zip: '751427' },
	{ city: 'Drummoher (Clare)', zip: '347385' },
	{ city: 'Drummole (Cavan)', zip: '590615' },
	{ city: 'Drummonaclara (Tipperary)', zip: '581728' },
	{ city: 'Drummond (Kildare)', zip: '479356' },
	{ city: 'Drummond (Laois)', zip: '351605' },
	{ city: 'Drummond (Meath)', zip: '328655' },
	{ city: 'Drummond (Monaghan)', zip: '723965' },
	{ city: 'Drummond (Tipperary)', zip: '801596' },
	{ city: 'Drummond (Wexford)', zip: '827750' },
	{ city: 'Drummond Etra (Monaghan)', zip: '370312' },
	{ city: 'Drummond Otra (Monaghan)', zip: '768108' },
	{ city: 'Drummoney (Cavan)', zip: '146686' },
	{ city: 'Drummonum (Cavan)', zip: '697738' },
	{ city: 'Drummora Great (Cavan)', zip: '946428' },
	{ city: 'Drummora Little (Cavan)', zip: '786139' },
	{ city: 'Drummoy (Cavan)', zip: '785769' },
	{ city: 'Drummuck (Cavan)', zip: '355868' },
	{ city: 'Drummuck (Monaghan)', zip: '302634' },
	{ city: 'Drummucker (Leitrim)', zip: '277821' },
	{ city: 'Drummucklagh (Donegal)', zip: '776296' },
	{ city: 'Drummulla (Monaghan)', zip: '378730' },
	{ city: 'Drummullagh (Cavan)', zip: '812370' },
	{ city: 'Drummullagh (Louth)', zip: '757735' },
	{ city: 'Drummullan (Cavan)', zip: '875068' },
	{ city: 'Drummullan (Monaghan)', zip: '359781' },
	{ city: 'Drummullig (Cavan)', zip: '306687' },
	{ city: 'Drummullin (Roscommon)', zip: '992725' },
	{ city: 'Drummully (Monaghan)', zip: '854567' },
	{ city: 'Drummully East (Cavan)', zip: '443325' },
	{ city: 'Drummully West (Cavan)', zip: '120047' },
	{ city: 'Drummurphy (Donegal)', zip: '512332' },
	{ city: 'Drummurry (Cavan)', zip: '703839' },
	{ city: 'Drummury (Cavan)', zip: '887300' },
	{ city: 'Drummury (Leitrim)', zip: '651748' },
	{ city: 'Drumna (Leitrim)', zip: '910711' },
	{ city: 'Drumnabehy (Laois)', zip: '404324' },
	{ city: 'Drumnabratty (Donegal)', zip: '418741' },
	{ city: 'Drumnacarra (Louth)', zip: '355054' },
	{ city: 'Drumnacarry (Donegal)', zip: '866858' },
	{ city: 'Drumnacart (Donegal)', zip: '642673' },
	{ city: 'Drumnacarta (Mayo)', zip: '749255' },
	{ city: 'Drumnacart Mountain Pasture (Donegal)', zip: '121027' },
	{ city: 'Drumnacooha (Longford)', zip: '268440' },
	{ city: 'Drumnacor (Longford)', zip: '439671' },
	{ city: 'Drumnacot (Leitrim)', zip: '378682' },
	{ city: 'Drumnacraig (Donegal)', zip: '623243' },
	{ city: 'Drumnacroil (Donegal)', zip: '884131' },
	{ city: 'Drumnacross (Donegal)', zip: '796179' },
	{ city: 'Drumnacross (Leitrim)', zip: '284581' },
	{ city: 'Drumnacross (Longford)', zip: '596330' },
	{ city: 'Drumnadeevna (Clare)', zip: '670095' },
	{ city: 'Drumnadober (Leitrim)', zip: '105012' },
	{ city: 'Drumnafinnagle (Donegal)', zip: '967607' },
	{ city: 'Drumnafinnila (Leitrim)', zip: '923574' },
	{ city: 'Drumnafinnila Barr (Leitrim)', zip: '512776' },
	{ city: 'Drumnagah (Clare)', zip: '496011' },
	{ city: 'Drumnagahan (Donegal)', zip: '363317' },
	{ city: 'Drumnagar (Cavan)', zip: '890475' },
	{ city: 'Drumnagavlin (Monaghan)', zip: '424277' },
	{ city: 'Drumnagoal (Sligo)', zip: '678704' },
	{ city: 'Drumnagran (Cavan)', zip: '482674' },
	{ city: 'Drumnagranshy (Sligo)', zip: '773363' },
	{ city: 'Drumnagrella (Monaghan)', zip: '526414' },
	{ city: 'Drumnagress (Cavan)', zip: '949948' },
	{ city: 'Drumnagroagh (Donegal)', zip: '606241' },
	{ city: 'Drumnaha (Donegal)', zip: '823173' },
	{ city: 'Drumnahara (Longford)', zip: '495143' },
	{ city: 'Drumnaheark East (Donegal)', zip: '640197' },
	{ city: 'Drumnaheark West (Donegal)', zip: '726579' },
	{ city: 'Drumnahoagh (Donegal)', zip: '278944' },
	{ city: 'Drumnahough (Donegal)', zip: '517607' },
	{ city: 'Drumnahoul (Donegal)', zip: '885262' },
	{ city: 'Drumnahunshin (Monaghan)', zip: '624574' },
	{ city: 'Drumnakillew (Donegal)', zip: '474031' },
	{ city: 'Drumnakilly (Donegal)', zip: '850022' },
	{ city: 'Drumnalaragh (Cavan)', zip: '254594' },
	{ city: 'Drumnalassan (Roscommon)', zip: '603564' },
	{ city: 'Drumnalifferny (Donegal)', zip: '903866' },
	{ city: 'Drumnalifferny Mountain (Donegal)', zip: '155359' },
	{ city: 'Drumnalost (Donegal)', zip: '875913' },
	{ city: 'Drumnalough (Donegal)', zip: '199941' },
	{ city: 'Drumnamahane (Tipperary)', zip: '208165' },
	{ city: 'Drumnamahaneisland (Tipperary)', zip: '653072' },
	{ city: 'Drumnanaliv (Monaghan)', zip: '850458' },
	{ city: 'Drumnanangle (Mayo)', zip: '313675' },
	{ city: 'Drumnanarragh (Cavan)', zip: '541528' },
	{ city: 'Drumnaraw (Donegal)', zip: '158705' },
	{ city: 'Drumnart (Monaghan)', zip: '514625' },
	{ city: 'Drumnashammar (Donegal)', zip: '337374' },
	{ city: 'Drumnasharragh (Donegal)', zip: '938019' },
	{ city: 'Drumnashear (Donegal)', zip: '859762' },
	{ city: 'Drumnashinnagh (Mayo)', zip: '620932' },
	{ city: 'Drumnasillagh (Donegal)', zip: '112585' },
	{ city: 'Drumnasillagh (Louth)', zip: '924557' },
	{ city: 'Drumnaskea (Donegal)', zip: '862212' },
	{ city: 'Drumnaslooeen (Mayo)', zip: '436056' },
	{ city: 'Drumnasoohy (Sligo)', zip: '453172' },
	{ city: 'Drumnasorn (Donegal)', zip: '422765' },
	{ city: 'Drumnasreane (Cavan)', zip: '474590' },
	{ city: 'Drumnatinny (Donegal)', zip: '529432' },
	{ city: 'Drumnatinny Barr (Donegal)', zip: '845283' },
	{ city: 'Drumnatread (Cavan)', zip: '453160' },
	{ city: 'Drumnaveagh (Cavan)', zip: '208973' },
	{ city: 'Drumnavrick (Cavan)', zip: '450546' },
	{ city: 'Drumnawall (Cavan)', zip: '386167' },
	{ city: 'Drumnawooa (Donegal)', zip: '755364' },
	{ city: 'Drumnee (Longford)', zip: '193608' },
	{ city: 'Drumneen (Laois)', zip: '977590' },
	{ city: 'Drumneen (Mayo)', zip: '331357' },
	{ city: 'Drumneen Beg (Mayo)', zip: '832274' },
	{ city: 'Drumneen More (Mayo)', zip: '664239' },
	{ city: 'Drumneen South (Mayo)', zip: '538369' },
	{ city: 'Drumneill (Monaghan)', zip: '420800' },
	{ city: 'Drumnid (Leitrim)', zip: '430351' },
	{ city: 'Drumnigh (Dublin)', zip: '122497' },
	{ city: 'Drumnolan (Monaghan)', zip: '737371' },
	{ city: 'Drumnoose (Cavan)', zip: '419707' },
	{ city: 'Drumny (Monaghan)', zip: '231022' },
	{ city: 'Drumod (Leitrim)', zip: '335673' },
	{ city: 'Drumod (Monaghan)', zip: '768955' },
	{ city: 'Drumod Beg (Leitrim)', zip: '784032' },
	{ city: 'Drumod Glebe (Cavan)', zip: '681968' },
	{ city: 'Drumod More (Leitrim)', zip: '278393' },
	{ city: 'Drumoghill (Donegal)', zip: '262972' },
	{ city: 'Drumoghra (Cavan)', zip: '939572' },
	{ city: 'Drumoghty Beg (Leitrim)', zip: '472210' },
	{ city: 'Drumoghty More (Leitrim)', zip: '909652' },
	{ city: 'Drumohan (Cavan)', zip: '639710' },
	{ city: 'Drumone (Meath)', zip: '167413' },
	{ city: 'Drumoosclin (Cavan)', zip: '380248' },
	{ city: 'Drumoske (Donegal)', zip: '845626' },
	{ city: 'Drumoula (Leitrim)', zip: '135341' },
	{ city: 'Drumparsons (Leitrim)', zip: '188867' },
	{ city: 'Drumpeak (Cavan)', zip: '766806' },
	{ city: 'Drumquill (Cavan)', zip: '109626' },
	{ city: 'Drumquill (Monaghan)', zip: '214371' },
	{ city: 'Drumquin (Clare)', zip: '803908' },
	{ city: 'Drumrackan (Leitrim)', zip: '227268' },
	{ city: 'Drumraghool North (Leitrim)', zip: '705150' },
	{ city: 'Drumraghool South (Leitrim)', zip: '126067' },
	{ city: 'Drumrahan (Leitrim)', zip: '461031' },
	{ city: 'Drumraine (Sligo)', zip: '796315' },
	{ city: 'Drumraine Glebe (Leitrim)', zip: '417436' },
	{ city: 'Drumrainy (Donegal)', zip: '862556' },
	{ city: 'Drumrane (Cavan)', zip: '422937' },
	{ city: 'Drumrane (Leitrim)', zip: '868833' },
	{ city: 'Drumraney (Westmeath)', zip: '278958' },
	{ city: 'Drumrat (Cavan)', zip: '669135' },
	{ city: 'Drumrat (Donegal)', zip: '206700' },
	{ city: 'Drumrath (Cavan)', zip: '540046' },
	{ city: 'Drumreagh (Donegal)', zip: '419866' },
	{ city: 'Drumreagh (Mayo)', zip: '432660' },
	{ city: 'Drumreagh (Wicklow)', zip: '628519' },
	{ city: 'Drumreask (Leitrim)', zip: '821415' },
	{ city: 'Drumreask (Monaghan)', zip: '854088' },
	{ city: 'Drumree (Meath)', zip: '136649' },
	{ city: 'Drumreenagh (Monaghan)', zip: '883958' },
	{ city: 'Drumregan (Leitrim)', zip: '653422' },
	{ city: 'Drumreilly (Leitrim)', zip: '135990' },
	{ city: 'Drumrevagh (Mayo)', zip: '763649' },
	{ city: 'Drumrewy (Leitrim)', zip: '869820' },
	{ city: 'Drumristin (Leitrim)', zip: '516211' },
	{ city: 'Drumrockady (Cavan)', zip: '834281' },
	{ city: 'Drumroe (Cavan)', zip: '337473' },
	{ city: 'Drumroe (Donegal)', zip: '447618' },
	{ city: 'Drumroe (Laois)', zip: '473845' },
	{ city: 'Drumroe (Longford)', zip: '205963' },
	{ city: 'Drumroe (Offaly)', zip: '707092' },
	{ city: 'Drumroe (Tipperary)', zip: '250155' },
	{ city: 'Drumroe (Waterford)', zip: '518212' },
	{ city: 'Drumroe Lower (Waterford)', zip: '299636' },
	{ city: 'Drumroe Upper (Waterford)', zip: '405862' },
	{ city: 'Drumrolla (Sligo)', zip: '843366' },
	{ city: 'Drumrone (Donegal)', zip: '385994' },
	{ city: 'Drumrooghill (Cavan)', zip: '474595' },
	{ city: 'Drumrooghill (Monaghan)', zip: '433890' },
	{ city: 'Drumroosk (Cavan)', zip: '536489' },
	{ city: 'Drumroosk (Donegal)', zip: '490019' },
	{ city: 'Drumroosk (Monaghan)', zip: '980057' },
	{ city: 'Drumroosk East (Donegal)', zip: '678502' },
	{ city: 'Drumroosk Middle (Donegal)', zip: '266322' },
	{ city: 'Drumroosk North (Leitrim)', zip: '404461' },
	{ city: 'Drumroosk South (Leitrim)', zip: '618095' },
	{ city: 'Drumroosk West (Donegal)', zip: '537964' },
	{ city: 'Drumroragh (Cavan)', zip: '684273' },
	{ city: 'Drumrud (Mayo)', zip: '242701' },
	{ city: 'Drumruekill (Leitrim)', zip: '823815' },
	{ city: 'Drumrush (Cavan)', zip: '853849' },
	{ city: 'Drumrusk (Waterford)', zip: '984346' },
	{ city: 'Drumrutagh (Monaghan)', zip: '431622' },
	{ city: 'Drumryan (Cavan)', zip: '660424' },
	{ city: 'Drumsallagh (Cavan)', zip: '998316' },
	{ city: 'Drumsallagh (Clare)', zip: '365605' },
	{ city: 'Drumsallagh (Donegal)', zip: '474392' },
	{ city: 'Drumsaul (Monaghan)', zip: '717827' },
	{ city: 'Drumsawry (Meath)', zip: '623061' },
	{ city: 'Drumscar (Galway)', zip: '239455' },
	{ city: 'Drumscoba (Mayo)', zip: '256261' },
	{ city: 'Drumscor (Monaghan)', zip: '150279' },
	{ city: 'Drumscruddan (Cavan)', zip: '488531' },
	{ city: 'Drumshallon (Louth)', zip: '145554' },
	{ city: 'Drumshanbo (Leitrim)', zip: '226951' },
	{ city: 'Drumshanbo North (Leitrim)', zip: '820450' },
	{ city: 'Drumshanbo South (Leitrim)', zip: '189989' },
	{ city: 'Drumshangore (Leitrim)', zip: '502089' },
	{ city: 'Drumshannagh (Roscommon)', zip: '122724' },
	{ city: 'Drumshannon (Monaghan)', zip: '123510' },
	{ city: 'Drumshanny (Monaghan)', zip: '246763' },
	{ city: 'Drumshantony (Donegal)', zip: '548668' },
	{ city: 'Drumsheaver (Monaghan)', zip: '643575' },
	{ city: 'Drumsheel Lower (Mayo)', zip: '416411' },
	{ city: 'Drumsheel Upper (Mayo)', zip: '807325' },
	{ city: 'Drumsheen (Mayo)', zip: '713307' },
	{ city: 'Drumsheeny (Monaghan)', zip: '557554' },
	{ city: 'Drumsheil (Cavan)', zip: '598833' },
	{ city: 'Drumshinnagh (Mayo)', zip: '618165' },
	{ city: 'Drumshinnagh (Sligo)', zip: '554019' },
	{ city: 'Drumshinny (Cavan)', zip: '877082' },
	{ city: 'Drumsillagh (Cavan)', zip: '712464' },
	{ city: 'Drumsillagh (Clare)', zip: '285352' },
	{ city: 'Drumsillagh (Leitrim)', zip: '149952' },
	{ city: 'Drumsillagh (Meath)', zip: '239082' },
	{ city: 'Drumsillagh (Roscommon)', zip: '707167' },
	{ city: 'Drumsinnot (Louth)', zip: '956197' },
	{ city: 'Drumsivney (Cavan)', zip: '588593' },
	{ city: 'Drumskeagh (Cavan)', zip: '521286' },
	{ city: 'Drumskellan (Donegal)', zip: '359689' },
	{ city: 'Drumskelt (Cavan)', zip: '560877' },
	{ city: 'Drumskelt (Monaghan)', zip: '458001' },
	{ city: 'Drumskerry (Cavan)', zip: '464037' },
	{ city: 'Drumslavog (Monaghan)', zip: '973389' },
	{ city: 'Drumsleed (Mayo)', zip: '478830' },
	{ city: 'Drumslig (Waterford)', zip: '795698' },
	{ city: 'Drumsloe (Monaghan)', zip: '916380' },
	{ city: 'Drumsna (Leitrim)', zip: '564332' },
	{ city: 'Drumsnauv (Galway)', zip: '753073' },
	{ city: 'Drumsoghla (Sligo)', zip: '997250' },
	{ city: 'Drumsru (Kildare)', zip: '411603' },
	{ city: 'Drumstevlin (Donegal)', zip: '858744' },
	{ city: 'Drumswords (Monaghan)', zip: '343506' },
	{ city: 'Drumtarsna (Tipperary)', zip: '208730' },
	{ city: 'Drumturk (Monaghan)', zip: '817607' },
	{ city: 'Drumullan (Clare)', zip: '725435' },
	{ city: 'Drumummery (Monaghan)', zip: '298641' },
	{ city: 'Drumumna (Clare)', zip: '992873' },
	{ city: 'Drumurcher (Monaghan)', zip: '501545' },
	{ city: 'Drumure (Longford)', zip: '566183' },
	{ city: 'Drumury (Cavan)', zip: '196636' },
	{ city: 'Drumury (Longford)', zip: '196042' },
	{ city: 'Drum West (Galway)', zip: '519715' },
	{ city: 'Drum West (Sligo)', zip: '272235' },
	{ city: 'Drumwood (Tipperary)', zip: '475649' },
	{ city: 'Drumyouth (Cavan)', zip: '312681' },
	{ city: 'Drung (Cavan)', zip: '451573' },
	{ city: 'Drung (Donegal)', zip: '287635' },
	{ city: 'Drungan (Leitrim)', zip: '241786' },
	{ city: 'Drunganagh East (Mayo)', zip: '736178' },
	{ city: 'Drunganagh West (Mayo)', zip: '960956' },
	{ city: 'Drutamon (Cavan)', zip: '338130' },
	{ city: 'Drutamy (Cavan)', zip: '900492' },
	{ city: 'Dryderstown (Westmeath)', zip: '685939' },
	{ city: 'Duagh (Kerry)', zip: '517116' },
	{ city: 'Duagh (Waterford)', zip: '274994' },
	{ city: 'Dually (Tipperary)', zip: '702314' },
	{ city: 'Duarrigle (Cork)', zip: '781957' },
	{ city: 'Dubber (Dublin)', zip: '185372' },
	{ city: 'Dublin (Dublin)', zip: '662427' },
	{ city: 'Dublin 2 (Dublin)', zip: '599468' },
	{ city: 'Ducalla (Kerry)', zip: '768546' },
	{ city: 'Ducarrig (Waterford)', zip: '713259' },
	{ city: 'Ducavan (Louth)', zip: '310693' },
	{ city: 'Duckfield (Cavan)', zip: '790586' },
	{ city: 'Duck Island (Donegal)', zip: '877952' },
	{ city: 'Duck Rock (Galway)', zip: '772641' },
	{ city: 'Duckspool (Waterford)', zip: '817875' },
	{ city: 'Duckstown (Limerick)', zip: '962613' },
	{ city: 'Ducleagh (Cork)', zip: '589614' },
	{ city: 'Duffcarrick (Waterford)', zip: '456487' },
	{ city: 'Duffcarrick (Wexford)', zip: '735779' },
	{ city: 'Duffcastle (Cavan)', zip: '909106' },
	{ city: 'Duffery (Carlow)', zip: '361867' },
	{ city: 'Duffsfarm (Louth)', zip: '755884' },
	{ city: 'Duffsland (Meath)', zip: '576105' },
	{ city: 'Duffur Rock (Mayo)', zip: '765574' },
	{ city: 'Dughile And Coomavanniha (Kerry)', zip: '237482' },
	{ city: 'Dughlone (Wexford)', zip: '601442' },
	{ city: 'Duinch (Cork)', zip: '471573' },
	{ city: 'Dukesmeadows (Kilkenny)', zip: '203578' },
	{ city: 'Dulane (Meath)', zip: '327183' },
	{ city: 'Duleek (Meath)', zip: '181563' },
	{ city: 'Dulick (Clare)', zip: '917514' },
	{ city: 'Dunabrattin (Waterford)', zip: '919063' },
	{ city: 'Dunacapple Island (Kerry)', zip: '442983' },
	{ city: 'Dunacleggan (Laois)', zip: '645405' },
	{ city: 'Dunaff (Donegal)', zip: '876812' },
	{ city: 'Dunagard (Donegal)', zip: '497728' },
	{ city: 'Dunaldron (Monaghan)', zip: '249611' },
	{ city: 'Dunamon (Roscommon)', zip: '124362' },
	{ city: 'Dunamon (Westmeath)', zip: '594706' },
	{ city: 'Dunancory (Cavan)', zip: '175916' },
	{ city: 'Dunanny (Monaghan)', zip: '315512' },
	{ city: 'Dunanore (Wexford)', zip: '995365' },
	{ city: 'Dunany (Louth)', zip: '649798' },
	{ city: 'Dunard (Offaly)', zip: '699567' },
	{ city: 'Dunaree (Cavan)', zip: '364150' },
	{ city: 'Dunaree (Monaghan)', zip: '599100' },
	{ city: 'Dunaree Latin (Monaghan)', zip: '798478' },
	{ city: 'Dunavinally (Leitrim)', zip: '588557' },
	{ city: 'Dunaweel (Cavan)', zip: '802163' },
	{ city: 'Dunbarry (Cork)', zip: '680797' },
	{ city: 'Dunbeacon (Cork)', zip: '452375' },
	{ city: 'Dunbeggan (Longford)', zip: '413997' },
	{ city: 'Dunbell Big (Kilkenny)', zip: '767441' },
	{ city: 'Dunbell Little (Kilkenny)', zip: '765431' },
	{ city: 'Dunbin Big (Louth)', zip: '154318' },
	{ city: 'Dunbin Little (Louth)', zip: '565542' },
	{ city: 'Dunbittern East (Cork)', zip: '713795' },
	{ city: 'Dunbittern West (Cork)', zip: '372779' },
	{ city: 'Dunblaney (Galway)', zip: '462420' },
	{ city: 'Dunboden Demesne (Westmeath)', zip: '358070' },
	{ city: 'Dunbogey (Cork)', zip: '745056' },
	{ city: 'Dunboy (Cork)', zip: '322472' },
	{ city: 'Dunboyke (Wicklow)', zip: '386877' },
	{ city: 'Dunboyne (Meath)', zip: '188865' },
	{ city: 'Dunbrin Lower (Laois)', zip: '208253' },
	{ city: 'Dunbrin Upper (Laois)', zip: '293689' },
	{ city: 'Dunbro (Dublin)', zip: '328915' },
	{ city: 'Dunbrody (Wexford)', zip: '527805' },
	{ city: 'Dunbulloge (Cork)', zip: '414334' },
	{ city: 'Dunbur Head (Wicklow)', zip: '962870' },
	{ city: 'Dunbur Lower (Wicklow)', zip: '826775' },
	{ city: 'Dunbur Upper (Wicklow)', zip: '289852' },
	{ city: 'Dunbyrne (Kildare)', zip: '778204' },
	{ city: 'Duncannon (Wexford)', zip: '957244' },
	{ city: 'Duncansland (Meath)', zip: '669588' },
	{ city: 'Duncarbry (Leitrim)', zip: '439966' },
	{ city: 'Duncollog (Cavan)', zip: '151382' },
	{ city: 'Duncormick (Wexford)', zip: '493500' },
	{ city: 'Duncormick Hill (Wexford)', zip: '701229' },
	{ city: 'Duncreevan (Kildare)', zip: '518453' },
	{ city: 'Duncummin (Tipperary)', zip: '578431' },
	{ city: 'Dundalk (Louth)', zip: '822585' },
	{ city: 'Dundareirke (Cork)', zip: '263276' },
	{ city: 'Dundaryark (Kilkenny)', zip: '854988' },
	{ city: 'Dundavan (Cavan)', zip: '106433' },
	{ city: 'Dundeady (Cork)', zip: '896267' },
	{ city: 'Dundee (Donegal)', zip: '986286' },
	{ city: 'Dunderk (Meath)', zip: '378648' },
	{ city: 'Dundermot (Roscommon)', zip: '582952' },
	{ city: 'Dunderrow (Cork)', zip: '422557' },
	{ city: 'Dunderry (Meath)', zip: '105650' },
	{ city: 'Dundian (Monaghan)', zip: '846290' },
	{ city: 'Dundonagh (Monaghan)', zip: '457051' },
	{ city: 'Dundonnell (Roscommon)', zip: '488558' },
	{ city: 'Dundonnell (Westmeath)', zip: '842478' },
	{ city: 'Dundooan Lower (Donegal)', zip: '116922' },
	{ city: 'Dundooan Upper (Donegal)', zip: '334556' },
	{ city: 'Dundoogan (Galway)', zip: '598879' },
	{ city: 'Dundragon (Cavan)', zip: '430950' },
	{ city: 'Dundrannan (Monaghan)', zip: '113002' },
	{ city: 'Dundrean (Donegal)', zip: '230083' },
	{ city: 'Dundrockan (Monaghan)', zip: '871910' },
	{ city: 'Dundrudian (Donegal)', zip: '529220' },
	{ city: 'Dundrum (Dublin)', zip: '100073' },
	{ city: 'Dundrum (Tipperary)', zip: '438593' },
	{ city: 'Dundrum (Wexford)', zip: '482110' },
	{ city: 'Dundrumman (Monaghan)', zip: '613051' },
	{ city: 'Dunduffsfort (Donegal)', zip: '882444' },
	{ city: 'Dundullerick East (Cork)', zip: '145489' },
	{ city: 'Dundullerick West (Cork)', zip: '391108' },
	{ city: 'Duneany (Kildare)', zip: '992654' },
	{ city: 'Duneel (Westmeath)', zip: '603757' },
	{ city: 'Duneen (Cork)', zip: '633036' },
	{ city: 'Duneena (Cavan)', zip: '997871' },
	{ city: 'Dunegan (Westmeath)', zip: '567487' },
	{ city: 'Dunelty (Monaghan)', zip: '800572' },
	{ city: 'Dunfanaghy (Donegal)', zip: '166076' },
	{ city: 'Dunfelimy (Monaghan)', zip: '239024' },
	{ city: 'Dunferris (Kerry)', zip: '343444' },
	{ city: 'Dunfierth (Kildare)', zip: '602912' },
	{ city: 'Dung (Cavan)', zip: '865187' },
	{ city: 'Dungaghy (Westmeath)', zip: '880681' },
	{ city: 'Dungannon (Cork)', zip: '284940' },
	{ city: 'Dunganny (Meath)', zip: '682895' },
	{ city: 'Dunganstown (Dublin)', zip: '591666' },
	{ city: 'Dunganstown (Westmeath)', zip: '841982' },
	{ city: 'Dunganstown (Wexford)', zip: '348768' },
	{ city: 'Dunganstown East (Wicklow)', zip: '479202' },
	{ city: 'Dunganstown West (Wicklow)', zip: '612739' },
	{ city: 'Dunganville Lower (Limerick)', zip: '519882' },
	{ city: 'Dunganville Upper (Limerick)', zip: '972947' },
	{ city: 'Dungar (Offaly)', zip: '643816' },
	{ city: 'Dungar (Roscommon)', zip: '554921' },
	{ city: 'Dungarvan (Kilkenny)', zip: '365522' },
	{ city: 'Dungarvan (Waterford)', zip: '258900' },
	{ city: 'Dungarvan Glebe (Kilkenny)', zip: '753910' },
	{ city: 'Dungeagan (Kerry)', zip: '533347' },
	{ city: 'Dungeeha (Limerick)', zip: '464431' },
	{ city: 'Dungeel (Kerry)', zip: '322319' },
	{ city: 'Dungeer (Wexford)', zip: '894069' },
	{ city: 'Dungillick (Monaghan)', zip: '924074' },
	{ city: 'Dunglave (Cavan)', zip: '748457' },
	{ city: 'Dunglow (Donegal)', zip: '996447' },
	{ city: 'Dungolman (Westmeath)', zip: '707847' },
	{ city: 'Dungonnan (Cavan)', zip: '786575' },
	{ city: 'Dungonnan (Monaghan)', zip: '719889' },
	{ city: 'Dungooly (Kilkenny)', zip: '164417' },
	{ city: 'Dungooly (Louth)', zip: '749999' },
	{ city: 'Dungorman (Donegal)', zip: '427926' },
	{ city: 'Dungory East (Galway)', zip: '397696' },
	{ city: 'Dungory West (Galway)', zip: '594352' },
	{ city: 'Dungourney (Cork)', zip: '185586' },
	{ city: 'Dunguib (Tipperary)', zip: '822948' },
	{ city: 'Dungulph (Wexford)', zip: '559803' },
	{ city: 'Dungummin Lower (Cavan)', zip: '940469' },
	{ city: 'Dungummin Upper (Cavan)', zip: '366194' },
	{ city: 'Dunheeda (Meath)', zip: '865636' },
	{ city: 'Dunhill (Waterford)', zip: '200896' },
	{ city: 'Dunhill Lodge (Waterford)', zip: '543247' },
	{ city: 'Duninga (Kilkenny)', zip: '651717' },
	{ city: 'Duniry (Galway)', zip: '542989' },
	{ city: 'Dunishal (Wexford)', zip: '611672' },
	{ city: 'Dunisky (Cork)', zip: '396465' },
	{ city: 'Dunkellin (Galway)', zip: '822307' },
	{ city: 'Dunkelly East (Cork)', zip: '391252' },
	{ city: 'Dunkelly Middle (Cork)', zip: '651008' },
	{ city: 'Dunkelly West (Cork)', zip: '692554' },
	{ city: 'Dunkereen (Cork)', zip: '749607' },
	{ city: 'Dunkerrin (Offaly)', zip: '513623' },
	{ city: 'Dunkerron (Kerry)', zip: '224772' },
	{ city: 'Dunkettle (Cork)', zip: '823030' },
	{ city: 'Dunkineely (Donegal)', zip: '452544' },
	{ city: 'Dunkip (Limerick)', zip: '987397' },
	{ city: 'Dunkitt (Kilkenny)', zip: '208110' },
	{ city: 'Dunlavin (Wicklow)', zip: '789188' },
	{ city: 'Dunlavin Lower (Wicklow)', zip: '785474' },
	{ city: 'Dunlavin Upper (Wicklow)', zip: '553256' },
	{ city: 'Dunleary (Dublin)', zip: '114888' },
	{ city: 'Dunleckny (Carlow)', zip: '118209' },
	{ city: 'Dunleer (Louth)', zip: '683577' },
	{ city: 'Dunleever Glebe (Meath)', zip: '112330' },
	{ city: 'Dunlewy Far (Donegal)', zip: '367078' },
	{ city: 'Dunlewy Near (Donegal)', zip: '397979' },
	{ city: 'Dunlo (Galway)', zip: '313545' },
	{ city: 'Dunloe Lower (Kerry)', zip: '481389' },
	{ city: 'Dunloe Upper (Kerry)', zip: '872189' },
	{ city: 'Dunlom East (Westmeath)', zip: '661707' },
	{ city: 'Dunlom West (Westmeath)', zip: '339136' },
	{ city: 'Dunlough (Cork)', zip: '460045' },
	{ city: 'Dunlough (Meath)', zip: '855145' },
	{ city: 'Dunmadigan (Monaghan)', zip: '897986' },
	{ city: 'Dunmahon (Cork)', zip: '211189' },
	{ city: 'Dunmahon (Louth)', zip: '101976' },
	{ city: 'Dunmain (Wexford)', zip: '149534' },
	{ city: 'Dunmakeever (Cavan)', zip: '537061' },
	{ city: 'Dunmakenna (Monaghan)', zip: '801758' },
	{ city: 'Dunmaniheen (Kerry)', zip: '980303' },
	{ city: 'Dunmanoge (Kildare)', zip: '594057' },
	{ city: 'Dunmanus East (Cork)', zip: '135037' },
	{ city: 'Dunmanus West (Cork)', zip: '928702' },
	{ city: 'Dunmanway (Cork)', zip: '857108' },
	{ city: 'Dunmanway North (Cork)', zip: '568219' },
	{ city: 'Dunmanway South (Cork)', zip: '757810' },
	{ city: 'Dunmarklun (Cork)', zip: '552624' },
	{ city: 'Dunmaurice (Monaghan)', zip: '125672' },
	{ city: 'Dunmoe (Meath)', zip: '358305' },
	{ city: 'Dunmoon (Waterford)', zip: '853183' },
	{ city: 'Dunmoon North (Waterford)', zip: '819243' },
	{ city: 'Dunmoon South (Waterford)', zip: '378222' },
	{ city: 'Dunmoran (Sligo)', zip: '895540' },
	{ city: 'Dunmore (Cork)', zip: '484123' },
	{ city: 'Dunmore (Donegal)', zip: '786679' },
	{ city: 'Dunmore (Galway)', zip: '948293' },
	{ city: 'Dunmore (Kilkenny)', zip: '832183' },
	{ city: 'Dunmore (Laois)', zip: '580334' },
	{ city: 'Dunmore (Waterford)', zip: '767594' },
	{ city: 'Dunmore Demesne (Galway)', zip: '298494' },
	{ city: 'Dunmore East (Kilkenny)', zip: '394425' },
	{ city: 'Dunmore East (Waterford)', zip: '191906' },
	{ city: 'Dunmorepark (Kilkenny)', zip: '477113' },
	{ city: 'Dunmore West (Kilkenny)', zip: '262527' },
	{ city: 'Dunmoylan (Limerick)', zip: '603186' },
	{ city: 'Dunmuckrum (Donegal)', zip: '389669' },
	{ city: 'Dunmucky (Dublin)', zip: '893696' },
	{ city: 'Dunmurraghill (Kildare)', zip: '796092' },
	{ city: 'Dunmurraghoe (Roscommon)', zip: '261315' },
	{ city: 'Dunmurry (Cavan)', zip: '876371' },
	{ city: 'Dunmurry East (Kildare)', zip: '189114' },
	{ city: 'Dunmurry West (Kildare)', zip: '248305' },
	{ city: 'Dunnagorran (Meath)', zip: '663522' },
	{ city: 'Dunnaloob (Donegal)', zip: '227333' },
	{ city: 'Dunnaluck (Monaghan)', zip: '310566' },
	{ city: 'Dunnamaggan (Kilkenny)', zip: '162025' },
	{ city: 'Dunnamaggan East (Kilkenny)', zip: '738676' },
	{ city: 'Dunnamaggan West (Kilkenny)', zip: '410311' },
	{ city: 'Dunnaman (Limerick)', zip: '352723' },
	{ city: 'Dunnamark (Cork)', zip: '928049' },
	{ city: 'Dunnamark Mill-Lot (Cork)', zip: '651199' },
	{ city: 'Dunnamona (Westmeath)', zip: '157437' },
	{ city: 'Dunneill (Clare)', zip: '225583' },
	{ city: 'Dunneill (Sligo)', zip: '891356' },
	{ city: 'Dunningstown (Kilkenny)', zip: '675290' },
	{ city: 'Dunnstown (Kildare)', zip: '157550' },
	{ city: 'Dunnycove (Cork)', zip: '666408' },
	{ city: 'Dunoge (Monaghan)', zip: '615385' },
	{ city: 'Dunowen (Cork)', zip: '840967' },
	{ city: 'Dunowla (Sligo)', zip: '468880' },
	{ city: 'Dunquin (Kerry)', zip: '908116' },
	{ city: 'Dunran Demesne (Wicklow)', zip: '298066' },
	{ city: 'Dunranhill (Wicklow)', zip: '575988' },
	{ city: 'Dunraymond (Monaghan)', zip: '411725' },
	{ city: 'Dunreagh (Meath)', zip: '282472' },
	{ city: 'Dunree (Donegal)', zip: '860320' },
	{ city: 'Dunroe (Carlow)', zip: '538048' },
	{ city: 'Dunrora (Cavan)', zip: '118679' },
	{ city: 'Dunross (Donegal)', zip: '125761' },
	{ city: 'Dunsallagh (Waterford)', zip: '269267' },
	{ city: 'Dunsandle (Galway)', zip: '544164' },
	{ city: 'Dunsany (Meath)', zip: '763302' },
	{ city: 'Dunscullib (Cork)', zip: '869065' },
	{ city: 'Dunseark (Monaghan)', zip: '560726' },
	{ city: 'Dunsfort (Cork)', zip: '379432' },
	{ city: 'Dunshaughlin (Meath)', zip: '459143' },
	{ city: 'Dunsinane (Wexford)', zip: '816856' },
	{ city: 'Dunsinare (Monaghan)', zip: '888912' },
	{ city: 'Dunsink (Dublin)', zip: '637869' },
	{ city: 'Dunsoghly (Dublin)', zip: '504696' },
	{ city: 'Dunsrim (Monaghan)', zip: '177192' },
	{ city: 'Duntahane (Cork)', zip: '963354' },
	{ city: 'Duntinny (Donegal)', zip: '647476' },
	{ city: 'Duntryleague (Limerick)', zip: '697478' },
	{ city: 'Dunville (Offaly)', zip: '766113' },
	{ city: 'Dunwiley (Donegal)', zip: '791962' },
	{ city: 'Dunworly (Cork)', zip: '370126' },
	{ city: 'Durah (Cork)', zip: '237063' },
	{ city: 'Durha (Clare)', zip: '893236' },
	{ city: 'Durhamstown (Meath)', zip: '130850' },
	{ city: 'Durless (Mayo)', zip: '501660' },
	{ city: 'Durnesh (Donegal)', zip: '257806' },
	{ city: 'Durnish (Limerick)', zip: '981909' },
	{ city: 'Durra (Clare)', zip: '408719' },
	{ city: 'Durra Big (Wexford)', zip: '662056' },
	{ city: 'Durraclogh (Limerick)', zip: '660704' },
	{ city: 'Durra Little (Wexford)', zip: '579160' },
	{ city: 'Durrow (Galway)', zip: '626453' },
	{ city: 'Durrow (Laois)', zip: '236170' },
	{ city: 'Durrow (Waterford)', zip: '800321' },
	{ city: 'Durrow Demesne (Offaly)', zip: '132402' },
	{ city: 'Durrow Townparks (Laois)', zip: '980103' },
	{ city: 'Durrus (Cork)', zip: '268642' },
	{ city: 'Duryhole (Louth)', zip: '886930' },
	{ city: 'Duvillaun Beg (Mayo)', zip: '688476' },
	{ city: 'Duvillaun More (Mayo)', zip: '250145' },
	{ city: 'Dyan (Monaghan)', zip: '304426' },
	{ city: 'Dyrick (Waterford)', zip: '915989' },
	{ city: 'Dyrick Lower (Waterford)', zip: '887448' },
	{ city: 'Dyrick Upper (Waterford)', zip: '550338' },
	{ city: 'Dysart (Cork)', zip: '464616' },
	{ city: 'Dysart (Kildare)', zip: '933832' },
	{ city: 'Dysart (Kilkenny)', zip: '433400' },
	{ city: 'Dysart (Laois)', zip: '256555' },
	{ city: 'Dysart (Louth)', zip: '262570' },
	{ city: 'Dysart (Westmeath)', zip: '122821' },
	{ city: 'Dysartbeagh (Laois)', zip: '428864' },
	{ city: 'Dysart Glebe (Kilkenny)', zip: '298624' },
	{ city: 'Dysert (Clare)', zip: '664430' },
	{ city: 'Dysert (Cork)', zip: '401045' },
	{ city: 'Dysert (Kerry)', zip: '987245' },
	{ city: 'Dysert (Limerick)', zip: '649246' },
	{ city: 'Dysert (Roscommon)', zip: '165168' },
	{ city: 'Dysert (Waterford)', zip: '108673' },
	{ city: 'Dysert Marshes (Kerry)', zip: '282523' },
	{ city: 'Eadestown (Kildare)', zip: '469928' },
	{ city: 'Eadestown Hill (Wicklow)', zip: '207376' },
	{ city: 'Eadestown Middle (Wicklow)', zip: '460826' },
	{ city: 'Eadestown North (Wicklow)', zip: '588695' },
	{ city: 'Eadestown South (Wicklow)', zip: '914291' },
	{ city: 'Eaglehill (Carlow)', zip: '221185' },
	{ city: 'Eaglehill (Cavan)', zip: '510545' },
	{ city: 'Eaglehill (Galway)', zip: '968473' },
	{ city: 'Eaglehill (Kildare)', zip: '927410' },
	{ city: 'Eaglehill (Waterford)', zip: '165801' },
	{ city: 'Eagle Island (Mayo)', zip: '731637' },
	{ city: 'Eagle Rock (Galway)', zip: '455567' },
	{ city: 'Eagleshill (Kilkenny)', zip: '849515' },
	{ city: 'Eantybeg North (Clare)', zip: '412147' },
	{ city: 'Eantybeg South (Clare)', zip: '530037' },
	{ city: 'Eanty More (Clare)', zip: '579360' },
	{ city: 'Eardownes Great (Wexford)', zip: '258748' },
	{ city: 'Eardownes Little (Wexford)', zip: '298826' },
	{ city: 'Earlhill (Clare)', zip: '726521' },
	{ city: 'Earlsbog (Kilkenny)', zip: '115802' },
	{ city: 'Earlsbog Commons (Kilkenny)', zip: '897940' },
	{ city: 'Earlscartron (Offaly)', zip: '788543' },
	{ city: 'Earlsfields (Cork)', zip: '402771' },
	{ city: 'Earlsgarden (Kilkenny)', zip: '418690' },
	{ city: 'Earlsgrove (Kilkenny)', zip: '211452' },
	{ city: 'Earlshill (Tipperary)', zip: '673033' },
	{ city: 'Earls Island (Galway)', zip: '484913' },
	{ city: 'Earlsland (Kilkenny)', zip: '820667' },
	{ city: 'Earlspark (Galway)', zip: '139058' },
	{ city: 'Earlsquarter (Kilkenny)', zip: '565793' },
	{ city: 'Earls Quarter (Louth)', zip: '173410' },
	{ city: 'Earlsrath (Kilkenny)', zip: '969094' },
	{ city: 'Easky (Sligo)', zip: '891077' },
	{ city: 'East Barrs (Leitrim)', zip: '181230' },
	{ city: 'Easterfield (Galway)', zip: '627357' },
	{ city: 'Easthill (Wicklow)', zip: '309457' },
	{ city: 'Eastlone (Tipperary)', zip: '979673' },
	{ city: 'Easton (Kildare)', zip: '785540' },
	{ city: 'Eastwell (Galway)', zip: '802469' },
	{ city: 'Eastwood (Tipperary)', zip: '461564' },
	{ city: 'Ecawn (Wicklow)', zip: '170003' },
	{ city: 'Ecclestown (Wexford)', zip: '372882' },
	{ city: 'Eddrim Glebe (Donegal)', zip: '557318' },
	{ city: 'Eden (Donegal)', zip: '358771' },
	{ city: 'Eden (Leitrim)', zip: '404723' },
	{ city: 'Eden (Mayo)', zip: '583411' },
	{ city: 'Eden (Meath)', zip: '519126' },
	{ city: 'Eden (Roscommon)', zip: '485449' },
	{ city: 'Edenacarnan North (Donegal)', zip: '661883' },
	{ city: 'Edenacarnan South (Donegal)', zip: '390604' },
	{ city: 'Edenaferkin (Monaghan)', zip: '662858' },
	{ city: 'Edenaforan (Monaghan)', zip: '828142' },
	{ city: 'Edenagoash (Monaghan)', zip: '860325' },
	{ city: 'Edenagor (Donegal)', zip: '871597' },
	{ city: 'Edenagrena (Louth)', zip: '681274' },
	{ city: 'Edenakill (Louth)', zip: '919686' },
	{ city: 'Edenamo (Monaghan)', zip: '907471' },
	{ city: 'Edenamoghil (Donegal)', zip: '438469' },
	{ city: 'Edenamuck (Donegal)', zip: '908108' },
	{ city: 'Edenan (Roscommon)', zip: '842051' },
	{ city: 'Edenan And Kinclare (Roscommon)', zip: '862548' },
	{ city: 'Edenanay (Monaghan)', zip: '580358' },
	{ city: 'Edenaneane (Monaghan)', zip: '528942' },
	{ city: 'Edenaquin (Louth)', zip: '286852' },
	{ city: 'Edenavow (Leitrim)', zip: '101978' },
	{ city: 'Edenbaun (Leitrim)', zip: '546306' },
	{ city: 'Edenbaun (Sligo)', zip: '694894' },
	{ city: 'Edenbrone (Monaghan)', zip: '342501' },
	{ city: 'Edenburt (Cavan)', zip: '841339' },
	{ city: 'Edencullentragh (Sligo)', zip: '778435' },
	{ city: 'Edencurra (Cork)', zip: '397553' },
	{ city: 'Edenderry (Offaly)', zip: '917549' },
	{ city: 'Edenfinfreagh (Donegal)', zip: '635138' },
	{ city: 'Edenforan (Monaghan)', zip: '607906' },
	{ city: 'Edengilrevy (Monaghan)', zip: '322218' },
	{ city: 'Edengora (Meath)', zip: '577759' },
	{ city: 'Edenhill (Galway)', zip: '117812' },
	{ city: 'Eden Island (Monaghan)', zip: '812311' },
	{ city: 'Edenmore (Cavan)', zip: '294014' },
	{ city: 'Edenmore (Donegal)', zip: '213861' },
	{ city: 'Edenmore (Dublin)', zip: '841219' },
	{ city: 'Edenmore (Leitrim)', zip: '725765' },
	{ city: 'Edenmore (Longford)', zip: '600629' },
	{ city: 'Edenmore (Monaghan)', zip: '511112' },
	{ city: 'Edenmore (Tipperary)', zip: '933724' },
	{ city: 'Edennagully (Cavan)', zip: '226572' },
	{ city: 'Edenreagh (Sligo)', zip: '601756' },
	{ city: 'Edenterriff (Cavan)', zip: '967321' },
	{ city: 'Edenticlare (Cavan)', zip: '372360' },
	{ city: 'Edentober (Louth)', zip: '310145' },
	{ city: 'Edenvale (Clare)', zip: '245163' },
	{ city: 'Edenvella (Leitrim)', zip: '931392' },
	{ city: 'Edera (Longford)', zip: '541385' },
	{ city: 'Edercloon (Longford)', zip: '418119' },
	{ city: 'Ederglen (Mayo)', zip: '187785' },
	{ city: 'Edergole (Cavan)', zip: '603999' },
	{ city: 'Edergole (Donegal)', zip: '267509' },
	{ city: 'Edergole (Leitrim)', zip: '804947' },
	{ city: 'Edergole (Monaghan)', zip: '294281' },
	{ city: 'Ederland (Longford)', zip: '477550' },
	{ city: 'Edermin (Cavan)', zip: '480047' },
	{ city: 'Edermine (Wexford)', zip: '225762' },
	{ city: 'Edernish (Donegal)', zip: '407005' },
	{ city: 'Edernishfree (Donegal)', zip: '466586' },
	{ city: 'Edgeworthstown (Longford)', zip: '680371' },
	{ city: 'Edmondstown (Dublin)', zip: '948633' },
	{ city: 'Edmondstown (Louth)', zip: '633002' },
	{ city: 'Edmondstown (Roscommon)', zip: '444135' },
	{ city: 'Edmondstown (Westmeath)', zip: '123363' },
	{ city: 'Edmondstown (Wicklow)', zip: '230276' },
	{ city: 'Edmonstown (Westmeath)', zip: '668964' },
	{ city: 'Edoxtown (Meath)', zip: '290281' },
	{ city: 'Edrans (Cavan)', zip: '713703' },
	{ city: 'Edwardstown (Limerick)', zip: '713630' },
	{ city: 'Edwardstown (Wexford)', zip: '697931' },
	{ city: 'Effelstown (Dublin)', zip: '116188' },
	{ city: 'Effernagh (Monaghan)', zip: '741255' },
	{ city: 'Effernan (Clare)', zip: '197289' },
	{ city: 'Effernoge (Wexford)', zip: '110382' },
	{ city: 'Effin (Limerick)', zip: '214395' },
	{ city: 'Effrinagh (Leitrim)', zip: '158782' },
	{ city: 'Egglybane (Donegal)', zip: '278927' },
	{ city: 'Eglish (Donegal)', zip: '496841' },
	{ city: 'Eglish (Galway)', zip: '357262' },
	{ city: 'Eglish (Laois)', zip: '711093' },
	{ city: 'Eglish (Offaly)', zip: '813555' },
	{ city: 'Egmont (Cork)', zip: '141404' },
	{ city: 'Egramush (Cavan)', zip: '113649' },
	{ city: 'Eighter (Cavan)', zip: '799694' },
	{ city: 'Eighterard (Galway)', zip: '207118' },
	{ city: 'Eightercua (Kerry)', zip: '731140' },
	{ city: 'Eighter Island (Donegal)', zip: '710833' },
	{ city: 'Eighterross (Donegal)', zip: '131601' },
	{ city: 'Eightyeight Acres (Meath)', zip: '569978' },
	{ city: 'Einagh (Clare)', zip: '853886' },
	{ city: 'Eirk (Kerry)', zip: '344320' },
	{ city: 'Elaghbeg (Donegal)', zip: '695006' },
	{ city: 'Elderfield (Laois)', zip: '385375' },
	{ city: 'Eldron (Monaghan)', zip: '688212' },
	{ city: 'Elevenacre (Wexford)', zip: '893383' },
	{ city: 'Eleven Ballyboes (Donegal)', zip: '683886' },
	{ city: 'Elfeet (Longford)', zip: '359143' },
	{ city: 'Elfordstown (Cork)', zip: '420084' },
	{ city: 'Elgarstown (Meath)', zip: '100397' },
	{ city: 'Ellagh (Galway)', zip: '729942' },
	{ city: 'Ellagh Beg (Mayo)', zip: '138182' },
	{ city: 'Ellagh More (Mayo)', zip: '544016' },
	{ city: 'Ellaghs (Mayo)', zip: '809809' },
	{ city: 'Ellaha (Limerick)', zip: '100904' },
	{ city: 'Ellenstown (Westmeath)', zip: '574610' },
	{ city: 'Ellickstown (Meath)', zip: '788311' },
	{ city: 'Ellinure (Monaghan)', zip: '598035' },
	{ city: 'Ellistown (Dublin)', zip: '976435' },
	{ city: 'Ellistown (Kildare)', zip: '988728' },
	{ city: 'Ellistrin Big (Donegal)', zip: '168819' },
	{ city: 'Ellistrin Little (Donegal)', zip: '659019' },
	{ city: 'Ellistronbeg (Mayo)', zip: '956534' },
	{ city: 'Ellistronparks (Mayo)', zip: '584164' },
	{ city: 'Elly (Donegal)', zip: '284552' },
	{ city: 'Elly (Mayo)', zip: '950594' },
	{ city: 'Elmhall (Kildare)', zip: '723816' },
	{ city: 'Elmhall (Mayo)', zip: '609862' },
	{ city: 'Elmhill (Clare)', zip: '150001' },
	{ city: 'Elmhill (Galway)', zip: '298706' },
	{ city: 'Elmhill (Tipperary)', zip: '372439' },
	{ city: 'Elmpark Demesne (Limerick)', zip: '429680' },
	{ city: 'Elmvale (Clare)', zip: '157659' },
	{ city: 'Elone (Kildare)', zip: '809007' },
	{ city: 'Elphin (Roscommon)', zip: '490569' },
	{ city: 'Elteen (Cavan)', zip: '671772' },
	{ city: 'Elton (Limerick)', zip: '984665' },
	{ city: 'Elverstown Great (Kildare)', zip: '902002' },
	{ city: 'Elverstown Little (Kildare)', zip: '760327' },
	{ city: 'Elvey (Monaghan)', zip: '628365' },
	{ city: 'Eminiska (Tipperary)', zip: '277662' },
	{ city: 'Emlagh (Clare)', zip: '145445' },
	{ city: 'Emlagh (Galway)', zip: '364405' },
	{ city: 'Emlagh (Kerry)', zip: '802763' },
	{ city: 'Emlagh (Louth)', zip: '903029' },
	{ city: 'Emlagh (Mayo)', zip: '718122' },
	{ city: 'Emlagh (Meath)', zip: '398075' },
	{ city: 'Emlagh (Roscommon)', zip: '962150' },
	{ city: 'Emlagh (Sligo)', zip: '743141' },
	{ city: 'Emlagh (Tipperary)', zip: '761867' },
	{ city: 'Emlagharan (Galway)', zip: '896866' },
	{ city: 'Emlagh Beg (Roscommon)', zip: '896457' },
	{ city: 'Emlaghdauroe (Galway)', zip: '594017' },
	{ city: 'Emlaghdreenagh (Kerry)', zip: '404624' },
	{ city: 'Emlagh East (Kerry)', zip: '289424' },
	{ city: 'Emlagher (Kildare)', zip: '256064' },
	{ city: 'Emlaghfad (Sligo)', zip: '440134' },
	{ city: 'Emlaghgissan (Sligo)', zip: '614191' },
	{ city: 'Emlaghglasny (Roscommon)', zip: '615624' },
	{ city: 'Emlaghkeadew (Roscommon)', zip: '722341' },
	{ city: 'Emlaghlea (Kerry)', zip: '863604' },
	{ city: 'Emlaghmore (Galway)', zip: '635362' },
	{ city: 'Emlaghmore (Kerry)', zip: '331961' },
	{ city: 'Emlagh More (Roscommon)', zip: '110035' },
	{ city: 'Emlaghmore East (Kerry)', zip: '998287' },
	{ city: 'Emlaghmore West (Kerry)', zip: '774987' },
	{ city: 'Emlaghnaghtan (Sligo)', zip: '209354' },
	{ city: 'Emlaghnagree (Roscommon)', zip: '387795' },
	{ city: 'Emlaghnamuck (Kerry)', zip: '436859' },
	{ city: 'Emlaghpeastia (Kerry)', zip: '314839' },
	{ city: 'Emlaghreagh (Kerry)', zip: '632859' },
	{ city: 'Emlaghslat (Kerry)', zip: '268005' },
	{ city: 'Emlagh West (Kerry)', zip: '942001' },
	{ city: 'Emlaghyroyin (Roscommon)', zip: '306475' },
	{ city: 'Emlicon (Carlow)', zip: '351572' },
	{ city: 'Emly (Tipperary)', zip: '276726' },
	{ city: 'Emlybeg (Mayo)', zip: '194983' },
	{ city: 'Emlybeg North (Mayo)', zip: '326595' },
	{ city: 'Emlybeg South (Mayo)', zip: '853454' },
	{ city: 'Emlycass (Mayo)', zip: '138236' },
	{ city: 'Emlymoran (Sligo)', zip: '171878' },
	{ city: 'Emmel (Offaly)', zip: '985005' },
	{ city: 'Emmel East (Offaly)', zip: '722494' },
	{ city: 'Emmel West (Offaly)', zip: '329011' },
	{ city: 'Emmoo (Roscommon)', zip: '675750' },
	{ city: 'Emo (Laois)', zip: '912876' },
	{ city: 'Emo Park (Laois)', zip: '502590' },
	{ city: 'Emper (Westmeath)', zip: '767433' },
	{ city: 'Emy (Monaghan)', zip: '638868' },
	{ city: 'Emyvale (Monaghan)', zip: '912576' },
	{ city: 'Enagh (Cavan)', zip: '243250' },
	{ city: 'Enagh (Monaghan)', zip: '281457' },
	{ city: 'Enagh (Roscommon)', zip: '358905' },
	{ city: 'Enaghan (Longford)', zip: '460198' },
	{ city: 'Enaghan (Offaly)', zip: '540460' },
	{ city: 'Enagh Beg (Mayo)', zip: '205301' },
	{ city: 'Enagh East (Clare)', zip: '166992' },
	{ city: 'Enaghgare (Limerick)', zip: '726250' },
	{ city: 'Enagh More (Mayo)', zip: '401716' },
	{ city: 'Enagh North (Clare)', zip: '301340' },
	{ city: 'Enaghoughter East (Cork)', zip: '530589' },
	{ city: 'Enaghoughter West (Cork)', zip: '202939' },
	{ city: 'Enaghroe (Limerick)', zip: '396565' },
	{ city: 'Enagh West (Clare)', zip: '614480' },
	{ city: 'Endrim (Offaly)', zip: '953178' },
	{ city: 'Enfield (Roscommon)', zip: '443499' },
	{ city: 'Englishgarden (Cork)', zip: '506945' },
	{ city: 'Englishisland (Cork)', zip: '244532' },
	{ city: 'Englishtenements (Limerick)', zip: '714973' },
	{ city: 'Englishtown (Galway)', zip: '569329' },
	{ city: 'Englishtown (Tipperary)', zip: '684777' },
	{ city: 'Englishtown (Waterford)', zip: '669498' },
	{ city: 'Englishtown (Wicklow)', zip: '257038' },
	{ city: 'Ennereilly (Wicklow)', zip: '359189' },
	{ city: 'Ennis (Clare)', zip: '474707' },
	{ city: 'Ennis (Monaghan)', zip: '455669' },
	{ city: 'Ennisboyne (Wicklow)', zip: '319531' },
	{ city: 'Enniscoffey (Westmeath)', zip: '174195' },
	{ city: 'Enniscorthy (Wexford)', zip: '657695' },
	{ city: 'Enniscoush (Limerick)', zip: '991530' },
	{ city: 'Enniskean (Cork)', zip: '771933' },
	{ city: 'Enniskeen (Cavan)', zip: '849963' },
	{ city: 'Enniskerry (Wicklow)', zip: '764996' },
	{ city: 'Ennismore (Kerry)', zip: '369573' },
	{ city: 'Ennisnag (Kilkenny)', zip: '406731' },
	{ city: 'Ennistimon (Clare)', zip: '422856' },
	{ city: 'Ennistown (Meath)', zip: '928261' },
	{ city: 'Enybegs (Longford)', zip: '509216' },
	{ city: 'Eonish (Cavan)', zip: '728805' },
	{ city: 'Eragh Island South (Galway)', zip: '144368' },
	{ city: 'Erenagh (Roscommon)', zip: '639542' },
	{ city: 'Erinagh (Tipperary)', zip: '651048' },
	{ city: 'Erinagh Beg (Clare)', zip: '310588' },
	{ city: 'Erinagh More (Clare)', zip: '452232' },
	{ city: 'Erneen (Kerry)', zip: '510973' },
	{ city: 'Erra (Roscommon)', zip: '308995' },
	{ city: 'Erraran (Cavan)', zip: '398529' },
	{ city: 'Errarooey Beg (Donegal)', zip: '612407' },
	{ city: 'Errarooey More (Donegal)', zip: '203549' },
	{ city: 'Errew (Leitrim)', zip: '551551' },
	{ city: 'Errew (Mayo)', zip: '775280' },
	{ city: 'Erriblagh (Roscommon)', zip: '652672' },
	{ city: 'Erribul (Clare)', zip: '161276' },
	{ city: 'Errick Beg (Roscommon)', zip: '211586' },
	{ city: 'Errick More (Roscommon)', zip: '968677' },
	{ city: 'Erriff (Leitrim)', zip: '595010' },
	{ city: 'Erriff (Mayo)', zip: '160761' },
	{ city: 'Errigal (Cavan)', zip: '671538' },
	{ city: 'Errill (Laois)', zip: '872939' },
	{ city: 'Errina (Clare)', zip: '552974' },
	{ city: 'Errinagh (Clare)', zip: '722972' },
	{ city: 'Errironagh (Roscommon)', zip: '511480' },
	{ city: 'Erris (Laois)', zip: '484604' },
	{ city: 'Erris (Roscommon)', zip: '372972' },
	{ city: 'Errisbeg East (Galway)', zip: '141599' },
	{ city: 'Errisbeg West (Galway)', zip: '514816' },
	{ city: 'Errit (Roscommon)', zip: '479825' },
	{ city: 'Errity (Donegal)', zip: '128126' },
	{ city: 'Errity Churchland (Donegal)', zip: '154267' },
	{ city: 'Erry (Offaly)', zip: '252625' },
	{ city: 'Erry (Tipperary)', zip: '306908' },
	{ city: 'Errybane (Monaghan)', zip: '487853' },
	{ city: 'Erryroe (Monaghan)', zip: '522324' },
	{ city: 'Ervallagh (Galway)', zip: '859069' },
	{ city: 'Ervallagh Eighter (Galway)', zip: '417663' },
	{ city: 'Ervallagh Oughter (Galway)', zip: '918524' },
	{ city: 'Ervey (Meath)', zip: '413284' },
	{ city: 'Eshacrin (Monaghan)', zip: '899840' },
	{ city: 'Eshcloghfin (Monaghan)', zip: '135372' },
	{ city: 'Eshnaglogh (Monaghan)', zip: '594313' },
	{ city: 'Eshveagh (Cavan)', zip: '575525' },
	{ city: 'Esk (Kerry)', zip: '215317' },
	{ city: 'Eskadawer (Kerry)', zip: '980957' },
	{ city: 'Eskaheen (Donegal)', zip: '364495' },
	{ city: 'Esk East (Kerry)', zip: '997838' },
	{ city: 'Eskenacartan (Cork)', zip: '250251' },
	{ city: 'Esker (Galway)', zip: '123701' },
	{ city: 'Esker (Kilkenny)', zip: '433188' },
	{ city: 'Esker (Laois)', zip: '422412' },
	{ city: 'Esker (Leitrim)', zip: '356888' },
	{ city: 'Esker (Longford)', zip: '446995' },
	{ city: 'Esker (Mayo)', zip: '879341' },
	{ city: 'Esker (Monaghan)', zip: '931041' },
	{ city: 'Esker (Offaly)', zip: '955142' },
	{ city: 'Esker (Roscommon)', zip: '190009' },
	{ city: 'Esker (Tipperary)', zip: '300560' },
	{ city: 'Eskeragh (Mayo)', zip: '563926' },
	{ city: 'Eskerballycahill (Galway)', zip: '205184' },
	{ city: 'Eskerbaun (Roscommon)', zip: '631597' },
	{ city: 'Eskerbeg (Roscommon)', zip: '844029' },
	{ city: 'Esker Beg (Offaly)', zip: '373625' },
	{ city: 'Eskerboy (Galway)', zip: '972727' },
	{ city: 'Esker East (Mayo)', zip: '719821' },
	{ city: 'Eskerhill (Kildare)', zip: '759983' },
	{ city: 'Eskerkeel (Galway)', zip: '614839' },
	{ city: 'Eskerlevally (Mayo)', zip: '834247' },
	{ city: 'Eskermore (Galway)', zip: '709644' },
	{ city: 'Esker More (Offaly)', zip: '700837' },
	{ city: 'Eskermurry (Galway)', zip: '256580' },
	{ city: 'Esker North (Dublin)', zip: '925913' },
	{ city: 'Esker North (Leitrim)', zip: '260896' },
	{ city: 'Esker North (Longford)', zip: '740875' },
	{ city: 'Esker North (Mayo)', zip: '206906' },
	{ city: 'Eskeromullacaun (Galway)', zip: '161458' },
	{ city: 'Eskerroe (Galway)', zip: '853557' },
	{ city: 'Eskershanore (Galway)', zip: '673372' },
	{ city: 'Esker South (Dublin)', zip: '144538' },
	{ city: 'Esker South (Leitrim)', zip: '562698' },
	{ city: 'Esker South (Longford)', zip: '567733' },
	{ city: 'Esker South (Mayo)', zip: '668162' },
	{ city: 'Eskerymorilly (Mayo)', zip: '489581' },
	{ city: 'Eskine (Kerry)', zip: '803763' },
	{ city: 'Esknamucky (Cork)', zip: '631835' },
	{ city: 'Esk North (Cork)', zip: '914258' },
	{ city: 'Eskragh (Sligo)', zip: '439208' },
	{ city: 'Eskraha (Cork)', zip: '739211' },
	{ city: 'Esk South (Cork)', zip: '940781' },
	{ city: 'Eskwacruttia (Kerry)', zip: '758442' },
	{ city: 'Esk West (Kerry)', zip: '728094' },
	{ city: 'Eslinbridge (Leitrim)', zip: '189817' },
	{ city: 'Essaun (Mayo)', zip: '811407' },
	{ city: 'Essexford (Louth)', zip: '746739' },
	{ city: 'Estersnow (Roscommon)', zip: '282736' },
	{ city: 'Ethelstown (Meath)', zip: '639239' },
	{ city: 'Euglaune (Cork)', zip: '717694' },
	{ city: 'Eustaceland (Tipperary)', zip: '808120' },
	{ city: 'Evegallahoo (Limerick)', zip: '808819' },
	{ city: 'Everardsgrange (Tipperary)', zip: '256201' },
	{ city: 'Everlaun (Sligo)', zip: '223489' },
	{ city: 'Evikeens (Roscommon)', zip: '918766' },
	{ city: 'Evishbreedy (Donegal)', zip: '584498' },
	{ city: 'Evlagh Beg (Cavan)', zip: '554681' },
	{ city: 'Evlagh More (Cavan)', zip: '975583' },
	{ city: 'Evneenmore Island (Galway)', zip: '716092' },
	{ city: 'Eyeries (Cork)', zip: '984318' },
	{ city: 'Eyne (Laois)', zip: '549829' },
	{ city: 'Eyon (Limerick)', zip: '936664' },
	{ city: 'Eyrecourt (Galway)', zip: '160867' },
	{ city: 'Eyrecourt Demesne (Galway)', zip: '338312' },
	{ city: 'Eyrehill (Clare)', zip: '657064' },
	{ city: 'Eyrephort (Galway)', zip: '347289' },
	{ city: 'Faartan (Galway)', zip: '374350' },
	{ city: 'Facefield (Mayo)', zip: '614848' },
	{ city: 'Faddan Beg (Offaly)', zip: '971908' },
	{ city: 'Faddan Beg (Tipperary)', zip: '650901' },
	{ city: 'Faddan More (Offaly)', zip: '551352' },
	{ city: 'Faddan More (Tipperary)', zip: '529382' },
	{ city: 'Fadduaga (Waterford)', zip: '387750' },
	{ city: 'Faganstown (Meath)', zip: '542508' },
	{ city: 'Faghbane (Kerry)', zip: '924125' },
	{ city: 'Faghcullia (Kerry)', zip: '187978' },
	{ city: 'Faghey (Longford)', zip: '856353' },
	{ city: 'Faha (Cork)', zip: '515468' },
	{ city: 'Faha (Kerry)', zip: '778892' },
	{ city: 'Faha (Limerick)', zip: '154670' },
	{ city: 'Faha (Tipperary)', zip: '169939' },
	{ city: 'Faha (Waterford)', zip: '531493' },
	{ city: 'Faha Demesne (Limerick)', zip: '122575' },
	{ city: 'Fahaduff (Kerry)', zip: '453909' },
	{ city: 'Faha East (Cork)', zip: '113530' },
	{ city: 'Faha East (Kerry)', zip: '348632' },
	{ city: 'Fahafeelagh (Waterford)', zip: '442890' },
	{ city: 'Fahalea (Cork)', zip: '135866' },
	{ city: 'Fahamore (Kerry)', zip: '957590' },
	{ city: 'Fahan (Donegal)', zip: '866472' },
	{ city: 'Fahan (Kerry)', zip: '893303' },
	{ city: 'Fahanalooscane (Cork)', zip: '753811' },
	{ city: 'Fahanasoodry (Limerick)', zip: '113724' },
	{ city: 'Fahane (Cork)', zip: '787607' },
	{ city: 'Fahanlunaghta Beg (Clare)', zip: '623060' },
	{ city: 'Fahanlunaghtamore (Clare)', zip: '660178' },
	{ city: 'Faharlagh (Cavan)', zip: '913071' },
	{ city: 'Fahavane (Kerry)', zip: '525731' },
	{ city: 'Faha West (Cork)', zip: '171793' },
	{ city: 'Faha West (Kerry)', zip: '986085' },
	{ city: 'Fahburren (Mayo)', zip: '201165' },
	{ city: 'Fahee North (Clare)', zip: '831678' },
	{ city: 'Faheens (Mayo)', zip: '996271' },
	{ city: 'Faheeran (Offaly)', zip: '367437' },
	{ city: 'Fahee South (Clare)', zip: '122723' },
	{ city: 'Faherlaghroe (Clare)', zip: '818482' },
	{ city: 'Fahouragh (Cork)', zip: '586428' },
	{ city: 'Fahy (Clare)', zip: '551749' },
	{ city: 'Fahy (Galway)', zip: '415837' },
	{ city: 'Fahy (Kilkenny)', zip: '788339' },
	{ city: 'Fahy (Leitrim)', zip: '587402' },
	{ city: 'Fahy (Mayo)', zip: '135761' },
	{ city: 'Fahy (Offaly)', zip: '630507' },
	{ city: 'Fahybeg (Mayo)', zip: '237590' },
	{ city: 'Fahy Beg (Clare)', zip: '514676' },
	{ city: 'Fahy Beg (Mayo)', zip: '300374' },
	{ city: 'Fahydorgan (Cork)', zip: '606761' },
	{ city: 'Fahykeen (Donegal)', zip: '414733' },
	{ city: 'Fahymactibbot (Galway)', zip: '804971' },
	{ city: 'Fahymore (Leitrim)', zip: '529782' },
	{ city: 'Fahy More (Mayo)', zip: '929074' },
	{ city: 'Fahy More North (Clare)', zip: '396407' },
	{ city: 'Fahy More South (Clare)', zip: '493363' },
	{ city: 'Fahysvillage (Galway)', zip: '259026' },
	{ city: 'Faiafannan (Donegal)', zip: '242357' },
	{ city: 'Fairfield (Galway)', zip: '145344' },
	{ city: 'Fairfield (Offaly)', zip: '772840' },
	{ city: 'Fairfield (Westmeath)', zip: '569454' },
	{ city: 'Fairfield (Wexford)', zip: '373080' },
	{ city: 'Fairfield Demesne (Monaghan)', zip: '579473' },
	{ city: 'Fairfield Lower (Mayo)', zip: '556543' },
	{ city: 'Fairfield Upper (Mayo)', zip: '276001' },
	{ city: 'Fairhill (Clare)', zip: '198191' },
	{ city: 'Fairhill (Galway)', zip: '690880' },
	{ city: 'Fairhill (Louth)', zip: '978453' },
	{ city: 'Fairhill (Mayo)', zip: '701988' },
	{ city: 'Fairlane (Waterford)', zip: '873246' },
	{ city: 'Fairtahy (Monaghan)', zip: '354828' },
	{ city: 'Fairview (Dublin)', zip: '874905' },
	{ city: 'Fairyfield Glebe (Limerick)', zip: '669718' },
	{ city: 'Fairyhall (Limerick)', zip: '877093' },
	{ city: 'Fairyhill (Clare)', zip: '327149' },
	{ city: 'Fairyhill (Galway)', zip: '879900' },
	{ city: 'Fairymount (Roscommon)', zip: '820890' },
	{ city: 'Faithlegg (Waterford)', zip: '434713' },
	{ city: 'Fakeeragh (Galway)', zip: '698155' },
	{ city: 'Falbane (Donegal)', zip: '340671' },
	{ city: 'Falcarragh (Donegal)', zip: '114191' },
	{ city: 'Falchorrib (Donegal)', zip: '511879' },
	{ city: 'Falfin (Sligo)', zip: '631660' },
	{ city: 'Falgarrow (Donegal)', zip: '921309' },
	{ city: 'Fallacarra (Leitrim)', zip: '367114' },
	{ city: 'Fallagh (Waterford)', zip: '692736' },
	{ city: 'Fallaghmore (Laois)', zip: '564568' },
	{ city: 'Fallagowan (Donegal)', zip: '164299' },
	{ city: 'Fallakeeran (Mayo)', zip: '562904' },
	{ city: 'Fallaneas (Donegal)', zip: '169257' },
	{ city: 'Fallard (Donegal)', zip: '718646' },
	{ city: 'Fallarees Commons (Kildare)', zip: '715508' },
	{ city: 'Fallask (Donegal)', zip: '234592' },
	{ city: 'Fallataggart (Mayo)', zip: '479081' },
	{ city: 'Fallathurteen (Sligo)', zip: '606851' },
	{ city: 'Fallduff (Mayo)', zip: '442966' },
	{ city: 'Falledeen (Roscommon)', zip: '225353' },
	{ city: 'Falleen (Tipperary)', zip: '208379' },
	{ city: 'Falleenadatha (Limerick)', zip: '580077' },
	{ city: 'Falleens (Sligo)', zip: '181250' },
	{ city: 'Falleeny (Tipperary)', zip: '364888' },
	{ city: 'Falleighter (Mayo)', zip: '410007' },
	{ city: 'Fallgarve (Mayo)', zip: '998648' },
	{ city: 'Fall Island (Donegal)', zip: '825724' },
	{ city: 'Fallmore (Mayo)', zip: '126262' },
	{ city: 'Fallougher (Sligo)', zip: '301710' },
	{ city: 'Fallowbeg Lower (Laois)', zip: '399313' },
	{ city: 'Fallowbeg Middle (Laois)', zip: '286622' },
	{ city: 'Fallowbeg Upper (Laois)', zip: '662719' },
	{ city: 'Fallsollus (Roscommon)', zip: '953971' },
	{ city: 'Falmore (Louth)', zip: '578410' },
	{ city: 'Falnashammer (Sligo)', zip: '434707' },
	{ city: 'Falnasoogaun (Sligo)', zip: '988288' },
	{ city: 'Falsk (Offaly)', zip: '762658' },
	{ city: 'Falsk (Roscommon)', zip: '524279' },
	{ city: 'Faltagh (Monaghan)', zip: '563610' },
	{ city: 'Faltia (Roscommon)', zip: '311191' },
	{ city: 'Falty (Leitrim)', zip: '828285' },
	{ city: 'Faltybanes (Donegal)', zip: '218783' },
	{ city: 'Fana (Tipperary)', zip: '865957' },
	{ city: 'Fanaghans (Donegal)', zip: '211590' },
	{ city: 'Fanaghs (Kildare)', zip: '902884' },
	{ city: 'Fanahy (Cork)', zip: '149571' },
	{ city: 'Fanaleen (Clare)', zip: '230982' },
	{ city: 'Fananierin (Wicklow)', zip: '587691' },
	{ city: 'Fanavolty (Donegal)', zip: '502839' },
	{ city: 'Fanbeg (Offaly)', zip: '504288' },
	{ city: 'Fancroft (Offaly)', zip: '102552' },
	{ city: 'Fanick (Cork)', zip: '988803' },
	{ city: 'Fanit (Tipperary)', zip: '291142' },
	{ city: 'Fanningsbog (Tipperary)', zip: '561450' },
	{ city: 'Fanningstown (Kilkenny)', zip: '741914' },
	{ city: 'Fanningstown (Limerick)', zip: '814732' },
	{ city: 'Fannystown (Wexford)', zip: '239247' },
	{ city: 'Fanore Beg (Clare)', zip: '534660' },
	{ city: 'Fanore More (Clare)', zip: '179310' },
	{ city: 'Fanta Glebe (Clare)', zip: '460575' },
	{ city: 'Fantane North (Tipperary)', zip: '390499' },
	{ city: 'Fantane South (Tipperary)', zip: '138513' },
	{ city: 'Fantstown (Limerick)', zip: '750037' },
	{ city: 'Fanygalvan (Clare)', zip: '638169' },
	{ city: 'Faraghy (Monaghan)', zip: '789832' },
	{ city: 'Farahy (Cork)', zip: '484129' },
	{ city: 'Farbreaga (Wicklow)', zip: '520255' },
	{ city: 'Farbreagues (Roscommon)', zip: '731287' },
	{ city: 'Fardrum (Westmeath)', zip: '186980' },
	{ city: 'Fardrumman (Longford)', zip: '105265' },
	{ city: 'Fardystown (Wexford)', zip: '340458' },
	{ city: 'Fargrim (Leitrim)', zip: '718527' },
	{ city: 'Farlehanes (Cork)', zip: '311676' },
	{ city: 'Farlistown (Cork)', zip: '412754' },
	{ city: 'Farm (Galway)', zip: '686656' },
	{ city: 'Farmersvale (Dublin)', zip: '227828' },
	{ city: 'Farmhill (Galway)', zip: '160630' },
	{ city: 'Farmhill (Mayo)', zip: '354158' },
	{ city: 'Farmhill (Wexford)', zip: '300656' },
	{ city: 'Farmley (Kilkenny)', zip: '427273' },
	{ city: 'Farmullagh (Longford)', zip: '770384' },
	{ city: 'Farna (Kerry)', zip: '456740' },
	{ city: 'Farnagh (Donegal)', zip: '320306' },
	{ city: 'Farnagh (Leitrim)', zip: '905967' },
	{ city: 'Farnagh (Longford)', zip: '702000' },
	{ city: 'Farnagh (Westmeath)', zip: '298130' },
	{ city: 'Farnaght (Galway)', zip: '216031' },
	{ city: 'Farnaght (Leitrim)', zip: '765954' },
	{ city: 'Farnaght (Mayo)', zip: '598890' },
	{ city: 'Farnaght Roeillaun (Galway)', zip: '424970' },
	{ city: 'Farnahoe (Cork)', zip: '856323' },
	{ city: 'Farnamurry (Tipperary)', zip: '236031' },
	{ city: 'Farnane (Limerick)', zip: '251447' },
	{ city: 'Farnanefranklin (Limerick)', zip: '197521' },
	{ city: 'Farnane Lower (Waterford)', zip: '554431' },
	{ city: 'Farnanes (Cork)', zip: '479588' },
	{ city: 'Farnane Upper (Waterford)', zip: '710832' },
	{ city: 'Farnans (Laois)', zip: '625337' },
	{ city: 'Farnatrane (Wexford)', zip: '201288' },
	{ city: 'Farnaun (Galway)', zip: '189013' },
	{ city: 'Farnaun (Mayo)', zip: '478642' },
	{ city: 'Farnbeg (Roscommon)', zip: '871520' },
	{ city: 'Farnees (Wicklow)', zip: '875379' },
	{ city: 'Farneigh (Tipperary)', zip: '916729' },
	{ city: 'Farneybridge (Tipperary)', zip: '600082' },
	{ city: 'Farneybridgehill (Tipperary)', zip: '914016' },
	{ city: 'Farnham (Cavan)', zip: '892271' },
	{ city: 'Farnmore (Roscommon)', zip: '692035' },
	{ city: 'Farnoge (Kilkenny)', zip: '892266' },
	{ city: 'Farnoge East (Kilkenny)', zip: '194259' },
	{ city: 'Farnoge West (Kilkenny)', zip: '308005' },
	{ city: 'Farragans (Donegal)', zip: '974271' },
	{ city: 'Farragh (Cavan)', zip: '565297' },
	{ city: 'Farragh (Mayo)', zip: '798356' },
	{ city: 'Farraghroe (Longford)', zip: '647608' },
	{ city: 'Farran (Cork)', zip: '785421' },
	{ city: 'Farran (Kerry)', zip: '458214' },
	{ city: 'Farran (Tipperary)', zip: '359201' },
	{ city: 'Farranablake East (Galway)', zip: '967643' },
	{ city: 'Farranablake West (Galway)', zip: '988767' },
	{ city: 'Farranacahill (Tipperary)', zip: '564001' },
	{ city: 'Farranacardy (Sligo)', zip: '736334' },
	{ city: 'Farranaclara (Tipperary)', zip: '252460' },
	{ city: 'Farranacliff (Tipperary)', zip: '162385' },
	{ city: 'Farranacounter (Cork)', zip: '352032' },
	{ city: 'Farranacoush (Cork)', zip: '748116' },
	{ city: 'Farranacurragh (Carlow)', zip: '500710' },
	{ city: 'Farranaderry (Tipperary)', zip: '802157' },
	{ city: 'Farranadoony (Meath)', zip: '671803' },
	{ city: 'Farranadum (Kildare)', zip: '240035' },
	{ city: 'Farranafina (Limerick)', zip: '647372' },
	{ city: 'Farranafreney (Carlow)', zip: '178051' },
	{ city: 'Farranagalliagh (Roscommon)', zip: '616102' },
	{ city: 'Farranagalliagh East (Roscommon)', zip: '950608' },
	{ city: 'Farranagalliagh West (Roscommon)', zip: '891449' },
	{ city: 'Farranagilla (Cork)', zip: '767412' },
	{ city: 'Farranaglogh (Meath)', zip: '987025' },
	{ city: 'Farranagow (Cork)', zip: '295101' },
	{ city: 'Farranakill (Longford)', zip: '742919' },
	{ city: 'Farranalahesery (Waterford)', zip: '616678' },
	{ city: 'Farranalcock (Meath)', zip: '208912' },
	{ city: 'Farranaleen (Tipperary)', zip: '328238' },
	{ city: 'Farranalickeen (Kerry)', zip: '171028' },
	{ city: 'Farranalough (Cork)', zip: '196863' },
	{ city: 'Farranalounty (Waterford)', zip: '813684' },
	{ city: 'Farranalynch (Galway)', zip: '443363' },
	{ city: 'Farranamanagh (Cork)', zip: '640134' },
	{ city: 'Farranamanagh (Tipperary)', zip: '952818' },
	{ city: 'Farranamoy (Cork)', zip: '276714' },
	{ city: 'Farranamranagh (Kerry)', zip: '443662' },
	{ city: 'Farranaphlure (Carlow)', zip: '152303' },
	{ city: 'Farranaraheen (Tipperary)', zip: '664949' },
	{ city: 'Farranaree (Kilkenny)', zip: '405743' },
	{ city: 'Farranarouga North (Cork)', zip: '937800' },
	{ city: 'Farranarouga South (Cork)', zip: '323199' },
	{ city: 'Farranasa (Tipperary)', zip: '392189' },
	{ city: 'Farranaspig (Kerry)', zip: '797612' },
	{ city: 'Farranastack (Kerry)', zip: '292903' },
	{ city: 'Farranastig (Cork)', zip: '198114' },
	{ city: 'Farranatlaba (Limerick)', zip: '868983' },
	{ city: 'Farranatouke (Cork)', zip: '222980' },
	{ city: 'Farranavarra (Cork)', zip: '267867' },
	{ city: 'Farranavarra (Tipperary)', zip: '199340' },
	{ city: 'Farranavarrigane (Cork)', zip: '826095' },
	{ city: 'Farranavulla (Tipperary)', zip: '672840' },
	{ city: 'Farranawana (Kerry)', zip: '867008' },
	{ city: 'Farranawillin (Roscommon)', zip: '291864' },
	{ city: 'Farranboley (Dublin)', zip: '663965' },
	{ city: 'Farranbrien East (Cork)', zip: '650558' },
	{ city: 'Farranbrien West (Cork)', zip: '884111' },
	{ city: 'Farranbullen (Waterford)', zip: '921793' },
	{ city: 'Farrancallin (Westmeath)', zip: '276540' },
	{ city: 'Farranconnor (Cork)', zip: '715753' },
	{ city: 'Farrancotter (Cork)', zip: '371951' },
	{ city: 'Farrandalouge (Kerry)', zip: '466735' },
	{ city: 'Farrandau (Cork)', zip: '425752' },
	{ city: 'Farrandeelion (Mayo)', zip: '968476' },
	{ city: 'Farrandeen (Kerry)', zip: '590921' },
	{ city: 'Farrandeligeen (Cork)', zip: '145948' },
	{ city: 'Farranderry (Meath)', zip: '776428' },
	{ city: 'Farrandoctor (Kerry)', zip: '793066' },
	{ city: 'Farrandreg (Louth)', zip: '435645' },
	{ city: 'Farranduff (Cork)', zip: '396087' },
	{ city: 'Farranedmond (Kerry)', zip: '360403' },
	{ city: 'Farraneen (Cork)', zip: '319462' },
	{ city: 'Farraneesteenig (Kerry)', zip: '286281' },
	{ city: 'Farraneglish Glebe (Laois)', zip: '197911' },
	{ city: 'Farraneshagh (Tipperary)', zip: '261318' },
	{ city: 'Farranfadda (Cork)', zip: '436264' },
	{ city: 'Farranflaherty (Kerry)', zip: '717979' },
	{ city: 'Farranfolliott (Westmeath)', zip: '836500' },
	{ city: 'Farranfore (Kerry)', zip: '475877' },
	{ city: 'Farrangalway (Cork)', zip: '785913' },
	{ city: 'Farrangarode (Mayo)', zip: '950693' },
	{ city: 'Farrangarret (Waterford)', zip: '301627' },
	{ city: 'Farrangarve (Cavan)', zip: '247482' },
	{ city: 'Farrangavnagh (Galway)', zip: '829944' },
	{ city: 'Farrangeel (Cork)', zip: '389544' },
	{ city: 'Farranhavane (Cork)', zip: '406178' },
	{ city: 'Farraniaragh (Kerry)', zip: '842604' },
	{ city: 'Farranimrish (Sligo)', zip: '325714' },
	{ city: 'Farranistick (Westmeath)', zip: '875637' },
	{ city: 'Farranjordan (Tipperary)', zip: '739377' },
	{ city: 'Farrankeal (Cork)', zip: '292411' },
	{ city: 'Farrankeal (Kerry)', zip: '282297' },
	{ city: 'Farrankelly (Wicklow)', zip: '162499' },
	{ city: 'Farrankindry (Tipperary)', zip: '589174' },
	{ city: 'Farranlahassery (Tipperary)', zip: '639428' },
	{ city: 'Farranlaheshery East (Cork)', zip: '782720' },
	{ city: 'Farranlaheshery West (Cork)', zip: '771947' },
	{ city: 'Farranlateeve (Kerry)', zip: '215167' },
	{ city: 'Farranliney (Tipperary)', zip: '956725' },
	{ city: 'Farranmacbride (Donegal)', zip: '125785' },
	{ city: 'Farranmacbrien (Tipperary)', zip: '446372' },
	{ city: 'Farranmacedmond (Kilkenny)', zip: '859015' },
	{ city: 'Farranmacfarrell (Sligo)', zip: '131143' },
	{ city: 'Farranmacshane (Offaly)', zip: '979297' },
	{ city: 'Farranmanagh (Kerry)', zip: '674913' },
	{ city: 'Farranmanny North (Westmeath)', zip: '712040' },
	{ city: 'Farranmanny South (Westmeath)', zip: '684342' },
	{ city: 'Farranmareen (Cork)', zip: '826516' },
	{ city: 'Farranmaurice (Sligo)', zip: '794363' },
	{ city: 'Farranmiller (Limerick)', zip: '726025' },
	{ city: 'Farranmorgan (Mayo)', zip: '844888' },
	{ city: 'Farrannabox (Galway)', zip: '383052' },
	{ city: 'Farrannabrack (Kerry)', zip: '866490' },
	{ city: 'Farrannacarriga (Kerry)', zip: '871594' },
	{ city: 'Farrannagark (Cork)', zip: '155189' },
	{ city: 'Farrannagark (Tipperary)', zip: '880355' },
	{ city: 'Farrannahineeny (Cork)', zip: '666857' },
	{ city: 'Farrannahow (Kerry)', zip: '821342' },
	{ city: 'Farrannakilla (Kerry)', zip: '875303' },
	{ city: 'Farrannamanagh (Cork)', zip: '186637' },
	{ city: 'Farrannamartin (Galway)', zip: '525019' },
	{ city: 'Farrannamoreen (Westmeath)', zip: '758532' },
	{ city: 'Farrannasculloge (Mayo)', zip: '583726' },
	{ city: 'Farrannasheshery (Cork)', zip: '268461' },
	{ city: 'Farrannoo (Mayo)', zip: '355924' },
	{ city: 'Farran North (Cork)', zip: '902594' },
	{ city: 'Farranpierce (Kerry)', zip: '324298' },
	{ city: 'Farranreagh (Kerry)', zip: '521385' },
	{ city: 'Farranredmond (Kerry)', zip: '713264' },
	{ city: 'Farranreigh (Tipperary)', zip: '356423' },
	{ city: 'Farranrory Lower (Tipperary)', zip: '490285' },
	{ city: 'Farranrory Upper (Tipperary)', zip: '204704' },
	{ city: 'Farranseer (Cavan)', zip: '873651' },
	{ city: 'Farranshea (Tipperary)', zip: '145883' },
	{ city: 'Farranshonikeen (Cork)', zip: '586597' },
	{ city: 'Farran South (Cork)', zip: '327537' },
	{ city: 'Farranstephen (Kerry)', zip: '637920' },
	{ city: 'Farrantaun (Kerry)', zip: '492179' },
	{ city: 'Farrantemple (Kilkenny)', zip: '165993' },
	{ city: 'Farranthomas (Cork)', zip: '432746' },
	{ city: 'Farrantooleen (Kerry)', zip: '948998' },
	{ city: 'Farrantoreen (Kerry)', zip: '328922' },
	{ city: 'Farrantrenchard (Cork)', zip: '402678' },
	{ city: 'Farranville (Laois)', zip: '759004' },
	{ city: 'Farranwilliam (Kerry)', zip: '322710' },
	{ city: 'Farranydaly (Cavan)', zip: '478988' },
	{ city: 'Farranyharpy (Sligo)', zip: '544832' },
	{ city: 'Farranykelly (Roscommon)', zip: '600539' },
	{ city: 'Farranyoogan (Longford)', zip: '924529' },
	{ city: 'Farravaun (Galway)', zip: '399331' },
	{ city: 'Farrihy (Clare)', zip: '174865' },
	{ city: 'Farrihy (Limerick)', zip: '401715' },
	{ city: 'Farrow (Westmeath)', zip: '803906' },
	{ city: 'Farsetmore (Donegal)', zip: '106345' },
	{ city: 'Farta (Galway)', zip: '745254' },
	{ city: 'Fartadreen (Cavan)', zip: '416296' },
	{ city: 'Fartagar (Galway)', zip: '539253' },
	{ city: 'Fartagh (Cavan)', zip: '565971' },
	{ city: 'Fartagorman (Monaghan)', zip: '390331' },
	{ city: 'Fartamore (Galway)', zip: '485114' },
	{ city: 'Fartan Lower (Cavan)', zip: '434647' },
	{ city: 'Fartannan (Sligo)', zip: '529816' },
	{ city: 'Fartan Upper (Cavan)', zip: '304877' },
	{ city: 'Fartha (Cork)', zip: '932470' },
	{ city: 'Farthingstown (Westmeath)', zip: '612437' },
	{ city: 'Farthingville East (Cork)', zip: '682607' },
	{ city: 'Farthingville West (Cork)', zip: '899837' },
	{ city: 'Fartrin (Cavan)', zip: '140445' },
	{ city: 'Fary (Wexford)', zip: '226281' },
	{ city: 'Fasagh (Cork)', zip: '645569' },
	{ city: 'Fasagh (Kildare)', zip: '607960' },
	{ city: 'Fasagh (Wexford)', zip: '202002' },
	{ city: 'Faslowart (Leitrim)', zip: '853379' },
	{ city: 'Fassagh (Westmeath)', zip: '441966' },
	{ city: 'Fassaroe (Wicklow)', zip: '193961' },
	{ city: 'Fastry (Monaghan)', zip: '950819' },
	{ city: 'Fatharnagh (Laois)', zip: '109091' },
	{ city: 'Fatthen (Tipperary)', zip: '105530' },
	{ city: 'Faughalstown (Westmeath)', zip: '515276' },
	{ city: 'Faughanhill (Meath)', zip: '298184' },
	{ city: 'Faughart Lower (Louth)', zip: '411174' },
	{ city: 'Faughart Upper (Louth)', zip: '137149' },
	{ city: 'Faughary (Leitrim)', zip: '720823' },
	{ city: 'Faugher (Donegal)', zip: '538495' },
	{ city: 'Faugher Mountain (Donegal)', zip: '938383' },
	{ city: 'Faughil (Mayo)', zip: '201240' },
	{ city: 'Faughts (Sligo)', zip: '283303' },
	{ city: 'Faul (Galway)', zip: '776825' },
	{ city: 'Faulagh (Mayo)', zip: '715771' },
	{ city: 'Fauleens (Mayo)', zip: '495267' },
	{ city: 'Faulkland (Monaghan)', zip: '941438' },
	{ city: 'Faulties (Leitrim)', zip: '256045' },
	{ city: 'Fauna (Wicklow)', zip: '816962' },
	{ city: 'Faunarooska (Clare)', zip: '928409' },
	{ city: 'Faunin (Galway)', zip: '338963' },
	{ city: 'Faunkill And The Woods (Cork)', zip: '901009' },
	{ city: 'Faunmore (Cork)', zip: '506101' },
	{ city: 'Faunrusk (Clare)', zip: '215488' },
	{ city: 'Fawans (Donegal)', zip: '669631' },
	{ city: 'Fawn (Leitrim)', zip: '216660' },
	{ city: 'Fawnaboy (Donegal)', zip: '483568' },
	{ city: 'Fawnagowan (Tipperary)', zip: '560417' },
	{ city: 'Fawnamore (Limerick)', zip: '722458' },
	{ city: 'Fawnanierin (Roscommon)', zip: '589419' },
	{ city: 'Fawnarevagh (Galway)', zip: '564347' },
	{ city: 'Fawnarry (Leitrim)', zip: '526340' },
	{ city: 'Fawnglass (Mayo)', zip: '401198' },
	{ city: 'Fawninoughan (Donegal)', zip: '238171' },
	{ city: 'Fawnlehane (Limerick)', zip: '311308' },
	{ city: 'Fawnlion (Leitrim)', zip: '590062' },
	{ city: 'Fawnlough (Tipperary)', zip: '656306' },
	{ city: 'Fawnmore (Donegal)', zip: '849548' },
	{ city: 'Fawnmore (Galway)', zip: '626122' },
	{ city: 'Faws (Roscommon)', zip: '431704' },
	{ city: 'Faymore (Donegal)', zip: '138783' },
	{ city: 'Faythe (Wexford)', zip: '574888' },
	{ city: 'Feacle (Roscommon)', zip: '690724' },
	{ city: 'Feagarrid (Waterford)', zip: '840585' },
	{ city: 'Feagarroge (Clare)', zip: '130837' },
	{ city: 'Feagh (Clare)', zip: '772085' },
	{ city: 'Feagh (Galway)', zip: '422543' },
	{ city: 'Feagh (Meath)', zip: '583198' },
	{ city: 'Feagh (Monaghan)', zip: '492252' },
	{ city: 'Feaghbeg (Galway)', zip: '465108' },
	{ city: 'Feagh East (Galway)', zip: '264160' },
	{ city: 'Feaghmaan East (Kerry)', zip: '306645' },
	{ city: 'Feaghmaan West (Kerry)', zip: '892852' },
	{ city: 'Feaghmore Eighter (Galway)', zip: '920441' },
	{ city: 'Feaghmore Oughter (Galway)', zip: '109972' },
	{ city: 'Feaghquin (Clare)', zip: '918871' },
	{ city: 'Feaght Rock (Kerry)', zip: '355110' },
	{ city: 'Feagh West (Galway)', zip: '975893' },
	{ city: 'Feagreen (Clare)', zip: '318543' },
	{ city: 'Feahoe (Monaghan)', zip: '825885' },
	{ city: 'Feakle (Clare)', zip: '828738' },
	{ city: 'Feamore (Carlow)', zip: '428057' },
	{ city: 'Feamore (Mayo)', zip: '762932' },
	{ city: 'Feamore (Roscommon)', zip: '120936' },
	{ city: 'Fearagh (Laois)', zip: '210474' },
	{ city: 'Fearagh (Roscommon)', zip: '338663' },
	{ city: 'Fearagha (Galway)', zip: '275293' },
	{ city: 'Fearaghafin (Roscommon)', zip: '696738' },
	{ city: 'Fearaghalee (Offaly)', zip: '105926' },
	{ city: 'Fearaun (Kildare)', zip: '965523' },
	{ city: 'Fearavolla (Kildare)', zip: '152965' },
	{ city: 'Fear Beg (Galway)', zip: '925842' },
	{ city: 'Fearboy (Offaly)', zip: '208527' },
	{ city: 'Feargarrow (Offaly)', zip: '890253' },
	{ city: 'Fearglass North (Leitrim)', zip: '221997' },
	{ city: 'Fearglass South (Leitrim)', zip: '839522' },
	{ city: 'Fearmore (Galway)', zip: '270355' },
	{ city: 'Fearmore (Kildare)', zip: '945954' },
	{ city: 'Fearmore (Meath)', zip: '379394' },
	{ city: 'Fearmore (Roscommon)', zip: '744350' },
	{ city: 'Fearmore (Westmeath)', zip: '393758' },
	{ city: 'Fear More (Galway)', zip: '211344' },
	{ city: 'Fearn (Donegal)', zip: '471867' },
	{ city: 'Fearnaght (Leitrim)', zip: '819026' },
	{ city: 'Fearnamona (Offaly)', zip: '631201' },
	{ city: 'Fearoe (Limerick)', zip: '258434' },
	{ city: 'Feathallagh (Kilkenny)', zip: '245814' },
	{ city: 'Feaugh (Cavan)', zip: '187780' },
	{ city: 'Feavautia (Kerry)', zip: '274930' },
	{ city: 'Febog (Meath)', zip: '187914' },
	{ city: 'Fedamore (Limerick)', zip: '889675' },
	{ city: 'Fedaro (Leitrim)', zip: '488770' },
	{ city: 'Feddans (Monaghan)', zip: '179725' },
	{ city: 'Feddans (Waterford)', zip: '208540' },
	{ city: 'Feddaun (Waterford)', zip: '145806' },
	{ city: 'Feddyglass (Donegal)', zip: '678440' },
	{ city: 'Fedoo (Monaghan)', zip: '666707' },
	{ city: 'Feeagh (Limerick)', zip: '957306' },
	{ city: 'Feeans (Kerry)', zip: '100287' },
	{ city: 'Feeard (Clare)', zip: '834788' },
	{ city: 'Feebaghbane (Monaghan)', zip: '733534' },
	{ city: 'Feebaghduff (Monaghan)', zip: '668553' },
	{ city: 'Feebane (Monaghan)', zip: '692932' },
	{ city: 'Fee Beg (Tipperary)', zip: '151694' },
	{ city: 'Feebrack (Galway)', zip: '506735' },
	{ city: 'Feedarragh (Cavan)', zip: '526946' },
	{ city: 'Feede (Louth)', zip: '940768' },
	{ city: 'Feegat (Meath)', zip: '490727' },
	{ city: 'Feegavla (Monaghan)', zip: '730361' },
	{ city: 'Feeghroe (Offaly)', zip: '926051' },
	{ city: 'Feeghs (Offaly)', zip: '838661' },
	{ city: 'Feemore (Tipperary)', zip: '983880' },
	{ city: 'Fee More (Tipperary)', zip: '337553' },
	{ city: 'Feenagh (Clare)', zip: '514940' },
	{ city: 'Feenagh (Limerick)', zip: '973004' },
	{ city: 'Feenaghmore (Sligo)', zip: '198449' },
	{ city: 'Feenaghroe (Sligo)', zip: '845380' },
	{ city: 'Feenish (Clare)', zip: '383463' },
	{ city: 'Feenlea (Clare)', zip: '161438' },
	{ city: 'Feenune (Mayo)', zip: '125570' },
	{ city: 'Feevagh (Roscommon)', zip: '675133' },
	{ city: 'Feevagh Beg (Roscommon)', zip: '859056' },
	{ city: 'Feevagh More (Roscommon)', zip: '202446' },
	{ city: 'Fegart (Donegal)', zip: '415931' },
	{ city: 'Fehanagh (Kerry)', zip: '808189' },
	{ city: 'Fehoonree (Tipperary)', zip: '467266' },
	{ city: 'Feigh (Tipperary)', zip: '235186' },
	{ city: 'Feighcullen (Kildare)', zip: '773777' },
	{ city: 'Feigh East (Tipperary)', zip: '951086' },
	{ city: 'Feighroe (Clare)', zip: '678103' },
	{ city: 'Feigh West (Tipperary)', zip: '511430' },
	{ city: 'Felane East (Cork)', zip: '111782' },
	{ city: 'Felane Middle (Cork)', zip: '661803' },
	{ city: 'Felane West (Cork)', zip: '721457' },
	{ city: 'Felimspark (Galway)', zip: '263722' },
	{ city: 'Feloree (Limerick)', zip: '946414' },
	{ city: 'Feltrim (Dublin)', zip: '191924' },
	{ city: 'Fenagh (Leitrim)', zip: '606997' },
	{ city: 'Fenagh Beg (Leitrim)', zip: '874711' },
	{ city: 'Fenane (Tipperary)', zip: '421840' },
	{ city: 'Fence (Wexford)', zip: '374825' },
	{ city: 'Fenit (Kerry)', zip: '616053' },
	{ city: 'Fenit Within (Kerry)', zip: '858312' },
	{ city: 'Fenit Without (Kerry)', zip: '117152' },
	{ city: 'Fennagh (Carlow)', zip: '604249' },
	{ city: 'Fenniscourt (Carlow)', zip: '363717' },
	{ city: 'Fennor (Kildare)', zip: '729282' },
	{ city: 'Fennor (Meath)', zip: '861979' },
	{ city: 'Fennor (Tipperary)', zip: '448239' },
	{ city: 'Fennor (Waterford)', zip: '281397' },
	{ city: 'Fennor (Westmeath)', zip: '245586' },
	{ city: 'Fennor Lower (Meath)', zip: '411042' },
	{ city: 'Fennor North (Waterford)', zip: '736918' },
	{ city: 'Fennor South (Waterford)', zip: '748829' },
	{ city: 'Fennor Upper (Meath)', zip: '376801' },
	{ city: 'Feohanagh (Kerry)', zip: '792814' },
	{ city: 'Feohanagh (Limerick)', zip: '735506' },
	{ city: 'Feoramore (Kerry)', zip: '778751' },
	{ city: 'Feorus East (Kerry)', zip: '672470' },
	{ city: 'Feorus West (Kerry)', zip: '707688' },
	{ city: 'Feragh (Monaghan)', zip: '564353' },
	{ city: 'Feraghfad (Longford)', zip: '518386' },
	{ city: 'Feraghs (Louth)', zip: '340311' },
	{ city: 'Ferbane (Offaly)', zip: '696717' },
	{ city: 'Ferganstown And Ballymacon (Meath)', zip: '226722' },
	{ city: 'Fergus (Cork)', zip: '496721' },
	{ city: 'Ferm (Cork)', zip: '131231' },
	{ city: 'Fermoy (Cork)', zip: '149660' },
	{ city: 'Fermoyle (Cork)', zip: '570611' },
	{ city: 'Fermoyle (Kerry)', zip: '403007' },
	{ city: 'Fermoyle (Laois)', zip: '186424' },
	{ city: 'Ferns (Wexford)', zip: '826649' },
	{ city: 'Ferns Demesne (Wexford)', zip: '538395' },
	{ city: 'Ferns Lower (Wexford)', zip: '441732' },
	{ city: 'Ferns Upper (Wexford)', zip: '812100' },
	{ city: 'Fernyhill (Laois)', zip: '587075' },
	{ city: 'Fernyhill (Wexford)', zip: '127774' },
	{ city: 'Ferrans (Meath)', zip: '884803' },
	{ city: 'Ferrestown (Meath)', zip: '176517' },
	{ city: 'Ferritersquarter (Kerry)', zip: '465199' },
	{ city: 'Ferrybank (Wicklow)', zip: '232144' },
	{ city: 'Ferrybank North (Wexford)', zip: '750641' },
	{ city: 'Ferrybank South (Wexford)', zip: '464978' },
	{ city: 'Ferrycarrig (Wexford)', zip: '154847' },
	{ city: 'Ferryfort (Cork)', zip: '893928' },
	{ city: 'Ferryhouse (Tipperary)', zip: '949130' },
	{ city: 'Ferry Islands (Donegal)', zip: '537782' },
	{ city: 'Ferskill (Longford)', zip: '356697' },
	{ city: 'Ferta (Kerry)', zip: '893755' },
	{ city: 'Fertagh (Leitrim)', zip: '452414' },
	{ city: 'Fertagh (Meath)', zip: '411302' },
	{ city: 'Fertaun (Offaly)', zip: '215535' },
	{ city: 'Fertiana (Tipperary)', zip: '765559' },
	{ city: 'Fethard (Tipperary)', zip: '965445' },
	{ city: 'Fethard (Wexford)', zip: '844708' },
	{ city: 'Fetherneen (Sligo)', zip: '554507' },
	{ city: 'Feugh (Cavan)', zip: '565109' },
	{ city: 'Ffrenchpark (Galway)', zip: '651296' },
	{ city: "Ffrench's Acres (Galway)", zip: '761466' },
	{ city: 'Fiddan (Wicklow)', zip: '333375' },
	{ city: 'Fiddancoyle (Wicklow)', zip: '127453' },
	{ city: 'Fiddandarry (Sligo)', zip: '419154' },
	{ city: 'Fiddane (Cork)', zip: '429144' },
	{ city: 'Fiddane (Kerry)', zip: '506523' },
	{ city: 'Fiddane (Tipperary)', zip: '587929' },
	{ city: 'Fiddane North (Cork)', zip: '915363' },
	{ city: 'Fiddane South (Cork)', zip: '461558' },
	{ city: 'Fiddaun (Galway)', zip: '706789' },
	{ city: 'Fiddaun (Roscommon)', zip: '637988' },
	{ city: 'Fiddaun (Sligo)', zip: '814699' },
	{ city: 'Fiddaun Lower (Kilkenny)', zip: '166247' },
	{ city: 'Fiddaunnageeroge (Mayo)', zip: '681819' },
	{ city: 'Fiddaun Upper (Kilkenny)', zip: '758603' },
	{ city: 'Fiddown (Kilkenny)', zip: '968325' },
	{ city: 'Fidorfe (Meath)', zip: '523287' },
	{ city: 'Fidwog (Sligo)', zip: '355630' },
	{ city: 'Fieldstown (Dublin)', zip: '981926' },
	{ city: 'Fieldstown (Louth)', zip: '242570' },
	{ city: 'Fieldstown (Meath)', zip: '771020' },
	{ city: 'Fieries (Kerry)', zip: '415060' },
	{ city: 'Figanny (Monaghan)', zip: '893916' },
	{ city: 'Figart (Donegal)', zip: '319309' },
	{ city: 'Figary (Donegal)', zip: '308481' },
	{ city: 'Figh (Roscommon)', zip: '434136' },
	{ city: 'Figlash (Tipperary)', zip: '109174' },
	{ city: 'Figullar (Monaghan)', zip: '662475' },
	{ city: 'Fihertagh (Tipperary)', zip: '787564' },
	{ city: 'Fihidy (Limerick)', zip: '469748' },
	{ city: 'Fihoges (Longford)', zip: '194164' },
	{ city: 'Fihoragh (Longford)', zip: '220727' },
	{ city: 'Filbuckstown (Kilkenny)', zip: '233249' },
	{ city: 'Finaghoo (Cavan)', zip: '587276' },
	{ city: 'Finanagh (Clare)', zip: '372477' },
	{ city: 'Finavarra Demesne (Clare)', zip: '637109' },
	{ city: 'Finaway (Cavan)', zip: '782166' },
	{ city: 'Fincarn (Monaghan)', zip: '846231' },
	{ city: 'Fincashel (Donegal)', zip: '204930' },
	{ city: 'Findrum (Donegal)', zip: '502115' },
	{ city: 'Finglas (Dublin)', zip: '249537' },
	{ city: 'Fingreagh Lower (Leitrim)', zip: '540863' },
	{ city: 'Fingreagh Upper (Leitrim)', zip: '881336' },
	{ city: 'Finisclin (Roscommon)', zip: '920068' },
	{ city: 'Finish Island (Galway)', zip: '754803' },
	{ city: 'Finisk (Cork)', zip: '655902' },
	{ city: 'Finiskil (Leitrim)', zip: '485923' },
	{ city: 'Finisklin (Galway)', zip: '281948' },
	{ city: 'Finisklin (Leitrim)', zip: '125886' },
	{ city: 'Finisklin (Sligo)', zip: '548387' },
	{ city: 'Finlaghtown Great (Meath)', zip: '798246' },
	{ city: 'Finlaghtown Little (Meath)', zip: '533687' },
	{ city: 'Finlough (Clare)', zip: '107232' },
	{ city: 'Finlough (Sligo)', zip: '449697' },
	{ city: 'Finnabanes (Donegal)', zip: '827696' },
	{ city: 'Finnadoos (Donegal)', zip: '703570' },
	{ city: 'Finnadork Glebe (Donegal)', zip: '691341' },
	{ city: 'Finnahy (Tipperary)', zip: '698887' },
	{ city: 'Finnalaghta (Leitrim)', zip: '867287' },
	{ city: 'Finnan (Kilkenny)', zip: '873627' },
	{ city: 'Finnanfield (Cork)', zip: '303001' },
	{ city: 'Finnaragh (Longford)', zip: '253387' },
	{ city: 'Finnaun (Galway)', zip: '775069' },
	{ city: 'Finnea (Westmeath)', zip: '167456' },
	{ city: 'Finned (Sligo)', zip: '584384' },
	{ city: 'Finner (Donegal)', zip: '904923' },
	{ city: 'Finnillaun (Galway)', zip: '385558' },
	{ city: 'Finnis (Cork)', zip: '520897' },
	{ city: 'Finnisglin (Galway)', zip: '492941' },
	{ city: 'Finniterstown (Limerick)', zip: '513352' },
	{ city: 'Finnoo (Limerick)', zip: '316642' },
	{ city: 'Finnor (Roscommon)', zip: '761561' },
	{ city: 'Finnor Beg (Clare)', zip: '656656' },
	{ city: 'Finnor More (Clare)', zip: '255165' },
	{ city: 'Finns (Longford)', zip: '490076' },
	{ city: 'Finnstown (Dublin)', zip: '528745' },
	{ city: 'Finnure (Galway)', zip: '728176' },
	{ city: 'Finnure (Sligo)', zip: '148277' },
	{ city: 'Finny (Mayo)', zip: '265069' },
	{ city: 'Finshoge (Wexford)', zip: '910931' },
	{ city: 'Fintawan (Cavan)', zip: '651431' },
	{ city: 'Finter (Offaly)', zip: '565400' },
	{ city: 'Finternagh (Cavan)', zip: '768730' },
	{ city: 'Fintown (Donegal)', zip: '512664' },
	{ city: 'Fintra Beg (Clare)', zip: '196255' },
	{ city: 'Fintragh (Donegal)', zip: '946347' },
	{ city: 'Fintra More (Clare)', zip: '832906' },
	{ city: 'Fintully (Monaghan)', zip: '751985' },
	{ city: 'Finuge (Kerry)', zip: '560323' },
	{ city: 'Finure (Cork)', zip: '849454' },
	{ city: 'Finvarra (Clare)', zip: '533175' },
	{ city: 'Finver (Donegal)', zip: '931474' },
	{ city: 'Finvoy (Louth)', zip: '663254' },
	{ city: 'Firgrove (Clare)', zip: '198218' },
	{ city: 'Firgrove (Kilkenny)', zip: '331986' },
	{ city: 'Firgrove (Tipperary)', zip: '631026' },
	{ city: 'Firhouse (Dublin)', zip: '691031' },
	{ city: 'Firmount (Cork)', zip: '928145' },
	{ city: 'Firmount (Longford)', zip: '222144' },
	{ city: 'Firmount (Tipperary)', zip: '122549' },
	{ city: 'Firmount Demesne (Kildare)', zip: '236498' },
	{ city: 'Firmount East (Kildare)', zip: '778455' },
	{ city: 'Firmount West (Kildare)', zip: '141338' },
	{ city: 'Firoda Upper (Kilkenny)', zip: '671261' },
	{ city: 'Firpark (Galway)', zip: '623680' },
	{ city: 'Firpark (Meath)', zip: '850548' },
	{ city: 'Firville East (Cork)', zip: '426631' },
	{ city: 'Firville West (Cork)', zip: '134125' },
	{ city: 'Fisherhill (Mayo)', zip: '283717' },
	{ city: 'Fishersgraigue (Kilkenny)', zip: '658505' },
	{ city: 'Fisherstown (Laois)', zip: '718100' },
	{ city: 'Fisherstown (Wexford)', zip: '710341' },
	{ city: 'Fishmoyne (Tipperary)', zip: '343728' },
	{ city: 'Fiveacre (Wexford)', zip: '978440' },
	{ city: 'Fiveacres (Westmeath)', zip: '539996' },
	{ city: 'Fivealley (Offaly)', zip: '448981' },
	{ city: 'Fivemilebourne (Leitrim)', zip: '775879' },
	{ city: 'Fivepoundland (Leitrim)', zip: '859527' },
	{ city: 'Flacketstown (Dublin)', zip: '118754' },
	{ city: 'Flagmount (Clare)', zip: '144289' },
	{ city: 'Flagmount North (Kilkenny)', zip: '872286' },
	{ city: 'Flagmount South (Kilkenny)', zip: '800221' },
	{ city: 'Flaskagh Beg (Galway)', zip: '361227' },
	{ city: 'Flaskagh Beg (Roscommon)', zip: '167452' },
	{ city: 'Flaskagh More (Galway)', zip: '739957' },
	{ city: 'Flaskagh More (Roscommon)', zip: '122060' },
	{ city: 'Flats (Cork)', zip: '657842' },
	{ city: 'Flean Beg (Limerick)', zip: '431428' },
	{ city: 'Flean More (Limerick)', zip: '578949' },
	{ city: 'Fleenstown Great (Meath)', zip: '683445' },
	{ city: 'Fleenstown Little (Meath)', zip: '999437' },
	{ city: 'Flegans (Roscommon)', zip: '683021' },
	{ city: 'Flemby (Kerry)', zip: '266865' },
	{ city: 'Flemingstown (Cork)', zip: '432236' },
	{ city: 'Flemingstown (Donegal)', zip: '649217' },
	{ city: 'Flemingstown (Kerry)', zip: '384247' },
	{ city: 'Flemingstown (Kilkenny)', zip: '293187' },
	{ city: 'Flemingstown (Limerick)', zip: '119756' },
	{ city: 'Flemingstown (Meath)', zip: '637262' },
	{ city: 'Flemingstown (Tipperary)', zip: '495420' },
	{ city: 'Flemingtown (Dublin)', zip: '472852' },
	{ city: 'Flemingtown (Meath)', zip: '944848' },
	{ city: 'Flemingtown North (Kildare)', zip: '155634' },
	{ city: 'Flemingtown South (Kildare)', zip: '576126' },
	{ city: 'Fleshtown (Kildare)', zip: '622578' },
	{ city: 'Fletcherstown (Meath)', zip: '407157' },
	{ city: 'Flintfield (Kerry)', zip: '975897' },
	{ city: 'Floodhall (Kilkenny)', zip: '648382' },
	{ city: 'Flowerhill (Sligo)', zip: '508238' },
	{ city: 'Flowerhill (Waterford)', zip: '150636' },
	{ city: 'Flughanagh (Leitrim)', zip: '288490' },
	{ city: 'Flughany (Mayo)', zip: '470694' },
	{ city: 'Flughland (Donegal)', zip: '887165' },
	{ city: 'Foalies (Cavan)', zip: '526556' },
	{ city: 'Foal Island (Galway)', zip: '343564' },
	{ city: 'Foardal (Kerry)', zip: '598151' },
	{ city: 'Foats (Galway)', zip: '969489' },
	{ city: 'Foaty (Cork)', zip: '633092' },
	{ city: 'Fodagh (Wexford)', zip: '197280' },
	{ city: 'Fodeen (Meath)', zip: '194189' },
	{ city: 'Fodeens (Kildare)', zip: '971724' },
	{ city: 'Fodry (Clare)', zip: '824146' },
	{ city: 'Foffanagh (Donegal)', zip: '793049' },
	{ city: 'Foghanagh Beg (Roscommon)', zip: '761408' },
	{ city: 'Foghanagh More (Roscommon)', zip: '506860' },
	{ city: 'Foghill (Mayo)', zip: '717082' },
	{ city: 'Fohanagh (Galway)', zip: '155685' },
	{ city: 'Foher (Galway)', zip: '817760' },
	{ city: 'Fohera (Leitrim)', zip: '737536' },
	{ city: 'Foheraghmore (Kerry)', zip: '559097' },
	{ city: 'Foherlagh (Cork)', zip: '256113' },
	{ city: 'Foil (Kerry)', zip: '996108' },
	{ city: 'Foilacamin (Tipperary)', zip: '563119' },
	{ city: 'Foilaclug (Tipperary)', zip: '354823' },
	{ city: 'Foiladaun (Cork)', zip: '280322' },
	{ city: 'Foiladuane (Kerry)', zip: '787935' },
	{ city: 'Foilagoule (Tipperary)', zip: '624750' },
	{ city: 'Foilakilly (Cork)', zip: '488841' },
	{ city: 'Foilatrisnig (Kerry)', zip: '490719' },
	{ city: 'Foildarg (Tipperary)', zip: '983388' },
	{ city: 'Foildarragh (Tipperary)', zip: '912330' },
	{ city: 'Foildarrig (Cork)', zip: '616117' },
	{ city: 'Foildarrig (Kerry)', zip: '891518' },
	{ city: 'Foildarrig (Tipperary)', zip: '584116' },
	{ city: 'Foildrenagh (Kerry)', zip: '718235' },
	{ city: 'Foilduff (Kerry)', zip: '598760' },
	{ city: 'Foilduff (Tipperary)', zip: '379693' },
	{ city: 'Foilmacduff (Tipperary)', zip: '682945' },
	{ city: 'Foilmahonmore (Tipperary)', zip: '366806' },
	{ city: 'Foilmarnell Lower (Tipperary)', zip: '882617' },
	{ city: 'Foilmarnell Upper (Tipperary)', zip: '997905' },
	{ city: 'Foilmore (Kerry)', zip: '100737' },
	{ city: 'Foilnacanony (Tipperary)', zip: '647636' },
	{ city: 'Foilnageragh (Kerry)', zip: '478325' },
	{ city: 'Foilnaman (Tipperary)', zip: '272883' },
	{ city: 'Foilnamuck (Cork)', zip: '886916' },
	{ city: 'Foilnamuck (Tipperary)', zip: '961727' },
	{ city: 'Foilogohig (Cork)', zip: '288984' },
	{ city: 'Foilrim (Clare)', zip: '649465' },
	{ city: 'Foilycleara (Limerick)', zip: '537235' },
	{ city: 'Foilycleary (Tipperary)', zip: '190456' },
	{ city: 'Folistown (Meath)', zip: '730783' },
	{ city: 'Folkstown Little (Dublin)', zip: '653584' },
	{ city: 'Follistown (Meath)', zip: '231496' },
	{ city: 'Folly (Dublin)', zip: '560496' },
	{ city: 'Fomerla (Clare)', zip: '254442' },
	{ city: 'Fonthill (Carlow)', zip: '528428' },
	{ city: 'Fonthill (Dublin)', zip: '919735' },
	{ city: 'Fontstown Lower (Kildare)', zip: '967790' },
	{ city: 'Fontstown Upper (Kildare)', zip: '106797' },
	{ city: 'Foohagh (Clare)', zip: '495765' },
	{ city: 'Foolagh (Galway)', zip: '455350' },
	{ city: 'Foorglass (Galway)', zip: '601355' },
	{ city: 'Footstown Great (Meath)', zip: '554712' },
	{ city: 'Footstown Little (Meath)', zip: '633957' },
	{ city: 'Ford Of Ling (Wexford)', zip: '266939' },
	{ city: 'Fordrath (Meath)', zip: '840445' },
	{ city: 'Fordstown (Meath)', zip: '748996' },
	{ city: 'Fore (Westmeath)', zip: '730653' },
	{ city: 'Forekill (Kilkenny)', zip: '903042' },
	{ city: 'Forelacka (Offaly)', zip: '593481' },
	{ city: 'Foremass (Monaghan)', zip: '253975' },
	{ city: 'Forenaght (Cork)', zip: '648704' },
	{ city: 'Forenaghts Great (Kildare)', zip: '286814' },
	{ city: 'Forenaghts Little (Kildare)', zip: '959229' },
	{ city: 'Forest (Kildare)', zip: '422315' },
	{ city: 'Forest (Laois)', zip: '209647' },
	{ city: 'Forest (Tipperary)', zip: '957631' },
	{ city: 'Forest (Wexford)', zip: '869443' },
	{ city: 'Forestalstown (Kilkenny)', zip: '832480' },
	{ city: 'Forest Lower (Laois)', zip: '754521' },
	{ city: 'Forest-Town (Cork)', zip: '583408' },
	{ city: 'Forest Upper (Laois)', zip: '625716' },
	{ city: 'Forestwood (Wexford)', zip: '864224' },
	{ city: 'Forgeland (Laois)', zip: '957989' },
	{ city: 'Forgelands (Wexford)', zip: '522121' },
	{ city: 'Forgestown (Tipperary)', zip: '631099' },
	{ city: 'Forgney (Longford)', zip: '145326' },
	{ city: 'Forkeala (Limerick)', zip: '375936' },
	{ city: 'Forkfield (Mayo)', zip: '276688' },
	{ city: 'Forkill (Meath)', zip: '652399' },
	{ city: 'Formal (Meath)', zip: '665181' },
	{ city: 'Formil (Monaghan)', zip: '613770' },
	{ city: 'Formoyle (Leitrim)', zip: '635968' },
	{ city: 'Formoyle (Longford)', zip: '815134' },
	{ city: 'Formoyle (Mayo)', zip: '269664' },
	{ city: 'Formoyle (Monaghan)', zip: '443053' },
	{ city: 'Formoyle (Sligo)', zip: '943272' },
	{ city: 'Formoyle Beg (Clare)', zip: '697984' },
	{ city: 'Formoyle East (Clare)', zip: '650444' },
	{ city: 'Formoyle Eighteragh (Clare)', zip: '514611' },
	{ city: 'Formoyle More (Clare)', zip: '561334' },
	{ city: 'Formoyle Oughteragh (Clare)', zip: '824701' },
	{ city: 'Formoyle West (Clare)', zip: '261987' },
	{ city: 'Formweel (Galway)', zip: '827256' },
	{ city: 'Fornaght (Cork)', zip: '410880' },
	{ city: 'Fornaght (Waterford)', zip: '227675' },
	{ city: 'Forquar (Donegal)', zip: '735133' },
	{ city: 'Forramoyle East (Galway)', zip: '474911' },
	{ city: 'Forramoyle West (Galway)', zip: '755413' },
	{ city: 'Forrestalstown (Wexford)', zip: '481237' },
	{ city: 'Forrestfields (Dublin)', zip: '595668' },
	{ city: 'Forrest Great (Dublin)', zip: '172737' },
	{ city: 'Forrest Little (Dublin)', zip: '598231' },
	{ city: 'Forrew (Mayo)', zip: '557279' },
	{ city: 'Forristeen (Wicklow)', zip: '278575' },
	{ city: 'Fortane Beg (Clare)', zip: '523935' },
	{ city: 'Fortane More (Clare)', zip: '697154' },
	{ city: 'Fortaugustus (Roscommon)', zip: '498868' },
	{ city: 'Fortbrown (Galway)', zip: '585248' },
	{ city: 'Fortchester Lower (Wexford)', zip: '979056' },
	{ city: 'Fortchester Upper (Wexford)', zip: '284252' },
	{ city: 'Fort East (Limerick)', zip: '945831' },
	{ city: 'Fortel (Offaly)', zip: '660311' },
	{ city: 'Fortetna (Limerick)', zip: '693704' },
	{ city: 'Fortfergus (Clare)', zip: '243702' },
	{ city: 'Fortgrady (Cork)', zip: '477094' },
	{ city: 'Fortgranite (Wicklow)', zip: '609245' },
	{ city: 'Forth Commons (Wexford)', zip: '548843' },
	{ city: 'Forthill (Cavan)', zip: '929979' },
	{ city: 'Forthill (Cork)', zip: '902309' },
	{ city: 'Forthill (Longford)', zip: '464942' },
	{ city: 'Forthill (Mayo)', zip: '448410' },
	{ city: 'Forties (Wexford)', zip: '996058' },
	{ city: 'Fortland (Cavan)', zip: '452402' },
	{ city: 'Fortland (Mayo)', zip: '169252' },
	{ city: 'Fortland (Sligo)', zip: '376094' },
	{ city: 'Fortlands (Cork)', zip: '551819' },
	{ city: 'Fortlawn (Mayo)', zip: '478510' },
	{ city: 'Fort Middle (Limerick)', zip: '736080' },
	{ city: 'Fortmoy (Tipperary)', zip: '716230' },
	{ city: 'Fortpark (Galway)', zip: '630121' },
	{ city: 'Fortstewart (Donegal)', zip: '340534' },
	{ city: 'Fortunestown (Dublin)', zip: '168342' },
	{ city: 'Fort West (Limerick)', zip: '381651' },
	{ city: 'Fortwilliam (Clare)', zip: '309719' },
	{ city: 'Fortwilliam (Kerry)', zip: '159414' },
	{ city: 'Fortwilliam (Longford)', zip: '723587' },
	{ city: 'Fortwilliam (Offaly)', zip: '723254' },
	{ city: 'Fortwilliam (Waterford)', zip: '462165' },
	{ city: 'Fortyacres (Cork)', zip: '339931' },
	{ city: 'Fortyacres (Dublin)', zip: '265987' },
	{ city: 'Fortyacres (Galway)', zip: '667894' },
	{ city: 'Fortyacres (Limerick)', zip: '704473' },
	{ city: 'Fortyacres (Offaly)', zip: '982628' },
	{ city: 'Fortyacres (Tipperary)', zip: '348535' },
	{ city: 'Fortyacres (Westmeath)', zip: '211085' },
	{ city: 'Fortyacres (Wexford)', zip: '778209' },
	{ city: 'Fossa (Kerry)', zip: '480664' },
	{ city: 'Fossa Beg (Clare)', zip: '819849' },
	{ city: 'Fossa More (Clare)', zip: '360729' },
	{ city: 'Fossy Lower (Laois)', zip: '148992' },
	{ city: 'Fossy Upper (Laois)', zip: '442976' },
	{ city: 'Fostersfields (Meath)', zip: '796932' },
	{ city: 'Fostersholding (Meath)', zip: '636277' },
	{ city: 'Fosterstown (Meath)', zip: '856755' },
	{ city: 'Fosterstown North (Dublin)', zip: '499071' },
	{ city: 'Fosterstown South (Dublin)', zip: '903285' },
	{ city: 'Fostragh (Longford)', zip: '934449' },
	{ city: 'Fostragh (Roscommon)', zip: '486462' },
	{ city: 'Fotish (Mayo)', zip: '375736' },
	{ city: 'Fough East (Galway)', zip: '670304' },
	{ city: 'Foughil (Roscommon)', zip: '318854' },
	{ city: 'Fough West (Galway)', zip: '952215' },
	{ city: 'Foulkesmill (Wexford)', zip: '342368' },
	{ city: 'Foulkscourt (Kilkenny)', zip: '801121' },
	{ city: 'Foulksrath (Kilkenny)', zip: '627629' },
	{ city: 'Foulkstown (Kilkenny)', zip: '689033' },
	{ city: 'Foulkstown (Tipperary)', zip: '146623' },
	{ city: 'Fountain (Clare)', zip: '545880' },
	{ city: 'Fountain (Waterford)', zip: '623702' },
	{ city: 'Fountainhill (Galway)', zip: '214155' },
	{ city: 'Fountainhill (Mayo)', zip: '733276' },
	{ city: 'Fountainstown (Cork)', zip: '208760' },
	{ city: 'Fountainstown North (Cork)', zip: '616794' },
	{ city: 'Fourcuil (Cork)', zip: '398470' },
	{ city: 'Fourknocks (Meath)', zip: '281860' },
	{ city: 'Four Mile House (Roscommon)', zip: '481350' },
	{ city: 'Four Roads (Roscommon)', zip: '186394' },
	{ city: 'Fowlerstown (Meath)', zip: '638316' },
	{ city: 'Foxandgeese (Clare)', zip: '999969' },
	{ city: 'Fox-And-Geese (Dublin)', zip: '791132' },
	{ city: 'Fox-And-Geese Common (Dublin)', zip: '546871' },
	{ city: 'Foxborough (Leitrim)', zip: '754306' },
	{ city: 'Foxborough (Roscommon)', zip: '588928' },
	{ city: 'Foxburrow (Laois)', zip: '881527' },
	{ city: 'Foxburrow (Offaly)', zip: '444081' },
	{ city: 'Foxburrow (Westmeath)', zip: '798906' },
	{ city: 'Foxcover (Kilkenny)', zip: '531310' },
	{ city: 'Foxcover (Wexford)', zip: '496435' },
	{ city: 'Foxford (Mayo)', zip: '800632' },
	{ city: 'Foxfort (Tipperary)', zip: '597294' },
	{ city: 'Fox & Geese (Dublin)', zip: '206116' },
	{ city: 'Foxhall (Cork)', zip: '973319' },
	{ city: 'Foxhall (Donegal)', zip: '914633' },
	{ city: 'Foxhall (Galway)', zip: '574046' },
	{ city: 'Foxhall (Longford)', zip: '787749' },
	{ city: 'Foxhall (Tipperary)', zip: '482171' },
	{ city: 'Foxhall East (Limerick)', zip: '868282' },
	{ city: 'Foxhall Glebe (Longford)', zip: '231292' },
	{ city: 'Foxhall Little (Galway)', zip: '414800' },
	{ city: 'Foxhall West (Limerick)', zip: '997133' },
	{ city: 'Foxhill (Kildare)', zip: '955423' },
	{ city: 'Foxhill (Roscommon)', zip: '147866' },
	{ city: 'Foxhole (Cork)', zip: '743097' },
	{ city: 'Foxhole (Monaghan)', zip: '579097' },
	{ city: 'Foxrock (Dublin)', zip: '833493' },
	{ city: "Fox's Castle (Waterford)", zip: '467658' },
	{ city: 'Foxtown (Meath)', zip: '642108' },
	{ city: 'Foy (Kildare)', zip: '494640' },
	{ city: 'Foyagh (Donegal)', zip: '213304' },
	{ city: 'Foyfin (Donegal)', zip: '932984' },
	{ city: 'Foygh (Longford)', zip: '358504' },
	{ city: 'Foylatalure (Kilkenny)', zip: '786444' },
	{ city: 'Foyle (Limerick)', zip: '918612' },
	{ city: 'Foyle North (Kilkenny)', zip: '691026' },
	{ city: 'Foyle South (Kilkenny)', zip: '341252' },
	{ city: 'Foynes (Limerick)', zip: '386848' },
	{ city: 'Foynes Island (Limerick)', zip: '593352' },
	{ city: 'Foyoges (Sligo)', zip: '372548' },
	{ city: 'Foyran (Westmeath)', zip: '797850' },
	{ city: 'Fraine (Meath)', zip: '797079' },
	{ city: 'France (Longford)', zip: '708897' },
	{ city: 'Franckfort (Offaly)', zip: '481715' },
	{ city: 'Frankford (Kilkenny)', zip: '150928' },
	{ city: 'Frankford (Offaly)', zip: '411517' },
	{ city: 'Frankford (Sligo)', zip: '420682' },
	{ city: 'Frankfort (Cork)', zip: '167235' },
	{ city: 'Frankfort (Limerick)', zip: '665745' },
	{ city: 'Frankfort (Wexford)', zip: '986293' },
	{ city: 'Frankfort East (Kilkenny)', zip: '475383' },
	{ city: 'Frankfort West (Kilkenny)', zip: '762985' },
	{ city: 'Frankstown (Meath)', zip: '158741' },
	{ city: 'Frasnadeffa (Roscommon)', zip: '875063' },
	{ city: 'Frass (Galway)', zip: '549940' },
	{ city: 'Fraugher (Donegal)', zip: '138071' },
	{ city: 'Freagh (Kildare)', zip: '303054' },
	{ city: 'Freagh (Meath)', zip: '108281' },
	{ city: 'Freagh (Offaly)', zip: '622858' },
	{ city: 'Freagh (Tipperary)', zip: '916672' },
	{ city: 'Freaghanagh (Kerry)', zip: '787978' },
	{ city: 'Freaghavaleen (Clare)', zip: '845671' },
	{ city: 'Freaghcastle (Clare)', zip: '724317' },
	{ city: 'Freaghduff (Tipperary)', zip: '644553' },
	{ city: 'Freaghillan (Mayo)', zip: '422104' },
	{ city: 'Freaghillaun (Galway)', zip: '350058' },
	{ city: 'Freaghillaun Beg (Galway)', zip: '892854' },
	{ city: 'Freaghillaun More (Galway)', zip: '494728' },
	{ city: 'Freaghillaun South (Galway)', zip: '343900' },
	{ city: 'Freaghmeen (Longford)', zip: '980764' },
	{ city: 'Freaghmore (Westmeath)', zip: '389953' },
	{ city: 'Freahanes (Cork)', zip: '651772' },
	{ city: 'Freame Mount Demesne (Monaghan)', zip: '518864' },
	{ city: 'Freeduff (Cavan)', zip: '186544' },
	{ city: 'Freehalman (Longford)', zip: '438090' },
	{ city: 'Freeheen (Mayo)', zip: '549234' },
	{ city: 'Freehold (Donegal)', zip: '435434' },
	{ city: 'Freemount (Cork)', zip: '671834' },
	{ city: 'Freemount (Kerry)', zip: '635540' },
	{ city: 'Freeport (Galway)', zip: '596619' },
	{ city: 'Freffans Great (Meath)', zip: '731460' },
	{ city: 'Freffans Little (Meath)', zip: '950698' },
	{ city: 'Frehans (Tipperary)', zip: '302402' },
	{ city: 'Fremagh (Monaghan)', zip: '406194' },
	{ city: 'Frenchbrook North (Mayo)', zip: '961574' },
	{ city: 'Frenchbrook South (Mayo)', zip: '132487' },
	{ city: 'Frenchfort (Galway)', zip: '759323' },
	{ city: 'Frenchfurze (Cork)', zip: '369266' },
	{ city: 'Frenchgrove (Mayo)', zip: '680977' },
	{ city: 'Frenchlawn (Roscommon)', zip: '512658' },
	{ city: 'Frenchpark (Galway)', zip: '734052' },
	{ city: 'Frenchpark (Roscommon)', zip: '873281' },
	{ city: 'Frenchpark Demesne (Roscommon)', zip: '360127' },
	{ city: 'Freneystown (Kilkenny)', zip: '669131' },
	{ city: 'Freshford (Kilkenny)', zip: '844875' },
	{ city: 'Freshford Lots (Kilkenny)', zip: '377463' },
	{ city: 'Frevanagh (Westmeath)', zip: '174918' },
	{ city: 'Freynestownhill (Wicklow)', zip: '309521' },
	{ city: 'Freynestown Lower (Wicklow)', zip: '597814' },
	{ city: 'Freynestown Upper (Wicklow)', zip: '117257' },
	{ city: 'Friarhill (Wicklow)', zip: '563939' },
	{ city: 'Friarland (Dublin)', zip: '647018' },
	{ city: 'Friarsbush (Donegal)', zip: '593491' },
	{ city: 'Friarsfield (Tipperary)', zip: '130170' },
	{ city: 'Friarsgrange (Tipperary)', zip: '340058' },
	{ city: 'Friarsground (Mayo)', zip: '790553' },
	{ city: 'Friarshill (Roscommon)', zip: '299288' },
	{ city: 'Friarshill (Wicklow)', zip: '960433' },
	{ city: 'Friarsinch (Kilkenny)', zip: '154129' },
	{ city: 'Friarsisland (Galway)', zip: '902728' },
	{ city: 'Friars Island (Galway)', zip: '956011' },
	{ city: 'Friars Island (Westmeath)', zip: '191677' },
	{ city: 'Friarsland (Galway)', zip: '393224' },
	{ city: 'Friarsland (Laois)', zip: '217588' },
	{ city: 'Friarspark (Meath)', zip: '630946' },
	{ city: 'Friarsquarter East (Mayo)', zip: '257145' },
	{ city: 'Friarsquarter West (Mayo)', zip: '506394' },
	{ city: 'Friarstown (Carlow)', zip: '762216' },
	{ city: 'Friarstown (Kildare)', zip: '552384' },
	{ city: 'Friarstown (Leitrim)', zip: '826872' },
	{ city: 'Friarstown (Limerick)', zip: '915852' },
	{ city: 'Friarstown (Mayo)', zip: '507336' },
	{ city: 'Friarstown (Westmeath)', zip: '652989' },
	{ city: 'Friarstown Lower (Dublin)', zip: '275257' },
	{ city: 'Friarstown North (Limerick)', zip: '846246' },
	{ city: 'Friarstown South (Limerick)', zip: '862448' },
	{ city: 'Friarstown Upper (Dublin)', zip: '184779' },
	{ city: 'Friary (Donegal)', zip: '596816' },
	{ city: 'Friary (Galway)', zip: '749228' },
	{ city: 'Friaryland (Meath)', zip: '562471' },
	{ city: 'Fringestown (Meath)', zip: '539965' },
	{ city: 'Froe (Cork)', zip: '386617' },
	{ city: 'Froghanstown (Westmeath)', zip: '974401' },
	{ city: 'Frolick (Tipperary)', zip: '775080' },
	{ city: 'Frosses (Donegal)', zip: '518699' },
	{ city: 'Fuddletown (Wexford)', zip: '624088' },
	{ city: 'Fuerty (Roscommon)', zip: '121220' },
	{ city: 'Fuhiry (Cork)', zip: '911454' },
	{ city: 'Fuhur (Cork)', zip: '621586' },
	{ city: 'Fulmort (Westmeath)', zip: '936142' },
	{ city: 'Funshadaun (Galway)', zip: '412903' },
	{ city: 'Funshin (Galway)', zip: '277067' },
	{ city: 'Funshinagh (Leitrim)', zip: '100164' },
	{ city: 'Funshinagh (Roscommon)', zip: '460842' },
	{ city: 'Funshinaugh (Mayo)', zip: '134618' },
	{ city: 'Funshin Beg (Galway)', zip: '778780' },
	{ city: 'Funshin More (Galway)', zip: '164182' },
	{ city: 'Funshog (Louth)', zip: '658966' },
	{ city: 'Funshoge (Wexford)', zip: '139420' },
	{ city: 'Furboghgarve (Galway)', zip: '109721' },
	{ city: 'Furgill (Mayo)', zip: '138147' },
	{ city: 'Furhane (Kerry)', zip: '165701' },
	{ city: 'Furhee (Clare)', zip: '654020' },
	{ city: 'Furkeal (Cork)', zip: '785697' },
	{ city: 'Furlongstown (Wexford)', zip: '259426' },
	{ city: 'Furnace (Clare)', zip: '538675' },
	{ city: 'Furnace (Galway)', zip: '104148' },
	{ city: 'Furnace (Leitrim)', zip: '822528' },
	{ city: 'Furnace (Mayo)', zip: '518801' },
	{ city: 'Furnaceland (Cavan)', zip: '294072' },
	{ city: 'Furraglaun (Clare)', zip: '165229' },
	{ city: 'Furraleigh (Waterford)', zip: '223621' },
	{ city: 'Furroor (Clare)', zip: '227523' },
	{ city: 'Furroor Lower (Clare)', zip: '744889' },
	{ city: 'Furroor Upper (Clare)', zip: '732601' },
	{ city: 'Furrow (Cork)', zip: '108222' },
	{ city: 'Furryhill (Kildare)', zip: '929788' },
	{ city: 'Furze (Longford)', zip: '501941' },
	{ city: 'Furze (Tipperary)', zip: '973258' },
	{ city: 'Furzeditch East (Wicklow)', zip: '662148' },
	{ city: 'Furzeditch West (Wicklow)', zip: '685174' },
	{ city: 'Furzehouse (Kilkenny)', zip: '603367' },
	{ city: 'Furziestown (Wexford)', zip: '104888' },
	{ city: 'Furzyhill (Meath)', zip: '886391' },
	{ city: 'Furzypark (Galway)', zip: '142080' },
	{ city: 'Fussa (Kerry)', zip: '710749' },
	{ city: 'Fussough (Tipperary)', zip: '156781' },
	{ city: 'Fustane Lower (Kerry)', zip: '935641' },
	{ city: 'Fustane Upper (Kerry)', zip: '422834' },
	{ city: 'Fyanstown (Meath)', zip: '271163' },
	{ city: 'Fybagh (Kerry)', zip: '357907' },
	{ city: 'Fycorranagh (Donegal)', zip: '256938' },
	{ city: 'Fynagh (Galway)', zip: '528667' },
	{ city: 'Gaddaghanstown (Westmeath)', zip: '871531' },
	{ city: 'Gaddan (Sligo)', zip: '768897' },
	{ city: 'Gaddan Beg (Sligo)', zip: '986466' },
	{ city: 'Gaddrystown (Westmeath)', zip: '533784' },
	{ city: 'Gaddyduff (Donegal)', zip: '334240' },
	{ city: 'Gafney (Meath)', zip: '838236' },
	{ city: 'Gafney Little (Meath)', zip: '394317' },
	{ city: 'Gaganstown (Kildare)', zip: '466136' },
	{ city: 'Gaggan (Cork)', zip: '520388' },
	{ city: 'Gaghta Island (Mayo)', zip: '423679' },
	{ city: 'Gaigue (Longford)', zip: '455303' },
	{ city: 'Gaile (Tipperary)', zip: '137486' },
	{ city: 'Gainestown (Westmeath)', zip: '765586' },
	{ city: 'Gainstown (Meath)', zip: '378064' },
	{ city: 'Gainstown Upper (Louth)', zip: '911915' },
	{ city: 'Gairha (Waterford)', zip: '134939' },
	{ city: 'Galbally (Limerick)', zip: '837593' },
	{ city: 'Galbally (Offaly)', zip: '601971' },
	{ city: 'Galbally (Wexford)', zip: '813279' },
	{ city: 'Galballybeg (Wexford)', zip: '407813' },
	{ city: 'Galbally East (Wexford)', zip: '943339' },
	{ city: 'Galbally North (Wexford)', zip: '254472' },
	{ city: 'Galbally West (Wexford)', zip: '775545' },
	{ city: 'Galbertstown Lower (Tipperary)', zip: '468236' },
	{ city: 'Galbertstown Upper (Tipperary)', zip: '988541' },
	{ city: 'Galboley (Galway)', zip: '726864' },
	{ city: 'Galbolie (Cavan)', zip: '248234' },
	{ city: 'Galboola (Limerick)', zip: '231887' },
	{ city: 'Galbooly (Tipperary)', zip: '116090' },
	{ city: 'Galbooly Little (Tipperary)', zip: '274611' },
	{ city: 'Galboystown (Meath)', zip: '165637' },
	{ city: 'Galdonagh (Donegal)', zip: '338779' },
	{ city: 'Galdonagh Glebe (Donegal)', zip: '755205' },
	{ city: 'Galesquarter (Laois)', zip: '774187' },
	{ city: 'Galey (Roscommon)', zip: '977713' },
	{ city: 'Galeybeg (Roscommon)', zip: '442615' },
	{ city: 'Galgystown (Wexford)', zip: '921259' },
	{ city: 'Gallagh (Galway)', zip: '236555' },
	{ city: 'Gallagh (Louth)', zip: '127225' },
	{ city: 'Gallagh (Mayo)', zip: '595353' },
	{ city: 'Gallagh (Monaghan)', zip: '533535' },
	{ city: 'Gallagh (Roscommon)', zip: '374721' },
	{ city: 'Gallagh (Wexford)', zip: '813972' },
	{ city: 'Gallanagh (Monaghan)', zip: '360448' },
	{ city: 'Gallane (Cork)', zip: '460338' },
	{ city: 'Gallanes (Cork)', zip: '695433' },
	{ city: 'Gallanstown (Dublin)', zip: '259395' },
	{ city: 'Gallarus (Kerry)', zip: '483057' },
	{ city: 'Gallavally (Kerry)', zip: '540534' },
	{ city: 'Galleastown (Meath)', zip: '228220' },
	{ city: 'Gallen (Offaly)', zip: '775707' },
	{ city: 'Gallgort (Mayo)', zip: '634418' },
	{ city: 'Gallid (Longford)', zip: '919326' },
	{ city: 'Gallon (Cavan)', zip: '956263' },
	{ city: 'Gallonbane (Cavan)', zip: '312013' },
	{ city: 'Gallonboy (Cavan)', zip: '822069' },
	{ city: 'Gallonbulloge (Cavan)', zip: '966161' },
	{ city: 'Galloncurra (Cavan)', zip: '592568' },
	{ city: 'Gallon Etra (Cavan)', zip: '141973' },
	{ city: 'Gallon Glebe (Cavan)', zip: '230348' },
	{ city: 'Gallonnambraher (Cavan)', zip: '922017' },
	{ city: 'Gallonreagh (Cavan)', zip: '576155' },
	{ city: 'Galloping Green North (Dublin)', zip: '982336' },
	{ city: 'Galloping Green South (Dublin)', zip: '951813' },
	{ city: 'Gallow (Meath)', zip: '603749' },
	{ city: 'Gallowsfields (Kerry)', zip: '420898' },
	{ city: 'Gallowshill (Clare)', zip: '425970' },
	{ city: 'Gallowshill (Kildare)', zip: '189396' },
	{ city: 'Gallowshill (Kilkenny)', zip: '769966' },
	{ city: 'Gallowshill (Waterford)', zip: '542364' },
	{ city: 'Gallstown (Louth)', zip: '544283' },
	{ city: 'Gallstown (Westmeath)', zip: '259526' },
	{ city: 'Galmoy (Kilkenny)', zip: '222714' },
	{ city: 'Galmoylestown Lower (Westmeath)', zip: '400266' },
	{ city: 'Galmoylestown Upper (Westmeath)', zip: '834077' },
	{ city: 'Galmoystown (Meath)', zip: '441412' },
	{ city: 'Galroostown (Louth)', zip: '861994' },
	{ city: 'Galros (Offaly)', zip: '691120' },
	{ city: 'Galros East (Offaly)', zip: '639580' },
	{ city: 'Galros West (Offaly)', zip: '812235' },
	{ city: 'Galtrim (Meath)', zip: '787001' },
	{ city: 'Galtrimsland (Louth)', zip: '642312' },
	{ city: 'Galvone (Limerick)', zip: '960362' },
	{ city: 'Galway (Galway)', zip: '833060' },
	{ city: 'Galway (Limerick)', zip: '756770' },
	{ city: 'Galwolie (Donegal)', zip: '603157' },
	{ city: 'Gammonsfield (Tipperary)', zip: '777298' },
	{ city: 'Ganaveens (Roscommon)', zip: '183113' },
	{ city: 'Ganderstown (Louth)', zip: '547054' },
	{ city: 'Gannavagh (Leitrim)', zip: '771657' },
	{ city: 'Gannavane (Limerick)', zip: '889706' },
	{ city: 'Gannavane Upper (Limerick)', zip: '778270' },
	{ city: 'Gannaveen (Galway)', zip: '700355' },
	{ city: 'Gannew And Curreen (Donegal)', zip: '825959' },
	{ city: 'Ganniv Beg (Cork)', zip: '334277' },
	{ city: 'Ganniv More (Cork)', zip: '541729' },
	{ city: 'Gannoughs (Galway)', zip: '864089' },
	{ city: 'Gannow (Galway)', zip: '202622' },
	{ city: 'Ganty (Galway)', zip: '617787' },
	{ city: 'Garadice (Leitrim)', zip: '809359' },
	{ city: 'Garadice (Meath)', zip: '437605' },
	{ city: 'Garballagh (Meath)', zip: '493831' },
	{ city: 'Garbally (Galway)', zip: '279004' },
	{ city: 'Garbally (Limerick)', zip: '984347' },
	{ city: 'Garbally (Offaly)', zip: '518909' },
	{ city: 'Garbally Demesne (Galway)', zip: '660814' },
	{ city: 'Gardamus Great (Wexford)', zip: '987389' },
	{ city: 'Gardamus Little (Wexford)', zip: '903779' },
	{ city: 'Gardeen (Cork)', zip: '167122' },
	{ city: 'Gardenblake (Galway)', zip: '904898' },
	{ city: 'Gardenblake Commons (Galway)', zip: '370789' },
	{ city: 'Gardenershill (Dublin)', zip: '801490' },
	{ city: 'Gardenfield (Galway)', zip: '222751' },
	{ city: 'Gardenfield (Limerick)', zip: '483802' },
	{ city: 'Gardenfield East (Limerick)', zip: '444355' },
	{ city: 'Gardenfield South (Limerick)', zip: '790648' },
	{ city: 'Gardenfield West (Limerick)', zip: '130959' },
	{ city: 'Gardenham (Galway)', zip: '190204' },
	{ city: 'Gardenhill (Limerick)', zip: '765734' },
	{ city: 'Gardenmorris (Waterford)', zip: '409766' },
	{ city: 'Gardenrath (Meath)', zip: '451588' },
	{ city: 'Gardens (Kilkenny)', zip: '577367' },
	{ city: 'Gardentown (Roscommon)', zip: '114548' },
	{ city: 'Garfinny (Kerry)', zip: '112619' },
	{ city: 'Garfiny (Cavan)', zip: '807317' },
	{ city: 'Gargrim (Donegal)', zip: '117135' },
	{ city: 'Gargrim (Leitrim)', zip: '198456' },
	{ city: 'Garhawnagh (Mayo)', zip: '608717' },
	{ city: 'Garhy (Westmeath)', zip: '298823' },
	{ city: 'Garinish (Cork)', zip: '772026' },
	{ city: 'Garinish (Kerry)', zip: '338308' },
	{ city: 'Garistown (Meath)', zip: '580085' },
	{ city: 'Garland (Cork)', zip: '450332' },
	{ city: 'Garlegobban (Monaghan)', zip: '714340' },
	{ city: 'Garmanagh (Meath)', zip: '195024' },
	{ city: 'Garnagale (Kilkenny)', zip: '208222' },
	{ city: 'Garnagowlan (Wicklow)', zip: '767680' },
	{ city: 'Garnakill (Wexford)', zip: '278653' },
	{ city: 'Garnavilla (Tipperary)', zip: '652817' },
	{ city: 'Garoke (Sligo)', zip: '756144' },
	{ city: 'Garr (Offaly)', zip: '541278' },
	{ city: 'Garr (Wexford)', zip: '833430' },
	{ city: 'Garra (Galway)', zip: '181472' },
	{ city: 'Garra (Wexford)', zip: '339748' },
	{ city: 'Garracloon (Clare)', zip: '225481' },
	{ city: 'Garracloon (Galway)', zip: '898870' },
	{ city: 'Garracloon (Mayo)', zip: '646959' },
	{ city: 'Garracloon North (Galway)', zip: '640897' },
	{ city: 'Garracloon South (Galway)', zip: '320362' },
	{ city: 'Garracummer (Tipperary)', zip: '740440' },
	{ city: 'Garradevlin (Monaghan)', zip: '455607' },
	{ city: 'Garradreen (Wexford)', zip: '445336' },
	{ city: 'Garra East (Waterford)', zip: '569144' },
	{ city: 'Garrafin (Laois)', zip: '137581' },
	{ city: 'Garrafine (Galway)', zip: '194838' },
	{ city: 'Garrafrauns (Galway)', zip: '540360' },
	{ city: 'Garraghill (Mayo)', zip: '130024' },
	{ city: 'Garragort (Cork)', zip: '202006' },
	{ city: 'Garraha (Cork)', zip: '547891' },
	{ city: 'Garrahadoo (Kerry)', zip: '190572' },
	{ city: 'Garrahies (Kerry)', zip: '792739' },
	{ city: 'Garrahylish (Waterford)', zip: '739311' },
	{ city: 'Garralacka (Cork)', zip: '750630' },
	{ city: 'Garran (Monaghan)', zip: '848752' },
	{ city: 'Garranabraher (Cork)', zip: '858621' },
	{ city: 'Garranacanty (Tipperary)', zip: '488049' },
	{ city: 'Garranachole (Cork)', zip: '962516' },
	{ city: 'Garranacleary (Tipperary)', zip: '701134' },
	{ city: 'Garranacool (Tipperary)', zip: '411581' },
	{ city: 'Garranagerra (Mayo)', zip: '277634' },
	{ city: 'Garranagoleen (Cork)', zip: '464384' },
	{ city: 'Garranakeevin (Tipperary)', zip: '827013' },
	{ city: 'Garranakilka (Tipperary)', zip: '361756' },
	{ city: 'Garranamanagh (Kilkenny)', zip: '440687' },
	{ city: 'Garrananaspick (Waterford)', zip: '888417' },
	{ city: 'Garrananassig (Cork)', zip: '243873' },
	{ city: 'Garranard (Limerick)', zip: '478697' },
	{ city: 'Garranard (Mayo)', zip: '348513' },
	{ city: 'Garranashingaun (Tipperary)', zip: '571640' },
	{ city: 'Garranbane (Limerick)', zip: '114397' },
	{ city: 'Garranbaun (Cork)', zip: '742931' },
	{ city: 'Garranbaun (Laois)', zip: '415208' },
	{ city: 'Garranbaun (Waterford)', zip: '262866' },
	{ city: 'Garranbeg (Cork)', zip: '130181' },
	{ city: 'Garranbeg (Tipperary)', zip: '972795' },
	{ city: 'Garranbehy Big (Kilkenny)', zip: '842388' },
	{ city: 'Garranbehy Little (Kilkenny)', zip: '506953' },
	{ city: 'Garranboy (Longford)', zip: '474864' },
	{ city: 'Garrancasey (Tipperary)', zip: '753939' },
	{ city: 'Garrancloyne (Cork)', zip: '968768' },
	{ city: 'Garranconnell (Kilkenny)', zip: '713869' },
	{ city: 'Garrandarragh (Kilkenny)', zip: '715064' },
	{ city: 'Garrandee (Tipperary)', zip: '439776' },
	{ city: 'Garrandillon (Tipperary)', zip: '783011' },
	{ city: 'Garrane (Cork)', zip: '112609' },
	{ city: 'Garrane (Kerry)', zip: '432390' },
	{ city: 'Garrane (Limerick)', zip: '263224' },
	{ city: 'Garrane (Tipperary)', zip: '246925' },
	{ city: 'Garrane (Westmeath)', zip: '957403' },
	{ city: 'Garraneanasig (Cork)', zip: '220903' },
	{ city: 'Garranearagh (Kerry)', zip: '776049' },
	{ city: 'Garraneard (Cork)', zip: '450209' },
	{ city: 'Garranebane (Kerry)', zip: '935828' },
	{ city: 'Garrane Beg (Limerick)', zip: '421502' },
	{ city: 'Garraneboy (Cork)', zip: '999054' },
	{ city: 'Garranecore (Cork)', zip: '949924' },
	{ city: 'Garranedarragh (Cork)', zip: '707267' },
	{ city: 'Garraneduff (Cork)', zip: '910632' },
	{ city: 'Garrane East (Kerry)', zip: '775213' },
	{ city: 'Garranefeen (Cork)', zip: '822473' },
	{ city: 'Garraneishal (Cork)', zip: '860623' },
	{ city: 'Garranejames (Cork)', zip: '546748' },
	{ city: 'Garranekeagh (Limerick)', zip: '298251' },
	{ city: 'Garranekeevan (Limerick)', zip: '112147' },
	{ city: 'Garranekinnefeake (Cork)', zip: '629180' },
	{ city: 'Garranelahan (Cork)', zip: '346745' },
	{ city: 'Garraneleigh (Cork)', zip: '737932' },
	{ city: 'Garrane More (Limerick)', zip: '830479' },
	{ city: 'Garranenagappul (Cork)', zip: '828839' },
	{ city: 'Garranenageevoge (Cork)', zip: '601973' },
	{ city: 'Garranenamuddagh (Cork)', zip: '601374' },
	{ city: 'Garrane North (Cork)', zip: '243363' },
	{ city: 'Garrane North (Kerry)', zip: '789049' },
	{ city: 'Garranereagh (Cork)', zip: '455370' },
	{ city: 'Garraneribbeen (Cork)', zip: '218974' },
	{ city: 'Garranes (Cork)', zip: '687910' },
	{ city: 'Garranes (Kerry)', zip: '762883' },
	{ city: 'Garranes North (Cork)', zip: '451818' },
	{ city: 'Garrane South (Cork)', zip: '355702' },
	{ city: 'Garrane South (Kerry)', zip: '416533' },
	{ city: 'Garranes South (Cork)', zip: '956703' },
	{ city: 'Garranewaterig (Cork)', zip: '714904' },
	{ city: 'Garrane West (Cork)', zip: '182413' },
	{ city: 'Garrane West (Kerry)', zip: '135538' },
	{ city: 'Garraneycarney (Cork)', zip: '287021' },
	{ city: 'Garrangibbon (Tipperary)', zip: '940332' },
	{ city: 'Garrangrena Lower (Tipperary)', zip: '507481' },
	{ city: 'Garrangrena Upper (Tipperary)', zip: '335709' },
	{ city: 'Garranhalloo (Kilkenny)', zip: '726385' },
	{ city: 'Garran Itra (Monaghan)', zip: '672054' },
	{ city: 'Garrankeel (Mayo)', zip: '873535' },
	{ city: 'Garrankesh (Westmeath)', zip: '537836' },
	{ city: 'Garrankyle (Tipperary)', zip: '401792' },
	{ city: 'Garrankyle East (Galway)', zip: '720955' },
	{ city: 'Garrankyle West (Galway)', zip: '329768' },
	{ city: 'Garranlahan (Roscommon)', zip: '486038' },
	{ city: 'Garranlahan Beg (Roscommon)', zip: '408912' },
	{ city: 'Garranlahan More (Roscommon)', zip: '370591' },
	{ city: 'Garranlea (Tipperary)', zip: '722061' },
	{ city: 'Garranmacgarrett (Cork)', zip: '749129' },
	{ city: 'Garranmachenry (Kilkenny)', zip: '778080' },
	{ city: 'Garranmaconly (Laois)', zip: '608974' },
	{ city: 'Garranmillon Lower (Waterford)', zip: '112765' },
	{ city: 'Garranmillon Upper (Waterford)', zip: '569178' },
	{ city: 'Garranmore (Tipperary)', zip: '404489' },
	{ city: 'Garrannafulla (Kerry)', zip: '478955' },
	{ city: 'Garrannaguilly (Kilkenny)', zip: '299822' },
	{ city: 'Garran Otra (Monaghan)', zip: '659264' },
	{ city: 'Garranrobin (Kilkenny)', zip: '673122' },
	{ city: 'Garranroe (Limerick)', zip: '278589' },
	{ city: 'Garranroe (Monaghan)', zip: '352830' },
	{ city: 'Garranroe (Tipperary)', zip: '778854' },
	{ city: 'Garrans (Laois)', zip: '862957' },
	{ city: 'Garransilly (Tipperary)', zip: '384696' },
	{ city: 'Garranstackle (Wexford)', zip: '131654' },
	{ city: 'Garranstan (Kilkenny)', zip: '692805' },
	{ city: 'Garranswood (Dublin)', zip: '226608' },
	{ city: 'Garranthurles (Tipperary)', zip: '135038' },
	{ city: 'Garrantrowlan (Wexford)', zip: '912408' },
	{ city: 'Garranturton (Waterford)', zip: '626778' },
	{ city: 'Garranty (Mayo)', zip: '693817' },
	{ city: 'Garranure (Cork)', zip: '436231' },
	{ city: 'Garranvabby (Kilkenny)', zip: '608835' },
	{ city: 'Garraree (Westmeath)', zip: '998578' },
	{ city: 'Garrarus (Waterford)', zip: '420091' },
	{ city: 'Garraun (Clare)', zip: '251212' },
	{ city: 'Garraun (Galway)', zip: '257172' },
	{ city: 'Garraun (Kerry)', zip: '686683' },
	{ city: 'Garraun (Kilkenny)', zip: '266765' },
	{ city: 'Garraun (Limerick)', zip: '562247' },
	{ city: 'Garraun (Mayo)', zip: '644640' },
	{ city: 'Garraun (Tipperary)', zip: '588392' },
	{ city: 'Garraun (Waterford)', zip: '703070' },
	{ city: 'Garraun (Wexford)', zip: '681282' },
	{ city: 'Garraunanearla (Tipperary)', zip: '899720' },
	{ city: 'Garraunard (Galway)', zip: '171850' },
	{ city: 'Garraunard (Mayo)', zip: '147580' },
	{ city: 'Garraunawarrig Lower (Cork)', zip: '978175' },
	{ city: 'Garraunawarrig Upper (Cork)', zip: '473291' },
	{ city: 'Garraunbaun (Galway)', zip: '826557' },
	{ city: 'Garraunbeg (Tipperary)', zip: '342259' },
	{ city: 'Garraun Beg (Galway)', zip: '214263' },
	{ city: 'Garraun Beg (Kerry)', zip: '421700' },
	{ city: 'Garraunboy (Clare)', zip: '558143' },
	{ city: 'Garraunboy (Limerick)', zip: '710688' },
	{ city: 'Garrauncreen (Galway)', zip: '952607' },
	{ city: 'Garraundarragh (Kerry)', zip: '265626' },
	{ city: 'Garraunfadda (Tipperary)', zip: '709427' },
	{ city: 'Garraunfadda (Waterford)', zip: '970933' },
	{ city: 'Garraunigerinagh (Cork)', zip: '755348' },
	{ city: 'Garraun Lower (Galway)', zip: '329684' },
	{ city: 'Garraun Lower (Wexford)', zip: '313231' },
	{ city: 'Garraunmore (Galway)', zip: '757409' },
	{ city: 'Garraun More (Galway)', zip: '624917' },
	{ city: 'Garraun More (Kerry)', zip: '495024' },
	{ city: 'Garraunnameetagh (Galway)', zip: '878732' },
	{ city: 'Garraunnatooha (Clare)', zip: '806762' },
	{ city: 'Garraun North (Cork)', zip: '327315' },
	{ city: 'Garraun North (Galway)', zip: '475443' },
	{ city: 'Garraun North (Roscommon)', zip: '628818' },
	{ city: 'Garraunorish (Tipperary)', zip: '609013' },
	{ city: 'Garraunphaudeen (Galway)', zip: '278018' },
	{ city: 'Garraunredmond (Cork)', zip: '335048' },
	{ city: 'Garrauns (Galway)', zip: '503303' },
	{ city: 'Garraun South (Cork)', zip: '925241' },
	{ city: 'Garraun South (Galway)', zip: '785563' },
	{ city: 'Garraun South (Roscommon)', zip: '493298' },
	{ city: 'Garraunteefineen (Cork)', zip: '257306' },
	{ city: 'Garraun Upper (Galway)', zip: '650631' },
	{ city: 'Garraun Upper (Waterford)', zip: '447186' },
	{ city: 'Garraun Upper (Wexford)', zip: '885607' },
	{ city: 'Garraunykee (Limerick)', zip: '841709' },
	{ city: 'Garravagh (Cork)', zip: '627040' },
	{ city: 'Garravally (Tipperary)', zip: '401469' },
	{ city: 'Garraveasoge (Cork)', zip: '777531' },
	{ city: 'Garravesoge (Cork)', zip: '935083' },
	{ city: 'Garravin (Limerick)', zip: '716153' },
	{ city: 'Garravlagh (Mayo)', zip: '671288' },
	{ city: 'Garravoone (Waterford)', zip: '177530' },
	{ city: 'Garra West (Waterford)', zip: '210909' },
	{ city: 'Garreenleen (Carlow)', zip: '960681' },
	{ city: 'Garreens (Mayo)', zip: '770831' },
	{ city: 'Garreer (Galway)', zip: '370524' },
	{ city: 'Garreiny (Kerry)', zip: '984247' },
	{ city: 'Garrendenny (Laois)', zip: '490504' },
	{ city: 'Garretstown (Meath)', zip: '610704' },
	{ city: 'Garrettstown (Carlow)', zip: '478583' },
	{ city: 'Garrettstown (Cork)', zip: '653753' },
	{ city: 'Garries (Kerry)', zip: '581430' },
	{ city: 'Garrifly (Monaghan)', zip: '334268' },
	{ city: 'Garrinch (Tipperary)', zip: '657558' },
	{ city: 'Garrincreen (Kilkenny)', zip: '528499' },
	{ city: 'Garrintaggart (Laois)', zip: '651490' },
	{ city: 'Garrisker (Kildare)', zip: '131183' },
	{ city: 'Garriskil (Westmeath)', zip: '484849' },
	{ city: 'Garrison (Cavan)', zip: '150772' },
	{ city: 'Garrison (Cork)', zip: '826313' },
	{ city: 'Garrison (Galway)', zip: '580733' },
	{ city: 'Garrison (Laois)', zip: '416198' },
	{ city: 'Garrison (Limerick)', zip: '428273' },
	{ city: 'Garrison (Waterford)', zip: '201084' },
	{ city: 'Garrison (Wexford)', zip: '229257' },
	{ city: 'Garrisonhill (Donegal)', zip: '449533' },
	{ city: 'Garristown (Dublin)', zip: '286663' },
	{ city: 'Garrivinnagh (Galway)', zip: '407572' },
	{ city: 'Garrolagh (Louth)', zip: '585037' },
	{ city: 'Garroman (Galway)', zip: '955347' },
	{ city: 'Garroon (Laois)', zip: '177955' },
	{ city: 'Garroonagh (Laois)', zip: '652783' },
	{ city: 'Garroose (Limerick)', zip: '876684' },
	{ city: 'Garrough (Kerry)', zip: '560919' },
	{ city: 'Garrough (Laois)', zip: '884052' },
	{ city: 'Garrow (Mayo)', zip: '188984' },
	{ city: 'Garrow (Roscommon)', zip: '948964' },
	{ city: 'Garrowcarry (Donegal)', zip: '119489' },
	{ city: 'Garrowchuill (Donegal)', zip: '785377' },
	{ city: 'Garrowhill (Longford)', zip: '140453' },
	{ city: 'Garrowlougher (Roscommon)', zip: '125349' },
	{ city: 'Garruragh (Clare)', zip: '895546' },
	{ city: 'Garryad And Garryduff (Galway)', zip: '308026' },
	{ city: 'Garryadeen (Cork)', zip: '101207' },
	{ city: 'Garryandrew (Longford)', zip: '154823' },
	{ city: 'Garryandrew North (Tipperary)', zip: '357313' },
	{ city: 'Garryandrew South (Tipperary)', zip: '791729' },
	{ city: 'Garryantaggart (Cork)', zip: '999193' },
	{ city: 'Garryantanvally (Kerry)', zip: '791032' },
	{ city: 'Garryantornora (Cork)', zip: '597884' },
	{ city: 'Garryard (Kerry)', zip: '440348' },
	{ city: 'Garryard (Tipperary)', zip: '586325' },
	{ city: 'Garryard East (Tipperary)', zip: '766086' },
	{ city: 'Garryard West (Tipperary)', zip: '281171' },
	{ city: 'Garryarthur (Limerick)', zip: '655675' },
	{ city: 'Garrybane (Monaghan)', zip: '511740' },
	{ city: 'Garrybaun (Cork)', zip: '332638' },
	{ city: 'Garrybaun (Tipperary)', zip: '235128' },
	{ city: 'Garryboghala (Galway)', zip: '392868' },
	{ city: 'Garrybran (Wexford)', zip: '754732' },
	{ city: 'Garrybrit Lower (Wexford)', zip: '420732' },
	{ city: 'Garrybrittas (Waterford)', zip: '936579' },
	{ city: 'Garrybrit Upper (Wexford)', zip: '981369' },
	{ city: 'Garrycaheragh (Cork)', zip: '677420' },
	{ city: 'Garrycam (Longford)', zip: '616247' },
	{ city: 'Garrycastle (Offaly)', zip: '916510' },
	{ city: 'Garrycastle (Westmeath)', zip: '831156' },
	{ city: 'Garrycleary (Wexford)', zip: '629144' },
	{ city: 'Garryclogh (Tipperary)', zip: '351074' },
	{ city: 'Garryclogher (Tipperary)', zip: '544759' },
	{ city: 'Garrycloher (Tipperary)', zip: '139202' },
	{ city: 'Garryclohy (Tipperary)', zip: '852522' },
	{ city: 'Garryclone (Waterford)', zip: '805795' },
	{ city: 'Garrycloonagh (Mayo)', zip: '143761' },
	{ city: 'Garrycloyne (Cork)', zip: '254666' },
	{ city: 'Garrycloyne (Waterford)', zip: '737202' },
	{ city: 'Garryconnell (Longford)', zip: '629763' },
	{ city: 'Garrycullen (Wexford)', zip: '417500' },
	{ city: 'Garrydague (Kilkenny)', zip: '854851' },
	{ city: 'Garrydaniel (Wexford)', zip: '775255' },
	{ city: 'Garrydine (Kerry)', zip: '833442' },
	{ city: 'Garrydoolis (Limerick)', zip: '486886' },
	{ city: 'Garryduff (Cork)', zip: '476227' },
	{ city: 'Garryduff (Galway)', zip: '868558' },
	{ city: 'Garryduff (Kilkenny)', zip: '292559' },
	{ city: 'Garryduff (Laois)', zip: '945326' },
	{ city: 'Garryduff (Limerick)', zip: '410065' },
	{ city: 'Garryduff (Mayo)', zip: '888769' },
	{ city: 'Garryduff (Monaghan)', zip: '523360' },
	{ city: 'Garryduff (Sligo)', zip: '759614' },
	{ city: 'Garryduff (Tipperary)', zip: '275632' },
	{ city: 'Garryduff (Waterford)', zip: '997653' },
	{ city: 'Garryduff (Westmeath)', zip: '592401' },
	{ city: 'Garryduff (Wexford)', zip: '187538' },
	{ city: 'Garryduff (Wicklow)', zip: '682604' },
	{ city: 'Garryduff East (Tipperary)', zip: '697480' },
	{ city: 'Garryduff Middle (Mayo)', zip: '222368' },
	{ city: 'Garryduff North (Mayo)', zip: '319818' },
	{ city: 'Garryduff South (Mayo)', zip: '639084' },
	{ city: 'Garryduff West (Mayo)', zip: '684731' },
	{ city: 'Garryduff West (Tipperary)', zip: '618745' },
	{ city: 'Garryeighter (Clare)', zip: '918214' },
	{ city: 'Garryellen (Limerick)', zip: '231244' },
	{ city: 'Garryfine (Limerick)', zip: '218812' },
	{ city: 'Garryfliugh (Cavan)', zip: '608009' },
	{ city: 'Garryfrask (Limerick)', zip: '807255' },
	{ city: 'Garrygaug (Kilkenny)', zip: '237459' },
	{ city: 'Garrygibbon (Wexford)', zip: '818613' },
	{ city: 'Garryglass (Cork)', zip: '357240' },
	{ city: 'Garryglass (Kerry)', zip: '522341' },
	{ city: 'Garryglass (Laois)', zip: '102151' },
	{ city: 'Garryglass (Limerick)', zip: '554696' },
	{ city: 'Garryglass (Roscommon)', zip: '736515' },
	{ city: 'Garryglass (Tipperary)', zip: '498398' },
	{ city: 'Garrygort (Donegal)', zip: '542868' },
	{ city: 'Garryhack (Wexford)', zip: '989955' },
	{ city: 'Garryhankard (Cork)', zip: '665036' },
	{ city: 'Garryhasten (Wexford)', zip: '629913' },
	{ city: 'Garryheakin (Limerick)', zip: '887861' },
	{ city: 'Garryheakin (Tipperary)', zip: '903958' },
	{ city: 'Garryhedder (Laois)', zip: '386599' },
	{ city: 'Garryhesty (Cork)', zip: '918812' },
	{ city: 'Garryhiggin (Kilkenny)', zip: '363428' },
	{ city: 'Garryhill (Carlow)', zip: '672010' },
	{ city: 'Garryhinch (Offaly)', zip: '616882' },
	{ city: 'Garryhintoge (Cork)', zip: '714319' },
	{ city: 'Garryhoe (Wicklow)', zip: '401768' },
	{ city: 'Garryhubbock (Wexford)', zip: '739419' },
	{ city: 'Garryhubert (Galway)', zip: '191234' },
	{ city: 'Garryhundon (Carlow)', zip: '573853' },
	{ city: 'Garrykennedy (Tipperary)', zip: '302866' },
	{ city: 'Garryknock (Wicklow)', zip: '307307' },
	{ city: 'Garryland (Galway)', zip: '240343' },
	{ city: 'Garrylaun (Kilkenny)', zip: '236250' },
	{ city: 'Garrylaurence (Cork)', zip: '130520' },
	{ city: 'Garrylawrence (Galway)', zip: '527725' },
	{ city: 'Garryleagh (Cork)', zip: '991796' },
	{ city: 'Garryleesha (Kilkenny)', zip: '284260' },
	{ city: 'Garryletter (Kerry)', zip: '392286' },
	{ city: 'Garrylough Lower (Wexford)', zip: '841764' },
	{ city: 'Garrylough Upper (Wexford)', zip: '680537' },
	{ city: 'Garrylucas (Cork)', zip: '132313' },
	{ city: 'Garrymacteige (Tipperary)', zip: '586136' },
	{ city: 'Garrymaddock (Laois)', zip: '268098' },
	{ city: 'Garrymile (Wexford)', zip: '578641' },
	{ city: 'Garrymona (Offaly)', zip: '398090' },
	{ city: 'Garrymore (Cavan)', zip: '327425' },
	{ city: 'Garrymore (Cork)', zip: '977998' },
	{ city: 'Garrymore (Donegal)', zip: '634753' },
	{ city: 'Garrymore (Galway)', zip: '481005' },
	{ city: 'Garrymore (Kerry)', zip: '503269' },
	{ city: 'Garrymore (Laois)', zip: '698397' },
	{ city: 'Garrymore (Limerick)', zip: '321699' },
	{ city: 'Garrymore (Mayo)', zip: '997930' },
	{ city: 'Garrymore (Offaly)', zip: '918190' },
	{ city: 'Garrymore (Tipperary)', zip: '627100' },
	{ city: 'Garrymore (Wexford)', zip: '612977' },
	{ city: 'Garrymore Lower (Wicklow)', zip: '879557' },
	{ city: 'Garrymore Upper (Wicklow)', zip: '378505' },
	{ city: 'Garrymorris (Tipperary)', zip: '836700' },
	{ city: 'Garrymoyle (Wexford)', zip: '357665' },
	{ city: 'Garrynabba (Mayo)', zip: '903178' },
	{ city: 'Garrynabolie (Meath)', zip: '403696' },
	{ city: 'Garrynacole (Cork)', zip: '243499' },
	{ city: 'Garrynadur (Kerry)', zip: '154754' },
	{ city: 'Garrynafana (Tipperary)', zip: '951794' },
	{ city: 'Garrynafela (Westmeath)', zip: '446763' },
	{ city: 'Garrynagawna (Roscommon)', zip: '117630' },
	{ city: 'Garrynagearagh (Cork)', zip: '270754' },
	{ city: 'Garrynageragh East (Waterford)', zip: '400064' },
	{ city: 'Garrynageragh West (Waterford)', zip: '158050' },
	{ city: 'Garrynagh (Longford)', zip: '955098' },
	{ city: 'Garrynaglogh (Galway)', zip: '711710' },
	{ city: 'Garrynagoord (Limerick)', zip: '971633' },
	{ city: 'Garrynagore (Kerry)', zip: '105424' },
	{ city: 'Garrynagoul (Cork)', zip: '470157' },
	{ city: 'Garrynagran (Mayo)', zip: '143047' },
	{ city: 'Garrynagran (Roscommon)', zip: '686393' },
	{ city: 'Garrynagranoge (Cork)', zip: '761268' },
	{ city: 'Garrynagree (Tipperary)', zip: '321044' },
	{ city: 'Garrynagree (Waterford)', zip: '845294' },
	{ city: 'Garrynagry (Clare)', zip: '994937' },
	{ city: 'Garrynagry (Galway)', zip: '834220' },
	{ city: 'Garrynalyna (Limerick)', zip: '398994' },
	{ city: 'Garrynamann Lower (Kilkenny)', zip: '464780' },
	{ city: 'Garrynamann Upper (Kilkenny)', zip: '159607' },
	{ city: 'Garrynamishaun (Galway)', zip: '305497' },
	{ city: 'Garrynamona (Clare)', zip: '997143' },
	{ city: 'Garrynamona (Tipperary)', zip: '974218' },
	{ city: 'Garrynaneaskagh (Kerry)', zip: '573763' },
	{ city: 'Garrynapeaka (Cork)', zip: '950121' },
	{ city: 'Garrynarea (Kilkenny)', zip: '344432' },
	{ city: 'Garrynasillagh (Galway)', zip: '491159' },
	{ city: 'Garrynatineel (Tipperary)', zip: '112965' },
	{ city: 'Garryncahera (Limerick)', zip: '737633' },
	{ city: 'Garryncallaha (Clare)', zip: '288381' },
	{ city: 'Garryncoonagh North (Limerick)', zip: '783782' },
	{ city: 'Garryncoonagh South (Limerick)', zip: '502644' },
	{ city: 'Garryncurra (Clare)', zip: '916102' },
	{ city: 'Garryncurry (Tipperary)', zip: '280927' },
	{ city: 'Garrynderk North (Limerick)', zip: '459634' },
	{ city: 'Garrynderk South (Limerick)', zip: '831284' },
	{ city: 'Garryndrihid (Tipperary)', zip: '820543' },
	{ city: 'Garryndruig (Cork)', zip: '857965' },
	{ city: 'Garrynew (Wexford)', zip: '993604' },
	{ city: 'Garrynisk (Wexford)', zip: '777786' },
	{ city: 'Garryniska (Laois)', zip: '269847' },
	{ city: 'Garryniskbeg (Wexford)', zip: '546574' },
	{ city: 'Garrynlease (Limerick)', zip: '594628' },
	{ city: 'Garrynoe (Cork)', zip: '489554' },
	{ city: 'Garrynoe (Limerick)', zip: '187699' },
	{ city: 'Garrynoe (Tipperary)', zip: '484308' },
	{ city: 'Garrynoe (Waterford)', zip: '989490' },
	{ city: 'Garrynogher (Cavan)', zip: '648553' },
	{ city: 'Garrynphort (Roscommon)', zip: '782479' },
	{ city: 'Garryntemple (Tipperary)', zip: '242547' },
	{ city: 'Garryntinodagh (Wexford)', zip: '845448' },
	{ city: 'Garryoughtragh North (Cork)', zip: '286397' },
	{ city: 'Garryoughtragh South (Cork)', zip: '820625' },
	{ city: 'Garryowen (Limerick)', zip: '631907' },
	{ city: 'Garryphelim (Wexford)', zip: '573487' },
	{ city: 'Garryredmond (Mayo)', zip: '133553' },
	{ city: 'Garryrichard (Wexford)', zip: '157747' },
	{ city: 'Garryrickin (Kilkenny)', zip: '249724' },
	{ city: 'Garryroan (Tipperary)', zip: '171108' },
	{ city: 'Garryroe (Mayo)', zip: '328266' },
	{ city: 'Garryroe (Tipperary)', zip: '886772' },
	{ city: 'Garryross (Cavan)', zip: '782873' },
	{ city: 'Garrysallagh (Cavan)', zip: '192199' },
	{ city: 'Garrysallagh (Tipperary)', zip: '326563' },
	{ city: 'Garrysallagh (Westmeath)', zip: '732015' },
	{ city: 'Garrysallagh Glebe (Offaly)', zip: '706679' },
	{ city: 'Garryshane (Tipperary)', zip: '922371' },
	{ city: 'Garryskillane (Tipperary)', zip: '278447' },
	{ city: 'Garryspillane (Limerick)', zip: '318486' },
	{ city: 'Garryteige (Tipperary)', zip: '262501' },
	{ city: 'Garrythomas (Kilkenny)', zip: '326835' },
	{ city: 'Garryvacum (Laois)', zip: '715084' },
	{ city: 'Garryvadden (Wexford)', zip: '814143' },
	{ city: 'Garryvaddenbeg (Wexford)', zip: '848974' },
	{ city: 'Garryvadden Lower (Wexford)', zip: '565820' },
	{ city: 'Garryvadden Upper (Wexford)', zip: '971391' },
	{ city: 'Garryvanus (Tipperary)', zip: '850787' },
	{ city: 'Garryvarren (Wexford)', zip: '393735' },
	{ city: 'Garryvicleheen (Tipperary)', zip: '810549' },
	{ city: 'Garryvoe Lower (Cork)', zip: '775692' },
	{ city: 'Garryvoe Upper (Cork)', zip: '403649' },
	{ city: 'Garryvurragha (Limerick)', zip: '444215' },
	{ city: 'Garrywadreen (Mayo)', zip: '199471' },
	{ city: 'Garrywilliam (Kerry)', zip: '268330' },
	{ city: 'Garrywilliam (Wexford)', zip: '253572' },
	{ city: 'Garshooey (Donegal)', zip: '589820' },
	{ city: 'Gartacara (Cavan)', zip: '540900' },
	{ city: 'Gartan Mountain (Donegal)', zip: '782723' },
	{ city: 'Gartaquill (Cavan)', zip: '820237' },
	{ city: 'Gartbrattan (Cavan)', zip: '102771' },
	{ city: 'Garterfarm (Kildare)', zip: '978485' },
	{ city: 'Garterhill (Mayo)', zip: '572677' },
	{ city: 'Gartinardress (Cavan)', zip: '952320' },
	{ city: 'Gartlandstown (Westmeath)', zip: '660187' },
	{ city: 'Gartnaneane (Cavan)', zip: '539313' },
	{ city: 'Gartnasillagh (Cavan)', zip: '550149' },
	{ city: 'Gartylough (Cavan)', zip: '107862' },
	{ city: 'Garvagh (Cavan)', zip: '568732' },
	{ city: 'Garvagh (Donegal)', zip: '832064' },
	{ city: 'Garvagh (Leitrim)', zip: '522960' },
	{ city: 'Garvagh (Longford)', zip: '404766' },
	{ city: 'Garvagh Glebe (Leitrim)', zip: '402644' },
	{ city: 'Garvalt Lower (Cavan)', zip: '780067' },
	{ city: 'Garvan (Donegal)', zip: '801932' },
	{ city: 'Garvanagh (Donegal)', zip: '233131' },
	{ city: 'Garvary (Cavan)', zip: '898867' },
	{ city: 'Garvary (Donegal)', zip: '575905' },
	{ city: 'Garvary (Longford)', zip: '139412' },
	{ city: 'Garvary Mountain (Donegal)', zip: '617713' },
	{ city: 'Garvegort Glebe (Donegal)', zip: '612927' },
	{ city: 'Garveross (Donegal)', zip: '207928' },
	{ city: 'Garvesk (Cavan)', zip: '342465' },
	{ city: 'Garvillaun (Clare)', zip: '488622' },
	{ city: 'Garvlough (Leitrim)', zip: '807533' },
	{ city: 'Garvoge (Kildare)', zip: '700507' },
	{ city: 'Garvoghil (Clare)', zip: '741475' },
	{ city: 'Gash (Laois)', zip: '263550' },
	{ city: 'Gaskinstown (Meath)', zip: '855081' },
	{ city: 'Gaterstreet (Galway)', zip: '346080' },
	{ city: 'Gates (Waterford)', zip: '358754' },
	{ city: 'Gathabawn (Kilkenny)', zip: '192303' },
	{ city: 'Gatterstown (Tipperary)', zip: '283430' },
	{ city: 'Gaulross (Tipperary)', zip: '673755' },
	{ city: 'Gaulstown (Kilkenny)', zip: '624664' },
	{ city: 'Gaulstown (Meath)', zip: '222600' },
	{ city: 'Gaulstown (Waterford)', zip: '192995' },
	{ city: 'Gaulstown Lower (Kilkenny)', zip: '632754' },
	{ city: 'Gaulstown Upper (Kilkenny)', zip: '875590' },
	{ city: 'Gaurus (Clare)', zip: '550722' },
	{ city: 'Gawny (Westmeath)', zip: '870601' },
	{ city: 'Gaybrook (Westmeath)', zip: '810506' },
	{ city: 'Gaybrook Demesne (Westmeath)', zip: '102884' },
	{ city: 'Gayfield (Offaly)', zip: '464033' },
	{ city: 'Gaynestown (Wexford)', zip: '381933' },
	{ city: 'Geaglom (Leitrim)', zip: '233611' },
	{ city: 'Gearagh (Cork)', zip: '495441' },
	{ city: 'Gearagh East (Cork)', zip: '247023' },
	{ city: 'Gearagh West (Cork)', zip: '470614' },
	{ city: 'Gearanaskagh (Cork)', zip: '915827' },
	{ city: 'Geararoe (Cork)', zip: '571898' },
	{ city: 'Gearha (Kerry)', zip: '383760' },
	{ city: 'Gearhadiveen (Kerry)', zip: '637804' },
	{ city: 'Gearhameen (Cork)', zip: '724932' },
	{ city: 'Gearhameen (Kerry)', zip: '394440' },
	{ city: 'Gearhanagoul (Kerry)', zip: '514617' },
	{ city: 'Gearha North (Kerry)', zip: '521190' },
	{ city: 'Gearhasallagh (Kerry)', zip: '839792' },
	{ city: 'Gearha South (Kerry)', zip: '618229' },
	{ city: 'Geashill (Offaly)', zip: '420307' },
	{ city: 'Geehanstown (Meath)', zip: '505122' },
	{ city: 'Geehy North (Galway)', zip: '850711' },
	{ city: 'Geehy South (Galway)', zip: '441253' },
	{ city: 'Geeragh (Limerick)', zip: '458718' },
	{ city: 'Geevagh (Sligo)', zip: '125277' },
	{ city: 'Geevraun (Mayo)', zip: '480447' },
	{ city: 'Gelshagh (Longford)', zip: '573319' },
	{ city: 'Genagh (Monaghan)', zip: '428562' },
	{ city: 'Genstown (Wexford)', zip: '788764' },
	{ city: "George's-Land (Tipperary)", zip: '166058' },
	{ city: 'Georgestown (Waterford)', zip: '696442' },
	{ city: 'Georgia (Leitrim)', zip: '379713' },
	{ city: 'Gerahies (Cork)', zip: '366879' },
	{ city: 'Geraldine (Kildare)', zip: '234143' },
	{ city: 'Gernonstown (Meath)', zip: '452571' },
	{ city: 'Gerrardstown (Dublin)', zip: '390263' },
	{ city: 'Gerrardstown (Meath)', zip: '625632' },
	{ city: 'Gerrib Big (Sligo)', zip: '247648' },
	{ city: 'Gerrib Little (Sligo)', zip: '764596' },
	{ city: 'Gerry (Wexford)', zip: '434395' },
	{ city: 'Geskanagh Glebe (Leitrim)', zip: '797798' },
	{ city: 'Giantsgrave (Tipperary)', zip: '109246' },
	{ city: 'Gibberpatrick (Wexford)', zip: '661746' },
	{ city: 'Gibberwell (Wexford)', zip: '482172' },
	{ city: 'Gibblockstown (Meath)', zip: '878048' },
	{ city: 'Gibboghstown (Wexford)', zip: '887305' },
	{ city: 'Gibbons (Dublin)', zip: '165968' },
	{ city: 'Gibbonsmoor (Dublin)', zip: '183195' },
	{ city: 'Gibbonstown (Limerick)', zip: '477865' },
	{ city: 'Gibbonstown (Meath)', zip: '421208' },
	{ city: 'Gibbonstown (Westmeath)', zip: '931969' },
	{ city: 'Gibletstown (Wexford)', zip: '698849' },
	{ city: 'Gibraltar (Dublin)', zip: '378179' },
	{ city: 'Gibraltar (Meath)', zip: '572217' },
	{ city: 'Gibraltar (Wicklow)', zip: '824718' },
	{ city: 'Gibstown (Louth)', zip: '970456' },
	{ city: 'Gibstown (Meath)', zip: '976857' },
	{ city: 'Gibstown (Westmeath)', zip: '491905' },
	{ city: 'Gibstown (Wicklow)', zip: '108856' },
	{ city: 'Gibstown Demesne (Meath)', zip: '820010' },
	{ city: 'Giddaun (Roscommon)', zip: '410547' },
	{ city: 'Gigginstown (Westmeath)', zip: '543640' },
	{ city: 'Gilbertstown (Carlow)', zip: '997902' },
	{ city: 'Gilbertstown (Donegal)', zip: '488955' },
	{ city: 'Gilbertstown (Louth)', zip: '368313' },
	{ city: 'Gilbertstown (Meath)', zip: '984383' },
	{ city: 'Gilbertstown (Westmeath)', zip: '279243' },
	{ city: 'Gilbinstown (Kildare)', zip: '457523' },
	{ city: 'Gilcagh (Cork)', zip: '414884' },
	{ city: 'Gilford (Monaghan)', zip: '786077' },
	{ city: 'Gilkagh (Galway)', zip: '260141' },
	{ city: 'Gilkagh East (Galway)', zip: '258008' },
	{ city: 'Gilkagh West (Galway)', zip: '897049' },
	{ city: 'Gillardstown (Westmeath)', zip: '625441' },
	{ city: 'Gilliamstown (Meath)', zip: '688872' },
	{ city: 'Gillinstown (Meath)', zip: '124349' },
	{ city: 'Gilloge (Clare)', zip: '786000' },
	{ city: 'Gillstown (Meath)', zip: '339287' },
	{ city: 'Gillstown (Roscommon)', zip: '840205' },
	{ city: 'Gillstown Great (Meath)', zip: '260516' },
	{ city: 'Gillstown Little (Meath)', zip: '541727' },
	{ city: 'Gilltown (Kildare)', zip: '278266' },
	{ city: 'Gilltown (Meath)', zip: '697286' },
	{ city: 'Gillystown (Donegal)', zip: '603245' },
	{ city: 'Gilroe (Galway)', zip: '778702' },
	{ city: 'Giltspur (Wicklow)', zip: '876390' },
	{ city: 'Gingerstown (Kildare)', zip: '835585' },
	{ city: 'Ginnaun (Galway)', zip: '882489' },
	{ city: 'Ginnets Great (Meath)', zip: '403438' },
	{ city: 'Ginnets Little (Meath)', zip: '912434' },
	{ city: 'Girfin (Monaghan)', zip: '688119' },
	{ city: 'Girley (Meath)', zip: '125525' },
	{ city: 'Glack (Donegal)', zip: '578224' },
	{ city: 'Glack (Leitrim)', zip: '722927' },
	{ city: 'Glack (Longford)', zip: '544701' },
	{ city: 'Glack (Louth)', zip: '825251' },
	{ city: 'Glack (Meath)', zip: '963780' },
	{ city: 'Glackadrumman (Donegal)', zip: '767287' },
	{ city: 'Glackaunadarragh (Leitrim)', zip: '681500' },
	{ city: 'Glackbaun (Sligo)', zip: '571480' },
	{ city: 'Glackstown (Westmeath)', zip: '801791' },
	{ city: 'Gladree (Mayo)', zip: '960186' },
	{ city: 'Glaglig (Wexford)', zip: '307260' },
	{ city: 'Glan (Cork)', zip: '895458' },
	{ city: 'Glanaclogha (Cork)', zip: '461354' },
	{ city: 'Glanaderhig (Kerry)', zip: '270960' },
	{ city: 'Glanageenty (Kerry)', zip: '137629' },
	{ city: 'Glanagow (Cork)', zip: '204651' },
	{ city: 'Glanakip (Cork)', zip: '644932' },
	{ city: 'Glanalin (Cork)', zip: '677380' },
	{ city: 'Glananarig (Cork)', zip: '734777' },
	{ city: 'Glananea (Westmeath)', zip: '576296' },
	{ city: 'Glanaphuca (Cork)', zip: '513773' },
	{ city: 'Glanaradotia (Cork)', zip: '194243' },
	{ city: 'Glanareagh (Cork)', zip: '189272' },
	{ city: 'Glanarough (Cork)', zip: '154324' },
	{ city: 'Glanatnaw (Cork)', zip: '817577' },
	{ city: 'Glanavaud (Cork)', zip: '728223' },
	{ city: 'Glanavirane (Cork)', zip: '568524' },
	{ city: 'Glanawaddra (Kerry)', zip: '976844' },
	{ city: 'Glanawillin (Kerry)', zip: '553930' },
	{ city: 'Glanballyma (Kerry)', zip: '310047' },
	{ city: 'Glanbane (Kerry)', zip: '140631' },
	{ city: 'Glanbannoo Lower (Cork)', zip: '271474' },
	{ city: 'Glanbannoo Upper (Cork)', zip: '963335' },
	{ city: 'Glanbeg (Cork)', zip: '643363' },
	{ city: 'Glanbeg (Kerry)', zip: '545249' },
	{ city: 'Glanbrack (Cork)', zip: '854394' },
	{ city: 'Glancam (Cork)', zip: '965990' },
	{ city: 'Glancullare North (Kerry)', zip: '775752' },
	{ city: 'Glancullare South (Kerry)', zip: '781222' },
	{ city: 'Glancuttaun Lower (Kerry)', zip: '460491' },
	{ city: 'Glancuttaun Upper (Kerry)', zip: '355565' },
	{ city: 'Glandaeagh (Kerry)', zip: '482416' },
	{ city: 'Glandahalin East (Kerry)', zip: '837009' },
	{ city: 'Glandahalin West (Kerry)', zip: '790943' },
	{ city: 'Glandart (Cork)', zip: '682754' },
	{ city: 'Glandarta (Cork)', zip: '180351' },
	{ city: 'Glandine (Cork)', zip: '676818' },
	{ city: 'Glandine (Kerry)', zip: '972364' },
	{ city: 'Glandonohoe (Cork)', zip: '707137' },
	{ city: 'Glandoran Lower (Wexford)', zip: '967428' },
	{ city: 'Glandoran Upper (Wexford)', zip: '676317' },
	{ city: 'Glandore (Cork)', zip: '471430' },
	{ city: 'Glanduff (Cork)', zip: '959130' },
	{ city: 'Glanearagh (Kerry)', zip: '988036' },
	{ city: 'Glane Great (Meath)', zip: '587297' },
	{ city: 'Glane Little (Meath)', zip: '749186' },
	{ city: 'Glanerdalliv (Kerry)', zip: '211985' },
	{ city: 'Glanfahan (Kerry)', zip: '789771' },
	{ city: 'Glangevlin (Cavan)', zip: '564614' },
	{ city: 'Glangristeen (Kerry)', zip: '265923' },
	{ city: 'Glankeagh (Kerry)', zip: '184396' },
	{ city: 'Glanlarehan (Kerry)', zip: '378526' },
	{ city: 'Glanlea (Kerry)', zip: '645769' },
	{ city: 'Glanleam (Kerry)', zip: '519658' },
	{ city: 'Glanlick (Kerry)', zip: '683964' },
	{ city: 'Glanlough (Cork)', zip: '661894' },
	{ city: 'Glanlough Lower (Kerry)', zip: '272568' },
	{ city: 'Glanlough North (Kerry)', zip: '766849' },
	{ city: 'Glanlough South (Kerry)', zip: '346847' },
	{ city: 'Glanlough Upper (Kerry)', zip: '683594' },
	{ city: 'Glanlough West (Kerry)', zip: '841913' },
	{ city: 'Glanmakee (Kerry)', zip: '929459' },
	{ city: 'Glanmane (Kerry)', zip: '474661' },
	{ city: 'Glanminard (Kerry)', zip: '461608' },
	{ city: 'Glanminnane (Cork)', zip: '226578' },
	{ city: 'Glanmire (Cork)', zip: '801951' },
	{ city: 'Glanmore (Kerry)', zip: '206720' },
	{ city: 'Glannafeen (Cork)', zip: '130579' },
	{ city: 'Glannagalt (Kerry)', zip: '914731' },
	{ city: 'Glannagaul (Cork)', zip: '801575' },
	{ city: 'Glannagear (Cork)', zip: '712505' },
	{ city: 'Glannageel (Cork)', zip: '356977' },
	{ city: 'Glannagh (Longford)', zip: '364634' },
	{ city: 'Glannagilliagh (Kerry)', zip: '523782' },
	{ city: 'Glannaharee East (Cork)', zip: '543558' },
	{ city: 'Glannaharee West (Cork)', zip: '559494' },
	{ city: 'Glannahary (Carlow)', zip: '347518' },
	{ city: 'Glannaheera (Kerry)', zip: '151238' },
	{ city: 'Glannakilleenagh (Cork)', zip: '630833' },
	{ city: 'Glannalappa East (Kerry)', zip: '952865' },
	{ city: 'Glannalappa Middle (Kerry)', zip: '667130' },
	{ city: 'Glannalappa West (Kerry)', zip: '106834' },
	{ city: 'Glannarouge East (Cork)', zip: '372564' },
	{ city: 'Glannarouge West (Cork)', zip: '669337' },
	{ city: 'Glannasack (Cork)', zip: '796302' },
	{ city: 'Glannoge (Cork)', zip: '104117' },
	{ city: 'Glanoe (Kerry)', zip: '654415' },
	{ city: 'Glanowen (Kerry)', zip: '196400' },
	{ city: 'Glanrastel (Kerry)', zip: '280982' },
	{ city: 'Glanreagh (Cork)', zip: '866311' },
	{ city: 'Glanroon (Cork)', zip: '607985' },
	{ city: 'Glansallagh (Cork)', zip: '908887' },
	{ city: 'Glanshanacuirp (Kerry)', zip: '234560' },
	{ city: 'Glanshearoon (Kerry)', zip: '989558' },
	{ city: 'Glansheskin (Cork)', zip: '616631' },
	{ city: 'Glansillagh (Kerry)', zip: '829966' },
	{ city: 'Glantane (Cork)', zip: '391131' },
	{ city: 'Glantane (Kerry)', zip: '551486' },
	{ city: 'Glantane Beg (Cork)', zip: '114772' },
	{ city: 'Glantane East (Cork)', zip: '143012' },
	{ city: 'Glantane More (Cork)', zip: '183979' },
	{ city: 'Glantane West (Cork)', zip: '891103' },
	{ city: 'Glantaunluskaha (Kerry)', zip: '227812' },
	{ city: 'Glantaunmacarthy (Cork)', zip: '193419' },
	{ city: 'Glantaunyalkeen (Kerry)', zip: '483403' },
	{ city: 'Glanteenassig (Kerry)', zip: '556279' },
	{ city: 'Glantrasna (Kerry)', zip: '982525' },
	{ city: 'Glanturkin (Cork)', zip: '535636' },
	{ city: 'Glanworth (Cork)', zip: '346891' },
	{ city: 'Glanycarney (Cork)', zip: '762345' },
	{ city: 'Glanycummane Lower (Cork)', zip: '226327' },
	{ city: 'Glanycummane Upper (Cork)', zip: '872934' },
	{ city: 'Glar (Donegal)', zip: '935904' },
	{ city: 'Glasalt (Donegal)', zip: '168294' },
	{ city: 'Glasbolie (Donegal)', zip: '127632' },
	{ city: 'Glascarn (Meath)', zip: '869108' },
	{ city: 'Glascarn (Westmeath)', zip: '634456' },
	{ city: 'Glascarrick (Cavan)', zip: '380534' },
	{ city: 'Glascarrig North (Wexford)', zip: '671120' },
	{ city: 'Glascarrig South (Wexford)', zip: '488243' },
	{ city: 'Glascloon (Clare)', zip: '457588' },
	{ city: 'Glascloon (Offaly)', zip: '578496' },
	{ city: 'Glascloyne (Tipperary)', zip: '836546' },
	{ city: 'Glascurram (Limerick)', zip: '736903' },
	{ city: 'Glasderry Beg (Offaly)', zip: '778181' },
	{ city: 'Glasderry More (Offaly)', zip: '301723' },
	{ city: 'Glasdrumman (Cavan)', zip: '924615' },
	{ city: 'Glasdrumman (Leitrim)', zip: '973930' },
	{ city: 'Glasdrumman (Monaghan)', zip: '973819' },
	{ city: 'Glasdrumman (Roscommon)', zip: '206251' },
	{ city: 'Glasdrumman Beg (Leitrim)', zip: '255604' },
	{ city: 'Glasdrumman East (Monaghan)', zip: '362186' },
	{ city: 'Glasdrumman More (Leitrim)', zip: '120232' },
	{ city: 'Glasdrumman West (Monaghan)', zip: '209082' },
	{ city: 'Glasdrummond (Monaghan)', zip: '935286' },
	{ city: 'Glasganny (Wexford)', zip: '399948' },
	{ city: 'Glasgort (Mayo)', zip: '614960' },
	{ city: 'Glasha (Laois)', zip: '525600' },
	{ city: 'Glasha (Waterford)', zip: '504897' },
	{ city: 'Glashabeg (Kerry)', zip: '710880' },
	{ city: 'Glasha Beg (Clare)', zip: '517624' },
	{ city: 'Glashaboy East (Cork)', zip: '674814' },
	{ city: 'Glashaboy North (Cork)', zip: '377170' },
	{ city: 'Glashaboy South (Cork)', zip: '552176' },
	{ city: 'Glashaboy West (Cork)', zip: '191291' },
	{ city: 'Glashacormick (Kerry)', zip: '968563' },
	{ city: 'Glashagh (Donegal)', zip: '447857' },
	{ city: 'Glashagh Beg (Donegal)', zip: '744804' },
	{ city: 'Glashagh More (Donegal)', zip: '211396' },
	{ city: 'Glasha More (Clare)', zip: '128578' },
	{ city: 'Glashanacree (Kerry)', zip: '219565' },
	{ city: 'Glashananoon (Kerry)', zip: '414172' },
	{ city: 'Glashapullagh (Limerick)', zip: '435602' },
	{ city: 'Glashare (Kilkenny)', zip: '276616' },
	{ city: 'Glashbeggan (Donegal)', zip: '701915' },
	{ city: 'Glasheen (Cork)', zip: '788032' },
	{ city: 'Glasheenanargid (Cork)', zip: '935954' },
	{ city: 'Glasheenaulin (Cork)', zip: '207360' },
	{ city: 'Glasheens (Mayo)', zip: '577932' },
	{ city: 'Glashina (Wicklow)', zip: '795774' },
	{ city: 'Glashydevet (Donegal)', zip: '312721' },
	{ city: 'Glaskeeragh (Donegal)', zip: '875028' },
	{ city: 'Glaskenny (Wicklow)', zip: '108408' },
	{ city: 'Glaskill (Offaly)', zip: '296745' },
	{ city: 'Glaslacken (Wexford)', zip: '806290' },
	{ city: 'Glasleck (Cavan)', zip: '203255' },
	{ city: 'Glaslough (Monaghan)', zip: '904741' },
	{ city: 'Glasly (Donegal)', zip: '173195' },
	{ city: 'Glasmansally (Mayo)', zip: '299134' },
	{ city: 'Glasmullagh (Monaghan)', zip: '628800' },
	{ city: 'Glasmullan (Donegal)', zip: '996774' },
	{ city: 'Glasnamullen (Wicklow)', zip: '566893' },
	{ city: 'Glasnant (Donegal)', zip: '439904' },
	{ city: 'Glasnarget North (Wicklow)', zip: '107427' },
	{ city: 'Glasnarget South (Wicklow)', zip: '691476' },
	{ city: 'Glasnevin (Dublin)', zip: '300292' },
	{ city: 'Glasnevin North (Dublin)', zip: '176300' },
	{ city: 'Glaspatrick (Mayo)', zip: '767581' },
	{ city: 'Glaspistol (Louth)', zip: '102891' },
	{ city: 'Glassallen (Meath)', zip: '869712' },
	{ city: 'Glassalt (Leitrim)', zip: '530681' },
	{ city: 'Glassamucky (Dublin)', zip: '849238' },
	{ city: 'Glassamucky Brakes (Dublin)', zip: '210002' },
	{ city: 'Glassamucky Mountain (Dublin)', zip: '605279' },
	{ city: 'Glassan (Donegal)', zip: '336654' },
	{ city: 'Glassan (Westmeath)', zip: '457392' },
	{ city: 'Glassavullaun (Dublin)', zip: '836466' },
	{ city: 'Glassdrum (Tipperary)', zip: '461972' },
	{ city: 'Glassely (Kildare)', zip: '796923' },
	{ city: 'Glasserchoo (Donegal)', zip: '748588' },
	{ city: 'Glasshouse (Cork)', zip: '746908' },
	{ city: 'Glasshouse (Offaly)', zip: '228717' },
	{ city: 'Glassillan (Mayo)', zip: '601624' },
	{ city: 'Glassillaun (Galway)', zip: '600445' },
	{ city: 'Glasstown (Cavan)', zip: '563143' },
	{ city: 'Glaster (Offaly)', zip: '264143' },
	{ city: 'Glasthule (Dublin)', zip: '219048' },
	{ city: 'Glastrasna (Mayo)', zip: '549616' },
	{ city: 'Glastrigan (Tipperary)', zip: '500729' },
	{ city: 'Glasvally (Mayo)', zip: '402979' },
	{ city: 'Glasvaunta (Cork)', zip: '161950' },
	{ city: 'Glear (Monaghan)', zip: '931611' },
	{ city: 'Glebe (Carlow)', zip: '286614' },
	{ city: 'Glebe (Cavan)', zip: '691161' },
	{ city: 'Glebe (Clare)', zip: '458797' },
	{ city: 'Glebe (Cork)', zip: '576919' },
	{ city: 'Glebe (Donegal)', zip: '741681' },
	{ city: 'Glebe (Dublin)', zip: '626255' },
	{ city: 'Glebe (Galway)', zip: '893033' },
	{ city: 'Glebe (Kerry)', zip: '262369' },
	{ city: 'Glebe (Kildare)', zip: '703430' },
	{ city: 'Glebe (Kilkenny)', zip: '955798' },
	{ city: 'Glebe (Laois)', zip: '549889' },
	{ city: 'Glebe (Leitrim)', zip: '510755' },
	{ city: 'Glebe (Limerick)', zip: '727453' },
	{ city: 'Glebe (Longford)', zip: '967415' },
	{ city: 'Glebe (Louth)', zip: '310759' },
	{ city: 'Glebe (Mayo)', zip: '431115' },
	{ city: 'Glebe (Meath)', zip: '890425' },
	{ city: 'Glebe (Monaghan)', zip: '806279' },
	{ city: 'Glebe (Offaly)', zip: '621345' },
	{ city: 'Glebe (Roscommon)', zip: '350557' },
	{ city: 'Glebe (Sligo)', zip: '390200' },
	{ city: 'Glebe (Tipperary)', zip: '517311' },
	{ city: 'Glebe (Waterford)', zip: '920905' },
	{ city: 'Glebe (Westmeath)', zip: '477547' },
	{ city: 'Glebe (Wexford)', zip: '622862' },
	{ city: 'Glebe (Wicklow)', zip: '623178' },
	{ city: 'Glebe Bog (Louth)', zip: '955295' },
	{ city: 'Glebe East (Dublin)', zip: '461614' },
	{ city: 'Glebe East (Kildare)', zip: '425587' },
	{ city: 'Glebe East (Louth)', zip: '305875' },
	{ city: 'Glebe East (Offaly)', zip: '440297' },
	{ city: 'Glebe East (Roscommon)', zip: '420736' },
	{ city: 'Glebe East (Westmeath)', zip: '595148' },
	{ city: 'Glebehill (Donegal)', zip: '605607' },
	{ city: 'Glebe Large (Donegal)', zip: '682480' },
	{ city: 'Glebemarsh (Cork)', zip: '817215' },
	{ city: 'Glebe North (Dublin)', zip: '158717' },
	{ city: 'Glebe North (Kildare)', zip: '224794' },
	{ city: 'Glebe South (Dublin)', zip: '280457' },
	{ city: 'Glebe South (Kildare)', zip: '552000' },
	{ city: 'Glebe South (Louth)', zip: '788792' },
	{ city: 'Glebe West (Dublin)', zip: '111496' },
	{ city: 'Glebe West (Kildare)', zip: '614003' },
	{ city: 'Glebe West (Louth)', zip: '411184' },
	{ city: 'Glebe West (Roscommon)', zip: '659359' },
	{ city: 'Glebe West (Westmeath)', zip: '503575' },
	{ city: 'Gleensk (Kerry)', zip: '693572' },
	{ city: 'Gleesk (Kerry)', zip: '849213' },
	{ city: 'Glen (Cavan)', zip: '751160' },
	{ city: 'Glen (Donegal)', zip: '326379' },
	{ city: 'Glen (Galway)', zip: '647363' },
	{ city: 'Glen (Kerry)', zip: '296904' },
	{ city: 'Glen (Kilkenny)', zip: '698157' },
	{ city: 'Glen (Limerick)', zip: '608371' },
	{ city: 'Glen (Longford)', zip: '854017' },
	{ city: 'Glen (Mayo)', zip: '678783' },
	{ city: 'Glen (Monaghan)', zip: '892236' },
	{ city: 'Glen (Roscommon)', zip: '378593' },
	{ city: 'Glen (Sligo)', zip: '217586' },
	{ city: 'Glen (Waterford)', zip: '846189' },
	{ city: 'Glen (Westmeath)', zip: '523278' },
	{ city: 'Glen (Wexford)', zip: '519111' },
	{ city: 'Glena (Kerry)', zip: '438508' },
	{ city: 'Glenabbey (Waterford)', zip: '698841' },
	{ city: 'Glenaboghil (Donegal)', zip: '773444' },
	{ city: 'Glenaboy (Waterford)', zip: '184756' },
	{ city: 'Glenacarney (Cork)', zip: '397093' },
	{ city: 'Glenaclara East (Galway)', zip: '415969' },
	{ city: 'Glenaclara West (Galway)', zip: '371446' },
	{ city: 'Glenacre (Tipperary)', zip: '469773' },
	{ city: 'Glenacroghery (Cork)', zip: '117841' },
	{ city: 'Glenacunna (Tipperary)', zip: '925443' },
	{ city: 'Glenacurragh (Offaly)', zip: '337431' },
	{ city: 'Glenacurrane (Limerick)', zip: '287508' },
	{ city: 'Glenade (Leitrim)', zip: '845132' },
	{ city: 'Glenafelly (Offaly)', zip: '305461' },
	{ city: 'Glenagarey (Dublin)', zip: '229484' },
	{ city: 'Glenagh (Mayo)', zip: '256342' },
	{ city: 'Glenaglogh North (Cork)', zip: '375799' },
	{ city: 'Glenaglogh South (Cork)', zip: '765291' },
	{ city: 'Glenagort (Mayo)', zip: '634756' },
	{ city: 'Glenagower (Limerick)', zip: '773950' },
	{ city: 'Glenagragara (Limerick)', zip: '864659' },
	{ city: 'Glenaguile (Tipperary)', zip: '693828' },
	{ city: 'Glenagurteen (Cork)', zip: '899813' },
	{ city: 'Glenahilty (Tipperary)', zip: '367743' },
	{ city: 'Glenaknockane (Cork)', zip: '963101' },
	{ city: 'Glenaknockaun East (Waterford)', zip: '266911' },
	{ city: 'Glenaknockaun West (Waterford)', zip: '612280' },
	{ city: 'Glenaleeriska (Waterford)', zip: '377280' },
	{ city: 'Glenalemy (Tipperary)', zip: '234469' },
	{ city: 'Glenall (Laois)', zip: '813068' },
	{ city: 'Glenalla (Donegal)', zip: '444239' },
	{ city: 'Glenalougha (Cork)', zip: '629943' },
	{ city: 'Glenamony Glebe (Offaly)', zip: '691706' },
	{ city: 'Glenamoon (Laois)', zip: '207854' },
	{ city: 'Glenamoy (Mayo)', zip: '477351' },
	{ city: 'Glenamuck North (Dublin)', zip: '923489' },
	{ city: 'Glenamuck South (Dublin)', zip: '730685' },
	{ city: 'Glenanair East (Limerick)', zip: '498460' },
	{ city: 'Glenanair West (Limerick)', zip: '435950' },
	{ city: 'Glenane Beg (Cork)', zip: '446811' },
	{ city: 'Glenane More (Cork)', zip: '812265' },
	{ city: 'Glenane Wood (Cork)', zip: '668390' },
	{ city: 'Glenaphuca (Cork)', zip: '943241' },
	{ city: 'Glenaraneen (Dublin)', zip: '605813' },
	{ city: 'Glenard (Donegal)', zip: '327520' },
	{ city: 'Glenaree (Kildare)', zip: '581066' },
	{ city: 'Glenaree (Limerick)', zip: '836153' },
	{ city: 'Glenarousk (Cork)', zip: '124575' },
	{ city: 'Glenart (Wicklow)', zip: '370669' },
	{ city: 'Glenaruid (Galway)', zip: '219960' },
	{ city: 'Glenary (Waterford)', zip: '557280' },
	{ city: 'Glenasaggart (Waterford)', zip: '632245' },
	{ city: 'Glenassy (Waterford)', zip: '945049' },
	{ city: 'Glenastar (Limerick)', zip: '715263' },
	{ city: 'Glenatallan (Galway)', zip: '310045' },
	{ city: 'Glenathonacash (Cork)', zip: '738806' },
	{ city: 'Glenatlucky (Cork)', zip: '828666' },
	{ city: 'Glenatore Lower (Cork)', zip: '379753' },
	{ city: 'Glenatore Upper (Cork)', zip: '275974' },
	{ city: 'Glenaun (Galway)', zip: '379051' },
	{ city: 'Glenavaddra (Waterford)', zip: '224929' },
	{ city: 'Glenaveha (Waterford)', zip: '649276' },
	{ city: 'Glenavenew (Mayo)', zip: '435759' },
	{ city: 'Glenaviegh (Tipperary)', zip: '118902' },
	{ city: 'Glenaward (Meath)', zip: '403726' },
	{ city: 'Glenawillin (Cork)', zip: '650576' },
	{ city: 'Glenawilling (Cork)', zip: '715426' },
	{ city: 'Glenawinna (Tipperary)', zip: '161800' },
	{ city: 'Glenballythomas (Roscommon)', zip: '111985' },
	{ city: 'Glenballyvally (Kilkenny)', zip: '506377' },
	{ city: 'Glenbane (Tipperary)', zip: '120829' },
	{ city: 'Glenbane East (Limerick)', zip: '513718' },
	{ city: 'Glenbane Lower (Tipperary)', zip: '616126' },
	{ city: 'Glenbane Upper (Tipperary)', zip: '113698' },
	{ city: 'Glenbane West (Limerick)', zip: '998036' },
	{ city: 'Glenbarrow (Laois)', zip: '650941' },
	{ city: 'Glenbaun (Limerick)', zip: '841736' },
	{ city: 'Glenbaun (Mayo)', zip: '618349' },
	{ city: 'Glenbaun (Wexford)', zip: '518101' },
	{ city: 'Glenbeagh (Donegal)', zip: '232363' },
	{ city: 'Glenbeg (Cork)', zip: '132377' },
	{ city: 'Glenbeg (Tipperary)', zip: '633001' },
	{ city: 'Glen Beg (Monaghan)', zip: '233636' },
	{ city: 'Glen Beg (Waterford)', zip: '325441' },
	{ city: 'Glenbeg East (Mayo)', zip: '968448' },
	{ city: 'Glenbeg West (Mayo)', zip: '326057' },
	{ city: 'Glenbeha (Tipperary)', zip: '763438' },
	{ city: 'Glenbeigh (Kerry)', zip: '154951' },
	{ city: 'Glenbevan (Limerick)', zip: '132425' },
	{ city: 'Glenbonniv (Clare)', zip: '806486' },
	{ city: 'Glenbough (Wexford)', zip: '706066' },
	{ city: 'Glenbower (Kilkenny)', zip: '291577' },
	{ city: 'Glenbower (Laois)', zip: '591548' },
	{ city: 'Glenbower (Tipperary)', zip: '329201' },
	{ city: 'Glenboy (Leitrim)', zip: '342506' },
	{ city: 'Glenboy (Meath)', zip: '645798' },
	{ city: 'Glenbrack (Galway)', zip: '437697' },
	{ city: 'Glenbradagh (Cork)', zip: '260629' },
	{ city: 'Glenbreedy (Tipperary)', zip: '685311' },
	{ city: 'Glenbrickeen (Galway)', zip: '730268' },
	{ city: 'Glenbride (Wicklow)', zip: '981121' },
	{ city: 'Glenbrohane (Limerick)', zip: '286869' },
	{ city: 'Glenbullock (Wexford)', zip: '987207' },
	{ city: 'Glencairn (Waterford)', zip: '432294' },
	{ city: 'Glencallaghan (Tipperary)', zip: '617958' },
	{ city: 'Glencally (Mayo)', zip: '125911' },
	{ city: 'Glencalry Lower (Mayo)', zip: '966023' },
	{ city: 'Glencalry Upper (Mayo)', zip: '249136' },
	{ city: 'Glencap Commons North (Wicklow)', zip: '847829' },
	{ city: 'Glencap Commons South (Wicklow)', zip: '519661' },
	{ city: 'Glencap Commons Upper (Wicklow)', zip: '810553' },
	{ city: 'Glencar (Kerry)', zip: '620357' },
	{ city: 'Glencar (Leitrim)', zip: '265491' },
	{ city: 'Glencarbry (Tipperary)', zip: '170151' },
	{ city: 'Glencarbury (Sligo)', zip: '667814' },
	{ city: 'Glencar Irish (Donegal)', zip: '276014' },
	{ city: 'Glencar Scotch (Donegal)', zip: '469667' },
	{ city: 'Glencash (Donegal)', zip: '613254' },
	{ city: 'Glencastle (Mayo)', zip: '983126' },
	{ city: 'Glencaw (Donegal)', zip: '179008' },
	{ city: 'Glencloghlea (Kilkenny)', zip: '939209' },
	{ city: 'Glencoagh (Donegal)', zip: '477423' },
	{ city: 'Glencoaghan (Galway)', zip: '574472' },
	{ city: 'Glencoh (Galway)', zip: '615052' },
	{ city: 'Glencollins Lower (Cork)', zip: '343460' },
	{ city: 'Glencollins Upper (Cork)', zip: '858532' },
	{ city: 'Glencolumbkille (Donegal)', zip: '228968' },
	{ city: 'Glencolumbkille North (Clare)', zip: '603546' },
	{ city: 'Glencolumbkille South (Clare)', zip: '444753' },
	{ city: 'Glencommaun (Kilkenny)', zip: '352343' },
	{ city: 'Glenconaun Beg (Clare)', zip: '932106' },
	{ city: 'Glenconaun More (Clare)', zip: '525715' },
	{ city: 'Glenconnelly (Mayo)', zip: '337873' },
	{ city: 'Glenconnor (Tipperary)', zip: '738432' },
	{ city: 'Glenconra (Laois)', zip: '566394' },
	{ city: 'Glencorick (Monaghan)', zip: '665206' },
	{ city: 'Glencormick North (Wicklow)', zip: '907781' },
	{ city: 'Glencormick South (Wicklow)', zip: '501118' },
	{ city: 'Glencorran (Cavan)', zip: '787285' },
	{ city: 'Glencoshabinnia (Tipperary)', zip: '723397' },
	{ city: 'Glencoum (Kilkenny)', zip: '144980' },
	{ city: 'Glencovet (Donegal)', zip: '331326' },
	{ city: 'Glencraff (Galway)', zip: '511706' },
	{ city: 'Glencree (Wicklow)', zip: '222112' },
	{ city: 'Glencrees (Galway)', zip: '951982' },
	{ city: 'Glencroe (Tipperary)', zip: '997648' },
	{ city: 'Glencross (Donegal)', zip: '652035' },
	{ city: 'Glencrow (Donegal)', zip: '394710' },
	{ city: 'Glencrue (Tipperary)', zip: '351432' },
	{ city: 'Glencullen (Dublin)', zip: '743594' },
	{ city: 'Glencullen (Waterford)', zip: '858323' },
	{ city: 'Glencullen Mountain (Dublin)', zip: '528769' },
	{ city: 'Glencullin (Mayo)', zip: '273898' },
	{ city: 'Glencullin Lower (Mayo)', zip: '267614' },
	{ city: 'Glencullin Upper (Mayo)', zip: '942784' },
	{ city: 'Glendaduff (Mayo)', zip: '713358' },
	{ city: 'Glendahurk (Mayo)', zip: '640209' },
	{ city: 'Glendalligan (Waterford)', zip: '786744' },
	{ city: 'Glendalough (Waterford)', zip: '297367' },
	{ city: 'Glendarragh (Limerick)', zip: '317631' },
	{ city: 'Glendarragh (Wicklow)', zip: '531722' },
	{ city: 'Glendav (Cork)', zip: '711668' },
	{ city: 'Glendavock (Mayo)', zip: '177490' },
	{ city: 'Glendavoolagh (Mayo)', zip: '714807' },
	{ city: 'Glendaw (Waterford)', zip: '452277' },
	{ city: 'Glendeish East (Waterford)', zip: '562755' },
	{ city: 'Glendeish West (Waterford)', zip: '213198' },
	{ city: 'Glenderry (Kerry)', zip: '599077' },
	{ city: 'Glendevine (Westmeath)', zip: '674464' },
	{ city: 'Glendiheen (Limerick)', zip: '317721' },
	{ city: 'Glendine (Kilkenny)', zip: '110755' },
	{ city: 'Glendine (Laois)', zip: '153704' },
	{ city: 'Glendine (Offaly)', zip: '303575' },
	{ city: 'Glendine North (Clare)', zip: '129549' },
	{ city: 'Glendineoregan (Laois)', zip: '759577' },
	{ city: 'Glendine South (Clare)', zip: '485937' },
	{ city: 'Glendonnell (Kilkenny)', zip: '497333' },
	{ city: 'Glendoo (Dublin)', zip: '423588' },
	{ city: 'Glendorragha (Mayo)', zip: '363704' },
	{ city: 'Glendossaun (Offaly)', zip: '185482' },
	{ city: 'Glendowanbeg (Donegal)', zip: '680117' },
	{ city: 'Glendree (Clare)', zip: '723366' },
	{ city: 'Glendrislagh (Wexford)', zip: '523893' },
	{ city: 'Glenduff (Cork)', zip: '675022' },
	{ city: 'Glenduff (Limerick)', zip: '707779' },
	{ city: 'Glenduff (Offaly)', zip: '819935' },
	{ city: 'Glenduff (Tipperary)', zip: '608720' },
	{ city: 'Glenduff (Wexford)', zip: '986934' },
	{ city: 'Glenealy (Wicklow)', zip: '421126' },
	{ city: 'Glen East (Cork)', zip: '646426' },
	{ city: 'Glen East (Waterford)', zip: '255938' },
	{ city: 'Glenedagh Eighter (Mayo)', zip: '788473' },
	{ city: 'Glenedagh Oughter (Mayo)', zip: '958762' },
	{ city: 'Gleneely (Donegal)', zip: '672720' },
	{ city: 'Gleneige (Leitrim)', zip: '575438' },
	{ city: 'Glenfad (Donegal)', zip: '432725' },
	{ city: 'Glenfarne (Leitrim)', zip: '775194' },
	{ city: 'Glenfield (Limerick)', zip: '662227' },
	{ city: 'Glenfield North (Cork)', zip: '872621' },
	{ city: 'Glenfield South (Cork)', zip: '318955' },
	{ city: 'Glenfin (Roscommon)', zip: '816933' },
	{ city: 'Glenfinshinagh (Tipperary)', zip: '816460' },
	{ city: 'Glenflesk (Kerry)', zip: '891770' },
	{ city: 'Glenfooran (Waterford)', zip: '201974' },
	{ city: 'Glengad (Donegal)', zip: '672693' },
	{ city: 'Glengaddy (Tipperary)', zip: '970424' },
	{ city: 'Glengall (Tipperary)', zip: '786894' },
	{ city: 'Glengar (Tipperary)', zip: '355828' },
	{ city: 'Glengarra (Tipperary)', zip: '803609' },
	{ city: 'Glengarra (Waterford)', zip: '748545' },
	{ city: 'Glengarriff (Cork)', zip: '119047' },
	{ city: 'Glengarriff (Tipperary)', zip: '881889' },
	{ city: 'Glengarriff Beg (Cork)', zip: '885995' },
	{ city: 'Glengarriff More (Cork)', zip: '236043' },
	{ city: 'Glengesh (Donegal)', zip: '990288' },
	{ city: 'Glengillagrana High (Donegal)', zip: '190897' },
	{ city: 'Glenglass (Wexford)', zip: '442504' },
	{ city: 'Glenglassera (Mayo)', zip: '840659' },
	{ city: 'Glengoagh (Waterford)', zip: '615983' },
	{ city: 'Glengoole North (Tipperary)', zip: '351250' },
	{ city: 'Glengoole South (Tipperary)', zip: '952806' },
	{ city: 'Glengorm (Westmeath)', zip: '768046' },
	{ city: 'Glengort North (Limerick)', zip: '262043' },
	{ city: 'Glengort South (Limerick)', zip: '106674' },
	{ city: 'Glengoura Lower (Cork)', zip: '660341' },
	{ city: 'Glengoura Upper (Cork)', zip: '319202' },
	{ city: 'Glengowla East (Galway)', zip: '836064' },
	{ city: 'Glengowla West (Galway)', zip: '530395' },
	{ city: 'Glengrant (Kilkenny)', zip: '204590' },
	{ city: 'Glenhouse (Waterford)', zip: '995956' },
	{ city: 'Glenicmurrin (Galway)', zip: '854822' },
	{ city: 'Glenidan (Westmeath)', zip: '495828' },
	{ city: 'Glenieraragh (Donegal)', zip: '836878' },
	{ city: 'Gleniff (Sligo)', zip: '293789' },
	{ city: 'Gleninagh (Galway)', zip: '248938' },
	{ city: 'Gleninagh North (Clare)', zip: '627825' },
	{ city: 'Gleninagh South (Clare)', zip: '591919' },
	{ city: 'Gleninchnaveigh (Tipperary)', zip: '718254' },
	{ city: 'Glenineeny (Donegal)', zip: '403031' },
	{ city: 'Gleninsheen (Clare)', zip: '595432' },
	{ city: 'Glenish (Monaghan)', zip: '344308' },
	{ city: 'Glenisland (Mayo)', zip: '191187' },
	{ city: 'Glenkeal (Cork)', zip: '167269' },
	{ city: 'Glenkeel (Leitrim)', zip: '116261' },
	{ city: 'Glenkeen (Donegal)', zip: '722269' },
	{ city: 'Glenkeen (Mayo)', zip: '629695' },
	{ city: 'Glenkeen (Tipperary)', zip: '964569' },
	{ city: 'Glenkeen Lower (Laois)', zip: '235038' },
	{ city: 'Glenkeen Upper (Laois)', zip: '161453' },
	{ city: 'Glenkeeragh (Donegal)', zip: '408799' },
	{ city: 'Glenkeeran (Donegal)', zip: '645954' },
	{ city: 'Glenkeo (Donegal)', zip: '970421' },
	{ city: 'Glenkitt (Laois)', zip: '217230' },
	{ city: 'Glenlahan (Cork)', zip: '526165' },
	{ city: 'Glenlara (Cork)', zip: '200003' },
	{ city: 'Glenlara (Mayo)', zip: '298269' },
	{ city: 'Glenlary (Limerick)', zip: '361991' },
	{ city: 'Glenlaur (Mayo)', zip: '549878' },
	{ city: 'Glenlea (Kerry)', zip: '684098' },
	{ city: 'Glenleary (Donegal)', zip: '675999' },
	{ city: 'Glenlee (Donegal)', zip: '819866' },
	{ city: 'Glenleigh (Cork)', zip: '954609' },
	{ city: 'Glenletter (Offaly)', zip: '872123' },
	{ city: 'Glenletternafinny (Clare)', zip: '967843' },
	{ city: 'Glenlicky (Waterford)', zip: '487218' },
	{ city: 'Glenlohane (Cork)', zip: '601749' },
	{ city: 'Glenlon North (Clare)', zip: '924443' },
	{ city: 'Glenlon South (Clare)', zip: '772797' },
	{ city: 'Glenlough (Cork)', zip: '165182' },
	{ city: 'Glenlough (Donegal)', zip: '208141' },
	{ city: 'Glenloughaun (Galway)', zip: '490678' },
	{ city: 'Glen Lower (Donegal)', zip: '670061' },
	{ city: 'Glen Lower (Sligo)', zip: '885512' },
	{ city: 'Glen Lower (Waterford)', zip: '896180' },
	{ city: 'Glenlusk (Galway)', zip: '527376' },
	{ city: 'Glenma (Limerick)', zip: '595375' },
	{ city: 'Glenmacannive (Donegal)', zip: '213289' },
	{ city: 'Glenmagoo (Kilkenny)', zip: '696888' },
	{ city: 'Glenmakee (Donegal)', zip: '535882' },
	{ city: 'Glenmaquin (Donegal)', zip: '465276' },
	{ city: 'Glenmaquin Lower (Donegal)', zip: '775434' },
	{ city: 'Glenmaquin Upper (Donegal)', zip: '553874' },
	{ city: 'Glenmask (Mayo)', zip: '784945' },
	{ city: 'Glenmeen (Galway)', zip: '351643' },
	{ city: 'Glenmenagh (Donegal)', zip: '993632' },
	{ city: 'Glen Middle (Cork)', zip: '838241' },
	{ city: 'Glenmore (Clare)', zip: '109741' },
	{ city: 'Glenmore (Galway)', zip: '273636' },
	{ city: 'Glenmore (Kildare)', zip: '803319' },
	{ city: 'Glenmore (Kilkenny)', zip: '976195' },
	{ city: 'Glenmore (Limerick)', zip: '526205' },
	{ city: 'Glenmore (Longford)', zip: '541296' },
	{ city: 'Glenmore (Louth)', zip: '744317' },
	{ city: 'Glenmore (Roscommon)', zip: '148632' },
	{ city: 'Glen More (Monaghan)', zip: '929909' },
	{ city: 'Glen More (Waterford)', zip: '245406' },
	{ city: 'Glenmore East (Limerick)', zip: '773715' },
	{ city: 'Glenmore Lower (Tipperary)', zip: '808293' },
	{ city: 'Glenmore Upper (Tipperary)', zip: '564713' },
	{ city: 'Glenmore West (Limerick)', zip: '854889' },
	{ city: 'Glenmorrishmeen (Waterford)', zip: '966708' },
	{ city: 'Glenmullynaha East (Mayo)', zip: '690333' },
	{ city: 'Glenmullynaha West (Mayo)', zip: '881364' },
	{ city: 'Glennacally (Mayo)', zip: '868010' },
	{ city: 'Glennacanon (Wicklow)', zip: '692624' },
	{ city: 'Glennaclohalea (Tipperary)', zip: '895334' },
	{ city: 'Glennafallia (Waterford)', zip: '526094' },
	{ city: 'Glennafosha (Galway)', zip: '555625' },
	{ city: 'Glennagad (Waterford)', zip: '502981' },
	{ city: 'Glennagark (Wexford)', zip: '286547' },
	{ city: 'Glennagarraun (Galway)', zip: '703655' },
	{ city: 'Glennagashleeny (Mayo)', zip: '121602' },
	{ city: 'Glennagat (Tipperary)', zip: '705380' },
	{ city: 'Glennageare East (Cork)', zip: '171468' },
	{ city: 'Glennageare West (Cork)', zip: '313226' },
	{ city: 'Glennageer (Clare)', zip: '578734' },
	{ city: 'Glennagevlagh (Galway)', zip: '395468' },
	{ city: 'Glennagiveny (Donegal)', zip: '170518' },
	{ city: 'Glennaglass (Laois)', zip: '977822' },
	{ city: 'Glennaglogh (Waterford)', zip: '266616' },
	{ city: 'Glennaglogh (Wexford)', zip: '671612' },
	{ city: 'Glennagloghaun (Galway)', zip: '932229' },
	{ city: 'Glennagloghaun North (Galway)', zip: '319140' },
	{ city: 'Glennagloghaun South (Galway)', zip: '854878' },
	{ city: 'Glennagoolagh (Sligo)', zip: '715094' },
	{ city: 'Glennagowan (Limerick)', zip: '816688' },
	{ city: 'Glennagross (Clare)', zip: '174939' },
	{ city: 'Glennahaglish (Limerick)', zip: '788636' },
	{ city: 'Glennahilt (Donegal)', zip: '563422' },
	{ city: 'Glennahoo (Kerry)', zip: '461600' },
	{ city: 'Glennahulla (Cork)', zip: '800330' },
	{ city: 'Glennakeel North (Cork)', zip: '941963' },
	{ city: 'Glennakeel South (Cork)', zip: '496340' },
	{ city: 'Glennakeel West (Cork)', zip: '609136' },
	{ city: 'Glennaknockane (Cork)', zip: '323768' },
	{ city: 'Glennamaddoo (Mayo)', zip: '888358' },
	{ city: 'Glennamaddy (Galway)', zip: '455356' },
	{ city: 'Glennameade (Limerick)', zip: '148451' },
	{ city: 'Glennameeltoge (Roscommon)', zip: '816157' },
	{ city: 'Glennameenagh (Wexford)', zip: '659169' },
	{ city: 'Glennamong (Mayo)', zip: '236670' },
	{ city: 'Glennamucka (Galway)', zip: '827445' },
	{ city: 'Glennamucklagh East (Cork)', zip: '110398' },
	{ city: 'Glennamucklagh West (Cork)', zip: '983245' },
	{ city: 'Glennan (Monaghan)', zip: '850392' },
	{ city: 'Glennanammer (Roscommon)', zip: '387622' },
	{ city: 'Glennan Beg (Leitrim)', zip: '617885' },
	{ city: 'Glennanea (Roscommon)', zip: '789982' },
	{ city: 'Glennaneane (Waterford)', zip: '808147' },
	{ city: 'Glennaneanemountain (Waterford)', zip: '912262' },
	{ city: 'Glennaneeny (Galway)', zip: '331285' },
	{ city: 'Glennan More (Leitrim)', zip: '123149' },
	{ city: 'Glennanoge (Tipperary)', zip: '721607' },
	{ city: 'Glennanore (Waterford)', zip: '236956' },
	{ city: 'Glennaphuca (Waterford)', zip: '376030' },
	{ city: 'Glennariesk (Tipperary)', zip: '703680' },
	{ city: 'Glennascaul (Galway)', zip: '805398' },
	{ city: 'Glennashouk (Wicklow)', zip: '129022' },
	{ city: 'Glennaskagh (Tipperary)', zip: '989577' },
	{ city: 'Glennaskehy (Galway)', zip: '568127' },
	{ city: 'Glennaslat (Galway)', zip: '634769' },
	{ city: 'Glennaslaud (Tipperary)', zip: '656319' },
	{ city: 'Glennaun (Galway)', zip: '285214' },
	{ city: 'Glennavaddoge (Galway)', zip: '391834' },
	{ city: 'Glennaveel (Galway)', zip: '203782' },
	{ city: 'Glennawillin (Waterford)', zip: '673833' },
	{ city: 'Glennawoo (Sligo)', zip: '323668' },
	{ city: 'Glen North (Clare)', zip: '771891' },
	{ city: 'Glen North (Cork)', zip: '963353' },
	{ city: 'Glenns (Offaly)', zip: '326922' },
	{ city: 'Glennyhorn (Monaghan)', zip: '469669' },
	{ city: 'Gleno (Limerick)', zip: '539588' },
	{ city: 'Glenoge (Carlow)', zip: '589991' },
	{ city: 'Glenoge (Wexford)', zip: '254243' },
	{ city: 'Glenoghil (Longford)', zip: '132576' },
	{ city: 'Glenogra (Limerick)', zip: '596931' },
	{ city: 'Gleno Knocklatteragh (Limerick)', zip: '812307' },
	{ city: 'Gleno Newtown (Limerick)', zip: '815639' },
	{ city: 'Glenoory (Donegal)', zip: '166134' },
	{ city: 'Glenora (Mayo)', zip: '944301' },
	{ city: 'Glenosheen (Limerick)', zip: '776691' },
	{ city: 'Glenough Lower (Tipperary)', zip: '716889' },
	{ city: 'Glenoughty (Donegal)', zip: '119355' },
	{ city: 'Glenough Upper (Tipperary)', zip: '214686' },
	{ city: 'Glenour (Wexford)', zip: '383746' },
	{ city: 'Glenpatrick (Waterford)', zip: '843588' },
	{ city: 'Glenpaudeen (Tipperary)', zip: '607275' },
	{ city: 'Glenphilipeen (Wicklow)', zip: '334075' },
	{ city: 'Glenpipe (Kilkenny)', zip: '868469' },
	{ city: 'Glenquin (Clare)', zip: '390114' },
	{ city: 'Glenquin (Limerick)', zip: '877658' },
	{ city: 'Glenquin South (Limerick)', zip: '246509' },
	{ city: 'Glenranny (Wexford)', zip: '590422' },
	{ city: 'Glenrath (Meath)', zip: '281411' },
	{ city: 'Glenreagh (Cork)', zip: '152079' },
	{ city: 'Glenreagh (Kilkenny)', zip: '641067' },
	{ city: 'Glenreagh (Tipperary)', zip: '698067' },
	{ city: 'Glenreagh Beg (Tipperary)', zip: '950008' },
	{ city: 'Glenreagh More (Tipperary)', zip: '486496' },
	{ city: 'Glenree (Donegal)', zip: '663804' },
	{ city: 'Glenregan (Offaly)', zip: '819643' },
	{ city: 'Glenrevagh (Galway)', zip: '110782' },
	{ city: 'Glenrevagh (Roscommon)', zip: '127028' },
	{ city: 'Glenribbeen (Waterford)', zip: '788448' },
	{ city: 'Glenroe (Limerick)', zip: '210431' },
	{ city: 'Glenroe (Wexford)', zip: '478288' },
	{ city: 'Glensansaw (Kilkenny)', zip: '933540' },
	{ city: 'Glensharrold (Limerick)', zip: '178456' },
	{ city: 'Glenshask Beg (Waterford)', zip: '586286' },
	{ city: 'Glenshask More (Waterford)', zip: '981774' },
	{ city: 'Glensleade (Clare)', zip: '397227' },
	{ city: 'Glensmoil (Donegal)', zip: '794448' },
	{ city: 'Glen South (Clare)', zip: '666246' },
	{ city: 'Glen South (Cork)', zip: '935217' },
	{ city: 'Glenstal (Limerick)', zip: '722028' },
	{ city: 'Glenstown (Waterford)', zip: '629139' },
	{ city: 'Glentane (Cork)', zip: '529610' },
	{ city: 'Glentane (Tipperary)', zip: '238954' },
	{ city: 'Glentaneatnagh North (Cork)', zip: '233426' },
	{ city: 'Glentaneatnagh South (Cork)', zip: '120301' },
	{ city: 'Glentanedowney (Cork)', zip: '527025' },
	{ city: 'Glentanefinnane (Cork)', zip: '662450' },
	{ city: 'Glentanemacelligot (Cork)', zip: '603948' },
	{ city: 'Glentara (Tipperary)', zip: '356506' },
	{ city: 'Glentaun (Galway)', zip: '530027' },
	{ city: 'Glentaun (Roscommon)', zip: '388025' },
	{ city: 'Glentaunatinagh (Waterford)', zip: '350249' },
	{ city: 'Glentaun East (Waterford)', zip: '757260' },
	{ city: 'Glentaunemon (Waterford)', zip: '660173' },
	{ city: 'Glentaun West (Waterford)', zip: '725400' },
	{ city: 'Glentavraun (Mayo)', zip: '378727' },
	{ city: 'Glenteige (Wexford)', zip: '166891' },
	{ city: 'Glenteige (Wicklow)', zip: '906219' },
	{ city: 'Glenthomas (Mayo)', zip: '490443' },
	{ city: 'Glentidaly (Donegal)', zip: '271160' },
	{ city: 'Glentidaly Glebe (Donegal)', zip: '360934' },
	{ city: 'Glenties (Donegal)', zip: '475187' },
	{ city: 'Glenties (Roscommon)', zip: '717178' },
	{ city: 'Glentillid (Donegal)', zip: '646004' },
	{ city: 'Glentire (Wexford)', zip: '903142' },
	{ city: 'Glentiroe (Kilkenny)', zip: '291934' },
	{ city: 'Glentogher (Donegal)', zip: '776362' },
	{ city: 'Glentornan (Donegal)', zip: '164705' },
	{ city: 'Glentown (Donegal)', zip: '241680' },
	{ city: 'Glentrasna (Cork)', zip: '990865' },
	{ city: 'Glentrasna (Galway)', zip: '699472' },
	{ city: 'Glentrasna North (Cork)', zip: '763569' },
	{ city: 'Glentrasna South (Cork)', zip: '143844' },
	{ city: 'Glenturk Beg (Mayo)', zip: '173502' },
	{ city: 'Glenturk More (Mayo)', zip: '513303' },
	{ city: 'Glenulra (Mayo)', zip: '850271' },
	{ city: 'Glenummera (Mayo)', zip: '519963' },
	{ city: 'Glen Upper (Donegal)', zip: '486267' },
	{ city: 'Glen Upper (Sligo)', zip: '210639' },
	{ city: 'Glen Upper (Waterford)', zip: '173347' },
	{ city: 'Glenvar (Donegal)', zip: '585577' },
	{ city: 'Glenvela (Roscommon)', zip: '375492' },
	{ city: 'Glenville (Cork)', zip: '615917' },
	{ city: 'Glenville (Limerick)', zip: '562451' },
	{ city: 'Glenwanish (Clare)', zip: '892444' },
	{ city: 'Glen West (Cork)', zip: '893271' },
	{ city: 'Glen West (Waterford)', zip: '267195' },
	{ city: 'Glenwilliam (Limerick)', zip: '354621' },
	{ city: 'Glenwilliam (Waterford)', zip: '803408' },
	{ city: 'Glenwood (Clare)', zip: '395143' },
	{ city: 'Glenwood (Cork)', zip: '319308' },
	{ city: 'Glenwood (Wicklow)', zip: '817386' },
	{ city: 'Gliddane Beg (Waterford)', zip: '551330' },
	{ city: 'Gliddane More (Waterford)', zip: '512085' },
	{ city: 'Glin (Limerick)', zip: '756091' },
	{ city: 'Glinch (Monaghan)', zip: '539017' },
	{ city: 'Glin Demesne (Limerick)', zip: '396187' },
	{ city: 'Glinn (Kilkenny)', zip: '559484' },
	{ city: 'Glin North (Kerry)', zip: '751931' },
	{ city: 'Glinny (Cork)', zip: '651295' },
	{ city: 'Glinsk (Donegal)', zip: '789044' },
	{ city: 'Glinsk (Galway)', zip: '927903' },
	{ city: 'Glinsk (Mayo)', zip: '405213' },
	{ city: 'Glin South (Kerry)', zip: '763361' },
	{ city: 'Glistinane (Waterford)', zip: '552162' },
	{ city: 'Globeisland (Kildare)', zip: '451929' },
	{ city: 'Glomerstown (Westmeath)', zip: '937574' },
	{ city: 'Glooria (Roscommon)', zip: '783730' },
	{ city: 'Gloragh (Kerry)', zip: '108154' },
	{ city: 'Glounthaune (Cork)', zip: '327893' },
	{ city: 'Glouria (Kerry)', zip: '352015' },
	{ city: 'Gloves East (Galway)', zip: '475559' },
	{ city: 'Gloves Middle (Galway)', zip: '120049' },
	{ city: 'Gloves South (Galway)', zip: '379211' },
	{ city: 'Gloves West (Galway)', zip: '501458' },
	{ city: 'Glowens (Kildare)', zip: '629769' },
	{ city: 'Glydefarm (Louth)', zip: '915307' },
	{ city: 'Glyn (Offaly)', zip: '829864' },
	{ city: 'Glynn (Cork)', zip: '149250' },
	{ city: 'Glynn (Wexford)', zip: '837090' },
	{ city: 'Gneeve (Cavan)', zip: '975988' },
	{ city: 'Gneeve (Longford)', zip: '207218' },
	{ city: 'Gneeve (Mayo)', zip: '436329' },
	{ city: 'Gneevebane (Westmeath)', zip: '824993' },
	{ city: 'Gneevebeg (Westmeath)', zip: '240878' },
	{ city: 'Gneevebrack (Westmeath)', zip: '569949' },
	{ city: 'Gneevekeel (Westmeath)', zip: '933942' },
	{ city: 'Gneeves (Cork)', zip: '754688' },
	{ city: 'Gneeves (Kerry)', zip: '135219' },
	{ city: 'Gneevestown (Westmeath)', zip: '358376' },
	{ city: 'Gneevgullia (Kerry)', zip: '138737' },
	{ city: 'Goatisland (Limerick)', zip: '576622' },
	{ city: 'Goat Island (Donegal)', zip: '965619' },
	{ city: 'Goat Island (Galway)', zip: '975089' },
	{ city: 'Goatland (Galway)', zip: '479309' },
	{ city: 'Goatstown (Dublin)', zip: '827973' },
	{ city: 'Goatstown (Kildare)', zip: '625484' },
	{ city: 'Gobbinstown (Wexford)', zip: '459703' },
	{ city: 'Gobnascale (Donegal)', zip: '528332' },
	{ city: 'Goddamendy (Dublin)', zip: '737845' },
	{ city: 'Gogganshill (Cork)', zip: '797785' },
	{ city: 'Gogganstown (Cork)', zip: '920557' },
	{ city: 'Go Island (Donegal)', zip: '311873' },
	{ city: 'Gokane (Cork)', zip: '969576' },
	{ city: 'Gola (Cavan)', zip: '887491' },
	{ city: 'Gola (Donegal)', zip: '830207' },
	{ city: 'Gola (Monaghan)', zip: '752341' },
	{ city: 'Goladoo (Donegal)', zip: '772135' },
	{ city: 'Gola English (Monaghan)', zip: '534517' },
	{ city: 'Gola Irish (Monaghan)', zip: '344240' },
	{ city: 'Golam (Galway)', zip: '238687' },
	{ city: 'Golan (Donegal)', zip: '956652' },
	{ city: 'Golan (Monaghan)', zip: '962936' },
	{ city: 'Goland (Donegal)', zip: '281646' },
	{ city: 'Golanduff (Monaghan)', zip: '716705' },
	{ city: 'Golanmurphy (Monaghan)', zip: '755188' },
	{ city: 'Golard (Donegal)', zip: '228719' },
	{ city: 'Golashane (Meath)', zip: '737606' },
	{ city: 'Golden (Tipperary)', zip: '372293' },
	{ city: 'Goldenfield (Kilkenny)', zip: '857106' },
	{ city: 'Goldenfort (Wicklow)', zip: '765269' },
	{ city: 'Goldengarden (Tipperary)', zip: '452676' },
	{ city: 'Goldengrove (Tipperary)', zip: '825499' },
	{ city: 'Goldenhill (Wicklow)', zip: '494929' },
	{ city: 'Goldenhills (Tipperary)', zip: '347096' },
	{ city: 'Golden Island (Westmeath)', zip: '780004' },
	{ city: 'Goldenpark (Galway)', zip: '367515' },
	{ city: 'Goldrum (Donegal)', zip: '329168' },
	{ city: 'Goldsmithslot (Offaly)', zip: '727279' },
	{ city: 'Goleen (Cork)', zip: '709960' },
	{ city: 'Goleenmarsh (Cork)', zip: '910954' },
	{ city: 'Gollierstown (Dublin)', zip: '621932' },
	{ city: 'Golree (Monaghan)', zip: '172750' },
	{ city: 'Goodwinsgarden (Kilkenny)', zip: '282315' },
	{ city: 'Gooig (Limerick)', zip: '356589' },
	{ city: 'Goolamore (Mayo)', zip: '534041' },
	{ city: "Goold's Cross (Tipperary)", zip: '331109' },
	{ city: 'Gooldshill (Cork)', zip: '557449' },
	{ city: 'Gooreen (Galway)', zip: '223373' },
	{ city: 'Gooreenatinny (Galway)', zip: '736446' },
	{ city: 'Goorey (Donegal)', zip: '334485' },
	{ city: 'Gooseberryhill (Cork)', zip: '954049' },
	{ city: 'Goresbridge (Kilkenny)', zip: '566480' },
	{ city: 'Gorey (Wexford)', zip: '849956' },
	{ city: 'Goreybridge (Wexford)', zip: '985551' },
	{ city: 'Goreycorporationlands (Wexford)', zip: '799228' },
	{ city: 'Goreyhill (Wexford)', zip: '866082' },
	{ city: 'Gormagh (Offaly)', zip: '589699' },
	{ city: 'Gormanston (Meath)', zip: '776737' },
	{ city: 'Gormanston Demesne (Dublin)', zip: '164672' },
	{ city: 'Gormanstown (Kildare)', zip: '515741' },
	{ city: 'Gormanstown (Limerick)', zip: '225080' },
	{ city: 'Gormanstown (Meath)', zip: '629519' },
	{ city: 'Gormanstown (Tipperary)', zip: '983366' },
	{ city: 'Gormanstown (Westmeath)', zip: '599326' },
	{ city: 'Gormanstown (Wicklow)', zip: '660805' },
	{ city: 'Gormlee (Cork)', zip: '863024' },
	{ city: 'Gormona (Carlow)', zip: '149884' },
	{ city: 'Gorragh Lower (Laois)', zip: '771840' },
	{ city: 'Gorragh Upper (Laois)', zip: '184380' },
	{ city: 'Gorraun (Offaly)', zip: '675585' },
	{ city: 'Gorreelagh (Laois)', zip: '588320' },
	{ city: 'Gort (Donegal)', zip: '941682' },
	{ city: 'Gort (Galway)', zip: '808093' },
	{ city: 'Gort (Leitrim)', zip: '169324' },
	{ city: 'Gort (Mayo)', zip: '531456' },
	{ city: 'Gortaboy (Galway)', zip: '503277' },
	{ city: 'Gortacappul (Kerry)', zip: '786393' },
	{ city: 'Gortacareen (Kerry)', zip: '713879' },
	{ city: 'Gortacarnan (Roscommon)', zip: '697812' },
	{ city: 'Gortacarnaun (Galway)', zip: '310351' },
	{ city: 'Gortacashel (Cavan)', zip: '379946' },
	{ city: 'Gortachalla (Galway)', zip: '781431' },
	{ city: 'Gortachallow (Offaly)', zip: '192051' },
	{ city: 'Gortachoosh (Leitrim)', zip: '157441' },
	{ city: 'Gortachurk (Cavan)', zip: '445834' },
	{ city: 'Gortaclade (Waterford)', zip: '993884' },
	{ city: 'Gortaclare (Clare)', zip: '457196' },
	{ city: 'Gortaclareen (Limerick)', zip: '500404' },
	{ city: 'Gortaclivore (Tipperary)', zip: '611117' },
	{ city: 'Gortaclob (Clare)', zip: '901682' },
	{ city: 'Gortacloghane (Kerry)', zip: '272642' },
	{ city: 'Gortaclogher (Cavan)', zip: '376780' },
	{ city: 'Gortacloona (Cork)', zip: '234280' },
	{ city: 'Gortacloona (Limerick)', zip: '572371' },
	{ city: 'Gortacluggy (Cork)', zip: '949958' },
	{ city: 'Gortacollopa (Kerry)', zip: '387077' },
	{ city: 'Gortacoosan (Roscommon)', zip: '238114' },
	{ city: 'Gortacoosaun (Galway)', zip: '136475' },
	{ city: 'Gortacorka (Leitrim)', zip: '771228' },
	{ city: 'Gortacoula (Tipperary)', zip: '781966' },
	{ city: 'Gortacrank (Limerick)', zip: '564348' },
	{ city: 'Gortacreenteen (Kerry)', zip: '957119' },
	{ city: 'Gortacroghig (Cork)', zip: '887303' },
	{ city: 'Gortacrossane (Kerry)', zip: '637594' },
	{ city: 'Gortacrossig (Cork)', zip: '409971' },
	{ city: 'Gortacrue (Cork)', zip: '286970' },
	{ city: 'Gortacullin (Clare)', zip: '764424' },
	{ city: 'Gortacullin (Tipperary)', zip: '584739' },
	{ city: 'Gortaculrush (Tipperary)', zip: '224261' },
	{ city: 'Gortacur (Offaly)', zip: '898882' },
	{ city: 'Gortacurra (Mayo)', zip: '580585' },
	{ city: 'Gortacurra (Tipperary)', zip: '802431' },
	{ city: 'Gortacurraun (Kerry)', zip: '166478' },
	{ city: 'Gortacurrig (Cork)', zip: '560475' },
	{ city: 'Gortadalaun (Tipperary)', zip: '985113' },
	{ city: 'Gortadeegan (Galway)', zip: '459435' },
	{ city: 'Gortaderry (Clare)', zip: '519217' },
	{ city: 'Gortaderry (Sligo)', zip: '950927' },
	{ city: 'Gortaderry (Tipperary)', zip: '420263' },
	{ city: 'Gortadirra (Kerry)', zip: '684191' },
	{ city: 'Gortadoo (Kerry)', zip: '538900' },
	{ city: 'Gortadooey (Galway)', zip: '965025' },
	{ city: 'Gortadragaun (Galway)', zip: '562724' },
	{ city: 'Gortadragon (Donegal)', zip: '882525' },
	{ city: 'Gortadrislig (Kerry)', zip: '899493' },
	{ city: 'Gortadrohid (Cork)', zip: '217888' },
	{ city: 'Gortadroma (Clare)', zip: '376457' },
	{ city: 'Gortadroma (Limerick)', zip: '967616' },
	{ city: 'Gortadullisk (Galway)', zip: '332389' },
	{ city: 'Gortaficka (Clare)', zip: '532922' },
	{ city: 'Gortafludig (Cork)', zip: '389899' },
	{ city: 'Gortaforia (Kerry)', zip: '658181' },
	{ city: 'Gortaganniff (Limerick)', zip: '702254' },
	{ city: 'Gortaganniv (Clare)', zip: '342387' },
	{ city: 'Gortaganny (Galway)', zip: '493421' },
	{ city: 'Gortaganny (Roscommon)', zip: '583404' },
	{ city: 'Gortagarraun (Galway)', zip: '430086' },
	{ city: 'Gortagarry (Cork)', zip: '726960' },
	{ city: 'Gortagarry (Tipperary)', zip: '111698' },
	{ city: 'Gortagass (Kerry)', zip: '624848' },
	{ city: 'Gortagea (Tipperary)', zip: '637876' },
	{ city: 'Gortageen (Cork)', zip: '757369' },
	{ city: 'Gortagenerick (Cork)', zip: '600669' },
	{ city: 'Gortaggle (Leitrim)', zip: '823170' },
	{ city: 'Gortaghokera (Galway)', zip: '113680' },
	{ city: 'Gortagoulane (Cork)', zip: '263103' },
	{ city: 'Gortagousta (Cork)', zip: '486588' },
	{ city: 'Gortagowan (Galway)', zip: '212968' },
	{ city: 'Gortagowan (Kerry)', zip: '653531' },
	{ city: 'Gortagowlane (Tipperary)', zip: '682833' },
	{ city: 'Gortagraffer (Cork)', zip: '279410' },
	{ city: 'Gortagreenane (Kerry)', zip: '685027' },
	{ city: 'Gortagrenane (Cork)', zip: '216344' },
	{ city: 'Gortagullane (Kerry)', zip: '275319' },
	{ city: 'Gortagurrane East (Kerry)', zip: '888337' },
	{ city: 'Gortagurrane West (Kerry)', zip: '441641' },
	{ city: 'Gortaha (Galway)', zip: '361990' },
	{ city: 'Gortaheeda (Cork)', zip: '374821' },
	{ city: 'Gortahile (Laois)', zip: '405562' },
	{ city: 'Gortahilly (Waterford)', zip: '172446' },
	{ city: 'Gortahoola (Tipperary)', zip: '992018' },
	{ city: 'Gortahoonig (Kerry)', zip: '910291' },
	{ city: 'Gortahoosh (Kerry)', zip: '219984' },
	{ city: 'Gortahork (Donegal)', zip: '101203' },
	{ city: 'Gortahork (Leitrim)', zip: '280059' },
	{ city: 'Gortahumma (Tipperary)', zip: '283075' },
	{ city: 'Gortakeeghan (Monaghan)', zip: '134967' },
	{ city: 'Gortakeeran (Galway)', zip: '177079' },
	{ city: 'Gortakeeran (Sligo)', zip: '334689' },
	{ city: 'Gortakilleen (Limerick)', zip: '690123' },
	{ city: 'Gortakilleen (Tipperary)', zip: '241173' },
	{ city: 'Gortaknockane (Cork)', zip: '174887' },
	{ city: 'Gortaknockeare (Tipperary)', zip: '126052' },
	{ city: 'Gortalaban (Donegal)', zip: '762885' },
	{ city: 'Gortalassa (Clare)', zip: '701382' },
	{ city: 'Gortalassa (Cork)', zip: '246407' },
	{ city: 'Gortalassa (Kerry)', zip: '255996' },
	{ city: 'Gortalassa (Limerick)', zip: '653177' },
	{ city: 'Gortalavaun (Mayo)', zip: '741190' },
	{ city: 'Gortaleam (Galway)', zip: '298149' },
	{ city: 'Gortalee (Kerry)', zip: '580869' },
	{ city: 'Gortaleen (Cork)', zip: '101832' },
	{ city: 'Gortaleen (Kerry)', zip: '877478' },
	{ city: 'Gortaleen-Mountain (Kerry)', zip: '725953' },
	{ city: 'Gortalia (Donegal)', zip: '866252' },
	{ city: 'Gortalicka (Kerry)', zip: '754851' },
	{ city: 'Gortalinny North (Kerry)', zip: '610622' },
	{ city: 'Gortalinny South (Kerry)', zip: '282557' },
	{ city: 'Gortaliscaw (Cork)', zip: '538941' },
	{ city: 'Gortaloman (Galway)', zip: '356605' },
	{ city: 'Gortalough (Galway)', zip: '352660' },
	{ city: 'Gortalough (Sligo)', zip: '255730' },
	{ city: 'Gortalough (Tipperary)', zip: '692216' },
	{ city: 'Gortalougha (Clare)', zip: '305298' },
	{ city: 'Gortaloughane (Galway)', zip: '332610' },
	{ city: 'Gortaloughane (Kerry)', zip: '797295' },
	{ city: 'Gortamarle (Roscommon)', zip: '154605' },
	{ city: 'Gortamullin (Kerry)', zip: '981614' },
	{ city: 'Gortanabla (Roscommon)', zip: '112766' },
	{ city: 'Gortanacra (Cork)', zip: '260306' },
	{ city: 'Gortanaddan (Cork)', zip: '949522' },
	{ city: 'Gortanahaneboy East (Kerry)', zip: '313651' },
	{ city: 'Gortanahaneboy West (Kerry)', zip: '278484' },
	{ city: 'Gortananny (Galway)', zip: '669170' },
	{ city: 'Gortanassy East (Tipperary)', zip: '829000' },
	{ city: 'Gortanassy West (Tipperary)', zip: '438480' },
	{ city: 'Gortaneadin (Cork)', zip: '270934' },
	{ city: 'Gortanear (Westmeath)', zip: '225754' },
	{ city: 'Gortaneare (Galway)', zip: '248327' },
	{ city: 'Gortaneare (Kerry)', zip: '380636' },
	{ city: 'Gortaneden (Kerry)', zip: '108772' },
	{ city: 'Gortaneden (Mayo)', zip: '142799' },
	{ city: 'Gortaneelig (Cork)', zip: '508096' },
	{ city: 'Gortanerrig (Tipperary)', zip: '980116' },
	{ city: 'Gortaniddan (Tipperary)', zip: '244652' },
	{ city: 'Gortanierin (Mayo)', zip: '236808' },
	{ city: 'Gortanimerisk (Kerry)', zip: '383708' },
	{ city: 'Gortanimill (Cork)', zip: '198392' },
	{ city: 'Gortaniska (Clare)', zip: '606690' },
	{ city: 'Gortanisky (Offaly)', zip: '418076' },
	{ city: 'Gortanny (Donegal)', zip: '878439' },
	{ city: 'Gortanoura (Tipperary)', zip: '653634' },
	{ city: 'Gortanummera (Galway)', zip: '524793' },
	{ city: 'Gortanure (Cork)', zip: '145881' },
	{ city: 'Gortanure (Roscommon)', zip: '122714' },
	{ city: 'Gortanure North (Leitrim)', zip: '520477' },
	{ city: 'Gortanure South (Leitrim)', zip: '381911' },
	{ city: 'Gortaphuill (Mayo)', zip: '938967' },
	{ city: 'Gortaphuill (Roscommon)', zip: '996340' },
	{ city: 'Gortaphuntaun (Mayo)', zip: '720799' },
	{ city: 'Gortaquigley (Donegal)', zip: '817658' },
	{ city: 'Gortaquill (Cavan)', zip: '636909' },
	{ city: 'Gortard (Galway)', zip: '874301' },
	{ city: 'Gortard (Kerry)', zip: '265337' },
	{ city: 'Gortard (Tipperary)', zip: '362817' },
	{ city: 'Gortaree (Kerry)', zip: '575254' },
	{ city: 'Gortarevan (Offaly)', zip: '824359' },
	{ city: 'Gortarica (Galway)', zip: '555430' },
	{ city: 'Gortaroe (Galway)', zip: '738720' },
	{ city: 'Gortaroe (Mayo)', zip: '767027' },
	{ city: 'Gortaroo (Cork)', zip: '277836' },
	{ city: 'Gortarowey (Sligo)', zip: '720659' },
	{ city: 'Gortaruaun (Mayo)', zip: '116367' },
	{ city: 'Gortarush Lower (Tipperary)', zip: '870709' },
	{ city: 'Gortarush Upper (Tipperary)', zip: '283386' },
	{ city: 'Gortaskibbole (Mayo)', zip: '586123' },
	{ city: 'Gortaspiddale (Kerry)', zip: '520549' },
	{ city: 'Gortataggart (Clare)', zip: '714335' },
	{ city: 'Gortataggart (Tipperary)', zip: '841672' },
	{ city: 'Gortatanavally (Cork)', zip: '736308' },
	{ city: 'Gortateeboy (Cork)', zip: '709660' },
	{ city: 'Gortatemple (Tipperary)', zip: '122783' },
	{ city: 'Gortatlea (Kerry)', zip: '927584' },
	{ city: 'Gortatleva (Galway)', zip: '960563' },
	{ city: 'Gortatober (Mayo)', zip: '430623' },
	{ city: 'Gortatogher (Clare)', zip: '149135' },
	{ city: 'Gortatogher (Mayo)', zip: '805078' },
	{ city: 'Gortatooda (Tipperary)', zip: '685094' },
	{ city: 'Gortatoor (Mayo)', zip: '295508' },
	{ city: 'Gortatornora (Cork)', zip: '117202' },
	{ city: 'Gortatrassa (Clare)', zip: '977835' },
	{ city: 'Gortatray (Cork)', zip: '767045' },
	{ city: 'Gortatresk (Leitrim)', zip: '278162' },
	{ city: 'Gortavacan (Leitrim)', zip: '911337' },
	{ city: 'Gortavacoosh (Limerick)', zip: '903392' },
	{ city: 'Gortavadda (Cork)', zip: '553643' },
	{ city: 'Gortavalla (Tipperary)', zip: '751737' },
	{ city: 'Gortavalla East (Limerick)', zip: '238849' },
	{ city: 'Gortavalla North (Limerick)', zip: '579401' },
	{ city: 'Gortavalla South (Limerick)', zip: '677831' },
	{ city: 'Gortavallig (Cork)', zip: '273141' },
	{ city: 'Gortavallig (Kerry)', zip: '813340' },
	{ city: 'Gortavally (Galway)', zip: '748461' },
	{ city: 'Gortavally (Offaly)', zip: '614922' },
	{ city: 'Gortavaura (Galway)', zip: '269050' },
	{ city: 'Gortaveer (Cork)', zip: '870222' },
	{ city: 'Gortaveha (Clare)', zip: '447500' },
	{ city: 'Gortavehy East (Cork)', zip: '324247' },
	{ city: 'Gortavehy West (Cork)', zip: '704707' },
	{ city: 'Gortavella (Cork)', zip: '651371' },
	{ city: 'Gortavicary (Waterford)', zip: '298445' },
	{ city: 'Gortavoata (Laois)', zip: '832047' },
	{ city: 'Gortavoher (Cork)', zip: '613539' },
	{ city: 'Gortavoher (Galway)', zip: '431680' },
	{ city: 'Gortavoher East (Tipperary)', zip: '336610' },
	{ city: 'Gortavoher West (Tipperary)', zip: '565410' },
	{ city: 'Gortavranner (Cork)', zip: '379496' },
	{ city: 'Gortavrulla (Clare)', zip: '154890' },
	{ city: 'Gortavullin (Kerry)', zip: '178757' },
	{ city: 'Gortaward (Donegal)', zip: '883203' },
	{ city: 'Gortawarla (Mayo)', zip: '295476' },
	{ city: 'Gortaway (Donegal)', zip: '503283' },
	{ city: 'Gortawee (Cavan)', zip: '668776' },
	{ city: 'Gortawoer (Tipperary)', zip: '379600' },
	{ city: 'Gortawullaun (Galway)', zip: '742829' },
	{ city: 'Gortbaun (Mayo)', zip: '137843' },
	{ city: 'Gortbeg (Galway)', zip: '998771' },
	{ city: 'Gortbofarna (Clare)', zip: '662362' },
	{ city: 'Gortbofinna (Cork)', zip: '460894' },
	{ city: 'Gortboy (Kerry)', zip: '536644' },
	{ city: 'Gortboy (Limerick)', zip: '307909' },
	{ city: 'Gortboy (Roscommon)', zip: '249518' },
	{ city: 'Gortboyheen (Clare)', zip: '779739' },
	{ city: 'Gortbrack (Cork)', zip: '109887' },
	{ city: 'Gortbrack (Galway)', zip: '531328' },
	{ city: 'Gortbrack (Kerry)', zip: '927969' },
	{ city: 'Gortbrack (Mayo)', zip: '752988' },
	{ city: 'Gortbrack (Tipperary)', zip: '337592' },
	{ city: 'Gortbrack East (Kerry)', zip: '223386' },
	{ city: 'Gortbrackmoor (Galway)', zip: '252777' },
	{ city: 'Gortbrack North (Mayo)', zip: '376472' },
	{ city: 'Gortbrack South (Mayo)', zip: '643651' },
	{ city: 'Gortbrack West (Kerry)', zip: '350436' },
	{ city: 'Gortbreagoge (Kerry)', zip: '897790' },
	{ city: 'Gortbrien (Limerick)', zip: '905356' },
	{ city: 'Gortbunacullin (Mayo)', zip: '657617' },
	{ city: 'Gortcally (Donegal)', zip: '285468' },
	{ city: 'Gortcallyroe (Clare)', zip: '571062' },
	{ city: 'Gortcam (Galway)', zip: '738267' },
	{ city: 'Gortclohy (Kerry)', zip: '151897' },
	{ city: 'Gortcloonagh (Roscommon)', zip: '509348' },
	{ city: 'Gortcloonmore (Galway)', zip: '761025' },
	{ city: 'Gortconnellan (Leitrim)', zip: '431705' },
	{ city: 'Gortcooldurrin (Clare)', zip: '909649' },
	{ city: 'Gortcorcoran (Cork)', zip: '981626' },
	{ city: 'Gortcormacan (Donegal)', zip: '911018' },
	{ city: 'Gortcreen (Offaly)', zip: '419070' },
	{ city: 'Gortcross (Donegal)', zip: '453508' },
	{ city: 'Gortcurka (Clare)', zip: '573158' },
	{ city: 'Gortcurreen (Kerry)', zip: '349429' },
	{ city: 'Gortderraree (Kerry)', zip: '376339' },
	{ city: 'Gortderrig (Kerry)', zip: '804065' },
	{ city: 'Gortderryboy (Tipperary)', zip: '685669' },
	{ city: 'Gortdirragh (Kerry)', zip: '878100' },
	{ city: 'Gortdonaghmore (Cork)', zip: '444830' },
	{ city: 'Gortdotia North (Cork)', zip: '385696' },
	{ city: 'Gortdotia South (Cork)', zip: '223826' },
	{ city: 'Gortdrishagh (Galway)', zip: '344662' },
	{ city: 'Gortdromagh (Cork)', zip: '557204' },
	{ city: 'Gortdromagh (Kerry)', zip: '499663' },
	{ city: 'Gortdromagownagh (Kerry)', zip: '175510' },
	{ city: 'Gortdromakiery (Kerry)', zip: '537089' },
	{ city: 'Gortdromasillahy (Kerry)', zip: '292239' },
	{ city: 'Gortdromerillagh (Kerry)', zip: '976477' },
	{ city: 'Gortdrum (Tipperary)', zip: '485680' },
	{ city: 'Gortduff (Cork)', zip: '291036' },
	{ city: 'Gortduff (Galway)', zip: '334185' },
	{ city: 'Gorteanish (Cork)', zip: '133679' },
	{ city: 'Gortearagh (Cork)', zip: '904323' },
	{ city: 'Gorteen (Cavan)', zip: '678897' },
	{ city: 'Gorteen (Clare)', zip: '726329' },
	{ city: 'Gorteen (Galway)', zip: '327962' },
	{ city: 'Gorteen (Kildare)', zip: '884089' },
	{ city: 'Gorteen (Kilkenny)', zip: '301714' },
	{ city: 'Gorteen (Laois)', zip: '838636' },
	{ city: 'Gorteen (Leitrim)', zip: '374549' },
	{ city: 'Gorteen (Limerick)', zip: '449335' },
	{ city: 'Gorteen (Longford)', zip: '251851' },
	{ city: 'Gorteen (Louth)', zip: '909901' },
	{ city: 'Gorteen (Mayo)', zip: '472906' },
	{ city: 'Gorteen (Offaly)', zip: '393850' },
	{ city: 'Gorteen (Sligo)', zip: '252663' },
	{ city: 'Gorteen (Tipperary)', zip: '471329' },
	{ city: 'Gorteen (Waterford)', zip: '274434' },
	{ city: 'Gorteen (Westmeath)', zip: '815779' },
	{ city: 'Gorteen (Wexford)', zip: '615659' },
	{ city: 'Gorteen (Wicklow)', zip: '311549' },
	{ city: 'Gorteenacammadil (Roscommon)', zip: '643532' },
	{ city: 'Gorteenachurry (Leitrim)', zip: '779901' },
	{ city: 'Gorteenacra (Galway)', zip: '909511' },
	{ city: 'Gorteenadiha (Tipperary)', zip: '740808' },
	{ city: 'Gorteenadrolane (Cork)', zip: '112930' },
	{ city: 'Gorteenafoly (Offaly)', zip: '776319' },
	{ city: 'Gorteenagloon (Longford)', zip: '905298' },
	{ city: 'Gorteenaguinnell (Leitrim)', zip: '497046' },
	{ city: 'Gorteenahilla (Laois)', zip: '859331' },
	{ city: 'Gorteenalomane (Cork)', zip: '219198' },
	{ city: 'Gorteenameale (Laois)', zip: '360721' },
	{ city: 'Gorteenaneelig (Clare)', zip: '226313' },
	{ city: 'Gorteenanillaun (Galway)', zip: '763053' },
	{ city: 'Gorteenaniska (Galway)', zip: '826759' },
	{ city: 'Gorteenapheebera (Galway)', zip: '674910' },
	{ city: 'Gorteenaphooka (Tipperary)', zip: '907675' },
	{ city: 'Gorteenaphoria (Tipperary)', zip: '835594' },
	{ city: 'Gorteenara (Kilkenny)', zip: '502406' },
	{ city: 'Gorteenard (Offaly)', zip: '339597' },
	{ city: 'Gorteenashingaun (Tipperary)', zip: '792222' },
	{ city: 'Gorteenatarriff (Cork)', zip: '929484' },
	{ city: 'Gorteenavalla (Tipperary)', zip: '796296' },
	{ city: 'Gorteenaveela (Galway)', zip: '952795' },
	{ city: 'Gorteenawillin (Galway)', zip: '739328' },
	{ city: 'Gorteenayanka (Galway)', zip: '454636' },
	{ city: 'Gorteen Beg (Mayo)', zip: '404473' },
	{ city: 'Gorteenboy (Galway)', zip: '852334' },
	{ city: 'Gorteenboy (Longford)', zip: '125373' },
	{ city: 'Gorteenbrack (Roscommon)', zip: '951034' },
	{ city: 'Gorteencahill (Galway)', zip: '279502' },
	{ city: 'Gorteenclareen (Longford)', zip: '956342' },
	{ city: 'Gorteencloogh (Roscommon)', zip: '244239' },
	{ city: 'Gorteencrin (Wexford)', zip: '109201' },
	{ city: 'Gorteendangan (Tipperary)', zip: '840894' },
	{ city: 'Gorteendarragh (Leitrim)', zip: '266346' },
	{ city: 'Gorteendarragh (Mayo)', zip: '843359' },
	{ city: 'Gorteendrishagh (Galway)', zip: '555370' },
	{ city: 'Gorteendrunagh (Mayo)', zip: '907394' },
	{ city: 'Gorteenduvane (Tipperary)', zip: '577952' },
	{ city: 'Gorteen East (Limerick)', zip: '686218' },
	{ city: 'Gorteenfadda (Galway)', zip: '684040' },
	{ city: 'Gorteengar (Longford)', zip: '933857' },
	{ city: 'Gorteengrone (Carlow)', zip: '538893' },
	{ city: 'Gorteenkeel (Offaly)', zip: '713382' },
	{ city: 'Gorteenlahard (Galway)', zip: '477277' },
	{ city: 'Gorteen Lower (Kildare)', zip: '207557' },
	{ city: 'Gorteen Lower (Tipperary)', zip: '264780' },
	{ city: 'Gorteen Lower (Wexford)', zip: '600463' },
	{ city: 'Gorteenlynagh (Mayo)', zip: '873834' },
	{ city: 'Gorteenmacnamara (Clare)', zip: '101886' },
	{ city: 'Gorteenmagher (Tipperary)', zip: '985016' },
	{ city: 'Gorteenminoge Lower (Wexford)', zip: '429150' },
	{ city: 'Gorteenminoge Upper (Wexford)', zip: '612799' },
	{ city: 'Gorteenmore (Mayo)', zip: '130085' },
	{ city: 'Gorteen More (Mayo)', zip: '846113' },
	{ city: 'Gorteennabarna (Tipperary)', zip: '267562' },
	{ city: 'Gorteennabohogy (Galway)', zip: '606383' },
	{ city: 'Gorteennacreeagh (Limerick)', zip: '299849' },
	{ city: 'Gorteennafinnoge (Cork)', zip: '763593' },
	{ city: 'Gorteennaglogh (Cavan)', zip: '121635' },
	{ city: 'Gorteennaglogh (Galway)', zip: '908117' },
	{ city: 'Gorteennaguppoge (Clare)', zip: '812997' },
	{ city: 'Gorteennakilla (Cork)', zip: '343745' },
	{ city: 'Gorteennakilla (Tipperary)', zip: '644669' },
	{ city: 'Gorteennalee (Kilkenny)', zip: '996603' },
	{ city: 'Gorteennamona (Tipperary)', zip: '292329' },
	{ city: 'Gorteennamrock (Limerick)', zip: '161487' },
	{ city: 'Gorteennamuck (Kilkenny)', zip: '156949' },
	{ city: 'Gorteennamuck (Mayo)', zip: '108886' },
	{ city: 'Gorteennaskagh (Limerick)', zip: '802793' },
	{ city: 'Gorteen North (Tipperary)', zip: '139579' },
	{ city: 'Gorteenoona (Kildare)', zip: '328484' },
	{ city: 'Gorteenoran (Leitrim)', zip: '716142' },
	{ city: 'Gorteenorna (Longford)', zip: '112427' },
	{ city: 'Gorteenphadder (Galway)', zip: '982348' },
	{ city: 'Gorteenrainee (Tipperary)', zip: '193604' },
	{ city: 'Gorteenreagh (Clare)', zip: '214693' },
	{ city: 'Gorteenrevagh (Longford)', zip: '164036' },
	{ city: 'Gorteenreynard (Limerick)', zip: '686288' },
	{ city: 'Gorteenroe (Mayo)', zip: '151350' },
	{ city: 'Gorteenruckaun (Galway)', zip: '153004' },
	{ city: 'Gorteens (Kilkenny)', zip: '694913' },
	{ city: 'Gorteens (Limerick)', zip: '281870' },
	{ city: 'Gorteens (Mayo)', zip: '958389' },
	{ city: 'Gorteens (Monaghan)', zip: '686250' },
	{ city: 'Gorteens (Wexford)', zip: '276465' },
	{ city: 'Gorteenshamrogue (Tipperary)', zip: '217815' },
	{ city: 'Gorteen South (Tipperary)', zip: '910443' },
	{ city: 'Gorteenteen (Kilkenny)', zip: '103848' },
	{ city: 'Gorteen Upper (Kildare)', zip: '306884' },
	{ city: 'Gorteen Upper (Tipperary)', zip: '993526' },
	{ city: 'Gorteen Upper (Wexford)', zip: '670274' },
	{ city: 'Gorteenvacan (Kildare)', zip: '984514' },
	{ city: 'Gorteen West (Limerick)', zip: '655568' },
	{ city: 'Gorteeny (Galway)', zip: '604426' },
	{ city: 'Gorteeny (Tipperary)', zip: '636545' },
	{ city: 'Gorteeshal (Tipperary)', zip: '210186' },
	{ city: 'Gortermone (Leitrim)', zip: '220109' },
	{ city: 'Gortermone (Sligo)', zip: '404385' },
	{ city: 'Gortersluin (Sligo)', zip: '210207' },
	{ city: 'Gorterwulla (Galway)', zip: '588093' },
	{ city: 'Gortfad (Donegal)', zip: '628212' },
	{ city: 'Gortfadda (Galway)', zip: '708728' },
	{ city: 'Gortfadda (Kerry)', zip: '983550' },
	{ city: 'Gortfadda (Leitrim)', zip: '268354' },
	{ city: 'Gortfadda (Limerick)', zip: '546123' },
	{ city: 'Gortfadda (Mayo)', zip: '484822' },
	{ city: 'Gortfahy (Mayo)', zip: '399322' },
	{ city: 'Gortflugh (Donegal)', zip: '157919' },
	{ city: 'Gortfree (Mayo)', zip: '937586' },
	{ city: 'Gortfree (Tipperary)', zip: '182334' },
	{ city: 'Gortgallan (Roscommon)', zip: '947770' },
	{ city: 'Gortgarra (Donegal)', zip: '513084' },
	{ city: 'Gortgarralt (Limerick)', zip: '284742' },
	{ city: 'Gortgarraun (Clare)', zip: '871869' },
	{ city: 'Gortgarriff (Cork)', zip: '395035' },
	{ city: 'Gortgarrigan (Leitrim)', zip: '246279' },
	{ city: 'Gortgarrow (Galway)', zip: '723498' },
	{ city: 'Gortgarve (Mayo)', zip: '472329' },
	{ city: 'Gortglass (Kerry)', zip: '808735' },
	{ city: 'Gort Glebe (Donegal)', zip: '484386' },
	{ city: 'Gortgower (Kerry)', zip: '486189' },
	{ city: 'Gortgranagh (Donegal)', zip: '332856' },
	{ city: 'Gortgranard (Monaghan)', zip: '634918' },
	{ city: 'Gorticleave (Monaghan)', zip: '605748' },
	{ city: 'Gorticmeelra (Roscommon)', zip: '151787' },
	{ city: 'Gortigrenane (Cork)', zip: '698193' },
	{ city: 'Gortin (Cavan)', zip: '601473' },
	{ city: 'Gortin (Donegal)', zip: '709373' },
	{ city: 'Gortinar (Leitrim)', zip: '193592' },
	{ city: 'Gortinarable (Tipperary)', zip: '432737' },
	{ city: 'Gortinee (Leitrim)', zip: '795094' },
	{ city: 'Gortiness (Donegal)', zip: '417295' },
	{ city: 'Gortinessy (Donegal)', zip: '266647' },
	{ city: 'Gortinlieve (Donegal)', zip: '283473' },
	{ city: 'Gortin North (Donegal)', zip: '844328' },
	{ city: 'Gortinreagh (Donegal)', zip: '880516' },
	{ city: 'Gortins (Wexford)', zip: '153761' },
	{ city: 'Gortins Great (Wexford)', zip: '477022' },
	{ city: 'Gortins Little (Wexford)', zip: '675727' },
	{ city: 'Gortin South (Donegal)', zip: '794116' },
	{ city: 'Gortinty (Leitrim)', zip: '308959' },
	{ city: 'Gortinure (Leitrim)', zip: '244944' },
	{ city: 'Gortjordan (Mayo)', zip: '843111' },
	{ city: 'Gortkeel (Clare)', zip: '645435' },
	{ city: 'Gortkelly (Tipperary)', zip: '337805' },
	{ city: 'Gortkilly (Donegal)', zip: '592317' },
	{ city: 'Gortknappagh (Galway)', zip: '165678' },
	{ city: 'Gortknock (Tipperary)', zip: '830395' },
	{ city: 'Gortknockaneroe (Cork)', zip: '493044' },
	{ city: 'Gortlahan (Mayo)', zip: '655855' },
	{ city: 'Gortlahard (Kerry)', zip: '605498' },
	{ city: 'Gortlandroe (Tipperary)', zip: '445364' },
	{ city: 'Gortlanna (Monaghan)', zip: '427192' },
	{ city: 'Gortlassabrien (Tipperary)', zip: '366843' },
	{ city: 'Gortlaunaght (Cavan)', zip: '928784' },
	{ city: 'Gortleatilla (Mayo)', zip: '739669' },
	{ city: 'Gortleck (Donegal)', zip: '524880' },
	{ city: 'Gortleck (Roscommon)', zip: '324843' },
	{ city: 'Gortlecka (Clare)', zip: '290389' },
	{ city: 'Gortlee (Donegal)', zip: '378490' },
	{ city: 'Gortlemon (Galway)', zip: '985117' },
	{ city: 'Gortletteragh (Donegal)', zip: '257855' },
	{ city: 'Gortletteragh (Leitrim)', zip: '405414' },
	{ city: 'Gortlicka (Kerry)', zip: '510898' },
	{ city: 'Gortloney (Meath)', zip: '524641' },
	{ city: 'Gortlosky (Donegal)', zip: '160902' },
	{ city: 'Gortlough (Donegal)', zip: '427222' },
	{ city: 'Gortloughera (Kerry)', zip: '608918' },
	{ city: 'Gortloughra (Cork)', zip: '290183' },
	{ city: 'Gortloughra (Kerry)', zip: '728130' },
	{ city: 'Gortlownan (Sligo)', zip: '368773' },
	{ city: 'Gortlum (Dublin)', zip: '635476' },
	{ city: 'Gortlurkaun (Clare)', zip: '379887' },
	{ city: 'Gortlush (Donegal)', zip: '261261' },
	{ city: 'Gortlusky (Galway)', zip: '292666' },
	{ city: 'Gortlusky (Laois)', zip: '124841' },
	{ city: 'Gortlustia (Roscommon)', zip: '978180' },
	{ city: 'Gortmacall Beg (Donegal)', zip: '744813' },
	{ city: 'Gortmacall More (Donegal)', zip: '124068' },
	{ city: 'Gortmagy (Clare)', zip: '115255' },
	{ city: 'Gortmahonoge (Tipperary)', zip: '211693' },
	{ city: 'Gortmakellis (Tipperary)', zip: '882122' },
	{ city: 'Gortmaloge (Tipperary)', zip: '406087' },
	{ city: 'Gortmaloon East (Kerry)', zip: '334687' },
	{ city: 'Gortmaloon West (Kerry)', zip: '920087' },
	{ city: 'Gortmanna (Limerick)', zip: '202692' },
	{ city: 'Gortmarrahafineen (Kerry)', zip: '141689' },
	{ city: 'Gortmellia (Mayo)', zip: '170872' },
	{ city: 'Gortmolire (Cork)', zip: '554965' },
	{ city: 'Gortmoney (Monaghan)', zip: '771984' },
	{ city: 'Gortmore (Cavan)', zip: '163526' },
	{ city: 'Gortmore (Clare)', zip: '732815' },
	{ city: 'Gortmore (Cork)', zip: '562860' },
	{ city: 'Gortmore (Galway)', zip: '127128' },
	{ city: 'Gortmore (Kerry)', zip: '551681' },
	{ city: 'Gortmore (Limerick)', zip: '780919' },
	{ city: 'Gortmore (Mayo)', zip: '366807' },
	{ city: 'Gortmore (Roscommon)', zip: '854053' },
	{ city: 'Gortmore (Tipperary)', zip: '111548' },
	{ city: 'Gortmore (Westmeath)', zip: '268346' },
	{ city: 'Gortmore North (Monaghan)', zip: '386305' },
	{ city: 'Gortmore South (Monaghan)', zip: '214602' },
	{ city: 'Gortmorris (Galway)', zip: '745922' },
	{ city: 'Gortmullin (Tipperary)', zip: '325846' },
	{ city: 'Gortmunga (Tipperary)', zip: '465280' },
	{ city: 'Gortnabarnaboy (Galway)', zip: '132828' },
	{ city: 'Gortnabarnan (Tipperary)', zip: '627972' },
	{ city: 'Gortnabinna (Cork)', zip: '839602' },
	{ city: 'Gortnabinny (Kerry)', zip: '951582' },
	{ city: 'Gortnaboha (Galway)', zip: '113978' },
	{ city: 'Gortnaboley (Tipperary)', zip: '489008' },
	{ city: 'Gortnaboola (Limerick)', zip: '379621' },
	{ city: 'Gortnaboul (Clare)', zip: '981471' },
	{ city: 'Gortnaboul (Kerry)', zip: '283479' },
	{ city: 'Gortnaboul Lower (Kerry)', zip: '314799' },
	{ city: 'Gortnaboul Upper (Kerry)', zip: '331295' },
	{ city: 'Gortnabrade (Donegal)', zip: '912155' },
	{ city: 'Gortnacally (Tipperary)', zip: '466932' },
	{ city: 'Gortnacamdarragh (Leitrim)', zip: '624143' },
	{ city: 'Gortnacargy (Cavan)', zip: '397246' },
	{ city: 'Gortnacarriga (Cork)', zip: '473326' },
	{ city: 'Gortnacarriga (Kerry)', zip: '226846' },
	{ city: 'Gortnacart Glebe (Donegal)', zip: '676677' },
	{ city: 'Gortnaclassagh (Galway)', zip: '949429' },
	{ city: 'Gortnaclassagh (Mayo)', zip: '228986' },
	{ city: 'Gortnaclea (Laois)', zip: '886582' },
	{ city: 'Gortnacleha (Tipperary)', zip: '346235' },
	{ city: 'Gortnacleigh (Cavan)', zip: '960520' },
	{ city: 'Gortnaclogh (Cork)', zip: '285483' },
	{ city: 'Gortnaclogh (Tipperary)', zip: '668541' },
	{ city: 'Gortnacloghy (Galway)', zip: '769968' },
	{ city: 'Gortnaclohy (Clare)', zip: '639069' },
	{ city: 'Gortnaclohy (Cork)', zip: '217816' },
	{ city: 'Gortnaclohy (Limerick)', zip: '479896' },
	{ city: 'Gortnacloy (Roscommon)', zip: '187915' },
	{ city: 'Gortnacooheen (Galway)', zip: '790087' },
	{ city: 'Gortnacoolagh (Limerick)', zip: '392920' },
	{ city: 'Gortnacoolagh (Tipperary)', zip: '563051' },
	{ city: 'Gortnacor (Donegal)', zip: '869514' },
	{ city: 'Gortnacorkoge (Leitrim)', zip: '352708' },
	{ city: 'Gortnacorragh (Clare)', zip: '694699' },
	{ city: 'Gortnacorrib (Donegal)', zip: '871055' },
	{ city: 'Gortnacowly (Cork)', zip: '703195' },
	{ city: 'Gortnacran Beg (Tipperary)', zip: '109774' },
	{ city: 'Gortnacran More (Tipperary)', zip: '334492' },
	{ city: 'Gortnacrannagh (Offaly)', zip: '586865' },
	{ city: 'Gortnacrannagh (Roscommon)', zip: '708199' },
	{ city: 'Gortnacreha (Cork)', zip: '784677' },
	{ city: 'Gortnacreha Lower (Limerick)', zip: '850886' },
	{ city: 'Gortnacreha Upper (Limerick)', zip: '766362' },
	{ city: 'Gortnacrieve (Leitrim)', zip: '706815' },
	{ city: 'Gortnacross (Galway)', zip: '696939' },
	{ city: 'Gortnacrusha North (Cork)', zip: '210828' },
	{ city: 'Gortnacrusha South (Cork)', zip: '853102' },
	{ city: 'Gortnacullia (Galway)', zip: '462486' },
	{ city: 'Gortnacurra (Clare)', zip: '790583' },
	{ city: 'Gortnacurra (Kerry)', zip: '451071' },
	{ city: 'Gortnacurragh (Kilkenny)', zip: '964106' },
	{ city: 'Gortnada (Tipperary)', zip: '618502' },
	{ city: 'Gortnadarra (Roscommon)', zip: '256763' },
	{ city: 'Gortnadeeve East (Galway)', zip: '679007' },
	{ city: 'Gortnadeeve West (Galway)', zip: '850789' },
	{ city: 'Gortnaderrary (Leitrim)', zip: '606442' },
	{ city: 'Gortnaderrylea (Cavan)', zip: '505693' },
	{ city: 'Gortnadiha Lower (Waterford)', zip: '676851' },
	{ city: 'Gortnadiha Upper (Waterford)', zip: '416871' },
	{ city: 'Gortnadihy (Cork)', zip: '975640' },
	{ city: 'Gortnadrass (Sligo)', zip: '204289' },
	{ city: 'Gortnadrehy (Mayo)', zip: '647167' },
	{ city: 'Gortnadromin (Limerick)', zip: '893492' },
	{ city: 'Gortnadrumman (Tipperary)', zip: '207296' },
	{ city: 'Gortnadrung (Sligo)', zip: '544378' },
	{ city: 'Gortnadullagh (Kerry)', zip: '233603' },
	{ city: 'Gortnadumagh (Tipperary)', zip: '859212' },
	{ city: 'Gortnafira (Cork)', zip: '296280' },
	{ city: 'Gortnafolla (Mayo)', zip: '506727' },
	{ city: 'Gortnafunshion (Cork)', zip: '220687' },
	{ city: 'Gortnafurra (Tipperary)', zip: '947790' },
	{ city: 'Gortnagan Beg (Kerry)', zip: '838813' },
	{ city: 'Gortnagane (Kerry)', zip: '308436' },
	{ city: 'Gortnagan More (Kerry)', zip: '996730' },
	{ city: 'Gortnagap (Kilkenny)', zip: '513048' },
	{ city: 'Gortnagappul (Cork)', zip: '249489' },
	{ city: 'Gortnagappul (Kerry)', zip: '373029' },
	{ city: 'Gortnagarde (Limerick)', zip: '345305' },
	{ city: 'Gortnagark (Cork)', zip: '406148' },
	{ city: 'Gortnagarn (Leitrim)', zip: '795735' },
	{ city: 'Gortnagashel (Cork)', zip: '224247' },
	{ city: 'Gortnagearagh (Cork)', zip: '703185' },
	{ city: 'Gortnageeragh (Mayo)', zip: '188763' },
	{ city: 'Gortnagier East (Galway)', zip: '585638' },
	{ city: 'Gortnagier West (Galway)', zip: '803163' },
	{ city: 'Gortnagishagh (Cork)', zip: '755490' },
	{ city: 'Gortnaglearagh (Clare)', zip: '308780' },
	{ city: 'Gortnagleav (Galway)', zip: '836532' },
	{ city: 'Gortnaglogh (Clare)', zip: '701830' },
	{ city: 'Gortnaglogh (Cork)', zip: '435139' },
	{ city: 'Gortnaglogh (Galway)', zip: '259262' },
	{ city: 'Gortnaglogh (Kerry)', zip: '721564' },
	{ city: 'Gortnaglogh (Kilkenny)', zip: '477987' },
	{ city: 'Gortnaglogh (Laois)', zip: '420408' },
	{ city: 'Gortnaglogh (Limerick)', zip: '379286' },
	{ city: 'Gortnaglogh (Tipperary)', zip: '860487' },
	{ city: 'Gortnagluggin (Limerick)', zip: '871349' },
	{ city: 'Gortnagole (Donegal)', zip: '129633' },
	{ city: 'Gortnagonnella (Clare)', zip: '451312' },
	{ city: 'Gortnagoul (Cork)', zip: '863739' },
	{ city: 'Gortnagowna (Tipperary)', zip: '381065' },
	{ city: 'Gortnagoyne (Galway)', zip: '916902' },
	{ city: 'Gortnagoyne (Roscommon)', zip: '762549' },
	{ city: 'Gortnagrace (Donegal)', zip: '504606' },
	{ city: 'Gortnagraiga (Cork)', zip: '347870' },
	{ city: 'Gortnagranagher (Mayo)', zip: '819348' },
	{ city: 'Gortnagrann (Tipperary)', zip: '246940' },
	{ city: 'Gortnagranna (Tipperary)', zip: '190987' },
	{ city: 'Gortnagree (Kerry)', zip: '680679' },
	{ city: 'Gortnagrelly (Sligo)', zip: '290988' },
	{ city: 'Gortnagroagh (Galway)', zip: '565123' },
	{ city: 'Gortnagroagh (Laois)', zip: '121701' },
	{ city: 'Gortnagrogerny (Leitrim)', zip: '110318' },
	{ city: 'Gortnagross (Cork)', zip: '887638' },
	{ city: 'Gortnagross (Limerick)', zip: '509709' },
	{ city: 'Gortnagrough (Cork)', zip: '913436' },
	{ city: 'Gortnagrour (Limerick)', zip: '964751' },
	{ city: 'Gortnagulla (Kerry)', zip: '879619' },
	{ city: 'Gortnagullanagh (Kerry)', zip: '245760' },
	{ city: 'Gortnagullion (Leitrim)', zip: '550129' },
	{ city: 'Gortnagunned (Galway)', zip: '680577' },
	{ city: 'Gortnagusetaul (Mayo)', zip: '979095' },
	{ city: 'Gortnahaha (Clare)', zip: '542089' },
	{ city: 'Gortnahaha (Tipperary)', zip: '199357' },
	{ city: 'Gortnahahaboy (Tipperary)', zip: '979855' },
	{ city: 'Gortnahalla (Tipperary)', zip: '145017' },
	{ city: 'Gortnahaskany (Galway)', zip: '685337' },
	{ city: 'Gortnaheltia (Mayo)', zip: '916441' },
	{ city: 'Gortnahimrissan (Galway)', zip: '913094' },
	{ city: 'Gortnahomna Beg (Cork)', zip: '413855' },
	{ city: 'Gortnahomna More (Cork)', zip: '411569' },
	{ city: 'Gortnahoo (Tipperary)', zip: '594871' },
	{ city: 'Gortnahoon (Galway)', zip: '139847' },
	{ city: 'Gortnahorna (Galway)', zip: '770634' },
	{ city: 'Gortnahorna (Meath)', zip: '612006' },
	{ city: 'Gortnahoughtee (Cork)', zip: '616808' },
	{ city: 'Gortnahoula (Sligo)', zip: '730465' },
	{ city: 'Gortnahown (Cork)', zip: '633415' },
	{ city: 'Gortnahown (Galway)', zip: '978793' },
	{ city: 'Gortnahulla (Kerry)', zip: '712218' },
	{ city: 'Gortnahulla (Tipperary)', zip: '690182' },
	{ city: 'Gortnahultra (Galway)', zip: '504091' },
	{ city: 'Gortnahurra Lower (Mayo)', zip: '817571' },
	{ city: 'Gortnahurra Upper (Mayo)', zip: '264884' },
	{ city: 'Gortnakesh (Cavan)', zip: '645907' },
	{ city: 'Gortnakilla (Galway)', zip: '405633' },
	{ city: 'Gortnakilla (Kerry)', zip: '328812' },
	{ city: 'Gortnakillew (Cavan)', zip: '342827' },
	{ city: 'Gortnakilly (Cork)', zip: '307622' },
	{ city: 'Gortnakilly (Kerry)', zip: '967472' },
	{ city: 'Gortnakistin (Limerick)', zip: '848901' },
	{ city: 'Gortnalaght (Waterford)', zip: '748819' },
	{ city: 'Gortnalahagh (Limerick)', zip: '773906' },
	{ city: 'Gortnalahee (Cork)', zip: '679398' },
	{ city: 'Gortnalamph (Leitrim)', zip: '878598' },
	{ city: 'Gortnalara (Tipperary)', zip: '734167' },
	{ city: 'Gortnalaragh (Donegal)', zip: '645969' },
	{ city: 'Gortnalavey (Galway)', zip: '941161' },
	{ city: 'Gortnalea (Galway)', zip: '459537' },
	{ city: 'Gortnaleaha (Kerry)', zip: '959809' },
	{ city: 'Gortnaleck (Cavan)', zip: '921324' },
	{ city: 'Gortnaleck (Donegal)', zip: '911326' },
	{ city: 'Gortnaleck (Sligo)', zip: '262877' },
	{ city: 'Gortnalecka (Galway)', zip: '435866' },
	{ city: 'Gortnalee (Laois)', zip: '895168' },
	{ city: 'Gortnaleg (Cavan)', zip: '683108' },
	{ city: 'Gortnalibbert (Leitrim)', zip: '636628' },
	{ city: 'Gortnalicky (Cork)', zip: '698233' },
	{ city: 'Gortnalone North (Galway)', zip: '787823' },
	{ city: 'Gortnalone South (Galway)', zip: '517772' },
	{ city: 'Gortnalougher (Leitrim)', zip: '825050' },
	{ city: 'Gortnaloughra (Cork)', zip: '269496' },
	{ city: 'Gortnalour (Cork)', zip: '274816' },
	{ city: 'Gortnaloura (Galway)', zip: '471761' },
	{ city: 'Gortnalower (Tipperary)', zip: '859059' },
	{ city: 'Gortnalug (Galway)', zip: '437406' },
	{ city: 'Gortnalug (Leitrim)', zip: '683977' },
	{ city: 'Gortnalughoge (Donegal)', zip: '130765' },
	{ city: 'Gortnalusheen (Cork)', zip: '359409' },
	{ city: 'Gortnalyer (Mayo)', zip: '838119' },
	{ city: 'Gortnamackan (Galway)', zip: '218539' },
	{ city: 'Gortnamackanee (Kerry)', zip: '922670' },
	{ city: 'Gortnamannagh East (Galway)', zip: '443256' },
	{ city: 'Gortnamannagh West (Galway)', zip: '331562' },
	{ city: 'Gortnamearacaun (Clare)', zip: '733447' },
	{ city: 'Gortnaminna (Cork)', zip: '882994' },
	{ city: 'Gortnaminsha (Kerry)', zip: '451406' },
	{ city: 'Gortnamona (Cork)', zip: '325752' },
	{ city: 'Gortnamona (Galway)', zip: '177402' },
	{ city: 'Gortnamona East (Galway)', zip: '322399' },
	{ city: 'Gortnamona West (Galway)', zip: '473371' },
	{ city: 'Gortnamoney (Donegal)', zip: '988195' },
	{ city: 'Gortnamuck (Clare)', zip: '236054' },
	{ city: 'Gortnamuck (Donegal)', zip: '169928' },
	{ city: 'Gortnamuck (Offaly)', zip: '417362' },
	{ city: 'Gortnamuckaly (Kerry)', zip: '858365' },
	{ city: 'Gortnamucklagh (Cork)', zip: '450196' },
	{ city: 'Gortnamucklagh (Donegal)', zip: '607154' },
	{ city: 'Gortnamucky (Cork)', zip: '455177' },
	{ city: 'Gortnamuinga (Clare)', zip: '179633' },
	{ city: 'Gortnana (Monaghan)', zip: '380453' },
	{ city: 'Gortnanark (Galway)', zip: '346151' },
	{ city: 'Gortnanool (Clare)', zip: '907362' },
	{ city: 'Gortnanoon (Cork)', zip: '950068' },
	{ city: 'Gortnanooran (Kerry)', zip: '166700' },
	{ city: 'Gortnanoul (Cavan)', zip: '735907' },
	{ city: 'Gortnanuv (Limerick)', zip: '964117' },
	{ city: 'Gortnapeaky (Waterford)', zip: '294418' },
	{ city: 'Gortnapeasty (Cork)', zip: '760805' },
	{ city: 'Gortnaporia (Galway)', zip: '530545' },
	{ city: 'Gortnaprocess (Kerry)', zip: '235164' },
	{ city: 'Gortnaraby (Mayo)', zip: '182371' },
	{ city: 'Gortnarah (Leitrim)', zip: '716217' },
	{ city: 'Gortnaraha (Mayo)', zip: '569362' },
	{ city: 'Gortnaraheen (Galway)', zip: '911498' },
	{ city: 'Gortnarea (Cork)', zip: '821031' },
	{ city: 'Gortnarup (Galway)', zip: '358128' },
	{ city: 'Gortnasate (Donegal)', zip: '209578' },
	{ city: 'Gortnascarry (Limerick)', zip: '413042' },
	{ city: 'Gortnascarty (Cork)', zip: '573814' },
	{ city: 'Gortnascreeny (Clare)', zip: '289735' },
	{ city: 'Gortnascreeny (Cork)', zip: '548236' },
	{ city: 'Gortnascregga (Cork)', zip: '781844' },
	{ city: 'Gortnasculloge (Galway)', zip: '485288' },
	{ city: 'Gortnasculloge (Tipperary)', zip: '416253' },
	{ city: 'Gortnashammer (Mayo)', zip: '295340' },
	{ city: 'Gortnashangan Lower (Cavan)', zip: '439317' },
	{ city: 'Gortnashangan Upper (Cavan)', zip: '639182' },
	{ city: 'Gortnasharvoge (Roscommon)', zip: '790037' },
	{ city: 'Gortnashingaun (Galway)', zip: '544907' },
	{ city: 'Gortnasillagh (Donegal)', zip: '873167' },
	{ city: 'Gortnasillagh (Galway)', zip: '511823' },
	{ city: 'Gortnasillagh (Leitrim)', zip: '103238' },
	{ city: 'Gortnasillagh (Mayo)', zip: '959309' },
	{ city: 'Gortnasillagh (Roscommon)', zip: '223035' },
	{ city: 'Gortnasillagh East (Leitrim)', zip: '697760' },
	{ city: 'Gortnasillagh West (Leitrim)', zip: '819531' },
	{ city: 'Gortnaskagh (Clare)', zip: '865642' },
	{ city: 'Gortnaskagh (Limerick)', zip: '376245' },
	{ city: 'Gortnaskarry (Kerry)', zip: '520538' },
	{ city: 'Gortnaskea (Donegal)', zip: '828056' },
	{ city: 'Gortnaskeagh (Donegal)', zip: '207818' },
	{ city: 'Gortnaskeagh (Kerry)', zip: '226641' },
	{ city: 'Gortnaskeagh (Leitrim)', zip: '544309' },
	{ city: 'Gortnaskeha (Kerry)', zip: '100515' },
	{ city: 'Gortnaskeha Commons (Kerry)', zip: '664555' },
	{ city: 'Gortnaskehy (Cork)', zip: '955023' },
	{ city: 'Gortnaskehy (Limerick)', zip: '119294' },
	{ city: 'Gortnaskehy (Tipperary)', zip: '267299' },
	{ city: 'Gortnaskohoge (Mayo)', zip: '471755' },
	{ city: 'Gortnasmuttaun (Mayo)', zip: '419089' },
	{ city: 'Gortnasmuttaun (Tipperary)', zip: '770388' },
	{ city: 'Gortnasna (Cork)', zip: '981804' },
	{ city: 'Gortnasoolboy (Roscommon)', zip: '672208' },
	{ city: 'Gortnasragh (Kilkenny)', zip: '523927' },
	{ city: 'Gortnastang (Mayo)', zip: '223454' },
	{ city: 'Gortnasteal (Galway)', zip: '776317' },
	{ city: 'Gortnasythe (Roscommon)', zip: '989974' },
	{ city: 'Gortnatona (Kerry)', zip: '896892' },
	{ city: 'Gortnatraw North (Donegal)', zip: '873829' },
	{ city: 'Gortnatraw South (Donegal)', zip: '923552' },
	{ city: 'Gortnatubbrid (Cork)', zip: '445943' },
	{ city: 'Gortnavarnoge (Tipperary)', zip: '143546' },
	{ city: 'Gortnaveigh (Tipperary)', zip: '656180' },
	{ city: 'Gortnavern (Donegal)', zip: '478738' },
	{ city: 'Gortnavilly (Donegal)', zip: '442294' },
	{ city: 'Gortnavreaghaun (Clare)', zip: '216434' },
	{ city: 'Gortnavreeghan (Cavan)', zip: '196868' },
	{ city: 'Gortnawaun (Leitrim)', zip: '151376' },
	{ city: 'Gortnawhinny (Monaghan)', zip: '763709' },
	{ city: 'Gortnesk (Donegal)', zip: '887690' },
	{ city: 'Gort North (Donegal)', zip: '919143' },
	{ city: 'Gortolee (Tipperary)', zip: '663947' },
	{ city: 'Gortonora (Kerry)', zip: '118656' },
	{ city: 'Gortoorlan (Cavan)', zip: '304138' },
	{ city: 'Gortore (Cork)', zip: '115641' },
	{ city: 'Gortphaudeen (Kilkenny)', zip: '520674' },
	{ city: 'Gortracussane (Kerry)', zip: '819987' },
	{ city: 'Gortrea (Galway)', zip: '221589' },
	{ city: 'Gortreagh (Kerry)', zip: '409943' },
	{ city: 'Gortreagh (Limerick)', zip: '601671' },
	{ city: 'Gortreagh (Tipperary)', zip: '198078' },
	{ city: 'Gortree (Donegal)', zip: '163570' },
	{ city: 'Gortrelig (Kerry)', zip: '434763' },
	{ city: 'Gortrevagh (Galway)', zip: '585413' },
	{ city: 'Gortroche (Cork)', zip: '663276' },
	{ city: 'Gortroe (Cork)', zip: '584019' },
	{ city: 'Gortroe (Galway)', zip: '315741' },
	{ city: 'Gortroe (Kerry)', zip: '216334' },
	{ city: 'Gortroe (Limerick)', zip: '423925' },
	{ city: 'Gortroe Lower (Cork)', zip: '770264' },
	{ city: 'Gortroe Upper (Cork)', zip: '240166' },
	{ city: 'Gortronnagh (Galway)', zip: '826737' },
	{ city: 'Gortrooskagh (Kerry)', zip: '578126' },
	{ city: 'Gortrory (Galway)', zip: '180800' },
	{ city: 'Gortroyan East (Galway)', zip: '146820' },
	{ city: 'Gortroyan West (Galway)', zip: '164001' },
	{ city: 'Gortrummagh (Galway)', zip: '307404' },
	{ city: 'Gortrush (Kilkenny)', zip: '504141' },
	{ city: 'Gortsallagh (Cork)', zip: '552009' },
	{ city: 'Gortshanavogh (Kerry)', zip: '109525' },
	{ city: 'Gortshanecrone (Cork)', zip: '555180' },
	{ city: 'Gortshane East (Tipperary)', zip: '319982' },
	{ city: 'Gortshane Middle (Tipperary)', zip: '259314' },
	{ city: 'Gortshaneroe (Tipperary)', zip: '682582' },
	{ city: 'Gortshane West (Tipperary)', zip: '837059' },
	{ city: 'Gortshanvally (Kerry)', zip: '884825' },
	{ city: 'Gortsheela (Galway)', zip: '595196' },
	{ city: 'Gortskagh (Cork)', zip: '749509' },
	{ city: 'Gortskagh (Limerick)', zip: '649303' },
	{ city: 'Gortskeagh (Cavan)', zip: '684617' },
	{ city: 'Gortskeagh (Galway)', zip: '168366' },
	{ city: 'Gortskeddia (Mayo)', zip: '898114' },
	{ city: 'Gortskeha (Offaly)', zip: '468407' },
	{ city: 'Gortskehy (Mayo)', zip: '712451' },
	{ city: 'Gortsmoorane (Cork)', zip: '386159' },
	{ city: 'Gort South (Donegal)', zip: '846760' },
	{ city: 'Gortstoke (Cork)', zip: '803967' },
	{ city: 'Gortstuckanagh (Galway)', zip: '452965' },
	{ city: 'Gorttoose (Roscommon)', zip: '549506' },
	{ city: 'Gorttyowen (Cork)', zip: '875386' },
	{ city: 'Gortullaghan (Cavan)', zip: '164401' },
	{ city: 'Gortumly (Westmeath)', zip: '513450' },
	{ city: 'Gortussa (Tipperary)', zip: '699888' },
	{ city: 'Gortvunatrime (Tipperary)', zip: '765724' },
	{ city: 'Gortyarrigan (Donegal)', zip: '455689' },
	{ city: 'Gortybrigane (Tipperary)', zip: '439956' },
	{ city: 'Gortyclery (Leitrim)', zip: '781203' },
	{ city: 'Gortycullane (Tipperary)', zip: '852182' },
	{ city: 'Gortygara (Sligo)', zip: '720633' },
	{ city: 'Gortygeeheen (Clare)', zip: '695804' },
	{ city: 'Gortyknaveen (Limerick)', zip: '950632' },
	{ city: 'Gortyleahy (Cork)', zip: '212768' },
	{ city: 'Gortyleane (Roscommon)', zip: '446413' },
	{ city: 'Gortyloughlin (Galway)', zip: '286256' },
	{ city: 'Gortymadden (Galway)', zip: '889614' },
	{ city: 'Gortyneill (Galway)', zip: '379189' },
	{ city: 'Gortyogan (Tipperary)', zip: '289111' },
	{ city: 'Gortyowen (Cork)', zip: '597084' },
	{ city: 'Gortyrahilly (Cork)', zip: '825666' },
	{ city: 'Gortyvahane (Limerick)', zip: '428847' },
	{ city: 'Gorumna (Galway)', zip: '798069' },
	{ city: 'Goslingstown (Kilkenny)', zip: '161714' },
	{ city: 'Gossbrook (Laois)', zip: '737325' },
	{ city: 'Gotham (Kildare)', zip: '132124' },
	{ city: 'Gotinstown (Tipperary)', zip: '206677' },
	{ city: 'Gotoon (Limerick)', zip: '494680' },
	{ city: 'Gougane (Cork)', zip: '943646' },
	{ city: 'Goulacullin (Cork)', zip: '768899' },
	{ city: 'Gouladoo (Cork)', zip: '209277' },
	{ city: 'Goulaun (Mayo)', zip: '453046' },
	{ city: 'Gouldavoher (Limerick)', zip: '306750' },
	{ city: 'Goulmore (Tipperary)', zip: '756286' },
	{ city: 'Goulnacappy And Coornagrena (Kerry)', zip: '813366' },
	{ city: 'Goulreagh (Tipperary)', zip: '510248' },
	{ city: 'Goulyduff (Kildare)', zip: '368756' },
	{ city: 'Gour (Cork)', zip: '392356' },
	{ city: 'Gouree Beg (Cork)', zip: '911281' },
	{ city: 'Gouree More (Cork)', zip: '332183' },
	{ city: 'Gowel (Leitrim)', zip: '900843' },
	{ city: 'Gowel (Mayo)', zip: '169246' },
	{ city: 'Gowelboy (Mayo)', zip: '499769' },
	{ city: 'Gowerhass (Clare)', zip: '272114' },
	{ city: 'Gower North (Clare)', zip: '331868' },
	{ city: 'Gower South (Clare)', zip: '115675' },
	{ city: 'Gowil (Galway)', zip: '127363' },
	{ city: 'Gowla (Galway)', zip: '360133' },
	{ city: 'Gowlagh North (Cavan)', zip: '106706' },
	{ city: 'Gowlagh South (Cavan)', zip: '131061' },
	{ city: 'Gowlan (Cavan)', zip: '467932' },
	{ city: 'Gowlan (Longford)', zip: '913722' },
	{ city: 'Gowlane (Cork)', zip: '780707' },
	{ city: 'Gowlane (Kerry)', zip: '145292' },
	{ city: 'Gowlaneard (Kerry)', zip: '652329' },
	{ city: 'Gowlan East (Galway)', zip: '890320' },
	{ city: 'Gowlane Beg (Kerry)', zip: '266543' },
	{ city: 'Gowlane East (Kerry)', zip: '312612' },
	{ city: 'Gowlane North (Cork)', zip: '427730' },
	{ city: 'Gowlanes (Kerry)', zip: '103489' },
	{ city: 'Gowlanes East (Kerry)', zip: '970984' },
	{ city: 'Gowlane South (Cork)', zip: '497137' },
	{ city: 'Gowlan West (Galway)', zip: '637776' },
	{ city: 'Gowlat (Cavan)', zip: '660705' },
	{ city: 'Gowlaun (Clare)', zip: '884926' },
	{ city: 'Gowlaun (Galway)', zip: '819160' },
	{ city: 'Gowlaun (Leitrim)', zip: '674529' },
	{ city: 'Gowlaun (Mayo)', zip: '923396' },
	{ city: 'Gowlaun (Waterford)', zip: '997421' },
	{ city: 'Gowlaunlee (Galway)', zip: '341435' },
	{ city: 'Gowlaun Mountain (Waterford)', zip: '169933' },
	{ city: 'Gowlaunrevagh (Leitrim)', zip: '191670' },
	{ city: 'Gowle (Wicklow)', zip: '403538' },
	{ city: 'Gowlin (Carlow)', zip: '721130' },
	{ city: 'Gowlin (Kerry)', zip: '525646' },
	{ city: 'Gowly (Leitrim)', zip: '307667' },
	{ city: 'Gowran (Kilkenny)', zip: '822479' },
	{ city: 'Gowran Demesne (Kilkenny)', zip: '633504' },
	{ city: 'Gracedieu (Dublin)', zip: '531697' },
	{ city: 'Gracefield (Laois)', zip: '619545' },
	{ city: 'Graceland (Tipperary)', zip: '527604' },
	{ city: 'Graceswood (Laois)', zip: '668142' },
	{ city: 'Graddoge (Galway)', zip: '367881' },
	{ city: 'Graddoge (Mayo)', zip: '967178' },
	{ city: 'Graddum (Cavan)', zip: '378202' },
	{ city: 'Gradoge (Leitrim)', zip: '387657' },
	{ city: 'Graffa Beg (Mayo)', zip: '169109' },
	{ city: 'Graffagh (Monaghan)', zip: '789945' },
	{ city: 'Graffa More (Mayo)', zip: '913014' },
	{ city: 'Graffan (Offaly)', zip: '257689' },
	{ city: 'Graffanstown (Westmeath)', zip: '724198' },
	{ city: 'Graffee (Kerry)', zip: '930515' },
	{ city: 'Graffeens (Kerry)', zip: '170055' },
	{ city: 'Graffin (Tipperary)', zip: '901852' },
	{ city: 'Graffoge (Longford)', zip: '153692' },
	{ city: 'Graffoge (Roscommon)', zip: '500643' },
	{ city: 'Graffy (Donegal)', zip: '251157' },
	{ city: 'Graffy (Mayo)', zip: '668942' },
	{ city: 'Gragadder (Kildare)', zip: '712514' },
	{ city: 'Gragane (Limerick)', zip: '422907' },
	{ city: 'Gragan East (Clare)', zip: '232515' },
	{ city: 'Gragan West (Clare)', zip: '902689' },
	{ city: 'Gragara (Kilkenny)', zip: '532734' },
	{ city: 'Gragarnagh (Monaghan)', zip: '869423' },
	{ city: 'Gragaugh (Tipperary)', zip: '104024' },
	{ city: 'Grageelagh (Wexford)', zip: '306098' },
	{ city: 'Grageen (Wexford)', zip: '258418' },
	{ city: 'Grageen Little (Wexford)', zip: '115180' },
	{ city: 'Gragh (Longford)', zip: '107407' },
	{ city: 'Graghil (Mayo)', zip: '891500' },
	{ city: 'Gragullagh (Roscommon)', zip: '855687' },
	{ city: 'Grahamsland (Donegal)', zip: '321956' },
	{ city: 'Grahamstown (Donegal)', zip: '794625' },
	{ city: 'Graheeroge (Wexford)', zip: '698390' },
	{ city: 'Grahormack (Wexford)', zip: '122593' },
	{ city: 'Grahormick (Wexford)', zip: '267243' },
	{ city: 'Graig (Cork)', zip: '754269' },
	{ city: 'Graig (Limerick)', zip: '218864' },
	{ city: 'Graigabbey (Galway)', zip: '450687' },
	{ city: 'Graigabbey South (Galway)', zip: '424514' },
	{ city: 'Graigacurragh (Limerick)', zip: '243061' },
	{ city: 'Graigaheesha (Tipperary)', zip: '468860' },
	{ city: 'Graigaman (Tipperary)', zip: '738014' },
	{ city: 'Graiganster (Limerick)', zip: '426501' },
	{ city: 'Graigariddy (Waterford)', zip: '834256' },
	{ city: 'Graigavalla (Waterford)', zip: '259847' },
	{ city: 'Graigavern (Laois)', zip: '631508' },
	{ city: 'Graigavine (Kilkenny)', zip: '359755' },
	{ city: 'Graigbeg (Limerick)', zip: '912733' },
	{ city: 'Graigeen (Limerick)', zip: '713502' },
	{ city: 'Graigillane (Tipperary)', zip: '832176' },
	{ city: 'Graignagower (Kerry)', zip: '684809' },
	{ city: 'Graignagower (Waterford)', zip: '206601' },
	{ city: 'Graignagreana (Kerry)', zip: '215523' },
	{ city: 'Graigoor (Limerick)', zip: '249289' },
	{ city: 'Graigrooth (Kildare)', zip: '220659' },
	{ city: 'Graigs (Meath)', zip: '134746' },
	{ city: 'Graigue (Carlow)', zip: '451708' },
	{ city: 'Graigue (Cork)', zip: '189901' },
	{ city: 'Graigue (Galway)', zip: '373666' },
	{ city: 'Graigue (Kerry)', zip: '807538' },
	{ city: 'Graigue (Kilkenny)', zip: '394289' },
	{ city: 'Graigue (Laois)', zip: '307063' },
	{ city: 'Graigue (Limerick)', zip: '515904' },
	{ city: 'Graigue (Offaly)', zip: '107580' },
	{ city: 'Graigue (Sligo)', zip: '833053' },
	{ city: 'Graigue (Tipperary)', zip: '287935' },
	{ city: 'Graigue (Waterford)', zip: '276861' },
	{ city: 'Graigue (Wexford)', zip: '725629' },
	{ city: 'Graigue (Wicklow)', zip: '228873' },
	{ city: 'Graigueachullaire (Galway)', zip: '573485' },
	{ city: 'Graigueadrisly (Laois)', zip: '208446' },
	{ city: 'Graigueafulla (Laois)', zip: '272095' },
	{ city: 'Graigueagarran (Laois)', zip: '361689' },
	{ city: 'Graigueagowan (Galway)', zip: '864700' },
	{ city: 'Graigueakilleen (Galway)', zip: '295772' },
	{ city: 'Graiguealug (Carlow)', zip: '155067' },
	{ city: 'Graigueanossy (Laois)', zip: '727089' },
	{ city: 'Graigueard (Laois)', zip: '854603' },
	{ city: 'Graiguearush (Waterford)', zip: '438972' },
	{ city: 'Graigueavallagh (Laois)', zip: '967706' },
	{ city: 'Graigueavoice (Laois)', zip: '446414' },
	{ city: 'Graigueavurra (Waterford)', zip: '421104' },
	{ city: 'Graigueawoneen (Galway)', zip: '751050' },
	{ city: 'Graiguebaun (Galway)', zip: '304655' },
	{ city: 'Graiguebeg (Tipperary)', zip: '393231' },
	{ city: 'Graigue Beg (Waterford)', zip: '340447' },
	{ city: 'Graigue Beg (Wexford)', zip: '495199' },
	{ city: 'Graigue East (Cork)', zip: '850935' },
	{ city: 'Graiguefrahane (Tipperary)', zip: '635374' },
	{ city: 'Graigue Glebe (Kerry)', zip: '771603' },
	{ city: 'Graigue Great (Wexford)', zip: '912844' },
	{ city: 'Graiguelin (Kildare)', zip: '666463' },
	{ city: 'Graigue Little (Tipperary)', zip: '537115' },
	{ city: 'Graigue Little (Wexford)', zip: '700684' },
	{ city: 'Graigue Lower (Kilkenny)', zip: '210667' },
	{ city: 'Graigue Lower (Tipperary)', zip: '677072' },
	{ city: 'Graigue More (Waterford)', zip: '158096' },
	{ city: 'Graigue More (Wexford)', zip: '325360' },
	{ city: 'Graiguenageeha (Waterford)', zip: '128995' },
	{ city: 'Graiguenahown (Laois)', zip: '511274' },
	{ city: 'Graiguenakill (Kilkenny)', zip: '932665' },
	{ city: 'Graiguenamanagh (Kilkenny)', zip: '529318' },
	{ city: 'Graiguenasmuttan (Laois)', zip: '490226' },
	{ city: 'Graiguenaspiddoge (Carlow)', zip: '942155' },
	{ city: 'Graiguenavaddoge (Galway)', zip: '515781' },
	{ city: 'Graiguenoe (Tipperary)', zip: '820399' },
	{ city: 'Graigueooly (Kilkenny)', zip: '706127' },
	{ city: 'Graiguepadeen (Tipperary)', zip: '308667' },
	{ city: 'Graiguepottle (Kildare)', zip: '120717' },
	{ city: 'Graigues (Kerry)', zip: '862824' },
	{ city: 'Graigues (Kildare)', zip: '128400' },
	{ city: 'Graigues (Limerick)', zip: '859578' },
	{ city: 'Graiguesallagh (Kildare)', zip: '764651' },
	{ city: 'Graiguesallagh (Wexford)', zip: '737820' },
	{ city: 'Graigueshoneen (Waterford)', zip: '140471' },
	{ city: 'Graiguesmeadow (Kilkenny)', zip: '359646' },
	{ city: 'Graiguesparling (Limerick)', zip: '632910' },
	{ city: 'Graigueswood (Kilkenny)', zip: '806689' },
	{ city: 'Graigue Upper (Kilkenny)', zip: '604335' },
	{ city: 'Graigue Upper (Tipperary)', zip: '772280' },
	{ city: 'Graigue West (Cork)', zip: '447409' },
	{ city: 'Graig Upper (Cork)', zip: '535350' },
	{ city: 'Grallagh (Dublin)', zip: '944505' },
	{ city: 'Grallagh (Galway)', zip: '503131' },
	{ city: 'Grallagh (Mayo)', zip: '378838' },
	{ city: 'Grallagh (Roscommon)', zip: '290897' },
	{ city: 'Grallagh (Tipperary)', zip: '302370' },
	{ city: 'Grallagh (Waterford)', zip: '986768' },
	{ city: 'Grallagh Beg (Roscommon)', zip: '383273' },
	{ city: 'Grallaghgarden (Mayo)', zip: '346775' },
	{ city: 'Grallagh Lower (Waterford)', zip: '960976' },
	{ city: 'Grallagh More (Roscommon)', zip: '121996' },
	{ city: 'Grallagh Upper (Waterford)', zip: '828152' },
	{ city: 'Granabeg Lower (Wicklow)', zip: '363324' },
	{ city: 'Granabeg Upper (Wicklow)', zip: '597760' },
	{ city: 'Granafallow (Laois)', zip: '194496' },
	{ city: 'Granagh (Limerick)', zip: '422902' },
	{ city: 'Granaghan (Clare)', zip: '280438' },
	{ city: 'Granaghan (Roscommon)', zip: '608836' },
	{ city: 'Granaghan Beg (Clare)', zip: '239635' },
	{ city: 'Granaghan More (Clare)', zip: '861876' },
	{ city: 'Granamore (Wicklow)', zip: '112029' },
	{ city: 'Granard (Limerick)', zip: '463659' },
	{ city: 'Granard (Longford)', zip: '184734' },
	{ city: 'Granardkill (Longford)', zip: '871568' },
	{ city: 'Grandy (Cork)', zip: '959727' },
	{ city: 'Graney East (Kildare)', zip: '302482' },
	{ city: 'Graney West (Kildare)', zip: '732730' },
	{ city: 'Grange (Cork)', zip: '202633' },
	{ city: 'Grange (Donegal)', zip: '404843' },
	{ city: 'Grange (Dublin)', zip: '775137' },
	{ city: 'Grange (Galway)', zip: '256990' },
	{ city: 'Grange (Kildare)', zip: '653683' },
	{ city: 'Grange (Kilkenny)', zip: '254350' },
	{ city: 'Grange (Laois)', zip: '985396' },
	{ city: 'Grange (Leitrim)', zip: '938395' },
	{ city: 'Grange (Limerick)', zip: '531414' },
	{ city: 'Grange (Louth)', zip: '772957' },
	{ city: 'Grange (Mayo)', zip: '726337' },
	{ city: 'Grange (Meath)', zip: '353149' },
	{ city: 'Grange (Offaly)', zip: '903370' },
	{ city: 'Grange (Roscommon)', zip: '880518' },
	{ city: 'Grange (Sligo)', zip: '658763' },
	{ city: 'Grange (Tipperary)', zip: '538631' },
	{ city: 'Grange (Waterford)', zip: '249433' },
	{ city: 'Grange (Westmeath)', zip: '193773' },
	{ city: 'Grange (Wexford)', zip: '590598' },
	{ city: 'Grange And Kiltober (Westmeath)', zip: '600052' },
	{ city: 'Grangebarry (Tipperary)', zip: '249622' },
	{ city: 'Grangebeg (Kildare)', zip: '596979' },
	{ city: 'Grangebeg (Tipperary)', zip: '515375' },
	{ city: 'Grange Beg (Cork)', zip: '800574' },
	{ city: 'Grange Beg (Galway)', zip: '730400' },
	{ city: 'Grange Beg (Kildare)', zip: '104554' },
	{ city: 'Grange Beg (Laois)', zip: '472489' },
	{ city: 'Grange Beg (Roscommon)', zip: '479057' },
	{ city: 'Grange Beg (Sligo)', zip: '474803' },
	{ city: 'Grange Beg (Tipperary)', zip: '111702' },
	{ city: 'Grange Beg (Westmeath)', zip: '637914' },
	{ city: 'Grangebeg Barr (Sligo)', zip: '395529' },
	{ city: 'Grangebellew (Louth)', zip: '792021' },
	{ city: 'Grange Big (Wexford)', zip: '642534' },
	{ city: 'Grangecastle (Tipperary)', zip: '316326' },
	{ city: 'Grangeclare (Kildare)', zip: '212773' },
	{ city: 'Grangeclare East (Kildare)', zip: '115707' },
	{ city: 'Grangeclare Little (Kildare)', zip: '327004' },
	{ city: 'Grangeclare West (Kildare)', zip: '998042' },
	{ city: 'Grangecommon (Kildare)', zip: '378909' },
	{ city: 'Grange Con (Wicklow)', zip: '424805' },
	{ city: 'Grangecon Demesne (Wicklow)', zip: '529753' },
	{ city: 'Grangecon Hill (Wicklow)', zip: '723779' },
	{ city: 'Grangecon Lower (Wicklow)', zip: '379580' },
	{ city: 'Grangecon Parks (Wicklow)', zip: '325793' },
	{ city: 'Grangecon Rocks (Wicklow)', zip: '160230' },
	{ city: 'Grangecon Upper (Wicklow)', zip: '572559' },
	{ city: 'Grangecoor (Kildare)', zip: '395821' },
	{ city: 'Grangecrag (Tipperary)', zip: '723664' },
	{ city: 'Grangecuffe (Kilkenny)', zip: '626373' },
	{ city: 'Grange Demesne (Wexford)', zip: '976878' },
	{ city: 'Grangeduff (Tipperary)', zip: '784198' },
	{ city: 'Grange East (Cork)', zip: '282483' },
	{ city: 'Grange East (Galway)', zip: '149537' },
	{ city: 'Grange East (Kildare)', zip: '735082' },
	{ city: 'Grange East (Limerick)', zip: '990338' },
	{ city: 'Grange East (Sligo)', zip: '597443' },
	{ city: 'Grangefertagh (Kilkenny)', zip: '911909' },
	{ city: 'Grangeford (Carlow)', zip: '777288' },
	{ city: 'Grangeford (Kildare)', zip: '525236' },
	{ city: 'Grangeford Old (Carlow)', zip: '626752' },
	{ city: 'Grangegeeth (Meath)', zip: '178039' },
	{ city: 'Grangegeeth (Westmeath)', zip: '252088' },
	{ city: 'Grangegibbon (Westmeath)', zip: '591437' },
	{ city: 'Grange Glebe (Meath)', zip: '637512' },
	{ city: 'Grangegoddan Glebe (Meath)', zip: '625488' },
	{ city: 'Grangehiggin (Kildare)', zip: '641424' },
	{ city: 'Grangehill (Kilkenny)', zip: '845249' },
	{ city: 'Grangehill (Tipperary)', zip: '748260' },
	{ city: 'Grange Irish (Louth)', zip: '976168' },
	{ city: 'Grange Little (Wexford)', zip: '100380' },
	{ city: 'Grangelough (Tipperary)', zip: '886968' },
	{ city: 'Grange Lower (Kilkenny)', zip: '171103' },
	{ city: 'Grange Lower (Laois)', zip: '773126' },
	{ city: 'Grange Lower (Limerick)', zip: '254105' },
	{ city: 'Grange Lower (Tipperary)', zip: '525203' },
	{ city: 'Grange Lower (Wexford)', zip: '752250' },
	{ city: 'Grangemellon (Kildare)', zip: '692888' },
	{ city: 'Grangemockler (Tipperary)', zip: '470305' },
	{ city: 'Grangemore (Kildare)', zip: '192643' },
	{ city: 'Grangemore (Tipperary)', zip: '737442' },
	{ city: 'Grange More (Cork)', zip: '153416' },
	{ city: 'Grange More (Galway)', zip: '986036' },
	{ city: 'Grange More (Laois)', zip: '965145' },
	{ city: 'Grange More (Roscommon)', zip: '540107' },
	{ city: 'Grange More (Sligo)', zip: '278135' },
	{ city: 'Grange More (Tipperary)', zip: '893751' },
	{ city: 'Grange More (Westmeath)', zip: '419075' },
	{ city: 'Grangend (Meath)', zip: '417022' },
	{ city: 'Grangend Common (Meath)', zip: '249438' },
	{ city: 'Grange North (Sligo)', zip: '127309' },
	{ city: 'Grange North (Tipperary)', zip: '488252' },
	{ city: 'Grange North (Westmeath)', zip: '281803' },
	{ city: 'Grange North (Wicklow)', zip: '123067' },
	{ city: 'Grange Old (Louth)', zip: '959476' },
	{ city: 'Grangepark (Galway)', zip: '310721' },
	{ city: 'Grangeroe (Tipperary)', zip: '139195' },
	{ city: 'Grangerosnolvan (Kildare)', zip: '542476' },
	{ city: 'Grangerosnolvan Lower (Kildare)', zip: '871521' },
	{ city: 'Grangerosnolvan Upper (Kildare)', zip: '453719' },
	{ city: 'Grange South (Tipperary)', zip: '609958' },
	{ city: 'Grange South (Westmeath)', zip: '990295' },
	{ city: 'Grange South (Wicklow)', zip: '207094' },
	{ city: 'Grangestown (Westmeath)', zip: '929868' },
	{ city: 'Grange Upper (Kilkenny)', zip: '252049' },
	{ city: 'Grange Upper (Laois)', zip: '687024' },
	{ city: 'Grange Upper (Limerick)', zip: '471491' },
	{ city: 'Grange Upper (Tipperary)', zip: '317520' },
	{ city: 'Grange Upper (Wexford)', zip: '329352' },
	{ city: 'Grangewat (Carlow)', zip: '796782' },
	{ city: 'Grange West (Cork)', zip: '630529' },
	{ city: 'Grange West (Galway)', zip: '120949' },
	{ city: 'Grange West (Kildare)', zip: '781993' },
	{ city: 'Grange West (Limerick)', zip: '911374' },
	{ city: 'Grange West (Sligo)', zip: '687403' },
	{ city: 'Graniamore (Sligo)', zip: '909502' },
	{ city: 'Graniaroe (Sligo)', zip: '120173' },
	{ city: 'Graniera (Tipperary)', zip: '177748' },
	{ city: 'Granig (Cork)', zip: '305865' },
	{ city: 'Granisk (Wexford)', zip: '558612' },
	{ city: 'Grannagh (Galway)', zip: '939003' },
	{ city: 'Grannagh Beg (Galway)', zip: '158992' },
	{ city: 'Granny (Kilkenny)', zip: '958967' },
	{ city: 'Granny (Roscommon)', zip: '423497' },
	{ city: 'Gransha (Donegal)', zip: '957543' },
	{ city: 'Gransha Beg (Monaghan)', zip: '690673' },
	{ city: 'Granshagh (Kerry)', zip: '408972' },
	{ city: 'Gransha Lower (Kerry)', zip: '619439' },
	{ city: 'Gransha More (Monaghan)', zip: '371314' },
	{ city: 'Gransha Upper (Kerry)', zip: '850258' },
	{ city: 'Grantstown (Laois)', zip: '922609' },
	{ city: 'Grantstown (Tipperary)', zip: '948355' },
	{ city: 'Grascur Great (Wexford)', zip: '904829' },
	{ city: 'Grascur Little (Wexford)', zip: '235726' },
	{ city: 'Grassyard (Longford)', zip: '225923' },
	{ city: 'Grattanstown (Louth)', zip: '389857' },
	{ city: 'Gravelstown (Meath)', zip: '284950' },
	{ city: 'Graveshill (Galway)', zip: '452843' },
	{ city: 'Grawky (Donegal)', zip: '375280' },
	{ city: 'Grawky Glebe (Donegal)', zip: '826171' },
	{ city: 'Grayrobin (Wexford)', zip: '958514' },
	{ city: 'Graysland (Kildare)', zip: '873495' },
	{ city: 'Graystown (Tipperary)', zip: '662202' },
	{ city: 'Greagh (Cavan)', zip: '575691' },
	{ city: 'Greagh (Leitrim)', zip: '203994' },
	{ city: 'Greagh (Longford)', zip: '686991' },
	{ city: 'Greagh (Monaghan)', zip: '716088' },
	{ city: 'Greagh (Roscommon)', zip: '683625' },
	{ city: 'Greaghacholea (Cavan)', zip: '131918' },
	{ city: 'Greaghacorra (Roscommon)', zip: '408580' },
	{ city: 'Greaghadoo (Cavan)', zip: '435003' },
	{ city: 'Greaghadossan (Cavan)', zip: '580477' },
	{ city: 'Greaghagarran (Cavan)', zip: '923573' },
	{ city: 'Greaghagibney (Cavan)', zip: '513190' },
	{ city: 'Greaghans (Mayo)', zip: '711997' },
	{ city: 'Greagharue (Cavan)', zip: '287896' },
	{ city: 'Greaghawillin (Monaghan)', zip: '277752' },
	{ city: 'Greaghclaugh (Cavan)', zip: '692441' },
	{ city: 'Greaghclogh (Cavan)', zip: '546709' },
	{ city: 'Greaghcrottagh (Cavan)', zip: '473595' },
	{ city: 'Greaghdrumit (Monaghan)', zip: '688940' },
	{ city: 'Greaghdrumneesk (Monaghan)', zip: '833759' },
	{ city: 'Greaghduff (Cavan)', zip: '411538' },
	{ city: 'Greaghettiagh (Cavan)', zip: '898638' },
	{ city: 'Greaghfarnagh (Leitrim)', zip: '598189' },
	{ city: 'Greaghglass (Leitrim)', zip: '768188' },
	{ city: 'Greaghglass (Monaghan)', zip: '119483' },
	{ city: 'Greaghlane (Monaghan)', zip: '604453' },
	{ city: 'Greaghlatacapple (Monaghan)', zip: '818793' },
	{ city: 'Greaghlone (Monaghan)', zip: '263706' },
	{ city: 'Greaghnacross (Cavan)', zip: '221330' },
	{ city: 'Greaghnacunnia (Cavan)', zip: '592774' },
	{ city: 'Greaghnadarragh (Cavan)', zip: '548183' },
	{ city: 'Greaghnadarragh (Leitrim)', zip: '953022' },
	{ city: 'Greaghnadoony (Cavan)', zip: '723438' },
	{ city: 'Greaghnafarna (Cavan)', zip: '767811' },
	{ city: 'Greaghnafarna (Leitrim)', zip: '716310' },
	{ city: 'Greaghnafarna (Roscommon)', zip: '828920' },
	{ city: 'Greaghnagee (Cavan)', zip: '720940' },
	{ city: 'Greaghnageeragh (Roscommon)', zip: '481279' },
	{ city: 'Greaghnaglogh (Leitrim)', zip: '754739' },
	{ city: 'Greaghnaglogh (Roscommon)', zip: '159103' },
	{ city: 'Greaghnagon (Leitrim)', zip: '468758' },
	{ city: 'Greaghnaguillaun (Leitrim)', zip: '336848' },
	{ city: 'Greaghnaleava Beg (Roscommon)', zip: '147948' },
	{ city: 'Greaghnaleava More (Roscommon)', zip: '374962' },
	{ city: 'Greaghnaloughry (Leitrim)', zip: '381016' },
	{ city: 'Greaghnamale (Cavan)', zip: '934648' },
	{ city: 'Greaghnaroog (Monaghan)', zip: '333049' },
	{ city: 'Greaghnaslieve (Leitrim)', zip: '906961' },
	{ city: 'Greaghrahan (Cavan)', zip: '978152' },
	{ city: 'Greaghrevagh Beg (Leitrim)', zip: '190688' },
	{ city: 'Greaghrevagh More Glebe (Leitrim)', zip: '773858' },
	{ city: 'Greaghs (Donegal)', zip: '739750' },
	{ city: 'Great-Blasket Island (Kerry)', zip: '590835' },
	{ city: 'Greatcommon (Dublin)', zip: '414905' },
	{ city: 'Greatconnell (Kildare)', zip: '986454' },
	{ city: 'Greatdown (Westmeath)', zip: '158960' },
	{ city: 'Greatfurze (Meath)', zip: '512219' },
	{ city: 'Greatheath (Laois)', zip: '359089' },
	{ city: 'Greathill (Cavan)', zip: '933164' },
	{ city: 'Greatisland (Wexford)', zip: '776434' },
	{ city: 'Great Island (Cork)', zip: '984653' },
	{ city: 'Greatmeadow (Roscommon)', zip: '749934' },
	{ city: 'Greatoak (Kilkenny)', zip: '477922' },
	{ city: 'Greatrath (Kildare)', zip: '751081' },
	{ city: 'Greatwood (Kilkenny)', zip: '602911' },
	{ city: 'Greatwood (Louth)', zip: '101561' },
	{ city: 'Green (Tipperary)', zip: '143930' },
	{ city: 'Greenan (Donegal)', zip: '754641' },
	{ city: 'Greenan (Mayo)', zip: '566027' },
	{ city: 'Greenan (Meath)', zip: '164715' },
	{ city: 'Greenan (Sligo)', zip: '590167' },
	{ city: 'Greenan (Tipperary)', zip: '351164' },
	{ city: 'Greenan (Waterford)', zip: '611282' },
	{ city: 'Greenan (Westmeath)', zip: '328008' },
	{ city: 'Greenan (Wexford)', zip: '442419' },
	{ city: 'Greenan (Wicklow)', zip: '220327' },
	{ city: 'Greenan Beg (Wicklow)', zip: '914988' },
	{ city: 'Greenane (Carlow)', zip: '125811' },
	{ city: 'Greenane (Cork)', zip: '107666' },
	{ city: 'Greenane (Kerry)', zip: '983122' },
	{ city: 'Greenane (Limerick)', zip: '708657' },
	{ city: 'Greenane (Tipperary)', zip: '309880' },
	{ city: 'Greenane (Waterford)', zip: '796860' },
	{ city: 'Greenanes (Cork)', zip: '320628' },
	{ city: 'Greenan More (Wicklow)', zip: '193860' },
	{ city: 'Greenans (Donegal)', zip: '646081' },
	{ city: 'Greenans (Mayo)', zip: '537641' },
	{ city: 'Greenanstown (Meath)', zip: '826013' },
	{ city: 'Greenaun (Leitrim)', zip: '638480' },
	{ city: 'Greenaun (Mayo)', zip: '800212' },
	{ city: 'Greenaun North (Leitrim)', zip: '710537' },
	{ city: 'Greenaun South (Leitrim)', zip: '649017' },
	{ city: 'Greenbatter (Louth)', zip: '818601' },
	{ city: 'Greencastle (Donegal)', zip: '438611' },
	{ city: 'Greencloyne (Cork)', zip: '703388' },
	{ city: 'Greeneenagh (Galway)', zip: '169116' },
	{ city: 'Greenfield (Cork)', zip: '502222' },
	{ city: 'Greenfield (Donegal)', zip: '748984' },
	{ city: 'Greenfield (Galway)', zip: '355272' },
	{ city: 'Greenfield (Kildare)', zip: '511666' },
	{ city: 'Greenfield (Tipperary)', zip: '494633' },
	{ city: 'Greenfield (Wexford)', zip: '855278' },
	{ city: 'Greenfields (Dublin)', zip: '848628' },
	{ city: 'Greenfort Demesne (Donegal)', zip: '508001' },
	{ city: 'Greenhall (Tipperary)', zip: '342671' },
	{ city: 'Greenhall (Wexford)', zip: '711822' },
	{ city: 'Greenhall (Wicklow)', zip: '170250' },
	{ city: 'Greenhall Lower (Kildare)', zip: '810613' },
	{ city: 'Greenhall Lower (Longford)', zip: '673763' },
	{ city: 'Greenhall Upper (Kildare)', zip: '702569' },
	{ city: 'Greenhall Upper (Longford)', zip: '152371' },
	{ city: 'Greenhill (Cork)', zip: '144202' },
	{ city: 'Greenhill (Donegal)', zip: '710838' },
	{ city: 'Greenhill (Kilkenny)', zip: '223315' },
	{ city: 'Greenhills (Donegal)', zip: '625045' },
	{ city: 'Greenhills (Dublin)', zip: '833629' },
	{ city: 'Greenhills (Galway)', zip: '100615' },
	{ city: 'Greenhills (Kildare)', zip: '345674' },
	{ city: 'Greenhills (Limerick)', zip: '758494' },
	{ city: 'Greenhills (Meath)', zip: '268121' },
	{ city: 'Greenhills (Offaly)', zip: '905019' },
	{ city: 'Greenhills (Tipperary)', zip: '644295' },
	{ city: 'Green Island (Donegal)', zip: '719938' },
	{ city: 'Greenlane (Louth)', zip: '910463' },
	{ city: 'Greenlane (Tipperary)', zip: '755730' },
	{ city: 'Greenmount (Cork)', zip: '472400' },
	{ city: 'Greenmount (Kildare)', zip: '229988' },
	{ city: 'Greenmount (Limerick)', zip: '385189' },
	{ city: 'Greenmount (Louth)', zip: '773859' },
	{ city: 'Greenmount (Monaghan)', zip: '167145' },
	{ city: 'Greenmount (Tipperary)', zip: '743519' },
	{ city: 'Greenoge (Dublin)', zip: '613280' },
	{ city: 'Greenoge (Meath)', zip: '825339' },
	{ city: 'Greenore (Louth)', zip: '314796' },
	{ city: 'Greenrath (Tipperary)', zip: '391147' },
	{ city: 'Greenridge (Kilkenny)', zip: '981846' },
	{ city: 'Greensland (Tipperary)', zip: '651130' },
	{ city: 'Greenville (Cork)', zip: '511559' },
	{ city: 'Greenville (Galway)', zip: '133709' },
	{ city: 'Greenville (Kilkenny)', zip: '573819' },
	{ city: 'Greenville (Offaly)', zip: '816624' },
	{ city: 'Greenville (Wexford)', zip: '192424' },
	{ city: 'Greenwood (Dublin)', zip: '576792' },
	{ city: 'Greenwood (Mayo)', zip: '892005' },
	{ city: 'Greenwood (Tipperary)', zip: '870046' },
	{ city: 'Greenwoodpark (Mayo)', zip: '610443' },
	{ city: 'Greers Isle (Donegal)', zip: '427989' },
	{ city: 'Greethill (Galway)', zip: '404380' },
	{ city: 'Greetiagh (Meath)', zip: '483745' },
	{ city: 'Greeve Island (Galway)', zip: '911534' },
	{ city: 'Gregmoher (Clare)', zip: '922378' },
	{ city: 'Gregorystown (Wexford)', zip: '119166' },
	{ city: 'Grehanstown (Westmeath)', zip: '608089' },
	{ city: 'Grellagh (Cavan)', zip: '768219' },
	{ city: 'Grellagh (Sligo)', zip: '864212' },
	{ city: 'Grenagh (Cork)', zip: '480837' },
	{ city: 'Grenagh (Kerry)', zip: '845330' },
	{ city: 'Grenagh North (Cork)', zip: '514735' },
	{ city: 'Grenagh South (Cork)', zip: '627668' },
	{ city: 'Grenan (Kilkenny)', zip: '790140' },
	{ city: 'Grenan (Laois)', zip: '547996' },
	{ city: 'Grenanstown (Tipperary)', zip: '675270' },
	{ city: 'Grennanstown (Meath)', zip: '127825' },
	{ city: 'Greville (Longford)', zip: '409105' },
	{ city: 'Grevine East (Kilkenny)', zip: '916012' },
	{ city: 'Grevine West (Kilkenny)', zip: '613832' },
	{ city: 'Grevisk (Roscommon)', zip: '620389' },
	{ city: 'Greyabbey (Kildare)', zip: '831622' },
	{ city: 'Greyfield (Leitrim)', zip: '700388' },
	{ city: 'Greyfield (Mayo)', zip: '155923' },
	{ city: 'Greyfield (Roscommon)', zip: '918880' },
	{ city: 'Greyfield (Sligo)', zip: '848700' },
	{ city: 'Greyford (Galway)', zip: '160432' },
	{ city: 'Greyfort (Tipperary)', zip: '190841' },
	{ city: 'Greygrove (Clare)', zip: '949885' },
	{ city: 'Greystones (Wicklow)', zip: '760621' },
	{ city: 'Griffinrath (Kildare)', zip: '299267' },
	{ city: 'Griffinstown (Kilkenny)', zip: '687258' },
	{ city: 'Griffinstown (Westmeath)', zip: '929246' },
	{ city: 'Griffinstown Glen (Wicklow)', zip: '828466' },
	{ city: 'Griffinstown Hill (Wicklow)', zip: '658985' },
	{ city: 'Griffinstown Lower (Wicklow)', zip: '480512' },
	{ city: 'Griffinstown Upper (Wicklow)', zip: '704365' },
	{ city: 'Grig (Monaghan)', zip: '566155' },
	{ city: 'Griggins (Galway)', zip: '804625' },
	{ city: 'Griggy (Monaghan)', zip: '667255' },
	{ city: 'Grillagh (Cork)', zip: '175058' },
	{ city: 'Grillagh (Limerick)', zip: '706636' },
	{ city: 'Grillagh (Longford)', zip: '997854' },
	{ city: 'Grillough (Cork)', zip: '194814' },
	{ city: 'Grilly (Cavan)', zip: '362097' },
	{ city: 'Griston East (Limerick)', zip: '752938' },
	{ city: 'Griston West (Limerick)', zip: '296292' },
	{ city: 'Grogagh (Donegal)', zip: '167374' },
	{ city: 'Grogagh (Sligo)', zip: '223318' },
	{ city: 'Grogan (Kilkenny)', zip: '611524' },
	{ city: 'Grogan (Laois)', zip: '157710' },
	{ city: 'Grogan (Wexford)', zip: '877571' },
	{ city: 'Grogan And Corroe (Offaly)', zip: '441241' },
	{ city: 'Grogan Burrow (Wexford)', zip: '709139' },
	{ city: 'Grogeen (Kerry)', zip: '984508' },
	{ city: 'Groin (Kerry)', zip: '407866' },
	{ city: 'Groom (Louth)', zip: '508140' },
	{ city: 'Grousehall (Cavan)', zip: '494685' },
	{ city: 'Grousehall (Donegal)', zip: '718344' },
	{ city: 'Grousehall (Tipperary)', zip: '508892' },
	{ city: 'Grouselodge (Limerick)', zip: '211774' },
	{ city: 'Grousemount (Kerry)', zip: '952524' },
	{ city: 'Grove (Kerry)', zip: '371084' },
	{ city: 'Grove (Kilkenny)', zip: '804447' },
	{ city: 'Grove (Leitrim)', zip: '597194' },
	{ city: 'Grove (Tipperary)', zip: '707161' },
	{ city: 'Grovebeg (Kilkenny)', zip: '961839' },
	{ city: 'Grove Great (Wexford)', zip: '578211' },
	{ city: 'Grovehall (Donegal)', zip: '801732' },
	{ city: 'Grove Little (Wexford)', zip: '693211' },
	{ city: 'Grovemill (Wexford)', zip: '308401' },
	{ city: 'Grovesend (Offaly)', zip: '634694' },
	{ city: 'Groves Lower (Monaghan)', zip: '709056' },
	{ city: 'Groves Upper (Monaghan)', zip: '510372' },
	{ city: 'Growtown (Meath)', zip: '379634' },
	{ city: 'Growtown Lower (Wexford)', zip: '650202' },
	{ city: 'Growtown Upper (Wexford)', zip: '196874' },
	{ city: 'Guardhill (Monaghan)', zip: '336992' },
	{ city: 'Guardhousepark (Mayo)', zip: '799262' },
	{ city: 'Gub (Cavan)', zip: '867030' },
	{ city: 'Gubacreeny (Leitrim)', zip: '492060' },
	{ city: 'Gubaderry (Leitrim)', zip: '235037' },
	{ city: 'Gubadorris (Leitrim)', zip: '718259' },
	{ city: 'Gubadruish (Leitrim)', zip: '799470' },
	{ city: 'Gubagraffy (Leitrim)', zip: '472451' },
	{ city: 'Gubalaun (Leitrim)', zip: '873451' },
	{ city: 'Gubanummera (Leitrim)', zip: '960270' },
	{ city: 'Gubaveeny (Cavan)', zip: '392227' },
	{ city: 'Gubb (Leitrim)', zip: '762066' },
	{ city: 'Gubbarudda (Roscommon)', zip: '160429' },
	{ city: 'Gubbeen (Cork)', zip: '762693' },
	{ city: 'Gubinea (Leitrim)', zip: '793661' },
	{ city: 'Gubmanus (Leitrim)', zip: '130763' },
	{ city: 'Gubnacurrafore (Leitrim)', zip: '466542' },
	{ city: 'Gubnafarna (Cavan)', zip: '882441' },
	{ city: 'Gubnageer (Leitrim)', zip: '404548' },
	{ city: 'Gubnagree (Cavan)', zip: '446127' },
	{ city: 'Gubnahardia (Mayo)', zip: '343348' },
	{ city: 'Gubnaveagh (Leitrim)', zip: '424196' },
	{ city: 'Gubrawully (Cavan)', zip: '240612' },
	{ city: 'Gubrimmaddera (Cavan)', zip: '214157' },
	{ city: 'Gubroe (Leitrim)', zip: '399038' },
	{ city: 'Gubs (Leitrim)', zip: '855441' },
	{ city: 'Gudderstown (Louth)', zip: '858284' },
	{ city: 'Guernal (Offaly)', zip: '352597' },
	{ city: 'Guhard North (Kerry)', zip: '959702' },
	{ city: 'Guhard South (Kerry)', zip: '821986' },
	{ city: 'Guidenstown North (Kildare)', zip: '538825' },
	{ city: 'Guidenstown South (Kildare)', zip: '884143' },
	{ city: 'Guigginstown (Westmeath)', zip: '529649' },
	{ city: 'Guilcagh (Waterford)', zip: '466032' },
	{ city: 'Guileen (Laois)', zip: '219971' },
	{ city: 'Guilford (Westmeath)', zip: '685459' },
	{ city: 'Guilkagh Beg (Kilkenny)', zip: '722463' },
	{ city: 'Guilkagh More (Kilkenny)', zip: '714604' },
	{ city: 'Gullaba (Kerry)', zip: '910753' },
	{ city: 'Gulladoo (Donegal)', zip: '754013' },
	{ city: 'Gulladoo (Leitrim)', zip: '366798' },
	{ city: 'Gullane East (Kerry)', zip: '125637' },
	{ city: 'Gullane Middle (Kerry)', zip: '307842' },
	{ city: 'Gullane West (Kerry)', zip: '516905' },
	{ city: 'Gullaun East (Kerry)', zip: '793832' },
	{ city: 'Gullaun West (Kerry)', zip: '964538' },
	{ city: 'Gull Island (Donegal)', zip: '865496' },
	{ city: 'Gully (Cork)', zip: '373859' },
	{ city: 'Gunnocks (Meath)', zip: '147197' },
	{ city: 'Gunnode (Galway)', zip: '246243' },
	{ city: 'Gunpoint (Cork)', zip: '706667' },
	{ city: 'Gunstown (Louth)', zip: '667276' },
	{ city: 'Gunstown (Meath)', zip: '968197' },
	{ city: 'Gurlins (Wexford)', zip: '194537' },
	{ city: 'Gurraghy (Cork)', zip: '554239' },
	{ city: 'Gurranes (Cork)', zip: '630687' },
	{ city: 'Gurraun (Laois)', zip: '611118' },
	{ city: 'Gurraunard (Mayo)', zip: '970896' },
	{ city: 'Gurrawirra (Offaly)', zip: '966415' },
	{ city: 'Gurteen (Cork)', zip: '498129' },
	{ city: 'Gurteen (Kerry)', zip: '119055' },
	{ city: 'Gurteen (Laois)', zip: '124293' },
	{ city: 'Gurteen (Leitrim)', zip: '336092' },
	{ city: 'Gurteen (Tipperary)', zip: '453254' },
	{ city: 'Gurteenaduige (Cork)', zip: '632934' },
	{ city: 'Gurteenard (Cork)', zip: '744181' },
	{ city: 'Gurteenavallig (Kerry)', zip: '379323' },
	{ city: 'Gurteenbeha (Cork)', zip: '598816' },
	{ city: 'Gurteenflugh (Cork)', zip: '235822' },
	{ city: 'Gurteeniher (Cork)', zip: '693128' },
	{ city: 'Gurteenina (Cork)', zip: '225669' },
	{ city: 'Gurteen Lower (Waterford)', zip: '977901' },
	{ city: 'Gurteennaboul (Cork)', zip: '447968' },
	{ city: 'Gurteennacloona (Cork)', zip: '205445' },
	{ city: 'Gurteennacloona (Kerry)', zip: '436718' },
	{ city: 'Gurteennakilla (Cork)', zip: '796979' },
	{ city: 'Gurteennasowna (Cork)', zip: '281684' },
	{ city: 'Gurteen North (Kerry)', zip: '210122' },
	{ city: 'Gurteenowen (Cork)', zip: '717053' },
	{ city: 'Gurteenroe (Cork)', zip: '832650' },
	{ city: 'Gurteenroe (Kerry)', zip: '248534' },
	{ city: 'Gurteenroe Commons (Cork)', zip: '324219' },
	{ city: 'Gurteenulla (Cork)', zip: '129168' },
	{ city: 'Gurteen Upper (Waterford)', zip: '661774' },
	{ city: 'Gurtnafleur (Tipperary)', zip: '184355' },
	{ city: 'Gurtnapisha (Tipperary)', zip: '904216' },
	{ city: 'Gusserane (Wexford)', zip: '764097' },
	{ city: 'Guystown (Donegal)', zip: '584684' },
	{ city: 'Gweedore (Donegal)', zip: '248217' },
	{ city: 'Gweeneeny (Clare)', zip: '844839' },
	{ city: 'Gweesalia (Mayo)', zip: '517469' },
	{ city: 'Gweeshadan (Mayo)', zip: '118328' },
	{ city: 'Habbitstown (Donegal)', zip: '604638' },
	{ city: 'Habsborough (Westmeath)', zip: '550929' },
	{ city: 'Hackballs Cross (Louth)', zip: '193041' },
	{ city: 'Hackelty (Cavan)', zip: '231508' },
	{ city: 'Hacketstown (Carlow)', zip: '389629' },
	{ city: 'Hacketstown (Cork)', zip: '235010' },
	{ city: 'Hacketstown (Dublin)', zip: '152687' },
	{ city: 'Hacketstown (Waterford)', zip: '370716' },
	{ city: 'Hacketstown Lower (Carlow)', zip: '179618' },
	{ city: 'Hacketstown Upper (Carlow)', zip: '448903' },
	{ city: 'Hackettsland (Dublin)', zip: '513234' },
	{ city: 'Hacklim (Louth)', zip: '668782' },
	{ city: 'Haggard (Kildare)', zip: '820891' },
	{ city: 'Haggard (Kilkenny)', zip: '986771' },
	{ city: 'Haggard (Wexford)', zip: '780089' },
	{ city: 'Haggardstown (Louth)', zip: '962947' },
	{ city: 'Haggardtown (Wexford)', zip: '162788' },
	{ city: 'Haggartsgreen (Kilkenny)', zip: '936791' },
	{ city: 'Halfcarton (Meath)', zip: '594514' },
	{ city: 'Halfcartron (Galway)', zip: '261955' },
	{ city: 'Halfcartron (Longford)', zip: '607453' },
	{ city: 'Halfmace (Galway)', zip: '812373' },
	{ city: 'Halfmiletown (Kildare)', zip: '723757' },
	{ city: 'Halfquarter (Sligo)', zip: '752800' },
	{ city: 'Halfstraddle (Galway)', zip: '766089' },
	{ city: 'Halftate (Louth)', zip: '408086' },
	{ city: 'Halftate (Monaghan)', zip: '699317' },
	{ city: 'Halftown (Donegal)', zip: '825106' },
	{ city: 'Hall (Westmeath)', zip: '743313' },
	{ city: 'Hallahoise (Kildare)', zip: '391636' },
	{ city: 'Hall Demesne (Donegal)', zip: '931900' },
	{ city: 'Halls (Leitrim)', zip: '760043' },
	{ city: 'Hallsfarm (Westmeath)', zip: '158255' },
	{ city: 'Hallstown (Meath)', zip: '935470' },
	{ city: 'Halltown (Meath)', zip: '890926' },
	{ city: 'Halseyrath (Wexford)', zip: '226229' },
	{ city: 'Halverstown (Kildare)', zip: '641130' },
	{ city: 'Hamlinstown (Louth)', zip: '748170' },
	{ city: 'Hamlinstown (Meath)', zip: '959067' },
	{ city: 'Hammondstown (Limerick)', zip: '646742' },
	{ city: 'Hammondstown (Louth)', zip: '705597' },
	{ city: 'Hammondstown (Meath)', zip: '993894' },
	{ city: 'Hammondstown And Tonaghmore (Westmeath)', zip: '282672' },
	{ city: 'Hammondtown (Meath)', zip: '503735' },
	{ city: 'Hampstead (Galway)', zip: '544716' },
	{ city: 'Hampton Demesne (Dublin)', zip: '290452' },
	{ city: 'Hamwood (Meath)', zip: '904602' },
	{ city: 'Hanlonstown (Meath)', zip: '935649' },
	{ city: 'Hansfield (Dublin)', zip: '951590' },
	{ city: 'Hanstown (Westmeath)', zip: '704110' },
	{ city: 'Harboursmouth (Cork)', zip: '339444' },
	{ city: 'Hardbog (Tipperary)', zip: '892150' },
	{ city: 'Harding Grove (Limerick)', zip: '892434' },
	{ city: 'Hardwood (Galway)', zip: '839544' },
	{ city: 'Hardwood (Meath)', zip: '777400' },
	{ city: 'Hardyglass (Wexford)', zip: '499750' },
	{ city: 'Hardygregan (Wexford)', zip: '571690' },
	{ city: 'Harefield (Mayo)', zip: '364129' },
	{ city: 'Hareisland (Westmeath)', zip: '158916' },
	{ city: 'Haremount (Cork)', zip: '631441' },
	{ city: 'Harepark (Roscommon)', zip: '786401' },
	{ city: 'Haresmead (Wexford)', zip: '535476' },
	{ city: 'Harleypark (Tipperary)', zip: '485634' },
	{ city: 'Harlinstown (Meath)', zip: '529661' },
	{ city: 'Harlockstown (Meath)', zip: '140626' },
	{ city: 'Harmanstown (Meath)', zip: '132650' },
	{ city: 'Harolds Cross (Dublin)', zip: '932968' },
	{ city: 'Haroldsgrange (Dublin)', zip: '272901' },
	{ city: 'Haroldstown (Carlow)', zip: '877190' },
	{ city: 'Harpers Island (Cork)', zip: '287576' },
	{ city: 'Harperstown (Wexford)', zip: '710918' },
	{ city: 'Harpoonstown (Wexford)', zip: '458579' },
	{ city: 'Harrisgrove (Cork)', zip: '892208' },
	{ city: 'Harristown (Carlow)', zip: '838155' },
	{ city: 'Harristown (Dublin)', zip: '614616' },
	{ city: 'Harristown (Kildare)', zip: '126089' },
	{ city: 'Harristown (Kilkenny)', zip: '334055' },
	{ city: 'Harristown (Laois)', zip: '719163' },
	{ city: 'Harristown (Louth)', zip: '301126' },
	{ city: 'Harristown (Meath)', zip: '493206' },
	{ city: 'Harristown (Roscommon)', zip: '322389' },
	{ city: 'Harristown (Waterford)', zip: '383161' },
	{ city: 'Harristown (Wexford)', zip: '223221' },
	{ city: 'Harristown (Wicklow)', zip: '598067' },
	{ city: 'Harristown Big (Wexford)', zip: '162060' },
	{ city: 'Harristown Common (Kildare)', zip: '603726' },
	{ city: 'Harristown Little (Wexford)', zip: '728181' },
	{ city: 'Harristown Lower (Kildare)', zip: '822887' },
	{ city: 'Harristown Upper (Kildare)', zip: '647216' },
	{ city: 'Harrowhill (Waterford)', zip: '615465' },
	{ city: 'Harrystown (Westmeath)', zip: '512450' },
	{ city: 'Hartley (Leitrim)', zip: '598662' },
	{ city: 'Hartstown (Dublin)', zip: '724162' },
	{ city: 'Hartstown (Meath)', zip: '738678' },
	{ city: 'Hartstown (Wicklow)', zip: '354760' },
	{ city: 'Hartwell Lower (Kildare)', zip: '539257' },
	{ city: 'Hartwell Upper (Kildare)', zip: '862016' },
	{ city: 'Harveystown (Wexford)', zip: '679099' },
	{ city: 'Hasley (Louth)', zip: '904061' },
	{ city: 'Haugh (Donegal)', zip: '739966' },
	{ city: 'Haughtons Island (Offaly)', zip: '229919' },
	{ city: 'Haw (Donegal)', zip: '728955' },
	{ city: 'Hawkfield (Kildare)', zip: '475602' },
	{ city: 'Hawkinstown (Meath)', zip: '296231' },
	{ city: 'Hawksford (Roscommon)', zip: '146413' },
	{ city: 'Hawkstown Lower (Wicklow)', zip: '714445' },
	{ city: 'Hawkstown Upper (Wicklow)', zip: '988722' },
	{ city: 'Hawkswood (Cavan)', zip: '655212' },
	{ city: 'Hawkswood (Offaly)', zip: '423187' },
	{ city: 'Hawthornlodge (Mayo)', zip: '494498' },
	{ city: 'Hayesland (Wexford)', zip: '832522' },
	{ city: 'Hayestown (Meath)', zip: '398296' },
	{ city: 'Hayestown Great (Wexford)', zip: '615894' },
	{ city: 'Hayestown Little (Wexford)', zip: '566449' },
	{ city: 'Haylands (Wicklow)', zip: '590446' },
	{ city: 'Haynestown (Kildare)', zip: '370001' },
	{ city: 'Haynestown (Louth)', zip: '210007' },
	{ city: 'Haystown (Dublin)', zip: '994065' },
	{ city: 'Haystown (Wexford)', zip: '414146' },
	{ city: 'Haystown And Carnuff Little (Meath)', zip: '891945' },
	{ city: 'Haytown (Wexford)', zip: '933737' },
	{ city: 'Haywood (Tipperary)', zip: '550063' },
	{ city: 'Haywood Demesne (Laois)', zip: '755935' },
	{ city: 'Hazardstown (Dublin)', zip: '951172' },
	{ city: 'Hazelbrook (Dublin)', zip: '417198' },
	{ city: 'Hazelfield (Limerick)', zip: '813156' },
	{ city: 'Hazelfort (Galway)', zip: '411919' },
	{ city: 'Hazelhatch (Dublin)', zip: '853612' },
	{ city: 'Hazelhill (Mayo)', zip: '228947' },
	{ city: 'Hazelwood Demesne (Sligo)', zip: '742110' },
	{ city: 'Headborough (Waterford)', zip: '137911' },
	{ city: 'Headford (Galway)', zip: '192107' },
	{ city: 'Headford (Leitrim)', zip: '285549' },
	{ city: 'Headfort (Kerry)', zip: '680433' },
	{ city: 'Headfort Demesne (Meath)', zip: '129621' },
	{ city: 'Headstown (Meath)', zip: '286915' },
	{ city: 'Healthfield (Wexford)', zip: '707753' },
	{ city: 'Healysland (Wexford)', zip: '169542' },
	{ city: 'Heapstown (Sligo)', zip: '418407' },
	{ city: 'Hearnesbrooke Demesne (Galway)', zip: '310743' },
	{ city: 'Heath (Carlow)', zip: '968762' },
	{ city: 'Heath (Kildare)', zip: '703226' },
	{ city: 'Heath (Mayo)', zip: '371043' },
	{ city: 'Heath (Offaly)', zip: '904830' },
	{ city: 'Heathfield (Roscommon)', zip: '156652' },
	{ city: 'Heath Island (Mayo)', zip: '565307' },
	{ city: 'Heathland (Westmeath)', zip: '371176' },
	{ city: 'Heathlawn (Galway)', zip: '159477' },
	{ city: 'Heathlawn (Mayo)', zip: '171588' },
	{ city: 'Heathlodge (Laois)', zip: '451878' },
	{ city: 'Heathmount (Clare)', zip: '477180' },
	{ city: 'Heathpark (Wexford)', zip: '730833' },
	{ city: 'Heaths (Wexford)', zip: '580248' },
	{ city: 'Heathstown (Westmeath)', zip: '159397' },
	{ city: 'Heathtown (Dublin)', zip: '463984' },
	{ city: 'Heathtown (Meath)', zip: '503570' },
	{ city: 'Heathview (Tipperary)', zip: '429700' },
	{ city: 'Heavenstown (Wexford)', zip: '243213' },
	{ city: 'Hedgestown (Dublin)', zip: '279224' },
	{ city: 'Heirhill (Kerry)', zip: '577256' },
	{ city: 'Helvick (Waterford)', zip: '182467' },
	{ city: 'Hempstown (Wicklow)', zip: '734011' },
	{ city: 'Hempstown Commons (Kildare)', zip: '244931' },
	{ city: 'Heney (Cavan)', zip: '885178' },
	{ city: 'Heneys (Donegal)', zip: '539799' },
	{ city: 'Henfield (Westmeath)', zip: '760340' },
	{ city: 'Hennigan (Meath)', zip: '675530' },
	{ city: 'Herbertsown (Meath)', zip: '586593' },
	{ city: 'Herbertstown (Kildare)', zip: '490119' },
	{ city: 'Herbertstown (Limerick)', zip: '137290' },
	{ city: 'Herbertstown (Meath)', zip: '156381' },
	{ city: 'Hermitage (Cork)', zip: '505765' },
	{ city: 'Hermitage (Dublin)', zip: '579640' },
	{ city: 'Hermitage (Galway)', zip: '104452' },
	{ city: 'Hermitage (Kilkenny)', zip: '637820' },
	{ city: 'Hermitage (Limerick)', zip: '347475' },
	{ city: 'Hernsbrook (Limerick)', zip: '316224' },
	{ city: 'Heronstown (Meath)', zip: '645982' },
	{ city: 'Hewitsland (Wexford)', zip: '653164' },
	{ city: 'Higginstown (Kilkenny)', zip: '843183' },
	{ city: 'Higginstown (Longford)', zip: '652950' },
	{ city: 'Higginstown (Meath)', zip: '109680' },
	{ city: 'Higginstown (Tipperary)', zip: '549618' },
	{ city: 'Higginstown (Westmeath)', zip: '690270' },
	{ city: 'Highbank (Donegal)', zip: '937307' },
	{ city: 'Highbog (Roscommon)', zip: '582109' },
	{ city: 'Highdownhill (Dublin)', zip: '346953' },
	{ city: 'Highfield (Cork)', zip: '912105' },
	{ city: 'Highfield (Galway)', zip: '973310' },
	{ city: 'Highglen (Donegal)', zip: '307879' },
	{ city: 'Highhays (Kilkenny)', zip: '655238' },
	{ city: 'High Island (Galway)', zip: '234872' },
	{ city: 'Highmount (Limerick)', zip: '631585' },
	{ city: 'Highpark (Galway)', zip: '606478' },
	{ city: 'Highpark (Limerick)', zip: '633158' },
	{ city: 'Highpark Lower (Wicklow)', zip: '820545' },
	{ city: 'Highpark Upper (Wicklow)', zip: '746416' },
	{ city: 'Highrath (Kilkenny)', zip: '768707' },
	{ city: 'Highstreet (Galway)', zip: '861736' },
	{ city: 'Hightown (Cork)', zip: '751136' },
	{ city: 'Hightown (Westmeath)', zip: '809474' },
	{ city: 'Hightown (Wexford)', zip: '183717' },
	{ city: 'Highwood (Sligo)', zip: '818447' },
	{ city: 'Hill (Wexford)', zip: '563814' },
	{ city: 'Hillbrook Lower (Wicklow)', zip: '258211' },
	{ city: 'Hillbrook Upper (Wicklow)', zip: '306786' },
	{ city: 'Hillburn (Wexford)', zip: '454558' },
	{ city: 'Hillcastle (Wexford)', zip: '290812' },
	{ city: 'Hillend (Kilkenny)', zip: '685670' },
	{ city: 'Hillfarm (Kildare)', zip: '878921' },
	{ city: 'Hillgrove (Kerry)', zip: '664153' },
	{ city: 'Hillhall (Monaghan)', zip: '211143' },
	{ city: 'Hill Of Down (Meath)', zip: '473018' },
	{ city: 'Hill Of Rath (Louth)', zip: '997588' },
	{ city: 'Hill Of Sea (Wexford)', zip: '200430' },
	{ city: 'Hillpark (Galway)', zip: '299609' },
	{ city: 'Hillquarter (Westmeath)', zip: '553942' },
	{ city: 'Hillsborough (Kildare)', zip: '724971' },
	{ city: 'Hillsbrook Demesne (Galway)', zip: '913260' },
	{ city: 'Hillsend (Roscommon)', zip: '735066' },
	{ city: "Hill's-Lot (Tipperary)", zip: '277740' },
	{ city: 'Hillstreet (Roscommon)', zip: '630424' },
	{ city: 'Hillswood (Galway)', zip: '623030' },
	{ city: 'Hillswood East (Galway)', zip: '202812' },
	{ city: 'Hillswood West (Galway)', zip: '838997' },
	{ city: 'Hilltown (Cork)', zip: '126047' },
	{ city: 'Hilltown (Dublin)', zip: '124649' },
	{ city: 'Hilltown (Meath)', zip: '320364' },
	{ city: 'Hilltown (Westmeath)', zip: '985784' },
	{ city: 'Hilltown (Wexford)', zip: '925652' },
	{ city: 'Hilltown Great (Meath)', zip: '706277' },
	{ city: 'Hilltown Little (Meath)', zip: '919685' },
	{ city: 'Hilton (Tipperary)', zip: '594041' },
	{ city: 'Hilton Demesne (Monaghan)', zip: '997431' },
	{ city: 'Hiskinstown (Westmeath)', zip: '574227' },
	{ city: 'Hitchestown (Louth)', zip: '975125' },
	{ city: 'Hoardstown (Meath)', zip: '116792' },
	{ city: 'Hoarstone (Louth)', zip: '382110' },
	{ city: 'Hoathstown (Louth)', zip: '331797' },
	{ city: 'Hobartstown East (Kildare)', zip: '170156' },
	{ city: 'Hobartstown West (Kildare)', zip: '317768' },
	{ city: 'Hobbinstown (Wexford)', zip: '405942' },
	{ city: 'Hoddersfield (Cork)', zip: '472190' },
	{ city: 'Hodgesmill (Wexford)', zip: '922854' },
	{ city: 'Hodgestown (Kildare)', zip: '828735' },
	{ city: 'Hodgestown (Meath)', zip: '489005' },
	{ city: 'Hodgestown (Westmeath)', zip: '166263' },
	{ city: 'Hoganswood (Kildare)', zip: '527384' },
	{ city: 'Hoganswood East (Kildare)', zip: '315910' },
	{ city: 'Holdensrath (Kilkenny)', zip: '655717' },
	{ city: 'Holdenstown (Kilkenny)', zip: '637784' },
	{ city: 'Holdenstown Lower (Wicklow)', zip: '958776' },
	{ city: 'Holdenstown Upper (Wicklow)', zip: '629244' },
	{ city: 'Hollands (Donegal)', zip: '891175' },
	{ city: 'Hollimshill (Offaly)', zip: '354055' },
	{ city: 'Hollowpark (Mayo)', zip: '287049' },
	{ city: 'Hollybrook (Wicklow)', zip: '628473' },
	{ city: 'Hollyford (Tipperary)', zip: '739864' },
	{ city: 'Hollyfort (Wexford)', zip: '811796' },
	{ city: 'Hollygrove (Galway)', zip: '923915' },
	{ city: 'Hollyhill (Cork)', zip: '488331' },
	{ city: 'Hollymount (Galway)', zip: '586046' },
	{ city: 'Hollymount (Laois)', zip: '437276' },
	{ city: 'Hollymount (Mayo)', zip: '378310' },
	{ city: 'Hollymount (Meath)', zip: '824045' },
	{ city: 'Hollymount Demesne (Mayo)', zip: '744079' },
	{ city: 'Hollypark (Galway)', zip: '672202' },
	{ city: 'Hollystown (Dublin)', zip: '949649' },
	{ city: 'Hollywood (Dublin)', zip: '181422' },
	{ city: 'Hollywood (Wicklow)', zip: '221294' },
	{ city: 'Hollywood Demesne (Wicklow)', zip: '179259' },
	{ city: 'Hollywood Great (Dublin)', zip: '893179' },
	{ city: 'Hollywood Little (Dublin)', zip: '660585' },
	{ city: 'Hollywood Lower (Wicklow)', zip: '114532' },
	{ city: 'Hollywoodrath (Dublin)', zip: '745337' },
	{ city: 'Hollywood Upper (Wicklow)', zip: '685743' },
	{ city: 'Holmanhill (Wexford)', zip: '194593' },
	{ city: 'Holmes (Donegal)', zip: '529379' },
	{ city: 'Holmestown Great (Wexford)', zip: '557696' },
	{ city: 'Holmestown Little (Wexford)', zip: '958214' },
	{ city: 'Holmpatrick (Dublin)', zip: '818162' },
	{ city: 'Holybanks (Dublin)', zip: '109571' },
	{ city: 'Holycross (Limerick)', zip: '859278' },
	{ city: 'Holycross (Tipperary)', zip: '672147' },
	{ city: 'Holyvalley (Wicklow)', zip: '697314' },
	{ city: 'Holywell (Wicklow)', zip: '677322' },
	{ city: 'Holywell Lower (Mayo)', zip: '786555' },
	{ city: 'Holywell Upper (Mayo)', zip: '732248' },
	{ city: 'Honeymount (Tipperary)', zip: '213561' },
	{ city: 'Honeypark (Dublin)', zip: '850552' },
	{ city: 'Honeypound (Limerick)', zip: '223348' },
	{ city: 'Hoodsgrove (Kilkenny)', zip: '633232' },
	{ city: 'Hooks (Wexford)', zip: '216784' },
	{ city: "Hoop's-Lot (Tipperary)", zip: '414123' },
	{ city: 'Hopefield (Wexford)', zip: '606881' },
	{ city: 'Hopeland (Wexford)', zip: '203323' },
	{ city: 'Hopestown (Westmeath)', zip: '379097' },
	{ city: 'Hophall (Laois)', zip: '349191' },
	{ city: 'Hop Island (Cork)', zip: '678567' },
	{ city: 'Hopkinsrea (Tipperary)', zip: '810045' },
	{ city: 'Hopkinstown (Meath)', zip: '410733' },
	{ city: 'Horath (Meath)', zip: '133850' },
	{ city: 'Horeabbey (Tipperary)', zip: '212536' },
	{ city: 'Horesland (Wexford)', zip: '921951' },
	{ city: 'Horestown (Dublin)', zip: '194596' },
	{ city: 'Horeswood (Wexford)', zip: '455491' },
	{ city: 'Horetown (Wexford)', zip: '955349' },
	{ city: 'Horetown North (Wexford)', zip: '762398' },
	{ city: 'Horetown South (Wexford)', zip: '397237' },
	{ city: 'Horistown (Meath)', zip: '130553' },
	{ city: 'Horseclose (Cork)', zip: '905708' },
	{ city: 'Horsehill Beg (Cork)', zip: '311619' },
	{ city: 'Horsehill More North (Cork)', zip: '306417' },
	{ city: 'Horsehill More South (Cork)', zip: '456711' },
	{ city: 'Horse Island (Cork)', zip: '742397' },
	{ city: 'Horse Island (Kerry)', zip: '545401' },
	{ city: 'Horse Island (Mayo)', zip: '980587' },
	{ city: 'Horse & Jockey (Tipperary)', zip: '711846' },
	{ city: 'Horseleap (Westmeath)', zip: '157487' },
	{ city: 'Horsemountmountain (Cork)', zip: '163601' },
	{ city: 'Horsemount North (Cork)', zip: '581688' },
	{ city: 'Horsemount South (Cork)', zip: '141098' },
	{ city: 'Horsepasstown (Kildare)', zip: '444282' },
	{ city: 'Horsepasture (Tipperary)', zip: '429155' },
	{ city: 'Hortland (Kildare)', zip: '313490' },
	{ city: 'Hospital (Limerick)', zip: '117588' },
	{ city: 'Hospitalbank (Westmeath)', zip: '750394' },
	{ city: 'Hospital Land (Meath)', zip: '549256' },
	{ city: 'Houndscourt (Limerick)', zip: '240889' },
	{ city: 'Houndswood Middle (Mayo)', zip: '865732' },
	{ city: 'Houndswood North (Mayo)', zip: '615530' },
	{ city: 'Houndswood South (Mayo)', zip: '568494' },
	{ city: 'Houseland (Wexford)', zip: '186785' },
	{ city: 'Howardstown North (Limerick)', zip: '679579' },
	{ city: 'Howardstown South (Limerick)', zip: '539764' },
	{ city: 'Howth (Dublin)', zip: '713441' },
	{ city: 'Howth Demesne (Dublin)', zip: '642186' },
	{ city: 'Howthstown (Meath)', zip: '530253' },
	{ city: 'Hugginstown (Kilkenny)', zip: '661837' },
	{ city: "Hughes'-Lot East (Tipperary)", zip: '308801' },
	{ city: "Hughes'-Lot West (Tipperary)", zip: '162397' },
	{ city: 'Hughestown (Roscommon)', zip: '216627' },
	{ city: 'Hughstown (Kildare)', zip: '566079' },
	{ city: 'Humewood (Wicklow)', zip: '618514' },
	{ city: 'Humphrystown (Wicklow)', zip: '542737' },
	{ city: 'Hundredacres (Galway)', zip: '525369' },
	{ city: 'Hundredacres (Mayo)', zip: '155921' },
	{ city: 'Hundredacres (Offaly)', zip: '741085' },
	{ city: 'Hundredacres (Roscommon)', zip: '805676' },
	{ city: 'Hundredacres East (Limerick)', zip: '366037' },
	{ city: 'Hundredacres West (Limerick)', zip: '869109' },
	{ city: 'Hungersmother (Donegal)', zip: '753057' },
	{ city: 'Hunterstown (Louth)', zip: '252801' },
	{ city: 'Hunthill (Waterford)', zip: '851480' },
	{ city: 'Huntingdon (Westmeath)', zip: '603135' },
	{ city: 'Huntingstown (Limerick)', zip: '810957' },
	{ city: 'Huntington (Carlow)', zip: '422256' },
	{ city: 'Huntingtown (Kilkenny)', zip: '488678' },
	{ city: 'Huntingtown (Wexford)', zip: '357798' },
	{ city: 'Huntston (Offaly)', zip: '592693' },
	{ city: 'Huntstown (Dublin)', zip: '489443' },
	{ city: 'Huntstown (Kilkenny)', zip: '891312' },
	{ city: 'Hurcle (Meath)', zip: '777253' },
	{ city: 'Hurdleston (Clare)', zip: '520934' },
	{ city: 'Hurdlestown (Meath)', zip: '748050' },
	{ city: 'Hurlstone (Louth)', zip: '967502' },
	{ city: 'Husseystown (Tipperary)', zip: '536943' },
	{ city: 'Huttonread (Kildare)', zip: '676691' },
	{ city: 'Hybla (Kildare)', zip: '273418' },
	{ city: 'Hydepark (Westmeath)', zip: '515374' },
	{ city: 'Hydepark (Wexford)', zip: '946693' },
	{ city: 'Hymenstown (Tipperary)', zip: '821224' },
	{ city: 'Hynespark (Dublin)', zip: '161120' },
	{ city: 'Hynestown (Dublin)', zip: '522265' },
	{ city: 'Ieverstown (Clare)', zip: '733088' },
	{ city: 'Iffernock (Meath)', zip: '251441' },
	{ city: 'Ightermurragh (Cork)', zip: '687885' },
	{ city: 'Illanaghtagh (Donegal)', zip: '961485' },
	{ city: 'Illananirvore (Donegal)', zip: '909232' },
	{ city: 'Illananummera (Tipperary)', zip: '119868' },
	{ city: 'Illanaran (Donegal)', zip: '421814' },
	{ city: 'Illanarva (Donegal)', zip: '224359' },
	{ city: 'Illanbaun (Mayo)', zip: '747155' },
	{ city: 'Illan Beg (Donegal)', zip: '759568' },
	{ city: 'Illanbelfarsad (Mayo)', zip: '491639' },
	{ city: 'Illancarragh (Donegal)', zip: '682890' },
	{ city: 'Illancreeve (Donegal)', zip: '662404' },
	{ city: 'Illancrone (Donegal)', zip: '805480' },
	{ city: 'Illandavuck (Mayo)', zip: '863697' },
	{ city: 'Illandermot (Donegal)', zip: '329149' },
	{ city: 'Illan Doo (Donegal)', zip: '143792' },
	{ city: 'Illandunmore (Donegal)', zip: '348707' },
	{ city: 'Illane (Cork)', zip: '335489' },
	{ city: 'Illanglass (Donegal)', zip: '458119' },
	{ city: 'Illanmore (Donegal)', zip: '153577' },
	{ city: 'Illanmore (Mayo)', zip: '128587' },
	{ city: 'Illanmurrish (Donegal)', zip: '325431' },
	{ city: 'Illannagall (Donegal)', zip: '565543' },
	{ city: 'Illannagalliagh (Donegal)', zip: '502869' },
	{ city: 'Illannagark (Donegal)', zip: '512531' },
	{ city: 'Illannagonragh (Donegal)', zip: '140960' },
	{ city: 'Illannamarve (Donegal)', zip: '135404' },
	{ city: 'Illannamohoge (Donegal)', zip: '288416' },
	{ city: 'Illannanaff (Donegal)', zip: '966699' },
	{ city: 'Illannanoon (Donegal)', zip: '644728' },
	{ city: 'Illannashammer (Donegal)', zip: '428657' },
	{ city: 'Illannavoree (Donegal)', zip: '443605' },
	{ city: 'Illanoona (Mayo)', zip: '163324' },
	{ city: 'Illanreagh (Donegal)', zip: '682470' },
	{ city: 'Illanroe (Mayo)', zip: '393777' },
	{ city: 'Illaun (Clare)', zip: '811452' },
	{ city: 'Illaun (Galway)', zip: '560302' },
	{ city: 'Illaunabuckedia (Galway)', zip: '915477' },
	{ city: 'Illaunacroghnut (Galway)', zip: '947385' },
	{ city: 'Illaunagawna (Galway)', zip: '184349' },
	{ city: 'Illaunagreasy (Galway)', zip: '106851' },
	{ city: 'Illaunaknick Islands (Galway)', zip: '540120' },
	{ city: 'Illaunaknock (Galway)', zip: '641199' },
	{ city: 'Illaunanarrew (Galway)', zip: '781586' },
	{ city: 'Illaunaneel (Galway)', zip: '968361' },
	{ city: 'Illaunaragh (Galway)', zip: '750954' },
	{ city: 'Illaunard (Galway)', zip: '617625' },
	{ city: 'Illaunatoo (Clare)', zip: '302832' },
	{ city: 'Illaunatraghta (Galway)', zip: '915263' },
	{ city: 'Illaunaveetry (Galway)', zip: '178000' },
	{ city: 'Illaunawehichy (Galway)', zip: '590863' },
	{ city: 'Illaunawullagh Islands (Galway)', zip: '359635' },
	{ city: 'Illaunbaun (Clare)', zip: '552186' },
	{ city: 'Illaunboy (Kerry)', zip: '569659' },
	{ city: 'Illauncaum (Kerry)', zip: '974507' },
	{ city: 'Illauncosheen (Galway)', zip: '995542' },
	{ city: 'Illauncurragilka (Galway)', zip: '256264' },
	{ city: 'Illaundarragh (Galway)', zip: '361157' },
	{ city: 'Illaundaulaur (Galway)', zip: '829561' },
	{ city: 'Illaundonoghrevy (Galway)', zip: '182628' },
	{ city: 'Illaundoon (Galway)', zip: '161002' },
	{ city: 'Illaunduff (Kerry)', zip: '805832' },
	{ city: 'Illauneeragh (Galway)', zip: '225999' },
	{ city: 'Illauneeragh West (Galway)', zip: '846725' },
	{ city: 'Illaunfadda Islands (Galway)', zip: '131824' },
	{ city: 'Illaungib Rock (Kerry)', zip: '753437' },
	{ city: 'Illaunglass (Galway)', zip: '403413' },
	{ city: 'Illaunglass Island (Galway)', zip: '470511' },
	{ city: 'Illaungorm North (Galway)', zip: '975890' },
	{ city: 'Illaungorm South (Galway)', zip: '705387' },
	{ city: 'Illaungurraig (Galway)', zip: '587269' },
	{ city: 'Illauninagh East (Cork)', zip: '472214' },
	{ city: 'Illauninagh West (Cork)', zip: '794683' },
	{ city: 'Illaunknocknanagh (Cork)', zip: '208964' },
	{ city: 'Illaunleenagh (Galway)', zip: '361551' },
	{ city: 'Illaunmaan (Galway)', zip: '132052' },
	{ city: 'Illaunmeen (Tipperary)', zip: '214347' },
	{ city: 'Illaunmore (Clare)', zip: '110538' },
	{ city: 'Illaunmore (Galway)', zip: '983183' },
	{ city: 'Illaunnacroagh Beg (Galway)', zip: '623307' },
	{ city: 'Illaunnacroagh More (Galway)', zip: '334464' },
	{ city: 'Illaunnagappul (Galway)', zip: '123612' },
	{ city: 'Illaunnaginga (Galway)', zip: '978572' },
	{ city: 'Illaunnaheltia (Galway)', zip: '670352' },
	{ city: 'Illaunnakirka (Galway)', zip: '181555' },
	{ city: 'Illaunnamang (Galway)', zip: '493942' },
	{ city: 'Illaunnanownim (Galway)', zip: '309969' },
	{ city: 'Illaunnarroor (Galway)', zip: '402961' },
	{ city: 'Illaunree (Galway)', zip: '625116' },
	{ city: 'Illaunribbeen (Galway)', zip: '219936' },
	{ city: 'Illaunroe (Galway)', zip: '899985' },
	{ city: 'Illaunrossalough (Galway)', zip: '455542' },
	{ city: 'Illaunstookagh (Kerry)', zip: '121355' },
	{ city: 'Illaunyregan (Clare)', zip: '241053' },
	{ city: 'Illeny (Galway)', zip: '909196' },
	{ city: 'Illies (Donegal)', zip: '584985' },
	{ city: 'Illion (Donegal)', zip: '902211' },
	{ city: 'Illion (Galway)', zip: '275342' },
	{ city: 'Illion East (Galway)', zip: '960478' },
	{ city: 'Illion West (Galway)', zip: '941524' },
	{ city: 'Imlick (Donegal)', zip: '446521' },
	{ city: 'Imogane (Cork)', zip: '778490' },
	{ city: 'Imokishy (Cork)', zip: '559659' },
	{ city: 'Imphrick (Cork)', zip: '934744' },
	{ city: 'Inagh (Clare)', zip: '578948' },
	{ city: 'Inagh (Mayo)', zip: '917388' },
	{ city: 'Inan (Meath)', zip: '280835' },
	{ city: 'Inane (Cork)', zip: '554571' },
	{ city: 'Inane (Tipperary)', zip: '187467' },
	{ city: 'Inch (Carlow)', zip: '997996' },
	{ city: 'Inch (Cork)', zip: '733914' },
	{ city: 'Inch (Donegal)', zip: '433694' },
	{ city: 'Inch (Dublin)', zip: '657351' },
	{ city: 'Inch (Kerry)', zip: '845893' },
	{ city: 'Inch (Kildare)', zip: '424364' },
	{ city: 'Inch (Laois)', zip: '354175' },
	{ city: 'Inch (Limerick)', zip: '505840' },
	{ city: 'Inch (Tipperary)', zip: '217838' },
	{ city: 'Inch (Wexford)', zip: '834361' },
	{ city: 'Incha (Limerick)', zip: '270155' },
	{ city: 'Inchabaun (Limerick)', zip: '620354' },
	{ city: 'Incha Beg (Tipperary)', zip: '299368' },
	{ city: 'Inchaboy North (Galway)', zip: '467423' },
	{ city: 'Inchaboy South (Galway)', zip: '688566' },
	{ city: 'Inchabride (Kilkenny)', zip: '475520' },
	{ city: 'Inchacarran (Kilkenny)', zip: '937946' },
	{ city: 'Inchacommaun Islands (Galway)', zip: '671123' },
	{ city: 'Inchacooly (Laois)', zip: '788942' },
	{ city: 'Inchacoomb (Limerick)', zip: '253666' },
	{ city: 'Inchadrinagh (Tipperary)', zip: '404183' },
	{ city: 'Inchafune (Cork)', zip: '304284' },
	{ city: 'Inchaghaun (Galway)', zip: '412584' },
	{ city: 'Inchagoill (Galway)', zip: '650988' },
	{ city: 'Inchagreana (Tipperary)', zip: '260263' },
	{ city: 'Inchagreenoge (Limerick)', zip: '249606' },
	{ city: 'Inchakevin (Cork)', zip: '650263' },
	{ city: 'Inchakill Glebe (Kilkenny)', zip: '963955' },
	{ city: 'Inchaleagh (Cork)', zip: '107530' },
	{ city: 'Inchaloughra (Kerry)', zip: '999225' },
	{ city: 'Inchalughoge (Clare)', zip: '634285' },
	{ city: 'Inchamakinna (Galway)', zip: '447993' },
	{ city: 'Inchamay North (Cork)', zip: '569660' },
	{ city: 'Inchamay South (Cork)', zip: '499193' },
	{ city: 'Inchamore (Cork)', zip: '276745' },
	{ city: 'Inchamore (Galway)', zip: '793819' },
	{ city: 'Incha More (Tipperary)', zip: '321423' },
	{ city: 'Inchanabraher (Tipperary)', zip: '503583' },
	{ city: 'Inchanadreen (Cork)', zip: '279134' },
	{ city: 'Inchanaglogh (Kilkenny)', zip: '348618' },
	{ city: 'Inchanapisha (Cork)', zip: '704049' },
	{ city: 'Inchanappa North (Wicklow)', zip: '186426' },
	{ city: 'Inchanappa South (Wicklow)', zip: '529823' },
	{ city: 'Inchanearl (Kildare)', zip: '850798' },
	{ city: 'Inchanisky (Laois)', zip: '210577' },
	{ city: 'Inchantotane (Cork)', zip: '919890' },
	{ city: 'Inchaquire (Kildare)', zip: '362137' },
	{ city: 'Inchbeg (Clare)', zip: '878775' },
	{ city: 'Inchbeg (Kilkenny)', zip: '455403' },
	{ city: 'Inchbofin (Westmeath)', zip: '938223' },
	{ city: 'Inchcleraun (Longford)', zip: '102069' },
	{ city: 'Inch East (Cork)', zip: '249711' },
	{ city: 'Inch East (Kerry)', zip: '659222' },
	{ city: 'Inchee (Kerry)', zip: '794820' },
	{ city: 'Inchee East (Kerry)', zip: '862706' },
	{ city: 'Incheens (Kerry)', zip: '949137' },
	{ city: 'Inchee West (Kerry)', zip: '460153' },
	{ city: 'Inchenagh (Longford)', zip: '432956' },
	{ city: 'Inchera (Cork)', zip: '920187' },
	{ city: 'Incherky (Offaly)', zip: '892595' },
	{ city: 'Inches (Cork)', zip: '452990' },
	{ city: 'Inchfarrannagleragh Glebe (Kerry)', zip: '509935' },
	{ city: 'Inchi Beg (Cork)', zip: '639113' },
	{ city: 'Inchiboy (Kerry)', zip: '567812' },
	{ city: 'Inchibrackane (Cork)', zip: '825061' },
	{ city: 'Inchiclogh (Cork)', zip: '938285' },
	{ city: 'Inchiclogh (Kerry)', zip: '757943' },
	{ city: 'Inchicloon (Kerry)', zip: '154099' },
	{ city: 'Inchicore (Dublin)', zip: '650886' },
	{ city: 'Inchicorrigane East (Kerry)', zip: '661867' },
	{ city: 'Inchicorrigane West (Kerry)', zip: '142230' },
	{ city: 'Inchicronan Island (Clare)', zip: '510907' },
	{ city: 'Inchidaly (Cork)', zip: '829809' },
	{ city: 'Inchideraille (Cork)', zip: '968459' },
	{ city: 'Inchigaggin (Cork)', zip: '316584' },
	{ city: 'Inchigeelagh (Cork)', zip: '466939' },
	{ city: 'Inchigrady (Cork)', zip: '994929' },
	{ city: 'Inchileigh (Cork)', zip: '979526' },
	{ city: 'Inchimacteige (Kerry)', zip: '602815' },
	{ city: 'Inchimore (Kerry)', zip: '922639' },
	{ city: 'Inchi More (Cork)', zip: '249078' },
	{ city: 'Inchinagotagh (Cork)', zip: '935000' },
	{ city: 'Inchinagoum (Cork)', zip: '707403' },
	{ city: 'Inchinahoury (Cork)', zip: '628022' },
	{ city: 'Inchinaleega East (Kerry)', zip: '961317' },
	{ city: 'Inchinaleega West (Kerry)', zip: '757942' },
	{ city: 'Inchinanagh (Cork)', zip: '726878' },
	{ city: 'Inchinanagh (Kerry)', zip: '676104' },
	{ city: 'Inchinaneave (Cork)', zip: '254274' },
	{ city: 'Inchinapallas (Cork)', zip: '145417' },
	{ city: 'Inchinapoagh (Kerry)', zip: '933163' },
	{ city: 'Inchinarihen (Cork)', zip: '462183' },
	{ city: 'Inchinascarty (Kerry)', zip: '419959' },
	{ city: 'Inchinashingane (Cork)', zip: '198026' },
	{ city: 'Inchinatinny (Kerry)', zip: '350933' },
	{ city: 'Inchinattin (Cork)', zip: '590591' },
	{ city: 'Inchinclare (Limerick)', zip: '872212' },
	{ city: 'Inchincoosh (Kerry)', zip: '986613' },
	{ city: 'Inchincummer (Kerry)', zip: '280372' },
	{ city: 'Inchincurka (Cork)', zip: '673208' },
	{ city: 'Inchindrisla (Waterford)', zip: '286589' },
	{ city: 'Inchindrislawood (Waterford)', zip: '744981' },
	{ city: 'Inchineill (Cork)', zip: '201193' },
	{ city: 'Inchingerig (Cork)', zip: '285424' },
	{ city: 'Inchinglanna (Kerry)', zip: '559814' },
	{ city: 'Inchinleama East (Waterford)', zip: '518907' },
	{ city: 'Inchinleama West (Waterford)', zip: '397449' },
	{ city: 'Inchinlinane (Cork)', zip: '343197' },
	{ city: 'Inchinlough (Kerry)', zip: '215954' },
	{ city: 'Inchinossig (Cork)', zip: '758414' },
	{ city: 'Inchinsquillib (Tipperary)', zip: '521885' },
	{ city: 'Inchintaggart (Cork)', zip: '750690' },
	{ city: 'Inchintaglin (Cork)', zip: '450449' },
	{ city: 'Inchinteskin (Cork)', zip: '946474' },
	{ city: 'Inchintrea (Kerry)', zip: '774247' },
	{ city: 'Inchinveema (Kerry)', zip: '675201' },
	{ city: 'Inchiquin (Clare)', zip: '161509' },
	{ city: 'Inchiquin (Cork)', zip: '163311' },
	{ city: 'Inchiquin (Galway)', zip: '921686' },
	{ city: 'Inchirahilly (Cork)', zip: '530485' },
	{ city: 'Inchireagh (Cork)', zip: '647793' },
	{ city: 'Inchiroe (Cork)', zip: '377891' },
	{ city: 'Inchiroe And Gortfree (Roscommon)', zip: '178081' },
	{ city: 'Inchirourke (Tipperary)', zip: '897451' },
	{ city: 'Inchisarsfield (Cork)', zip: '817775' },
	{ city: 'Inchisine (Cork)', zip: '179958' },
	{ city: 'Inchisland (Carlow)', zip: '944022' },
	{ city: 'Inch Island (Cavan)', zip: '548085' },
	{ city: 'Inchivara (Tipperary)', zip: '135810' },
	{ city: 'Inch Level (Donegal)', zip: '272584' },
	{ city: 'Inch-Moor (Kerry)', zip: '759782' },
	{ city: 'Inchmore (Kilkenny)', zip: '156864' },
	{ city: 'Inchmore (Limerick)', zip: '998391' },
	{ city: 'Inchmore (Westmeath)', zip: '880267' },
	{ city: 'Inch More (Clare)', zip: '166063' },
	{ city: 'Inchnagree (Cork)', zip: '277049' },
	{ city: 'Inchnamuck (Tipperary)', zip: '251830' },
	{ city: 'Inchnanoon (Cork)', zip: '211474' },
	{ city: 'Inch Saint Lawrence (Limerick)', zip: '892983' },
	{ city: 'Inch Saint Lawrence North (Limerick)', zip: '472501' },
	{ city: 'Inch Saint Lawrence South (Limerick)', zip: '665622' },
	{ city: 'Inchturk (Westmeath)', zip: '921308' },
	{ city: 'Inch West (Cork)', zip: '422882' },
	{ city: 'Inch West (Kerry)', zip: '614961' },
	{ city: 'Inchy (Galway)', zip: '904587' },
	{ city: 'Inchyallagh (Cork)', zip: '260199' },
	{ city: 'Inchybegga (Cork)', zip: '347901' },
	{ city: 'Inchycullane (Kerry)', zip: '649037' },
	{ city: 'Inchydoney Island (Cork)', zip: '583238' },
	{ city: 'Inchymagilleragh East (Kerry)', zip: '951584' },
	{ city: 'Inchymagilleragh West (Kerry)', zip: '426566' },
	{ city: 'Ing (Clare)', zip: '399012' },
	{ city: 'Ing East (Clare)', zip: '630944' },
	{ city: 'Ing West (Clare)', zip: '698669' },
	{ city: 'Inish (Galway)', zip: '828430' },
	{ city: 'Inishaellaun (Clare)', zip: '338330' },
	{ city: 'Inishal (Donegal)', zip: '898864' },
	{ city: 'Inishammon (Monaghan)', zip: '777975' },
	{ city: 'Inish And Ballyteige Slob (Wexford)', zip: '528670' },
	{ city: 'Inishannagh (Galway)', zip: '698083' },
	{ city: 'Inishannon (Cork)', zip: '630552' },
	{ city: 'Inishard (Mayo)', zip: '116258' },
	{ city: 'Inishbarra (Galway)', zip: '836946' },
	{ city: 'Inishbeg (Cavan)', zip: '234698' },
	{ city: 'Inishbeg (Cork)', zip: '275045' },
	{ city: 'Inishbeg (Donegal)', zip: '452349' },
	{ city: 'Inishbiana (Galway)', zip: '148427' },
	{ city: 'Inishbigger (Galway)', zip: '689882' },
	{ city: 'Inishbiggle (Mayo)', zip: '210441' },
	{ city: 'Inishbofin (Donegal)', zip: '327359' },
	{ city: 'Inishbofin (Galway)', zip: '491714' },
	{ city: 'Inishcarra (Cork)', zip: '792914' },
	{ city: 'Inishcoe (Mayo)', zip: '589811' },
	{ city: 'Inishconga (Galway)', zip: '840596' },
	{ city: 'Inishconnell (Cavan)', zip: '791696' },
	{ city: 'Inishcoo (Donegal)', zip: '689267' },
	{ city: 'Inishcoog (Mayo)', zip: '917554' },
	{ city: 'Inishcoole (Donegal)', zip: '195836' },
	{ city: 'Inishcorker (Clare)', zip: '325725' },
	{ city: 'Inishcrone (Sligo)', zip: '592764' },
	{ city: 'Inishdauwee (Galway)', zip: '830493' },
	{ city: 'Inishdea (Clare)', zip: '380295' },
	{ city: 'Inishderry (Mayo)', zip: '290458' },
	{ city: 'Inishdevlin (Monaghan)', zip: '946341' },
	{ city: 'Inishdooey (Donegal)', zip: '965411' },
	{ city: 'Inishdoorus (Galway)', zip: '211173' },
	{ city: 'Inisheane (Donegal)', zip: '419186' },
	{ city: 'Inishee (Galway)', zip: '925853' },
	{ city: 'Inisheer (Galway)', zip: '182369' },
	{ city: 'Inisheltia (Galway)', zip: '432109' },
	{ city: 'Inisherk (Galway)', zip: '886697' },
	{ city: 'Inishfad (Donegal)', zip: '593181' },
	{ city: 'Inishfarnard (Cork)', zip: '123838' },
	{ city: 'Inishfaugh (Donegal)', zip: '695226' },
	{ city: 'Inishfoyle (Kerry)', zip: '733839' },
	{ city: 'Inishfree Lower (Donegal)', zip: '492716' },
	{ city: 'Inishfree Upper (Donegal)', zip: '238814' },
	{ city: 'Inishglora (Mayo)', zip: '228419' },
	{ city: 'Inishillintry (Donegal)', zip: '163857' },
	{ city: 'Inishinny (Donegal)', zip: '893062' },
	{ city: 'Inishkea North (Mayo)', zip: '378778' },
	{ city: 'Inishkea South (Mayo)', zip: '523106' },
	{ city: 'Inishkeel (Donegal)', zip: '937403' },
	{ city: 'Inishkeen (Limerick)', zip: '105002' },
	{ city: 'Inishkeen (Monaghan)', zip: '459778' },
	{ city: 'Inishkeen Glebe (Monaghan)', zip: '751340' },
	{ city: 'Inishkeeragh (Donegal)', zip: '662369' },
	{ city: 'Inishkeeragh (Mayo)', zip: '722129' },
	{ city: 'Inishkenny (Cork)', zip: '693535' },
	{ city: 'Inishlackan (Galway)', zip: '271925' },
	{ city: 'Inishlay (Galway)', zip: '523986' },
	{ city: 'Inishleena (Cork)', zip: '225217' },
	{ city: 'Inishloe (Clare)', zip: '215779' },
	{ city: 'Inishlounaght (Tipperary)', zip: '125593' },
	{ city: 'Inishlusk (Galway)', zip: '805802' },
	{ city: 'Inishlyon (Galway)', zip: '412673' },
	{ city: 'Inishlyre (Mayo)', zip: '970322' },
	{ city: 'Inishmaan (Galway)', zip: '404609' },
	{ city: 'Inishmacnaghtan (Clare)', zip: '864363' },
	{ city: 'Inishmacowney (Clare)', zip: '609451' },
	{ city: 'Inishmaine (Mayo)', zip: '880111' },
	{ city: 'Inishmeal (Donegal)', zip: '803146' },
	{ city: 'Inishmeane (Donegal)', zip: '532552' },
	{ city: 'Inishmicatreer (Galway)', zip: '801466' },
	{ city: 'Inishmore (Cavan)', zip: '950620' },
	{ city: 'Inishmore (Clare)', zip: '953373' },
	{ city: 'Inishmore (Galway)', zip: '214400' },
	{ city: 'Inishmuck (Cavan)', zip: '837038' },
	{ city: 'Inishmulclohy (Sligo)', zip: '952762' },
	{ city: 'Inishmurray (Sligo)', zip: '399953' },
	{ city: 'Inishmuskerry (Galway)', zip: '700084' },
	{ city: 'Inishnabro (Kerry)', zip: '917823' },
	{ city: 'Inishnakillew (Mayo)', zip: '378546' },
	{ city: 'Inishnanean (Galway)', zip: '309288' },
	{ city: 'Inishnee (Galway)', zip: '409385' },
	{ city: 'Inishodriscol (Cork)', zip: '113734' },
	{ city: 'Inishowen (Mayo)', zip: '464163' },
	{ city: 'Inishroo (Galway)', zip: '165335' },
	{ city: 'Inishshark (Galway)', zip: '182958' },
	{ city: 'Inishsirrer (Donegal)', zip: '342191' },
	{ city: 'Inishthee (Galway)', zip: '954469' },
	{ city: 'Inishthee Rocks (Galway)', zip: '909173' },
	{ city: 'Inishtooskert (Kerry)', zip: '908390' },
	{ city: 'Inishtrahull (Donegal)', zip: '535479' },
	{ city: 'Inishtravin (Galway)', zip: '624711' },
	{ city: 'Inishtreh (Galway)', zip: '205839' },
	{ city: 'Inishtroghenmore (Galway)', zip: '971690' },
	{ city: 'Inishtubbrid (Clare)', zip: '732445' },
	{ city: 'Inishturk (Galway)', zip: '420747' },
	{ city: 'Inishturk (Mayo)', zip: '997693' },
	{ city: 'Inishvickillane (Kerry)', zip: '810473' },
	{ city: 'Inishvinlush (Galway)', zip: '904731' },
	{ city: 'Inistioge (Kilkenny)', zip: '793533' },
	{ city: 'Innfield (Meath)', zip: '488803' },
	{ city: 'Innishkil (Donegal)', zip: '576538' },
	{ city: 'Inniskil (Donegal)', zip: '942798' },
	{ city: 'Innplot (Galway)', zip: '429983' },
	{ city: 'Innygraga (Cork)', zip: '948854' },
	{ city: 'Intack (Wicklow)', zip: '369847' },
	{ city: 'Intake (Dublin)', zip: '837191' },
	{ city: 'Intake (Wexford)', zip: '829279' },
	{ city: 'Inver (Donegal)', zip: '479961' },
	{ city: 'Inver (Mayo)', zip: '276174' },
	{ city: 'Inveran (Galway)', zip: '330744' },
	{ city: 'Inver Glebe (Donegal)', zip: '431266' },
	{ city: 'Invyarroge (Cavan)', zip: '488143' },
	{ city: 'Iragh (Clare)', zip: '889752' },
	{ city: 'Irby (Tipperary)', zip: '637522' },
	{ city: "Ireland's Eye (Dublin)", zip: '731170' },
	{ city: 'Irishstown (Westmeath)', zip: '589679' },
	{ city: 'Irishtown (Dublin)', zip: '231662' },
	{ city: 'Irishtown (Kildare)', zip: '710909' },
	{ city: 'Irishtown (Louth)', zip: '947529' },
	{ city: 'Irishtown (Mayo)', zip: '431104' },
	{ city: 'Irishtown (Meath)', zip: '482482' },
	{ city: 'Irishtown (Offaly)', zip: '393952' },
	{ city: 'Irishtown (Wexford)', zip: '171838' },
	{ city: 'Irishtown (Wicklow)', zip: '203998' },
	{ city: 'Irishtown East (Wicklow)', zip: '103359' },
	{ city: 'Irishtown Lower (Kildare)', zip: '644738' },
	{ city: 'Irishtown Park (Wicklow)', zip: '610307' },
	{ city: 'Irishtown Upper (Kildare)', zip: '773883' },
	{ city: 'Irishtown West (Wicklow)', zip: '191673' },
	{ city: 'Irongrange Lower (Wicklow)', zip: '440151' },
	{ city: 'Irongrange Upper (Wicklow)', zip: '420305' },
	{ city: 'Ironhills (Kildare)', zip: '110922' },
	{ city: 'Ironmills (Laois)', zip: '925744' },
	{ city: 'Ironpool (Galway)', zip: '972216' },
	{ city: 'Ironworks (Donegal)', zip: '741565' },
	{ city: 'Irrabeg (Kerry)', zip: '277776' },
	{ city: 'Irramore (Kerry)', zip: '280937' },
	{ city: 'Iry (Laois)', zip: '747464' },
	{ city: 'Isaacstown (Meath)', zip: '818327' },
	{ city: 'Isertkelly North (Galway)', zip: '805044' },
	{ city: 'Isertkelly South (Galway)', zip: '304615' },
	{ city: 'Ishlaun (Roscommon)', zip: '403446' },
	{ city: 'Iskanafeelna (Cork)', zip: '529116' },
	{ city: 'Iskanamucky (Cork)', zip: '517962' },
	{ city: 'Iskancullin (Clare)', zip: '276060' },
	{ city: 'Iskaroon (Meath)', zip: '725742' },
	{ city: 'Iskaroon Little (Meath)', zip: '572529' },
	{ city: 'Islafalcon (Wexford)', zip: '267336' },
	{ city: 'Island (Carlow)', zip: '484419' },
	{ city: 'Island (Cavan)', zip: '854507' },
	{ city: 'Island (Clare)', zip: '408887' },
	{ city: 'Island (Cork)', zip: '334685' },
	{ city: 'Island (Galway)', zip: '387849' },
	{ city: 'Island (Laois)', zip: '933113' },
	{ city: 'Island (Longford)', zip: '850913' },
	{ city: 'Island (Mayo)', zip: '734207' },
	{ city: 'Island (Offaly)', zip: '576368' },
	{ city: 'Island (Waterford)', zip: '552463' },
	{ city: 'Island (Wexford)', zip: '644571' },
	{ city: 'Islandav (Cork)', zip: '879757' },
	{ city: 'Islandavanna Lower (Clare)', zip: '492832' },
	{ city: 'Islandavanna Upper (Clare)', zip: '951470' },
	{ city: 'Islandbawn (Tipperary)', zip: '967733' },
	{ city: 'Island Beg (Galway)', zip: '452079' },
	{ city: 'Islandboy (Kerry)', zip: '108308' },
	{ city: 'Islandboy (Limerick)', zip: '150318' },
	{ city: 'Islandboy East (Kerry)', zip: '262073' },
	{ city: 'Islandboy West (Kerry)', zip: '361762' },
	{ city: 'Islandbrack (Cork)', zip: '817251' },
	{ city: 'Islandbridge (Dublin)', zip: '923682' },
	{ city: 'Islandcosgry (Clare)', zip: '131883' },
	{ city: 'Island-Dahill (Cork)', zip: '738312' },
	{ city: 'Island Dromagh (Limerick)', zip: '861009' },
	{ city: 'Islandduane (Limerick)', zip: '783566' },
	{ city: 'Islandea (Limerick)', zip: '584021' },
	{ city: 'Islandeady (Mayo)', zip: '266254' },
	{ city: 'Islandearagh (Kerry)', zip: '723969' },
	{ city: 'Island East (Galway)', zip: '496952' },
	{ city: 'Island Eddy (Galway)', zip: '817341' },
	{ city: 'Islandganniv North (Kerry)', zip: '579173' },
	{ city: 'Islandganniv South (Kerry)', zip: '912971' },
	{ city: 'Islandgar (Clare)', zip: '664772' },
	{ city: 'Islandhubbock (Waterford)', zip: '265585' },
	{ city: 'Islandikane East (Waterford)', zip: '668086' },
	{ city: 'Islandikane North (Waterford)', zip: '515826' },
	{ city: 'Islandikane South (Waterford)', zip: '497086' },
	{ city: 'Island Lower (Roscommon)', zip: '183175' },
	{ city: 'Island Lower (Wexford)', zip: '700595' },
	{ city: 'Islandmacloughry (Kerry)', zip: '631762' },
	{ city: 'Islandmacnevin (Clare)', zip: '243433' },
	{ city: 'Island Mac Teige (Limerick)', zip: '636855' },
	{ city: 'Islandmagrath (Clare)', zip: '443546' },
	{ city: 'Island Middle (Wexford)', zip: '754152' },
	{ city: 'Islandmore (Clare)', zip: '382018' },
	{ city: 'Islandmore (Galway)', zip: '539240' },
	{ city: 'Islandmore (Kerry)', zip: '233967' },
	{ city: 'Islandmore (Mayo)', zip: '155802' },
	{ city: 'Islandmore (Roscommon)', zip: '696951' },
	{ city: 'Island More (Donegal)', zip: '769822' },
	{ city: 'Island More (Mayo)', zip: '420936' },
	{ city: 'Island Ravedy (Donegal)', zip: '329622' },
	{ city: 'Island Reagh (Donegal)', zip: '937071' },
	{ city: 'Island Roy (Donegal)', zip: '396212' },
	{ city: 'Islandroy Barr (Donegal)', zip: '220728' },
	{ city: 'Islands (Galway)', zip: '111038' },
	{ city: 'Islands (Kilkenny)', zip: '967023' },
	{ city: 'Islands (Monaghan)', zip: '344986' },
	{ city: 'Islands (Tipperary)', zip: '853013' },
	{ city: 'Island Strand Intake (Cork)', zip: '901358' },
	{ city: 'Islandtarsney North (Waterford)', zip: '118020' },
	{ city: 'Islandtarsney South (Waterford)', zip: '211064' },
	{ city: 'Island Upper (Roscommon)', zip: '921350' },
	{ city: 'Island Upper (Wexford)', zip: '795237' },
	{ city: 'Island West (Galway)', zip: '305521' },
	{ city: 'Islandwood (Tipperary)', zip: '153467' },
	{ city: 'Issane (Limerick)', zip: '878124' },
	{ city: 'Istalea Lower (Kerry)', zip: '215586' },
	{ city: 'Istalea Upper (Kerry)', zip: '935233' },
	{ city: 'Itereery (Monaghan)', zip: '172707' },
	{ city: 'Ivyhall (Tipperary)', zip: '356124' },
	{ city: 'Ivy Hill (Monaghan)', zip: '245427' },
	{ city: 'Jacketstown (Wexford)', zip: '507845' },
	{ city: 'Jackstown (Kilkenny)', zip: '353697' },
	{ city: 'Jamesbrook (Cork)', zip: '726754' },
	{ city: 'Jamesgreen (Kilkenny)', zip: '664566' },
	{ city: 'Jamespark (Kilkenny)', zip: '529699' },
	{ city: 'Jamestown (Dublin)', zip: '720757' },
	{ city: 'Jamestown (Kilkenny)', zip: '546770' },
	{ city: 'Jamestown (Laois)', zip: '536908' },
	{ city: 'Jamestown (Leitrim)', zip: '656355' },
	{ city: 'Jamestown (Limerick)', zip: '524215' },
	{ city: 'Jamestown (Meath)', zip: '310653' },
	{ city: 'Jamestown (Roscommon)', zip: '389230' },
	{ city: 'Jamestown (Tipperary)', zip: '637011' },
	{ city: 'Jamestown (Westmeath)', zip: '231003' },
	{ city: 'Jamestown (Wexford)', zip: '472782' },
	{ city: 'Jamestown Little (Dublin)', zip: '817975' },
	{ city: 'Janeville (Carlow)', zip: '351364' },
	{ city: 'Janeville (Waterford)', zip: '700011' },
	{ city: 'Jarretstown (Kildare)', zip: '941805' },
	{ city: 'Jarretstown (Meath)', zip: '951717' },
	{ city: 'Jealoustown (Meath)', zip: '190442' },
	{ city: 'Jeffrystown (Westmeath)', zip: '291756' },
	{ city: 'Jenkinstown (Kilkenny)', zip: '276509' },
	{ city: 'Jenkinstown (Louth)', zip: '185851' },
	{ city: 'Jenkinstown (Meath)', zip: '728874' },
	{ city: 'Jerpointabbey (Kilkenny)', zip: '115067' },
	{ city: 'Jerpointchurch (Kilkenny)', zip: '366435' },
	{ city: 'Jerpointhill (Kilkenny)', zip: '301977' },
	{ city: 'Jerpoint West (Kilkenny)', zip: '832837' },
	{ city: 'Jerusalem (Kildare)', zip: '908082' },
	{ city: 'Jessfield (Tipperary)', zip: '789605' },
	{ city: 'Jigginstown (Kildare)', zip: '520204' },
	{ city: 'Joanstown (Waterford)', zip: '134012' },
	{ city: 'Joanstown (Westmeath)', zip: '432095' },
	{ city: 'Jobstown (Dublin)', zip: '539875' },
	{ city: 'Jockeyhall (Kilkenny)', zip: '698884' },
	{ city: 'Jockeyhall (Limerick)', zip: '157929' },
	{ city: 'Jockeyhall (Tipperary)', zip: '380721' },
	{ city: 'Johnduffswood (Carlow)', zip: '895737' },
	{ city: 'Johninstown (Kildare)', zip: '349125' },
	{ city: 'Johnsborough (Laois)', zip: '533072' },
	{ city: 'Johnsbrook (Meath)', zip: '927350' },
	{ city: 'Johnsfort (Mayo)', zip: '835634' },
	{ city: 'Johnstown (Carlow)', zip: '417850' },
	{ city: 'Johnstown (Cork)', zip: '366903' },
	{ city: 'Johnstown (Dublin)', zip: '889432' },
	{ city: 'Johnstown (Galway)', zip: '746433' },
	{ city: 'Johnstown (Kildare)', zip: '372965' },
	{ city: 'Johnstown (Kilkenny)', zip: '417183' },
	{ city: 'Johnstown (Louth)', zip: '244346' },
	{ city: 'Johnstown (Meath)', zip: '530184' },
	{ city: 'Johnstown (Tipperary)', zip: '564543' },
	{ city: 'Johnstown (Waterford)', zip: '114892' },
	{ city: 'Johnstown (Westmeath)', zip: '745290' },
	{ city: 'Johnstown (Wexford)', zip: '767986' },
	{ city: 'Johnstown (Wicklow)', zip: '477445' },
	{ city: 'Johnstown Bridge (Kildare)', zip: '318908' },
	{ city: 'Johnstown Demesne (Roscommon)', zip: '139369' },
	{ city: 'Johnstown East (Cork)', zip: '340454' },
	{ city: 'Johnstown Glebe (Laois)', zip: '279390' },
	{ city: 'Johnstown Hill (Wicklow)', zip: '529741' },
	{ city: 'Johnstown Lower (Wicklow)', zip: '912035' },
	{ city: 'Johnstown North (Kildare)', zip: '928431' },
	{ city: 'Johnstown North (Wicklow)', zip: '757148' },
	{ city: 'Johnstown South (Kildare)', zip: '193993' },
	{ city: 'Johnstown South (Wicklow)', zip: '454904' },
	{ city: 'Johnstown Upper (Wicklow)', zip: '198460' },
	{ city: 'Johnstown West (Cork)', zip: '763028' },
	{ city: 'Johnswell (Kilkenny)', zip: '682378' },
	{ city: 'Joinersfolly (Kilkenny)', zip: '583488' },
	{ city: 'Jonastown (Wexford)', zip: '207535' },
	{ city: 'Jonestown (Offaly)', zip: '134624' },
	{ city: 'Jordansquarter (Tipperary)', zip: '369756' },
	{ city: 'Jordanstown (Cork)', zip: '120718' },
	{ city: 'Jordanstown (Dublin)', zip: '420396' },
	{ city: 'Jordanstown (Kilkenny)', zip: '390466' },
	{ city: 'Jordanstown (Meath)', zip: '374343' },
	{ city: 'Jordanstown (Westmeath)', zip: '896868' },
	{ city: 'Joristown Lower (Westmeath)', zip: '895499' },
	{ city: 'Joristown Upper (Westmeath)', zip: '942443' },
	{ city: 'Jossestown (Tipperary)', zip: '520181' },
	{ city: 'Joulterspark (Waterford)', zip: '657076' },
	{ city: 'Joycegrove (Galway)', zip: '704929' },
	{ city: 'Joyces Island (Galway)', zip: '686531' },
	{ city: "Joyce's Park (Galway)", zip: '707593' },
	{ city: 'Julianstown (Kilkenny)', zip: '258892' },
	{ city: 'Julianstown (Meath)', zip: '247717' },
	{ city: 'Julianstown East (Meath)', zip: '642480' },
	{ city: 'Julianstown South (Meath)', zip: '423643' },
	{ city: 'Julianstown West (Meath)', zip: '140354' },
	{ city: 'Kanargad (Galway)', zip: '168812' },
	{ city: 'Kane (Louth)', zip: '422811' },
	{ city: 'Kanefield (Roscommon)', zip: '863523' },
	{ city: 'Kanrawer (Galway)', zip: '369215' },
	{ city: 'Kanturk (Cork)', zip: '873885' },
	{ city: 'Kavanaghspark (Wexford)', zip: '760271' },
	{ city: 'Kayle (Wexford)', zip: '746037' },
	{ city: 'Kead (Galway)', zip: '608837' },
	{ city: 'Keadagh (Roscommon)', zip: '699146' },
	{ city: 'Keadeen (Wicklow)', zip: '147925' },
	{ city: 'Keadew (Cavan)', zip: '830255' },
	{ city: 'Keadew (Donegal)', zip: '778144' },
	{ city: 'Keadew (Roscommon)', zip: '790134' },
	{ city: 'Keadew East (Roscommon)', zip: '455078' },
	{ city: 'Keadew Lower (Donegal)', zip: '617704' },
	{ city: 'Keadews (Sligo)', zip: '773220' },
	{ city: 'Keadew Upper (Donegal)', zip: '329985' },
	{ city: 'Keadew West (Roscommon)', zip: '441906' },
	{ city: 'Keal (Tipperary)', zip: '631073' },
	{ city: 'Kealafreaghane East (Kerry)', zip: '164882' },
	{ city: 'Kealafreaghane West (Kerry)', zip: '448491' },
	{ city: 'Kealagowlane (Cork)', zip: '382283' },
	{ city: 'Kealanine (Cork)', zip: '214932' },
	{ city: 'Kealariddig (Kerry)', zip: '552145' },
	{ city: 'Kealcoum (Cork)', zip: '355010' },
	{ city: 'Kealduff Lower (Kerry)', zip: '209656' },
	{ city: 'Kealduff Upper (Kerry)', zip: '636167' },
	{ city: 'Keale (Limerick)', zip: '850731' },
	{ city: 'Keale North (Cork)', zip: '267754' },
	{ city: 'Keale South (Cork)', zip: '980901' },
	{ city: 'Kealfadda (Cork)', zip: '565077' },
	{ city: 'Kealfoun (Waterford)', zip: '474555' },
	{ city: 'Kealgorm (Kerry)', zip: '140048' },
	{ city: 'Kealid (Kerry)', zip: '901146' },
	{ city: 'Kealkill (Cork)', zip: '101742' },
	{ city: 'Kealmanagh (Cork)', zip: '533452' },
	{ city: 'Kealoge (Cork)', zip: '790483' },
	{ city: 'Kealroe (Waterford)', zip: '807166' },
	{ city: 'Kealstown (Kildare)', zip: '693190' },
	{ city: 'Kealties (Cork)', zip: '981434' },
	{ city: 'Kealvaugh Beg (Cork)', zip: '266348' },
	{ city: 'Kealvaugh More (Cork)', zip: '207590' },
	{ city: 'Keam (Kerry)', zip: '451113' },
	{ city: 'Keamcorravooly (Cork)', zip: '298807' },
	{ city: 'Keamnabricka (Cork)', zip: '740119' },
	{ city: 'Keamnalicky (Cork)', zip: '786285' },
	{ city: 'Keamore (Cork)', zip: '125993' },
	{ city: 'Keamsellagh East (Galway)', zip: '815714' },
	{ city: 'Keamsellagh West (Galway)', zip: '115557' },
	{ city: 'Kearneysbay (Kilkenny)', zip: '441668' },
	{ city: 'Kearneystown (Louth)', zip: '124665' },
	{ city: 'Kearneystown Lower (Kildare)', zip: '841660' },
	{ city: 'Kearneystown Upper (Kildare)', zip: '536822' },
	{ city: 'Kearntown (Meath)', zip: '844212' },
	{ city: 'Keatingspark (Dublin)', zip: '607054' },
	{ city: 'Keatingstown (Kilkenny)', zip: '847691' },
	{ city: 'Keatleysclose (Cork)', zip: '842031' },
	{ city: 'Keave (Galway)', zip: '399071' },
	{ city: 'Kednagullion (Monaghan)', zip: '904752' },
	{ city: 'Kednaminsha (Monaghan)', zip: '628119' },
	{ city: 'Kedrah (Tipperary)', zip: '757919' },
	{ city: 'Keeagh (Galway)', zip: '900820' },
	{ city: 'Keeas (Kerry)', zip: '229680' },
	{ city: 'Keebagh (Mayo)', zip: '912066' },
	{ city: 'Keeghan (Cavan)', zip: '953033' },
	{ city: 'Keekill (Galway)', zip: '567253' },
	{ city: 'Keel (Cork)', zip: '743858' },
	{ city: 'Keel (Kerry)', zip: '979657' },
	{ city: 'Keel (Longford)', zip: '891246' },
	{ city: 'Keel (Mayo)', zip: '663365' },
	{ city: 'Keelagh (Cavan)', zip: '695464' },
	{ city: 'Keelagh (Laois)', zip: '157696' },
	{ city: 'Keelagh (Leitrim)', zip: '311396' },
	{ city: 'Keelagh Glebe (Cavan)', zip: '809378' },
	{ city: 'Keelaraheen (Cork)', zip: '762044' },
	{ city: 'Keelbanada (Roscommon)', zip: '345691' },
	{ city: 'Keelbaun (Longford)', zip: '134219' },
	{ city: 'Keelbeg (Westmeath)', zip: '352429' },
	{ city: 'Keelcurragh (Roscommon)', zip: '721135' },
	{ city: 'Keelderry (Cavan)', zip: '346411' },
	{ city: 'Keelderry (Clare)', zip: '606066' },
	{ city: 'Keelderry (Galway)', zip: '475014' },
	{ city: 'Keeldra (Leitrim)', zip: '915464' },
	{ city: 'Keeldrum (Donegal)', zip: '772182' },
	{ city: 'Keeldrum Lower (Donegal)', zip: '797639' },
	{ city: 'Keeldrum Upper (Donegal)', zip: '968787' },
	{ city: 'Keel East (Mayo)', zip: '870629' },
	{ city: 'Keelhilla (Clare)', zip: '635763' },
	{ city: 'Keelkill (Mayo)', zip: '913577' },
	{ city: 'Keelkyle (Clare)', zip: '325323' },
	{ city: 'Keelkyle (Galway)', zip: '836842' },
	{ city: 'Keelnagore (Kerry)', zip: '101264' },
	{ city: 'Keelogalabaun (Longford)', zip: '823739' },
	{ city: 'Keeloge (Galway)', zip: '204753' },
	{ city: 'Keeloge (Kildare)', zip: '980536' },
	{ city: 'Keeloge (Laois)', zip: '242565' },
	{ city: 'Keeloge (Leitrim)', zip: '194061' },
	{ city: 'Keeloge (Longford)', zip: '581702' },
	{ city: 'Keeloge (Offaly)', zip: '740426' },
	{ city: 'Keeloge (Westmeath)', zip: '714079' },
	{ city: 'Keeloge (Wicklow)', zip: '838643' },
	{ city: 'Keeloge Lower (Wicklow)', zip: '398348' },
	{ city: 'Keelogenasause (Longford)', zip: '717337' },
	{ city: 'Keeloge North (Laois)', zip: '438845' },
	{ city: 'Keeloges (Donegal)', zip: '665246' },
	{ city: 'Keeloges (Dublin)', zip: '168557' },
	{ city: 'Keeloges (Galway)', zip: '367093' },
	{ city: 'Keeloges (Kildare)', zip: '219606' },
	{ city: 'Keeloges (Leitrim)', zip: '164226' },
	{ city: 'Keeloges (Limerick)', zip: '293458' },
	{ city: 'Keeloges (Longford)', zip: '724854' },
	{ city: 'Keeloges (Mayo)', zip: '557013' },
	{ city: 'Keeloges (Roscommon)', zip: '507199' },
	{ city: 'Keeloges (Sligo)', zip: '694845' },
	{ city: 'Keeloges (Wexford)', zip: '203240' },
	{ city: 'Keeloges (Wicklow)', zip: '968837' },
	{ city: 'Keelogesbeg (Galway)', zip: '844396' },
	{ city: 'Keeloges East (Galway)', zip: '669787' },
	{ city: 'Keeloges Lower (Mayo)', zip: '901246' },
	{ city: 'Keeloges New (Mayo)', zip: '449137' },
	{ city: 'Keeloges Old (Mayo)', zip: '323153' },
	{ city: 'Keeloge South (Laois)', zip: '535962' },
	{ city: 'Keeloges Upper (Mayo)', zip: '180406' },
	{ city: 'Keeloges West (Galway)', zip: '159835' },
	{ city: 'Keeloge Upper (Wicklow)', zip: '534445' },
	{ city: 'Keelogyboy (Sligo)', zip: '623598' },
	{ city: 'Keelough Glebe (Laois)', zip: '129678' },
	{ city: 'Keelrin (Leitrim)', zip: '591463' },
	{ city: 'Keeltane (Cork)', zip: '515359' },
	{ city: 'Keelties (Kerry)', zip: '717394' },
	{ city: 'Keeltrasna (Cork)', zip: '495974' },
	{ city: 'Keelty (Clare)', zip: '604366' },
	{ city: 'Keelty (Roscommon)', zip: '294119' },
	{ city: 'Keelty (Sligo)', zip: '440063' },
	{ city: 'Keel West (Mayo)', zip: '841548' },
	{ city: 'Keely Island (Mayo)', zip: '654541' },
	{ city: 'Keem (Mayo)', zip: '752205' },
	{ city: 'Keenagh (Cavan)', zip: '988555' },
	{ city: 'Keenagh (Donegal)', zip: '235582' },
	{ city: 'Keenagh (Longford)', zip: '597913' },
	{ city: 'Keenagh (Roscommon)', zip: '945250' },
	{ city: 'Keenaghan (Cavan)', zip: '210082' },
	{ city: 'Keenaghan (Donegal)', zip: '604787' },
	{ city: 'Keenaghan (Galway)', zip: '354429' },
	{ city: 'Keenaghan (Leitrim)', zip: '920756' },
	{ city: 'Keenaghan (Meath)', zip: '265771' },
	{ city: 'Keenaghan (Sligo)', zip: '517216' },
	{ city: 'Keenagh Beg (Mayo)', zip: '665133' },
	{ city: 'Keenagh More (Mayo)', zip: '786067' },
	{ city: 'Keeneraboy (Monaghan)', zip: '442982' },
	{ city: 'Keenheen (Leitrim)', zip: '847701' },
	{ city: 'Keenleen (Cork)', zip: '774615' },
	{ city: 'Keenog (Monaghan)', zip: '618345' },
	{ city: 'Keenogbane (Monaghan)', zip: '660322' },
	{ city: 'Keenogduff (Monaghan)', zip: '902778' },
	{ city: 'Keenoge (Meath)', zip: '174293' },
	{ city: 'Keenoge (Monaghan)', zip: '163315' },
	{ city: 'Keenoge (Westmeath)', zip: '924008' },
	{ city: 'Keenrath (Cork)', zip: '461078' },
	{ city: 'Keeny (Cavan)', zip: '871140' },
	{ city: 'Keeran (Meath)', zip: '234999' },
	{ city: 'Keeranbane (Donegal)', zip: '626926' },
	{ city: 'Keeraunbeg (Galway)', zip: '722138' },
	{ city: 'Keeraunnagark North (Galway)', zip: '404449' },
	{ city: 'Keeraunnagark South (Galway)', zip: '165743' },
	{ city: 'Keereen Lower (Waterford)', zip: '529218' },
	{ city: 'Keereen Upper (Waterford)', zip: '954115' },
	{ city: 'Keerglen (Mayo)', zip: '793593' },
	{ city: 'Keerhan (Louth)', zip: '823540' },
	{ city: 'Keerhaunmore (Galway)', zip: '678407' },
	{ city: 'Keerhaun North (Galway)', zip: '941142' },
	{ city: 'Keerhaun South (Galway)', zip: '544583' },
	{ city: 'Keernaun (Galway)', zip: '936427' },
	{ city: 'Keevagh (Clare)', zip: '345064' },
	{ city: 'Keeverstown (Louth)', zip: '177238' },
	{ city: 'Keilagh (Cavan)', zip: '624745' },
	{ city: 'Keilnascarta (Cork)', zip: '472786' },
	{ city: 'Keiloge (Waterford)', zip: '489552' },
	{ city: 'Kellistown East (Carlow)', zip: '232879' },
	{ city: 'Kellistown West (Carlow)', zip: '794705' },
	{ city: 'Kells (Clare)', zip: '432679' },
	{ city: 'Kells (Kerry)', zip: '535274' },
	{ city: 'Kells (Kilkenny)', zip: '580426' },
	{ city: 'Kells (Limerick)', zip: '497206' },
	{ city: 'Kells (Meath)', zip: '838263' },
	{ city: 'Kellsborough (Kilkenny)', zip: '608118' },
	{ city: 'Kellsgrange (Kilkenny)', zip: '559825' },
	{ city: 'Kellybrook (Roscommon)', zip: '739933' },
	{ city: 'Kellybrook (Westmeath)', zip: '792297' },
	{ city: 'Kellymount (Kilkenny)', zip: '102825' },
	{ city: 'Kellysgrove (Galway)', zip: '436900' },
	{ city: "Kelly's Island (Galway)", zip: '876949' },
	{ city: "Kelly's Island North (Galway)", zip: '415382' },
	{ city: 'Kellysmeadow (Donegal)', zip: '228755' },
	{ city: 'Kellystown (Dublin)', zip: '184972' },
	{ city: 'Kellystown (Kildare)', zip: '543968' },
	{ city: 'Kellystown (Laois)', zip: '798200' },
	{ city: 'Kellystown (Louth)', zip: '885355' },
	{ city: 'Kellystown (Meath)', zip: '198242' },
	{ city: 'Kellystown (Wexford)', zip: '475170' },
	{ city: 'Kellystown (Wicklow)', zip: '317451' },
	{ city: 'Kellyville (Laois)', zip: '402566' },
	{ city: 'Kelsha (Wicklow)', zip: '121795' },
	{ city: 'Kelshabeg (Wicklow)', zip: '769237' },
	{ city: 'Kelshamore (Wicklow)', zip: '432051' },
	{ city: 'Kemmins Mill (Meath)', zip: '251602' },
	{ city: 'Kenmare (Kerry)', zip: '904658' },
	{ city: 'Kenmare Old (Kerry)', zip: '418745' },
	{ city: 'Kennaghstown (Meath)', zip: '245567' },
	{ city: 'Kennastown (Meath)', zip: '545090' },
	{ city: 'Kennel (Cork)', zip: '984102' },
	{ city: 'Kennetstown (Meath)', zip: '730978' },
	{ city: 'Kennyborough (Roscommon)', zip: '905846' },
	{ city: 'Kennycourt (Kildare)', zip: '752371' },
	{ city: 'Kennystown (Wicklow)', zip: '531545' },
	{ city: 'Kentfield (Galway)', zip: '793849' },
	{ city: 'Kentstown (Galway)', zip: '714329' },
	{ city: 'Kentstown (Meath)', zip: '926535' },
	{ city: 'Keoltown (Westmeath)', zip: '551973' },
	{ city: 'Keonbrook (Leitrim)', zip: '697864' },
	{ city: 'Kerane (Tipperary)', zip: '567721' },
	{ city: 'Keranstown (Donegal)', zip: '531133' },
	{ city: 'Keraun (Offaly)', zip: '641392' },
	{ city: 'Kerdiffstown (Kildare)', zip: '547983' },
	{ city: 'Kereight (Wexford)', zip: '924328' },
	{ city: 'Kerinstown And Balrowan (Westmeath)', zip: '698128' },
	{ city: 'Kerlagh (Roscommon)', zip: '955440' },
	{ city: 'Kerloge (Wexford)', zip: '110654' },
	{ city: 'Kernanstown (Carlow)', zip: '153328' },
	{ city: 'Kerries East (Kerry)', zip: '684728' },
	{ city: 'Kerries West (Kerry)', zip: '283212' },
	{ city: 'Kerrikyle (Limerick)', zip: '627636' },
	{ city: 'Kerrymount (Dublin)', zip: '944917' },
	{ city: 'Kesh (Sligo)', zip: '224927' },
	{ city: 'Keshcarrigan (Leitrim)', zip: '519706' },
	{ city: 'Keshends (Donegal)', zip: '112371' },
	{ city: 'Kevanstown North (Tipperary)', zip: '374181' },
	{ city: 'Kevanstown South (Tipperary)', zip: '219930' },
	{ city: 'Kevit Lower (Cavan)', zip: '900551' },
	{ city: 'Kevit Upper (Cavan)', zip: '355599' },
	{ city: 'Keyanna (Limerick)', zip: '620183' },
	{ city: 'Keyfield (Roscommon)', zip: '718902' },
	{ city: 'Keylong (Tipperary)', zip: '843466' },
	{ city: 'Kibberidog (Monaghan)', zip: '773752' },
	{ city: 'Kid Island (Mayo)', zip: '544632' },
	{ city: 'Kiernans Hill (Wicklow)', zip: '384022' },
	{ city: 'Kiffagh (Cavan)', zip: '802979' },
	{ city: 'Kihaska (Clare)', zip: '143654' },
	{ city: 'Kilaned (Donegal)', zip: '404129' },
	{ city: 'Kilbaha (Clare)', zip: '693084' },
	{ city: 'Kilbaha Middle (Kerry)', zip: '960860' },
	{ city: 'Kilbaha North (Clare)', zip: '604522' },
	{ city: 'Kilbaha North (Kerry)', zip: '144714' },
	{ city: 'Kilbaha South (Clare)', zip: '321050' },
	{ city: 'Kilbaha South (Kerry)', zip: '678414' },
	{ city: 'Kilbaha West (Kerry)', zip: '346336' },
	{ city: 'Kilballivor (Meath)', zip: '419794' },
	{ city: 'Kilballyboy (Tipperary)', zip: '199561' },
	{ city: 'Kilballycurrane (Cork)', zip: '102946' },
	{ city: 'Kilballygorman (Tipperary)', zip: '349963' },
	{ city: 'Kilballyhemikin (Tipperary)', zip: '173621' },
	{ city: 'Kilballyherberry (Tipperary)', zip: '205737' },
	{ city: 'Kilballyhue (Carlow)', zip: '176184' },
	{ city: 'Kilballykeefe (Kilkenny)', zip: '487572' },
	{ city: 'Kilballylahiff (Kerry)', zip: '473690' },
	{ city: 'Kilballyowen (Clare)', zip: '608247' },
	{ city: 'Kilballyowen (Limerick)', zip: '888843' },
	{ city: 'Kilballyowen (Wicklow)', zip: '768629' },
	{ city: 'Kilballyporter (Meath)', zip: '604470' },
	{ city: 'Kilballyquilty (Waterford)', zip: '156894' },
	{ city: 'Kilballyskea (Offaly)', zip: '172944' },
	{ city: 'Kilbalraherd (Westmeath)', zip: '664823' },
	{ city: 'Kilbane (Clare)', zip: '333139' },
	{ city: 'Kilbane (Cork)', zip: '112872' },
	{ city: 'Kilbane (Kerry)', zip: '820678' },
	{ city: 'Kilbane (Limerick)', zip: '790320' },
	{ city: 'Kilbannivane (Kerry)', zip: '595224' },
	{ city: 'Kilbarrack Lower (Dublin)', zip: '632416' },
	{ city: 'Kilbarrack Upper (Dublin)', zip: '420569' },
	{ city: 'Kilbarrahan (Cork)', zip: '742187' },
	{ city: 'Kilbarraree (Cork)', zip: '121183' },
	{ city: 'Kilbarrick (Dublin)', zip: '628476' },
	{ city: 'Kilbarron (Clare)', zip: '289642' },
	{ city: 'Kilbarron (Donegal)', zip: '886681' },
	{ city: 'Kilbarron (Tipperary)', zip: '362675' },
	{ city: 'Kilbarry (Cork)', zip: '463218' },
	{ city: 'Kilbarry (Roscommon)', zip: '495332' },
	{ city: 'Kilbarrymeaden (Waterford)', zip: '114344' },
	{ city: 'Kilbaylet Lower (Wicklow)', zip: '817074' },
	{ city: 'Kilbaylet Upper (Wicklow)', zip: '979163' },
	{ city: 'Kilbeacanty (Galway)', zip: '839654' },
	{ city: 'Kilbeg (Cork)', zip: '342285' },
	{ city: 'Kilbeg (Donegal)', zip: '259494' },
	{ city: 'Kilbeg (Galway)', zip: '258386' },
	{ city: 'Kilbeg (Kildare)', zip: '927514' },
	{ city: 'Kilbeg (Laois)', zip: '963861' },
	{ city: 'Kilbeg (Offaly)', zip: '932839' },
	{ city: 'Kilbeg (Roscommon)', zip: '234619' },
	{ city: 'Kilbeg (Tipperary)', zip: '906029' },
	{ city: 'Kilbeg (Waterford)', zip: '361877' },
	{ city: 'Kilbeg (Westmeath)', zip: '781076' },
	{ city: 'Kilbeg (Wicklow)', zip: '464388' },
	{ city: 'Kilbeg East (Kerry)', zip: '384505' },
	{ city: 'Kilbeg East (Limerick)', zip: '153940' },
	{ city: 'Kilbeggan (Westmeath)', zip: '358567' },
	{ city: 'Kilbeggan North (Westmeath)', zip: '491726' },
	{ city: 'Kilbeggan South (Westmeath)', zip: '572842' },
	{ city: 'Kilbeg Lower (Galway)', zip: '185820' },
	{ city: 'Kilbeg Lower (Meath)', zip: '344414' },
	{ city: 'Kilbeg Lower (Waterford)', zip: '997179' },
	{ city: 'Kilbegly (Roscommon)', zip: '307982' },
	{ city: 'Kilbeg-Malone (Mayo)', zip: '901924' },
	{ city: 'Kilbegnet (Roscommon)', zip: '687242' },
	{ city: 'Kilbegnet (Wexford)', zip: '373079' },
	{ city: 'Kilbeg North (Cork)', zip: '364171' },
	{ city: 'Kilbeg South (Cork)', zip: '609855' },
	{ city: 'Kilbeg Upper (Galway)', zip: '268113' },
	{ city: 'Kilbeg Upper (Meath)', zip: '756894' },
	{ city: 'Kilbeg Upper (Waterford)', zip: '589549' },
	{ city: 'Kilbeg West (Kerry)', zip: '678871' },
	{ city: 'Kilbeg West (Limerick)', zip: '177021' },
	{ city: 'Kilbeheny (Limerick)', zip: '237146' },
	{ city: 'Kilbehy (Limerick)', zip: '935106' },
	{ city: 'Kilbelin (Kildare)', zip: '216672' },
	{ city: 'Kilbeloge (Cork)', zip: '724746' },
	{ city: 'Kilberehert (Kerry)', zip: '781119' },
	{ city: 'Kilberrihert (Cork)', zip: '964985' },
	{ city: 'Kilberry (Kildare)', zip: '428675' },
	{ city: 'Kilberry (Meath)', zip: '771591' },
	{ city: 'Kilbillaghan (Westmeath)', zip: '932829' },
	{ city: 'Kilbiller (Tipperary)', zip: '837060' },
	{ city: 'Kilbixy (Westmeath)', zip: '603601' },
	{ city: 'Kilblaffer (Cork)', zip: '343448' },
	{ city: 'Kilbline (Kilkenny)', zip: '963125' },
	{ city: 'Kilboderry (Leitrim)', zip: '487833' },
	{ city: 'Kilboggan (Kildare)', zip: '189346' },
	{ city: 'Kilbogget (Dublin)', zip: '437707' },
	{ city: 'Kilboggoon (Clare)', zip: '788827' },
	{ city: 'Kilboght (Galway)', zip: '401607' },
	{ city: 'Kilboglashy (Sligo)', zip: '694669' },
	{ city: 'Kilbolane (Cork)', zip: '498523' },
	{ city: 'Kilbonane (Cork)', zip: '150448' },
	{ city: 'Kilbonane (Kerry)', zip: '804885' },
	{ city: 'Kilbora (Wexford)', zip: '504130' },
	{ city: 'Kilboultragh (Cork)', zip: '554477' },
	{ city: 'Kilboy (Cork)', zip: '569416' },
	{ city: 'Kilboy (Tipperary)', zip: '555720' },
	{ city: 'Kilboy (Wicklow)', zip: '530009' },
	{ city: 'Kilboyne (Meath)', zip: '379235' },
	{ city: 'Kilbrack (Cork)', zip: '608474' },
	{ city: 'Kilbrack (Waterford)', zip: '254164' },
	{ city: 'Kilbrackan (Laois)', zip: '385669' },
	{ city: 'Kilbrackan (Leitrim)', zip: '319441' },
	{ city: 'Kilbradran (Limerick)', zip: '403334' },
	{ city: 'Kilbragh (Tipperary)', zip: '866412' },
	{ city: 'Kilbraghan (Kilkenny)', zip: '524562' },
	{ city: 'Kilbraney (Wexford)', zip: '772980' },
	{ city: 'Kilbrannel (Tipperary)', zip: '958855' },
	{ city: 'Kilbrannish North (Carlow)', zip: '956752' },
	{ city: 'Kilbrannish South (Carlow)', zip: '689311' },
	{ city: 'Kilbrattan (Sligo)', zip: '331325' },
	{ city: 'Kilbraugh (Tipperary)', zip: '375226' },
	{ city: 'Kilbrean Beg (Kerry)', zip: '652508' },
	{ city: 'Kilbrean More (Kerry)', zip: '442863' },
	{ city: 'Kilbreckan (Clare)', zip: '410426' },
	{ city: 'Kilbreckstown (Meath)', zip: '721586' },
	{ city: 'Kilbree (Cork)', zip: '457490' },
	{ city: 'Kilbreedy (Laois)', zip: '212411' },
	{ city: 'Kilbreedy (Limerick)', zip: '444508' },
	{ city: 'Kilbreedy (Tipperary)', zip: '725064' },
	{ city: 'Kilbreedy East (Limerick)', zip: '648771' },
	{ city: 'Kilbreedy West (Limerick)', zip: '976786' },
	{ city: 'Kilbree East (Waterford)', zip: '143529' },
	{ city: 'Kilbree Lower (Mayo)', zip: '126059' },
	{ city: 'Kilbree Upper (Mayo)', zip: '428932' },
	{ city: 'Kilbree West (Waterford)', zip: '983198' },
	{ city: 'Kilbreffy (Wicklow)', zip: '634203' },
	{ city: 'Kilbrenan (Cork)', zip: '343274' },
	{ city: 'Kilbrenan (Mayo)', zip: '255157' },
	{ city: 'Kilbrennan (Westmeath)', zip: '772469' },
	{ city: 'Kilbrew (Meath)', zip: '712758' },
	{ city: 'Kilbrickan (Carlow)', zip: '594087' },
	{ city: 'Kilbrickan (Galway)', zip: '767085' },
	{ city: 'Kilbrickan (Kilkenny)', zip: '349774' },
	{ city: 'Kilbrickan (Laois)', zip: '524753' },
	{ city: 'Kilbrickane (Kerry)', zip: '155293' },
	{ city: 'Kilbrickane (Tipperary)', zip: '555220' },
	{ city: 'Kilbride (Carlow)', zip: '343085' },
	{ city: 'Kilbride (Cavan)', zip: '877120' },
	{ city: 'Kilbride (Dublin)', zip: '173855' },
	{ city: 'Kilbride (Galway)', zip: '560353' },
	{ city: 'Kilbride (Kildare)', zip: '977494' },
	{ city: 'Kilbride (Kilkenny)', zip: '645037' },
	{ city: 'Kilbride (Laois)', zip: '762240' },
	{ city: 'Kilbride (Longford)', zip: '262426' },
	{ city: 'Kilbride (Louth)', zip: '958819' },
	{ city: 'Kilbride (Mayo)', zip: '885542' },
	{ city: 'Kilbride (Meath)', zip: '744728' },
	{ city: 'Kilbride (Offaly)', zip: '452958' },
	{ city: 'Kilbride (Roscommon)', zip: '754140' },
	{ city: 'Kilbride (Westmeath)', zip: '286159' },
	{ city: 'Kilbride (Wexford)', zip: '355301' },
	{ city: 'Kilbride (Wicklow)', zip: '871685' },
	{ city: 'Kilbride Glebe (Kilkenny)', zip: '344706' },
	{ city: 'Kilbride North (Waterford)', zip: '288402' },
	{ city: 'Kilbride South (Waterford)', zip: '659426' },
	{ city: 'Kilbrien (Cork)', zip: '448494' },
	{ city: 'Kilbrin (Cork)', zip: '754748' },
	{ city: 'Kilbrittain (Cork)', zip: '857282' },
	{ city: 'Kilbrogan (Cork)', zip: '493572' },
	{ city: 'Kilbroney (Cork)', zip: '964179' },
	{ city: 'Kilbronoge (Cork)', zip: '688069' },
	{ city: 'Kilbrown (Cork)', zip: '340853' },
	{ city: 'Kilbryan (Roscommon)', zip: '374459' },
	{ city: 'Kilbryan Lower (Waterford)', zip: '433710' },
	{ city: 'Kilbryan Upper (Waterford)', zip: '221867' },
	{ city: 'Kilbunow (Kerry)', zip: '179228' },
	{ city: 'Kilburn (Cork)', zip: '547498' },
	{ city: 'Kilburn (Kerry)', zip: '986238' },
	{ city: 'Kilburry East (Tipperary)', zip: '830942' },
	{ city: 'Kilburry West (Tipperary)', zip: '180958' },
	{ city: 'Kilcaddan (Donegal)', zip: '830079' },
	{ city: 'Kilcahill (Galway)', zip: '158323' },
	{ city: 'Kilcaimin (Galway)', zip: '965388' },
	{ city: 'Kilcalf East (Waterford)', zip: '502577' },
	{ city: 'Kilcalfmountain (Waterford)', zip: '462668' },
	{ city: 'Kilcalf West (Waterford)', zip: '196015' },
	{ city: 'Kilcamin (Offaly)', zip: '428854' },
	{ city: 'Kilcanavee (Waterford)', zip: '785832' },
	{ city: 'Kilcandra (Wicklow)', zip: '198414' },
	{ city: 'Kilcannon (Waterford)', zip: '640213' },
	{ city: 'Kilcannon (Wexford)', zip: '257171' },
	{ city: 'Kilcanoran (Roscommon)', zip: '902058' },
	{ city: 'Kilcanway (Cork)', zip: '279200' },
	{ city: 'Kilcappagh (Offaly)', zip: '272852' },
	{ city: 'Kilcar (Donegal)', zip: '535433' },
	{ city: 'Kilcar (Roscommon)', zip: '261104' },
	{ city: 'Kilcaragh (Waterford)', zip: '744645' },
	{ city: 'Kilcarbery (Dublin)', zip: '908262' },
	{ city: 'Kilcarbry (Wexford)', zip: '306430' },
	{ city: 'Kilcarn (Meath)', zip: '497343' },
	{ city: 'Kilcarney Lower (Wicklow)', zip: '900354' },
	{ city: 'Kilcarney Upper (Wicklow)', zip: '455806' },
	{ city: 'Kilcarra Beg (Kerry)', zip: '635756' },
	{ city: 'Kilcarra East (Wicklow)', zip: '674615' },
	{ city: 'Kilcarragh (Clare)', zip: '340584' },
	{ city: 'Kilcarra More (Kerry)', zip: '956290' },
	{ city: 'Kilcarra West (Wicklow)', zip: '387799' },
	{ city: 'Kilcarren (Tipperary)', zip: '854531' },
	{ city: 'Kilcarrig (Carlow)', zip: '745202' },
	{ city: 'Kilcarroll (Clare)', zip: '744825' },
	{ city: 'Kilcarroon (Tipperary)', zip: '505344' },
	{ city: 'Kilcarrooraun (Galway)', zip: '987197' },
	{ city: 'Kilcarry (Carlow)', zip: '149729' },
	{ city: 'Kilcarton (Waterford)', zip: '447594' },
	{ city: 'Kilcarty (Meath)', zip: '257594' },
	{ city: 'Kilcasey (Donegal)', zip: '134837' },
	{ city: 'Kilcasey Lower (Wexford)', zip: '857406' },
	{ city: 'Kilcasey Upper (Wexford)', zip: '417305' },
	{ city: 'Kilcash (Roscommon)', zip: '671385' },
	{ city: 'Kilcash (Tipperary)', zip: '248475' },
	{ city: 'Kilcasheen (Clare)', zip: '432197' },
	{ city: 'Kilcashel (Donegal)', zip: '498512' },
	{ city: 'Kilcashel (Mayo)', zip: '958310' },
	{ city: 'Kilcashel (Wicklow)', zip: '810720' },
	{ city: 'Kilcaskan (Cork)', zip: '814649' },
	{ city: 'Kilcaskan North (Cork)', zip: '730588' },
	{ city: 'Kilcaskan South (Cork)', zip: '180022' },
	{ city: 'Kilcaskin (Limerick)', zip: '872976' },
	{ city: 'Kilcat (Sligo)', zip: '302127' },
	{ city: 'Kilcatherina (Westmeath)', zip: '940942' },
	{ city: 'Kilcatherine (Cork)', zip: '630243' },
	{ city: 'Kilcavan (Laois)', zip: '625382' },
	{ city: 'Kilcavan (Wexford)', zip: '492309' },
	{ city: 'Kilcavan Lower (Wexford)', zip: '195512' },
	{ city: 'Kilcavan Lower (Wicklow)', zip: '471800' },
	{ city: 'Kilcavan Upper (Wexford)', zip: '627371' },
	{ city: 'Kilcavan Upper (Wicklow)', zip: '520680' },
	{ city: 'Kilcawha (Cork)', zip: '398889' },
	{ city: 'Kilcaysan (Wexford)', zip: '139636' },
	{ city: 'Kilchreest (Galway)', zip: '742734' },
	{ city: 'Kilclammon (Wexford)', zip: '413116' },
	{ city: 'Kilclaran (Clare)', zip: '973950' },
	{ city: 'Kilclare (Leitrim)', zip: '639654' },
	{ city: 'Kilclare (Offaly)', zip: '588196' },
	{ city: 'Kilclarebeg (Leitrim)', zip: '181025' },
	{ city: 'Kilclareen (Tipperary)', zip: '654231' },
	{ city: 'Kilclare Lower (Cork)', zip: '656781' },
	{ city: 'Kilclaremore (Leitrim)', zip: '938784' },
	{ city: 'Kilclare Upper (Cork)', zip: '244310' },
	{ city: 'Kilcleagh (Westmeath)', zip: '724161' },
	{ city: 'Kilclehaun (Clare)', zip: '740600' },
	{ city: 'Kilcloggan (Wexford)', zip: '765733' },
	{ city: 'Kilcloggaun (Galway)', zip: '589537' },
	{ city: 'Kilclogh (Cork)', zip: '106226' },
	{ city: 'Kilclogh (Galway)', zip: '904461' },
	{ city: 'Kilclogha (Cavan)', zip: '620989' },
	{ city: 'Kilcloghan (Roscommon)', zip: '511315' },
	{ city: 'Kilcloghan (Westmeath)', zip: '539705' },
	{ city: 'Kilcloghans (Galway)', zip: '203726' },
	{ city: 'Kilclogherane (Kerry)', zip: '480119' },
	{ city: 'Kilclogherna (Roscommon)', zip: '474898' },
	{ city: 'Kilcloher (Clare)', zip: '644111' },
	{ city: 'Kilcloher (Waterford)', zip: '873043' },
	{ city: 'Kilclonagh (Tipperary)', zip: '108463' },
	{ city: 'Kilcloncorkry (Offaly)', zip: '789271' },
	{ city: 'Kilclone (Meath)', zip: '760772' },
	{ city: 'Kilcloney (Carlow)', zip: '548079' },
	{ city: 'Kilclonfert (Offaly)', zip: '210472' },
	{ city: 'Kilclooney (Cork)', zip: '645749' },
	{ city: 'Kilclooney (Waterford)', zip: '562531' },
	{ city: 'Kilclooney Beg (Donegal)', zip: '155171' },
	{ city: 'Kilclooney More (Donegal)', zip: '128574' },
	{ city: 'Kilcloony (Galway)', zip: '325307' },
	{ city: 'Kilcloran (Wexford)', zip: '533435' },
	{ city: 'Kilcoagh East (Wicklow)', zip: '428987' },
	{ city: 'Kilcoagh West (Wicklow)', zip: '171776' },
	{ city: 'Kilcock (Kildare)', zip: '254464' },
	{ city: 'Kilcock (Roscommon)', zip: '293643' },
	{ city: 'Kilcockan (Waterford)', zip: '108768' },
	{ city: 'Kilcock Lower (Kerry)', zip: '166496' },
	{ city: 'Kilcock Upper (Kerry)', zip: '541632' },
	{ city: 'Kilcoe (Cork)', zip: '312039' },
	{ city: 'Kilcogy (Cavan)', zip: '478570' },
	{ city: 'Kilcoilshy (Wexford)', zip: '567244' },
	{ city: 'Kilcoke (Laois)', zip: '513006' },
	{ city: 'Kilcoke (Tipperary)', zip: '732339' },
	{ city: 'Kilcolagh (Roscommon)', zip: '210222' },
	{ city: 'Kilcolgan (Galway)', zip: '351366' },
	{ city: 'Kilcolgan Beg (Offaly)', zip: '524542' },
	{ city: 'Kilcolgan Lower (Kerry)', zip: '424669' },
	{ city: 'Kilcolgan More (Offaly)', zip: '776924' },
	{ city: 'Kilcolgan Upper (Kerry)', zip: '567449' },
	{ city: 'Kilcollan (Kilkenny)', zip: '291304' },
	{ city: 'Kilcollin (Offaly)', zip: '994005' },
	{ city: 'Kilcolman (Cork)', zip: '721871' },
	{ city: 'Kilcolman (Kerry)', zip: '473420' },
	{ city: 'Kilcolman (Limerick)', zip: '500455' },
	{ city: 'Kilcolman (Mayo)', zip: '670099' },
	{ city: 'Kilcolman (Offaly)', zip: '383149' },
	{ city: 'Kilcolman (Roscommon)', zip: '285419' },
	{ city: 'Kilcolman (Tipperary)', zip: '950633' },
	{ city: 'Kilcolman (Waterford)', zip: '205965' },
	{ city: 'Kilcolmanbane (Laois)', zip: '853494' },
	{ city: 'Kilcolman East (Cork)', zip: '280092' },
	{ city: 'Kilcolman East (Limerick)', zip: '236179' },
	{ city: 'Kilcolman Middle (Cork)', zip: '730870' },
	{ city: 'Kilcolmanpark (Cork)', zip: '655358' },
	{ city: 'Kilcolman West (Cork)', zip: '432408' },
	{ city: 'Kilcolman West (Limerick)', zip: '318162' },
	{ city: 'Kilcolta (Cork)', zip: '903247' },
	{ city: 'Kilcoltrim (Carlow)', zip: '436901' },
	{ city: 'Kilcolumb (Clare)', zip: '955648' },
	{ city: 'Kilcolumb (Galway)', zip: '363594' },
	{ city: 'Kilcoman (Kerry)', zip: '957968' },
	{ city: 'Kilcomane (Cork)', zip: '207032' },
	{ city: 'Kilcomeragh (Waterford)', zip: '373682' },
	{ city: 'Kilcomin (Offaly)', zip: '356722' },
	{ city: 'Kilcommadan (Galway)', zip: '138731' },
	{ city: 'Kilcommock Glebe (Longford)', zip: '199269' },
	{ city: 'Kilcommon (Mayo)', zip: '769489' },
	{ city: 'Kilcommon (Tipperary)', zip: '940363' },
	{ city: 'Kilcommon Beg (Tipperary)', zip: '704013' },
	{ city: 'Kilcommon More (Tipperary)', zip: '362618' },
	{ city: 'Kilconane (Tipperary)', zip: '287343' },
	{ city: 'Kilcondy (Cork)', zip: '515123' },
	{ city: 'Kilconierin (Galway)', zip: '583620' },
	{ city: 'Kilconly (Galway)', zip: '343789' },
	{ city: 'Kilconly North (Kerry)', zip: '518918' },
	{ city: 'Kilconly South (Kerry)', zip: '302171' },
	{ city: 'Kilconnaught (Carlow)', zip: '256128' },
	{ city: 'Kilconnell (Clare)', zip: '441874' },
	{ city: 'Kilconnell (Donegal)', zip: '943498' },
	{ city: 'Kilconnell (Galway)', zip: '941334' },
	{ city: 'Kilconnell (Tipperary)', zip: '211865' },
	{ city: 'Kilconnelly (Kilkenny)', zip: '471553' },
	{ city: 'Kilconner (Carlow)', zip: '349778' },
	{ city: 'Kilconnib (Wexford)', zip: '195570' },
	{ city: 'Kilconnor (Cork)', zip: '145984' },
	{ city: 'Kilconny (Cavan)', zip: '844446' },
	{ city: 'Kilcoo (Kildare)', zip: '375695' },
	{ city: 'Kilcool (Limerick)', zip: '778469' },
	{ city: 'Kilcoolaght (Kerry)', zip: '334892' },
	{ city: 'Kilcoolaght East (Kerry)', zip: '124122' },
	{ city: 'Kilcoolaght West (Kerry)', zip: '668490' },
	{ city: 'Kilcoole (Carlow)', zip: '129540' },
	{ city: 'Kilcoole (Wicklow)', zip: '436044' },
	{ city: 'Kilcooley (Galway)', zip: '332319' },
	{ city: 'Kilcooley (Roscommon)', zip: '135102' },
	{ city: 'Kilcoolishal (Cork)', zip: '909639' },
	{ city: 'Kilcooly (Galway)', zip: '138343' },
	{ city: 'Kilcooly (Kerry)', zip: '278961' },
	{ city: 'Kilcooly (Meath)', zip: '739346' },
	{ city: 'Kilcoolyabbey (Tipperary)', zip: '147374' },
	{ city: 'Kilcooly North (Kerry)', zip: '409298' },
	{ city: 'Kilcooly South (Kerry)', zip: '570476' },
	{ city: 'Kilcoon (Leitrim)', zip: '490124' },
	{ city: 'Kilcoona (Galway)', zip: '408069' },
	{ city: 'Kilcooney (Clare)', zip: '834345' },
	{ city: 'Kilcooney (Offaly)', zip: '931044' },
	{ city: 'Kilcooney (Waterford)', zip: '603920' },
	{ city: 'Kilcoorha (Limerick)', zip: '557422' },
	{ city: 'Kilcoosh (Galway)', zip: '726239' },
	{ city: 'Kilcoosy (Leitrim)', zip: '588365' },
	{ city: 'Kilcop Lower (Waterford)', zip: '214421' },
	{ city: 'Kilcop Upper (Waterford)', zip: '330569' },
	{ city: 'Kilcoran (Laois)', zip: '461649' },
	{ city: 'Kilcoran (Tipperary)', zip: '691879' },
	{ city: 'Kilcoran North (Cork)', zip: '437249' },
	{ city: 'Kilcoran South (Cork)', zip: '170755' },
	{ city: 'Kilcorban (Galway)', zip: '773507' },
	{ city: 'Kilcorbry (Offaly)', zip: '632195' },
	{ city: 'Kilcorby (Cavan)', zip: '393345' },
	{ city: 'Kilcorcoran (Clare)', zip: '532650' },
	{ city: 'Kilcorkan (Clare)', zip: '964931' },
	{ city: 'Kilcorkey (Roscommon)', zip: '708517' },
	{ city: 'Kilcorkey (Wexford)', zip: '828207' },
	{ city: 'Kilcormac (Offaly)', zip: '208184' },
	{ city: 'Kilcormick (Wexford)', zip: '596287' },
	{ city: 'Kilcornan (Clare)', zip: '257184' },
	{ city: 'Kilcornan (Galway)', zip: '596012' },
	{ city: 'Kilcornan (Tipperary)', zip: '963176' },
	{ city: 'Kilcornan (Westmeath)', zip: '189637' },
	{ city: 'Kilcorney (Clare)', zip: '250902' },
	{ city: 'Kilcorney (Cork)', zip: '217027' },
	{ city: 'Kilcorney (Meath)', zip: '730693' },
	{ city: 'Kilcorney Glebe (Clare)', zip: '259169' },
	{ city: 'Kilcor North (Cork)', zip: '612896' },
	{ city: 'Kilcorral (Wexford)', zip: '279375' },
	{ city: 'Kilcorran (Monaghan)', zip: '927131' },
	{ city: 'Kilcor South (Cork)', zip: '418799' },
	{ city: 'Kilcosgrave (Limerick)', zip: '190102' },
	{ city: 'Kilcoskan (Dublin)', zip: '734277' },
	{ city: 'Kilcotton (Laois)', zip: '965706' },
	{ city: 'Kilcotty (Wexford)', zip: '666030' },
	{ city: 'Kilcotty Beg (Wexford)', zip: '837550' },
	{ city: 'Kilcotty More (Wexford)', zip: '610284' },
	{ city: 'Kilcounty (Cork)', zip: '664423' },
	{ city: 'Kilcourcey (Longford)', zip: '984105' },
	{ city: 'Kilcoursey (Offaly)', zip: '310897' },
	{ city: 'Kilcow (Kerry)', zip: '952112' },
	{ city: 'Kilcowan Lower (Wexford)', zip: '350904' },
	{ city: 'Kilcowan Upper (Wexford)', zip: '345269' },
	{ city: 'Kilcowran (Tipperary)', zip: '321389' },
	{ city: 'Kilcraggan (Kilkenny)', zip: '158055' },
	{ city: 'Kilcraheen (Cork)', zip: '543999' },
	{ city: 'Kilcran (Monaghan)', zip: '481680' },
	{ city: 'Kilcranathan (Cork)', zip: '462315' },
	{ city: 'Kilcrea (Cork)', zip: '788135' },
	{ city: 'Kilcrea (Dublin)', zip: '750851' },
	{ city: 'Kilcredan (Cork)', zip: '942717' },
	{ city: 'Kilcredaun (Clare)', zip: '572303' },
	{ city: 'Kilcreen (Donegal)', zip: '908500' },
	{ city: 'Kilcreen (Kerry)', zip: '516336' },
	{ city: 'Kilcreen (Kilkenny)', zip: '172831' },
	{ city: 'Kilcreen (Monaghan)', zip: '353682' },
	{ city: 'Kilcreevanty (Galway)', zip: '473096' },
	{ city: 'Kilcreevin (Sligo)', zip: '459482' },
	{ city: 'Kilcreggane (Waterford)', zip: '237354' },
	{ city: 'Kilcreman (Offaly)', zip: '840815' },
	{ city: 'Kilcrimple (Galway)', zip: '245618' },
	{ city: 'Kilcrin (Galway)', zip: '104771' },
	{ city: 'Kilcroe (Tipperary)', zip: '831815' },
	{ city: 'Kilcrohane (Cork)', zip: '261399' },
	{ city: 'Kilcronan (Cork)', zip: '235302' },
	{ city: 'Kilcronan (Laois)', zip: '980877' },
	{ city: 'Kilcronat (Cork)', zip: '565192' },
	{ city: 'Kilcronatmountain (Cork)', zip: '750549' },
	{ city: 'Kilcrone (Cork)', zip: '204127' },
	{ city: 'Kilcroney (Louth)', zip: '790775' },
	{ city: 'Kilcroney (Wicklow)', zip: '613716' },
	{ city: 'Kilcross (Kilkenny)', zip: '579184' },
	{ city: 'Kilcrossbeg (Cavan)', zip: '798775' },
	{ city: 'Kilcrossduff (Cavan)', zip: '128922' },
	{ city: 'Kilcrow (Galway)', zip: '135566' },
	{ city: 'Kilcrow (Kildare)', zip: '191602' },
	{ city: 'Kilcrow (Monaghan)', zip: '280519' },
	{ city: 'Kilcroy (Roscommon)', zip: '659840' },
	{ city: 'Kilcruaig (Limerick)', zip: '148102' },
	{ city: 'Kilcruise (Laois)', zip: '677817' },
	{ city: 'Kilcruit (Carlow)', zip: '461099' },
	{ city: 'Kilcruttin (Offaly)', zip: '916907' },
	{ city: 'Kilcullane (Limerick)', zip: '860949' },
	{ city: 'Kilculleen (Limerick)', zip: '960579' },
	{ city: 'Kilcullen (Kildare)', zip: '994522' },
	{ city: 'Kilcullen (Kilkenny)', zip: '458926' },
	{ city: 'Kilcullen (Wexford)', zip: '824515' },
	{ city: 'Kilcullenbridge (Kildare)', zip: '171175' },
	{ city: 'Kilcullen Lower (Waterford)', zip: '574818' },
	{ city: 'Kilcullen North (Cork)', zip: '290615' },
	{ city: 'Kilcullen South (Cork)', zip: '781884' },
	{ city: 'Kilcullen Upper (Waterford)', zip: '719388' },
	{ city: 'Kilcully (Cork)', zip: '384017' },
	{ city: 'Kilcumber (Monaghan)', zip: '672580' },
	{ city: 'Kilcumber (Offaly)', zip: '674030' },
	{ city: 'Kilcummer Lower (Cork)', zip: '846010' },
	{ city: 'Kilcummer Upper (Cork)', zip: '725409' },
	{ city: 'Kilcummin (Kerry)', zip: '677048' },
	{ city: 'Kilcummin (Mayo)', zip: '359140' },
	{ city: 'Kilcummin (Offaly)', zip: '332437' },
	{ city: 'Kilcummin (Sligo)', zip: '838602' },
	{ city: 'Kilcummin Beg (Kerry)', zip: '829635' },
	{ city: 'Kilcummin More (Kerry)', zip: '220771' },
	{ city: 'Kilcumney (Carlow)', zip: '196278' },
	{ city: 'Kilcumny (Westmeath)', zip: '690776' },
	{ city: 'Kilcumreragh (Westmeath)', zip: '635478' },
	{ city: 'Kilcunnahin Beg (Tipperary)', zip: '699772' },
	{ city: 'Kilcunnahin More (Tipperary)', zip: '553685' },
	{ city: 'Kilcurfin Glebe (Cork)', zip: '677456' },
	{ city: 'Kilcurkree (Tipperary)', zip: '357831' },
	{ city: 'Kilcurl (Kilkenny)', zip: '480091' },
	{ city: 'Kilcurley (Offaly)', zip: '417006' },
	{ city: 'Kilcurly (Limerick)', zip: '486234' },
	{ city: 'Kilcurly (Louth)', zip: '245024' },
	{ city: 'Kilcurrane East (Kerry)', zip: '810460' },
	{ city: 'Kilcurrane West (Kerry)', zip: '439850' },
	{ city: 'Kilcurrish (Clare)', zip: '773660' },
	{ city: 'Kilcurrivard (Galway)', zip: '515874' },
	{ city: 'Kilcurriv Eighter (Galway)', zip: '924195' },
	{ city: 'Kilcurry (Longford)', zip: '366415' },
	{ city: 'Kilcurry (Louth)', zip: '121969' },
	{ city: 'Kilcusnaun (Kerry)', zip: '877725' },
	{ city: 'Kildalkey (Meath)', zip: '505056' },
	{ city: 'Kildallan (Cavan)', zip: '125232' },
	{ city: 'Kildallan (Westmeath)', zip: '763038' },
	{ city: 'Kildallan North (Westmeath)', zip: '458156' },
	{ city: 'Kildalloge (Roscommon)', zip: '515618' },
	{ city: 'Kildalloo (Wexford)', zip: '318376' },
	{ city: 'Kildalton (Kilkenny)', zip: '243691' },
	{ city: 'Kildangan (Kildare)', zip: '736640' },
	{ city: 'Kildangan (Meath)', zip: '111326' },
	{ city: 'Kildangan (Offaly)', zip: '151724' },
	{ city: 'Kildanoge (Tipperary)', zip: '635587' },
	{ city: 'Kildare (Kildare)', zip: '676205' },
	{ city: 'Kildaree (Galway)', zip: '453206' },
	{ city: 'Kildaree (Mayo)', zip: '110731' },
	{ city: 'Kildarganmore (Sligo)', zip: '942287' },
	{ city: 'Kildarra (Cork)', zip: '703408' },
	{ city: 'Kildarra (Mayo)', zip: '172493' },
	{ city: 'Kildarragh (Donegal)', zip: '450330' },
	{ city: 'Kildavaroge (Mayo)', zip: '623767' },
	{ city: 'Kildavin (Carlow)', zip: '817137' },
	{ city: 'Kildavin (Clare)', zip: '287253' },
	{ city: 'Kildavin Lower (Wexford)', zip: '623260' },
	{ city: 'Kildavin Upper (Wexford)', zip: '441909' },
	{ city: 'Kilday (Wicklow)', zip: '103287' },
	{ city: 'Kildee (Cork)', zip: '902375' },
	{ city: 'Kildeema (Clare)', zip: '909797' },
	{ city: 'Kildeema North (Clare)', zip: '551661' },
	{ city: 'Kildeema South (Clare)', zip: '837129' },
	{ city: 'Kildellig (Laois)', zip: '359517' },
	{ city: 'Kildermody (Waterford)', zip: '798526' },
	{ city: 'Kildermot (Mayo)', zip: '533066' },
	{ city: 'Kildermot (Wexford)', zip: '278498' },
	{ city: 'Kilderreen (Longford)', zip: '259895' },
	{ city: 'Kilderrig (Cork)', zip: '732596' },
	{ city: 'Kilderriheen (Waterford)', zip: '662804' },
	{ city: 'Kilderry (Kilkenny)', zip: '285012' },
	{ city: 'Kilderry (Limerick)', zip: '905261' },
	{ city: 'Kilderry (Wexford)', zip: '269510' },
	{ city: 'Kilderry North (Kerry)', zip: '444632' },
	{ city: 'Kilderry South (Kerry)', zip: '112756' },
	{ city: 'Kildimo (Limerick)', zip: '462450' },
	{ city: 'Kildimo New (Limerick)', zip: '356179' },
	{ city: 'Kildimo Old (Limerick)', zip: '633736' },
	{ city: 'Kildinan (Cork)', zip: '510115' },
	{ city: 'Kildoagh (Cavan)', zip: '435353' },
	{ city: 'Kildoagh (Monaghan)', zip: '299817' },
	{ city: 'Kildonan (Dublin)', zip: '197928' },
	{ city: 'Kildoney Glebe (Donegal)', zip: '235568' },
	{ city: 'Kildonnell (Limerick)', zip: '305292' },
	{ city: 'Kildoo (Leitrim)', zip: '431477' },
	{ city: 'Kildoon (Kildare)', zip: '686665' },
	{ city: 'Kildoorus (Clare)', zip: '378652' },
	{ city: 'Kildordan (Longford)', zip: '644163' },
	{ city: 'Kildorragh (Leitrim)', zip: '825688' },
	{ city: 'Kildorragh Glebe (Cavan)', zip: '378449' },
	{ city: 'Kildorrery (Cork)', zip: '261309' },
	{ city: 'Kildotia (Mayo)', zip: '163962' },
	{ city: 'Kildreelig (Kerry)', zip: '699456' },
	{ city: 'Kildreenagh (Carlow)', zip: '377720' },
	{ city: 'Kildrimeen (Wexford)', zip: '197852' },
	{ city: 'Kildrinagh (Kilkenny)', zip: '649057' },
	{ city: 'Kildrinagh (Laois)', zip: '385819' },
	{ city: 'Kildromalive (Cork)', zip: '409860' },
	{ city: 'Kildromin (Limerick)', zip: '389558' },
	{ city: 'Kildroughtaun (Waterford)', zip: '552273' },
	{ city: 'Kildrum (Clare)', zip: '846404' },
	{ city: 'Kildrum (Cork)', zip: '264096' },
	{ city: 'Kildrum (Galway)', zip: '911735' },
	{ city: 'Kildrum Lower (Donegal)', zip: '146347' },
	{ city: 'Kildrumman (Offaly)', zip: '380735' },
	{ city: 'Kildrummy (Kilkenny)', zip: '998736' },
	{ city: 'Kildrum Upper (Donegal)', zip: '954554' },
	{ city: 'Kilduane (Waterford)', zip: '296466' },
	{ city: 'Kilduff (Cavan)', zip: '422671' },
	{ city: 'Kilduff (Kerry)', zip: '453411' },
	{ city: 'Kilduff (Limerick)', zip: '869624' },
	{ city: 'Kilduff (Offaly)', zip: '623791' },
	{ city: 'Kilduff (Tipperary)', zip: '766157' },
	{ city: 'Kilduffahoo (Limerick)', zip: '713593' },
	{ city: 'Kilduff Lower (Cavan)', zip: '591063' },
	{ city: 'Kilduff Lower (Clare)', zip: '295801' },
	{ city: 'Kilduff Middle (Cavan)', zip: '569694' },
	{ city: 'Kilduff Middle (Clare)', zip: '905232' },
	{ city: 'Kilduff Upper (Cavan)', zip: '191601' },
	{ city: 'Kilduff Upper (Clare)', zip: '937219' },
	{ city: 'Kildun (Mayo)', zip: '353994' },
	{ city: 'Kildun Beg (Mayo)', zip: '801547' },
	{ city: 'Kildun More (Mayo)', zip: '994743' },
	{ city: 'Kildurney (Roscommon)', zip: '270390' },
	{ city: 'Kildurrihy East (Kerry)', zip: '966000' },
	{ city: 'Kildurrihy West (Kerry)', zip: '845276' },
	{ city: 'Kileroe (Tipperary)', zip: '192242' },
	{ city: 'Kilfadda (Tipperary)', zip: '212892' },
	{ city: 'Kilfadda Beg (Kerry)', zip: '774146' },
	{ city: 'Kilfadda More (Kerry)', zip: '634439' },
	{ city: 'Kilfadeen (Cork)', zip: '135195' },
	{ city: 'Kilfahavon (Monaghan)', zip: '634781' },
	{ city: 'Kilfallinga (Kerry)', zip: '911581' },
	{ city: 'Kilfane Demesne (Kilkenny)', zip: '911031' },
	{ city: 'Kilfane East (Kilkenny)', zip: '775733' },
	{ city: 'Kilfane West (Kilkenny)', zip: '899478' },
	{ city: 'Kilfannan (Meath)', zip: '267449' },
	{ city: 'Kilfarboy (Clare)', zip: '796365' },
	{ city: 'Kilfarnoge (Kerry)', zip: '719864' },
	{ city: 'Kilfarrasy (Waterford)', zip: '332798' },
	{ city: 'Kilfaughna (Roscommon)', zip: '137839' },
	{ city: 'Kilfaughny (Westmeath)', zip: '580053' },
	{ city: 'Kilfaul (Mayo)', zip: '324811' },
	{ city: 'Kilfea (Mayo)', zip: '654493' },
	{ city: 'Kilfeacle (Laois)', zip: '460015' },
	{ city: 'Kilfeakle (Tipperary)', zip: '903183' },
	{ city: 'Kilfeakle Churchquarter (Tipperary)', zip: '776559' },
	{ city: 'Kilfearagh (Clare)', zip: '580650' },
	{ city: 'Kilfeighny North (Kerry)', zip: '974700' },
	{ city: 'Kilfeighny South (Kerry)', zip: '280458' },
	{ city: 'Kilfeilim (Clare)', zip: '737658' },
	{ city: 'Kilfelim (Kerry)', zip: '147309' },
	{ city: 'Kilfelligy (Galway)', zip: '344024' },
	{ city: 'Kilfenora (Clare)', zip: '242464' },
	{ city: 'Kilfenora (Kerry)', zip: '188095' },
	{ city: 'Kilferagh (Kilkenny)', zip: '790844' },
	{ city: 'Kilfergus (Limerick)', zip: '550704' },
	{ city: 'Kilfinnan (Cork)', zip: '450478' },
	{ city: 'Kilfinnane (Limerick)', zip: '228290' },
	{ city: 'Kilfinny (Limerick)', zip: '963729' },
	{ city: 'Kilfintan (Longford)', zip: '432790' },
	{ city: 'Kilfintan Lower (Longford)', zip: '483913' },
	{ city: 'Kilfithmone (Tipperary)', zip: '547716' },
	{ city: 'Kilflyn (Kerry)', zip: '992883' },
	{ city: 'Kilfountan (Kerry)', zip: '577519' },
	{ city: 'Kilfoylan (Offaly)', zip: '348442' },
	{ city: 'Kilfrancis (Offaly)', zip: '876205' },
	{ city: 'Kilfree (Sligo)', zip: '298933' },
	{ city: 'Kilfrush (Limerick)', zip: '560170' },
	{ city: 'Kilgabriel (Waterford)', zip: '494173' },
	{ city: 'Kilgainy Lower (Waterford)', zip: '176499' },
	{ city: 'Kilgainy Upper (Waterford)', zip: '150835' },
	{ city: 'Kilgalligan (Mayo)', zip: '576634' },
	{ city: 'Kilgar (Westmeath)', zip: '244572' },
	{ city: 'Kilgaroan (Westmeath)', zip: '929840' },
	{ city: 'Kilgarran (Wicklow)', zip: '590550' },
	{ city: 'Kilgarriff (Cork)', zip: '791179' },
	{ city: 'Kilgarriff (Galway)', zip: '866221' },
	{ city: 'Kilgarriff (Leitrim)', zip: '684132' },
	{ city: 'Kilgarriff (Limerick)', zip: '849754' },
	{ city: 'Kilgarriff (Mayo)', zip: '608256' },
	{ city: 'Kilgarriff North (Galway)', zip: '863572' },
	{ city: 'Kilgarriff South (Galway)', zip: '538124' },
	{ city: 'Kilgarriff West (Mayo)', zip: '760812' },
	{ city: 'Kilgarriv (Kerry)', zip: '445793' },
	{ city: 'Kilgarvan (Cork)', zip: '772983' },
	{ city: 'Kilgarvan (Kerry)', zip: '871293' },
	{ city: 'Kilgarvan (Mayo)', zip: '735672' },
	{ city: 'Kilgarvan (Tipperary)', zip: '612560' },
	{ city: 'Kilgarvan (Westmeath)', zip: '346458' },
	{ city: 'Kilgarvan (Wexford)', zip: '259107' },
	{ city: 'Kilgarvan Glebe (Westmeath)', zip: '404913' },
	{ city: 'Kilgarve (Cavan)', zip: '540036' },
	{ city: 'Kilgarve (Galway)', zip: '128192' },
	{ city: 'Kilgarve (Mayo)', zip: '485847' },
	{ city: 'Kilgarve (Roscommon)', zip: '895695' },
	{ city: 'Kilgarve North (Galway)', zip: '137309' },
	{ city: 'Kilgarve South (Galway)', zip: '466474' },
	{ city: 'Kilgask (Tipperary)', zip: '118234' },
	{ city: 'Kilgawny (Westmeath)', zip: '242559' },
	{ city: 'Kilgeever (Mayo)', zip: '826194' },
	{ city: 'Kilgellia (Mayo)', zip: '194825' },
	{ city: 'Kilgerrill (Galway)', zip: '199725' },
	{ city: 'Kilgevrin (Galway)', zip: '727403' },
	{ city: 'Kilgibbon (Wexford)', zip: '243415' },
	{ city: 'Kilgilky North (Cork)', zip: '447054' },
	{ city: 'Kilgilky South (Cork)', zip: '111012' },
	{ city: 'Kilgill (Galway)', zip: '854824' },
	{ city: 'Kilglass (Galway)', zip: '916461' },
	{ city: 'Kilglass (Kildare)', zip: '487822' },
	{ city: 'Kilglass (Limerick)', zip: '635878' },
	{ city: 'Kilglass (Roscommon)', zip: '967672' },
	{ city: 'Kilglass (Sligo)', zip: '793830' },
	{ city: 'Kilglassan (Mayo)', zip: '906455' },
	{ city: 'Kilglass And Cloonagh (Longford)', zip: '329317' },
	{ city: 'Kilglassy (Clare)', zip: '515627' },
	{ city: 'Kilglin (Meath)', zip: '847051' },
	{ city: 'Kilgobban (Clare)', zip: '646756' },
	{ city: 'Kilgobban (Cork)', zip: '276836' },
	{ city: 'Kilgobban (Mayo)', zip: '445221' },
	{ city: 'Kilgobbin (Cork)', zip: '907756' },
	{ city: 'Kilgobbin (Dublin)', zip: '168160' },
	{ city: 'Kilgobbin (Limerick)', zip: '580816' },
	{ city: 'Kilgobnet (Cork)', zip: '150536' },
	{ city: 'Kilgobnet (Kerry)', zip: '255415' },
	{ city: 'Kilgobnet (Waterford)', zip: '393256' },
	{ city: 'Kilgolagh (Cavan)', zip: '781755' },
	{ city: 'Kilgolan Lower (Offaly)', zip: '959746' },
	{ city: 'Kilgolan Upper (Offaly)', zip: '470417' },
	{ city: 'Kilgolban (Limerick)', zip: '787769' },
	{ city: 'Kilgole (Donegal)', zip: '859722' },
	{ city: 'Kilgoly (Donegal)', zip: '488181' },
	{ city: 'Kilgorman (Wexford)', zip: '780522' },
	{ city: 'Kilgormly (Monaghan)', zip: '979147' },
	{ city: 'Kilgort (Donegal)', zip: '934847' },
	{ city: 'Kilgortaree (Kerry)', zip: '493549' },
	{ city: 'Kilgorteen (Tipperary)', zip: '576080' },
	{ city: 'Kilgortin (Offaly)', zip: '368095' },
	{ city: 'Kilgory (Clare)', zip: '556425' },
	{ city: 'Kilgory (Laois)', zip: '695181' },
	{ city: 'Kilgowan (Kildare)', zip: '812952' },
	{ city: 'Kilgraffy (Roscommon)', zip: '992403' },
	{ city: 'Kilgraigue (Meath)', zip: '347740' },
	{ city: 'Kilgraney (Carlow)', zip: '418492' },
	{ city: 'Kilgreana (Limerick)', zip: '298874' },
	{ city: 'Kilgreana (Mayo)', zip: '287065' },
	{ city: 'Kilgreany (Waterford)', zip: '238050' },
	{ city: 'Kilgrellane (Cork)', zip: '269296' },
	{ city: 'Kilgrogan (Cork)', zip: '677566' },
	{ city: 'Kilgrogan (Limerick)', zip: '301285' },
	{ city: 'Kilgrogy Beg (Tipperary)', zip: '567038' },
	{ city: 'Kilgrogy More (Tipperary)', zip: '972481' },
	{ city: 'Kilgrovan (Waterford)', zip: '278934' },
	{ city: 'Kilgulbin East (Kerry)', zip: '968221' },
	{ city: 'Kilgulbin West (Kerry)', zip: '177901' },
	{ city: 'Kilgullane (Cork)', zip: '305972' },
	{ city: 'Kilhale (Mayo)', zip: '108380' },
	{ city: 'Kilheffernan (Tipperary)', zip: '294172' },
	{ city: 'Kilhile (Wexford)', zip: '805314' },
	{ city: 'Kilhonerush (Galway)', zip: '618640' },
	{ city: 'Kilhugh (Westmeath)', zip: '320245' },
	{ city: 'Kilinkere (Cavan)', zip: '295570' },
	{ city: 'Kiljames Lower (Kilkenny)', zip: '231635' },
	{ city: 'Kiljames Upper (Kilkenny)', zip: '920462' },
	{ city: 'Kilkea (Kildare)', zip: '132011' },
	{ city: 'Kilkea Demesne (Kildare)', zip: '415676' },
	{ city: 'Kilkea Lodge Farm (Kildare)', zip: '417632' },
	{ city: 'Kilkea Lower (Kildare)', zip: '673890' },
	{ city: 'Kilkeana (Kerry)', zip: '402576' },
	{ city: 'Kilkeany (Waterford)', zip: '109815' },
	{ city: 'Kilkeanymountain (Waterford)', zip: '773672' },
	{ city: 'Kilkeary (Tipperary)', zip: '126035' },
	{ city: 'Kilkeaskin (Kildare)', zip: '112639' },
	{ city: 'Kilkeasy (Kilkenny)', zip: '386680' },
	{ city: 'Kilkea Upper (Kildare)', zip: '472546' },
	{ city: 'Kilkeaveragh (Kerry)', zip: '327313' },
	{ city: 'Kilkee (Clare)', zip: '414525' },
	{ city: 'Kilkee East (Clare)', zip: '402859' },
	{ city: 'Kilkeehagh (Kerry)', zip: '387663' },
	{ city: 'Kilkeelan (Meath)', zip: '512320' },
	{ city: 'Kilkee Lower (Clare)', zip: '952924' },
	{ city: 'Kilkeeran (Mayo)', zip: '277439' },
	{ city: 'Kilkeeran (Meath)', zip: '624281' },
	{ city: 'Kilkeeran (Offaly)', zip: '860425' },
	{ city: 'Kilkeeran (Roscommon)', zip: '940016' },
	{ city: 'Kilkee Upper (Clare)', zip: '733754' },
	{ city: 'Kilkee West (Clare)', zip: '984504' },
	{ city: 'Kilkelly (Mayo)', zip: '239781' },
	{ city: 'Kilkenny (Donegal)', zip: '624560' },
	{ city: 'Kilkenny (Kilkenny)', zip: '174763' },
	{ city: 'Kilkenny (Mayo)', zip: '617476' },
	{ city: 'Kilkenny (Roscommon)', zip: '260984' },
	{ city: 'Kilkenny Abbey (Westmeath)', zip: '607647' },
	{ city: 'Kilkennybeg (Tipperary)', zip: '389455' },
	{ city: 'Kilkenny Lanesborough (Westmeath)', zip: '910771' },
	{ city: 'Kilkenny West (Westmeath)', zip: '354088' },
	{ city: 'Kilkeran (Cork)', zip: '306985' },
	{ city: 'Kilkere (Sligo)', zip: '375129' },
	{ city: 'Kilkerin (Clare)', zip: '590380' },
	{ city: 'Kilkerran North (Cork)', zip: '569941' },
	{ city: 'Kilkerran South (Cork)', zip: '275500' },
	{ city: 'Kilkerrin (Galway)', zip: '816216' },
	{ city: 'Kilkerry (Kerry)', zip: '122125' },
	{ city: 'Kilkey (Carlow)', zip: '378512' },
	{ city: 'Kilkieran (Clare)', zip: '658229' },
	{ city: 'Kilkieran (Galway)', zip: '931250' },
	{ city: 'Kilkieran (Kilkenny)', zip: '839194' },
	{ city: 'Kilkillahara (Tipperary)', zip: '400761' },
	{ city: 'Kilkilleen (Cork)', zip: '351287' },
	{ city: 'Kilkilloge (Sligo)', zip: '963794' },
	{ city: 'Kilkilvery (Galway)', zip: '612744' },
	{ city: 'Kilkinlea Lower (Limerick)', zip: '502129' },
	{ city: 'Kilkinlea Upper (Limerick)', zip: '943954' },
	{ city: 'Kilkinnikin East (Cork)', zip: '252818' },
	{ city: 'Kilkinnikin West (Cork)', zip: '768993' },
	{ city: 'Kilkip East (Tipperary)', zip: '679441' },
	{ city: 'Kilkip West (Tipperary)', zip: '957987' },
	{ city: 'Kilkishen (Clare)', zip: '257739' },
	{ city: 'Kilkishen Demesne (Clare)', zip: '452820' },
	{ city: 'Kilkit (Monaghan)', zip: '811594' },
	{ city: 'Kilkittaun (Clare)', zip: '485432' },
	{ city: 'Kilkneedan (Kerry)', zip: '699022' },
	{ city: 'Kilknock (Carlow)', zip: '733446' },
	{ city: 'Kilknock (Mayo)', zip: '936595' },
	{ city: 'Kilknockan (Cork)', zip: '684489' },
	{ city: 'Kilknockan (Limerick)', zip: '402252' },
	{ city: 'Kilknockan (Tipperary)', zip: '686027' },
	{ city: 'Kilknockan (Waterford)', zip: '270670' },
	{ city: 'Kilknockane (Cork)', zip: '883408' },
	{ city: 'Kill (Cavan)', zip: '927714' },
	{ city: 'Kill (Cork)', zip: '466321' },
	{ city: 'Kill (Donegal)', zip: '505920' },
	{ city: 'Kill (Galway)', zip: '486294' },
	{ city: 'Kill (Kerry)', zip: '678073' },
	{ city: 'Kill (Kildare)', zip: '616267' },
	{ city: 'Kill (Kilkenny)', zip: '554693' },
	{ city: 'Kill (Mayo)', zip: '762036' },
	{ city: 'Kill (Waterford)', zip: '883716' },
	{ city: 'Kill (Westmeath)', zip: '811658' },
	{ city: 'Kill (Wicklow)', zip: '897966' },
	{ city: 'Killaan (Galway)', zip: '706042' },
	{ city: 'Killabban (Laois)', zip: '362429' },
	{ city: 'Killabeg (Wexford)', zip: '211527' },
	{ city: 'Killabeg (Wicklow)', zip: '349406' },
	{ city: 'Killabraher North (Cork)', zip: '125853' },
	{ city: 'Killabraher South (Cork)', zip: '103242' },
	{ city: 'Killabrick (Monaghan)', zip: '631036' },
	{ city: 'Killabunane (Kerry)', zip: '939502' },
	{ city: 'Killabuonia (Kerry)', zip: '901301' },
	{ city: 'Killachonna (Westmeath)', zip: '813712' },
	{ city: 'Killachunna (Galway)', zip: '932790' },
	{ city: 'Killaclare (Mayo)', zip: '956598' },
	{ city: 'Killaclogher (Galway)', zip: '559983' },
	{ city: 'Killaclohane (Kerry)', zip: '197800' },
	{ city: 'Killacloran (Wicklow)', zip: '155668' },
	{ city: 'Killacloyne (Cork)', zip: '542395' },
	{ city: 'Killaclug (Cork)', zip: '253929' },
	{ city: 'Killaclug East (Cork)', zip: '330446' },
	{ city: 'Killaclug West (Cork)', zip: '452088' },
	{ city: 'Killacolla (Limerick)', zip: '737736' },
	{ city: 'Killaconin (Meath)', zip: '779362' },
	{ city: 'Killaconner (Louth)', zip: '214881' },
	{ city: 'Killaconnigan (Meath)', zip: '513417' },
	{ city: 'Killacoosane (Cork)', zip: '691134' },
	{ city: 'Killacorraun (Mayo)', zip: '323334' },
	{ city: 'Killacrim (Kerry)', zip: '901885' },
	{ city: 'Killacroy (Meath)', zip: '213336' },
	{ city: 'Killaculleen (Limerick)', zip: '629426' },
	{ city: 'Killadangan (Mayo)', zip: '292767' },
	{ city: 'Killadangan (Roscommon)', zip: '804085' },
	{ city: 'Killadangan (Tipperary)', zip: '992511' },
	{ city: 'Killadangan (Waterford)', zip: '376723' },
	{ city: 'Killadden (Meath)', zip: '880623' },
	{ city: 'Killadeer (Mayo)', zip: '994022' },
	{ city: 'Killaderry (Clare)', zip: '941631' },
	{ city: 'Killaderry (Cork)', zip: '390000' },
	{ city: 'Killaderry (Galway)', zip: '976396' },
	{ city: 'Killaderry (Offaly)', zip: '899617' },
	{ city: 'Killadiskert (Leitrim)', zip: '505490' },
	{ city: 'Killadooley (Laois)', zip: '806412' },
	{ city: 'Killadoon (Kildare)', zip: '401367' },
	{ city: 'Killadoon (Mayo)', zip: '708780' },
	{ city: 'Killadoon (Sligo)', zip: '437876' },
	{ city: 'Killadough (Leitrim)', zip: '984859' },
	{ city: 'Killadoughran (Westmeath)', zip: '518677' },
	{ city: 'Killadreenan (Wicklow)', zip: '834581' },
	{ city: 'Killadrown (Offaly)', zip: '502032' },
	{ city: 'Killaduff (Wicklow)', zip: '804130' },
	{ city: 'Killadullisk (Galway)', zip: '450173' },
	{ city: 'Killadysert (Clare)', zip: '521492' },
	{ city: 'Killafeen (Galway)', zip: '831928' },
	{ city: 'Killag (Wexford)', zip: '111800' },
	{ city: 'Killagally Glebe (Offaly)', zip: '292980' },
	{ city: 'Killagh (Westmeath)', zip: '796529' },
	{ city: 'Killaghaduff (Cavan)', zip: '129431' },
	{ city: 'Killaghaun (Galway)', zip: '618060' },
	{ city: 'Killagh Beg (Galway)', zip: '547173' },
	{ city: 'Killaghintober (Offaly)', zip: '778518' },
	{ city: 'Killagh More (Galway)', zip: '248448' },
	{ city: 'Killaghoor (Mayo)', zip: '393290' },
	{ city: 'Killaghtee (Donegal)', zip: '937811' },
	{ city: 'Killaghteen (Limerick)', zip: '869270' },
	{ city: 'Killaghwaun (Mayo)', zip: '427800' },
	{ city: 'Killaghy (Tipperary)', zip: '183370' },
	{ city: 'Killaglasheen (Leitrim)', zip: '349283' },
	{ city: 'Killaglish (Laois)', zip: '162524' },
	{ city: 'Killagoley (Wexford)', zip: '709973' },
	{ city: 'Killagoola (Galway)', zip: '527985' },
	{ city: 'Killagowan (Wexford)', zip: '217299' },
	{ city: 'Killagrohan (Cork)', zip: '993525' },
	{ city: 'Killaguile (Galway)', zip: '889945' },
	{ city: 'Killagurteen (Kerry)', zip: '247616' },
	{ city: 'Killaha (Kerry)', zip: '582706' },
	{ city: 'Killaha East (Kerry)', zip: '868100' },
	{ city: 'Killahagan (Tipperary)', zip: '336705' },
	{ city: 'Killahaly East (Waterford)', zip: '406785' },
	{ city: 'Killahaly West (Waterford)', zip: '840945' },
	{ city: 'Killahan (Kerry)', zip: '647085' },
	{ city: 'Killahane (Cork)', zip: '976809' },
	{ city: 'Killahane (Kerry)', zip: '449526' },
	{ city: 'Killahara (Tipperary)', zip: '964741' },
	{ city: 'Killahard (Wexford)', zip: '604120' },
	{ city: 'Killaha West (Kerry)', zip: '944431' },
	{ city: 'Killahora (Cork)', zip: '728211' },
	{ city: 'Killahugh (Westmeath)', zip: '905186' },
	{ city: 'Killahurk (Leitrim)', zip: '788493' },
	{ city: 'Killahurler Lower (Wicklow)', zip: '424291' },
	{ city: 'Killahurler Upper (Wicklow)', zip: '755119' },
	{ city: 'Killahy (Kilkenny)', zip: '178377' },
	{ city: 'Killaidamee (Tipperary)', zip: '905612' },
	{ city: 'Killakane (Cork)', zip: '683805' },
	{ city: 'Killakeady (Monaghan)', zip: '402945' },
	{ city: 'Killakee (Dublin)', zip: '821778' },
	{ city: 'Killala (Mayo)', zip: '412743' },
	{ city: 'Killala (Sligo)', zip: '273891' },
	{ city: 'Killalane (Dublin)', zip: '556912' },
	{ city: 'Killalane (Tipperary)', zip: '435890' },
	{ city: 'Killalea (Westmeath)', zip: '808635' },
	{ city: 'Killalee (Kerry)', zip: '390752' },
	{ city: 'Killaleen (Leitrim)', zip: '709534' },
	{ city: 'Killalish Lower (Wicklow)', zip: '768077' },
	{ city: 'Killalish Upper (Wicklow)', zip: '435207' },
	{ city: 'Killaliss (Cavan)', zip: '333716' },
	{ city: 'Killallaghtan (Galway)', zip: '561346' },
	{ city: 'Killalligan North (Wexford)', zip: '486031' },
	{ city: 'Killalligan South (Wexford)', zip: '594169' },
	{ city: 'Killally (Kerry)', zip: '468489' },
	{ city: 'Killally (Louth)', zip: '748769' },
	{ city: 'Killally East (Cork)', zip: '410268' },
	{ city: 'Killally West (Cork)', zip: '186339' },
	{ city: 'Killaloan Lower (Tipperary)', zip: '446619' },
	{ city: 'Killaloan Upper (Tipperary)', zip: '637127' },
	{ city: 'Killaloe (Clare)', zip: '583989' },
	{ city: 'Killaloe (Kilkenny)', zip: '422055' },
	{ city: 'Killalongford (Carlow)', zip: '384647' },
	{ city: 'Killalooghan (Laois)', zip: '725318' },
	{ city: 'Killaloonty (Galway)', zip: '228138' },
	{ city: 'Killalough (Cork)', zip: '457572' },
	{ city: 'Killaltanagh (Galway)', zip: '798441' },
	{ city: 'Killamanagh (Galway)', zip: '112372' },
	{ city: 'Killamaster (Carlow)', zip: '281524' },
	{ city: 'Killamaun (Leitrim)', zip: '247457' },
	{ city: 'Killameen (Leitrim)', zip: '264544' },
	{ city: 'Killamery (Kilkenny)', zip: '866090' },
	{ city: 'Killaminoge (Cork)', zip: '725333' },
	{ city: 'Killamoat Lower (Wicklow)', zip: '445263' },
	{ city: 'Killamoat Upper (Wicklow)', zip: '876241' },
	{ city: 'Killamonan (Dublin)', zip: '671083' },
	{ city: 'Killamoyne (Tipperary)', zip: '874695' },
	{ city: 'Killamuck (Laois)', zip: '490999' },
	{ city: 'Killamucky (Cork)', zip: '794366' },
	{ city: 'Killamude East (Galway)', zip: '689469' },
	{ city: 'Killamude West (Galway)', zip: '726634' },
	{ city: 'Killamurren (Cork)', zip: '559894' },
	{ city: 'Killan (Cavan)', zip: '494240' },
	{ city: 'Killanafinch (Tipperary)', zip: '639906' },
	{ city: 'Killanahan (Limerick)', zip: '189486' },
	{ city: 'Killanamaul (Cork)', zip: '178411' },
	{ city: 'Killananima (Leitrim)', zip: '498486' },
	{ city: 'Killananny (Offaly)', zip: '836715' },
	{ city: 'Killandrew (Kilkenny)', zip: '430850' },
	{ city: 'Killandy (Sligo)', zip: '468686' },
	{ city: 'Killane (Carlow)', zip: '105759' },
	{ city: 'Killaneen (Leitrim)', zip: '969572' },
	{ city: 'Killaneer (Cork)', zip: '830531' },
	{ city: 'Killaneetig (Cork)', zip: '647350' },
	{ city: 'Killanena (Clare)', zip: '218462' },
	{ city: 'Killangal (Cork)', zip: '425125' },
	{ city: 'Killanigan (Tipperary)', zip: '724453' },
	{ city: 'Killanly (Sligo)', zip: '164518' },
	{ city: 'Killann (Wexford)', zip: '986881' },
	{ city: 'Killannaduff (Wexford)', zip: '649682' },
	{ city: 'Killannin (Galway)', zip: '562651' },
	{ city: 'Killanny (Louth)', zip: '542525' },
	{ city: 'Killanny (Monaghan)', zip: '734582' },
	{ city: 'Killanoordrane (Kerry)', zip: '691667' },
	{ city: 'Killanthony (Waterford)', zip: '223192' },
	{ city: 'Killanully (Cork)', zip: '950408' },
	{ city: 'Killanummery (Leitrim)', zip: '489203' },
	{ city: 'Killanure (Wexford)', zip: '587747' },
	{ city: 'Killany (Cork)', zip: '392238' },
	{ city: 'Killaphort (Leitrim)', zip: '681352' },
	{ city: 'Killaphort (Offaly)', zip: '891786' },
	{ city: 'Killappoge (Roscommon)', zip: '131335' },
	{ city: 'Killaquill (Cavan)', zip: '162797' },
	{ city: 'Killaraght (Sligo)', zip: '416863' },
	{ city: 'Killarah (Cavan)', zip: '865846' },
	{ city: 'Killarainy (Galway)', zip: '628951' },
	{ city: 'Killaranny (Offaly)', zip: '804412' },
	{ city: 'Killarcan (Leitrim)', zip: '546521' },
	{ city: 'Killard (Clare)', zip: '909155' },
	{ city: 'Killard (Cork)', zip: '704869' },
	{ city: 'Killard (Limerick)', zip: '145996' },
	{ city: 'Killard (Mayo)', zip: '650609' },
	{ city: 'Killard (Tipperary)', zip: '796093' },
	{ city: 'Killard (Westmeath)', zip: '113858' },
	{ city: 'Killaready (Limerick)', zip: '848382' },
	{ city: 'Killarecastle (Westmeath)', zip: '262672' },
	{ city: 'Killarechurch (Westmeath)', zip: '495190' },
	{ city: 'Killaree (Cork)', zip: '958771' },
	{ city: 'Killaree (Kilkenny)', zip: '622018' },
	{ city: 'Killareeny (Galway)', zip: '863822' },
	{ city: 'Killarga (Leitrim)', zip: '639240' },
	{ city: 'Killarida (Kerry)', zip: '251074' },
	{ city: 'Killark (Monaghan)', zip: '367344' },
	{ city: 'Killarles (Offaly)', zip: '701000' },
	{ city: 'Killarney (Kerry)', zip: '116334' },
	{ city: 'Killarney (Kilkenny)', zip: '869119' },
	{ city: 'Killarney (Roscommon)', zip: '934343' },
	{ city: 'Killarney (Wicklow)', zip: '731737' },
	{ city: 'Killaroo (Westmeath)', zip: '915200' },
	{ city: 'Killarriv (Galway)', zip: '349022' },
	{ city: 'Killartery (Louth)', zip: '425267' },
	{ city: 'Killarue (Monaghan)', zip: '237715' },
	{ city: 'Killarush (Cork)', zip: '915167' },
	{ city: 'Killary (Meath)', zip: '983628' },
	{ city: 'Killary (Tipperary)', zip: '624056' },
	{ city: 'Killasanowl (Leitrim)', zip: '382111' },
	{ city: 'Killascaul (Galway)', zip: '731309' },
	{ city: 'Killashandra (Cavan)', zip: '571510' },
	{ city: 'Killashee (Kildare)', zip: '628494' },
	{ city: 'Killashee (Longford)', zip: '409997' },
	{ city: 'Killashee And Aghakeeran (Longford)', zip: '579479' },
	{ city: 'Killaskillen (Meath)', zip: '436571' },
	{ city: 'Killasmeestia (Laois)', zip: '278946' },
	{ city: 'Killasmuggaun (Galway)', zip: '272245' },
	{ city: 'Killasona (Longford)', zip: '628690' },
	{ city: 'Killaspicktarvin (Kerry)', zip: '928157' },
	{ city: 'Killaspugbrone (Sligo)', zip: '166777' },
	{ city: 'Killaspuglonane (Clare)', zip: '488617' },
	{ city: 'Killaspugmoylan (Galway)', zip: '453884' },
	{ city: 'Killaspy (Kilkenny)', zip: '181166' },
	{ city: 'Killasser (Mayo)', zip: '431621' },
	{ city: 'Killasseragh (Cork)', zip: '525845' },
	{ city: 'Killastalliff (Roscommon)', zip: '294712' },
	{ city: 'Killasteever (Donegal)', zip: '975498' },
	{ city: 'Killaster (Roscommon)', zip: '768272' },
	{ city: 'Killatee (Cavan)', zip: '412777' },
	{ city: 'Killateeaun (Mayo)', zip: '744031' },
	{ city: 'Killathy (Cork)', zip: '746128' },
	{ city: 'Killatoor (Waterford)', zip: '345455' },
	{ city: 'Killatten (Monaghan)', zip: '875549' },
	{ city: 'Killattimoriarty (Roscommon)', zip: '613227' },
	{ city: 'Killaturly (Mayo)', zip: '246462' },
	{ city: 'Killaun (Offaly)', zip: '720999' },
	{ city: 'Killaun (Tipperary)', zip: '730476' },
	{ city: 'Killavackan (Roscommon)', zip: '430962' },
	{ city: 'Killavalla (Tipperary)', zip: '942380' },
	{ city: 'Killavallig (Cork)', zip: '861681' },
	{ city: 'Killavally (Laois)', zip: '823439' },
	{ city: 'Killavally (Mayo)', zip: '981218' },
	{ city: 'Killavally (Tipperary)', zip: '835792' },
	{ city: 'Killavally (Westmeath)', zip: '242227' },
	{ city: 'Killavally East (Mayo)', zip: '136194' },
	{ city: 'Killavally West (Mayo)', zip: '385701' },
	{ city: 'Killavarilly (Cork)', zip: '316632' },
	{ city: 'Killavarrig (Cork)', zip: '199641' },
	{ city: 'Killavee (Donegal)', zip: '524516' },
	{ city: 'Killaveenoge East (Cork)', zip: '160205' },
	{ city: 'Killaveenoge West (Cork)', zip: '402467' },
	{ city: 'Killavenoge (Tipperary)', zip: '245992' },
	{ city: 'Killaveny (Wicklow)', zip: '972945' },
	{ city: 'Killavil (Sligo)', zip: '534374' },
	{ city: 'Killavilla (Offaly)', zip: '999179' },
	{ city: 'Killavinoge (Tipperary)', zip: '341578' },
	{ city: 'Killavoggy (Leitrim)', zip: '884908' },
	{ city: 'Killavoher (Galway)', zip: '618346' },
	{ city: 'Killavoy (Clare)', zip: '488182' },
	{ city: 'Killavoy (Cork)', zip: '754372' },
	{ city: 'Killavullen (Cork)', zip: '728948' },
	{ city: 'Killawardy (Tipperary)', zip: '770668' },
	{ city: 'Killawillin (Cork)', zip: '902357' },
	{ city: 'Killawinna (Clare)', zip: '872337' },
	{ city: 'Killawlan (Waterford)', zip: '603012' },
	{ city: 'Killawullaun East (Mayo)', zip: '824470' },
	{ city: 'Killawullaun Mountain (Mayo)', zip: '874318' },
	{ city: 'Killawullaun West (Mayo)', zip: '291950' },
	{ city: 'Kill Beg (Meath)', zip: '699389' },
	{ city: 'Killbrook (Kildare)', zip: '631105' },
	{ city: 'Kill Demesne (Cavan)', zip: '420841' },
	{ city: 'Killea (Leitrim)', zip: '509446' },
	{ city: 'Killea (Limerick)', zip: '758372' },
	{ city: 'Killea (Roscommon)', zip: '644561' },
	{ city: 'Killea (Tipperary)', zip: '480121' },
	{ city: 'Killea (Waterford)', zip: '947000' },
	{ city: 'Killeacle (Kerry)', zip: '458314' },
	{ city: 'Killeagh (Cork)', zip: '579657' },
	{ city: 'Killeagh (Kerry)', zip: '530673' },
	{ city: 'Killeagh (Kildare)', zip: '131627' },
	{ city: 'Killeagh (Limerick)', zip: '489014' },
	{ city: 'Killeagh (Waterford)', zip: '118182' },
	{ city: 'Killeagh (Westmeath)', zip: '790198' },
	{ city: 'Killeagh (Wexford)', zip: '995738' },
	{ city: 'Killeagh (Wicklow)', zip: '928153' },
	{ city: 'Killeagh Common (Kildare)', zip: '437691' },
	{ city: 'Killeagh Gardens (Cork)', zip: '593002' },
	{ city: 'Killeagy (Clare)', zip: '481191' },
	{ city: 'Killeane (Cork)', zip: '724806' },
	{ city: 'Killeanly (Monaghan)', zip: '899088' },
	{ city: 'Killeany (Clare)', zip: '703519' },
	{ city: 'Killeany (Galway)', zip: '594416' },
	{ city: 'Killeany (Laois)', zip: '477926' },
	{ city: 'Killeany (Meath)', zip: '845826' },
	{ city: 'Killeany Beg (Limerick)', zip: '306352' },
	{ city: 'Killeany More (Limerick)', zip: '871234' },
	{ city: 'Kill East (Kildare)', zip: '750160' },
	{ city: 'Killeatin (Tipperary)', zip: '271029' },
	{ city: 'Killedan (Mayo)', zip: '956572' },
	{ city: 'Killederdaowen (Galway)', zip: '696555' },
	{ city: 'Killedmond (Carlow)', zip: '807620' },
	{ city: 'Killee (Cork)', zip: '186607' },
	{ city: 'Killeedy North (Limerick)', zip: '658755' },
	{ city: 'Killeedy South (Limerick)', zip: '654094' },
	{ city: 'Killeef (Monaghan)', zip: '908026' },
	{ city: 'Killeek (Dublin)', zip: '755733' },
	{ city: 'Killeelaun (Galway)', zip: '782906' },
	{ city: 'Killeely Beg (Galway)', zip: '796695' },
	{ city: 'Killeely More (Galway)', zip: '212246' },
	{ city: 'Killeen (Clare)', zip: '751850' },
	{ city: 'Killeen (Cork)', zip: '982275' },
	{ city: 'Killeen (Donegal)', zip: '363501' },
	{ city: 'Killeen (Dublin)', zip: '533735' },
	{ city: 'Killeen (Galway)', zip: '708653' },
	{ city: 'Killeen (Kerry)', zip: '836579' },
	{ city: 'Killeen (Kildare)', zip: '977326' },
	{ city: 'Killeen (Kilkenny)', zip: '713668' },
	{ city: 'Killeen (Laois)', zip: '478384' },
	{ city: 'Killeen (Leitrim)', zip: '647739' },
	{ city: 'Killeen (Limerick)', zip: '672716' },
	{ city: 'Killeen (Longford)', zip: '306867' },
	{ city: 'Killeen (Louth)', zip: '152905' },
	{ city: 'Killeen (Mayo)', zip: '671209' },
	{ city: 'Killeen (Meath)', zip: '243458' },
	{ city: 'Killeen (Offaly)', zip: '101545' },
	{ city: 'Killeen (Tipperary)', zip: '517795' },
	{ city: 'Killeen (Westmeath)', zip: '124782' },
	{ city: 'Killeen (Wexford)', zip: '248270' },
	{ city: 'Killeena (Cork)', zip: '887476' },
	{ city: 'Killeena (Mayo)', zip: '392024' },
	{ city: 'Killeenadeema (Galway)', zip: '388990' },
	{ city: 'Killeenadeema (Roscommon)', zip: '232072' },
	{ city: 'Killeenadeema East (Galway)', zip: '840418' },
	{ city: 'Killeenadeema West (Galway)', zip: '226495' },
	{ city: 'Killeenafinnane (Kerry)', zip: '197632' },
	{ city: 'Killeenagarriff (Limerick)', zip: '607120' },
	{ city: 'Killeenagh (Clare)', zip: '852612' },
	{ city: 'Killeenagh (Kerry)', zip: '339533' },
	{ city: 'Killeenagh (Westmeath)', zip: '887057' },
	{ city: 'Killeenaghmountain (Waterford)', zip: '627612' },
	{ city: 'Killeenagh North (Waterford)', zip: '744297' },
	{ city: 'Killeenagh South (Waterford)', zip: '503940' },
	{ city: 'Killeenagroagh (Westmeath)', zip: '261480' },
	{ city: 'Killeenan (Clare)', zip: '868163' },
	{ city: 'Killeenan Beg (Galway)', zip: '572527' },
	{ city: 'Killeen And Lugnaboley (Offaly)', zip: '374848' },
	{ city: 'Killeenan More (Galway)', zip: '361406' },
	{ city: 'Killeenaran (Galway)', zip: '847847' },
	{ city: 'Killeenasteena (Tipperary)', zip: '939538' },
	{ city: 'Killeenatoor (Westmeath)', zip: '531132' },
	{ city: 'Killeenatruan (Longford)', zip: '686821' },
	{ city: 'Killeenavarra (Galway)', zip: '967051' },
	{ city: 'Killeenavera (Limerick)', zip: '423474' },
	{ city: 'Killeenbeg (Kildare)', zip: '667973' },
	{ city: 'Killeenboy (Longford)', zip: '481115' },
	{ city: 'Killeenboy (Offaly)', zip: '135710' },
	{ city: 'Killeenboy (Roscommon)', zip: '564257' },
	{ city: 'Killeenboy (Westmeath)', zip: '123202' },
	{ city: 'Killeenboylegan (Westmeath)', zip: '169861' },
	{ city: 'Killeenbrack (Westmeath)', zip: '351263' },
	{ city: 'Killeenbreaghan (Offaly)', zip: '834400' },
	{ city: 'Killeenbutler (Tipperary)', zip: '417101' },
	{ city: 'Killeencoff (Mayo)', zip: '245807' },
	{ city: 'Killeencreevagh (Mayo)', zip: '936722' },
	{ city: 'Killeendaniel (Cork)', zip: '338875' },
	{ city: 'Killeendooling (Cork)', zip: '440068' },
	{ city: 'Killeendowd (Longford)', zip: '860968' },
	{ city: 'Killeenduff (Sligo)', zip: '881938' },
	{ city: 'Killeen East (Galway)', zip: '389952' },
	{ city: 'Killeen East (Kildare)', zip: '421357' },
	{ city: 'Killeen East (Kilkenny)', zip: '830175' },
	{ city: 'Killeen East (Roscommon)', zip: '877585' },
	{ city: 'Killeeneen Beg (Galway)', zip: '126563' },
	{ city: 'Killeeneen More (Galway)', zip: '624124' },
	{ city: 'Killeenemer (Cork)', zip: '856555' },
	{ city: 'Killeenerk (Westmeath)', zip: '843022' },
	{ city: 'Killeenhugh (Galway)', zip: '216195' },
	{ city: 'Killeenlea (Kildare)', zip: '155079' },
	{ city: 'Killeenleagh (Cork)', zip: '552468' },
	{ city: 'Killeenleagh (Kerry)', zip: '235436' },
	{ city: 'Killeenleigh (Cork)', zip: '133848' },
	{ city: 'Killeenleigh (Tipperary)', zip: '634448' },
	{ city: 'Killeenmacoog North (Clare)', zip: '775946' },
	{ city: 'Killeenmacoog South (Clare)', zip: '134482' },
	{ city: 'Killeenmore (Kildare)', zip: '260175' },
	{ city: 'Killeenmore (Offaly)', zip: '103107' },
	{ city: 'Killeenmore (Westmeath)', zip: '218796' },
	{ city: 'Killeenmunterlane North (Galway)', zip: '781324' },
	{ city: 'Killeenmunterlane South (Galway)', zip: '207681' },
	{ city: 'Killeennagallive (Tipperary)', zip: '153730' },
	{ city: 'Killeennamanagh (Cork)', zip: '369181' },
	{ city: 'Killeennanam (Westmeath)', zip: '192490' },
	{ city: 'Killeennashask (Mayo)', zip: '251122' },
	{ city: 'Killeen North (Cork)', zip: '479342' },
	{ city: 'Killeen North (Galway)', zip: '634670' },
	{ city: 'Killeenoghty (Limerick)', zip: '630540' },
	{ city: 'Killeenpatrick (Galway)', zip: '530949' },
	{ city: 'Killeenrevagh (Mayo)', zip: '821816' },
	{ city: 'Killeenrevagh (Roscommon)', zip: '146157' },
	{ city: 'Killeens (Cork)', zip: '726615' },
	{ city: 'Killeens (Kerry)', zip: '786982' },
	{ city: 'Killeens (Kilkenny)', zip: '511670' },
	{ city: 'Killeens (Wexford)', zip: '100261' },
	{ city: 'Killeen South (Cork)', zip: '243010' },
	{ city: 'Killeen South (Galway)', zip: '773811' },
	{ city: 'Killeentierna (Kerry)', zip: '269404' },
	{ city: 'Killeen West (Galway)', zip: '428530' },
	{ city: 'Killeen West (Kildare)', zip: '146535' },
	{ city: 'Killeen West (Kilkenny)', zip: '751999' },
	{ city: 'Killeen West (Roscommon)', zip: '275236' },
	{ city: 'Killeeny (Longford)', zip: '819037' },
	{ city: 'Killeenyarda (Tipperary)', zip: '230244' },
	{ city: 'Killeenycallaghan (Westmeath)', zip: '210210' },
	{ city: 'Killeeshal (Carlow)', zip: '745833' },
	{ city: 'Killeeshal (Waterford)', zip: '668210' },
	{ city: 'Killeevan (Monaghan)', zip: '626371' },
	{ city: 'Killeevan Glebe (Monaghan)', zip: '440965' },
	{ city: 'Killegan (Roscommon)', zip: '452348' },
	{ city: 'Killegane (Kerry)', zip: '271511' },
	{ city: 'Killegar (Leitrim)', zip: '513895' },
	{ city: 'Killegar (Wicklow)', zip: '189174' },
	{ city: 'Killeglan (Roscommon)', zip: '613633' },
	{ city: 'Killegland (Meath)', zip: '246485' },
	{ city: 'Killegney (Wexford)', zip: '641409' },
	{ city: 'Killegran (Wexford)', zip: '914755' },
	{ city: 'Killegy Lower (Kerry)', zip: '828341' },
	{ city: 'Killegy Upper (Kerry)', zip: '242513' },
	{ city: 'Killehagh (Cork)', zip: '613398' },
	{ city: 'Killeheen (Limerick)', zip: '142153' },
	{ city: 'Killeheen (Tipperary)', zip: '234127' },
	{ city: 'Killehenny (Kerry)', zip: '851081' },
	{ city: 'Killeigh (Cork)', zip: '495062' },
	{ city: 'Killeigh (Offaly)', zip: '225100' },
	{ city: 'Killeigh (Tipperary)', zip: '235539' },
	{ city: 'Killeighter (Galway)', zip: '491883' },
	{ city: 'Killeighter (Kildare)', zip: '691423' },
	{ city: 'Killeinagh (Clare)', zip: '233302' },
	{ city: 'Killeisk (Tipperary)', zip: '904716' },
	{ city: 'Killelan (Kildare)', zip: '561355' },
	{ city: 'Killelan (Wexford)', zip: '708734' },
	{ city: 'Killelane (Kerry)', zip: '615550' },
	{ city: 'Killelan East (Kerry)', zip: '525503' },
	{ city: 'Killelan West (Kerry)', zip: '104738' },
	{ city: 'Killeline (Limerick)', zip: '363495' },
	{ city: 'Killellery (Offaly)', zip: '147715' },
	{ city: 'Killelton (Kerry)', zip: '572950' },
	{ city: 'Killelton (Waterford)', zip: '215041' },
	{ city: 'Killemly (Tipperary)', zip: '658803' },
	{ city: 'Killenagh (Wexford)', zip: '824955' },
	{ city: 'Killenard (Laois)', zip: '321512' },
	{ city: 'Killenaule (Tipperary)', zip: '916610' },
	{ city: 'Killenna Glebe (Leitrim)', zip: '114590' },
	{ city: 'Killenny (Laois)', zip: '222304' },
	{ city: 'Killenora (Carlow)', zip: '111618' },
	{ city: 'Killenough (Cork)', zip: '152057' },
	{ city: 'Killenure (Tipperary)', zip: '640640' },
	{ city: 'Killeragh (Galway)', zip: '801816' },
	{ city: 'Killerdoo (Roscommon)', zip: '384679' },
	{ city: 'Killerduff (Mayo)', zip: '711516' },
	{ city: 'Killerguile (Waterford)', zip: '466842' },
	{ city: 'Killerk (Wicklow)', zip: '458815' },
	{ city: 'Killerk East (Clare)', zip: '373577' },
	{ city: 'Killerk North (Tipperary)', zip: '140784' },
	{ city: 'Killerk South (Tipperary)', zip: '109047' },
	{ city: 'Killerk West (Clare)', zip: '882156' },
	{ city: 'Killermogh (Laois)', zip: '872644' },
	{ city: 'Killernan (Clare)', zip: '321504' },
	{ city: 'Killernan (Mayo)', zip: '482145' },
	{ city: 'Killerneen (Galway)', zip: '801325' },
	{ city: 'Killeroran (Galway)', zip: '217621' },
	{ city: 'Killerr (Roscommon)', zip: '908366' },
	{ city: 'Killerrig (Carlow)', zip: '796174' },
	{ city: 'Killerrin (Leitrim)', zip: '865820' },
	{ city: 'Killerry (Sligo)', zip: '680941' },
	{ city: 'Killescragh (Galway)', zip: '634470' },
	{ city: 'Killeshil (Offaly)', zip: '774573' },
	{ city: 'Killeshin (Laois)', zip: '918046' },
	{ city: 'Killesk (Wexford)', zip: '746044' },
	{ city: 'Killester (Dublin)', zip: '322274' },
	{ city: 'Killester (Meath)', zip: '390744' },
	{ city: 'Killestry (Clare)', zip: '883522' },
	{ city: 'Killeter (Cavan)', zip: '431610' },
	{ city: 'Killeter (Longford)', zip: '616672' },
	{ city: 'Killetra (Cork)', zip: '502992' },
	{ city: 'Killetragh (Cork)', zip: '975723' },
	{ city: 'Killevny (Galway)', zip: '397577' },
	{ city: 'Killhill (Kildare)', zip: '691599' },
	{ city: 'Killiaghan And Gort (Roscommon)', zip: '413516' },
	{ city: 'Killian (Clare)', zip: '564109' },
	{ city: 'Killian (Galway)', zip: '630210' },
	{ city: 'Killiane (Galway)', zip: '793450' },
	{ city: 'Killiane (Wexford)', zip: '719654' },
	{ city: 'Killiane Little (Wexford)', zip: '576029' },
	{ city: 'Killicar (Cavan)', zip: '751037' },
	{ city: 'Killickabawn (Wicklow)', zip: '262526' },
	{ city: 'Killickaforavane (Cork)', zip: '505261' },
	{ city: 'Killickaweeny (Kildare)', zip: '833387' },
	{ city: 'Killierisk (Kerry)', zip: '888079' },
	{ city: 'Killilagh (Clare)', zip: '799616' },
	{ city: 'Killillane (Wexford)', zip: '864070' },
	{ city: 'Killimor (Galway)', zip: '708243' },
	{ city: 'Killimor (Mayo)', zip: '763509' },
	{ city: 'Killimor And Boleybeg (Galway)', zip: '174056' },
	{ city: 'Killimy (Laois)', zip: '187331' },
	{ city: 'Killin (Donegal)', zip: '783678' },
	{ city: 'Killin (Louth)', zip: '915095' },
	{ city: 'Killina (Monaghan)', zip: '824204' },
	{ city: 'Killina (Offaly)', zip: '866827' },
	{ city: 'Killinaboy (Clare)', zip: '183263' },
	{ city: 'Killinaddan (Roscommon)', zip: '530489' },
	{ city: 'Killinagh (Cork)', zip: '827966' },
	{ city: 'Killinagh (Kildare)', zip: '798971' },
	{ city: 'Killinagh (Westmeath)', zip: '370690' },
	{ city: 'Killinagh Lower (Kildare)', zip: '508132' },
	{ city: 'Killinagh Upper (Kildare)', zip: '500515' },
	{ city: 'Killinaker (Leitrim)', zip: '512067' },
	{ city: 'Killinane (Carlow)', zip: '803021' },
	{ city: 'Killinane (Cork)', zip: '757922' },
	{ city: 'Killinane (Kildare)', zip: '327310' },
	{ city: 'Killinane (Limerick)', zip: '293171' },
	{ city: 'Killinane (Tipperary)', zip: '556617' },
	{ city: 'Killinangel Beg (Donegal)', zip: '551238' },
	{ city: 'Killinangel More (Donegal)', zip: '334050' },
	{ city: 'Killinaparson (Laois)', zip: '799078' },
	{ city: 'Killinardan (Dublin)', zip: '840920' },
	{ city: 'Killinardrish (Cork)', zip: '871889' },
	{ city: 'Killinaspick (Kilkenny)', zip: '184430' },
	{ city: 'Killinawas (Longford)', zip: '637828' },
	{ city: 'Killinbore (Longford)', zip: '669255' },
	{ city: 'Killincarrig (Wicklow)', zip: '242238' },
	{ city: 'Killinch (Tipperary)', zip: '725572' },
	{ city: 'Killincoole (Louth)', zip: '561492' },
	{ city: 'Killincooly Beg (Wexford)', zip: '627889' },
	{ city: 'Killincooly More (Wexford)', zip: '961389' },
	{ city: 'Killindarragh (Donegal)', zip: '772619' },
	{ city: 'Killindra (Kilkenny)', zip: '912327' },
	{ city: 'Killined (Sligo)', zip: '581930' },
	{ city: 'Killineen East (Waterford)', zip: '500707' },
	{ city: 'Killineen West (Waterford)', zip: '669444' },
	{ city: 'Killineer (Louth)', zip: '831929' },
	{ city: 'Killiney (Dublin)', zip: '966414' },
	{ city: 'Killiney (Kerry)', zip: '256704' },
	{ city: 'Killinga (Cork)', zip: '406984' },
	{ city: 'Killinick (Wexford)', zip: '488469' },
	{ city: 'Killinierin (Wexford)', zip: '644902' },
	{ city: 'Killininneen (Westmeath)', zip: '769396' },
	{ city: 'Killininny (Dublin)', zip: '417643' },
	{ city: 'Killiniskyduff (Wicklow)', zip: '630906' },
	{ city: 'Killinlahan (Westmeath)', zip: '984727' },
	{ city: 'Killinlastra (Longford)', zip: '434170' },
	{ city: 'Killinleigh (Tipperary)', zip: '513060' },
	{ city: 'Killinny (Clare)', zip: '551149' },
	{ city: 'Killinny (Galway)', zip: '291103' },
	{ city: 'Killinny (Kilkenny)', zip: '546813' },
	{ city: 'Killinny East (Galway)', zip: '333760' },
	{ city: 'Killinny West (Galway)', zip: '460043' },
	{ city: 'Killinoorin (Waterford)', zip: '561079' },
	{ city: 'Killinordan (Roscommon)', zip: '921425' },
	{ city: 'Killinordanbeg (Roscommon)', zip: '439375' },
	{ city: 'Killinpark (Wicklow)', zip: '410779' },
	{ city: 'Killinraghty Big (Roscommon)', zip: '825905' },
	{ city: 'Killinraghty Little (Roscommon)', zip: '895598' },
	{ city: 'Killinroan (Westmeath)', zip: '407537' },
	{ city: 'Killinthomas (Kildare)', zip: '446105' },
	{ city: 'Killintown (Westmeath)', zip: '281396' },
	{ city: 'Killinure (Laois)', zip: '414075' },
	{ city: 'Killinure (Limerick)', zip: '131886' },
	{ city: 'Killinure (Longford)', zip: '966820' },
	{ city: 'Killinure (Offaly)', zip: '462902' },
	{ city: 'Killinure (Tipperary)', zip: '378544' },
	{ city: 'Killinure (Wicklow)', zip: '923584' },
	{ city: 'Killinure North (Westmeath)', zip: '217881' },
	{ city: 'Killinure South (Westmeath)', zip: '533113' },
	{ city: 'Killinvoy (Roscommon)', zip: '661511' },
	{ city: 'Killisk (Wexford)', zip: '306610' },
	{ city: 'Killiskea (Offaly)', zip: '910114' },
	{ city: 'Killiskey (Wicklow)', zip: '308989' },
	{ city: 'Killissane (Cork)', zip: '226018' },
	{ city: 'Killistafford (Tipperary)', zip: '378139' },
	{ city: 'Killistristane (Offaly)', zip: '286405' },
	{ city: 'Kill More (Meath)', zip: '219826' },
	{ city: 'Killmountain (Cork)', zip: '801972' },
	{ city: 'Killnamartery (Cork)', zip: '852849' },
	{ city: 'Kill North (Cork)', zip: '906597' },
	{ city: 'Killock (Tipperary)', zip: '422985' },
	{ city: 'Killoe (Kerry)', zip: '590111' },
	{ city: 'Killoe (Longford)', zip: '286833' },
	{ city: 'Killoe Glebe (Longford)', zip: '788006' },
	{ city: 'Killofin (Clare)', zip: '348905' },
	{ city: 'Kill Of The Grange (Dublin)', zip: '938373' },
	{ city: 'Killogeary (Mayo)', zip: '642725' },
	{ city: 'Killogeenaghan (Westmeath)', zip: '133882' },
	{ city: 'Killoghil (Clare)', zip: '299481' },
	{ city: 'Killogilleen (Galway)', zip: '264879' },
	{ city: 'Killognaveen North (Kerry)', zip: '572327' },
	{ city: 'Killognaveen South (Kerry)', zip: '151896' },
	{ city: 'Killogrone (Kerry)', zip: '441872' },
	{ city: 'Killogunra (Mayo)', zip: '448211' },
	{ city: 'Killokennedy (Clare)', zip: '413350' },
	{ city: 'Killola (Galway)', zip: '392225' },
	{ city: 'Killoluaig (Kerry)', zip: '108939' },
	{ city: 'Killomeerhoe (Kerry)', zip: '277190' },
	{ city: 'Killomenaghan (Westmeath)', zip: '608116' },
	{ city: 'Killomoran (Galway)', zip: '410186' },
	{ city: 'Killonahan (Limerick)', zip: '197948' },
	{ city: 'Killonan (Limerick)', zip: '901595' },
	{ city: 'Killone (Laois)', zip: '281741' },
	{ city: 'Killone (Waterford)', zip: '362159' },
	{ city: 'Killonecaha (Kerry)', zip: '334658' },
	{ city: 'Killoneen (Offaly)', zip: '263419' },
	{ city: 'Killonerry (Kilkenny)', zip: '106241' },
	{ city: 'Killongford (Waterford)', zip: '957506' },
	{ city: 'Killooaun (Galway)', zip: '875029' },
	{ city: 'Killooly (Offaly)', zip: '448078' },
	{ city: 'Killooman (Leitrim)', zip: '654308' },
	{ city: 'Killora (Galway)', zip: '721393' },
	{ city: 'Killoran (Galway)', zip: '761553' },
	{ city: 'Killoran (Tipperary)', zip: '130737' },
	{ city: 'Killorane (Kerry)', zip: '853775' },
	{ city: 'Killoran North (Sligo)', zip: '883153' },
	{ city: 'Killoran South (Sligo)', zip: '599611' },
	{ city: 'Killorath (Limerick)', zip: '739165' },
	{ city: 'Killorglin (Kerry)', zip: '980744' },
	{ city: 'Killoscobe (Galway)', zip: '116052' },
	{ city: 'Killoscully (Tipperary)', zip: '776752' },
	{ city: 'Killosheheen (Mayo)', zip: '373504' },
	{ city: 'Killoshulan (Kilkenny)', zip: '780383' },
	{ city: 'Killoskehan (Tipperary)', zip: '257072' },
	{ city: 'Killosolan (Galway)', zip: '503557' },
	{ city: 'Killosseragh (Waterford)', zip: '962160' },
	{ city: 'Killossery (Dublin)', zip: '993808' },
	{ city: 'Killoteran (Waterford)', zip: '809340' },
	{ city: 'Killough (Galway)', zip: '557431' },
	{ city: 'Killough (Tipperary)', zip: '201277' },
	{ city: 'Killoughane (Kerry)', zip: '811481' },
	{ city: 'Killoughcarran (Donegal)', zip: '876644' },
	{ city: 'Killough East (Cork)', zip: '356563' },
	{ city: 'Killougher (Dublin)', zip: '497813' },
	{ city: 'Killough Lower (Wicklow)', zip: '780916' },
	{ city: 'Killoughrum (Wexford)', zip: '589776' },
	{ city: 'Killoughter (Cavan)', zip: '536117' },
	{ city: 'Killoughter (Wicklow)', zip: '303135' },
	{ city: 'Killoughternane (Carlow)', zip: '421712' },
	{ city: 'Killoughty (Limerick)', zip: '755564' },
	{ city: 'Killough Upper (Wicklow)', zip: '646930' },
	{ city: 'Killough West (Cork)', zip: '238766' },
	{ city: 'Killoughy (Offaly)', zip: '664168' },
	{ city: 'Killountain (Cork)', zip: '441183' },
	{ city: 'Killountane (Cork)', zip: '817264' },
	{ city: 'Killour (Mayo)', zip: '253491' },
	{ city: 'Killourney (Clare)', zip: '738325' },
	{ city: 'Killoveenoge (Cork)', zip: '429798' },
	{ city: 'Killoveeny (Mayo)', zip: '638476' },
	{ city: 'Killow (Clare)', zip: '107498' },
	{ city: 'Killowen (Cork)', zip: '200087' },
	{ city: 'Killowen (Kerry)', zip: '256884' },
	{ city: 'Killowen (Offaly)', zip: '126916' },
	{ city: 'Killowen (Waterford)', zip: '215354' },
	{ city: 'Killowen (Wexford)', zip: '276567' },
	{ city: 'Killowen Lower (Wexford)', zip: '878380' },
	{ city: 'Killowen Upper (Wexford)', zip: '606091' },
	{ city: 'Killower (Galway)', zip: '871955' },
	{ city: 'Killowney Beg (Offaly)', zip: '734238' },
	{ city: 'Killowney Big (Tipperary)', zip: '516926' },
	{ city: 'Killowney Little (Tipperary)', zip: '637563' },
	{ city: 'Killowney More (Offaly)', zip: '454723' },
	{ city: 'Killowny (Cork)', zip: '697375' },
	{ city: 'Killoy (Roscommon)', zip: '951404' },
	{ city: 'Kill-Saint-Anne North (Cork)', zip: '524052' },
	{ city: 'Kill-Saint-Anne South (Cork)', zip: '437871' },
	{ city: 'Kill Saint Nicholas (Waterford)', zip: '762039' },
	{ city: 'Kill South (Cork)', zip: '264700' },
	{ city: 'Killua (Westmeath)', zip: '180961' },
	{ city: 'Killucan (Westmeath)', zip: '192085' },
	{ city: 'Killugger (Wexford)', zip: '599388' },
	{ city: 'Killukin (Roscommon)', zip: '855289' },
	{ city: 'Killulagh (Westmeath)', zip: '677976' },
	{ city: 'Killulla (Clare)', zip: '979380' },
	{ city: 'Killult (Donegal)', zip: '117763' },
	{ city: 'Killultagh (Roscommon)', zip: '111799' },
	{ city: 'Killultan (Donegal)', zip: '275515' },
	{ city: 'Killummod (Roscommon)', zip: '624839' },
	{ city: 'Killumney (Cork)', zip: '217951' },
	{ city: 'Killunagher (Mayo)', zip: '157367' },
	{ city: 'Killuney (Galway)', zip: '435734' },
	{ city: 'Killuntin North (Cork)', zip: '690796' },
	{ city: 'Killuntin South (Cork)', zip: '322343' },
	{ city: 'Killuppaun (Galway)', zip: '733970' },
	{ city: 'Killuragh (Cork)', zip: '122294' },
	{ city: 'Killuragh (Limerick)', zip: '943196' },
	{ city: 'Killuran (Clare)', zip: '357912' },
	{ city: 'Killuran Beg (Clare)', zip: '157189' },
	{ city: 'Killurane (Tipperary)', zip: '496076' },
	{ city: 'Killuran More (Clare)', zip: '426972' },
	{ city: 'Killure (Sligo)', zip: '940587' },
	{ city: 'Killure (Waterford)', zip: '851560' },
	{ city: 'Killure Beg (Galway)', zip: '228808' },
	{ city: 'Killure Castle (Galway)', zip: '494862' },
	{ city: 'Killure More (Galway)', zip: '623672' },
	{ city: 'Killurin (Offaly)', zip: '798913' },
	{ city: 'Killurin (Wexford)', zip: '944261' },
	{ city: 'Killurly (Kerry)', zip: '122701' },
	{ city: 'Killurly Commons (Kerry)', zip: '273024' },
	{ city: 'Killurly East (Kerry)', zip: '883695' },
	{ city: 'Killurly West (Kerry)', zip: '416155' },
	{ city: 'Killurney (Tipperary)', zip: '692945' },
	{ city: 'Killurriga (Cork)', zip: '295018' },
	{ city: 'Killusty North (Tipperary)', zip: '943493' },
	{ city: 'Killusty South (Tipperary)', zip: '756821' },
	{ city: 'Kill West (Kildare)', zip: '894847' },
	{ city: 'Killybandrick (Cavan)', zip: '750498' },
	{ city: 'Killybeg (Wicklow)', zip: '157421' },
	{ city: 'Killybegs (Donegal)', zip: '935177' },
	{ city: 'Killybegs (Kildare)', zip: '590070' },
	{ city: 'Killybegs (Wexford)', zip: '638115' },
	{ city: 'Killybegs Demesne (Kildare)', zip: '297248' },
	{ city: 'Killybern (Monaghan)', zip: '389250' },
	{ city: 'Killyboley (Monaghan)', zip: '205377' },
	{ city: 'Killybough (Monaghan)', zip: '120620' },
	{ city: 'Killybreen (Monaghan)', zip: '584253' },
	{ city: 'Killybressal (Monaghan)', zip: '581461' },
	{ city: 'Killybrone (Mayo)', zip: '801979' },
	{ city: 'Killybrone (Monaghan)', zip: '239574' },
	{ city: 'Killycannan (Cavan)', zip: '467638' },
	{ city: 'Killycard (Monaghan)', zip: '809383' },
	{ city: 'Killycarnan (Monaghan)', zip: '113910' },
	{ city: 'Killycarnan North (Monaghan)', zip: '237144' },
	{ city: 'Killycarnan South (Monaghan)', zip: '227966' },
	{ city: 'Killycarney (Cavan)', zip: '948338' },
	{ city: 'Killycarran (Monaghan)', zip: '147537' },
	{ city: 'Killycatron (Cavan)', zip: '713434' },
	{ city: 'Killycleare (Cavan)', zip: '673066' },
	{ city: 'Killyclessy (Louth)', zip: '454973' },
	{ city: 'Killycloghan (Cavan)', zip: '712154' },
	{ city: 'Killycloghan (Leitrim)', zip: '327766' },
	{ city: 'Killyclug (Donegal)', zip: '159203' },
	{ city: 'Killycluggin (Cavan)', zip: '764563' },
	{ city: 'Killycoghill (Monaghan)', zip: '551055' },
	{ city: 'Killycolman (Donegal)', zip: '821514' },
	{ city: 'Killyconigan (Monaghan)', zip: '101285' },
	{ city: 'Killyconnan (Cavan)', zip: '636029' },
	{ city: 'Killyconny (Cavan)', zip: '385655' },
	{ city: 'Killycooly (Monaghan)', zip: '306540' },
	{ city: 'Killycoonagh (Monaghan)', zip: '632545' },
	{ city: 'Killycorran (Monaghan)', zip: '765762' },
	{ city: 'Killycracken (Monaghan)', zip: '254898' },
	{ city: 'Killycramph (Cavan)', zip: '969818' },
	{ city: 'Killycreen (Monaghan)', zip: '750553' },
	{ city: 'Killycreeny (Cavan)', zip: '195055' },
	{ city: 'Killycrin (Cavan)', zip: '355567' },
	{ city: 'Killycrom (Monaghan)', zip: '492166' },
	{ city: 'Killycronaghan (Monaghan)', zip: '300479' },
	{ city: 'Killycrone (Cavan)', zip: '921276' },
	{ city: 'Killycroney (Louth)', zip: '719988' },
	{ city: 'Killycushil (Monaghan)', zip: '918884' },
	{ city: 'Killydesert (Donegal)', zip: '965915' },
	{ city: 'Killydonagh (Monaghan)', zip: '385602' },
	{ city: 'Killydonnell (Donegal)', zip: '999804' },
	{ city: 'Killydonnelly (Monaghan)', zip: '194461' },
	{ city: 'Killydonoghoe (Cork)', zip: '817564' },
	{ city: 'Killydoon (Cavan)', zip: '780527' },
	{ city: 'Killydream (Cavan)', zip: '223306' },
	{ city: 'Killydreen (Monaghan)', zip: '637892' },
	{ city: 'Killydrum (Leitrim)', zip: '977450' },
	{ city: 'Killydrutan (Monaghan)', zip: '904589' },
	{ city: 'Killyduff (Cavan)', zip: '607091' },
	{ city: 'Killyfad (Leitrim)', zip: '249755' },
	{ city: 'Killyfad (Longford)', zip: '590470' },
	{ city: 'Killyfana (Cavan)', zip: '384779' },
	{ city: 'Killyfaragh (Monaghan)', zip: '282424' },
	{ city: 'Killyfargy (Monaghan)', zip: '735319' },
	{ city: 'Killyfassy (Cavan)', zip: '303174' },
	{ city: 'Killyfea (Leitrim)', zip: '341704' },
	{ city: 'Killyfern (Cavan)', zip: '935836' },
	{ city: 'Killyfinla (Cavan)', zip: '186683' },
	{ city: 'Killyfuddy (Monaghan)', zip: '587704' },
	{ city: 'Killygally (Monaghan)', zip: '461032' },
	{ city: 'Killyganard (Laois)', zip: '553394' },
	{ city: 'Killygar (Leitrim)', zip: '954218' },
	{ city: 'Killygarry (Cavan)', zip: '173495' },
	{ city: 'Killygarvan Lower (Donegal)', zip: '298685' },
	{ city: 'Killygarvan Upper (Donegal)', zip: '552841' },
	{ city: 'Killygavna (Monaghan)', zip: '307732' },
	{ city: 'Killygola (Monaghan)', zip: '996961' },
	{ city: 'Killygone (Monaghan)', zip: '221262' },
	{ city: 'Killygordon (Donegal)', zip: '480779' },
	{ city: 'Killygorman (Cavan)', zip: '720872' },
	{ city: 'Killygorman (Monaghan)', zip: '499257' },
	{ city: 'Killygowan (Cavan)', zip: '779110' },
	{ city: 'Killygowan (Monaghan)', zip: '737460' },
	{ city: 'Killygragy (Monaghan)', zip: '938968' },
	{ city: 'Killygrallan (Monaghan)', zip: '466266' },
	{ city: 'Killygreagh (Cavan)', zip: '757529' },
	{ city: 'Killygrogan (Cavan)', zip: '478213' },
	{ city: 'Killyguire (Kildare)', zip: '418781' },
	{ city: 'Killyhoman (Monaghan)', zip: '723195' },
	{ city: 'Killykeen (Cavan)', zip: '179067' },
	{ city: 'Killykeeragh (Monaghan)', zip: '870115' },
	{ city: 'Killykeskeame (Monaghan)', zip: '580724' },
	{ city: 'Killylaragh (Monaghan)', zip: '676819' },
	{ city: 'Killylastin (Donegal)', zip: '163181' },
	{ city: 'Killylaughnane (Tipperary)', zip: '673005' },
	{ city: 'Killylea (Cavan)', zip: '681266' },
	{ city: 'Killylea (Mayo)', zip: '459038' },
	{ city: 'Killyleck (Monaghan)', zip: '458669' },
	{ city: 'Killyleen (Monaghan)', zip: '617824' },
	{ city: 'Killyleg (Monaghan)', zip: '512019' },
	{ city: 'Killyliss (Monaghan)', zip: '347390' },
	{ city: 'Killylough (Monaghan)', zip: '374436' },
	{ city: 'Killyloughavoy (Monaghan)', zip: '229896' },
	{ city: 'Killymacaran (Cavan)', zip: '885606' },
	{ city: 'Killymarly (Monaghan)', zip: '840669' },
	{ city: 'Killymarran (Monaghan)', zip: '554093' },
	{ city: 'Killymasny (Donegal)', zip: '292857' },
	{ city: 'Killymeehan (Cavan)', zip: '491168' },
	{ city: 'Killymeehin (Leitrim)', zip: '333566' },
	{ city: 'Killymonaghan (Monaghan)', zip: '216609' },
	{ city: 'Killymongaun (Galway)', zip: '547861' },
	{ city: 'Killymoriarty (Cavan)', zip: '378837' },
	{ city: 'Killymullin (Cavan)', zip: '130094' },
	{ city: 'Killymurry (Monaghan)', zip: '779048' },
	{ city: 'Killynaff (Cavan)', zip: '281096' },
	{ city: 'Killynagh Beg (Roscommon)', zip: '832044' },
	{ city: 'Killynagh More (Roscommon)', zip: '320135' },
	{ city: 'Killynaher (Cavan)', zip: '572720' },
	{ city: 'Killynan (Westmeath)', zip: '343697' },
	{ city: 'Killynann (Wexford)', zip: '701734' },
	{ city: 'Killynanum (Cavan)', zip: '327964' },
	{ city: 'Killyneary (Cavan)', zip: '156359' },
	{ city: 'Killynebber (Cavan)', zip: '380291' },
	{ city: 'Killyneill (Monaghan)', zip: '485826' },
	{ city: 'Killynenagh (Monaghan)', zip: '848056' },
	{ city: 'Killynure (Cavan)', zip: '584980' },
	{ city: 'Killynure (Donegal)', zip: '392711' },
	{ city: 'Killyon (Kildare)', zip: '201735' },
	{ city: 'Killyon (Meath)', zip: '805248' },
	{ city: 'Killyon (Offaly)', zip: '232080' },
	{ city: 'Killyran (Cavan)', zip: '744918' },
	{ city: 'Killyrean Lower (Monaghan)', zip: '942347' },
	{ city: 'Killyrean Upper (Monaghan)', zip: '682686' },
	{ city: 'Killyreask (Monaghan)', zip: '549364' },
	{ city: 'Killyrue (Cavan)', zip: '121613' },
	{ city: 'Killyshane (Carlow)', zip: '868402' },
	{ city: 'Killyslavan (Monaghan)', zip: '792926' },
	{ city: 'Killytawny (Cavan)', zip: '839560' },
	{ city: 'Killyteane (Cavan)', zip: '361091' },
	{ city: 'Killytogher (Cavan)', zip: '597705' },
	{ city: 'Killytur (Monaghan)', zip: '603530' },
	{ city: 'Killyvaghan (Cavan)', zip: '693113' },
	{ city: 'Killyvahan (Cavan)', zip: '892751' },
	{ city: 'Killyvally (Cavan)', zip: '996646' },
	{ city: 'Killyvane (Monaghan)', zip: '451634' },
	{ city: 'Killyvanny (Cavan)', zip: '371645' },
	{ city: 'Killyvehy (Leitrim)', zip: '263619' },
	{ city: 'Killyverry (Donegal)', zip: '434460' },
	{ city: 'Killywaum (Cavan)', zip: '920728' },
	{ city: 'Killywillin (Cavan)', zip: '329702' },
	{ city: 'Killywilly (Cavan)', zip: '187043' },
	{ city: 'Kilmacabea (Cork)', zip: '599292' },
	{ city: 'Kilmacahill (Cork)', zip: '766911' },
	{ city: 'Kilmacahill (Kilkenny)', zip: '124648' },
	{ city: 'Kilmacahill (Westmeath)', zip: '617342' },
	{ city: 'Kilmacananneny (Roscommon)', zip: '585540' },
	{ city: 'Kilmacanearla North (Limerick)', zip: '608591' },
	{ city: 'Kilmacanearla South (Limerick)', zip: '281072' },
	{ city: 'Kilmacanelly (Mayo)', zip: '203056' },
	{ city: 'Kilmacannon (Longford)', zip: '967691' },
	{ city: 'Kilmacannon (Sligo)', zip: '759981' },
	{ city: 'Kilmacanoge (Wicklow)', zip: '996102' },
	{ city: 'Kilmacanoge North (Wicklow)', zip: '862368' },
	{ city: 'Kilmacanoge South (Wicklow)', zip: '906946' },
	{ city: 'Kilmacar (Kilkenny)', zip: '815007' },
	{ city: 'Kilmacarril (Roscommon)', zip: '580025' },
	{ city: 'Kilmacart (Carlow)', zip: '799278' },
	{ city: 'Kilmacat (Limerick)', zip: '639433' },
	{ city: 'Kilmacdermot (Wexford)', zip: '689713' },
	{ city: 'Kilmacduagh (Galway)', zip: '786887' },
	{ city: 'Kilmacduagh (Mayo)', zip: '959822' },
	{ city: 'Kilmacduane East (Clare)', zip: '615966' },
	{ city: 'Kilmacduane West (Clare)', zip: '861478' },
	{ city: 'Kilmachugh (Galway)', zip: '666170' },
	{ city: 'Kilmackerrin East (Kerry)', zip: '916202' },
	{ city: 'Kilmackerrin West (Kerry)', zip: '575982' },
	{ city: 'Kilmackilloo (Donegal)', zip: '633120' },
	{ city: 'Kilmackowen (Cork)', zip: '904395' },
	{ city: 'Kilmacleague East (Waterford)', zip: '506956' },
	{ city: 'Kilmacleague West (Waterford)', zip: '456786' },
	{ city: 'Kilmaclenine (Cork)', zip: '109541' },
	{ city: 'Kilmacnevan (Westmeath)', zip: '149831' },
	{ city: 'Kilmacnoran (Cavan)', zip: '756397' },
	{ city: 'Kilmacoe (Wexford)', zip: '314475' },
	{ city: 'Kilmacogue (Limerick)', zip: '182573' },
	{ city: 'Kilmacogue (Tipperary)', zip: '878679' },
	{ city: 'Kilmacoliver (Kilkenny)', zip: '279432' },
	{ city: 'Kilmacomb (Waterford)', zip: '319010' },
	{ city: 'Kilmacomma (Tipperary)', zip: '491171' },
	{ city: 'Kilmacomma (Waterford)', zip: '397118' },
	{ city: 'Kilmacoo (Wicklow)', zip: '638035' },
	{ city: 'Kilmacoom (Cork)', zip: '883490' },
	{ city: 'Kilmacoo Upper (Wicklow)', zip: '341803' },
	{ city: 'Kilmacot (Wexford)', zip: '556036' },
	{ city: 'Kilmacow (Cork)', zip: '541712' },
	{ city: 'Kilmacow (Kilkenny)', zip: '264181' },
	{ city: 'Kilmacow (Limerick)', zip: '433879' },
	{ city: 'Kilmacowen (Sligo)', zip: '338320' },
	{ city: 'Kilmacrade (Mayo)', zip: '747697' },
	{ city: 'Kilmacrah (Galway)', zip: '494243' },
	{ city: 'Kilmacrea Lower (Wicklow)', zip: '614195' },
	{ city: 'Kilmacrea Upper (Wicklow)', zip: '218227' },
	{ city: 'Kilmacreddan (Donegal)', zip: '320633' },
	{ city: 'Kilmacredock Lower (Kildare)', zip: '254202' },
	{ city: 'Kilmacredock Upper (Kildare)', zip: '916556' },
	{ city: 'Kilmacree (Dublin)', zip: '325853' },
	{ city: 'Kilmacree (Wexford)', zip: '716952' },
	{ city: 'Kilmacrenan (Donegal)', zip: '444119' },
	{ city: 'Kilmacrickard (Galway)', zip: '105638' },
	{ city: 'Kilmacroy (Roscommon)', zip: '254818' },
	{ city: 'Kilmacshane (Galway)', zip: '174110' },
	{ city: 'Kilmacshane (Kilkenny)', zip: '458201' },
	{ city: 'Kilmacsherwell (Leitrim)', zip: '452960' },
	{ city: 'Kilmacsimon (Cork)', zip: '697093' },
	{ city: 'Kilmactalway (Dublin)', zip: '465461' },
	{ city: 'Kilmacteige (Sligo)', zip: '295103' },
	{ city: 'Kilmacthomas (Waterford)', zip: '263723' },
	{ city: 'Kilmactranny (Sligo)', zip: '323724' },
	{ city: 'Kilmactrasna (Monaghan)', zip: '928587' },
	{ city: 'Kilmacuagh (Roscommon)', zip: '721321' },
	{ city: 'Kilmacuagh (Westmeath)', zip: '757661' },
	{ city: 'Kilmacud (Dublin)', zip: '981992' },
	{ city: 'Kilmacuddy (Offaly)', zip: '345395' },
	{ city: 'Kilmacuddy (Tipperary)', zip: '210732' },
	{ city: 'Kilmacud East (Dublin)', zip: '454819' },
	{ city: 'Kilmacud West (Dublin)', zip: '726554' },
	{ city: 'Kilmaculla (Cork)', zip: '841661' },
	{ city: 'Kilmacullagh (Wicklow)', zip: '794409' },
	{ city: 'Kilmacumsy (Roscommon)', zip: '819171' },
	{ city: 'Kilmacurkan (Sligo)', zip: '183327' },
	{ city: 'Kilmacurra East (Wicklow)', zip: '136784' },
	{ city: 'Kilmacurrane (Cork)', zip: '474433' },
	{ city: 'Kilmacurra West (Wicklow)', zip: '830908' },
	{ city: 'Kilmaddaroe (Leitrim)', zip: '197838' },
	{ city: 'Kilmademoge (Kilkenny)', zip: '670870' },
	{ city: 'Kilmadum (Kilkenny)', zip: '864158' },
	{ city: 'Kilmaganny (Kilkenny)', zip: '451429' },
	{ city: 'Kilmagar (Kilkenny)', zip: '144046' },
	{ city: 'Kilmagarvoge (Carlow)', zip: '786749' },
	{ city: 'Kilmaghera (Leitrim)', zip: '607591' },
	{ city: 'Kilmagibboge (Waterford)', zip: '920986' },
	{ city: 'Kilmagig Lower (Wicklow)', zip: '694509' },
	{ city: 'Kilmagig Upper (Wicklow)', zip: '605849' },
	{ city: 'Kilmaglasderry (Tipperary)', zip: '925063' },
	{ city: 'Kilmaglin (Carlow)', zip: '231073' },
	{ city: 'Kilmaglish (Westmeath)', zip: '271896' },
	{ city: 'Kilmaglush (Carlow)', zip: '632795' },
	{ city: 'Kilmagner (Cork)', zip: '151981' },
	{ city: 'Kilmagorroge (Kildare)', zip: '868648' },
	{ city: 'Kilmagoura (Cork)', zip: '684880' },
	{ city: 'Kilmahon (Longford)', zip: '707217' },
	{ city: 'Kilmahuddrick (Dublin)', zip: '217080' },
	{ city: 'Kilmaine (Mayo)', zip: '685104' },
	{ city: 'Kilmaine (Offaly)', zip: '827977' },
	{ city: 'Kilmainepark (Mayo)', zip: '629366' },
	{ city: 'Kilmainham (Cavan)', zip: '565701' },
	{ city: 'Kilmainham (Dublin)', zip: '108664' },
	{ city: 'Kilmainham (Laois)', zip: '642138' },
	{ city: 'Kilmainham (Meath)', zip: '729269' },
	{ city: 'Kilmainhamwood (Meath)', zip: '685739' },
	{ city: 'Kilmakaroge (Cork)', zip: '449601' },
	{ city: 'Kilmakenny (Leitrim)', zip: '150929' },
	{ city: 'Kilmakerrill (Leitrim)', zip: '151657' },
	{ city: 'Kilmakevoge (Kilkenny)', zip: '331413' },
	{ city: 'Kilmakill (Tipperary)', zip: '653020' },
	{ city: 'Kilmakilloge (Kerry)', zip: '673725' },
	{ city: 'Kilmakinlan (Longford)', zip: '975841' },
	{ city: 'Kilmalady Big (Offaly)', zip: '760977' },
	{ city: 'Kilmalady Little (Offaly)', zip: '741597' },
	{ city: 'Kilmalaw (Galway)', zip: '205135' },
	{ city: 'Kilmaleery (Clare)', zip: '206315' },
	{ city: 'Kilmaley (Clare)', zip: '880413' },
	{ city: 'Kilmalin (Wicklow)', zip: '332028' },
	{ city: 'Kilmalinoge (Galway)', zip: '234784' },
	{ city: 'Kilmalkedar (Kerry)', zip: '132960' },
	{ city: 'Kilmallock (Limerick)', zip: '342803' },
	{ city: 'Kilmallock (Wexford)', zip: '518698' },
	{ city: 'Kilmallock Hill (Limerick)', zip: '122967' },
	{ city: 'Kilmaloda (Cork)', zip: '690020' },
	{ city: 'Kilmaloge (Tipperary)', zip: '514550' },
	{ city: 'Kilmalogue (Offaly)', zip: '130503' },
	{ city: 'Kilmaloo (Waterford)', zip: '300466' },
	{ city: 'Kilmalooda (Cork)', zip: '337743' },
	{ city: 'Kilmaloo East (Waterford)', zip: '617162' },
	{ city: 'Kilmaloo West (Waterford)', zip: '389309' },
	{ city: 'Kilmalum (Kildare)', zip: '690719' },
	{ city: 'Kilmanagh (Kilkenny)', zip: '520053' },
	{ city: 'Kilmanaghan (Offaly)', zip: '175045' },
	{ city: 'Kilmanahan (Waterford)', zip: '276790' },
	{ city: 'Kilmanaheen (Kilkenny)', zip: '521478' },
	{ city: 'Kilmanahin (Kilkenny)', zip: '710005' },
	{ city: 'Kilmaneen (Tipperary)', zip: '963364' },
	{ city: 'Kilmangah (Kilkenny)', zip: '101862' },
	{ city: 'Kilmanicholas (Waterford)', zip: '572386' },
	{ city: 'Kilmaniheen East (Kerry)', zip: '238732' },
	{ city: 'Kilmaniheen West (Kerry)', zip: '929678' },
	{ city: 'Kilmanman (Laois)', zip: '860036' },
	{ city: 'Kilmannan (Wexford)', zip: '626720' },
	{ city: 'Kilmannan Little (Wexford)', zip: '163245' },
	{ city: 'Kilmannin (Mayo)', zip: '593069' },
	{ city: 'Kilmannock (Wexford)', zip: '732886' },
	{ city: 'Kilmanoge (Wicklow)', zip: '361225' },
	{ city: 'Kilmaquague (Waterford)', zip: '828375' },
	{ city: 'Kilmartin (Dublin)', zip: '400703' },
	{ city: 'Kilmartin (Laois)', zip: '978433' },
	{ city: 'Kilmartin (Wicklow)', zip: '406324' },
	{ city: 'Kilmartin Lower (Cork)', zip: '930696' },
	{ city: 'Kilmartin Upper (Cork)', zip: '954151' },
	{ city: 'Kilmashogue (Dublin)', zip: '550545' },
	{ city: 'Kilmass (Roscommon)', zip: '735013' },
	{ city: 'Kilmastulla (Tipperary)', zip: '496012' },
	{ city: 'Kilmead (Kildare)', zip: '736509' },
	{ city: 'Kilmeadan (Waterford)', zip: '102306' },
	{ city: 'Kilmeage (Kildare)', zip: '769708' },
	{ city: 'Kilmeage Little (Kildare)', zip: '707003' },
	{ city: 'Kilmeany (Carlow)', zip: '218515' },
	{ city: 'Kilmeany (Kerry)', zip: '150232' },
	{ city: 'Kilmeedy (Limerick)', zip: '263944' },
	{ city: 'Kilmeedy East (Cork)', zip: '326631' },
	{ city: 'Kilmeedy East (Waterford)', zip: '183162' },
	{ city: 'Kilmeedy West (Cork)', zip: '705650' },
	{ city: 'Kilmeedy West (Waterford)', zip: '899996' },
	{ city: 'Kilmeelchon (Offaly)', zip: '564167' },
	{ city: 'Kilmeelickin (Galway)', zip: '709358' },
	{ city: 'Kilmeen (Cork)', zip: '866910' },
	{ city: 'Kilmeen (Galway)', zip: '970765' },
	{ city: 'Kilmeena (Mayo)', zip: '768359' },
	{ city: 'Kilmelan (Tipperary)', zip: '884960' },
	{ city: 'Kilmessan (Meath)', zip: '865076' },
	{ city: 'Kilmichael (Cork)', zip: '807335' },
	{ city: 'Kilmichael (Wexford)', zip: '955845' },
	{ city: 'Kilmichael East (Cork)', zip: '165039' },
	{ city: 'Kilmichaelhill (Wexford)', zip: '383743' },
	{ city: 'Kilmichael Lower (Wexford)', zip: '998811' },
	{ city: 'Kilmichael Upper (Wexford)', zip: '522904' },
	{ city: 'Kilmichael West (Cork)', zip: '102182' },
	{ city: 'Kilmihil (Clare)', zip: '105693' },
	{ city: 'Kilmihil (Limerick)', zip: '703049' },
	{ city: 'Kilmilan (Laois)', zip: '185033' },
	{ city: 'Kilminchy (Laois)', zip: '733912' },
	{ city: 'Kilminfoyle (Laois)', zip: '364794' },
	{ city: 'Kilminnick East (Kilkenny)', zip: '714759' },
	{ city: 'Kilminnick West (Kilkenny)', zip: '278887' },
	{ city: 'Kilminnin Lower (Waterford)', zip: '326164' },
	{ city: 'Kilminnin North (Waterford)', zip: '446391' },
	{ city: 'Kilminnin South (Waterford)', zip: '749293' },
	{ city: 'Kilminnin Upper (Waterford)', zip: '825981' },
	{ city: 'Kilmissan (Carlow)', zip: '792420' },
	{ city: 'Kilmisten (Wexford)', zip: '267000' },
	{ city: 'Kilmochonna (Offaly)', zip: '163028' },
	{ city: 'Kilmocolmock (Roscommon)', zip: '285643' },
	{ city: 'Kilmoculla (Clare)', zip: '609238' },
	{ city: 'Kilmog (Kilkenny)', zip: '320651' },
	{ city: 'Kilmogue (Kilkenny)', zip: '799879' },
	{ city: 'Kilmolash (Waterford)', zip: '930055' },
	{ city: 'Kilmolash Lower (Tipperary)', zip: '156992' },
	{ city: 'Kilmolash Upper (Tipperary)', zip: '928376' },
	{ city: 'Kilmona (Cork)', zip: '423773' },
	{ city: 'Kilmonaster Lower (Donegal)', zip: '994840' },
	{ city: 'Kilmonaster Middle (Donegal)', zip: '705586' },
	{ city: 'Kilmoney (Cork)', zip: '890048' },
	{ city: 'Kilmoney North (Kildare)', zip: '694392' },
	{ city: 'Kilmoney South (Kildare)', zip: '613827' },
	{ city: 'Kilmoon (Cork)', zip: '655336' },
	{ city: 'Kilmoon (Meath)', zip: '997247' },
	{ city: 'Kilmoon East (Clare)', zip: '135690' },
	{ city: 'Kilmoon West (Clare)', zip: '444128' },
	{ city: 'Kilmoraun (Clare)', zip: '438706' },
	{ city: 'Kilmore (Cavan)', zip: '906195' },
	{ city: 'Kilmore (Clare)', zip: '148932' },
	{ city: 'Kilmore (Cork)', zip: '203158' },
	{ city: 'Kilmore (Donegal)', zip: '209466' },
	{ city: 'Kilmore (Dublin)', zip: '170291' },
	{ city: 'Kilmore (Galway)', zip: '129141' },
	{ city: 'Kilmore (Kerry)', zip: '461959' },
	{ city: 'Kilmore (Kildare)', zip: '243996' },
	{ city: 'Kilmore (Leitrim)', zip: '819313' },
	{ city: 'Kilmore (Limerick)', zip: '177055' },
	{ city: 'Kilmore (Longford)', zip: '159969' },
	{ city: 'Kilmore (Mayo)', zip: '357238' },
	{ city: 'Kilmore (Meath)', zip: '437172' },
	{ city: 'Kilmore (Offaly)', zip: '307106' },
	{ city: 'Kilmore (Roscommon)', zip: '471566' },
	{ city: 'Kilmore (Tipperary)', zip: '815437' },
	{ city: 'Kilmore (Waterford)', zip: '275864' },
	{ city: 'Kilmore (Westmeath)', zip: '880560' },
	{ city: 'Kilmore (Wexford)', zip: '358063' },
	{ city: 'Kilmore Big (Dublin)', zip: '547501' },
	{ city: 'Kilmorebrannagh (Kildare)', zip: '488202' },
	{ city: 'Kilmore Demesne (Limerick)', zip: '801945' },
	{ city: 'Kilmore East (Monaghan)', zip: '320613' },
	{ city: 'Kilmore East (Waterford)', zip: '904528' },
	{ city: 'Kilmoreen (Limerick)', zip: '602223' },
	{ city: 'Kilmore Lower (Cavan)', zip: '464724' },
	{ city: 'Kilmore Lower (Longford)', zip: '490624' },
	{ city: 'Kilmore Lower (Tipperary)', zip: '658310' },
	{ city: 'Kilmoremoy (Mayo)', zip: '377709' },
	{ city: 'Kilmore North (Clare)', zip: '736655' },
	{ city: 'Kilmore Quay (Wexford)', zip: '200555' },
	{ city: 'Kilmore South (Clare)', zip: '231535' },
	{ city: 'Kilmore Upper (Cavan)', zip: '766359' },
	{ city: 'Kilmore Upper (Longford)', zip: '676411' },
	{ city: 'Kilmore Upper (Tipperary)', zip: '288000' },
	{ city: 'Kilmore West (Monaghan)', zip: '502536' },
	{ city: 'Kilmore West (Waterford)', zip: '931360' },
	{ city: 'Kilmorgan (Sligo)', zip: '965482' },
	{ city: 'Kilmorna (Kerry)', zip: '425139' },
	{ city: 'Kilmorony (Laois)', zip: '292444' },
	{ city: 'Kilmountain (Cork)', zip: '420150' },
	{ city: 'Kilmovee (Mayo)', zip: '695008' },
	{ city: 'Kilmovee (Waterford)', zip: '185589' },
	{ city: 'Kilmoyemoge East (Waterford)', zip: '381972' },
	{ city: 'Kilmoyemoge West (Waterford)', zip: '919113' },
	{ city: 'Kilmoylan (Limerick)', zip: '641153' },
	{ city: 'Kilmoylan Lower (Limerick)', zip: '450379' },
	{ city: 'Kilmoylan Upper (Limerick)', zip: '997703' },
	{ city: 'Kilmoyle (Longford)', zip: '750372' },
	{ city: 'Kilmoyler (Tipperary)', zip: '517984' },
	{ city: 'Kilmoylerane North (Cork)', zip: '220023' },
	{ city: 'Kilmoylerane South (Cork)', zip: '631838' },
	{ city: 'Kilmoylin (Waterford)', zip: '745367' },
	{ city: 'Kilmoyly North (Kerry)', zip: '408793' },
	{ city: 'Kilmoyly South (Kerry)', zip: '971860' },
	{ city: 'Kilmucklin (Offaly)', zip: '524983' },
	{ city: 'Kilmuckridge (Wexford)', zip: '438014' },
	{ city: 'Kilmulhane (Kerry)', zip: '927580' },
	{ city: 'Kilmullen (Laois)', zip: '658867' },
	{ city: 'Kilmullin (Wicklow)', zip: '366668' },
	{ city: 'Kilmur (Meath)', zip: '868004' },
	{ city: 'Kilmurragh (Offaly)', zip: '561551' },
	{ city: 'Kilmurriheen (Cork)', zip: '333784' },
	{ city: 'Kilmurrily (Kerry)', zip: '961257' },
	{ city: 'Kilmurrin (Waterford)', zip: '748464' },
	{ city: 'Kilmurry (Carlow)', zip: '678266' },
	{ city: 'Kilmurry (Clare)', zip: '695543' },
	{ city: 'Kilmurry (Cork)', zip: '353836' },
	{ city: 'Kilmurry (Galway)', zip: '546599' },
	{ city: 'Kilmurry (Kerry)', zip: '287216' },
	{ city: 'Kilmurry (Kildare)', zip: '736648' },
	{ city: 'Kilmurry (Kilkenny)', zip: '412551' },
	{ city: 'Kilmurry (Laois)', zip: '289390' },
	{ city: 'Kilmurry (Limerick)', zip: '496452' },
	{ city: 'Kilmurry (Meath)', zip: '640328' },
	{ city: 'Kilmurry (Monaghan)', zip: '992203' },
	{ city: 'Kilmurry (Offaly)', zip: '183453' },
	{ city: 'Kilmurry (Roscommon)', zip: '169233' },
	{ city: 'Kilmurry (Tipperary)', zip: '965898' },
	{ city: 'Kilmurry (Waterford)', zip: '975406' },
	{ city: 'Kilmurry (Wexford)', zip: '986147' },
	{ city: 'Kilmurry (Wicklow)', zip: '571023' },
	{ city: 'Kilmurry Beg (Mayo)', zip: '226158' },
	{ city: 'Kilmurrybog (Limerick)', zip: '540401' },
	{ city: 'Kilmurry East (Clare)', zip: '657391' },
	{ city: 'Kilmurryely (Offaly)', zip: '694515' },
	{ city: 'Kilmurry Lower (Wicklow)', zip: '232960' },
	{ city: 'Kilmurry Middle (Wicklow)', zip: '316717' },
	{ city: 'Kilmurry More (Mayo)', zip: '251978' },
	{ city: 'Kilmurry North (Cork)', zip: '911837' },
	{ city: 'Kilmurry North (Wicklow)', zip: '223723' },
	{ city: 'Kilmurry South (Cork)', zip: '610180' },
	{ city: 'Kilmurry South (Wicklow)', zip: '188509' },
	{ city: 'Kilmurry Upper (Wicklow)', zip: '497252' },
	{ city: 'Kilmurry West (Clare)', zip: '587006' },
	{ city: 'Kilmurvy (Galway)', zip: '431966' },
	{ city: 'Kilnabinnia (Offaly)', zip: '319538' },
	{ city: 'Kilnabooley (Kildare)', zip: '134282' },
	{ city: 'Kilnaborris (Galway)', zip: '195693' },
	{ city: 'Kilnabrack Lower (Kerry)', zip: '429877' },
	{ city: 'Kilnabrack Upper (Kerry)', zip: '916310' },
	{ city: 'Kilnacally (Clare)', zip: '610415' },
	{ city: 'Kilnacally (Cork)', zip: '159434' },
	{ city: 'Kilnacappagh (Tipperary)', zip: '446189' },
	{ city: 'Kilnacarra (Offaly)', zip: '472408' },
	{ city: 'Kilnacarriga (Tipperary)', zip: '570005' },
	{ city: 'Kilnacarriga (Waterford)', zip: '872763' },
	{ city: 'Kilnacarrow (Longford)', zip: '138268' },
	{ city: 'Kilnacash (Laois)', zip: '984042' },
	{ city: 'Kilnacask Lower (Tipperary)', zip: '207933' },
	{ city: 'Kilnacask Upper (Tipperary)', zip: '388666' },
	{ city: 'Kilnaclasha (Cork)', zip: '356873' },
	{ city: 'Kilnaclay (Monaghan)', zip: '963445' },
	{ city: 'Kilnacloghy (Roscommon)', zip: '790874' },
	{ city: 'Kilnacloona (Cork)', zip: '123501' },
	{ city: 'Kilnacloy (Monaghan)', zip: '253208' },
	{ city: 'Kilnacor (Cavan)', zip: '903547' },
	{ city: 'Kilnacran (Monaghan)', zip: '564335' },
	{ city: 'Kilnacranagh (Cavan)', zip: '974422' },
	{ city: 'Kilnacranagh East (Cork)', zip: '845762' },
	{ city: 'Kilnacranagh West (Cork)', zip: '510318' },
	{ city: 'Kilnacrandy (Clare)', zip: '574381' },
	{ city: 'Kilnacranfy (Monaghan)', zip: '785732' },
	{ city: 'Kilnacranna (Tipperary)', zip: '750368' },
	{ city: 'Kilnacreagh (Clare)', zip: '789529' },
	{ city: 'Kilnacreeve (Cavan)', zip: '698422' },
	{ city: 'Kilnacreevy (Cavan)', zip: '231060' },
	{ city: 'Kilnacreevy (Leitrim)', zip: '803607' },
	{ city: 'Kilnacrew (Cavan)', zip: '636459' },
	{ city: 'Kilnacross (Cavan)', zip: '905351' },
	{ city: 'Kilnacrott (Cavan)', zip: '387845' },
	{ city: 'Kilnadreen (Monaghan)', zip: '108414' },
	{ city: 'Kilnadrow (Cork)', zip: '394138' },
	{ city: 'Kilnadur (Cork)', zip: '248227' },
	{ city: 'Kilnafaddoge (Westmeath)', zip: '658097' },
	{ city: 'Kilnafarna Lower (Waterford)', zip: '336033' },
	{ city: 'Kilnafarna Upper (Waterford)', zip: '234756' },
	{ city: 'Kilnafrehan East (Waterford)', zip: '365706' },
	{ city: 'Kilnafrehan Middle (Waterford)', zip: '277293' },
	{ city: 'Kilnafrehanmountain (Waterford)', zip: '127291' },
	{ city: 'Kilnafrehan West (Waterford)', zip: '143239' },
	{ city: 'Kilnafurrery (Cork)', zip: '734757' },
	{ city: 'Kilnagall (Offaly)', zip: '446796' },
	{ city: 'Kilnagalliagh (Clare)', zip: '378927' },
	{ city: 'Kilnagalliagh (Meath)', zip: '185520' },
	{ city: 'Kilnagalliagh (Westmeath)', zip: '140756' },
	{ city: 'Kilnagappagh (Galway)', zip: '632686' },
	{ city: 'Kilnagarbet (Cavan)', zip: '940692' },
	{ city: 'Kilnagarnagh (Offaly)', zip: '408260' },
	{ city: 'Kilnagarns Lower (Leitrim)', zip: '232493' },
	{ city: 'Kilnagarns Upper (Leitrim)', zip: '922680' },
	{ city: 'Kilnageer (Mayo)', zip: '727706' },
	{ city: 'Kilnageer (Monaghan)', zip: '590859' },
	{ city: 'Kilnaglare (Cavan)', zip: '734966' },
	{ city: 'Kilnaglare Lower (Cavan)', zip: '824944' },
	{ city: 'Kilnaglare Upper (Cavan)', zip: '526059' },
	{ city: 'Kilnaglearagh (Kerry)', zip: '596853' },
	{ city: 'Kilnaglery (Cork)', zip: '510872' },
	{ city: 'Kilnaglinny (Offaly)', zip: '410589' },
	{ city: 'Kilnaglory (Cork)', zip: '246142' },
	{ city: 'Kilnagnady (Cork)', zip: '530875' },
	{ city: 'Kilnagoolny (Offaly)', zip: '361279' },
	{ city: 'Kilnagornan (Kildare)', zip: '857427' },
	{ city: 'Kilnagospagh (Cork)', zip: '339747' },
	{ city: 'Kilnagower (Mayo)', zip: '845985' },
	{ city: 'Kilnagralta (Roscommon)', zip: '319613' },
	{ city: 'Kilnagranagh (Tipperary)', zip: '228684' },
	{ city: 'Kilnagrange (Waterford)', zip: '312212' },
	{ city: 'Kilnagross (Leitrim)', zip: '265481' },
	{ city: 'Kilnagross (Meath)', zip: '474068' },
	{ city: 'Kilnagullan (Monaghan)', zip: '535728' },
	{ city: 'Kilnagun (Cavan)', zip: '964987' },
	{ city: 'Kilnagurteen (Cork)', zip: '290186' },
	{ city: 'Kilnahaltar (Monaghan)', zip: '189118' },
	{ city: 'Kilnahard (Cavan)', zip: '281685' },
	{ city: 'Kilnaharry (Sligo)', zip: '762668' },
	{ city: 'Kilnaharvey (Monaghan)', zip: '587997' },
	{ city: 'Kilnahera East (Cork)', zip: '387965' },
	{ city: 'Kilnahera West (Cork)', zip: '186831' },
	{ city: 'Kilnahinch (Westmeath)', zip: '861739' },
	{ city: 'Kilnahone (Cork)', zip: '821774' },
	{ city: 'Kilnahone (Tipperary)', zip: '425681' },
	{ city: 'Kilnahown (Galway)', zip: '114228' },
	{ city: 'Kilnahue (Wexford)', zip: '844133' },
	{ city: 'Kilnahulla Beg (Cork)', zip: '448628' },
	{ city: 'Kilnahulla More (Cork)', zip: '486676' },
	{ city: 'Kilnaknappoge (Cork)', zip: '205953' },
	{ city: 'Kilnalacka (Offaly)', zip: '555138' },
	{ city: 'Kilnalag (Galway)', zip: '801252' },
	{ city: 'Kilnalappa (Galway)', zip: '910860' },
	{ city: 'Kilnaleck (Cavan)', zip: '234913' },
	{ city: 'Kilnalosset (Roscommon)', zip: '882833' },
	{ city: 'Kilnalug (Westmeath)', zip: '734374' },
	{ city: 'Kilnalun (Meath)', zip: '591090' },
	{ city: 'Kilnamack East (Waterford)', zip: '589858' },
	{ city: 'Kilnamack West (Waterford)', zip: '259001' },
	{ city: 'Kilnamaddy (Monaghan)', zip: '742642' },
	{ city: 'Kilnamaddyroe (Leitrim)', zip: '172131' },
	{ city: 'Kilnamanagh (Dublin)', zip: '524390' },
	{ city: 'Kilnamanagh (Roscommon)', zip: '805601' },
	{ city: 'Kilnamanagh (Sligo)', zip: '899291' },
	{ city: 'Kilnamanagh Beg (Wicklow)', zip: '899188' },
	{ city: 'Kilnamanagh Lower (Wexford)', zip: '541207' },
	{ city: 'Kilnamanagh More (Wicklow)', zip: '716946' },
	{ city: 'Kilnamanagh Upper (Wexford)', zip: '331047' },
	{ city: 'Kilnamarve (Leitrim)', zip: '392470' },
	{ city: 'Kilnameela (Cork)', zip: '703385' },
	{ city: 'Kilnamona (Clare)', zip: '968468' },
	{ city: 'Kilnamona (Limerick)', zip: '538161' },
	{ city: 'Kilnamona (Tipperary)', zip: '191473' },
	{ city: 'Kilnamoragh North (Kildare)', zip: '583152' },
	{ city: 'Kilnamoragh South (Kildare)', zip: '423595' },
	{ city: 'Kilnamryall (Roscommon)', zip: '515231' },
	{ city: 'Kilnamucky (Cork)', zip: '364429' },
	{ city: 'Kilnamullaun (Galway)', zip: '674163' },
	{ city: 'Kilnanare (Kerry)', zip: '573360' },
	{ city: 'Kilnaneave (Tipperary)', zip: '756039' },
	{ city: 'Kilnanooan (Roscommon)', zip: '848630' },
	{ city: 'Kilnantoge Lower (Offaly)', zip: '980968' },
	{ city: 'Kilnantoge Upper (Offaly)', zip: '628030' },
	{ city: 'Kilnarovanagh (Cork)', zip: '295663' },
	{ city: 'Kilnarovanagh (Kerry)', zip: '159058' },
	{ city: 'Kilnaruane (Cork)', zip: '595502' },
	{ city: 'Kilnasavoge (Longford)', zip: '985408' },
	{ city: 'Kilnaseer (Laois)', zip: '791448' },
	{ city: 'Kilnaseer (Tipperary)', zip: '714648' },
	{ city: 'Kilnashanally (Tipperary)', zip: '997810' },
	{ city: 'Kilnashane (Laois)', zip: '447110' },
	{ city: 'Kilnashee (Longford)', zip: '863078' },
	{ city: 'Kilnasillagh (Roscommon)', zip: '842274' },
	{ city: 'Kilnaslieve (Galway)', zip: '992641' },
	{ city: 'Kilnasmuttaun (Wexford)', zip: '256685' },
	{ city: 'Kilnasoolagh (Clare)', zip: '162436' },
	{ city: 'Kilnasudry (Cork)', zip: '622804' },
	{ city: 'Kilnatoora (Cork)', zip: '454823' },
	{ city: 'Kilnavar (Cavan)', zip: '595386' },
	{ city: 'Kilnavara (Cavan)', zip: '119591' },
	{ city: 'Kilnavert (Cavan)', zip: '378756' },
	{ city: 'Kilnew (Meath)', zip: '923109' },
	{ city: 'Kilnew (Wexford)', zip: '759387' },
	{ city: 'Kilnoe (Clare)', zip: '914886' },
	{ city: 'Kilnoe (Tipperary)', zip: '937287' },
	{ city: 'Kilnpark (Donegal)', zip: '502995' },
	{ city: 'Kilpadder (Kerry)', zip: '388385' },
	{ city: 'Kilpadder North (Cork)', zip: '658235' },
	{ city: 'Kilpadder South (Cork)', zip: '809953' },
	{ city: 'Kilpaddoge (Kerry)', zip: '311808' },
	{ city: 'Kilparteen (Tipperary)', zip: '802982' },
	{ city: 'Kilpatrick (Cork)', zip: '320438' },
	{ city: 'Kilpatrick (Kerry)', zip: '894652' },
	{ city: 'Kilpatrick (Kildare)', zip: '302015' },
	{ city: 'Kilpatrick (Louth)', zip: '610378' },
	{ city: 'Kilpatrick (Offaly)', zip: '538084' },
	{ city: 'Kilpatrick (Tipperary)', zip: '299494' },
	{ city: 'Kilpatrick (Westmeath)', zip: '812462' },
	{ city: 'Kilpatrick (Wexford)', zip: '217651' },
	{ city: 'Kilpatrick (Wicklow)', zip: '610594' },
	{ city: 'Kilpeacon (Limerick)', zip: '391343' },
	{ city: 'Kilpedder (Wicklow)', zip: '948143' },
	{ city: 'Kilpedder East (Wicklow)', zip: '630127' },
	{ city: 'Kilpedder West (Wicklow)', zip: '209722' },
	{ city: 'Kilpheak (Donegal)', zip: '852414' },
	{ city: 'Kilpheak (Tipperary)', zip: '528040' },
	{ city: 'Kilphelan (Cork)', zip: '580722' },
	{ city: 'Kilphierish (Westmeath)', zip: '364795' },
	{ city: 'Kilphillibeen (Cork)', zip: '336758' },
	{ city: 'Kilphrasoga (Galway)', zip: '208353' },
	{ city: 'Kilpierce (Wexford)', zip: '252869' },
	{ city: 'Kilpipe (Wicklow)', zip: '227011' },
	{ city: 'Kilpoole Hill (Wicklow)', zip: '871782' },
	{ city: 'Kilpoole Lower (Wicklow)', zip: '667594' },
	{ city: 'Kilpoole Upper (Wicklow)', zip: '581986' },
	{ city: 'Kilpurcel (Laois)', zip: '259408' },
	{ city: 'Kilquade (Wicklow)', zip: '466195' },
	{ city: 'Kilquain (Galway)', zip: '991262' },
	{ city: 'Kilquane (Clare)', zip: '576659' },
	{ city: 'Kilquane (Cork)', zip: '411178' },
	{ city: 'Kilquane (Kerry)', zip: '622041' },
	{ city: 'Kilquane (Limerick)', zip: '432674' },
	{ city: 'Kilqueeny (Wicklow)', zip: '300026' },
	{ city: 'Kilquiggin (Wicklow)', zip: '776558' },
	{ city: 'Kilquilly (Cavan)', zip: '209683' },
	{ city: 'Kilquire Lower (Mayo)', zip: '602342' },
	{ city: 'Kilquire Upper (Mayo)', zip: '936876' },
	{ city: 'Kilrainy (Kildare)', zip: '689257' },
	{ city: 'Kilrane (Wexford)', zip: '408229' },
	{ city: 'Kilranelagh (Wicklow)', zip: '830668' },
	{ city: 'Kilrateera Lower (Clare)', zip: '987560' },
	{ city: 'Kilrateera Upper (Clare)', zip: '185611' },
	{ city: 'Kilrathmurry (Kildare)', zip: '965088' },
	{ city: 'Kilrean (Donegal)', zip: '545755' },
	{ city: 'Kilrean Lower (Donegal)', zip: '785042' },
	{ city: 'Kilrean Upper (Donegal)', zip: '362201' },
	{ city: 'Kilreash (Limerick)', zip: '583690' },
	{ city: 'Kilree (Carlow)', zip: '866433' },
	{ city: 'Kilree (Kilkenny)', zip: '454873' },
	{ city: 'Kilree (Roscommon)', zip: '873280' },
	{ city: 'Kilreekill (Galway)', zip: '494526' },
	{ city: 'Kilreesk (Dublin)', zip: '124389' },
	{ city: 'Kilregane (Tipperary)', zip: '979481' },
	{ city: 'Kilriffet (Tipperary)', zip: '736408' },
	{ city: 'Kilriffin (Meath)', zip: '213471' },
	{ city: 'Kilrodane (Limerick)', zip: '446506' },
	{ city: 'Kilroddan (Roscommon)', zip: '591009' },
	{ city: 'Kilroe (Cork)', zip: '864553' },
	{ city: 'Kilroe (Galway)', zip: '822644' },
	{ city: 'Kilroe (Mayo)', zip: '485430' },
	{ city: 'Kilroe (Tipperary)', zip: '389955' },
	{ city: 'Kilroe East (Galway)', zip: '209662' },
	{ city: 'Kilroe West (Galway)', zip: '491533' },
	{ city: 'Kilroe Wood (Tipperary)', zip: '744433' },
	{ city: 'Kilroghter (Galway)', zip: '549779' },
	{ city: 'Kilronan (Galway)', zip: '225899' },
	{ city: 'Kilronan (Waterford)', zip: '794634' },
	{ city: 'Kilronane East (Cork)', zip: '373662' },
	{ city: 'Kilronane West (Cork)', zip: '892173' },
	{ city: 'Kilronan Mountain (Roscommon)', zip: '259215' },
	{ city: 'Kilrooan (Roscommon)', zip: '686452' },
	{ city: 'Kilroosk (Leitrim)', zip: '292491' },
	{ city: 'Kilroosky (Roscommon)', zip: '342158' },
	{ city: 'Kilrory (Laois)', zip: '388343' },
	{ city: 'Kilross (Donegal)', zip: '244203' },
	{ city: 'Kilross (Sligo)', zip: '833197' },
	{ city: 'Kilross (Tipperary)', zip: '673760' },
	{ city: 'Kilrossanty (Waterford)', zip: '277391' },
	{ city: 'Kilroughil (Clare)', zip: '750658' },
	{ city: 'Kilruane (Cork)', zip: '558981' },
	{ city: 'Kilruane (Tipperary)', zip: '652317' },
	{ city: 'Kilruddery Deerpark (Wicklow)', zip: '627185' },
	{ city: 'Kilruddery Demesne East (Wicklow)', zip: '543205' },
	{ city: 'Kilruddery Demesne West (Wicklow)', zip: '231185' },
	{ city: 'Kilrue (Meath)', zip: '261495' },
	{ city: 'Kilrush (Clare)', zip: '360828' },
	{ city: 'Kilrush (Cork)', zip: '441551' },
	{ city: 'Kilrush (Kildare)', zip: '992568' },
	{ city: 'Kilrush (Kilkenny)', zip: '341245' },
	{ city: 'Kilrush (Leitrim)', zip: '996792' },
	{ city: 'Kilrush (Mayo)', zip: '390812' },
	{ city: 'Kilrush (Tipperary)', zip: '861367' },
	{ city: 'Kilrush (Waterford)', zip: '288346' },
	{ city: 'Kilrusheighter (Sligo)', zip: '257142' },
	{ city: 'Kilrush Lower (Westmeath)', zip: '225085' },
	{ city: 'Kilrush Upper (Westmeath)', zip: '333605' },
	{ city: 'Kilrussane (Cork)', zip: '775296' },
	{ city: 'Kilsallagh (Cavan)', zip: '845467' },
	{ city: 'Kilsallagh (Galway)', zip: '684144' },
	{ city: 'Kilsallagh (Kerry)', zip: '539354' },
	{ city: 'Kilsallagh (Longford)', zip: '661198' },
	{ city: 'Kilsallagh (Mayo)', zip: '617364' },
	{ city: 'Kilsallagh (Sligo)', zip: '827196' },
	{ city: 'Kilsallagh (Tipperary)', zip: '714274' },
	{ city: 'Kilsallaghan (Dublin)', zip: '791680' },
	{ city: 'Kilsallagh Lower (Mayo)', zip: '621916' },
	{ city: 'Kilsallagh Upper (Mayo)', zip: '329133' },
	{ city: 'Kilsaran (Cavan)', zip: '272067' },
	{ city: 'Kilsaran (Louth)', zip: '443745' },
	{ city: 'Kilsarkan East (Kerry)', zip: '695629' },
	{ city: 'Kilsarkan West (Kerry)', zip: '688437' },
	{ city: 'Kilsarlaght (Cork)', zip: '765748' },
	{ city: 'Kilscanlan (Limerick)', zip: '717115' },
	{ city: 'Kilscanlan (Wexford)', zip: '506861' },
	{ city: 'Kilscannell (Limerick)', zip: '154213' },
	{ city: 'Kilscobin (Tipperary)', zip: '740138' },
	{ city: 'Kilscohagh (Mayo)', zip: '704817' },
	{ city: 'Kilscohanagh (Cork)', zip: '924629' },
	{ city: 'Kilscoran (Wexford)', zip: '842400' },
	{ city: 'Kilseily (Clare)', zip: '354765' },
	{ city: 'Kilsellagh (Sligo)', zip: '914488' },
	{ city: 'Kilshallow (Westmeath)', zip: '726792' },
	{ city: 'Kilshalvy (Sligo)', zip: '395180' },
	{ city: 'Kilshanchoe (Kildare)', zip: '618258' },
	{ city: 'Kilshane (Dublin)', zip: '474128' },
	{ city: 'Kilshane (Limerick)', zip: '673342' },
	{ city: 'Kilshane (Tipperary)', zip: '491363' },
	{ city: 'Kilshannig (Kerry)', zip: '749850' },
	{ city: 'Kilshannig Lower (Cork)', zip: '631445' },
	{ city: 'Kilshannig Upper (Cork)', zip: '735787' },
	{ city: 'Kilshanny (Clare)', zip: '356619' },
	{ city: 'Kilshanny (Cork)', zip: '416918' },
	{ city: 'Kilshanvy (Galway)', zip: '372884' },
	{ city: 'Kilsharvan (Meath)', zip: '350297' },
	{ city: 'Kilsheelan (Tipperary)', zip: '259587' },
	{ city: 'Kilshenane (Kerry)', zip: '872544' },
	{ city: 'Kilshenane (Tipperary)', zip: '640458' },
	{ city: 'Kilshinahan (Cork)', zip: '145808' },
	{ city: 'Kilshruley (Longford)', zip: '906867' },
	{ city: 'Kilsillagh (Cork)', zip: '724787' },
	{ city: 'Kilskeagh (Galway)', zip: '368582' },
	{ city: 'Kilskeagh (Mayo)', zip: '807030' },
	{ city: 'Kilskeer (Meath)', zip: '114674' },
	{ city: 'Kilsob (Cavan)', zip: '748415' },
	{ city: 'Kilsough North (Dublin)', zip: '396100' },
	{ city: 'Kilsough South (Dublin)', zip: '483089' },
	{ city: 'Kilsteague (Waterford)', zip: '177274' },
	{ city: 'Kilstraghlan (Sligo)', zip: '560543' },
	{ city: 'Kiltaan (Clare)', zip: '575877' },
	{ city: 'Kiltacky Beg (Clare)', zip: '720612' },
	{ city: 'Kiltacky More (Clare)', zip: '124177' },
	{ city: 'Kiltaghan North (Kildare)', zip: '833226' },
	{ city: 'Kiltaghan South (Kildare)', zip: '213827' },
	{ city: 'Kiltaglassan (Cavan)', zip: '613069' },
	{ city: 'Kiltale (Meath)', zip: '177979' },
	{ city: 'Kiltallaghan (Kilkenny)', zip: '463949' },
	{ city: 'Kiltallaght (Louth)', zip: '896087' },
	{ city: 'Kiltalown (Dublin)', zip: '396923' },
	{ city: 'Kiltamagh (Mayo)', zip: '957883' },
	{ city: 'Kiltankin (Tipperary)', zip: '626907' },
	{ city: 'Kiltanna (Limerick)', zip: '713651' },
	{ city: 'Kiltanon (Clare)', zip: '693897' },
	{ city: 'Kiltareher (Westmeath)', zip: '995446' },
	{ city: 'Kiltarnaght (Mayo)', zip: '867040' },
	{ city: 'Kiltarsaghaun (Mayo)', zip: '435199' },
	{ city: 'Kiltartan (Galway)', zip: '491127' },
	{ city: 'Kiltass (Cork)', zip: '361923' },
	{ city: 'Kiltaugharaun (Mayo)', zip: '817269' },
	{ city: 'Kilteale (Laois)', zip: '980140' },
	{ city: 'Kiltealy (Wexford)', zip: '503901' },
	{ city: 'Kilteany (Mayo)', zip: '232383' },
	{ city: 'Kilteasheen (Roscommon)', zip: '350416' },
	{ city: 'Kilteean (Kerry)', zip: '552130' },
	{ city: 'Kilteel (Kildare)', zip: '803264' },
	{ city: 'Kilteel Lower (Kildare)', zip: '114478' },
	{ city: 'Kilteel Upper (Kildare)', zip: '563211' },
	{ city: 'Kilteely (Limerick)', zip: '955700' },
	{ city: 'Kilteenbane (Kerry)', zip: '537058' },
	{ city: 'Kilteery (Limerick)', zip: '682581' },
	{ city: 'Kilteevan (Roscommon)', zip: '270227' },
	{ city: 'Kiltegan (Tipperary)', zip: '553702' },
	{ city: 'Kiltegan (Wicklow)', zip: '339018' },
	{ city: 'Kiltemplan (Limerick)', zip: '397329' },
	{ city: 'Kiltenan North (Limerick)', zip: '836679' },
	{ city: 'Kiltenan South (Limerick)', zip: '119654' },
	{ city: 'Kiltennan North (Clare)', zip: '500286' },
	{ city: 'Kiltennan South (Clare)', zip: '626605' },
	{ city: 'Kiltennell (Wexford)', zip: '981424' },
	{ city: 'Kilthomas (Wexford)', zip: '853559' },
	{ city: 'Kiltiernan (Dublin)', zip: '999961' },
	{ city: 'Kiltiernan Domain (Dublin)', zip: '441044' },
	{ city: 'Kiltiernan East (Galway)', zip: '697701' },
	{ city: 'Kiltiernan West (Galway)', zip: '558233' },
	{ city: 'Kiltillahan (Wexford)', zip: '362535' },
	{ city: 'Kiltillane (Tipperary)', zip: '533676' },
	{ city: 'Kiltilliha (Tipperary)', zip: '937929' },
	{ city: 'Kiltilly (Wexford)', zip: '244667' },
	{ city: 'Kiltimon (Wicklow)', zip: '951603' },
	{ city: 'Kiltinan (Tipperary)', zip: '170150' },
	{ city: 'Kiltipper (Dublin)', zip: '444488' },
	{ city: 'Kiltivna (Galway)', zip: '607412' },
	{ city: 'Kiltober (Westmeath)', zip: '402538' },
	{ city: 'Kiltoghert (Leitrim)', zip: '663900' },
	{ city: 'Kiltogorra (Mayo)', zip: '741277' },
	{ city: 'Kiltole (Donegal)', zip: '447509' },
	{ city: 'Kiltomulty (Cavan)', zip: '499396' },
	{ city: 'Kiltomy (Kerry)', zip: '852310' },
	{ city: 'Kiltoohig (Cork)', zip: '512485' },
	{ city: 'Kiltoom (Roscommon)', zip: '441079' },
	{ city: 'Kiltoom (Westmeath)', zip: '394621' },
	{ city: 'Kiltoome (Meath)', zip: '542694' },
	{ city: 'Kiltooris (Donegal)', zip: '395085' },
	{ city: 'Kiltorcan (Kilkenny)', zip: '325268' },
	{ city: 'Kiltormer (Galway)', zip: '634675' },
	{ city: 'Kiltormer East (Galway)', zip: '691970' },
	{ city: 'Kiltormer West (Galway)', zip: '713726' },
	{ city: 'Kiltotan And Collinstown (Westmeath)', zip: '591882' },
	{ city: 'Kiltown (Donegal)', zip: '728224' },
	{ city: 'Kiltown (Kilkenny)', zip: '327782' },
	{ city: 'Kiltown (Wexford)', zip: '104274' },
	{ city: 'Kiltoy (Donegal)', zip: '870771' },
	{ city: 'Kiltra (Wexford)', zip: '562750' },
	{ city: 'Kiltrasna (Cavan)', zip: '104846' },
	{ city: 'Kiltrasna (Galway)', zip: '100725' },
	{ city: 'Kiltrassy (Kilkenny)', zip: '394863' },
	{ city: 'Kiltrea (Wexford)', zip: '516551' },
	{ city: 'Kiltrellig (Clare)', zip: '529390' },
	{ city: 'Kiltrislane (Cork)', zip: '537493' },
	{ city: 'Kiltroge (Galway)', zip: '162178' },
	{ city: 'Kiltrone (Mayo)', zip: '854048' },
	{ city: 'Kiltrough (Meath)', zip: '983718' },
	{ city: 'Kiltrustan (Roscommon)', zip: '907399' },
	{ city: 'Kiltubbrid (Leitrim)', zip: '954709' },
	{ city: 'Kiltubbrid (Monaghan)', zip: '827233' },
	{ city: 'Kiltubbrid Island (Offaly)', zip: '479313' },
	{ city: 'Kiltullagh (Galway)', zip: '814715' },
	{ city: 'Kiltullagh (Roscommon)', zip: '271787' },
	{ city: 'Kiltullagh North (Galway)', zip: '239851' },
	{ city: 'Kiltullagh South (Galway)', zip: '833872' },
	{ city: 'Kiltultoge (Roscommon)', zip: '530465' },
	{ city: 'Kiltumper (Clare)', zip: '870160' },
	{ city: 'Kilturra (Sligo)', zip: '206783' },
	{ city: 'Kiltybannan (Galway)', zip: '971869' },
	{ city: 'Kiltybardan (Leitrim)', zip: '925612' },
	{ city: 'Kiltybegs (Longford)', zip: '243270' },
	{ city: 'Kiltybegs (Monaghan)', zip: '414773' },
	{ city: 'Kiltybo (Mayo)', zip: '608718' },
	{ city: 'Kiltybranks (Roscommon)', zip: '216760' },
	{ city: 'Kiltybrannock (Roscommon)', zip: '304966' },
	{ city: 'Kiltycahill (Sligo)', zip: '122750' },
	{ city: 'Kiltycarney (Leitrim)', zip: '446433' },
	{ city: 'Kiltyclogh (Longford)', zip: '268752' },
	{ city: 'Kiltycloghan (Sligo)', zip: '103974' },
	{ city: 'Kiltyclogher (Leitrim)', zip: '514077' },
	{ city: 'Kiltycon (Longford)', zip: '380804' },
	{ city: 'Kiltycooly (Sligo)', zip: '844241' },
	{ city: 'Kiltycreaghtan (Roscommon)', zip: '127263' },
	{ city: 'Kiltycreen (Sligo)', zip: '856597' },
	{ city: 'Kiltycreevagh (Leitrim)', zip: '690781' },
	{ city: 'Kiltycreevagh (Longford)', zip: '166848' },
	{ city: 'Kiltyfanned (Donegal)', zip: '749881' },
	{ city: 'Kiltyfeenaghty Glebe (Leitrim)', zip: '778019' },
	{ city: 'Kiltyfergal (Donegal)', zip: '183149' },
	{ city: 'Kiltyfinnan (Leitrim)', zip: '860861' },
	{ city: 'Kiltygerry (Leitrim)', zip: '897894' },
	{ city: 'Kiltyhugh (Leitrim)', zip: '965643' },
	{ city: 'Kiltykeary (Longford)', zip: '572506' },
	{ city: 'Kiltykere (Sligo)', zip: '874423' },
	{ city: 'Kiltylough (Sligo)', zip: '114538' },
	{ city: 'Kiltymaine (Roscommon)', zip: '517705' },
	{ city: 'Kiltymoodan (Leitrim)', zip: '553332' },
	{ city: 'Kiltynashinnagh (Leitrim)', zip: '689927' },
	{ city: 'Kiltynaskellan (Cavan)', zip: '339768' },
	{ city: 'Kiltyreher (Longford)', zip: '433250' },
	{ city: 'Kiltyroe (Mayo)', zip: '411202' },
	{ city: 'Kiltyrome (Tipperary)', zip: '634778' },
	{ city: 'Kiltyteige (Sligo)', zip: '738743' },
	{ city: 'Kilva (Cork)', zip: '211925' },
	{ city: 'Kilvahan (Laois)', zip: '786694' },
	{ city: 'Kilvanloon (Roscommon)', zip: '124276' },
	{ city: 'Kilvarnet North (Sligo)', zip: '269351' },
	{ city: 'Kilvarnet South (Sligo)', zip: '924935' },
	{ city: 'Kilvealaton East (Cork)', zip: '846675' },
	{ city: 'Kilvealaton West (Cork)', zip: '191533' },
	{ city: 'Kilvemnon (Tipperary)', zip: '990552' },
	{ city: 'Kilvey (Monaghan)', zip: '228274' },
	{ city: 'Kilvickadownig (Kerry)', zip: '378068' },
	{ city: 'Kilvickanease (Cork)', zip: '868003' },
	{ city: 'Kilvilcorris (Tipperary)', zip: '129857' },
	{ city: 'Kilvinane (Cork)', zip: '718423' },
	{ city: 'Kilvindoney (Mayo)', zip: '190367' },
	{ city: 'Kilvine (Mayo)', zip: '429555' },
	{ city: 'Kilvinoge (Kilkenny)', zip: '428201' },
	{ city: 'Kilvoy (Roscommon)', zip: '931518' },
	{ city: 'Kilvoydan (Clare)', zip: '660046' },
	{ city: 'Kilvoydan North (Clare)', zip: '208371' },
	{ city: 'Kilvoydan South (Clare)', zip: '520494' },
	{ city: 'Kilvurra (Cork)', zip: '613283' },
	{ city: 'Kilwalter (Westmeath)', zip: '303512' },
	{ city: 'Kilwarden (Kildare)', zip: '648458' },
	{ city: 'Kilwarden (Meath)', zip: '326468' },
	{ city: 'Kilwarry (Donegal)', zip: '343255' },
	{ city: 'Kilwatermoy (Waterford)', zip: '730498' },
	{ city: 'Kilwatermoymountain (Waterford)', zip: '822370' },
	{ city: 'Kilweelran (Clare)', zip: '713881' },
	{ city: 'Kilwinny (Waterford)', zip: '101999' },
	{ city: 'Kilwoghan (Kildare)', zip: '980004' },
	{ city: 'Kilworth (Cork)', zip: '406386' },
	{ city: 'Kilwullaun (Galway)', zip: '743114' },
	{ city: 'Kimego East (Kerry)', zip: '962189' },
	{ city: 'Kimego West (Kerry)', zip: '642570' },
	{ city: 'Kimeheer (Limerick)', zip: '304319' },
	{ city: 'Kimmage (Dublin)', zip: '434951' },
	{ city: 'Kimmeenmore (Galway)', zip: '527507' },
	{ city: 'Kimmeens (Kildare)', zip: '991822' },
	{ city: 'Kimmid (Donegal)', zip: '348715' },
	{ city: 'Kimmins (Meath)', zip: '293295' },
	{ city: 'Kinaff (Mayo)', zip: '598342' },
	{ city: 'Kinagha Beg (Cavan)', zip: '593377' },
	{ city: 'Kinagha More (Cavan)', zip: '149501' },
	{ city: 'Kinallybane (Monaghan)', zip: '324505' },
	{ city: 'Kinallyduff (Monaghan)', zip: '525387' },
	{ city: 'Kinard (Limerick)', zip: '173101' },
	{ city: 'Kinard (Longford)', zip: '936815' },
	{ city: 'Kinard (Mayo)', zip: '946851' },
	{ city: 'Kinard (Monaghan)', zip: '713137' },
	{ city: 'Kinard (Roscommon)', zip: '331247' },
	{ city: 'Kinard (Sligo)', zip: '256892' },
	{ city: 'Kinard East (Kerry)', zip: '630303' },
	{ city: 'Kinard West (Kerry)', zip: '954325' },
	{ city: 'Kinathfineen (Cork)', zip: '774740' },
	{ city: 'Kincaslough (Donegal)', zip: '865054' },
	{ city: 'Kinclare (Galway)', zip: '616915' },
	{ city: 'Kinclare (Roscommon)', zip: '458139' },
	{ city: 'Kincon (Mayo)', zip: '243659' },
	{ city: 'Kincora (Offaly)', zip: '432362' },
	{ city: 'Kincorragh (Monaghan)', zip: '591022' },
	{ city: 'Kincraigy (Donegal)', zip: '547896' },
	{ city: 'Kincrum (Donegal)', zip: '940720' },
	{ city: 'Kincuillew (Sligo)', zip: '670808' },
	{ city: 'Kincullia (Galway)', zip: '955059' },
	{ city: 'Kindlestown Lower (Wicklow)', zip: '594266' },
	{ city: 'Kindlestown Upper (Wicklow)', zip: '464585' },
	{ city: 'Kindroghed (Donegal)', zip: '791527' },
	{ city: 'Kindrum (Donegal)', zip: '289620' },
	{ city: 'Kinduff (Monaghan)', zip: '525500' },
	{ city: 'Kineagh (Kildare)', zip: '378883' },
	{ city: 'Kineigh (Kerry)', zip: '361899' },
	{ city: 'Kineilty (Clare)', zip: '558859' },
	{ city: 'Kingarrow (Donegal)', zip: '724816' },
	{ city: 'Kingorry (Monaghan)', zip: '812698' },
	{ city: 'Kingsbog (Kildare)', zip: '621046' },
	{ city: 'Kingsborough (Sligo)', zip: '844154' },
	{ city: 'Kingsbrook (Sligo)', zip: '921737' },
	{ city: 'Kingscourt (Cavan)', zip: '951202' },
	{ city: 'Kingsfort (Sligo)', zip: '615584' },
	{ city: 'Kingsfurze (Kildare)', zip: '869703' },
	{ city: 'Kingsland (Cork)', zip: '453308' },
	{ city: 'Kingsland (Kerry)', zip: '244170' },
	{ city: 'Kingsland (Kildare)', zip: '452696' },
	{ city: 'Kingsland (Kilkenny)', zip: '418771' },
	{ city: 'Kingsland (Limerick)', zip: '236868' },
	{ city: 'Kingsland (Roscommon)', zip: '204977' },
	{ city: 'Kingsland East (Kilkenny)', zip: '582762' },
	{ city: 'Kingsland North (Galway)', zip: '194737' },
	{ city: 'Kingsland South (Galway)', zip: '901631' },
	{ city: 'Kingsland West (Kilkenny)', zip: '963160' },
	{ city: 'Kingsmountain (Kilkenny)', zip: '732965' },
	{ city: 'Kingsmountain (Meath)', zip: '974811' },
	{ city: 'Kingsmountain (Sligo)', zip: '224825' },
	{ city: 'Kingston (Dublin)', zip: '535648' },
	{ city: 'Kingston (Wicklow)', zip: '651298' },
	{ city: "Kingston's-Fields (Cork)", zip: '379702' },
	{ city: 'Kingstown (Dublin)', zip: '831704' },
	{ city: 'Kingstown And Carnuff Great (Meath)', zip: '449096' },
	{ city: 'Kingstown Glebe (Galway)', zip: '696432' },
	{ city: 'Kingswood (Dublin)', zip: '683823' },
	{ city: 'Kinincha (Galway)', zip: '279335' },
	{ city: 'Kiniska (Galway)', zip: '996056' },
	{ city: 'Kinitty (Roscommon)', zip: '882940' },
	{ city: 'Kinkeel (Cavan)', zip: '496380' },
	{ city: 'Kinkillew (Leitrim)', zip: '328452' },
	{ city: 'Kinkillew (Longford)', zip: '916329' },
	{ city: 'Kinkillew (Sligo)', zip: '425372' },
	{ city: 'Kinknock (Mayo)', zip: '826538' },
	{ city: 'Kinlea (Clare)', zip: '713252' },
	{ city: 'Kinletter (Donegal)', zip: '408182' },
	{ city: 'Kinletteragh (Donegal)', zip: '784644' },
	{ city: 'Kinlough (Leitrim)', zip: '428319' },
	{ city: 'Kinlough (Mayo)', zip: '955584' },
	{ city: 'Kinmona North (Galway)', zip: '743723' },
	{ city: 'Kinmona South (Galway)', zip: '144443' },
	{ city: 'Kinnabo (Cavan)', zip: '441610' },
	{ city: 'Kinnacally (Donegal)', zip: '830558' },
	{ city: 'Kinnaderry (Donegal)', zip: '321391' },
	{ city: 'Kinnadoohy (Mayo)', zip: '587415' },
	{ city: 'Kinnafad (Kildare)', zip: '482840' },
	{ city: 'Kinnafad (Offaly)', zip: '923442' },
	{ city: 'Kinnagh (Wexford)', zip: '916369' },
	{ city: 'Kinnagin (Monaghan)', zip: '774084' },
	{ city: 'Kinnagoe (Donegal)', zip: '806265' },
	{ city: 'Kinnagrelly (Sligo)', zip: '952105' },
	{ city: 'Kinnakillew (Donegal)', zip: '778705' },
	{ city: 'Kinnakillew (Mayo)', zip: '383725' },
	{ city: 'Kinnakinelly (Galway)', zip: '690209' },
	{ city: 'Kinnalargy (Donegal)', zip: '737492' },
	{ city: 'Kinnalough (Donegal)', zip: '157580' },
	{ city: 'Kinnara Glebe (Leitrim)', zip: '388926' },
	{ city: 'Kinnavally (Mayo)', zip: '734536' },
	{ city: 'Kinnaveelish (Galway)', zip: '762772' },
	{ city: 'Kinnea (Cavan)', zip: '452745' },
	{ city: 'Kinnea (Donegal)', zip: '838457' },
	{ city: 'Kinnegad (Westmeath)', zip: '225064' },
	{ city: 'Kinnegar (Donegal)', zip: '899361' },
	{ city: 'Kinneigh (Cork)', zip: '169285' },
	{ city: 'Kinnelly Islands (Galway)', zip: '844978' },
	{ city: 'Kinnewry (Mayo)', zip: '367636' },
	{ city: 'Kinnitty (Offaly)', zip: '218120' },
	{ city: 'Kinnoghty (Donegal)', zip: '110848' },
	{ city: 'Kinnypottle (Cavan)', zip: '182432' },
	{ city: 'Kinoristown (Meath)', zip: '107146' },
	{ city: 'Kinoud (Dublin)', zip: '679208' },
	{ city: 'Kinreask (Galway)', zip: '745352' },
	{ city: 'Kinsale (Cork)', zip: '660186' },
	{ city: 'Kinsalebeg (Waterford)', zip: '586616' },
	{ city: 'Kinsaley (Dublin)', zip: '953807' },
	{ city: 'Kinsellastown (Wicklow)', zip: '775670' },
	{ city: 'Kintale (Donegal)', zip: '275829' },
	{ city: 'Kinteera (Cork)', zip: '494185' },
	{ city: 'Kintogher (Sligo)', zip: '816275' },
	{ city: 'Kinturk (Clare)', zip: '118167' },
	{ city: 'Kinturk (Monaghan)', zip: '468143' },
	{ city: 'Kinturk Demesne (Westmeath)', zip: '747455' },
	{ city: 'Kinturk Lower (Mayo)', zip: '923658' },
	{ city: 'Kinturk Upper (Mayo)', zip: '422369' },
	{ city: 'Kinure (Cork)', zip: '571460' },
	{ city: 'Kinvarra (Galway)', zip: '310114' },
	{ city: 'Kippagh (Cork)', zip: '301784' },
	{ city: 'Kippaghingergill (Cork)', zip: '720671' },
	{ city: 'Kippagh Middle (Cork)', zip: '232891' },
	{ city: 'Kippagh North (Cork)', zip: '494292' },
	{ city: 'Kippagh South (Cork)', zip: '965080' },
	{ city: 'Kippane (Cork)', zip: '825590' },
	{ city: 'Kippaunagh (Galway)', zip: '500973' },
	{ city: 'Kippeenduff (Offaly)', zip: '546318' },
	{ city: 'Kippin (Westmeath)', zip: '717430' },
	{ city: 'Kippinduff (Westmeath)', zip: '492140' },
	{ city: 'Kippinstown (Westmeath)', zip: '904135' },
	{ city: 'Kippure (Wicklow)', zip: '818905' },
	{ city: 'Kippure East (Wicklow)', zip: '999328' },
	{ city: 'Kircock (Louth)', zip: '854416' },
	{ city: 'Kirikee (Wicklow)', zip: '740627' },
	{ city: 'Kirkneedy (Donegal)', zip: '633780' },
	{ city: 'Kirkstown (Donegal)', zip: '174642' },
	{ city: "Kirwan's Inch (Kilkenny)", zip: '781061' },
	{ city: 'Kish (Wicklow)', zip: '655695' },
	{ city: 'Kisha (Wexford)', zip: '310042' },
	{ city: 'Kishawanny Lower (Kildare)', zip: '903581' },
	{ city: 'Kishawanny Upper (Kildare)', zip: '595239' },
	{ city: 'Kishkeam (Cork)', zip: '852050' },
	{ city: 'Kishkeam Lower (Cork)', zip: '104479' },
	{ city: 'Kishkeam Upper (Cork)', zip: '299963' },
	{ city: 'Kishoge (Dublin)', zip: '707739' },
	{ city: 'Kishyquirk (Limerick)', zip: '380832' },
	{ city: 'Kitchenstown (Dublin)', zip: '619210' },
	{ city: 'Kitestown (Wexford)', zip: '874180' },
	{ city: 'Kivvy (Cavan)', zip: '331965' },
	{ city: 'Kivvy (Leitrim)', zip: '840250' },
	{ city: 'Knader (Donegal)', zip: '214088' },
	{ city: 'Knappagh (Cavan)', zip: '912534' },
	{ city: 'Knappagh (Monaghan)', zip: '294363' },
	{ city: 'Knappagh Beg (Mayo)', zip: '888007' },
	{ city: 'Knappagh Beg (Sligo)', zip: '927876' },
	{ city: 'Knappaghmanagh (Mayo)', zip: '756267' },
	{ city: 'Knappagh More (Mayo)', zip: '445278' },
	{ city: 'Knappagh More (Sligo)', zip: '966852' },
	{ city: 'Knappoge (Clare)', zip: '393349' },
	{ city: 'Knappoge (Longford)', zip: '752446' },
	{ city: 'Knapton (Laois)', zip: '619606' },
	{ city: 'Knavagh (Galway)', zip: '147908' },
	{ city: 'Knavinstown (Kildare)', zip: '619669' },
	{ city: 'Knavinstown (Meath)', zip: '467727' },
	{ city: 'Knawhill (Cork)', zip: '408916' },
	{ city: 'Kneestown (Carlow)', zip: '692818' },
	{ city: 'Knickeen (Kilkenny)', zip: '758091' },
	{ city: 'Knickeen (Wicklow)', zip: '935894' },
	{ city: 'Knigh (Tipperary)', zip: '618413' },
	{ city: 'Knightsbrook (Meath)', zip: '539807' },
	{ city: 'Knightstown (Dublin)', zip: '619262' },
	{ city: 'Knightstown (Laois)', zip: '424828' },
	{ city: 'Knightstown (Meath)', zip: '162958' },
	{ city: "Knight's Town (Kerry)", zip: '160137' },
	{ city: 'Knightstreet (Limerick)', zip: '260709' },
	{ city: 'Knightswood (Westmeath)', zip: '658946' },
	{ city: 'Knock (Clare)', zip: '525156' },
	{ city: 'Knock (Cork)', zip: '362202' },
	{ city: 'Knock (Donegal)', zip: '866716' },
	{ city: 'Knock (Dublin)', zip: '200080' },
	{ city: 'Knock (Galway)', zip: '131283' },
	{ city: 'Knock (Limerick)', zip: '575373' },
	{ city: 'Knock (Longford)', zip: '350772' },
	{ city: 'Knock (Mayo)', zip: '897886' },
	{ city: 'Knock (Meath)', zip: '194699' },
	{ city: 'Knock (Offaly)', zip: '712219' },
	{ city: 'Knock (Roscommon)', zip: '648401' },
	{ city: 'Knock (Wexford)', zip: '477294' },
	{ city: 'Knockaarum (Tipperary)', zip: '147481' },
	{ city: 'Knockabeany (Monaghan)', zip: '976029' },
	{ city: 'Knockaboy (Galway)', zip: '382640' },
	{ city: 'Knockaboys (Louth)', zip: '599317' },
	{ city: 'Knockabritta (Tipperary)', zip: '657428' },
	{ city: 'Knockacaharna (Waterford)', zip: '687832' },
	{ city: 'Knockacappul (Cork)', zip: '991929' },
	{ city: 'Knockacappul (Kerry)', zip: '454872' },
	{ city: 'Knockacappul (Sligo)', zip: '819879' },
	{ city: 'Knockacappul (Tipperary)', zip: '541028' },
	{ city: 'Knockacareigh (Cork)', zip: '209921' },
	{ city: 'Knockacarhanduff Commons (Tipperary)', zip: '294050' },
	{ city: 'Knockacarn (Clare)', zip: '666849' },
	{ city: 'Knockacarracoosh (Cork)', zip: '759436' },
	{ city: 'Knockacarrigeen (Galway)', zip: '274418' },
	{ city: 'Knockacaurhin (Clare)', zip: '895128' },
	{ city: 'Knockachur (Kerry)', zip: '411959' },
	{ city: 'Knockaclara (Clare)', zip: '151550' },
	{ city: 'Knockaclare (Kerry)', zip: '980627' },
	{ city: 'Knockaclarig (Cork)', zip: '645685' },
	{ city: 'Knockaclogher (Kerry)', zip: '256023' },
	{ city: 'Knockaclugga (Limerick)', zip: '681775' },
	{ city: 'Knockacluggin (Cork)', zip: '933515' },
	{ city: 'Knockacoller (Laois)', zip: '802314' },
	{ city: 'Knockacomortish (Waterford)', zip: '573911' },
	{ city: 'Knockaconny (Monaghan)', zip: '867465' },
	{ city: 'Knockacool (Cork)', zip: '891431' },
	{ city: 'Knockacoola (Waterford)', zip: '239140' },
	{ city: 'Knockacorbally (Cork)', zip: '563239' },
	{ city: 'Knockacorha (Roscommon)', zip: '769641' },
	{ city: 'Knockacosan (Leitrim)', zip: '898343' },
	{ city: 'Knockacraheen (Tipperary)', zip: '404031' },
	{ city: 'Knockacraig (Limerick)', zip: '139634' },
	{ city: 'Knockacrin (Laois)', zip: '496293' },
	{ city: 'Knockacroghera (Cork)', zip: '425956' },
	{ city: 'Knockacroghery (Mayo)', zip: '623257' },
	{ city: 'Knockacronaun (Waterford)', zip: '949607' },
	{ city: 'Knockacrump (Cork)', zip: '954976' },
	{ city: 'Knockacullata (Cork)', zip: '148558' },
	{ city: 'Knockacullea North (Clare)', zip: '658519' },
	{ city: 'Knockacullea South (Clare)', zip: '651586' },
	{ city: 'Knockaculleen (Mayo)', zip: '567075' },
	{ city: 'Knockaculleen (Roscommon)', zip: '135312' },
	{ city: 'Knockaculleen (Sligo)', zip: '367296' },
	{ city: 'Knockacullen (Cork)', zip: '700311' },
	{ city: 'Knockacullen (Waterford)', zip: '185628' },
	{ city: 'Knockacullig North (Kerry)', zip: '776794' },
	{ city: 'Knockacullig South (Kerry)', zip: '526849' },
	{ city: 'Knockacullin (Cork)', zip: '796974' },
	{ city: 'Knockacullin (Tipperary)', zip: '124516' },
	{ city: 'Knockacullion (Leitrim)', zip: '605434' },
	{ city: 'Knockacullion (Monaghan)', zip: '300104' },
	{ city: 'Knockacummer (Cork)', zip: '118228' },
	{ city: 'Knockacunnier (Monaghan)', zip: '949508' },
	{ city: 'Knockacur (Cork)', zip: '257831' },
	{ city: 'Knockacurra (Tipperary)', zip: '602542' },
	{ city: 'Knockacurra (Westmeath)', zip: '830115' },
	{ city: 'Knockacurrane (Kerry)', zip: '480376' },
	{ city: 'Knockacurreen (Mayo)', zip: '773258' },
	{ city: 'Knockacurrin (Waterford)', zip: '658743' },
	{ city: 'Knockadaff (Roscommon)', zip: '621030' },
	{ city: 'Knockadalteen (Roscommon)', zip: '715710' },
	{ city: 'Knockadalteen (Sligo)', zip: '369058' },
	{ city: 'Knockadangan (Clare)', zip: '300547' },
	{ city: 'Knockadangan (Mayo)', zip: '249834' },
	{ city: 'Knockadangan (Roscommon)', zip: '878076' },
	{ city: 'Knockadaumore (Galway)', zip: '111044' },
	{ city: 'Knockadav (Galway)', zip: '475357' },
	{ city: 'Knockadav (Waterford)', zip: '148675' },
	{ city: 'Knockadawk (Wexford)', zip: '131821' },
	{ city: 'Knockadea (Limerick)', zip: '140798' },
	{ city: 'Knockaderreen (Clare)', zip: '907029' },
	{ city: 'Knockaderreen (Kerry)', zip: '723013' },
	{ city: 'Knockaderry (Clare)', zip: '929716' },
	{ city: 'Knockaderry (Kerry)', zip: '797787' },
	{ city: 'Knockaderry (Limerick)', zip: '379761' },
	{ city: 'Knockaderry (Tipperary)', zip: '802566' },
	{ city: 'Knockaderry (Waterford)', zip: '328305' },
	{ city: 'Knockaderry (Wicklow)', zip: '508433' },
	{ city: 'Knockaderry Lower (Waterford)', zip: '452332' },
	{ city: 'Knockaderry Upper (Waterford)', zip: '726531' },
	{ city: 'Knockadigeen (Tipperary)', zip: '549025' },
	{ city: 'Knockadikeen (Galway)', zip: '880432' },
	{ city: 'Knockadilly (Wexford)', zip: '102041' },
	{ city: 'Knockadoagh (Galway)', zip: '953586' },
	{ city: 'Knockadoo (Roscommon)', zip: '612757' },
	{ city: 'Knockadoo (Sligo)', zip: '392449' },
	{ city: 'Knockadoobrusna (Roscommon)', zip: '923023' },
	{ city: 'Knockadooma (Cork)', zip: '959304' },
	{ city: 'Knockadoon (Clare)', zip: '914964' },
	{ city: 'Knockadoon (Cork)', zip: '461792' },
	{ city: 'Knockadoon (Mayo)', zip: '815822' },
	{ city: 'Knockadoonlea (Waterford)', zip: '295921' },
	{ city: 'Knockadorraghy (Mayo)', zip: '282166' },
	{ city: 'Knockadosan (Wicklow)', zip: '321707' },
	{ city: 'Knockadreet (Wicklow)', zip: '322278' },
	{ city: 'Knockadrehid (Roscommon)', zip: '558518' },
	{ city: 'Knockadrina (Kilkenny)', zip: '108931' },
	{ city: 'Knockadrinan (Leitrim)', zip: '536817' },
	{ city: 'Knockadroleen (Cork)', zip: '903863' },
	{ city: 'Knockadromin (Tipperary)', zip: '833265' },
	{ city: 'Knockadrum (Galway)', zip: '721238' },
	{ city: 'Knockadrum (Mayo)', zip: '362599' },
	{ city: 'Knockadrumalea (Waterford)', zip: '301862' },
	{ city: 'Knockadryan (Roscommon)', zip: '914136' },
	{ city: 'Knockadullaun East (Waterford)', zip: '412145' },
	{ city: 'Knockadullaun West (Waterford)', zip: '564952' },
	{ city: 'Knockafall (Mayo)', zip: '240389' },
	{ city: 'Knockafreaghaun (Kerry)', zip: '713258' },
	{ city: 'Knockagallane (Cork)', zip: '547690' },
	{ city: 'Knockagar (Donegal)', zip: '707542' },
	{ city: 'Knockagarran (Donegal)', zip: '821075' },
	{ city: 'Knockagarrane (Kerry)', zip: '794227' },
	{ city: 'Knockagarrane East (Cork)', zip: '329388' },
	{ city: 'Knockagarrane West (Cork)', zip: '265088' },
	{ city: 'Knockagarraun (Mayo)', zip: '208736' },
	{ city: 'Knockagarravaun (Mayo)', zip: '446111' },
	{ city: 'Knockagarry (Carlow)', zip: '236178' },
	{ city: 'Knockagarry (Cork)', zip: '701968' },
	{ city: 'Knockagh (Longford)', zip: '836558' },
	{ city: 'Knockagh (Louth)', zip: '706657' },
	{ city: 'Knockagh (Tipperary)', zip: '701416' },
	{ city: 'Knockaghaduff (Cork)', zip: '515652' },
	{ city: 'Knockaghy (Cavan)', zip: '880206' },
	{ city: 'Knockaglana (Mayo)', zip: '939793' },
	{ city: 'Knockagolig (Cork)', zip: '573513' },
	{ city: 'Knockagower (Sligo)', zip: '756683' },
	{ city: 'Knockagowna (Kerry)', zip: '136886' },
	{ city: 'Knockagowny (Longford)', zip: '633214' },
	{ city: 'Knockagraffy (Mayo)', zip: '649170' },
	{ city: 'Knockagreenaun (Mayo)', zip: '475831' },
	{ city: 'Knockaguilla (Clare)', zip: '954082' },
	{ city: 'Knockahavaun (Waterford)', zip: '380879' },
	{ city: 'Knockahaw (Laois)', zip: '669801' },
	{ city: 'Knockahaw (Longford)', zip: '871171' },
	{ city: 'Knockahonagh (Laois)', zip: '845665' },
	{ city: 'Knockahone (Wexford)', zip: '218231' },
	{ city: 'Knockahoney (Sligo)', zip: '686957' },
	{ city: 'Knockahorrea East (Cork)', zip: '635706' },
	{ city: 'Knockahorrea West (Cork)', zip: '245188' },
	{ city: 'Knockahunna (Tipperary)', zip: '553139' },
	{ city: 'Knockahurka (Sligo)', zip: '379645' },
	{ city: 'Knockainy (Limerick)', zip: '733048' },
	{ city: 'Knockainy East (Limerick)', zip: '938695' },
	{ city: 'Knockainy West (Limerick)', zip: '793199' },
	{ city: 'Knockakeen (Cork)', zip: '867691' },
	{ city: 'Knockakeery (Mayo)', zip: '761294' },
	{ city: 'Knockakelly (Tipperary)', zip: '948268' },
	{ city: 'Knockakeo (Cork)', zip: '115099' },
	{ city: 'Knockakilleen (Galway)', zip: '811601' },
	{ city: 'Knockakilly (Tipperary)', zip: '718288' },
	{ city: 'Knockakirwan (Monaghan)', zip: '362799' },
	{ city: 'Knockakishta (Cavan)', zip: '837221' },
	{ city: 'Knockalafalla (Waterford)', zip: '292443' },
	{ city: 'Knockalaghta (Roscommon)', zip: '489076' },
	{ city: 'Knockalahara (Waterford)', zip: '422166' },
	{ city: 'Knockalass (Sligo)', zip: '607249' },
	{ city: 'Knockalassa (Clare)', zip: '245656' },
	{ city: 'Knockalassa (Mayo)', zip: '412546' },
	{ city: 'Knockalassa (Waterford)', zip: '545925' },
	{ city: 'Knockaleanore (Mayo)', zip: '313971' },
	{ city: 'Knockalegan (Mayo)', zip: '895932' },
	{ city: 'Knockalegan (Tipperary)', zip: '306730' },
	{ city: 'Knockalegan East (Roscommon)', zip: '417201' },
	{ city: 'Knockalegan West (Roscommon)', zip: '455973' },
	{ city: 'Knockalehid (Clare)', zip: '664614' },
	{ city: 'Knockaleva (Louth)', zip: '826789' },
	{ city: 'Knockalibade (Kerry)', zip: '864112' },
	{ city: 'Knockalinsky (Mayo)', zip: '399199' },
	{ city: 'Knockalisheen (Clare)', zip: '972152' },
	{ city: 'Knockalisheen (Cork)', zip: '104466' },
	{ city: 'Knockalisheen (Waterford)', zip: '715501' },
	{ city: 'Knockaloaghan (Clare)', zip: '789806' },
	{ city: 'Knockalohert (Cork)', zip: '874010' },
	{ city: 'Knockalonga (Tipperary)', zip: '388566' },
	{ city: 'Knockalongford (Leitrim)', zip: '300794' },
	{ city: 'Knockalough (Clare)', zip: '143888' },
	{ city: 'Knockalough (Galway)', zip: '630949' },
	{ city: 'Knockalough (Mayo)', zip: '698223' },
	{ city: 'Knockalough (Sligo)', zip: '411168' },
	{ city: 'Knockalougha (Kerry)', zip: '358881' },
	{ city: 'Knockalough Commons (Tipperary)', zip: '770881' },
	{ city: 'Knockaloura East (Galway)', zip: '884486' },
	{ city: 'Knockaloura West (Galway)', zip: '556714' },
	{ city: 'Knockalt Lower (Wicklow)', zip: '530970' },
	{ city: 'Knockalton Lower (Tipperary)', zip: '540600' },
	{ city: 'Knockalton Upper (Tipperary)', zip: '844365' },
	{ city: 'Knockalt Upper (Wicklow)', zip: '410616' },
	{ city: 'Knockaluskraun (Clare)', zip: '616973' },
	{ city: 'Knockamany (Donegal)', zip: '805077' },
	{ city: 'Knockamoohane (Kerry)', zip: '140852' },
	{ city: 'Knockamullin (Laois)', zip: '448900' },
	{ city: 'Knockanabohilly (Tipperary)', zip: '424637' },
	{ city: 'Knockanacartan (Tipperary)', zip: '819203' },
	{ city: 'Knockanacohig (Cork)', zip: '595853' },
	{ city: 'Knockanaconny (Roscommon)', zip: '202030' },
	{ city: 'Knockanacree (Tipperary)', zip: '932208' },
	{ city: 'Knockanacuig (Kerry)', zip: '707873' },
	{ city: 'Knockanacullin (Waterford)', zip: '698819' },
	{ city: 'Knockanacunna (Tipperary)', zip: '518535' },
	{ city: 'Knockanaddoge (Kilkenny)', zip: '223548' },
	{ city: 'Knockanaffrin (Waterford)', zip: '335817' },
	{ city: 'Knockanagh (Waterford)', zip: '886733' },
	{ city: 'Knockanagher (Sligo)', zip: '824721' },
	{ city: 'Knockanalban (Clare)', zip: '813675' },
	{ city: 'Knockanally (Kildare)', zip: '805723' },
	{ city: 'Knockananeel (Mayo)', zip: '981026' },
	{ city: 'Knockananig (Cork)', zip: '964215' },
	{ city: 'Knockananima (Roscommon)', zip: '148519' },
	{ city: 'Knockananlig (Kerry)', zip: '557868' },
	{ city: 'Knockananna (Waterford)', zip: '478142' },
	{ city: 'Knockananna (Wicklow)', zip: '604185' },
	{ city: 'Knockanannig (Cork)', zip: '827025' },
	{ city: 'Knockananny (Mayo)', zip: '153450' },
	{ city: 'Knockananore (Kerry)', zip: '594209' },
	{ city: 'Knockananty (Limerick)', zip: '229755' },
	{ city: 'Knockanare (Cork)', zip: '119874' },
	{ city: 'Knockanarra (Galway)', zip: '882260' },
	{ city: 'Knockanarra (Mayo)', zip: '627276' },
	{ city: 'Knockanarrig (Cork)', zip: '130667' },
	{ city: 'Knockanarrigan (Wicklow)', zip: '262171' },
	{ city: 'Knockanarroor (Kerry)', zip: '790964' },
	{ city: 'Knockanarrow (Sligo)', zip: '785926' },
	{ city: 'Knockanasig (Kerry)', zip: '633152' },
	{ city: 'Knockanattin (Tipperary)', zip: '601929' },
	{ city: 'Knockanavar (Tipperary)', zip: '656868' },
	{ city: 'Knockanavoddy (Galway)', zip: '435678' },
	{ city: 'Knockanbaun (Limerick)', zip: '267344' },
	{ city: 'Knockanbaun (Longford)', zip: '617156' },
	{ city: 'Knockanbaun (Sligo)', zip: '827680' },
	{ city: 'Knockanboy (Longford)', zip: '239878' },
	{ city: 'Knockanclash (Tipperary)', zip: '859141' },
	{ city: 'Knockancullenagh (Tipperary)', zip: '379866' },
	{ city: 'Knockandarragh (Wicklow)', zip: '425709' },
	{ city: 'Knockandort (Wicklow)', zip: '132752' },
	{ city: 'Knockanduff (Waterford)', zip: '980719' },
	{ city: 'Knockanduff (Wexford)', zip: '536725' },
	{ city: 'Knockanduff (Wicklow)', zip: '691410' },
	{ city: 'Knockane (Cork)', zip: '184150' },
	{ city: 'Knockane (Kerry)', zip: '230730' },
	{ city: 'Knockane (Limerick)', zip: '226733' },
	{ city: 'Knockane (Tipperary)', zip: '181322' },
	{ city: 'Knockane (Waterford)', zip: '225738' },
	{ city: 'Knockanea (Limerick)', zip: '565341' },
	{ city: 'Knockanea (Westmeath)', zip: '252320' },
	{ city: 'Knockaneacoolteen (Kerry)', zip: '342755' },
	{ city: 'Knockaneady (Cork)', zip: '493682' },
	{ city: 'Knockaneag (Cork)', zip: '857767' },
	{ city: 'Knockaneagh (Cork)', zip: '173681' },
	{ city: 'Knockaneamealgulla (Cork)', zip: '314112' },
	{ city: 'Knockanean (Clare)', zip: '231799' },
	{ city: 'Knockanearis (Waterford)', zip: '967934' },
	{ city: 'Knockanearla (Monaghan)', zip: '779001' },
	{ city: 'Knockaneasy (Wexford)', zip: '911048' },
	{ city: 'Knockanebeg (Tipperary)', zip: '891582' },
	{ city: 'Knockanebrack (Limerick)', zip: '670888' },
	{ city: 'Knockanecosduff (Cork)', zip: '972854' },
	{ city: 'Knockaneda (Cork)', zip: '139696' },
	{ city: 'Knockaneden (Clare)', zip: '122280' },
	{ city: 'Knockaneden (Kerry)', zip: '147941' },
	{ city: 'Knockaneden (Mayo)', zip: '901125' },
	{ city: 'Knockaneduff (Tipperary)', zip: '209981' },
	{ city: 'Knockaneek (Dublin)', zip: '729187' },
	{ city: 'Knockaneglass East (Cork)', zip: '450325' },
	{ city: 'Knockaneglass West (Cork)', zip: '737457' },
	{ city: 'Knockaneleigh (Cork)', zip: '413572' },
	{ city: 'Knockanelo (Mayo)', zip: '104462' },
	{ city: 'Knockanemeeleen (Cork)', zip: '647274' },
	{ city: 'Knockanemore (Cork)', zip: '824711' },
	{ city: 'Knockane More (Cork)', zip: '596774' },
	{ city: 'Knockanemorney (Cork)', zip: '364972' },
	{ city: 'Knockanena (Clare)', zip: '751053' },
	{ city: 'Knockanenabohilly (Cork)', zip: '471863' },
	{ city: 'Knockanenacrohy (Cork)', zip: '132042' },
	{ city: 'Knockanenafinoga (Cork)', zip: '328456' },
	{ city: 'Knockanenagark (Cork)', zip: '313334' },
	{ city: 'Knockanenakirka (Cork)', zip: '366502' },
	{ city: 'Knockaneowen (Cork)', zip: '532770' },
	{ city: 'Knockanereagh (Cork)', zip: '565387' },
	{ city: 'Knockaneroe (Cork)', zip: '311321' },
	{ city: 'Knockaneroe (Kerry)', zip: '512143' },
	{ city: 'Knockaneroe (Tipperary)', zip: '802557' },
	{ city: 'Knockanerrew (Mayo)', zip: '379631' },
	{ city: 'Knockanerry (Limerick)', zip: '218122' },
	{ city: 'Knockanes (Kerry)', zip: '396720' },
	{ city: 'Knockanes (Limerick)', zip: '163100' },
	{ city: 'Knockaneshane (Cork)', zip: '283668' },
	{ city: 'Knockanevin (Cork)', zip: '292114' },
	{ city: 'Knockanevin (Tipperary)', zip: '506719' },
	{ city: 'Knockanevin (Wexford)', zip: '733404' },
	{ city: 'Knockaneyouloo (Kerry)', zip: '465226' },
	{ city: 'Knockanfoil More (Tipperary)', zip: '544965' },
	{ city: 'Knockangall (Wexford)', zip: '945037' },
	{ city: 'Knockanglass (Tipperary)', zip: '105024' },
	{ city: 'Knockanillaun (Mayo)', zip: '754922' },
	{ city: 'Knockanima (Galway)', zip: '384844' },
	{ city: 'Knockanimana (Clare)', zip: '634511' },
	{ city: 'Knockanimma (Sligo)', zip: '398362' },
	{ city: 'Knockanimrish (Kerry)', zip: '839065' },
	{ city: 'Knockanina (Laois)', zip: '771927' },
	{ city: 'Knockaninane East (Kerry)', zip: '511421' },
	{ city: 'Knockaninane West (Kerry)', zip: '183859' },
	{ city: 'Knockaninaun (Clare)', zip: '906128' },
	{ city: 'Knockanira (Clare)', zip: '864826' },
	{ city: 'Knockaniska (Waterford)', zip: '255768' },
	{ city: 'Knockaniska East (Waterford)', zip: '651755' },
	{ city: 'Knockaniska West (Waterford)', zip: '635132' },
	{ city: 'Knockannabinna (Tipperary)', zip: '256021' },
	{ city: 'Knockannacreeva (Limerick)', zip: '937997' },
	{ city: 'Knockannagad (Laois)', zip: '328047' },
	{ city: 'Knockannagore (Kerry)', zip: '626182' },
	{ city: 'Knockannamaurnagh (Cork)', zip: '665328' },
	{ city: 'Knockannamohilly (Tipperary)', zip: '406314' },
	{ city: 'Knockannanagh (Waterford)', zip: '302689' },
	{ city: 'Knockannapisha (Tipperary)', zip: '598351' },
	{ city: 'Knockannaveigh (Tipperary)', zip: '592222' },
	{ city: 'Knockanoark (Cavan)', zip: '998939' },
	{ city: 'Knockanode (Wicklow)', zip: '231532' },
	{ city: 'Knockanohill (Cork)', zip: '208893' },
	{ city: 'Knockanooker Lower (Wicklow)', zip: '177180' },
	{ city: 'Knockanooker Upper (Wicklow)', zip: '636234' },
	{ city: 'Knockanora (Tipperary)', zip: '314360' },
	{ city: 'Knockanoran (Cork)', zip: '762683' },
	{ city: 'Knockanoran (Laois)', zip: '776879' },
	{ city: 'Knockanore (Cavan)', zip: '173459' },
	{ city: 'Knockanore (Kilkenny)', zip: '681833' },
	{ city: 'Knockanore (Waterford)', zip: '827133' },
	{ city: 'Knockanotish (Mayo)', zip: '459943' },
	{ city: 'Knockanoulort (Kerry)', zip: '189532' },
	{ city: 'Knockanoulty (Cork)', zip: '837095' },
	{ city: 'Knockanour (Mayo)', zip: '604899' },
	{ city: 'Knockanoura (Clare)', zip: '428429' },
	{ city: 'Knockanowal (Laois)', zip: '785567' },
	{ city: 'Knockanpaddin (Waterford)', zip: '352591' },
	{ city: 'Knockanpierce (Tipperary)', zip: '134956' },
	{ city: 'Knockanpower Lower (Waterford)', zip: '751360' },
	{ city: 'Knockanpower Upper (Waterford)', zip: '773378' },
	{ city: 'Knockanrahan Lower (Wicklow)', zip: '602095' },
	{ city: 'Knockanrahan Upper (Wicklow)', zip: '273599' },
	{ city: 'Knockanrawley (Tipperary)', zip: '818577' },
	{ city: 'Knockanreagh (Cork)', zip: '118876' },
	{ city: 'Knockanreagh (Wicklow)', zip: '624585' },
	{ city: 'Knockanree (Wicklow)', zip: '841703' },
	{ city: 'Knockanree Lower (Wicklow)', zip: '965342' },
	{ city: 'Knockanree Upper (Wicklow)', zip: '524904' },
	{ city: 'Knockanroe (Cork)', zip: '978693' },
	{ city: 'Knockanroe (Kilkenny)', zip: '953161' },
	{ city: 'Knockanroe (Leitrim)', zip: '202852' },
	{ city: 'Knockanroe (Mayo)', zip: '674494' },
	{ city: 'Knockanroe (Tipperary)', zip: '156046' },
	{ city: 'Knockanroe (Waterford)', zip: '903939' },
	{ city: 'Knockanroe North (Kilkenny)', zip: '394804' },
	{ city: 'Knockanroe South (Kilkenny)', zip: '174300' },
	{ city: 'Knockanroger (Tipperary)', zip: '231072' },
	{ city: 'Knockanruddig (Kerry)', zip: '898830' },
	{ city: 'Knockans Lower (Clare)', zip: '724936' },
	{ city: 'Knockans Upper (Clare)', zip: '871797' },
	{ city: 'Knockansweeny (Cork)', zip: '967189' },
	{ city: 'Knockantemple (Tipperary)', zip: '245446' },
	{ city: 'Knockantibrien (Tipperary)', zip: '446276' },
	{ city: 'Knockantota North (Cork)', zip: '142441' },
	{ city: 'Knockantota South (Cork)', zip: '535200' },
	{ city: 'Knockanuha (Kerry)', zip: '990433' },
	{ city: 'Knockanulty (Clare)', zip: '715044' },
	{ city: 'Knockanumera (Mayo)', zip: '682809' },
	{ city: 'Knockanure (Cork)', zip: '776232' },
	{ city: 'Knockanure (Wexford)', zip: '991040' },
	{ city: 'Knockanush East (Kerry)', zip: '348989' },
	{ city: 'Knockanush West (Kerry)', zip: '286376' },
	{ city: 'Knockanyconor (Roscommon)', zip: '167049' },
	{ city: 'Knockaphonery (Cork)', zip: '949687' },
	{ city: 'Knockaphort (Clare)', zip: '368031' },
	{ city: 'Knockaphreaghane (Cork)', zip: '775957' },
	{ city: 'Knockaphreaghaun (Clare)', zip: '829995' },
	{ city: 'Knockaphreaghaun (Galway)', zip: '388778' },
	{ city: 'Knockaphrumpa (Wicklow)', zip: '483070' },
	{ city: 'Knockaphubble (Monaghan)', zip: '792912' },
	{ city: 'Knockaphuca (Kildare)', zip: '759104' },
	{ city: 'Knockaphunta (Mayo)', zip: '540019' },
	{ city: 'Knockaquirk (Wicklow)', zip: '994521' },
	{ city: 'Knockaraha (Mayo)', zip: '976934' },
	{ city: 'Knockaraha (Waterford)', zip: '761211' },
	{ city: 'Knockaraha East (Mayo)', zip: '685476' },
	{ city: 'Knockaraha West (Mayo)', zip: '771996' },
	{ city: 'Knockaraheen (Cavan)', zip: '902500' },
	{ city: 'Knockaranny (Meath)', zip: '542448' },
	{ city: 'Knockarasser (Galway)', zip: '325959' },
	{ city: 'Knockard (Kilkenny)', zip: '186495' },
	{ city: 'Knockarda (Carlow)', zip: '424598' },
	{ city: 'Knockardagannon North (Laois)', zip: '529418' },
	{ city: 'Knockardagannon South (Laois)', zip: '681709' },
	{ city: 'Knockardagur (Laois)', zip: '992668' },
	{ city: 'Knockardamrum (Cork)', zip: '611585' },
	{ city: 'Knockardbane (Cork)', zip: '903921' },
	{ city: 'Knockardfree (Cork)', zip: '106418' },
	{ city: 'Knockardnacorlan (Limerick)', zip: '389418' },
	{ city: 'Knockardrahan (Cork)', zip: '878419' },
	{ city: 'Knockardsharriv (Cork)', zip: '182012' },
	{ city: 'Knockardtry (Kerry)', zip: '947380' },
	{ city: 'Knockaree (Wexford)', zip: '202187' },
	{ city: 'Knockariblihane (Cork)', zip: '481055' },
	{ city: 'Knockariddane (Kerry)', zip: '226739' },
	{ city: 'Knockariddera (Kerry)', zip: '539507' },
	{ city: 'Knockarigg (Wicklow)', zip: '840266' },
	{ city: 'Knockarigg Demesne (Wicklow)', zip: '539226' },
	{ city: 'Knockarigg Hill (Wicklow)', zip: '712136' },
	{ city: 'Knockarley (Offaly)', zip: '454529' },
	{ city: 'Knockaroe (Laois)', zip: '428908' },
	{ city: 'Knockaroura (Cork)', zip: '308852' },
	{ city: 'Knockarudane (Cork)', zip: '739522' },
	{ city: 'Knockarush (Roscommon)', zip: '242448' },
	{ city: 'Knockasarnet (Kerry)', zip: '906289' },
	{ city: 'Knockash (Galway)', zip: '190014' },
	{ city: 'Knockaskeehaun (Mayo)', zip: '661304' },
	{ city: 'Knockaskehane (Cork)', zip: '203443' },
	{ city: 'Knockaskeheen (Clare)', zip: '988072' },
	{ city: 'Knockaskibbole (Clare)', zip: '824567' },
	{ city: 'Knockaskibbole (Mayo)', zip: '213225' },
	{ city: 'Knockasproha (Mayo)', zip: '812228' },
	{ city: 'Knockaspur (Offaly)', zip: '241740' },
	{ city: 'Knockastickane (Cork)', zip: '972132' },
	{ city: 'Knockastoller (Donegal)', zip: '512144' },
	{ city: 'Knockastuckane (Cork)', zip: '362669' },
	{ city: 'Knockasturkeen (Cork)', zip: '788904' },
	{ city: 'Knockataggart (Cavan)', zip: '648238' },
	{ city: 'Knockataggart (Cork)', zip: '791301' },
	{ city: 'Knockataggart (Mayo)', zip: '682667' },
	{ city: 'Knockataggle Beg (Kerry)', zip: '149599' },
	{ city: 'Knockataggle More (Kerry)', zip: '571955' },
	{ city: 'Knockatallan (Monaghan)', zip: '664828' },
	{ city: 'Knockatancashlane (Limerick)', zip: '663476' },
	{ city: 'Knockatarriv (Kerry)', zip: '728759' },
	{ city: 'Knockatarry (Longford)', zip: '754430' },
	{ city: 'Knockatassonig (Cork)', zip: '152408' },
	{ city: 'Knockatavy (Louth)', zip: '623724' },
	{ city: 'Knockataylor (Wexford)', zip: '156072' },
	{ city: 'Knockateane (Cavan)', zip: '932695' },
	{ city: 'Knockatee (Cavan)', zip: '586950' },
	{ city: 'Knockatee (Kerry)', zip: '616448' },
	{ city: 'Knockatee (Westmeath)', zip: '346180' },
	{ city: 'Knockateean (Leitrim)', zip: '122957' },
	{ city: 'Knockatee East (Galway)', zip: '705818' },
	{ city: 'Knockateemore (Waterford)', zip: '688842' },
	{ city: 'Knockateery (Cavan)', zip: '349206' },
	{ city: 'Knockatee West (Galway)', zip: '748730' },
	{ city: 'Knockatelly (Sligo)', zip: '274581' },
	{ city: 'Knockatemple (Cavan)', zip: '286209' },
	{ city: 'Knockatemple (Clare)', zip: '288955' },
	{ city: 'Knockatemple (Mayo)', zip: '652047' },
	{ city: 'Knockatemple (Wicklow)', zip: '252532' },
	{ city: 'Knockatermon (Clare)', zip: '226724' },
	{ city: 'Knockatillane (Wicklow)', zip: '766093' },
	{ city: 'Knockatinnole (Mayo)', zip: '106664' },
	{ city: 'Knockatinty (Clare)', zip: '244796' },
	{ city: 'Knockatippaun (Kildare)', zip: '223218' },
	{ city: 'Knockatloe (Clare)', zip: '467360' },
	{ city: 'Knockatlowig (Cork)', zip: '257492' },
	{ city: 'Knockatober (Louth)', zip: '382284' },
	{ city: 'Knockatober (Mayo)', zip: '819235' },
	{ city: 'Knockatober (Sligo)', zip: '965511' },
	{ city: 'Knockatober (Wexford)', zip: '651582' },
	{ city: 'Knockatogher (Galway)', zip: '419515' },
	{ city: 'Knockatomcoyle (Wicklow)', zip: '228039' },
	{ city: 'Knockatoo (Galway)', zip: '579968' },
	{ city: 'Knockatooan (Cork)', zip: '844567' },
	{ city: 'Knockatoo Mountain (Galway)', zip: '837775' },
	{ city: 'Knockatoor (Cork)', zip: '214280' },
	{ city: 'Knockatoor (Galway)', zip: '693731' },
	{ city: 'Knockatoor (Tipperary)', zip: '347438' },
	{ city: 'Knockatoor (Waterford)', zip: '231245' },
	{ city: 'Knockatoora Commons (Tipperary)', zip: '270839' },
	{ city: 'Knockatooreen (Clare)', zip: '447222' },
	{ city: 'Knockatooreen (Tipperary)', zip: '569389' },
	{ city: 'Knockatore (Kilkenny)', zip: '194896' },
	{ city: 'Knockatotaun (Mayo)', zip: '575093' },
	{ city: 'Knockatotaun (Sligo)', zip: '729110' },
	{ city: 'Knockatouk (Waterford)', zip: '197329' },
	{ city: 'Knockatoumpane (Cork)', zip: '639904' },
	{ city: 'Knockatrasnane (Cork)', zip: '472178' },
	{ city: 'Knockatreenane (Cork)', zip: '144739' },
	{ city: 'Knockatrellane (Waterford)', zip: '519216' },
	{ city: 'Knockattigan (Cork)', zip: '214615' },
	{ city: 'Knockattin (Louth)', zip: '722993' },
	{ city: 'Knockatudor (Cavan)', zip: '577017' },
	{ city: 'Knockatullaghaun (Clare)', zip: '829684' },
	{ city: 'Knockatunna (Clare)', zip: '336135' },
	{ city: 'Knockaturly (Monaghan)', zip: '236796' },
	{ city: 'Knockaturnory (Waterford)', zip: '125284' },
	{ city: 'Knockauduff (Cork)', zip: '327569' },
	{ city: 'Knockaulin (Kildare)', zip: '514320' },
	{ city: 'Knockaun (Clare)', zip: '113280' },
	{ city: 'Knockaun (Galway)', zip: '222858' },
	{ city: 'Knockaun (Mayo)', zip: '970818' },
	{ city: 'Knockaun (Sligo)', zip: '404894' },
	{ city: 'Knockaun (Waterford)', zip: '842669' },
	{ city: 'Knockaunabroona (Mayo)', zip: '648261' },
	{ city: 'Knockaunabulloga (Waterford)', zip: '575920' },
	{ city: 'Knockaunacat (Mayo)', zip: '139566' },
	{ city: 'Knockaunacorrin (Cork)', zip: '973044' },
	{ city: 'Knockaunacuit (Waterford)', zip: '313252' },
	{ city: 'Knockaunacurraheen (Kerry)', zip: '574403' },
	{ city: 'Knockaunagloon (Waterford)', zip: '974371' },
	{ city: 'Knockaunakill (Mayo)', zip: '655081' },
	{ city: 'Knockaunalour (Cork)', zip: '853575' },
	{ city: 'Knockaunanerrigal (Clare)', zip: '377070' },
	{ city: 'Knockaunarainy (Galway)', zip: '914833' },
	{ city: 'Knockaunarast (Waterford)', zip: '391384' },
	{ city: 'Knockaunatee (Kerry)', zip: '491692' },
	{ city: 'Knockaunatouk (Galway)', zip: '596910' },
	{ city: 'Knockaunavad (Limerick)', zip: '767590' },
	{ city: 'Knockaunavaddreen (Cork)', zip: '855433' },
	{ city: 'Knockaunavlyman (Limerick)', zip: '526416' },
	{ city: 'Knockaunavoddig (Limerick)', zip: '796744' },
	{ city: 'Knockaunavogga (Tipperary)', zip: '588803' },
	{ city: 'Knockaunawadda (Galway)', zip: '554928' },
	{ city: 'Knockaunbaun (Galway)', zip: '325217' },
	{ city: 'Knockaunbaun (Mayo)', zip: '224357' },
	{ city: 'Knockaunbrack (Galway)', zip: '884758' },
	{ city: 'Knockaunbrack (Kerry)', zip: '396136' },
	{ city: 'Knockaunbrandaun (Waterford)', zip: '226179' },
	{ city: 'Knockauncarragh (Galway)', zip: '318751' },
	{ city: 'Knockauncore (Kerry)', zip: '807167' },
	{ city: 'Knockauncoura (Galway)', zip: '847192' },
	{ city: 'Knockauncourt (Tipperary)', zip: '739461' },
	{ city: 'Knockauncurragh (Kerry)', zip: '280633' },
	{ city: 'Knockaundarragh (Galway)', zip: '747168' },
	{ city: 'Knockaunderry (Mayo)', zip: '734249' },
	{ city: 'Knockaundoolis (Limerick)', zip: '927434' },
	{ city: 'Knockaun East (Waterford)', zip: '319875' },
	{ city: 'Knockauneevin And Ballywatteen (Galway)', zip: '295306' },
	{ city: 'Knockaunfargarve (Waterford)', zip: '866774' },
	{ city: 'Knockaungarriff (Waterford)', zip: '338550' },
	{ city: 'Knockaunglass (Galway)', zip: '713549' },
	{ city: 'Knockaunglass (Kerry)', zip: '414327' },
	{ city: 'Knockaunkeel (Galway)', zip: '885187' },
	{ city: 'Knockaunmore (Kerry)', zip: '616133' },
	{ city: 'Knockaunnacarragh (Galway)', zip: '917078' },
	{ city: 'Knockaunnacuddoge (Kerry)', zip: '798247' },
	{ city: 'Knockaunnacurraha (Limerick)', zip: '659671' },
	{ city: 'Knockaunnagat (Galway)', zip: '137756' },
	{ city: 'Knockaunnageeha (Galway)', zip: '963757' },
	{ city: 'Knockaunnaglokee (Waterford)', zip: '926478' },
	{ city: 'Knockaunnagoun (Waterford)', zip: '143070' },
	{ city: 'Knockaunnagun (Limerick)', zip: '151796' },
	{ city: 'Knockaunnakirkeen (Galway)', zip: '469545' },
	{ city: 'Knockaunnanoon (Kerry)', zip: '131679' },
	{ city: 'Knockaun North (Waterford)', zip: '903058' },
	{ city: 'Knockaunranny (Galway)', zip: '548698' },
	{ city: 'Knockaunroe (Clare)', zip: '558831' },
	{ city: 'Knockaunroe (Galway)', zip: '220653' },
	{ city: 'Knockaunroe (Kerry)', zip: '478443' },
	{ city: 'Knockaunroe (Limerick)', zip: '971565' },
	{ city: 'Knockaunroe (Waterford)', zip: '493782' },
	{ city: 'Knockaunrory (Kerry)', zip: '790327' },
	{ city: 'Knockauns (Tipperary)', zip: '524129' },
	{ city: 'Knockauns East (Galway)', zip: '320333' },
	{ city: 'Knockaunsmountain (Clare)', zip: '658442' },
	{ city: 'Knockaun South (Waterford)', zip: '830726' },
	{ city: 'Knockauns West (Galway)', zip: '442338' },
	{ city: 'Knockaunvickteera (Clare)', zip: '551276' },
	{ city: 'Knockavadagh (Tipperary)', zip: '642497' },
	{ city: 'Knockavaddra (Cork)', zip: '651765' },
	{ city: 'Knockavaghig (Kerry)', zip: '796622' },
	{ city: 'Knockavallig (Kerry)', zip: '164536' },
	{ city: 'Knockavally (Galway)', zip: '931845' },
	{ city: 'Knockavally (Kilkenny)', zip: '166213' },
	{ city: 'Knockavanloman (Mayo)', zip: '137118' },
	{ city: 'Knockavannia (Waterford)', zip: '706902' },
	{ city: 'Knockavanniamountain (Waterford)', zip: '761548' },
	{ city: 'Knockavanny (Galway)', zip: '994441' },
	{ city: 'Knockaveale (Cork)', zip: '735840' },
	{ city: 'Knockaveelish (Waterford)', zip: '989099' },
	{ city: 'Knockaveely Glebe (Mayo)', zip: '727411' },
	{ city: 'Knockavegan (Longford)', zip: '615789' },
	{ city: 'Knockavelish (Waterford)', zip: '913413' },
	{ city: 'Knockaverry (Cork)', zip: '315178' },
	{ city: 'Knockavilla (Galway)', zip: '375999' },
	{ city: 'Knockavilla (Mayo)', zip: '660147' },
	{ city: 'Knockavilla (Tipperary)', zip: '808025' },
	{ city: 'Knockavilla (Wexford)', zip: '294577' },
	{ city: 'Knockaville (Westmeath)', zip: '749471' },
	{ city: 'Knockavinnane (Kerry)', zip: '149732' },
	{ city: 'Knockavoarheen (Clare)', zip: '390594' },
	{ city: 'Knockavocka (Wexford)', zip: '477859' },
	{ city: 'Knockavoher (Cork)', zip: '111204' },
	{ city: 'Knockavolis (Monaghan)', zip: '478053' },
	{ city: 'Knockavoreen (Cork)', zip: '616098' },
	{ city: 'Knockavota (Kerry)', zip: '321274' },
	{ city: 'Knockavota (Wexford)', zip: '233903' },
	{ city: 'Knockavreaneen (Roscommon)', zip: '874178' },
	{ city: 'Knockavroe (Roscommon)', zip: '528763' },
	{ city: 'Knockavrogeen East (Kerry)', zip: '764556' },
	{ city: 'Knockavrogeen West (Kerry)', zip: '515679' },
	{ city: 'Knockavrony (Mayo)', zip: '308142' },
	{ city: 'Knockavuddig (Cork)', zip: '161449' },
	{ city: 'Knockavullig (Cork)', zip: '475845' },
	{ city: 'Knockavurra Glebe (Kerry)', zip: '535919' },
	{ city: 'Knockavurrea (Roscommon)', zip: '818175' },
	{ city: 'Knockavurrig (Wicklow)', zip: '473955' },
	{ city: 'Knockawaddra (Cork)', zip: '722088' },
	{ city: 'Knockawaddra East (Kerry)', zip: '564160' },
	{ city: 'Knockawaddra Middle (Kerry)', zip: '254997' },
	{ city: 'Knockawaddra West (Kerry)', zip: '236011' },
	{ city: 'Knockawalky (Longford)', zip: '313766' },
	{ city: 'Knockawillin (Cork)', zip: '125471' },
	{ city: 'Knockawinna (Kerry)', zip: '708277' },
	{ city: 'Knockawuddy (Galway)', zip: '916642' },
	{ city: 'Knockballagh (Mayo)', zip: '198661' },
	{ city: 'Knockballiniry (Tipperary)', zip: '382523' },
	{ city: 'Knockballyboy (Offaly)', zip: '425922' },
	{ city: 'Knockballyclery (Galway)', zip: '267628' },
	{ city: 'Knockballyfookeen (Limerick)', zip: '796276' },
	{ city: 'Knockballymaloogh (Tipperary)', zip: '662717' },
	{ city: 'Knockballymartin (Cork)', zip: '640963' },
	{ city: 'Knockballynameath (Clare)', zip: '363015' },
	{ city: 'Knockballynoe East (Tipperary)', zip: '452821' },
	{ city: 'Knockballynoe West (Tipperary)', zip: '965527' },
	{ city: 'Knockballyroney (Monaghan)', zip: '667563' },
	{ city: 'Knockballystine (Carlow)', zip: '321499' },
	{ city: 'Knockballyvishteal (Galway)', zip: '197917' },
	{ city: 'Knockbane (Donegal)', zip: '817637' },
	{ city: 'Knockbane (Galway)', zip: '899797' },
	{ city: 'Knockbane (Kildare)', zip: '549494' },
	{ city: 'Knockbane (Offaly)', zip: '107660' },
	{ city: 'Knockbane (Wicklow)', zip: '402802' },
	{ city: 'Knockbaron (Galway)', zip: '728055' },
	{ city: 'Knockbarragh (Carlow)', zip: '897143' },
	{ city: 'Knockbarron (Offaly)', zip: '792571' },
	{ city: 'Knockbarron North (Kilkenny)', zip: '891251' },
	{ city: 'Knockbarron South (Kilkenny)', zip: '141759' },
	{ city: 'Knockbarry (Cork)', zip: '754577' },
	{ city: 'Knockbaun (Galway)', zip: '108787' },
	{ city: 'Knockbaun (Laois)', zip: '618810' },
	{ city: 'Knockbaun (Mayo)', zip: '509679' },
	{ city: 'Knockbaun (Waterford)', zip: '870496' },
	{ city: 'Knockbaun (Wexford)', zip: '724604' },
	{ city: 'Knockbawn (Wicklow)', zip: '629855' },
	{ city: 'Knockbeg (Laois)', zip: '578972' },
	{ city: 'Knockbeg (Mayo)', zip: '465178' },
	{ city: 'Knockbeg East (Sligo)', zip: '157278' },
	{ city: 'Knockbeg West (Sligo)', zip: '410121' },
	{ city: 'Knockbeha (Clare)', zip: '475370' },
	{ city: 'Knockbeha Mountain (Clare)', zip: '343956' },
	{ city: 'Knockbine (Wexford)', zip: '934900' },
	{ city: 'Knockbodaly (Kilkenny)', zip: '901880' },
	{ city: 'Knockbody (Westmeath)', zip: '838835' },
	{ city: 'Knockboghil (Cork)', zip: '945031' },
	{ city: 'Knockboha (Mayo)', zip: '819048' },
	{ city: 'Knockboordan (Tipperary)', zip: '253632' },
	{ city: 'Knockbounce (Kildare)', zip: '827623' },
	{ city: 'Knockbower (Carlow)', zip: '655210' },
	{ city: 'Knockboy (Carlow)', zip: '247331' },
	{ city: 'Knockboy (Cork)', zip: '968224' },
	{ city: 'Knockboy (Galway)', zip: '417049' },
	{ city: 'Knockboy (Mayo)', zip: '488976' },
	{ city: 'Knockboy (Monaghan)', zip: '947205' },
	{ city: 'Knockboy (Tipperary)', zip: '808989' },
	{ city: 'Knockboy (Waterford)', zip: '849807' },
	{ city: 'Knockbrack (Carlow)', zip: '636669' },
	{ city: 'Knockbrack (Clare)', zip: '164678' },
	{ city: 'Knockbrack (Cork)', zip: '246318' },
	{ city: 'Knockbrack (Donegal)', zip: '851457' },
	{ city: 'Knockbrack (Dublin)', zip: '442777' },
	{ city: 'Knockbrack (Galway)', zip: '753920' },
	{ city: 'Knockbrack (Kerry)', zip: '827736' },
	{ city: 'Knockbrack (Kilkenny)', zip: '492915' },
	{ city: 'Knockbrack (Laois)', zip: '637547' },
	{ city: 'Knockbrack (Leitrim)', zip: '713576' },
	{ city: 'Knockbrack (Limerick)', zip: '301660' },
	{ city: 'Knockbrack (Mayo)', zip: '463025' },
	{ city: 'Knockbrack (Meath)', zip: '207355' },
	{ city: 'Knockbrack (Offaly)', zip: '895369' },
	{ city: 'Knockbrack (Sligo)', zip: '727066' },
	{ city: 'Knockbrack (Tipperary)', zip: '411715' },
	{ city: 'Knockbrack (Waterford)', zip: '586800' },
	{ city: 'Knockbrack (Wexford)', zip: '672836' },
	{ city: 'Knockbrack East (Kerry)', zip: '830653' },
	{ city: 'Knockbrack East (Limerick)', zip: '675077' },
	{ city: 'Knockbrack Lower (Clare)', zip: '818381' },
	{ city: 'Knockbrack Upper (Clare)', zip: '487307' },
	{ city: 'Knockbrack West (Kerry)', zip: '195966' },
	{ city: 'Knockbrack West (Limerick)', zip: '660063' },
	{ city: 'Knockbrandon Lower (Wexford)', zip: '691886' },
	{ city: 'Knockbrandon Upper (Wexford)', zip: '485230' },
	{ city: 'Knockbreaga (Mayo)', zip: '785188' },
	{ city: 'Knockbreenagher (Sligo)', zip: '443137' },
	{ city: 'Knockbride (Cavan)', zip: '341530' },
	{ city: 'Knockbridge (Louth)', zip: '727040' },
	{ city: 'Knockbrien (Limerick)', zip: '962938' },
	{ city: 'Knockbrit (Tipperary)', zip: '991947' },
	{ city: 'Knockbroad (Wexford)', zip: '393942' },
	{ city: 'Knockbrogan (Cork)', zip: '463198' },
	{ city: 'Knockbrown (Cork)', zip: '312847' },
	{ city: 'Knockbulloge (Tipperary)', zip: '390265' },
	{ city: 'Knockburden (Cork)', zip: '463119' },
	{ city: 'Knockburrane (Kerry)', zip: '276402' },
	{ city: 'Knockbutton (Kilkenny)', zip: '317429' },
	{ city: 'Knockbweeheen (Limerick)', zip: '966318' },
	{ city: 'Knockcahill (Cork)', zip: '650395' },
	{ city: 'Knockclonagad (Carlow)', zip: '876536' },
	{ city: 'Knockcloona (Cork)', zip: '483357' },
	{ city: 'Knockcommane (Limerick)', zip: '277461' },
	{ city: 'Knockcommon (Meath)', zip: '215229' },
	{ city: 'Knockconan (Monaghan)', zip: '407296' },
	{ city: 'Knockcoolkeare (Limerick)', zip: '530635' },
	{ city: 'Knockcor (Kildare)', zip: '230393' },
	{ city: 'Knockcor (Louth)', zip: '180837' },
	{ city: 'Knockcor (Monaghan)', zip: '849495' },
	{ city: 'Knockcorragh (Limerick)', zip: '183868' },
	{ city: 'Knockcorragh (Waterford)', zip: '160823' },
	{ city: 'Knockcorrandoo (Galway)', zip: '856279' },
	{ city: 'Knockcroghery (Roscommon)', zip: '486431' },
	{ city: 'Knockcumshin (Wexford)', zip: '463750' },
	{ city: 'Knockcurlan (Louth)', zip: '723634' },
	{ city: 'Knockcurra (Tipperary)', zip: '851618' },
	{ city: 'Knockcurraghbola Commons (Tipperary)', zip: '584846' },
	{ city: 'Knockcurraghbola Crownlands (Tipperary)', zip: '871990' },
	{ city: 'Knockdav (Kilkenny)', zip: '695982' },
	{ city: 'Knockderk (Limerick)', zip: '881389' },
	{ city: 'Knockdinnin (Louth)', zip: '848438' },
	{ city: 'Knockdoebeg East (Galway)', zip: '394881' },
	{ city: 'Knockdoebeg West (Galway)', zip: '293726' },
	{ city: 'Knockdoemore (Galway)', zip: '279306' },
	{ city: 'Knockdomny (Westmeath)', zip: '886421' },
	{ city: 'Knockdonagh (Clare)', zip: '358337' },
	{ city: 'Knockdoo (Wicklow)', zip: '927081' },
	{ city: 'Knockdoocunna (Clare)', zip: '389345' },
	{ city: 'Knockdoorah (Kerry)', zip: '209364' },
	{ city: 'Knockdoorish (Carlow)', zip: '357849' },
	{ city: 'Knockdoorty (Cork)', zip: '253082' },
	{ city: 'Knockdown (Kerry)', zip: '420961' },
	{ city: 'Knockdown (Limerick)', zip: '269294' },
	{ city: 'Knockdramagh (Carlow)', zip: '533953' },
	{ city: 'Knockdrin (Offaly)', zip: '824631' },
	{ city: 'Knockdrin (Westmeath)', zip: '272238' },
	{ city: 'Knockdrislagh (Cork)', zip: '632916' },
	{ city: 'Knockdromaclogh (Cork)', zip: '744602' },
	{ city: 'Knockdromin (Limerick)', zip: '869550' },
	{ city: 'Knockdrum (Cork)', zip: '664619' },
	{ city: 'Knockdrumdonnell (Roscommon)', zip: '732182' },
	{ city: 'Knockdrumleague (Clare)', zip: '879947' },
	{ city: 'Knockdrummagh North (Clare)', zip: '322673' },
	{ city: 'Knockdrummagh South (Clare)', zip: '494119' },
	{ city: 'Knockdrummore (Galway)', zip: '432951' },
	{ city: 'Knockduff (Cork)', zip: '745120' },
	{ city: 'Knockduff (Donegal)', zip: '466169' },
	{ city: 'Knockduff (Kerry)', zip: '532432' },
	{ city: 'Knockduff (Mayo)', zip: '438528' },
	{ city: 'Knockduff (Tipperary)', zip: '851612' },
	{ city: 'Knockduff (Wexford)', zip: '825212' },
	{ city: 'Knockduff Lower (Cork)', zip: '891843' },
	{ city: 'Knockduff Upper (Cork)', zip: '527162' },
	{ city: 'Knockdunnee (Tipperary)', zip: '107378' },
	{ city: 'Knockea (Cork)', zip: '336980' },
	{ city: 'Knockea (Limerick)', zip: '466276' },
	{ city: 'Knockea (Wexford)', zip: '523568' },
	{ city: 'Knockeanagh (Kerry)', zip: '500593' },
	{ city: 'Knockearagh (Cork)', zip: '228406' },
	{ city: 'Knockearagh (Kerry)', zip: '751489' },
	{ city: 'Knockearl (Offaly)', zip: '616832' },
	{ city: 'Knockeen (Carlow)', zip: '302510' },
	{ city: 'Knockeen (Cork)', zip: '864785' },
	{ city: 'Knockeen (Kerry)', zip: '752869' },
	{ city: 'Knockeen (Limerick)', zip: '494563' },
	{ city: 'Knockeen (Mayo)', zip: '947220' },
	{ city: 'Knockeen (Tipperary)', zip: '167453' },
	{ city: 'Knockeen (Waterford)', zip: '601810' },
	{ city: 'Knockeen (Wexford)', zip: '989388' },
	{ city: 'Knockeen (Wicklow)', zip: '888382' },
	{ city: 'Knockeenacurrig East (Cork)', zip: '514342' },
	{ city: 'Knockeenacurrig West (Cork)', zip: '788858' },
	{ city: 'Knockeenacuttin (Cork)', zip: '756442' },
	{ city: 'Knockeenadallane (Cork)', zip: '868178' },
	{ city: 'Knockeenatuder (Cork)', zip: '796843' },
	{ city: 'Knockeenawaddra (Kerry)', zip: '455327' },
	{ city: 'Knockeenbaun (Kilkenny)', zip: '590146' },
	{ city: 'Knockeenboy (Cork)', zip: '104129' },
	{ city: 'Knockeenbwee Lower (Cork)', zip: '607119' },
	{ city: 'Knockeenbwee Upper (Cork)', zip: '570915' },
	{ city: 'Knockeencon (Cork)', zip: '723179' },
	{ city: 'Knockeencreen (Kerry)', zip: '378459' },
	{ city: 'Knockeenduff (Kerry)', zip: '710114' },
	{ city: 'Knockeengancan (Waterford)', zip: '201035' },
	{ city: 'Knockeenglass (Kilkenny)', zip: '280363' },
	{ city: 'Knockeennagearagh (Cork)', zip: '152261' },
	{ city: 'Knockeennagowan (Kerry)', zip: '299487' },
	{ city: 'Knockeennagroagh (Cork)', zip: '236241' },
	{ city: 'Knockeennahone (Kerry)', zip: '485712' },
	{ city: 'Knockeennalicka (Kerry)', zip: '637113' },
	{ city: 'Knockeens (Cork)', zip: '498985' },
	{ city: 'Knockeens (Kerry)', zip: '494611' },
	{ city: 'Knockeeragh (Mayo)', zip: '303880' },
	{ city: 'Knockeevan (Tipperary)', zip: '607311' },
	{ city: 'Knockegan And Cloonagh Beg (Mayo)', zip: '132583' },
	{ city: 'Knockenagh North (Kerry)', zip: '285287' },
	{ city: 'Knockenagh South (Kerry)', zip: '183255' },
	{ city: 'Knockendrane (Carlow)', zip: '532114' },
	{ city: 'Knockeravella (Limerick)', zip: '906510' },
	{ city: 'Knockercreeveen (Kerry)', zip: '692827' },
	{ city: 'Knockereen (Galway)', zip: '853617' },
	{ city: 'Knockergrana (Donegal)', zip: '643613' },
	{ city: 'Knockerk (Meath)', zip: '599666' },
	{ city: 'Knockerry East (Clare)', zip: '128887' },
	{ city: 'Knockerry West (Clare)', zip: '690281' },
	{ city: 'Knockersally (Meath)', zip: '168537' },
	{ city: 'Knockevagh (Carlow)', zip: '257878' },
	{ city: 'Knockfad (Cavan)', zip: '839412' },
	{ city: 'Knockfadda (Cork)', zip: '556606' },
	{ city: 'Knockfadda (Mayo)', zip: '537786' },
	{ city: 'Knockfadda (Wicklow)', zip: '833700' },
	{ city: 'Knockfair (Donegal)', zip: '585322' },
	{ city: 'Knockfarnaght (Mayo)', zip: '215024' },
	{ city: 'Knockfeen (Cork)', zip: '597008' },
	{ city: 'Knockfelim (Mayo)', zip: '327801' },
	{ city: 'Knockfennell (Limerick)', zip: '680379' },
	{ city: 'Knockfenora (Limerick)', zip: '242756' },
	{ city: 'Knockfereen (Mayo)', zip: '325374' },
	{ city: 'Knockfield (Kildare)', zip: '315070' },
	{ city: 'Knockfin (Cavan)', zip: '594036' },
	{ city: 'Knockfin (Laois)', zip: '733661' },
	{ city: 'Knockfin (Mayo)', zip: '614593' },
	{ city: 'Knockfinnisk (Limerick)', zip: '200857' },
	{ city: 'Knockfobole (Tipperary)', zip: '324037' },
	{ city: 'Knockfola (Donegal)', zip: '125203' },
	{ city: 'Knockforlagh (Tipperary)', zip: '920723' },
	{ city: 'Knockfree (Mayo)', zip: '935920' },
	{ city: 'Knockfune (Tipperary)', zip: '763737' },
	{ city: 'Knockgarraun (Waterford)', zip: '605828' },
	{ city: 'Knockgarve (Tipperary)', zip: '174261' },
	{ city: 'Knockglass (Cork)', zip: '470731' },
	{ city: 'Knockglass (Donegal)', zip: '192564' },
	{ city: 'Knockglass (Galway)', zip: '326933' },
	{ city: 'Knockglass (Kilkenny)', zip: '328460' },
	{ city: 'Knockglass (Limerick)', zip: '252860' },
	{ city: 'Knockglass (Mayo)', zip: '141948' },
	{ city: 'Knockglass (Meath)', zip: '197004' },
	{ city: 'Knockglass (Roscommon)', zip: '669564' },
	{ city: 'Knockglass Beg (Kerry)', zip: '612777' },
	{ city: 'Knockglass More (Kerry)', zip: '757992' },
	{ city: 'Knockgorm (Cavan)', zip: '299807' },
	{ city: 'Knockgorm (Cork)', zip: '493255' },
	{ city: 'Knockgorman (Tipperary)', zip: '968523' },
	{ city: 'Knockgrace (Kilkenny)', zip: '605176' },
	{ city: 'Knockgraffon (Tipperary)', zip: '905645' },
	{ city: 'Knockgrania (Sligo)', zip: '412969' },
	{ city: 'Knockgrean (Limerick)', zip: '268539' },
	{ city: 'Knockgreany (Wexford)', zip: '149731' },
	{ city: 'Knockgriffin (Cork)', zip: '665960' },
	{ city: 'Knockhall (Roscommon)', zip: '519396' },
	{ city: 'Knockharley (Meath)', zip: '150402' },
	{ city: 'Knockheel (Laois)', zip: '139375' },
	{ city: 'Knockhill And Drinagh (Offaly)', zip: '287153' },
	{ city: 'Knockhogan (Clare)', zip: '206518' },
	{ city: 'Knockhouse (Waterford)', zip: '753310' },
	{ city: 'Knockhowlin (Wexford)', zip: '216208' },
	{ city: 'Knockieran Lower (Wicklow)', zip: '259140' },
	{ city: 'Knockieran Upper (Wicklow)', zip: '815681' },
	{ city: 'Knockilly (Cork)', zip: '964581' },
	{ city: 'Knockilterra (Tipperary)', zip: '181247' },
	{ city: 'Knockina (Wexford)', zip: '523827' },
	{ city: 'Knockinrichard (Tipperary)', zip: '774922' },
	{ city: 'Knockinure (Monaghan)', zip: '398313' },
	{ city: 'Knockinure (Tipperary)', zip: '384265' },
	{ city: 'Knockisland (Meath)', zip: '777831' },
	{ city: 'Knockkelly (Tipperary)', zip: '578151' },
	{ city: 'Knockkillaree (Galway)', zip: '748591' },
	{ city: 'Knock Killua (Westmeath)', zip: '528301' },
	{ city: 'Knocklagh (Cork)', zip: '645923' },
	{ city: 'Knocklahard (Mayo)', zip: '663688' },
	{ city: 'Knocklahaun (Wexford)', zip: '264685' },
	{ city: 'Knocklary (Limerick)', zip: '368371' },
	{ city: 'Knocklawrence (Galway)', zip: '671765' },
	{ city: 'Knocklead (Laois)', zip: '729360' },
	{ city: 'Knocklegan (Kilkenny)', zip: '352578' },
	{ city: 'Knocklehaugh (Mayo)', zip: '239022' },
	{ city: 'Knockleigh (Cork)', zip: '306408' },
	{ city: 'Knocklishen Beg (Carlow)', zip: '763685' },
	{ city: 'Knocklishen More (Carlow)', zip: '185557' },
	{ city: 'Knockloe (Wicklow)', zip: '569065' },
	{ city: 'Knocklofty (Tipperary)', zip: '759100' },
	{ city: 'Knocklofty Demesne (Tipperary)', zip: '373118' },
	{ city: 'Knocklong (Limerick)', zip: '977144' },
	{ city: 'Knocklong East (Limerick)', zip: '840583' },
	{ city: 'Knocklong West (Limerick)', zip: '416101' },
	{ city: 'Knocklore (Louth)', zip: '815926' },
	{ city: 'Knockloskeraun (Clare)', zip: '629224' },
	{ city: 'Knocklough (Meath)', zip: '593486' },
	{ city: 'Knocklough (Sligo)', zip: '855926' },
	{ city: 'Knockloughlin (Longford)', zip: '376103' },
	{ city: 'Knockloughlin (Offaly)', zip: '218248' },
	{ city: 'Knockloughra (Mayo)', zip: '493019' },
	{ city: 'Knocklucas (Waterford)', zip: '250158' },
	{ city: 'Knocklucy (Cork)', zip: '950612' },
	{ city: 'Knocklyon (Dublin)', zip: '113723' },
	{ city: 'Knockmacool (Cork)', zip: '916674' },
	{ city: 'Knockmacoony (Meath)', zip: '318722' },
	{ city: 'Knockmacrory (Leitrim)', zip: '201041' },
	{ city: 'Knockmael East (Clare)', zip: '413583' },
	{ city: 'Knockmael West (Clare)', zip: '587191' },
	{ city: 'Knockmahon (Waterford)', zip: '492187' },
	{ city: 'Knockmajor (Kilkenny)', zip: '423934' },
	{ city: 'Knockmanagh (Cork)', zip: '810782' },
	{ city: 'Knockmanagh (Kerry)', zip: '642462' },
	{ city: 'Knockmanagh (Mayo)', zip: '881793' },
	{ city: 'Knockmant (Westmeath)', zip: '648220' },
	{ city: 'Knockmanus (Carlow)', zip: '125823' },
	{ city: 'Knockmanus (Mayo)', zip: '933078' },
	{ city: 'Knockmaon (Waterford)', zip: '497768' },
	{ city: 'Knockmaria (Mayo)', zip: '189390' },
	{ city: 'Knockmark (Meath)', zip: '593847' },
	{ city: 'Knockmaroe (Tipperary)', zip: '419162' },
	{ city: 'Knockmarshal (Wexford)', zip: '613027' },
	{ city: 'Knockmartin (Longford)', zip: '357442' },
	{ city: 'Knockmascahill (Galway)', zip: '350455' },
	{ city: 'Knockmay (Laois)', zip: '872539' },
	{ city: 'Knockmeal (Kerry)', zip: '513946' },
	{ city: 'Knockmeal (Waterford)', zip: '922078' },
	{ city: 'Knockmealdown (Waterford)', zip: '545121' },
	{ city: 'Knockmeale (Tipperary)', zip: '398467' },
	{ city: 'Knockmeane (Roscommon)', zip: '611822' },
	{ city: 'Knockmeelmore (Waterford)', zip: '218236' },
	{ city: 'Knockmehill (Tipperary)', zip: '638784' },
	{ city: 'Knockmehill East (Tipperary)', zip: '946945' },
	{ city: 'Knockmiller (Wicklow)', zip: '319420' },
	{ city: 'Knockmitten (Dublin)', zip: '398397' },
	{ city: 'Knockmonalea East (Cork)', zip: '394521' },
	{ city: 'Knockmonalea West (Cork)', zip: '745739' },
	{ city: 'Knockmoody (Longford)', zip: '655282' },
	{ city: 'Knockmooney (Meath)', zip: '470377' },
	{ city: 'Knockmore (Carlow)', zip: '501157' },
	{ city: 'Knockmore (Cavan)', zip: '408405' },
	{ city: 'Knockmore (Clare)', zip: '262002' },
	{ city: 'Knockmore (Cork)', zip: '484925' },
	{ city: 'Knockmore (Galway)', zip: '358293' },
	{ city: 'Knockmore (Kilkenny)', zip: '956699' },
	{ city: 'Knockmore (Limerick)', zip: '863512' },
	{ city: 'Knockmore (Louth)', zip: '544924' },
	{ city: 'Knockmore (Mayo)', zip: '431314' },
	{ city: 'Knockmore (Sligo)', zip: '817205' },
	{ city: 'Knockmore (Tipperary)', zip: '853269' },
	{ city: 'Knockmore (Westmeath)', zip: '942099' },
	{ city: 'Knockmore (Wexford)', zip: '818125' },
	{ city: 'Knockmore Eighter (Mayo)', zip: '486253' },
	{ city: 'Knockmore Oughter (Mayo)', zip: '429276' },
	{ city: 'Knockmorris (Tipperary)', zip: '509842' },
	{ city: 'Knockmorris (Westmeath)', zip: '105663' },
	{ city: 'Knockmoy (Clare)', zip: '990403' },
	{ city: 'Knockmoylan (Kilkenny)', zip: '457348' },
	{ city: 'Knockmoyle (Mayo)', zip: '890737' },
	{ city: 'Knockmoyle East (Galway)', zip: '286179' },
	{ city: 'Knockmoyleen (Mayo)', zip: '311365' },
	{ city: 'Knockmoyle West (Galway)', zip: '642870' },
	{ city: 'Knockmoynagh (Sligo)', zip: '708504' },
	{ city: 'Knockmuinard (Mayo)', zip: '871985' },
	{ city: 'Knockmuldoney (Sligo)', zip: '244938' },
	{ city: 'Knockmullane (Cork)', zip: '435518' },
	{ city: 'Knockmullen (Wexford)', zip: '212676' },
	{ city: 'Knockmullin (Leitrim)', zip: '539941' },
	{ city: 'Knockmullin (Mayo)', zip: '899965' },
	{ city: 'Knockmullin (Sligo)', zip: '712795' },
	{ city: 'Knockmullin (Wexford)', zip: '228509' },
	{ city: 'Knockmurragha (Clare)', zip: '338597' },
	{ city: 'Knockmurry (Roscommon)', zip: '838019' },
	{ city: 'Knocknabansha (Tipperary)', zip: '760060' },
	{ city: 'Knocknabeast (Roscommon)', zip: '953639' },
	{ city: 'Knocknabehy (Cork)', zip: '126138' },
	{ city: 'Knocknabinny (Cork)', zip: '536440' },
	{ city: 'Knocknaboha (Limerick)', zip: '207827' },
	{ city: 'Knocknaboha (Tipperary)', zip: '852982' },
	{ city: 'Knocknabohilly (Cork)', zip: '953288' },
	{ city: 'Knocknaboley (Galway)', zip: '762873' },
	{ city: 'Knocknaboley (Mayo)', zip: '291259' },
	{ city: 'Knocknaboley (Wicklow)', zip: '246998' },
	{ city: 'Knocknabollan (Donegal)', zip: '650349' },
	{ city: 'Knocknaboola (Kerry)', zip: '459169' },
	{ city: 'Knocknabooly (Cork)', zip: '136288' },
	{ city: 'Knocknabooly (Kilkenny)', zip: '350316' },
	{ city: 'Knocknabooly East (Limerick)', zip: '367959' },
	{ city: 'Knocknabooly Middle (Limerick)', zip: '955500' },
	{ city: 'Knocknabooly West (Limerick)', zip: '189874' },
	{ city: 'Knocknaboul (Kerry)', zip: '302143' },
	{ city: 'Knocknaboul (Waterford)', zip: '444398' },
	{ city: 'Knocknabranagh And Knockbaun (Carlow)', zip: '745076' },
	{ city: 'Knocknabro (Kerry)', zip: '138421' },
	{ city: 'Knocknabrogue (Tipperary)', zip: '624006' },
	{ city: 'Knocknabrone (Waterford)', zip: '882279' },
	{ city: 'Knocknacaheragh (Cork)', zip: '147418' },
	{ city: 'Knocknacaheragh (Kerry)', zip: '510033' },
	{ city: 'Knocknacally (Cork)', zip: '587523' },
	{ city: 'Knocknacarney (Monaghan)', zip: '190787' },
	{ city: 'Knocknacarriga (Limerick)', zip: '473728' },
	{ city: 'Knocknacarrow (Roscommon)', zip: '191593' },
	{ city: 'Knocknacaska (Kerry)', zip: '434662' },
	{ city: 'Knocknaclassagh (Leitrim)', zip: '265625' },
	{ city: 'Knocknacloy (Roscommon)', zip: '482944' },
	{ city: 'Knocknacolan (Cork)', zip: '931978' },
	{ city: 'Knocknaconnery (Tipperary)', zip: '979871' },
	{ city: 'Knocknacoska (Leitrim)', zip: '837583' },
	{ city: 'Knocknacran East (Monaghan)', zip: '903585' },
	{ city: 'Knocknacran West (Monaghan)', zip: '676295' },
	{ city: 'Knocknacree (Kerry)', zip: '868348' },
	{ city: 'Knocknacree (Kildare)', zip: '503271' },
	{ city: 'Knocknacreeva (Galway)', zip: '290666' },
	{ city: 'Knocknacreha (Waterford)', zip: '218681' },
	{ city: 'Knocknacroagha (Mayo)', zip: '990672' },
	{ city: 'Knocknacrohy (Kerry)', zip: '140495' },
	{ city: 'Knocknacrohy (Limerick)', zip: '115568' },
	{ city: 'Knocknacrohy (Waterford)', zip: '592014' },
	{ city: 'Knocknacrooha Lower (Waterford)', zip: '908409' },
	{ city: 'Knocknacrooha Upper (Waterford)', zip: '631668' },
	{ city: 'Knocknacross (Sligo)', zip: '170930' },
	{ city: 'Knocknacroy (Sligo)', zip: '303595' },
	{ city: 'Knocknacullen East (Cork)', zip: '873513' },
	{ city: 'Knocknacullen West (Cork)', zip: '283228' },
	{ city: 'Knocknacurra (Cork)', zip: '714125' },
	{ city: 'Knocknacurra (Kerry)', zip: '183267' },
	{ city: 'Knocknacurragh (Cork)', zip: '198505' },
	{ city: 'Knocknadarriv (Kerry)', zip: '983890' },
	{ city: 'Knocknadaula (Galway)', zip: '215049' },
	{ city: 'Knocknadempsey (Tipperary)', zip: '972813' },
	{ city: 'Knocknadiha (Limerick)', zip: '218395' },
	{ city: 'Knocknadrimna (Mayo)', zip: '661028' },
	{ city: 'Knocknadroose (Wicklow)', zip: '827462' },
	{ city: 'Knocknafallia (Waterford)', zip: '287331' },
	{ city: 'Knocknafaugher (Donegal)', zip: '772989' },
	{ city: 'Knocknafreeny (Waterford)', zip: '929432' },
	{ city: 'Knocknafrehane (Waterford)', zip: '583046' },
	{ city: 'Knocknafushoga (Roscommon)', zip: '735232' },
	{ city: 'Knocknagallagh (Cork)', zip: '670816' },
	{ city: 'Knocknagalliagh (Kildare)', zip: '851972' },
	{ city: 'Knocknagalty (Limerick)', zip: '418646' },
	{ city: 'Knocknaganny (Mayo)', zip: '164259' },
	{ city: 'Knocknaganny (Sligo)', zip: '485110' },
	{ city: 'Knocknagappagh (Cork)', zip: '778581' },
	{ city: 'Knocknagappagh (Galway)', zip: '625764' },
	{ city: 'Knocknagapple (Cork)', zip: '246719' },
	{ city: 'Knocknagapple (Tipperary)', zip: '345575' },
	{ city: 'Knocknagapple (Wexford)', zip: '393289' },
	{ city: 'Knocknagappul (Cork)', zip: '731510' },
	{ city: 'Knocknagappul (Waterford)', zip: '503133' },
	{ city: 'Knocknagare (Cork)', zip: '471874' },
	{ city: 'Knocknagarhoon (Clare)', zip: '843344' },
	{ city: 'Knocknagarnaman (Monaghan)', zip: '751872' },
	{ city: 'Knocknagarrane (Cork)', zip: '675475' },
	{ city: 'Knocknagarrivhan (Galway)', zip: '712238' },
	{ city: 'Knocknagartan (Cavan)', zip: '659767' },
	{ city: 'Knocknagarve (Tipperary)', zip: '883016' },
	{ city: 'Knocknagashel (Kerry)', zip: '868886' },
	{ city: 'Knocknagashel East (Kerry)', zip: '981827' },
	{ city: 'Knocknagashel West (Kerry)', zip: '868091' },
	{ city: 'Knocknagawna (Roscommon)', zip: '711887' },
	{ city: 'Knocknagee (Kildare)', zip: '804671' },
	{ city: 'Knocknageeha (Clare)', zip: '160740' },
	{ city: 'Knocknageeha (Kerry)', zip: '674166' },
	{ city: 'Knocknageeha (Mayo)', zip: '649673' },
	{ city: 'Knocknageeha (Monaghan)', zip: '932531' },
	{ city: 'Knocknageeha (Sligo)', zip: '381181' },
	{ city: 'Knocknageeha East (Cork)', zip: '898005' },
	{ city: 'Knocknageeha North (Cork)', zip: '432976' },
	{ city: 'Knocknageeha South (Cork)', zip: '936263' },
	{ city: 'Knocknageeha West (Cork)', zip: '448524' },
	{ city: 'Knocknageehy (Cork)', zip: '930140' },
	{ city: 'Knocknageehy (Mayo)', zip: '115132' },
	{ city: 'Knocknageragh (Waterford)', zip: '756763' },
	{ city: 'Knocknagilky Lower (Wicklow)', zip: '199060' },
	{ city: 'Knocknagilky Upper (Wicklow)', zip: '552415' },
	{ city: 'Knocknagillagh (Cavan)', zip: '931586' },
	{ city: 'Knocknagin (Dublin)', zip: '348263' },
	{ city: 'Knocknaglogh (Kerry)', zip: '968092' },
	{ city: 'Knocknaglogh (Waterford)', zip: '146476' },
	{ city: 'Knocknaglogh Lower (Waterford)', zip: '607561' },
	{ city: 'Knocknaglogh Upper (Waterford)', zip: '854931' },
	{ city: 'Knocknaglohall (Cork)', zip: '972609' },
	{ city: 'Knocknagon (Mayo)', zip: '348708' },
	{ city: 'Knocknagoogh (Tipperary)', zip: '317600' },
	{ city: 'Knocknagool (Mayo)', zip: '463029' },
	{ city: 'Knocknagoran (Louth)', zip: '880674' },
	{ city: 'Knocknagore (Cork)', zip: '715817' },
	{ city: 'Knocknagore (Sligo)', zip: '665882' },
	{ city: 'Knocknagornagh (Limerick)', zip: '439303' },
	{ city: 'Knocknagorteeny (Limerick)', zip: '576216' },
	{ city: 'Knocknagorty (Cork)', zip: '756057' },
	{ city: 'Knocknagoug (Clare)', zip: '984285' },
	{ city: 'Knocknagoul (Cork)', zip: '462901' },
	{ city: 'Knocknagoum (Kerry)', zip: '175817' },
	{ city: 'Knocknagoun (Cork)', zip: '238747' },
	{ city: 'Knocknagowan (Kerry)', zip: '853380' },
	{ city: 'Knocknagower (Kerry)', zip: '870826' },
	{ city: 'Knocknagraigue East (Clare)', zip: '285318' },
	{ city: 'Knocknagraigue West (Clare)', zip: '855064' },
	{ city: 'Knocknagrally (Laois)', zip: '466069' },
	{ city: 'Knocknagranagh (Waterford)', zip: '964029' },
	{ city: 'Knocknagranshy (Limerick)', zip: '312296' },
	{ city: 'Knocknagrat (Monaghan)', zip: '618351' },
	{ city: 'Knocknagrave (Monaghan)', zip: '539384' },
	{ city: 'Knocknagreana (Galway)', zip: '714856' },
	{ city: 'Knocknagree (Cork)', zip: '640952' },
	{ city: 'Knocknagree (Tipperary)', zip: '425040' },
	{ city: 'Knocknagree (Wicklow)', zip: '647678' },
	{ city: 'Knocknagriffin (Waterford)', zip: '249841' },
	{ city: 'Knocknagroagh (Clare)', zip: '676593' },
	{ city: 'Knocknagroagh (Laois)', zip: '252377' },
	{ city: 'Knocknagroagh (Sligo)', zip: '804615' },
	{ city: 'Knocknagross (Wexford)', zip: '373382' },
	{ city: 'Knocknagull (Wicklow)', zip: '195058' },
	{ city: 'Knocknagulshy (Mayo)', zip: '980887' },
	{ city: 'Knocknagun (Kerry)', zip: '164972' },
	{ city: 'Knocknagundarragh (Carlow)', zip: '830037' },
	{ city: 'Knocknaguppoge (Kilkenny)', zip: '386313' },
	{ city: 'Knocknahaha (Kerry)', zip: '237499' },
	{ city: 'Knocknahannee (Clare)', zip: '117256' },
	{ city: 'Knocknaharney (Tipperary)', zip: '791273' },
	{ city: 'Knocknahattin (Meath)', zip: '568705' },
	{ city: 'Knocknahaw (Galway)', zip: '972716' },
	{ city: 'Knocknahila (Kerry)', zip: '777726' },
	{ city: 'Knocknahila Beg (Clare)', zip: '140984' },
	{ city: 'Knocknahila More North (Clare)', zip: '192053' },
	{ city: 'Knocknahila More South (Clare)', zip: '883493' },
	{ city: 'Knocknahilan (Cork)', zip: '463289' },
	{ city: 'Knocknahoe (Kerry)', zip: '539254' },
	{ city: 'Knocknahoo (Sligo)', zip: '332429' },
	{ city: 'Knocknahooan (Clare)', zip: '332642' },
	{ city: 'Knocknahoola (Waterford)', zip: '708965' },
	{ city: 'Knocknahorgan (Cork)', zip: '203432' },
	{ city: 'Knocknahorna (Donegal)', zip: '648476' },
	{ city: 'Knocknahorna (Mayo)', zip: '876512' },
	{ city: 'Knocknahorna (Offaly)', zip: '143232' },
	{ city: 'Knocknahow (Kerry)', zip: '762248' },
	{ city: 'Knocknahowla Beg (Cork)', zip: '911815' },
	{ city: 'Knocknahowla More (Cork)', zip: '595622' },
	{ city: 'Knocknahur (Sligo)', zip: '464934' },
	{ city: 'Knocknahur North (Sligo)', zip: '834958' },
	{ city: 'Knocknahur South (Sligo)', zip: '756515' },
	{ city: 'Knocknakearn (Laois)', zip: '621748' },
	{ city: 'Knocknakill (Tipperary)', zip: '500086' },
	{ city: 'Knocknakilla (Cork)', zip: '774915' },
	{ city: 'Knocknakillardy (Tipperary)', zip: '391375' },
	{ city: 'Knocknakillew (Mayo)', zip: '750780' },
	{ city: 'Knocknakillew (Sligo)', zip: '795235' },
	{ city: 'Knocknakilly (Kerry)', zip: '281189' },
	{ city: 'Knocknalappa (Clare)', zip: '253232' },
	{ city: 'Knocknalina (Mayo)', zip: '704589' },
	{ city: 'Knocknaloman (Cork)', zip: '940708' },
	{ city: 'Knocknalooricaun (Waterford)', zip: '305560' },
	{ city: 'Knocknalosset (Cavan)', zip: '297237' },
	{ city: 'Knocknalougha (Waterford)', zip: '134559' },
	{ city: 'Knocknalour (Wexford)', zip: '797795' },
	{ city: 'Knocknalower (Mayo)', zip: '623852' },
	{ city: 'Knocknalun (Monaghan)', zip: '965553' },
	{ city: 'Knocknalurgan (Cork)', zip: '424215' },
	{ city: 'Knocknalyre (Cork)', zip: '300305' },
	{ city: 'Knocknalyre (Mayo)', zip: '676046' },
	{ city: 'Knocknamadderee (Cork)', zip: '356255' },
	{ city: 'Knocknamaddy (Monaghan)', zip: '193439' },
	{ city: 'Knocknamallavoge (Cork)', zip: '910847' },
	{ city: 'Knocknaman (Kerry)', zip: '831497' },
	{ city: 'Knocknamanagh (Cork)', zip: '141090' },
	{ city: 'Knocknamanagh (Galway)', zip: '701941' },
	{ city: 'Knocknamarriff (Cork)', zip: '900435' },
	{ city: 'Knocknamarshal (Wexford)', zip: '688296' },
	{ city: 'Knocknamase (Offaly)', zip: '667612' },
	{ city: 'Knocknamaulee (Waterford)', zip: '155324' },
	{ city: 'Knocknambraher (Laois)', zip: '539693' },
	{ city: 'Knocknamena Commons (Tipperary)', zip: '691889' },
	{ city: 'Knocknamoe (Laois)', zip: '412929' },
	{ city: 'Knocknamoghalaun (Mayo)', zip: '383666' },
	{ city: 'Knocknamohalagh (Cork)', zip: '138867' },
	{ city: 'Knocknamoheragh (Tipperary)', zip: '527079' },
	{ city: 'Knocknamohill (Wicklow)', zip: '311403' },
	{ city: 'Knocknamona (Cork)', zip: '583400' },
	{ city: 'Knocknamona (Donegal)', zip: '245035' },
	{ city: 'Knocknamona (Waterford)', zip: '181147' },
	{ city: 'Knocknamota (Wexford)', zip: '795029' },
	{ city: 'Knocknamouragh (Cork)', zip: '321551' },
	{ city: 'Knocknamuck (Cork)', zip: '899594' },
	{ city: 'Knocknamuck (Kilkenny)', zip: '846385' },
	{ city: 'Knocknamucklagh (Cork)', zip: '846573' },
	{ city: 'Knocknamucklagh (Kerry)', zip: '223251' },
	{ city: 'Knocknamucklagh (Mayo)', zip: '874074' },
	{ city: 'Knocknamuck Lower (Wicklow)', zip: '489724' },
	{ city: 'Knocknamuck North (Waterford)', zip: '735101' },
	{ city: 'Knocknamuck South (Waterford)', zip: '281844' },
	{ city: 'Knocknamuck Upper (Wicklow)', zip: '870517' },
	{ city: 'Knocknamucky (Clare)', zip: '689652' },
	{ city: 'Knocknamullagh (Cork)', zip: '270336' },
	{ city: 'Knocknamunnion (Wicklow)', zip: '289947' },
	{ city: 'Knocknanagh Commons (Cork)', zip: '717404' },
	{ city: 'Knocknanagh East (Cork)', zip: '554314' },
	{ city: 'Knocknanagh West (Cork)', zip: '357524' },
	{ city: 'Knocknanarney (Kerry)', zip: '269762' },
	{ city: 'Knocknanask (Waterford)', zip: '484607' },
	{ city: 'Knocknanav (Cork)', zip: '951233' },
	{ city: 'Knocknaneen (Monaghan)', zip: '495719' },
	{ city: 'Knocknaneirk (Cork)', zip: '729039' },
	{ city: 'Knocknanool (Roscommon)', zip: '562495' },
	{ city: 'Knocknanuss (Cork)', zip: '538011' },
	{ city: 'Knocknanuss (Tipperary)', zip: '729882' },
	{ city: 'Knocknapisha (Mayo)', zip: '734964' },
	{ city: 'Knocknapogaree (Cork)', zip: '182430' },
	{ city: 'Knocknaquill (Tipperary)', zip: '575508' },
	{ city: 'Knocknaraha (Clare)', zip: '433547' },
	{ city: 'Knocknaraha (Cork)', zip: '485259' },
	{ city: 'Knocknaraha (Waterford)', zip: '802713' },
	{ city: 'Knocknaranhy (Clare)', zip: '405702' },
	{ city: 'Knocknarea North (Sligo)', zip: '954622' },
	{ city: 'Knocknarea South (Sligo)', zip: '194068' },
	{ city: 'Knocknaree (Waterford)', zip: '354195' },
	{ city: 'Knocknareeha (Clare)', zip: '326916' },
	{ city: 'Knocknasalla (Waterford)', zip: '133484' },
	{ city: 'Knocknasave (Monaghan)', zip: '639537' },
	{ city: 'Knocknasawna (Leitrim)', zip: '213464' },
	{ city: 'Knocknascrow (Limerick)', zip: '486998' },
	{ city: 'Knocknaseed (Kerry)', zip: '809029' },
	{ city: 'Knocknashammer (Cavan)', zip: '170721' },
	{ city: 'Knocknashammer (Sligo)', zip: '780065' },
	{ city: 'Knocknashamroge (Wicklow)', zip: '338856' },
	{ city: 'Knocknashangan (Donegal)', zip: '132369' },
	{ city: 'Knocknashannagh (Cork)', zip: '140189' },
	{ city: 'Knocknashee (Roscommon)', zip: '184123' },
	{ city: 'Knocknashee Common (Sligo)', zip: '142191' },
	{ city: 'Knocknasheega (Waterford)', zip: '878917' },
	{ city: 'Knocknasilloge (Wexford)', zip: '448938' },
	{ city: 'Knocknaskagh (Cork)', zip: '759670' },
	{ city: 'Knocknaskagh Lower (Waterford)', zip: '715907' },
	{ city: 'Knocknaskagh Upper (Waterford)', zip: '865453' },
	{ city: 'Knocknaskea (Longford)', zip: '876324' },
	{ city: 'Knocknaskeagh (Clare)', zip: '212896' },
	{ city: 'Knocknaskeagh (Mayo)', zip: '997182' },
	{ city: 'Knocknaskeagh (Sligo)', zip: '936889' },
	{ city: 'Knocknaskeagh (Wexford)', zip: '365916' },
	{ city: 'Knocknaskeagh (Wicklow)', zip: '944273' },
	{ city: 'Knocknaskeha (Kerry)', zip: '368099' },
	{ city: 'Knocknaskeharoe (Tipperary)', zip: '928067' },
	{ city: 'Knocknasliggaun (Sligo)', zip: '331010' },
	{ city: 'Knocknasnaa (Limerick)', zip: '413778' },
	{ city: 'Knocknastooka (Cork)', zip: '893289' },
	{ city: 'Knocknastooka (Waterford)', zip: '931386' },
	{ city: 'Knocknastreile (Wicklow)', zip: '771447' },
	{ city: 'Knocknasuff (Cork)', zip: '856400' },
	{ city: 'Knocknatinnyweel (Mayo)', zip: '243964' },
	{ city: 'Knocknatubbrid (Carlow)', zip: '363216' },
	{ city: 'Knocknaveagh (Cavan)', zip: '703513' },
	{ city: 'Knocknaveagh (Mayo)', zip: '795289' },
	{ city: 'Knocknavey (Wexford)', zip: '384711' },
	{ city: 'Knocknavorahee (Cork)', zip: '171059' },
	{ city: 'Knocknawhishoge (Sligo)', zip: '453667' },
	{ city: 'Knocknell (Wexford)', zip: '872355' },
	{ city: 'Knockneppy (Clare)', zip: '505944' },
	{ city: 'Knocknew (Kilkenny)', zip: '229404' },
	{ city: 'Knocknoran (Wexford)', zip: '302648' },
	{ city: 'Knock North (Galway)', zip: '478862' },
	{ city: 'Knock North (Mayo)', zip: '423358' },
	{ city: 'Knockoconor (Sligo)', zip: '964619' },
	{ city: 'Knock Of The Rocks (Wexford)', zip: '502952' },
	{ city: 'Knockognoe (Kerry)', zip: '495093' },
	{ city: 'Knockogonnell (Clare)', zip: '306588' },
	{ city: 'Knockogonnell (Galway)', zip: '689889' },
	{ city: 'Knockordan (Tipperary)', zip: '117004' },
	{ city: 'Knockough (Cork)', zip: '562564' },
	{ city: 'Knockoura (Cork)', zip: '304678' },
	{ city: 'Knockoura (Galway)', zip: '953890' },
	{ city: 'Knockouran (Galway)', zip: '633370' },
	{ city: 'Knockowen (Kerry)', zip: '582380' },
	{ city: 'Knockown (Kilkenny)', zip: '452666' },
	{ city: 'Knockparson (Waterford)', zip: '556633' },
	{ city: 'Knockpatrick (Clare)', zip: '428852' },
	{ city: 'Knockpatrick (Kildare)', zip: '809174' },
	{ city: 'Knockpatrick (Limerick)', zip: '539235' },
	{ city: 'Knockphelagh (Tipperary)', zip: '226863' },
	{ city: 'Knockphilip (Laois)', zip: '974270' },
	{ city: 'Knockphutteen (Clare)', zip: '962805' },
	{ city: 'Knockpoge (Cork)', zip: '691632' },
	{ city: 'Knockraha (Cork)', zip: '175827' },
	{ city: 'Knockraha East (Cork)', zip: '980775' },
	{ city: 'Knockraha West (Cork)', zip: '197684' },
	{ city: 'Knockraheen (Cork)', zip: '280664' },
	{ city: 'Knockraheen (Wicklow)', zip: '736187' },
	{ city: 'Knockranny (Cavan)', zip: '408889' },
	{ city: 'Knockranny (Galway)', zip: '779525' },
	{ city: 'Knockranny (Mayo)', zip: '847810' },
	{ city: 'Knockranny (Roscommon)', zip: '704876' },
	{ city: 'Knockrath Big (Wicklow)', zip: '105210' },
	{ city: 'Knockrathkelly (Tipperary)', zip: '410591' },
	{ city: 'Knockrathkyle (Wexford)', zip: '884718' },
	{ city: 'Knockrath Little (Wicklow)', zip: '144109' },
	{ city: 'Knockrawer (Donegal)', zip: '175278' },
	{ city: 'Knockrawer (Mayo)', zip: '250951' },
	{ city: 'Knockrawer (Sligo)', zip: '243925' },
	{ city: 'Knockreagh (Clare)', zip: '420700' },
	{ city: 'Knockreagh (Kerry)', zip: '743183' },
	{ city: 'Knockreagh (Kilkenny)', zip: '915187' },
	{ city: 'Knockreagh (Monaghan)', zip: '981805' },
	{ city: 'Knockreagh (Wexford)', zip: '617928' },
	{ city: 'Knockreagh Lower (Monaghan)', zip: '470307' },
	{ city: 'Knockreagh Upper (Monaghan)', zip: '131124' },
	{ city: 'Knockreddan (Clare)', zip: '259084' },
	{ city: 'Knockredmond (Wexford)', zip: '633517' },
	{ city: 'Knockreer (Kerry)', zip: '683503' },
	{ city: 'Knockrickard (Mayo)', zip: '806503' },
	{ city: 'Knockrinahan (Tipperary)', zip: '579752' },
	{ city: 'Knockrobin (Cork)', zip: '355894' },
	{ city: 'Knockrobin (Wicklow)', zip: '680557' },
	{ city: 'Knockrobin Lower (Wexford)', zip: '566030' },
	{ city: 'Knockrobin Murragh (Wicklow)', zip: '374676' },
	{ city: 'Knockrobin Upper (Wexford)', zip: '466493' },
	{ city: 'Knockroe (Carlow)', zip: '746595' },
	{ city: 'Knockroe (Cavan)', zip: '662545' },
	{ city: 'Knockroe (Clare)', zip: '289346' },
	{ city: 'Knockroe (Cork)', zip: '572903' },
	{ city: 'Knockroe (Galway)', zip: '306093' },
	{ city: 'Knockroe (Kerry)', zip: '769363' },
	{ city: 'Knockroe (Kildare)', zip: '652727' },
	{ city: 'Knockroe (Kilkenny)', zip: '880127' },
	{ city: 'Knockroe (Limerick)', zip: '505038' },
	{ city: 'Knockroe (Mayo)', zip: '255597' },
	{ city: 'Knockroe (Monaghan)', zip: '498221' },
	{ city: 'Knockroe (Roscommon)', zip: '552913' },
	{ city: 'Knockroe (Sligo)', zip: '817069' },
	{ city: 'Knockroe (Tipperary)', zip: '278015' },
	{ city: 'Knockroe (Waterford)', zip: '402968' },
	{ city: 'Knockroe (Westmeath)', zip: '429892' },
	{ city: 'Knockroe (Wexford)', zip: '942747' },
	{ city: 'Knockroe (Wicklow)', zip: '914041' },
	{ city: 'Knockroe Beg (Galway)', zip: '487074' },
	{ city: 'Knockroe East (Cork)', zip: '473814' },
	{ city: 'Knockroe Middle (Cork)', zip: '962651' },
	{ city: 'Knockroe West (Cork)', zip: '741073' },
	{ city: 'Knockronaghan (Monaghan)', zip: '167135' },
	{ city: 'Knockroosk (Leitrim)', zip: '443859' },
	{ city: 'Knockroosky (Mayo)', zip: '172688' },
	{ city: 'Knockroundaly (Cork)', zip: '591576' },
	{ city: 'Knockrour (Cork)', zip: '811929' },
	{ city: 'Knockrour (Limerick)', zip: '667949' },
	{ city: 'Knockrour (Waterford)', zip: '900809' },
	{ city: 'Knockrower East (Kerry)', zip: '856569' },
	{ city: 'Knockrower West (Kerry)', zip: '252920' },
	{ city: 'Knockruth (Wexford)', zip: '561045' },
	{ city: 'Knocks (Cork)', zip: '343164' },
	{ city: 'Knocks (Laois)', zip: '329380' },
	{ city: 'Knocks (Leitrim)', zip: '824536' },
	{ city: 'Knocks (Mayo)', zip: '940439' },
	{ city: 'Knocks (Meath)', zip: '455582' },
	{ city: 'Knocks (Wexford)', zip: '155965' },
	{ city: 'Knocksaggart (Clare)', zip: '296573' },
	{ city: 'Knocksaharn (Cork)', zip: '421098' },
	{ city: 'Knocksaintlour (Tipperary)', zip: '271570' },
	{ city: 'Knocksaxon (Mayo)', zip: '204587' },
	{ city: 'Knocksbarrett (Mayo)', zip: '607920' },
	{ city: 'Knocks East (Monaghan)', zip: '240974' },
	{ city: 'Knocksedan (Dublin)', zip: '191758' },
	{ city: 'Knockseera (Laois)', zip: '746582' },
	{ city: 'Knocksentry (Limerick)', zip: '723239' },
	{ city: 'Knockshanawee (Cork)', zip: '647466' },
	{ city: 'Knockshanbally (Galway)', zip: '727471' },
	{ city: 'Knockshanbally (Kilkenny)', zip: '999934' },
	{ city: 'Knockshanbally (Mayo)', zip: '647590' },
	{ city: 'Knockshanbo (Mayo)', zip: '236441' },
	{ city: 'Knockshanbrittas (Tipperary)', zip: '330454' },
	{ city: 'Knockshangan (Meath)', zip: '830044' },
	{ city: 'Knockshangarry (Galway)', zip: '976618' },
	{ city: 'Knockshannagh (Kildare)', zip: '564093' },
	{ city: 'Knockshanvo (Clare)', zip: '243523' },
	{ city: 'Knockshaunfin (Wexford)', zip: '259326' },
	{ city: 'Knockshearoon (Tipperary)', zip: '368472' },
	{ city: 'Knockshigowna (Tipperary)', zip: '249006' },
	{ city: 'Knockshough Glebe (Kildare)', zip: '306136' },
	{ city: 'Knocksimon (Westmeath)', zip: '407358' },
	{ city: 'Knocksink (Wicklow)', zip: '369429' },
	{ city: 'Knockskagh (Cork)', zip: '944039' },
	{ city: 'Knockskagh (Tipperary)', zip: '249402' },
	{ city: 'Knockskavane (Cork)', zip: '752275' },
	{ city: 'Knockskehan (Roscommon)', zip: '813887' },
	{ city: 'Knockskehy (Cork)', zip: '159773' },
	{ city: 'Knockskemolin (Wexford)', zip: '560290' },
	{ city: 'Knocksmall (Cork)', zip: '226589' },
	{ city: 'Knocksouna (Limerick)', zip: '282793' },
	{ city: 'Knock South (Galway)', zip: '252112' },
	{ city: 'Knock South (Mayo)', zip: '865726' },
	{ city: 'Knocksquire (Carlow)', zip: '350054' },
	{ city: 'Knockstown (Meath)', zip: '264743' },
	{ city: 'Knockstown (Wexford)', zip: '918378' },
	{ city: 'Knockstowry (Tipperary)', zip: '454727' },
	{ city: 'Knocks West (Monaghan)', zip: '324459' },
	{ city: 'Knocktarton (Wexford)', zip: '801574' },
	{ city: 'Knockthomas (Mayo)', zip: '112534' },
	{ city: 'Knocktoby (Galway)', zip: '103954' },
	{ city: 'Knocktoosh (Limerick)', zip: '940417' },
	{ city: 'Knocktopher (Kilkenny)', zip: '592089' },
	{ city: 'Knocktopher Abbey (Kilkenny)', zip: '259794' },
	{ city: 'Knocktopher Commons (Kilkenny)', zip: '335814' },
	{ city: 'Knocktopher Manor (Kilkenny)', zip: '943968' },
	{ city: 'Knocktoran (Limerick)', zip: '254452' },
	{ city: 'Knocktown (Wexford)', zip: '398598' },
	{ city: 'Knockudder (Meath)', zip: '994590' },
	{ city: 'Knockullard (Carlow)', zip: '673252' },
	{ city: 'Knockulty (Tipperary)', zip: '770726' },
	{ city: 'Knockumber (Meath)', zip: '387031' },
	{ city: 'Knockundervaul (Kerry)', zip: '382178' },
	{ city: 'Knockuragh (Tipperary)', zip: '370267' },
	{ city: 'Knockuregare (Limerick)', zip: '391631' },
	{ city: 'Knockvicar (Roscommon)', zip: '163176' },
	{ city: 'Knockwatear (Cork)', zip: '455677' },
	{ city: 'Knockwilliam (Kilkenny)', zip: '206470' },
	{ city: 'Knockwilliam (Tipperary)', zip: '307460' },
	{ city: 'Knockybrin (Donegal)', zip: '794373' },
	{ city: 'Knockycahillaun (Mayo)', zip: '971591' },
	{ city: 'Knockycallanan (Clare)', zip: '569710' },
	{ city: 'Knockychottaun (Mayo)', zip: '395076' },
	{ city: 'Knockyclovaun (Clare)', zip: '763338' },
	{ city: 'Knockycosker (Westmeath)', zip: '670419' },
	{ city: 'Knockyeala (Kerry)', zip: '665031' },
	{ city: 'Knockyelan (Waterford)', zip: '569760' },
	{ city: 'Knockyhena (Cork)', zip: '158594' },
	{ city: 'Knockyline (Kerry)', zip: '475045' },
	{ city: 'Knockymullgurry (Carlow)', zip: '454071' },
	{ city: 'Knockyoolahan (Waterford)', zip: '935085' },
	{ city: 'Knockyoolahan East (Waterford)', zip: '654254' },
	{ city: 'Knockyoolahan West (Waterford)', zip: '112587' },
	{ city: 'Knockyrourke (Cork)', zip: '474941' },
	{ city: 'Knockysheehan (Kerry)', zip: '590966' },
	{ city: 'Knockysprickaun (Mayo)', zip: '877549' },
	{ city: 'Knopoge (Clare)', zip: '288510' },
	{ city: 'Knoppoge (Cork)', zip: '956879' },
	{ city: 'Knoppoge (Kerry)', zip: '989617' },
	{ city: 'Knoppoge North (Kerry)', zip: '366094' },
	{ city: 'Knoppoge South (Kerry)', zip: '421226' },
	{ city: 'Knottown (Wexford)', zip: '745765' },
	{ city: 'Knowth (Meath)', zip: '340964' },
	{ city: 'Knoxspark (Sligo)', zip: '155180' },
	{ city: 'Knoxtershill (Wicklow)', zip: '699308' },
	{ city: 'Knuttery (Cork)', zip: '836151' },
	{ city: 'Kye (Roscommon)', zip: '697284' },
	{ city: 'Kylaglass (Tipperary)', zip: '644198' },
	{ city: 'Kylagowan (Galway)', zip: '836868' },
	{ city: 'Kylanoreashy (Tipperary)', zip: '269610' },
	{ city: 'Kylatallin (Kerry)', zip: '934004' },
	{ city: 'Kylatlea (Tipperary)', zip: '308813' },
	{ city: 'Kylawilling (Tipperary)', zip: '306482' },
	{ city: 'Kyle (Carlow)', zip: '976378' },
	{ city: 'Kyle (Clare)', zip: '931722' },
	{ city: 'Kyle (Cork)', zip: '247170' },
	{ city: 'Kyle (Kilkenny)', zip: '192046' },
	{ city: 'Kyle (Laois)', zip: '466440' },
	{ city: 'Kyle (Limerick)', zip: '316249' },
	{ city: 'Kyle (Offaly)', zip: '798167' },
	{ city: 'Kyle (Tipperary)', zip: '291844' },
	{ city: 'Kyle (Wexford)', zip: '921733' },
	{ city: 'Kyle (Wicklow)', zip: '326333' },
	{ city: 'Kylea (Clare)', zip: '355243' },
	{ city: 'Kyleadohir (Kilkenny)', zip: '259464' },
	{ city: 'Kyleaduhir (Tipperary)', zip: '919876' },
	{ city: 'Kyleagarry (Tipperary)', zip: '151082' },
	{ city: 'Kyleaglanna (Tipperary)', zip: '188534' },
	{ city: 'Kyleaglannawood (Galway)', zip: '629896' },
	{ city: 'Kyleamullaun (Laois)', zip: '535583' },
	{ city: 'Kyleandangan (Kilkenny)', zip: '846955' },
	{ city: 'Kyleannagh (Tipperary)', zip: '213142' },
	{ city: 'Kyleashinnaun (Tipperary)', zip: '890641' },
	{ city: 'Kyleateera (Kilkenny)', zip: '949670' },
	{ city: 'Kyleatunna (Clare)', zip: '493327' },
	{ city: 'Kyleavarraga Middle (Limerick)', zip: '280190' },
	{ city: 'Kyleavarraga North (Limerick)', zip: '514942' },
	{ city: 'Kyleavarraga South (Limerick)', zip: '769815' },
	{ city: 'Kyleballygalvan (Tipperary)', zip: '400554' },
	{ city: 'Kyleballynamoe (Kilkenny)', zip: '468151' },
	{ city: 'Kyleballyoughter (Kilkenny)', zip: '505367' },
	{ city: 'Kylebeg (Cork)', zip: '156935' },
	{ city: 'Kylebeg (Galway)', zip: '714656' },
	{ city: 'Kylebeg (Kerry)', zip: '639482' },
	{ city: 'Kylebeg (Kilkenny)', zip: '144589' },
	{ city: 'Kylebeg (Laois)', zip: '579972' },
	{ city: 'Kylebeg (Offaly)', zip: '646631' },
	{ city: 'Kylebeg (Tipperary)', zip: '782823' },
	{ city: 'Kyleboher (Offaly)', zip: '192831' },
	{ city: 'Kylebrack (Galway)', zip: '167047' },
	{ city: 'Kylebrack East (Galway)', zip: '334311' },
	{ city: 'Kylebrack West (Galway)', zip: '787705' },
	{ city: 'Kylebroghlan (Galway)', zip: '931968' },
	{ city: 'Kylebwee (Kerry)', zip: '913548' },
	{ city: 'Kyleclonhobert (Laois)', zip: '681090' },
	{ city: 'Kylecreen (Clare)', zip: '417349' },
	{ city: 'Kyle East (Kilkenny)', zip: '609902' },
	{ city: 'Kyleegan (Galway)', zip: '765281' },
	{ city: 'Kylefinchin (Cork)', zip: '981299' },
	{ city: 'Kylefreaghane (Tipperary)', zip: '164415' },
	{ city: 'Kylegarriff (Galway)', zip: '157001' },
	{ city: 'Kylegarve (Limerick)', zip: '290865' },
	{ city: 'Kyleglass (Clare)', zip: '961555' },
	{ city: 'Kylekiproe (Laois)', zip: '937585' },
	{ city: 'Kyle Little (Wexford)', zip: '275736' },
	{ city: 'Kyle Lower (Wexford)', zip: '611793' },
	{ city: 'Kyle Middle (Wexford)', zip: '374532' },
	{ city: 'Kylemore (Galway)', zip: '109652' },
	{ city: 'Kylemore (Kilkenny)', zip: '817095' },
	{ city: 'Kylemore (Tipperary)', zip: '990654' },
	{ city: 'Kylenabehy (Laois)', zip: '155541' },
	{ city: 'Kylenagappa (Galway)', zip: '975522' },
	{ city: 'Kylenagoneeny (Limerick)', zip: '885292' },
	{ city: 'Kylenaheskeragh (Tipperary)', zip: '821749' },
	{ city: 'Kylenahoory (Cork)', zip: '340180' },
	{ city: 'Kylenamelly (Galway)', zip: '638308' },
	{ city: 'Kylenamuck (Tipperary)', zip: '796703' },
	{ city: 'Kylenasaggart (Kilkenny)', zip: '271712' },
	{ city: 'Kylenaskeagh (Kilkenny)', zip: '932917' },
	{ city: 'Kyleomadaun East (Tipperary)', zip: '746726' },
	{ city: 'Kyleomadaun West (Tipperary)', zip: '854397' },
	{ city: 'Kyleonermody (Tipperary)', zip: '486855' },
	{ city: 'Kyleroe (Kilkenny)', zip: '337419' },
	{ city: 'Kylesalia (Galway)', zip: '500315' },
	{ city: 'Kylespiddoge (Laois)', zip: '782355' },
	{ city: 'Kyletalesha (Laois)', zip: '336475' },
	{ city: 'Kyletaun (Limerick)', zip: '183479' },
	{ city: 'Kyletilloge (Laois)', zip: '464273' },
	{ city: 'Kyletombrickane (Tipperary)', zip: '858964' },
	{ city: 'Kyle Upper (Wexford)', zip: '936750' },
	{ city: 'Kyleva (Kilkenny)', zip: '923350' },
	{ city: 'Kylevehagh Commons (Kilkenny)', zip: '584905' },
	{ city: 'Kyle West (Kilkenny)', zip: '773171' },
	{ city: 'Labanasigh (Carlow)', zip: '347126' },
	{ city: 'Labanstown (Louth)', zip: '578090' },
	{ city: 'Labasheeda (Clare)', zip: '333423' },
	{ city: 'Labaun (Cork)', zip: '682849' },
	{ city: 'Labaun (Westmeath)', zip: '848804' },
	{ city: 'Labbacallee (Cork)', zip: '661662' },
	{ city: 'Labbadermody (Cork)', zip: '455299' },
	{ city: 'Labbadish (Donegal)', zip: '572745' },
	{ city: 'Labbadoo (Donegal)', zip: '562966' },
	{ city: 'Labbamolaga East (Cork)', zip: '234722' },
	{ city: 'Labbamolaga Middle (Cork)', zip: '787204' },
	{ city: 'Labbamolaga West (Cork)', zip: '536407' },
	{ city: 'Labbanacallee (Waterford)', zip: '104091' },
	{ city: 'Labbinlee (Cavan)', zip: '906407' },
	{ city: 'Labbyeslin (Leitrim)', zip: '314075' },
	{ city: 'Laboge (Roscommon)', zip: '325241' },
	{ city: 'Lack (Clare)', zip: '297837' },
	{ city: 'Lack (Galway)', zip: '953350' },
	{ city: 'Lack (Kerry)', zip: '494973' },
	{ city: 'Lack (Roscommon)', zip: '917702' },
	{ city: 'Lacka (Kerry)', zip: '128238' },
	{ city: 'Lacka (Laois)', zip: '543463' },
	{ city: 'Lacka (Limerick)', zip: '461553' },
	{ city: 'Lacka (Tipperary)', zip: '705738' },
	{ city: 'Lackabane (Cork)', zip: '757880' },
	{ city: 'Lackabane (Kerry)', zip: '734576' },
	{ city: 'Lackabaun (Cork)', zip: '921806' },
	{ city: 'Lackabaun (Galway)', zip: '501467' },
	{ city: 'Lackabaun (Kerry)', zip: '559580' },
	{ city: 'Lackabeg (Carlow)', zip: '770136' },
	{ city: 'Lacka Beg (Kerry)', zip: '115011' },
	{ city: 'Lacka Beg (Limerick)', zip: '243255' },
	{ city: 'Lackabeha East (Cork)', zip: '331337' },
	{ city: 'Lackabeha West (Cork)', zip: '885754' },
	{ city: 'Lackaboy (Kerry)', zip: '206243' },
	{ city: 'Lackabrack (Cork)', zip: '579651' },
	{ city: 'Lackabrack (Tipperary)', zip: '446724' },
	{ city: 'Lackabranner (Clare)', zip: '147110' },
	{ city: 'Lackaduff (Cork)', zip: '652779' },
	{ city: 'Lackaduv (Cork)', zip: '203788' },
	{ city: 'Lacka East (Kerry)', zip: '436136' },
	{ city: 'Lackafin (Monaghan)', zip: '356012' },
	{ city: 'Lackafinna (Mayo)', zip: '446505' },
	{ city: 'Lackafinna North (Galway)', zip: '241900' },
	{ city: 'Lackafinna South (Galway)', zip: '208664' },
	{ city: 'Lackagh (Donegal)', zip: '555383' },
	{ city: 'Lackagh (Galway)', zip: '286165' },
	{ city: 'Lackagh (Leitrim)', zip: '234398' },
	{ city: 'Lackagh (Monaghan)', zip: '704453' },
	{ city: 'Lackagh (Roscommon)', zip: '527747' },
	{ city: 'Lackagh (Sligo)', zip: '474770' },
	{ city: 'Lackagh (Tipperary)', zip: '238396' },
	{ city: 'Lackaghane (Cork)', zip: '265284' },
	{ city: 'Lackaghatermon (Donegal)', zip: '209027' },
	{ city: 'Lackagh Beg (Galway)', zip: '931773' },
	{ city: 'Lackagh Beg (Kildare)', zip: '215085' },
	{ city: 'Lackagh Beg (Offaly)', zip: '701831' },
	{ city: 'Lackaghbog (Kildare)', zip: '858864' },
	{ city: 'Lackaghmore (Kildare)', zip: '427606' },
	{ city: 'Lackagh More (Galway)', zip: '870489' },
	{ city: 'Lackagh More (Offaly)', zip: '384644' },
	{ city: 'Lackakeely (Mayo)', zip: '597888' },
	{ city: 'Lackakera (Tipperary)', zip: '187659' },
	{ city: 'Lackalea (Galway)', zip: '302765' },
	{ city: 'Lackaleigh (Cork)', zip: '339480' },
	{ city: 'Lacka Lower (Limerick)', zip: '391196' },
	{ city: 'Lackalustraun (Mayo)', zip: '188944' },
	{ city: 'Lackamore (Clare)', zip: '644734' },
	{ city: 'Lackamore (Laois)', zip: '214350' },
	{ city: 'Lackamore (Tipperary)', zip: '266980' },
	{ city: 'Lackamore (Waterford)', zip: '728814' },
	{ city: 'Lacka More (Kerry)', zip: '203809' },
	{ city: 'Lacka More (Limerick)', zip: '834509' },
	{ city: 'Lackan (Carlow)', zip: '924825' },
	{ city: 'Lackan (Cavan)', zip: '838890' },
	{ city: 'Lackan (Galway)', zip: '895851' },
	{ city: 'Lackan (Laois)', zip: '667843' },
	{ city: 'Lackan (Longford)', zip: '521237' },
	{ city: 'Lackan (Monaghan)', zip: '153285' },
	{ city: 'Lackan (Offaly)', zip: '496764' },
	{ city: 'Lackan (Roscommon)', zip: '289758' },
	{ city: 'Lackan (Sligo)', zip: '440987' },
	{ city: 'Lackan (Westmeath)', zip: '324306' },
	{ city: 'Lackan (Wexford)', zip: '537320' },
	{ city: 'Lackan (Wicklow)', zip: '935395' },
	{ city: 'Lackanabrickane (Tipperary)', zip: '864368' },
	{ city: 'Lackanagoneeny (Limerick)', zip: '174946' },
	{ city: 'Lackanagrour (Limerick)', zip: '985513' },
	{ city: 'Lackanalooha (Cork)', zip: '795513' },
	{ city: 'Lackanamona (Cork)', zip: '644372' },
	{ city: 'Lackanascarry (Limerick)', zip: '200472' },
	{ city: 'Lackanash (Meath)', zip: '969850' },
	{ city: 'Lackanashinnagh (Cork)', zip: '644048' },
	{ city: 'Lackanastooka (Cork)', zip: '383435' },
	{ city: 'Lackanatlieve (Sligo)', zip: '638967' },
	{ city: 'Lackancahill (Sligo)', zip: '574721' },
	{ city: 'Lackanclare (Cavan)', zip: '651189' },
	{ city: 'Lackandarra (Tipperary)', zip: '937588' },
	{ city: 'Lackandarra (Waterford)', zip: '968644' },
	{ city: 'Lackandarragh Lower (Wicklow)', zip: '498253' },
	{ city: 'Lackandarragh Upper (Wicklow)', zip: '623683' },
	{ city: 'Lackandarra Lower (Waterford)', zip: '979642' },
	{ city: 'Lackandarra Upper (Waterford)', zip: '593027' },
	{ city: 'Lackanduff (Cavan)', zip: '587245' },
	{ city: 'Lackaneen (Cork)', zip: '178032' },
	{ city: 'Lackanhill (Mayo)', zip: '131678' },
	{ city: 'Lackan Lower (Cavan)', zip: '709579' },
	{ city: 'Lackanmore (Cavan)', zip: '146950' },
	{ city: 'Lackannashinnagh (Clare)', zip: '813515' },
	{ city: 'Lackanoneen (Kerry)', zip: '713995' },
	{ city: 'Lackanroe (Galway)', zip: '354316' },
	{ city: 'Lackantedane (Tipperary)', zip: '308132' },
	{ city: 'Lackan Upper (Cavan)', zip: '784623' },
	{ city: 'Lackanwood (Westmeath)', zip: '884053' },
	{ city: 'Lackareagh (Clare)', zip: '893016' },
	{ city: 'Lackareagh (Cork)', zip: '111128' },
	{ city: 'Lackareagh (Wicklow)', zip: '575051' },
	{ city: 'Lackareagh Beg (Clare)', zip: '757703' },
	{ city: 'Lackareagh More (Clare)', zip: '517188' },
	{ city: 'Lackaroe (Cork)', zip: '481870' },
	{ city: 'Lackaroe (Kerry)', zip: '991250' },
	{ city: 'Lackaroe (Offaly)', zip: '604835' },
	{ city: 'Lackaroe (Tipperary)', zip: '323249' },
	{ city: 'Lackaroe (Waterford)', zip: '190628' },
	{ city: 'Lackarour (Cork)', zip: '504774' },
	{ city: 'Lackaun (Mayo)', zip: '488735' },
	{ city: 'Lacka Upper (Limerick)', zip: '550754' },
	{ city: 'Lackavane (Cork)', zip: '257903' },
	{ city: 'Lackavaun (Cork)', zip: '680714' },
	{ city: 'Lackavrea (Galway)', zip: '437246' },
	{ city: 'Lackavunaknick (Cork)', zip: '690128' },
	{ city: 'Lackaweer (Donegal)', zip: '792411' },
	{ city: 'Lacka West (Kerry)', zip: '187909' },
	{ city: 'Lack Beg (Cork)', zip: '525674' },
	{ city: 'Lackbrack (Cork)', zip: '742990' },
	{ city: 'Lackbrooder (Kerry)', zip: '172634' },
	{ city: 'Lackcrom (Donegal)', zip: '475899' },
	{ city: 'Lackderg (Mayo)', zip: '670089' },
	{ city: 'Lackdotia (Cork)', zip: '786663' },
	{ city: 'Lack East (Clare)', zip: '258109' },
	{ city: 'Lack East (Mayo)', zip: '927348' },
	{ city: 'Lackeel (Cork)', zip: '128012' },
	{ city: 'Lackeen (Cork)', zip: '750589' },
	{ city: 'Lackeen (Kerry)', zip: '196281' },
	{ city: 'Lackelly East (Limerick)', zip: '117666' },
	{ city: 'Lackelly West (Limerick)', zip: '111737' },
	{ city: 'Lacken (Carlow)', zip: '346881' },
	{ city: 'Lacken (Clare)', zip: '940428' },
	{ city: 'Lacken (Cork)', zip: '549076' },
	{ city: 'Lacken (Kilkenny)', zip: '552973' },
	{ city: 'Lacken (Tipperary)', zip: '443261' },
	{ city: 'Lacken (Waterford)', zip: '142584' },
	{ city: 'Lacken (Wexford)', zip: '289664' },
	{ city: 'Lackenacoombe (Tipperary)', zip: '601079' },
	{ city: 'Lackenacreena (Tipperary)', zip: '340873' },
	{ city: 'Lackenacummeen (Cork)', zip: '330453' },
	{ city: 'Lackenafasoge (Cork)', zip: '613346' },
	{ city: 'Lackenagea (Cork)', zip: '577638' },
	{ city: 'Lackenagobidane (Cork)', zip: '724270' },
	{ city: 'Lackenagreany (Waterford)', zip: '740230' },
	{ city: 'Lackenakea (Cork)', zip: '913756' },
	{ city: 'Lackenareague (Cork)', zip: '927324' },
	{ city: 'Lackenavea (Tipperary)', zip: '572196' },
	{ city: 'Lackenavorna (Tipperary)', zip: '916148' },
	{ city: 'Lackenbaun (Clare)', zip: '817940' },
	{ city: 'Lackenbehy (Cork)', zip: '909198' },
	{ city: 'Lackendarra (Waterford)', zip: '879968' },
	{ city: 'Lackendarragh (Cork)', zip: '314216' },
	{ city: 'Lackendarragh (Limerick)', zip: '173875' },
	{ city: 'Lackendarragh (Wexford)', zip: '837696' },
	{ city: 'Lackendarragh Middle (Cork)', zip: '463513' },
	{ city: 'Lackendarragh North (Cork)', zip: '645828' },
	{ city: 'Lackendarragh South (Cork)', zip: '746266' },
	{ city: 'Lackendragaun (Kilkenny)', zip: '855911' },
	{ city: 'Lackenduff (Cork)', zip: '299143' },
	{ city: 'Lackenfune (Waterford)', zip: '525611' },
	{ city: 'Lackennaskagh (Clare)', zip: '440159' },
	{ city: 'Lackenrea (Waterford)', zip: '595445' },
	{ city: 'Lackenroe (Cork)', zip: '398606' },
	{ city: 'Lackenshoneen (Cork)', zip: '773118' },
	{ city: 'Lackensillagh (Waterford)', zip: '642174' },
	{ city: 'Lackey (Laois)', zip: '452792' },
	{ city: 'Lackfrancis (Cork)', zip: '637599' },
	{ city: 'Lacklea (Donegal)', zip: '524018' },
	{ city: 'Lacklea (Galway)', zip: '646377' },
	{ city: 'Lacklom (Donegal)', zip: '456133' },
	{ city: 'Lacklom (Monaghan)', zip: '667047' },
	{ city: 'Lackmelch (Meath)', zip: '594012' },
	{ city: 'Lack More (Cork)', zip: '834272' },
	{ city: 'Lacknacoo (Donegal)', zip: '339206' },
	{ city: 'Lacknagreagh (Louth)', zip: '786747' },
	{ city: 'Lacknahaghny (Cork)', zip: '294109' },
	{ city: 'Lacktify (Cork)', zip: '483090' },
	{ city: 'Lack West (Clare)', zip: '599238' },
	{ city: 'Lack West (Mayo)', zip: '409557' },
	{ city: 'Laconnell (Donegal)', zip: '425142' },
	{ city: 'Lacoon (Leitrim)', zip: '341249' },
	{ city: 'Lacroagh (Donegal)', zip: '333254' },
	{ city: 'Lacystown (Meath)', zip: '663570' },
	{ city: 'Laddan (Donegal)', zip: '939415' },
	{ city: 'Ladestown (Westmeath)', zip: '590607' },
	{ city: 'Ladycastle Lower (Kildare)', zip: '831403' },
	{ city: 'Ladycastle Upper (Kildare)', zip: '262452' },
	{ city: 'Ladyhill (Kildare)', zip: '298962' },
	{ city: 'Lady Island (Meath)', zip: '364110' },
	{ city: 'Ladyrath (Meath)', zip: '891425' },
	{ city: 'Ladysabbey (Tipperary)', zip: '207813' },
	{ city: 'Ladysbridge (Cork)', zip: '895305' },
	{ city: "Lady's Bridge (Cork)", zip: '365645' },
	{ city: "Lady's Island (Kerry)", zip: '254126' },
	{ city: "Lady's Island (Wexford)", zip: '722371' },
	{ city: 'Ladystown (Carlow)', zip: '326223' },
	{ city: "Lady's Well (Tipperary)", zip: '705126' },
	{ city: 'Ladytown (Kildare)', zip: '743512' },
	{ city: 'Laffina (Tipperary)', zip: '927299' },
	{ city: 'Lafone (Waterford)', zip: '214249' },
	{ city: 'Lag (Cork)', zip: '700139' },
	{ city: 'Lag (Donegal)', zip: '849074' },
	{ city: 'Lagacurry (Donegal)', zip: '541838' },
	{ city: 'Lagakilleen (Mayo)', zip: '865668' },
	{ city: 'Lagan (Cavan)', zip: '918229' },
	{ city: 'Lagan (Louth)', zip: '626059' },
	{ city: 'Lagan (Monaghan)', zip: '849449' },
	{ city: 'Laganore (Tipperary)', zip: '538651' },
	{ city: 'Lagaturrin (Mayo)', zip: '295491' },
	{ city: 'Lagavooren (Louth)', zip: '218277' },
	{ city: 'Lagavooren (Meath)', zip: '201148' },
	{ city: 'Lagcurragh (Mayo)', zip: '349777' },
	{ city: 'Lagduff Beg (Mayo)', zip: '613041' },
	{ city: 'Lagduff More (Mayo)', zip: '481853' },
	{ city: 'Lagganstown Lower (Tipperary)', zip: '733334' },
	{ city: 'Lagganstown Upper (Tipperary)', zip: '549287' },
	{ city: 'Laggoo (Galway)', zip: '624875' },
	{ city: 'Laghcloon (Clare)', zip: '665899' },
	{ city: 'Laghil (Donegal)', zip: '574097' },
	{ city: 'Laghile (Clare)', zip: '885251' },
	{ city: 'Laghile (Tipperary)', zip: '135340' },
	{ city: 'Laghloon (Mayo)', zip: '495471' },
	{ city: 'Laghlooney (Longford)', zip: '620507' },
	{ city: 'Laght (Cork)', zip: '736263' },
	{ city: 'Laghta (Leitrim)', zip: '588172' },
	{ city: 'Laghtacallow (Kerry)', zip: '275855' },
	{ city: 'Laghtadawannagh (Mayo)', zip: '309315' },
	{ city: 'Laghta Eighter (Mayo)', zip: '689146' },
	{ city: 'Laghtagalla (Tipperary)', zip: '395126' },
	{ city: 'Laghtagoona (Clare)', zip: '259789' },
	{ city: 'Laghtanabba (Galway)', zip: '637251' },
	{ city: 'Laghtane East (Limerick)', zip: '907573' },
	{ city: 'Laghtane West (Limerick)', zip: '185161' },
	{ city: 'Laghtanvack (Mayo)', zip: '638385' },
	{ city: 'Laghta Oughter (Mayo)', zip: '281593' },
	{ city: 'Laghtavarry (Mayo)', zip: '516387' },
	{ city: 'Laghtbrack (Kilkenny)', zip: '818130' },
	{ city: 'Laghtcausk (Roscommon)', zip: '718157' },
	{ city: 'Laghtea (Tipperary)', zip: '778184' },
	{ city: 'Laghtgannon (Galway)', zip: '482061' },
	{ city: 'Laghtgeorge (Galway)', zip: '805435' },
	{ city: 'Laghtmacdurkan (Mayo)', zip: '403016' },
	{ city: 'Laghtmurragha (Mayo)', zip: '709153' },
	{ city: 'Laghtmurreda (Clare)', zip: '120356' },
	{ city: 'Laghtneill (Cork)', zip: '163612' },
	{ city: 'Laghtonora (Galway)', zip: '178065' },
	{ city: 'Laghtphilip (Galway)', zip: '877716' },
	{ city: 'Laghtsigh (Cork)', zip: '129958' },
	{ city: 'Laghty (Leitrim)', zip: '336299' },
	{ city: 'Laghty Barr (Leitrim)', zip: '649841' },
	{ city: 'Laghtyshaughnessy (Galway)', zip: '114570' },
	{ city: 'Laghvally (Clare)', zip: '204923' },
	{ city: 'Laghy (Donegal)', zip: '288189' },
	{ city: 'Lagile (Cork)', zip: '199944' },
	{ city: 'Lagnagillew (Donegal)', zip: '937272' },
	{ city: 'Lagnagoushee (Waterford)', zip: '690621' },
	{ city: 'Lagnamuck (Mayo)', zip: '241508' },
	{ city: 'Lagnavaddoge (Mayo)', zip: '369605' },
	{ city: 'Lagneeve (Cork)', zip: '762854' },
	{ city: 'Lagore Big (Meath)', zip: '403958' },
	{ city: 'Lagore Little (Meath)', zip: '523033' },
	{ city: 'Lagunna (Donegal)', zip: '884866' },
	{ city: 'Lahacrogher (Galway)', zip: '319056' },
	{ city: 'Lahadane (Cork)', zip: '308896' },
	{ city: 'Lahagboy (Roscommon)', zip: '161946' },
	{ city: 'Lahagh (Tipperary)', zip: '277932' },
	{ city: 'Lahaghglass North (Galway)', zip: '699872' },
	{ city: 'Lahaghglass South (Galway)', zip: '567515' },
	{ city: 'Lahakinneen (Cork)', zip: '338866' },
	{ city: 'Lahanagh (Sligo)', zip: '970640' },
	{ city: 'Lahanaght (Cork)', zip: '699839' },
	{ city: 'Lahan Island (Donegal)', zip: '932807' },
	{ city: 'Laharan (Cork)', zip: '714888' },
	{ city: 'Laharan (Kerry)', zip: '836341' },
	{ city: 'Laharandota (Cork)', zip: '261258' },
	{ city: 'Laharandota Mountain (Cork)', zip: '933396' },
	{ city: 'Laharan East (Cork)', zip: '885364' },
	{ city: 'Laharankeal (Cork)', zip: '419664' },
	{ city: 'Laharan North (Kerry)', zip: '148961' },
	{ city: 'Laharanshermeen (Cork)', zip: '310793' },
	{ city: 'Laharan South (Kerry)', zip: '338430' },
	{ city: 'Laharan West (Cork)', zip: '736186' },
	{ city: 'Lahard (Cavan)', zip: '266785' },
	{ city: 'Lahard (Cork)', zip: '175780' },
	{ city: 'Lahard (Kerry)', zip: '344451' },
	{ city: 'Lahard (Leitrim)', zip: '258884' },
	{ city: 'Lahardan (Clare)', zip: '652904' },
	{ city: 'Lahardan (Sligo)', zip: '318178' },
	{ city: 'Lahardan (Waterford)', zip: '737234' },
	{ city: 'Lahardane (Cork)', zip: '806621' },
	{ city: 'Lahardane (Kerry)', zip: '990400' },
	{ city: 'Lahardane Beg (Cork)', zip: '903099' },
	{ city: 'Lahardane More (Cork)', zip: '144254' },
	{ city: 'Lahardan Lower (Tipperary)', zip: '530157' },
	{ city: 'Lahardan Upper (Tipperary)', zip: '832506' },
	{ city: 'Lahardaun (Clare)', zip: '879759' },
	{ city: 'Lahardaun (Galway)', zip: '992718' },
	{ city: 'Lahardaun (Mayo)', zip: '657472' },
	{ city: 'Laharran (Cork)', zip: '373963' },
	{ city: 'Laheen (Cavan)', zip: '955462' },
	{ city: 'Laheen (Donegal)', zip: '141220' },
	{ city: 'Laheen (Leitrim)', zip: '886450' },
	{ city: 'Laheennamona (Leitrim)', zip: '434038' },
	{ city: 'Laheen North (Leitrim)', zip: '195880' },
	{ city: 'Laheen South (Leitrim)', zip: '442541' },
	{ city: 'Laheratanvally (Cork)', zip: '503772' },
	{ city: 'Laherfineen (Cork)', zip: '314675' },
	{ city: 'Laherfree (Kerry)', zip: '698855' },
	{ city: 'Lahern (Cork)', zip: '330047' },
	{ city: 'Lahernathee (Cork)', zip: '230234' },
	{ city: 'Lahertidaly (Cork)', zip: '957097' },
	{ city: 'Lahesheragh North (Kerry)', zip: '348023' },
	{ city: 'Lahesheragh South (Kerry)', zip: '101318' },
	{ city: 'Lahesseragh (Tipperary)', zip: '737920' },
	{ city: 'Lahid (Tipperary)', zip: '732333' },
	{ city: 'Lake (Wexford)', zip: '421349' },
	{ city: 'Lake Big (Wexford)', zip: '967830' },
	{ city: 'Lakefield (Cavan)', zip: '697413' },
	{ city: 'Lakefield (Galway)', zip: '245480' },
	{ city: 'Lakefield (Meath)', zip: '869928' },
	{ city: 'Lakeland Lower (Mayo)', zip: '144711' },
	{ city: 'Lakeland Upper (Mayo)', zip: '834436' },
	{ city: 'Lake Little (Wexford)', zip: '170592' },
	{ city: 'Lakeview (Galway)', zip: '298659' },
	{ city: 'Lakill (Mayo)', zip: '906796' },
	{ city: 'Lakill And Moortown (Westmeath)', zip: '297375' },
	{ city: 'Lakingstown (Westmeath)', zip: '785529' },
	{ city: 'Lakyle (Clare)', zip: '152514' },
	{ city: 'Lakyle (Galway)', zip: '314586' },
	{ city: 'Lakyle (Kilkenny)', zip: '934618' },
	{ city: 'Lakyle North (Clare)', zip: '424914' },
	{ city: 'Lakyle South (Clare)', zip: '277982' },
	{ city: 'Lalistown (Westmeath)', zip: '669139' },
	{ city: "Lalor's-Lot (Tipperary)", zip: '701581' },
	{ city: 'Lamagh (Longford)', zip: '702936' },
	{ city: 'Lambay Island (Dublin)', zip: '450956' },
	{ city: 'Lamberton (Wicklow)', zip: '835414' },
	{ city: 'Lamberton Demesne (Laois)', zip: '199209' },
	{ city: 'Lambertstown (Meath)', zip: '680216' },
	{ city: 'Lambertstown (Wexford)', zip: '793821' },
	{ city: 'Lambhill (Galway)', zip: '882971' },
	{ city: 'Lambs Isle (Donegal)', zip: '271310' },
	{ city: 'Lambstown (Laois)', zip: '964134' },
	{ city: 'Lambstown (Wexford)', zip: '403636' },
	{ city: 'Lambstown Great (Wexford)', zip: '335507' },
	{ city: 'Lambstown Little (Wexford)', zip: '232037' },
	{ city: 'Lambtown (Louth)', zip: '502887' },
	{ city: 'Lamoge (Kilkenny)', zip: '455735' },
	{ city: 'Landenstown (Kildare)', zip: '115884' },
	{ city: 'Landscape (Waterford)', zip: '844533' },
	{ city: 'Landscape (Wexford)', zip: '702322' },
	{ city: 'Landsdown (Tipperary)', zip: '399029' },
	{ city: 'Lane (Dublin)', zip: '836727' },
	{ city: 'Lanehead (Donegal)', zip: '675855' },
	{ city: 'Lanesborough (Longford)', zip: '408261' },
	{ city: 'Lanespark (Tipperary)', zip: '529282' },
	{ city: 'Lanestown (Dublin)', zip: '833943' },
	{ city: 'Langanoran (Waterford)', zip: '799318' },
	{ city: 'Langough (Clare)', zip: '408148' },
	{ city: 'Lankill (Mayo)', zip: '932747' },
	{ city: 'Lanliss (Cavan)', zip: '904257' },
	{ city: 'Lanmore (Mayo)', zip: '890868' },
	{ city: 'Lanna (Clare)', zip: '477362' },
	{ city: 'Lannagh (Wexford)', zip: '478205' },
	{ city: 'Lannaght (Clare)', zip: '541815' },
	{ city: 'Lannanerriagh (Cavan)', zip: '721986' },
	{ city: 'Lannat (Louth)', zip: '719891' },
	{ city: 'Lannat (Monaghan)', zip: '848514' },
	{ city: 'Lansville (Dublin)', zip: '324463' },
	{ city: 'Lantaur (Monaghan)', zip: '304321' },
	{ city: 'Lappallagh (Mayo)', zip: '518114' },
	{ city: 'Lappan (Monaghan)', zip: '992615' },
	{ city: 'Lappanbane (Cavan)', zip: '468125' },
	{ city: 'Lappanduff (Cavan)', zip: '393371' },
	{ city: 'Laracor (Meath)', zip: '433200' },
	{ city: 'Laragh (Cavan)', zip: '357041' },
	{ city: 'Laragh (Cork)', zip: '768213' },
	{ city: 'Laragh (Galway)', zip: '601239' },
	{ city: 'Laragh (Kildare)', zip: '421907' },
	{ city: 'Laragh (Leitrim)', zip: '415254' },
	{ city: 'Laragh (Longford)', zip: '591227' },
	{ city: 'Laragh (Monaghan)', zip: '720267' },
	{ city: 'Laragh (Sligo)', zip: '603061' },
	{ city: 'Laragh (Westmeath)', zip: '488541' },
	{ city: 'Laragh (Wicklow)', zip: '539328' },
	{ city: 'Laraghakea (Clare)', zip: '408491' },
	{ city: 'Laragh And Ross (Roscommon)', zip: '766717' },
	{ city: 'Laragh Beg (Galway)', zip: '357843' },
	{ city: 'Laraghbryan East (Kildare)', zip: '262279' },
	{ city: 'Laraghbryan West (Kildare)', zip: '597759' },
	{ city: 'Laraghcon (Dublin)', zip: '313268' },
	{ city: 'Laragh Demesne (Kildare)', zip: '306806' },
	{ city: 'Laragh East (Wicklow)', zip: '953050' },
	{ city: 'Laraghirril (Donegal)', zip: '712286' },
	{ city: 'Laragh More (Galway)', zip: '746932' },
	{ city: 'Laragh West (Wicklow)', zip: '726702' },
	{ city: 'Larah (Carlow)', zip: '497670' },
	{ city: 'Larah (Cavan)', zip: '157430' },
	{ city: 'Laraheen (Wexford)', zip: '391326' },
	{ city: 'Laraheenhill (Wexford)', zip: '999836' },
	{ city: 'Laralae (Mayo)', zip: '352116' },
	{ city: 'Larass (Sligo)', zip: '281037' },
	{ city: 'Laravoolta (Cork)', zip: '163258' },
	{ city: 'Laraweehan (Cavan)', zip: '779194' },
	{ city: 'Larchfield Glebe (Cavan)', zip: '223682' },
	{ city: 'Larch Hill (Kildare)', zip: '933137' },
	{ city: 'Larch Hill (Laois)', zip: '194875' },
	{ city: 'Lareen (Leitrim)', zip: '261159' },
	{ city: 'Larga (Leitrim)', zip: '226136' },
	{ city: 'Largan (Cavan)', zip: '920255' },
	{ city: 'Largan (Galway)', zip: '576954' },
	{ city: 'Largan (Leitrim)', zip: '109497' },
	{ city: 'Largan (Mayo)', zip: '899181' },
	{ city: 'Largan (Roscommon)', zip: '596840' },
	{ city: 'Largan (Sligo)', zip: '701880' },
	{ city: 'Larganakilla (Donegal)', zip: '541376' },
	{ city: 'Larganavaddoge (Leitrim)', zip: '899788' },
	{ city: 'Largan Beg (Mayo)', zip: '467009' },
	{ city: 'Larganboy East (Mayo)', zip: '126962' },
	{ city: 'Larganboy West (Mayo)', zip: '685541' },
	{ city: 'Largandill (Leitrim)', zip: '395658' },
	{ city: 'Largandoon (Leitrim)', zip: '309906' },
	{ city: 'Larganhugh (Leitrim)', zip: '298279' },
	{ city: 'Larganmore (Mayo)', zip: '909342' },
	{ city: 'Largan More (Mayo)', zip: '584570' },
	{ city: 'Largan Mountain (Leitrim)', zip: '237949' },
	{ city: 'Larganreagh (Donegal)', zip: '362631' },
	{ city: 'Larganreagh Barr (Donegal)', zip: '212620' },
	{ city: 'Largantemple (Leitrim)', zip: '945377' },
	{ city: 'Largatreany (Donegal)', zip: '573195' },
	{ city: 'Large Island (Galway)', zip: '422498' },
	{ city: 'Largnalarkan (Donegal)', zip: '716645' },
	{ city: 'Largnalore (Donegal)', zip: '145907' },
	{ city: 'Largy (Cavan)', zip: '743256' },
	{ city: 'Largy (Leitrim)', zip: '975313' },
	{ city: 'Largy (Meath)', zip: '562786' },
	{ city: 'Largy (Monaghan)', zip: '676793' },
	{ city: 'Largybrack (Donegal)', zip: '270572' },
	{ city: 'Largydonnell (Leitrim)', zip: '607817' },
	{ city: 'Largymore (Donegal)', zip: '531811' },
	{ city: 'Largynagreana (Donegal)', zip: '736972' },
	{ city: 'Largysillagh (Donegal)', zip: '670391' },
	{ city: 'Larha (Kerry)', zip: '604068' },
	{ city: 'Larha North (Tipperary)', zip: '820535' },
	{ city: 'Larha South (Tipperary)', zip: '217108' },
	{ city: 'Larkfield (Leitrim)', zip: '788722' },
	{ city: 'Larkfield (Longford)', zip: '538634' },
	{ city: 'Larkhill (Sligo)', zip: '401084' },
	{ city: 'Larkinstown (Westmeath)', zip: '252071' },
	{ city: 'Larkinstown (Wexford)', zip: '156865' },
	{ city: 'Larraga (Galway)', zip: '786465' },
	{ city: 'Larragan (Galway)', zip: '858143' },
	{ city: 'Larragan (Laois)', zip: '879320' },
	{ city: 'Laskiltagh (Limerick)', zip: '609307' },
	{ city: 'Lasmaconly (Carlow)', zip: '364957' },
	{ city: 'Lassaboy (Kerry)', zip: '336876' },
	{ city: 'Lassana (Clare)', zip: '591261' },
	{ city: 'Lassanaroe (Cork)', zip: '430891' },
	{ city: 'Lassanny (Mayo)', zip: '814777' },
	{ city: 'Lateaster (Cavan)', zip: '176227' },
	{ city: 'Lateeve (Kerry)', zip: '803578' },
	{ city: 'Lateeve Beg (Kerry)', zip: '582670' },
	{ city: 'Lateevemanagh (Kerry)', zip: '946644' },
	{ city: 'Lateeve More (Kerry)', zip: '950194' },
	{ city: 'Lateever (Cavan)', zip: '598155' },
	{ city: 'Lates (Kilkenny)', zip: '614626' },
	{ city: 'Latgallan (Monaghan)', zip: '634123' },
	{ city: 'Latgee (Monaghan)', zip: '238982' },
	{ city: 'Lathaleere (Wicklow)', zip: '483474' },
	{ city: 'Latimerstown (Wexford)', zip: '223332' },
	{ city: 'Latinalbany (Monaghan)', zip: '146337' },
	{ city: 'Latlorcan (Monaghan)', zip: '833797' },
	{ city: 'Latnadronagh (Cavan)', zip: '686314' },
	{ city: 'Latnakelly (Monaghan)', zip: '193028' },
	{ city: 'Latnamard (Monaghan)', zip: '553775' },
	{ city: 'Latoon North (Clare)', zip: '455988' },
	{ city: 'Latoon South (Clare)', zip: '782445' },
	{ city: 'Latroe (Monaghan)', zip: '627679' },
	{ city: 'Latsey (Cavan)', zip: '673116' },
	{ city: 'Latt (Cavan)', zip: '606565' },
	{ city: 'Lattacapple (Cavan)', zip: '686312' },
	{ city: 'Lattacrom (Monaghan)', zip: '566332' },
	{ city: 'Lattacrossan (Monaghan)', zip: '180385' },
	{ city: 'Lattagloghan (Cavan)', zip: '170467' },
	{ city: 'Lattensbog (Kildare)', zip: '698990' },
	{ city: 'Latteragh (Tipperary)', zip: '513118' },
	{ city: 'Latterriff (Cavan)', zip: '958154' },
	{ city: 'Lattigar (Monaghan)', zip: '600140' },
	{ city: 'Lattin (Tipperary)', zip: '372497' },
	{ city: 'Lattin East (Tipperary)', zip: '797467' },
	{ city: 'Lattin North (Tipperary)', zip: '615829' },
	{ city: 'Lattin West (Tipperary)', zip: '576119' },
	{ city: 'Latton (Monaghan)', zip: '457591' },
	{ city: 'Lattone (Cavan)', zip: '976536' },
	{ city: 'Lattone (Leitrim)', zip: '327205' },
	{ city: 'Lattonfasky (Monaghan)', zip: '182709' },
	{ city: 'Lattoon (Cavan)', zip: '501481' },
	{ city: 'Lattoon (Galway)', zip: '254825' },
	{ city: 'Lattylanigan (Monaghan)', zip: '796164' },
	{ city: 'Lattyloo (Cavan)', zip: '919395' },
	{ city: 'Latully (Cavan)', zip: '590052' },
	{ city: 'Laughanstown (Dublin)', zip: '743150' },
	{ city: 'Laughil (Galway)', zip: '880835' },
	{ city: 'Laughil (Longford)', zip: '498155' },
	{ city: 'Laughil (Mayo)', zip: '998597' },
	{ city: 'Laughil (Offaly)', zip: '724843' },
	{ city: 'Laughil (Roscommon)', zip: '468097' },
	{ city: 'Laughil (Sligo)', zip: '188081' },
	{ city: 'Laught (Laois)', zip: '453472' },
	{ city: 'Lauhir (Kerry)', zip: '923295' },
	{ city: 'Launtaggart (Leitrim)', zip: '399599' },
	{ city: 'Lauragh (Kerry)', zip: '162550' },
	{ city: 'Lauragh (Laois)', zip: '359489' },
	{ city: 'Lauragh (Waterford)', zip: '930238' },
	{ city: 'Lauragh Lower (Kerry)', zip: '258560' },
	{ city: 'Lauragh Upper (Kerry)', zip: '677755' },
	{ city: 'Laurclavagh (Galway)', zip: '749833' },
	{ city: 'Laurel Hill (Laois)', zip: '256174' },
	{ city: 'Laurencetown (Galway)', zip: '555821' },
	{ city: 'Laurencetown (Offaly)', zip: '257012' },
	{ city: 'Laurencetown North (Limerick)', zip: '405310' },
	{ city: 'Laurencetown South (Limerick)', zip: '575839' },
	{ city: 'Laurestown (Dublin)', zip: '448710' },
	{ city: 'Laurstown (Wexford)', zip: '352638' },
	{ city: 'Lauvlyer (Mayo)', zip: '931068' },
	{ city: 'Lavagh (Cavan)', zip: '526090' },
	{ city: 'Lavagh (Galway)', zip: '530546' },
	{ city: 'Lavagh (Leitrim)', zip: '940341' },
	{ city: 'Lavagh (Offaly)', zip: '525662' },
	{ city: 'Lavagh (Roscommon)', zip: '687504' },
	{ city: 'Lavagh (Sligo)', zip: '810673' },
	{ city: 'Lavagh Beg (Offaly)', zip: '108286' },
	{ city: 'Lavagilduff (Monaghan)', zip: '270680' },
	{ city: 'Lavally (Clare)', zip: '683722' },
	{ city: 'Lavally (Galway)', zip: '752178' },
	{ city: 'Lavally (Roscommon)', zip: '421536' },
	{ city: 'Lavally (Sligo)', zip: '205717' },
	{ city: 'Lavallyconor (Galway)', zip: '826728' },
	{ city: 'Lavally Lower (Cork)', zip: '401890' },
	{ city: 'Lavally Lower (Tipperary)', zip: '951112' },
	{ city: 'Lavally North (Clare)', zip: '484299' },
	{ city: 'Lavally South (Clare)', zip: '432331' },
	{ city: 'Lavally Upper (Cork)', zip: '385951' },
	{ city: 'Lavally Upper (Tipperary)', zip: '489185' },
	{ city: 'Lavareen (Leitrim)', zip: '996433' },
	{ city: 'Lavarreen (Clare)', zip: '177203' },
	{ city: 'Lavaur (Leitrim)', zip: '217715' },
	{ city: 'Lavey (Cavan)', zip: '869413' },
	{ city: 'Lavinscartron (Sligo)', zip: '610213' },
	{ city: 'Lavistown (Kilkenny)', zip: '905021' },
	{ city: 'Lavy Beg (Mayo)', zip: '459932' },
	{ city: 'Lavy More (Mayo)', zip: '433554' },
	{ city: 'Lawarreen (Mayo)', zip: '917317' },
	{ city: 'Lawaus (Mayo)', zip: '640413' },
	{ city: 'Lawcus (Kilkenny)', zip: '327155' },
	{ city: 'Lawlesstown (Louth)', zip: '700175' },
	{ city: 'Lawlesstown (Tipperary)', zip: '798218' },
	{ city: 'Laytown (Dublin)', zip: '653191' },
	{ city: 'Laytown (Meath)', zip: '259056' },
	{ city: 'Lea (Laois)', zip: '197900' },
	{ city: 'Leab (Longford)', zip: '465793' },
	{ city: 'Leabaleaha (Kerry)', zip: '561622' },
	{ city: 'Leabeg (Offaly)', zip: '116713' },
	{ city: 'Leabeg (Roscommon)', zip: '721123' },
	{ city: 'Lea Beg (Offaly)', zip: '478567' },
	{ city: 'Leabeg Lower (Wicklow)', zip: '769680' },
	{ city: 'Leabeg Middle (Wicklow)', zip: '541564' },
	{ city: 'Leabeg Upper (Wicklow)', zip: '421423' },
	{ city: 'Leabgarrow (Donegal)', zip: '500524' },
	{ city: 'Leabrannagh (Donegal)', zip: '244864' },
	{ city: 'Leachestown (Wexford)', zip: '839615' },
	{ city: 'Leadawillin (Cork)', zip: '736051' },
	{ city: 'Leadinton (Cork)', zip: '472119' },
	{ city: 'Leadmore East (Clare)', zip: '522499' },
	{ city: 'Leadmore West (Clare)', zip: '560639' },
	{ city: 'Leadymore (Mayo)', zip: '293241' },
	{ city: 'Leaffony (Sligo)', zip: '325019' },
	{ city: 'Leafin (Meath)', zip: '103561' },
	{ city: 'Leaf Island (Galway)', zip: '631259' },
	{ city: 'Leagane (Limerick)', zip: '443555' },
	{ city: 'Leagane (Tipperary)', zip: '437091' },
	{ city: 'Leagans (Donegal)', zip: '389167' },
	{ city: 'Leagard North (Clare)', zip: '777847' },
	{ city: 'Leagard South (Clare)', zip: '330994' },
	{ city: 'Leagaun (Galway)', zip: '531595' },
	{ city: 'Leagh (Carlow)', zip: '911295' },
	{ city: 'Leagh (Kerry)', zip: '892429' },
	{ city: 'Leagh (Laois)', zip: '414348' },
	{ city: 'Leagh (Monaghan)', zip: '711490' },
	{ city: 'Leagh (Waterford)', zip: '337004' },
	{ city: 'Leaghcarrick (Galway)', zip: '600327' },
	{ city: 'Leaghin (Cavan)', zip: '420554' },
	{ city: 'Leagh-Marshes (Kerry)', zip: '898754' },
	{ city: 'Leagh North (Galway)', zip: '927156' },
	{ city: 'Leaghort (Clare)', zip: '607822' },
	{ city: 'Leaghort Beg (Clare)', zip: '706669' },
	{ city: 'Leaghort More (Clare)', zip: '112918' },
	{ city: 'Leagh South (Galway)', zip: '826909' },
	{ city: 'Leaght (Donegal)', zip: '683865' },
	{ city: 'Leaha (Galway)', zip: '629665' },
	{ city: 'Leaha (Kerry)', zip: '596881' },
	{ city: 'Leaheen (Clare)', zip: '847257' },
	{ city: 'Leahill (Cork)', zip: '550540' },
	{ city: 'Leahys (Limerick)', zip: '667205' },
	{ city: 'Lealetter (Galway)', zip: '674595' },
	{ city: 'Leam (Cavan)', zip: '918222' },
	{ city: 'Leam (Mayo)', zip: '313023' },
	{ city: 'Leam (Roscommon)', zip: '894475' },
	{ city: 'Leamacrossan (Donegal)', zip: '803791' },
	{ city: 'Leamadartaun (Mayo)', zip: '857382' },
	{ city: 'Leamagowra (Donegal)', zip: '383625' },
	{ city: 'Leamaneh North (Clare)', zip: '980847' },
	{ city: 'Leamaneh South (Clare)', zip: '710016' },
	{ city: 'Leamaneigh Beg (Clare)', zip: '203022' },
	{ city: 'Leamaneigh More (Clare)', zip: '549854' },
	{ city: 'Leamanish (Leitrim)', zip: '709118' },
	{ city: 'Leamareha Island (Mayo)', zip: '609004' },
	{ city: 'Leamaskally (Leitrim)', zip: '226624' },
	{ city: 'Leamcon (Cork)', zip: '878714' },
	{ city: 'Leamcon (Galway)', zip: '483502' },
	{ city: 'Leam East (Galway)', zip: '558766' },
	{ city: 'Leamgeltan (Cavan)', zip: '836272' },
	{ city: 'Leamirlea (Kerry)', zip: '990201' },
	{ city: 'Leamlara (Cork)', zip: '516045' },
	{ city: 'Leamnaguila (Kerry)', zip: '881264' },
	{ city: 'Leamnaleaha (Clare)', zip: '834700' },
	{ city: 'Leamore (Roscommon)', zip: '975716' },
	{ city: 'Lea More (Offaly)', zip: '251251' },
	{ city: 'Leamore Lower (Wicklow)', zip: '688337' },
	{ city: 'Leamore Upper (Wicklow)', zip: '718827' },
	{ city: 'Leampreaghane (Kerry)', zip: '417034' },
	{ city: 'Leam West (Galway)', zip: '683715' },
	{ city: 'Leamydoody (Kerry)', zip: '130886' },
	{ city: 'Leamyglissane (Kerry)', zip: '517387' },
	{ city: 'Leana (Clare)', zip: '893630' },
	{ city: 'Leanamore (Kerry)', zip: '361823' },
	{ city: 'Leansaghane (Kerry)', zip: '851989' },
	{ city: 'Leany (Carlow)', zip: '326663' },
	{ city: 'Leap (Cork)', zip: '452925' },
	{ city: 'Leap (Laois)', zip: '862280' },
	{ city: 'Leap (Offaly)', zip: '819642' },
	{ city: 'Leapstown (Kilkenny)', zip: '192836' },
	{ city: 'Lear (Cavan)', zip: '942177' },
	{ city: 'Lear (Leitrim)', zip: '914345' },
	{ city: 'Leas (Dublin)', zip: '650766' },
	{ city: 'Leaselands (Cork)', zip: '541249' },
	{ city: 'Leastown (Dublin)', zip: '248063' },
	{ city: 'Leat Beg (Donegal)', zip: '849051' },
	{ city: 'Leath East (Kerry)', zip: '524285' },
	{ city: 'Leath West (Kerry)', zip: '922882' },
	{ city: 'Leat More (Donegal)', zip: '371282' },
	{ city: 'Lecade (Westmeath)', zip: '591050' },
	{ city: 'Lecarhoo (Kerry)', zip: '944475' },
	{ city: 'Lecarrow (Galway)', zip: '155761' },
	{ city: 'Lecarrow (Leitrim)', zip: '702296' },
	{ city: 'Lecarrow (Mayo)', zip: '938511' },
	{ city: 'Lecarrow (Offaly)', zip: '577663' },
	{ city: 'Lecarrow (Roscommon)', zip: '500727' },
	{ city: 'Lecarrow (Sligo)', zip: '579031' },
	{ city: 'Lecarrowanteean (Mayo)', zip: '282444' },
	{ city: 'Lecarrow Beg (Clare)', zip: '759755' },
	{ city: 'Lecarrowcloghagh (Mayo)', zip: '768107' },
	{ city: 'Lecarrow Glebe (Offaly)', zip: '124845' },
	{ city: 'Lecarrowkilleen (Mayo)', zip: '274522' },
	{ city: 'Lecarrow Lower (Clare)', zip: '338052' },
	{ city: 'Lecarrowmactully (Galway)', zip: '824149' },
	{ city: 'Lecarrowmore (Galway)', zip: '997619' },
	{ city: 'Lecarrow More (Clare)', zip: '217372' },
	{ city: 'Lecarrownagappoge (Galway)', zip: '747666' },
	{ city: 'Lecarrownaveagh (Sligo)', zip: '347380' },
	{ city: 'Lecarrow North (Clare)', zip: '733504' },
	{ city: 'Lecarrow North (Galway)', zip: '147468' },
	{ city: 'Lecarrowntemple (Mayo)', zip: '268845' },
	{ city: 'Lecarrowntruhaun (Galway)', zip: '152209' },
	{ city: 'Lecarrownwaddy (Mayo)', zip: '122983' },
	{ city: 'Lecarrow South (Clare)', zip: '195409' },
	{ city: 'Lecarrow South (Galway)', zip: '904901' },
	{ city: 'Lecarrow Upper (Clare)', zip: '391872' },
	{ city: 'Lecharrownahone (Cavan)', zip: '431669' },
	{ city: 'Lecharry (Cavan)', zip: '132850' },
	{ city: 'Lechurragh (Longford)', zip: '181466' },
	{ city: 'Leck (Cavan)', zip: '963652' },
	{ city: 'Leck (Monaghan)', zip: '896994' },
	{ city: 'Leckan (Leitrim)', zip: '553706' },
	{ city: 'Leckanarainey (Leitrim)', zip: '242009' },
	{ city: 'Leckaneen (Cork)', zip: '396015' },
	{ city: 'Leckanvy (Mayo)', zip: '411544' },
	{ city: 'Leckaun (Clare)', zip: '989062' },
	{ city: 'Leckaun (Leitrim)', zip: '423271' },
	{ city: 'Leckaun (Waterford)', zip: '100111' },
	{ city: 'Leckbeg (Donegal)', zip: '936740' },
	{ city: 'Leckee (Mayo)', zip: '128142' },
	{ city: 'Leckemy (Donegal)', zip: '747254' },
	{ city: 'Leckenagh (Donegal)', zip: '133262' },
	{ city: 'Lecklasser (Sligo)', zip: '339057' },
	{ city: 'Lecklevera (Monaghan)', zip: '590609' },
	{ city: 'Lecklintown (Dublin)', zip: '234109' },
	{ city: 'Lecknabegga (Galway)', zip: '236312' },
	{ city: 'Lecknagh (Leitrim)', zip: '417973' },
	{ city: 'Lecknavarna (Galway)', zip: '580631' },
	{ city: 'Leckneen (Mayo)', zip: '269037' },
	{ city: 'Lecks (Cavan)', zip: '417221' },
	{ city: 'Lederg (Donegal)', zip: '257612' },
	{ city: 'Ledonigan (Cavan)', zip: '953175' },
	{ city: 'Ledwithstown (Longford)', zip: '418229' },
	{ city: 'Lee (Galway)', zip: '335374' },
	{ city: 'Leean (Leitrim)', zip: '155929' },
	{ city: 'Leedaun (Mayo)', zip: '469202' },
	{ city: 'Leeds (Clare)', zip: '519482' },
	{ city: 'Leeg (Monaghan)', zip: '715054' },
	{ city: 'Leegane (Wexford)', zip: '537481' },
	{ city: 'Leek (Monaghan)', zip: '818861' },
	{ city: 'Leekfield (Sligo)', zip: '790275' },
	{ city: 'Leemount (Cork)', zip: '956426' },
	{ city: 'Leenane (Cork)', zip: '120679' },
	{ city: 'Leenane East (Tipperary)', zip: '434254' },
	{ city: 'Leenane West (Tipperary)', zip: '777051' },
	{ city: 'Leenaun (Galway)', zip: '664450' },
	{ city: 'Leenavesta (Mayo)', zip: '164798' },
	{ city: 'Lefanta (Waterford)', zip: '688758' },
	{ city: 'Lefinn (Donegal)', zip: '249491' },
	{ city: 'Legacurry (Donegal)', zip: '949275' },
	{ city: 'Legacurry (Monaghan)', zip: '130450' },
	{ city: 'Legaginny (Cavan)', zip: '517820' },
	{ city: 'Legagunnia (Meath)', zip: '587945' },
	{ city: 'Legaland (Cavan)', zip: '695926' },
	{ city: 'Legaloscran (Donegal)', zip: '731759' },
	{ city: 'Legalough (Cavan)', zip: '281122' },
	{ city: 'Legaltan (Donegal)', zip: '814797' },
	{ city: 'Legan (Kilkenny)', zip: '399073' },
	{ city: 'Legan (Longford)', zip: '511837' },
	{ city: 'Legan (Mayo)', zip: '310274' },
	{ city: 'Legan (Roscommon)', zip: '707517' },
	{ city: 'Legan (Westmeath)', zip: '446549' },
	{ city: 'Leganamer (Leitrim)', zip: '452920' },
	{ city: 'Legarhill (Monaghan)', zip: '458109' },
	{ city: 'Legatraghta (Cavan)', zip: '501155' },
	{ city: 'Legaun (Laois)', zip: '365524' },
	{ city: 'Legaun (Mayo)', zip: '965740' },
	{ city: 'Legavreagra (Cavan)', zip: '280660' },
	{ city: 'Legaweel (Cavan)', zip: '252021' },
	{ city: 'Legboy (Donegal)', zip: '510121' },
	{ city: 'Legeelan (Cavan)', zip: '101449' },
	{ city: 'Leggagh (Longford)', zip: '996285' },
	{ city: 'Leggagh (Meath)', zip: '658254' },
	{ city: 'Leggandorragh (Donegal)', zip: '220466' },
	{ city: 'Legganhall (Meath)', zip: '569115' },
	{ city: 'Leggatinty (Roscommon)', zip: '947576' },
	{ city: 'Leggetsrath East (Kilkenny)', zip: '730292' },
	{ city: 'Leggetsrath West (Kilkenny)', zip: '584341' },
	{ city: 'Legghimore (Monaghan)', zip: '836928' },
	{ city: 'Legglass (Cavan)', zip: '103893' },
	{ city: 'Leggykelly (Cavan)', zip: '222851' },
	{ city: 'Leghawny (Donegal)', zip: '962961' },
	{ city: 'Legland (Cavan)', zip: '789083' },
	{ city: 'Legland (Donegal)', zip: '196538' },
	{ city: 'Legmuckduff (Donegal)', zip: '700206' },
	{ city: 'Legnabraid (Donegal)', zip: '104313' },
	{ city: 'Legnacreeve (Monaghan)', zip: '629864' },
	{ city: 'Legnaderk (Cavan)', zip: '144190' },
	{ city: 'Legnaduff (Donegal)', zip: '979725' },
	{ city: 'Legnaglogh (Wexford)', zip: '393823' },
	{ city: 'Legnagrow (Cavan)', zip: '729016' },
	{ city: 'Legnahoory (Donegal)', zip: '867835' },
	{ city: 'Legnakelly (Monaghan)', zip: '413541' },
	{ city: 'Legnaneale (Donegal)', zip: '708835' },
	{ city: 'Legnanornoge (Donegal)', zip: '904099' },
	{ city: 'Legnatraw (Donegal)', zip: '773130' },
	{ city: 'Legnawley Glebe (Donegal)', zip: '145799' },
	{ city: 'Legvoy (Roscommon)', zip: '472242' },
	{ city: 'Legwee (Cavan)', zip: '191393' },
	{ city: 'Lehaknock (Clare)', zip: '490849' },
	{ city: 'Lehanagh (Galway)', zip: '395957' },
	{ city: 'Lehanagh (Mayo)', zip: '642157' },
	{ city: 'Lehanagh North (Galway)', zip: '648182' },
	{ city: 'Lehanagh South (Galway)', zip: '631902' },
	{ city: 'Lehardan (Donegal)', zip: '236293' },
	{ city: 'Lehenagh (Cork)', zip: '631180' },
	{ city: 'Lehenagh Beg (Cork)', zip: '986233' },
	{ city: 'Lehenagh More (Cork)', zip: '835899' },
	{ city: 'Lehery (Longford)', zip: '172240' },
	{ city: 'Lehid (Galway)', zip: '904843' },
	{ city: 'Lehid (Kerry)', zip: '160074' },
	{ city: 'Lehinch (Clare)', zip: '891576' },
	{ city: 'Lehinch (Galway)', zip: '791931' },
	{ city: 'Lehinch (Offaly)', zip: '786152' },
	{ city: 'Lehinch (Tipperary)', zip: '295650' },
	{ city: 'Lehinch Demesne (Mayo)', zip: '589931' },
	{ city: 'Lehurick (Galway)', zip: '271695' },
	{ city: 'Leigh (Tipperary)', zip: '442954' },
	{ city: 'Leighcloon (Cork)', zip: '945888' },
	{ city: 'Leighlinbridge (Carlow)', zip: '886653' },
	{ city: 'Leighmoney Beg (Cork)', zip: '631640' },
	{ city: 'Leighmoney More (Cork)', zip: '228257' },
	{ city: 'Leighon Island (Galway)', zip: '775243' },
	{ city: 'Leinsterlodge (Kildare)', zip: '176279' },
	{ city: 'Leiter (Cavan)', zip: '211148' },
	{ city: 'Leiterra (Roscommon)', zip: '550679' },
	{ city: 'Leitra (Cavan)', zip: '639365' },
	{ city: 'Leitra (Clare)', zip: '693789' },
	{ city: 'Leitra (Leitrim)', zip: '456484' },
	{ city: 'Leitra (Offaly)', zip: '138958' },
	{ city: 'Leitrim (Cavan)', zip: '904366' },
	{ city: 'Leitrim (Clare)', zip: '466973' },
	{ city: 'Leitrim (Cork)', zip: '564272' },
	{ city: 'Leitrim (Donegal)', zip: '298686' },
	{ city: 'Leitrim (Leitrim)', zip: '212997' },
	{ city: 'Leitrim (Longford)', zip: '340722' },
	{ city: 'Leitrim (Monaghan)', zip: '663983' },
	{ city: 'Leitrim (Offaly)', zip: '456299' },
	{ city: 'Leitrim (Roscommon)', zip: '444877' },
	{ city: 'Leitrim (Wicklow)', zip: '493004' },
	{ city: 'Leitrim Beg (Cork)', zip: '245098' },
	{ city: 'Leitrim Beg (Galway)', zip: '691665' },
	{ city: 'Leitrim East (Kerry)', zip: '588027' },
	{ city: 'Leitrim Lower (Leitrim)', zip: '377775' },
	{ city: 'Leitrim Lower (Meath)', zip: '756262' },
	{ city: 'Leitrim Middle (Kerry)', zip: '237967' },
	{ city: 'Leitrim More (Cork)', zip: '645647' },
	{ city: 'Leitrim More (Galway)', zip: '510325' },
	{ city: 'Leitrim North (Sligo)', zip: '531123' },
	{ city: 'Leitrim South (Sligo)', zip: '598301' },
	{ city: 'Leitrim Upper (Leitrim)', zip: '590916' },
	{ city: 'Leitrim Upper (Meath)', zip: '222375' },
	{ city: 'Leitrim West (Kerry)', zip: '775663' },
	{ city: 'Leitry Lower (Cork)', zip: '732797' },
	{ city: 'Leitry Upper (Cork)', zip: '146955' },
	{ city: 'Leixlip (Kildare)', zip: '282145' },
	{ city: 'Leixlip Demesne (Kildare)', zip: '303266' },
	{ city: 'Lelagh (Tipperary)', zip: '297328' },
	{ city: 'Lemanaghan (Offaly)', zip: '988386' },
	{ city: 'Lemgare (Monaghan)', zip: '839416' },
	{ city: 'Lemnaheltia (Galway)', zip: '497150' },
	{ city: 'Lemonfield (Galway)', zip: '687704' },
	{ city: 'Lemonfield (Limerick)', zip: '256165' },
	{ city: 'Lemonstown (Kilkenny)', zip: '679058' },
	{ city: 'Lemonstown (Wicklow)', zip: '833198' },
	{ city: 'Lemybrien (Waterford)', zip: '568079' },
	{ city: 'Lenabower (Galway)', zip: '656135' },
	{ city: 'Lenaboy (Galway)', zip: '867813' },
	{ city: 'Lenaboy (Longford)', zip: '920168' },
	{ city: 'Lenacraigaboy (Mayo)', zip: '164951' },
	{ city: 'Lenadoon (Sligo)', zip: '673768' },
	{ city: 'Lenafin (Galway)', zip: '840952' },
	{ city: 'Lenagh (Monaghan)', zip: '967511' },
	{ city: 'Lenagorra (Kildare)', zip: '695671' },
	{ city: 'Lenalea (Donegal)', zip: '582283' },
	{ city: 'Lenaloughra (Galway)', zip: '126124' },
	{ city: 'Lenamarran (Offaly)', zip: '621984' },
	{ city: 'Lenamore (Galway)', zip: '424266' },
	{ city: 'Lenamore (Mayo)', zip: '615184' },
	{ city: 'Lenamore (Westmeath)', zip: '264878' },
	{ city: 'Lenan (Donegal)', zip: '156548' },
	{ city: 'Lenanaboll (Mayo)', zip: '459682' },
	{ city: 'Lenanadurtaun (Mayo)', zip: '722374' },
	{ city: 'Lenanamalla (Roscommon)', zip: '193652' },
	{ city: 'Lenanasillagh (Mayo)', zip: '868381' },
	{ city: 'Lenanavea (Mayo)', zip: '618326' },
	{ city: 'Lenanavragh (Cavan)', zip: '586230' },
	{ city: 'Lenanmarla (Galway)', zip: '469213' },
	{ city: 'Lenareagh (Galway)', zip: '771834' },
	{ city: 'Lenarevagh (Galway)', zip: '665390' },
	{ city: 'Lenarevagh (Mayo)', zip: '504775' },
	{ city: 'Lennaght (Kilkenny)', zip: '341257' },
	{ city: 'Lennaght (Monaghan)', zip: '967641' },
	{ city: 'Lennan (Monaghan)', zip: '749806' },
	{ city: 'Leny (Westmeath)', zip: '250989' },
	{ city: 'Leo (Mayo)', zip: '621576' },
	{ city: 'Leoh (Wicklow)', zip: '579270' },
	{ city: 'Leonagh (Leitrim)', zip: '849810' },
	{ city: 'Leonards Island (Monaghan)', zip: '517480' },
	{ city: 'Leonardstown (Meath)', zip: '718891' },
	{ city: 'Leons Beg (Monaghan)', zip: '929921' },
	{ city: 'Leonsgarve (Monaghan)', zip: '952024' },
	{ city: 'Leperstown (Waterford)', zip: '769352' },
	{ city: 'Lergadaghtan (Donegal)', zip: '689753' },
	{ city: 'Lergadaghtan Mountain (Donegal)', zip: '364168' },
	{ city: 'Lerginacarha (Donegal)', zip: '934616' },
	{ city: 'Lergynasearhagh (Donegal)', zip: '857235' },
	{ city: 'Lerhin (Galway)', zip: '297283' },
	{ city: 'Lerrig North (Kerry)', zip: '230126' },
	{ city: 'Lerrig South (Kerry)', zip: '214034' },
	{ city: 'Leshemstown (Meath)', zip: '273702' },
	{ city: 'Lessanny (Mayo)', zip: '400973' },
	{ city: 'Letachmentgallon (Meath)', zip: '763087' },
	{ city: 'Letfordspark (Roscommon)', zip: '148378' },
	{ city: 'Letgonnelly (Monaghan)', zip: '741227' },
	{ city: 'Letloonigan (Monaghan)', zip: '788732' },
	{ city: 'Letter (Cork)', zip: '976143' },
	{ city: 'Letter (Donegal)', zip: '999291' },
	{ city: 'Letter (Galway)', zip: '505629' },
	{ city: 'Letter (Kerry)', zip: '803765' },
	{ city: 'Letter (Leitrim)', zip: '106128' },
	{ city: 'Letter (Mayo)', zip: '784089' },
	{ city: 'Letter (Offaly)', zip: '363279' },
	{ city: 'Lettera (Galway)', zip: '518320' },
	{ city: 'Lettera (Mayo)', zip: '536194' },
	{ city: 'Letteragh (Clare)', zip: '656019' },
	{ city: 'Letteragh (Monaghan)', zip: '725715' },
	{ city: 'Letterard (Galway)', zip: '690919' },
	{ city: 'Letterass (Mayo)', zip: '439887' },
	{ city: 'Letterbane (Monaghan)', zip: '617613' },
	{ city: 'Letterbarra (Donegal)', zip: '120390' },
	{ city: 'Letterbeg (Mayo)', zip: '397826' },
	{ city: 'Letter Beg (Galway)', zip: '222167' },
	{ city: 'Letterbreckaun (Galway)', zip: '210576' },
	{ city: 'Letterbrick (Donegal)', zip: '641489' },
	{ city: 'Letterbrick (Mayo)', zip: '485795' },
	{ city: 'Letterbrickaun (Galway)', zip: '338219' },
	{ city: 'Letterbrock (Mayo)', zip: '442291' },
	{ city: 'Letterbrone (Sligo)', zip: '544377' },
	{ city: 'Lettercallow (Galway)', zip: '362492' },
	{ city: 'Lettercannon (Kerry)', zip: '231739' },
	{ city: 'Lettercau (Donegal)', zip: '339456' },
	{ city: 'Lettercaumus (Galway)', zip: '175809' },
	{ city: 'Lettercollum (Cork)', zip: '975527' },
	{ city: 'Lettercraff (Galway)', zip: '513138' },
	{ city: 'Lettercraffroe (Galway)', zip: '369347' },
	{ city: 'Lettercran (Donegal)', zip: '285378' },
	{ city: 'Letterdeen (Galway)', zip: '820940' },
	{ city: 'Letterdeskert (Galway)', zip: '908961' },
	{ city: 'Letterdife (Galway)', zip: '228172' },
	{ city: 'Letterdunane (Kerry)', zip: '746252' },
	{ city: 'Letter East (Cork)', zip: '973441' },
	{ city: 'Letter East (Kerry)', zip: '557146' },
	{ city: 'Lettereeneen (Mayo)', zip: '354423' },
	{ city: 'Lettereeragh (Mayo)', zip: '906426' },
	{ city: 'Letterettrin (Galway)', zip: '420984' },
	{ city: 'Letterfad (Donegal)', zip: '815363' },
	{ city: 'Letterfine (Leitrim)', zip: '884054' },
	{ city: 'Letterfinish (Kerry)', zip: '182815' },
	{ city: 'Letterfir (Galway)', zip: '893407' },
	{ city: 'Letterfore (Galway)', zip: '110127' },
	{ city: 'Letterfrack (Galway)', zip: '809183' },
	{ city: 'Lettergarriv (Kerry)', zip: '800219' },
	{ city: 'Lettergeeragh (Longford)', zip: '671453' },
	{ city: 'Lettergesh East (Galway)', zip: '977601' },
	{ city: 'Lettergesh West (Galway)', zip: '568529' },
	{ city: 'Lettergonnell (Longford)', zip: '434914' },
	{ city: 'Lettergorman (Cork)', zip: '819085' },
	{ city: 'Lettergull (Donegal)', zip: '693863' },
	{ city: 'Lettergullion (Longford)', zip: '646397' },
	{ city: 'Lettergunnet (Galway)', zip: '513586' },
	{ city: 'Letterilly (Donegal)', zip: '125313' },
	{ city: 'Letterkeeghaun (Galway)', zip: '567051' },
	{ city: 'Letterkeeghaun (Mayo)', zip: '663189' },
	{ city: 'Letterkeen (Mayo)', zip: '920946' },
	{ city: 'Letterkelly (Clare)', zip: '536813' },
	{ city: 'Letterkenny (Donegal)', zip: '348303' },
	{ city: 'Letterleague (Donegal)', zip: '669040' },
	{ city: 'Letterlicky East (Cork)', zip: '944890' },
	{ city: 'Letterlicky Middle (Cork)', zip: '189339' },
	{ city: 'Letterlicky West (Cork)', zip: '274583' },
	{ city: 'Letterlough (Mayo)', zip: '396979' },
	{ city: 'Letter Lower (Cork)', zip: '137100' },
	{ city: 'Letter Lower (Kerry)', zip: '435907' },
	{ city: 'Lettermacaward (Donegal)', zip: '603269' },
	{ city: 'Lettermaghera North (Mayo)', zip: '847795' },
	{ city: 'Lettermaghera South (Mayo)', zip: '903598' },
	{ city: 'Lettermaglinskin (Mayo)', zip: '987534' },
	{ city: 'Lettermakenny (Donegal)', zip: '805288' },
	{ city: 'Lettermas (Galway)', zip: '713924' },
	{ city: 'Lettermoneel (Kerry)', zip: '260640' },
	{ city: 'Lettermore (Cavan)', zip: '504339' },
	{ city: 'Lettermore (Donegal)', zip: '246334' },
	{ city: 'Lettermore (Galway)', zip: '824066' },
	{ city: 'Letter More (Galway)', zip: '892121' },
	{ city: 'Letter-Mountain (Cork)', zip: '801868' },
	{ city: 'Lettermuckoo (Galway)', zip: '847506' },
	{ city: 'Lettermullan (Galway)', zip: '382254' },
	{ city: 'Letternacahy (Donegal)', zip: '633460' },
	{ city: 'Letternadarriv (Kerry)', zip: '348484' },
	{ city: 'Letterneevoge (Mayo)', zip: '927164' },
	{ city: 'Letternoosh (Galway)', zip: '450311' },
	{ city: 'Letterpeak (Galway)', zip: '191642' },
	{ city: 'Letterpibrum (Galway)', zip: '517015' },
	{ city: 'Letterscanlan (Cork)', zip: '154732' },
	{ city: 'Lettershanbally (Galway)', zip: '513639' },
	{ city: 'Lettershanbo (Donegal)', zip: '840754' },
	{ city: 'Lettershanna (Galway)', zip: '168982' },
	{ city: 'Lettershea (Galway)', zip: '756051' },
	{ city: 'Lettershinna (Galway)', zip: '400240' },
	{ city: 'Lettertinlish (Cork)', zip: '148555' },
	{ city: 'Lettertrask (Mayo)', zip: '789763' },
	{ city: 'Lettertreane (Donegal)', zip: '322576' },
	{ city: 'Letterunshin (Sligo)', zip: '443641' },
	{ city: 'Letter Upper (Kerry)', zip: '185873' },
	{ city: 'Letter West (Cork)', zip: '715704' },
	{ city: 'Letter West (Kerry)', zip: '816356' },
	{ city: 'Lettery (Galway)', zip: '467557' },
	{ city: 'Lettreen (Roscommon)', zip: '572674' },
	{ city: 'Lettybrook (Offaly)', zip: '332600' },
	{ city: 'Leugh (Kilkenny)', zip: '139511' },
	{ city: 'Leugh (Tipperary)', zip: '100950' },
	{ city: 'Levallinree (Mayo)', zip: '748606' },
	{ city: 'Levally (Galway)', zip: '596716' },
	{ city: 'Levally (Laois)', zip: '406754' },
	{ city: 'Levally (Mayo)', zip: '928603' },
	{ city: 'Levally East (Galway)', zip: '481175' },
	{ city: 'Levallyroe (Mayo)', zip: '392263' },
	{ city: 'Levally West (Galway)', zip: '645573' },
	{ city: 'Leveelick (Mayo)', zip: '343215' },
	{ city: 'Leveelick (Roscommon)', zip: '413776' },
	{ city: 'Levern (Wicklow)', zip: '667468' },
	{ city: 'Levitstown (Kildare)', zip: '788398' },
	{ city: 'Levitstown (Wexford)', zip: '189558' },
	{ city: 'Lewagh Beg (Tipperary)', zip: '184930' },
	{ city: 'Lewagh More (Tipperary)', zip: '424522' },
	{ city: 'Lewellensland (Meath)', zip: '488712' },
	{ city: 'Lewistown (Kildare)', zip: '117423' },
	{ city: 'Lewistown (Wexford)', zip: '520147' },
	{ city: 'Liafin (Donegal)', zip: '424773' },
	{ city: 'Liberties Of Carlingford (Louth)', zip: '430500' },
	{ city: 'Liberty (Roscommon)', zip: '344691' },
	{ city: 'Libgate (Wexford)', zip: '323371' },
	{ city: 'Lickadoon (Limerick)', zip: '838758' },
	{ city: 'Lickane (Cork)', zip: '984206' },
	{ city: 'Lickbarrahane (Cork)', zip: '723417' },
	{ city: 'Lickbla (Westmeath)', zip: '854540' },
	{ city: 'Lickeen (Kerry)', zip: '443694' },
	{ city: 'Lickeen (Wicklow)', zip: '527415' },
	{ city: 'Lickeen East (Clare)', zip: '259634' },
	{ city: 'Lickeen East (Cork)', zip: '389425' },
	{ city: 'Lickeen West (Clare)', zip: '113442' },
	{ city: 'Lickeen West (Cork)', zip: '207810' },
	{ city: 'Lickerrig (Galway)', zip: '336406' },
	{ city: 'Licketstown (Kilkenny)', zip: '642134' },
	{ city: 'Lickfinn (Tipperary)', zip: '824523' },
	{ city: 'Licklash (Cork)', zip: '456104' },
	{ city: 'Lickmolassy (Galway)', zip: '729124' },
	{ city: 'Licknaun (Clare)', zip: '972738' },
	{ city: 'Licknavar (Cork)', zip: '686537' },
	{ city: 'Lickny (Westmeath)', zip: '554199' },
	{ city: 'Lickoran (Waterford)', zip: '937962' },
	{ city: 'Lickoranmountain (Waterford)', zip: '375485' },
	{ city: 'Lickowen (Cork)', zip: '540651' },
	{ city: 'Liffane (Limerick)', zip: '653406' },
	{ city: 'Lifford (Clare)', zip: '400100' },
	{ city: 'Lifford (Donegal)', zip: '923278' },
	{ city: 'Lifford Bog (Donegal)', zip: '113516' },
	{ city: 'Lifford Common (Donegal)', zip: '835889' },
	{ city: 'Lightfield (Longford)', zip: '632287' },
	{ city: 'Lightford (Mayo)', zip: '871704' },
	{ city: 'Lighthouse Lot (Donegal)', zip: '842533' },
	{ city: 'Lillybrook (Sligo)', zip: '476182' },
	{ city: 'Limehill (Galway)', zip: '796834' },
	{ city: 'Limekilnclose (Cork)', zip: '243718' },
	{ city: 'Limekilnclose (Waterford)', zip: '968365' },
	{ city: 'Limekilnfarm (Dublin)', zip: '261670' },
	{ city: 'Limekilnhill (Meath)', zip: '670349' },
	{ city: 'Limepark North (Galway)', zip: '273746' },
	{ city: 'Limepark South (Galway)', zip: '415920' },
	{ city: 'Limerick (Limerick)', zip: '639090' },
	{ city: 'Limerick (Wexford)', zip: '604169' },
	{ city: 'Limerick Junction (Tipperary)', zip: '407243' },
	{ city: 'Limnagh (Sligo)', zip: '766909' },
	{ city: "Lindsay's Farm (Galway)", zip: '932282' },
	{ city: 'Linfield (Limerick)', zip: '298759' },
	{ city: 'Lingstown Lower (Wexford)', zip: '249115' },
	{ city: 'Lingstown Upper (Wexford)', zip: '335006' },
	{ city: 'Linkardstown (Carlow)', zip: '532295' },
	{ city: 'Linnanagh (Wexford)', zip: '273243' },
	{ city: 'Linns (Louth)', zip: '784025' },
	{ city: 'Linsfort (Donegal)', zip: '754122' },
	{ city: 'Lintaun (Kilkenny)', zip: '631752' },
	{ city: 'Linziestown (Wexford)', zip: '774929' },
	{ city: 'Lionsden (Meath)', zip: '273301' },
	{ city: 'Lippa (Galway)', zip: '428558' },
	{ city: 'Lipstown (Kildare)', zip: '754143' },
	{ city: 'Lipstown Lower (Kildare)', zip: '447066' },
	{ city: 'Lipstown Upper (Kildare)', zip: '776140' },
	{ city: 'Lisabuck (Monaghan)', zip: '444960' },
	{ city: 'Lisachunny (Cavan)', zip: '201047' },
	{ city: 'Lisacoghil (Leitrim)', zip: '898344' },
	{ city: 'Lisacul (Roscommon)', zip: '389381' },
	{ city: 'Lisacullion (Monaghan)', zip: '841656' },
	{ city: 'Lisaderg (Cavan)', zip: '133562' },
	{ city: 'Lisadlooey (Leitrim)', zip: '494473' },
	{ city: 'Lisaginny (Monaghan)', zip: '647513' },
	{ city: 'Lisagoan (Cavan)', zip: '860529' },
	{ city: 'Lisagore (Monaghan)', zip: '385989' },
	{ city: 'Lisalea (Monaghan)', zip: '888705' },
	{ city: 'Lisanalsk (Cavan)', zip: '968098' },
	{ city: 'Lisanisk (Monaghan)', zip: '155085' },
	{ city: 'Lisanisky (Cavan)', zip: '114477' },
	{ city: 'Lisanny (Cavan)', zip: '896673' },
	{ city: 'Lisaquill (Longford)', zip: '812297' },
	{ city: 'Lisaquill (Monaghan)', zip: '104925' },
	{ city: 'Lisard (Waterford)', zip: '509396' },
	{ city: 'Lisarearke (Monaghan)', zip: '596936' },
	{ city: 'Lisarney (Cavan)', zip: '726460' },
	{ city: 'Lisarrilly (Monaghan)', zip: '398539' },
	{ city: 'Lisasturrin (Cavan)', zip: '589507' },
	{ city: 'Lisataggart (Cavan)', zip: '831306' },
	{ city: 'Lisatawan (Cavan)', zip: '970861' },
	{ city: 'Lisatillister (Monaghan)', zip: '200296' },
	{ city: 'Lisatoo (Cavan)', zip: '700814' },
	{ city: 'Lisavaddy (Donegal)', zip: '739892' },
	{ city: 'Lisavargy (Monaghan)', zip: '173857' },
	{ city: 'Lisawaum (Cavan)', zip: '258146' },
	{ city: 'Lisbabe (Kerry)', zip: '136850' },
	{ city: 'Lisbaleely (Sligo)', zip: '966580' },
	{ city: 'Lisball (Cavan)', zip: '796063' },
	{ city: 'Lisballyard (Tipperary)', zip: '213165' },
	{ city: 'Lisballyfroot (Kilkenny)', zip: '170160' },
	{ city: 'Lisballyhay (Cork)', zip: '891128' },
	{ city: 'Lisbalting (Tipperary)', zip: '213129' },
	{ city: 'Lisbanagher (Sligo)', zip: '992617' },
	{ city: 'Lisbane (Kerry)', zip: '556496' },
	{ city: 'Lisbane (Limerick)', zip: '819743' },
	{ city: 'Lisbane (Monaghan)', zip: '879050' },
	{ city: 'Lisbarreen (Clare)', zip: '969183' },
	{ city: 'Lisbaun (Mayo)', zip: '647526' },
	{ city: 'Lisbaun (Roscommon)', zip: '295982' },
	{ city: 'Lisbaun East (Mayo)', zip: '824664' },
	{ city: 'Lisbaun West (Mayo)', zip: '149199' },
	{ city: 'Lisbealad East (Cork)', zip: '871209' },
	{ city: 'Lisbealad West (Cork)', zip: '465114' },
	{ city: 'Lisbeg (Galway)', zip: '489261' },
	{ city: 'Lisbehegh (Cork)', zip: '874825' },
	{ city: 'Lisbiggeen (Clare)', zip: '510239' },
	{ city: 'Lisbigney (Laois)', zip: '394422' },
	{ city: 'Lisblowick (Mayo)', zip: '221520' },
	{ city: 'Lisboduff (Cavan)', zip: '722700' },
	{ city: 'Lisbook (Tipperary)', zip: '842080' },
	{ city: 'Lisboy (Meath)', zip: '712138' },
	{ city: 'Lisboy (Monaghan)', zip: '788049' },
	{ city: 'Lisboy (Roscommon)', zip: '105409' },
	{ city: 'Lisboy Beg (Cork)', zip: '783474' },
	{ city: 'Lisboy More (Cork)', zip: '836258' },
	{ city: 'Lisbrack (Longford)', zip: '872738' },
	{ city: 'Lisbrannan (Monaghan)', zip: '342780' },
	{ city: 'Lisbree (Cavan)', zip: '710273' },
	{ city: 'Lisbride (Roscommon)', zip: '787158' },
	{ city: 'Lisbrien (Tipperary)', zip: '952052' },
	{ city: 'Lisbrin (Mayo)', zip: '809107' },
	{ city: 'Lisbrine (Galway)', zip: '809905' },
	{ city: 'Lisbrockan (Leitrim)', zip: '577625' },
	{ city: 'Lisbrogan (Mayo)', zip: '110081' },
	{ city: 'Lisbryan (Tipperary)', zip: '876030' },
	{ city: 'Lisbunny (Tipperary)', zip: '881173' },
	{ city: 'Lisbush (Kildare)', zip: '743948' },
	{ city: 'Liscahane (Cork)', zip: '601772' },
	{ city: 'Liscahane (Kerry)', zip: '988105' },
	{ city: 'Liscahane Beg (Cork)', zip: '947977' },
	{ city: 'Liscahane More (Cork)', zip: '903337' },
	{ city: 'Liscahill (Longford)', zip: '139802' },
	{ city: 'Liscahill (Tipperary)', zip: '413543' },
	{ city: 'Liscallyroan (Leitrim)', zip: '741329' },
	{ city: 'Liscam (Roscommon)', zip: '248071' },
	{ city: 'Liscananaun (Galway)', zip: '282038' },
	{ city: 'Liscannor (Clare)', zip: '198877' },
	{ city: 'Liscappul (Galway)', zip: '115114' },
	{ city: 'Liscarban (Leitrim)', zip: '994310' },
	{ city: 'Liscarnan (Monaghan)', zip: '924484' },
	{ city: 'Liscarney (Kerry)', zip: '444639' },
	{ city: 'Liscarney (Mayo)', zip: '532788' },
	{ city: 'Liscarney (Monaghan)', zip: '169718' },
	{ city: 'Liscarrigane (Cork)', zip: '788145' },
	{ city: 'Liscarroll (Cork)', zip: '268951' },
	{ city: 'Liscartan (Meath)', zip: '205263' },
	{ city: 'Liscasey (Clare)', zip: '725657' },
	{ city: 'Liscat (Mayo)', zip: '803452' },
	{ city: 'Liscat (Monaghan)', zip: '766315' },
	{ city: 'Lisclamerty (Donegal)', zip: '690280' },
	{ city: 'Lisclogher (Cavan)', zip: '706246' },
	{ city: 'Lisclogher Great (Westmeath)', zip: '603911' },
	{ city: 'Lisclogher Little (Westmeath)', zip: '827798' },
	{ city: 'Lisclone (Cavan)', zip: '465741' },
	{ city: 'Liscloonadea (Leitrim)', zip: '274224' },
	{ city: 'Lisclooney (Offaly)', zip: '480816' },
	{ city: 'Liscloonmeeltoge (Galway)', zip: '362880' },
	{ city: 'Lisclovaun (Mayo)', zip: '607934' },
	{ city: 'Liscluman (Mayo)', zip: '163981' },
	{ city: 'Liscoffy (Roscommon)', zip: '561902' },
	{ city: 'Liscolman (Wicklow)', zip: '659793' },
	{ city: 'Liscolvan (Roscommon)', zip: '666944' },
	{ city: 'Lisconduff (Monaghan)', zip: '321016' },
	{ city: 'Liscongill (Cork)', zip: '481829' },
	{ city: 'Lisconly (Galway)', zip: '751881' },
	{ city: 'Lisconny (Sligo)', zip: '720964' },
	{ city: 'Lisconor (Clare)', zip: '938822' },
	{ city: 'Lisconor (Leitrim)', zip: '985528' },
	{ city: 'Lisconwy (Sligo)', zip: '403729' },
	{ city: 'Liscooly (Donegal)', zip: '385394' },
	{ city: 'Liscoonera (Clare)', zip: '576572' },
	{ city: 'Liscormick (Clare)', zip: '233892' },
	{ city: 'Liscormick (Longford)', zip: '798161' },
	{ city: 'Liscorran (Monaghan)', zip: '490613' },
	{ city: 'Liscorry (Louth)', zip: '203237' },
	{ city: 'Liscosker (Mayo)', zip: '237779' },
	{ city: 'Liscottle (Mayo)', zip: '831666' },
	{ city: 'Liscoyle (Galway)', zip: '226896' },
	{ city: 'Liscreagh (Cork)', zip: '999147' },
	{ city: 'Liscreagh (Limerick)', zip: '239178' },
	{ city: 'Liscreagh (Tipperary)', zip: '121307' },
	{ city: 'Liscromwell (Mayo)', zip: '677032' },
	{ city: 'Liscubba (Cork)', zip: '526470' },
	{ city: 'Liscuilfea (Leitrim)', zip: '758162' },
	{ city: 'Liscuill (Galway)', zip: '925021' },
	{ city: 'Liscuillew Lower (Leitrim)', zip: '479303' },
	{ city: 'Liscuillew Upper (Leitrim)', zip: '834184' },
	{ city: 'Liscullane (Cork)', zip: '436000' },
	{ city: 'Liscullane (Kerry)', zip: '105694' },
	{ city: 'Liscullaun (Clare)', zip: '710305' },
	{ city: 'Liscumasky (Monaghan)', zip: '697008' },
	{ city: 'Liscune Lower (Galway)', zip: '114396' },
	{ city: 'Liscune Upper (Galway)', zip: '601899' },
	{ city: 'Liscunnell (Mayo)', zip: '140342' },
	{ city: 'Lisdachon (Westmeath)', zip: '209346' },
	{ city: 'Lisdadanan (Leitrim)', zip: '746470' },
	{ city: 'Lisdalleen And Drummin (Tipperary)', zip: '416927' },
	{ city: 'Lisdaly (Offaly)', zip: '321709' },
	{ city: 'Lisdaly (Roscommon)', zip: '103978' },
	{ city: 'Lisdangan (Cork)', zip: '485175' },
	{ city: 'Lisdaran (Cavan)', zip: '758913' },
	{ city: 'Lisdargan (Kerry)', zip: '668978' },
	{ city: 'Lisdarragh (Monaghan)', zip: '417797' },
	{ city: 'Lisdarush (Leitrim)', zip: '566790' },
	{ city: 'Lisdauky (Leitrim)', zip: '188082' },
	{ city: 'Lisdaulan (Roscommon)', zip: '519905' },
	{ city: 'Lisdavuck (Offaly)', zip: '323899' },
	{ city: 'Lisdeegin (Cavan)', zip: '390933' },
	{ city: 'Lisdeen (Clare)', zip: '370928' },
	{ city: 'Lisdeligny (Galway)', zip: '226048' },
	{ city: 'Lisdermot (Offaly)', zip: '433950' },
	{ city: 'Lisdillure (Roscommon)', zip: '985833' },
	{ city: 'Lisdoagh (Cavan)', zip: '341377' },
	{ city: 'Lisdonagh (Galway)', zip: '507262' },
	{ city: 'Lisdonan (Cavan)', zip: '939097' },
	{ city: 'Lisdonnellroe (Galway)', zip: '201588' },
	{ city: 'Lisdonnish (Cavan)', zip: '948909' },
	{ city: 'Lisdonny (Monaghan)', zip: '827720' },
	{ city: 'Lisdonowley (Tipperary)', zip: '262131' },
	{ city: 'Lisdoo (Louth)', zip: '856872' },
	{ city: 'Lisdooaun (Galway)', zip: '422374' },
	{ city: 'Lisdoogan (Sligo)', zip: '960079' },
	{ city: 'Lisdoonan (Monaghan)', zip: '134752' },
	{ city: 'Lisdoonvarna (Clare)', zip: '312163' },
	{ city: 'Lisdoony East (Clare)', zip: '546005' },
	{ city: 'Lisdoony West (Clare)', zip: '127349' },
	{ city: 'Lisdoran (Galway)', zip: '229418' },
	{ city: 'Lisdornan (Meath)', zip: '295630' },
	{ city: 'Lisdossan (Westmeath)', zip: '592545' },
	{ city: 'Lisdowney (Kilkenny)', zip: '779614' },
	{ city: 'Lisdreenagh (Longford)', zip: '984778' },
	{ city: 'Lisdromacrone (Leitrim)', zip: '652744' },
	{ city: 'Lisdromafarna (Leitrim)', zip: '290091' },
	{ city: 'Lisdromarea North (Leitrim)', zip: '580361' },
	{ city: 'Lisdromarea South (Leitrim)', zip: '105756' },
	{ city: 'Lisdrumcleve (Monaghan)', zip: '727060' },
	{ city: 'Lisdrumdoagh (Monaghan)', zip: '207587' },
	{ city: 'Lisdrumfad (Cavan)', zip: '614743' },
	{ city: 'Lisdrumgivel Lower (Leitrim)', zip: '546686' },
	{ city: 'Lisdrumgivel Upper (Leitrim)', zip: '147449' },
	{ city: 'Lisdrumgormly (Monaghan)', zip: '272474' },
	{ city: 'Lisdrumgran (Leitrim)', zip: '817169' },
	{ city: 'Lisdrumneill (Roscommon)', zip: '969294' },
	{ city: 'Lisdrumskea (Cavan)', zip: '362851' },
	{ city: 'Lisdrumturk (Monaghan)', zip: '109713' },
	{ city: 'Lisduane (Limerick)', zip: '237502' },
	{ city: 'Lisduff (Cavan)', zip: '821998' },
	{ city: 'Lisduff (Clare)', zip: '347675' },
	{ city: 'Lisduff (Cork)', zip: '953885' },
	{ city: 'Lisduff (Galway)', zip: '906736' },
	{ city: 'Lisduff (Kerry)', zip: '543126' },
	{ city: 'Lisduff (Kilkenny)', zip: '675602' },
	{ city: 'Lisduff (Laois)', zip: '670114' },
	{ city: 'Lisduff (Leitrim)', zip: '581874' },
	{ city: 'Lisduff (Limerick)', zip: '719542' },
	{ city: 'Lisduff (Longford)', zip: '927681' },
	{ city: 'Lisduff (Mayo)', zip: '714923' },
	{ city: 'Lisduff (Monaghan)', zip: '198938' },
	{ city: 'Lisduff (Offaly)', zip: '134584' },
	{ city: 'Lisduff (Roscommon)', zip: '958812' },
	{ city: 'Lisduff (Sligo)', zip: '520874' },
	{ city: 'Lisduff (Tipperary)', zip: '170247' },
	{ city: 'Lisduff (Westmeath)', zip: '544403' },
	{ city: 'Lisduff South (Galway)', zip: '729252' },
	{ city: 'Lisduggan (Waterford)', zip: '551006' },
	{ city: 'Lisduggan North (Cork)', zip: '604048' },
	{ city: 'Lisduggan South (Cork)', zip: '143768' },
	{ city: 'Lisduneen (Galway)', zip: '657502' },
	{ city: 'Lisdunvis Glebe (Cavan)', zip: '303571' },
	{ city: 'Lisdurra (Galway)', zip: '248916' },
	{ city: 'Lisdurraun (Mayo)', zip: '341563' },
	{ city: 'Lisduvoge (Mayo)', zip: '669314' },
	{ city: 'Liseenan (Monaghan)', zip: '579977' },
	{ city: 'Liseggerton (Monaghan)', zip: '680499' },
	{ city: 'Lisegny (Cavan)', zip: '239212' },
	{ city: 'Lisfannan (Donegal)', zip: '983538' },
	{ city: 'Lisfarrell (Longford)', zip: '471285' },
	{ city: 'Lisfarrellboy (Roscommon)', zip: '107058' },
	{ city: 'Lisfehill (Cork)', zip: '674268' },
	{ city: 'Lisfelim (Roscommon)', zip: '302718' },
	{ city: 'Lisfennel (Waterford)', zip: '811904' },
	{ city: 'Lisfinny (Galway)', zip: '410481' },
	{ city: 'Lisfinny (Waterford)', zip: '134450' },
	{ city: 'Lisfuiltaghan (Leitrim)', zip: '911919' },
	{ city: 'Lisfunshion (Tipperary)', zip: '937658' },
	{ city: 'Lisgall (Monaghan)', zip: '189044' },
	{ city: 'Lisgannon (Cavan)', zip: '989793' },
	{ city: 'Lisgar (Cavan)', zip: '591740' },
	{ city: 'Lisgar (Galway)', zip: '149040' },
	{ city: 'Lisgarney (Leitrim)', zip: '424640' },
	{ city: 'Lisgarode (Tipperary)', zip: '570027' },
	{ city: 'Lisgarriff (Tipperary)', zip: '520566' },
	{ city: 'Lisgarriff East (Tipperary)', zip: '400890' },
	{ city: 'Lisgarriff West (Tipperary)', zip: '144066' },
	{ city: 'Lisgarvan (Carlow)', zip: '112741' },
	{ city: 'Lisgarve (Roscommon)', zip: '361206' },
	{ city: 'Lisgaugh (Limerick)', zip: '782316' },
	{ city: 'Lisgavneen (Leitrim)', zip: '687769' },
	{ city: 'Lisgibbon (Tipperary)', zip: '197330' },
	{ city: 'Lisgillalea (Roscommon)', zip: '493803' },
	{ city: 'Lisgillan (Monaghan)', zip: '150938' },
	{ city: 'Lisgillock Glebe (Leitrim)', zip: '494090' },
	{ city: 'Lisglasheen (Cork)', zip: '301758' },
	{ city: 'Lisglass (Waterford)', zip: '248376' },
	{ city: 'Lisglassan (Monaghan)', zip: '529549' },
	{ city: 'Lisglassock (Longford)', zip: '195972' },
	{ city: 'Lisglenbeha (Tipperary)', zip: '296346' },
	{ city: 'Lisglennon (Mayo)', zip: '365819' },
	{ city: 'Lisgoagh (Monaghan)', zip: '373422' },
	{ city: 'Lisgobban (Roscommon)', zip: '304068' },
	{ city: 'Lisgoogan (Clare)', zip: '334638' },
	{ city: 'Lisgool (Leitrim)', zip: '571430' },
	{ city: 'Lisgoold (Cork)', zip: '423251' },
	{ city: 'Lisgoold East (Cork)', zip: '983820' },
	{ city: 'Lisgoold North (Cork)', zip: '697208' },
	{ city: 'Lisgoold West (Cork)', zip: '462939' },
	{ city: 'Lisgordan (Limerick)', zip: '540099' },
	{ city: 'Lisgorey (Sligo)', zip: '630831' },
	{ city: 'Lisgorman (Leitrim)', zip: '640154' },
	{ city: 'Lisgormin (Mayo)', zip: '939634' },
	{ city: 'Lisgorran (Monaghan)', zip: '697473' },
	{ city: 'Lisgowel (Mayo)', zip: '552726' },
	{ city: 'Lisgrea (Cavan)', zip: '630602' },
	{ city: 'Lisgreaghan (Roscommon)', zip: '273115' },
	{ city: 'Lisgrew (Monaghan)', zip: '604608' },
	{ city: 'Lisgriffin (Cork)', zip: '337108' },
	{ city: 'Lisgriffin (Waterford)', zip: '366612' },
	{ city: 'Lisgruddy (Leitrim)', zip: '606100' },
	{ city: 'Lisgub (Galway)', zip: '145078' },
	{ city: 'Lisgub East (Galway)', zip: '564965' },
	{ city: 'Lisgub West (Galway)', zip: '246068' },
	{ city: 'Lisgullaun (Sligo)', zip: '395290' },
	{ city: 'Lisgurreen (Clare)', zip: '554105' },
	{ city: 'Lisgurry (Longford)', zip: '291353' },
	{ city: 'Lisheen (Clare)', zip: '447524' },
	{ city: 'Lisheen (Cork)', zip: '710690' },
	{ city: 'Lisheen (Galway)', zip: '713030' },
	{ city: 'Lisheen (Kerry)', zip: '642610' },
	{ city: 'Lisheen (Limerick)', zip: '692642' },
	{ city: 'Lisheen (Offaly)', zip: '547632' },
	{ city: 'Lisheen (Roscommon)', zip: '925440' },
	{ city: 'Lisheen (Tipperary)', zip: '540472' },
	{ city: 'Lisheen (Waterford)', zip: '237717' },
	{ city: 'Lisheenabrone (Mayo)', zip: '996617' },
	{ city: 'Lisheenaclara (Galway)', zip: '161977' },
	{ city: 'Lisheenacloonta (Tipperary)', zip: '978848' },
	{ city: 'Lisheenacooravan (Sligo)', zip: '793131' },
	{ city: 'Lisheenacrannagh (Galway)', zip: '450319' },
	{ city: 'Lisheenacrehig (Cork)', zip: '132738' },
	{ city: 'Lisheenafeela (Cork)', zip: '496710' },
	{ city: 'Lisheenagower (Tipperary)', zip: '607182' },
	{ city: 'Lisheenaguile (Galway)', zip: '246822' },
	{ city: 'Lisheenahevnia (Galway)', zip: '635103' },
	{ city: 'Lisheenakeeran (Galway)', zip: '237772' },
	{ city: 'Lisheenaleen (Cork)', zip: '342030' },
	{ city: 'Lisheenaleen (Galway)', zip: '507485' },
	{ city: 'Lisheenaleen (Tipperary)', zip: '108296' },
	{ city: 'Lisheenanierin (Roscommon)', zip: '647925' },
	{ city: 'Lisheenanoran (Galway)', zip: '347628' },
	{ city: 'Lisheenanoul (Tipperary)', zip: '453615' },
	{ city: 'Lisheenataggart (Tipperary)', zip: '279807' },
	{ city: 'Lisheenavalla (Galway)', zip: '299410' },
	{ city: 'Lisheenaveelish (Mayo)', zip: '321264' },
	{ city: 'Lisheenbaun (Kerry)', zip: '722183' },
	{ city: 'Lisheen Beg (Tipperary)', zip: '185866' },
	{ city: 'Lisheenboy (Tipperary)', zip: '723194' },
	{ city: 'Lisheenbrien (Tipperary)', zip: '733672' },
	{ city: 'Lisheencrony (Clare)', zip: '958840' },
	{ city: 'Lisheendarby (Tipperary)', zip: '937828' },
	{ city: 'Lisheeneagh (Clare)', zip: '538359' },
	{ city: 'Lisheeneenaun East (Galway)', zip: '245114' },
	{ city: 'Lisheeneenaun West (Galway)', zip: '783184' },
	{ city: 'Lisheeneynaun (Galway)', zip: '816560' },
	{ city: 'Lisheenfrankagh (Tipperary)', zip: '603473' },
	{ city: 'Lisheenfurroor (Clare)', zip: '841624' },
	{ city: 'Lisheenielagaun (Mayo)', zip: '603174' },
	{ city: 'Lisheenkyle (Tipperary)', zip: '918451' },
	{ city: 'Lisheenkyle East (Galway)', zip: '848108' },
	{ city: 'Lisheenkyle West (Galway)', zip: '132288' },
	{ city: 'Lisheenleigh (Cork)', zip: '244579' },
	{ city: 'Lisheenloughtin (Roscommon)', zip: '682968' },
	{ city: 'Lisheen Lower (Cork)', zip: '619198' },
	{ city: 'Lisheenmanus (Mayo)', zip: '367020' },
	{ city: 'Lisheennacannina (Kerry)', zip: '675122' },
	{ city: 'Lisheennacreagh (Cork)', zip: '905233' },
	{ city: 'Lisheennagat (Galway)', zip: '939877' },
	{ city: 'Lisheennageeha (Galway)', zip: '713789' },
	{ city: 'Lisheennaheltia (Galway)', zip: '901287' },
	{ city: 'Lisheennamalausa (Tipperary)', zip: '832453' },
	{ city: 'Lisheennapingina (Cork)', zip: '282246' },
	{ city: 'Lisheennashingane (Kerry)', zip: '665112' },
	{ city: 'Lisheennavannoge (Galway)', zip: '842598' },
	{ city: 'Lisheen North (Galway)', zip: '295372' },
	{ city: 'Lisheenoona (Waterford)', zip: '354496' },
	{ city: 'Lisheenowen (Cork)', zip: '209464' },
	{ city: 'Lisheenpower (Tipperary)', zip: '927431' },
	{ city: 'Lisheenroe (Cork)', zip: '807824' },
	{ city: 'Lisheens (Cork)', zip: '941194' },
	{ city: 'Lisheens (Wicklow)', zip: '712375' },
	{ city: 'Lisheensheela (Limerick)', zip: '581084' },
	{ city: 'Lisheen South (Galway)', zip: '694921' },
	{ city: 'Lisheenteige (Galway)', zip: '740802' },
	{ city: 'Lisheentyrone (Tipperary)', zip: '831072' },
	{ city: 'Lisheentyrone South (Tipperary)', zip: '932178' },
	{ city: 'Lisheen Upper (Cork)', zip: '199438' },
	{ city: 'Lisheenvicknaheeha (Clare)', zip: '244290' },
	{ city: 'Lisheeny (Galway)', zip: '352076' },
	{ city: 'Lisheenydeen (Clare)', zip: '165142' },
	{ city: 'Lishenry (Cavan)', zip: '555905' },
	{ city: 'Lishugh (Roscommon)', zip: '760556' },
	{ city: 'Lisinan (Monaghan)', zip: '467204' },
	{ city: 'Lisinigan (Cavan)', zip: '850118' },
	{ city: 'Lisinisky (Monaghan)', zip: '464492' },
	{ city: 'Lisirril (Monaghan)', zip: '301783' },
	{ city: 'Liskea (Galway)', zip: '307142' },
	{ city: 'Liskeabrick (Monaghan)', zip: '470087' },
	{ city: 'Liskeagh (Sligo)', zip: '210332' },
	{ city: 'Liskeelty (Waterford)', zip: '570347' },
	{ city: 'Liskeeraghan (Donegal)', zip: '413938' },
	{ city: 'Liskeevy (Galway)', zip: '711958' },
	{ city: 'Liskelly (Cork)', zip: '495686' },
	{ city: 'Liskelly (Galway)', zip: '829472' },
	{ city: 'Liskenna (Monaghan)', zip: '409402' },
	{ city: 'Liskennett East (Limerick)', zip: '971074' },
	{ city: 'Liskennett West (Limerick)', zip: '508552' },
	{ city: 'Liskeran (Donegal)', zip: '668296' },
	{ city: 'Lisket (Clare)', zip: '424231' },
	{ city: 'Liskeveen (Tipperary)', zip: '759639' },
	{ city: 'Liskevin (Galway)', zip: '550656' },
	{ city: 'Liskey (Donegal)', zip: '614970' },
	{ city: 'Liskillea (Cork)', zip: '209761' },
	{ city: 'Liskilleen (Limerick)', zip: '877844' },
	{ city: 'Liskilleen (Mayo)', zip: '732356' },
	{ city: 'Liskilly (Limerick)', zip: '398804' },
	{ city: 'Liskinlahan (Tipperary)', zip: '577417' },
	{ city: 'Lislackagh (Mayo)', zip: '208704' },
	{ city: 'Lisladeen (Cork)', zip: '418612' },
	{ city: 'Lisladraun (Kerry)', zip: '337718' },
	{ city: 'Lislahelly (Sligo)', zip: '791147' },
	{ city: 'Lislahy (Leitrim)', zip: '793027' },
	{ city: 'Lislanly (Monaghan)', zip: '739653' },
	{ city: 'Lislannan (Monaghan)', zip: '490309' },
	{ city: 'Lislarheenbeg (Clare)', zip: '195355' },
	{ city: 'Lislarheenmore (Clare)', zip: '791549' },
	{ city: 'Lislary (Sligo)', zip: '991197' },
	{ city: 'Lislaughera (Mayo)', zip: '537545' },
	{ city: 'Lislaughna (Mayo)', zip: '221613' },
	{ city: 'Lislaughtin (Kerry)', zip: '780704' },
	{ city: 'Lislea (Cavan)', zip: '379336' },
	{ city: 'Lislea (Clare)', zip: '908787' },
	{ city: 'Lislea (Galway)', zip: '104653' },
	{ city: 'Lislea (Leitrim)', zip: '431339' },
	{ city: 'Lislea (Longford)', zip: '356151' },
	{ city: 'Lislea (Louth)', zip: '705095' },
	{ city: 'Lislea (Meath)', zip: '579389' },
	{ city: 'Lislea (Monaghan)', zip: '252656' },
	{ city: 'Lislea (Roscommon)', zip: '302873' },
	{ city: 'Lislea (Sligo)', zip: '166028' },
	{ city: 'Lisleagh (Cork)', zip: '337909' },
	{ city: 'Lisleagh (Waterford)', zip: '849593' },
	{ city: 'Lisleaghmountain (Waterford)', zip: '910511' },
	{ city: 'Lisleecourt (Cork)', zip: '311432' },
	{ city: 'Lisleetemple (Cork)', zip: '493710' },
	{ city: 'Lislehane (Cork)', zip: '203644' },
	{ city: 'Lisleibane (Kerry)', zip: '397357' },
	{ city: 'Lisleighbeg (Tipperary)', zip: '326642' },
	{ city: 'Lisleitrim (Monaghan)', zip: '403802' },
	{ city: 'Lislevane (Cork)', zip: '773915' },
	{ city: 'Lisliddy (Roscommon)', zip: '433068' },
	{ city: 'Lislin (Cavan)', zip: '658314' },
	{ city: 'Lislom (Longford)', zip: '872861' },
	{ city: 'Lislonane (Kerry)', zip: '501474' },
	{ city: 'Lislongfield (Monaghan)', zip: '618632' },
	{ city: 'Lisloose (Kerry)', zip: '180307' },
	{ city: 'Lisloran (Tipperary)', zip: '778402' },
	{ city: 'Lislorkan North (Clare)', zip: '198118' },
	{ city: 'Lislorkan South (Clare)', zip: '456911' },
	{ city: 'Lisloughlin (Galway)', zip: '296699' },
	{ city: 'Lisluinaghan (Clare)', zip: '719832' },
	{ city: 'Lislynchahan (Monaghan)', zip: '490741' },
	{ city: 'Lismacaffry (Westmeath)', zip: '851080' },
	{ city: 'Lismacanigan Lower (Cavan)', zip: '603459' },
	{ city: 'Lismacanigan Upper (Cavan)', zip: '336063' },
	{ city: 'Lismacbryan (Sligo)', zip: '835209' },
	{ city: 'Lismacfinnin (Kerry)', zip: '115013' },
	{ city: 'Lismacleane (Clare)', zip: '314239' },
	{ city: 'Lismacmanus (Longford)', zip: '318892' },
	{ city: 'Lismacmurrogh (Longford)', zip: '369211' },
	{ city: 'Lismacool (Roscommon)', zip: '167717' },
	{ city: 'Lismacrerk (Monaghan)', zip: '499306' },
	{ city: 'Lismacrory (Tipperary)', zip: '111943' },
	{ city: 'Lismacsheedy (Clare)', zip: '418082' },
	{ city: 'Lismacteige (Clare)', zip: '998479' },
	{ city: 'Lismacteige (Galway)', zip: '908812' },
	{ city: 'Lismacue (Tipperary)', zip: '505310' },
	{ city: 'Lismafadda (Galway)', zip: '275212' },
	{ city: 'Lismaganshion (Mayo)', zip: '711302' },
	{ city: 'Lismagawley (Longford)', zip: '153089' },
	{ city: 'Lismagawley Bog (Longford)', zip: '761212' },
	{ city: 'Lismagawley Meadow (Longford)', zip: '605198' },
	{ city: 'Lismageevoge (Roscommon)', zip: '135277' },
	{ city: 'Lismagiril (Cavan)', zip: '733377' },
	{ city: 'Lismagoneen (Longford)', zip: '457505' },
	{ city: 'Lismagonway (Monaghan)', zip: '992037' },
	{ city: 'Lismagratty (Cavan)', zip: '180123' },
	{ city: 'Lismagroon (Roscommon)', zip: '900600' },
	{ city: 'Lismagunshin (Monaghan)', zip: '246238' },
	{ city: 'Lismaha (Roscommon)', zip: '599989' },
	{ city: 'Lismahane (Cork)', zip: '431444' },
	{ city: 'Lismahon (Meath)', zip: '481643' },
	{ city: 'Lismaine (Kilkenny)', zip: '772927' },
	{ city: 'Lismakeegan (Leitrim)', zip: '864981' },
	{ city: 'Lismakeery (Limerick)', zip: '969790' },
	{ city: 'Lismakeeve (Tipperary)', zip: '278407' },
	{ city: 'Lismakin (Tipperary)', zip: '524107' },
	{ city: 'Lismalady (Westmeath)', zip: '345789' },
	{ city: 'Lismalaghlin (Cork)', zip: '484385' },
	{ city: 'Lismalin (Tipperary)', zip: '373605' },
	{ city: 'Lismaline (Tipperary)', zip: '156738' },
	{ city: 'Lismannagh (Leitrim)', zip: '914674' },
	{ city: 'Lismanny (Galway)', zip: '448453' },
	{ city: 'Lismanus (Louth)', zip: '622157' },
	{ city: 'Lismateige (Kilkenny)', zip: '935915' },
	{ city: 'Lismeagh (Monaghan)', zip: '130334' },
	{ city: 'Lismeegaun (Mayo)', zip: '186042' },
	{ city: 'Lismeehy (Roscommon)', zip: '861554' },
	{ city: 'Lismeelcunnin (Cork)', zip: '897326' },
	{ city: 'Lismeen (Cavan)', zip: '360359' },
	{ city: 'Lismenan (Monaghan)', zip: '530841' },
	{ city: 'Lismerraun (Sligo)', zip: '360581' },
	{ city: 'Lismihil (Galway)', zip: '278695' },
	{ city: 'Lismintan (Donegal)', zip: '370853' },
	{ city: 'Lismiraun (Mayo)', zip: '729463' },
	{ city: 'Lismire (Cork)', zip: '337420' },
	{ city: 'Lismoes (Galway)', zip: '666087' },
	{ city: 'Lismoghry (Donegal)', zip: '758449' },
	{ city: 'Lismoher (Clare)', zip: '876688' },
	{ city: 'Lismolin (Mayo)', zip: '386189' },
	{ city: 'Lismonaghan (Donegal)', zip: '835672' },
	{ city: 'Lismoney (Offaly)', zip: '446081' },
	{ city: 'Lismongane (Kerry)', zip: '584864' },
	{ city: 'Lismontigley (Donegal)', zip: '190744' },
	{ city: 'Lismorahaun (Clare)', zip: '489843' },
	{ city: 'Lismoran (Mayo)', zip: '711139' },
	{ city: 'Lismore (Kerry)', zip: '545098' },
	{ city: 'Lismore (Laois)', zip: '894060' },
	{ city: 'Lismore (Longford)', zip: '531286' },
	{ city: 'Lismore (Tipperary)', zip: '695958' },
	{ city: 'Lismore (Waterford)', zip: '730886' },
	{ city: 'Lismore Demesne (Cavan)', zip: '183525' },
	{ city: 'Lismore Demesne (Galway)', zip: '969695' },
	{ city: 'Lismorris (Clare)', zip: '405772' },
	{ city: 'Lismortagh (Tipperary)', zip: '715277' },
	{ city: 'Lismoy (Longford)', zip: '675783' },
	{ city: 'Lismoylan (Galway)', zip: '238520' },
	{ city: 'Lismoyle (Galway)', zip: '160326' },
	{ city: 'Lismoyle (Leitrim)', zip: '374053' },
	{ city: 'Lismoyle (Roscommon)', zip: '526517' },
	{ city: 'Lismoynan (Tipperary)', zip: '520180' },
	{ city: 'Lismoyny (Westmeath)', zip: '601667' },
	{ city: 'Lismuinga East (Clare)', zip: '180708' },
	{ city: 'Lismuinga West (Clare)', zip: '326096' },
	{ city: 'Lismulbreeda (Clare)', zip: '291711' },
	{ city: 'Lismulkeare (Roscommon)', zip: '616015' },
	{ city: 'Lismullane (Limerick)', zip: '218523' },
	{ city: 'Lismullig (Cavan)', zip: '390806' },
	{ city: 'Lismullin (Meath)', zip: '933995' },
	{ city: 'Lismullyduff (Donegal)', zip: '615459' },
	{ city: 'Lismurphy (Tipperary)', zip: '213231' },
	{ city: 'Lismurragha (Laois)', zip: '189326' },
	{ city: 'Lismurrew (Mayo)', zip: '670861' },
	{ city: 'Lismurtagh (Roscommon)', zip: '508135' },
	{ city: 'Lismuse (Clare)', zip: '352382' },
	{ city: 'Lisnabanree (Cork)', zip: '863121' },
	{ city: 'Lisnabantry (Cavan)', zip: '115687' },
	{ city: 'Lisnabert (Donegal)', zip: '539691' },
	{ city: 'Lisnabin (Westmeath)', zip: '689931' },
	{ city: 'Lisnabo (Longford)', zip: '152270' },
	{ city: 'Lisnabo (Meath)', zip: '527580' },
	{ city: 'Lisnaboley (Mayo)', zip: '807038' },
	{ city: 'Lisnaboll (Roscommon)', zip: '977234' },
	{ city: 'Lisnaboy (Meath)', zip: '829591' },
	{ city: 'Lisnaboy Lower (Cork)', zip: '555990' },
	{ city: 'Lisnaboy Upper (Cork)', zip: '775311' },
	{ city: 'Lisnabrack (Leitrim)', zip: '304171' },
	{ city: 'Lisnabrinlodge (Cork)', zip: '201039' },
	{ city: 'Lisnabrin Lower (Cork)', zip: '289631' },
	{ city: 'Lisnabrinnia (Cavan)', zip: '219961' },
	{ city: 'Lisnabrin North (Cork)', zip: '942687' },
	{ city: 'Lisnabrinny (Cork)', zip: '234950' },
	{ city: 'Lisnabrin South (Cork)', zip: '709163' },
	{ city: 'Lisnacark (Cavan)', zip: '683348' },
	{ city: 'Lisnacask (Westmeath)', zip: '930118' },
	{ city: 'Lisnaclassagh (Galway)', zip: '642872' },
	{ city: 'Lisnaclea (Cavan)', zip: '366994' },
	{ city: 'Lisnaclea (Monaghan)', zip: '538245' },
	{ city: 'Lisnacon (Cork)', zip: '768178' },
	{ city: 'Lisnacreevy (Longford)', zip: '497416' },
	{ city: 'Lisnacrilla (Cork)', zip: '989294' },
	{ city: 'Lisnacroghy (Roscommon)', zip: '643498' },
	{ city: 'Lisnacuddy (Cork)', zip: '348502' },
	{ city: 'Lisnacullia (Limerick)', zip: '207172' },
	{ city: 'Lisnacunna (Cork)', zip: '878173' },
	{ city: 'Lisnacurley (Mayo)', zip: '498235' },
	{ city: 'Lisnacush (Longford)', zip: '183396' },
	{ city: 'Lisnadarragh (Cavan)', zip: '862486' },
	{ city: 'Lisnadarragh (Monaghan)', zip: '890653' },
	{ city: 'Lisnadrisha (Galway)', zip: '990024' },
	{ city: 'Lisnafaha (Clare)', zip: '396545' },
	{ city: 'Lisnafana (Cavan)', zip: '953640' },
	{ city: 'Lisnafeddaly (Monaghan)', zip: '548001' },
	{ city: 'Lisnafinelly (Monaghan)', zip: '847774' },
	{ city: 'Lisnafulla (Limerick)', zip: '221503' },
	{ city: 'Lisnafunshin (Kilkenny)', zip: '181812' },
	{ city: 'Lisnagalliagh (Monaghan)', zip: '702988' },
	{ city: 'Lisnagappagh (Westmeath)', zip: '242910' },
	{ city: 'Lisnagard (Roscommon)', zip: '511848' },
	{ city: 'Lisnagar Demesne (Cork)', zip: '314443' },
	{ city: 'Lisnagat (Cork)', zip: '315702' },
	{ city: 'Lisnagat (Leitrim)', zip: '722841' },
	{ city: 'Lisnagaul (Tipperary)', zip: '895890' },
	{ city: 'Lisnagavragh (Roscommon)', zip: '301377' },
	{ city: 'Lisnagea (Leitrim)', zip: '139705' },
	{ city: 'Lisnageeha (Mayo)', zip: '709490' },
	{ city: 'Lisnageenly (Tipperary)', zip: '140609' },
	{ city: 'Lisnageer (Cavan)', zip: '785853' },
	{ city: 'Lisnageeragh (Galway)', zip: '464252' },
	{ city: 'Lisnageeragh (Longford)', zip: '645750' },
	{ city: 'Lisnageeragh (Offaly)', zip: '778047' },
	{ city: 'Lisnageragh (Waterford)', zip: '248357' },
	{ city: 'Lisnagirra (Roscommon)', zip: '259189' },
	{ city: 'Lisnaglea (Cavan)', zip: '688697' },
	{ city: 'Lisnagloos (Galway)', zip: '340540' },
	{ city: 'Lisnagomman (Laois)', zip: '927103' },
	{ city: 'Lisnagon (Meath)', zip: '104544' },
	{ city: 'Lisnagoneeny (Kerry)', zip: '106734' },
	{ city: 'Lisnagonoge (Tipperary)', zip: '704562' },
	{ city: 'Lisnagoon (Cavan)', zip: '939671' },
	{ city: 'Lisnagoorneen (Cork)', zip: '382615' },
	{ city: 'Lisnagore (Monaghan)', zip: '504795' },
	{ city: 'Lisnagore (Sligo)', zip: '333425' },
	{ city: 'Lisnagowan (Cavan)', zip: '417438' },
	{ city: 'Lisnagowan (Leitrim)', zip: '656650' },
	{ city: 'Lisnagower (Tipperary)', zip: '185595' },
	{ city: 'Lisnagranshy (Galway)', zip: '680335' },
	{ city: 'Lisnagrave (Kerry)', zip: '537063' },
	{ city: 'Lisnagree (Galway)', zip: '711172' },
	{ city: 'Lisnagree (Kerry)', zip: '476322' },
	{ city: 'Lisnagree (Waterford)', zip: '432944' },
	{ city: 'Lisnagree (Westmeath)', zip: '709983' },
	{ city: 'Lisnagreeve (Monaghan)', zip: '780287' },
	{ city: 'Lisnagrish (Longford)', zip: '795517' },
	{ city: 'Lisnagroagh (Roscommon)', zip: '542402' },
	{ city: 'Lisnagroob (Roscommon)', zip: '558112' },
	{ city: 'Lisnagross (Mayo)', zip: '811170' },
	{ city: 'Lisnagrough (Cork)', zip: '894066' },
	{ city: 'Lisnagrough (Tipperary)', zip: '678661' },
	{ city: 'Lisnagrow (Meath)', zip: '818356' },
	{ city: 'Lisnagry (Galway)', zip: '719243' },
	{ city: 'Lisnagry (Limerick)', zip: '763717' },
	{ city: 'Lisnaguiveragh (Monaghan)', zip: '184705' },
	{ city: 'Lisnagunnion (Monaghan)', zip: '864143' },
	{ city: 'Lisnagyreeny (Galway)', zip: '899209' },
	{ city: 'Lisnahederna (Cavan)', zip: '697890' },
	{ city: 'Lisnahirka (Roscommon)', zip: '144261' },
	{ city: 'Lisnahoon (Roscommon)', zip: '826832' },
	{ city: 'Lisnahorna (Cork)', zip: '675794' },
	{ city: 'Lisnakealwee (Kerry)', zip: '680613' },
	{ city: 'Lisnakeeny (Monaghan)', zip: '727097' },
	{ city: 'Lisnakelly (Monaghan)', zip: '753463' },
	{ city: 'Lisnakill (Waterford)', zip: '910650' },
	{ city: 'Lisnakirka (Mayo)', zip: '232643' },
	{ city: 'Lisnalanniv (Limerick)', zip: '166074' },
	{ city: 'Lisnalannow (Roscommon)', zip: '279704' },
	{ city: 'Lisnalea (Cavan)', zip: '982839' },
	{ city: 'Lisnalea (Kilkenny)', zip: '128468' },
	{ city: 'Lisnalee (Monaghan)', zip: '879621' },
	{ city: 'Lisnalegan (Roscommon)', zip: '757968' },
	{ city: 'Lisnalong (Monaghan)', zip: '113153' },
	{ city: 'Lisnalurg (Sligo)', zip: '681488' },
	{ city: 'Lisnamacka (Monaghan)', zip: '838930' },
	{ city: 'Lisnamaine (Cavan)', zip: '282909' },
	{ city: 'Lisnamandra (Cavan)', zip: '818551' },
	{ city: 'Lisnamaneeagh (Mayo)', zip: '581890' },
	{ city: 'Lisnaminaun (Galway)', zip: '328347' },
	{ city: 'Lisnamoe (Tipperary)', zip: '550516' },
	{ city: 'Lisnamoltaun (Galway)', zip: '956781' },
	{ city: 'Lisnamovaun (Kerry)', zip: '309938' },
	{ city: 'Lisnamoyle (Mayo)', zip: '787947' },
	{ city: 'Lisnamoyle Etra (Monaghan)', zip: '500331' },
	{ city: 'Lisnamoyle Otra (Monaghan)', zip: '454667' },
	{ city: 'Lisnamrock (Tipperary)', zip: '533455' },
	{ city: 'Lisnamuck (Limerick)', zip: '594260' },
	{ city: 'Lisnamuck (Longford)', zip: '767280' },
	{ city: 'Lisnamuck (Tipperary)', zip: '492145' },
	{ city: 'Lisnamucklagh (Roscommon)', zip: '522378' },
	{ city: 'Lisnamulligan (Donegal)', zip: '716090' },
	{ city: 'Lisnamult (Roscommon)', zip: '501613' },
	{ city: 'Lisnanagh (Longford)', zip: '470079' },
	{ city: 'Lisnananagh (Cavan)', zip: '909190' },
	{ city: 'Lisnanard (Clare)', zip: '369808' },
	{ city: 'Lisnanarriagh (Roscommon)', zip: '288708' },
	{ city: 'Lisnanaw (Leitrim)', zip: '133091' },
	{ city: 'Lisnaneane (Longford)', zip: '721160' },
	{ city: 'Lisnaneane (Roscommon)', zip: '442987' },
	{ city: 'Lisnanees Lower (Donegal)', zip: '680985' },
	{ city: 'Lisnanees Upper (Donegal)', zip: '968978' },
	{ city: 'Lisnanore (Monaghan)', zip: '261160' },
	{ city: 'Lisnanorrus (Leitrim)', zip: '270804' },
	{ city: 'Lisnanoul (Kerry)', zip: '571627' },
	{ city: 'Lisnanroum (Clare)', zip: '783923' },
	{ city: 'Lisnanuran (Roscommon)', zip: '433139' },
	{ city: 'Lisnapaste (Donegal)', zip: '107864' },
	{ city: 'Lisnaponra North (Mayo)', zip: '775253' },
	{ city: 'Lisnaponra South (Mayo)', zip: '417734' },
	{ city: 'Lisnaran (Mayo)', zip: '401291' },
	{ city: 'Lisnarawer (Sligo)', zip: '542122' },
	{ city: 'Lisnaree (Donegal)', zip: '436741' },
	{ city: 'Lisnareelin (Tipperary)', zip: '934593' },
	{ city: 'Lisnarode (Laois)', zip: '880941' },
	{ city: 'Lisnaroe Far (Monaghan)', zip: '499410' },
	{ city: 'Lisnaroe Near (Monaghan)', zip: '571780' },
	{ city: 'Lisnasallagh (Cork)', zip: '135247' },
	{ city: 'Lisnasaran (Cavan)', zip: '217206' },
	{ city: 'Lisnasassonagh (Cavan)', zip: '831640' },
	{ city: 'Lisnascreen (Westmeath)', zip: '537951' },
	{ city: 'Lisnascreena (Galway)', zip: '911538' },
	{ city: 'Lisnasella (Tipperary)', zip: '251348' },
	{ city: 'Lisnashandrum East (Cork)', zip: '803132' },
	{ city: 'Lisnashandrum West (Cork)', zip: '733676' },
	{ city: 'Lisnashanna (Cavan)', zip: '986295' },
	{ city: 'Lisnashannagh (Monaghan)', zip: '755197' },
	{ city: 'Lisnashearshane (Cork)', zip: '677907' },
	{ city: 'Lisnasillagh (Roscommon)', zip: '627775' },
	{ city: 'Lisnasoolmoy (Tipperary)', zip: '843439' },
	{ city: 'Lisnatea (Roscommon)', zip: '939327' },
	{ city: 'Lisnatinny (Cavan)', zip: '846780' },
	{ city: 'Lisnatubbrid (Tipperary)', zip: '909399' },
	{ city: 'Lisnatullagh (Leitrim)', zip: '474120' },
	{ city: 'Lisnaveane (Monaghan)', zip: '671366' },
	{ city: 'Lisnaviddoge North (Tipperary)', zip: '419116' },
	{ city: 'Lisnaviddoge South (Tipperary)', zip: '745801' },
	{ city: 'Lisnawully (Louth)', zip: '799646' },
	{ city: 'Lisnenan (Donegal)', zip: '175551' },
	{ city: 'Lisnevagh (Carlow)', zip: '525114' },
	{ city: 'Lisnoble (Donegal)', zip: '933890' },
	{ city: 'Lisnolan (Mayo)', zip: '474961' },
	{ city: 'Lisnugent (Westmeath)', zip: '648794' },
	{ city: 'Lisoarty (Monaghan)', zip: '991402' },
	{ city: 'Lisomadaun (Leitrim)', zip: '412184' },
	{ city: 'Lispatrick (Mayo)', zip: '720180' },
	{ city: 'Lispatrick Lower (Cork)', zip: '166040' },
	{ city: 'Lispatrick Upper (Cork)', zip: '394263' },
	{ city: 'Lispheasty (Galway)', zip: '404254' },
	{ city: 'Lisphilip (Roscommon)', zip: '218725' },
	{ city: 'Lispole (Kerry)', zip: '499570' },
	{ city: 'Lispopple (Dublin)', zip: '651950' },
	{ city: 'Lispopple (Westmeath)', zip: '983584' },
	{ city: 'Lispuckaun (Clare)', zip: '119051' },
	{ city: 'Lisquigny (Monaghan)', zip: '463341' },
	{ city: 'Lisquillibeen (Tipperary)', zip: '290150' },
	{ city: 'Lisquinlan (Cork)', zip: '471961' },
	{ city: 'Lisrabirra (Galway)', zip: '983629' },
	{ city: 'Lisraghtigan (Longford)', zip: '562484' },
	{ city: 'Lisraherty (Longford)', zip: '330978' },
	{ city: 'Lisready (Limerick)', zip: '774193' },
	{ city: 'Lisreagh (Cavan)', zip: '806407' },
	{ city: 'Lisrenny (Louth)', zip: '734350' },
	{ city: 'Lisrevagh (Longford)', zip: '692580' },
	{ city: 'Lisrivis (Galway)', zip: '873879' },
	{ city: 'Lisrobert (Mayo)', zip: '634976' },
	{ city: 'Lisrobin East (Cork)', zip: '915912' },
	{ city: 'Lisrobin West (Cork)', zip: '454711' },
	{ city: 'Lisroe (Clare)', zip: '326001' },
	{ city: 'Lisroe (Cork)', zip: '142872' },
	{ city: 'Lisroe (Kerry)', zip: '628424' },
	{ city: 'Lisroe (Waterford)', zip: '753775' },
	{ city: 'Lisronagh (Tipperary)', zip: '372943' },
	{ city: 'Lisroosky (Monaghan)', zip: '382472' },
	{ city: 'Lisroughty (Leitrim)', zip: '954979' },
	{ city: 'Lisroyne (Roscommon)', zip: '843708' },
	{ city: 'Lisruntagh (Sligo)', zip: '708948' },
	{ city: 'Lisryan (Longford)', zip: '874531' },
	{ city: 'Liss (Clare)', zip: '965627' },
	{ city: 'Liss (Galway)', zip: '108746' },
	{ city: 'Liss (Kerry)', zip: '727973' },
	{ city: 'Liss (Tipperary)', zip: '971991' },
	{ city: 'Liss (Waterford)', zip: '168650' },
	{ city: 'Lissacaha (Cork)', zip: '433337' },
	{ city: 'Lissacapia (Cork)', zip: '861938' },
	{ city: 'Lissacapple (Cavan)', zip: '368578' },
	{ city: 'Lissacarha (Galway)', zip: '263845' },
	{ city: 'Lissacarn (Leitrim)', zip: '271072' },
	{ city: 'Lissacarrow (Roscommon)', zip: '185742' },
	{ city: 'Lissacholly (Donegal)', zip: '686183' },
	{ city: 'Lissaclarig East (Cork)', zip: '943342' },
	{ city: 'Lissaclarig West (Cork)', zip: '416447' },
	{ city: 'Lissacresig (Cork)', zip: '307050' },
	{ city: 'Lissacroneen (Cork)', zip: '826466' },
	{ city: 'Lissacrue (Cork)', zip: '975285' },
	{ city: 'Lissacullaun (Galway)', zip: '267492' },
	{ city: 'Lissacurkia (Roscommon)', zip: '321060' },
	{ city: 'Lissadill (Sligo)', zip: '806245' },
	{ city: 'Lissadober (Tipperary)', zip: '104488' },
	{ city: 'Lissadoill (Galway)', zip: '594096' },
	{ city: 'Lissadonna (Tipperary)', zip: '388578' },
	{ city: 'Lissadorn (Roscommon)', zip: '626306' },
	{ city: 'Lissadrone East (Mayo)', zip: '585634' },
	{ city: 'Lissadrone West (Mayo)', zip: '402013' },
	{ city: 'Lissadulta (Galway)', zip: '990488' },
	{ city: 'Lissagadda (Tipperary)', zip: '841278' },
	{ city: 'Lissagallan (Roscommon)', zip: '932253' },
	{ city: 'Lissagarvan (Leitrim)', zip: '468416' },
	{ city: 'Lissagernal (Longford)', zip: '296809' },
	{ city: 'Lissaghanedan (Longford)', zip: '380034' },
	{ city: 'Lissagriffin (Cork)', zip: '931277' },
	{ city: 'Lissagroom (Cork)', zip: '795168' },
	{ city: 'Lissagurraun (Galway)', zip: '997987' },
	{ city: 'Lissahane (Kerry)', zip: '768092' },
	{ city: 'Lissahane (Waterford)', zip: '107352' },
	{ city: 'Lissakillen North (Westmeath)', zip: '229211' },
	{ city: 'Lissakillen South (Westmeath)', zip: '157912' },
	{ city: 'Lissakilly (Westmeath)', zip: '969756' },
	{ city: 'Lissakit (Longford)', zip: '801153' },
	{ city: 'Lissakyle (Tipperary)', zip: '587453' },
	{ city: 'Lissalacaun (Mayo)', zip: '780871' },
	{ city: 'Lissaleen (Galway)', zip: '404060' },
	{ city: 'Lissaleen (Limerick)', zip: '696991' },
	{ city: 'Lissalican (Carlow)', zip: '760076' },
	{ city: 'Lissalohorig (Cork)', zip: '974948' },
	{ city: 'Lissalondoon (Galway)', zip: '149659' },
	{ city: 'Lissalough (Sligo)', zip: '254193' },
	{ city: 'Lissalougha (Clare)', zip: '870929' },
	{ city: 'Lissalumma (Galway)', zip: '774458' },
	{ city: 'Lissalway (Roscommon)', zip: '490649' },
	{ city: 'Lissameen (Longford)', zip: '616906' },
	{ city: 'Lissamona (Cork)', zip: '299424' },
	{ city: 'Lissamota (Limerick)', zip: '829385' },
	{ city: 'Lissanacody (Galway)', zip: '791846' },
	{ city: 'Lissanair (Clare)', zip: '493196' },
	{ city: 'Lissanalta (Limerick)', zip: '579644' },
	{ city: 'Lissananny (Galway)', zip: '757415' },
	{ city: 'Lissananny (Roscommon)', zip: '270993' },
	{ city: 'Lissananny Beg (Sligo)', zip: '667128' },
	{ city: 'Lissananny More (Sligo)', zip: '948580' },
	{ city: 'Lissanard East (Galway)', zip: '162140' },
	{ city: 'Lissanard West (Galway)', zip: '416824' },
	{ city: 'Lissanarroor (Limerick)', zip: '513482' },
	{ city: 'Lissaneagh (Sligo)', zip: '529097' },
	{ city: 'Lissanearla East (Kerry)', zip: '565143' },
	{ city: 'Lissanearla West (Kerry)', zip: '409143' },
	{ city: 'Lissan East (Clare)', zip: '536390' },
	{ city: 'Lissaneaville (Roscommon)', zip: '958266' },
	{ city: 'Lissaneena (Sligo)', zip: '409248' },
	{ city: 'Lissaneeny (Sligo)', zip: '734779' },
	{ city: 'Lissane Lower (Cork)', zip: '361733' },
	{ city: 'Lissane Upper (Cork)', zip: '240901' },
	{ city: 'Lissangle (Cork)', zip: '474018' },
	{ city: 'Lissanierin (Offaly)', zip: '214150' },
	{ city: 'Lissaniska (Cork)', zip: '494820' },
	{ city: 'Lissaniska (Galway)', zip: '721599' },
	{ city: 'Lissaniska (Kerry)', zip: '636089' },
	{ city: 'Lissaniska (Mayo)', zip: '369390' },
	{ city: 'Lissaniska (Offaly)', zip: '292893' },
	{ city: 'Lissaniska (Waterford)', zip: '617792' },
	{ city: 'Lissaniska East (Limerick)', zip: '780288' },
	{ city: 'Lissaniska East (Mayo)', zip: '129309' },
	{ city: 'Lissaniska North (Galway)', zip: '177542' },
	{ city: 'Lissaniska South (Galway)', zip: '834072' },
	{ city: 'Lissaniska West (Limerick)', zip: '637131' },
	{ city: 'Lissaniska West (Mayo)', zip: '746389' },
	{ city: 'Lissanisky (Cork)', zip: '264463' },
	{ city: 'Lissanisky (Longford)', zip: '949364' },
	{ city: 'Lissanisky (Mayo)', zip: '334662' },
	{ city: 'Lissanisky (Offaly)', zip: '736450' },
	{ city: 'Lissanisky (Roscommon)', zip: '624539' },
	{ city: 'Lissanisky (Tipperary)', zip: '976748' },
	{ city: 'Lissanly (Cork)', zip: '447850' },
	{ city: 'Lissannymore (Cavan)', zip: '642261' },
	{ city: 'Lissanode (Westmeath)', zip: '578123' },
	{ city: 'Lissanoohig (Cork)', zip: '690275' },
	{ city: 'Lissanore (Longford)', zip: '151695' },
	{ city: 'Lissanover (Cavan)', zip: '520729' },
	{ city: 'Lissanumera (Mayo)', zip: '555715' },
	{ city: 'Lissanure (Longford)', zip: '529141' },
	{ city: 'Lissanure (Tipperary)', zip: '474533' },
	{ city: 'Lissanurlan (Longford)', zip: '434796' },
	{ city: 'Lissan West (Clare)', zip: '254255' },
	{ city: 'Lissapharson (Galway)', zip: '378442' },
	{ city: 'Lissaphobble (Roscommon)', zip: '641361' },
	{ city: 'Lissaphooca (Cork)', zip: '689583' },
	{ city: 'Lissaphuca (Galway)', zip: '478007' },
	{ city: 'Lissaphuca (Roscommon)', zip: '133581' },
	{ city: 'Lissaquill (Westmeath)', zip: '358049' },
	{ city: 'Lissarankin (Cork)', zip: '397109' },
	{ city: 'Lissaraw (Monaghan)', zip: '548290' },
	{ city: 'Lissard (Cork)', zip: '548422' },
	{ city: 'Lissard (Galway)', zip: '957333' },
	{ city: 'Lissard (Limerick)', zip: '821958' },
	{ city: 'Lissard (Longford)', zip: '571260' },
	{ city: 'Lissardagh (Cork)', zip: '125808' },
	{ city: 'Lissardboola (Kerry)', zip: '365520' },
	{ city: 'Lissard More (Mayo)', zip: '979478' },
	{ city: 'Lissardowlan (Longford)', zip: '155590' },
	{ city: 'Lissaree (Cork)', zip: '791268' },
	{ city: 'Lissareemig (Cork)', zip: '107955' },
	{ city: 'Lissaroon (Tipperary)', zip: '154504' },
	{ city: 'Lissarourke (Cork)', zip: '754464' },
	{ city: 'Lissarow (Waterford)', zip: '489109' },
	{ city: 'Lissarulla (Galway)', zip: '321607' },
	{ city: 'Lissasmuttaun (Waterford)', zip: '493387' },
	{ city: 'Lissataggle (Kerry)', zip: '464897' },
	{ city: 'Lissatanvally (Kerry)', zip: '962804' },
	{ city: 'Lissatava (Mayo)', zip: '777642' },
	{ city: 'Lissatinnig (Kerry)', zip: '557590' },
	{ city: 'Lissatotan (Limerick)', zip: '592819' },
	{ city: 'Lissatunna (Clare)', zip: '309011' },
	{ city: 'Lissatunny (Galway)', zip: '622668' },
	{ city: 'Lissatunny (Tipperary)', zip: '296431' },
	{ city: 'Lissatunny (Westmeath)', zip: '733543' },
	{ city: 'Lissava (Tipperary)', zip: '932393' },
	{ city: 'Lissavaddy (Longford)', zip: '291388' },
	{ city: 'Lissavahaun (Galway)', zip: '533322' },
	{ city: 'Lissavally (Galway)', zip: '629009' },
	{ city: 'Lissavally Glebe (Galway)', zip: '909996' },
	{ city: 'Lissavane East (Kerry)', zip: '989783' },
	{ city: 'Lissavane West (Kerry)', zip: '616006' },
	{ city: 'Lissavard (Cork)', zip: '503902' },
	{ city: 'Lissavarra (Limerick)', zip: '175250' },
	{ city: 'Lissavilla (Roscommon)', zip: '853613' },
	{ city: 'Lissaviron (Waterford)', zip: '243565' },
	{ city: 'Lissavironbog (Waterford)', zip: '905962' },
	{ city: 'Lissavoura (Cork)', zip: '639999' },
	{ city: 'Lissavra Big (Westmeath)', zip: '915922' },
	{ city: 'Lissavra Little (Westmeath)', zip: '667854' },
	{ city: 'Lissavruggy (Galway)', zip: '382479' },
	{ city: 'Lissawaddy (Roscommon)', zip: '384881' },
	{ city: 'Lissawarriff (Longford)', zip: '214753' },
	{ city: 'Lissawly (Longford)', zip: '426632' },
	{ city: 'Lissawullaun (Galway)', zip: '233206' },
	{ city: 'Lissawully (Sligo)', zip: '485756' },
	{ city: 'Lisseagh (Monaghan)', zip: '341930' },
	{ city: 'Lisseeghan (Leitrim)', zip: '781298' },
	{ city: 'Lisseenamanragh (Roscommon)', zip: '342481' },
	{ city: 'Lisseevin (Roscommon)', zip: '540348' },
	{ city: 'Lisselan (Waterford)', zip: '119339' },
	{ city: 'Lisselane (Cork)', zip: '277862' },
	{ city: 'Lisselan Intake (Waterford)', zip: '678685' },
	{ city: 'Lisselton (Kerry)', zip: '994084' },
	{ city: 'Lisselty (Waterford)', zip: '554177' },
	{ city: 'Lissenhall (Tipperary)', zip: '731710' },
	{ city: 'Lissenhall Great (Dublin)', zip: '124294' },
	{ city: 'Lissenhall Little (Dublin)', zip: '853168' },
	{ city: 'Lisserdrea (Roscommon)', zip: '683023' },
	{ city: 'Lissergloon (Sligo)', zip: '636531' },
	{ city: 'Lissergool (Roscommon)', zip: '603286' },
	{ city: 'Lisserlough (Sligo)', zip: '431574' },
	{ city: 'Lissernane (Tipperary)', zip: '967497' },
	{ city: 'Lissheeda (Cork)', zip: '960209' },
	{ city: 'Lissian (Roscommon)', zip: '618959' },
	{ city: 'Lissicorrane (Cork)', zip: '657384' },
	{ city: 'Lissinagroagh (Leitrim)', zip: '611752' },
	{ city: 'Lissindragan (Galway)', zip: '308721' },
	{ city: 'Lissinisk (Donegal)', zip: '722525' },
	{ city: 'Lissiniska (Leitrim)', zip: '383612' },
	{ city: 'Lissinore (Donegal)', zip: '922285' },
	{ city: 'Lissireen (Kerry)', zip: '945947' },
	{ city: 'Liss Lower (Kerry)', zip: '405274' },
	{ city: 'Lissobihane (Tipperary)', zip: '531088' },
	{ city: 'Lissodeige (Kerry)', zip: '952540' },
	{ city: 'Lissofin (Clare)', zip: '353685' },
	{ city: 'Lissonuffy (Roscommon)', zip: '383514' },
	{ city: 'Lissooleen (Kerry)', zip: '282690' },
	{ city: 'Lissoughter (Galway)', zip: '625849' },
	{ city: 'Lissowen (Limerick)', zip: '800791' },
	{ city: 'Lissoy (Westmeath)', zip: '488110' },
	{ city: 'Liss Upper (Kerry)', zip: '341536' },
	{ city: 'Lissurla (Cork)', zip: '468103' },
	{ city: 'Lissurland (Limerick)', zip: '594199' },
	{ city: 'Lissybroder (Galway)', zip: '423747' },
	{ city: 'Lissyclearig Lower (Kerry)', zip: '919206' },
	{ city: 'Lissyclearig Upper (Kerry)', zip: '903520' },
	{ city: 'Lissyconnor (Kerry)', zip: '546575' },
	{ city: 'Lissyconor (Galway)', zip: '263716' },
	{ city: 'Lissycoyne (Sligo)', zip: '150396' },
	{ city: 'Lissycrimeen (Cork)', zip: '546550' },
	{ city: 'Lissycurrig (Kerry)', zip: '527650' },
	{ city: 'Lissydaly (Roscommon)', zip: '457733' },
	{ city: 'Lissydonnell (Cork)', zip: '261518' },
	{ city: 'Lissyegan (Galway)', zip: '613971' },
	{ city: 'Lissygreaghan (Roscommon)', zip: '337527' },
	{ city: 'Lissyleamy (Tipperary)', zip: '445889' },
	{ city: 'Lissyline (Clare)', zip: '849350' },
	{ city: 'Lissylisheen (Clare)', zip: '726342' },
	{ city: 'Lissymulgee (Mayo)', zip: '780891' },
	{ city: 'Lissyneillan (Clare)', zip: '498637' },
	{ city: 'Lissyviggeen (Kerry)', zip: '439169' },
	{ city: 'Lissyvurriheen (Clare)', zip: '473466' },
	{ city: 'Lissywollen (Westmeath)', zip: '262136' },
	{ city: 'Listack (Donegal)', zip: '655761' },
	{ city: 'Listannagh (Donegal)', zip: '692523' },
	{ city: 'Listarkin (Cork)', zip: '634288' },
	{ city: 'Listeige (Waterford)', zip: '148516' },
	{ city: 'Listellan (Monaghan)', zip: '901951' },
	{ city: 'Listellian (Donegal)', zip: '154300' },
	{ city: 'Listellick North (Kerry)', zip: '183687' },
	{ city: 'Listellick South (Kerry)', zip: '623031' },
	{ city: 'Listerlin (Kilkenny)', zip: '842165' },
	{ city: 'Listernan (Mayo)', zip: '520279' },
	{ city: 'Listhomasroe (Roscommon)', zip: '710097' },
	{ city: 'Listicall Lower (Donegal)', zip: '941975' },
	{ city: 'Listicall Upper (Donegal)', zip: '951840' },
	{ city: 'Listiernan (Cavan)', zip: '509342' },
	{ city: 'Listinny (Monaghan)', zip: '512726' },
	{ city: 'Listobit (Longford)', zip: '549431' },
	{ city: 'Listoke (Louth)', zip: '760006' },
	{ city: 'Listowel (Kerry)', zip: '843787' },
	{ city: 'Listraghee (Longford)', zip: '999307' },
	{ city: 'Listraheagny (Monaghan)', zip: '230635' },
	{ city: 'Listrim (Kerry)', zip: '436345' },
	{ city: 'Listrisnan (Mayo)', zip: '804286' },
	{ city: 'Listroar (Monaghan)', zip: '760843' },
	{ city: 'Listrolin (Kilkenny)', zip: '309100' },
	{ city: 'Listrush (Sligo)', zip: '119481' },
	{ city: 'Listry (Kerry)', zip: '764616' },
	{ city: 'Listulk (Louth)', zip: '884695' },
	{ city: 'Listymurragh (Kerry)', zip: '559821' },
	{ city: 'Lisvarrinane (Tipperary)', zip: '874267' },
	{ city: 'Liswilliam (Roscommon)', zip: '482917' },
	{ city: 'Litter Beg (Wexford)', zip: '701199' },
	{ city: 'Litter More (Wexford)', zip: '244811' },
	{ city: 'Little Bray (Wicklow)', zip: '458142' },
	{ city: 'Littlebridge (Wexford)', zip: '935960' },
	{ city: 'Littlebridge Inches (Waterford)', zip: '571725' },
	{ city: 'Littleconnell (Kildare)', zip: '755012' },
	{ city: 'Littlefield (Kilkenny)', zip: '581079' },
	{ city: 'Littlefield (Tipperary)', zip: '779584' },
	{ city: 'Littlegrace (Cork)', zip: '501598' },
	{ city: 'Littlegrace (Waterford)', zip: '499182' },
	{ city: 'Littlegrange (Louth)', zip: '986919' },
	{ city: 'Little-Island (Cork)', zip: '687990' },
	{ city: 'Littlemill (Louth)', zip: '151199' },
	{ city: 'Littlepace (Dublin)', zip: '911040' },
	{ city: 'Littlerath (Kildare)', zip: '135479' },
	{ city: 'Littlerath (Meath)', zip: '934915' },
	{ city: 'Littlesilver (Cork)', zip: '941603' },
	{ city: 'Littleton (Tipperary)', zip: '886835' },
	{ city: 'Littletown (Kildare)', zip: '951032' },
	{ city: 'Littletown (Westmeath)', zip: '120171' },
	{ city: 'Littletown (Wexford)', zip: '278423' },
	{ city: 'Littlewood (Westmeath)', zip: '570179' },
	{ city: 'Lixnaw (Kerry)', zip: '317888' },
	{ city: 'Lloydsborough (Tipperary)', zip: '908516' },
	{ city: 'Loan (Kilkenny)', zip: '886563' },
	{ city: 'Lobawn (Wicklow)', zip: '199552' },
	{ city: 'Lobinstown (Meath)', zip: '350737' },
	{ city: 'Loch Gowna (Cavan)', zip: '587720' },
	{ city: 'Lockardstown (Westmeath)', zip: '244630' },
	{ city: 'Lockclose (Offaly)', zip: '902421' },
	{ city: 'Lockstown Lower (Wicklow)', zip: '540004' },
	{ city: 'Lockstown Upper (Wicklow)', zip: '890481' },
	{ city: 'Lodge (Cork)', zip: '447933' },
	{ city: 'Lodge (Galway)', zip: '173795' },
	{ city: 'Lodge (Kilkenny)', zip: '241183' },
	{ city: 'Lodge (Limerick)', zip: '439932' },
	{ city: 'Lodge (Roscommon)', zip: '427805' },
	{ city: 'Lodge (Tipperary)', zip: '457113' },
	{ city: 'Lodge Demesne East (Kilkenny)', zip: '592038' },
	{ city: 'Lodge Demesne West (Kilkenny)', zip: '748632' },
	{ city: 'Lodgepark (Kildare)', zip: '706581' },
	{ city: 'Lodgewood (Wexford)', zip: '245889' },
	{ city: 'Loftusacre (Wexford)', zip: '491745' },
	{ city: 'Loftushall (Wexford)', zip: '236778' },
	{ city: 'Loganstown (Meath)', zip: '358268' },
	{ city: 'Logavinshire (Limerick)', zip: '376761' },
	{ city: 'Logg (Tipperary)', zip: '759719' },
	{ city: 'Loggan Lower (Wexford)', zip: '150113' },
	{ city: 'Loggan Upper (Wexford)', zip: '290223' },
	{ city: 'Loghill (Limerick)', zip: '964349' },
	{ city: 'Loginsherd (Wexford)', zip: '823935' },
	{ city: 'Logleagh (Waterford)', zip: '188663' },
	{ city: 'Lognafulla (Tipperary)', zip: '226446' },
	{ city: 'Lognagappul (Cork)', zip: '731191' },
	{ city: 'Logstown (Kildare)', zip: '741653' },
	{ city: 'Lohart (Kerry)', zip: '163476' },
	{ city: 'Loher (Kerry)', zip: '519864' },
	{ city: 'Lohercannan (Kerry)', zip: '400097' },
	{ city: 'Lohort East (Cork)', zip: '320631' },
	{ city: 'Lohort West (Cork)', zip: '956278' },
	{ city: 'Lomanagh (Kerry)', zip: '755059' },
	{ city: 'Lomanagh North (Kerry)', zip: '928226' },
	{ city: 'Lomanagh South (Kerry)', zip: '560597' },
	{ city: 'Lomaunaghbaun (Galway)', zip: '580118' },
	{ city: 'Lomaunaghroe (Galway)', zip: '876802' },
	{ city: 'Lombardstown (Cork)', zip: '706091' },
	{ city: 'Lombardstown (Limerick)', zip: '398710' },
	{ city: 'Lomcloon (Sligo)', zip: '369405' },
	{ city: 'Lonagh (Cork)', zip: '983648' },
	{ city: 'Lonart (Kerry)', zip: '577127' },
	{ city: 'Long (Cavan)', zip: '791862' },
	{ city: 'Longacre (Cork)', zip: '588389' },
	{ city: 'Longfield (Cavan)', zip: '953311' },
	{ city: 'Longfield (Donegal)', zip: '722711' },
	{ city: 'Longfield (Kerry)', zip: '270312' },
	{ city: 'Longfield (Leitrim)', zip: '798715' },
	{ city: 'Longfield (Longford)', zip: '925297' },
	{ city: 'Longfield (Mayo)', zip: '146068' },
	{ city: 'Longfield (Monaghan)', zip: '140449' },
	{ city: 'Longfield (Roscommon)', zip: '324430' },
	{ city: 'Longfield (Tipperary)', zip: '207744' },
	{ city: 'Longfield Etra (Monaghan)', zip: '687141' },
	{ city: 'Longfield Otra (Monaghan)', zip: '895967' },
	{ city: 'Longford (Galway)', zip: '282930' },
	{ city: 'Longford (Laois)', zip: '605981' },
	{ city: 'Longford (Longford)', zip: '347456' },
	{ city: 'Longford (Mayo)', zip: '495725' },
	{ city: 'Longford (Meath)', zip: '706900' },
	{ city: 'Longford (Offaly)', zip: '892459' },
	{ city: 'Longford (Roscommon)', zip: '793363' },
	{ city: 'Longford (Tipperary)', zip: '283247' },
	{ city: 'Longford Big (Offaly)', zip: '211098' },
	{ city: 'Longford Demesne (Sligo)', zip: '737276' },
	{ city: 'Longford East (Limerick)', zip: '875957' },
	{ city: 'Longford Little (Offaly)', zip: '206344' },
	{ city: 'Longfordpass East (Tipperary)', zip: '550234' },
	{ city: 'Longfordpass North (Tipperary)', zip: '854961' },
	{ city: 'Longfordpass South (Tipperary)', zip: '895076' },
	{ city: 'Longford West (Limerick)', zip: '602616' },
	{ city: 'Longfordwood (Tipperary)', zip: '847924' },
	{ city: 'Longgraigue (Wexford)', zip: '875556' },
	{ city: 'Longhill (Donegal)', zip: '585469' },
	{ city: 'Longhill Commons (Wicklow)', zip: '186935' },
	{ city: 'Long Island (Cork)', zip: '926198' },
	{ city: 'Long Island (Roscommon)', zip: '131104' },
	{ city: "Longjohn'shill (Tipperary)", zip: '649815' },
	{ city: 'Longnamuck (Roscommon)', zip: '515808' },
	{ city: 'Longorchard (Tipperary)', zip: '513667' },
	{ city: 'Longridge (Wexford)', zip: '983502' },
	{ city: 'Long Rock (Donegal)', zip: '704087' },
	{ city: 'Longship Rock (Waterford)', zip: '895975' },
	{ city: 'Longstone (Cork)', zip: '390373' },
	{ city: 'Longstone (Kildare)', zip: '569807' },
	{ city: 'Longstone (Limerick)', zip: '730900' },
	{ city: 'Longstone (Tipperary)', zip: '844553' },
	{ city: 'Longstones (Leitrim)', zip: '876118' },
	{ city: 'Longstones (Louth)', zip: '157764' },
	{ city: 'Longstown (Cork)', zip: '233858' },
	{ city: 'Longtown (Kildare)', zip: '683591' },
	{ city: 'Longtown (Meath)', zip: '306670' },
	{ city: 'Longtown Demesne (Kildare)', zip: '718084' },
	{ city: 'Longtown North (Kildare)', zip: '247159' },
	{ city: 'Longtown South (Kildare)', zip: '586172' },
	{ city: 'Longueville (Cork)', zip: '973685' },
	{ city: 'Longueville North (Cork)', zip: '669983' },
	{ city: 'Longueville South (Cork)', zip: '847130' },
	{ city: 'Longwood (Meath)', zip: '593320' },
	{ city: 'Lonnogs (Cavan)', zip: '649778' },
	{ city: 'Looart (Monaghan)', zip: '709662' },
	{ city: 'Loobnamuck (Mayo)', zip: '937651' },
	{ city: 'Loobroe (Galway)', zip: '804881' },
	{ city: 'Loona Beg (Mayo)', zip: '283964' },
	{ city: 'Loonaghtan (Galway)', zip: '594929' },
	{ city: 'Loona More (Mayo)', zip: '892245' },
	{ city: 'Loortan (Cavan)', zip: '639091' },
	{ city: 'Looscaun (Galway)', zip: '554381' },
	{ city: 'Looscaunagh (Kerry)', zip: '703467' },
	{ city: 'Loran (Tipperary)', zip: '100209' },
	{ city: 'Lordstown (Meath)', zip: '768908' },
	{ city: 'Lorrha (Tipperary)', zip: '305219' },
	{ city: 'Lorrug (Wicklow)', zip: '764626' },
	{ city: 'Lorum (Carlow)', zip: '425926' },
	{ city: 'Loskeran (Waterford)', zip: '461777' },
	{ city: 'Losset (Cavan)', zip: '201040' },
	{ city: 'Losset (Donegal)', zip: '279658' },
	{ city: 'Losset (Meath)', zip: '714837' },
	{ city: 'Losset (Monaghan)', zip: '945254' },
	{ city: 'Losset (Tipperary)', zip: '745841' },
	{ city: 'Lossetkillew (Cavan)', zip: '807680' },
	{ city: 'Lossets (Monaghan)', zip: '723011' },
	{ city: 'Lota More (Cork)', zip: '206941' },
	{ city: 'Lotteragh Lower (Limerick)', zip: '873052' },
	{ city: 'Lotteragh Upper (Limerick)', zip: '534363' },
	{ city: 'Lough (Kerry)', zip: '874276' },
	{ city: 'Lough (Kilkenny)', zip: '580884' },
	{ city: 'Lough (Laois)', zip: '197463' },
	{ city: 'Lough (Wexford)', zip: '507189' },
	{ city: 'Loughabor (Kildare)', zip: '178733' },
	{ city: 'Loughaclerybeg (Galway)', zip: '358384' },
	{ city: 'Loughaconeera (Galway)', zip: '604225' },
	{ city: 'Loughaconnick (Cavan)', zip: '207370' },
	{ city: 'Loughacutteen (Tipperary)', zip: '628049' },
	{ city: 'Loughaderry (Cork)', zip: '811471' },
	{ city: 'Loughadoon (Kerry)', zip: '998292' },
	{ city: 'Loughagannon (Donegal)', zip: '988779' },
	{ city: 'Loughagar Beg (Westmeath)', zip: '227535' },
	{ city: 'Loughagar More (Westmeath)', zip: '202370' },
	{ city: 'Loughagher (Donegal)', zip: '124237' },
	{ city: 'Loughakeo (Laois)', zip: '839938' },
	{ city: 'Loughan (Cavan)', zip: '565741' },
	{ city: 'Loughan (Longford)', zip: '311319' },
	{ city: 'Loughan (Meath)', zip: '468528' },
	{ city: 'Loughan (Offaly)', zip: '464656' },
	{ city: 'Loughan (Westmeath)', zip: '278038' },
	{ city: 'Loughanaganky (Mayo)', zip: '983953' },
	{ city: 'Loughanagore (Westmeath)', zip: '617202' },
	{ city: 'Loughanalla (Westmeath)', zip: '368809' },
	{ city: 'Loughananna (Limerick)', zip: '485165' },
	{ city: 'Loughanaskin (Westmeath)', zip: '844530' },
	{ city: 'Loughanavagh (Westmeath)', zip: '225893' },
	{ city: 'Loughanavally (Westmeath)', zip: '250308' },
	{ city: 'Loughanavatta (Tipperary)', zip: '564540' },
	{ city: 'Loughanboy (Mayo)', zip: '838473' },
	{ city: 'Loughanbrean (Meath)', zip: '166367' },
	{ city: 'Loughanderg (Meath)', zip: '102782' },
	{ city: 'Loughandonning (Westmeath)', zip: '488291' },
	{ city: 'Loughandys (Kildare)', zip: '790873' },
	{ city: 'Loughane (Cork)', zip: '329344' },
	{ city: 'Loughane Beg (Cork)', zip: '803367' },
	{ city: 'Loughane East (Cork)', zip: '832002' },
	{ city: 'Loughane Lower (Tipperary)', zip: '661488' },
	{ city: 'Loughanelteen (Sligo)', zip: '313415' },
	{ city: 'Loughane More (Cork)', zip: '423458' },
	{ city: 'Loughanes (Kerry)', zip: '895335' },
	{ city: 'Loughane Upper (Tipperary)', zip: '744368' },
	{ city: 'Loughane West (Cork)', zip: '810563' },
	{ city: 'Loughaniska (Waterford)', zip: '669349' },
	{ city: 'Loughanleagh (Limerick)', zip: '567720' },
	{ city: 'Loughanlewnaght (Westmeath)', zip: '804938' },
	{ city: 'Loughanmore (Louth)', zip: '586932' },
	{ city: 'Loughannacrannoge (Sligo)', zip: '672102' },
	{ city: 'Loughanspark (Galway)', zip: '782222' },
	{ city: 'Loughanstown (Limerick)', zip: '737654' },
	{ city: 'Loughanstown (Meath)', zip: '870478' },
	{ city: 'Loughanstown (Westmeath)', zip: '463872' },
	{ city: 'Loughanstown Lower (Westmeath)', zip: '890742' },
	{ city: 'Loughantarve (Louth)', zip: '505586' },
	{ city: 'Loughanunna (Waterford)', zip: '598995' },
	{ city: 'Loughanure (Donegal)', zip: '721554' },
	{ city: 'Loughanure Commons (Kildare)', zip: '565091' },
	{ city: 'Loughaphonta (Leitrim)', zip: '815024' },
	{ city: 'Loughaphonta Barr (Leitrim)', zip: '854498' },
	{ city: 'Loughaphreaghaun (Cork)', zip: '817830' },
	{ city: 'Loughard (Wexford)', zip: '642761' },
	{ city: 'Lougharuane (Cork)', zip: '123005' },
	{ city: 'Loughaskerry (Donegal)', zip: '630723' },
	{ city: 'Loughatalia (Cork)', zip: '555168' },
	{ city: 'Loughatorick North (Galway)', zip: '675070' },
	{ city: 'Loughatorick South (Galway)', zip: '411846' },
	{ city: 'Loughaun (Galway)', zip: '588212' },
	{ city: 'Loughaun (Limerick)', zip: '527011' },
	{ city: 'Loughaun (Offaly)', zip: '231663' },
	{ city: 'Loughaun (Tipperary)', zip: '866522' },
	{ city: 'Loughauna (Galway)', zip: '704312' },
	{ city: 'Loughaunacreen (Kerry)', zip: '702007' },
	{ city: 'Loughaunawadda (Galway)', zip: '521225' },
	{ city: 'Loughaunbeg (Galway)', zip: '571907' },
	{ city: 'Loughaunboy (Galway)', zip: '273446' },
	{ city: 'Loughaunbrean (Galway)', zip: '888018' },
	{ city: 'Loughaunenaghan (Galway)', zip: '914671' },
	{ city: 'Loughaunnaman (Mayo)', zip: '360652' },
	{ city: 'Loughaunnavaag (Galway)', zip: '306649' },
	{ city: 'Loughaunnaweelaun (Clare)', zip: '420850' },
	{ city: 'Loughaun North (Clare)', zip: '505023' },
	{ city: 'Loughaunroe East (Galway)', zip: '781939' },
	{ city: 'Loughaunroe West (Galway)', zip: '176360' },
	{ city: 'Loughaun South (Clare)', zip: '826401' },
	{ city: 'Loughavaul (Cork)', zip: '590680' },
	{ city: 'Loughawee (Galway)', zip: '636441' },
	{ city: 'Loughbally (Roscommon)', zip: '697186' },
	{ city: 'Loughbarn (Dublin)', zip: '202299' },
	{ city: 'Loughbarra (Donegal)', zip: '615221' },
	{ city: 'Loughbeg (Cork)', zip: '599802' },
	{ city: 'Loughbeg (Kerry)', zip: '188685' },
	{ city: 'Loughbeg (Kilkenny)', zip: '158394' },
	{ city: 'Loughbeg (Tipperary)', zip: '999270' },
	{ city: 'Loughbollard Commons (Kildare)', zip: '811889' },
	{ city: 'Loughboreen (Kilkenny)', zip: '776220' },
	{ city: 'Loughborough (Clare)', zip: '264628' },
	{ city: 'Loughbown (Galway)', zip: '163406' },
	{ city: 'Loughboy (Kilkenny)', zip: '316115' },
	{ city: 'Loughbrack (Tipperary)', zip: '608949' },
	{ city: 'Loughbrackan (Meath)', zip: '660333' },
	{ city: 'Loughbrattoge (Monaghan)', zip: '555199' },
	{ city: 'Loughbrown (Kildare)', zip: '370939' },
	{ city: 'Loughburke (Clare)', zip: '214887' },
	{ city: 'Loughburke (Galway)', zip: '230260' },
	{ city: 'Loughcapple (Tipperary)', zip: '668969' },
	{ city: 'Loughcarrick Island (Galway)', zip: '745292' },
	{ city: 'Lough Common (Dublin)', zip: '817974' },
	{ city: 'Loughconway (Leitrim)', zip: '409495' },
	{ city: 'Loughcrew (Meath)', zip: '574747' },
	{ city: 'Loughcrillan (Donegal)', zip: '383255' },
	{ city: 'Loughcrot (Cork)', zip: '181724' },
	{ city: 'Loughcuill (Donegal)', zip: '579956' },
	{ city: 'Loughcurra North (Galway)', zip: '690900' },
	{ city: 'Loughcurra South (Galway)', zip: '699502' },
	{ city: 'Lough Cutra Demesne (Galway)', zip: '309352' },
	{ city: 'Loughdawan (Cavan)', zip: '652339' },
	{ city: 'Loughdeeveen (Cork)', zip: '656084' },
	{ city: 'Loughdeheen (Waterford)', zip: '522421' },
	{ city: 'Loughderryduff (Donegal)', zip: '640600' },
	{ city: 'Loughdoo (Donegal)', zip: '363490' },
	{ city: 'Loughdooly (Cavan)', zip: '660287' },
	{ city: 'Loughduff (Cavan)', zip: '610198' },
	{ city: 'Lougheagle (Cork)', zip: '664723' },
	{ city: 'Lougheask Demesne (Donegal)', zip: '532918' },
	{ city: 'Lougher (Kerry)', zip: '891157' },
	{ city: 'Lougher (Meath)', zip: '359754' },
	{ city: 'Lougheraherk (Donegal)', zip: '683747' },
	{ city: 'Lougherbraghy (Donegal)', zip: '269017' },
	{ city: 'Lougherrig (Donegal)', zip: '383102' },
	{ city: 'Loughfad (Donegal)', zip: '509286' },
	{ city: 'Loughfarm (Longford)', zip: '725517' },
	{ city: 'Loughfeedora (Tipperary)', zip: '673190' },
	{ city: 'Loughgerald (Wexford)', zip: '566637' },
	{ city: 'Loughglinn (Roscommon)', zip: '760080' },
	{ city: 'Loughglinn Demesne (Roscommon)', zip: '531016' },
	{ city: 'Loughgunnen Great (Wexford)', zip: '659786' },
	{ city: 'Loughgunnen Little (Wexford)', zip: '468396' },
	{ city: 'Loughgur (Limerick)', zip: '902636' },
	{ city: 'Lough Hill (Donegal)', zip: '169786' },
	{ city: 'Loughill (Kilkenny)', zip: '334876' },
	{ city: 'Loughinch (Galway)', zip: '189188' },
	{ city: 'Loughkeen (Tipperary)', zip: '271406' },
	{ city: 'Loughkent East (Tipperary)', zip: '608415' },
	{ city: 'Loughkent Lower (Tipperary)', zip: '763938' },
	{ city: 'Loughkent West (Tipperary)', zip: '813089' },
	{ city: 'Loughkip (Donegal)', zip: '591814' },
	{ city: 'Loughlackagh (Roscommon)', zip: '323832' },
	{ city: 'Loughlahan (Tipperary)', zip: '183358' },
	{ city: 'Loughland (Dublin)', zip: '446006' },
	{ city: 'Loughlass (Laois)', zip: '974836' },
	{ city: 'Loughlea (Cork)', zip: '977312' },
	{ city: 'Loughleigh (Cork)', zip: '234055' },
	{ city: 'Loughlin Island (Donegal)', zip: '934628' },
	{ city: 'Loughlinnan (Cavan)', zip: '969721' },
	{ city: 'Loughlinstown (Dublin)', zip: '661870' },
	{ city: 'Loughlinstown (Kildare)', zip: '190405' },
	{ city: 'Loughlinstown (Meath)', zip: '737081' },
	{ city: 'Loughlinstown Commons (Dublin)', zip: '100852' },
	{ city: 'Loughlion (Kildare)', zip: '392240' },
	{ city: 'Loughlohery (Tipperary)', zip: '977911' },
	{ city: 'Loughmacask (Kilkenny)', zip: '300830' },
	{ city: 'Loughmain (Dublin)', zip: '525847' },
	{ city: 'Loughmansland Glebe (Laois)', zip: '770903' },
	{ city: 'Loughmarsh (Cork)', zip: '199032' },
	{ city: 'Loughmerans (Kilkenny)', zip: '876187' },
	{ city: 'Loughminane (Kildare)', zip: '247112' },
	{ city: 'Loughmoe (Tipperary)', zip: '722456' },
	{ city: 'Loughmogue Lower (Wicklow)', zip: '969521' },
	{ city: 'Loughmogue Upper (Wicklow)', zip: '210108' },
	{ city: 'Loughmore (Waterford)', zip: '845336' },
	{ city: 'Loughmore Common (Limerick)', zip: '441792' },
	{ city: 'Loughmorne (Monaghan)', zip: '223560' },
	{ city: 'Loughmuck (Donegal)', zip: '811064' },
	{ city: 'Loughmuilt (Donegal)', zip: '505529' },
	{ city: 'Loughmuirran (Leitrim)', zip: '322100' },
	{ city: 'Loughnacappagh (Kerry)', zip: '733367' },
	{ city: 'Loughnacush (Kildare)', zip: '835815' },
	{ city: 'Loughnafin (Cavan)', zip: '400678' },
	{ city: 'Loughnafina (Tipperary)', zip: '456896' },
	{ city: 'Loughnageer (Wexford)', zip: '189937' },
	{ city: 'Loughnagin (Donegal)', zip: '812079' },
	{ city: 'Loughnagore (Kerry)', zip: '269156' },
	{ city: 'Loughnagowan (Clare)', zip: '938370' },
	{ city: 'Loughnahelly (Mayo)', zip: '672384' },
	{ city: 'Loughnahilly (Cork)', zip: '455001' },
	{ city: 'Loughnakey (Donegal)', zip: '830692' },
	{ city: 'Loughnalughraman (Donegal)', zip: '177876' },
	{ city: 'Loughnambraddan (Donegal)', zip: '303113' },
	{ city: 'Loughnamuck (Laois)', zip: '897484' },
	{ city: 'Loughnamucka (Mayo)', zip: '104635' },
	{ city: 'Loughnaneane (Roscommon)', zip: '626257' },
	{ city: 'Loughnasollis Lower (Waterford)', zip: '727807' },
	{ city: 'Loughnasollis Upper (Waterford)', zip: '641826' },
	{ city: 'Loughnatouse (Waterford)', zip: '988493' },
	{ city: 'Loughooly (Kilkenny)', zip: '186857' },
	{ city: 'Loughoony (Monaghan)', zip: '883826' },
	{ city: 'Loughourna (Tipperary)', zip: '621687' },
	{ city: 'Loughpark (Galway)', zip: '942379' },
	{ city: 'Loughpark (Mayo)', zip: '205609' },
	{ city: 'Loughpark (Tipperary)', zip: '923089' },
	{ city: 'Loughpark (Westmeath)', zip: '225031' },
	{ city: 'Loughquin (Cork)', zip: '991000' },
	{ city: 'Loughrask (Clare)', zip: '836099' },
	{ city: 'Loughrea (Galway)', zip: '442206' },
	{ city: 'Loughroe (Offaly)', zip: '736702' },
	{ city: 'Loughros (Leitrim)', zip: '797379' },
	{ city: 'Loughros Glebe (Donegal)', zip: '635527' },
	{ city: 'Loughrusheen (Mayo)', zip: '568518' },
	{ city: 'Loughsallagh (Donegal)', zip: '250326' },
	{ city: 'Loughsallagh (Meath)', zip: '947583' },
	{ city: 'Loughsalt (Donegal)', zip: '376469' },
	{ city: 'Loughscur (Leitrim)', zip: '652986' },
	{ city: 'Loughsheedan (Longford)', zip: '877534' },
	{ city: 'Loughshinny (Dublin)', zip: '320861' },
	{ city: 'Loughsollish (Kilkenny)', zip: '403162' },
	{ city: 'Loughstown (Westmeath)', zip: '346266' },
	{ city: 'Loughtally (Tipperary)', zip: '155882' },
	{ city: 'Loughtate (Louth)', zip: '985061' },
	{ city: 'Loughteeog (Laois)', zip: '850391' },
	{ city: 'Loughtown (Kildare)', zip: '759450' },
	{ city: 'Loughtown Lower (Dublin)', zip: '529321' },
	{ city: 'Loughtown Upper (Dublin)', zip: '593128' },
	{ city: 'Loughturk East (Galway)', zip: '411159' },
	{ city: 'Loughturk West (Galway)', zip: '168545' },
	{ city: 'Loughultan (Donegal)', zip: '514383' },
	{ city: 'Loughvella (Clare)', zip: '612635' },
	{ city: 'Loughwheelion (Offaly)', zip: '220912' },
	{ city: 'Louisburgh (Mayo)', zip: '232313' },
	{ city: 'Loumanagh North (Cork)', zip: '347055' },
	{ city: 'Loumanagh South (Cork)', zip: '722147' },
	{ city: 'Lounaghan (Kerry)', zip: '649750' },
	{ city: 'Lousybush (Kilkenny)', zip: '675347' },
	{ city: 'Louth (Louth)', zip: '741242' },
	{ city: 'Louth Hall (Louth)', zip: '207323' },
	{ city: 'Lowberry (Roscommon)', zip: '324656' },
	{ city: 'Lowerheath (Offaly)', zip: '841615' },
	{ city: 'Lower Maymore (Donegal)', zip: '732434' },
	{ city: 'Lowerton Beg (Offaly)', zip: '756634' },
	{ city: 'Lowerton More (Offaly)', zip: '720506' },
	{ city: 'Lowertown (Cork)', zip: '623050' },
	{ city: 'Lowertown (Monaghan)', zip: '741917' },
	{ city: 'Lowertown (Westmeath)', zip: '509511' },
	{ city: 'Lowerwood (Westmeath)', zip: '656978' },
	{ city: 'Lowesgreen (Tipperary)', zip: '657637' },
	{ city: 'Lowfield (Roscommon)', zip: '605080' },
	{ city: 'Lowlough (Wexford)', zip: '636731' },
	{ city: 'Lowpark (Galway)', zip: '747039' },
	{ city: 'Lowpark (Mayo)', zip: '735436' },
	{ city: 'Lowpark (Westmeath)', zip: '619299' },
	{ city: 'Lowparks (Roscommon)', zip: '920463' },
	{ city: 'Lowran (Laois)', zip: '285624' },
	{ city: 'Lowrath North (Louth)', zip: '925663' },
	{ city: 'Lowrath South (Louth)', zip: '387758' },
	{ city: 'Lowtown (Kildare)', zip: '966481' },
	{ city: 'Lowtown (Westmeath)', zip: '231143' },
	{ city: 'Lowtown (Wicklow)', zip: '424843' },
	{ city: 'Lowtown Kilcashel (Roscommon)', zip: '827193' },
	{ city: 'Lowville (Galway)', zip: '825761' },
	{ city: 'Loyer (Offaly)', zip: '941784' },
	{ city: 'Loyst (Monaghan)', zip: '555264' },
	{ city: 'Luaghnabrogue (Donegal)', zip: '878130' },
	{ city: 'Lucan (Dublin)', zip: '452815' },
	{ city: 'Lucan And Pettycannon (Dublin)', zip: '232842' },
	{ city: 'Lucan Demesne (Dublin)', zip: '312571' },
	{ city: "Lucas's Park (Wexford)", zip: '867282' },
	{ city: 'Luddan (Donegal)', zip: '860985' },
	{ city: 'Luddenbeg (Limerick)', zip: '934531' },
	{ city: 'Luddenmore (Limerick)', zip: '535663' },
	{ city: 'Luffany (Kilkenny)', zip: '353547' },
	{ city: 'Luffertan (Sligo)', zip: '589497' },
	{ city: 'Luffertaun (Mayo)', zip: '205432' },
	{ city: 'Lug (Offaly)', zip: '116632' },
	{ city: 'Lugacaha (Sligo)', zip: '796250' },
	{ city: 'Lugacaha (Westmeath)', zip: '765236' },
	{ city: 'Lugadoo (Kildare)', zip: '820912' },
	{ city: 'Lugadowden (Kildare)', zip: '636245' },
	{ city: 'Lugakeeran (Roscommon)', zip: '814733' },
	{ city: 'Lugalisheen North (Mayo)', zip: '691299' },
	{ city: 'Lugalisheen South (Mayo)', zip: '564680' },
	{ city: 'Lugalustran (Leitrim)', zip: '300073' },
	{ city: 'Lugamarla (Offaly)', zip: '312812' },
	{ city: 'Luganiska (Offaly)', zip: '962646' },
	{ city: 'Lugaphuill (Mayo)', zip: '458647' },
	{ city: 'Lugasnaghta (Leitrim)', zip: '874413' },
	{ city: 'Lugatallin (Mayo)', zip: '537407' },
	{ city: 'Lugateane (Roscommon)', zip: '178646' },
	{ city: 'Lugatemple (Mayo)', zip: '919697' },
	{ city: 'Lugatober (Sligo)', zip: '303090' },
	{ city: 'Lugatryna (Wicklow)', zip: '797375' },
	{ city: 'Lugawarry (Sligo)', zip: '109570' },
	{ city: 'Lugbaun (Sligo)', zip: '658100' },
	{ city: 'Lugboy (Roscommon)', zip: '247570' },
	{ city: 'Lugboy Demesne (Mayo)', zip: '405627' },
	{ city: 'Lugbrack (Mayo)', zip: '621667' },
	{ city: 'Lugbriscan (Louth)', zip: '180841' },
	{ city: 'Lugdoon (Sligo)', zip: '703876' },
	{ city: 'Lugduff (Wicklow)', zip: '983580' },
	{ city: 'Lugfree (Cork)', zip: '339886' },
	{ city: 'Lugg (Dublin)', zip: '320215' },
	{ city: 'Luggacurren (Laois)', zip: '146916' },
	{ city: 'Luggakeeraun (Galway)', zip: '881609' },
	{ city: 'Lugganaffrin (Galway)', zip: '905337' },
	{ city: 'Lugganammer (Leitrim)', zip: '577223' },
	{ city: 'Lugganashlere (Mayo)', zip: '571589' },
	{ city: 'Lugganimma (Galway)', zip: '908246' },
	{ city: 'Luggatarriff (Galway)', zip: '236193' },
	{ city: 'Luggawannia (Galway)', zip: '962341' },
	{ city: 'Lugglass (Offaly)', zip: '997452' },
	{ city: 'Lugglass Lower (Wicklow)', zip: '225063' },
	{ city: 'Lugglass Upper (Wicklow)', zip: '638717' },
	{ city: 'Luggs (Roscommon)', zip: '589248' },
	{ city: 'Luggygalla (Westmeath)', zip: '211373' },
	{ city: 'Lughanagh (Galway)', zip: '496259' },
	{ city: 'Lughawnagh (Leitrim)', zip: '794914' },
	{ city: 'Lugher (Donegal)', zip: '305686' },
	{ city: 'Lughil (Kildare)', zip: '406277' },
	{ city: 'Lughinny (Kilkenny)', zip: '428427' },
	{ city: 'Lughveen (Donegal)', zip: '952942' },
	{ city: 'Lugmeeltan (Leitrim)', zip: '777827' },
	{ city: 'Lugmeen (Leitrim)', zip: '922868' },
	{ city: 'Lugmore (Dublin)', zip: '610458' },
	{ city: 'Lugmore (Leitrim)', zip: '957710' },
	{ city: 'Lugmore (Offaly)', zip: '966118' },
	{ city: 'Lugnadeffa (Sligo)', zip: '637890' },
	{ city: 'Lugnafahy (Mayo)', zip: '378413' },
	{ city: 'Lugnafaughery (Leitrim)', zip: '638312' },
	{ city: 'Lugnagall (Sligo)', zip: '341764' },
	{ city: 'Lugnagappul (Kerry)', zip: '695672' },
	{ city: 'Lugnagon (Leitrim)', zip: '694742' },
	{ city: 'Lugnagroagh (Wicklow)', zip: '940697' },
	{ city: 'Lugnagullagh (Westmeath)', zip: '838453' },
	{ city: 'Lugnagun Great (Wicklow)', zip: '887112' },
	{ city: 'Lugnagun Little (Wicklow)', zip: '594432' },
	{ city: 'Lugnalettin (Mayo)', zip: '404092' },
	{ city: 'Lugnamackan (Sligo)', zip: '223497' },
	{ city: 'Lugnamannow (Mayo)', zip: '325934' },
	{ city: 'Lugnaquillia (Wicklow)', zip: '481375' },
	{ city: 'Lugnashammer (Roscommon)', zip: '344075' },
	{ city: 'Lugnaskeehan (Leitrim)', zip: '228116' },
	{ city: 'Lugnavaddoge (Mayo)', zip: '949399' },
	{ city: 'Lugrevagh (Mayo)', zip: '847440' },
	{ city: 'Luimnagh East (Galway)', zip: '236523' },
	{ city: 'Luimnagh West (Galway)', zip: '298161' },
	{ city: 'Lullybeg (Kildare)', zip: '814089' },
	{ city: 'Lullymore East (Kildare)', zip: '372743' },
	{ city: 'Lullymore West (Kildare)', zip: '527173' },
	{ city: 'Lumcloon (Carlow)', zip: '763613' },
	{ city: 'Lumcloon (Offaly)', zip: '727811' },
	{ city: 'Lumcloon (Wicklow)', zip: '275993' },
	{ city: 'Lumnagh Beg (Cork)', zip: '854612' },
	{ city: 'Lumnagh More (Cork)', zip: '691584' },
	{ city: 'Lumville (Offaly)', zip: '614256' },
	{ city: 'Lunderstown (Meath)', zip: '636642' },
	{ city: 'Lunestown (Westmeath)', zip: '974282' },
	{ city: 'Lung (Roscommon)', zip: '337018' },
	{ city: 'Lunniagh (Donegal)', zip: '564381' },
	{ city: 'Luogh North (Clare)', zip: '917670' },
	{ city: 'Luogh South (Clare)', zip: '152185' },
	{ city: 'Luppan (Monaghan)', zip: '174807' },
	{ city: 'Lure (Kerry)', zip: '237998' },
	{ city: 'Lurga (Galway)', zip: '393757' },
	{ city: 'Lurga (Leitrim)', zip: '613880' },
	{ city: 'Lurga (Mayo)', zip: '225241' },
	{ city: 'Lurga (Roscommon)', zip: '162654' },
	{ city: 'Lurgabaun (Galway)', zip: '978895' },
	{ city: 'Lurgaboy (Roscommon)', zip: '978862' },
	{ city: 'Lurgabrack (Donegal)', zip: '196629' },
	{ city: 'Lurgachamlough (Monaghan)', zip: '149890' },
	{ city: 'Lurgacloghan (Donegal)', zip: '335483' },
	{ city: 'Lurgacloy (Mayo)', zip: '634493' },
	{ city: 'Lurga Lower (Mayo)', zip: '353574' },
	{ city: 'Lurgan (Cavan)', zip: '779215' },
	{ city: 'Lurgan (Donegal)', zip: '967827' },
	{ city: 'Lurgan (Galway)', zip: '184817' },
	{ city: 'Lurgan (Leitrim)', zip: '264527' },
	{ city: 'Lurgan (Longford)', zip: '717854' },
	{ city: 'Lurgan (Mayo)', zip: '736380' },
	{ city: 'Lurgan (Offaly)', zip: '590630' },
	{ city: 'Lurgan (Roscommon)', zip: '974492' },
	{ city: 'Lurgan (Sligo)', zip: '456044' },
	{ city: 'Lurgan (Westmeath)', zip: '960469' },
	{ city: 'Lurgananure (Cavan)', zip: '767125' },
	{ city: 'Lurganaveele (Cavan)', zip: '548916' },
	{ city: 'Lurganbane (Cavan)', zip: '799455' },
	{ city: 'Lurgan Beg (Galway)', zip: '732753' },
	{ city: 'Lurganboy (Cavan)', zip: '818408' },
	{ city: 'Lurganboy (Donegal)', zip: '786661' },
	{ city: 'Lurganboy (Louth)', zip: '418495' },
	{ city: 'Lurganboy (Meath)', zip: '257321' },
	{ city: 'Lurganboy (Monaghan)', zip: '284620' },
	{ city: 'Lurganboys (Monaghan)', zip: '312146' },
	{ city: 'Lurganbrack (Donegal)', zip: '612065' },
	{ city: 'Lurgandarragh (Mayo)', zip: '556774' },
	{ city: 'Lurganearly (Monaghan)', zip: '521855' },
	{ city: 'Lurgan Glebe (Cavan)', zip: '329600' },
	{ city: 'Lurgan Great (Galway)', zip: '570704' },
	{ city: 'Lurgangreen (Monaghan)', zip: '636109' },
	{ city: 'Lurgankeel (Louth)', zip: '668743' },
	{ city: 'Lurgan Little (Galway)', zip: '361274' },
	{ city: 'Lurganmore (Monaghan)', zip: '192966' },
	{ city: 'Lurgan More (Galway)', zip: '333537' },
	{ city: 'Lurgans (Monaghan)', zip: '138887' },
	{ city: 'Lurganshannagh (Donegal)', zip: '957772' },
	{ city: 'Lurganshanny (Galway)', zip: '549703' },
	{ city: 'Lurga Upper (Mayo)', zip: '541547' },
	{ city: 'Lurgoe (Tipperary)', zip: '607466' },
	{ city: 'Lurgy (Donegal)', zip: '207621' },
	{ city: 'Lurgybrack (Donegal)', zip: '248752' },
	{ city: 'Lurraga (Clare)', zip: '763754' },
	{ city: 'Lurraga (Limerick)', zip: '313573' },
	{ city: 'Lurraga (Roscommon)', zip: '826937' },
	{ city: 'Lurrig (Cork)', zip: '611820' },
	{ city: 'Lurrig (Westmeath)', zip: '657610' },
	{ city: 'Lurriga (Cork)', zip: '681130' },
	{ city: 'Lushkinnagh (Kilkenny)', zip: '691734' },
	{ city: 'Lusk (Dublin)', zip: '362676' },
	{ city: 'Luskanargid (Waterford)', zip: '971663' },
	{ city: 'Lusteen Beg (Mayo)', zip: '335040' },
	{ city: 'Lusteenbeg Rocks (Mayo)', zip: '310490' },
	{ city: 'Lusteen More (Mayo)', zip: '689197' },
	{ city: 'Lustia (Leitrim)', zip: '300852' },
	{ city: 'Lustia (Roscommon)', zip: '898167' },
	{ city: 'Lustown (Meath)', zip: '852439' },
	{ city: 'Lyan (Clare)', zip: '549177' },
	{ city: 'Lyanmore (Longford)', zip: '878308' },
	{ city: 'Lybagh (Wicklow)', zip: '917270' },
	{ city: 'Lybe (Cork)', zip: '972447' },
	{ city: 'Lybes (Kerry)', zip: '374772' },
	{ city: 'Lydacan (Galway)', zip: '975408' },
	{ city: 'Lyle (Sligo)', zip: '798515' },
	{ city: 'Lynaghstown (Meath)', zip: '473492' },
	{ city: 'Lynally Glebe (Offaly)', zip: '794104' },
	{ city: 'Lynamsgarden (Kildare)', zip: '426482' },
	{ city: 'Lynchsacres (Mayo)', zip: '835641' },
	{ city: 'Lyneen (Longford)', zip: '978214' },
	{ city: 'Lynn (Westmeath)', zip: '669913' },
	{ city: 'Lyons (Kildare)', zip: '258594' },
	{ city: 'Lyons (Kilkenny)', zip: '565368' },
	{ city: 'Lyonstown (Roscommon)', zip: '356665' },
	{ city: 'Lyonstown (Tipperary)', zip: '762783' },
	{ city: 'Lyracrumpane (Kerry)', zip: '725757' },
	{ city: 'Lyradane (Cork)', zip: '479183' },
	{ city: 'Lyragh (Cork)', zip: '371049' },
	{ city: 'Lyrane (Wexford)', zip: '676121' },
	{ city: 'Lyraneag (Cork)', zip: '968652' },
	{ city: 'Lyranearla (Waterford)', zip: '801618' },
	{ city: 'Lyranes Lower (Kerry)', zip: '782317' },
	{ city: 'Lyranes Upper (Kerry)', zip: '203538' },
	{ city: 'Lyrath (Kilkenny)', zip: '534943' },
	{ city: 'Lyrattin (Waterford)', zip: '516906' },
	{ city: 'Lyravarrig (Cork)', zip: '198605' },
	{ city: 'Lyravuckane (Cork)', zip: '391134' },
	{ city: 'Lyre (Cork)', zip: '690620' },
	{ city: 'Lyre (Kerry)', zip: '974718' },
	{ city: 'Lyre (Limerick)', zip: '829897' },
	{ city: 'Lyre (Tipperary)', zip: '201420' },
	{ city: 'Lyre (Waterford)', zip: '875915' },
	{ city: 'Lyre (Wexford)', zip: '896059' },
	{ city: 'Lyreboy (Kerry)', zip: '917220' },
	{ city: 'Lyredaowen (Cork)', zip: '270639' },
	{ city: 'Lyre East (Waterford)', zip: '748276' },
	{ city: 'Lyreen (Cork)', zip: '554245' },
	{ city: 'Lyrefune (Tipperary)', zip: '629623' },
	{ city: 'Lyremountain (Cork)', zip: '770515' },
	{ city: 'Lyremountain (Waterford)', zip: '255428' },
	{ city: 'Lyrenacallee East (Waterford)', zip: '233496' },
	{ city: 'Lyrenacallee West (Waterford)', zip: '426402' },
	{ city: 'Lyrenacarriga (Waterford)', zip: '780309' },
	{ city: 'Lyrenageeha (Cork)', zip: '464867' },
	{ city: 'Lyrenaglogh (Waterford)', zip: '726220' },
	{ city: 'Lyrenamon (Cork)', zip: '163148' },
	{ city: 'Lyre West (Waterford)', zip: '380992' },
	{ city: 'Lyroe (Cork)', zip: '592290' },
	{ city: 'Lyroge (Laois)', zip: '255754' },
	{ city: 'Lysaghtstown (Cork)', zip: '212897' },
	{ city: 'Lysterfield (Roscommon)', zip: '459312' },
	{ city: 'Maas (Donegal)', zip: '993148' },
	{ city: 'Mabbotstown (Kilkenny)', zip: '852578' },
	{ city: 'Mabestown (Dublin)', zip: '460620' },
	{ city: 'Mabestown (Meath)', zip: '494388' },
	{ city: 'Mabestown (Westmeath)', zip: '348551' },
	{ city: 'Mabrista (Westmeath)', zip: '993615' },
	{ city: 'Mace (Galway)', zip: '946061' },
	{ city: 'Mace (Westmeath)', zip: '830651' },
	{ city: 'Macecrump (Mayo)', zip: '453939' },
	{ city: 'Macecrump Common (Mayo)', zip: '254934' },
	{ city: 'Mace Lower (Mayo)', zip: '634384' },
	{ city: 'Mace Middle (Mayo)', zip: '847760' },
	{ city: 'Mace North (Mayo)', zip: '817049' },
	{ city: 'Mace South (Mayo)', zip: '625128' },
	{ city: 'Macetown (Meath)', zip: '639009' },
	{ city: 'Macetown (Westmeath)', zip: '483398' },
	{ city: 'Macetown Middle (Dublin)', zip: '779235' },
	{ city: 'Macetown North (Dublin)', zip: '635129' },
	{ city: 'Macetown South (Dublin)', zip: '236416' },
	{ city: 'Mace Upper (Mayo)', zip: '167137' },
	{ city: 'Mackan (Cavan)', zip: '249209' },
	{ city: 'Mackan (Leitrim)', zip: '402746' },
	{ city: 'Mackanagh Lower (Tipperary)', zip: '250235' },
	{ city: 'Mackanagh Upper (Tipperary)', zip: '975185' },
	{ city: 'Mackanhill (Meath)', zip: '323079' },
	{ city: 'Mackanrany (Westmeath)', zip: '220295' },
	{ city: 'Mackenstown (Wexford)', zip: '362326' },
	{ city: 'Mackinawood (Tipperary)', zip: '123210' },
	{ city: 'Mackmine (Wexford)', zip: '923562' },
	{ city: 'Macknan (Cavan)', zip: '796900' },
	{ city: 'Mackney (Galway)', zip: '940087' },
	{ city: 'Mackney (Tipperary)', zip: '978915' },
	{ city: 'Macmeenstown (Donegal)', zip: '362248' },
	{ city: 'Macmurroughs (Wexford)', zip: '748647' },
	{ city: 'Macmurroughsisland (Wexford)', zip: '881783' },
	{ city: 'Macnadille (Roscommon)', zip: '149456' },
	{ city: 'Macnahanny (Offaly)', zip: '725495' },
	{ city: 'Macoghlans Island (Offaly)', zip: '661185' },
	{ city: 'Macoyle Lower (Wexford)', zip: '588056' },
	{ city: 'Macoyle Upper (Wexford)', zip: '346265' },
	{ city: 'Macreary (Tipperary)', zip: '311919' },
	{ city: 'Macreddin East (Wicklow)', zip: '213031' },
	{ city: 'Macreddin West (Wicklow)', zip: '795522' },
	{ city: 'Macroney Lower (Cork)', zip: '919510' },
	{ city: 'Macroney Upper (Cork)', zip: '261602' },
	{ city: 'Macroom (Cork)', zip: '802991' },
	{ city: 'Madabawn (Cavan)', zip: '451712' },
	{ city: 'Madame (Cork)', zip: '534256' },
	{ city: 'Madamsland (Tipperary)', zip: '914203' },
	{ city: 'Madara (Clare)', zip: '837266' },
	{ city: 'Madavagh (Donegal)', zip: '679671' },
	{ city: 'Maddadoo (Westmeath)', zip: '103817' },
	{ city: 'Maddenstown Demesne (Kildare)', zip: '716040' },
	{ city: 'Maddenstown Middle (Kildare)', zip: '503254' },
	{ city: 'Maddenstown North (Kildare)', zip: '352084' },
	{ city: 'Maddenstown South (Kildare)', zip: '787065' },
	{ city: 'Maddockstown (Kilkenny)', zip: '366505' },
	{ city: 'Maddox Garden (Louth)', zip: '626824' },
	{ city: 'Maddoxland (Louth)', zip: '734363' },
	{ city: 'Maddyboy (Limerick)', zip: '348211' },
	{ city: 'Madore (Cork)', zip: '535788' },
	{ city: 'Madranna (Cork)', zip: '457103' },
	{ city: 'Maelra (Limerick)', zip: '704014' },
	{ city: 'Magaha (Waterford)', zip: '406487' },
	{ city: 'Maganey (Kildare)', zip: '490969' },
	{ city: 'Maganey Lower (Kildare)', zip: '757658' },
	{ city: 'Maganey Upper (Kildare)', zip: '835190' },
	{ city: 'Maghanaboe (Kerry)', zip: '801314' },
	{ city: 'Maghancoosaun (Kerry)', zip: '465833' },
	{ city: 'Maghanknockane (Kerry)', zip: '593124' },
	{ city: 'Maghanlawaun (Kerry)', zip: '102263' },
	{ city: 'Maghanveel (Kerry)', zip: '183999' },
	{ city: 'Maghareagh (Laois)', zip: '852896' },
	{ city: 'Maghasheela (Kerry)', zip: '918675' },
	{ city: 'Magh East (Kerry)', zip: '794762' },
	{ city: 'Magheestown (Donegal)', zip: '583972' },
	{ city: 'Maghera (Clare)', zip: '594649' },
	{ city: 'Maghera (Donegal)', zip: '634427' },
	{ city: 'Maghera (Limerick)', zip: '971543' },
	{ city: 'Maghera (Sligo)', zip: '470320' },
	{ city: 'Maghera (Westmeath)', zip: '322155' },
	{ city: 'Magherabane (Offaly)', zip: '944722' },
	{ city: 'Magherabaun (Clare)', zip: '869253' },
	{ city: 'Magherabeg (Donegal)', zip: '845655' },
	{ city: 'Magherabeg (Kerry)', zip: '862884' },
	{ city: 'Magherabeg (Wicklow)', zip: '587939' },
	{ city: 'Maghera Beg (Donegal)', zip: '374638' },
	{ city: 'Maghera Beg (Galway)', zip: '922667' },
	{ city: 'Magherablad (Donegal)', zip: '454129' },
	{ city: 'Magheraboy (Donegal)', zip: '948060' },
	{ city: 'Magheraboy (Mayo)', zip: '322616' },
	{ city: 'Magheraboy (Monaghan)', zip: '983359' },
	{ city: 'Magheraboy (Roscommon)', zip: '552052' },
	{ city: 'Magheraboy (Sligo)', zip: '379681' },
	{ city: 'Magheraboy Glebe (Donegal)', zip: '226520' },
	{ city: 'Magheraboy Lower (Cavan)', zip: '363318' },
	{ city: 'Magheraboy Upper (Cavan)', zip: '730185' },
	{ city: 'Magherabrack (Mayo)', zip: '245520' },
	{ city: 'Magherabrack (Sligo)', zip: '660203' },
	{ city: 'Magheracar (Donegal)', zip: '523081' },
	{ city: 'Magheraclogher (Donegal)', zip: '395192' },
	{ city: 'Magheracloigh (Donegal)', zip: '793000' },
	{ city: 'Magheracloone (Monaghan)', zip: '104613' },
	{ city: 'Magheracloy (Donegal)', zip: '221335' },
	{ city: 'Magheracorran (Donegal)', zip: '686180' },
	{ city: 'Magheracuirknagh (Westmeath)', zip: '914710' },
	{ city: 'Magheradrumman (Donegal)', zip: '184605' },
	{ city: 'Magherafadda (Mayo)', zip: '117560' },
	{ city: 'Magheragallan (Donegal)', zip: '185016' },
	{ city: 'Magheraghanrush (Sligo)', zip: '789616' },
	{ city: 'Magheragillerneeve (Sligo)', zip: '273241' },
	{ city: 'Magherahaan (Donegal)', zip: '711693' },
	{ city: 'Magherahee (Donegal)', zip: '128617' },
	{ city: 'Magheralackagh (Sligo)', zip: '150578' },
	{ city: 'Magheralahan (Donegal)', zip: '294030' },
	{ city: 'Magheramagorgan (Donegal)', zip: '863428' },
	{ city: 'Magheramenagh (Donegal)', zip: '807893' },
	{ city: 'Magheramore (Donegal)', zip: '879969' },
	{ city: 'Magheramore (Galway)', zip: '186790' },
	{ city: 'Magheramore (Leitrim)', zip: '129152' },
	{ city: 'Magheramore (Mayo)', zip: '566514' },
	{ city: 'Magheramore (Offaly)', zip: '695577' },
	{ city: 'Magheramore (Westmeath)', zip: '537224' },
	{ city: 'Magheramore (Wicklow)', zip: '784673' },
	{ city: 'Maghera More (Donegal)', zip: '355621' },
	{ city: 'Maghera More (Galway)', zip: '494953' },
	{ city: 'Magheramurry (Westmeath)', zip: '511561' },
	{ city: 'Magheran (Donegal)', zip: '736921' },
	{ city: 'Magheranagay (Mayo)', zip: '101231' },
	{ city: 'Magheranakilly (Donegal)', zip: '240204' },
	{ city: 'Magheranan (Donegal)', zip: '104317' },
	{ city: 'Magheranappan (Donegal)', zip: '450952' },
	{ city: 'Magheranaskeagh (Offaly)', zip: '199798' },
	{ city: 'Magheranaul (Donegal)', zip: '114253' },
	{ city: 'Magheranearla (Galway)', zip: '730630' },
	{ city: 'Magheranenagh (Tipperary)', zip: '920749' },
	{ city: 'Magheranerla (Westmeath)', zip: '761875' },
	{ city: 'Magheranore (Sligo)', zip: '305539' },
	{ city: 'Magheranraheen (Clare)', zip: '293551' },
	{ city: 'Magheranure (Cavan)', zip: '869503' },
	{ city: 'Magheranure (Monaghan)', zip: '654236' },
	{ city: 'Magherapaste (Donegal)', zip: '938394' },
	{ city: 'Magherareagh (Clare)', zip: '271242' },
	{ city: 'Magherareagh (Donegal)', zip: '209101' },
	{ city: 'Magherareagh (Limerick)', zip: '285563' },
	{ city: 'Magherareagh (Offaly)', zip: '840227' },
	{ city: 'Magherareagh (Tipperary)', zip: '239965' },
	{ city: 'Magherarny (Monaghan)', zip: '687528' },
	{ city: 'Magheraroarty (Donegal)', zip: '464794' },
	{ city: 'Magheraroarty Mountain (Donegal)', zip: '475994' },
	{ city: 'Magherashaghry (Monaghan)', zip: '881296' },
	{ city: 'Magherashanvally (Donegal)', zip: '127499' },
	{ city: 'Magherasollus (Donegal)', zip: '902093' },
	{ city: 'Magherasrahan (Kerry)', zip: '235906' },
	{ city: 'Magheravall (Donegal)', zip: '919187' },
	{ city: 'Magheraveen (Longford)', zip: '715208' },
	{ city: 'Magherawardan (Donegal)', zip: '624380' },
	{ city: 'Magheraweeleen (Clare)', zip: '177532' },
	{ city: 'Maghereagh (Louth)', zip: '921479' },
	{ city: 'Maghereen (Cork)', zip: '327038' },
	{ city: 'Magherintemple (Cavan)', zip: '451545' },
	{ city: 'Maghernacaldry (Cavan)', zip: '239320' },
	{ city: 'Maghernacloy (Monaghan)', zip: '679675' },
	{ city: 'Maghernagran (Donegal)', zip: '782825' },
	{ city: 'Maghernaharny (Monaghan)', zip: '361521' },
	{ city: 'Maghernakelly (Monaghan)', zip: '357903' },
	{ city: 'Maghernakill (Monaghan)', zip: '644063' },
	{ city: 'Maghernalaght (Donegal)', zip: '656756' },
	{ city: 'Maghernashangan (Donegal)', zip: '242925' },
	{ city: 'Magheross (Monaghan)', zip: '668789' },
	{ city: 'Maghery (Donegal)', zip: '453467' },
	{ city: 'Maghery (Monaghan)', zip: '434230' },
	{ city: 'Magheryard (Donegal)', zip: '807899' },
	{ city: 'Magherycallaghan (Donegal)', zip: '837574' },
	{ city: 'Maghery Glebe (Donegal)', zip: '920028' },
	{ city: 'Maghon (Monaghan)', zip: '780584' },
	{ city: 'Magh West (Kerry)', zip: '608982' },
	{ city: 'Maghygreenane (Kerry)', zip: '688916' },
	{ city: 'Magillstown (Dublin)', zip: '953345' },
	{ city: 'Maginstown (Tipperary)', zip: '540663' },
	{ city: 'Maglass (Kerry)', zip: '600948' },
	{ city: 'Maglass East (Kerry)', zip: '746799' },
	{ city: 'Maglass West (Kerry)', zip: '506171' },
	{ city: 'Maglin (Cork)', zip: '310353' },
	{ city: 'Magmore (Wexford)', zip: '864839' },
	{ city: 'Magnershill (Cork)', zip: '157061' },
	{ city: 'Magoney (Monaghan)', zip: '267171' },
	{ city: 'Magooly (Cork)', zip: '341646' },
	{ city: 'Magorban (Tipperary)', zip: '975081' },
	{ city: 'Magowna (Clare)', zip: '942223' },
	{ city: 'Magowna East (Clare)', zip: '471278' },
	{ city: 'Magowna West (Clare)', zip: '705266' },
	{ city: 'Magowry (Tipperary)', zip: '644658' },
	{ city: 'Maguins Island (Sligo)', zip: '648460' },
	{ city: 'Magurk (Leitrim)', zip: '811142' },
	{ city: 'Mahallagh (Cork)', zip: '516524' },
	{ city: 'Mahanagh (Cork)', zip: '101645' },
	{ city: 'Mahanagh (Galway)', zip: '159859' },
	{ city: 'Mahanagh (Leitrim)', zip: '157459' },
	{ city: 'Mahanagh (Mayo)', zip: '105497' },
	{ city: 'Mahanagh (Sligo)', zip: '120194' },
	{ city: 'Mahanagh (Wexford)', zip: '393654' },
	{ city: 'Mahonburgh (Clare)', zip: '796936' },
	{ city: 'Mahonstown (Meath)', zip: '512699' },
	{ city: 'Mahonstown (Westmeath)', zip: '641132' },
	{ city: 'Mahoonagh (Limerick)', zip: '312262' },
	{ city: 'Mahoonagh Beg (Limerick)', zip: '476626' },
	{ city: 'Mahoonagh More (Limerick)', zip: '250968' },
	{ city: 'Maidenhall (Kilkenny)', zip: '844823' },
	{ city: 'Maidenhead (Laois)', zip: '418533' },
	{ city: 'Maidenhill (Kilkenny)', zip: '926071' },
	{ city: 'Maidstown (Limerick)', zip: '199396' },
	{ city: 'Maine (Louth)', zip: '775421' },
	{ city: 'Maine North (Cork)', zip: '455818' },
	{ city: 'Maine South (Cork)', zip: '157465' },
	{ city: 'Mainham (Kildare)', zip: '579068' },
	{ city: 'Mainscourt (Dublin)', zip: '539338' },
	{ city: 'Mainstown (Tipperary)', zip: '476548' },
	{ city: 'Makief (Cavan)', zip: '266476' },
	{ city: 'Malahide (Dublin)', zip: '831422' },
	{ city: 'Malahide Demesne (Dublin)', zip: '875436' },
	{ city: 'Malapardas (Cork)', zip: '939672' },
	{ city: 'Malheney (Dublin)', zip: '863435' },
	{ city: 'Malin (Donegal)', zip: '998038' },
	{ city: 'Malin Beg (Donegal)', zip: '322737' },
	{ city: 'Malin More (Donegal)', zip: '876516' },
	{ city: 'Mallabracka (Cork)', zip: '311242' },
	{ city: 'Mallahow (Dublin)', zip: '431862' },
	{ city: 'Mallaranny (Mayo)', zip: '606603' },
	{ city: 'Mallardstown (Kilkenny)', zip: '148504' },
	{ city: 'Mallardstown East (Kilkenny)', zip: '854463' },
	{ city: 'Mallardstown Great (Kilkenny)', zip: '217257' },
	{ city: 'Mallardstown Lower (Kilkenny)', zip: '708186' },
	{ city: 'Mallardstown Upper (Kilkenny)', zip: '207038' },
	{ city: 'Mallardstown West (Kilkenny)', zip: '435429' },
	{ city: 'Mallaroe (Mayo)', zip: '149208' },
	{ city: 'Mallavoge (Cork)', zip: '690807' },
	{ city: 'Mallavonea (Cork)', zip: '243781' },
	{ city: 'Mallow (Cork)', zip: '727945' },
	{ city: 'Mallowgaton (Cork)', zip: '645854' },
	{ city: 'Mallyree (Galway)', zip: '819435' },
	{ city: 'Malthousepark (Westmeath)', zip: '156651' },
	{ city: 'Maltpool (Mayo)', zip: '523482' },
	{ city: 'Mamucky (Cork)', zip: '974369' },
	{ city: 'Manch East (Cork)', zip: '829191' },
	{ city: 'Manch Middle (Cork)', zip: '465018' },
	{ city: 'Manch West (Cork)', zip: '202988' },
	{ city: 'Mandistown (Meath)', zip: '467507' },
	{ city: 'Mandoran (Wexford)', zip: '239992' },
	{ city: 'Mangan (Tipperary)', zip: '133877' },
	{ city: 'Mangan (Wexford)', zip: '787538' },
	{ city: 'Mangan Lower (Wexford)', zip: '259564' },
	{ city: 'Mangans (Wicklow)', zip: '830316' },
	{ city: 'Mangan Upper (Wexford)', zip: '607319' },
	{ city: 'Manger (Laois)', zip: '389446' },
	{ city: 'Manger (Wicklow)', zip: '101279' },
	{ city: 'Mangerton (Kerry)', zip: '863188' },
	{ city: 'Manistown (Louth)', zip: '219908' },
	{ city: 'Manna North (Tipperary)', zip: '251922' },
	{ city: 'Mannanstown (Meath)', zip: '723603' },
	{ city: 'Manna South (Tipperary)', zip: '907874' },
	{ city: 'Mannin (Galway)', zip: '545315' },
	{ city: 'Mannin (Laois)', zip: '771269' },
	{ city: 'Mannin (Mayo)', zip: '907812' },
	{ city: 'Manninard (Galway)', zip: '590095' },
	{ city: 'Mannin Beg (Galway)', zip: '537911' },
	{ city: 'Manning (Cork)', zip: '378975' },
	{ city: 'Mannin More (Galway)', zip: '240811' },
	{ city: 'Manofwar (Wicklow)', zip: '378972' },
	{ city: 'Manor (Roscommon)', zip: '727477' },
	{ city: 'Manorcunningham (Donegal)', zip: '849044' },
	{ city: 'Manorcunningham Churchland (Donegal)', zip: '874094' },
	{ city: 'Manorcunningham Churchland Isle (Donegal)', zip: '415062' },
	{ city: 'Manor East (Kerry)', zip: '615644' },
	{ city: 'Manorhamilton (Leitrim)', zip: '532947' },
	{ city: 'Manorland (Meath)', zip: '616911' },
	{ city: 'Manor West (Kerry)', zip: '188844' },
	{ city: 'Manragh Lower (Cavan)', zip: '712915' },
	{ city: 'Manraghrory (Mayo)', zip: '258458' },
	{ city: 'Manragh Upper (Cavan)', zip: '949658' },
	{ city: 'Manselscourt (Kilkenny)', zip: '977497' },
	{ city: 'Manselstown (Tipperary)', zip: '244093' },
	{ city: 'Manserghshill (Tipperary)', zip: '966140' },
	{ city: "Mansfield's-Land (Cork)", zip: '413901' },
	{ city: 'Mansfieldstown (Louth)', zip: '576073' },
	{ city: 'Mantingstown (Kilkenny)', zip: '666988' },
	{ city: 'Mantlehill Great (Tipperary)', zip: '906575' },
	{ city: 'Mantlehill Little (Tipperary)', zip: '258343' },
	{ city: 'Mantua (Dublin)', zip: '273645' },
	{ city: 'Mantua (Roscommon)', zip: '224363' },
	{ city: 'Mantuar (Roscommon)', zip: '866924' },
	{ city: 'Manulla (Mayo)', zip: '346732' },
	{ city: 'Manuslynn (Galway)', zip: '819192' },
	{ city: 'Manusmore (Clare)', zip: '246272' },
	{ city: 'Mapastown (Louth)', zip: '463113' },
	{ city: 'Maperath (Meath)', zip: '671613' },
	{ city: 'Mapestown (Waterford)', zip: '647486' },
	{ city: 'Maplestown (Carlow)', zip: '914825' },
	{ city: 'Marahill (Cavan)', zip: '988911' },
	{ city: 'Marblehill (Donegal)', zip: '623676' },
	{ city: 'Marblehill (Galway)', zip: '524292' },
	{ city: 'Mardyke (Tipperary)', zip: '200853' },
	{ city: 'Marfagh (Donegal)', zip: '813766' },
	{ city: 'Marganure (Galway)', zip: '233692' },
	{ city: "Margaret's Fields (Kilkenny)", zip: '715019' },
	{ city: 'Margaretstown (Dublin)', zip: '871636' },
	{ city: 'Marhin (Kerry)', zip: '236145' },
	{ city: 'Mariavilla (Kildare)', zip: '601088' },
	{ city: 'Marino (Cork)', zip: '100828' },
	{ city: 'Marino (Dublin)', zip: '550461' },
	{ city: 'Markree Demesne (Sligo)', zip: '797095' },
	{ city: 'Marlay (Galway)', zip: '492868' },
	{ city: 'Marlay (Louth)', zip: '914003' },
	{ city: 'Marlbrook (Limerick)', zip: '335830' },
	{ city: 'Marley (Carlow)', zip: '776868' },
	{ city: 'Marley (Galway)', zip: '502978' },
	{ city: 'Marley (Wexford)', zip: '515320' },
	{ city: 'Marlfield (Tipperary)', zip: '210408' },
	{ city: 'Marlhill (Tipperary)', zip: '900225' },
	{ city: 'Marlinstown (Westmeath)', zip: '187815' },
	{ city: 'Marlinstown Bog (Westmeath)', zip: '220714' },
	{ city: 'Marlow (Tipperary)', zip: '928890' },
	{ city: 'Marnellsgrove (Galway)', zip: '243542' },
	{ city: 'Marnellsmeadows (Kilkenny)', zip: '584510' },
	{ city: 'Marsh (Cork)', zip: '727813' },
	{ city: 'Marsh (Wicklow)', zip: '260005' },
	{ city: 'Marshallrath (Louth)', zip: '627116' },
	{ city: 'Marshallspark (Galway)', zip: '963274' },
	{ city: 'Marshallstown (Dublin)', zip: '979817' },
	{ city: 'Marshalstown (Cork)', zip: '194394' },
	{ city: 'Marshalstown (Kildare)', zip: '378214' },
	{ city: 'Marshalstown (Tipperary)', zip: '822275' },
	{ city: 'Marshalstown (Wexford)', zip: '647914' },
	{ city: 'Marshes Lower (Louth)', zip: '262759' },
	{ city: 'Marshes Upper (Louth)', zip: '272195' },
	{ city: 'Marshmeadows (Wexford)', zip: '898359' },
	{ city: 'Marsh North (Louth)', zip: '754038' },
	{ city: 'Marsh South (Louth)', zip: '637698' },
	{ city: 'Marshtown (Cork)', zip: '306433' },
	{ city: 'Martara (Kerry)', zip: '876350' },
	{ city: 'Martingale (Wexford)', zip: '452330' },
	{ city: 'Martinstown (Kildare)', zip: '637709' },
	{ city: 'Martinstown (Limerick)', zip: '587014' },
	{ city: 'Martinstown (Louth)', zip: '376492' },
	{ city: 'Martinstown (Meath)', zip: '895645' },
	{ city: 'Martinstown (Westmeath)', zip: '380875' },
	{ city: 'Martinstown (Wexford)', zip: '228871' },
	{ city: 'Martramane (Kerry)', zip: '787381' },
	{ city: 'Martry (Clare)', zip: '233390' },
	{ city: 'Martry (Meath)', zip: '403759' },
	{ city: 'Martry (Roscommon)', zip: '116574' },
	{ city: 'Marvelstown (Meath)', zip: '393523' },
	{ city: 'Maryborough (Cork)', zip: '358324' },
	{ city: 'Maryborough (Laois)', zip: '657540' },
	{ city: 'Marybrook (Cork)', zip: '371562' },
	{ city: 'Maryfort (Clare)', zip: '295974' },
	{ city: 'Maryglen (Tipperary)', zip: '847764' },
	{ city: 'Maryland (Meath)', zip: '653343' },
	{ city: 'Marymount (Laois)', zip: '874845' },
	{ city: 'Marymount (Offaly)', zip: '984082' },
	{ city: 'Marystown (Roscommon)', zip: '963774' },
	{ city: 'Maryville (Clare)', zip: '640484' },
	{ city: 'Maryville (Cork)', zip: '346001' },
	{ city: 'Maryville (Limerick)', zip: '351338' },
	{ city: 'Mashanaglass (Cork)', zip: '969614' },
	{ city: 'Masiness (Donegal)', zip: '466047' },
	{ city: 'Masmore (Galway)', zip: '882638' },
	{ city: 'Masonbrook (Galway)', zip: '859210' },
	{ city: 'Mason Island (Galway)', zip: '798144' },
	{ city: 'Mason Lodge (Monaghan)', zip: '959343' },
	{ city: 'Masreagh (Sligo)', zip: '181605' },
	{ city: 'Mass Beg (Donegal)', zip: '184964' },
	{ city: 'Massbrook Lower (Mayo)', zip: '469420' },
	{ city: 'Massbrook South (Mayo)', zip: '668996' },
	{ city: 'Massbrook Upper (Mayo)', zip: '786981' },
	{ city: 'Masshill (Donegal)', zip: '914184' },
	{ city: 'Mass More (Donegal)', zip: '279315' },
	{ city: 'Masspool (Meath)', zip: '598633' },
	{ city: 'Massreagh (Donegal)', zip: '880105' },
	{ city: 'Mastergeeha (Kerry)', zip: '109158' },
	{ city: 'Mastergeehy (Kerry)', zip: '264573' },
	{ city: 'Masterstown (Tipperary)', zip: '367530' },
	{ city: 'Matehy (Cork)', zip: '760275' },
	{ city: 'Matt (Dublin)', zip: '837092' },
	{ city: 'Matthewstown (Waterford)', zip: '877990' },
	{ city: 'Mattymount (Wicklow)', zip: '479659' },
	{ city: 'Maudemount (Tipperary)', zip: '273332' },
	{ city: 'Maudlin (Kilkenny)', zip: '647349' },
	{ city: 'Maudlin (Meath)', zip: '690882' },
	{ city: 'Maudlings (Kildare)', zip: '966516' },
	{ city: 'Maudlins (Wexford)', zip: '283410' },
	{ city: 'Maudlinsland (Kilkenny)', zip: '330545' },
	{ city: 'Maudlintown (Wexford)', zip: '403281' },
	{ city: 'Mauganstown (Tipperary)', zip: '396854' },
	{ city: 'Maugh (Cork)', zip: '541155' },
	{ city: 'Maugha (Cork)', zip: '940766' },
	{ city: 'Maughanaclea (Cork)', zip: '339616' },
	{ city: 'Maughanasilly (Cork)', zip: '842300' },
	{ city: 'Maughantoorig (Kerry)', zip: '324087' },
	{ city: 'Maul (Cork)', zip: '279900' },
	{ city: 'Mauladinna (Cork)', zip: '195459' },
	{ city: 'Maulagallane (Cork)', zip: '178552' },
	{ city: 'Maulagallane (Kerry)', zip: '178549' },
	{ city: 'Maulagh (Kerry)', zip: '747034' },
	{ city: 'Maulagirkane (Kerry)', zip: '898191' },
	{ city: 'Maulagow (Cork)', zip: '604742' },
	{ city: 'Maulagowna (Kerry)', zip: '134643' },
	{ city: 'Maulane East (Cork)', zip: '170794' },
	{ city: 'Maulane West (Cork)', zip: '990963' },
	{ city: 'Maulanimirish (Cork)', zip: '174166' },
	{ city: 'Maularaha (Cork)', zip: '618911' },
	{ city: 'Maulashangarry (Cork)', zip: '255179' },
	{ city: 'Maulatanvally (Cork)', zip: '789078' },
	{ city: 'Maulatrahane (Cork)', zip: '696210' },
	{ city: 'Maulavanig (Cork)', zip: '500564' },
	{ city: 'Maulbaun (Cork)', zip: '333504' },
	{ city: 'Maulbrack (Cork)', zip: '952702' },
	{ city: 'Maulbrack East (Cork)', zip: '768954' },
	{ city: 'Maulbrack West (Cork)', zip: '189279' },
	{ city: 'Maulcallee (Kerry)', zip: '847995' },
	{ city: 'Maulcorragh (Cork)', zip: '719619' },
	{ city: 'Maulicarrane (Cork)', zip: '783556' },
	{ city: 'Maulikeeve (Cork)', zip: '117460' },
	{ city: 'Maulin (Kerry)', zip: '210714' },
	{ city: 'Maulinward (Cork)', zip: '828069' },
	{ city: 'Maulmacredmond (Cork)', zip: '994122' },
	{ city: 'Maulmane (Cork)', zip: '828085' },
	{ city: 'Maulmareen (Cork)', zip: '768768' },
	{ city: 'Maulmore (Cork)', zip: '763478' },
	{ city: 'Maulnabrack (Kerry)', zip: '555679' },
	{ city: 'Maulnagearagh (Cork)', zip: '260148' },
	{ city: 'Maulnagirra (Cork)', zip: '345951' },
	{ city: 'Maulnagower (Kerry)', zip: '615653' },
	{ city: 'Maulnagrough (Cork)', zip: '630302' },
	{ city: 'Maulnahone (Kerry)', zip: '492218' },
	{ city: 'Maulnahorna (Cork)', zip: '462517' },
	{ city: 'Maulnahorna (Kerry)', zip: '546912' },
	{ city: 'Maulnarouga North (Cork)', zip: '583727' },
	{ city: 'Maulnarouga South (Cork)', zip: '215291' },
	{ city: 'Maulnaskeha (Cork)', zip: '279325' },
	{ city: 'Maulnaskehy (Cork)', zip: '783380' },
	{ city: 'Maulrane (Cork)', zip: '765134' },
	{ city: 'Maulrour (Cork)', zip: '148248' },
	{ city: 'Maulskinlahane (Cork)', zip: '179655' },
	{ city: 'Maulvirane (Cork)', zip: '556802' },
	{ city: 'Maulyarkane (Kerry)', zip: '622012' },
	{ city: 'Maulyclickeen (Cork)', zip: '421666' },
	{ city: 'Maulycorcoran (Cork)', zip: '929648' },
	{ city: 'Maulykeavane (Kerry)', zip: '336357' },
	{ city: 'Maulyneill (Kerry)', zip: '135290' },
	{ city: 'Maulyregan (Cork)', zip: '260726' },
	{ city: 'Maum (Galway)', zip: '208944' },
	{ city: 'Maum (Mayo)', zip: '891214' },
	{ city: 'Maumagarrane (Kerry)', zip: '233921' },
	{ city: 'Maumanorig (Kerry)', zip: '130017' },
	{ city: 'Maumaratta (Mayo)', zip: '972929' },
	{ city: 'Maum East (Galway)', zip: '557085' },
	{ city: 'Maumeen (Galway)', zip: '523407' },
	{ city: 'Maumeen (Mayo)', zip: '346580' },
	{ city: 'Maumfin (Galway)', zip: '278479' },
	{ city: 'Maumgawnagh (Galway)', zip: '876194' },
	{ city: 'Maumnahaltora (Kerry)', zip: '558589' },
	{ city: 'Maumnaman (Mayo)', zip: '573870' },
	{ city: 'Maumtrasna (Mayo)', zip: '715786' },
	{ city: 'Maum West (Galway)', zip: '645934' },
	{ city: 'Maune (Cork)', zip: '752972' },
	{ city: 'Maunvough (Cork)', zip: '401608' },
	{ city: 'Mauricesmills (Clare)', zip: '638314' },
	{ city: 'Mauricetown (Limerick)', zip: '356475' },
	{ city: 'Mauritiustown (Wexford)', zip: '261358' },
	{ city: 'Mausnarylaan (Clare)', zip: '645379' },
	{ city: 'Mausrevagh (Galway)', zip: '829418' },
	{ city: 'Mausrower (Kerry)', zip: '493836' },
	{ city: 'Mauteoge (Mayo)', zip: '824162' },
	{ city: 'Mautiagh (Leitrim)', zip: '531804' },
	{ city: 'Maw (Galway)', zip: '383850' },
	{ city: 'Mawbeg East (Cork)', zip: '231019' },
	{ city: 'Mawbeg West (Cork)', zip: '231351' },
	{ city: 'Mawbrin (Cork)', zip: '507610' },
	{ city: 'Mawmore East (Cork)', zip: '541946' },
	{ city: 'Mawmore West (Cork)', zip: '360260' },
	{ city: 'Maws (Kildare)', zip: '129262' },
	{ city: 'Maxboley (Wexford)', zip: '454046' },
	{ city: 'Maxtown (Kilkenny)', zip: '718730' },
	{ city: 'Mayfield (Kildare)', zip: '531889' },
	{ city: 'Mayfield (Mayo)', zip: '630386' },
	{ city: 'Mayfield (Waterford)', zip: '775130' },
	{ city: 'Mayladstown (Tipperary)', zip: '914272' },
	{ city: 'Maylin (Donegal)', zip: '977084' },
	{ city: 'Mayne (Limerick)', zip: '272851' },
	{ city: 'Mayne (Louth)', zip: '258926' },
	{ city: 'Mayne (Meath)', zip: '345492' },
	{ city: 'Mayne (Westmeath)', zip: '330741' },
	{ city: 'Maynebog (Laois)', zip: '167022' },
	{ city: 'Maynetown (Dublin)', zip: '603391' },
	{ city: 'Maynooth (Kildare)', zip: '595165' },
	{ city: 'Maynooth South (Kildare)', zip: '619846' },
	{ city: 'Mayo (Cavan)', zip: '342277' },
	{ city: 'Mayo (Laois)', zip: '553064' },
	{ city: 'Mayo (Leitrim)', zip: '878897' },
	{ city: 'Mayo (Mayo)', zip: '409352' },
	{ city: 'Mayo Parks (Mayo)', zip: '887199' },
	{ city: 'Maytown (Cork)', zip: '719060' },
	{ city: 'Maytown (Wexford)', zip: '772806' },
	{ city: 'Meadagh (Limerick)', zip: '348880' },
	{ city: 'Meadowpark (Westmeath)', zip: '320427' },
	{ city: 'Meadstown (Cork)', zip: '836978' },
	{ city: 'Meadstown (Meath)', zip: '935824' },
	{ city: 'Meaghsland (Louth)', zip: '372516' },
	{ city: 'Meakstown (Dublin)', zip: '513885' },
	{ city: 'Mealclye (Tipperary)', zip: '677319' },
	{ city: 'Mealisheen (Cork)', zip: '191042' },
	{ city: 'Meallaghmore (Kilkenny)', zip: '596234' },
	{ city: 'Meallaghmore Lower (Kilkenny)', zip: '773891' },
	{ city: 'Meallaghmore Upper (Kilkenny)', zip: '856401' },
	{ city: 'Meallis (Kerry)', zip: '459922' },
	{ city: 'Meanagh (Clare)', zip: '965429' },
	{ city: 'Meanus (Galway)', zip: '786420' },
	{ city: 'Meanus (Kerry)', zip: '458524' },
	{ city: 'Meanus (Limerick)', zip: '598165' },
	{ city: 'Meath Hill (Meath)', zip: '752510' },
	{ city: 'Medophall (Wexford)', zip: '435060' },
	{ city: 'Medophall Demesne (Wexford)', zip: '682075' },
	{ city: 'Meedanmore (Donegal)', zip: '622759' },
	{ city: 'Meedian (Westmeath)', zip: '781290' },
	{ city: 'Meehan (Westmeath)', zip: '673743' },
	{ city: 'Meehaun (Roscommon)', zip: '149403' },
	{ city: 'Meelaghans (Offaly)', zip: '500024' },
	{ city: 'Meelagulleen (Kerry)', zip: '496113' },
	{ city: 'Meelaherragh (Cork)', zip: '631013' },
	{ city: 'Meelcon (Kerry)', zip: '786363' },
	{ city: 'Meeldrum (Westmeath)', zip: '496261' },
	{ city: 'Meeleen (Cork)', zip: '496423' },
	{ city: 'Meelgarrow (Wexford)', zip: '894057' },
	{ city: 'Meelick (Clare)', zip: '723451' },
	{ city: 'Meelick (Galway)', zip: '783107' },
	{ city: 'Meelick (Kerry)', zip: '681433' },
	{ city: 'Meelick (Laois)', zip: '863680' },
	{ city: 'Meelick (Leitrim)', zip: '471142' },
	{ city: 'Meelick (Longford)', zip: '974858' },
	{ city: 'Meelick (Mayo)', zip: '488789' },
	{ city: 'Meelick (Roscommon)', zip: '539564' },
	{ city: 'Meelick (Tipperary)', zip: '320014' },
	{ city: 'Meelickaduff (Roscommon)', zip: '661387' },
	{ city: 'Meelickbeg (Galway)', zip: '511104' },
	{ city: 'Meelick Beg (Mayo)', zip: '860468' },
	{ city: 'Meelick East (Galway)', zip: '282886' },
	{ city: 'Meelickmore (Galway)', zip: '337124' },
	{ city: 'Meelick More (Mayo)', zip: '304638' },
	{ city: 'Meelick Park (Sligo)', zip: '660139' },
	{ city: 'Meelickroe (Roscommon)', zip: '679476' },
	{ city: 'Meelick West (Galway)', zip: '382253' },
	{ city: 'Meelin (Cork)', zip: '179785' },
	{ city: 'Meelmane (Cork)', zip: '907275' },
	{ city: 'Meelnagh (Wexford)', zip: '147541' },
	{ city: 'Meelon (Cork)', zip: '795245' },
	{ city: 'Meelragh (Leitrim)', zip: '175426' },
	{ city: 'Meelshane (Cork)', zip: '589771' },
	{ city: 'Meeltanagh (Longford)', zip: '698839' },
	{ city: 'Meeltoge (Cavan)', zip: '464823' },
	{ city: 'Meeltran (Mayo)', zip: '661907' },
	{ city: 'Meeltraun (Roscommon)', zip: '973368' },
	{ city: 'Meen (Kerry)', zip: '105384' },
	{ city: 'Meenabaltin (Donegal)', zip: '828373' },
	{ city: 'Meenaboll (Donegal)', zip: '734972' },
	{ city: 'Meenabollagan (Donegal)', zip: '487702' },
	{ city: 'Meenabrock (Donegal)', zip: '535416' },
	{ city: 'Meenacahan (Donegal)', zip: '798875' },
	{ city: 'Meenacally (Donegal)', zip: '538761' },
	{ city: 'Meenacargagh (Donegal)', zip: '155560' },
	{ city: 'Meenacarn (Donegal)', zip: '328624' },
	{ city: 'Meenachallow (Donegal)', zip: '431518' },
	{ city: 'Meenacharbet (Donegal)', zip: '547221' },
	{ city: 'Meenacharvy (Donegal)', zip: '835523' },
	{ city: 'Meenachuit (Donegal)', zip: '289533' },
	{ city: 'Meenachullalan (Donegal)', zip: '302042' },
	{ city: 'Meenachullion (Donegal)', zip: '812617' },
	{ city: 'Meenaclady (Donegal)', zip: '677381' },
	{ city: 'Meenacloghcor (Donegal)', zip: '126180' },
	{ city: 'Meenacloghspar (Donegal)', zip: '261463' },
	{ city: 'Meenacloy (Donegal)', zip: '455699' },
	{ city: 'Meenacross (Donegal)', zip: '438828' },
	{ city: 'Meenacung (Donegal)', zip: '489851' },
	{ city: 'Meenacurrin (Donegal)', zip: '604158' },
	{ city: 'Meenadaura (Donegal)', zip: '678681' },
	{ city: 'Meenadiff (Donegal)', zip: '605943' },
	{ city: 'Meenadoan (Donegal)', zip: '720347' },
	{ city: 'Meenadreen (Donegal)', zip: '399971' },
	{ city: 'Meenaduff (Cork)', zip: '523528' },
	{ city: 'Meenaduff (Donegal)', zip: '302502' },
	{ city: 'Meenagannive (Donegal)', zip: '257671' },
	{ city: 'Meenagh (Leitrim)', zip: '798621' },
	{ city: 'Meenagleragh (Sligo)', zip: '740235' },
	{ city: 'Meenaglogh (Sligo)', zip: '462099' },
	{ city: 'Meenagloghrane (Cork)', zip: '222721' },
	{ city: 'Meenagolan (Donegal)', zip: '792234' },
	{ city: 'Meenagoppoge (Donegal)', zip: '529857' },
	{ city: 'Meenagory (Donegal)', zip: '578762' },
	{ city: 'Meenagowan (Donegal)', zip: '424537' },
	{ city: 'Meenagowna (Donegal)', zip: '577018' },
	{ city: 'Meenagran (Donegal)', zip: '157372' },
	{ city: 'Meenagranoge (Donegal)', zip: '783809' },
	{ city: 'Meenagraun (Leitrim)', zip: '257446' },
	{ city: 'Meenagrauv (Donegal)', zip: '313723' },
	{ city: 'Meenagrillagh (Donegal)', zip: '589004' },
	{ city: 'Meenagrubby (Donegal)', zip: '481484' },
	{ city: 'Meenaguse Beg (Donegal)', zip: '521424' },
	{ city: 'Meenaguse More (Donegal)', zip: '808258' },
	{ city: 'Meenahinnis (Donegal)', zip: '212802' },
	{ city: 'Meenahoney (Donegal)', zip: '750153' },
	{ city: 'Meenahony (Cork)', zip: '142570' },
	{ city: 'Meenahorna (Donegal)', zip: '362484' },
	{ city: 'Meenakillew (Donegal)', zip: '292689' },
	{ city: 'Meenakilwirra (Donegal)', zip: '391540' },
	{ city: 'Meenalaban (Donegal)', zip: '373792' },
	{ city: 'Meenalargan (Donegal)', zip: '768301' },
	{ city: 'Meenaleavin (Donegal)', zip: '780018' },
	{ city: 'Meenalecky (Donegal)', zip: '965151' },
	{ city: 'Meenaleenaghan (Donegal)', zip: '524708' },
	{ city: 'Meenalig (Donegal)', zip: '232423' },
	{ city: 'Meenalooban (Donegal)', zip: '875923' },
	{ city: 'Meenamaddo (Sligo)', zip: '895130' },
	{ city: 'Meenamalragh (Donegal)', zip: '418767' },
	{ city: 'Meenamanragh (Donegal)', zip: '882956' },
	{ city: 'Meenamullaghan (Donegal)', zip: '194724' },
	{ city: 'Meenanall (Donegal)', zip: '546565' },
	{ city: 'Meenanamph (Donegal)', zip: '848338' },
	{ city: 'Meenanare (Kerry)', zip: '782335' },
	{ city: 'Meenanarwa (Donegal)', zip: '622560' },
	{ city: 'Meenane (Cork)', zip: '385159' },
	{ city: 'Meenaneary (Donegal)', zip: '704332' },
	{ city: 'Meenanellison (Donegal)', zip: '584425' },
	{ city: 'Meenanillar (Donegal)', zip: '388817' },
	{ city: 'Meenanilta (Donegal)', zip: '656111' },
	{ city: 'Meenapeaky (Donegal)', zip: '934308' },
	{ city: 'Meenaphuill (Leitrim)', zip: '734691' },
	{ city: 'Meenaroshin (Donegal)', zip: '750600' },
	{ city: 'Meenasillagh (Donegal)', zip: '474857' },
	{ city: 'Meenaslieve (Cavan)', zip: '919316' },
	{ city: 'Meenasrone North (Donegal)', zip: '922601' },
	{ city: 'Meenasrone South (Donegal)', zip: '676029' },
	{ city: 'Meenataggart (Donegal)', zip: '341475' },
	{ city: 'Meenatarriff (Cork)', zip: '503725' },
	{ city: 'Meenatawy (Donegal)', zip: '145815' },
	{ city: 'Meenateia (Donegal)', zip: '926083' },
	{ city: 'Meenatinny (Donegal)', zip: '378506' },
	{ city: 'Meenatole (Donegal)', zip: '631542' },
	{ city: 'Meenavaghran (Donegal)', zip: '311916' },
	{ city: 'Meenavale (Donegal)', zip: '941780' },
	{ city: 'Meenavally (Donegal)', zip: '875422' },
	{ city: 'Meenavanaghan (Donegal)', zip: '638109' },
	{ city: 'Meenavean (Donegal)', zip: '244021' },
	{ city: 'Meenavoy (Donegal)', zip: '897210' },
	{ city: 'Meenawannia (Donegal)', zip: '961767' },
	{ city: 'Meenawilderg (Donegal)', zip: '169367' },
	{ city: 'Meenawilligan (Donegal)', zip: '981317' },
	{ city: 'Meenawley (Donegal)', zip: '211691' },
	{ city: 'Meenawullaghan (Donegal)', zip: '672562' },
	{ city: 'Meenbane (Donegal)', zip: '968451' },
	{ city: 'Meenbannad (Donegal)', zip: '227879' },
	{ city: 'Meenbannivane (Kerry)', zip: '412781' },
	{ city: 'Meenbog (Donegal)', zip: '490923' },
	{ city: 'Meenboy (Donegal)', zip: '133344' },
	{ city: 'Meenbunone (Donegal)', zip: '543913' },
	{ city: 'Meencargagh (Donegal)', zip: '991973' },
	{ city: 'Meencoolasheskin (Donegal)', zip: '688838' },
	{ city: 'Meencorwick (Donegal)', zip: '559492' },
	{ city: 'Meencrumlin (Donegal)', zip: '706993' },
	{ city: 'Meendacalliagh (Donegal)', zip: '714058' },
	{ city: 'Meenderrygamph (Donegal)', zip: '360653' },
	{ city: 'Meenderryherk Glebe (Donegal)', zip: '365723' },
	{ city: 'Meenderrynasloe (Donegal)', zip: '791003' },
	{ city: 'Meenderryowan (Donegal)', zip: '972948' },
	{ city: 'Meendoran (Donegal)', zip: '394413' },
	{ city: 'Meendrain (Donegal)', zip: '124331' },
	{ city: 'Meendurragha (Cork)', zip: '527533' },
	{ city: 'Meeneen (Galway)', zip: '840067' },
	{ city: 'Meeneeshal (Cork)', zip: '139011' },
	{ city: 'Meenformal (Donegal)', zip: '870654' },
	{ city: 'Meengilcarry (Donegal)', zip: '961060' },
	{ city: 'Meengorman (Cork)', zip: '650540' },
	{ city: 'Meenirroy (Donegal)', zip: '687950' },
	{ city: 'Meeniska (Westmeath)', zip: '286807' },
	{ city: 'Meenkearagh (Cork)', zip: '425394' },
	{ city: 'Meenkeeragh (Donegal)', zip: '592862' },
	{ city: 'Meenkeeragh (Leitrim)', zip: '798935' },
	{ city: 'Meenlagh (Meath)', zip: '719283' },
	{ city: 'Meenlaragh (Donegal)', zip: '933348' },
	{ city: 'Meenleana (Galway)', zip: '943101' },
	{ city: 'Meenlecknalore (Donegal)', zip: '238510' },
	{ city: 'Meenleitrim North (Kerry)', zip: '785055' },
	{ city: 'Meenleitrim South (Kerry)', zip: '248000' },
	{ city: 'Meenletterbale (Donegal)', zip: '272335' },
	{ city: 'Meenlougher (Donegal)', zip: '743244' },
	{ city: 'Meenmore (Donegal)', zip: '620159' },
	{ city: 'Meenmore (Sligo)', zip: '658135' },
	{ city: 'Meenmore East (Donegal)', zip: '938484' },
	{ city: 'Meenmore West (Donegal)', zip: '315094' },
	{ city: 'Meennacloghfinny (Mayo)', zip: '910185' },
	{ city: 'Meennagishagh (Kerry)', zip: '121669' },
	{ city: 'Meennahorna (Kerry)', zip: '756712' },
	{ city: 'Meennaraheeny (Cork)', zip: '921542' },
	{ city: 'Meennascarty (Kerry)', zip: '848166' },
	{ city: 'Meenogahane (Kerry)', zip: '707123' },
	{ city: 'Meenoughter (Cork)', zip: '747729' },
	{ city: 'Meenreagh (Donegal)', zip: '699144' },
	{ city: 'Meenroe (Cork)', zip: '283641' },
	{ city: 'Meenross (Clare)', zip: '813041' },
	{ city: 'Meens (Cork)', zip: '290264' },
	{ city: 'Meenscovane (Kerry)', zip: '851251' },
	{ city: 'Meensheefin (Donegal)', zip: '742223' },
	{ city: 'Meenskeha East (Cork)', zip: '955739' },
	{ city: 'Meenskeha West (Cork)', zip: '964389' },
	{ city: 'Meentacor (Donegal)', zip: '311843' },
	{ city: 'Meentacreeghan (Donegal)', zip: '862569' },
	{ city: 'Meentadun (Donegal)', zip: '894264' },
	{ city: 'Meentagh (Donegal)', zip: '888836' },
	{ city: 'Meentaghconlan (Donegal)', zip: '808921' },
	{ city: 'Meentaghmore (Donegal)', zip: '713490' },
	{ city: 'Meentakeeraghan (Donegal)', zip: '666598' },
	{ city: 'Meentanadea (Donegal)', zip: '724653' },
	{ city: 'Meentanakill (Donegal)', zip: '847203' },
	{ city: 'Meentashesk (Donegal)', zip: '927373' },
	{ city: 'Meentinny East (Cork)', zip: '165296' },
	{ city: 'Meentinny West (Cork)', zip: '881851' },
	{ city: 'Meentoges (Kerry)', zip: '636960' },
	{ city: 'Meentolla (Limerick)', zip: '468997' },
	{ city: 'Meentullynagarn (Donegal)', zip: '927133' },
	{ city: 'Meentycat (Donegal)', zip: '887800' },
	{ city: 'Meentyflugh (Cork)', zip: '463711' },
	{ city: 'Meentygrannagh (Donegal)', zip: '995439' },
	{ city: 'Meentymorgal (Donegal)', zip: '335357' },
	{ city: 'Meenvane (Cork)', zip: '269981' },
	{ city: 'Meenwaun (Offaly)', zip: '602530' },
	{ city: 'Meenyanly (Donegal)', zip: '620632' },
	{ city: 'Meenybraddan (Donegal)', zip: '813588' },
	{ city: 'Meenychanon (Donegal)', zip: '589111' },
	{ city: 'Meenyhooghan (Donegal)', zip: '596748' },
	{ city: 'Meenyline North (Limerick)', zip: '134525' },
	{ city: 'Meenyline South (Limerick)', zip: '474015' },
	{ city: 'Meenymore (Leitrim)', zip: '490459' },
	{ city: 'Meenyvoughaun (Kerry)', zip: '793692' },
	{ city: 'Meera (Roscommon)', zip: '947019' },
	{ city: 'Meermihil (Mayo)', zip: '152716' },
	{ city: 'Meeshal (Cork)', zip: '320356' },
	{ city: 'Meetings (Wicklow)', zip: '587565' },
	{ city: 'Meggagh East (Clare)', zip: '195582' },
	{ city: 'Meggagh West (Clare)', zip: '661375' },
	{ city: 'Meheranspark (Galway)', zip: '179083' },
	{ city: 'Meldrum (Tipperary)', zip: '912354' },
	{ city: 'Melkagh (Longford)', zip: '808942' },
	{ city: 'Melkernagh (Longford)', zip: '760350' },
	{ city: 'Mell (Louth)', zip: '724638' },
	{ city: 'Mellamore (Donegal)', zip: '500542' },
	{ city: 'Mellefontstown (Cork)', zip: '422666' },
	{ city: 'Mellifont (Louth)', zip: '828863' },
	{ city: 'Mellifont (Meath)', zip: '595842' },
	{ city: 'Mellifont Park (Louth)', zip: '548346' },
	{ city: 'Mellifontstown (Cork)', zip: '527856' },
	{ city: 'Mellisson (Tipperary)', zip: '814878' },
	{ city: 'Mellon (Limerick)', zip: '431406' },
	{ city: 'Melmore (Donegal)', zip: '841860' },
	{ city: 'Melville (Kilkenny)', zip: '718506' },
	{ city: 'Memory (Kilkenny)', zip: '108165' },
	{ city: 'Menamny (Donegal)', zip: '454881' },
	{ city: 'Meneen (Mayo)', zip: '992627' },
	{ city: 'Menlough (Galway)', zip: '310092' },
	{ city: 'Menlough Commons (Galway)', zip: '380504' },
	{ city: 'Menlough Eighter (Galway)', zip: '896451' },
	{ city: 'Menlough Oughter (Galway)', zip: '782408' },
	{ city: 'Mentrim (Meath)', zip: '604049' },
	{ city: 'Menus (Galway)', zip: '472842' },
	{ city: 'Menus Park (Galway)', zip: '560156' },
	{ city: 'Meoul (Waterford)', zip: '363742' },
	{ city: 'Merepark (Wicklow)', zip: '405054' },
	{ city: 'Merginstown (Wicklow)', zip: '443174' },
	{ city: 'Merginstown Demesne (Wicklow)', zip: '180435' },
	{ city: 'Merginstown Glen (Wicklow)', zip: '157586' },
	{ city: 'Merrion (Dublin)', zip: '212914' },
	{ city: 'Merryfalls (Dublin)', zip: '807694' },
	{ city: 'Merrymeeting (Wicklow)', zip: '473974' },
	{ city: 'Merrywell (Meath)', zip: '685176' },
	{ city: 'Mersheen (Wexford)', zip: '363659' },
	{ city: 'Mertonhall (Tipperary)', zip: '456415' },
	{ city: 'Mevagh (Donegal)', zip: '478463' },
	{ city: 'Mewlaghmore (Roscommon)', zip: '465533' },
	{ city: 'Michaelschurch (Kilkenny)', zip: '363592' },
	{ city: 'Micknanstown (Meath)', zip: '982912' },
	{ city: 'Middleborough (Meath)', zip: '534950' },
	{ city: 'Middleknock (Kilkenny)', zip: '242638' },
	{ city: 'Middleline North (Clare)', zip: '324305' },
	{ city: 'Middleline South (Clare)', zip: '283597' },
	{ city: 'Middlemount (Laois)', zip: '971514' },
	{ city: 'Middleplough (Tipperary)', zip: '172871' },
	{ city: 'Middlequarter (Galway)', zip: '577538' },
	{ city: 'Middlequarter (Tipperary)', zip: '202830' },
	{ city: 'Middlequarter (Waterford)', zip: '388277' },
	{ city: 'Middleton (Longford)', zip: '825469' },
	{ city: 'Middletown (Cavan)', zip: '808522' },
	{ city: 'Middletown (Donegal)', zip: '113716' },
	{ city: 'Middletown (Dublin)', zip: '208676' },
	{ city: 'Middletown (Mayo)', zip: '969008' },
	{ city: 'Middletown (Tipperary)', zip: '644702' },
	{ city: 'Middletown (Wexford)', zip: '299072' },
	{ city: 'Middlewalk (Tipperary)', zip: '851824' },
	{ city: 'Midfield (Mayo)', zip: '461597' },
	{ city: 'Midleton (Cork)', zip: '856075' },
	{ city: 'Mien (Tipperary)', zip: '592182' },
	{ city: 'Mihanagh (Roscommon)', zip: '178309' },
	{ city: 'Mihanboy (Roscommon)', zip: '526079' },
	{ city: 'Milane (Cork)', zip: '179704' },
	{ city: 'Milcum (Mayo)', zip: '622460' },
	{ city: 'Milehouse (Wexford)', zip: '115577' },
	{ city: 'Milemill (Kildare)', zip: '251561' },
	{ city: 'Miles (Cork)', zip: '729287' },
	{ city: 'Milestone (Tipperary)', zip: '594704' },
	{ city: 'Milestown (Dublin)', zip: '906963' },
	{ city: 'Milestown (Louth)', zip: '287501' },
	{ city: 'Milestown (Meath)', zip: '246254' },
	{ city: 'Milestown (Tipperary)', zip: '157851' },
	{ city: 'Milestown (Wexford)', zip: '981810' },
	{ city: 'Milford (Cork)', zip: '240174' },
	{ city: 'Milford (Laois)', zip: '700185' },
	{ city: 'Milford (Tipperary)', zip: '370024' },
	{ city: 'Milford Demesne (Mayo)', zip: '476575' },
	{ city: 'Milkernagh (Westmeath)', zip: '456654' },
	{ city: 'Milk Isle (Donegal)', zip: '814838' },
	{ city: 'Mill And Churchquarter (Waterford)', zip: '402359' },
	{ city: 'Millbanks (Kilkenny)', zip: '555607' },
	{ city: 'Mill Big (Cork)', zip: '704872' },
	{ city: 'Millbrook (Donegal)', zip: '885709' },
	{ city: 'Millbrook (Mayo)', zip: '592370' },
	{ city: 'Millbrook (Offaly)', zip: '280425' },
	{ city: 'Millbrook (Tipperary)', zip: '551835' },
	{ city: 'Millcastle (Westmeath)', zip: '192113' },
	{ city: 'Milleen (Cork)', zip: '377157' },
	{ city: 'Milleenahilan (Cork)', zip: '249449' },
	{ city: 'Milleenanannig (Cork)', zip: '381796' },
	{ city: 'Milleenanimrish (Cork)', zip: '423333' },
	{ city: 'Milleenawillin (Cork)', zip: '645416' },
	{ city: 'Milleenboy (Cork)', zip: '321385' },
	{ city: 'Milleencoola (Cork)', zip: '747761' },
	{ city: 'Milleenduff (Cork)', zip: '367681' },
	{ city: 'Milleennagun (Cork)', zip: '204701' },
	{ city: 'Milleennahorna (Cork)', zip: '574125' },
	{ city: 'Milleens (Kerry)', zip: '481006' },
	{ city: 'Milleeny (Cork)', zip: '618796' },
	{ city: 'Milleenylegane (Cork)', zip: '268208' },
	{ city: 'Millerhill (Mayo)', zip: '326435' },
	{ city: 'Millerstown (Waterford)', zip: '152855' },
	{ city: 'Millerstown (Westmeath)', zip: '682715' },
	{ city: 'Millfarm (Donegal)', zip: '743575' },
	{ city: 'Millfarm (Kildare)', zip: '170197' },
	{ city: 'Millfarm (Limerick)', zip: '815716' },
	{ city: 'Millford (Donegal)', zip: '246365' },
	{ city: 'Millford (Galway)', zip: '772244' },
	{ city: 'Millgrange (Louth)', zip: '531958' },
	{ city: 'Millgrove (Offaly)', zip: '715621' },
	{ city: 'Millhead (Dublin)', zip: '395976' },
	{ city: 'Millicent Demesne (Kildare)', zip: '388389' },
	{ city: 'Millicent North (Kildare)', zip: '501767' },
	{ city: 'Millicent South (Kildare)', zip: '465193' },
	{ city: 'Milligan (Monaghan)', zip: '907249' },
	{ city: 'Mill Island (Kilkenny)', zip: '479642' },
	{ city: 'Millknock (Wexford)', zip: '197188' },
	{ city: 'Mill Land (Laois)', zip: '587538' },
	{ city: 'Mill Land (Meath)', zip: '881912' },
	{ city: 'Mill Land (Westmeath)', zip: '326900' },
	{ city: 'Mill Land (Wicklow)', zip: '595293' },
	{ city: 'Mill-Land (Cork)', zip: '240748' },
	{ city: 'Mill Lands (Wexford)', zip: '398010' },
	{ city: 'Mill Little (Cork)', zip: '240555' },
	{ city: 'Millmount (Limerick)', zip: '343995' },
	{ city: 'Millockstown (Louth)', zip: '631565' },
	{ city: 'Millpark (Galway)', zip: '741510' },
	{ city: 'Millpark (Leitrim)', zip: '262067' },
	{ city: 'Millpark (Louth)', zip: '449811' },
	{ city: 'Millpark (Tipperary)', zip: '528564' },
	{ city: 'Millplot (Galway)', zip: '457851' },
	{ city: 'Millquarter (Wexford)', zip: '364940' },
	{ city: 'Millsessiagh (Donegal)', zip: '552755' },
	{ city: 'Millstreet (Cork)', zip: '499122' },
	{ city: 'Milltown (Carlow)', zip: '852176' },
	{ city: 'Milltown (Cavan)', zip: '932726' },
	{ city: 'Milltown (Clare)', zip: '307752' },
	{ city: 'Milltown (Cork)', zip: '526894' },
	{ city: 'Milltown (Donegal)', zip: '834692' },
	{ city: 'Milltown (Dublin)', zip: '624506' },
	{ city: 'Milltown (Galway)', zip: '926395' },
	{ city: 'Milltown (Kerry)', zip: '652997' },
	{ city: 'Milltown (Kildare)', zip: '595330' },
	{ city: 'Milltown (Kilkenny)', zip: '771457' },
	{ city: 'Milltown (Laois)', zip: '430077' },
	{ city: 'Milltown (Leitrim)', zip: '741798' },
	{ city: 'Milltown (Limerick)', zip: '308146' },
	{ city: 'Milltown (Louth)', zip: '357428' },
	{ city: 'Milltown (Meath)', zip: '222847' },
	{ city: 'Milltown (Monaghan)', zip: '657923' },
	{ city: 'Milltown (Offaly)', zip: '166796' },
	{ city: 'Milltown (Roscommon)', zip: '101242' },
	{ city: 'Milltown (Tipperary)', zip: '906697' },
	{ city: 'Milltown (Westmeath)', zip: '366437' },
	{ city: 'Milltown (Wexford)', zip: '809658' },
	{ city: 'Milltown (Wicklow)', zip: '943958' },
	{ city: 'Milltown Beg (Tipperary)', zip: '764019' },
	{ city: 'Milltown Bog (Louth)', zip: '718561' },
	{ city: 'Milltown Britton (Tipperary)', zip: '388638' },
	{ city: 'Milltown Grange (Louth)', zip: '614826' },
	{ city: 'Milltown Malbay (Clare)', zip: '546692' },
	{ city: 'Milltown More (Tipperary)', zip: '759247' },
	{ city: 'Milltown North (Limerick)', zip: '501831' },
	{ city: 'Milltown North (Wicklow)', zip: '757978' },
	{ city: 'Milltown Old (Louth)', zip: '269549' },
	{ city: 'Milltownpass (Westmeath)', zip: '606808' },
	{ city: 'Milltown Saint John (Tipperary)', zip: '336235' },
	{ city: 'Milltown South (Limerick)', zip: '670006' },
	{ city: 'Milltown South (Wicklow)', zip: '588206' },
	{ city: 'Milmorane (Cork)', zip: '237126' },
	{ city: 'Milshoge (Wexford)', zip: '374859' },
	{ city: 'Miltonsfields (Dublin)', zip: '677443' },
	{ city: 'Miltron Glebe (Leitrim)', zip: '526186' },
	{ city: 'Milverton (Dublin)', zip: '299836' },
	{ city: 'Milverton Demesne (Dublin)', zip: '435232' },
	{ city: 'Minane (Cork)', zip: '799789' },
	{ city: 'Minane Bridge (Cork)', zip: '993264' },
	{ city: 'Minanes (Cork)', zip: '717598' },
	{ city: 'Minard (Longford)', zip: '254913' },
	{ city: 'Minard East (Kerry)', zip: '290334' },
	{ city: 'Minard West (Kerry)', zip: '217476' },
	{ city: 'Minehill (Cork)', zip: '976781' },
	{ city: 'Minish (Kerry)', zip: '528396' },
	{ city: "Minister's-Land (Limerick)", zip: '705098' },
	{ city: 'Ministown (Meath)', zip: '338106' },
	{ city: 'Minkill (Leitrim)', zip: '335518' },
	{ city: 'Minmore (Wicklow)', zip: '476859' },
	{ city: 'Minna (Galway)', zip: '796983' },
	{ city: 'Minnauns (Kilkenny)', zip: '769612' },
	{ city: 'Minorstown (Tipperary)', zip: '941538' },
	{ city: 'Minus Island (Offaly)', zip: '996764' },
	{ city: 'Minvaud Lower (Carlow)', zip: '297126' },
	{ city: 'Minvaud Upper (Carlow)', zip: '525930' },
	{ city: 'Mira (Galway)', zip: '186256' },
	{ city: 'Mirehill (Galway)', zip: '379307' },
	{ city: 'Mishells (Cork)', zip: '313427' },
	{ city: 'Miskaun Glebe (Leitrim)', zip: '280044' },
	{ city: 'Miskish Beg (Monaghan)', zip: '963406' },
	{ city: 'Miskish More (Monaghan)', zip: '511020' },
	{ city: 'Misterin (Wexford)', zip: '730702' },
	{ city: 'Mitchellsfort (Cork)', zip: '881657' },
	{ city: 'Mitchelstown (Cork)', zip: '740906' },
	{ city: 'Mitchelstown (Dublin)', zip: '488918' },
	{ city: 'Mitchelstown (Limerick)', zip: '328487' },
	{ city: 'Mitchelstown (Louth)', zip: '591954' },
	{ city: 'Mitchelstown (Meath)', zip: '997339' },
	{ city: 'Mitchelstown (Westmeath)', zip: '542649' },
	{ city: 'Mitchelstowndown (Limerick)', zip: '636974' },
	{ city: 'Mitchelstowndown East (Limerick)', zip: '666195' },
	{ city: 'Mitchelstowndown North (Limerick)', zip: '818171' },
	{ city: 'Mitchelstowndown West (Limerick)', zip: '261656' },
	{ city: 'Mitchelstown East (Cork)', zip: '405157' },
	{ city: 'Mitchelstown West (Cork)', zip: '156999' },
	{ city: 'Moanabricka (Cork)', zip: '740203' },
	{ city: 'Moanacurragh (Carlow)', zip: '875975' },
	{ city: 'Moanahila (Limerick)', zip: '817339' },
	{ city: 'Moanalow (Carlow)', zip: '193092' },
	{ city: 'Moanamanagh (Carlow)', zip: '732599' },
	{ city: 'Moanamought Commons (Kilkenny)', zip: '980653' },
	{ city: 'Moananagh (Clare)', zip: '378583' },
	{ city: 'Moanarnane (Cork)', zip: '757518' },
	{ city: 'Moanarone (Cork)', zip: '926163' },
	{ city: 'Moanaspick (Wicklow)', zip: '222582' },
	{ city: 'Moanaviddoge (Limerick)', zip: '278140' },
	{ city: 'Moanavoth (Carlow)', zip: '270871' },
	{ city: 'Moanavraca (Cork)', zip: '710481' },
	{ city: 'Moanballyshivane (Waterford)', zip: '878366' },
	{ city: 'Moanbarron (Tipperary)', zip: '400737' },
	{ city: 'Moanbaun (Cork)', zip: '575584' },
	{ city: 'Moanbaun (Galway)', zip: '121519' },
	{ city: 'Moanbeg (Tipperary)', zip: '354698' },
	{ city: 'Moan Beg (Tipperary)', zip: '369306' },
	{ city: 'Moanbrack (Waterford)', zip: '759706' },
	{ city: 'Moancrea (Tipperary)', zip: '961862' },
	{ city: 'Moandoherdagh (Tipperary)', zip: '734573' },
	{ city: 'Moanduff (Carlow)', zip: '737483' },
	{ city: 'Moanduff (Limerick)', zip: '847212' },
	{ city: 'Moanfad (Laois)', zip: '301478' },
	{ city: 'Moanfin (Tipperary)', zip: '926187' },
	{ city: 'Moanflugh (Cork)', zip: '191680' },
	{ city: 'Moanfoun (Waterford)', zip: '715708' },
	{ city: 'Moanfune (Waterford)', zip: '940012' },
	{ city: 'Moangarriff (Tipperary)', zip: '294223' },
	{ city: 'Moangarve (Kilkenny)', zip: '519604' },
	{ city: 'Moankeal Commons (Kilkenny)', zip: '827545' },
	{ city: 'Moankeenane (Tipperary)', zip: '423636' },
	{ city: 'Moanlahan (Cork)', zip: '974035' },
	{ city: 'Moanleana (Limerick)', zip: '731215' },
	{ city: 'Moanmehill (Tipperary)', zip: '852331' },
	{ city: 'Moanmore (Carlow)', zip: '273080' },
	{ city: 'Moanmore (Galway)', zip: '680039' },
	{ city: 'Moanmore (Kerry)', zip: '891656' },
	{ city: 'Moanmore (Kilkenny)', zip: '700747' },
	{ city: 'Moanmore (Limerick)', zip: '962114' },
	{ city: 'Moanmore (Tipperary)', zip: '268784' },
	{ city: 'Moan More (Tipperary)', zip: '193218' },
	{ city: 'Moanmore Commons (Kilkenny)', zip: '576789' },
	{ city: 'Moanmore East (Galway)', zip: '363363' },
	{ city: 'Moanmore Lower (Clare)', zip: '918760' },
	{ city: 'Moanmore North (Clare)', zip: '399466' },
	{ city: 'Moanmore South (Clare)', zip: '749330' },
	{ city: 'Moanmore Upper (Clare)', zip: '377713' },
	{ city: 'Moanmore West (Galway)', zip: '740893' },
	{ city: 'Moannakeeba East (Galway)', zip: '774795' },
	{ city: 'Moannakeeba West (Galway)', zip: '632980' },
	{ city: 'Moanogeenagh (Clare)', zip: '956166' },
	{ city: 'Moanoola (Limerick)', zip: '515338' },
	{ city: 'Moanour (Tipperary)', zip: '606296' },
	{ city: 'Moanreagh (Tipperary)', zip: '326126' },
	{ city: 'Moanreel North (Clare)', zip: '991499' },
	{ city: 'Moanreel South (Clare)', zip: '700601' },
	{ city: 'Moanroe (Cork)', zip: '212350' },
	{ city: 'Moanroe (Kilkenny)', zip: '246648' },
	{ city: 'Moanroe (Limerick)', zip: '700802' },
	{ city: 'Moanroe (Tipperary)', zip: '510257' },
	{ city: 'Moanroe Beg (Limerick)', zip: '170320' },
	{ city: 'Moanroe Commons (Kilkenny)', zip: '645813' },
	{ city: 'Moanroe More (Limerick)', zip: '588857' },
	{ city: 'Moanteen (Tipperary)', zip: '296443' },
	{ city: 'Moanteenmore (Kilkenny)', zip: '880132' },
	{ city: 'Moanvane (Offaly)', zip: '969354' },
	{ city: 'Moanvane (Roscommon)', zip: '132310' },
	{ city: 'Moanvaun (Tipperary)', zip: '162659' },
	{ city: 'Moanvawn (Wicklow)', zip: '175824' },
	{ city: 'Moanvurrin (Tipperary)', zip: '114169' },
	{ city: 'Moanwing (Limerick)', zip: '244137' },
	{ city: 'Moarhaun (Clare)', zip: '728431' },
	{ city: 'Moat (Cavan)', zip: '589718' },
	{ city: 'Moat (Galway)', zip: '664493' },
	{ city: 'Moat (Kilkenny)', zip: '243557' },
	{ city: 'Moat (Laois)', zip: '239767' },
	{ city: 'Moat (Mayo)', zip: '115263' },
	{ city: 'Moat (Meath)', zip: '921072' },
	{ city: 'Moat (Waterford)', zip: '419413' },
	{ city: 'Moatabulcane (Tipperary)', zip: '376642' },
	{ city: 'Moatavally (Longford)', zip: '499452' },
	{ city: 'Moatavanny (Kildare)', zip: '615217' },
	{ city: 'Moat Commons (Kildare)', zip: '460870' },
	{ city: 'Moate (Westmeath)', zip: '122650' },
	{ city: 'Moategranoge (Westmeath)', zip: '610944' },
	{ city: 'Moatfarrell (Longford)', zip: '484141' },
	{ city: 'Moat Farrell (Longford)', zip: '130026' },
	{ city: 'Moatfield (Longford)', zip: '999638' },
	{ city: 'Moathill (Meath)', zip: '381617' },
	{ city: 'Moatpark (Kilkenny)', zip: '523184' },
	{ city: 'Moatquarter (Tipperary)', zip: '174989' },
	{ city: 'Moatstown (Kildare)', zip: '844110' },
	{ city: 'Moat Town (Meath)', zip: '240548' },
	{ city: 'Moaty (Galway)', zip: '807282' },
	{ city: 'Mobarnan (Tipperary)', zip: '231524' },
	{ city: 'Mocklershill (Tipperary)', zip: '364666' },
	{ city: 'Mocklerstown (Tipperary)', zip: '616474' },
	{ city: 'Mocmoyne (Roscommon)', zip: '213989' },
	{ city: 'Mocollagan (Mayo)', zip: '393863' },
	{ city: 'Mocollop (Waterford)', zip: '184995' },
	{ city: 'Mocorha (Mayo)', zip: '181832' },
	{ city: 'Mocurry East (Wexford)', zip: '519840' },
	{ city: 'Mocurry West (Wexford)', zip: '619005' },
	{ city: 'Moddybeg (Wexford)', zip: '314751' },
	{ city: 'Modeese (Monaghan)', zip: '942326' },
	{ city: 'Model Village (Cork)', zip: '760902' },
	{ city: 'Modeshil (Tipperary)', zip: '895531' },
	{ city: 'Modorragh (Leitrim)', zip: '823333' },
	{ city: 'Modranstown (Westmeath)', zip: '548447' },
	{ city: 'Modreeny (Tipperary)', zip: '421236' },
	{ city: 'Moe (Clare)', zip: '457320' },
	{ city: 'Mogeely (Cork)', zip: '145920' },
	{ city: 'Mogeely Lower (Cork)', zip: '514911' },
	{ city: 'Mogeely Upper (Cork)', zip: '623383' },
	{ city: 'Mogh (Tipperary)', zip: '977187' },
	{ city: 'Mogland (Tipperary)', zip: '553527' },
	{ city: 'Moglass (Tipperary)', zip: '184259' },
	{ city: 'Mogouhy (Clare)', zip: '422075' },
	{ city: 'Mogullaan (Clare)', zip: '525124' },
	{ city: 'Mogumna (Donegal)', zip: '901959' },
	{ city: 'Mogumna Mountain (Donegal)', zip: '827278' },
	{ city: 'Mohanagh (Cork)', zip: '215207' },
	{ city: 'Moheedian (Roscommon)', zip: '202690' },
	{ city: 'Moher (Cavan)', zip: '584539' },
	{ city: 'Moher (Cork)', zip: '863552' },
	{ city: 'Moher (Galway)', zip: '497110' },
	{ city: 'Moher (Kerry)', zip: '712081' },
	{ city: 'Moher (Leitrim)', zip: '753101' },
	{ city: 'Moher (Limerick)', zip: '184662' },
	{ city: 'Moher (Roscommon)', zip: '131002' },
	{ city: 'Moher (Tipperary)', zip: '682424' },
	{ city: 'Mohera (Cork)', zip: '910583' },
	{ city: 'Moheracreevy Glebe (Leitrim)', zip: '768087' },
	{ city: 'Moheragh (Tipperary)', zip: '836525' },
	{ city: 'Moheramoylan (Clare)', zip: '724692' },
	{ city: 'Moheraroon (Clare)', zip: '825321' },
	{ city: 'Moherbullog (Clare)', zip: '670458' },
	{ city: 'Mohercrom (Cavan)', zip: '305781' },
	{ city: 'Moher East (Laois)', zip: '824199' },
	{ city: 'Moher East (Tipperary)', zip: '757826' },
	{ city: 'Mohereen (Cork)', zip: '738396' },
	{ city: 'Moherloob (Cavan)', zip: '996710' },
	{ city: 'Mohernagh (Limerick)', zip: '575845' },
	{ city: 'Mohernameela (Leitrim)', zip: '865654' },
	{ city: 'Moherreagh (Cavan)', zip: '300676' },
	{ city: 'Moherrevan (Leitrim)', zip: '694976' },
	{ city: 'Moherrevogagh (Leitrim)', zip: '453550' },
	{ city: 'Moher West (Laois)', zip: '261551' },
	{ city: 'Moher West (Tipperary)', zip: '580016' },
	{ city: 'Mohil (Kilkenny)', zip: '328181' },
	{ city: 'Mohill (Leitrim)', zip: '529568' },
	{ city: 'Mohober (Tipperary)', zip: '603825' },
	{ city: 'Mohona (Cork)', zip: '414684' },
	{ city: 'Mohullen (Carlow)', zip: '200530' },
	{ city: 'Moig (Limerick)', zip: '299625' },
	{ city: 'Moig East (Limerick)', zip: '147953' },
	{ city: 'Moig East Glebe (Limerick)', zip: '848713' },
	{ city: 'Moigh (Limerick)', zip: '383270' },
	{ city: 'Moigh (Roscommon)', zip: '905744' },
	{ city: 'Moigh Lower (Roscommon)', zip: '475413' },
	{ city: 'Moigh Upper (Roscommon)', zip: '100955' },
	{ city: 'Moig North (Limerick)', zip: '374296' },
	{ city: 'Moig South (Limerick)', zip: '577093' },
	{ city: 'Moig West (Limerick)', zip: '365468' },
	{ city: 'Mokeeran (Monaghan)', zip: '877177' },
	{ city: 'Molassy (Kilkenny)', zip: '388488' },
	{ city: 'Molerick (Meath)', zip: '243790' },
	{ city: 'Mollaneen (Clare)', zip: '965019' },
	{ city: 'Molly (Longford)', zip: '966109' },
	{ city: 'Mollyglass (Longford)', zip: '377537' },
	{ city: 'Mollynadinta (Leitrim)', zip: '299203' },
	{ city: 'Mollyroe (Longford)', zip: '649939' },
	{ city: 'Molosky (Clare)', zip: '338843' },
	{ city: 'Molougha (Clare)', zip: '931207' },
	{ city: 'Moloughabbey (Tipperary)', zip: '959867' },
	{ city: 'Moloughnewtown (Tipperary)', zip: '349875' },
	{ city: 'Molum (Kilkenny)', zip: '712394' },
	{ city: 'Momeen (Donegal)', zip: '102375' },
	{ city: 'Momony (Monaghan)', zip: '942109' },
	{ city: 'Monablanchameen (Kilkenny)', zip: '863272' },
	{ city: 'Monaboul (Kilkenny)', zip: '850586' },
	{ city: 'Monabraher (Cork)', zip: '114675' },
	{ city: 'Monabreeka (Waterford)', zip: '613388' },
	{ city: 'Monabrika (Kilkenny)', zip: '228608' },
	{ city: 'Monabrogue (Kilkenny)', zip: '791382' },
	{ city: 'Monacahee (Wexford)', zip: '319699' },
	{ city: 'Monacallee (Waterford)', zip: '538109' },
	{ city: 'Monacappa (Kerry)', zip: '827891' },
	{ city: 'Monachunna (Kilkenny)', zip: '432743' },
	{ city: 'Monaclarig (Cork)', zip: '911141' },
	{ city: 'Monaclaudy (Kildare)', zip: '811784' },
	{ city: 'Monaclinoe (Limerick)', zip: '708455' },
	{ city: 'Monacnapa (Cork)', zip: '220033' },
	{ city: 'Monacocka (Tipperary)', zip: '758632' },
	{ city: 'Monacow (Galway)', zip: '159168' },
	{ city: 'Monacreagh (Cork)', zip: '553152' },
	{ city: 'Monacullee (Waterford)', zip: '209942' },
	{ city: 'Monadarragh (Longford)', zip: '651017' },
	{ city: 'Monaderreen (Tipperary)', zip: '314024' },
	{ city: 'Monadiha (Waterford)', zip: '448327' },
	{ city: 'Monadreela (Tipperary)', zip: '920857' },
	{ city: 'Monadrishane (Cork)', zip: '463094' },
	{ city: 'Monadubbaun (Kilkenny)', zip: '372146' },
	{ city: 'Monaduff (Longford)', zip: '734874' },
	{ city: 'Monaduff (Westmeath)', zip: '557377' },
	{ city: 'Monafehadee (Waterford)', zip: '707693' },
	{ city: 'Monaferrick (Laois)', zip: '839960' },
	{ city: 'Monafrica (Kilkenny)', zip: '372699' },
	{ city: 'Monagalliagh (Meath)', zip: '393316' },
	{ city: 'Monagally East (Waterford)', zip: '591043' },
	{ city: 'Monagally West (Waterford)', zip: '218036' },
	{ city: 'Monagarraun (Mayo)', zip: '103197' },
	{ city: 'Monagarrow Little (Wexford)', zip: '595477' },
	{ city: 'Monagarrow Lower (Wexford)', zip: '992759' },
	{ city: 'Monagarrow Upper (Wexford)', zip: '780264' },
	{ city: 'Monage (Monaghan)', zip: '732618' },
	{ city: 'Monagead (Westmeath)', zip: '840909' },
	{ city: 'Monagear (Wexford)', zip: '791138' },
	{ city: 'Monagee (Tipperary)', zip: '915025' },
	{ city: 'Monageela (Waterford)', zip: '264044' },
	{ city: 'Monaghan (Monaghan)', zip: '955968' },
	{ city: 'Monaghanoose (Cavan)', zip: '353551' },
	{ city: 'Monaghanstown (Westmeath)', zip: '899509' },
	{ city: 'Monagilleeny (Waterford)', zip: '476311' },
	{ city: 'Monaglogh (Wicklow)', zip: '737126' },
	{ city: 'Monagor (Monaghan)', zip: '451342' },
	{ city: 'Monagormley (Galway)', zip: '436538' },
	{ city: 'Monagoul (Cork)', zip: '224801' },
	{ city: 'Monagoun (Cork)', zip: '153752' },
	{ city: 'Monagoush (Waterford)', zip: '575847' },
	{ city: 'Monagreany Lower (Wexford)', zip: '273371' },
	{ city: 'Monagreany Upper (Wexford)', zip: '444737' },
	{ city: 'Monagurra (Cork)', zip: '845337' },
	{ city: 'Monaincha (Tipperary)', zip: '367163' },
	{ city: 'Monairmore (Galway)', zip: '786497' },
	{ city: 'Monakeeba (Tipperary)', zip: '847026' },
	{ city: 'Monakirka (Waterford)', zip: '489727' },
	{ city: 'Monalahy (Cork)', zip: '576768' },
	{ city: 'Monalee (Wexford)', zip: '107990' },
	{ city: 'Monaleehill (Wexford)', zip: '274986' },
	{ city: 'Monalia (Monaghan)', zip: '617262' },
	{ city: 'Monalin (Wicklow)', zip: '811206' },
	{ city: 'Monallig (Cork)', zip: '686297' },
	{ city: 'Monaloo (Cork)', zip: '732181' },
	{ city: 'Monaloughra (Tipperary)', zip: '292611' },
	{ city: 'Monalour Lower (Waterford)', zip: '792942' },
	{ city: 'Monalour Upper (Waterford)', zip: '719754' },
	{ city: 'Monaltybane (Monaghan)', zip: '252164' },
	{ city: 'Monaltyduff (Monaghan)', zip: '218447' },
	{ city: 'Monalug (Wexford)', zip: '422839' },
	{ city: 'Monalummery (Waterford)', zip: '577859' },
	{ city: 'Monalumpera (Tipperary)', zip: '498888' },
	{ city: 'Monaman Lower (Waterford)', zip: '236078' },
	{ city: 'Monamanry (Laois)', zip: '265968' },
	{ city: 'Monaman Upper (Waterford)', zip: '643024' },
	{ city: 'Monambraher (Galway)', zip: '751380' },
	{ city: 'Monameagh (Tipperary)', zip: '645894' },
	{ city: 'Monameean (Waterford)', zip: '698006' },
	{ city: 'Monamelagh (Waterford)', zip: '716164' },
	{ city: 'Monamintra (Waterford)', zip: '296488' },
	{ city: 'Monamoe (Tipperary)', zip: '821225' },
	{ city: 'Monamolin (Wexford)', zip: '394476' },
	{ city: 'Monamonra (Laois)', zip: '282458' },
	{ city: 'Monamore (Mayo)', zip: '684341' },
	{ city: 'Monamraher (Waterford)', zip: '116358' },
	{ city: 'Monamuck (Wicklow)', zip: '307445' },
	{ city: 'Monanagirr (Monaghan)', zip: '204085' },
	{ city: 'Monanaleen (Clare)', zip: '777005' },
	{ city: 'Monananig (Cork)', zip: '941089' },
	{ city: 'Monanarrig (Wexford)', zip: '145838' },
	{ city: 'Monaneague (Cork)', zip: '845735' },
	{ city: 'Monanearla (Tipperary)', zip: '895526' },
	{ city: 'Monaneea (Waterford)', zip: '637112' },
	{ city: 'Monang (Waterford)', zip: '932581' },
	{ city: 'Monanimy Lower (Cork)', zip: '547125' },
	{ city: 'Monanimy Upper (Cork)', zip: '225026' },
	{ city: 'Monanny (Monaghan)', zip: '565165' },
	{ city: 'Monanoe (Clare)', zip: '465371' },
	{ city: 'Monanooag (Limerick)', zip: '700033' },
	{ city: 'Monanore (Tipperary)', zip: '286525' },
	{ city: 'Monantin (Monaghan)', zip: '538252' },
	{ city: 'Monanveel (Cork)', zip: '429536' },
	{ city: 'Monaparson (Cork)', zip: '696961' },
	{ city: 'Monaquill (Tipperary)', zip: '716112' },
	{ city: 'Monaraha (Tipperary)', zip: '327467' },
	{ city: 'Monaraheen (Tipperary)', zip: '638634' },
	{ city: 'Monarche Commons (Kilkenny)', zip: '762282' },
	{ city: 'Monard (Cork)', zip: '757069' },
	{ city: 'Monard (Galway)', zip: '912729' },
	{ city: 'Monard (Mayo)', zip: '803123' },
	{ city: 'Monard (Tipperary)', zip: '569728' },
	{ city: 'Monard (Waterford)', zip: '771525' },
	{ city: 'Monareagh (Cork)', zip: '636479' },
	{ city: 'Monareagh (Wexford)', zip: '660755' },
	{ city: 'Monaree (Kerry)', zip: '940603' },
	{ city: 'Monargan Glebe (Donegal)', zip: '898399' },
	{ city: 'Monaroan (Tipperary)', zip: '647455' },
	{ city: 'Monart East (Wexford)', zip: '435820' },
	{ city: 'Monart West (Wexford)', zip: '687369' },
	{ city: 'Monarud (Waterford)', zip: '670113' },
	{ city: 'Monarudmountain (Waterford)', zip: '785140' },
	{ city: 'Monascallaghan (Longford)', zip: '827927' },
	{ city: 'Monascreeban (Laois)', zip: '844830' },
	{ city: 'Monascreebe (Louth)', zip: '244035' },
	{ city: 'Monaseed (Wexford)', zip: '673275' },
	{ city: 'Monaseed Demesne (Wexford)', zip: '224548' },
	{ city: 'Monashinnagh (Limerick)', zip: '643175' },
	{ city: 'Monaskeha (Clare)', zip: '683500' },
	{ city: 'Monasootagh (Wexford)', zip: '715608' },
	{ city: 'Monasop (Laois)', zip: '512885' },
	{ city: 'Monassa (Kilkenny)', zip: '502066' },
	{ city: 'Monasset (Westmeath)', zip: '576273' },
	{ city: 'Monaster (Limerick)', zip: '928582' },
	{ city: 'Monasteraden (Sligo)', zip: '257302' },
	{ city: 'Monasterboice (Louth)', zip: '560316' },
	{ city: 'Monasterevin (Kildare)', zip: '217606' },
	{ city: 'Monasterevin Bog (Kildare)', zip: '641171' },
	{ city: 'Monasternalea (Galway)', zip: '441849' },
	{ city: 'Monaster North (Limerick)', zip: '949933' },
	{ city: 'Monasteroris (Offaly)', zip: '125990' },
	{ city: 'Monasterowen (Galway)', zip: '797642' },
	{ city: 'Monasterredan (Sligo)', zip: '627714' },
	{ city: 'Monaster South (Limerick)', zip: '838972' },
	{ city: 'Monastery (Wicklow)', zip: '189559' },
	{ city: 'Monastill (Carlow)', zip: '426076' },
	{ city: 'Monataggart (Cork)', zip: '544188' },
	{ city: 'Monataggart (Waterford)', zip: '361350' },
	{ city: 'Monatarriv East (Waterford)', zip: '464529' },
	{ city: 'Monatarriv West (Waterford)', zip: '890619' },
	{ city: 'Monatierna (Tipperary)', zip: '892151' },
	{ city: 'Monatogher (Tipperary)', zip: '665636' },
	{ city: 'Monatooreen (Cork)', zip: '157992' },
	{ city: 'Monatore (Kildare)', zip: '674347' },
	{ city: 'Monatore (Wicklow)', zip: '985769' },
	{ city: 'Monatray East (Waterford)', zip: '115565' },
	{ city: 'Monatray Middle (Waterford)', zip: '481642' },
	{ city: 'Monatray West (Waterford)', zip: '767960' },
	{ city: 'Monatrim Lower (Waterford)', zip: '600825' },
	{ city: 'Monatrim Upper (Waterford)', zip: '720040' },
	{ city: 'Monature (Wexford)', zip: '180013' },
	{ city: 'Monaughrim (Carlow)', zip: '316003' },
	{ city: 'Monavadaroe (Kilkenny)', zip: '349854' },
	{ city: 'Monavaddra (Cork)', zip: '777640' },
	{ city: 'Monavaddra (Kilkenny)', zip: '719859' },
	{ city: 'Monavaha (Limerick)', zip: '288777' },
	{ city: 'Monavallet (Louth)', zip: '772767' },
	{ city: 'Monavally (Kerry)', zip: '765932' },
	{ city: 'Monavanshere (Cork)', zip: '673077' },
	{ city: 'Monavarnoge (Cork)', zip: '272848' },
	{ city: 'Monavaud (Waterford)', zip: '742023' },
	{ city: 'Monavea (Laois)', zip: '650237' },
	{ city: 'Monavinnaun (Kilkenny)', zip: '196439' },
	{ city: 'Monavoddagh (Wexford)', zip: '177699' },
	{ city: 'Monavugga (Waterford)', zip: '652968' },
	{ city: 'Monawilling Lower (Wexford)', zip: '506640' },
	{ city: 'Monawilling Upper (Wexford)', zip: '280209' },
	{ city: 'Monawinnia (Kilkenny)', zip: '380807' },
	{ city: 'Monbay Lower (Wexford)', zip: '843834' },
	{ city: 'Monbay Upper (Wexford)', zip: '319097' },
	{ city: 'Monbeg (Wexford)', zip: '657508' },
	{ city: 'Monboy (Waterford)', zip: '831706' },
	{ city: 'Monclink (Donegal)', zip: '905771' },
	{ city: 'Mondaniel (Cork)', zip: '199891' },
	{ city: 'Mondaniel (Wexford)', zip: '197448' },
	{ city: 'Mondellihy (Limerick)', zip: '848832' },
	{ city: 'Mondooey Lower (Donegal)', zip: '630205' },
	{ city: 'Mondooey Middle (Donegal)', zip: '153074' },
	{ city: 'Mondooey Upper (Donegal)', zip: '846253' },
	{ city: 'Mondrehid (Laois)', zip: '818066' },
	{ city: 'Monduff (Wicklow)', zip: '856422' },
	{ city: 'Monea (Waterford)', zip: '304388' },
	{ city: 'Monearaniska (Cork)', zip: '856536' },
	{ city: 'Monearla (Limerick)', zip: '653371' },
	{ city: 'Monearmore (Cork)', zip: '795111' },
	{ city: 'Monearmore (Galway)', zip: '512239' },
	{ city: 'Monearmore (Kerry)', zip: '451527' },
	{ city: 'Monearmore (Tipperary)', zip: '147831' },
	{ city: 'Monebrock (Laois)', zip: '313601' },
	{ city: 'Monee East (Cork)', zip: '137662' },
	{ city: 'Moneen (Cavan)', zip: '506648' },
	{ city: 'Moneen (Clare)', zip: '909035' },
	{ city: 'Moneen (Cork)', zip: '524142' },
	{ city: 'Moneen (Donegal)', zip: '782991' },
	{ city: 'Moneen (Galway)', zip: '620442' },
	{ city: 'Moneen (Kilkenny)', zip: '456123' },
	{ city: 'Moneen (Leitrim)', zip: '202420' },
	{ city: 'Moneen (Limerick)', zip: '371468' },
	{ city: 'Moneen (Mayo)', zip: '948203' },
	{ city: 'Moneen (Roscommon)', zip: '238956' },
	{ city: 'Moneen (Westmeath)', zip: '310916' },
	{ city: 'Moneenabrone (Cavan)', zip: '651265' },
	{ city: 'Moneenacully (Roscommon)', zip: '904034' },
	{ city: 'Moneenageer (Leitrim)', zip: '768641' },
	{ city: 'Moneenagunnell (Offaly)', zip: '974563' },
	{ city: 'Moneenaheeltia (Galway)', zip: '189143' },
	{ city: 'Moneenalion Commons Lower (Dublin)', zip: '421677' },
	{ city: 'Moneenalion Commons Upper (Dublin)', zip: '746631' },
	{ city: 'Moneenally (Galway)', zip: '124081' },
	{ city: 'Moneenatieve (Leitrim)', zip: '114627' },
	{ city: 'Moneenaun (Kilkenny)', zip: '522170' },
	{ city: 'Moneenaveena (Galway)', zip: '524099' },
	{ city: 'Moneenbog (Roscommon)', zip: '533395' },
	{ city: 'Moneenbradagh (Mayo)', zip: '353804' },
	{ city: 'Moneenderg (Offaly)', zip: '890401' },
	{ city: 'Moneen East (Galway)', zip: '845917' },
	{ city: 'Moneengaugagh (Leitrim)', zip: '244690' },
	{ city: 'Moneenlom (Leitrim)', zip: '236512' },
	{ city: 'Moneenmore (Galway)', zip: '484843' },
	{ city: 'Moneennagliggin North (Clare)', zip: '669589' },
	{ city: 'Moneennagliggin South (Clare)', zip: '214928' },
	{ city: 'Moneennamucky (Cork)', zip: '557249' },
	{ city: 'Moneenpollagh (Galway)', zip: '104985' },
	{ city: 'Moneenreave (Leitrim)', zip: '897943' },
	{ city: 'Moneenroe (Galway)', zip: '234763' },
	{ city: 'Moneenroe (Kilkenny)', zip: '257640' },
	{ city: 'Moneens (Cork)', zip: '317269' },
	{ city: 'Moneensauran (Cavan)', zip: '599877' },
	{ city: 'Moneenshinnagh (Leitrim)', zip: '845314' },
	{ city: 'Moneenterriff (Cavan)', zip: '616332' },
	{ city: 'Moneen West (Galway)', zip: '710308' },
	{ city: 'Monee West (Cork)', zip: '756951' },
	{ city: 'Monellan (Donegal)', zip: '710158' },
	{ city: 'Monelly (Laois)', zip: '470188' },
	{ city: 'Monelty (Cavan)', zip: '480610' },
	{ city: 'Monennican (Meath)', zip: '946399' },
	{ city: 'Monenstown (Meath)', zip: '368067' },
	{ city: 'Monereagh (Sligo)', zip: '827007' },
	{ city: 'Monesk (Cavan)', zip: '972059' },
	{ city: 'Moness (Donegal)', zip: '718448' },
	{ city: 'Moneteen (Limerick)', zip: '470551' },
	{ city: 'Money (Cavan)', zip: '274684' },
	{ city: 'Money (Mayo)', zip: '839554' },
	{ city: 'Money (Monaghan)', zip: '259886' },
	{ city: 'Money (Offaly)', zip: '237728' },
	{ city: 'Money (Westmeath)', zip: '365384' },
	{ city: 'Money (Wexford)', zip: '760606' },
	{ city: 'Moneyatta Commons (Dublin)', zip: '879560' },
	{ city: 'Moneyballytyrrell (Laois)', zip: '928730' },
	{ city: 'Moneybeg (Carlow)', zip: '701174' },
	{ city: 'Moneybeg (Westmeath)', zip: '677731' },
	{ city: 'Money Beg (Donegal)', zip: '802771' },
	{ city: 'Money Big (Wicklow)', zip: '585364' },
	{ city: 'Moneyboe (Wexford)', zip: '747927' },
	{ city: 'Moneyboy (Roscommon)', zip: '781778' },
	{ city: 'Moneycarroll (Wicklow)', zip: '426134' },
	{ city: 'Moneycass Glebe (Cavan)', zip: '267732' },
	{ city: 'Moneycleare (Laois)', zip: '248336' },
	{ city: 'Moneycooly (Kildare)', zip: '111987' },
	{ city: 'Moneycrockroe (Louth)', zip: '478985' },
	{ city: 'Moneycross Lower (Wexford)', zip: '818420' },
	{ city: 'Moneycross Upper (Wexford)', zip: '629773' },
	{ city: 'Moneycusker (Cork)', zip: '461427' },
	{ city: 'Moneydarragh (Donegal)', zip: '691957' },
	{ city: 'Moneydass (Tipperary)', zip: '276735' },
	{ city: 'Moneyduff (Galway)', zip: '923980' },
	{ city: 'Moneyduff (Kerry)', zip: '615551' },
	{ city: 'Moneyduff (Leitrim)', zip: '592507' },
	{ city: 'Moneyduff (Roscommon)', zip: '914791' },
	{ city: 'Moneydurtlow (Wexford)', zip: '937456' },
	{ city: 'Moneyfad (Longford)', zip: '465751' },
	{ city: 'Moneyflugh (Cork)', zip: '914685' },
	{ city: 'Moneyflugh (Kerry)', zip: '961807' },
	{ city: 'Moneygaff East (Cork)', zip: '225486' },
	{ city: 'Moneygaff West (Cork)', zip: '343378' },
	{ city: 'Moneygall (Offaly)', zip: '774744' },
	{ city: 'Moneygashel (Cavan)', zip: '721024' },
	{ city: 'Moneygold (Sligo)', zip: '796601' },
	{ city: 'Moneygorm (Cork)', zip: '352879' },
	{ city: 'Moneygorm (Waterford)', zip: '807543' },
	{ city: 'Moneygorm East (Waterford)', zip: '608489' },
	{ city: 'Moneygorm North (Waterford)', zip: '341391' },
	{ city: 'Moneygorm South (Waterford)', zip: '259353' },
	{ city: 'Moneygorm West (Waterford)', zip: '957868' },
	{ city: 'Moneygreggan (Donegal)', zip: '692684' },
	{ city: 'Moneygrogh (Carlow)', zip: '595279' },
	{ city: 'Moneygurney (Cork)', zip: '931368' },
	{ city: 'Moneyguyneen (Offaly)', zip: '274399' },
	{ city: 'Moneyhaughly (Donegal)', zip: '693193' },
	{ city: 'Moneyheer (Wexford)', zip: '947282' },
	{ city: 'Moneyhenry (Kilkenny)', zip: '192940' },
	{ city: 'Moneyhoolaghan (Longford)', zip: '846854' },
	{ city: 'Moneyhore (Wexford)', zip: '413366' },
	{ city: 'Moneylagan (Longford)', zip: '165304' },
	{ city: 'Moneylahan (Sligo)', zip: '915293' },
	{ city: 'Moneylane (Wicklow)', zip: '290828' },
	{ city: 'Moneylawn Lower (Wexford)', zip: '800192' },
	{ city: 'Moneylawn Upper (Wexford)', zip: '256716' },
	{ city: 'Moneylea (Cork)', zip: '557959' },
	{ city: 'Moneylea (Roscommon)', zip: '982413' },
	{ city: 'Moneylea (Westmeath)', zip: '631956' },
	{ city: 'Money Little (Wicklow)', zip: '132910' },
	{ city: 'Money Lower (Laois)', zip: '665757' },
	{ city: 'Money Lower (Wicklow)', zip: '226828' },
	{ city: 'Moneymeen (Wicklow)', zip: '402460' },
	{ city: 'Moneymohill (Limerick)', zip: '942643' },
	{ city: 'Moneymore (Donegal)', zip: '886147' },
	{ city: 'Moneymore (Laois)', zip: '861987' },
	{ city: 'Moneymore (Louth)', zip: '912140' },
	{ city: 'Moneymore (Mayo)', zip: '359032' },
	{ city: 'Moneymore (Meath)', zip: '445947' },
	{ city: 'Moneymore (Roscommon)', zip: '912070' },
	{ city: 'Moneymore (Wicklow)', zip: '118087' },
	{ city: 'Money More (Donegal)', zip: '515329' },
	{ city: 'Moneymore East (Galway)', zip: '781942' },
	{ city: 'Moneymore West (Galway)', zip: '549930' },
	{ city: 'Moneynaboola (Tipperary)', zip: '545864' },
	{ city: 'Moneynacroha (Cork)', zip: '755703' },
	{ city: 'Moneynamough (Wexford)', zip: '984784' },
	{ city: 'Moneynamuck (Kilkenny)', zip: '767750' },
	{ city: 'Moneynierin (Mayo)', zip: '432212' },
	{ city: 'Moneynure (Cavan)', zip: '396969' },
	{ city: 'Moneynure (Leitrim)', zip: '148801' },
	{ city: 'Moneypark (Tipperary)', zip: '951257' },
	{ city: 'Moneyquid (Laois)', zip: '943739' },
	{ city: 'Moneyreague (Cork)', zip: '606363' },
	{ city: 'Moneyribbin (Wexford)', zip: '221088' },
	{ city: 'Moneyroe (Leitrim)', zip: '353661' },
	{ city: 'Moneyshingaun (Offaly)', zip: '907170' },
	{ city: 'Moneystown Hill (Wicklow)', zip: '788733' },
	{ city: 'Moneystown North (Wicklow)', zip: '969472' },
	{ city: 'Moneystown South (Wicklow)', zip: '583945' },
	{ city: 'Moneyteige (Galway)', zip: '127805' },
	{ city: 'Moneyteige Middle (Wicklow)', zip: '451025' },
	{ city: 'Moneyteige North (Wicklow)', zip: '592740' },
	{ city: 'Moneyteige South (Wicklow)', zip: '758415' },
	{ city: 'Moneytucker (Wexford)', zip: '215545' },
	{ city: 'Money Upper (Laois)', zip: '226354' },
	{ city: 'Money Upper (Wicklow)', zip: '917213' },
	{ city: 'Moneyveen (Galway)', zip: '342403' },
	{ city: 'Moneyvolan (Monaghan)', zip: '961663' },
	{ city: 'Moneyvollahane (Cork)', zip: '273934' },
	{ city: 'Monfad (Donegal)', zip: '565153' },
	{ city: 'Monfieldstown (Cork)', zip: '782633' },
	{ city: 'Monfin (Wexford)', zip: '808785' },
	{ city: 'Mong (Leitrim)', zip: '274942' },
	{ city: 'Mongagh (Roscommon)', zip: '345331' },
	{ city: 'Mongan (Wicklow)', zip: '434105' },
	{ city: 'Monganstown (Westmeath)', zip: '544437' },
	{ city: 'Mongaun (Wexford)', zip: '531588' },
	{ city: 'Mongavlin (Donegal)', zip: '272145' },
	{ city: 'Mongfune (Limerick)', zip: '761706' },
	{ city: 'Monglass (Donegal)', zip: '583171' },
	{ city: 'Monglass (Wexford)', zip: '685495' },
	{ city: 'Mongnacool Lower (Wicklow)', zip: '322486' },
	{ city: 'Mongnacool Upper (Wicklow)', zip: '294458' },
	{ city: 'Mongorry (Donegal)', zip: '873867' },
	{ city: 'Monicknew (Laois)', zip: '171213' },
	{ city: 'Monilea (Westmeath)', zip: '896796' },
	{ city: 'Monintin (Monaghan)', zip: '870428' },
	{ city: 'Monintown (Westmeath)', zip: '498042' },
	{ city: 'Monivea (Galway)', zip: '653822' },
	{ city: 'Monivea Demesne (Galway)', zip: '395401' },
	{ city: 'Monkeal (Waterford)', zip: '465837' },
	{ city: 'Monknewtown (Meath)', zip: '940282' },
	{ city: 'Monksfield (Galway)', zip: '511436' },
	{ city: 'Monksgrange (Tipperary)', zip: '441677' },
	{ city: 'Monksland (Louth)', zip: '440730' },
	{ city: 'Monksland (Roscommon)', zip: '263407' },
	{ city: 'Monksland (Westmeath)', zip: '154784' },
	{ city: 'Monkstown (Cork)', zip: '909642' },
	{ city: 'Monkstown (Dublin)', zip: '202645' },
	{ city: 'Monkstown (Tipperary)', zip: '304828' },
	{ city: 'Monkstown (Westmeath)', zip: '279607' },
	{ city: 'Monkstown Castlefarm (Dublin)', zip: '102157' },
	{ city: 'Monkstown Housefarm (Dublin)', zip: '483181' },
	{ city: 'Monktown (Meath)', zip: '613392' },
	{ city: 'Monktown (Westmeath)', zip: '907488' },
	{ city: 'Monloum (Waterford)', zip: '941635' },
	{ city: 'Monminane (Waterford)', zip: '871661' },
	{ city: 'Monmore (Wexford)', zip: '590969' },
	{ city: 'Monmurry (Monaghan)', zip: '210864' },
	{ city: 'Monnagh (Laois)', zip: '832432' },
	{ city: 'Monneill (Monaghan)', zip: '961571' },
	{ city: 'Monnery Lower (Cavan)', zip: '704820' },
	{ city: 'Monnery Upper (Cavan)', zip: '968913' },
	{ city: 'Monphole (Kilkenny)', zip: '393515' },
	{ city: 'Monread North (Kildare)', zip: '142394' },
	{ city: 'Monread South (Kildare)', zip: '282087' },
	{ city: 'Monreagh (Clare)', zip: '884503' },
	{ city: 'Monreagh (Donegal)', zip: '133560' },
	{ city: 'Monroe (Galway)', zip: '615466' },
	{ city: 'Monroe (Tipperary)', zip: '593893' },
	{ city: 'Monroe (Westmeath)', zip: '620412' },
	{ city: 'Monroe (Wexford)', zip: '192637' },
	{ city: 'Monroe (Wicklow)', zip: '160450' },
	{ city: 'Monroe East (Tipperary)', zip: '202956' },
	{ city: 'Monroe Glebe (Waterford)', zip: '549014' },
	{ city: 'Monroe West (Tipperary)', zip: '365742' },
	{ city: 'Monsea (Tipperary)', zip: '782446' },
	{ city: 'Monslatt (Tipperary)', zip: '509108' },
	{ city: 'Montanagay (Kerry)', zip: '144551' },
	{ city: 'Montanavoe (Tipperary)', zip: '654461' },
	{ city: 'Monteen (Cork)', zip: '248730' },
	{ city: 'Monteensudder (Cork)', zip: '967259' },
	{ city: 'Montiagh (Sligo)', zip: '879106' },
	{ city: 'Montiagh North (Galway)', zip: '790005' },
	{ city: 'Montiagh South (Galway)', zip: '663762' },
	{ city: 'Montore (Tipperary)', zip: '245751' },
	{ city: 'Montpelier (Dublin)', zip: '967539' },
	{ city: 'Montpelier (Galway)', zip: '217127' },
	{ city: 'Montpelier (Limerick)', zip: '807738' },
	{ city: 'Montrath (Westmeath)', zip: '923139' },
	{ city: 'Montymeane (Donegal)', zip: '741361' },
	{ city: 'Monument (Kerry)', zip: '276387' },
	{ city: 'Monumentpark (Galway)', zip: '566562' },
	{ city: 'Monumentpark (Mayo)', zip: '246375' },
	{ city: 'Monure (Laois)', zip: '510386' },
	{ city: 'Monvore (Waterford)', zip: '469986' },
	{ city: 'Monvoy (Waterford)', zip: '792484' },
	{ city: 'Monydoo (Cavan)', zip: '960534' },
	{ city: 'Monyglen (Monaghan)', zip: '583185' },
	{ city: 'Monygorbet (Monaghan)', zip: '452238' },
	{ city: 'Monyheige Commons (Kilkenny)', zip: '925958' },
	{ city: 'Monyvroe (Waterford)', zip: '891426' },
	{ city: 'Moodoge (Cavan)', zip: '982774' },
	{ city: 'Moodoge (Sligo)', zip: '481091' },
	{ city: 'Moods (Kildare)', zip: '281348' },
	{ city: 'Mooghaun North (Clare)', zip: '739532' },
	{ city: 'Mooghaun South (Clare)', zip: '361959' },
	{ city: 'Mooghna (Clare)', zip: '770830' },
	{ city: 'Moohane (Kerry)', zip: '885415' },
	{ city: 'Moohane (Limerick)', zip: '968662' },
	{ city: 'Mooncoin (Kilkenny)', zip: '287423' },
	{ city: 'Moone (Kildare)', zip: '613081' },
	{ city: 'Mooneennahasragh (Donegal)', zip: '618120' },
	{ city: 'Mooneystown (Meath)', zip: '349480' },
	{ city: 'Moonhall (Kilkenny)', zip: '316234' },
	{ city: 'Moonveen (Kilkenny)', zip: '141936' },
	{ city: 'Moor (Galway)', zip: '284287' },
	{ city: 'Moor (Longford)', zip: '695375' },
	{ city: 'Moor (Roscommon)', zip: '958621' },
	{ city: 'Moor (Tipperary)', zip: '100332' },
	{ city: 'Moor (Wexford)', zip: '403607' },
	{ city: 'Moorabbey (Tipperary)', zip: '667084' },
	{ city: 'Moorbrook (Mayo)', zip: '942222' },
	{ city: 'Moord (Waterford)', zip: '456218' },
	{ city: 'Mooreabbey Demesne (Kildare)', zip: '890970' },
	{ city: 'Moorechurch (Meath)', zip: '194400' },
	{ city: 'Mooreenaruggan (Dublin)', zip: '816289' },
	{ city: 'Moorehill (Waterford)', zip: '193535' },
	{ city: 'Mooremount (Louth)', zip: '184387' },
	{ city: 'Moore North (Roscommon)', zip: '522343' },
	{ city: 'Moorepark (Cork)', zip: '130407' },
	{ city: 'Moorepark (Meath)', zip: '641010' },
	{ city: 'Moorepark West (Cork)', zip: '875952' },
	{ city: 'Moorerow (Westmeath)', zip: '644237' },
	{ city: 'Mooresfort (Tipperary)', zip: '495074' },
	{ city: 'Mooreshill (Wicklow)', zip: '777199' },
	{ city: 'Mooresides (Meath)', zip: '235250' },
	{ city: 'Moore South (Roscommon)', zip: '908367' },
	{ city: 'Moorestown (Carlow)', zip: '221128' },
	{ city: 'Moorestown (Kerry)', zip: '555099' },
	{ city: 'Moorestown (Limerick)', zip: '404581' },
	{ city: 'Mooretown (Dublin)', zip: '389903' },
	{ city: 'Mooretown (Kildare)', zip: '903916' },
	{ city: 'Mooretown (Louth)', zip: '284785' },
	{ city: 'Mooretown (Meath)', zip: '981634' },
	{ city: 'Mooretown (Westmeath)', zip: '648199' },
	{ city: 'Moorfield (Galway)', zip: '635060' },
	{ city: 'Moorfield (Kildare)', zip: '823476' },
	{ city: 'Moorfields (Wexford)', zip: '331458' },
	{ city: 'Moorgagagh (Mayo)', zip: '296459' },
	{ city: 'Moorhill (Kildare)', zip: '440411' },
	{ city: 'Moorlagh (Meath)', zip: '283847' },
	{ city: 'Moorland (Louth)', zip: '427406' },
	{ city: 'Moorneen (Galway)', zip: '419235' },
	{ city: 'Moorock (Offaly)', zip: '662263' },
	{ city: 'Moor Of Meath (Meath)', zip: '923325' },
	{ city: 'Moorspark (Wicklow)', zip: '463942' },
	{ city: 'Moorstown (Tipperary)', zip: '207356' },
	{ city: 'Moorstown (Wicklow)', zip: '288389' },
	{ city: 'Moortown (Dublin)', zip: '547563' },
	{ city: 'Moortown (Kildare)', zip: '924012' },
	{ city: 'Moortown (Meath)', zip: '185000' },
	{ city: 'Moortown (Tipperary)', zip: '467406' },
	{ city: 'Moortown (Wexford)', zip: '776470' },
	{ city: 'Moortowncastle (Kildare)', zip: '824632' },
	{ city: 'Moortown Great (Wexford)', zip: '829572' },
	{ city: 'Moortown Little (Wexford)', zip: '448828' },
	{ city: 'Moraghy (Monaghan)', zip: '528984' },
	{ city: 'Moranspark (Westmeath)', zip: '611790' },
	{ city: 'Moranstown (Westmeath)', zip: '786779' },
	{ city: 'Moreagh (Cork)', zip: '192097' },
	{ city: 'Morenane (Limerick)', zip: '708149' },
	{ city: 'Morerah (Leitrim)', zip: '239663' },
	{ city: 'Moress (Donegal)', zip: '111037' },
	{ city: 'Morett (Laois)', zip: '179482' },
	{ city: "Morgan's Island (Galway)", zip: '290442' },
	{ city: 'Morgans North (Limerick)', zip: '372974' },
	{ city: 'Morgans South (Limerick)', zip: '624595' },
	{ city: 'Morganstown (Kildare)', zip: '986278' },
	{ city: 'Morganstown (Louth)', zip: '421876' },
	{ city: 'Mornane (Limerick)', zip: '993888' },
	{ city: 'Mornin (Longford)', zip: '420720' },
	{ city: 'Mornington (Meath)', zip: '219468' },
	{ city: 'Moroe (Limerick)', zip: '563894' },
	{ city: 'Moroewood (Limerick)', zip: '783161' },
	{ city: 'Moross (Donegal)', zip: '469345' },
	{ city: 'Morrell (Meath)', zip: '416704' },
	{ city: 'Morriscastle (Wexford)', zip: '895111' },
	{ city: 'Morrissysland (Wexford)', zip: '944552' },
	{ city: 'Morristown (Kildare)', zip: '995724' },
	{ city: 'Morristownbiller (Kildare)', zip: '714418' },
	{ city: 'Morristown Little (Kildare)', zip: '495635' },
	{ city: 'Morristown Lower (Kildare)', zip: '169203' },
	{ city: 'Morristown Upper (Kildare)', zip: '660798' },
	{ city: 'Mortarstown Lower (Carlow)', zip: '720944' },
	{ city: 'Mortarstown Upper (Carlow)', zip: '128459' },
	{ city: 'Mortgage (Limerick)', zip: '612862' },
	{ city: 'Mortgage (Waterford)', zip: '836143' },
	{ city: 'Mortgage Fields (Kilkenny)', zip: '671844' },
	{ city: 'Mortlestown (Limerick)', zip: '299601' },
	{ city: 'Mortlestown (Tipperary)', zip: '428871' },
	{ city: 'Mortlestown Little (Tipperary)', zip: '262554' },
	{ city: 'Mortyclogh (Clare)', zip: '349939' },
	{ city: 'Mosestown (Cork)', zip: '365847' },
	{ city: 'Moskeagh (Cork)', zip: '691591' },
	{ city: 'Mosney (Meath)', zip: '724121' },
	{ city: 'Mossbrook (Mayo)', zip: '970503' },
	{ city: 'Mossfield (Donegal)', zip: '931905' },
	{ city: 'Mossfield (Offaly)', zip: '305293' },
	{ city: 'Mossgrove (Cork)', zip: '818221' },
	{ city: 'Mosstown (Longford)', zip: '776966' },
	{ city: 'Mosstown Demesne (Westmeath)', zip: '781206' },
	{ city: 'Mosstown North (Louth)', zip: '940590' },
	{ city: 'Mosstown South (Louth)', zip: '613502' },
	{ city: 'Mossy Glen (Donegal)', zip: '854155' },
	{ city: 'Mota (Tipperary)', zip: '246228' },
	{ city: 'Motabower (Wexford)', zip: '532251' },
	{ city: 'Mote Demesne (Roscommon)', zip: '729693' },
	{ city: 'Mothel (Waterford)', zip: '486751' },
	{ city: 'Mough (Leitrim)', zip: '203636' },
	{ city: 'Mough (Offaly)', zip: '986857' },
	{ city: 'Moularostig (Kerry)', zip: '705259' },
	{ city: 'Mount (Clare)', zip: '788710' },
	{ city: 'Mountain (Galway)', zip: '978587' },
	{ city: 'Mountain (Mayo)', zip: '302805' },
	{ city: 'Mountaincastle North (Waterford)', zip: '295735' },
	{ city: 'Mountaincastle South (Waterford)', zip: '115105' },
	{ city: 'Mountaincommon (Mayo)', zip: '449223' },
	{ city: 'Mountain Common (Cork)', zip: '648770' },
	{ city: 'Mountain Common (Mayo)', zip: '439927' },
	{ city: 'Mountainfarm (Laois)', zip: '324200' },
	{ city: 'Mountainfarm (Waterford)', zip: '899812' },
	{ city: 'Mountaingate (Wexford)', zip: '992682' },
	{ city: 'Mountain Lodge Demesne (Monaghan)', zip: '615157' },
	{ city: 'Mountain Lower (Roscommon)', zip: '374786' },
	{ city: 'Mountainmuck (Wexford)', zip: '929672' },
	{ city: 'Mountain North (Galway)', zip: '656992' },
	{ city: 'Mountainpark (Donegal)', zip: '481655' },
	{ city: 'Mountainpark (Galway)', zip: '640308' },
	{ city: 'Mountainpole (Meath)', zip: '151951' },
	{ city: 'Mountainrea (Waterford)', zip: '375118' },
	{ city: 'Mountain South (Galway)', zip: '649145' },
	{ city: 'Mountainstown (Meath)', zip: '287683' },
	{ city: 'Mountainthird (Leitrim)', zip: '893371' },
	{ city: 'Mountaintown (Louth)', zip: '759407' },
	{ city: 'Mountain Upper (Roscommon)', zip: '583787' },
	{ city: 'Mountain West (Galway)', zip: '516418' },
	{ city: 'Mountalexander (Wexford)', zip: '770499' },
	{ city: 'Mountallen (Roscommon)', zip: '400673' },
	{ city: 'Mountallon (Clare)', zip: '254583' },
	{ city: 'Mountalt (Tipperary)', zip: '304955' },
	{ city: 'Mountambrose Great (Dublin)', zip: '300517' },
	{ city: 'Mountambrose Little (Dublin)', zip: '527599' },
	{ city: 'Mountanglesby (Tipperary)', zip: '706556' },
	{ city: 'Mount Anketell (Monaghan)', zip: '315335' },
	{ city: 'Mountanna (Wexford)', zip: '690041' },
	{ city: 'Mountanville (Dublin)', zip: '104159' },
	{ city: 'Mountarmstrong (Kildare)', zip: '975681' },
	{ city: 'Mountarmstrong (Offaly)', zip: '730161' },
	{ city: 'Mountashton (Dublin)', zip: '218672' },
	{ city: 'Mountaylor (Tipperary)', zip: '413491' },
	{ city: 'Mountbagnall (Louth)', zip: '858719' },
	{ city: 'Mountbell (Cork)', zip: '587649' },
	{ city: 'Mountbellew Bridge (Galway)', zip: '287644' },
	{ city: 'Mountbellew Demesne (Galway)', zip: '125269' },
	{ city: 'Mountbernard (Galway)', zip: '111193' },
	{ city: 'Mountblakeney (Limerick)', zip: '686880' },
	{ city: 'Mountbolton (Waterford)', zip: '985370' },
	{ city: 'Mountbolus (Offaly)', zip: '145130' },
	{ city: 'Mountbridget (Cork)', zip: '749276' },
	{ city: 'Mountbrown (Mayo)', zip: '182405' },
	{ city: 'Mountbrowne (Galway)', zip: '243454' },
	{ city: 'Mountcampbell (Leitrim)', zip: '482350' },
	{ city: 'Mountcarmel (Monaghan)', zip: '338955' },
	{ city: 'Mountcashel (Clare)', zip: '621109' },
	{ city: 'Mountcatherine (Clare)', zip: '766123' },
	{ city: 'Mountcatherine (Cork)', zip: '661011' },
	{ city: 'Mountcatherine (Limerick)', zip: '278113' },
	{ city: 'Mountcatherine (Tipperary)', zip: '224935' },
	{ city: 'Mountcharles (Donegal)', zip: '147734' },
	{ city: 'Mountcoal (Kerry)', zip: '445744' },
	{ city: 'Mountcollins (Limerick)', zip: '525201' },
	{ city: 'Mountcongreve (Waterford)', zip: '581744' },
	{ city: 'Mountcoote (Limerick)', zip: '858922' },
	{ city: 'Mountcorbitt (Cork)', zip: '925764' },
	{ city: 'Mountcotton (Cork)', zip: '827610' },
	{ city: 'Mountcross (Wexford)', zip: '343543' },
	{ city: 'Mountdavid (Limerick)', zip: '321253' },
	{ city: 'Mount Davys (Longford)', zip: '638479' },
	{ city: 'Mountdelvin (Roscommon)', zip: '133988' },
	{ city: 'Mount Desert (Cork)', zip: '540185' },
	{ city: 'Mountdillon (Roscommon)', zip: '503161' },
	{ city: 'Mountdoyle (Louth)', zip: '447976' },
	{ city: 'Mountdruid (Roscommon)', zip: '231148' },
	{ city: 'Mounteagle (Laois)', zip: '475205' },
	{ city: 'Mounteagle (Limerick)', zip: '531813' },
	{ city: 'Mountelliott (Wexford)', zip: '875497' },
	{ city: 'Mountfalcon (Tipperary)', zip: '593782' },
	{ city: 'Mountfead (Laois)', zip: '119084' },
	{ city: 'Mountfin Lower (Wexford)', zip: '459522' },
	{ city: 'Mountfinn (Kilkenny)', zip: '883459' },
	{ city: 'Mountfin Upper (Wexford)', zip: '975253' },
	{ city: 'Mountforest (Wexford)', zip: '490510' },
	{ city: 'Mountfortescue (Meath)', zip: '312886' },
	{ city: 'Mountfox (Limerick)', zip: '408862' },
	{ city: 'Mountfrisco (Tipperary)', zip: '303456' },
	{ city: 'Mountgabriel (Cork)', zip: '429014' },
	{ city: 'Mountgaffeny (Sligo)', zip: '355836' },
	{ city: 'Mountgale (Kilkenny)', zip: '480130' },
	{ city: 'Mountgarret (Galway)', zip: '517837' },
	{ city: 'Mountgarrett (Wexford)', zip: '163033' },
	{ city: 'Mountgeorge (Tipperary)', zip: '893905' },
	{ city: 'Mountgeorge (Wexford)', zip: '544627' },
	{ city: 'Mountgordon (Clare)', zip: '607329' },
	{ city: 'Mountgorry (Dublin)', zip: '433754' },
	{ city: 'Mountgregory (Mayo)', zip: '354054' },
	{ city: 'Mounthall (Donegal)', zip: '884150' },
	{ city: 'Mounthall (Laois)', zip: '388551' },
	{ city: 'Mounthamilton (Louth)', zip: '860256' },
	{ city: 'Mounthanover (Wexford)', zip: '429500' },
	{ city: 'Mounthawk (Kerry)', zip: '451740' },
	{ city: 'Mounthazel (Galway)', zip: '604036' },
	{ city: 'Mountheaton (Offaly)', zip: '923819' },
	{ city: 'Mounthenry (Kerry)', zip: '865814' },
	{ city: 'Mounthenry (Mayo)', zip: '384592' },
	{ city: 'Mounthenry (Offaly)', zip: '107274' },
	{ city: 'Mounthillary (Cork)', zip: '409131' },
	{ city: 'Mounthovel (Cork)', zip: '367074' },
	{ city: 'Mounthoward Lower (Wexford)', zip: '706121' },
	{ city: 'Mounthoward Upper (Wexford)', zip: '748253' },
	{ city: 'Mountievers (Clare)', zip: '266981' },
	{ city: 'Mountinfant (Cork)', zip: '604275' },
	{ city: 'Mountirvine (Sligo)', zip: '187278' },
	{ city: 'Mountisland (Tipperary)', zip: '170509' },
	{ city: 'Mountjessop (Longford)', zip: '146864' },
	{ city: 'Mountjohn (Wicklow)', zip: '637448' },
	{ city: 'Mountjudkin (Tipperary)', zip: '925772' },
	{ city: 'Mountkeeffe (Cork)', zip: '305718' },
	{ city: 'Mountkelly (Carlow)', zip: '605276' },
	{ city: 'Mountkelly (Galway)', zip: '693531' },
	{ city: 'Mount Kennedy Demesne (Wicklow)', zip: '165344' },
	{ city: 'Mountland (Meath)', zip: '656029' },
	{ city: 'Mountleader (Cork)', zip: '574992' },
	{ city: 'Mountloftus (Kilkenny)', zip: '815983' },
	{ city: 'Mountlong (Cork)', zip: '979121' },
	{ city: 'Mountluke (Kerry)', zip: '686327' },
	{ city: 'Mountlusk (Wicklow)', zip: '139841' },
	{ city: 'Mountmelican (Carlow)', zip: '375641' },
	{ city: 'Mountmelleray (Waterford)', zip: '169462' },
	{ city: 'Mountmellick (Laois)', zip: '794658' },
	{ city: 'Mount Merrion (Dublin)', zip: '896724' },
	{ city: 'Mountmerrion South (Dublin)', zip: '644502' },
	{ city: 'Mountminnett (Limerick)', zip: '530060' },
	{ city: 'Mountmisery (Kilkenny)', zip: '482202' },
	{ city: 'Mountmurray (Westmeath)', zip: '548967' },
	{ city: 'Mountmusic (Cork)', zip: '580576' },
	{ city: 'Mountnagle (Cork)', zip: '310802' },
	{ city: 'Mountnebo (Wexford)', zip: '674640' },
	{ city: 'Mountneill (Carlow)', zip: '481479' },
	{ city: 'Mountneill (Kilkenny)', zip: '985982' },
	{ city: 'Mountnicholas (Kerry)', zip: '551177' },
	{ city: 'Mountnorth (Cork)', zip: '983712' },
	{ city: 'Mountnugent (Cavan)', zip: '878862' },
	{ city: 'Mount Nugent (Cavan)', zip: '415069' },
	{ city: 'Mountnugent Lower (Kilkenny)', zip: '645253' },
	{ city: 'Mountnugent Upper (Kilkenny)', zip: '673635' },
	{ city: 'Mountodell (Waterford)', zip: '159346' },
	{ city: 'Mountoliver (Laois)', zip: '862890' },
	{ city: 'Mountoven (Kerry)', zip: '125521' },
	{ city: 'Mountpallas (Cavan)', zip: '223738' },
	{ city: 'Mountpelier (Dublin)', zip: '799716' },
	{ city: 'Mountphilips (Tipperary)', zip: '246833' },
	{ city: 'Mountpill (Wexford)', zip: '440755' },
	{ city: 'Mountpill Burrow (Wexford)', zip: '864156' },
	{ city: 'Mountpleasant (Carlow)', zip: '353881' },
	{ city: 'Mountpleasant (Galway)', zip: '741744' },
	{ city: 'Mountpleasant (Limerick)', zip: '136660' },
	{ city: 'Mountpleasant (Mayo)', zip: '328529' },
	{ city: 'Mountpleasant (Offaly)', zip: '295940' },
	{ city: 'Mountpleasant (Roscommon)', zip: '215433' },
	{ city: 'Mountpleasant (Wexford)', zip: '473110' },
	{ city: 'Mountpleasant (Wicklow)', zip: '847073' },
	{ city: 'Mountpleasure (Donegal)', zip: '894320' },
	{ city: 'Mountplummer (Limerick)', zip: '726382' },
	{ city: 'Mountplunket (Roscommon)', zip: '938853' },
	{ city: 'Mountpotter (Galway)', zip: '501618' },
	{ city: 'Mountprospect (Cavan)', zip: '304977' },
	{ city: 'Mountprospect (Cork)', zip: '966068' },
	{ city: 'Mountprospect (Kildare)', zip: '536080' },
	{ city: 'Mountprospect (Roscommon)', zip: '130152' },
	{ city: 'Mountrath (Laois)', zip: '933362' },
	{ city: 'Mountrice (Clare)', zip: '407073' },
	{ city: 'Mountrice (Kildare)', zip: '100433' },
	{ city: 'Mountrice Bog (Kildare)', zip: '826529' },
	{ city: 'Mountrivers (Clare)', zip: '848284' },
	{ city: 'Mountrivers (Cork)', zip: '464806' },
	{ city: 'Mountrivers (Tipperary)', zip: '845106' },
	{ city: 'Mountrivers (Waterford)', zip: '963044' },
	{ city: 'Mountrobert (Westmeath)', zip: '189250' },
	{ city: 'Mountross (Galway)', zip: '980576' },
	{ city: 'Mountrush (Louth)', zip: '605475' },
	{ city: 'Mountrussell (Cork)', zip: '188967' },
	{ city: 'Mountrussell (Limerick)', zip: '721233' },
	{ city: 'Mountsack (Tipperary)', zip: '411705' },
	{ city: 'Mountscribe (Galway)', zip: '697225' },
	{ city: 'Mountseaton (Wexford)', zip: '388239' },
	{ city: 'Mountseskin (Dublin)', zip: '950938' },
	{ city: 'Mountshannon (Clare)', zip: '433449' },
	{ city: 'Mountshannon (Limerick)', zip: '237753' },
	{ city: 'Mountshannon East (Clare)', zip: '626420' },
	{ city: 'Mountshannon West (Clare)', zip: '347532' },
	{ city: 'Mountsilk (Galway)', zip: '884899' },
	{ city: 'Mountsion (Kilkenny)', zip: '181759' },
	{ city: 'Mountsion (Limerick)', zip: '445185' },
	{ city: 'Mountsion (Tipperary)', zip: '339964' },
	{ city: 'Mountstuart (Dublin)', zip: '351783' },
	{ city: 'Mountstuart (Waterford)', zip: '626636' },
	{ city: 'Mount Talbot (Roscommon)', zip: '723386' },
	{ city: 'Mount Temple (Sligo)', zip: '531225' },
	{ city: 'Mount Temple (Westmeath)', zip: '111654' },
	{ city: 'Mount Town (Sligo)', zip: '209569' },
	{ city: 'Mounttrenchard (Limerick)', zip: '802202' },
	{ city: 'Mountuniacke (Cork)', zip: '133915' },
	{ city: 'Mount Uniacke (Cork)', zip: '493005' },
	{ city: 'Mountusher (Wicklow)', zip: '282177' },
	{ city: 'Mountventure (Galway)', zip: '296600' },
	{ city: 'Mountwilliam (Limerick)', zip: '560936' },
	{ city: 'Mountwilliam (Tipperary)', zip: '797535' },
	{ city: 'Mountwilson (Offaly)', zip: '438653' },
	{ city: 'Mountwolseley (Carlow)', zip: '310387' },
	{ city: 'Mourneabbey (Cork)', zip: '389296' },
	{ city: 'Moveedy (Limerick)', zip: '941531' },
	{ city: 'Moveen East (Clare)', zip: '693906' },
	{ city: 'Moveen West (Clare)', zip: '824761' },
	{ city: 'Moville (Donegal)', zip: '900776' },
	{ city: 'Moy (Clare)', zip: '440834' },
	{ city: 'Moy (Donegal)', zip: '963985' },
	{ city: 'Moy (Galway)', zip: '643214' },
	{ city: 'Moy (Meath)', zip: '801696' },
	{ city: 'Moy (Monaghan)', zip: '473192' },
	{ city: 'Moyadd (Laois)', zip: '535670' },
	{ city: 'Moyadda Beg (Clare)', zip: '588912' },
	{ city: 'Moyadda More (Clare)', zip: '423875' },
	{ city: 'Moyagh (Donegal)', zip: '849692' },
	{ city: 'Moyagher (Meath)', zip: '990613' },
	{ city: 'Moyagher Lower (Meath)', zip: '998782' },
	{ city: 'Moyaliff (Tipperary)', zip: '794419' },
	{ city: 'Moyally (Offaly)', zip: '423460' },
	{ city: 'Moyanna (Laois)', zip: '769610' },
	{ city: 'Moyard (Galway)', zip: '327781' },
	{ city: 'Moyarta East (Clare)', zip: '522451' },
	{ city: 'Moyarta West (Clare)', zip: '318139' },
	{ city: 'Moyarwood (Galway)', zip: '264821' },
	{ city: 'Moyassa (Kerry)', zip: '288859' },
	{ city: 'Moyasta (Clare)', zip: '945431' },
	{ city: 'Moy Beg (Clare)', zip: '437109' },
	{ city: 'Moybella North (Kerry)', zip: '839751' },
	{ city: 'Moybella South (Kerry)', zip: '122895' },
	{ city: 'Moycarky (Tipperary)', zip: '335396' },
	{ city: 'Moycashel (Westmeath)', zip: '824231' },
	{ city: 'Moyclare (Offaly)', zip: '998535' },
	{ city: 'Moycola (Galway)', zip: '403309' },
	{ city: 'Moycullen (Galway)', zip: '515749' },
	{ city: 'Moydilliga (Cork)', zip: '574489' },
	{ city: 'Moydorragh (Meath)', zip: '600917' },
	{ city: 'Moydough (Sligo)', zip: '637331' },
	{ city: 'Moydow (Longford)', zip: '846259' },
	{ city: 'Moydow (Roscommon)', zip: '230256' },
	{ city: 'Moydow Glebe (Longford)', zip: '624187' },
	{ city: 'Moydristan (Cavan)', zip: '759600' },
	{ city: 'Moydrum (Meath)', zip: '788352' },
	{ city: 'Moydrum (Westmeath)', zip: '874677' },
	{ city: 'Moyduff (Cavan)', zip: '874414' },
	{ city: 'Moyeady (Wexford)', zip: '335700' },
	{ city: 'Moyeightragh (Kerry)', zip: '841078' },
	{ city: 'Moyer (Cavan)', zip: '231923' },
	{ city: 'Moy Etra (Monaghan)', zip: '231850' },
	{ city: 'Moyfadda (Clare)', zip: '952405' },
	{ city: 'Moyfeagher (Meath)', zip: '516899' },
	{ city: 'Moyfin (Meath)', zip: '486009' },
	{ city: 'Moygaddy (Meath)', zip: '599720' },
	{ city: 'Moygalla (Clare)', zip: '185030' },
	{ city: 'Moygara (Sligo)', zip: '410110' },
	{ city: 'Moyge (Cork)', zip: '181989' },
	{ city: 'Moygh (Longford)', zip: '640632' },
	{ city: 'Moyglare (Meath)', zip: '607629' },
	{ city: 'Moyglass (Galway)', zip: '318247' },
	{ city: 'Moyglass (Roscommon)', zip: '410012' },
	{ city: 'Moyglass (Tipperary)', zip: '885036' },
	{ city: 'Moyglass Beg (Clare)', zip: '990725' },
	{ city: 'Moyglass More (Clare)', zip: '821904' },
	{ city: 'Moygowna (Clare)', zip: '618750' },
	{ city: 'Moygrehan Lower (Westmeath)', zip: '577592' },
	{ city: 'Moygrehan Upper (Westmeath)', zip: '588521' },
	{ city: 'Moyhastin (Mayo)', zip: '640398' },
	{ city: 'Moyhenna (Mayo)', zip: '421808' },
	{ city: 'Moyhill (Clare)', zip: '258766' },
	{ city: 'Moyhill (Meath)', zip: '498625' },
	{ city: 'Moyhora (Kilkenny)', zip: '429846' },
	{ city: 'Moyhullin (Clare)', zip: '708325' },
	{ city: 'Moylagh (Meath)', zip: '583985' },
	{ city: 'Moyle (Donegal)', zip: '644673' },
	{ city: 'Moyleabbey (Kildare)', zip: '424573' },
	{ city: 'Moyle Beg (Monaghan)', zip: '338056' },
	{ city: 'Moyle Big (Carlow)', zip: '497390' },
	{ city: 'Moyleen (Galway)', zip: '912360' },
	{ city: 'Moyleggan (Meath)', zip: '284746' },
	{ city: 'Moyleglass (Kerry)', zip: '136028' },
	{ city: 'Moylehill (Donegal)', zip: '172337' },
	{ city: 'Moyle Little (Carlow)', zip: '600754' },
	{ city: 'Moyle More (Monaghan)', zip: '982562' },
	{ city: 'Moylemoss (Donegal)', zip: '202552' },
	{ city: 'Moylemuck (Monaghan)', zip: '805603' },
	{ city: 'Moyleroe Big (Westmeath)', zip: '218177' },
	{ city: 'Moyleroe Little (Westmeath)', zip: '178245' },
	{ city: 'Moyles (Monaghan)', zip: '295357' },
	{ city: 'Moylett (Cavan)', zip: '359078' },
	{ city: 'Moylisha (Wicklow)', zip: '160107' },
	{ city: 'Moyliss (Roscommon)', zip: '879583' },
	{ city: 'Moylough (Galway)', zip: '888380' },
	{ city: 'Moylough (Monaghan)', zip: '686174' },
	{ city: 'Moylough (Sligo)', zip: '172753' },
	{ city: 'Moylough Beg (Galway)', zip: '683685' },
	{ city: 'Moylough More (Galway)', zip: '340113' },
	{ city: 'Moymet (Meath)', zip: '857131' },
	{ city: 'Moymlough (Sligo)', zip: '900211' },
	{ city: 'Moymore (Clare)', zip: '913336' },
	{ city: 'Moymore (Limerick)', zip: '779220' },
	{ city: 'Moy More (Clare)', zip: '572268' },
	{ city: 'Moymore North (Clare)', zip: '252483' },
	{ city: 'Moymore South (Clare)', zip: '985820' },
	{ city: 'Moyna (Mayo)', zip: '905641' },
	{ city: 'Moynagh (Meath)', zip: '904026' },
	{ city: 'Moynagh Lower (Cavan)', zip: '498395' },
	{ city: 'Moynagh Upper (Cavan)', zip: '163224' },
	{ city: 'Moynalty (Meath)', zip: '881525' },
	{ city: 'Moynalvy (Meath)', zip: '345162' },
	{ city: 'Moynasboy (Meath)', zip: '855933' },
	{ city: 'Moyne (Clare)', zip: '417837' },
	{ city: 'Moyne (Donegal)', zip: '519050' },
	{ city: 'Moyne (Galway)', zip: '932018' },
	{ city: 'Moyne (Kilkenny)', zip: '306068' },
	{ city: 'Moyne (Laois)', zip: '919306' },
	{ city: 'Moyne (Longford)', zip: '932888' },
	{ city: 'Moyne (Mayo)', zip: '575055' },
	{ city: 'Moyne (Roscommon)', zip: '639958' },
	{ city: 'Moyne (Tipperary)', zip: '743746' },
	{ city: 'Moyne (Wicklow)', zip: '102943' },
	{ city: 'Moyneard (Tipperary)', zip: '359836' },
	{ city: 'Moynehall (Cavan)', zip: '523658' },
	{ city: 'Moyne Lower (Wexford)', zip: '983365' },
	{ city: 'Moyne Middle (Wexford)', zip: '614558' },
	{ city: 'Moynetemple (Tipperary)', zip: '354180' },
	{ city: 'Moyne Upper (Wexford)', zip: '762978' },
	{ city: 'Moyng (Waterford)', zip: '720452' },
	{ city: 'Moyng Little (Waterford)', zip: '968980' },
	{ city: 'Moynish More (Mayo)', zip: '544976' },
	{ city: 'Moynoe (Clare)', zip: '940878' },
	{ city: 'Moynsha (Kerry)', zip: '332753' },
	{ city: 'Moyntiagh (Wicklow)', zip: '556677' },
	{ city: 'Moynure (Offaly)', zip: '707372' },
	{ city: 'Moynure (Roscommon)', zip: '707625' },
	{ city: 'Moyny (Mayo)', zip: '548246' },
	{ city: 'Moyny East (Cork)', zip: '737591' },
	{ city: 'Moyny Lower (Cork)', zip: '228089' },
	{ city: 'Moyny Middle (Cork)', zip: '858450' },
	{ city: 'Moyny Upper (Cork)', zip: '562546' },
	{ city: 'Moyode (Galway)', zip: '677986' },
	{ city: 'Moyode Demesne (Galway)', zip: '571562' },
	{ city: 'Moyoran (Roscommon)', zip: '878262' },
	{ city: 'Moy Otra (Monaghan)', zip: '137954' },
	{ city: 'Moyour (Mayo)', zip: '117998' },
	{ city: 'Moyower (Galway)', zip: '206724' },
	{ city: 'Moyra And Fortmill (Longford)', zip: '579567' },
	{ city: 'Moyra Glebe (Donegal)', zip: '866644' },
	{ city: 'Moyrahan (Mayo)', zip: '379490' },
	{ city: 'Moyrath (Meath)', zip: '449011' },
	{ city: 'Moyree Commons (Clare)', zip: '312267' },
	{ city: 'Moyreen (Limerick)', zip: '663970' },
	{ city: 'Moyriesk (Clare)', zip: '849621' },
	{ city: 'Moyrisk (Kerry)', zip: '656793' },
	{ city: 'Moyroe (Tipperary)', zip: '355091' },
	{ city: 'Moyrus (Galway)', zip: '238288' },
	{ city: 'Moyrush (Sligo)', zip: '259055' },
	{ city: 'Moys (Clare)', zip: '197302' },
	{ city: 'Moysnaght (Monaghan)', zip: '751627' },
	{ city: 'Moystown Demesne (Offaly)', zip: '596714' },
	{ city: 'Moytirra East (Sligo)', zip: '999637' },
	{ city: 'Moytirra West (Sligo)', zip: '423966' },
	{ city: 'Moyure (Galway)', zip: '100176' },
	{ city: 'Moyvally (Carlow)', zip: '261486' },
	{ city: 'Moyvally (Kildare)', zip: '633763' },
	{ city: 'Moyvane North (Kerry)', zip: '252960' },
	{ city: 'Moyvane South (Kerry)', zip: '355870' },
	{ city: 'Moyvannan (Roscommon)', zip: '180461' },
	{ city: 'Moyveela (Galway)', zip: '522552' },
	{ city: 'Moyvoon East (Galway)', zip: '380970' },
	{ city: 'Moyvoon West (Galway)', zip: '360080' },
	{ city: 'Moyvore (Westmeath)', zip: '129337' },
	{ city: 'Moyvoughly (Westmeath)', zip: '331400' },
	{ city: 'Muccurragh (Cork)', zip: '468647' },
	{ city: 'Muchgrange (Louth)', zip: '828178' },
	{ city: 'Muchknock (Wexford)', zip: '700607' },
	{ city: 'Muchrath (Wexford)', zip: '161983' },
	{ city: 'Muchtown (Wexford)', zip: '181737' },
	{ city: 'Muchwood (Meath)', zip: '677033' },
	{ city: 'Muchwood (Wexford)', zip: '175022' },
	{ city: 'Muck (Kilkenny)', zip: '638149' },
	{ city: 'Muckalee (Kilkenny)', zip: '177014' },
	{ city: 'Muckanagh (Clare)', zip: '116495' },
	{ city: 'Muckanagh (Galway)', zip: '266824' },
	{ city: 'Muckanagh (Leitrim)', zip: '760487' },
	{ city: 'Muckanagh (Mayo)', zip: '152521' },
	{ city: 'Muckanagh (Roscommon)', zip: '466428' },
	{ city: 'Muckanagh (Westmeath)', zip: '163262' },
	{ city: 'Muckanaghederdauhaulia (Galway)', zip: '290985' },
	{ city: 'Muckanaghkillew (Galway)', zip: '435969' },
	{ city: 'Muckanagh North (Galway)', zip: '360104' },
	{ city: 'Muckanagh South (Galway)', zip: '681793' },
	{ city: 'Muckcoort (Galway)', zip: '173726' },
	{ city: 'Muckduff (Sligo)', zip: '273126' },
	{ city: 'Muckduff Lower (Wicklow)', zip: '816790' },
	{ city: 'Muckduff Upper (Wicklow)', zip: '828677' },
	{ city: 'Muckeen (Galway)', zip: '109362' },
	{ city: 'Muckelty (Sligo)', zip: '984962' },
	{ city: 'Muckenagh (Cork)', zip: '421599' },
	{ city: 'Muckenagh (Kerry)', zip: '399579' },
	{ city: 'Mucker (Monaghan)', zip: '537028' },
	{ city: 'Muckera (Kerry)', zip: '756050' },
	{ city: 'Muckerstaff (Longford)', zip: '697699' },
	{ city: 'Muckerstown (Meath)', zip: '558800' },
	{ city: 'Muckinish (Clare)', zip: '950117' },
	{ city: 'Muckinish East (Clare)', zip: '471733' },
	{ city: 'Muckinish West (Clare)', zip: '976451' },
	{ city: 'Mucklagh (Cavan)', zip: '966412' },
	{ city: 'Mucklagh (Louth)', zip: '764370' },
	{ city: 'Mucklagh (Mayo)', zip: '444111' },
	{ city: 'Mucklagh (Monaghan)', zip: '747704' },
	{ city: 'Mucklagh (Offaly)', zip: '358145' },
	{ city: 'Mucklagh (Wicklow)', zip: '826207' },
	{ city: 'Mucklaghan Glebe (Leitrim)', zip: '516687' },
	{ city: 'Mucklin (Tipperary)', zip: '830114' },
	{ city: 'Mucklin (Westmeath)', zip: '791121' },
	{ city: 'Mucklon (Kildare)', zip: '514731' },
	{ city: 'Mucklone (Laois)', zip: '452317' },
	{ city: 'Mucklone East (Offaly)', zip: '372653' },
	{ city: 'Mucklone West (Offaly)', zip: '470576' },
	{ city: 'Muckloon (Galway)', zip: '438487' },
	{ city: 'Muckloon (Mayo)', zip: '917447' },
	{ city: 'Muckloon (Tipperary)', zip: '275166' },
	{ city: 'Muckloonmodderee (Tipperary)', zip: '915972' },
	{ city: 'Mucklougher (Leitrim)', zip: '170689' },
	{ city: 'Mucklow (Wexford)', zip: '978086' },
	{ city: 'Muckmeadows (Kilkenny)', zip: '655622' },
	{ city: 'Mucknagh (Longford)', zip: '816913' },
	{ city: 'Muckranstown (Wexford)', zip: '910634' },
	{ city: 'Muckridge (Cork)', zip: '956575' },
	{ city: 'Muckridge Demesne (Cork)', zip: '109600' },
	{ city: 'Muckros (Donegal)', zip: '673459' },
	{ city: 'Muckros (Leitrim)', zip: '848370' },
	{ city: 'Muckross (Kerry)', zip: '429672' },
	{ city: 'Muckrum (Leitrim)', zip: '708048' },
	{ city: 'Muckrush (Galway)', zip: '455784' },
	{ city: 'Muckrush Island (Galway)', zip: '409777' },
	{ city: 'Muckruss (Cork)', zip: '960909' },
	{ city: 'Muckrussaun (Mayo)', zip: '378285' },
	{ city: 'Mucksna (Kerry)', zip: '647272' },
	{ city: 'Muckstown (Wexford)', zip: '555082' },
	{ city: 'Muff (Cavan)', zip: '412440' },
	{ city: 'Muff (Donegal)', zip: '668527' },
	{ city: 'Muff (Louth)', zip: '166108' },
	{ city: 'Muff (Meath)', zip: '637505' },
	{ city: 'Muff (Monaghan)', zip: '333026' },
	{ city: 'Muff (Roscommon)', zip: '289763' },
	{ city: 'Muggaunagh (Galway)', zip: '722186' },
	{ city: 'Muinaghan (Cavan)', zip: '448521' },
	{ city: 'Muineagh (Donegal)', zip: '136574' },
	{ city: 'Muineal (Cavan)', zip: '512389' },
	{ city: 'Muing (Galway)', zip: '791913' },
	{ city: 'Muingacarreen (Clare)', zip: '126920' },
	{ city: 'Muingacree (Limerick)', zip: '658210' },
	{ city: 'Muingagarha (Kerry)', zip: '150025' },
	{ city: 'Muingaghel (Mayo)', zip: '744706' },
	{ city: 'Muinganierin (Mayo)', zip: '712761' },
	{ city: 'Muinganine (Cork)', zip: '625426' },
	{ city: 'Muingaphuca (Kerry)', zip: '426334' },
	{ city: 'Muingatlaunlush (Kerry)', zip: '958096' },
	{ city: 'Muingatogher (Mayo)', zip: '441802' },
	{ city: 'Muingavrannig (Kerry)', zip: '284554' },
	{ city: 'Muingbaun (Galway)', zip: '829615' },
	{ city: 'Muingboy (Clare)', zip: '600515' },
	{ city: 'Muing East (Kerry)', zip: '191928' },
	{ city: 'Muingelly (Mayo)', zip: '733620' },
	{ city: 'Muingerroon North (Mayo)', zip: '876496' },
	{ city: 'Muingerroon South (Mayo)', zip: '837616' },
	{ city: 'Muingingaun (Mayo)', zip: '667664' },
	{ city: 'Muingmore (Mayo)', zip: '842168' },
	{ city: 'Muingnabo (Mayo)', zip: '969079' },
	{ city: 'Muingnahalloona (Mayo)', zip: '662281' },
	{ city: 'Muingnaminnane (Kerry)', zip: '110224' },
	{ city: 'Muingnanarnad (Mayo)', zip: '282092' },
	{ city: 'Muingnatee (Kerry)', zip: '375270' },
	{ city: 'Muingrevagh (Mayo)', zip: '956799' },
	{ city: 'Muings (Mayo)', zip: '262497' },
	{ city: 'Muingvautia (Kerry)', zip: '606037' },
	{ city: 'Muingwee (Kerry)', zip: '379658' },
	{ city: 'Muing West (Kerry)', zip: '324217' },
	{ city: 'Muingwore (Sligo)', zip: '387446' },
	{ city: 'Muingydowda (Kerry)', zip: '182215' },
	{ city: 'Muingyroogeen (Cork)', zip: '877128' },
	{ city: 'Muiniagh (Offaly)', zip: '651231' },
	{ city: 'Mulchanstown (Dublin)', zip: '378102' },
	{ city: 'Mulchanstown (Westmeath)', zip: '232405' },
	{ city: 'Mulderricksfield (Limerick)', zip: '380781' },
	{ city: 'Muldrumman (Monaghan)', zip: '328664' },
	{ city: 'Mulgannon (Wexford)', zip: '439976' },
	{ city: 'Mulgeeth (Kildare)', zip: '856537' },
	{ city: 'Mulhuddart (Dublin)', zip: '120130' },
	{ city: 'Mulhussey (Meath)', zip: '931542' },
	{ city: 'Mulkaun (Leitrim)', zip: '370684' },
	{ city: 'Mullabane (Louth)', zip: '980866' },
	{ city: 'Mullabohy (Louth)', zip: '918864' },
	{ city: 'Mullabrack (Monaghan)', zip: '952635' },
	{ city: 'Mullabryan (Monaghan)', zip: '939741' },
	{ city: 'Mullacapple (Louth)', zip: '912939' },
	{ city: 'Mullacash Middle (Kildare)', zip: '924911' },
	{ city: 'Mullacash North (Kildare)', zip: '405841' },
	{ city: 'Mullacash South (Kildare)', zip: '670615' },
	{ city: 'Mullacastle (Cavan)', zip: '467262' },
	{ city: 'Mullacloe (Louth)', zip: '343586' },
	{ city: 'Mullacrew (Louth)', zip: '728705' },
	{ city: 'Mullacroghery (Cavan)', zip: '816857' },
	{ city: 'Mullacurry (Louth)', zip: '516188' },
	{ city: 'Mulladermot (Monaghan)', zip: '634277' },
	{ city: 'Mulladrillen (Louth)', zip: '307467' },
	{ city: 'Mulladuff (Monaghan)', zip: '186038' },
	{ city: 'Mullafarry (Mayo)', zip: '675718' },
	{ city: 'Mullafin (Donegal)', zip: '483349' },
	{ city: 'Mullagarry (Monaghan)', zip: '720254' },
	{ city: 'Mullagh (Cavan)', zip: '277596' },
	{ city: 'Mullagh (Clare)', zip: '393225' },
	{ city: 'Mullagh (Cork)', zip: '767404' },
	{ city: 'Mullagh (Galway)', zip: '352244' },
	{ city: 'Mullagh (Leitrim)', zip: '588045' },
	{ city: 'Mullagh (Limerick)', zip: '333516' },
	{ city: 'Mullagh (Longford)', zip: '610787' },
	{ city: 'Mullagh (Mayo)', zip: '237603' },
	{ city: 'Mullagh (Meath)', zip: '917911' },
	{ city: 'Mullagh (Roscommon)', zip: '571075' },
	{ city: 'Mullagh (Tipperary)', zip: '565598' },
	{ city: 'Mullagh (Westmeath)', zip: '306083' },
	{ city: 'Mullagha (Meath)', zip: '118562' },
	{ city: 'Mullaghadrum (Galway)', zip: '558704' },
	{ city: 'Mullaghadun (Monaghan)', zip: '343939' },
	{ city: 'Mullaghagarry (Donegal)', zip: '677665' },
	{ city: 'Mullaghahy (Cavan)', zip: '480832' },
	{ city: 'Mullaghakaraun (Offaly)', zip: '767587' },
	{ city: 'Mullaghakaraun Bog (Offaly)', zip: '848919' },
	{ city: 'Mullaghanard (Laois)', zip: '500004' },
	{ city: 'Mullaghanarry (Sligo)', zip: '171423' },
	{ city: 'Mullaghaneary (Donegal)', zip: '804504' },
	{ city: 'Mullaghanee (Monaghan)', zip: '716170' },
	{ city: 'Mullaghaneigh (Leitrim)', zip: '142606' },
	{ city: 'Mullaghanny (Donegal)', zip: '666050' },
	{ city: 'Mullaghard (Cavan)', zip: '159858' },
	{ city: 'Mullaghard (Meath)', zip: '505518' },
	{ city: 'Mullaghardagh (Roscommon)', zip: '345865' },
	{ city: 'Mullagharlin (Louth)', zip: '762790' },
	{ city: 'Mullagharoy (Meath)', zip: '421446' },
	{ city: 'Mullagharush (Offaly)', zip: '845816' },
	{ city: 'Mullaghattin (Louth)', zip: '459240' },
	{ city: 'Mullaghavally (Meath)', zip: '596829' },
	{ city: 'Mullaghavorneen (Longford)', zip: '990906' },
	{ city: 'Mullaghawny (Mayo)', zip: '734388' },
	{ city: 'Mullaghbane (Monaghan)', zip: '591650' },
	{ city: 'Mullaghbaun (Leitrim)', zip: '560212' },
	{ city: 'Mullagh Beg (Galway)', zip: '270253' },
	{ city: 'Mullagh Bog (Longford)', zip: '494970' },
	{ city: 'Mullaghboy (Cavan)', zip: '535833' },
	{ city: 'Mullaghboy (Kildare)', zip: '262831' },
	{ city: 'Mullaghboy (Leitrim)', zip: '694990' },
	{ city: 'Mullaghboy (Meath)', zip: '625967' },
	{ city: 'Mullaghboy (Monaghan)', zip: '392721' },
	{ city: 'Mullaghbrack (Leitrim)', zip: '637680' },
	{ city: 'Mullaghcashel (Leitrim)', zip: '735499' },
	{ city: 'Mullaghcloe (Westmeath)', zip: '953747' },
	{ city: 'Mullaghcor (Monaghan)', zip: '195575' },
	{ city: 'Mullaghcor (Sligo)', zip: '676887' },
	{ city: 'Mullaghcroghery (Monaghan)', zip: '414831' },
	{ city: 'Mullaghcrohy (Offaly)', zip: '438827' },
	{ city: 'Mullaghcroy (Westmeath)', zip: '480037' },
	{ city: 'Mullaghdarrig (Wexford)', zip: '338207' },
	{ city: 'Mullaghderg (Donegal)', zip: '849623' },
	{ city: 'Mullaghderg Mountain Pasture (Donegal)', zip: '968500' },
	{ city: 'Mullaghdillon (Meath)', zip: '905634' },
	{ city: 'Mullaghdoo (Cavan)', zip: '565526' },
	{ city: 'Mullaghdoo (Leitrim)', zip: '279996' },
	{ city: 'Mullaghdoo Irish (Donegal)', zip: '394688' },
	{ city: 'Mullaghdoo Scotch (Donegal)', zip: '910495' },
	{ city: 'Mullaghduff (Cavan)', zip: '261440' },
	{ city: 'Mullaghduff (Monaghan)', zip: '158217' },
	{ city: 'Mullagheep (Donegal)', zip: '738830' },
	{ city: 'Mullaghey (Meath)', zip: '272133' },
	{ city: 'Mullaghfadda (Leitrim)', zip: '817657' },
	{ city: 'Mullaghfarna (Sligo)', zip: '847180' },
	{ city: 'Mullaghfin (Donegal)', zip: '727517' },
	{ city: 'Mullaghfin (Meath)', zip: '728145' },
	{ city: 'Mullaghfin (Sligo)', zip: '533454' },
	{ city: 'Mullaghgar (Sligo)', zip: '763084' },
	{ city: 'Mullaghgarve (Leitrim)', zip: '775624' },
	{ city: 'Mullaghgarve (Monaghan)', zip: '790391' },
	{ city: 'Mullaghglass (Galway)', zip: '736595' },
	{ city: 'Mullaghgreenan (Monaghan)', zip: '461602' },
	{ city: 'Mullaghinshigo (Monaghan)', zip: '263429' },
	{ city: 'Mullaghkeel (Cavan)', zip: '664312' },
	{ city: 'Mullaghlea (Cavan)', zip: '106184' },
	{ city: 'Mullaghlea Glen (Cavan)', zip: '623946' },
	{ city: 'Mullaghlusky (Roscommon)', zip: '139207' },
	{ city: 'Mullaghmacateer (Monaghan)', zip: '605940' },
	{ city: 'Mullaghmacormick (Roscommon)', zip: '862320' },
	{ city: 'Mullaghmarkagh (Galway)', zip: '795443' },
	{ city: 'Mullaghmarky (Kerry)', zip: '982410' },
	{ city: 'Mullaghmatt (Monaghan)', zip: '580412' },
	{ city: 'Mullaghmeen (Cavan)', zip: '172291' },
	{ city: 'Mullaghmeen (Monaghan)', zip: '645970' },
	{ city: 'Mullaghmeen (Westmeath)', zip: '649173' },
	{ city: 'Mullaghmesha (Cork)', zip: '196476' },
	{ city: 'Mullaghmonaghan (Monaghan)', zip: '457242' },
	{ city: 'Mullaghmore (Cavan)', zip: '430484' },
	{ city: 'Mullaghmore (Cork)', zip: '669711' },
	{ city: 'Mullaghmore (Laois)', zip: '842870' },
	{ city: 'Mullaghmore (Leitrim)', zip: '844624' },
	{ city: 'Mullaghmore (Meath)', zip: '272508' },
	{ city: 'Mullaghmore (Monaghan)', zip: '254908' },
	{ city: 'Mullaghmore (Roscommon)', zip: '582181' },
	{ city: 'Mullaghmore (Sligo)', zip: '716084' },
	{ city: 'Mullagh More (Galway)', zip: '833081' },
	{ city: 'Mullaghmore East (Galway)', zip: '316017' },
	{ city: 'Mullaghmore East (Monaghan)', zip: '479220' },
	{ city: 'Mullaghmore North (Galway)', zip: '517542' },
	{ city: 'Mullaghmore North (Monaghan)', zip: '250090' },
	{ city: 'Mullaghmore South (Galway)', zip: '451284' },
	{ city: 'Mullaghmore West (Galway)', zip: '475389' },
	{ city: 'Mullaghmore West (Monaghan)', zip: '719093' },
	{ city: 'Mullaghmore West (Sligo)', zip: '197881' },
	{ city: 'Mullaghmoyne East (Kildare)', zip: '541749' },
	{ city: 'Mullaghmoyne West (Kildare)', zip: '447553' },
	{ city: 'Mullaghmullan (Cavan)', zip: '424501' },
	{ city: 'Mullaghnabreena (Sligo)', zip: '300788' },
	{ city: 'Mullaghnahegny (Monaghan)', zip: '375088' },
	{ city: 'Mullaghnameely (Leitrim)', zip: '742595' },
	{ city: 'Mullaghnaneane (Sligo)', zip: '866777' },
	{ city: 'Mullaghnashee (Roscommon)', zip: '526396' },
	{ city: 'Mullaghnoney (Tipperary)', zip: '584894' },
	{ city: 'Mullaghoran (Cavan)', zip: '160427' },
	{ city: 'Mullagh Otra (Monaghan)', zip: '742482' },
	{ city: 'Mullaghpeak (Monaghan)', zip: '969807' },
	{ city: 'Mullaghrafferty (Monaghan)', zip: '793679' },
	{ city: 'Mullaghreagh (Meath)', zip: '614580' },
	{ city: 'Mullaghreelan (Kildare)', zip: '340355' },
	{ city: 'Mullaghrigny (Leitrim)', zip: '631346' },
	{ city: 'Mullaghroe (Cork)', zip: '736969' },
	{ city: 'Mullaghroe (Mayo)', zip: '315408' },
	{ city: 'Mullaghroe (Meath)', zip: '762767' },
	{ city: 'Mullaghroe (Sligo)', zip: '701510' },
	{ city: 'Mullaghroe Lower (Kildare)', zip: '199844' },
	{ city: 'Mullaghroe North (Cork)', zip: '800939' },
	{ city: 'Mullaghroe South (Cork)', zip: '196248' },
	{ city: 'Mullaghroe Upper (Kildare)', zip: '900659' },
	{ city: 'Mullaghruttery (Galway)', zip: '993428' },
	{ city: 'Mullaghsallagh (Leitrim)', zip: '998559' },
	{ city: 'Mullaghselsana (Monaghan)', zip: '257704' },
	{ city: 'Mullaghstones (Meath)', zip: '944512' },
	{ city: 'Mullaghteelin (Meath)', zip: '196566' },
	{ city: 'Mullaghunshinagh (Monaghan)', zip: '208870' },
	{ city: 'Mullaghveal (Kerry)', zip: '120352' },
	{ city: 'Mullaghwillin (Meath)', zip: '215440' },
	{ city: 'Mullaghycullen (Leitrim)', zip: '687525' },
	{ city: 'Mullaglassan (Monaghan)', zip: '926576' },
	{ city: 'Mullaliss (Monaghan)', zip: '133648' },
	{ city: 'Mullalough (Offaly)', zip: '190766' },
	{ city: 'Mullaloughan (Monaghan)', zip: '345026' },
	{ city: 'Mullalougher (Cavan)', zip: '989065' },
	{ city: 'Mullamast (Kildare)', zip: '806052' },
	{ city: 'Mullameelan (Louth)', zip: '637013' },
	{ city: 'Mullamore (Louth)', zip: '772696' },
	{ city: 'Mullamurphy (Monaghan)', zip: '779863' },
	{ city: 'Mullan (Cavan)', zip: '142714' },
	{ city: 'Mullan (Monaghan)', zip: '249167' },
	{ city: 'Mullanabattog (Monaghan)', zip: '116371' },
	{ city: 'Mullanabreena (Sligo)', zip: '535828' },
	{ city: 'Mullanacarry (Donegal)', zip: '303106' },
	{ city: 'Mullanacask (Monaghan)', zip: '456502' },
	{ city: 'Mullanachose (Donegal)', zip: '619433' },
	{ city: 'Mullanacloy (Donegal)', zip: '244677' },
	{ city: 'Mullanacloy (Monaghan)', zip: '791997' },
	{ city: 'Mullanacranna (Wicklow)', zip: '385552' },
	{ city: 'Mullanacre Lower (Cavan)', zip: '359518' },
	{ city: 'Mullanacre Upper (Cavan)', zip: '407886' },
	{ city: 'Mullanacross (Cavan)', zip: '381928' },
	{ city: 'Mullanacross (Donegal)', zip: '132969' },
	{ city: 'Mullanacross (Monaghan)', zip: '365257' },
	{ city: 'Mullanadarragh (Leitrim)', zip: '997252' },
	{ city: 'Mullanafawnia (Offaly)', zip: '838068' },
	{ city: 'Mullanaffrin (Cavan)', zip: '663054' },
	{ city: 'Mullanafinnog (Monaghan)', zip: '689870' },
	{ city: 'Mullanagore (Monaghan)', zip: '131406' },
	{ city: 'Mullanagower (Wexford)', zip: '286983' },
	{ city: 'Mullanakill (Westmeath)', zip: '193476' },
	{ city: 'Mullanalamphry (Donegal)', zip: '572035' },
	{ city: 'Mullanaleck (Leitrim)', zip: '974769' },
	{ city: 'Mullanamoy (Monaghan)', zip: '919544' },
	{ city: 'Mullananallog (Monaghan)', zip: '566890' },
	{ city: 'Mullananalt (Monaghan)', zip: '284824' },
	{ city: 'Mullanard (Donegal)', zip: '162592' },
	{ city: 'Mullanarockan (Monaghan)', zip: '579431' },
	{ city: 'Mullanarry (Monaghan)', zip: '396068' },
	{ city: 'Mullanary Cortannel (Monaghan)', zip: '414133' },
	{ city: 'Mullanary Glebe (Monaghan)', zip: '605923' },
	{ city: 'Mullanashee (Sligo)', zip: '236811' },
	{ city: 'Mullanaskeagh (Leitrim)', zip: '997702' },
	{ city: 'Mullanasole (Donegal)', zip: '787766' },
	{ city: 'Mullanasole Barr (Donegal)', zip: '874221' },
	{ city: 'Mullanavannog (Monaghan)', zip: '596987' },
	{ city: 'Mullanavarnoge (Cavan)', zip: '556168' },
	{ city: 'Mullanavockaun (Leitrim)', zip: '787173' },
	{ city: 'Mullanboy (Donegal)', zip: '370949' },
	{ city: 'Mullanboys (Donegal)', zip: '359864' },
	{ city: 'Mullandavagh (Monaghan)', zip: '700490' },
	{ city: 'Mullanderg (Monaghan)', zip: '168880' },
	{ city: 'Mullandrait (Donegal)', zip: '216828' },
	{ city: 'Mullanfad (Sligo)', zip: '595344' },
	{ city: 'Mullangore (Donegal)', zip: '289224' },
	{ city: 'Mullanlary (Monaghan)', zip: '274386' },
	{ city: 'Mullanmore (Donegal)', zip: '342949' },
	{ city: 'Mullannagaun (Carlow)', zip: '903931' },
	{ city: 'Mullannaskeagh (Carlow)', zip: '885584' },
	{ city: 'Mullannaskeagh (Wicklow)', zip: '964722' },
	{ city: 'Mullannavode (Carlow)', zip: '567556' },
	{ city: 'Mullanour (Wexford)', zip: '441949' },
	{ city: 'Mullans (Donegal)', zip: '225471' },
	{ city: 'Mullans (Limerick)', zip: '707131' },
	{ city: 'Mullans (Monaghan)', zip: '660270' },
	{ city: 'Mullans (Wicklow)', zip: '832685' },
	{ city: 'Mullans North (Wicklow)', zip: '838793' },
	{ city: 'Mullans South (Wicklow)', zip: '835675' },
	{ city: 'Mullanstown (Louth)', zip: '241227' },
	{ city: 'Mullantiboyle (Donegal)', zip: '967179' },
	{ city: 'Mullantimore (Monaghan)', zip: '768756' },
	{ city: 'Mullantine (Kildare)', zip: '938397' },
	{ city: 'Mullantlavan (Monaghan)', zip: '788004' },
	{ city: 'Mullantornan (Monaghan)', zip: '770163' },
	{ city: 'Mullantra (Cavan)', zip: '634933' },
	{ city: 'Mullanwary (Cavan)', zip: '898837' },
	{ city: 'Mullanyduff (Leitrim)', zip: '572279' },
	{ city: 'Mullanyduffy (Leitrim)', zip: '108266' },
	{ city: 'Mullarie (Cork)', zip: '909831' },
	{ city: 'Mullarney (Kildare)', zip: '367179' },
	{ city: 'Mullaroe (Sligo)', zip: '654355' },
	{ city: 'Mullatee (Louth)', zip: '443787' },
	{ city: 'Mullatigorry (Monaghan)', zip: '726733' },
	{ city: 'Mullatishaughlin (Monaghan)', zip: '464000' },
	{ city: 'Mullaun (Leitrim)', zip: '308679' },
	{ city: 'Mullaun (Mayo)', zip: '652523' },
	{ city: 'Mullaun (Roscommon)', zip: '691509' },
	{ city: 'Mullaun (Sligo)', zip: '622202' },
	{ city: 'Mullaun (Wexford)', zip: '599779' },
	{ city: 'Mullaunattina (Kilkenny)', zip: '258504' },
	{ city: 'Mullaunbrack (Tipperary)', zip: '921809' },
	{ city: 'Mullaunfin (Wexford)', zip: '937786' },
	{ city: 'Mullaunglass (Kilkenny)', zip: '493235' },
	{ city: 'Mullaun Glebe (Leitrim)', zip: '210105' },
	{ city: 'Mullaunnasmear (Wexford)', zip: '737945' },
	{ city: 'Mullaunreagh (Wexford)', zip: '991067' },
	{ city: 'Mullauns (Dublin)', zip: '927288' },
	{ city: 'Mullauns (Mayo)', zip: '553826' },
	{ city: 'Mullauns (Tipperary)', zip: '708342' },
	{ city: 'Mullavally (Louth)', zip: '607688' },
	{ city: 'Mullawornia (Longford)', zip: '877524' },
	{ city: 'Mullen (Kerry)', zip: '177058' },
	{ city: 'Mullen (Roscommon)', zip: '855285' },
	{ city: 'Mullenaboree (Cork)', zip: '518837' },
	{ city: 'Mullenaglemig (Kerry)', zip: '654244' },
	{ city: 'Mullenaranky (Tipperary)', zip: '567509' },
	{ city: 'Mullenataura (Cork)', zip: '620371' },
	{ city: 'Mullenbeg (Kilkenny)', zip: '460616' },
	{ city: 'Mullenduff (Roscommon)', zip: '377835' },
	{ city: 'Mullendunny (Cork)', zip: '920219' },
	{ city: 'Mullenkeagh (Tipperary)', zip: '977941' },
	{ city: 'Mullenmadoge (Mayo)', zip: '863514' },
	{ city: 'Mullenmeehan (Westmeath)', zip: '224198' },
	{ city: 'Mullenmore North (Mayo)', zip: '189917' },
	{ city: 'Mullenmore South (Mayo)', zip: '640794' },
	{ city: 'Mullennaglogh (Tipperary)', zip: '408788' },
	{ city: 'Mullennahone (Kilkenny)', zip: '884191' },
	{ city: 'Mullennakill (Kilkenny)', zip: '929786' },
	{ city: 'Mullenroe (Cork)', zip: '515607' },
	{ city: 'Mulleny (Donegal)', zip: '275135' },
	{ city: 'Mullies (Leitrim)', zip: '721310' },
	{ city: 'Mulliganstown (Westmeath)', zip: '564138' },
	{ city: 'Mullinabro (Kilkenny)', zip: '787772' },
	{ city: 'Mullinahone (Tipperary)', zip: '371772' },
	{ city: 'Mullinam (Meath)', zip: '700858' },
	{ city: 'Mullinavat (Kilkenny)', zip: '978078' },
	{ city: 'Mullinaveige (Wicklow)', zip: '364106' },
	{ city: 'Mullincross (Louth)', zip: '755201' },
	{ city: 'Mullinderry (Wexford)', zip: '569780' },
	{ city: 'Mullingar (Donegal)', zip: '880160' },
	{ city: 'Mullingar (Westmeath)', zip: '740139' },
	{ city: 'Mullingee (Longford)', zip: '197409' },
	{ city: 'Mullinnagore (Wexford)', zip: '525976' },
	{ city: 'Mullinoly (Tipperary)', zip: '855553' },
	{ city: 'Mullinree (Wexford)', zip: '222679' },
	{ city: 'Mullinroe (Longford)', zip: '938166' },
	{ city: 'Mullinscross (Louth)', zip: '183846' },
	{ city: 'Mullolagher (Longford)', zip: '908970' },
	{ city: 'Mully (Donegal)', zip: '100130' },
	{ city: 'Mullyamly (Cavan)', zip: '287601' },
	{ city: 'Mullyandrew (Meath)', zip: '833871' },
	{ city: 'Mullyash (Monaghan)', zip: '559567' },
	{ city: 'Mullyaster (Leitrim)', zip: '550627' },
	{ city: 'Mullybrack (Cavan)', zip: '777183' },
	{ city: 'Mullycagh Lower (Wicklow)', zip: '357597' },
	{ city: 'Mullycagh Upper (Wicklow)', zip: '897693' },
	{ city: 'Mullycrock (Monaghan)', zip: '115655' },
	{ city: 'Mullyera (Monaghan)', zip: '718753' },
	{ city: 'Mullygollan (Roscommon)', zip: '947108' },
	{ city: 'Mullyjordan (Monaghan)', zip: '152740' },
	{ city: 'Mullyknock (Monaghan)', zip: '216737' },
	{ city: 'Mully Lower (Cavan)', zip: '899629' },
	{ city: 'Mullylusty (Monaghan)', zip: '917244' },
	{ city: 'Mullymagaraghan (Monaghan)', zip: '989494' },
	{ city: 'Mullymagowan (Cavan)', zip: '759833' },
	{ city: 'Mullymucks (Roscommon)', zip: '914765' },
	{ city: 'Mullynadrumman (Leitrim)', zip: '476202' },
	{ city: 'Mullynagolman (Cavan)', zip: '611298' },
	{ city: 'Mullynahinch (Monaghan)', zip: '336649' },
	{ city: 'Mullynure (Monaghan)', zip: '865923' },
	{ city: 'Mullyore (Monaghan)', zip: '110649' },
	{ city: 'Mullystaghan (Meath)', zip: '409153' },
	{ city: 'Mully Upper (Cavan)', zip: '476007' },
	{ city: 'Mullyvea (Donegal)', zip: '255261' },
	{ city: 'Mulmontry (Wexford)', zip: '296887' },
	{ city: 'Mulmosog (Donegal)', zip: '186316' },
	{ city: 'Mulnagoad (Donegal)', zip: '204858' },
	{ city: 'Mulnagung (Donegal)', zip: '310716' },
	{ city: 'Mulnamin Beg (Donegal)', zip: '368702' },
	{ city: 'Mulnamin More (Donegal)', zip: '794650' },
	{ city: 'Mulnanarragh (Cavan)', zip: '320182' },
	{ city: 'Mulnasillagh (Leitrim)', zip: '863409' },
	{ city: 'Mulnavannoge (Leitrim)', zip: '610616' },
	{ city: 'Mulnaveagh (Donegal)', zip: '428792' },
	{ city: 'Mulphedder (Meath)', zip: '956995' },
	{ city: 'Mulpit (Galway)', zip: '999694' },
	{ city: 'Mulrankin (Wexford)', zip: '607803' },
	{ city: 'Mulrick (Cavan)', zip: '404043' },
	{ city: 'Mulroog East (Galway)', zip: '529567' },
	{ city: 'Mulroog West (Galway)', zip: '987999' },
	{ city: 'Multins (Donegal)', zip: '970270' },
	{ city: 'Multyfarnham (Westmeath)', zip: '493389' },
	{ city: 'Munakill (Leitrim)', zip: '498070' },
	{ city: 'Mundellihy (Limerick)', zip: '434373' },
	{ city: 'Munga (Galway)', zip: '946699' },
	{ city: 'Mungacullin (Wicklow)', zip: '414722' },
	{ city: 'Mungan (Kilkenny)', zip: '252938' },
	{ city: 'Mungaun (Mayo)', zip: '164227' },
	{ city: 'Mungmacody (Kilkenny)', zip: '733214' },
	{ city: 'Mungret (Limerick)', zip: '518735' },
	{ city: 'Munlough North (Cavan)', zip: '496126' },
	{ city: 'Munlough South (Cavan)', zip: '510732' },
	{ city: 'Munlusk (Tipperary)', zip: '943806' },
	{ city: 'Munmahoge (Waterford)', zip: '460835' },
	{ city: 'Munnadesha (Mayo)', zip: '961403' },
	{ city: 'Munnagashel (Leitrim)', zip: '163456' },
	{ city: 'Munnane (Cork)', zip: '560787' },
	{ city: 'Munnia (Clare)', zip: '137965' },
	{ city: 'Munnia (Tipperary)', zip: '218841' },
	{ city: 'Munnig North (Cork)', zip: '638416' },
	{ city: 'Munnig South (Cork)', zip: '165991' },
	{ city: 'Munnilly (Cavan)', zip: '421516' },
	{ city: 'Munnilly (Monaghan)', zip: '381143' },
	{ city: 'Munsburrow (Waterford)', zip: '855997' },
	{ city: 'Muntermellan (Donegal)', zip: '270790' },
	{ city: 'Munterneese (Donegal)', zip: '175090' },
	{ city: 'Munterowen East (Galway)', zip: '127281' },
	{ city: 'Munterowen Middle (Galway)', zip: '266658' },
	{ city: 'Munterowen West (Galway)', zip: '805010' },
	{ city: 'Muntertinny (Donegal)', zip: '100434' },
	{ city: 'Murgasty (Tipperary)', zip: '717295' },
	{ city: 'Murhaun (Leitrim)', zip: '870171' },
	{ city: 'Murher (Kerry)', zip: '139312' },
	{ city: 'Murhy (Sligo)', zip: '761194' },
	{ city: 'Murillyroe (Sligo)', zip: '194520' },
	{ city: 'Murirrigane (Kerry)', zip: '515534' },
	{ city: 'Murlough (Donegal)', zip: '596256' },
	{ city: 'Murmod (Cavan)', zip: '401594' },
	{ city: 'Murnaghbeg (Cork)', zip: '952252' },
	{ city: 'Murneen North (Mayo)', zip: '421251' },
	{ city: 'Murneen South (Mayo)', zip: '499155' },
	{ city: 'Murntown (Wexford)', zip: '833075' },
	{ city: 'Murntown Lower (Wexford)', zip: '193882' },
	{ city: 'Murntown Upper (Wexford)', zip: '336166' },
	{ city: 'Murphystown (Dublin)', zip: '308234' },
	{ city: 'Murragh (Cork)', zip: '647762' },
	{ city: 'Murragh (Dublin)', zip: '438061' },
	{ city: 'Murragh (Offaly)', zip: '637508' },
	{ city: 'Murrahin (Cork)', zip: '891457' },
	{ city: 'Murrahin North (Cork)', zip: '233510' },
	{ city: 'Murrahin South (Cork)', zip: '410159' },
	{ city: 'Murreagh (Cork)', zip: '113527' },
	{ city: 'Murreagh (Kerry)', zip: '551770' },
	{ city: 'Murren (Donegal)', zip: '645660' },
	{ city: 'Murrens (Meath)', zip: '457748' },
	{ city: 'Murrevagh (Mayo)', zip: '681943' },
	{ city: 'Murrisk (Mayo)', zip: '688891' },
	{ city: 'Murrisk Demesne (Mayo)', zip: '706307' },
	{ city: 'Murrisknaboll (Mayo)', zip: '783437' },
	{ city: 'Murroe (Donegal)', zip: '318526' },
	{ city: 'Murrooghkilly (Clare)', zip: '825743' },
	{ city: 'Murrooghtoohy North (Clare)', zip: '980713' },
	{ city: 'Murrooghtoohy South (Clare)', zip: '645399' },
	{ city: 'Murtaghstown (Kilkenny)', zip: '866717' },
	{ city: 'Murvagh Island (Galway)', zip: '193788' },
	{ city: 'Murvagh Lower (Donegal)', zip: '814993' },
	{ city: 'Murvagh Upper Glebe (Donegal)', zip: '312123' },
	{ city: 'Murvey (Galway)', zip: '450397' },
	{ city: 'Mushera (Cork)', zip: '912930' },
	{ city: 'Musicfield (Mayo)', zip: '246614' },
	{ city: 'Muskeagh (Wicklow)', zip: '948673' },
	{ city: 'Mutton Island (Clare)', zip: '904211' },
	{ city: 'Mweelagarraun (Clare)', zip: '365823' },
	{ city: 'Mweelahorna (Waterford)', zip: '520301' },
	{ city: 'Mweelcaha (Kerry)', zip: '292863' },
	{ city: 'Mweelin (Galway)', zip: '823747' },
	{ city: 'Mweelin (Kerry)', zip: '385592' },
	{ city: 'Mweelin (Mayo)', zip: '560822' },
	{ city: 'Mweeling (Waterford)', zip: '142795' },
	{ city: 'Mweelinroe (Kerry)', zip: '294567' },
	{ city: 'Mweelis (Mayo)', zip: '170270' },
	{ city: 'Mweeloon (Galway)', zip: '808999' },
	{ city: 'Mweelra (Westmeath)', zip: '604657' },
	{ city: 'Mweelroe (Sligo)', zip: '959415' },
	{ city: 'Mweenish Island (Galway)', zip: '924240' },
	{ city: 'Mweennalaa (Kerry)', zip: '570399' },
	{ city: 'Mweevoo (Kerry)', zip: '160731' },
	{ city: 'Mweevuck (Kerry)', zip: '234717' },
	{ city: 'Mweewillin (Mayo)', zip: '447398' },
	{ city: 'Myaugh (Wexford)', zip: '312145' },
	{ city: 'Mylane (Cork)', zip: '671590' },
	{ city: 'Mylerspark (Wexford)', zip: '925395' },
	{ city: 'Mylerstown (Kildare)', zip: '350901' },
	{ city: 'Mylerstown (Tipperary)', zip: '812613' },
	{ city: 'Mylesestate (Mayo)', zip: '547628' },
	{ city: 'Mylespark (Galway)', zip: '961443' },
	{ city: 'Mylestown (Westmeath)', zip: '859334' },
	{ city: 'Mynagh (Kildare)', zip: '708880' },
	{ city: 'Myross (Cork)', zip: '621928' },
	{ city: 'Myrtleville (Cork)', zip: '911826' },
	{ city: 'Myshall (Carlow)', zip: '573179' },
	{ city: 'Naas (Kildare)', zip: '721284' },
	{ city: 'Naas East (Kildare)', zip: '204705' },
	{ city: 'Naas West (Kildare)', zip: '989005' },
	{ city: 'Nadanuller Beg (Cork)', zip: '117788' },
	{ city: 'Nadanuller More (Cork)', zip: '726923' },
	{ city: 'Nadnaveagh (Roscommon)', zip: '732427' },
	{ city: 'Nadneagh (Offaly)', zip: '289415' },
	{ city: 'Nadrid (Cork)', zip: '793776' },
	{ city: 'Nafarty (Monaghan)', zip: '238980' },
	{ city: 'Naghill (Monaghan)', zip: '992266' },
	{ city: 'Naglesborough (Cork)', zip: '109329' },
	{ city: 'Naglesland (Kilkenny)', zip: '688693' },
	{ city: 'Nahana (Offaly)', zip: '731251' },
	{ city: 'Naheellis (Cavan)', zip: '513578' },
	{ city: 'Nahod Little (Westmeath)', zip: '700090' },
	{ city: 'Nahod More (Westmeath)', zip: '482107' },
	{ city: 'Nail (Galway)', zip: '632394' },
	{ city: 'Nakil (Mayo)', zip: '862557' },
	{ city: 'Nangor (Dublin)', zip: '269649' },
	{ city: 'Nantinan (Kerry)', zip: '759655' },
	{ city: 'Nantinan (Limerick)', zip: '481272' },
	{ city: 'Nappagh (Longford)', zip: '165861' },
	{ city: 'Naran (Donegal)', zip: '594684' },
	{ city: 'Narrabaun North (Kilkenny)', zip: '838130' },
	{ city: 'Narrabaun South (Kilkenny)', zip: '395410' },
	{ city: 'Narraghbeg (Kildare)', zip: '751793' },
	{ city: 'Narraghmore (Kildare)', zip: '209784' },
	{ city: 'Narraghmore Demesne (Kildare)', zip: '378769' },
	{ city: 'Nart (Monaghan)', zip: '487697' },
	{ city: 'Nash (Wexford)', zip: '483426' },
	{ city: "Nashe's Quarter (Carlow)", zip: '698378' },
	{ city: 'Naul (Dublin)', zip: '926762' },
	{ city: 'Naul (Meath)', zip: '277553' },
	{ city: 'Naulswood (Meath)', zip: '474450' },
	{ city: 'Navan (Louth)', zip: '300527' },
	{ city: 'Navan (Meath)', zip: '873279' },
	{ city: 'Navenny (Donegal)', zip: '412685' },
	{ city: 'Neale (Mayo)', zip: '536916' },
	{ city: 'Nealepark (Mayo)', zip: '109939' },
	{ city: 'Neaskin (Cork)', zip: '449778' },
	{ city: 'Ned (Cavan)', zip: '667531' },
	{ city: 'Nedanone (Kerry)', zip: '860347' },
	{ city: 'Neddaiagh (Cavan)', zip: '793413' },
	{ city: 'Neddans (Tipperary)', zip: '203750' },
	{ city: 'Nedinagh East (Cork)', zip: '199070' },
	{ city: 'Nedinagh West (Cork)', zip: '719671' },
	{ city: 'Needle Island (Galway)', zip: '429541' },
	{ city: 'Neesha (Kerry)', zip: '245316' },
	{ city: 'Neigham (Kilkenny)', zip: '332658' },
	{ city: 'Neillstown (Dublin)', zip: '858962' },
	{ city: 'Neillstown (Meath)', zip: '532028' },
	{ city: 'Neillstown Park (Meath)', zip: '213563' },
	{ city: 'Nemestown (Wexford)', zip: '349309' },
	{ city: 'Nenagh (Tipperary)', zip: '615057' },
	{ city: 'Nenagh North (Tipperary)', zip: '891757' },
	{ city: 'Nenagh South (Tipperary)', zip: '560299' },
	{ city: 'Nethertown (Wexford)', zip: '431585' },
	{ city: 'Nettleville Demesne (Cork)', zip: '353290' },
	{ city: 'Nevillescourt (Wexford)', zip: '412674' },
	{ city: 'Nevinstown (Meath)', zip: '291920' },
	{ city: 'Nevinstown East (Dublin)', zip: '369932' },
	{ city: 'Nevinstown West (Dublin)', zip: '468825' },
	{ city: 'Nevitt (Dublin)', zip: '974400' },
	{ city: 'Newabbey (Kildare)', zip: '743222' },
	{ city: 'Newacre (Carlow)', zip: '904990' },
	{ city: 'Newantrim (Mayo)', zip: '186681' },
	{ city: 'Newbarn (Dublin)', zip: '255600' },
	{ city: 'Newbawn (Wexford)', zip: '474397' },
	{ city: 'Newbawn (Wicklow)', zip: '931855' },
	{ city: 'Newbay (Wexford)', zip: '361784' },
	{ city: 'Newberry (Cork)', zip: '847755' },
	{ city: 'New Birmingham (Tipperary)', zip: '497968' },
	{ city: 'Newbliss (Monaghan)', zip: '659740' },
	{ city: 'Newborough (Cork)', zip: '460958' },
	{ city: 'Newbridge (Galway)', zip: '673797' },
	{ city: 'Newbridge (Kildare)', zip: '543721' },
	{ city: 'Newbridge (Wexford)', zip: '818210' },
	{ city: 'Newbridge Demesne (Dublin)', zip: '380771' },
	{ city: 'Newbristy North (Westmeath)', zip: '948245' },
	{ city: 'Newbristy South (Westmeath)', zip: '307855' },
	{ city: 'Newbrook (Leitrim)', zip: '301832' },
	{ city: 'Newbrook (Tipperary)', zip: '219964' },
	{ city: 'Newcastle (Cork)', zip: '224736' },
	{ city: 'Newcastle (Dublin)', zip: '380709' },
	{ city: 'Newcastle (Galway)', zip: '491507' },
	{ city: 'Newcastle (Limerick)', zip: '929999' },
	{ city: 'Newcastle (Longford)', zip: '895411' },
	{ city: 'Newcastle (Mayo)', zip: '733458' },
	{ city: 'Newcastle (Meath)', zip: '704849' },
	{ city: 'Newcastle (Tipperary)', zip: '827588' },
	{ city: 'Newcastle (Westmeath)', zip: '840166' },
	{ city: 'Newcastle (Wexford)', zip: '818875' },
	{ city: 'Newcastle (Wicklow)', zip: '160967' },
	{ city: 'Newcastle Demesne (Dublin)', zip: '904285' },
	{ city: 'Newcastle Farm (Dublin)', zip: '759839' },
	{ city: 'Newcastle Lower (Wexford)', zip: '619495' },
	{ city: 'Newcastle Lower (Wicklow)', zip: '601350' },
	{ city: 'Newcastle Middle (Wicklow)', zip: '164928' },
	{ city: 'Newcastle North (Dublin)', zip: '653075' },
	{ city: 'Newcastle South (Dublin)', zip: '935324' },
	{ city: 'Newcastle Upper (Wexford)', zip: '306481' },
	{ city: 'Newcastle Upper (Wicklow)', zip: '729731' },
	{ city: 'Newcastle West (Limerick)', zip: '481953' },
	{ city: 'Newcestown (Cork)', zip: '981419' },
	{ city: 'Newchapel (Tipperary)', zip: '787994' },
	{ city: 'Newchurch (Kilkenny)', zip: '389451' },
	{ city: 'Newchurch Glebe (Donegal)', zip: '106286' },
	{ city: 'Newcourt (Wicklow)', zip: '552660' },
	{ city: 'Newdown (Westmeath)', zip: '438319' },
	{ city: 'Newengland (Kilkenny)', zip: '493465' },
	{ city: 'Newfarm (Kilkenny)', zip: '130396' },
	{ city: 'Newfield (Mayo)', zip: '752788' },
	{ city: 'Newford (Galway)', zip: '632512' },
	{ city: 'Newforest (Galway)', zip: '426011' },
	{ city: 'Newfort (Wexford)', zip: '883314' },
	{ city: 'Newgarden (Carlow)', zip: '195614' },
	{ city: 'Newgarden North (Limerick)', zip: '767538' },
	{ city: 'Newgarden South (Limerick)', zip: '958221' },
	{ city: 'New Glebe (Roscommon)', zip: '364069' },
	{ city: 'Newgrange (Meath)', zip: '482972' },
	{ city: 'Newgrove (Cork)', zip: '823971' },
	{ city: 'Newgrove (Galway)', zip: '365808' },
	{ city: 'Newgrove (Kilkenny)', zip: '684982' },
	{ city: 'Newgrove (Monaghan)', zip: '298557' },
	{ city: 'Newgrove (Westmeath)', zip: '875737' },
	{ city: 'Newhaggard (Dublin)', zip: '666198' },
	{ city: 'Newhaggard (Meath)', zip: '164730' },
	{ city: 'Newhall (Clare)', zip: '870440' },
	{ city: 'Newhall (Galway)', zip: '543795' },
	{ city: 'Newhall (Kildare)', zip: '440277' },
	{ city: 'Newhall (Louth)', zip: '836354' },
	{ city: 'Newhall (Tipperary)', zip: '492302' },
	{ city: 'Newhill (Tipperary)', zip: '191831' },
	{ city: 'Newhouse (Kilkenny)', zip: '249040' },
	{ city: 'Newhouse (Louth)', zip: '661720' },
	{ city: 'Newhouse (Wexford)', zip: '222880' },
	{ city: 'Newhouses (Wexford)', zip: '237750' },
	{ city: 'Newinn (Tipperary)', zip: '172587' },
	{ city: 'New Inn (Cavan)', zip: '653404' },
	{ city: 'New Inn (Galway)', zip: '385119' },
	{ city: 'Newland North (Kildare)', zip: '160453' },
	{ city: 'Newlands (Dublin)', zip: '610200' },
	{ city: 'Newlands (Kilkenny)', zip: '507179' },
	{ city: 'Newlands Demesne (Dublin)', zip: '525109' },
	{ city: 'Newland South (Kildare)', zip: '361767' },
	{ city: 'Newland West (Kildare)', zip: '837236' },
	{ city: 'Newlawn (Tipperary)', zip: '697395' },
	{ city: 'Newmarket (Clare)', zip: '133122' },
	{ city: 'Newmarket (Cork)', zip: '406335' },
	{ city: 'Newmarket (Kilkenny)', zip: '699650' },
	{ city: 'Newmarket On Fergus (Clare)', zip: '114334' },
	{ city: 'Newmill (Donegal)', zip: '569440' },
	{ city: 'Neworchard (Kilkenny)', zip: '673868' },
	{ city: 'Newpaddocks (Wicklow)', zip: '285438' },
	{ city: 'Newpark (Clare)', zip: '420125' },
	{ city: 'Newpark (Dublin)', zip: '303458' },
	{ city: 'Newpark (Kildare)', zip: '521108' },
	{ city: 'Newpark (Kilkenny)', zip: '960527' },
	{ city: 'Newpark (Limerick)', zip: '522021' },
	{ city: 'Newpark (Longford)', zip: '101934' },
	{ city: 'Newpark (Mayo)', zip: '871744' },
	{ city: 'Newpark (Sligo)', zip: '545911' },
	{ city: 'Newpark (Tipperary)', zip: '879383' },
	{ city: 'Newpark (Wicklow)', zip: '309008' },
	{ city: 'Newpark Lower (Kilkenny)', zip: '165381' },
	{ city: 'Newpark Upper (Kilkenny)', zip: '283171' },
	{ city: 'Newpass Demesne (Westmeath)', zip: '478915' },
	{ city: 'Newport (Longford)', zip: '678955' },
	{ city: 'Newport (Mayo)', zip: '953015' },
	{ city: 'Newport (Tipperary)', zip: '349636' },
	{ city: 'Newport East (Waterford)', zip: '506844' },
	{ city: 'Newport West (Waterford)', zip: '884016' },
	{ city: 'Newquay (Clare)', zip: '852939' },
	{ city: 'Newragh (Louth)', zip: '500908' },
	{ city: 'Newrath (Kilkenny)', zip: '928899' },
	{ city: 'Newrath (Louth)', zip: '676387' },
	{ city: 'Newrath (Meath)', zip: '805329' },
	{ city: 'Newrath (Wicklow)', zip: '398295' },
	{ city: 'Newrath Big (Meath)', zip: '504694' },
	{ city: 'Newrath Little (Meath)', zip: '901873' },
	{ city: 'Newross (Tipperary)', zip: '319986' },
	{ city: 'New Ross (Wexford)', zip: '874559' },
	{ city: 'Newrow (Donegal)', zip: '643040' },
	{ city: 'Newrow (Kildare)', zip: '761084' },
	{ city: 'Newry (Wicklow)', zip: '342742' },
	{ city: 'Newstone (Meath)', zip: '967604' },
	{ city: 'Newstown (Carlow)', zip: '399602' },
	{ city: 'Newtown (Carlow)', zip: '555345' },
	{ city: 'Newtown (Cavan)', zip: '212795' },
	{ city: 'Newtown (Clare)', zip: '613056' },
	{ city: 'Newtown (Cork)', zip: '978274' },
	{ city: 'Newtown (Dublin)', zip: '696984' },
	{ city: 'Newtown (Galway)', zip: '530338' },
	{ city: 'Newtown (Kildare)', zip: '417561' },
	{ city: 'Newtown (Kilkenny)', zip: '341944' },
	{ city: 'Newtown (Laois)', zip: '192522' },
	{ city: 'Newtown (Limerick)', zip: '428640' },
	{ city: 'Newtown (Longford)', zip: '389195' },
	{ city: 'Newtown (Louth)', zip: '807331' },
	{ city: 'Newtown (Mayo)', zip: '499066' },
	{ city: 'Newtown (Meath)', zip: '335363' },
	{ city: 'Newtown (Offaly)', zip: '277302' },
	{ city: 'Newtown (Roscommon)', zip: '422207' },
	{ city: 'Newtown (Sligo)', zip: '175943' },
	{ city: 'Newtown (Tipperary)', zip: '748013' },
	{ city: 'Newtown (Waterford)', zip: '853002' },
	{ city: 'Newtown (Westmeath)', zip: '866993' },
	{ city: 'Newtown (Wexford)', zip: '254552' },
	{ city: 'Newtown (Wicklow)', zip: '920318' },
	{ city: 'Newtownadam (Tipperary)', zip: '661496' },
	{ city: 'Newtownallen (Kildare)', zip: '923380' },
	{ city: 'Newtownanner Demesne (Tipperary)', zip: '436122' },
	{ city: 'Newtownbabe (Louth)', zip: '297223' },
	{ city: 'Newtownbalregan (Louth)', zip: '560618' },
	{ city: 'Newtown Baltracey (Kildare)', zip: '325277' },
	{ city: 'Newtownbarry (Wexford)', zip: '847484' },
	{ city: 'Newtownbert (Kildare)', zip: '914315' },
	{ city: 'Newtown Big (Wexford)', zip: '763888' },
	{ city: 'Newtown Blackrock (Dublin)', zip: '349865' },
	{ city: 'Newtownblake (Galway)', zip: '441824' },
	{ city: 'Newtownbond (Longford)', zip: '105025' },
	{ city: 'Newtownboswell (Wicklow)', zip: '291258' },
	{ city: 'Newtownbracklagh (Galway)', zip: '905353' },
	{ city: 'Newtownburke (Donegal)', zip: '113311' },
	{ city: 'Newtown Carradoan (Donegal)', zip: '552700' },
	{ city: 'Newtowncarrigans (Roscommon)', zip: '599736' },
	{ city: 'Newtown Cashel (Longford)', zip: '857996' },
	{ city: 'Newtown Castlebyrn (Dublin)', zip: '870754' },
	{ city: 'Newtowncliffony (Sligo)', zip: '813389' },
	{ city: 'Newtownclonbun (Meath)', zip: '260675' },
	{ city: 'Newtown Commons (Meath)', zip: '974224' },
	{ city: 'Newtowncorduff (Dublin)', zip: '310944' },
	{ city: 'Newtowncunningham (Donegal)', zip: '802664' },
	{ city: 'Newtown Cunningham (Donegal)', zip: '674442' },
	{ city: 'Newtowndarver (Louth)', zip: '919314' },
	{ city: 'Newtowndonore (Kildare)', zip: '238108' },
	{ city: 'Newtowndrangan (Tipperary)', zip: '575603' },
	{ city: 'Newtowndrumgornan (Donegal)', zip: '654589' },
	{ city: 'Newtown East (Clare)', zip: '210166' },
	{ city: 'Newtowneyre (Galway)', zip: '367109' },
	{ city: 'Newtownfane (Louth)', zip: '536173' },
	{ city: 'Newtown Farragher (Roscommon)', zip: '726067' },
	{ city: 'Newtownflanigan (Longford)', zip: '506529' },
	{ city: 'Newtown Forbes (Longford)', zip: '911491' },
	{ city: 'Newtownfore (Donegal)', zip: '612334' },
	{ city: 'Newtown Girley (Meath)', zip: '495625' },
	{ city: 'Newtowngore (Leitrim)', zip: '592184' },
	{ city: 'Newtown Gore (Leitrim)', zip: '183810' },
	{ city: 'Newtown Great (Kildare)', zip: '413067' },
	{ city: 'Newtownhamilton (Donegal)', zip: '695322' },
	{ city: 'Newtownhortland (Kildare)', zip: '651991' },
	{ city: 'Newtownkelly (Galway)', zip: '356957' },
	{ city: 'Newtown Kilcashel (Roscommon)', zip: '678341' },
	{ city: 'Newtown Kilcolgan (Galway)', zip: '516765' },
	{ city: 'Newtown Knockaleva (Louth)', zip: '422216' },
	{ city: 'Newtownlaragh (Kildare)', zip: '677909' },
	{ city: 'Newtown Little (Dublin)', zip: '672990' },
	{ city: 'Newtown Little (Kildare)', zip: '989333' },
	{ city: 'Newtown Little (Wexford)', zip: '933806' },
	{ city: 'Newtownlow (Westmeath)', zip: '595675' },
	{ city: 'Newtown Lower (Dublin)', zip: '646019' },
	{ city: 'Newtown Lower (Tipperary)', zip: '963258' },
	{ city: 'Newtown Lower (Wexford)', zip: '813401' },
	{ city: 'Newtownlynch (Galway)', zip: '775647' },
	{ city: 'Newtownmacabe (Kildare)', zip: '605094' },
	{ city: 'Newtown Monasterboice (Louth)', zip: '840578' },
	{ city: 'Newtownmoneenluggagh (Kildare)', zip: '893017' },
	{ city: 'Newtown Mount Kennedy (Wicklow)', zip: '913173' },
	{ city: 'Newtownmoyaghy (Meath)', zip: '305543' },
	{ city: 'Newtownmoynagh (Meath)', zip: '631009' },
	{ city: 'Newtown Mt. Kennedy (Wicklow)', zip: '167787' },
	{ city: 'Newtown North (Cork)', zip: '985210' },
	{ city: 'Newtown North (Galway)', zip: '263559' },
	{ city: 'Newtown North (Limerick)', zip: '694407' },
	{ city: 'Newtown North (Mayo)', zip: '379605' },
	{ city: 'Newtown North (Tipperary)', zip: '493830' },
	{ city: 'Newtownpark (Dublin)', zip: '485606' },
	{ city: 'Newtownpark (Kildare)', zip: '614069' },
	{ city: 'Newtownpilsworth (Kildare)', zip: '999856' },
	{ city: 'Newtownrathganley (Meath)', zip: '536972' },
	{ city: 'Newtown Sandes (Kerry)', zip: '792706' },
	{ city: 'Newtownsaunders (Wicklow)', zip: '135969' },
	{ city: 'Newtownshandrum (Cork)', zip: '776578' },
	{ city: 'Newtown South (Cork)', zip: '954099' },
	{ city: 'Newtown South (Galway)', zip: '242247' },
	{ city: 'Newtown South (Limerick)', zip: '386500' },
	{ city: 'Newtown South (Mayo)', zip: '719424' },
	{ city: 'Newtown South (Tipperary)', zip: '199681' },
	{ city: 'Newtown Springfield (Donegal)', zip: '233425' },
	{ city: 'Newtownstalaban (Louth)', zip: '423211' },
	{ city: 'Newtown Upper (Dublin)', zip: '528350' },
	{ city: 'Newtown Upper (Tipperary)', zip: '693402' },
	{ city: 'Newtown Upper (Wexford)', zip: '271533' },
	{ city: 'Newtown West (Clare)', zip: '484259' },
	{ city: 'Newtownwhite (Mayo)', zip: '729993' },
	{ city: 'New Twopothouse Village (Cork)', zip: '793618' },
	{ city: 'Newvillage (Galway)', zip: '904449' },
	{ city: 'Nicharee (Wexford)', zip: '660774' },
	{ city: 'Nicholastown (Kildare)', zip: '417130' },
	{ city: 'Nicholastown (Kilkenny)', zip: '184649' },
	{ city: 'Nicholastown (Louth)', zip: '610650' },
	{ city: 'Nicholastown (Tipperary)', zip: '380039' },
	{ city: 'Nicholastown (Waterford)', zip: '674309' },
	{ city: 'Nicholastown (Westmeath)', zip: '160252' },
	{ city: 'Nicker (Limerick)', zip: '722532' },
	{ city: 'Nickeres (Tipperary)', zip: '833747' },
	{ city: 'Ninch (Meath)', zip: '143085' },
	{ city: 'Nineacres (Galway)', zip: '220882' },
	{ city: 'Nineacres (Wexford)', zip: '845020' },
	{ city: 'Ninemilehouse (Tipperary)', zip: '329551' },
	{ city: 'Nineteenacres (Wexford)', zip: '124994' },
	{ city: 'Noan (Tipperary)', zip: '815843' },
	{ city: 'Noard (Tipperary)', zip: '293358' },
	{ city: 'Nobber (Meath)', zip: '686557' },
	{ city: 'Nodstown (Tipperary)', zip: '607691' },
	{ city: 'Nodstown North (Tipperary)', zip: '823296' },
	{ city: 'Nodstown South (Tipperary)', zip: '633737' },
	{ city: 'Noggusboy (Offaly)', zip: '337119' },
	{ city: 'Noggusduff (Offaly)', zip: '306106' },
	{ city: 'Noghan (Cavan)', zip: '268757' },
	{ city: 'Nohaval (Cork)', zip: '777528' },
	{ city: 'Nohavaldaly (Cork)', zip: '164349' },
	{ city: 'Nohaval Lower (Cork)', zip: '938188' },
	{ city: 'Nohaval North (Kerry)', zip: '546957' },
	{ city: 'Nohaval South (Kerry)', zip: '962450' },
	{ city: 'Nohaval Upper (Cork)', zip: '977517' },
	{ city: 'Nolagh (Cavan)', zip: '780134' },
	{ city: 'Nonsuch (Westmeath)', zip: '790246' },
	{ city: 'Nooaff East (Clare)', zip: '560209' },
	{ city: 'Nooaff West (Clare)', zip: '838230' },
	{ city: 'Nooan (Clare)', zip: '190884' },
	{ city: 'Nook (Monaghan)', zip: '422434' },
	{ city: 'Nook (Wexford)', zip: '547485' },
	{ city: 'Normangrove (Galway)', zip: '900922' },
	{ city: 'Normansgrove (Meath)', zip: '823463' },
	{ city: 'Normanstown (Meath)', zip: '603201' },
	{ city: 'Norrira (Donegal)', zip: '987488' },
	{ city: 'Norrisland (Waterford)', zip: '164570' },
	{ city: 'Norrismount (Wexford)', zip: '301456' },
	{ city: 'Norristown (Wexford)', zip: '901352' },
	{ city: 'Northampton (Galway)', zip: '197897' },
	{ city: 'Northbrook (Galway)', zip: '239250' },
	{ city: 'North East Slob (Wexford)', zip: '635863' },
	{ city: 'Northgrove (Laois)', zip: '530577' },
	{ city: 'North Island (Galway)', zip: '904747' },
	{ city: 'Northlands (Cavan)', zip: '725754' },
	{ city: 'North West Slob (Wexford)', zip: '941226' },
	{ city: 'Northyard (Roscommon)', zip: '188791' },
	{ city: 'Noughaval (Clare)', zip: '820124' },
	{ city: 'Noughaval (Westmeath)', zip: '360761' },
	{ city: 'Noughermore (Donegal)', zip: '882815' },
	{ city: 'Nugentstown (Meath)', zip: '248680' },
	{ city: 'Nunsacre (Galway)', zip: '228096' },
	{ city: 'Nunsland (Kildare)', zip: '393404' },
	{ city: 'Nunstown (Kerry)', zip: '619081' },
	{ city: 'Nure (Leitrim)', zip: '869063' },
	{ city: 'Nure (Mayo)', zip: '458655' },
	{ city: 'Nure (Westmeath)', zip: '994093' },
	{ city: 'Nure Beg (Monaghan)', zip: '273851' },
	{ city: 'Nure More (Monaghan)', zip: '462524' },
	{ city: 'Nurney (Carlow)', zip: '290321' },
	{ city: 'Nurney (Kildare)', zip: '827732' },
	{ city: 'Nurneybog (Kildare)', zip: '637094' },
	{ city: 'Nurney Demesne (Kildare)', zip: '417202' },
	{ city: 'Nurserypark (Galway)', zip: '337355' },
	{ city: 'Nursetown Beg (Cork)', zip: '851064' },
	{ city: 'Nursetown More (Cork)', zip: '663406' },
	{ city: 'Nutfield (Cavan)', zip: '547711' },
	{ city: 'Nutfield (Clare)', zip: '304700' },
	{ city: 'Nutgrove (Cork)', zip: '986224' },
	{ city: 'Nutgrove (Laois)', zip: '979306' },
	{ city: 'Nutstown (Dublin)', zip: '294365' },
	{ city: 'Nuttstown (Meath)', zip: '249624' },
	{ city: 'Nymphhall (Waterford)', zip: '275202' },
	{ city: 'Nymphsfield (Mayo)', zip: '174420' },
	{ city: 'Nyra (Laois)', zip: '605314' },
	{ city: 'Oakfield (Clare)', zip: '160495' },
	{ city: 'Oakfield (Galway)', zip: '802115' },
	{ city: 'Oakfield (Roscommon)', zip: '466222' },
	{ city: 'Oakfield Demesne (Donegal)', zip: '150541' },
	{ city: 'Oakhampton (Tipperary)', zip: '563590' },
	{ city: 'Oaklands (Wexford)', zip: '449467' },
	{ city: 'Oakleypark (Kildare)', zip: '583135' },
	{ city: 'Oakleypark (Meath)', zip: '866155' },
	{ city: 'Oakleypark (Offaly)', zip: '679631' },
	{ city: 'Oakpark (Carlow)', zip: '108252' },
	{ city: 'Oakport Demesne (Roscommon)', zip: '379894' },
	{ city: 'Oakstown (Meath)', zip: '606351' },
	{ city: 'Oaktate (Louth)', zip: '962888' },
	{ city: 'Oakwood (Cavan)', zip: '691275' },
	{ city: 'Oakwood (Wicklow)', zip: '774551' },
	{ city: 'Oakwood North (Galway)', zip: '720346' },
	{ city: 'Oakwood South (Galway)', zip: '384293' },
	{ city: 'Oatencake (Cork)', zip: '167591' },
	{ city: 'Oatfield (Clare)', zip: '266466' },
	{ city: 'Oatfield (Galway)', zip: '913963' },
	{ city: 'Oatlands (Limerick)', zip: '380050' },
	{ city: 'Oberstown (Dublin)', zip: '233969' },
	{ city: 'Oberstown (Louth)', zip: '683937' },
	{ city: 'Obertstown (Meath)', zip: '647637' },
	{ city: "O'Briensbridge (Clare)", zip: '560147' },
	{ city: "O'Brienscastle (Clare)", zip: '694624' },
	{ city: "O'Callaghansmills (Clare)", zip: '574008' },
	{ city: 'Ockanaroe (Laois)', zip: '154119' },
	{ city: 'Odagh (Kilkenny)', zip: '485197' },
	{ city: 'Oddacres (Galway)', zip: '874733' },
	{ city: 'Odder (Meath)', zip: '347356' },
	{ city: 'Oggal (Cavan)', zip: '250327' },
	{ city: 'Ogham (Sligo)', zip: '912854' },
	{ city: 'Oghambaun (Sligo)', zip: '638884' },
	{ city: 'Ogherbeg (Donegal)', zip: '908313' },
	{ city: 'Oghermong (Kerry)', zip: '503482' },
	{ city: 'Oghery (Galway)', zip: '534673' },
	{ city: 'Oghil (Galway)', zip: '587160' },
	{ city: 'Oghil (Kildare)', zip: '726144' },
	{ city: 'Oghil (Longford)', zip: '215236' },
	{ city: 'Oghil (Sligo)', zip: '534532' },
	{ city: 'Oghil Beg (Galway)', zip: '641275' },
	{ city: 'Oghill (Cavan)', zip: '830603' },
	{ city: 'Oghill (Donegal)', zip: '504994' },
	{ city: 'Oghill (Leitrim)', zip: '824460' },
	{ city: 'Oghill (Monaghan)', zip: '204449' },
	{ city: 'Oghillees (Mayo)', zip: '840280' },
	{ city: 'Oghil Lower (Wicklow)', zip: '380240' },
	{ city: 'Oghilly (Galway)', zip: '590775' },
	{ city: 'Oghil More (Galway)', zip: '983487' },
	{ city: 'Oghil Upper (Wicklow)', zip: '244457' },
	{ city: 'Ogonnelloe (Clare)', zip: '242063' },
	{ city: 'Ogulla (Roscommon)', zip: '276179' },
	{ city: 'Oilgate (Wexford)', zip: '190808' },
	{ city: 'Okyle (Waterford)', zip: '372772' },
	{ city: 'Oldabbey (Cork)', zip: '900915' },
	{ city: 'Oldabbey (Limerick)', zip: '575651' },
	{ city: 'Oldbawn (Dublin)', zip: '805794' },
	{ city: 'Oldboley (Wexford)', zip: '182672' },
	{ city: 'Oldboleys (Wicklow)', zip: '208018' },
	{ city: 'Oldborris (Laois)', zip: '872930' },
	{ city: 'Oldbridge (Meath)', zip: '703510' },
	{ city: 'Oldbridge (Tipperary)', zip: '475351' },
	{ city: 'Oldcamp (Laois)', zip: '235487' },
	{ city: 'Oldcarton (Kildare)', zip: '528904' },
	{ city: 'Oldcastle (Cork)', zip: '926613' },
	{ city: 'Oldcastle (Galway)', zip: '516141' },
	{ city: 'Oldcastle (Mayo)', zip: '464893' },
	{ city: 'Oldcastle (Meath)', zip: '296676' },
	{ city: 'Oldcastle (Tipperary)', zip: '511448' },
	{ city: 'Oldcastle Lower (Kilkenny)', zip: '957180' },
	{ city: 'Oldcastletown (Cork)', zip: '561323' },
	{ city: 'Oldcastle Upper (Kilkenny)', zip: '908564' },
	{ city: 'Old Church Glebe (Donegal)', zip: '329566' },
	{ city: 'Oldconnaught (Dublin)', zip: '749486' },
	{ city: 'Old Connaught (Wicklow)', zip: '866574' },
	{ city: 'Oldconnell (Kildare)', zip: '438642' },
	{ city: 'Oldcourt (Cork)', zip: '472255' },
	{ city: 'Oldcourt (Dublin)', zip: '543759' },
	{ city: 'Oldcourt (Kildare)', zip: '804149' },
	{ city: 'Oldcourt (Kilkenny)', zip: '443880' },
	{ city: 'Oldcourt (Laois)', zip: '992928' },
	{ city: 'Oldcourt (Limerick)', zip: '372189' },
	{ city: 'Oldcourt (Tipperary)', zip: '264981' },
	{ city: 'Oldcourt (Wexford)', zip: '803324' },
	{ city: 'Oldcourt (Wicklow)', zip: '607909' },
	{ city: 'Oldcourt East (Cork)', zip: '230610' },
	{ city: 'Oldcourt West (Cork)', zip: '689776' },
	{ city: 'Oldcroghan (Offaly)', zip: '898608' },
	{ city: 'Olderrig (Laois)', zip: '450318' },
	{ city: 'Oldforge (Kerry)', zip: '782601' },
	{ city: 'Old-Fort (Cork)', zip: '428486' },
	{ city: 'Oldglass (Laois)', zip: '181635' },
	{ city: 'Oldgraigue (Meath)', zip: '551782' },
	{ city: 'Oldgrange (Kildare)', zip: '803543' },
	{ city: 'Oldgrange (Kilkenny)', zip: '589483' },
	{ city: 'Oldgrange (Sligo)', zip: '610371' },
	{ city: 'Oldgrange (Tipperary)', zip: '142452' },
	{ city: 'Oldgrange (Waterford)', zip: '116761' },
	{ city: 'Oldhall (Wexford)', zip: '166719' },
	{ city: 'Oldhead (Mayo)', zip: '946421' },
	{ city: 'Oldkilcullen (Kildare)', zip: '683484' },
	{ city: 'Oldleagh (Laois)', zip: '386509' },
	{ city: 'Oldleighlin (Carlow)', zip: '671956' },
	{ city: 'Oldmill (Laois)', zip: '394294' },
	{ city: 'Oldmill (Wexford)', zip: '475011' },
	{ city: 'Oldmilltown (Kildare)', zip: '551197' },
	{ city: 'Oldorchard (Dublin)', zip: '407755' },
	{ city: 'Oldpaddocks (Wicklow)', zip: '755971' },
	{ city: 'Oldpark (Kilkenny)', zip: '641209' },
	{ city: 'Oldstreet (Galway)', zip: '826615' },
	{ city: 'Oldtown (Carlow)', zip: '334596' },
	{ city: 'Oldtown (Donegal)', zip: '487345' },
	{ city: 'Oldtown (Dublin)', zip: '523313' },
	{ city: 'Oldtown (Kildare)', zip: '544981' },
	{ city: 'Oldtown (Kilkenny)', zip: '221264' },
	{ city: 'Oldtown (Laois)', zip: '177527' },
	{ city: 'Oldtown (Limerick)', zip: '462568' },
	{ city: 'Oldtown (Longford)', zip: '536767' },
	{ city: 'Oldtown (Meath)', zip: '664099' },
	{ city: 'Oldtown (Offaly)', zip: '616125' },
	{ city: 'Oldtown (Roscommon)', zip: '322016' },
	{ city: 'Oldtown (Tipperary)', zip: '425854' },
	{ city: 'Oldtown (Westmeath)', zip: '270160' },
	{ city: 'Oldtown (Wexford)', zip: '288989' },
	{ city: 'Oldtown (Wicklow)', zip: '476785' },
	{ city: 'Old Town (Laois)', zip: '298402' },
	{ city: 'Oldtown Demesne (Kildare)', zip: '661253' },
	{ city: 'Oldtowndonore (Kildare)', zip: '510276' },
	{ city: 'Oldtownhill (Kilkenny)', zip: '220520' },
	{ city: 'Oldtown Kilcashel (Roscommon)', zip: '802422' },
	{ city: 'Oldtully (Meath)', zip: '655819' },
	{ city: 'Ollatrim (Tipperary)', zip: '229880' },
	{ city: 'Oltore (Galway)', zip: '566819' },
	{ city: 'Omard (Cavan)', zip: '906009' },
	{ city: 'Omaun Beg (Galway)', zip: '358389' },
	{ city: 'Omaun More (Galway)', zip: '227611' },
	{ city: "O'Meara's Acres (Tipperary)", zip: '363820' },
	{ city: 'Omeath (Louth)', zip: '338140' },
	{ city: 'Omoresforest (Laois)', zip: '750075' },
	{ city: 'Onagh (Roscommon)', zip: '961002' },
	{ city: 'Onagh (Wicklow)', zip: '912730' },
	{ city: 'Onaght (Galway)', zip: '136670' },
	{ city: 'Ongenstown (Meath)', zip: '282226' },
	{ city: 'Onomy (Monaghan)', zip: '152610' },
	{ city: 'Ooankeagh (Clare)', zip: '520097' },
	{ city: 'Ooghcorragaun (Mayo)', zip: '634981' },
	{ city: 'Oola (Limerick)', zip: '179979' },
	{ city: 'Oolagh East (Kerry)', zip: '680376' },
	{ city: 'Oolagh West (Kerry)', zip: '326854' },
	{ city: 'Oolahills East (Limerick)', zip: '548643' },
	{ city: 'Oolahills West (Limerick)', zip: '732572' },
	{ city: 'Oorid (Galway)', zip: '225278' },
	{ city: 'Oorla (Limerick)', zip: '235869' },
	{ city: 'Oort (Donegal)', zip: '362404' },
	{ city: 'Oory (Mayo)', zip: '644060' },
	{ city: 'Oram (Monaghan)', zip: '754209' },
	{ city: 'Oran (Roscommon)', zip: '807642' },
	{ city: 'Oran Beg (Galway)', zip: '582682' },
	{ city: 'Oranhill (Galway)', zip: '931751' },
	{ city: 'Oranmore (Galway)', zip: '204413' },
	{ city: 'Oran More (Galway)', zip: '802090' },
	{ city: 'Oranstown (Meath)', zip: '356830' },
	{ city: 'Orchard (Carlow)', zip: '616876' },
	{ city: 'Orchard Lower (Laois)', zip: '325220' },
	{ city: 'Orchardstown (Waterford)', zip: '688718' },
	{ city: 'Orchardstown East (Tipperary)', zip: '669811' },
	{ city: 'Orchardstown West (Tipperary)', zip: '881628' },
	{ city: 'Orchard Upper (Laois)', zip: '613269' },
	{ city: 'Ordnance Ground (Galway)', zip: '824916' },
	{ city: 'Ories (Westmeath)', zip: '261127' },
	{ city: 'Oristown (Meath)', zip: '756948' },
	{ city: 'Orkneys (Tipperary)', zip: '148103' },
	{ city: 'Orlagh (Dublin)', zip: '893124' },
	{ city: 'Orristown (Wexford)', zip: '827494' },
	{ city: 'Osberstown (Kildare)', zip: '924153' },
	{ city: "O'shea'S Acres (Clare)", zip: '133297' },
	{ city: 'Osierbrook (Offaly)', zip: '927029' },
	{ city: 'Ossoryhill (Kilkenny)', zip: '244552' },
	{ city: 'Otterstown (Meath)', zip: '412880' },
	{ city: 'Oughaval (Laois)', zip: '353525' },
	{ city: 'Oughaval (Sligo)', zip: '262308' },
	{ city: 'Oughtagh (Galway)', zip: '369534' },
	{ city: 'Oughtagh (Mayo)', zip: '106293' },
	{ city: 'Oughtagh (Roscommon)', zip: '459653' },
	{ city: 'Oughtagorey (Sligo)', zip: '138205' },
	{ city: 'Oughtcarn (Donegal)', zip: '822398' },
	{ city: 'Oughtdarra (Clare)', zip: '917991' },
	{ city: 'Oughter (Mayo)', zip: '378890' },
	{ city: 'Oughter (Offaly)', zip: '703441' },
	{ city: 'Oughteragh (Leitrim)', zip: '190588' },
	{ city: 'Oughterard (Clare)', zip: '204219' },
	{ city: 'Oughterard (Galway)', zip: '361512' },
	{ city: 'Oughterard (Kildare)', zip: '929244' },
	{ city: 'Oughterlin (Donegal)', zip: '658280' },
	{ city: 'Oughtihery (Cork)', zip: '149791' },
	{ city: 'Oughtiv (Kerry)', zip: '886184' },
	{ city: 'Oughtmama (Clare)', zip: '668636' },
	{ city: 'Oughtmeen (Donegal)', zip: '175233' },
	{ city: 'Oughtminnee (Cork)', zip: '682673' },
	{ city: 'Oughtnadrin (Donegal)', zip: '595687' },
	{ city: 'Oughtohig (Cork)', zip: '699594' },
	{ city: 'Oughty (Mayo)', zip: '589311' },
	{ city: 'Oulart (Wexford)', zip: '814956' },
	{ city: 'Oulartard (Wexford)', zip: '990714' },
	{ city: 'Oulartleigh (Wexford)', zip: '256929' },
	{ city: 'Oulartwick Beg (Wexford)', zip: '394415' },
	{ city: 'Oulartwick More (Wexford)', zip: '955348' },
	{ city: 'Ouley (Cavan)', zip: '757558' },
	{ city: 'Oultauns (Mayo)', zip: '934633' },
	{ city: 'Oultort (Galway)', zip: '172012' },
	{ city: 'Ounagh (Sligo)', zip: '570501' },
	{ city: 'Ouragh (Carlow)', zip: '366977' },
	{ city: 'Ouris (Offaly)', zip: '291546' },
	{ city: 'Outeragh (Tipperary)', zip: '235885' },
	{ city: 'Outlands (Dublin)', zip: '796409' },
	{ city: 'Outrath (Kilkenny)', zip: '534156' },
	{ city: 'Ouvry (Monaghan)', zip: '432431' },
	{ city: 'Ovaun (Roscommon)', zip: '365068' },
	{ city: 'Ovenstown (Kilkenny)', zip: '686796' },
	{ city: 'Ovidstown (Kildare)', zip: '460175' },
	{ city: 'Owenanirragh (Mayo)', zip: '218554' },
	{ city: 'Owenavaddy (Galway)', zip: '992055' },
	{ city: 'Owenbeg (Sligo)', zip: '156166' },
	{ city: 'Owenboy (Donegal)', zip: '101117' },
	{ city: 'Owenboy (Mayo)', zip: '166469' },
	{ city: 'Owenbristy (Galway)', zip: '888411' },
	{ city: 'Owencam (Cavan)', zip: '782041' },
	{ city: 'Owenduff (Mayo)', zip: '887260' },
	{ city: 'Owengallees (Cavan)', zip: '219350' },
	{ city: 'Owenglass (Mayo)', zip: '933133' },
	{ city: 'Owenkillew And Barnahone (Donegal)', zip: '331202' },
	{ city: 'Owennagadragh (Donegal)', zip: '800866' },
	{ city: "Owen's And Bigg'S-Lot (Tipperary)", zip: '312880' },
	{ city: 'Owenstown (Meath)', zip: '382002' },
	{ city: 'Owenstown (Wexford)', zip: '142634' },
	{ city: 'Owenteskiny (Donegal)', zip: '572253' },
	{ city: 'Owenwee (Mayo)', zip: '630256' },
	{ city: 'Owenykeevan (Sligo)', zip: '166221' },
	{ city: 'Ower (Galway)', zip: '377239' },
	{ city: 'Owey Island (Donegal)', zip: '287996' },
	{ city: 'Owlbeg (Carlow)', zip: '550525' },
	{ city: 'Ownagarry (Kerry)', zip: '805835' },
	{ city: 'Owning (Kilkenny)', zip: '901981' },
	{ city: 'Oxford (Mayo)', zip: '516306' },
	{ city: 'Oxgrove (Galway)', zip: '359440' },
	{ city: 'Oxpark (Tipperary)', zip: '280256' },
	{ city: 'Oysterhaven (Cork)', zip: '615161' },
	{ city: 'Paal East (Cork)', zip: '429246' },
	{ city: 'Paal West (Cork)', zip: '694248' },
	{ city: 'Pace (Meath)', zip: '296703' },
	{ city: 'Paddingstown (Meath)', zip: '377218' },
	{ city: 'Paddinstown Lower (Westmeath)', zip: '637921' },
	{ city: 'Paddinstown Upper (Westmeath)', zip: '596852' },
	{ city: 'Paddock (Cavan)', zip: '435919' },
	{ city: 'Paddock (Cork)', zip: '814248' },
	{ city: 'Paddock (Galway)', zip: '351090' },
	{ city: 'Paddock (Kerry)', zip: '441535' },
	{ city: 'Paddock (Kilkenny)', zip: '796272' },
	{ city: 'Paddock (Laois)', zip: '459723' },
	{ city: 'Paddock (Louth)', zip: '748157' },
	{ city: 'Paddock (Meath)', zip: '619731' },
	{ city: 'Paddock (Roscommon)', zip: '665658' },
	{ city: 'Paddock (Tipperary)', zip: '911409' },
	{ city: 'Paddock (Waterford)', zip: '569121' },
	{ city: 'Paddock (Wicklow)', zip: '762519' },
	{ city: 'Paddocks (Waterford)', zip: '826913' },
	{ city: 'Padinstown (Meath)', zip: '865368' },
	{ city: 'Pagestown (Meath)', zip: '710057' },
	{ city: 'Painestown (Kildare)', zip: '713180' },
	{ city: 'Painestown (Louth)', zip: '556941' },
	{ city: 'Painestown (Meath)', zip: '346233' },
	{ city: 'Pakenhamhall (Westmeath)', zip: '647001' },
	{ city: 'Palace (Wexford)', zip: '980988' },
	{ city: 'Palaceanne (Cork)', zip: '558523' },
	{ city: 'Palace East (Wexford)', zip: '547324' },
	{ city: 'Palace West (Wexford)', zip: '415295' },
	{ city: 'Palatine (Carlow)', zip: '280263' },
	{ city: 'Pallas (Cork)', zip: '578776' },
	{ city: 'Pallas (Galway)', zip: '373572' },
	{ city: 'Pallas (Kerry)', zip: '760586' },
	{ city: 'Pallas (Limerick)', zip: '394284' },
	{ city: 'Pallas (Offaly)', zip: '425910' },
	{ city: 'Pallas (Tipperary)', zip: '856509' },
	{ city: 'Pallas (Westmeath)', zip: '565006' },
	{ city: 'Pallasbeg (Limerick)', zip: '467175' },
	{ city: 'Pallas Beg (Longford)', zip: '317150' },
	{ city: 'Pallas Beg (Tipperary)', zip: '885804' },
	{ city: 'Pallas Big (Laois)', zip: '879953' },
	{ city: 'Pallasboy (Westmeath)', zip: '726679' },
	{ city: 'Pallas East (Tipperary)', zip: '830006' },
	{ city: 'Pallas Grean (Limerick)', zip: '936465' },
	{ city: 'Pallas Grean New (Limerick)', zip: '544993' },
	{ city: 'Pallashill (Limerick)', zip: '994970' },
	{ city: 'Pallashill (Tipperary)', zip: '606068' },
	{ city: 'Pallaskenry (Limerick)', zip: '589159' },
	{ city: 'Pallas Little (Laois)', zip: '479614' },
	{ city: 'Pallas Lower (Tipperary)', zip: '330212' },
	{ city: 'Pallas More (Longford)', zip: '532799' },
	{ city: 'Pallas More (Tipperary)', zip: '245203' },
	{ city: 'Pallaspark (Offaly)', zip: '998690' },
	{ city: 'Pallas Upper (Tipperary)', zip: '224955' },
	{ city: 'Pallas West (Tipperary)', zip: '888145' },
	{ city: 'Pallis (Kerry)', zip: '108128' },
	{ city: 'Pallis (Waterford)', zip: '248570' },
	{ city: 'Pallishill (Wexford)', zip: '608658' },
	{ city: 'Pallis Lower (Wexford)', zip: '338984' },
	{ city: 'Pallis Upper (Wexford)', zip: '883347' },
	{ city: 'Palmershill (Laois)', zip: '451657' },
	{ city: "Palmer's-Hill (Tipperary)", zip: '871630' },
	{ city: 'Palmersland (Louth)', zip: '166174' },
	{ city: 'Palmerston (Dublin)', zip: '944733' },
	{ city: 'Palmerston Lower (Dublin)', zip: '827018' },
	{ city: 'Palmerston Upper (Dublin)', zip: '163282' },
	{ city: 'Palmerstown (Dublin)', zip: '407622' },
	{ city: 'Palmerstown (Galway)', zip: '607991' },
	{ city: 'Palmerstown (Kildare)', zip: '487078' },
	{ city: 'Palmerstown (Kilkenny)', zip: '528889' },
	{ city: 'Palmerstown Demesne (Kildare)', zip: '600378' },
	{ city: 'Paradise (Wexford)', zip: '986913' },
	{ city: 'Paradise Little (Wexford)', zip: '988826' },
	{ city: 'Parcellstown (Westmeath)', zip: '757848' },
	{ city: 'Parisee (Cavan)', zip: '105767' },
	{ city: 'Paristown (Westmeath)', zip: '833382' },
	{ city: 'Park (Carlow)', zip: '591918' },
	{ city: 'Park (Cork)', zip: '138081' },
	{ city: 'Park (Galway)', zip: '953155' },
	{ city: 'Park (Kerry)', zip: '371937' },
	{ city: 'Park (Laois)', zip: '892443' },
	{ city: 'Park (Leitrim)', zip: '478359' },
	{ city: 'Park (Limerick)', zip: '431235' },
	{ city: 'Park (Mayo)', zip: '983887' },
	{ city: 'Park (Meath)', zip: '135973' },
	{ city: 'Park (Offaly)', zip: '184074' },
	{ city: 'Park (Tipperary)', zip: '877655' },
	{ city: 'Park (Waterford)', zip: '765393' },
	{ city: 'Park (Wexford)', zip: '315209' },
	{ city: 'Park (Wicklow)', zip: '388469' },
	{ city: 'Parkacunna (Cork)', zip: '788813' },
	{ city: 'Parkacurry (Galway)', zip: '567986' },
	{ city: 'Parkadallane (Cork)', zip: '901538' },
	{ city: 'Parkaderreen (Tipperary)', zip: '736151' },
	{ city: 'Parkagarraun (Galway)', zip: '691402' },
	{ city: 'Parkahoughill (Laois)', zip: '335173' },
	{ city: 'Parkalassa (Kerry)', zip: '228892' },
	{ city: 'Parkalough (Clare)', zip: '659504' },
	{ city: 'Parkaloughan (Galway)', zip: '382514' },
	{ city: 'Parkana (Cork)', zip: '449454' },
	{ city: 'Parkanallacan (Galway)', zip: '798250' },
	{ city: 'Parkanillane (Cork)', zip: '828359' },
	{ city: 'Parkannesley Lower (Wexford)', zip: '562310' },
	{ city: 'Parkannesley Upper (Wexford)', zip: '440000' },
	{ city: 'Parkaree (Limerick)', zip: '396233' },
	{ city: 'Parkaree (Offaly)', zip: '297446' },
	{ city: 'Parkatleva (Galway)', zip: '191383' },
	{ city: 'Parkatleva (Mayo)', zip: '569966' },
	{ city: 'Parkatluggera (Waterford)', zip: '158737' },
	{ city: 'Parkatobeen (Waterford)', zip: '619342' },
	{ city: 'Parkatotaun (Limerick)', zip: '929667' },
	{ city: 'Parkavilla (Laois)', zip: '682755' },
	{ city: 'Parkavonear (Kerry)', zip: '306697' },
	{ city: 'Parkbaun (Galway)', zip: '608687' },
	{ city: 'Parkbaun (Wexford)', zip: '991325' },
	{ city: 'Parkbawn (Laois)', zip: '546128' },
	{ city: 'Parkbeg (Laois)', zip: '117724' },
	{ city: 'Parkbeg (Tipperary)', zip: '813760' },
	{ city: 'Parkbeg (Waterford)', zip: '510795' },
	{ city: 'Parkboy (Kerry)', zip: '699632' },
	{ city: 'Parkboy (Mayo)', zip: '549764' },
	{ city: 'Parkboy (Meath)', zip: '645209' },
	{ city: 'Parkboy (Tipperary)', zip: '871587' },
	{ city: 'Parkdotia (Waterford)', zip: '882536' },
	{ city: 'Parke (Sligo)', zip: '577199' },
	{ city: 'Parkearagh (Kerry)', zip: '702819' },
	{ city: 'Park East (Galway)', zip: '746429' },
	{ city: 'Parkeel (Roscommon)', zip: '855009' },
	{ city: 'Parkeenaflugh (Waterford)', zip: '887377' },
	{ city: 'Parkeenagarra (Waterford)', zip: '933240' },
	{ city: 'Parkeenalougha (Waterford)', zip: '232086' },
	{ city: 'Parkeennaglogh (Waterford)', zip: '917979' },
	{ city: 'Parkeighter (Galway)', zip: '641849' },
	{ city: 'Parkgarriff (Cork)', zip: '500482' },
	{ city: 'Parkgarriff (Waterford)', zip: '353665' },
	{ city: 'Parkgarve (Galway)', zip: '153610' },
	{ city: 'Parkhill (Donegal)', zip: '660224' },
	{ city: 'Parklane (Waterford)', zip: '279441' },
	{ city: 'Parklaur (Galway)', zip: '437532' },
	{ city: 'Parklaurence (Cork)', zip: '917824' },
	{ city: 'Parklewis (Limerick)', zip: '969442' },
	{ city: 'Park Lower (Laois)', zip: '332236' },
	{ city: 'Parkmeen (Offaly)', zip: '778125' },
	{ city: 'Parkmore (Clare)', zip: '750706' },
	{ city: 'Parkmore (Cork)', zip: '931317' },
	{ city: 'Parkmore (Donegal)', zip: '983995' },
	{ city: 'Parkmore (Galway)', zip: '468119' },
	{ city: 'Parkmore (Kerry)', zip: '378726' },
	{ city: 'Parkmore (Kilkenny)', zip: '331457' },
	{ city: 'Parkmore (Limerick)', zip: '166483' },
	{ city: 'Parkmore (Offaly)', zip: '496228' },
	{ city: 'Parkmore (Roscommon)', zip: '959566' },
	{ city: 'Parkmore (Sligo)', zip: '962123' },
	{ city: 'Parkmore (Tipperary)', zip: '781978' },
	{ city: 'Parkmore (Waterford)', zip: '566510' },
	{ city: 'Parkmore (Wicklow)', zip: '382517' },
	{ city: 'Parkmountain (Cork)', zip: '690026' },
	{ city: 'Parknabinnia (Clare)', zip: '249904' },
	{ city: 'Parknacross (Wexford)', zip: '274293' },
	{ city: 'Parknagappul (Waterford)', zip: '272252' },
	{ city: 'Parknageragh (Kerry)', zip: '364954' },
	{ city: 'Parknahown (Galway)', zip: '150126' },
	{ city: 'Parknahown (Laois)', zip: '789958' },
	{ city: 'Parknahyla (Cork)', zip: '934429' },
	{ city: 'Parknakilla (Cork)', zip: '999011' },
	{ city: 'Parknakillew (Mayo)', zip: '557061' },
	{ city: 'Parknakyle (Carlow)', zip: '986016' },
	{ city: 'Parknamoney (Clare)', zip: '555948' },
	{ city: 'Parknamulloge (Kerry)', zip: '848430' },
	{ city: 'Parknascaddane (Tipperary)', zip: '540612' },
	{ city: 'Parknashaw (Wicklow)', zip: '121458' },
	{ city: 'Parknashingaun (Mayo)', zip: '916311' },
	{ city: 'Parknashoge (Wexford)', zip: '960289' },
	{ city: 'Parknasilloge (Wicklow)', zip: '938358' },
	{ city: 'Parknasmuttaun (Kerry)', zip: '524580' },
	{ city: 'Parknoe (Waterford)', zip: '364995' },
	{ city: 'Park North (Cork)', zip: '494562' },
	{ city: 'Parkplace (Longford)', zip: '376707' },
	{ city: 'Parkroe (Clare)', zip: '501719' },
	{ city: 'Parkroe (Galway)', zip: '268136' },
	{ city: 'Parkroe (Limerick)', zip: '652493' },
	{ city: 'Parkroe (Tipperary)', zip: '681484' },
	{ city: 'Parkroe (Wicklow)', zip: '985702' },
	{ city: 'Parks (Kilkenny)', zip: '890685' },
	{ city: 'Parks (Mayo)', zip: '844935' },
	{ city: 'Parksgrove (Kilkenny)', zip: '545851' },
	{ city: 'Park South (Cork)', zip: '311063' },
	{ city: 'Parkstown (Meath)', zip: '641018' },
	{ city: 'Parkstown (Tipperary)', zip: '111489' },
	{ city: 'Parkstown Lower (Kilkenny)', zip: '104665' },
	{ city: 'Parkstown Upper (Kilkenny)', zip: '313954' },
	{ city: 'Parkswood Lower (Waterford)', zip: '305186' },
	{ city: 'Parkswood Upper (Waterford)', zip: '208930' },
	{ city: 'Park Upper (Laois)', zip: '302353' },
	{ city: 'Parkville (Tipperary)', zip: '994044' },
	{ city: 'Park West (Galway)', zip: '907797' },
	{ city: 'Parkwood (Limerick)', zip: '894840' },
	{ city: 'Parkwood (Offaly)', zip: '485074' },
	{ city: 'Parnelstown (Dublin)', zip: '657049' },
	{ city: 'Parslickstown (Dublin)', zip: '822075' },
	{ city: 'Parsonstown (Kildare)', zip: '628699' },
	{ city: 'Parsonstown (Louth)', zip: '149947' },
	{ city: 'Parsonstown (Meath)', zip: '583518' },
	{ city: 'Parsonstown (Westmeath)', zip: '574531' },
	{ city: 'Parsonstown Demesne (Meath)', zip: '506133' },
	{ city: 'Parteen (Clare)', zip: '566159' },
	{ city: 'Partry (Mayo)', zip: '561822' },
	{ city: 'Paslicktown (Westmeath)', zip: '797039' },
	{ city: 'Pass (Clare)', zip: '469064' },
	{ city: 'Pass (Laois)', zip: '666110' },
	{ city: 'Pass (Offaly)', zip: '352535' },
	{ city: 'Passage East (Waterford)', zip: '215343' },
	{ city: 'Passage West (Cork)', zip: '314609' },
	{ city: 'Passage West (Waterford)', zip: '806086' },
	{ city: 'Passifyoucan (Dublin)', zip: '816124' },
	{ city: 'Passlands (Kildare)', zip: '766560' },
	{ city: 'Pass Of Kilbride (Westmeath)', zip: '196918' },
	{ city: 'Patch (Galway)', zip: '716922' },
	{ city: 'Patch (Kerry)', zip: '612549' },
	{ city: 'Patch (Sligo)', zip: '635184' },
	{ city: 'Patches (Galway)', zip: '479175' },
	{ city: 'Patrickstown (Meath)', zip: '452141' },
	{ city: 'Patrickswell (Carlow)', zip: '548468' },
	{ city: 'Patrickswell (Limerick)', zip: '377484' },
	{ city: 'Patrickswell (Tipperary)', zip: '799548' },
	{ city: 'Pattenspark (Mayo)', zip: '746275' },
	{ city: 'Paudeenourstown (Kildare)', zip: '327852' },
	{ city: 'Paughanstown (Louth)', zip: '717592' },
	{ city: 'Paulbeg (Wicklow)', zip: '676255' },
	{ city: 'Paulsacres (Waterford)', zip: '629583' },
	{ city: 'Paulstown (Kilkenny)', zip: '934442' },
	{ city: 'Pawlerth (Kilkenny)', zip: '820938' },
	{ city: 'Peacockstown (Meath)', zip: '831014' },
	{ city: 'Peafield (Cork)', zip: '231064' },
	{ city: 'Peafield (Laois)', zip: '841169' },
	{ city: 'Peafield (Limerick)', zip: '219440' },
	{ city: 'Peahill (Tipperary)', zip: '314632' },
	{ city: 'Peak (Galway)', zip: '384967' },
	{ city: 'Peak (Roscommon)', zip: '159831' },
	{ city: 'Peake (Cork)', zip: '440564' },
	{ city: 'Peake (Tipperary)', zip: '380732' },
	{ city: 'Peakroe (Galway)', zip: '790201' },
	{ city: 'Peamount (Dublin)', zip: '805811' },
	{ city: 'Pearsonsbrook (Westmeath)', zip: '182476' },
	{ city: 'Peast (Monaghan)', zip: '521639' },
	{ city: 'Peenoge (Mayo)', zip: '966198' },
	{ city: 'Pegsborough (Tipperary)', zip: '791929' },
	{ city: 'Pelletstown (Dublin)', zip: '440136' },
	{ city: 'Pelletstown (Meath)', zip: '477004' },
	{ city: 'Pellick (Cork)', zip: '844448' },
	{ city: 'Pembroke (Cork)', zip: '680163' },
	{ city: 'Pembrokestown (Waterford)', zip: '158817' },
	{ city: 'Pembrokestown (Wexford)', zip: '926224' },
	{ city: 'Penane (Tipperary)', zip: '953079' },
	{ city: 'Pennefatherslot (Kilkenny)', zip: '636588' },
	{ city: 'Pennefatherswood (Tipperary)', zip: '175147' },
	{ city: 'Peppardscastle (Wexford)', zip: '894496' },
	{ city: 'Peppardstown (Tipperary)', zip: '619526' },
	{ city: 'Pepperhill (Cork)', zip: '984492' },
	{ city: 'Pepperstown (Louth)', zip: '629551' },
	{ city: 'Pepperstown (Meath)', zip: '520248' },
	{ city: 'Perrymount (Wexford)', zip: '726241' },
	{ city: 'Perrystown (Dublin)', zip: '608992' },
	{ city: 'Perssepark (Galway)', zip: '600255' },
	{ city: "Persse's-Lot (Tipperary)", zip: '808372' },
	{ city: 'Peru (Meath)', zip: '256498' },
	{ city: 'Peterstown (Meath)', zip: '892101' },
	{ city: 'Peterswell (Galway)', zip: '673943' },
	{ city: 'Petestown (Louth)', zip: '659361' },
	{ city: 'Petitstown (Wexford)', zip: '578370' },
	{ city: 'Petitswood (Westmeath)', zip: '903968' },
	{ city: 'Pettigoe (Donegal)', zip: '335703' },
	{ city: 'Phaleesh (Sligo)', zip: '552969' },
	{ city: 'Phale Lower (Cork)', zip: '129011' },
	{ city: 'Phale Upper (Cork)', zip: '481637' },
	{ city: 'Pheasanthill (Mayo)', zip: '210506' },
	{ city: 'Phepotstown (Meath)', zip: '909033' },
	{ city: 'Philibenstown (Louth)', zip: '180503' },
	{ city: 'Philippintown (Wexford)', zip: '101921' },
	{ city: 'Philipston (Tipperary)', zip: '807508' },
	{ city: 'Philipstown (Kildare)', zip: '310284' },
	{ city: 'Philipstown (Louth)', zip: '322140' },
	{ city: 'Philipstown (Meath)', zip: '473978' },
	{ city: 'Phillinstown (Meath)', zip: '689487' },
	{ city: 'Phillipstown (Carlow)', zip: '346827' },
	{ city: 'Phillistown (Meath)', zip: '743476' },
	{ city: 'Philpotstown (Meath)', zip: '744640' },
	{ city: 'Phoenixtown (Meath)', zip: '443417' },
	{ city: 'Phrompstown (Dublin)', zip: '239875' },
	{ city: 'Physicianstown (Kilkenny)', zip: '438963' },
	{ city: 'Pickardstown (Dublin)', zip: '626072' },
	{ city: 'Pickardstown (Waterford)', zip: '164092' },
	{ city: 'Picketstown (Kilkenny)', zip: '154874' },
	{ city: 'Piedmont (Louth)', zip: '127424' },
	{ city: 'Piercefield (Westmeath)', zip: '962982' },
	{ city: 'Piercetown (Cork)', zip: '553987' },
	{ city: 'Piercetown (Dublin)', zip: '302874' },
	{ city: 'Piercetown (Kildare)', zip: '189573' },
	{ city: 'Piercetown (Meath)', zip: '133234' },
	{ city: 'Piercetown (Tipperary)', zip: '657365' },
	{ city: 'Piercetown (Westmeath)', zip: '858625' },
	{ city: 'Piercetown (Wexford)', zip: '765767' },
	{ city: 'Pigeonhill (Cork)', zip: '523815' },
	{ city: 'Pigeonhouse (Offaly)', zip: '354963' },
	{ city: 'Pigeonpark (Kilkenny)', zip: '307095' },
	{ city: 'Pigeon Park (Tipperary)', zip: '864510' },
	{ city: 'Pigeon Rock (Mayo)', zip: '181119' },
	{ city: 'Pigeonstown (Offaly)', zip: '524601' },
	{ city: 'Pighill (Meath)', zip: '508897' },
	{ city: 'Pig Island (Mayo)', zip: '936383' },
	{ city: 'Pigotstown (Meath)', zip: '463579' },
	{ city: 'Pigotts (Wexford)', zip: '749628' },
	{ city: 'Pikesland (Cork)', zip: '335911' },
	{ city: 'Pilgrimhill (Kerry)', zip: '574596' },
	{ city: 'Pilgrimhill (Laois)', zip: '328714' },
	{ city: 'Pillmore (Cork)', zip: '938015' },
	{ city: 'Pillpark (Waterford)', zip: '432815' },
	{ city: 'Pilltown (Kilkenny)', zip: '152868' },
	{ city: 'Pilltown (Meath)', zip: '195764' },
	{ city: 'Pilltown (Waterford)', zip: '134276' },
	{ city: 'Pinnacle (Wicklow)', zip: '319688' },
	{ city: 'Pintown (Tipperary)', zip: '644563' },
	{ city: 'Pinure (Kerry)', zip: '144010' },
	{ city: 'Piperhill (Tipperary)', zip: '111713' },
	{ city: 'Pipersbog (Cork)', zip: '518762' },
	{ city: 'Pipershall (Kildare)', zip: '199786' },
	{ city: 'Piperstown (Dublin)', zip: '824459' },
	{ city: 'Piperstown (Louth)', zip: '726195' },
	{ city: 'Pishanagh (Westmeath)', zip: '625095' },
	{ city: 'Pitchfordstown (Kildare)', zip: '897932' },
	{ city: 'Plaster (Donegal)', zip: '814328' },
	{ city: 'Plaster (Louth)', zip: '597362' },
	{ city: 'Platin (Meath)', zip: '308905' },
	{ city: 'Plattinstown (Wexford)', zip: '107651' },
	{ city: 'Plaukarauka (Limerick)', zip: '230786' },
	{ city: 'Plea Isle (Donegal)', zip: '289071' },
	{ city: 'Pleberstown (Kilkenny)', zip: '965541' },
	{ city: 'Plezica (Wicklow)', zip: '413979' },
	{ city: 'Plodstown (Westmeath)', zip: '791473' },
	{ city: 'Ploopluck (Kildare)', zip: '391118' },
	{ city: 'Ploresk (Kerry)', zip: '228655' },
	{ city: 'Plot (Wexford)', zip: '956253' },
	{ city: 'Ploverhill (Tipperary)', zip: '685600' },
	{ city: 'Pluck (Donegal)', zip: '747743' },
	{ city: 'Pluckanes East (Cork)', zip: '264258' },
	{ city: 'Pluckanes North (Cork)', zip: '350190' },
	{ city: 'Pluckanes South (Cork)', zip: '392775' },
	{ city: 'Pluckanes West (Cork)', zip: '658670' },
	{ city: 'Pluckeen (Kerry)', zip: '280309' },
	{ city: 'Pluckerstown (Kildare)', zip: '259407' },
	{ city: 'Pluckhimin (Dublin)', zip: '281265' },
	{ city: 'Pluckhimin (Meath)', zip: '584065' },
	{ city: 'Pluckstown (Kildare)', zip: '465445' },
	{ city: 'Pluckstown (Meath)', zip: '786099' },
	{ city: 'Pludboher (Wexford)', zip: '441806' },
	{ city: 'Plughoge (Donegal)', zip: '225283' },
	{ city: 'Plughoge And Leabrannagh Mountain North (Donegal)', zip: '434216' },
	{ city: 'Plughoge And Leabrannagh Mountain South (Donegal)', zip: '197997' },
	{ city: 'Plunketsland (Louth)', zip: '763617' },
	{ city: 'Plunketstown Lower (Kildare)', zip: '266631' },
	{ city: 'Plunketstown Upper (Kildare)', zip: '477888' },
	{ city: 'Plush (Cavan)', zip: '685362' },
	{ city: 'Point (Donegal)', zip: '708011' },
	{ city: 'Point (Louth)', zip: '472030' },
	{ city: 'Point (Monaghan)', zip: '747088' },
	{ city: 'Polecastle (Meath)', zip: '648027' },
	{ city: 'Polehore (Wexford)', zip: '561517' },
	{ city: 'Poles (Cavan)', zip: '861881' },
	{ city: 'Pollabane (Cavan)', zip: '197969' },
	{ city: 'Pollacappul (Galway)', zip: '529405' },
	{ city: 'Pollacappul (Mayo)', zip: '738232' },
	{ city: 'Pollacorragune (Galway)', zip: '948639' },
	{ city: 'Pollacossaun Eighter (Galway)', zip: '939479' },
	{ city: 'Pollacossaun Oughter (Galway)', zip: '132408' },
	{ city: 'Pollacrossaun (Galway)', zip: '232242' },
	{ city: 'Pollacullaire (Galway)', zip: '222939' },
	{ city: 'Pollacurra (Galway)', zip: '329403' },
	{ city: 'Polladooey (Galway)', zip: '647703' },
	{ city: 'Polladooey (Longford)', zip: '543648' },
	{ city: 'Polladoohy (Mayo)', zip: '669087' },
	{ city: 'Pollafree (Cavan)', zip: '515551' },
	{ city: 'Pollagarraun (Mayo)', zip: '943870' },
	{ city: 'Pollagh (Clare)', zip: '173301' },
	{ city: 'Pollagh (Galway)', zip: '208146' },
	{ city: 'Pollagh (Kerry)', zip: '859870' },
	{ city: 'Pollagh (Kilkenny)', zip: '829169' },
	{ city: 'Pollagh (Longford)', zip: '669501' },
	{ city: 'Pollagh (Mayo)', zip: '692361' },
	{ city: 'Pollagh (Offaly)', zip: '421058' },
	{ city: 'Pollagh (Tipperary)', zip: '917961' },
	{ city: 'Pollaghadoo (Wicklow)', zip: '436117' },
	{ city: 'Pollaghaglass (Offaly)', zip: '252493' },
	{ city: 'Pollaghanumera (Clare)', zip: '614121' },
	{ city: 'Pollaghnagraigue (Offaly)', zip: '808997' },
	{ city: 'Pollaghoole (Offaly)', zip: '204932' },
	{ city: 'Pollaghrevagh (Galway)', zip: '251288' },
	{ city: 'Pollagooil (Galway)', zip: '709216' },
	{ city: 'Pollagoona Mountain (Clare)', zip: '808014' },
	{ city: 'Pollagorteen (Kildare)', zip: '108256' },
	{ city: 'Pollaguill (Donegal)', zip: '394292' },
	{ city: 'Pollahoney (Wicklow)', zip: '265698' },
	{ city: 'Pollakeel (Cavan)', zip: '117682' },
	{ city: 'Pollalaher (Roscommon)', zip: '648113' },
	{ city: 'Pollalena (Mayo)', zip: '283543' },
	{ city: 'Pollamalady (Cavan)', zip: '622021' },
	{ city: 'Pollamore Far (Cavan)', zip: '398524' },
	{ city: 'Pollamore Near (Cavan)', zip: '500754' },
	{ city: 'Pollanalty East (Roscommon)', zip: '210378' },
	{ city: 'Pollanalty West (Roscommon)', zip: '740734' },
	{ city: 'Pollanarroo (Roscommon)', zip: '654690' },
	{ city: 'Pollanaskan (Mayo)', zip: '228024' },
	{ city: 'Pollandoo (Donegal)', zip: '544614' },
	{ city: 'Pollanea Lower (Roscommon)', zip: '961887' },
	{ city: 'Pollanea Upper (Roscommon)', zip: '426196' },
	{ city: 'Pollaneyster (Galway)', zip: '411886' },
	{ city: 'Pollaniska (Mayo)', zip: '345286' },
	{ city: 'Pollanorman (Tipperary)', zip: '316413' },
	{ city: 'Pollanoughty (Mayo)', zip: '769703' },
	{ city: 'Pollans (Donegal)', zip: '596757' },
	{ city: 'Pollaphuca (Galway)', zip: '311643' },
	{ city: 'Pollaphuca (Roscommon)', zip: '125400' },
	{ city: 'Pollaphuca (Wicklow)', zip: '736790' },
	{ city: 'Pollarassa (Galway)', zip: '152525' },
	{ city: 'Pollardstown (Cork)', zip: '134991' },
	{ city: 'Pollardstown (Kildare)', zip: '719387' },
	{ city: 'Pollareagh (Cavan)', zip: '133662' },
	{ city: 'Pollataggle (Galway)', zip: '519178' },
	{ city: 'Pollatlugga (Galway)', zip: '282452' },
	{ city: 'Pollatrumpa (Clare)', zip: '748858' },
	{ city: 'Pollaturick (Galway)', zip: '728601' },
	{ city: 'Pollaturk (Galway)', zip: '860403' },
	{ city: 'Pollavaddy (Mayo)', zip: '938910' },
	{ city: 'Pollavullaun (Galway)', zip: '187092' },
	{ city: 'Pollawaddy (Mayo)', zip: '867435' },
	{ city: 'Pollawarla (Galway)', zip: '337273' },
	{ city: 'Pollawarla (Mayo)', zip: '738311' },
	{ city: 'Pollaweela (Mayo)', zip: '149242' },
	{ city: 'Pollbaun (Galway)', zip: '371934' },
	{ city: 'Pollbaun (Mayo)', zip: '204793' },
	{ city: 'Pollboy (Galway)', zip: '776500' },
	{ city: 'Pollboy (Leitrim)', zip: '394784' },
	{ city: 'Pollboy (Mayo)', zip: '996270' },
	{ city: 'Pollboy (Roscommon)', zip: '155334' },
	{ city: 'Pollbrean (Wexford)', zip: '509500' },
	{ city: 'Pollbrock (Louth)', zip: '343312' },
	{ city: 'Polldarragh (Galway)', zip: '327372' },
	{ city: 'Polldarrig (Wexford)', zip: '218596' },
	{ city: 'Polldonoghoe (Galway)', zip: '394362' },
	{ city: 'Polldoon (Wexford)', zip: '589039' },
	{ city: 'Polldorragha (Galway)', zip: '952022' },
	{ city: 'Polldrian (Mayo)', zip: '513616' },
	{ city: 'Pollduff (Offaly)', zip: '621087' },
	{ city: 'Polleagh North (Galway)', zip: '312435' },
	{ city: 'Polleagh South (Galway)', zip: '120525' },
	{ city: 'Polleban (Meath)', zip: '151766' },
	{ city: 'Polleens (Galway)', zip: '855851' },
	{ city: 'Polleeny (Galway)', zip: '742416' },
	{ city: 'Polleha (Galway)', zip: '208773' },
	{ city: 'Polleighter (Galway)', zip: '525709' },
	{ city: 'Pollerton Big (Carlow)', zip: '404919' },
	{ city: 'Pollerton Little (Carlow)', zip: '501284' },
	{ city: 'Pollet (Donegal)', zip: '178194' },
	{ city: 'Pollfeeneen (Galway)', zip: '746780' },
	{ city: 'Pollintemple (Cavan)', zip: '853992' },
	{ city: 'Pollkeen (Galway)', zip: '900517' },
	{ city: 'Pollmanagh Great (Wexford)', zip: '178290' },
	{ city: 'Pollmanagh Little (Wexford)', zip: '688840' },
	{ city: 'Pollnabanny (Galway)', zip: '827552' },
	{ city: 'Pollnabrone (Galway)', zip: '472851' },
	{ city: 'Pollnabunny (Mayo)', zip: '322040' },
	{ city: 'Pollnacartan (Mayo)', zip: '140766' },
	{ city: 'Pollnaclogha (Galway)', zip: '644465' },
	{ city: 'Pollnacroaghy (Mayo)', zip: '752395' },
	{ city: 'Pollnagappul (Leitrim)', zip: '539031' },
	{ city: 'Pollnagarragh East (Galway)', zip: '954377' },
	{ city: 'Pollnagarragh West (Galway)', zip: '588255' },
	{ city: 'Pollnagawna (Mayo)', zip: '363181' },
	{ city: 'Pollnagroagh (Galway)', zip: '510192' },
	{ city: 'Pollnahallia (Galway)', zip: '355086' },
	{ city: 'Pollnahincha (Galway)', zip: '181369' },
	{ city: 'Pollnamal (Galway)', zip: '942825' },
	{ city: 'Pollnamoghil (Roscommon)', zip: '872334' },
	{ city: 'Pollnaranny (Donegal)', zip: '703259' },
	{ city: 'Pollnashinnagh (Galway)', zip: '405742' },
	{ city: 'Pollnasillagh (Mayo)', zip: '460063' },
	{ city: 'Pollnaveagh (Galway)', zip: '908656' },
	{ city: 'Pollower (Roscommon)', zip: '263052' },
	{ city: 'Pollpeasty (Wexford)', zip: '957339' },
	{ city: 'Pollraddy (Mayo)', zip: '777210' },
	{ city: 'Pollrane (Wexford)', zip: '822468' },
	{ city: 'Pollrankin (Wexford)', zip: '308991' },
	{ city: 'Pollranny (Mayo)', zip: '861669' },
	{ city: 'Pollranny (Roscommon)', zip: '549212' },
	{ city: 'Pollregan (Wexford)', zip: '234500' },
	{ city: 'Pollremon (Galway)', zip: '209908' },
	{ city: 'Pollrevagh (Galway)', zip: '737119' },
	{ city: 'Pollroebuck (Galway)', zip: '109260' },
	{ city: 'Pollronahan Beg (Mayo)', zip: '299719' },
	{ city: 'Pollronahan More (Mayo)', zip: '529590' },
	{ city: 'Pollrone (Kilkenny)', zip: '851377' },
	{ city: 'Pollsallagh (Wexford)', zip: '507386' },
	{ city: 'Pollsharvoge (Mayo)', zip: '451205' },
	{ city: 'Pollshask (Galway)', zip: '381726' },
	{ city: 'Pollsillagh (Galway)', zip: '335280' },
	{ city: 'Polltalloon East (Galway)', zip: '632953' },
	{ city: 'Polltalloon West (Galway)', zip: '410415' },
	{ city: 'Pollwitch (Wexford)', zip: '365789' },
	{ city: 'Pollymount (Roscommon)', zip: '226138' },
	{ city: 'Pollynoon (Galway)', zip: '778392' },
	{ city: 'Pondfields (Wexford)', zip: '235295' },
	{ city: 'Pookeen (Cork)', zip: '336159' },
	{ city: 'Poormansbridge (Laois)', zip: '270304' },
	{ city: 'Popeshall (Dublin)', zip: '775861' },
	{ city: 'Poplar (Wexford)', zip: '913567' },
	{ city: 'Poppintree (Dublin)', zip: '778589' },
	{ city: 'Poppyhill (Galway)', zip: '538489' },
	{ city: 'Porchavodda (Carlow)', zip: '290656' },
	{ city: 'Porridgetown East (Galway)', zip: '341908' },
	{ city: 'Porridgetown West (Galway)', zip: '601637' },
	{ city: 'Porsoon (Clare)', zip: '756391' },
	{ city: 'Port (Cavan)', zip: '880944' },
	{ city: 'Port (Donegal)', zip: '314896' },
	{ city: 'Port (Leitrim)', zip: '382446' },
	{ city: 'Port (Limerick)', zip: '442624' },
	{ city: 'Port (Louth)', zip: '690816' },
	{ city: 'Portacarron (Galway)', zip: '508540' },
	{ city: 'Portacarron Beg (Galway)', zip: '271321' },
	{ city: 'Portacloghan (Cavan)', zip: '979568' },
	{ city: 'Portacloy (Mayo)', zip: '554519' },
	{ city: 'Portagh (Mayo)', zip: '314455' },
	{ city: 'Portaghard (Roscommon)', zip: '488537' },
	{ city: 'Portaghbradagh (Sligo)', zip: '992940' },
	{ city: 'Portaliff (Cavan)', zip: '757761' },
	{ city: 'Portaliff Glebe (Cavan)', zip: '843332' },
	{ city: 'Portally (Waterford)', zip: '814182' },
	{ city: 'Portan (Cavan)', zip: '317193' },
	{ city: 'Portan (Meath)', zip: '231330' },
	{ city: 'Portanab (Meath)', zip: '836944' },
	{ city: 'Portanclogh (Meath)', zip: '973002' },
	{ city: 'Portane (Limerick)', zip: '796454' },
	{ city: 'Portaneena (Westmeath)', zip: '960447' },
	{ city: 'Portaneoght (Leitrim)', zip: '275810' },
	{ city: 'Portanure (Cavan)', zip: '579238' },
	{ city: 'Portanure (Longford)', zip: '837152' },
	{ city: 'Portanure Bog (Longford)', zip: '580291' },
	{ city: 'Portarlington (Laois)', zip: '374496' },
	{ city: 'Portauns (Limerick)', zip: '652141' },
	{ city: 'Portavarrig (Cork)', zip: '139187' },
	{ city: 'Portavaud (Sligo)', zip: '608212' },
	{ city: 'Portboy (Limerick)', zip: '546345' },
	{ city: 'Portcreevy (Donegal)', zip: '514900' },
	{ city: 'Portcrusha (Limerick)', zip: '532908' },
	{ city: 'Portdarragh (Galway)', zip: '903818' },
	{ city: 'Portdrine (Clare)', zip: '920074' },
	{ city: 'Portduff (Cork)', zip: '148858' },
	{ city: 'Portduff (Kerry)', zip: '906674' },
	{ city: 'Porteen And Ballyrevagh (Roscommon)', zip: '693773' },
	{ city: 'Porteen And Ballyrevagh West (Roscommon)', zip: '888947' },
	{ city: 'Portersgate (Wexford)', zip: '527024' },
	{ city: 'Portersize (Kildare)', zip: '434805' },
	{ city: 'Portersland (Wexford)', zip: '421165' },
	{ city: 'Porterstown (Dublin)', zip: '472197' },
	{ city: 'Porterstown (Kildare)', zip: '844334' },
	{ city: 'Porterstown (Meath)', zip: '879863' },
	{ city: 'Porterstown (Westmeath)', zip: '758998' },
	{ city: 'Portgloriam (Kildare)', zip: '701040' },
	{ city: 'Porthall (Donegal)', zip: '274043' },
	{ city: 'Portinaghy (Monaghan)', zip: '767656' },
	{ city: 'Portinch (Sligo)', zip: '756328' },
	{ city: 'Portinure (Donegal)', zip: '433744' },
	{ city: 'Portjack (Westmeath)', zip: '379558' },
	{ city: 'Portland (Tipperary)', zip: '397937' },
	{ city: 'Portland Island (Tipperary)', zip: '704153' },
	{ city: 'Portland Little (Tipperary)', zip: '454035' },
	{ city: 'Portlaoise (Laois)', zip: '874007' },
	{ city: 'Portlaw (Waterford)', zip: '172699' },
	{ city: 'Portlawney (Cavan)', zip: '575000' },
	{ city: 'Portlecka (Clare)', zip: '551970' },
	{ city: 'Portleen (Donegal)', zip: '411425' },
	{ city: 'Portlester (Meath)', zip: '274470' },
	{ city: 'Portlick (Westmeath)', zip: '411907' },
	{ city: 'Portloman (Westmeath)', zip: '887941' },
	{ city: 'Portlongfield (Cavan)', zip: '717113' },
	{ city: 'Portlough (Donegal)', zip: '352220' },
	{ city: 'Portmagee (Kerry)', zip: '291579' },
	{ city: 'Portmanna (Meath)', zip: '603659' },
	{ city: 'Portmarnock (Dublin)', zip: '351438' },
	{ city: 'Portmellick (Dublin)', zip: '680088' },
	{ city: 'Portnablahy (Donegal)', zip: '369414' },
	{ city: 'Portnaboe (Waterford)', zip: '657113' },
	{ city: 'Portnacrinnaght (Roscommon)', zip: '671494' },
	{ city: 'Portnahinch (Laois)', zip: '944873' },
	{ city: 'Portnahinch (Roscommon)', zip: '597390' },
	{ city: 'Portnahully (Kilkenny)', zip: '539557' },
	{ city: 'Portnaquin (Cavan)', zip: '177833' },
	{ city: 'Portnard (Limerick)', zip: '106752' },
	{ city: 'Portnascully (Kilkenny)', zip: '159315' },
	{ city: 'Portnashangan (Westmeath)', zip: '789649' },
	{ city: 'Portnason (Donegal)', zip: '753217' },
	{ city: 'Portnick (Galway)', zip: '362355' },
	{ city: 'Portnoo (Donegal)', zip: '977346' },
	{ city: 'Portobello (Roscommon)', zip: '664101' },
	{ city: 'Portraine (Dublin)', zip: '973786' },
	{ city: 'Portraine Demesne (Dublin)', zip: '248855' },
	{ city: 'Portree (Laois)', zip: '596609' },
	{ city: 'Portroe (Tipperary)', zip: '143583' },
	{ city: 'Portroyal (Mayo)', zip: '901164' },
	{ city: 'Portruan (Cavan)', zip: '538438' },
	{ city: 'Portrunny (Roscommon)', zip: '726014' },
	{ city: 'Portrushen Lower (Carlow)', zip: '140596' },
	{ city: 'Portrushen Upper (Carlow)', zip: '680188' },
	{ city: 'Portsalon (Donegal)', zip: '581219' },
	{ city: 'Portumna (Galway)', zip: '784560' },
	{ city: 'Portumna Demesne (Galway)', zip: '217195' },
	{ city: 'Porturlan (Cavan)', zip: '322216' },
	{ city: 'Porturlin (Mayo)', zip: '194063' },
	{ city: 'Posey (Kilkenny)', zip: '878433' },
	{ city: 'Posseckstown (Kildare)', zip: '744254' },
	{ city: 'Posseckstown (Meath)', zip: '263624' },
	{ city: 'Potaley (Kerry)', zip: '634762' },
	{ city: 'Pottahee (Cavan)', zip: '461853' },
	{ city: 'Pottiaghan Commons (Westmeath)', zip: '637266' },
	{ city: 'Pottle (Cavan)', zip: '961558' },
	{ city: 'Pottlebane (Cavan)', zip: '941004' },
	{ city: 'Pottlebane (Meath)', zip: '100926' },
	{ city: 'Pottleboy (Cavan)', zip: '149498' },
	{ city: 'Pottlebrack (Cavan)', zip: '908445' },
	{ city: 'Pottleduff (Cavan)', zip: '826209' },
	{ city: 'Pottle East (Cavan)', zip: '791452' },
	{ city: 'Pottle Lower (Cavan)', zip: '800406' },
	{ city: 'Pottlerath (Kilkenny)', zip: '522132' },
	{ city: 'Pottlereagh (Cavan)', zip: '406516' },
	{ city: 'Pottlereagh (Meath)', zip: '505850' },
	{ city: 'Pottle Soden (Cavan)', zip: '124259' },
	{ city: 'Pottle Upper (Cavan)', zip: '895075' },
	{ city: 'Pottle West (Cavan)', zip: '236004' },
	{ city: 'Pottore (Leitrim)', zip: '652845' },
	{ city: 'Poulacapple (Clare)', zip: '813438' },
	{ city: 'Poulacapple East (Tipperary)', zip: '760415' },
	{ city: 'Poulacapple West (Tipperary)', zip: '528917' },
	{ city: 'Poulacarran (Clare)', zip: '642654' },
	{ city: 'Poulaculleare (Tipperary)', zip: '478192' },
	{ city: 'Poulacurry North (Cork)', zip: '608134' },
	{ city: 'Poulacurry South (Cork)', zip: '660077' },
	{ city: 'Pouladown (Cork)', zip: '530492' },
	{ city: 'Poulaforia (Clare)', zip: '139659' },
	{ city: 'Poulagower (Clare)', zip: '859975' },
	{ city: 'Poulagower (Kerry)', zip: '193757' },
	{ city: 'Poulakerry (Tipperary)', zip: '958442' },
	{ city: 'Poulanargid (Cork)', zip: '891354' },
	{ city: 'Poulanassy (Kilkenny)', zip: '648427' },
	{ city: 'Poulanine (Clare)', zip: '108429' },
	{ city: 'Poulaniska (Cork)', zip: '368436' },
	{ city: 'Poulaphuca (Clare)', zip: '356146' },
	{ city: 'Poularick (Cork)', zip: '751129' },
	{ city: 'Poulataggle (Clare)', zip: '887449' },
	{ city: 'Poulatar (Tipperary)', zip: '739676' },
	{ city: 'Poulavala (Tipperary)', zip: '915231' },
	{ city: 'Poulavare (Cork)', zip: '658998' },
	{ city: 'Poulavone (Waterford)', zip: '677092' },
	{ city: 'Poulawack (Clare)', zip: '813127' },
	{ city: 'Poulawaddra (Kerry)', zip: '187407' },
	{ city: 'Poulawillin (Clare)', zip: '784201' },
	{ city: 'Poulbaun (Clare)', zip: '635701' },
	{ city: 'Poulbautia (Waterford)', zip: '551063' },
	{ city: 'Poulboy (Kilkenny)', zip: '706525' },
	{ city: 'Poulboy (Waterford)', zip: '537865' },
	{ city: 'Poulcaragharush (Clare)', zip: '592558' },
	{ city: 'Pouldine (Tipperary)', zip: '450157' },
	{ city: 'Pouleenacoona (Clare)', zip: '959988' },
	{ city: 'Poulfadda (Waterford)', zip: '105611' },
	{ city: 'Poulgorm (Clare)', zip: '412390' },
	{ city: 'Poulgour (Kilkenny)', zip: '414293' },
	{ city: 'Pouliskaboy (Clare)', zip: '541938' },
	{ city: 'Poulleagh (Cork)', zip: '382956' },
	{ city: 'Poulmacrih (Clare)', zip: '763321' },
	{ city: 'Poulmaleen (Tipperary)', zip: '821129' },
	{ city: 'Poulmaloe (Wexford)', zip: '319547' },
	{ city: 'Poulmarl (Wexford)', zip: '843798' },
	{ city: 'Poulnabrone (Clare)', zip: '153771' },
	{ city: 'Poulnabrucky (Clare)', zip: '617653' },
	{ city: 'Poulnacallee (Cork)', zip: '621350' },
	{ city: 'Poulnadarree (Clare)', zip: '290875' },
	{ city: 'Poulnagun (Clare)', zip: '149172' },
	{ city: 'Poulnagunoge (Waterford)', zip: '794499' },
	{ city: 'Poulnahaha (Kerry)', zip: '637334' },
	{ city: 'Poulnalour (Clare)', zip: '149816' },
	{ city: 'Poulnamuck (Kerry)', zip: '898771' },
	{ city: 'Poulnareagha (Cork)', zip: '296457' },
	{ city: 'Poulnaskagh (Clare)', zip: '671585' },
	{ city: 'Poulpeasty (Wexford)', zip: '830269' },
	{ city: 'Poulroe (Clare)', zip: '581652' },
	{ city: 'Poultalloon (Limerick)', zip: '873691' },
	{ city: 'Pound (Kerry)', zip: '335591' },
	{ city: 'Poundcartron (Galway)', zip: '694068' },
	{ city: 'Poundfields (Cork)', zip: '658420' },
	{ city: 'Poundhill (Leitrim)', zip: '148098' },
	{ city: 'Poundlick (Cork)', zip: '706605' },
	{ city: 'Poundquarter (Cork)', zip: '915981' },
	{ city: 'Powderlough (Meath)', zip: '741825' },
	{ city: 'Powellsborough (Sligo)', zip: '901609' },
	{ city: 'Powellshill (Roscommon)', zip: '661093' },
	{ city: 'Powelstown (Laois)', zip: '878877' },
	{ city: 'Powerfield (Limerick)', zip: '902372' },
	{ city: 'Powerscourt Demesne (Wicklow)', zip: '802295' },
	{ city: 'Powerscourt Mountain (Wicklow)', zip: '706026' },
	{ city: 'Powerscourt Paddock (Wicklow)', zip: '448670' },
	{ city: 'Powersknock (Waterford)', zip: '336487' },
	{ city: 'Powerstown (Carlow)', zip: '602700' },
	{ city: 'Powerstown (Cork)', zip: '580242' },
	{ city: 'Powerstown (Dublin)', zip: '424333' },
	{ city: 'Powerstown (Tipperary)', zip: '568318' },
	{ city: 'Powerstown Demesne (Tipperary)', zip: '847326' },
	{ city: 'Powerstown East (Kilkenny)', zip: '509069' },
	{ city: 'Powerstown West (Kilkenny)', zip: '754381' },
	{ city: 'Powerswood (Kilkenny)', zip: '317227' },
	{ city: 'Poyntstown (Tipperary)', zip: '126725' },
	{ city: 'Prabagh (Leitrim)', zip: '402348' },
	{ city: 'Prablin (Donegal)', zip: '919151' },
	{ city: 'Prap (Cork)', zip: '842311' },
	{ city: 'Prap (Waterford)', zip: '455945' },
	{ city: 'Preban (Wicklow)', zip: '959012' },
	{ city: 'Prebaun (Mayo)', zip: '175372' },
	{ city: 'Prebaun (Westmeath)', zip: '138610' },
	{ city: 'Preghane (Cork)', zip: '845896' },
	{ city: 'Pribbaun (Galway)', zip: '480075' },
	{ city: "Price's-Lot (Tipperary)", zip: '662014' },
	{ city: 'Priesthaggard (Wexford)', zip: '848258' },
	{ city: 'Priesthouse (Dublin)', zip: '327410' },
	{ city: 'Priestsnewtown (Wicklow)', zip: '610464' },
	{ city: 'Prieststown (Donegal)', zip: '677159' },
	{ city: 'Priestsvalley (Kilkenny)', zip: '997028' },
	{ city: 'Priesttown (Tipperary)', zip: '425508' },
	{ city: 'Priesttown (Westmeath)', zip: '729716' },
	{ city: 'Priest Town (Louth)', zip: '982752' },
	{ city: 'Priest Town (Meath)', zip: '637714' },
	{ city: 'Priest-Town (Dublin)', zip: '550004' },
	{ city: 'Priest-Town (Tipperary)', zip: '142710' },
	{ city: 'Priesttown Demesne (Tipperary)', zip: '163768' },
	{ city: 'Primatepark (Louth)', zip: '493205' },
	{ city: 'Primatestown (Meath)', zip: '413850' },
	{ city: 'Primestown (Wexford)', zip: '246390' },
	{ city: 'Primrosegrange (Sligo)', zip: '477260' },
	{ city: 'Princetown (Meath)', zip: '174741' },
	{ city: 'Printinstown (Westmeath)', zip: '656289' },
	{ city: 'Priorland (Dublin)', zip: '637857' },
	{ city: 'Priorland (Louth)', zip: '556390' },
	{ city: 'Priorpark (Tipperary)', zip: '780188' },
	{ city: 'Priorstate (Louth)', zip: '643928' },
	{ city: 'Priorstown (Louth)', zip: '741344' },
	{ city: 'Priorstown (Tipperary)', zip: '153067' },
	{ city: 'Priory Demesne (Tipperary)', zip: '945172' },
	{ city: 'Prioryland (Meath)', zip: '815774' },
	{ city: 'Prison East (Mayo)', zip: '467090' },
	{ city: 'Prison North (Mayo)', zip: '118430' },
	{ city: 'Prison South (Mayo)', zip: '615561' },
	{ city: 'Procklis (Donegal)', zip: '593598' },
	{ city: 'Prohoness (Cork)', zip: '634667' },
	{ city: 'Prohus (Cork)', zip: '375116' },
	{ city: 'Prohust (Cork)', zip: '708463' },
	{ city: 'Proleek (Louth)', zip: '700040' },
	{ city: 'Proleek Acres (Louth)', zip: '963771' },
	{ city: 'Prologue (Kilkenny)', zip: '487648' },
	{ city: 'Proonts (Limerick)', zip: '786900' },
	{ city: 'Propoge (Cork)', zip: '792336' },
	{ city: 'Propoge (Waterford)', zip: '122834' },
	{ city: 'Prospect (Cavan)', zip: '871724' },
	{ city: 'Prospect (Clare)', zip: '890285' },
	{ city: 'Prospect (Galway)', zip: '658589' },
	{ city: 'Prospect (Kildare)', zip: '183577' },
	{ city: 'Prospect (Limerick)', zip: '403431' },
	{ city: 'Prospect (Mayo)', zip: '742648' },
	{ city: 'Prospect (Tipperary)', zip: '848696' },
	{ city: 'Prospect (Wexford)', zip: '909016' },
	{ city: 'Prospect Demesne (Galway)', zip: '653998' },
	{ city: 'Prospect East (Tipperary)', zip: '791055' },
	{ city: 'Prospecthall (Waterford)', zip: '324465' },
	{ city: 'Prospecthill (Galway)', zip: '445534' },
	{ city: 'Prospect Lower (Wicklow)', zip: '979581' },
	{ city: 'Prospect Upper (Wicklow)', zip: '907862' },
	{ city: 'Prospect West (Tipperary)', zip: '277471' },
	{ city: 'Prosperous (Kildare)', zip: '544931' },
	{ city: 'Proudfootstown (Meath)', zip: '906240' },
	{ city: 'Proudstown (Meath)', zip: '470613' },
	{ city: 'Prucklish (Longford)', zip: '261924' },
	{ city: 'Prucklishtown (Longford)', zip: '655583' },
	{ city: 'Prughlish (Leitrim)', zip: '601981' },
	{ city: 'Prughlish (Mayo)', zip: '700046' },
	{ city: 'Prumpelstown Lower (Kildare)', zip: '742750' },
	{ city: 'Prumpelstown Upper (Kildare)', zip: '570208' },
	{ city: 'Pruntus (Cork)', zip: '332868' },
	{ city: 'Prusselstown (Kildare)', zip: '105022' },
	{ city: 'Pubblehill (Tipperary)', zip: '879274' },
	{ city: 'Pubblestown (Meath)', zip: '801582' },
	{ city: 'Puckane (Cork)', zip: '830904' },
	{ city: 'Puckane (Limerick)', zip: '569385' },
	{ city: 'Puckaun (Tipperary)', zip: '885521' },
	{ city: 'Puckisland (Kerry)', zip: '563395' },
	{ city: 'Puck Island (Galway)', zip: '611380' },
	{ city: 'Puckstown (Louth)', zip: '686729' },
	{ city: 'Puddingfield (Tipperary)', zip: '215279' },
	{ city: 'Puffin Island (Kerry)', zip: '150661' },
	{ city: 'Pulla (Waterford)', zip: '657952' },
	{ city: 'Pullagh (Clare)', zip: '879009' },
	{ city: 'Pullagh (Kildare)', zip: '677135' },
	{ city: 'Pullagh (Limerick)', zip: '356720' },
	{ city: 'Pullagh (Sligo)', zip: '142214' },
	{ city: 'Pullans (Monaghan)', zip: '489485' },
	{ city: 'Pulleen (Cork)', zip: '560035' },
	{ city: 'Pulleen (Kerry)', zip: '457053' },
	{ city: 'Pullingtown (Wexford)', zip: '382994' },
	{ city: 'Pullinstown Big (Wexford)', zip: '205416' },
	{ city: 'Pullinstown Little (Wexford)', zip: '120851' },
	{ city: 'Pullis (Monaghan)', zip: '109757' },
	{ city: 'Punchbowl (Clare)', zip: '202670' },
	{ city: 'Punchersgrange (Kildare)', zip: '532913' },
	{ city: 'Punchestown (Kildare)', zip: '735018' },
	{ city: 'Punchestown Great (Kildare)', zip: '508806' },
	{ city: 'Punchestown Little (Kildare)', zip: '263772' },
	{ city: 'Punchestown Lower (Kildare)', zip: '180677' },
	{ city: 'Punchestown Upper (Kildare)', zip: '864303' },
	{ city: 'Puntabeg (Mayo)', zip: '940733' },
	{ city: 'Purcellsgarden (Kilkenny)', zip: '861161' },
	{ city: 'Purcellsinch (Kilkenny)', zip: '314457' },
	{ city: 'Purcellstown (Louth)', zip: '701274' },
	{ city: 'Purrauns (Mayo)', zip: '284526' },
	{ city: 'Pust North (Limerick)', zip: '306364' },
	{ city: 'Pust South (Limerick)', zip: '657283' },
	{ city: 'Putiaghan Lower (Cavan)', zip: '521597' },
	{ city: 'Putiaghan Upper (Cavan)', zip: '188674' },
	{ city: 'Puttaghan (Offaly)', zip: '371736' },
	{ city: 'Quakerstown (Clare)', zip: '238526' },
	{ city: 'Quakerstown (Tipperary)', zip: '761978' },
	{ city: 'Quanstown (Wexford)', zip: '363297' },
	{ city: 'Quarry (Dublin)', zip: '254550' },
	{ city: 'Quarry (Kildare)', zip: '734578' },
	{ city: 'Quarry (Westmeath)', zip: '388432' },
	{ city: 'Quarry (Wexford)', zip: '267189' },
	{ city: 'Quarryfield (Sligo)', zip: '768237' },
	{ city: 'Quarryhill (Galway)', zip: '749882' },
	{ city: 'Quarryland (Kilkenny)', zip: '260163' },
	{ city: 'Quarryland (Meath)', zip: '648821' },
	{ city: 'Quarrymount (Galway)', zip: '824344' },
	{ city: 'Quarrymount (Laois)', zip: '913360' },
	{ city: 'Quarryvale (Dublin)', zip: '421633' },
	{ city: 'Quarter (Galway)', zip: '407266' },
	{ city: 'Quarter (Waterford)', zip: '446806' },
	{ city: 'Quartercross (Tipperary)', zip: '315962' },
	{ city: 'Quartertown Lower (Cork)', zip: '345140' },
	{ city: 'Quartertown Upper (Cork)', zip: '672310' },
	{ city: 'Quay (Dublin)', zip: '420543' },
	{ city: 'Quaybaun (Galway)', zip: '477613' },
	{ city: 'Quaybaun (Kerry)', zip: '270023' },
	{ city: 'Queensacres (Galway)', zip: '413352' },
	{ city: 'Queensfort (Galway)', zip: '571076' },
	{ city: 'Queensland (Longford)', zip: '859644' },
	{ city: 'Querrin (Clare)', zip: '736897' },
	{ city: 'Quigabar (Sligo)', zip: '898358' },
	{ city: 'Quigaboy (Sligo)', zip: '741268' },
	{ city: 'Quigelagh (Meath)', zip: '771023' },
	{ city: 'Quigginroe (Wicklow)', zip: '897189' },
	{ city: "Quigley's Point (Donegal)", zip: '374633' },
	{ city: 'Quiglough (Monaghan)', zip: '212074' },
	{ city: 'Quignalecka (Mayo)', zip: '732405' },
	{ city: 'Quignalegan (Mayo)', zip: '586772' },
	{ city: 'Quignamanger (Mayo)', zip: '312031' },
	{ city: 'Quignashee (Mayo)', zip: '449634' },
	{ city: 'Quillia (Waterford)', zip: '567481' },
	{ city: 'Quiltinan (Roscommon)', zip: '213018' },
	{ city: 'Quilty (Clare)', zip: '662610' },
	{ city: 'Quilty East (Clare)', zip: '670057' },
	{ city: 'Quilty West (Clare)', zip: '986303' },
	{ city: 'Quin (Clare)', zip: '644003' },
	{ city: 'Quinagh (Carlow)', zip: '488936' },
	{ city: 'Quinaltagh (Galway)', zip: '315576' },
	{ city: 'Quingardens (Clare)', zip: '345831' },
	{ city: 'Quinsborough (Kildare)', zip: '958757' },
	{ city: 'Quinspool North (Clare)', zip: '245610' },
	{ city: 'Quinspool South (Clare)', zip: '311929' },
	{ city: 'Quinville North (Clare)', zip: '902714' },
	{ city: 'Quinville South (Clare)', zip: '933116' },
	{ city: 'Quitchery Great (Wexford)', zip: '207476' },
	{ city: 'Quitchery Little (Wexford)', zip: '739821' },
	{ city: 'Quitrentmountain (Cork)', zip: '464678' },
	{ city: 'Quivvy (Cavan)', zip: '265527' },
	{ city: 'Rabane (Cavan)', zip: '203116' },
	{ city: 'Rabaun (Mayo)', zip: '828859' },
	{ city: 'Rabbitburrow (Offaly)', zip: '445668' },
	{ city: 'Rabbitburrow (Roscommon)', zip: '382617' },
	{ city: 'Rabbit Island (Galway)', zip: '947417' },
	{ city: 'Rabbit Island (Mayo)', zip: '944787' },
	{ city: 'Rabbit Island North (Galway)', zip: '766296' },
	{ city: 'Rabbitpark (Galway)', zip: '656901' },
	{ city: 'Rabbitpark (Longford)', zip: '561860' },
	{ city: 'Rabows (Monaghan)', zip: '667735' },
	{ city: 'Rabrackan (Cavan)', zip: '788726' },
	{ city: 'Rabradagh (Roscommon)', zip: '736471' },
	{ city: 'Racaulfield (Monaghan)', zip: '609873' },
	{ city: 'Race (Limerick)', zip: '144205' },
	{ city: 'Racebeg (Limerick)', zip: '650002' },
	{ city: 'Racecourse (Galway)', zip: '566256' },
	{ city: 'Racecourse (Tipperary)', zip: '916348' },
	{ city: 'Racecourse (Waterford)', zip: '973351' },
	{ city: 'Racecourse (Wexford)', zip: '611686' },
	{ city: 'Racecourse Common (Dublin)', zip: '376058' },
	{ city: 'Racecourse Demesne (Tipperary)', zip: '162171' },
	{ city: 'Race End (Donegal)', zip: '985575' },
	{ city: 'Racefield (Kildare)', zip: '750018' },
	{ city: 'Racepark (Galway)', zip: '109842' },
	{ city: 'Rackans (Roscommon)', zip: '810039' },
	{ city: 'Rackavra (Westmeath)', zip: '498400' },
	{ city: 'Rackenstown (Meath)', zip: '214025' },
	{ city: 'Rackethall (Tipperary)', zip: '381488' },
	{ city: 'Rackwallace (Monaghan)', zip: '326972' },
	{ city: 'Raclaghy (Cavan)', zip: '432191' },
	{ city: 'Racomane East (Kerry)', zip: '983849' },
	{ city: 'Racomane West (Kerry)', zip: '906360' },
	{ city: 'Raconnell (Monaghan)', zip: '498127' },
	{ city: 'Racoona (Galway)', zip: '808868' },
	{ city: 'Racorcraun (Clare)', zip: '762285' },
	{ city: 'Racraveen (Cavan)', zip: '359657' },
	{ city: 'Racullen (Leitrim)', zip: '980970' },
	{ city: 'Radeerpark (Monaghan)', zip: '167169' },
	{ city: 'Radeery (Monaghan)', zip: '126207' },
	{ city: 'Radestown North (Kilkenny)', zip: '260619' },
	{ city: 'Radestown South (Kilkenny)', zip: '347171' },
	{ city: 'Radrinagh (Kerry)', zip: '291374' },
	{ city: 'Radrum (Monaghan)', zip: '770485' },
	{ city: 'Radrumskean (Monaghan)', zip: '174299' },
	{ city: 'Radullaan (Galway)', zip: '214749' },
	{ city: 'Rafarn (Galway)', zip: '227614' },
	{ city: 'Rafeehan (Meath)', zip: '450202' },
	{ city: 'Rafeenan (Monaghan)', zip: '116095' },
	{ city: 'Raferagh (Monaghan)', zip: '644133' },
	{ city: 'Raferigeen (Cork)', zip: '295775' },
	{ city: 'Raffeen (Cork)', zip: '906837' },
	{ city: 'Raffin (Meath)', zip: '409510' },
	{ city: 'Raffony (Cavan)', zip: '813801' },
	{ city: 'Rafian (Cavan)', zip: '778904' },
	{ city: 'Raflacony (Monaghan)', zip: '635381' },
	{ city: 'Rafline (Clare)', zip: '539990' },
	{ city: 'Rafoarty (Donegal)', zip: '777433' },
	{ city: 'Raford (Galway)', zip: '194195' },
	{ city: 'Raforker (Donegal)', zip: '766436' },
	{ city: 'Rafwee (Galway)', zip: '203185' },
	{ city: 'Ragamus (Limerick)', zip: '411390' },
	{ city: 'Ragaskin (Cavan)', zip: '182252' },
	{ city: 'Raggetsland (Kilkenny)', zip: '529480' },
	{ city: 'Raggettstown (Laois)', zip: '328160' },
	{ city: 'Raghly (Sligo)', zip: '476452' },
	{ city: 'Raghra (Offaly)', zip: '451323' },
	{ city: 'Raghrabeg (Roscommon)', zip: '939407' },
	{ city: 'Raha (Galway)', zip: '962479' },
	{ city: 'Rahaberna (Sligo)', zip: '907279' },
	{ city: 'Rahadorrish (Westmeath)', zip: '929738' },
	{ city: 'Rahaghan (Cavan)', zip: '998044' },
	{ city: 'Rahaghy (Meath)', zip: '461156' },
	{ city: 'Rahale (Wexford)', zip: '607702' },
	{ city: 'Rahalisk (Cork)', zip: '628245' },
	{ city: 'Rahally (Galway)', zip: '650069' },
	{ city: 'Rahaly (Galway)', zip: '384796' },
	{ city: 'Rahan (Cork)', zip: '191195' },
	{ city: 'Rahan (Offaly)', zip: '395743' },
	{ city: 'Rahanagh (Limerick)', zip: '464025' },
	{ city: 'Rahanane (Kerry)', zip: '953168' },
	{ city: 'Rahanavannagh (Laois)', zip: '933640' },
	{ city: 'Rahan Demesne (Offaly)', zip: '905458' },
	{ city: 'Rahandrick Lower (Laois)', zip: '998801' },
	{ city: 'Rahandrick Upper (Laois)', zip: '865375' },
	{ city: 'Rahaneena (Galway)', zip: '579223' },
	{ city: 'Rahan Far (Donegal)', zip: '400257' },
	{ city: 'Rahanine (Westmeath)', zip: '602380' },
	{ city: 'Rahaniska (Clare)', zip: '353667' },
	{ city: 'Rahaniskey (Tipperary)', zip: '460676' },
	{ city: 'Rahanisky (Cork)', zip: '461215' },
	{ city: 'Rahanlacky (Donegal)', zip: '687871' },
	{ city: 'Rahanna (Louth)', zip: '579210' },
	{ city: 'Rahan Near (Donegal)', zip: '654586' },
	{ city: 'Rahans (Mayo)', zip: '775833' },
	{ city: 'Rahans (Monaghan)', zip: '772798' },
	{ city: 'Rahara (Roscommon)', zip: '434893' },
	{ city: 'Rahard (Galway)', zip: '622873' },
	{ city: 'Rahard (Kilkenny)', zip: '602554' },
	{ city: 'Rahard (Limerick)', zip: '905707' },
	{ city: 'Rahard (Mayo)', zip: '950216' },
	{ city: 'Rahard (Meath)', zip: '940456' },
	{ city: 'Rahard (Wexford)', zip: '947351' },
	{ city: 'Rahardagh (Roscommon)', zip: '970839' },
	{ city: 'Rahard East (Kilkenny)', zip: '336384' },
	{ city: 'Rahardrum (Cavan)', zip: '418072' },
	{ city: 'Rahard West (Kilkenny)', zip: '981693' },
	{ city: 'Raharney (Westmeath)', zip: '379803' },
	{ city: 'Raharney Little (Westmeath)', zip: '623810' },
	{ city: 'Raharverty (Cavan)', zip: '581598' },
	{ city: 'Rahasane (Galway)', zip: '690204' },
	{ city: 'Rahaval (Wicklow)', zip: '680635' },
	{ city: 'Rahavanig (Kerry)', zip: '568820' },
	{ city: 'Rahealy (Kerry)', zip: '346413' },
	{ city: 'Raheelagh (Cavan)', zip: '309342' },
	{ city: 'Raheelan (Cavan)', zip: '186477' },
	{ city: 'Raheelin (Leitrim)', zip: '906494' },
	{ city: 'Raheely (Roscommon)', zip: '893619' },
	{ city: 'Raheen (Carlow)', zip: '701898' },
	{ city: 'Raheen (Clare)', zip: '561485' },
	{ city: 'Raheen (Cork)', zip: '781211' },
	{ city: 'Raheen (Donegal)', zip: '847975' },
	{ city: 'Raheen (Dublin)', zip: '970602' },
	{ city: 'Raheen (Galway)', zip: '589329' },
	{ city: 'Raheen (Kerry)', zip: '383801' },
	{ city: 'Raheen (Kildare)', zip: '988909' },
	{ city: 'Raheen (Kilkenny)', zip: '202920' },
	{ city: 'Raheen (Laois)', zip: '322827' },
	{ city: 'Raheen (Limerick)', zip: '365891' },
	{ city: 'Raheen (Offaly)', zip: '975258' },
	{ city: 'Raheen (Roscommon)', zip: '997953' },
	{ city: 'Raheen (Tipperary)', zip: '984041' },
	{ city: 'Raheen (Waterford)', zip: '188789' },
	{ city: 'Raheen (Westmeath)', zip: '695009' },
	{ city: 'Raheen (Wexford)', zip: '793032' },
	{ city: 'Raheen (Wicklow)', zip: '277559' },
	{ city: 'Raheenabbeyland (Mayo)', zip: '812783' },
	{ city: 'Raheenabrogue (Laois)', zip: '792710' },
	{ city: 'Raheenaclonagh (Wexford)', zip: '588257' },
	{ city: 'Raheenacrehy (Meath)', zip: '764871' },
	{ city: 'Raheenadaw (Carlow)', zip: '732589' },
	{ city: 'Raheenadeeragh (Kildare)', zip: '877022' },
	{ city: 'Raheenagh (Limerick)', zip: '343259' },
	{ city: 'Raheenagurren East (Wexford)', zip: '563367' },
	{ city: 'Raheenagurren West (Wexford)', zip: '799593' },
	{ city: 'Raheenahennedy (Wexford)', zip: '488844' },
	{ city: 'Raheenahoran (Laois)', zip: '147437' },
	{ city: 'Raheenakeeran (Offaly)', zip: '374046' },
	{ city: 'Raheenakit (Wicklow)', zip: '562748' },
	{ city: 'Raheenaniska (Laois)', zip: '449743' },
	{ city: 'Raheenanisky (Laois)', zip: '588972' },
	{ city: 'Raheenapisha (Kilkenny)', zip: '858822' },
	{ city: 'Raheenarostia (Wexford)', zip: '162644' },
	{ city: 'Raheenarran (Kilkenny)', zip: '918679' },
	{ city: 'Raheenavine (Wicklow)', zip: '692774' },
	{ city: 'Raheenballindoney (Tipperary)', zip: '770186' },
	{ city: 'Raheenbarnagh (Laois)', zip: '559851' },
	{ city: 'Raheen Barr (Mayo)', zip: '419735' },
	{ city: 'Raheenbeg (Offaly)', zip: '817163' },
	{ city: 'Raheen Beg (Cork)', zip: '943885' },
	{ city: 'Raheen Beg (Westmeath)', zip: '981513' },
	{ city: 'Raheen Beg (Wexford)', zip: '228862' },
	{ city: 'Raheendarragh (Carlow)', zip: '375450' },
	{ city: 'Raheendarrig (Wexford)', zip: '993283' },
	{ city: 'Raheen Demesne (Galway)', zip: '230359' },
	{ city: 'Raheendonore (Kilkenny)', zip: '619237' },
	{ city: 'Raheendoran (Carlow)', zip: '422917' },
	{ city: 'Raheenduff (Kilkenny)', zip: '440224' },
	{ city: 'Raheenduff (Laois)', zip: '132420' },
	{ city: 'Raheenduff (Leitrim)', zip: '202344' },
	{ city: 'Raheenduff (Mayo)', zip: '806207' },
	{ city: 'Raheenduff (Offaly)', zip: '965757' },
	{ city: 'Raheenduff (Wexford)', zip: '817633' },
	{ city: 'Raheenduff Big (Laois)', zip: '203219' },
	{ city: 'Raheenduff Little (Laois)', zip: '820533' },
	{ city: 'Raheen Eighter (Galway)', zip: '449264' },
	{ city: 'Raheenering (Cork)', zip: '729157' },
	{ city: 'Raheenglass (Offaly)', zip: '474277' },
	{ city: 'Raheenglass (Wicklow)', zip: '897645' },
	{ city: 'Raheengraney (Wicklow)', zip: '742407' },
	{ city: 'Raheen Kilkelly (Galway)', zip: '994535' },
	{ city: 'Raheenkillane (Carlow)', zip: '359748' },
	{ city: 'Raheenkyle (Carlow)', zip: '175369' },
	{ city: 'Raheenleagh (Laois)', zip: '676149' },
	{ city: 'Raheenleagh (Wicklow)', zip: '489604' },
	{ city: 'Raheenliegh (Carlow)', zip: '606262' },
	{ city: 'Raheen Lower (Laois)', zip: '827356' },
	{ city: 'Raheen Lower (Tipperary)', zip: '724649' },
	{ city: 'Raheenlusk (Wexford)', zip: '860706' },
	{ city: 'Raheenmeel (Offaly)', zip: '565225' },
	{ city: 'Raheenmoor (Wexford)', zip: '435270' },
	{ city: 'Raheen Moor (Wexford)', zip: '955558' },
	{ city: 'Raheenmore (Offaly)', zip: '190840' },
	{ city: 'Raheenmore (Wicklow)', zip: '520988' },
	{ city: 'Raheen More (Cork)', zip: '379691' },
	{ city: 'Raheen More (Westmeath)', zip: '364568' },
	{ city: 'Raheen More (Wexford)', zip: '927535' },
	{ city: 'Raheennagee (Wexford)', zip: '568802' },
	{ city: 'Raheennagun (Kilkenny)', zip: '657212' },
	{ city: 'Raheennahoon (Wexford)', zip: '442163' },
	{ city: 'Raheennahown (Laois)', zip: '673703' },
	{ city: 'Raheennahown North (Laois)', zip: '700132' },
	{ city: 'Raheennahown South (Laois)', zip: '418030' },
	{ city: 'Raheennamadra (Limerick)', zip: '366447' },
	{ city: 'Raheennaskeagh Lower (Wexford)', zip: '305919' },
	{ city: 'Raheennaskeagh Upper (Wexford)', zip: '742216' },
	{ city: 'Raheen Old (Kildare)', zip: '584611' },
	{ city: 'Raheen Oughter (Galway)', zip: '893551' },
	{ city: 'Raheenpark (Wexford)', zip: '980195' },
	{ city: 'Raheenphelan Glebe (Laois)', zip: '497226' },
	{ city: 'Raheenroche (Kilkenny)', zip: '264021' },
	{ city: 'Raheenroe (Cork)', zip: '187470' },
	{ city: 'Raheenroe (Limerick)', zip: '879471' },
	{ city: 'Raheenroe (Mayo)', zip: '903254' },
	{ city: 'Raheenroe (Tipperary)', zip: '122659' },
	{ city: 'Raheens (Cork)', zip: '639309' },
	{ city: 'Raheens (Kerry)', zip: '694165' },
	{ city: 'Raheens (Kildare)', zip: '984527' },
	{ city: 'Raheens (Mayo)', zip: '925271' },
	{ city: 'Raheens (Tipperary)', zip: '870070' },
	{ city: 'Raheens (Waterford)', zip: '611856' },
	{ city: 'Raheens East (Cork)', zip: '374401' },
	{ city: 'Raheensheara (Laois)', zip: '680080' },
	{ city: 'Raheenteige (Wicklow)', zip: '905537' },
	{ city: 'Raheen Upper (Laois)', zip: '472326' },
	{ city: 'Raheen Upper (Tipperary)', zip: '872375' },
	{ city: 'Raheenwood (Carlow)', zip: '425129' },
	{ city: 'Raheenyhooig (Kerry)', zip: '275368' },
	{ city: 'Raheevarren (Wexford)', zip: '146380' },
	{ city: 'Raheever (Cavan)', zip: '624563' },
	{ city: 'Raheg (Cavan)', zip: '859435' },
	{ city: 'Rahellistin (Cavan)', zip: '981015' },
	{ city: 'Rahelly (Sligo)', zip: '412452' },
	{ city: 'Rahelty (Kilkenny)', zip: '867488' },
	{ city: 'Rahelty (Tipperary)', zip: '954029' },
	{ city: 'Rahena Beg (Clare)', zip: '864228' },
	{ city: 'Rahena More (Clare)', zip: '687948' },
	{ city: 'Rahendrick (Meath)', zip: '816674' },
	{ city: 'Raheny (Dublin)', zip: '224928' },
	{ city: 'Raherd (Wicklow)', zip: '345442' },
	{ city: 'Raherneen (Galway)', zip: '940331' },
	{ city: 'Raherolus (Mayo)', zip: '700113' },
	{ city: 'Rahill (Carlow)', zip: '834671' },
	{ city: 'Rahill (Meath)', zip: '785867' },
	{ city: 'Rahilla Commons (Kildare)', zip: '890684' },
	{ city: 'Rahilla Glebe (Kildare)', zip: '869822' },
	{ city: 'Rahillakeen (Kilkenny)', zip: '450100' },
	{ city: 'Rahillion (Dublin)', zip: '213803' },
	{ city: 'Rahin (Kildare)', zip: '735369' },
	{ city: 'Rahin (Laois)', zip: '113293' },
	{ city: 'Rahina (Limerick)', zip: '394905' },
	{ city: 'Rahinaghmore (Tipperary)', zip: '614468' },
	{ city: 'Rahinane (Tipperary)', zip: '566500' },
	{ city: 'Rahinashane And Spittaltown (Westmeath)', zip: '228990' },
	{ city: 'Rahinashurock (Westmeath)', zip: '635915' },
	{ city: 'Rahinch (Tipperary)', zip: '553662' },
	{ city: 'Rahincuill (Westmeath)', zip: '832747' },
	{ city: 'Rahine (Cork)', zip: '597890' },
	{ city: 'Rahinmore (Westmeath)', zip: '337640' },
	{ city: 'Rahinnane (Kerry)', zip: '104610' },
	{ city: 'Rahinnane West (Kerry)', zip: '647062' },
	{ city: 'Rahins (Galway)', zip: '476044' },
	{ city: 'Rahinstown (Meath)', zip: '880883' },
	{ city: 'Rahogarty North (Galway)', zip: '758037' },
	{ city: 'Rahogarty South (Galway)', zip: '505135' },
	{ city: 'Raholland (Meath)', zip: '284037' },
	{ city: 'Rahona East (Clare)', zip: '496893' },
	{ city: 'Rahona West (Clare)', zip: '287783' },
	{ city: 'Rahone (Tipperary)', zip: '336466' },
	{ city: 'Rahoneen (Kerry)', zip: '746107' },
	{ city: 'Rahood (Meath)', zip: '769792' },
	{ city: 'Rahoonagh (Kerry)', zip: '288693' },
	{ city: 'Rahoonagh East (Cork)', zip: '380456' },
	{ city: 'Rahoonagh West (Cork)', zip: '190639' },
	{ city: 'Rahoonane (Kerry)', zip: '192823' },
	{ city: 'Rahoonbeak (Kildare)', zip: '353024' },
	{ city: 'Rahora (Kilkenny)', zip: '397097' },
	{ city: 'Rahoran (Cavan)', zip: '143207' },
	{ city: 'Rahugh (Westmeath)', zip: '187359' },
	{ city: 'Rahulk (Dublin)', zip: '585307' },
	{ city: 'Rahultan (Cavan)', zip: '387448' },
	{ city: 'Rahyconor (Galway)', zip: '735896' },
	{ city: 'Rahyvira (Tipperary)', zip: '808308' },
	{ city: 'Raigh (Galway)', zip: '584604' },
	{ city: 'Raigh (Mayo)', zip: '207018' },
	{ city: 'Railpark (Kildare)', zip: '314318' },
	{ city: 'Railstown (Tipperary)', zip: '835186' },
	{ city: 'Rainestown (Carlow)', zip: '554137' },
	{ city: 'Raish (Mayo)', zip: '371778' },
	{ city: 'Rakane (Cavan)', zip: '181024' },
	{ city: 'Rakean (Monaghan)', zip: '878184' },
	{ city: 'Rakeelan (Cavan)', zip: '951532' },
	{ city: 'Rakeeragh (Monaghan)', zip: '887663' },
	{ city: 'Rakeevan (Cavan)', zip: '381764' },
	{ city: 'Rakeevan (Monaghan)', zip: '223887' },
	{ city: 'Rakelly (Monaghan)', zip: '644907' },
	{ city: 'Rakenny (Cavan)', zip: '718430' },
	{ city: 'Rakerin (Galway)', zip: '458048' },
	{ city: 'Ralaghan (Cavan)', zip: '647893' },
	{ city: 'Ralaghan (Monaghan)', zip: '218683' },
	{ city: 'Ralappane (Kerry)', zip: '812593' },
	{ city: 'Raleagh (Cavan)', zip: '849025' },
	{ city: 'Raleigh North (Cork)', zip: '518095' },
	{ city: 'Raleigh South (Cork)', zip: '383439' },
	{ city: 'Ralish (Laois)', zip: '679379' },
	{ city: 'Rallekaystown (Dublin)', zip: '603364' },
	{ city: 'Raloaghan (Meath)', zip: '825516' },
	{ city: 'Ralph (Waterford)', zip: '936814' },
	{ city: 'Ralph (Wexford)', zip: '596448' },
	{ city: 'Ralphtown (Wexford)', zip: '311595' },
	{ city: 'Raludan (Cavan)', zip: '725836' },
	{ city: 'Ralusk (Galway)', zip: '599072' },
	{ city: 'Ramanny (Monaghan)', zip: '768143' },
	{ city: 'Ramolin (Mayo)', zip: '688591' },
	{ city: 'Ramonan (Cavan)', zip: '921472' },
	{ city: 'Ramooney (Leitrim)', zip: '499300' },
	{ city: 'Ramoy (Monaghan)', zip: '429595' },
	{ city: 'Rampark (Louth)', zip: '206932' },
	{ city: 'Rampark (Roscommon)', zip: '572401' },
	{ city: 'Rampere (Wicklow)', zip: '703086' },
	{ city: 'Ramsgrange (Wexford)', zip: '318329' },
	{ city: 'Rams Island (Mayo)', zip: '686746' },
	{ city: 'Ramstown (Wexford)', zip: '776193' },
	{ city: 'Ramstown Lower (Wexford)', zip: '471590' },
	{ city: 'Ramstown Upper (Wexford)', zip: '913140' },
	{ city: 'Ramulligan (Cavan)', zip: '831005' },
	{ city: 'Ranacrohy (Tipperary)', zip: '245713' },
	{ city: 'Ranaghan (Clare)', zip: '480339' },
	{ city: 'Ranaghan (Longford)', zip: '250986' },
	{ city: 'Ranaghan (Westmeath)', zip: '813412' },
	{ city: 'Ranaghanbaun (Longford)', zip: '582355' },
	{ city: 'Ranaghan Beg (Sligo)', zip: '955651' },
	{ city: 'Ranaghan More (Sligo)', zip: '407749' },
	{ city: 'Ranaghdoo Island (Donegal)', zip: '819167' },
	{ city: 'Ranaghmore (Donegal)', zip: '575031' },
	{ city: 'Ranaghy (Mayo)', zip: '111223' },
	{ city: 'Ranagissaun (Mayo)', zip: '394349' },
	{ city: 'Ranahan (Limerick)', zip: '897259' },
	{ city: 'Ranahinch (Westmeath)', zip: '498153' },
	{ city: 'Ranaleen (Kerry)', zip: '444920' },
	{ city: 'Ranalough (Kerry)', zip: '573437' },
	{ city: 'Ranamackan (Galway)', zip: '195069' },
	{ city: 'Ranaranny (Mayo)', zip: '767602' },
	{ city: 'Randallsmill (Wexford)', zip: '579477' },
	{ city: 'Randalstown (Meath)', zip: '335831' },
	{ city: 'Randalstown (Wexford)', zip: '991667' },
	{ city: 'Randalstown (Wicklow)', zip: '998000' },
	{ city: 'Raneany East (Donegal)', zip: '768127' },
	{ city: 'Raneany West (Donegal)', zip: '562553' },
	{ city: 'Raneely (Donegal)', zip: '579986' },
	{ city: 'Raneevoge (Meath)', zip: '765380' },
	{ city: 'Ranelagh (Dublin)', zip: '810219' },
	{ city: 'Ranelagh (Roscommon)', zip: '170162' },
	{ city: 'Ranelagh (Westmeath)', zip: '477769' },
	{ city: 'Rangaroe (Cork)', zip: '941180' },
	{ city: 'Rangue (Kerry)', zip: '575591' },
	{ city: 'Rann (Donegal)', zip: '897901' },
	{ city: 'Rannagh (Clare)', zip: '660991' },
	{ city: 'Rannagh And Toories (Donegal)', zip: '773467' },
	{ city: 'Rannagh East (Clare)', zip: '563923' },
	{ city: 'Rannagh West (Clare)', zip: '286891' },
	{ city: 'Rannatruffaun East (Sligo)', zip: '697530' },
	{ city: 'Rannatruffaun West (Sligo)', zip: '808332' },
	{ city: 'Ranns (Mayo)', zip: '343243' },
	{ city: 'Ranny (Donegal)', zip: '510049' },
	{ city: 'Ranrenagh (Cavan)', zip: '104768' },
	{ city: 'Ransborough (Cork)', zip: '957609' },
	{ city: 'Rantavan (Cavan)', zip: '949539' },
	{ city: 'Rantoge Glebe (Leitrim)', zip: '665159' },
	{ city: 'Rapepark (Clare)', zip: '934804' },
	{ city: 'Raphoe (Donegal)', zip: '698698' },
	{ city: 'Raphoe Demesne (Donegal)', zip: '846830' },
	{ city: 'Raphoe Townparks (Donegal)', zip: '918199' },
	{ city: 'Rapla (Laois)', zip: '185761' },
	{ city: 'Rapla (Tipperary)', zip: '743596' },
	{ city: 'Rapla North (Tipperary)', zip: '285860' },
	{ city: 'Rapla South (Tipperary)', zip: '118323' },
	{ city: 'Rappa (Laois)', zip: '726300' },
	{ city: 'Rappacastle (Mayo)', zip: '298847' },
	{ city: 'Rappareehill (Longford)', zip: '630064' },
	{ city: 'Raragh (Cavan)', zip: '277169' },
	{ city: 'Rareagh (Donegal)', zip: '707048' },
	{ city: 'Rareagh (Kerry)', zip: '542538' },
	{ city: 'Rarooey (Donegal)', zip: '318044' },
	{ city: 'Raruddy East (Galway)', zip: '956272' },
	{ city: 'Raruddy West (Galway)', zip: '492582' },
	{ city: 'Rarutagh (Monaghan)', zip: '427879' },
	{ city: 'Rascalstreet (Cork)', zip: '893315' },
	{ city: 'Rashedoge (Donegal)', zip: '836598' },
	{ city: 'Rashenny (Donegal)', zip: '342972' },
	{ city: 'Rashinagh (Offaly)', zip: '278936' },
	{ city: 'Rasillagh (Meath)', zip: '920289' },
	{ city: 'Raskeagh (Louth)', zip: '987593' },
	{ city: 'Raskill (Cavan)', zip: '449207' },
	{ city: 'Raspberryhill (Waterford)', zip: '627226' },
	{ city: 'Rassakeeran (Mayo)', zip: '674395' },
	{ city: 'Rassan (Cavan)', zip: '647687' },
	{ city: 'Rassan (Louth)', zip: '620842' },
	{ city: 'Rassaraun (Mayo)', zip: '115582' },
	{ city: 'Rassaun (Leitrim)', zip: '879435' },
	{ city: 'Rassaun East (Leitrim)', zip: '244246' },
	{ city: 'Rassaun West (Leitrim)', zip: '240019' },
	{ city: 'Rasuddan (Cavan)', zip: '170166' },
	{ city: 'Rataine (Meath)', zip: '247564' },
	{ city: 'Ratallen (Roscommon)', zip: '764417' },
	{ city: 'Ratass (Kerry)', zip: '377955' },
	{ city: 'Ratawragh (Roscommon)', zip: '936581' },
	{ city: 'Rateerbane (Monaghan)', zip: '368285' },
	{ city: 'Rath (Clare)', zip: '941265' },
	{ city: 'Rath (Cork)', zip: '989655' },
	{ city: 'Rath (Donegal)', zip: '938623' },
	{ city: 'Rath (Dublin)', zip: '921607' },
	{ city: 'Rath (Kerry)', zip: '426518' },
	{ city: 'Rath (Laois)', zip: '207914' },
	{ city: 'Rath (Limerick)', zip: '870628' },
	{ city: 'Rath (Longford)', zip: '545165' },
	{ city: 'Rath (Louth)', zip: '910677' },
	{ city: 'Rath (Mayo)', zip: '216331' },
	{ city: 'Rath (Meath)', zip: '500101' },
	{ city: 'Rath (Offaly)', zip: '749916' },
	{ city: 'Rath (Tipperary)', zip: '787675' },
	{ city: 'Rath (Waterford)', zip: '380792' },
	{ city: 'Rath (Westmeath)', zip: '427184' },
	{ city: 'Rath (Wexford)', zip: '630724' },
	{ city: 'Rath (Wicklow)', zip: '318128' },
	{ city: 'Rathaglish (Kilkenny)', zip: '894523' },
	{ city: 'Rathaldron (Meath)', zip: '861343' },
	{ city: 'Rathaleek (Kilkenny)', zip: '130799' },
	{ city: 'Rathaneague (Cork)', zip: '599800' },
	{ city: 'Rathangan (Kildare)', zip: '387953' },
	{ city: 'Rathangan (Wexford)', zip: '193147' },
	{ city: 'Rathangan Demesne (Kildare)', zip: '325919' },
	{ city: 'Rathaniska (Westmeath)', zip: '715860' },
	{ city: 'Rathanker (Cork)', zip: '976106' },
	{ city: 'Rathanlon (Galway)', zip: '223319' },
	{ city: 'Rathanna (Carlow)', zip: '823900' },
	{ city: 'Rathanny (Kerry)', zip: '409460' },
	{ city: 'Rathanny (Limerick)', zip: '470962' },
	{ city: 'Rathanny (Tipperary)', zip: '372371' },
	{ city: 'Rathanny (Waterford)', zip: '829138' },
	{ city: 'Rathanure (Tipperary)', zip: '898495' },
	{ city: 'Rathard (Cork)', zip: '235814' },
	{ city: 'Rathard (Tipperary)', zip: '253139' },
	{ city: 'Rathardeagher (Roscommon)', zip: '634629' },
	{ city: 'Ratharney (Longford)', zip: '710834' },
	{ city: 'Ratharoon East (Cork)', zip: '594472' },
	{ city: 'Ratharoon West (Cork)', zip: '378388' },
	{ city: 'Rathartan (Dublin)', zip: '321096' },
	{ city: 'Rathasker (Kildare)', zip: '876059' },
	{ city: 'Rathaspick (Laois)', zip: '369593' },
	{ city: 'Rathaspick (Westmeath)', zip: '607565' },
	{ city: 'Rathaspick (Wexford)', zip: '520141' },
	{ city: 'Rathattin (Wicklow)', zip: '261775' },
	{ city: 'Rathavin (Tipperary)', zip: '720495' },
	{ city: 'Rathavisteen (Mayo)', zip: '545512' },
	{ city: 'Rathbal (Mayo)', zip: '201927' },
	{ city: 'Rathballylong (Wicklow)', zip: '175293' },
	{ city: 'Rathbane (Kildare)', zip: '896488' },
	{ city: 'Rathbane (Kilkenny)', zip: '798726' },
	{ city: 'Rathbane (Meath)', zip: '561538' },
	{ city: 'Rathbane (Wicklow)', zip: '224987' },
	{ city: 'Rathbane South (Limerick)', zip: '951994' },
	{ city: 'Rathbarna (Roscommon)', zip: '866887' },
	{ city: 'Rathbarran (Sligo)', zip: '348929' },
	{ city: 'Rathbarry (Cork)', zip: '743422' },
	{ city: 'Rathbaun (Carlow)', zip: '509697' },
	{ city: 'Rathbaun (Clare)', zip: '145724' },
	{ city: 'Rathbaun (Galway)', zip: '303603' },
	{ city: 'Rathbaun (Leitrim)', zip: '642350' },
	{ city: 'Rathbaun (Mayo)', zip: '233257' },
	{ city: 'Rathbaun (Sligo)', zip: '171707' },
	{ city: 'Rathbaun North (Sligo)', zip: '556148' },
	{ city: 'Rathbaun South (Sligo)', zip: '548828' },
	{ city: 'Rathbawn (Wicklow)', zip: '864779' },
	{ city: 'Rathbeagh (Kilkenny)', zip: '261952' },
	{ city: 'Rathbeal (Dublin)', zip: '842629' },
	{ city: 'Rathbeg (Tipperary)', zip: '922058' },
	{ city: 'Rath Beg (Clare)', zip: '858473' },
	{ city: 'Rath Beg (Cork)', zip: '235673' },
	{ city: 'Rath Beg (Kerry)', zip: '962950' },
	{ city: 'Rath Beg (Offaly)', zip: '892360' },
	{ city: 'Rathbeggan (Meath)', zip: '993472' },
	{ city: 'Rathbennett (Westmeath)', zip: '954090' },
	{ city: 'Rathbody (Louth)', zip: '391498' },
	{ city: 'Rathbourn (Kilkenny)', zip: '176039' },
	{ city: 'Rathbrack (Meath)', zip: '489181' },
	{ city: 'Rathbrack (Westmeath)', zip: '525224' },
	{ city: 'Rathbrackan (Longford)', zip: '597833' },
	{ city: 'Rathbraghan (Sligo)', zip: '307644' },
	{ city: 'Rathbran (Wicklow)', zip: '632533' },
	{ city: 'Rathbranagh (Limerick)', zip: '794988' },
	{ city: 'Rathbran Beg (Meath)', zip: '816628' },
	{ city: 'Rathbranchurch (Meath)', zip: '549972' },
	{ city: 'Rathbran More (Meath)', zip: '679915' },
	{ city: 'Rathbrenan (Roscommon)', zip: '848891' },
	{ city: 'Rathbrennan (Laois)', zip: '112540' },
	{ city: 'Rathbride (Kildare)', zip: '442411' },
	{ city: 'Rathbrist (Louth)', zip: '557262' },
	{ city: 'Rathbrit (Tipperary)', zip: '169690' },
	{ city: 'Rathcabban (Tipperary)', zip: '108608' },
	{ city: 'Rathcahaun (Clare)', zip: '499544' },
	{ city: 'Rathcahill (Offaly)', zip: '272927' },
	{ city: 'Rathcahill East (Limerick)', zip: '230813' },
	{ city: 'Rathcahill West (Limerick)', zip: '582820' },
	{ city: 'Rathcaled (Westmeath)', zip: '818527' },
	{ city: 'Rathcallan (Cork)', zip: '445966' },
	{ city: 'Rathcam (Westmeath)', zip: '539172' },
	{ city: 'Rathcanning (Cork)', zip: '547552' },
	{ city: 'Rathcannon (Limerick)', zip: '254514' },
	{ city: 'Rathcardan (Tipperary)', zip: '316520' },
	{ city: 'Rathcarra (Westmeath)', zip: '334143' },
	{ city: 'Rathcarran (Meath)', zip: '914475' },
	{ city: 'Rathcarran (Roscommon)', zip: '685801' },
	{ city: 'Rathcarreen (Mayo)', zip: '866953' },
	{ city: 'Rathcarrick (Sligo)', zip: '901453' },
	{ city: 'Rathcarstown (Meath)', zip: '358366' },
	{ city: 'Rathcash (Kilkenny)', zip: '168623' },
	{ city: 'Rathcash (Mayo)', zip: '255242' },
	{ city: 'Rathcash East (Kilkenny)', zip: '420963' },
	{ city: 'Rathcash Little (Kilkenny)', zip: '995889' },
	{ city: 'Rathcash West (Kilkenny)', zip: '538716' },
	{ city: 'Rathcassan (Louth)', zip: '863945' },
	{ city: 'Rathcastle (Westmeath)', zip: '606678' },
	{ city: 'Rathclare (Cork)', zip: '493287' },
	{ city: 'Rathclarish (Tipperary)', zip: '977915' },
	{ city: 'Rathclevin (Kilkenny)', zip: '622752' },
	{ city: 'Rathcline (Longford)', zip: '621337' },
	{ city: 'Rathclittagh (Westmeath)', zip: '867086' },
	{ city: 'Rathclogh (Kilkenny)', zip: '916222' },
	{ city: 'Rathclogh North (Tipperary)', zip: '303265' },
	{ city: 'Rathclogh South (Tipperary)', zip: '953339' },
	{ city: 'Rathcloheen (Tipperary)', zip: '559391' },
	{ city: 'Rathclooney (Clare)', zip: '703591' },
	{ city: 'Rathcobane (Cork)', zip: '663383' },
	{ city: 'Rathcobican (Offaly)', zip: '680580' },
	{ city: 'Rathcoffey (Laois)', zip: '720529' },
	{ city: 'Rathcoffey Demesne (Kildare)', zip: '120905' },
	{ city: 'Rathcoffey North (Kildare)', zip: '925800' },
	{ city: 'Rathcoffey South (Kildare)', zip: '102713' },
	{ city: 'Rathcogue (Westmeath)', zip: '797569' },
	{ city: 'Rathcolman (Westmeath)', zip: '627881' },
	{ city: 'Rathconnell (Kildare)', zip: '419368' },
	{ city: 'Rathconnell (Westmeath)', zip: '843799' },
	{ city: 'Rathconnellwood (Kildare)', zip: '319826' },
	{ city: 'Rathconny (Meath)', zip: '638192' },
	{ city: 'Rathconor (Roscommon)', zip: '391854' },
	{ city: 'Rathconrath (Westmeath)', zip: '688724' },
	{ city: 'Rathcool (Cork)', zip: '491459' },
	{ city: 'Rathcool (Meath)', zip: '223353' },
	{ city: 'Rathcool (Tipperary)', zip: '486482' },
	{ city: 'Rathcoola East (Cork)', zip: '822328' },
	{ city: 'Rathcoola West (Cork)', zip: '738471' },
	{ city: 'Rathcoole (Dublin)', zip: '495983' },
	{ city: 'Rathcoole (Louth)', zip: '723152' },
	{ city: 'Rathcoon (Meath)', zip: '959497' },
	{ city: 'Rathcooney (Cork)', zip: '929240' },
	{ city: 'Rathcooney (Tipperary)', zip: '678053' },
	{ city: 'Rathcor (Longford)', zip: '207991' },
	{ city: 'Rathcor (Louth)', zip: '320369' },
	{ city: 'Rathcorbally (Westmeath)', zip: '990673' },
	{ city: 'Rathcore (Meath)', zip: '274888' },
	{ city: 'Rathcore (Westmeath)', zip: '276757' },
	{ city: 'Rathcorick (Cavan)', zip: '398938' },
	{ city: 'Rathcormack (Cork)', zip: '696793' },
	{ city: 'Rathcormack-Mountain (Cork)', zip: '478723' },
	{ city: 'Rathcormick (Meath)', zip: '387223' },
	{ city: 'Rathcosgry (Galway)', zip: '304459' },
	{ city: 'Rathcot (Wicklow)', zip: '805137' },
	{ city: 'Rathcoun (Tipperary)', zip: '273766' },
	{ city: 'Rathcoursey East (Cork)', zip: '711793' },
	{ city: 'Rathcoursey West (Cork)', zip: '695170' },
	{ city: 'Rathcoyle Lower (Wicklow)', zip: '125843' },
	{ city: 'Rathcoyle Upper (Wicklow)', zip: '296663' },
	{ city: 'Rathcraggaun (Clare)', zip: '260093' },
	{ city: 'Rathcrea (Laois)', zip: '450224' },
	{ city: 'Rathcreedan (Dublin)', zip: '324133' },
	{ city: 'Rathcreevagh (Westmeath)', zip: '541285' },
	{ city: 'Rathcriddoge (Tipperary)', zip: '213097' },
	{ city: 'Rathcrihane (Kerry)', zip: '426860' },
	{ city: 'Rathcrogue (Carlow)', zip: '392197' },
	{ city: 'Rathcronan (Longford)', zip: '333259' },
	{ city: 'Rathcrony (Clare)', zip: '982408' },
	{ city: 'Rathculbin (Kilkenny)', zip: '648521' },
	{ city: 'Rathculleen (Cork)', zip: '801752' },
	{ city: 'Rathculliheen (Kilkenny)', zip: '109192' },
	{ city: 'Rathcunikeen (Tipperary)', zip: '461018' },
	{ city: 'Rathcuppoge (Cork)', zip: '174269' },
	{ city: 'Rathcurby North (Kilkenny)', zip: '437291' },
	{ city: 'Rathcurby South (Kilkenny)', zip: '629138' },
	{ city: 'Rathcusack (Kilkenny)', zip: '721405' },
	{ city: 'Rathdaggan (Cork)', zip: '446547' },
	{ city: 'Rathdangan (Wicklow)', zip: '907095' },
	{ city: 'Rathdaniel (Carlow)', zip: '800971' },
	{ city: 'Rathdaniel (Louth)', zip: '871363' },
	{ city: 'Rathdermot (Tipperary)', zip: '290560' },
	{ city: 'Rathdiveen (Roscommon)', zip: '570139' },
	{ city: 'Rathdonnell (Donegal)', zip: '604832' },
	{ city: 'Rathdonnell (Mayo)', zip: '641580' },
	{ city: 'Rathdoony Beg (Sligo)', zip: '920901' },
	{ city: 'Rathdoony More (Sligo)', zip: '331139' },
	{ city: 'Rathdowney (Laois)', zip: '897297' },
	{ city: 'Rathdowney (Wexford)', zip: '406345' },
	{ city: 'Rathdown Lower (Wicklow)', zip: '164529' },
	{ city: 'Rathdown Upper (Wicklow)', zip: '983588' },
	{ city: 'Rathdrinagh (Meath)', zip: '401602' },
	{ city: 'Rathdrishoge (Westmeath)', zip: '995217' },
	{ city: 'Rathdrought (Cork)', zip: '833263' },
	{ city: 'Rathdrum (Cork)', zip: '529073' },
	{ city: 'Rathdrum (Offaly)', zip: '539087' },
	{ city: 'Rathdrum (Tipperary)', zip: '468781' },
	{ city: 'Rathdrum (Wicklow)', zip: '159104' },
	{ city: 'Rathdrumin (Louth)', zip: '400249' },
	{ city: 'Rathduane (Cork)', zip: '555485' },
	{ city: 'Rathduff (Carlow)', zip: '787792' },
	{ city: 'Rathduff (Cork)', zip: '873392' },
	{ city: 'Rathduff (Kerry)', zip: '357837' },
	{ city: 'Rathduff (Kilkenny)', zip: '639087' },
	{ city: 'Rathduff (Laois)', zip: '282615' },
	{ city: 'Rathduff (Louth)', zip: '836359' },
	{ city: 'Rathduff (Mayo)', zip: '286413' },
	{ city: 'Rathduff (Tipperary)', zip: '276739' },
	{ city: 'Rathduff (Westmeath)', zip: '535979' },
	{ city: 'Rathduff (Wexford)', zip: '662428' },
	{ city: 'Rathduffbeg (Wicklow)', zip: '140675' },
	{ city: 'Rathduff Lower (Kilkenny)', zip: '674945' },
	{ city: 'Rathduff Lower (Tipperary)', zip: '497296' },
	{ city: 'Rathduffmore (Wicklow)', zip: '510513' },
	{ city: 'Rathduff Upper (Kilkenny)', zip: '311037' },
	{ city: 'Rathduff Upper (Tipperary)', zip: '825774' },
	{ city: 'Rathe (Meath)', zip: '186068' },
	{ city: 'Rathea (Kerry)', zip: '474738' },
	{ city: 'Rathealy (Kilkenny)', zip: '266309' },
	{ city: 'Rath East (Cork)', zip: '771694' },
	{ city: 'Rath East (Wicklow)', zip: '609718' },
	{ city: 'Rathedan (Carlow)', zip: '962650' },
	{ city: 'Rathedmond (Sligo)', zip: '565078' },
	{ city: 'Ratheeragh (Carlow)', zip: '563405' },
	{ city: 'Rathellin (Carlow)', zip: '532433' },
	{ city: 'Rathenny (Offaly)', zip: '576158' },
	{ city: 'Rathercan (Carlow)', zip: '402042' },
	{ city: 'Rathernan (Kildare)', zip: '553648' },
	{ city: 'Ratherrig (Laois)', zip: '508901' },
	{ city: 'Rathescar Middle (Louth)', zip: '277069' },
	{ city: 'Rathescar North (Louth)', zip: '948480' },
	{ city: 'Rathescar South (Louth)', zip: '826936' },
	{ city: 'Ratheskin (Mayo)', zip: '891921' },
	{ city: 'Ratheven (Laois)', zip: '140304' },
	{ city: 'Rathevin (Roscommon)', zip: '301457' },
	{ city: 'Rathfalla (Tipperary)', zip: '452732' },
	{ city: 'Rathfarnham (Dublin)', zip: '530415' },
	{ city: 'Rathfarra (Limerick)', zip: '823366' },
	{ city: 'Rathfee (Galway)', zip: '497663' },
	{ city: 'Rathfeigh (Meath)', zip: '164659' },
	{ city: 'Rathfelane (Cork)', zip: '691983' },
	{ city: 'Rathfeston (Offaly)', zip: '376775' },
	{ city: 'Rathfield (Kerry)', zip: '386311' },
	{ city: 'Rathfilode (Cork)', zip: '501244' },
	{ city: 'Rathflesk (Meath)', zip: '741948' },
	{ city: 'Rathfolan (Clare)', zip: '615662' },
	{ city: 'Rathfootera (Cork)', zip: '670177' },
	{ city: 'Rathfragan (Donegal)', zip: '710015' },
	{ city: 'Rathfran (Mayo)', zip: '487845' },
	{ city: 'Rathfranpark (Mayo)', zip: '939320' },
	{ city: 'Rathfrask (Sligo)', zip: '464819' },
	{ city: 'Rathfreedy (Limerick)', zip: '151306' },
	{ city: 'Rathfuadagh (Roscommon)', zip: '152441' },
	{ city: 'Rathfylane (Wexford)', zip: '367880' },
	{ city: 'Rathgallen (Tipperary)', zip: '993930' },
	{ city: 'Rathganny (Westmeath)', zip: '599055' },
	{ city: 'Rathgar (Dublin)', zip: '533109' },
	{ city: 'Rathgaroge (Wexford)', zip: '258774' },
	{ city: 'Rathgarrett (Westmeath)', zip: '528583' },
	{ city: 'Rathgarry (Kilkenny)', zip: '239913' },
	{ city: 'Rathgarvan (Kilkenny)', zip: '482903' },
	{ city: 'Rathgarve (Westmeath)', zip: '570474' },
	{ city: 'Rathgaskig (Cork)', zip: '746257' },
	{ city: 'Rathgeean (Sligo)', zip: '610163' },
	{ city: 'Rathgeenan (Louth)', zip: '526717' },
	{ city: 'Rathgeran (Carlow)', zip: '226855' },
	{ city: 'Rathgibbon North (Offaly)', zip: '770933' },
	{ city: 'Rathgibbon South (Offaly)', zip: '494178' },
	{ city: 'Rathgilbert (Laois)', zip: '776779' },
	{ city: 'Rathgillen (Meath)', zip: '683291' },
	{ city: 'Rathgire (Cork)', zip: '253428' },
	{ city: 'Rathglass (Carlow)', zip: '696622' },
	{ city: 'Rathglass (Donegal)', zip: '525466' },
	{ city: 'Rathglass (Galway)', zip: '688058' },
	{ city: 'Rathglass (Mayo)', zip: '742362' },
	{ city: 'Rathglass (Sligo)', zip: '881716' },
	{ city: 'Rathglassane (Cork)', zip: '934312' },
	{ city: 'Rathglass East (Mayo)', zip: '691786' },
	{ city: 'Rathglass West (Mayo)', zip: '247665' },
	{ city: 'Rathgoggan Middle (Cork)', zip: '670628' },
	{ city: 'Rathgoggan North (Cork)', zip: '170048' },
	{ city: 'Rathgoggan South (Cork)', zip: '103345' },
	{ city: 'Rathgoonan (Limerick)', zip: '630750' },
	{ city: 'Rathgoonaun (Sligo)', zip: '571473' },
	{ city: 'Rathgorgin (Galway)', zip: '212451' },
	{ city: 'Rathgormuck (Waterford)', zip: '611711' },
	{ city: 'Rathgorragh (Kildare)', zip: '763131' },
	{ city: 'Rathgorragh Lower (Wicklow)', zip: '516131' },
	{ city: 'Rathgorragh Upper (Wicklow)', zip: '789966' },
	{ city: 'Rathgory (Donegal)', zip: '670271' },
	{ city: 'Rathgory (Louth)', zip: '261336' },
	{ city: 'Rathgowan (Westmeath)', zip: '221272' },
	{ city: 'Rathgran (Sligo)', zip: '466144' },
	{ city: 'Rathgranagher (Mayo)', zip: '963071' },
	{ city: 'Rath Great (Dublin)', zip: '983511' },
	{ city: 'Rathgreedan (Offaly)', zip: '436836' },
	{ city: 'Rathgrumly (Kildare)', zip: '674161' },
	{ city: 'Rathhaha (Cork)', zip: '496992' },
	{ city: 'Rath-Healy (Cork)', zip: '677026' },
	{ city: 'Rath Hill (Meath)', zip: '121311' },
	{ city: 'Rathhugh (Sligo)', zip: '264426' },
	{ city: 'Rathiddy (Louth)', zip: '544992' },
	{ city: 'Rathingle (Dublin)', zip: '339364' },
	{ city: 'Rathinree Lower (Meath)', zip: '393033' },
	{ city: 'Rathinree Upper (Meath)', zip: '596006' },
	{ city: 'Rathinure (Kilkenny)', zip: '211065' },
	{ city: 'Rathjarney (Wexford)', zip: '387405' },
	{ city: 'Rathjordan (Limerick)', zip: '790342' },
	{ city: 'Rathkea (Tipperary)', zip: '219675' },
	{ city: 'Rathkeale (Limerick)', zip: '856784' },
	{ city: 'Rathkeale Commons (Limerick)', zip: '185047' },
	{ city: 'Rathkeeragan (Offaly)', zip: '790883' },
	{ city: 'Rathkeery (Roscommon)', zip: '345171' },
	{ city: 'Rathkeevin (Tipperary)', zip: '514211' },
	{ city: 'Rathkelly (Mayo)', zip: '354091' },
	{ city: 'Rathkenna (Meath)', zip: '183538' },
	{ city: 'Rathkennan (Tipperary)', zip: '808018' },
	{ city: 'Rathkennanwood (Tipperary)', zip: '616481' },
	{ city: 'Rathkenny (Kerry)', zip: '566341' },
	{ city: 'Rathkenny (Meath)', zip: '553623' },
	{ city: 'Rathkenny (Tipperary)', zip: '289350' },
	{ city: 'Rathkenty (Tipperary)', zip: '962549' },
	{ city: 'Rathkerry (Clare)', zip: '506497' },
	{ city: 'Rathkeva (Roscommon)', zip: '105158' },
	{ city: 'Rathkieran (Kerry)', zip: '200835' },
	{ city: 'Rathkieran (Kilkenny)', zip: '646000' },
	{ city: 'Rathkilmore (Meath)', zip: '341500' },
	{ city: 'Rathkineely (Roscommon)', zip: '477009' },
	{ city: 'Rathkip (Mayo)', zip: '931323' },
	{ city: 'Rathkyle (Kilkenny)', zip: '599014' },
	{ city: 'Rathkyle (Wexford)', zip: '948012' },
	{ city: 'Rathlackan (Mayo)', zip: '688079' },
	{ city: 'Rathlagan (Meath)', zip: '389281' },
	{ city: 'Rathlaheen North (Clare)', zip: '230277' },
	{ city: 'Rathlaheen South (Clare)', zip: '909864' },
	{ city: 'Rathlannon (Wexford)', zip: '995694' },
	{ city: 'Rathlead (Waterford)', zip: '581230' },
	{ city: 'Rathleague (Laois)', zip: '116858' },
	{ city: 'Rathleash (Laois)', zip: '861229' },
	{ city: 'Rathleasty (Tipperary)', zip: '664843' },
	{ city: 'Rathlee (Sligo)', zip: '604895' },
	{ city: 'Rathleek (Meath)', zip: '165024' },
	{ city: 'Rathleen (Kilkenny)', zip: '172267' },
	{ city: 'Rathleg (Roscommon)', zip: '372313' },
	{ city: 'Rathlena (Roscommon)', zip: '483316' },
	{ city: 'Rathlevanagh (Westmeath)', zip: '108813' },
	{ city: 'Rathlihen (Offaly)', zip: '529319' },
	{ city: "Rathlin O'Birne Island (Donegal)", zip: '476973' },
	{ city: 'Rath Little (Dublin)', zip: '685092' },
	{ city: 'Rathlogan (Kilkenny)', zip: '105452' },
	{ city: 'Rathloose (Tipperary)', zip: '397889' },
	{ city: 'Rath Lower (Louth)', zip: '513997' },
	{ city: 'Rath Lower (Waterford)', zip: '970145' },
	{ city: 'Rath Lower (Westmeath)', zip: '692813' },
	{ city: 'Rathluby (Clare)', zip: '434771' },
	{ city: 'Rathlumber (Offaly)', zip: '970216' },
	{ city: 'Rathlust (Louth)', zip: '596200' },
	{ city: 'Rathlyon (Carlow)', zip: '444805' },
	{ city: 'Rathmacan (Kilkenny)', zip: '485357' },
	{ city: 'Rathmacarty East (Tipperary)', zip: '433393' },
	{ city: 'Rathmacarty West (Tipperary)', zip: '287785' },
	{ city: 'Rathmacknee Little (Wexford)', zip: '497776' },
	{ city: 'Rathmackneem Great (Wexford)', zip: '829148' },
	{ city: 'Rathmacostello (Mayo)', zip: '558291' },
	{ city: 'Rathmactiernan (Sligo)', zip: '557359' },
	{ city: 'Rathmacullig East (Cork)', zip: '515418' },
	{ city: 'Rathmacullig West (Cork)', zip: '366930' },
	{ city: 'Rathmadder (Sligo)', zip: '830072' },
	{ city: 'Rathmagurry (Sligo)', zip: '171542' },
	{ city: 'Rathmaher (Cork)', zip: '443756' },
	{ city: 'Rathmaiden (Meath)', zip: '579870' },
	{ city: 'Rathmaiden (Waterford)', zip: '115603' },
	{ city: 'Rathmakelly Glebe (Laois)', zip: '924806' },
	{ city: 'Rathmale (Limerick)', zip: '889969' },
	{ city: 'Rathmalikeen (Mayo)', zip: '723208' },
	{ city: 'Rathmalode (Kerry)', zip: '751301' },
	{ city: 'Rathmanna (Tipperary)', zip: '173104' },
	{ city: 'Rathmanoo (Meath)', zip: '747356' },
	{ city: 'Rathmea (Meath)', zip: '154118' },
	{ city: 'Rathmeague (Wicklow)', zip: '975485' },
	{ city: 'Rathmeehan (Clare)', zip: '580717' },
	{ city: 'Rathmeel (Mayo)', zip: '965169' },
	{ city: 'Rathmeel (Sligo)', zip: '736530' },
	{ city: 'Rathmelton (Donegal)', zip: '688043' },
	{ city: 'Rathmew (Roscommon)', zip: '890519' },
	{ city: 'Rathmichael (Dublin)', zip: '393002' },
	{ city: 'Rathmiles (Laois)', zip: '463586' },
	{ city: 'Rathmines (Dublin)', zip: '766883' },
	{ city: 'Rathmines Great (Dublin)', zip: '181144' },
	{ city: 'Rathmines Little (Dublin)', zip: '584544' },
	{ city: 'Rathmolyon (Meath)', zip: '378607' },
	{ city: 'Rathmoney (Sligo)', zip: '801260' },
	{ city: 'Rathmooley (Tipperary)', zip: '319440' },
	{ city: 'Rathmoon (Wicklow)', zip: '647876' },
	{ city: 'Rathmooney (Dublin)', zip: '679306' },
	{ city: 'Rathmore (Carlow)', zip: '839111' },
	{ city: 'Rathmore (Cork)', zip: '651038' },
	{ city: 'Rathmore (Donegal)', zip: '827096' },
	{ city: 'Rathmore (Galway)', zip: '132046' },
	{ city: 'Rathmore (Kerry)', zip: '364950' },
	{ city: 'Rathmore (Kildare)', zip: '841674' },
	{ city: 'Rathmore (Laois)', zip: '923893' },
	{ city: 'Rathmore (Longford)', zip: '113111' },
	{ city: 'Rathmore (Louth)', zip: '721351' },
	{ city: 'Rathmore (Mayo)', zip: '446248' },
	{ city: 'Rathmore (Meath)', zip: '518943' },
	{ city: 'Rathmore (Monaghan)', zip: '918608' },
	{ city: 'Rathmore (Offaly)', zip: '937044' },
	{ city: 'Rathmore (Roscommon)', zip: '690353' },
	{ city: 'Rathmore (Sligo)', zip: '412222' },
	{ city: 'Rathmore (Tipperary)', zip: '374438' },
	{ city: 'Rathmore (Westmeath)', zip: '845681' },
	{ city: 'Rathmore (Wexford)', zip: '447750' },
	{ city: 'Rathmore (Wicklow)', zip: '332515' },
	{ city: 'Rath More (Clare)', zip: '257586' },
	{ city: 'Rath More (Cork)', zip: '784604' },
	{ city: 'Rath More (Kerry)', zip: '950712' },
	{ city: 'Rath More (Offaly)', zip: '190842' },
	{ city: 'Rathmoreahanduff (Galway)', zip: '617416' },
	{ city: 'Rathmore Demesne (Galway)', zip: '977923' },
	{ city: 'Rathmore East (Kildare)', zip: '793794' },
	{ city: 'Rathmore North (Limerick)', zip: '648702' },
	{ city: 'Rathmore South (Limerick)', zip: '371236' },
	{ city: 'Rathmore West (Kildare)', zip: '992593' },
	{ city: 'Rathmorgan (Cork)', zip: '193348' },
	{ city: 'Rathmorgan (Mayo)', zip: '457352' },
	{ city: 'Rathmorrel (Kerry)', zip: '190306' },
	{ city: 'Rathmorrissy (Galway)', zip: '782884' },
	{ city: 'Rathmount (Offaly)', zip: '522335' },
	{ city: 'Rath Mountain (Donegal)', zip: '531542' },
	{ city: 'Rathmoy (Tipperary)', zip: '986077' },
	{ city: 'Rathmoylan (Waterford)', zip: '199290' },
	{ city: 'Rathmoyle (Galway)', zip: '891120' },
	{ city: 'Rathmoyle (Kilkenny)', zip: '937569' },
	{ city: 'Rathmoyle (Laois)', zip: '612046' },
	{ city: 'Rathmoyle (Mayo)', zip: '977380' },
	{ city: 'Rathmoyle (Offaly)', zip: '697159' },
	{ city: 'Rathmoyle (Roscommon)', zip: '550773' },
	{ city: 'Rathmuck (Kildare)', zip: '297082' },
	{ city: 'Rathmullan (Donegal)', zip: '996339' },
	{ city: 'Rathmullan (Louth)', zip: '189175' },
	{ city: 'Rathmullan (Meath)', zip: '792227' },
	{ city: 'Rathmullan And Ballyboe (Donegal)', zip: '315782' },
	{ city: 'Rathmulpatrick (Sligo)', zip: '529061' },
	{ city: 'Rathmurphy (Sligo)', zip: '873311' },
	{ city: 'Rathmurragh (Offaly)', zip: '388038' },
	{ city: 'Rathnabo (Wicklow)', zip: '310515' },
	{ city: 'Rathnacally (Cork)', zip: '828808' },
	{ city: 'Rathnacarton (Cork)', zip: '788805' },
	{ city: 'Rathnaconeen (Mayo)', zip: '708000' },
	{ city: 'Rathnacreeva (Mayo)', zip: '515504' },
	{ city: 'Rathnadoffy (Mayo)', zip: '854865' },
	{ city: 'Rathnafushoge (Carlow)', zip: '294062' },
	{ city: 'Rathnagard (Cork)', zip: '211547' },
	{ city: 'Rathnageeragh (Carlow)', zip: '769483' },
	{ city: 'Rathnageeragh (Wexford)', zip: '735682' },
	{ city: 'Rathnaglye (Roscommon)', zip: '616372' },
	{ city: 'Rathnagore (Limerick)', zip: '498008' },
	{ city: 'Rathnagrew Lower (Carlow)', zip: '375533' },
	{ city: 'Rathnagrew Upper (Carlow)', zip: '155249' },
	{ city: 'Rathnaguppaun (Mayo)', zip: '303883' },
	{ city: 'Rathnakelliga (Sligo)', zip: '734231' },
	{ city: 'Rathnaleen North (Tipperary)', zip: '938217' },
	{ city: 'Rathnaleen South (Tipperary)', zip: '341676' },
	{ city: 'Rathnaleugh (Laois)', zip: '253470' },
	{ city: 'Rathnallog (Roscommon)', zip: '590241' },
	{ city: 'Rathnally (Meath)', zip: '825995' },
	{ city: 'Rathnalour (Tipperary)', zip: '231659' },
	{ city: 'Rathnalulleagh (Roscommon)', zip: '562785' },
	{ city: 'Rathnamagh (Mayo)', zip: '830244' },
	{ city: 'Rathnamanagh (Laois)', zip: '766160' },
	{ city: 'Rathnameneenagh (Waterford)', zip: '492335' },
	{ city: 'Rathnamuddagh (Westmeath)', zip: '922297' },
	{ city: 'Rathnaneane (Limerick)', zip: '169383' },
	{ city: 'Rathnapish (Carlow)', zip: '397719' },
	{ city: 'Rathnarovanagh (Roscommon)', zip: '855282' },
	{ city: 'Rathnarrow (Sligo)', zip: '855988' },
	{ city: 'Rathnarrow (Westmeath)', zip: '253746' },
	{ city: 'Rathnaruogy (Cork)', zip: '199714' },
	{ city: 'Rathnaseer (Limerick)', zip: '987222' },
	{ city: 'Rathnashannagh (Carlow)', zip: '366782' },
	{ city: 'Rathnaskilloge (Waterford)', zip: '444944' },
	{ city: 'Rathnasliggeen (Tipperary)', zip: '400765' },
	{ city: 'Rathnasmolagh (Kilkenny)', zip: '561361' },
	{ city: 'Rathnaveoge Lower (Tipperary)', zip: '646650' },
	{ city: 'Rathnaveoge Upper (Tipperary)', zip: '167100' },
	{ city: 'Rathnawooraun (Mayo)', zip: '546448' },
	{ city: 'Rathneaveen (Tipperary)', zip: '653911' },
	{ city: 'Rathnedan (Wexford)', zip: '721102' },
	{ city: 'Rathnee (Cork)', zip: '870304' },
	{ city: 'Rathneestin (Louth)', zip: '521075' },
	{ city: 'Rathneety (Louth)', zip: '814910' },
	{ city: 'Rathnew (Westmeath)', zip: '473210' },
	{ city: 'Rathnew (Wicklow)', zip: '466695' },
	{ city: 'Rathnugent (Westmeath)', zip: '254410' },
	{ city: 'Rathnure (Westmeath)', zip: '141209' },
	{ city: 'Rathnure (Wexford)', zip: '663528' },
	{ city: 'Rathnure Lower (Wexford)', zip: '512987' },
	{ city: 'Rathnure Upper (Wexford)', zip: '287058' },
	{ city: 'Rathokelly (Tipperary)', zip: '570562' },
	{ city: 'Ratholm (Wexford)', zip: '498738' },
	{ city: 'Rathoma (Mayo)', zip: '554591' },
	{ city: 'Rathonoane (Cork)', zip: '702813' },
	{ city: 'Rathonoragh (Sligo)', zip: '928727' },
	{ city: 'Rathoonagh (Mayo)', zip: '382482' },
	{ city: 'Rathoran (Kerry)', zip: '240886' },
	{ city: 'Rathordan (Tipperary)', zip: '176047' },
	{ city: 'Rathorgan (Cork)', zip: '567495' },
	{ city: 'Rathornan (Carlow)', zip: '131382' },
	{ city: 'Rathory (Louth)', zip: '112005' },
	{ city: 'Rathoscar (Kilkenny)', zip: '803125' },
	{ city: 'Rathosey (Sligo)', zip: '154581' },
	{ city: 'Rathosheen (Kilkenny)', zip: '929027' },
	{ city: 'Rathowen (Westmeath)', zip: '670528' },
	{ city: 'Rathowen East (Mayo)', zip: '926115' },
	{ city: 'Rathowen West (Mayo)', zip: '655806' },
	{ city: 'Rathpalatine (Limerick)', zip: '999463' },
	{ city: 'Rathpatrick (Kilkenny)', zip: '387288' },
	{ city: 'Rathpeacon (Cork)', zip: '584162' },
	{ city: 'Rathpeak (Roscommon)', zip: '837296' },
	{ city: 'Rathphaudin (Wexford)', zip: '906626' },
	{ city: 'Rathphelan (Laois)', zip: '950448' },
	{ city: 'Rathpiercehill (Wexford)', zip: '462417' },
	{ city: 'Rathpierce Lower (Wexford)', zip: '572180' },
	{ city: 'Rathpierce Upper (Wexford)', zip: '688267' },
	{ city: 'Rathpiper North (Laois)', zip: '515906' },
	{ city: 'Rathpiper South (Laois)', zip: '270259' },
	{ city: 'Rathpoge East (Kerry)', zip: '166077' },
	{ city: 'Rathpoge West (Kerry)', zip: '630676' },
	{ city: 'Rathpoleen (Kilkenny)', zip: '980654' },
	{ city: 'Rathquage (Waterford)', zip: '787810' },
	{ city: 'Rathquarter (Sligo)', zip: '125157' },
	{ city: 'Rathranna (Cork)', zip: '654888' },
	{ city: 'Rathreagh (Kilkenny)', zip: '214323' },
	{ city: 'Rathreagh (Mayo)', zip: '965637' },
	{ city: 'Rathreagh Beg (Limerick)', zip: '771508' },
	{ city: 'Rathreagh More (Limerick)', zip: '528759' },
	{ city: 'Rathredmond (Mayo)', zip: '893577' },
	{ city: 'Rathreedaun (Mayo)', zip: '511914' },
	{ city: 'Rathregan (Meath)', zip: '139270' },
	{ city: 'Rathreynolds (Meath)', zip: '279515' },
	{ city: 'Rathrippin (Sligo)', zip: '107029' },
	{ city: 'Rathroal (Louth)', zip: '701369' },
	{ city: 'Rathrobin (Offaly)', zip: '854256' },
	{ city: 'Rathroe (Cork)', zip: '231263' },
	{ city: 'Rathroe (Kerry)', zip: '675603' },
	{ city: 'Rathroe (Mayo)', zip: '543031' },
	{ city: 'Rathroe (Roscommon)', zip: '680749' },
	{ city: 'Rathroe (Tipperary)', zip: '802560' },
	{ city: 'Rathroeen (Mayo)', zip: '842022' },
	{ city: 'Rathrolan (Wexford)', zip: '548952' },
	{ city: 'Rathronan (Tipperary)', zip: '152462' },
	{ city: 'Rathronan (Wexford)', zip: '368923' },
	{ city: 'Rathronan Demesne (Tipperary)', zip: '964075' },
	{ city: 'Rathronshin (Laois)', zip: '387128' },
	{ city: 'Rathrowan (Mayo)', zip: '103917' },
	{ city: 'Rathruane Beg (Cork)', zip: '856497' },
	{ city: 'Rathruane More (Cork)', zip: '913834' },
	{ city: 'Rathrush (Carlow)', zip: '984947' },
	{ city: 'Rathrushel (Mayo)', zip: '731178' },
	{ city: 'Rathsallagh (Longford)', zip: '797637' },
	{ city: 'Rathsallagh (Tipperary)', zip: '728782' },
	{ city: 'Rathsallagh (Wicklow)', zip: '715959' },
	{ city: 'Rathsallagh Demesne (Wicklow)', zip: '620838' },
	{ city: 'Rathsaran Glebe (Laois)', zip: '466915' },
	{ city: 'Rathsasseragh (Tipperary)', zip: '900937' },
	{ city: 'Rathscanlan (Mayo)', zip: '572776' },
	{ city: 'Rathscanlan (Sligo)', zip: '165368' },
	{ city: 'Rathscannel (Kerry)', zip: '554539' },
	{ city: 'Rathshane (Westmeath)', zip: '222479' },
	{ city: 'Rathshanmore East (Wicklow)', zip: '493187' },
	{ city: 'Rathshanmore South (Wicklow)', zip: '201292' },
	{ city: 'Rathshanmore West (Wicklow)', zip: '496815' },
	{ city: 'Rathshillane (Wexford)', zip: '635176' },
	{ city: 'Rathsillagh (Wexford)', zip: '625842' },
	{ city: 'Rathsillagh Lower (Kildare)', zip: '757137' },
	{ city: 'Rathsillagh Upper (Kildare)', zip: '952701' },
	{ city: 'Rathskeagh Lower (Westmeath)', zip: '284047' },
	{ city: 'Rathskeagh Upper (Westmeath)', zip: '149511' },
	{ city: 'Rathslevin (Mayo)', zip: '422945' },
	{ city: 'Rathsnagadan (Kilkenny)', zip: '322808' },
	{ city: 'Rathstephen (Meath)', zip: '769754' },
	{ city: 'Rathstewart (Kildare)', zip: '574233' },
	{ city: 'Rathtermon (Sligo)', zip: '639074' },
	{ city: 'Rathtillig (Laois)', zip: '640626' },
	{ city: 'Rathtinaun (Sligo)', zip: '928787' },
	{ city: 'Rathtinny Glebe (Donegal)', zip: '194495' },
	{ city: 'Rathtoe (Carlow)', zip: '937897' },
	{ city: 'Rathtoole (Wicklow)', zip: '791898' },
	{ city: 'Rathtrasna (Meath)', zip: '940266' },
	{ city: 'Rathtrim (Westmeath)', zip: '431969' },
	{ city: 'Rathtroane (Meath)', zip: '656041' },
	{ city: 'Rathturtin (Wexford)', zip: '198705' },
	{ city: 'Rathumney (Wexford)', zip: '409611' },
	{ city: 'Rath Upper (Waterford)', zip: '167998' },
	{ city: 'Rath Upper (Westmeath)', zip: '120104' },
	{ city: 'Rathurd (Limerick)', zip: '665058' },
	{ city: 'Rathure North (Offaly)', zip: '828868' },
	{ city: 'Rathure South (Offaly)', zip: '674985' },
	{ city: 'Rathurles (Tipperary)', zip: '295571' },
	{ city: 'Rathurles Commonage (Tipperary)', zip: '507384' },
	{ city: 'Rathurlisk (Sligo)', zip: '889117' },
	{ city: 'Rathvaldron (Longford)', zip: '436677' },
	{ city: 'Rathvallikeen (Cork)', zip: '248931' },
	{ city: 'Rathvarrin (Carlow)', zip: '870992' },
	{ city: 'Rathvergin (Clare)', zip: '479559' },
	{ city: 'Rathvilla (Offaly)', zip: '475866' },
	{ city: 'Rathvilly (Carlow)', zip: '789385' },
	{ city: 'Rathvinden (Carlow)', zip: '855504' },
	{ city: 'Rathwade (Carlow)', zip: '543828' },
	{ city: 'Rathwalkin (Kildare)', zip: '725886' },
	{ city: 'Rathwalter (Tipperary)', zip: '137529' },
	{ city: 'Rath West (Cork)', zip: '676778' },
	{ city: 'Rathwilladoon (Galway)', zip: '805844' },
	{ city: 'Rathwire Lower (Westmeath)', zip: '279034' },
	{ city: 'Rathwire Upper (Westmeath)', zip: '307924' },
	{ city: 'Rathwood (Limerick)', zip: '697851' },
	{ city: 'Rathyark (Wexford)', zip: '883236' },
	{ city: 'Ratoath (Meath)', zip: '377703' },
	{ city: 'Ratoath Manor (Meath)', zip: '853309' },
	{ city: 'Ratooragh (Cork)', zip: '991042' },
	{ city: 'Ratra (Roscommon)', zip: '966175' },
	{ city: 'Ratrass (Westmeath)', zip: '655967' },
	{ city: 'Ratrussan (Cavan)', zip: '820282' },
	{ city: 'Ratteen (Donegal)', zip: '149770' },
	{ city: 'Rattin (Westmeath)', zip: '765090' },
	{ city: 'Rattinagh (Roscommon)', zip: '852013' },
	{ city: 'Rattoo (Kerry)', zip: '368559' },
	{ city: 'Rausakeera North (Mayo)', zip: '656430' },
	{ city: 'Rausakeera South (Mayo)', zip: '602340' },
	{ city: 'Rausker (Monaghan)', zip: '322055' },
	{ city: 'Ravakeel (Cork)', zip: '385875' },
	{ city: 'Ravanny (Louth)', zip: '112248' },
	{ city: 'Raveege (Roscommon)', zip: '430305' },
	{ city: 'Ravel (Louth)', zip: '982320' },
	{ city: 'Ravensdale (Kildare)', zip: '577788' },
	{ city: 'Ravensdale (Louth)', zip: '170485' },
	{ city: 'Ravensdale Park (Louth)', zip: '587836' },
	{ city: 'Ravenswell (Wicklow)', zip: '745901' },
	{ city: 'Raw (Monaghan)', zip: '843104' },
	{ city: 'Rawleystown (Limerick)', zip: '649028' },
	{ city: 'Rawros (Donegal)', zip: '962523' },
	{ city: 'Raws Lower (Donegal)', zip: '457862' },
	{ city: 'Raws Upper (Donegal)', zip: '577039' },
	{ city: 'Ray (Cavan)', zip: '458490' },
	{ city: 'Ray (Donegal)', zip: '867681' },
	{ city: 'Rayhill (Galway)', zip: '313967' },
	{ city: 'Raymoghy (Donegal)', zip: '995269' },
	{ city: 'Raymondstown (Limerick)', zip: '717862' },
	{ city: 'Raynestown (Meath)', zip: '373387' },
	{ city: 'Raystown (Meath)', zip: '521888' },
	{ city: 'Rea (Cork)', zip: '309634' },
	{ city: 'Rea (Kerry)', zip: '166586' },
	{ city: 'Rea-Allen (Cork)', zip: '486845' },
	{ city: 'Reaboy (Kerry)', zip: '288129' },
	{ city: 'Reacashlagh (Kerry)', zip: '110823' },
	{ city: 'Reacaslagh (Kerry)', zip: '675317' },
	{ city: 'Reacaumaglanna (Waterford)', zip: '774967' },
	{ city: 'Readesbarn (Kilkenny)', zip: '295563' },
	{ city: 'Readoty (Waterford)', zip: '481791' },
	{ city: 'Readrinagh (Kerry)', zip: '634051' },
	{ city: 'Readsland (Meath)', zip: '152237' },
	{ city: 'Readstown (Meath)', zip: '773195' },
	{ city: 'Readypenny (Louth)', zip: '237982' },
	{ city: 'Reafadda (Tipperary)', zip: '718866' },
	{ city: 'Reagh (Cork)', zip: '681253' },
	{ city: 'Reagh (Roscommon)', zip: '247399' },
	{ city: 'Reaghan (Galway)', zip: '447200' },
	{ city: 'Reaghfa (Clare)', zip: '191908' },
	{ city: 'Reaghstown (Louth)', zip: '912272' },
	{ city: 'Reagoulane (Tipperary)', zip: '539558' },
	{ city: 'Reagrellagh (Cork)', zip: '882774' },
	{ city: 'Reagrove (Cork)', zip: '275942' },
	{ city: 'Reahouse (Wexford)', zip: '661113' },
	{ city: 'Realtoge (Meath)', zip: '186802' },
	{ city: 'Reamanagh (Waterford)', zip: '513688' },
	{ city: 'Reamanagh East (Waterford)', zip: '577371' },
	{ city: 'Reamanagh West (Waterford)', zip: '866675' },
	{ city: 'Reanabarna (Waterford)', zip: '782697' },
	{ city: 'Reanabobul (Cork)', zip: '979278' },
	{ city: 'Reanaboola (Waterford)', zip: '295050' },
	{ city: 'Reanabrone (Clare)', zip: '877315' },
	{ city: 'Reanacaheragh (Cork)', zip: '803076' },
	{ city: 'Reanaclogheen (Waterford)', zip: '566543' },
	{ city: 'Reanacoolagh East (Waterford)', zip: '749679' },
	{ city: 'Reanacoolagh West (Waterford)', zip: '494248' },
	{ city: 'Reanadampaun Commons (Waterford)', zip: '925205' },
	{ city: 'Reanagashel (Cork)', zip: '518276' },
	{ city: 'Reanagillee Commons (Limerick)', zip: '916823' },
	{ city: 'Reanagishagh (Clare)', zip: '984070' },
	{ city: 'Reanagowan (Kerry)', zip: '388734' },
	{ city: 'Reanagullee (Waterford)', zip: '173868' },
	{ city: 'Reanahoun (Cork)', zip: '959964' },
	{ city: 'Reanahumana (Clare)', zip: '105736' },
	{ city: 'Reananerree (Cork)', zip: '976322' },
	{ city: 'Reanascreena (Cork)', zip: '152132' },
	{ city: 'Reanascreena North (Cork)', zip: '175660' },
	{ city: 'Reanascreena South (Cork)', zip: '240527' },
	{ city: 'Reanaskeha (Waterford)', zip: '631364' },
	{ city: 'Reanasup (Kerry)', zip: '344588' },
	{ city: 'Reanaviddoge (Waterford)', zip: '842320' },
	{ city: 'Reandallane (Cork)', zip: '377615' },
	{ city: 'Reanduff (Cork)', zip: '748386' },
	{ city: 'Reaniesglen (Cork)', zip: '273341' },
	{ city: 'Reanieshouse (Cork)', zip: '164981' },
	{ city: 'Rearahinagh (Cork)', zip: '792792' },
	{ city: 'Rear Cross (Tipperary)', zip: '610090' },
	{ city: 'Reardnogy Beg (Tipperary)', zip: '759399' },
	{ city: 'Reardnogy More (Tipperary)', zip: '344813' },
	{ city: 'Rearoe (Tipperary)', zip: '992411' },
	{ city: 'Rearour (Cork)', zip: '169872' },
	{ city: 'Rearour And Barrettshill (Cork)', zip: '124328' },
	{ city: 'Rearour North (Cork)', zip: '633778' },
	{ city: 'Rearour South (Cork)', zip: '327898' },
	{ city: 'Reary Beg (Laois)', zip: '608557' },
	{ city: 'Reary More (Laois)', zip: '121029' },
	{ city: 'Rearyvalley (Laois)', zip: '873158' },
	{ city: 'Reask (Cavan)', zip: '659007' },
	{ city: 'Reask (Galway)', zip: '106942' },
	{ city: 'Reask (Kerry)', zip: '455072' },
	{ city: 'Reask (Limerick)', zip: '317657' },
	{ city: 'Reask (Mayo)', zip: '619663' },
	{ city: 'Reask (Meath)', zip: '704295' },
	{ city: 'Reask (Sligo)', zip: '837599' },
	{ city: 'Reaskaun (Clare)', zip: '659462' },
	{ city: 'Reaskavalla (Tipperary)', zip: '435428' },
	{ city: 'Reaskcamoge (Clare)', zip: '168090' },
	{ city: 'Reaskgarriff (Galway)', zip: '739907' },
	{ city: 'Reaskmore (Galway)', zip: '476281' },
	{ city: 'Reaskrevagh (Galway)', zip: '259790' },
	{ city: 'Reatagh (Waterford)', zip: '666207' },
	{ city: 'Reavaun (Kerry)', zip: '408754' },
	{ city: 'Reavilleen (Cork)', zip: '425160' },
	{ city: 'Reavouler (Cork)', zip: '447299' },
	{ city: 'Rebane (Monaghan)', zip: '402362' },
	{ city: 'Reboge (Limerick)', zip: '163891' },
	{ city: 'Reboge Meadows (Limerick)', zip: '500902' },
	{ city: 'Recess (Galway)', zip: '387366' },
	{ city: 'Redacres North (Kilkenny)', zip: '832158' },
	{ city: 'Redacres South (Kilkenny)', zip: '974306' },
	{ city: 'Redbarn (Cork)', zip: '989977' },
	{ city: 'Redbog (Carlow)', zip: '741682' },
	{ city: 'Redbog (Kildare)', zip: '612346' },
	{ city: 'Redbog (Kilkenny)', zip: '591054' },
	{ city: 'Redbog (Louth)', zip: '557154' },
	{ city: 'Redbog (Meath)', zip: '667388' },
	{ city: 'Redbrae (Leitrim)', zip: '738243' },
	{ city: 'Redcastle (Donegal)', zip: '592804' },
	{ city: 'Redcastle (Laois)', zip: '717994' },
	{ city: 'Redcity (Tipperary)', zip: '161236' },
	{ city: 'Redcow (Dublin)', zip: '322793' },
	{ city: 'Redcow (Louth)', zip: '254691' },
	{ city: 'Redcowfarm (Dublin)', zip: '861950' },
	{ city: 'Redcross (Wicklow)', zip: '330467' },
	{ city: 'Reddanswalk (Tipperary)', zip: '836211' },
	{ city: 'Reddina (Wexford)', zip: '651350' },
	{ city: 'Reddysland (Wexford)', zip: '413237' },
	{ city: 'Redeen (Kilkenny)', zip: '686269' },
	{ city: 'Redflag Island (Galway)', zip: '220579' },
	{ city: 'Redford Glebe (Donegal)', zip: '706349' },
	{ city: 'Redgap (Dublin)', zip: '440808' },
	{ city: 'Redgap (Kilkenny)', zip: '115435' },
	{ city: 'Redhill (Mayo)', zip: '203795' },
	{ city: 'Redhill Demesne (Cavan)', zip: '484612' },
	{ city: 'Redhills (Cavan)', zip: '831763' },
	{ city: 'Redhills (Kildare)', zip: '776163' },
	{ city: 'Redhills (Laois)', zip: '696295' },
	{ city: 'Redhouse (Kilkenny)', zip: '868318' },
	{ city: 'Redhouse (Wexford)', zip: '828116' },
	{ city: 'Red Island (Galway)', zip: '506541' },
	{ city: 'Red Island (Mayo)', zip: '725609' },
	{ city: 'Redmondstown (Tipperary)', zip: '945902' },
	{ city: 'Redmondstown (Westmeath)', zip: '317207' },
	{ city: 'Redmondstown (Wexford)', zip: '470436' },
	{ city: 'Redmoor (Wexford)', zip: '380756' },
	{ city: 'Redmountain (Meath)', zip: '187042' },
	{ city: 'Redpark (Galway)', zip: '715291' },
	{ city: 'Redtrench North (Kerry)', zip: '631169' },
	{ city: 'Redtrench South (Kerry)', zip: '699127' },
	{ city: 'Reduff (Monaghan)', zip: '320127' },
	{ city: 'Redwood (Tipperary)', zip: '283533' },
	{ city: 'Reechestown (Tipperary)', zip: '143972' },
	{ city: 'Reedstown (Wexford)', zip: '728744' },
	{ city: 'Reen (Cork)', zip: '705335' },
	{ city: 'Reen (Kerry)', zip: '723649' },
	{ city: 'Reenabulliga (Cork)', zip: '359102' },
	{ city: 'Reenacappul (Cork)', zip: '547075' },
	{ city: 'Reenadisert (Cork)', zip: '897582' },
	{ city: 'Reenaknock (Cork)', zip: '439199' },
	{ city: 'Reenard (Kerry)', zip: '720023' },
	{ city: 'Reenavanna East (Limerick)', zip: '443398' },
	{ city: 'Reenavanna West (Limerick)', zip: '431143' },
	{ city: 'Reenavanny (Cork)', zip: '276496' },
	{ city: 'Reenbeg (Kerry)', zip: '345485' },
	{ city: 'Reenboy (Kerry)', zip: '494093' },
	{ city: 'Reencaheragh (Kerry)', zip: '541471' },
	{ city: 'Reenconnell (Kerry)', zip: '280335' },
	{ city: 'Reencorreen (Cork)', zip: '526694' },
	{ city: 'Reendacussane (Cork)', zip: '847463' },
	{ city: 'Reenearagh (Kerry)', zip: '372008' },
	{ city: 'Reengarrigeen (Cork)', zip: '570246' },
	{ city: 'Reenkilla (Kerry)', zip: '833677' },
	{ city: 'Reenmeen East (Cork)', zip: '575038' },
	{ city: 'Reenmeen West (Cork)', zip: '988107' },
	{ city: 'Reenmurragha (Cork)', zip: '991108' },
	{ city: 'Reennacoola (Kerry)', zip: '177333' },
	{ city: 'Reennanallagane (Kerry)', zip: '432222' },
	{ city: 'Reenogrena (Cork)', zip: '578063' },
	{ city: 'Reenroe (Cork)', zip: '891666' },
	{ city: 'Reenroe (Kerry)', zip: '661658' },
	{ city: 'Reenrour East (Cork)', zip: '717306' },
	{ city: 'Reenrour West (Cork)', zip: '697884' },
	{ city: 'Reens East (Limerick)', zip: '341726' },
	{ city: 'Reens West (Limerick)', zip: '620745' },
	{ city: 'Reentrusk (Cork)', zip: '830172' },
	{ city: 'Reenturk (Kerry)', zip: '148149' },
	{ city: 'Reenydonagan (Cork)', zip: '304447' },
	{ city: 'Reerasta North (Limerick)', zip: '987561' },
	{ city: 'Reerasta South (Limerick)', zip: '654594' },
	{ city: 'Reevanagh (Kilkenny)', zip: '600401' },
	{ city: 'Reeves (Kildare)', zip: '247084' },
	{ city: 'Regaile (Tipperary)', zip: '509860' },
	{ city: 'Regan (Wexford)', zip: '240341' },
	{ city: 'Regeens (Dublin)', zip: '880352' },
	{ city: 'Regles (Dublin)', zip: '229848' },
	{ city: 'Rehill (Kerry)', zip: '588700' },
	{ city: 'Rehill (Tipperary)', zip: '628742' },
	{ city: 'Rehy East (Clare)', zip: '645554' },
	{ city: 'Rehy West (Clare)', zip: '275509' },
	{ city: 'Reisk (Tipperary)', zip: '734107' },
	{ city: 'Reisk (Waterford)', zip: '316624' },
	{ city: 'Relagh Beg (Cavan)', zip: '806037' },
	{ city: 'Relagh More (Cavan)', zip: '878517' },
	{ city: 'Releagh (Kerry)', zip: '178397' },
	{ city: 'Relick (Westmeath)', zip: '940683' },
	{ city: 'Remeen (Kilkenny)', zip: '382455' },
	{ city: 'Renaghmore (Tipperary)', zip: '423546' },
	{ city: 'Renalicka (Clare)', zip: '686739' },
	{ city: 'Renny Lower (Cork)', zip: '571497' },
	{ city: 'Renny Upper (Cork)', zip: '854098' },
	{ city: 'Rerrin (Cork)', zip: '828823' },
	{ city: 'Retreat (Westmeath)', zip: '879481' },
	{ city: 'Reviewfields (Kilkenny)', zip: '735240' },
	{ city: 'Revlin (Donegal)', zip: '426861' },
	{ city: 'Reycroftspark (Roscommon)', zip: '590545' },
	{ city: 'Reynabrone (Galway)', zip: '509435' },
	{ city: 'Reynclamper (Galway)', zip: '729208' },
	{ city: 'Reynella (Westmeath)', zip: '791054' },
	{ city: 'Reynoldstown (Dublin)', zip: '351436' },
	{ city: 'Reynoldstown (Louth)', zip: '985034' },
	{ city: 'Reyrawer (Galway)', zip: '247542' },
	{ city: 'Rhine (Longford)', zip: '446049' },
	{ city: 'Rhode (Offaly)', zip: '874972' },
	{ city: 'Ribstown (Meath)', zip: '592635' },
	{ city: 'Ricesland (Kilkenny)', zip: '291099' },
	{ city: 'Ricetown (Meath)', zip: '497000' },
	{ city: 'Richardstown (Cork)', zip: '151444' },
	{ city: 'Richardstown (Dublin)', zip: '396813' },
	{ city: 'Richardstown (Kildare)', zip: '398220' },
	{ city: 'Richardstown (Louth)', zip: '739837' },
	{ city: 'Richardstown (Meath)', zip: '969478' },
	{ city: 'Richard Taaffes Holding (Louth)', zip: '132014' },
	{ city: 'Richfield (Wexford)', zip: '754924' },
	{ city: 'Richhill (Limerick)', zip: '241958' },
	{ city: 'Richmond (Galway)', zip: '468683' },
	{ city: 'Richmond (Mayo)', zip: '806792' },
	{ city: 'Richmond (Tipperary)', zip: '256876' },
	{ city: 'Richmondvilla (Limerick)', zip: '918714' },
	{ city: 'Rickardsland North (Kilkenny)', zip: '780862' },
	{ city: 'Rickardsland South (Kilkenny)', zip: '232824' },
	{ city: 'Rickardstown (Kildare)', zip: '653576' },
	{ city: 'Rickardstown (Westmeath)', zip: '142696' },
	{ city: 'Rickardstown (Wexford)', zip: '340325' },
	{ city: 'Rickardstown Lower (Kildare)', zip: '714009' },
	{ city: 'Rickardstown Upper (Kildare)', zip: '877746' },
	{ city: 'Ricketstown (Carlow)', zip: '932353' },
	{ city: 'Ricketstown North (Carlow)', zip: '136586' },
	{ city: 'Ricketstown South (Carlow)', zip: '695211' },
	{ city: 'Riddlestown (Limerick)', zip: '688405' },
	{ city: 'Ridge (Carlow)', zip: '680723' },
	{ city: 'Ridge (Kilkenny)', zip: '919146' },
	{ city: 'Riesk (Cork)', zip: '101350' },
	{ city: 'Riesk (Kilkenny)', zip: '262967' },
	{ city: 'Riesk (Wexford)', zip: '776800' },
	{ city: 'Riggins (Meath)', zip: '346622' },
	{ city: 'Rigsdale (Cork)', zip: '485040' },
	{ city: 'Rin (Offaly)', zip: '250872' },
	{ city: 'Rinagall (Mayo)', zip: '361362' },
	{ city: 'Rinaghan (Kildare)', zip: '423125' },
	{ city: 'Rinagry (Mayo)', zip: '679777' },
	{ city: 'Rinakilleen (Mayo)', zip: '960014' },
	{ city: 'Rinanagh (Mayo)', zip: '398951' },
	{ city: 'Rinaneel (Mayo)', zip: '564046' },
	{ city: 'Rinanny (Roscommon)', zip: '888452' },
	{ city: 'Rinawade Lower (Kildare)', zip: '203209' },
	{ city: 'Rinawade Upper (Kildare)', zip: '253669' },
	{ city: 'Rinbaun (Sligo)', zip: '373398' },
	{ city: 'Rinboy (Donegal)', zip: '709313' },
	{ city: 'Rinbrack (Mayo)', zip: '606774' },
	{ city: 'Rinclevan (Donegal)', zip: '606486' },
	{ city: 'Rincoolagh (Longford)', zip: '665662' },
	{ city: 'Rincrew (Waterford)', zip: '621234' },
	{ city: 'Rincullia (Limerick)', zip: '758441' },
	{ city: 'Rindifin (Galway)', zip: '935114' },
	{ city: 'Rine (Clare)', zip: '553639' },
	{ city: 'Rineanna North (Clare)', zip: '637872' },
	{ city: 'Rineanna South (Clare)', zip: '475528' },
	{ city: 'Rinecaha (Clare)', zip: '530795' },
	{ city: 'Rineen (Cork)', zip: '431609' },
	{ city: 'Rinelea (Clare)', zip: '998767' },
	{ city: 'Rinemackaderrig (Clare)', zip: '482695' },
	{ city: 'Rineroe (Clare)', zip: '873120' },
	{ city: 'Rineroe (Limerick)', zip: '961902' },
	{ city: 'Rinerrinagh (Clare)', zip: '114996' },
	{ city: 'Ring (Cork)', zip: '476418' },
	{ city: 'Ring (Dublin)', zip: '821933' },
	{ city: 'Ring (Wexford)', zip: '240038' },
	{ city: 'Ringabella (Cork)', zip: '643842' },
	{ city: 'Ringacoltig (Cork)', zip: '393296' },
	{ city: 'Ringaheen (Wexford)', zip: '348558' },
	{ city: 'Ringaphuca (Waterford)', zip: '110223' },
	{ city: 'Ringarraun (Mayo)', zip: '414215' },
	{ city: 'Ringaskiddy (Cork)', zip: '409405' },
	{ city: 'Ringbaun (Wexford)', zip: '355857' },
	{ city: 'Ringbaun Burrow (Wexford)', zip: '784190' },
	{ city: 'Ring Commons (Dublin)', zip: '960864' },
	{ city: 'Ringcrehy (Waterford)', zip: '416552' },
	{ city: 'Ring East (Cork)', zip: '257367' },
	{ city: 'Ringeelaun (Galway)', zip: '388669' },
	{ city: 'Ringfinnan (Cork)', zip: '538956' },
	{ city: 'Ring Green (Wexford)', zip: '378106' },
	{ city: 'Ringknock (Wexford)', zip: '888800' },
	{ city: 'Ringlestown (Meath)', zip: '477314' },
	{ city: 'Ring Little (Wexford)', zip: '266649' },
	{ city: 'Ringmeen (Cork)', zip: '265454' },
	{ city: 'Ringmoylan (Limerick)', zip: '141410' },
	{ city: 'Ringnanean (Cork)', zip: '338864' },
	{ city: 'Ringnasilloge (Waterford)', zip: '742140' },
	{ city: 'Ringowny (Longford)', zip: '402281' },
	{ city: 'Ringroe (Cork)', zip: '687904' },
	{ city: 'Ringroe (Tipperary)', zip: '143991' },
	{ city: 'Ringrone (Cork)', zip: '360939' },
	{ city: 'Ringsend (Dublin)', zip: '921501' },
	{ city: 'Ringsherane (Wexford)', zip: '867478' },
	{ city: 'Ringstown (Laois)', zip: '358746' },
	{ city: 'Ringstown (Westmeath)', zip: '207434' },
	{ city: 'Ringville (Cork)', zip: '782798' },
	{ city: 'Ringville (Kilkenny)', zip: '927726' },
	{ city: 'Ringville (Waterford)', zip: '661334' },
	{ city: 'Ring West (Cork)', zip: '408624' },
	{ city: 'Ringwood (Dublin)', zip: '928020' },
	{ city: 'Ringwood (Kilkenny)', zip: '614381' },
	{ city: 'Rinkinstown (Louth)', zip: '661952' },
	{ city: 'Rinkippeen (Galway)', zip: '977382' },
	{ city: 'Rinmore (Donegal)', zip: '294176' },
	{ city: 'Rinmore (Mayo)', zip: '975248' },
	{ city: 'Rinn (Cavan)', zip: '769239' },
	{ city: 'Rinn (Galway)', zip: '545492' },
	{ city: 'Rinn (Laois)', zip: '770611' },
	{ city: 'Rinn (Leitrim)', zip: '279522' },
	{ city: 'Rinn (Mayo)', zip: '435883' },
	{ city: 'Rinn (Roscommon)', zip: '925971' },
	{ city: 'Rinn (Sligo)', zip: '691960' },
	{ city: 'Rinnacurreen (Leitrim)', zip: '414947' },
	{ city: 'Rinnafarset (Donegal)', zip: '923241' },
	{ city: 'Rinnagan (Roscommon)', zip: '459198' },
	{ city: 'Rinnagowna (Leitrim)', zip: '658162' },
	{ city: 'Rinnaharney (Galway)', zip: '962205' },
	{ city: 'Rinnahulty (Mayo)', zip: '799921' },
	{ city: 'Rinnakill (Donegal)', zip: '298664' },
	{ city: 'Rinnaknock (Galway)', zip: '664525' },
	{ city: 'Rinnamart (Donegal)', zip: '915075' },
	{ city: 'Rinnamona (Clare)', zip: '976389' },
	{ city: 'Rinnananny (Mayo)', zip: '776964' },
	{ city: 'Rinnaraw (Donegal)', zip: '449558' },
	{ city: 'Rinnarogue (Sligo)', zip: '294793' },
	{ city: 'Rinnaseer (Mayo)', zip: '193102' },
	{ city: 'Rinnashinnagh (Mayo)', zip: '410171' },
	{ city: 'Rinnasligo (Donegal)', zip: '733149' },
	{ city: 'Rinneen (Clare)', zip: '466770' },
	{ city: 'Rinneen (Galway)', zip: '578954' },
	{ city: 'Rinneen (Kerry)', zip: '829887' },
	{ city: 'Rinnenny (Longford)', zip: '805101' },
	{ city: 'Rinnerroon (Galway)', zip: '890613' },
	{ city: 'Rinrainy Island (Donegal)', zip: '753422' },
	{ city: 'Rinroe (Clare)', zip: '450137' },
	{ city: 'Rinroe (Longford)', zip: '600119' },
	{ city: 'Rinroe (Sligo)', zip: '996594' },
	{ city: 'Rinrush (Galway)', zip: '512184' },
	{ city: 'Rinshinna (Mayo)', zip: '617330' },
	{ city: 'Rinskea (Clare)', zip: '518446' },
	{ city: 'Rintulla (Limerick)', zip: '125494' },
	{ city: 'Rinvanny (Longford)', zip: '281291' },
	{ city: 'Rinville East (Galway)', zip: '907150' },
	{ city: 'Rinville West (Galway)', zip: '913253' },
	{ city: 'Riscrann (Wexford)', zip: '397105' },
	{ city: 'Riverdale (Westmeath)', zip: '152860' },
	{ city: 'Riverlawn (Tipperary)', zip: '992662' },
	{ city: 'Rivers (Limerick)', zip: '180009' },
	{ city: 'Riversdale (Galway)', zip: '212395' },
	{ city: 'Riversfield (Kilkenny)', zip: '898117' },
	{ city: 'Riversfield (Limerick)', zip: '402684' },
	{ city: 'Riverstick (Cork)', zip: '303409' },
	{ city: 'Riverstown (Cork)', zip: '287848' },
	{ city: 'Riverstown (Kildare)', zip: '895889' },
	{ city: 'Riverstown (Louth)', zip: '150581' },
	{ city: 'Riverstown (Meath)', zip: '433002' },
	{ city: 'Riverstown (Sligo)', zip: '869083' },
	{ city: 'Riverstown (Westmeath)', zip: '384298' },
	{ city: 'Riverstown (Wexford)', zip: '651532' },
	{ city: 'Riverview (Wexford)', zip: '638734' },
	{ city: 'Rivory (Cavan)', zip: '104917' },
	{ city: 'Roachpond (Kilkenny)', zip: '334601' },
	{ city: 'Road (Offaly)', zip: '600272' },
	{ city: 'Roadmain (Meath)', zip: '272106' },
	{ city: 'Roadquarter (Roscommon)', zip: '210258' },
	{ city: 'Roads (Kerry)', zip: '938898' },
	{ city: 'Roan (Tipperary)', zip: '681667' },
	{ city: 'Roanstown (Meath)', zip: '646512' },
	{ city: 'Robeen (Mayo)', zip: '986707' },
	{ city: 'Robeenard (Mayo)', zip: '559653' },
	{ city: 'Robertshill (Kilkenny)', zip: '685752' },
	{ city: 'Robertstown (Cork)', zip: '426197' },
	{ city: 'Robertstown (Kildare)', zip: '180773' },
	{ city: 'Robertstown (Limerick)', zip: '883660' },
	{ city: 'Robertstown (Meath)', zip: '959641' },
	{ city: 'Robertstown (Waterford)', zip: '856015' },
	{ city: 'Robertstown East (Kildare)', zip: '150072' },
	{ city: 'Robertstown West (Kildare)', zip: '483872' },
	{ city: 'Robinhood (Dublin)', zip: '521066' },
	{ city: 'Robinrath (Meath)', zip: '684846' },
	{ city: 'Robinstown (Kilkenny)', zip: '874188' },
	{ city: 'Robinstown (Longford)', zip: '896073' },
	{ city: 'Robinstown (Meath)', zip: '244890' },
	{ city: 'Robinstown (Westmeath)', zip: '683797' },
	{ city: 'Robinstown (Wexford)', zip: '510043' },
	{ city: 'Robinstown Great (Westmeath)', zip: '862332' },
	{ city: 'Robinstown Great (Wexford)', zip: '154373' },
	{ city: 'Robinstown Little (Westmeath)', zip: '598571' },
	{ city: 'Robinstown Little (Wexford)', zip: '363588' },
	{ city: 'Robinstown Lower (Westmeath)', zip: '659946' },
	{ city: 'Robinstown Upper (Westmeath)', zip: '448049' },
	{ city: 'Robswalls (Dublin)', zip: '946869' },
	{ city: 'Roche (Louth)', zip: '296444' },
	{ city: 'Rocheshill (Dublin)', zip: '694320' },
	{ city: 'Rochestown (Cork)', zip: '493869' },
	{ city: 'Rochestown (Dublin)', zip: '582926' },
	{ city: 'Rochestown (Kildare)', zip: '906421' },
	{ city: 'Rochestown (Kilkenny)', zip: '449861' },
	{ city: 'Rochestown (Limerick)', zip: '399271' },
	{ city: 'Rochestown (Meath)', zip: '247864' },
	{ city: 'Rochestown (Tipperary)', zip: '266690' },
	{ city: 'Rochestown (Westmeath)', zip: '823270' },
	{ city: 'Rochestown (Wexford)', zip: '352285' },
	{ city: 'Rochestown Domain (Dublin)', zip: '991282' },
	{ city: 'Rochfordstown (Cork)', zip: '694296' },
	{ city: 'Rochfortbridge (Westmeath)', zip: '278873' },
	{ city: 'Rochfort Demesne (Westmeath)', zip: '424421' },
	{ city: 'Rock (Donegal)', zip: '611756' },
	{ city: 'Rock (Dublin)', zip: '885204' },
	{ city: 'Rock (Kildare)', zip: '293628' },
	{ city: 'Rock (Louth)', zip: '971296' },
	{ city: 'Rock (Roscommon)', zip: '768765' },
	{ city: 'Rockbarton (Limerick)', zip: '762694' },
	{ city: 'Rock Big (Wicklow)', zip: '820057' },
	{ city: 'Rockbog (Wicklow)', zip: '121892' },
	{ city: 'Rockborough (Cork)', zip: '822918' },
	{ city: 'Rockbrook (Dublin)', zip: '658304' },
	{ city: 'Rockbrook (Sligo)', zip: '195732' },
	{ city: 'Rockchapel (Cork)', zip: '590211' },
	{ city: 'Rockcorry (Monaghan)', zip: '266133' },
	{ city: 'Rocker (Tipperary)', zip: '619992' },
	{ city: 'Rockfarm (Limerick)', zip: '990021' },
	{ city: 'Rockfield (Cavan)', zip: '484541' },
	{ city: 'Rockfield (Donegal)', zip: '800352' },
	{ city: 'Rockfield (Dublin)', zip: '466398' },
	{ city: 'Rockfield (Galway)', zip: '900901' },
	{ city: 'Rockfield (Kerry)', zip: '242128' },
	{ city: 'Rockfield (Limerick)', zip: '493143' },
	{ city: 'Rockfield (Mayo)', zip: '333591' },
	{ city: 'Rockfield (Meath)', zip: '425501' },
	{ city: 'Rockfield (Waterford)', zip: '280910' },
	{ city: 'Rockfield East (Galway)', zip: '460283' },
	{ city: 'Rockfield East (Kerry)', zip: '698500' },
	{ city: 'Rockfield Middle (Kerry)', zip: '504841' },
	{ city: 'Rockfield West (Galway)', zip: '291735' },
	{ city: 'Rockfield West (Kerry)', zip: '906550' },
	{ city: 'Rockfinlough (Sligo)', zip: '340439' },
	{ city: 'Rockfleet (Mayo)', zip: '568698' },
	{ city: 'Rockforest (Tipperary)', zip: '407344' },
	{ city: 'Rockforest East (Cork)', zip: '207840' },
	{ city: 'Rockforest West (Cork)', zip: '821440' },
	{ city: 'Rockfort (Cork)', zip: '188900' },
	{ city: 'Rockgrove (Cork)', zip: '807133' },
	{ city: 'Rockhill (Donegal)', zip: '971372' },
	{ city: 'Rockhill (Galway)', zip: '289519' },
	{ city: 'Rockhill (Roscommon)', zip: '213935' },
	{ city: 'Rockhill East (Cork)', zip: '359344' },
	{ city: 'Rockhill West (Cork)', zip: '694269' },
	{ city: 'Rockhouse (Cork)', zip: '433723' },
	{ city: 'Rockingham Demesne (Roscommon)', zip: '996165' },
	{ city: 'Rock Island (Cork)', zip: '222706' },
	{ city: 'Rock Island (Galway)', zip: '214206' },
	{ city: 'Rockland (Roscommon)', zip: '519933' },
	{ city: 'Rocklands (Galway)', zip: '596905' },
	{ city: 'Rock Little (Wicklow)', zip: '311354' },
	{ city: 'Rocklow (Tipperary)', zip: '563484' },
	{ city: 'Rockmarshall (Louth)', zip: '374196' },
	{ city: 'Rock Of Ballingly (Wexford)', zip: '960197' },
	{ city: 'Rockpark (Galway)', zip: '733486' },
	{ city: 'Rockpeyton (Longford)', zip: '620043' },
	{ city: 'Rocks (Cavan)', zip: '551940' },
	{ city: 'Rocksavage (Carlow)', zip: '284942' },
	{ city: 'Rocksavage (Cork)', zip: '990395' },
	{ city: 'Rocksborough (Wexford)', zip: '759540' },
	{ city: 'Rocksborough North (Mayo)', zip: '279450' },
	{ city: 'Rocksborough South (Mayo)', zip: '146867' },
	{ city: 'Rockshire (Kilkenny)', zip: '283636' },
	{ city: 'Rockspring (Cork)', zip: '199496' },
	{ city: 'Rockspring (Wexford)', zip: '448187' },
	{ city: 'Rockstown (Limerick)', zip: '381815' },
	{ city: 'Rockstown Lower (Wicklow)', zip: '916190' },
	{ city: 'Rockstown Upper (Wicklow)', zip: '420480' },
	{ city: 'Rockvale (Clare)', zip: '235336' },
	{ city: 'Rockvale (Tipperary)', zip: '354001' },
	{ city: 'Rockview (Tipperary)', zip: '737190' },
	{ city: 'Rockville (Roscommon)', zip: '345645' },
	{ city: 'Rockwell (Tipperary)', zip: '773157' },
	{ city: 'Rockwood (Galway)', zip: '379986' },
	{ city: 'Rodanstown (Meath)', zip: '815924' },
	{ city: 'Roddenagh (Wicklow)', zip: '565885' },
	{ city: 'Rodeen (Cork)', zip: '447770' },
	{ city: 'Rodeen (Roscommon)', zip: '665630' },
	{ city: 'Rodeen (Waterford)', zip: '384282' },
	{ city: 'Rodeen Lower (Tipperary)', zip: '965817' },
	{ city: 'Rodeen Upper (Tipperary)', zip: '315999' },
	{ city: 'Roden (Tipperary)', zip: '588256' },
	{ city: 'Rodstown (Meath)', zip: '393019' },
	{ city: 'Rodus (Tipperary)', zip: '103500' },
	{ city: 'Roebuck (Cavan)', zip: '231534' },
	{ city: 'Roebuck (Dublin)', zip: '611423' },
	{ city: "Roebuck's-Land (Tipperary)", zip: '786278' },
	{ city: 'Roechrow (Donegal)', zip: '916226' },
	{ city: 'Roegarraun (Tipperary)', zip: '670788' },
	{ city: 'Roeillan (Mayo)', zip: '498147' },
	{ city: 'Roeillaun (Galway)', zip: '232796' },
	{ city: 'Roeillaunbaun (Galway)', zip: '879464' },
	{ city: 'Roeillaundoo (Galway)', zip: '862275' },
	{ city: 'Roeillaun East (Galway)', zip: '122333' },
	{ city: 'Roeillaun South (Galway)', zip: '729733' },
	{ city: 'Roekilmeena (Mayo)', zip: '247987' },
	{ city: 'Roelough (Donegal)', zip: '272200' },
	{ city: 'Roemore (Mayo)', zip: '453094' },
	{ city: 'Roes (Donegal)', zip: '205659' },
	{ city: 'Roesborough (Tipperary)', zip: '683528' },
	{ city: 'Roestown (Kildare)', zip: '753512' },
	{ city: 'Roestown (Louth)', zip: '454199' },
	{ city: 'Roestown (Meath)', zip: '779044' },
	{ city: 'Roevehagh (Galway)', zip: '476459' },
	{ city: 'Roganspark (Donegal)', zip: '256917' },
	{ city: 'Roganstown (Dublin)', zip: '999420' },
	{ city: 'Rogary (Cavan)', zip: '329102' },
	{ city: 'Rogerstown (Dublin)', zip: '156315' },
	{ city: 'Rogerstown (Kilkenny)', zip: '371347' },
	{ city: 'Rogerstown (Louth)', zip: '470254' },
	{ city: 'Rogerstown (Meath)', zip: '808435' },
	{ city: 'Rogerstown (Offaly)', zip: '787186' },
	{ city: 'Rogerstown (Westmeath)', zip: '923721' },
	{ city: 'Rokeby (Louth)', zip: '214514' },
	{ city: 'Rolagh (Meath)', zip: '829232' },
	{ city: 'Ronanstown (Dublin)', zip: '363848' },
	{ city: 'Ronard (Cavan)', zip: '269189' },
	{ city: 'Roo (Cavan)', zip: '414276' },
	{ city: 'Roo (Galway)', zip: '524662' },
	{ city: 'Roo (Monaghan)', zip: '699853' },
	{ city: 'Roo (Roscommon)', zip: '556901' },
	{ city: 'Rooan (Westmeath)', zip: '319118' },
	{ city: 'Rooaun (Galway)', zip: '602927' },
	{ city: 'Rooaun (Offaly)', zip: '200773' },
	{ city: 'Rooaun (Roscommon)', zip: '138998' },
	{ city: 'Rooaunalaghta (Mayo)', zip: '707879' },
	{ city: 'Rooaun Bog And Meadow (Roscommon)', zip: '953849' },
	{ city: 'Rooaunmore (Galway)', zip: '713601' },
	{ city: 'Roo Demesne (Galway)', zip: '739423' },
	{ city: 'Roodstown (Louth)', zip: '520052' },
	{ city: 'Roo East (Clare)', zip: '385539' },
	{ city: 'Rooghan (Galway)', zip: '938580' },
	{ city: 'Rooghan (Mayo)', zip: '194230' },
	{ city: 'Rooghan (Sligo)', zip: '275859' },
	{ city: 'Rooghaun (Galway)', zip: '369161' },
	{ city: 'Rooghaun (Mayo)', zip: '507457' },
	{ city: 'Rookwood (Galway)', zip: '928204' },
	{ city: 'Roolagh (Tipperary)', zip: '665003' },
	{ city: 'Roonah (Mayo)', zip: '662723' },
	{ city: 'Roonkeel (Mayo)', zip: '819118' },
	{ city: 'Roos (Longford)', zip: '943590' },
	{ city: 'Roos (Mayo)', zip: '177504' },
	{ city: 'Roosca (Tipperary)', zip: '724837' },
	{ city: 'Roosk (Cork)', zip: '166568' },
	{ city: 'Roosk (Kildare)', zip: '228953' },
	{ city: 'Roosk (Offaly)', zip: '211890' },
	{ city: 'Rooska (Clare)', zip: '917333' },
	{ city: 'Rooska East (Cork)', zip: '247310' },
	{ city: 'Rooskagh (Cork)', zip: '708369' },
	{ city: 'Rooskagh (Roscommon)', zip: '719729' },
	{ city: 'Rooskagh East (Limerick)', zip: '571578' },
	{ city: 'Rooskagh West (Limerick)', zip: '963204' },
	{ city: 'Rooska West (Cork)', zip: '949633' },
	{ city: 'Roosky (Cavan)', zip: '379403' },
	{ city: 'Roosky (Donegal)', zip: '549029' },
	{ city: 'Roosky (Leitrim)', zip: '383585' },
	{ city: 'Roosky (Mayo)', zip: '911619' },
	{ city: 'Roosky (Meath)', zip: '192965' },
	{ city: 'Roosky (Monaghan)', zip: '574010' },
	{ city: 'Roosky (Roscommon)', zip: '820833' },
	{ city: 'Rooskybeg (Mayo)', zip: '242914' },
	{ city: 'Roosky Beg (Sligo)', zip: '317938' },
	{ city: 'Roosky Lower (Donegal)', zip: '951327' },
	{ city: 'Roosky More (Sligo)', zip: '366229' },
	{ city: 'Rooskynamona (Leitrim)', zip: '786871' },
	{ city: 'Roosky New (Roscommon)', zip: '543911' },
	{ city: 'Roosky Upper (Donegal)', zip: '510008' },
	{ city: 'Rootagh (Tipperary)', zip: '116989' },
	{ city: 'Rootate (Louth)', zip: '344555' },
	{ city: 'Rootiagh (Limerick)', zip: '106346' },
	{ city: 'Rooty (Roscommon)', zip: '695651' },
	{ city: 'Rooves Beg (Cork)', zip: '130147' },
	{ city: 'Rooves More (Cork)', zip: '228283' },
	{ city: 'Roo West (Clare)', zip: '989764' },
	{ city: 'Roperstown (Wexford)', zip: '205136' },
	{ city: 'Roran (Tipperary)', zip: '210944' },
	{ city: 'Roranna (Monaghan)', zip: '647612' },
	{ city: 'Rorardstown Lower (Tipperary)', zip: '601633' },
	{ city: 'Rorardstown Upper (Tipperary)', zip: '194258' },
	{ city: 'Roristown (Meath)', zip: '656485' },
	{ city: 'Rosahane (Wicklow)', zip: '158429' },
	{ city: 'Rosbane (Wicklow)', zip: '342245' },
	{ city: 'Rosbarnagh Island (Mayo)', zip: '536188' },
	{ city: 'Rosbeg (Mayo)', zip: '318805' },
	{ city: 'Rosbercon (Kilkenny)', zip: '944794' },
	{ city: 'Rosbercon (Wexford)', zip: '177939' },
	{ city: 'Rosbercon Millbanks (Wexford)', zip: '335635' },
	{ city: 'Rosberry (Kildare)', zip: '845345' },
	{ city: 'Rosbran (Kildare)', zip: '377593' },
	{ city: 'Rosbran (Laois)', zip: '571035' },
	{ city: 'Roscahill (Mayo)', zip: '736094' },
	{ city: 'Roscall (Dublin)', zip: '260268' },
	{ city: 'Roscarban (Leitrim)', zip: '211465' },
	{ city: 'Roscat (Carlow)', zip: '907282' },
	{ city: 'Roscath (Wicklow)', zip: '993580' },
	{ city: 'Rosclave (Mayo)', zip: '700010' },
	{ city: 'Rosclogher (Leitrim)', zip: '145108' },
	{ city: 'Roscolvin (Kildare)', zip: '331666' },
	{ city: 'Roscommon (Roscommon)', zip: '839660' },
	{ city: 'Roscomroe (Offaly)', zip: '252315' },
	{ city: 'Roscon (Kilkenny)', zip: '883590' },
	{ city: 'Roscore Demesne (Offaly)', zip: '641802' },
	{ city: 'Roscrea (Galway)', zip: '812137' },
	{ city: 'Roscrea (Tipperary)', zip: '616807' },
	{ city: 'Roscrib East (Sligo)', zip: '917515' },
	{ city: 'Roscrib West (Sligo)', zip: '762811' },
	{ city: 'Roscullen Island (Kerry)', zip: '218617' },
	{ city: 'Roscunnish (Leitrim)', zip: '604507' },
	{ city: 'Rosdaul (Galway)', zip: '989871' },
	{ city: 'Rosdellig (Carlow)', zip: '184133' },
	{ city: 'Rosdoagh (Mayo)', zip: '636911' },
	{ city: 'Rosdooaun (Mayo)', zip: '427858' },
	{ city: 'Rosdoowaun (Leitrim)', zip: '508022' },
	{ city: 'Rosdrehid (Offaly)', zip: '134899' },
	{ city: 'Rosduff (Longford)', zip: '498403' },
	{ city: 'Rosefield (Monaghan)', zip: '850702' },
	{ city: 'Rosegarland (Wexford)', zip: '594008' },
	{ city: 'Rosegreen (Tipperary)', zip: '220646' },
	{ city: 'Rosehill (Cavan)', zip: '658213' },
	{ city: 'Rosehill (Wexford)', zip: '768197' },
	{ city: 'Roseland (Wexford)', zip: '753919' },
	{ city: 'Rosemaryhill (Wexford)', zip: '858126' },
	{ city: 'Rosemount (Westmeath)', zip: '170033' },
	{ city: 'Rosenallis (Laois)', zip: '482506' },
	{ city: 'Rosepark (Dublin)', zip: '838114' },
	{ city: 'Rosepenna (Donegal)', zip: '344054' },
	{ city: 'Rosetown (Kildare)', zip: '133362' },
	{ city: 'Rosetown (Wexford)', zip: '206921' },
	{ city: 'Rosfaraghan (Offaly)', zip: '130916' },
	{ city: 'Rosfriar (Leitrim)', zip: '833787' },
	{ city: 'Rosgalliv (Mayo)', zip: '591532' },
	{ city: 'Rosgibbileen (Mayo)', zip: '812142' },
	{ city: 'Rosgoordagh (Tipperary)', zip: '340505' },
	{ city: 'Rosharry (Leitrim)', zip: '912849' },
	{ city: 'Roshin (Donegal)', zip: '806876' },
	{ city: 'Roshin Acres (Donegal)', zip: '480268' },
	{ city: 'Roshin Lodge (Donegal)', zip: '473847' },
	{ city: 'Roshin North (Donegal)', zip: '639139' },
	{ city: 'Roshin South (Donegal)', zip: '304810' },
	{ city: 'Roskeeda (Galway)', zip: '894721' },
	{ city: 'Roskeen (Cork)', zip: '180804' },
	{ city: 'Roskeen (Laois)', zip: '952464' },
	{ city: 'Roskeen (Tipperary)', zip: '125450' },
	{ city: 'Roskeen Little (Tipperary)', zip: '557623' },
	{ city: 'Roskeen North (Mayo)', zip: '257445' },
	{ city: 'Roskeen North (Tipperary)', zip: '189122' },
	{ city: 'Roskeen South (Mayo)', zip: '268721' },
	{ city: 'Roskeen South (Tipperary)', zip: '637830' },
	{ city: 'Roslahan Lower (Mayo)', zip: '625937' },
	{ city: 'Roslahan Upper (Mayo)', zip: '724538' },
	{ city: 'Roslaher (Mayo)', zip: '797540' },
	{ city: 'Rosleague (Galway)', zip: '532796' },
	{ city: 'Rosmadda East (Clare)', zip: '892216' },
	{ city: 'Rosmadda West (Clare)', zip: '719877' },
	{ city: 'Rosmearan (Galway)', zip: '413813' },
	{ city: 'Rosmeen (Roscommon)', zip: '137967' },
	{ city: 'Rosmindle (Mayo)', zip: '364060' },
	{ city: 'Rosmoney (Mayo)', zip: '698488' },
	{ city: 'Rosmore (Galway)', zip: '494047' },
	{ city: 'Rosmore (Mayo)', zip: '351958' },
	{ city: 'Rosmore (Sligo)', zip: '879955' },
	{ city: 'Rosmoylan (Roscommon)', zip: '533652' },
	{ city: 'Rosmuck (Galway)', zip: '448926' },
	{ city: 'Rosmult (Tipperary)', zip: '931457' },
	{ city: 'Rosnacananee (Tipperary)', zip: '857586' },
	{ city: 'Rosnacartan Beg (Kerry)', zip: '124288' },
	{ city: 'Rosnacartan More (Kerry)', zip: '666613' },
	{ city: 'Rosnagleragh (Mayo)', zip: '837050' },
	{ city: 'Rosnagowloge (Offaly)', zip: '984528' },
	{ city: 'Rosnagussane (Cork)', zip: '625275' },
	{ city: 'Rosnakill (Donegal)', zip: '963217' },
	{ city: 'Rosnakilly (Mayo)', zip: '265093' },
	{ city: 'Rosnamullane (Laois)', zip: '750698' },
	{ city: 'Rosnamulteeny (Tipperary)', zip: '316921' },
	{ city: 'Rosnascalp (Cork)', zip: '202811' },
	{ city: 'Rosnastraw (Wicklow)', zip: '221075' },
	{ city: 'Rosneillan (Clare)', zip: '677741' },
	{ city: 'Rosroe (Clare)', zip: '542199' },
	{ city: 'Rosroe (Galway)', zip: '109560' },
	{ city: 'Ross (Clare)', zip: '164930' },
	{ city: 'Ross (Galway)', zip: '783157' },
	{ city: 'Ross (Kerry)', zip: '217795' },
	{ city: 'Ross (Laois)', zip: '523832' },
	{ city: 'Ross (Leitrim)', zip: '504747' },
	{ city: 'Ross (Mayo)', zip: '458269' },
	{ city: 'Ross (Meath)', zip: '860400' },
	{ city: 'Ross (Offaly)', zip: '158027' },
	{ city: 'Ross (Sligo)', zip: '684741' },
	{ city: 'Ross (Tipperary)', zip: '524088' },
	{ city: 'Ross (Waterford)', zip: '452405' },
	{ city: 'Ross (Westmeath)', zip: '306182' },
	{ city: 'Rossacon (Cork)', zip: '642710' },
	{ city: 'Rossacoosane (Kerry)', zip: '942582' },
	{ city: 'Rossacroo (Kerry)', zip: '191707' },
	{ city: 'Rossacroobeg (Kerry)', zip: '815057' },
	{ city: 'Rossacroonaloo (Kerry)', zip: '153822' },
	{ city: 'Rossacrow (Tipperary)', zip: '745913' },
	{ city: 'Rossacurra (Carlow)', zip: '138000' },
	{ city: 'Rossadillisk (Galway)', zip: '380139' },
	{ city: 'Rossadown (Laois)', zip: '260824' },
	{ city: 'Rossadrehid (Tipperary)', zip: '696122' },
	{ city: 'Rossagh East (Cork)', zip: '631820' },
	{ city: 'Rossaghroe (Cork)', zip: '480256' },
	{ city: 'Rossagh West (Cork)', zip: '516515' },
	{ city: 'Rossaguile (Tipperary)', zip: '430868' },
	{ city: 'Rossalee (Laois)', zip: '675687' },
	{ city: 'Rossalia (Clare)', zip: '477750' },
	{ city: 'Rossalia (Kerry)', zip: '199048' },
	{ city: 'Rossalougha (Cork)', zip: '356096' },
	{ city: 'Rossamine (Offaly)', zip: '596341' },
	{ city: 'Rossan (Longford)', zip: '745733' },
	{ city: 'Rossan (Meath)', zip: '608122' },
	{ city: 'Rossana Lower (Wicklow)', zip: '949145' },
	{ city: 'Rossana Upper (Wicklow)', zip: '268458' },
	{ city: 'Rossane (Tipperary)', zip: '613410' },
	{ city: 'Rossanean (Kerry)', zip: '439841' },
	{ city: 'Rossaneny (Kilkenny)', zip: '978008' },
	{ city: 'Rossanrubble (Mayo)', zip: '365364' },
	{ city: 'Rossanure (Clare)', zip: '941559' },
	{ city: 'Rossard (Cork)', zip: '472048' },
	{ city: 'Rossard (Kerry)', zip: '649979' },
	{ city: 'Rossard (Limerick)', zip: '972181' },
	{ city: 'Rossard (Wexford)', zip: '184234' },
	{ city: 'Rossarrell (Monaghan)', zip: '341021' },
	{ city: 'Rossary Beg (Tipperary)', zip: '106606' },
	{ city: 'Rossary More (Tipperary)', zip: '252919' },
	{ city: 'Rossaveel (Galway)', zip: '302054' },
	{ city: 'Rossbane (Limerick)', zip: '903889' },
	{ city: 'Rossbaun (Laois)', zip: '869598' },
	{ city: 'Rossbeg (Donegal)', zip: '400671' },
	{ city: 'Rossbeg (Mayo)', zip: '465998' },
	{ city: 'Rossbeg (Tipperary)', zip: '738135' },
	{ city: 'Rossbeg (Westmeath)', zip: '978400' },
	{ city: 'Ross Beg (Leitrim)', zip: '721546' },
	{ city: 'Ross Beg (Roscommon)', zip: '696366' },
	{ city: 'Ross Beg Glebe (Leitrim)', zip: '263209' },
	{ city: 'Rossbehy (Kerry)', zip: '608773' },
	{ city: 'Rossbog (Tipperary)', zip: '385786' },
	{ city: 'Rossboy (Kerry)', zip: '907157' },
	{ city: 'Rossbrackan (Donegal)', zip: '937950' },
	{ city: 'Rossbrien (Limerick)', zip: '520997' },
	{ city: 'Rossbrin (Cork)', zip: '797498' },
	{ city: 'Rosscad (Donegal)', zip: '995008' },
	{ city: 'Rosscahill East (Galway)', zip: '871491' },
	{ city: 'Rosscahill West (Galway)', zip: '543145' },
	{ city: 'Rosscanlan (Donegal)', zip: '279904' },
	{ city: 'Ross Carbery (Cork)', zip: '800293' },
	{ city: 'Rosscat (Donegal)', zip: '209301' },
	{ city: 'Rosscliff (Clare)', zip: '529195' },
	{ city: 'Rosscolgan (Cavan)', zip: '936547' },
	{ city: 'Rossconnell Glebe (Laois)', zip: '829119' },
	{ city: 'Rossdama (Kilkenny)', zip: '598821' },
	{ city: 'Rossdarragh (Laois)', zip: '659715' },
	{ city: 'Ross Demesne (Galway)', zip: '432459' },
	{ city: 'Rossdohan (Kerry)', zip: '471707' },
	{ city: 'Rossdohan Island (Kerry)', zip: '445593' },
	{ city: 'Rossdorragha (Laois)', zip: '895140' },
	{ city: 'Rossdreenagh (Monaghan)', zip: '568038' },
	{ city: 'Rossduff (Waterford)', zip: '983794' },
	{ city: 'Ross East (Mayo)', zip: '537898' },
	{ city: 'Rosseeshal (Galway)', zip: '106052' },
	{ city: 'Rosseightragh (Kerry)', zip: '446039' },
	{ city: 'Rossena (Laois)', zip: '628999' },
	{ city: 'Rossenarra (Kilkenny)', zip: '596372' },
	{ city: 'Rossenarra Demesne (Kilkenny)', zip: '679890' },
	{ city: 'Rosserk (Mayo)', zip: '220941' },
	{ city: 'Rosses Lower (Sligo)', zip: '574966' },
	{ city: 'Rosses Point (Sligo)', zip: '506868' },
	{ city: 'Rossestown (Tipperary)', zip: '323710' },
	{ city: 'Rosses Upper (Sligo)', zip: '735458' },
	{ city: 'Rossfinch (Tipperary)', zip: '108761' },
	{ city: 'Rossgarrow (Donegal)', zip: '260232' },
	{ city: 'Rossgeir (Donegal)', zip: '733445' },
	{ city: 'Rossglass (Cork)', zip: '509550' },
	{ city: 'Rossgrilla (Waterford)', zip: '388547' },
	{ city: 'Rosshill (Galway)', zip: '135278' },
	{ city: 'Rossilly (Donegal)', zip: '640384' },
	{ city: 'Rossilly Barr (Donegal)', zip: '232596' },
	{ city: 'Rossinan (Kilkenny)', zip: '199253' },
	{ city: 'Rossinver (Leitrim)', zip: '634279' },
	{ city: 'Ross Island (Kerry)', zip: '393305' },
	{ city: 'Rosskeeragh (Cavan)', zip: '700585' },
	{ city: 'Rosskelton (Laois)', zip: '487480' },
	{ city: 'Rosskerrig (Cork)', zip: '785011' },
	{ city: 'Rosskerrig-Mountain (Cork)', zip: '930134' },
	{ city: 'Rosskirk And Killhill (Donegal)', zip: '903974' },
	{ city: 'Rosslague (Cork)', zip: '931756' },
	{ city: 'Rosslara (Clare)', zip: '787310' },
	{ city: 'Rosslare (Wexford)', zip: '523075' },
	{ city: 'Rosslarefort (Wexford)', zip: '382955' },
	{ city: 'Rosslare Harbour (Wexford)', zip: '981057' },
	{ city: 'Rosslare Intake (Wexford)', zip: '918816' },
	{ city: 'Rossleaghan (Laois)', zip: '942706' },
	{ city: 'Rosslee (Carlow)', zip: '450490' },
	{ city: 'Rosslevan (Clare)', zip: '726040' },
	{ city: 'Rossline (Cork)', zip: '963398' },
	{ city: 'Rosslough (Louth)', zip: '945814' },
	{ city: 'Rossmackowen (Cork)', zip: '963711' },
	{ city: 'Rossmackowen Commons (Cork)', zip: '972962' },
	{ city: 'Rossmakay (Louth)', zip: '713168' },
	{ city: 'Rossmanagher (Clare)', zip: '548577' },
	{ city: 'Rossmeen (Meath)', zip: '343031' },
	{ city: 'Rossminoge North (Wexford)', zip: '197421' },
	{ city: 'Rossminoge South (Wexford)', zip: '659664' },
	{ city: 'Rossmore (Cork)', zip: '650057' },
	{ city: 'Rossmore (Donegal)', zip: '613082' },
	{ city: 'Rossmore (Kerry)', zip: '769825' },
	{ city: 'Rossmore (Kilkenny)', zip: '220178' },
	{ city: 'Rossmore (Laois)', zip: '656661' },
	{ city: 'Rossmore (Limerick)', zip: '595880' },
	{ city: 'Rossmore (Tipperary)', zip: '654809' },
	{ city: 'Ross More (Leitrim)', zip: '778152' },
	{ city: 'Ross More East (Roscommon)', zip: '286787' },
	{ city: 'Rossmore Island (Kerry)', zip: '300004' },
	{ city: 'Ross More West (Roscommon)', zip: '464520' },
	{ city: 'Rossnabarnagh (Laois)', zip: '218407' },
	{ city: 'Rossnabrone (Cork)', zip: '558131' },
	{ city: 'Rossnacaheragh (Cork)', zip: '855392' },
	{ city: 'Rossnaclonagh Inside (Laois)', zip: '120637' },
	{ city: 'Rossnaclonagh Outside (Laois)', zip: '696913' },
	{ city: 'Rossnacreena (Laois)', zip: '489099' },
	{ city: 'Rossnadough (Laois)', zip: '630582' },
	{ city: 'Rossnagad (Laois)', zip: '507259' },
	{ city: 'Rossnaglogh East (Monaghan)', zip: '163647' },
	{ city: 'Rossnaglogh West (Monaghan)', zip: '449043' },
	{ city: 'Rossnagoose (Cork)', zip: '807252' },
	{ city: 'Rossnagrena (Cork)', zip: '117455' },
	{ city: 'Rossnahowgarry (Kerry)', zip: '450004' },
	{ city: 'Rossnakilla (Cork)', zip: '471649' },
	{ city: 'Rossnamanniff Lower (Tipperary)', zip: '628898' },
	{ city: 'Rossnamanniff Upper (Tipperary)', zip: '199478' },
	{ city: 'Rossnanarney (Cork)', zip: '413801' },
	{ city: 'Rossnanowl (Kilkenny)', zip: '794524' },
	{ city: 'Rossnaree (Meath)', zip: '578920' },
	{ city: 'Rossnashunsoge (Cork)', zip: '706285' },
	{ city: 'Rossnowlagh Lower (Donegal)', zip: '779455' },
	{ city: 'Rossnowlagh Upper (Donegal)', zip: '813554' },
	{ city: 'Rossollus (Monaghan)', zip: '209067' },
	{ city: 'Rossoulty (Tipperary)', zip: '263063' },
	{ city: 'Rossow (Mayo)', zip: '292836' },
	{ city: 'Rosspile (Wexford)', zip: '487354' },
	{ city: 'Ross Port (Mayo)', zip: '220337' },
	{ city: 'Rossreagh (Donegal)', zip: '450806' },
	{ city: 'Rossrehill (Tipperary)', zip: '600301' },
	{ city: 'Rossroe (Kilkenny)', zip: '457198' },
	{ city: 'Rossroe Island (Galway)', zip: '327994' },
	{ city: 'Rosstemple (Limerick)', zip: '636579' },
	{ city: 'Rosstillegane (Laois)', zip: '143466' },
	{ city: 'Ross West (Mayo)', zip: '713272' },
	{ city: 'Rossy (Leitrim)', zip: '221305' },
	{ city: 'Rossylongan (Donegal)', zip: '477522' },
	{ city: 'Rossymailley (Mayo)', zip: '665833' },
	{ city: 'Rossyvera (Mayo)', zip: '639513' },
	{ city: 'Rossyvolan (Donegal)', zip: '382665' },
	{ city: 'Rostalla (Westmeath)', zip: '696232' },
	{ city: 'Rostellan (Cork)', zip: '164924' },
	{ city: 'Rostollus (Galway)', zip: '910405' },
	{ city: 'Rostonstown (Wexford)', zip: '238827' },
	{ city: 'Rostonstown Burrow (Wexford)', zip: '653114' },
	{ city: 'Rostoohy (Mayo)', zip: '718665' },
	{ city: 'Rosturk (Mayo)', zip: '200253' },
	{ city: 'Rosturra (Galway)', zip: '884242' },
	{ city: 'Rostyduff Lower (Wicklow)', zip: '163749' },
	{ city: 'Rostyduff Upper (Wicklow)', zip: '369324' },
	{ city: 'Rostygah (Wicklow)', zip: '204548' },
	{ city: 'Rosybower (Cork)', zip: '861004' },
	{ city: 'Rottenhill (Wicklow)', zip: '904055' },
	{ city: 'Rougham (Cork)', zip: '904535' },
	{ city: 'Roughan (Clare)', zip: '994631' },
	{ city: 'Roughan (Donegal)', zip: '728159' },
	{ city: 'Roughan (Tipperary)', zip: '587525' },
	{ city: 'Roughan B2133 (Donegal)', zip: '738716' },
	{ city: 'Roughan Glebe (Donegal)', zip: '800512' },
	{ city: 'Roughaun (Clare)', zip: '930192' },
	{ city: 'Roughfield (Kilkenny)', zip: '798627' },
	{ city: 'Roughgrange (Meath)', zip: '278655' },
	{ city: 'Roughgrove East (Cork)', zip: '716127' },
	{ city: 'Roughgrove West (Cork)', zip: '307182' },
	{ city: 'Rough Hill (Monaghan)', zip: '811563' },
	{ city: 'Rough Island (Donegal)', zip: '512428' },
	{ city: 'Roughmead (Wexford)', zip: '266829' },
	{ city: 'Roughpark (Donegal)', zip: '435242' },
	{ city: 'Roundfield (Galway)', zip: '686974' },
	{ city: 'Roundhill (Cork)', zip: '413877' },
	{ city: 'Roundhill (Offaly)', zip: '950281' },
	{ city: 'Roundhills (Kildare)', zip: '133634' },
	{ city: 'Round Islands (Mayo)', zip: '850103' },
	{ city: 'Roundstone (Galway)', zip: '406400' },
	{ city: 'Roundwood (Laois)', zip: '118429' },
	{ city: 'Roundwood (Wicklow)', zip: '886208' },
	{ city: 'Rouryglen (Cork)', zip: '909789' },
	{ city: 'Routagh (Limerick)', zip: '708399' },
	{ city: 'Rover (Sligo)', zip: '312482' },
	{ city: 'Roverkilly (Roscommon)', zip: '971782' },
	{ city: 'Rover Lower (Roscommon)', zip: '360568' },
	{ city: 'Rover Upper (Roscommon)', zip: '994495' },
	{ city: 'Rowan (Meath)', zip: '561189' },
	{ city: 'Rowans Big (Dublin)', zip: '315203' },
	{ city: 'Rowans Little (Dublin)', zip: '993652' },
	{ city: 'Rowanstown (Kildare)', zip: '967714' },
	{ city: 'Rowantreehill (Donegal)', zip: '283004' },
	{ city: 'Rowe (Westmeath)', zip: '501717' },
	{ city: 'Rower Beg (Limerick)', zip: '135198' },
	{ city: 'Rower More (Limerick)', zip: '682714' },
	{ city: 'Rowestown (Wexford)', zip: '858959' },
	{ city: 'Rowgarrane (Cork)', zip: '110813' },
	{ city: 'Rowlagh (Dublin)', zip: '632845' },
	{ city: 'Rowlandstown (Westmeath)', zip: '285110' },
	{ city: 'Rowlestown (Meath)', zip: '661656' },
	{ city: 'Rowlestown East (Dublin)', zip: '563291' },
	{ city: 'Rowlestown West (Dublin)', zip: '289672' },
	{ city: 'Rowls (Cork)', zip: '311768' },
	{ city: 'Rowls North (Cork)', zip: '662070' },
	{ city: 'Rowls South (Cork)', zip: '683433' },
	{ city: 'Roxborough (Cork)', zip: '486672' },
	{ city: 'Roxborough (Galway)', zip: '521917' },
	{ city: 'Roxborough (Kerry)', zip: '910724' },
	{ city: 'Roxborough (Limerick)', zip: '814170' },
	{ city: 'Roxborough (Louth)', zip: '822654' },
	{ city: 'Roxborough (Roscommon)', zip: '446003' },
	{ city: 'Roxborough (Tipperary)', zip: '539830' },
	{ city: 'Roxborough Glebe (Donegal)', zip: '485903' },
	{ city: 'Roxton (Clare)', zip: '410959' },
	{ city: 'Roy (Galway)', zip: '808369' },
	{ city: 'Roy (Mayo)', zip: '656167' },
	{ city: 'Royaloak (Kildare)', zip: '544779' },
	{ city: 'Roymore (Galway)', zip: '886093' },
	{ city: 'Ruan (Clare)', zip: '244893' },
	{ city: 'Ruan (Limerick)', zip: '162456' },
	{ city: 'Ruanard (Clare)', zip: '235597' },
	{ city: 'Ruan Commons (Clare)', zip: '788169' },
	{ city: 'Ruanes (Cork)', zip: '498199' },
	{ city: 'Ruaunmore (Wexford)', zip: '327914' },
	{ city: 'Rubbal (Leitrim)', zip: '915563' },
	{ city: 'Rubble (Mayo)', zip: '900981' },
	{ city: 'Rudder (Meath)', zip: '498330' },
	{ city: 'Rue (Leitrim)', zip: '889095' },
	{ city: 'Rue (Sligo)', zip: '735708' },
	{ city: 'Runnabackan (Roscommon)', zip: '452489' },
	{ city: 'Runnabehy (Roscommon)', zip: '643677' },
	{ city: 'Runnaboll (Roscommon)', zip: '141121' },
	{ city: 'Runnacocka (Roscommon)', zip: '112631' },
	{ city: 'Runnameelta (Roscommon)', zip: '112581' },
	{ city: 'Runnamoat (Roscommon)', zip: '773058' },
	{ city: 'Runnaroddan (Roscommon)', zip: '364989' },
	{ city: 'Runnaroddaun (Roscommon)', zip: '677266' },
	{ city: 'Runnaruag (Roscommon)', zip: '793326' },
	{ city: 'Ruppa (Kilkenny)', zip: '727771' },
	{ city: 'Rupperagh (Cork)', zip: '968428' },
	{ city: 'Ruppulagh (Limerick)', zip: '196120' },
	{ city: 'Rush (Dublin)', zip: '526481' },
	{ city: 'Rush (Meath)', zip: '684998' },
	{ city: 'Rushanes (Cork)', zip: '989983' },
	{ city: 'Rushaun (Clare)', zip: '473437' },
	{ city: 'Rushbrook (Mayo)', zip: '678331' },
	{ city: 'Rushbrook East (Mayo)', zip: '803007' },
	{ city: 'Rushbrook West (Mayo)', zip: '834237' },
	{ city: 'Rush Demesne (Dublin)', zip: '424234' },
	{ city: 'Rusheen (Clare)', zip: '165563' },
	{ city: 'Rusheen (Cork)', zip: '783255' },
	{ city: 'Rusheen (Galway)', zip: '186388' },
	{ city: 'Rusheen (Kerry)', zip: '794148' },
	{ city: 'Rusheen (Mayo)', zip: '751265' },
	{ city: 'Rusheen (Offaly)', zip: '885179' },
	{ city: 'Rusheen (Roscommon)', zip: '311314' },
	{ city: 'Rusheen (Sligo)', zip: '206537' },
	{ city: 'Rusheenaniska (Cork)', zip: '690992' },
	{ city: 'Rusheen Beg (Kerry)', zip: '586411' },
	{ city: 'Rusheen Beg (Tipperary)', zip: '357284' },
	{ city: 'Rusheenduff (Galway)', zip: '880407' },
	{ city: 'Rusheen East (Galway)', zip: '337408' },
	{ city: 'Rusheen Island (Mayo)', zip: '150457' },
	{ city: 'Rusheen More (Kerry)', zip: '790487' },
	{ city: 'Rusheen More (Tipperary)', zip: '846003' },
	{ city: 'Rusheennacholla (Galway)', zip: '794883' },
	{ city: 'Rusheennamanagh (Galway)', zip: '631358' },
	{ city: 'Rusheenpark (Kerry)', zip: '521629' },
	{ city: 'Rusheens (Kerry)', zip: '634182' },
	{ city: 'Rusheens (Mayo)', zip: '353242' },
	{ city: 'Rusheens (Waterford)', zip: '753848' },
	{ city: 'Rusheens East (Mayo)', zip: '606318' },
	{ city: 'Rusheens North (Galway)', zip: '617084' },
	{ city: 'Rusheens South (Galway)', zip: '563527' },
	{ city: 'Rusheens West (Mayo)', zip: '826177' },
	{ city: 'Rusheen West (Galway)', zip: '153622' },
	{ city: 'Rusheeny (Galway)', zip: '959030' },
	{ city: 'Rusheenyvulligan (Galway)', zip: '295963' },
	{ city: 'Rushen (Donegal)', zip: '466882' },
	{ city: 'Rushes (Laois)', zip: '849239' },
	{ city: 'Rushestown (Galway)', zip: '785635' },
	{ city: 'Rushfield (Cork)', zip: '227621' },
	{ city: 'Rush Hall (Laois)', zip: '695738' },
	{ city: 'Rush Hill (Mayo)', zip: '716589' },
	{ city: 'Rush Hill (Roscommon)', zip: '458841' },
	{ city: 'Rushin (Laois)', zip: '282866' },
	{ city: 'Rushpark Farragher (Roscommon)', zip: '712496' },
	{ city: 'Rushport (Roscommon)', zip: '155516' },
	{ city: 'Rushveala (Galway)', zip: '349427' },
	{ city: 'Rushwee (Meath)', zip: '128451' },
	{ city: 'Rushyhill (Donegal)', zip: '537479' },
	{ city: 'Russa (Clare)', zip: '736614' },
	{ city: 'Russagh (Cork)', zip: '482575' },
	{ city: 'Russagh (Offaly)', zip: '541531' },
	{ city: 'Russagh (Westmeath)', zip: '742077' },
	{ city: 'Russaun (Galway)', zip: '411263' },
	{ city: 'Russborough (Wicklow)', zip: '831655' },
	{ city: 'Russelhill (Cork)', zip: '486595' },
	{ city: 'Russellspenn (Offaly)', zip: '729196' },
	{ city: 'Russellstown (Carlow)', zip: '617356' },
	{ city: 'Russellstown (Kildare)', zip: '958712' },
	{ city: 'Russellstown (Kilkenny)', zip: '218790' },
	{ city: 'Russellstown (Waterford)', zip: '427643' },
	{ city: 'Russellstown (Westmeath)', zip: '439371' },
	{ city: 'Russellstown (Wexford)', zip: '210991' },
	{ city: 'Russellstown (Wicklow)', zip: '655037' },
	{ city: 'Russellstown Little (Westmeath)', zip: '615331' },
	{ city: 'Russellstown New (Waterford)', zip: '328978' },
	{ city: 'Russellswood (Kildare)', zip: '514430' },
	{ city: 'Russelstown (Galway)', zip: '481711' },
	{ city: 'Russelstown (Tipperary)', zip: '212461' },
	{ city: 'Ruthstown (Kilkenny)', zip: '975896' },
	{ city: 'Rutland (Offaly)', zip: '491588' },
	{ city: 'Rutland Island (Donegal)', zip: '637947' },
	{ city: 'Ryane (Wexford)', zip: '464072' },
	{ city: 'Ryecourt (Cork)', zip: '939175' },
	{ city: 'Ryefield (Cavan)', zip: '397605' },
	{ city: 'Ryefield (Roscommon)', zip: '350066' },
	{ city: 'Ryefield East (Cork)', zip: '405949' },
	{ city: 'Ryefield West (Cork)', zip: '453028' },
	{ city: 'Ryehill (Galway)', zip: '712255' },
	{ city: 'Ryehill Demesne (Galway)', zip: '286331' },
	{ city: 'Ryelands (Donegal)', zip: '114007' },
	{ city: 'Ryelanes (Kilkenny)', zip: '261416' },
	{ city: 'Ryland Lower (Wexford)', zip: '849408' },
	{ city: 'Ryland Upper (Wexford)', zip: '211187' },
	{ city: 'Rylane (Clare)', zip: '357539' },
	{ city: 'Rylane (Cork)', zip: '407246' },
	{ city: 'Rylane (Kerry)', zip: '684038' },
	{ city: 'Rylanes (Limerick)', zip: '259471' },
	{ city: 'Ryleen (Wexford)', zip: '157741' },
	{ city: 'Ryninch Lower (Tipperary)', zip: '281272' },
	{ city: 'Ryninch Upper (Tipperary)', zip: '393908' },
	{ city: 'Ryvescastle (Limerick)', zip: '541411' },
	{ city: 'Sackville (Kerry)', zip: '328716' },
	{ city: 'Saddlestown (Meath)', zip: '307152' },
	{ city: 'Sadleirswells (Tipperary)', zip: '624909' },
	{ city: 'Saggart (Dublin)', zip: '349469' },
	{ city: "Saint Anne's Glebe (Longford)", zip: '289544' },
	{ city: 'Saint Awaries (Wexford)', zip: '638537' },
	{ city: "Saint Brendan's (Galway)", zip: '161000' },
	{ city: "Saint Catherine's (Kildare)", zip: '292295' },
	{ city: "Saint Catherine's Park (Dublin)", zip: '760008' },
	{ city: "Saint Catherine's Park (Kildare)", zip: '590013' },
	{ city: 'Saintclerans (Galway)', zip: '815076' },
	{ city: "Saint Dominick's Abbey (Tipperary)", zip: '322714' },
	{ city: 'Saintdoolaghs (Dublin)', zip: '439182' },
	{ city: "Saint Edmond's (Wexford)", zip: '343347' },
	{ city: 'Saint Edmondsbury (Dublin)', zip: '788017' },
	{ city: 'Saintellen (Galway)', zip: '730062' },
	{ city: 'Saint Francisabbey (Tipperary)', zip: '368430' },
	{ city: 'Sainthelens (Dublin)', zip: '228935' },
	{ city: "Saint Helen's (Wexford)", zip: '210758' },
	{ city: 'Saint Iberius (Wexford)', zip: '563869' },
	{ city: 'Saintjohns (Kildare)', zip: '346768' },
	{ city: 'Saintjohns (Meath)', zip: '899386' },
	{ city: "Saint John's (Wexford)", zip: '561691' },
	{ city: 'Saintjohnsfort (Meath)', zip: '975874' },
	{ city: "Saint John's Rath (Meath)", zip: '583661' },
	{ city: 'Saintjohnstown (Donegal)', zip: '670594' },
	{ city: 'Saint Johnstown (Tipperary)', zip: '420035' },
	{ city: 'Saintkierans (Wexford)', zip: '478708' },
	{ city: 'Saint Laurencesfields (Galway)', zip: '646436' },
	{ city: 'Saintleonards (Wexford)', zip: '614034' },
	{ city: "Saint Macdara's Island (Galway)", zip: '997414' },
	{ city: "Saint Margaret's (Dublin)", zip: '459962' },
	{ city: "Saint Margaret's (Wexford)", zip: '677144' },
	{ city: "Saint Mullin's (Carlow)", zip: '502007' },
	{ city: 'Saint Patricksrock (Tipperary)', zip: '781429' },
	{ city: 'Saints Island (Longford)', zip: '285566' },
	{ city: 'Saint Tenants (Wexford)', zip: '988736' },
	{ city: "Saint Vogue's (Wexford)", zip: '683140' },
	{ city: 'Saint Wolstans (Kildare)', zip: '443607' },
	{ city: 'Saleen (Cork)', zip: '597499' },
	{ city: 'Saleen (Mayo)', zip: '304409' },
	{ city: 'Salestown (Meath)', zip: '321126' },
	{ city: 'Salia (Mayo)', zip: '199913' },
	{ city: 'Salisbury (Kildare)', zip: '923891' },
	{ city: 'Sallaghagrane (Donegal)', zip: '215811' },
	{ city: 'Sallaghan (Cavan)', zip: '535004' },
	{ city: 'Sallaghan (Leitrim)', zip: '393307' },
	{ city: 'Sallagher (Mayo)', zip: '570240' },
	{ city: 'Sallaghill (Cavan)', zip: '661513' },
	{ city: 'Sallahig (Kerry)', zip: '721337' },
	{ city: 'Sallins (Kildare)', zip: '518813' },
	{ city: 'Sallows (Donegal)', zip: '170863' },
	{ city: 'Sallsquarter (Tipperary)', zip: '159501' },
	{ city: 'Sallybog (Tipperary)', zip: '450607' },
	{ city: 'Sallybrook (Donegal)', zip: '296955' },
	{ city: 'Sallybrook (Meath)', zip: '856371' },
	{ city: 'Sallyhernaun (Mayo)', zip: '546800' },
	{ city: 'Sallymount (Limerick)', zip: '122222' },
	{ city: 'Sallymount (Wicklow)', zip: '971218' },
	{ city: 'Sallymount Demesne (Kildare)', zip: '875040' },
	{ city: 'Sallynoggin (Dublin)', zip: '612673' },
	{ city: 'Sallypark (Tipperary)', zip: '397770' },
	{ city: 'Sally Park (Cork)', zip: '841590' },
	{ city: 'Sallystown (Wexford)', zip: '299285' },
	{ city: 'Sallywood (Donegal)', zip: '349097' },
	{ city: 'Salmon (Dublin)', zip: '705641' },
	{ city: 'Salrock (Galway)', zip: '668594' },
	{ city: 'Saltee Island Great (Wexford)', zip: '712494' },
	{ city: 'Saltee Island Little (Wexford)', zip: '873797' },
	{ city: 'Salterbridge (Waterford)', zip: '692852' },
	{ city: 'Salterstown (Louth)', zip: '659999' },
	{ city: 'Salthill (Galway)', zip: '877014' },
	{ city: 'Salthill Demesne (Donegal)', zip: '139314' },
	{ city: 'Saltmills (Wexford)', zip: '747823' },
	{ city: 'Saltpans (Donegal)', zip: '461969' },
	{ city: 'Salville (Wexford)', zip: '150874' },
	{ city: 'Sanctuary (Wexford)', zip: '413761' },
	{ city: 'Sandfield (Donegal)', zip: '912896' },
	{ city: 'Sandfield (Louth)', zip: '349132' },
	{ city: 'Sandfordscourt (Kilkenny)', zip: '863166' },
	{ city: 'Sandhill (Donegal)', zip: '333690' },
	{ city: 'Sandhill (Mayo)', zip: '201547' },
	{ city: 'Sandhills (Monaghan)', zip: '483814' },
	{ city: 'Sand Island (Donegal)', zip: '879605' },
	{ city: 'Sandpits (Kilkenny)', zip: '993370' },
	{ city: 'Sandville (Cork)', zip: '701586' },
	{ city: 'Sandyford (Dublin)', zip: '753635' },
	{ city: 'Sandyhill (Cork)', zip: '782631' },
	{ city: 'Sandyhill (Dublin)', zip: '624796' },
	{ city: 'Sandyhill (Sligo)', zip: '925346' },
	{ city: 'Sandyhills (Wicklow)', zip: '598284' },
	{ city: 'Sandylane (Limerick)', zip: '106340' },
	{ city: 'Sandymount (Dublin)', zip: '378953' },
	{ city: 'Sandymount (Mayo)', zip: '233766' },
	{ city: 'Sandymount (Tipperary)', zip: '659984' },
	{ city: 'Santry (Dublin)', zip: '169997' },
	{ city: 'Santry Demesne (Dublin)', zip: '445729' },
	{ city: 'Santryhill (Wicklow)', zip: '732742' },
	{ city: 'Sapperton North (Waterford)', zip: '362084' },
	{ city: 'Sapperton South (Waterford)', zip: '323365' },
	{ city: 'Sarnaght (Mayo)', zip: '903855' },
	{ city: 'Sarney (Meath)', zip: '496179' },
	{ city: 'Sarsanstown (Westmeath)', zip: '628050' },
	{ city: 'Sarsfieldscourt (Cork)', zip: '882165' },
	{ city: 'Sarsfieldstown (Meath)', zip: '876740' },
	{ city: 'Sarsfieldstown (Westmeath)', zip: '832471' },
	{ city: 'Sarshill (Wexford)', zip: '147722' },
	{ city: 'Sart (Kilkenny)', zip: '220120' },
	{ city: 'Sarue (Cork)', zip: '213571' },
	{ city: 'Saucerstown (Dublin)', zip: '857818' },
	{ city: 'Saucestown (Tipperary)', zip: '867274' },
	{ city: 'Saunderscourt (Wexford)', zip: '530289' },
	{ city: 'Saundersgrove (Wicklow)', zip: '878242' },
	{ city: 'Saundersgrove Hill (Wicklow)', zip: '107865' },
	{ city: 'Savagetown (Waterford)', zip: '533166' },
	{ city: 'Sawnagh (Galway)', zip: '187468' },
	{ city: 'Sawyerswood (Kildare)', zip: '502989' },
	{ city: 'Scaddaman (Donegal)', zip: '505609' },
	{ city: 'Scalaheen (Tipperary)', zip: '634939' },
	{ city: 'Scalestown (Meath)', zip: '185370' },
	{ city: 'Scalkill (Monaghan)', zip: '795444' },
	{ city: 'Scallanstown (Meath)', zip: '855554' },
	{ city: 'Scalp (Clare)', zip: '358118' },
	{ city: 'Scalp (Galway)', zip: '861962' },
	{ city: 'Scalp (Wicklow)', zip: '612387' },
	{ city: 'Scalpnagown (Clare)', zip: '806806' },
	{ city: 'Scalpwilliam (Dublin)', zip: '548981' },
	{ city: "Scanlan's Island (Clare)", zip: '350389' },
	{ city: 'Scanlansland (Kilkenny)', zip: '944912' },
	{ city: 'Scar (Wexford)', zip: '175056' },
	{ city: 'Scarawalsh (Wexford)', zip: '219289' },
	{ city: 'Scardan Beg (Sligo)', zip: '695551' },
	{ city: 'Scardan More (Sligo)', zip: '912528' },
	{ city: 'Scardaun (Leitrim)', zip: '561721' },
	{ city: 'Scardaun (Mayo)', zip: '924644' },
	{ city: 'Scardaun (Roscommon)', zip: '717704' },
	{ city: 'Scardaun East (Mayo)', zip: '278417' },
	{ city: 'Scardaun West (Mayo)', zip: '854307' },
	{ city: 'Scariff (Kerry)', zip: '225614' },
	{ city: 'Scark (Wexford)', zip: '627946' },
	{ city: 'Scarletstown (Kildare)', zip: '359276' },
	{ city: 'Scarnageeragh (Monaghan)', zip: '977201' },
	{ city: 'Scarnagh Lower (Wexford)', zip: '190208' },
	{ city: 'Scarnagh Upper (Wexford)', zip: '830367' },
	{ city: 'Scarragh (Tipperary)', zip: '526923' },
	{ city: 'Scarreth (Galway)', zip: '139363' },
	{ city: 'Scarriff (Clare)', zip: '632668' },
	{ city: 'Scarriff (Cork)', zip: '588697' },
	{ city: 'Scarriff (Galway)', zip: '414948' },
	{ city: 'Scarriff (Kerry)', zip: '476985' },
	{ city: 'Scarroon (Laois)', zip: '353125' },
	{ city: 'Scarrough (Tipperary)', zip: '462432' },
	{ city: 'Scarry (Offaly)', zip: '648298' },
	{ city: 'Scart (Cork)', zip: '644306' },
	{ city: 'Scart (Kerry)', zip: '661463' },
	{ city: 'Scart (Kilkenny)', zip: '898018' },
	{ city: 'Scart (Limerick)', zip: '577470' },
	{ city: 'Scart (Tipperary)', zip: '245580' },
	{ city: 'Scart (Waterford)', zip: '811990' },
	{ city: 'Scartacrooka (Waterford)', zip: '521713' },
	{ city: 'Scartagh (Cork)', zip: '574251' },
	{ city: 'Scartaglin (Kerry)', zip: '708995' },
	{ city: 'Scartana (Tipperary)', zip: '461532' },
	{ city: 'Scartbarry (Cork)', zip: '146138' },
	{ city: 'Scartbaun (Cork)', zip: '327656' },
	{ city: 'Scartbeg (Tipperary)', zip: '436162' },
	{ city: 'Scart East (Tipperary)', zip: '461752' },
	{ city: 'Scarteen (Cork)', zip: '687732' },
	{ city: 'Scarteen (Kerry)', zip: '750993' },
	{ city: 'Scarteen (Limerick)', zip: '143924' },
	{ city: 'Scarteenakillin (Cork)', zip: '774737' },
	{ city: 'Scarteen Lower (Cork)', zip: '454263' },
	{ city: 'Scarteen Upper (Cork)', zip: '304489' },
	{ city: 'Scartlea (Kerry)', zip: '270340' },
	{ city: 'Scartlea (Waterford)', zip: '434267' },
	{ city: 'Scartlea Lower (Cork)', zip: '449857' },
	{ city: 'Scartlea Upper (Cork)', zip: '619713' },
	{ city: 'Scartleigh (Kerry)', zip: '464344' },
	{ city: 'Scart Lower (Cork)', zip: '738769' },
	{ city: 'Scartmountain (Waterford)', zip: '603217' },
	{ city: 'Scartnacrooha (Waterford)', zip: '796600' },
	{ city: 'Scartnadriny (Waterford)', zip: '426845' },
	{ city: 'Scartnadrinymountain (Waterford)', zip: '897470' },
	{ city: 'Scartnaglorane (Tipperary)', zip: '672892' },
	{ city: 'Scartnamackagh (Kerry)', zip: '997836' },
	{ city: 'Scartnamoe (Kilkenny)', zip: '799701' },
	{ city: 'Scartnamuck (Cork)', zip: '966199' },
	{ city: 'Scartore (Waterford)', zip: '670671' },
	{ city: 'Scart Upper (Cork)', zip: '609070' },
	{ city: 'Scart West (Tipperary)', zip: '955598' },
	{ city: 'Scarvy (Monaghan)', zip: '511628' },
	{ city: 'Scatternagh (Dublin)', zip: '730089' },
	{ city: 'Scatternagh (Meath)', zip: '565272' },
	{ city: 'Scattery Island (Clare)', zip: '145280' },
	{ city: 'Scaughmolin (Wexford)', zip: '420804' },
	{ city: 'Scholarstown (Dublin)', zip: '292457' },
	{ city: 'Schoolgardens (Cork)', zip: '287547' },
	{ city: 'School Land (Longford)', zip: '945345' },
	{ city: 'School-Land (Cork)', zip: '141886' },
	{ city: 'Scilly (Cork)', zip: '268108' },
	{ city: 'Scobaun (Cork)', zip: '418065' },
	{ city: 'Scogganstown (Louth)', zip: '394192' },
	{ city: 'Scolbillaun (Galway)', zip: '922139' },
	{ city: 'Scollagh (Wexford)', zip: '450731' },
	{ city: 'Scoltadillisk (Donegal)', zip: '647864' },
	{ city: 'Sconce (Offaly)', zip: '742073' },
	{ city: 'Sconce Lower (Laois)', zip: '156859' },
	{ city: 'Sconce Upper (Laois)', zip: '279678' },
	{ city: 'Scool (Clare)', zip: '850858' },
	{ city: 'Scor Beg (Roscommon)', zip: '331334' },
	{ city: 'Scordaun (Waterford)', zip: '849543' },
	{ city: 'Scorduff (Offaly)', zip: '615010' },
	{ city: 'Scor More (Roscommon)', zip: '911039' },
	{ city: 'Scotchfort (Mayo)', zip: '135526' },
	{ city: 'Scotchrath (Laois)', zip: '841694' },
	{ city: 'Scotland (Carlow)', zip: '236478' },
	{ city: 'Scotland (Donegal)', zip: '382138' },
	{ city: 'Scotland (Galway)', zip: '131797' },
	{ city: 'Scotland (Laois)', zip: '252073' },
	{ city: 'Scotsborough (Kilkenny)', zip: '372369' },
	{ city: 'Scotshouse (Monaghan)', zip: '779480' },
	{ city: 'Scotsland (Wexford)', zip: '217884' },
	{ city: 'Scotstown (Monaghan)', zip: '999867' },
	{ city: 'Scottstown (Meath)', zip: '632730' },
	{ city: 'Scoul (Limerick)', zip: '606411' },
	{ city: 'Scrabbagh (Leitrim)', zip: '701119' },
	{ city: 'Scrabbagh (Roscommon)', zip: '664665' },
	{ city: 'Scrabby (Cavan)', zip: '607379' },
	{ city: 'Scragg (Tipperary)', zip: '629580' },
	{ city: 'Scraggane (Kerry)', zip: '440942' },
	{ city: 'Scraggaun (Tipperary)', zip: '717807' },
	{ city: 'Scraggeen (Tipperary)', zip: '976642' },
	{ city: 'Scrahallia (Galway)', zip: '259662' },
	{ city: 'Scrahan (Cork)', zip: '832562' },
	{ city: 'Scrahan (Kerry)', zip: '864797' },
	{ city: 'Scrahan (Waterford)', zip: '819652' },
	{ city: 'Scrahanagnave (Kerry)', zip: '509101' },
	{ city: 'Scrahanagown (Cork)', zip: '685156' },
	{ city: 'Scrahanagullaun (Kerry)', zip: '555655' },
	{ city: 'Scrahanard (Cork)', zip: '617408' },
	{ city: 'Scrahanaveal (Kerry)', zip: '908633' },
	{ city: 'Scrahane (Kerry)', zip: '817827' },
	{ city: 'Scrahanfadda (Kerry)', zip: '220547' },
	{ city: 'Scrahanmore (Cork)', zip: '366687' },
	{ city: 'Scrahannagaur (Kerry)', zip: '702391' },
	{ city: 'Scrahans (Waterford)', zip: '182022' },
	{ city: 'Scrahans East (Waterford)', zip: '552479' },
	{ city: 'Scrahans West (Waterford)', zip: '714082' },
	{ city: 'Scrahanyleary (Cork)', zip: '513692' },
	{ city: 'Scrallaghbeg (Kerry)', zip: '683968' },
	{ city: 'Scramoge (Roscommon)', zip: '832030' },
	{ city: 'Scrarour (Cork)', zip: '991507' },
	{ city: 'Scratenagh (Wicklow)', zip: '116039' },
	{ city: 'Scrawhill (Donegal)', zip: '481936' },
	{ city: 'Screeboge (Longford)', zip: '786879' },
	{ city: 'Screeboge (Meath)', zip: '779164' },
	{ city: 'Scregg (Mayo)', zip: '702351' },
	{ city: 'Scregg (Roscommon)', zip: '442117' },
	{ city: 'Screggan (Offaly)', zip: '205346' },
	{ city: 'Scregg East (Galway)', zip: '103248' },
	{ city: 'Scregg West (Galway)', zip: '173882' },
	{ city: 'Screhan (Kilkenny)', zip: '766063' },
	{ city: 'Screhaneroe (Cork)', zip: '206996' },
	{ city: 'Scribblestown (Dublin)', zip: '660088' },
	{ city: 'Scribly (Donegal)', zip: '886614' },
	{ city: 'Scriboge (Tipperary)', zip: '384465' },
	{ city: 'Scrivoge (Cork)', zip: '805995' },
	{ city: 'Scroghil (Westmeath)', zip: '256252' },
	{ city: 'Scronagare (Cork)', zip: '477673' },
	{ city: 'Scrothea East (Tipperary)', zip: '759629' },
	{ city: 'Scrothea East (Waterford)', zip: '293639' },
	{ city: 'Scrothea West (Tipperary)', zip: '544625' },
	{ city: 'Scrothea West (Waterford)', zip: '391723' },
	{ city: 'Scrowmore (Limerick)', zip: '120415' },
	{ city: 'Scrub (Offaly)', zip: '430097' },
	{ city: 'Scrub And Glenmacolla (Laois)', zip: '984486' },
	{ city: 'Scullaboge (Wexford)', zip: '176485' },
	{ city: 'Sculleen (Cork)', zip: '608922' },
	{ city: 'Scurlocksbush (Wexford)', zip: '744499' },
	{ city: 'Scurlocksleap (Wicklow)', zip: '448856' },
	{ city: 'Scurlockstown (Meath)', zip: '690745' },
	{ city: 'Scurlockstown (Westmeath)', zip: '241941' },
	{ city: 'Scurlogebush (Wexford)', zip: '172744' },
	{ city: 'Scurlogue (Wicklow)', zip: '739932' },
	{ city: 'Scurmore (Sligo)', zip: '206113' },
	{ city: 'Seabank (Wicklow)', zip: '597624' },
	{ city: 'Seacor (Donegal)', zip: '484251' },
	{ city: 'Seadavog Mountain (Donegal)', zip: '706946' },
	{ city: 'Seafield (Clare)', zip: '475578' },
	{ city: 'Seafield (Cork)', zip: '213066' },
	{ city: 'Seafield (Galway)', zip: '395252' },
	{ city: 'Seafield (Sligo)', zip: '510720' },
	{ city: 'Seafield (Waterford)', zip: '258415' },
	{ city: 'Seafield (Wexford)', zip: '153934' },
	{ city: 'Seahill And Tuckmill Hill (Donegal)', zip: '737375' },
	{ city: 'Seamount (Wexford)', zip: '621986' },
	{ city: 'Seapoint (Dublin)', zip: '459792' },
	{ city: 'Seapoint (Galway)', zip: '762510' },
	{ city: 'Searkin (Monaghan)', zip: '897733' },
	{ city: 'Seasonpark (Wicklow)', zip: '733581' },
	{ city: 'Seasons (Kildare)', zip: '207065' },
	{ city: 'Seatown East (Dublin)', zip: '927207' },
	{ city: 'Seatown West (Dublin)', zip: '565974' },
	{ city: 'Seaveagh (Monaghan)', zip: '978032' },
	{ city: 'Seaview (Wexford)', zip: '599664' },
	{ city: 'Seaview (Wicklow)', zip: '528300' },
	{ city: 'Sedenrath (Meath)', zip: '540487' },
	{ city: 'Sedgemoor (Tipperary)', zip: '425978' },
	{ city: 'See (Cavan)', zip: '822427' },
	{ city: 'Seeaghanbaun (Mayo)', zip: '154478' },
	{ city: 'Seeaghandoo (Mayo)', zip: '565919' },
	{ city: 'Seecon (Galway)', zip: '236455' },
	{ city: 'Seeconglas (Limerick)', zip: '132328' },
	{ city: 'Seecrin (Louth)', zip: '275301' },
	{ city: 'Seedagh (Donegal)', zip: '838624' },
	{ city: 'Seeds (Cork)', zip: '896155' },
	{ city: 'Seefin (Cavan)', zip: '260060' },
	{ city: 'Seefin (Galway)', zip: '922827' },
	{ city: 'Seefin (Mayo)', zip: '915531' },
	{ city: 'Seefin (Offaly)', zip: '960699' },
	{ city: 'Seefin (Sligo)', zip: '995613' },
	{ city: 'Seehanes (Cork)', zip: '844943' },
	{ city: 'Seeharan (Cavan)', zip: '488237' },
	{ city: 'Seemochuda (Waterford)', zip: '941027' },
	{ city: 'Seeoge (Westmeath)', zip: '568066' },
	{ city: 'Seeola (Monaghan)', zip: '261668' },
	{ city: 'Seeoran (Cavan)', zip: '847916' },
	{ city: 'Seersha (Clare)', zip: '657774' },
	{ city: 'Seersha (Kerry)', zip: '264394' },
	{ city: 'Seershin (Galway)', zip: '639204' },
	{ city: 'Seevness (Sligo)', zip: '435540' },
	{ city: 'Segravescastle (Kildare)', zip: '785312' },
	{ city: 'Seixeslough (Kilkenny)', zip: '746004' },
	{ city: 'Seller (Meath)', zip: '609441' },
	{ city: 'Sellernaun East (Clare)', zip: '207794' },
	{ city: 'Sellernaun West (Clare)', zip: '247801' },
	{ city: 'Selloo (Monaghan)', zip: '220737' },
	{ city: 'Seltan (Leitrim)', zip: '453744' },
	{ city: 'Seltanahunshin (Leitrim)', zip: '592017' },
	{ city: 'Seltannasaggart (Leitrim)', zip: '656871' },
	{ city: 'Seltannaskeagh (Leitrim)', zip: '469789' },
	{ city: 'Seltannaveeny (Roscommon)', zip: '489708' },
	{ city: 'Seneschalstown (Meath)', zip: '153297' },
	{ city: 'Sentryhill (Laois)', zip: '769262' },
	{ city: 'Seraghstown (Meath)', zip: '419923' },
	{ city: "Sergeant's-Lot (Tipperary)", zip: '653283' },
	{ city: 'Seskin (Carlow)', zip: '513298' },
	{ city: 'Seskin (Kilkenny)', zip: '675567' },
	{ city: 'Seskin (Tipperary)', zip: '897698' },
	{ city: 'Seskin (Wicklow)', zip: '671891' },
	{ city: 'Seskin Little (Kilkenny)', zip: '576306' },
	{ city: 'Seskin Lower (Carlow)', zip: '956327' },
	{ city: 'Seskinnamadra (Carlow)', zip: '887272' },
	{ city: 'Seskin North (Kilkenny)', zip: '838539' },
	{ city: 'Seskinrea (Carlow)', zip: '456907' },
	{ city: 'Seskinryan (Carlow)', zip: '737678' },
	{ city: 'Seskin South (Kilkenny)', zip: '929128' },
	{ city: 'Seskin Upper (Carlow)', zip: '404833' },
	{ city: 'Sesnacully (Donegal)', zip: '237783' },
	{ city: 'Sessiagh (Donegal)', zip: '213541' },
	{ city: 'Sessiagh (Leitrim)', zip: '504110' },
	{ city: 'Sessiagh (Mayo)', zip: '825984' },
	{ city: 'Sessiaghkeelta (Donegal)', zip: '707160' },
	{ city: 'Sessuecommon (Sligo)', zip: '281709' },
	{ city: 'Sessuegarry (Sligo)', zip: '174893' },
	{ city: 'Sessuegilroy (Sligo)', zip: '578112' },
	{ city: 'Sevenchurches (Wicklow)', zip: '594822' },
	{ city: 'Sevenparks (Dublin)', zip: '504305' },
	{ city: 'Sevensisters (Kilkenny)', zip: '574197' },
	{ city: 'Sevitsland (Meath)', zip: '731917' },
	{ city: 'Seymourstown Black (Meath)', zip: '561561' },
	{ city: 'Seymourstown White (Meath)', zip: '614511' },
	{ city: 'Shaen (Laois)', zip: '187509' },
	{ city: 'Shallee (Clare)', zip: '607135' },
	{ city: 'Shallee (Tipperary)', zip: '444906' },
	{ city: 'Shallee Lower And Upper (Tipperary)', zip: '731694' },
	{ city: 'Shallogan Beg (Donegal)', zip: '926193' },
	{ city: 'Shallogan More (Donegal)', zip: '348251' },
	{ city: 'Shallon (Dublin)', zip: '134297' },
	{ city: 'Shallon (Meath)', zip: '983505' },
	{ city: 'Shallowspark (Wexford)', zip: '809584' },
	{ city: 'Shalvanstown (Meath)', zip: '129175' },
	{ city: 'Shalwy (Donegal)', zip: '500704' },
	{ city: 'Shammerbaun (Mayo)', zip: '225954' },
	{ city: 'Shammerdoo (Mayo)', zip: '766968' },
	{ city: 'Shamrockhill (Louth)', zip: '577934' },
	{ city: 'Shamrocklodge (Kildare)', zip: '621740' },
	{ city: 'Shanaboola (Cork)', zip: '662509' },
	{ city: 'Shanacashel (Cork)', zip: '777537' },
	{ city: 'Shanacashel (Kerry)', zip: '739278' },
	{ city: 'Shanacashelkneeves (Cork)', zip: '977551' },
	{ city: 'Shanaclogh (Cork)', zip: '420599' },
	{ city: 'Shanaclogh (Limerick)', zip: '367613' },
	{ city: 'Shanaclogh East (Limerick)', zip: '486692' },
	{ city: 'Shanaclogh West (Limerick)', zip: '989950' },
	{ city: 'Shanaclone (Waterford)', zip: '191513' },
	{ city: 'Shanacloon (Cork)', zip: '973774' },
	{ city: 'Shanacloon (Kerry)', zip: '775020' },
	{ city: 'Shanacloon (Kildare)', zip: '604983' },
	{ city: 'Shanacloon (Limerick)', zip: '911075' },
	{ city: 'Shanacloon (Offaly)', zip: '138184' },
	{ city: 'Shanacloon (Tipperary)', zip: '312352' },
	{ city: 'Shanacloon (Waterford)', zip: '509497' },
	{ city: 'Shanacloon (Wexford)', zip: '862722' },
	{ city: 'Shanacloyne (Cork)', zip: '852686' },
	{ city: 'Shanacool (Kerry)', zip: '635003' },
	{ city: 'Shanacool (Waterford)', zip: '609399' },
	{ city: 'Shanacoole (Waterford)', zip: '333736' },
	{ city: 'Shanacoumha (Cork)', zip: '953242' },
	{ city: 'Shanacrane East (Cork)', zip: '356737' },
	{ city: 'Shanacrane West (Cork)', zip: '953589' },
	{ city: 'Shanadullaun (Galway)', zip: '725607' },
	{ city: 'Shanafaraghaun (Galway)', zip: '179681' },
	{ city: 'Shanafona (Kerry)', zip: '212016' },
	{ city: 'Shanagarry (Cork)', zip: '448625' },
	{ city: 'Shanagarry North (Cork)', zip: '681948' },
	{ city: 'Shanagarry South (Cork)', zip: '918387' },
	{ city: 'Shanagh (Cork)', zip: '844372' },
	{ city: 'Shanagh (Mayo)', zip: '219674' },
	{ city: 'Shanaghan (Donegal)', zip: '342012' },
	{ city: 'Shanaghmoyle (Mayo)', zip: '165923' },
	{ city: 'Shanaghobarravane (Cork)', zip: '393293' },
	{ city: 'Shanaghy (Mayo)', zip: '600526' },
	{ city: 'Shanagolden (Limerick)', zip: '399218' },
	{ city: 'Shanagolden Demesne (Limerick)', zip: '289232' },
	{ city: 'Shanagraigue (Cork)', zip: '236962' },
	{ city: 'Shanahee (Cork)', zip: '617006' },
	{ city: 'Shanahill (Kerry)', zip: '385690' },
	{ city: 'Shanahill East (Kerry)', zip: '903249' },
	{ city: 'Shanahoe (Laois)', zip: '712130' },
	{ city: 'Shanahona (Wexford)', zip: '737617' },
	{ city: 'Shanakeal (Kerry)', zip: '964595' },
	{ city: 'Shanakeever (Galway)', zip: '325936' },
	{ city: 'Shanakill (Cork)', zip: '837560' },
	{ city: 'Shanakill (Kerry)', zip: '222854' },
	{ city: 'Shanakill (Tipperary)', zip: '404343' },
	{ city: 'Shanakill (Waterford)', zip: '383706' },
	{ city: 'Shanakill Lower (Cork)', zip: '119994' },
	{ city: 'Shanakill Lower (Tipperary)', zip: '125712' },
	{ city: 'Shanakill Upper (Cork)', zip: '419820' },
	{ city: 'Shanakill Upper (Tipperary)', zip: '808060' },
	{ city: 'Shanaknock (Cork)', zip: '110617' },
	{ city: 'Shanaknock (Kerry)', zip: '420204' },
	{ city: 'Shanaknock (Tipperary)', zip: '381739' },
	{ city: 'Shanakyle (Kerry)', zip: '655864' },
	{ city: 'Shanakyle (Tipperary)', zip: '624557' },
	{ city: 'Shanapollagh (Waterford)', zip: '157800' },
	{ city: 'Shanavagh (Cork)', zip: '217264' },
	{ city: 'Shanavagha (Cork)', zip: '288041' },
	{ city: 'Shanavagoon (Cork)', zip: '582582' },
	{ city: 'Shanavalla (Cork)', zip: '543265' },
	{ city: 'Shanavally (Cork)', zip: '841675' },
	{ city: 'Shanavally (Kerry)', zip: '760436' },
	{ city: 'Shanavally (Tipperary)', zip: '627245' },
	{ city: 'Shanavallyleigh (Cork)', zip: '509689' },
	{ city: 'Shanavaur (Laois)', zip: '281239' },
	{ city: 'Shanaveag (Galway)', zip: '679702' },
	{ city: 'Shanavogh East (Clare)', zip: '893439' },
	{ city: 'Shanavogh West (Clare)', zip: '846298' },
	{ city: 'Shanavoher (Cork)', zip: '263848' },
	{ city: 'Shanavoola (Waterford)', zip: '894684' },
	{ city: 'Shanavougha (Cork)', zip: '432597' },
	{ city: 'Shanaway East (Cork)', zip: '130544' },
	{ city: 'Shanaway East (Kerry)', zip: '766141' },
	{ city: 'Shanaway Middle (Cork)', zip: '740536' },
	{ city: 'Shanaway West (Cork)', zip: '757989' },
	{ city: 'Shanaway West (Kerry)', zip: '743096' },
	{ city: 'Shanawillen (Kerry)', zip: '931136' },
	{ city: 'Shanballard (Galway)', zip: '412675' },
	{ city: 'Shanbally (Clare)', zip: '243673' },
	{ city: 'Shanbally (Cork)', zip: '813919' },
	{ city: 'Shanbally (Donegal)', zip: '172771' },
	{ city: 'Shanbally (Galway)', zip: '290660' },
	{ city: 'Shanbally (Kerry)', zip: '967914' },
	{ city: 'Shanbally (Laois)', zip: '711417' },
	{ city: 'Shanbally (Limerick)', zip: '996103' },
	{ city: 'Shanbally (Tipperary)', zip: '711946' },
	{ city: 'Shanbally (Waterford)', zip: '108023' },
	{ city: 'Shanballyanne (Waterford)', zip: '916920' },
	{ city: 'Shanballyard (Tipperary)', zip: '382505' },
	{ city: 'Shanballybaun (Roscommon)', zip: '785897' },
	{ city: 'Shanballybeg (Galway)', zip: '132404' },
	{ city: 'Shanballycleary (Tipperary)', zip: '527442' },
	{ city: 'Shanballycolman (Galway)', zip: '296902' },
	{ city: 'Shanballyduff (Galway)', zip: '647438' },
	{ city: 'Shanballyduff (Tipperary)', zip: '868301' },
	{ city: 'Shanballyeden (Roscommon)', zip: '785373' },
	{ city: 'Shanballyedmond (Tipperary)', zip: '719513' },
	{ city: 'Shanballyeeshal (Galway)', zip: '821462' },
	{ city: 'Shanballylosky (Roscommon)', zip: '852817' },
	{ city: 'Shanballymore (Cork)', zip: '630004' },
	{ city: 'Shanballymore (Galway)', zip: '436219' },
	{ city: 'Shanballymore (Roscommon)', zip: '703241' },
	{ city: 'Shanballymore (Tipperary)', zip: '458550' },
	{ city: 'Shanballymore Lower (Cork)', zip: '191500' },
	{ city: 'Shanballymore Upper (Cork)', zip: '636993' },
	{ city: 'Shanballynahagh (Tipperary)', zip: '512988' },
	{ city: 'Shanballynakill (Offaly)', zip: '455783' },
	{ city: 'Shanballyreagh (Cork)', zip: '940313' },
	{ city: 'Shanballysallagh (Clare)', zip: '496719' },
	{ city: 'Shanbeg (Laois)', zip: '215158' },
	{ city: 'Shanbo (Meath)', zip: '364672' },
	{ city: 'Shanboe (Laois)', zip: '122700' },
	{ city: 'Shanbogh Lower (Kilkenny)', zip: '973211' },
	{ city: 'Shanbogh Upper (Kilkenny)', zip: '894428' },
	{ city: 'Shanboley (Galway)', zip: '298056' },
	{ city: 'Shanboolard (Galway)', zip: '909193' },
	{ city: 'Shancarnan (Meath)', zip: '442120' },
	{ city: 'Shancarrick (Leitrim)', zip: '385434' },
	{ city: 'Shancarrigeen (Sligo)', zip: '781241' },
	{ city: 'Shancashlaun (Kilkenny)', zip: '375962' },
	{ city: 'Shanclogh (Galway)', zip: '126218' },
	{ city: 'Shanclogh (Mayo)', zip: '950007' },
	{ city: 'Shancloon (Galway)', zip: '955076' },
	{ city: 'Shanco (Meath)', zip: '128723' },
	{ city: 'Shanco (Monaghan)', zip: '453279' },
	{ city: 'Shancobane (Monaghan)', zip: '322859' },
	{ city: 'Shancoduff (Monaghan)', zip: '292607' },
	{ city: 'Shancor (Cavan)', zip: '473780' },
	{ city: 'Shancor (Meath)', zip: '684599' },
	{ city: 'Shancorn (Cavan)', zip: '900591' },
	{ city: 'Shancorry (Cavan)', zip: '720201' },
	{ city: 'Shancough (Sligo)', zip: '978559' },
	{ city: 'Shancroaghan (Cavan)', zip: '411033' },
	{ city: 'Shancrock (Sligo)', zip: '662504' },
	{ city: 'Shancurragh (Leitrim)', zip: '934384' },
	{ city: 'Shancurragh Barr Of (Leitrim)', zip: '519127' },
	{ city: 'Shancurry (Leitrim)', zip: '753859' },
	{ city: 'Shandangan (Clare)', zip: '618079' },
	{ city: 'Shandangan (Limerick)', zip: '171917' },
	{ city: 'Shandangan (Tipperary)', zip: '269881' },
	{ city: 'Shandangan East (Clare)', zip: '176423' },
	{ city: 'Shandangan East (Cork)', zip: '107695' },
	{ city: 'Shandangan West (Clare)', zip: '538106' },
	{ city: 'Shandangan West (Cork)', zip: '753748' },
	{ city: 'Shanderry (Laois)', zip: '867736' },
	{ city: 'Shanderry (Offaly)', zip: '654614' },
	{ city: 'Shandon (Waterford)', zip: '973909' },
	{ city: 'Shandrim (Donegal)', zip: '320749' },
	{ city: 'Shandrum (Clare)', zip: '587718' },
	{ city: 'Shandrum (Cork)', zip: '356521' },
	{ city: 'Shandrum (Kerry)', zip: '716572' },
	{ city: 'Shandrum (Mayo)', zip: '559608' },
	{ city: 'Shandrum Beg (Cork)', zip: '681769' },
	{ city: 'Shandrum More (Cork)', zip: '320745' },
	{ city: 'Shane (Monaghan)', zip: '759026' },
	{ city: 'Shanemullagh (Monaghan)', zip: '371981' },
	{ city: 'Shanettra (Mayo)', zip: '188862' },
	{ city: 'Shanganagh (Clare)', zip: '294587' },
	{ city: 'Shanganagh (Dublin)', zip: '993980' },
	{ city: 'Shanganagh Beg (Laois)', zip: '761749' },
	{ city: 'Shanganagh More (Laois)', zip: '154665' },
	{ city: 'Shanganhill (Dublin)', zip: '645472' },
	{ city: 'Shanganny (Kilkenny)', zip: '760261' },
	{ city: 'Shangarry (Carlow)', zip: '354315' },
	{ city: 'Shangarry (Galway)', zip: '406720' },
	{ city: 'Shangarry (Limerick)', zip: '470967' },
	{ city: 'Shangarry (Tipperary)', zip: '600170' },
	{ city: 'Shangort (Galway)', zip: '990737' },
	{ city: 'Shangort (Mayo)', zip: '322299' },
	{ city: 'Shangownagh (Laois)', zip: '107518' },
	{ city: 'Shanid Lower (Limerick)', zip: '569511' },
	{ city: 'Shanid Upper (Limerick)', zip: '208513' },
	{ city: 'Shankill (Cavan)', zip: '209565' },
	{ city: 'Shankill (Dublin)', zip: '161007' },
	{ city: 'Shankill (Galway)', zip: '443663' },
	{ city: 'Shankill (Kilkenny)', zip: '869684' },
	{ city: 'Shankill (Monaghan)', zip: '251990' },
	{ city: 'Shankill (Roscommon)', zip: '805438' },
	{ city: 'Shankill (Wicklow)', zip: '727504' },
	{ city: 'Shankill East (Galway)', zip: '509345' },
	{ city: 'Shankill Lower (Cavan)', zip: '459770' },
	{ city: 'Shankill Upper (Cavan)', zip: '571608' },
	{ city: 'Shankill West (Galway)', zip: '803328' },
	{ city: 'Shankoagh (Roscommon)', zip: '329503' },
	{ city: 'Shanlaragh (Cork)', zip: '688686' },
	{ city: 'Shanlis (Louth)', zip: '569384' },
	{ city: 'Shanlothe (Meath)', zip: '344701' },
	{ city: 'Shanlough Point (Donegal)', zip: '806834' },
	{ city: 'Shanlyre (Cork)', zip: '304819' },
	{ city: 'Shanmullagh (Longford)', zip: '411622' },
	{ city: 'Shanmullagh (Louth)', zip: '175882' },
	{ city: 'Shanmullagh (Monaghan)', zip: '570895' },
	{ city: 'Shanmullagh North (Monaghan)', zip: '881899' },
	{ city: 'Shanmullagh South (Monaghan)', zip: '910136' },
	{ city: 'Shannabooly (Limerick)', zip: '817079' },
	{ city: 'Shannacool (Clare)', zip: '263130' },
	{ city: 'Shannadonnell (Galway)', zip: '878445' },
	{ city: 'Shannadullaghaun (Galway)', zip: '846817' },
	{ city: 'Shannafreaghoge (Galway)', zip: '109517' },
	{ city: 'Shannagh (Donegal)', zip: '141856' },
	{ city: 'Shannagh (Leitrim)', zip: '367096' },
	{ city: 'Shannagh Beg (Galway)', zip: '857997' },
	{ city: 'Shannaghdoo (Donegal)', zip: '498510' },
	{ city: 'Shannagh More (Galway)', zip: '481954' },
	{ city: 'Shannagurraun (Galway)', zip: '564223' },
	{ city: 'Shannakea Beg (Clare)', zip: '672880' },
	{ city: 'Shannakea More (Clare)', zip: '386513' },
	{ city: 'Shannakeela (Galway)', zip: '511497' },
	{ city: 'Shannaknock (Clare)', zip: '959136' },
	{ city: 'Shannakyle (Clare)', zip: '882856' },
	{ city: 'Shannanagower (Galway)', zip: '496879' },
	{ city: 'Shannapheasteen (Galway)', zip: '250954' },
	{ city: 'Shannasmore (Mayo)', zip: '917101' },
	{ city: 'Shannaunnafeola (Galway)', zip: '561972' },
	{ city: 'Shannavara (Galway)', zip: '208001' },
	{ city: 'Shannawagh (Galway)', zip: '314539' },
	{ city: 'Shannawirra (Galway)', zip: '166802' },
	{ city: 'Shannawona (Galway)', zip: '242167' },
	{ city: 'Shannawoneen (Galway)', zip: '395198' },
	{ city: 'Shannera Lower (Kerry)', zip: '149700' },
	{ city: 'Shannera Upper (Kerry)', zip: '213467' },
	{ city: 'Shannon (Clare)', zip: '340483' },
	{ city: 'Shannonbridge (Offaly)', zip: '954683' },
	{ city: 'Shannon Eighter (Sligo)', zip: '865650' },
	{ city: 'Shannongrove (Limerick)', zip: '291680' },
	{ city: 'Shannonhall (Tipperary)', zip: '515873' },
	{ city: 'Shannon Harbour (Offaly)', zip: '461033' },
	{ city: 'Shannon Lower (Donegal)', zip: '357172' },
	{ city: 'Shannon Middle (Donegal)', zip: '567215' },
	{ city: 'Shannon Oughter (Sligo)', zip: '347059' },
	{ city: 'Shannonpark (Cork)', zip: '337127' },
	{ city: 'Shannonspark East (Sligo)', zip: '692655' },
	{ city: 'Shannonspark West (Sligo)', zip: '999355' },
	{ city: 'Shannonvale (Tipperary)', zip: '571043' },
	{ city: 'Shannonview (Limerick)', zip: '485135' },
	{ city: 'Shannow (Cavan)', zip: '153272' },
	{ city: 'Shannow Lower (Cavan)', zip: '360128' },
	{ city: 'Shannow Upper (Cavan)', zip: '479835' },
	{ city: 'Shannow Wood (Cavan)', zip: '289372' },
	{ city: 'Shanonagh (Westmeath)', zip: '353066' },
	{ city: 'Shanoo (Wexford)', zip: '355901' },
	{ city: 'Shanowle (Wexford)', zip: '466491' },
	{ city: 'Shanpallas (Limerick)', zip: '489587' },
	{ city: 'Shanragh (Laois)', zip: '941863' },
	{ city: 'Shanrah (Monaghan)', zip: '894053' },
	{ city: 'Shanrahan (Tipperary)', zip: '973888' },
	{ city: 'Shanraheen (Kildare)', zip: '787604' },
	{ city: 'Shanrath (Kildare)', zip: '374710' },
	{ city: 'Shanrath (Limerick)', zip: '755334' },
	{ city: 'Shanrath East (Kildare)', zip: '739643' },
	{ city: 'Shanrath West (Kildare)', zip: '791200' },
	{ city: 'Shanraw (Leitrim)', zip: '293479' },
	{ city: 'Shanrawy (Mayo)', zip: '143573' },
	{ city: 'Shanroe (Monaghan)', zip: '638134' },
	{ city: 'Shantalliv (Kerry)', zip: '498481' },
	{ city: 'Shantallow (Galway)', zip: '443698' },
	{ city: 'Shantallow (Mayo)', zip: '136568' },
	{ city: 'Shantemon (Cavan)', zip: '223016' },
	{ city: 'Shantonagh (Monaghan)', zip: '736271' },
	{ city: 'Shantony (Monaghan)', zip: '350239' },
	{ city: 'Shantraud (Clare)', zip: '305213' },
	{ city: 'Shantraud (Limerick)', zip: '769253' },
	{ city: 'Shantulla (Clare)', zip: '418459' },
	{ city: 'Shantullig North (Cork)', zip: '418807' },
	{ city: 'Shantullig South (Cork)', zip: '805383' },
	{ city: 'Shantully (Cavan)', zip: '551130' },
	{ city: 'Shantum (Longford)', zip: '488253' },
	{ city: 'Shanvaghera (Mayo)', zip: '823790' },
	{ city: 'Shanvaghey (Laois)', zip: '689862' },
	{ city: 'Shanvally (Galway)', zip: '331106' },
	{ city: 'Shanvally (Laois)', zip: '264201' },
	{ city: 'Shanvally (Mayo)', zip: '541849' },
	{ city: 'Shanvally (Offaly)', zip: '930685' },
	{ city: 'Shanvally (Tipperary)', zip: '313426' },
	{ city: 'Shanvallyard (Mayo)', zip: '763157' },
	{ city: 'Shanvallybeg (Cork)', zip: '745451' },
	{ city: 'Shanvallybeg (Mayo)', zip: '436324' },
	{ city: 'Shanvallyboght (Mayo)', zip: '558721' },
	{ city: 'Shanvallycahill (Mayo)', zip: '816073' },
	{ city: 'Shanvallyhugh (Mayo)', zip: '641128' },
	{ city: 'Shanvallyshane (Cork)', zip: '181272' },
	{ city: 'Shanvaus (Leitrim)', zip: '385704' },
	{ city: 'Shanvodinnaun (Mayo)', zip: '782232' },
	{ city: 'Shanvogh (Clare)', zip: '240924' },
	{ city: 'Shanvoher (Galway)', zip: '324148' },
	{ city: 'Shanvolahan (Mayo)', zip: '606095' },
	{ city: 'Shanvoley (Galway)', zip: '917960' },
	{ city: 'Shanvoley (Mayo)', zip: '155809' },
	{ city: 'Shanvoley (Roscommon)', zip: '389129' },
	{ city: 'Shanwar (Mayo)', zip: '879496' },
	{ city: 'Sharagore (Donegal)', zip: '627425' },
	{ city: 'Sharavogue (Offaly)', zip: '455380' },
	{ city: 'Sharon Glebe (Donegal)', zip: '488002' },
	{ city: 'Sharragh (Tipperary)', zip: '205823' },
	{ city: 'Sharvoge (Longford)', zip: '299691' },
	{ city: 'Shasgar (Leitrim)', zip: '208470' },
	{ city: 'Shasmore (Leitrim)', zip: '875313' },
	{ city: 'Shass (Leitrim)', zip: '332467' },
	{ city: 'Shawstown (Wexford)', zip: '655000' },
	{ city: 'Sheafield North (Kilkenny)', zip: '368334' },
	{ city: 'Sheafield South (Kilkenny)', zip: '331956' },
	{ city: 'Shean (Cork)', zip: '528575' },
	{ city: 'Shean (Offaly)', zip: '499110' },
	{ city: 'Shean Beg (Waterford)', zip: '177273' },
	{ city: 'Sheanliss (Cork)', zip: '961757' },
	{ city: 'Shean Lower (Cork)', zip: '179262' },
	{ city: 'Shean More (Waterford)', zip: '303836' },
	{ city: 'Sheans East (Kerry)', zip: '477316' },
	{ city: 'Sheans West (Kerry)', zip: '824895' },
	{ city: 'Shean Upper (Cork)', zip: '634016' },
	{ city: 'Sheastown (Kilkenny)', zip: '847049' },
	{ city: 'Sheastown (Wexford)', zip: '894193' },
	{ city: 'Shee (Monaghan)', zip: '761279' },
	{ city: 'Sheean (Carlow)', zip: '670501' },
	{ city: 'Sheean (Kildare)', zip: '386720' },
	{ city: 'Sheean (Leitrim)', zip: '475544' },
	{ city: 'Sheean (Mayo)', zip: '617305' },
	{ city: 'Sheean (Roscommon)', zip: '588656' },
	{ city: 'Sheean (Westmeath)', zip: '804912' },
	{ city: 'Sheeanabeg (Wicklow)', zip: '435737' },
	{ city: 'Sheeana More (Wicklow)', zip: '126114' },
	{ city: 'Sheeanmore (Mayo)', zip: '273378' },
	{ city: 'Sheeanmore (Sligo)', zip: '760266' },
	{ city: 'Sheeans (Mayo)', zip: '722929' },
	{ city: 'Sheeaun (Clare)', zip: '468471' },
	{ city: 'Sheeaun (Galway)', zip: '912094' },
	{ city: 'Sheeaunpark (Galway)', zip: '944568' },
	{ city: 'Sheeaunroe (Galway)', zip: '745610' },
	{ city: 'Sheeaunrush (Galway)', zip: '753360' },
	{ city: 'Sheeauns (Galway)', zip: '671495' },
	{ city: 'Sheebeg (Leitrim)', zip: '892204' },
	{ city: 'Sheefin (Westmeath)', zip: '982818' },
	{ city: 'Sheegan (Galway)', zip: '107735' },
	{ city: 'Sheegeeragh (Roscommon)', zip: '916034' },
	{ city: 'Sheegorey (Roscommon)', zip: '180725' },
	{ city: 'Sheegys (Donegal)', zip: '219226' },
	{ city: 'Sheehane (Tipperary)', zip: '176969' },
	{ city: 'Sheehaun (Roscommon)', zip: '662581' },
	{ city: 'Sheelagh (Louth)', zip: '207549' },
	{ city: 'Sheelruddera (Tipperary)', zip: '699354' },
	{ city: 'Sheemore (Leitrim)', zip: '450905' },
	{ city: 'Sheena (Leitrim)', zip: '986149' },
	{ city: 'Sheeny (Meath)', zip: '130409' },
	{ city: 'Sheepgrange (Louth)', zip: '479587' },
	{ city: 'Sheephill (Dublin)', zip: '279387' },
	{ city: 'Sheephouse (Meath)', zip: '667593' },
	{ city: 'Sheephouse (Wexford)', zip: '451847' },
	{ city: 'Sheephouse (Wicklow)', zip: '686108' },
	{ city: 'Sheepmoor (Dublin)', zip: '715619' },
	{ city: 'Sheep Park (Donegal)', zip: '339963' },
	{ city: 'Sheepstown (Kilkenny)', zip: '856924' },
	{ city: 'Sheepstown (Westmeath)', zip: '992233' },
	{ city: 'Sheeptown (Kilkenny)', zip: '660801' },
	{ city: 'Sheepwalk (Cork)', zip: '263796' },
	{ city: 'Sheepwalk (Galway)', zip: '206094' },
	{ city: 'Sheepwalk (Kerry)', zip: '112225' },
	{ city: 'Sheepwalk (Louth)', zip: '558966' },
	{ city: 'Sheepwalk (Roscommon)', zip: '703953' },
	{ city: 'Sheepwalk (Wexford)', zip: '173515' },
	{ city: 'Sheepwalk (Wicklow)', zip: '817748' },
	{ city: 'Sheepwalk East (Cork)', zip: '142059' },
	{ city: 'Sheepwalk West (Cork)', zip: '630575' },
	{ city: 'Sheercloon (Donegal)', zip: '601706' },
	{ city: 'Sheerevagh (Roscommon)', zip: '617866' },
	{ city: 'Sheerevagh (Sligo)', zip: '716227' },
	{ city: 'Sheeroe (Longford)', zip: '974264' },
	{ city: 'Sheeroe (Mayo)', zip: '679921' },
	{ city: 'Sheetrim (Monaghan)', zip: '687771' },
	{ city: 'Sheevannan (Roscommon)', zip: '624239' },
	{ city: 'Sheffield (Leitrim)', zip: '411640' },
	{ city: 'Sheheree (Kerry)', zip: '452868' },
	{ city: 'Shehy Beg (Cork)', zip: '527186' },
	{ city: 'Shehy More (Cork)', zip: '355215' },
	{ city: 'Sheilstown (Wicklow)', zip: '388212' },
	{ city: 'Shelbaggan (Wexford)', zip: '591693' },
	{ city: 'Shelbourne (Offaly)', zip: '762395' },
	{ city: 'Shellfield (Donegal)', zip: '768503' },
	{ city: 'Shellumsrath (Kilkenny)', zip: '987178' },
	{ city: 'Shelmaliere Commons (Wexford)', zip: '566633' },
	{ city: 'Shelton (Wicklow)', zip: '275450' },
	{ city: 'Shelton Abbey (Wicklow)', zip: '874380' },
	{ city: 'Shelvins (Monaghan)', zip: '677657' },
	{ city: 'Shepherdshill (Wicklow)', zip: '351203' },
	{ city: 'Shercock (Cavan)', zip: '163757' },
	{ city: 'Sheriffhill (Kildare)', zip: '138473' },
	{ city: 'Sherky Island (Kerry)', zip: '701006' },
	{ city: 'Sherlockstown (Kildare)', zip: '320363' },
	{ city: 'Sherlockstown Common (Kildare)', zip: '139466' },
	{ city: 'Sherwood (Carlow)', zip: '539403' },
	{ city: 'Sherwood (Wexford)', zip: '325340' },
	{ city: 'Sherwoodpark (Carlow)', zip: '341226' },
	{ city: 'Shesharoe (Tipperary)', zip: '684943' },
	{ city: 'Shesheraghkeale (Tipperary)', zip: '493268' },
	{ city: 'Shesheraghmore (Tipperary)', zip: '758793' },
	{ city: 'Shesheraghscanlan (Tipperary)', zip: '209323' },
	{ city: 'Sheshia (Clare)', zip: '550019' },
	{ city: 'Sheshiv (Limerick)', zip: '153856' },
	{ city: 'Sheshodonnell East (Clare)', zip: '261508' },
	{ city: 'Sheshodonnell West (Clare)', zip: '253677' },
	{ city: 'Sheshoon (Kildare)', zip: '572568' },
	{ city: 'Sheshymore (Clare)', zip: '918213' },
	{ city: 'Sheskernagh (Westmeath)', zip: '385341' },
	{ city: 'Sheskin (Cork)', zip: '261610' },
	{ city: 'Sheskin (Leitrim)', zip: '833407' },
	{ city: 'Sheskin (Mayo)', zip: '940943' },
	{ city: 'Sheskin (Monaghan)', zip: '192266' },
	{ city: 'Sheskin (Offaly)', zip: '680414' },
	{ city: 'Sheskin (Tipperary)', zip: '798058' },
	{ city: 'Sheskin (Waterford)', zip: '590961' },
	{ city: 'Sheskinacurry (Leitrim)', zip: '563021' },
	{ city: 'Sheskinapoll (Donegal)', zip: '176494' },
	{ city: 'Sheskinarone (Donegal)', zip: '982384' },
	{ city: 'Sheskinatawy (Donegal)', zip: '160195' },
	{ city: 'Sheskinbeg (Donegal)', zip: '897087' },
	{ city: 'Sheskin Commons (Kilkenny)', zip: '473013' },
	{ city: 'Shesknan (Leitrim)', zip: '828884' },
	{ city: 'Shessanagirba (Galway)', zip: '127331' },
	{ city: 'Shessareagh (Galway)', zip: '980191' },
	{ city: 'Shessiv (Clare)', zip: '838439' },
	{ city: 'Shessy North (Galway)', zip: '796640' },
	{ city: 'Shessy South (Galway)', zip: '682892' },
	{ city: 'Shevry (Tipperary)', zip: '913229' },
	{ city: 'Shibbilis (Cavan)', zip: '342016' },
	{ city: 'Shigaunagh (Galway)', zip: '277173' },
	{ city: 'Shilbrack (Wexford)', zip: '471338' },
	{ city: 'Shillelagh (Wicklow)', zip: '840978' },
	{ city: 'Shilmaine (Wexford)', zip: '431502' },
	{ city: 'Shilmore (Wexford)', zip: '195006' },
	{ city: 'Shinagh (Cork)', zip: '259693' },
	{ city: 'Shinan (Cavan)', zip: '185308' },
	{ city: 'Shinanagh (Cork)', zip: '314610' },
	{ city: 'Shindala (Kildare)', zip: '853447' },
	{ city: 'Shinganagh (Mayo)', zip: '811500' },
	{ city: 'Shinganagh (Tipperary)', zip: '672316' },
	{ city: 'Shinganagh (Waterford)', zip: '325944' },
	{ city: 'Shingaun (Wexford)', zip: '632388' },
	{ city: 'Shingaunagh North (Clare)', zip: '360790' },
	{ city: 'Shingaunagh South (Clare)', zip: '335815' },
	{ city: 'Shinglis (Westmeath)', zip: '751992' },
	{ city: 'Shinnagh (Kerry)', zip: '325112' },
	{ city: 'Shinnagh (Mayo)', zip: '399950' },
	{ city: 'Shinnanagh (Galway)', zip: '552972' },
	{ city: 'Shinrone (Offaly)', zip: '251111' },
	{ city: 'Shiplough (Cork)', zip: '281199' },
	{ city: 'Ship-Pool (Cork)', zip: '528756' },
	{ city: 'Shirsheen (Wexford)', zip: '363544' },
	{ city: 'Shivdelagh (Leitrim)', zip: '365247' },
	{ city: 'Shivdilla (Leitrim)', zip: '111208' },
	{ city: 'Shoalmore (Leitrim)', zip: '952698' },
	{ city: 'Shoodaun (Galway)', zip: '893879' },
	{ city: 'Shortallstown (Kilkenny)', zip: '830442' },
	{ city: 'Shortalstown (Wexford)', zip: '210550' },
	{ city: 'Shortcastle (Tipperary)', zip: '606941' },
	{ city: 'Shortstone East (Louth)', zip: '392622' },
	{ city: 'Shortstone West (Louth)', zip: '949245' },
	{ city: 'Shortwood (Kildare)', zip: '277433' },
	{ city: 'Shouks (Wexford)', zip: '479901' },
	{ city: 'Shower (Tipperary)', zip: '747077' },
	{ city: 'Shreelane (Cork)', zip: '204559' },
	{ city: 'Shronaboy (Kerry)', zip: '395227' },
	{ city: 'Shronacarton (Cork)', zip: '824597' },
	{ city: 'Shronagree (Cork)', zip: '374673' },
	{ city: 'Shronagreehy (Cork)', zip: '603562' },
	{ city: 'Shronahiree Beg (Kerry)', zip: '350428' },
	{ city: 'Shronahiree More (Kerry)', zip: '675818' },
	{ city: 'Shronaloughane (Kerry)', zip: '310261' },
	{ city: 'Shrone (Cork)', zip: '903730' },
	{ city: 'Shrone (Kerry)', zip: '322771' },
	{ city: 'Shrone Beg (Kerry)', zip: '519261' },
	{ city: 'Shronebeha (Cork)', zip: '598793' },
	{ city: 'Shronebeirne (Kerry)', zip: '142048' },
	{ city: 'Shronebirrane (Kerry)', zip: '567378' },
	{ city: 'Shronedarragh (Kerry)', zip: '546986' },
	{ city: 'Shrone East (Kerry)', zip: '270018' },
	{ city: 'Shronell (Tipperary)', zip: '869685' },
	{ city: 'Shronell Beg (Tipperary)', zip: '864980' },
	{ city: 'Shronell More (Tipperary)', zip: '642714' },
	{ city: 'Shrone Middle (Kerry)', zip: '118815' },
	{ city: 'Shrone More (Kerry)', zip: '815182' },
	{ city: 'Shronepookeen (Cork)', zip: '898263' },
	{ city: 'Shrone West (Kerry)', zip: '723292' },
	{ city: 'Shrough (Tipperary)', zip: '814669' },
	{ city: 'Shrubbywood (Westmeath)', zip: '708208' },
	{ city: 'Shrule (Galway)', zip: '463354' },
	{ city: 'Shrule (Laois)', zip: '933136' },
	{ city: 'Shrule (Longford)', zip: '527498' },
	{ city: 'Shrule (Mayo)', zip: '119952' },
	{ city: 'Shrule (Wexford)', zip: '458136' },
	{ city: 'Shrulegrove (Galway)', zip: '243384' },
	{ city: 'Shureen And Ballynasuddery (Westmeath)', zip: '994473' },
	{ city: 'Shurock (Westmeath)', zip: '424220' },
	{ city: 'Sicily (Meath)', zip: '764970' },
	{ city: 'Siddan (Meath)', zip: '427518' },
	{ city: 'Sigginstown (Wexford)', zip: '110262' },
	{ city: 'Siginshaggard (Wexford)', zip: '688732' },
	{ city: 'Sileshaun East (Clare)', zip: '762707' },
	{ city: 'Sileshaun West (Clare)', zip: '409431' },
	{ city: 'Sillagh (Kildare)', zip: '622184' },
	{ city: 'Sillaheens (Waterford)', zip: '969004' },
	{ city: 'Sillahertane (Cork)', zip: '900208' },
	{ city: 'Sillahertane (Kerry)', zip: '564850' },
	{ city: 'Silliothill (Kildare)', zip: '831223' },
	{ city: 'Sillis (Monaghan)', zip: '214095' },
	{ city: 'Silloge (Dublin)', zip: '118595' },
	{ city: 'Silloge (Louth)', zip: '138771' },
	{ city: 'Silloge (Meath)', zip: '250419' },
	{ city: 'Silverfort (Tipperary)', zip: '566261' },
	{ city: 'Silvergrove (Clare)', zip: '457076' },
	{ city: 'Silvergrove (Cork)', zip: '872594' },
	{ city: 'Silverhill (Clare)', zip: '619316' },
	{ city: 'Silverhill (Galway)', zip: '685023' },
	{ city: 'Silverhill (Offaly)', zip: '734841' },
	{ city: 'Silverhill (Sligo)', zip: '662146' },
	{ city: 'Silverhill Lower (Kildare)', zip: '533738' },
	{ city: 'Silverhill Upper (Kildare)', zip: '666615' },
	{ city: 'Silvermines (Tipperary)', zip: '604964' },
	{ city: 'Silverspring (Wexford)', zip: '808557' },
	{ city: 'Silverstream (Galway)', zip: '621200' },
	{ city: 'Simmonstown (Kildare)', zip: '225537' },
	{ city: 'Simonsland (Kilkenny)', zip: '226422' },
	{ city: 'Simonstown (Louth)', zip: '554869' },
	{ city: 'Simonstown (Meath)', zip: '394752' },
	{ city: 'Simonstown (Westmeath)', zip: '749320' },
	{ city: 'Simonstown East (Kildare)', zip: '151982' },
	{ city: 'Simonstown West (Kildare)', zip: '231596' },
	{ city: 'Singland (Limerick)', zip: '420127' },
	{ city: 'Sinnottsmill (Wexford)', zip: '935333' },
	{ city: 'Sinnottstown (Wexford)', zip: '990169' },
	{ city: 'Sion (Kildare)', zip: '668104' },
	{ city: 'Sion (Waterford)', zip: '302498' },
	{ city: 'Sion (Wexford)', zip: '878682' },
	{ city: 'Sionhermitage (Kilkenny)', zip: '634509' },
	{ city: 'Sionhill (Westmeath)', zip: '696025' },
	{ city: 'Sixacre (Wexford)', zip: '557145' },
	{ city: 'Sixmilebridge (Clare)', zip: '497738' },
	{ city: 'Sixnoggins (Mayo)', zip: '448464' },
	{ city: 'Sixty Acres (Donegal)', zip: '301652' },
	{ city: 'Skagh (Cork)', zip: '775826' },
	{ city: 'Skagh (Limerick)', zip: '513777' },
	{ city: 'Skaghardgannon (Cork)', zip: '785640' },
	{ city: 'Skaghvickincrow (Clare)', zip: '595242' },
	{ city: 'Skahanagh (Cork)', zip: '325764' },
	{ city: 'Skahanagh (Kerry)', zip: '152067' },
	{ city: 'Skahanagh Beg (Cork)', zip: '272347' },
	{ city: 'Skahanagh Lower (Cork)', zip: '848592' },
	{ city: 'Skahanagh More (Cork)', zip: '574512' },
	{ city: 'Skahanagh North (Cork)', zip: '235559' },
	{ city: 'Skahanagh South (Cork)', zip: '588135' },
	{ city: 'Skahanrane (Carlow)', zip: '918053' },
	{ city: 'Skahard (Limerick)', zip: '472604' },
	{ city: 'Skahies (Kerry)', zip: '979384' },
	{ city: 'Skanagore (Cork)', zip: '577000' },
	{ city: 'Skarragh (Cork)', zip: '765719' },
	{ city: 'Skeachorn (Monaghan)', zip: '327117' },
	{ city: 'Skeaf (Cork)', zip: '211654' },
	{ city: 'Skeaf East (Cork)', zip: '932073' },
	{ city: 'Skeaf West (Cork)', zip: '683825' },
	{ city: 'Skeagarvey (Monaghan)', zip: '286555' },
	{ city: 'Skeagh (Cavan)', zip: '877218' },
	{ city: 'Skeagh (Cork)', zip: '748361' },
	{ city: 'Skeagh (Donegal)', zip: '212325' },
	{ city: 'Skeagh (Dublin)', zip: '900860' },
	{ city: 'Skeagh (Laois)', zip: '308006' },
	{ city: 'Skeagh (Monaghan)', zip: '927617' },
	{ city: 'Skeagh (Roscommon)', zip: '334762' },
	{ city: 'Skeagh (Tipperary)', zip: '361702' },
	{ city: 'Skeaghacloran (Kilkenny)', zip: '685677' },
	{ city: 'Skeaghaderreen (Galway)', zip: '497724' },
	{ city: 'Skeaghanore East (Cork)', zip: '891933' },
	{ city: 'Skeaghanore West (Cork)', zip: '162587' },
	{ city: 'Skeaghard (Mayo)', zip: '570913' },
	{ city: 'Skeagharegan (Galway)', zip: '696323' },
	{ city: 'Skeaghaturrish (Kilkenny)', zip: '264972' },
	{ city: 'Skeaghbeg (Galway)', zip: '955763' },
	{ city: 'Skeagh Beg (Westmeath)', zip: '611645' },
	{ city: 'Skeaghcroum (Kilkenny)', zip: '397088' },
	{ city: 'Skeaghmore (Louth)', zip: '523742' },
	{ city: 'Skeagh More (Westmeath)', zip: '871344' },
	{ city: 'Skeaghvasteen (Kilkenny)', zip: '244535' },
	{ city: 'Skeahanagh (Westmeath)', zip: '266798' },
	{ city: 'Skeahanagh (Wexford)', zip: '241913' },
	{ city: 'Skealoghan (Mayo)', zip: '443201' },
	{ city: 'Skeamartin (Leitrim)', zip: '382918' },
	{ city: 'Skeanamuck (Roscommon)', zip: '415929' },
	{ city: 'Skeanavart (Roscommon)', zip: '493569' },
	{ city: 'Skeanaveane (Westmeath)', zip: '942017' },
	{ city: 'Skeard (Kilkenny)', zip: '781784' },
	{ city: 'Skearke (Meath)', zip: '960805' },
	{ city: 'Skeaterpark (Wexford)', zip: '358612' },
	{ city: 'Skeatry (Monaghan)', zip: '748865' },
	{ city: 'Skeavally (Roscommon)', zip: '522165' },
	{ city: 'Skecoor (Galway)', zip: '788704' },
	{ city: 'Skehacreggaun (Limerick)', zip: '304970' },
	{ city: 'Skehacrine (Waterford)', zip: '893032' },
	{ city: 'Skehaghard (Galway)', zip: '803465' },
	{ city: 'Skehana (Kilkenny)', zip: '746317' },
	{ city: 'Skehanagh (Clare)', zip: '829643' },
	{ city: 'Skehanagh (Cork)', zip: '242534' },
	{ city: 'Skehanagh (Galway)', zip: '692667' },
	{ city: 'Skehanagh (Kerry)', zip: '207616' },
	{ city: 'Skehanagh (Laois)', zip: '730047' },
	{ city: 'Skehanagh (Limerick)', zip: '505792' },
	{ city: 'Skehanagh (Mayo)', zip: '696427' },
	{ city: 'Skehanagh (Offaly)', zip: '512223' },
	{ city: 'Skehanagh (Tipperary)', zip: '290819' },
	{ city: 'Skehanagh Lower (Mayo)', zip: '402039' },
	{ city: 'Skehanagh North (Galway)', zip: '196548' },
	{ city: 'Skehanagh North (Tipperary)', zip: '429298' },
	{ city: 'Skehanagh South (Galway)', zip: '898538' },
	{ city: 'Skehanagh South (Tipperary)', zip: '830586' },
	{ city: 'Skehanagh Upper (Mayo)', zip: '750853' },
	{ city: 'Skehanard (Waterford)', zip: '687960' },
	{ city: 'Skehanierin (Kerry)', zip: '371222' },
	{ city: 'Skehanierin Lower (Kerry)', zip: '955938' },
	{ city: 'Skehavaud (Mayo)', zip: '383284' },
	{ city: 'Skeheen (Cork)', zip: '717846' },
	{ city: 'Skeheen (Mayo)', zip: '553556' },
	{ city: 'Skeheen (Westmeath)', zip: '580588' },
	{ city: 'Skeheen And Lisseveleen (Mayo)', zip: '823207' },
	{ city: 'Skeheenaranky (Tipperary)', zip: '716340' },
	{ city: 'Skeheen Upper (Cork)', zip: '370137' },
	{ city: 'Skehil (Cork)', zip: '660380' },
	{ city: 'Skellig Rock Great (Kerry)', zip: '793502' },
	{ city: 'Skellig Rock Little (Kerry)', zip: '954881' },
	{ city: 'Skelpy (Donegal)', zip: '926471' },
	{ city: 'Skenageehy (Galway)', zip: '426448' },
	{ city: 'Skenagun (Kildare)', zip: '574283' },
	{ city: 'Skenakilla (Cork)', zip: '211661' },
	{ city: 'Skeoge (Donegal)', zip: '860096' },
	{ city: 'Skephubble (Dublin)', zip: '989403' },
	{ city: 'Skerdagh Lower (Mayo)', zip: '521437' },
	{ city: 'Skerdagh Upper (Mayo)', zip: '621351' },
	{ city: 'Skerrick East (Monaghan)', zip: '490085' },
	{ city: 'Skerrick West (Monaghan)', zip: '506052' },
	{ city: 'Skerries (Dublin)', zip: '796753' },
	{ city: 'Skerries North (Kildare)', zip: '400806' },
	{ city: 'Skerries South (Kildare)', zip: '900971' },
	{ city: 'Skerrig (Cavan)', zip: '635136' },
	{ city: 'Skerry (Donegal)', zip: '769207' },
	{ city: 'Skerry (Laois)', zip: '546729' },
	{ city: 'Skerrymore (Monaghan)', zip: '421032' },
	{ city: 'Skervan (Monaghan)', zip: '781252' },
	{ city: 'Skevanish (Cork)', zip: '688143' },
	{ city: 'Skibbereen (Cork)', zip: '362107' },
	{ city: 'Skibbolecorragh (Sligo)', zip: '929501' },
	{ city: 'Skibbolmore (Louth)', zip: '863782' },
	{ city: 'Skiddernagh (Mayo)', zip: '120383' },
	{ city: 'Skidoo (Dublin)', zip: '722968' },
	{ city: 'Skinnagin (Monaghan)', zip: '930024' },
	{ city: 'Skinnahergna (Monaghan)', zip: '631439' },
	{ city: 'Skinnew (Wexford)', zip: '628029' },
	{ city: 'Skinstown (Kilkenny)', zip: '729143' },
	{ city: 'Skirteen (Kildare)', zip: '888634' },
	{ city: 'Skool (Limerick)', zip: '156811' },
	{ city: 'Skoolhill (Limerick)', zip: '677006' },
	{ city: 'Skreen (Donegal)', zip: '185446' },
	{ city: 'Skreen (Meath)', zip: '442054' },
	{ city: 'Skreen (Sligo)', zip: '434708' },
	{ city: 'Skreen Beg (Sligo)', zip: '154681' },
	{ city: 'Skreen Lower (Donegal)', zip: '796788' },
	{ city: 'Skreen More (Sligo)', zip: '497830' },
	{ city: 'Skreen Upper (Donegal)', zip: '880672' },
	{ city: 'Skreeny (Leitrim)', zip: '407741' },
	{ city: 'Skreeny Little (Leitrim)', zip: '161861' },
	{ city: 'Skrillagh (Kerry)', zip: '955192' },
	{ city: 'Skrine (Roscommon)', zip: '311046' },
	{ city: 'Skull (Cork)', zip: '325699' },
	{ city: 'Slad (Wexford)', zip: '792597' },
	{ city: 'Sladagh (Tipperary)', zip: '856610' },
	{ city: 'Slade (Dublin)', zip: '978590' },
	{ city: 'Slade (Kilkenny)', zip: '471880' },
	{ city: 'Slade (Wexford)', zip: '782102' },
	{ city: 'Slademore (Dublin)', zip: '502196' },
	{ city: 'Sladoo (Clare)', zip: '814889' },
	{ city: 'Sladran (Donegal)', zip: '271537' },
	{ city: 'Slaghbooly (Clare)', zip: '548389' },
	{ city: 'Slaght (Kerry)', zip: '908317' },
	{ city: 'Slaght (Wexford)', zip: '395433' },
	{ city: 'Slaghta (Galway)', zip: '811582' },
	{ city: 'Slaheny (Kerry)', zip: '774070' },
	{ city: 'Slainstown North (Tipperary)', zip: '149867' },
	{ city: 'Slainstown South (Tipperary)', zip: '658495' },
	{ city: 'Slanduff (Meath)', zip: '469816' },
	{ city: 'Slane (Meath)', zip: '836854' },
	{ city: 'Slane Beg (Westmeath)', zip: '697043' },
	{ city: 'Slanecastle Demesne (Meath)', zip: '456467' },
	{ city: 'Slanemore (Westmeath)', zip: '434543' },
	{ city: 'Slane More (Westmeath)', zip: '194926' },
	{ city: 'Slanestown (Meath)', zip: '413552' },
	{ city: 'Slanestown (Westmeath)', zip: '890050' },
	{ city: 'Slaney Park (Wicklow)', zip: '891022' },
	{ city: 'Slaneyquarter (Carlow)', zip: '729718' },
	{ city: 'Slanore (Cavan)', zip: '484265' },
	{ city: 'Slate (Wicklow)', zip: '577071' },
	{ city: 'Slatefield (Galway)', zip: '244906' },
	{ city: 'Slatefield (Tipperary)', zip: '770607' },
	{ city: 'Slatehill (Donegal)', zip: '818931' },
	{ city: 'Slatequarries (Kildare)', zip: '266593' },
	{ city: 'Slattagh Beg (Roscommon)', zip: '688664' },
	{ city: 'Slattagh More (Roscommon)', zip: '205103' },
	{ city: 'Slatt Lower (Laois)', zip: '496973' },
	{ city: 'Slatt Upper (Laois)', zip: '136309' },
	{ city: 'Slaugar (Mayo)', zip: '871445' },
	{ city: 'Sleadycastle (Waterford)', zip: '440286' },
	{ city: 'Sleamaine (Wicklow)', zip: '750927' },
	{ city: 'Sleanaglogh (Wicklow)', zip: '981196' },
	{ city: 'Sleaty (Laois)', zip: '539816' },
	{ city: 'Sleedagh (Wexford)', zip: '147990' },
	{ city: 'Sleeghan (Donegal)', zip: '440147' },
	{ city: 'Sleehaun (Longford)', zip: '246178' },
	{ city: 'Sleemana (Cork)', zip: '502885' },
	{ city: 'Sleenoge (Cork)', zip: '569494' },
	{ city: 'Sleveen (Cork)', zip: '720061' },
	{ city: 'Sleveen (Kerry)', zip: '583090' },
	{ city: 'Sleveen (Kilkenny)', zip: '580441' },
	{ city: 'Sleveen (Leitrim)', zip: '678633' },
	{ city: 'Sleveen (Waterford)', zip: '937693' },
	{ city: 'Sleveen East (Cork)', zip: '174222' },
	{ city: 'Sleveen West (Cork)', zip: '725102' },
	{ city: 'Slevin (Roscommon)', zip: '621154' },
	{ city: 'Slevinagee (Roscommon)', zip: '508982' },
	{ city: 'Slevoir (Tipperary)', zip: '577556' },
	{ city: 'Slevoy (Wexford)', zip: '863491' },
	{ city: 'Slievadrehid (Kerry)', zip: '814265' },
	{ city: 'Slievaduff (Kerry)', zip: '892077' },
	{ city: 'Slievawaddra (Kerry)', zip: '330455' },
	{ city: 'Slieve (Galway)', zip: '419414' },
	{ city: 'Slieve (Longford)', zip: '675381' },
	{ city: 'Slieve (Louth)', zip: '197101' },
	{ city: 'Slieveadoctor (Cork)', zip: '263482' },
	{ city: 'Slievealoughaun (Clare)', zip: '377641' },
	{ city: 'Slieve And Corbally (Roscommon)', zip: '928190' },
	{ city: 'Slieveaneena (Galway)', zip: '612959' },
	{ city: 'Slieveanore (Clare)', zip: '966396' },
	{ city: 'Slieveaun (Galway)', zip: '719607' },
	{ city: 'Slievebaun (Wexford)', zip: '961772' },
	{ city: 'Slieveboy (Louth)', zip: '546708' },
	{ city: 'Slieveboy (Westmeath)', zip: '142337' },
	{ city: 'Slieveboy Lower (Wicklow)', zip: '440058' },
	{ city: 'Slieveboy Upper (Wicklow)', zip: '803474' },
	{ city: 'Slievebrickan (Cavan)', zip: '118760' },
	{ city: 'Slievebuck (Donegal)', zip: '824826' },
	{ city: 'Slieveburke (Galway)', zip: '262090' },
	{ city: 'Slieveburth (Waterford)', zip: '983789' },
	{ city: 'Slievebwee (Kerry)', zip: '148544' },
	{ city: 'Slievecarragh (Kilkenny)', zip: '515552' },
	{ city: 'Slievecarran (Clare)', zip: '452698' },
	{ city: 'Slievecoiltia Commons (Wexford)', zip: '430511' },
	{ city: 'Slievecorragh (Wicklow)', zip: '574476' },
	{ city: 'Slievedarragh (Galway)', zip: '246294' },
	{ city: 'Slievedooley (Clare)', zip: '944361' },
	{ city: 'Slievedotia (Cork)', zip: '126329' },
	{ city: 'Slievedotia (Galway)', zip: '288460' },
	{ city: 'Slieveduff (Wicklow)', zip: '363767' },
	{ city: 'Slievedurda (Carlow)', zip: '778292' },
	{ city: 'Slieve East (Kerry)', zip: '808334' },
	{ city: 'Slievefin (Galway)', zip: '218775' },
	{ city: 'Slievefoore (Wicklow)', zip: '995465' },
	{ city: 'Slievegallane (Cork)', zip: '982371' },
	{ city: 'Slievegar (Wexford)', zip: '886320' },
	{ city: 'Slievegaura (Kerry)', zip: '752365' },
	{ city: 'Slieveglass (Kerry)', zip: '908934' },
	{ city: 'Slievegorm (Galway)', zip: '128621' },
	{ city: 'Slievemaan (Wicklow)', zip: '467656' },
	{ city: 'Slievemore (Cork)', zip: '325107' },
	{ city: 'Slievemore (Mayo)', zip: '257960' },
	{ city: 'Slievemore (Sligo)', zip: '553431' },
	{ city: 'Slievemurry (Galway)', zip: '312866' },
	{ city: 'Slievemweel (Wicklow)', zip: '721630' },
	{ city: 'Slievenabillog (Clare)', zip: '925964' },
	{ city: 'Slievenabrehan (Mayo)', zip: '507779' },
	{ city: 'Slievenagark (Mayo)', zip: '360318' },
	{ city: 'Slievenageeragh (Clare)', zip: '684853' },
	{ city: 'Slievenaglasha (Clare)', zip: '441382' },
	{ city: 'Slievenaglogh (Louth)', zip: '866834' },
	{ city: 'Slievenagorea (Wexford)', zip: '551164' },
	{ city: 'Slievenagrane (Wexford)', zip: '730289' },
	{ city: 'Slievenagry (Clare)', zip: '145628' },
	{ city: 'Slievenakilla (Leitrim)', zip: '480074' },
	{ city: 'Slievenalicka (Clare)', zip: '775967' },
	{ city: 'Slievenamough (Wicklow)', zip: '321642' },
	{ city: 'Slievenamough Plain (Wicklow)', zip: '495990' },
	{ city: 'Slievenashaska (Kerry)', zip: '261449' },
	{ city: 'Slievenavadoge (Kerry)', zip: '462415' },
	{ city: 'Slievenavode (Wicklow)', zip: '533479' },
	{ city: 'Slieveowen (Cork)', zip: '815697' },
	{ city: 'Slievereagh (Cork)', zip: '516553' },
	{ city: 'Slievereagh Lower (Wicklow)', zip: '487785' },
	{ city: 'Slievereagh Upper (Wicklow)', zip: '395124' },
	{ city: 'Slieveroe (Cork)', zip: '647175' },
	{ city: 'Slieveroe (Galway)', zip: '979157' },
	{ city: 'Slieveroe (Kildare)', zip: '156848' },
	{ city: 'Slieveroe (Kilkenny)', zip: '214328' },
	{ city: 'Slieveroe (Monaghan)', zip: '925389' },
	{ city: 'Slieveroe (Roscommon)', zip: '776277' },
	{ city: 'Slieveroe (Sligo)', zip: '213192' },
	{ city: 'Slieveroe (Waterford)', zip: '602110' },
	{ city: 'Slieveroe (Wicklow)', zip: '923914' },
	{ city: 'Slievethoul (Dublin)', zip: '596337' },
	{ city: 'Slieve West (Kerry)', zip: '657655' },
	{ city: 'Sliganagh (Leitrim)', zip: '231601' },
	{ city: 'Sligaunagh (Waterford)', zip: '805963' },
	{ city: 'Sligo (Sligo)', zip: '209971' },
	{ city: 'Sliguff (Carlow)', zip: '212138' },
	{ city: 'Slihaun Beg (Galway)', zip: '600407' },
	{ city: 'Slihaun More (Galway)', zip: '540830' },
	{ city: 'Slinaun (Mayo)', zip: '386655' },
	{ city: 'Slinaunroe (Mayo)', zip: '352094' },
	{ city: 'Slip (Cork)', zip: '794904' },
	{ city: 'Slippery Green (Wexford)', zip: '885650' },
	{ city: 'Slishmeen (Mayo)', zip: '968496' },
	{ city: 'Slishwood (Sligo)', zip: '828098' },
	{ city: 'Sliss (Kerry)', zip: '716999' },
	{ city: 'Sluggara (Waterford)', zip: '722075' },
	{ city: 'Sluggary (Limerick)', zip: '554910' },
	{ city: 'Sluicequarter (Kerry)', zip: '134173' },
	{ city: 'Smaghraan (Roscommon)', zip: '515296' },
	{ city: 'Smallford (Kildare)', zip: '474427' },
	{ city: 'Smallquarter (Waterford)', zip: '246093' },
	{ city: 'Smarmore (Louth)', zip: '586953' },
	{ city: 'Smartscastle East (Kilkenny)', zip: '825104' },
	{ city: 'Smartscastle West (Kilkenny)', zip: '479016' },
	{ city: 'Smear (Longford)', zip: '121634' },
	{ city: 'Smerwick (Kerry)', zip: '603988' },
	{ city: 'Sminver (Donegal)', zip: '927531' },
	{ city: 'Smithborough (Monaghan)', zip: '782086' },
	{ city: 'Smithfield (Cork)', zip: '173478' },
	{ city: 'Smithfield (Longford)', zip: '283026' },
	{ city: 'Smithsfarm (Tipperary)', zip: '746926' },
	{ city: "Smith's Island (Galway)", zip: '567602' },
	{ city: 'Smithsland North (Kilkenny)', zip: '789606' },
	{ city: 'Smithsland South (Kilkenny)', zip: '971786' },
	{ city: 'Smithstown (Clare)', zip: '471384' },
	{ city: 'Smithstown (Kildare)', zip: '670261' },
	{ city: 'Smithstown (Kilkenny)', zip: '599233' },
	{ city: 'Smithstown (Meath)', zip: '782863' },
	{ city: 'Smithstown (Offaly)', zip: '941916' },
	{ city: 'Smithstown Lower (Kilkenny)', zip: '282310' },
	{ city: 'Smithstown Upper (Kilkenny)', zip: '925788' },
	{ city: 'Smoor Beg (Waterford)', zip: '638757' },
	{ city: 'Smoor More (Waterford)', zip: '596908' },
	{ city: 'Smorane (Cork)', zip: '470722' },
	{ city: 'Smuttanagh (Mayo)', zip: '362333' },
	{ city: 'Smutternagh (Roscommon)', zip: '257956' },
	{ city: 'Snakeel (Cavan)', zip: '783481' },
	{ city: 'Snaty (Clare)', zip: '708364' },
	{ city: 'Snauvbo (Galway)', zip: '127852' },
	{ city: 'Snave (Cork)', zip: '123917' },
	{ city: 'Sneem (Kerry)', zip: '488781' },
	{ city: 'Sneeoge (Meath)', zip: '514513' },
	{ city: 'Sniggeen (Sligo)', zip: '591302' },
	{ city: 'Snimnagorta (Westmeath)', zip: '417585' },
	{ city: 'Snugborough (Cavan)', zip: '171883' },
	{ city: 'Snugborough (Clare)', zip: '988684' },
	{ city: 'Snugborough (Donegal)', zip: '644494' },
	{ city: 'Snugborough (Dublin)', zip: '249698' },
	{ city: 'Snugborough (Limerick)', zip: '778531' },
	{ city: 'Snugborough (Longford)', zip: '690070' },
	{ city: 'Snugborough (Mayo)', zip: '413756' },
	{ city: 'Snugborough (Offaly)', zip: '316987' },
	{ city: 'Snugborough (Waterford)', zip: '141079' },
	{ city: 'Snugborough (Wicklow)', zip: '139101' },
	{ city: 'Snugburrow (Kildare)', zip: '384550' },
	{ city: 'Sockar (Donegal)', zip: '666317' },
	{ city: 'Socknalougher (Leitrim)', zip: '313631' },
	{ city: 'Socks (Leitrim)', zip: '693437' },
	{ city: 'Sogher (Monaghan)', zip: '168525' },
	{ city: 'Soheen (Clare)', zip: '594075' },
	{ city: 'Soho (Westmeath)', zip: '299279' },
	{ city: 'Solloghodbeg (Tipperary)', zip: '873516' },
	{ city: 'Solsborough (Tipperary)', zip: '932562' },
	{ city: 'Solsborough (Wexford)', zip: '146767' },
	{ city: 'Somerset (Galway)', zip: '122990' },
	{ city: 'Sonna Demesne (Westmeath)', zip: '686859' },
	{ city: 'Sonnagh (Galway)', zip: '857803' },
	{ city: 'Sonnagh (Leitrim)', zip: '439490' },
	{ city: 'Sonnagh (Longford)', zip: '810421' },
	{ city: 'Sonnagh (Mayo)', zip: '606866' },
	{ city: 'Sonnagh (Westmeath)', zip: '672711' },
	{ city: 'Sonnagh East (Galway)', zip: '586601' },
	{ city: 'Sonnagh New (Galway)', zip: '705344' },
	{ city: 'Sonnagh Old (Galway)', zip: '615854' },
	{ city: 'Sonnagh West (Galway)', zip: '155332' },
	{ city: 'Sonvolaun (Mayo)', zip: '392883' },
	{ city: 'Soodry (Sligo)', zip: '201469' },
	{ city: 'Sooey (Sligo)', zip: '894921' },
	{ city: 'Sooreeny (Clare)', zip: '431316' },
	{ city: 'Soppog (Donegal)', zip: '596636' },
	{ city: 'Sopwell (Tipperary)', zip: '365547' },
	{ city: 'Soran (Longford)', zip: '239079' },
	{ city: 'Sorne (Donegal)', zip: '754189' },
	{ city: 'Sorrel (Cork)', zip: '377680' },
	{ city: 'Soughane (Wexford)', zip: '315136' },
	{ city: 'Soul Island (Galway)', zip: '254950' },
	{ city: 'Sousheen Common (Kildare)', zip: '179664' },
	{ city: 'Southfield (Laois)', zip: '474952' },
	{ city: 'Southgreen (Kildare)', zip: '850852' },
	{ city: 'Southhill (Tipperary)', zip: '736513' },
	{ city: 'Southhill (Westmeath)', zip: '541551' },
	{ city: 'Southknock (Wexford)', zip: '539511' },
	{ city: 'Southpark (Waterford)', zip: '771597' },
	{ city: 'Southpark Demesne (Roscommon)', zip: '663165' },
	{ city: 'South-Ring (Cork)', zip: '253112' },
	{ city: 'Spa (Roscommon)', zip: '694653' },
	{ city: 'Spa (Waterford)', zip: '291571' },
	{ city: 'Spaddagh (Mayo)', zip: '886492' },
	{ city: 'Spaddan (Donegal)', zip: '607009' },
	{ city: 'Spafield (Tipperary)', zip: '322130' },
	{ city: 'Spaglen (Cork)', zip: '153672' },
	{ city: 'Spahill (Carlow)', zip: '761386' },
	{ city: 'Spahill (Kilkenny)', zip: '606452' },
	{ city: 'Spaightspark (Clare)', zip: '361280' },
	{ city: 'Spanishcove (Cork)', zip: '871711' },
	{ city: 'Spanish Island (Cork)', zip: '982081' },
	{ city: 'Spanish Point (Clare)', zip: '748704' },
	{ city: 'Spaquarter (Laois)', zip: '972098' },
	{ city: 'Sparrograda (Cork)', zip: '351220' },
	{ city: 'Sparrowsland (Wexford)', zip: '570035' },
	{ city: 'Spaug (Clare)', zip: '133085' },
	{ city: 'Speck (Mayo)', zip: '607596' },
	{ city: 'Speenoge (Donegal)', zip: '320606' },
	{ city: 'Spellickanee (Louth)', zip: '395869' },
	{ city: 'Spelsherstown (Wexford)', zip: '686662' },
	{ city: 'Spiddal (Meath)', zip: '439194' },
	{ city: 'Spiddle (Galway)', zip: '923615' },
	{ city: 'Spiddle East (Galway)', zip: '900229' },
	{ city: 'Spiddle Middle (Galway)', zip: '538411' },
	{ city: 'Spiddle West (Galway)', zip: '605982' },
	{ city: 'Spierstown (Donegal)', zip: '447941' },
	{ city: 'Spike Island (Cork)', zip: '661618' },
	{ city: 'Spinans East (Wicklow)', zip: '781823' },
	{ city: 'Spinans Hill (Wicklow)', zip: '694285' },
	{ city: 'Spinans Middle (Wicklow)', zip: '723103' },
	{ city: 'Spinans West (Wicklow)', zip: '103766' },
	{ city: 'Spink (Offaly)', zip: '769812' },
	{ city: 'Spital (Cork)', zip: '844681' },
	{ city: 'Spitalfield (Tipperary)', zip: '803306' },
	{ city: 'Spital-Land (Cork)', zip: '720118' },
	{ city: 'Spital-Land (Tipperary)', zip: '719727' },
	{ city: 'Spittaltown (Westmeath)', zip: '719714' },
	{ city: 'Spittle (Limerick)', zip: '330190' },
	{ city: 'Spollanstown (Offaly)', zip: '562621' },
	{ city: 'Sporthouse (Waterford)', zip: '462261' },
	{ city: 'Sportsmans Hall (Louth)', zip: '569009' },
	{ city: 'Spotfield (Sligo)', zip: '692543' },
	{ city: 'Spratstown (Kildare)', zip: '263398' },
	{ city: 'Spricklestown (Dublin)', zip: '615783' },
	{ city: 'Spring (Waterford)', zip: '160056' },
	{ city: 'Springfarm (Wicklow)', zip: '847445' },
	{ city: 'Springfield (Clare)', zip: '492062' },
	{ city: 'Springfield (Cork)', zip: '300077' },
	{ city: 'Springfield (Donegal)', zip: '872706' },
	{ city: 'Springfield (Galway)', zip: '499003' },
	{ city: 'Springfield (Laois)', zip: '513207' },
	{ city: 'Springfield (Leitrim)', zip: '931295' },
	{ city: 'Springfield (Limerick)', zip: '989375' },
	{ city: 'Springfield (Mayo)', zip: '465006' },
	{ city: 'Springfield (Offaly)', zip: '159205' },
	{ city: 'Springfield (Sligo)', zip: '405182' },
	{ city: 'Springfield (Tipperary)', zip: '383560' },
	{ city: 'Springfield (Waterford)', zip: '665594' },
	{ city: 'Springfield (Westmeath)', zip: '520160' },
	{ city: 'Springfield (Wicklow)', zip: '861896' },
	{ city: 'Springfield Glebe (Tipperary)', zip: '979108' },
	{ city: 'Springfield Lower (Waterford)', zip: '216059' },
	{ city: 'Springfield Upper (Waterford)', zip: '763908' },
	{ city: 'Spring Garden (Galway)', zip: '212624' },
	{ city: 'Spring Garden (Sligo)', zip: '566617' },
	{ city: 'Spring Gardens (Roscommon)', zip: '945437' },
	{ city: 'Spring Grove (Cork)', zip: '583473' },
	{ city: 'Springhall (Meath)', zip: '193454' },
	{ city: 'Springhill (Cork)', zip: '258724' },
	{ city: 'Springhill (Donegal)', zip: '348200' },
	{ city: 'Springhill (Dublin)', zip: '158436' },
	{ city: 'Springhill (Kilkenny)', zip: '292351' },
	{ city: 'Springhill (Laois)', zip: '394690' },
	{ city: 'Springhill (Mayo)', zip: '635343' },
	{ city: 'Springhill (Tipperary)', zip: '262700' },
	{ city: 'Springhouse (Tipperary)', zip: '700541' },
	{ city: 'Springlawn (Galway)', zip: '986186' },
	{ city: 'Springlodge (Limerick)', zip: '626579' },
	{ city: 'Springmount (Clare)', zip: '985730' },
	{ city: 'Springmount (Kerry)', zip: '995521' },
	{ city: 'Springmount (Laois)', zip: '197394' },
	{ city: 'Springmount (Tipperary)', zip: '822447' },
	{ city: 'Springmount (Waterford)', zip: '291707' },
	{ city: 'Springmount (Wexford)', zip: '146329' },
	{ city: 'Springpark (Offaly)', zip: '234646' },
	{ city: 'Springpark (Tipperary)', zip: '851048' },
	{ city: 'Springpark (Wexford)', zip: '617724' },
	{ city: 'Springtown (Longford)', zip: '254026' },
	{ city: 'Springvale (Cork)', zip: '861084' },
	{ city: 'Springvale (Mayo)', zip: '992499' },
	{ city: 'Springvalley (Meath)', zip: '855857' },
	{ city: 'Springville (Cork)', zip: '474676' },
	{ city: 'Springville (Meath)', zip: '452683' },
	{ city: 'Spruceshay (Kilkenny)', zip: '273515' },
	{ city: 'Spunkane (Kerry)', zip: '290177' },
	{ city: 'Spurree (Cork)', zip: '528101' },
	{ city: 'Spurtown (Sligo)', zip: '285633' },
	{ city: 'Spurtown Lower (Sligo)', zip: '427913' },
	{ city: 'Sra (Monaghan)', zip: '432083' },
	{ city: 'Srabra (Roscommon)', zip: '409829' },
	{ city: 'Srabragan (Roscommon)', zip: '333903' },
	{ city: 'Srabrick (Leitrim)', zip: '224041' },
	{ city: 'Sracleighreen (Leitrim)', zip: '431953' },
	{ city: 'Sracocka (Roscommon)', zip: '922080' },
	{ city: 'Sracreeghan (Leitrim)', zip: '281584' },
	{ city: 'Sracummer (Leitrim)', zip: '850214' },
	{ city: 'Sradoon (Leitrim)', zip: '246459' },
	{ city: 'Sradrinagh (Leitrim)', zip: '696866' },
	{ city: 'Sradrinan (Leitrim)', zip: '325297' },
	{ city: 'Sradrine (Leitrim)', zip: '139237' },
	{ city: 'Sraduff (Roscommon)', zip: '215555' },
	{ city: 'Sraduff (Tipperary)', zip: '200497' },
	{ city: 'Sraduff (Westmeath)', zip: '612320' },
	{ city: 'Sraduffy (Leitrim)', zip: '728830' },
	{ city: 'Sragarn (Leitrim)', zip: '501624' },
	{ city: 'Sragarrow (Longford)', zip: '661761' },
	{ city: 'Sragarve (Leitrim)', zip: '907398' },
	{ city: 'Sragh (Carlow)', zip: '479443' },
	{ city: 'Sragh (Clare)', zip: '201230' },
	{ city: 'Sragh (Kilkenny)', zip: '996518' },
	{ city: 'Sragh (Sligo)', zip: '413760' },
	{ city: 'Sragh (Tipperary)', zip: '466218' },
	{ city: 'Sraghgaddy (Kilkenny)', zip: '968991' },
	{ city: 'Sraghmore (Wicklow)', zip: '163059' },
	{ city: 'Srah (Galway)', zip: '474740' },
	{ city: 'Srah (Laois)', zip: '377090' },
	{ city: 'Srah (Mayo)', zip: '753470' },
	{ city: 'Srah (Offaly)', zip: '782109' },
	{ city: 'Srah (Roscommon)', zip: '246816' },
	{ city: 'Srahacorick (Mayo)', zip: '955535' },
	{ city: 'Srahan (Cavan)', zip: '403919' },
	{ city: 'Srahanarry (Mayo)', zip: '878185' },
	{ city: 'Srahanboy (Laois)', zip: '674283' },
	{ city: 'Srahanbregagh (Offaly)', zip: '551562' },
	{ city: 'Srahane (Limerick)', zip: '554037' },
	{ city: 'Srahane East (Limerick)', zip: '687530' },
	{ city: 'Srahane West (Limerick)', zip: '155672' },
	{ city: 'Sraharla (Cork)', zip: '821291' },
	{ city: 'Srahataggle (Mayo)', zip: '161086' },
	{ city: 'Srahataggle South (Mayo)', zip: '214498' },
	{ city: 'Srahatloe (Mayo)', zip: '456054' },
	{ city: 'Srahaun (Galway)', zip: '519067' },
	{ city: 'Srahaunananta (Galway)', zip: '348021' },
	{ city: 'Srahaunnagort (Galway)', zip: '220892' },
	{ city: 'Srahauns (Roscommon)', zip: '380345' },
	{ city: 'Srahavarrella (Tipperary)', zip: '322146' },
	{ city: 'Srahbaun (Laois)', zip: '584167' },
	{ city: 'Srahcullen (Laois)', zip: '584137' },
	{ city: 'Srahdoo (Galway)', zip: '119223' },
	{ city: 'Srahduff Glebe (Laois)', zip: '802347' },
	{ city: 'Srahduggaun (Mayo)', zip: '207751' },
	{ city: 'Srahederdaowen (Mayo)', zip: '422147' },
	{ city: 'Sraheen (Clare)', zip: '326614' },
	{ city: 'Sraheen (Mayo)', zip: '721519' },
	{ city: 'Sraheendoo (Galway)', zip: '265904' },
	{ city: 'Sraheens (Mayo)', zip: '859247' },
	{ city: 'Sraheens (Sligo)', zip: '115127' },
	{ city: 'Srahenry (Westmeath)', zip: '853688' },
	{ city: 'Srahgarve (Galway)', zip: '417598' },
	{ city: 'Srahgraddy (Mayo)', zip: '951526' },
	{ city: 'Srahlaghy (Mayo)', zip: '409254' },
	{ city: 'Srahlea (Mayo)', zip: '523129' },
	{ city: 'Srahleagh (Laois)', zip: '312793' },
	{ city: 'Srahloughra (Galway)', zip: '434314' },
	{ city: 'Srah Lower (Mayo)', zip: '661739' },
	{ city: 'Srahmeen (Mayo)', zip: '449439' },
	{ city: 'Srahmore (Mayo)', zip: '234044' },
	{ city: 'Srahnacloy (Mayo)', zip: '195238' },
	{ city: 'Srahnakilly (Mayo)', zip: '922779' },
	{ city: 'Srahnamanragh (Mayo)', zip: '194119' },
	{ city: 'Srahnanagh (Mayo)', zip: '154715' },
	{ city: 'Srahnaplaia (Mayo)', zip: '228538' },
	{ city: 'Srahnashasky (Mayo)', zip: '618266' },
	{ city: 'Srahrevagh (Mayo)', zip: '730781' },
	{ city: 'Srahroosky (Mayo)', zip: '841568' },
	{ city: 'Srah Upper (Mayo)', zip: '714676' },
	{ city: 'Srahwee (Mayo)', zip: '999724' },
	{ city: 'Srahyconigaun (Mayo)', zip: '276199' },
	{ city: 'Sralagagh East (Mayo)', zip: '157563' },
	{ city: 'Sralagagh West (Mayo)', zip: '581419' },
	{ city: 'Sralahan (Cavan)', zip: '602004' },
	{ city: 'Sralea (Roscommon)', zip: '140380' },
	{ city: 'Sralea (Sligo)', zip: '468266' },
	{ city: 'Sraleagh (Kilkenny)', zip: '984062' },
	{ city: 'Sraleigh (Cork)', zip: '612663' },
	{ city: 'Sraloaghan (Leitrim)', zip: '601384' },
	{ city: 'Srameen (Westmeath)', zip: '862238' },
	{ city: 'Sramore (Leitrim)', zip: '254852' },
	{ city: 'Sranaboll (Meath)', zip: '751676' },
	{ city: 'Sranacally (Mayo)', zip: '492232' },
	{ city: 'Sranacrannaghy (Leitrim)', zip: '300750' },
	{ city: 'Sranadarragh (Leitrim)', zip: '329963' },
	{ city: 'Sranagalloon (Clare)', zip: '325433' },
	{ city: 'Sranagarvanagh (Leitrim)', zip: '772070' },
	{ city: 'Sranagross (Leitrim)', zip: '447360' },
	{ city: 'Sranahaw (Galway)', zip: '540311' },
	{ city: 'Sranalaghta North (Mayo)', zip: '482605' },
	{ city: 'Sranalaghta South (Mayo)', zip: '573123' },
	{ city: 'Sranalee (Mayo)', zip: '304644' },
	{ city: 'Srananagh (Sligo)', zip: '979792' },
	{ city: 'Srananny (Monaghan)', zip: '716527' },
	{ city: 'Srananooan (Roscommon)', zip: '420153' },
	{ city: 'Sranaviddoge (Cork)', zip: '509044' },
	{ city: 'Sranayalloge (Cavan)', zip: '130106' },
	{ city: 'Sranea (Leitrim)', zip: '227464' },
	{ city: 'Sraneeg (Westmeath)', zip: '867761' },
	{ city: 'Sranure (Offaly)', zip: '637623' },
	{ city: 'Srarevagh (Sligo)', zip: '968555' },
	{ city: 'Sratrissaun North (Leitrim)', zip: '661126' },
	{ city: 'Sratrissaun South (Leitrim)', zip: '821067' },
	{ city: 'Sraud (Leitrim)', zip: '947062' },
	{ city: 'Sravrannies (Leitrim)', zip: '373005' },
	{ city: 'Sreelane (Limerick)', zip: '458528' },
	{ city: 'Sreenty (Monaghan)', zip: '293601' },
	{ city: 'Sriff (Leitrim)', zip: '887362' },
	{ city: 'Sroankeeragh (Roscommon)', zip: '718953' },
	{ city: 'Sronagh (Laois)', zip: '508738' },
	{ city: 'Sronscull (Laois)', zip: '710212' },
	{ city: 'Sroohil (Clare)', zip: '765573' },
	{ city: 'Sroolane (Limerick)', zip: '342184' },
	{ city: 'Sroolane North (Limerick)', zip: '337384' },
	{ city: 'Sroolane South (Limerick)', zip: '624834' },
	{ city: 'Sroove (Galway)', zip: '743382' },
	{ city: 'Sroove (Roscommon)', zip: '375065' },
	{ city: 'Sroove (Sligo)', zip: '622849' },
	{ city: 'Sroughan (Wicklow)', zip: '865776' },
	{ city: 'Sroughmore (Wexford)', zip: '288721' },
	{ city: 'Sroughmore (Wicklow)', zip: '547382' },
	{ city: 'Srowland (Kildare)', zip: '714517' },
	{ city: 'Srue (Galway)', zip: '990453' },
	{ city: 'Sruell (Donegal)', zip: '881810' },
	{ city: 'Srughawadda (Kilkenny)', zip: '602197' },
	{ city: 'Srugreana (Kerry)', zip: '151774' },
	{ city: 'Sruhagh (Cavan)', zip: '596664' },
	{ city: 'Sruhanagh (Cavan)', zip: '290514' },
	{ city: 'Sruhane (Tipperary)', zip: '916180' },
	{ city: 'Sruhangarrow (Donegal)', zip: '580849' },
	{ city: 'Sruhangarrow Mountain (Donegal)', zip: '111029' },
	{ city: 'Sruhanreagh (Donegal)', zip: '672422' },
	{ city: 'Sruhaun (Leitrim)', zip: '608851' },
	{ city: 'Sruhaun (Wicklow)', zip: '353036' },
	{ city: 'Sruhaunfusta (Galway)', zip: '315108' },
	{ city: 'Sruh East (Waterford)', zip: '787618' },
	{ city: 'Sruh West (Waterford)', zip: '848234' },
	{ city: 'Srunahella (Westmeath)', zip: '296695' },
	{ city: 'Sruveel (Monaghan)', zip: '660496' },
	{ city: 'Stabannan (Louth)', zip: '764544' },
	{ city: 'Stable (Wexford)', zip: '187757' },
	{ city: 'Stackallan (Meath)', zip: '849197' },
	{ city: 'Stackarnagh (Donegal)', zip: '494283' },
	{ city: "Stack's-Mountain (Kerry)", zip: '600081' },
	{ city: 'Stackstown (Dublin)', zip: '811094' },
	{ city: 'Stacumny (Kildare)', zip: '474630' },
	{ city: 'Stacumny Cottage (Kildare)', zip: '162527' },
	{ city: 'Stadalt (Meath)', zip: '569706' },
	{ city: 'Stael (Waterford)', zip: '688195' },
	{ city: 'Staffordstown (Dublin)', zip: '340007' },
	{ city: 'Staffordstown (Meath)', zip: '638714' },
	{ city: 'Staffordstown Little (Meath)', zip: '652202' },
	{ city: 'Staffordstown Turvey (Dublin)', zip: '538446' },
	{ city: 'Staghall (Donegal)', zip: '996277' },
	{ city: 'Staghall Mountain (Donegal)', zip: '872443' },
	{ city: 'Staghall Mountain East (Donegal)', zip: '461925' },
	{ city: 'Staghall Mountain West (Donegal)', zip: '464765' },
	{ city: 'Stagmount (Kerry)', zip: '687294' },
	{ city: 'Stag Park (Cork)', zip: '736900' },
	{ city: 'Stagreenan (Louth)', zip: '751588' },
	{ city: 'Stagreenan (Meath)', zip: '893446' },
	{ city: 'Stags Of Broad Haven (Mayo)', zip: '220290' },
	{ city: 'Staholmog (Meath)', zip: '759517' },
	{ city: 'Staigbraud (Waterford)', zip: '315054' },
	{ city: 'Staigue (Kerry)', zip: '983412' },
	{ city: 'Stakally (Kilkenny)', zip: '443858' },
	{ city: 'Stalleen (Meath)', zip: '414007' },
	{ city: 'Stameen (Louth)', zip: '517474' },
	{ city: 'Stameen (Meath)', zip: '840831' },
	{ city: 'Stampspark (Kilkenny)', zip: '523089' },
	{ city: 'Stamullin (Dublin)', zip: '775257' },
	{ city: 'Stamullin (Meath)', zip: '254727' },
	{ city: 'Stangaun (Leitrim)', zip: '245732' },
	{ city: 'Stangs (Kilkenny)', zip: '644855' },
	{ city: 'Stangs (Tipperary)', zip: '695082' },
	{ city: 'Stanney (Laois)', zip: '582285' },
	{ city: 'Staplestown (Carlow)', zip: '458448' },
	{ city: 'Staplestown (Kildare)', zip: '334990' },
	{ city: 'Staplestown (Wexford)', zip: '853385' },
	{ city: 'Stapolin (Dublin)', zip: '359676' },
	{ city: 'Starinagh (Meath)', zip: '741676' },
	{ city: 'Starritstown (Donegal)', zip: '945455' },
	{ city: 'Starvehall (Wexford)', zip: '796458' },
	{ city: 'Steales (Limerick)', zip: '918196' },
	{ city: 'Stealroe (Kerry)', zip: '523819' },
	{ city: 'Steelaun (Mayo)', zip: '688443' },
	{ city: 'Steelstown (Dublin)', zip: '682674' },
	{ city: 'Steeplestown (Meath)', zip: '544852' },
	{ city: 'Steilaneigh (Cork)', zip: '164626' },
	{ city: 'Steill (Roscommon)', zip: '169943' },
	{ city: 'Stepaside (Dublin)', zip: '149182' },
	{ city: 'Stephensland (Wexford)', zip: '271558' },
	{ city: 'Stephenstown (Dublin)', zip: '455954' },
	{ city: 'Stephenstown (Limerick)', zip: '517433' },
	{ city: 'Stephenstown (Louth)', zip: '807053' },
	{ city: 'Stephenstown (Meath)', zip: '782175' },
	{ city: 'Stephenstown (Tipperary)', zip: '722293' },
	{ city: 'Stephenstown (Wexford)', zip: '651727' },
	{ city: 'Stephenstownbeg (Tipperary)', zip: '274921' },
	{ city: 'Stephenstown North (Kildare)', zip: '751094' },
	{ city: 'Stephenstown South (Kildare)', zip: '716735' },
	{ city: 'Stereame (Tipperary)', zip: '874556' },
	{ city: 'Stewartsgrove (Laois)', zip: '559934' },
	{ city: 'Stickillin (Louth)', zip: '825041' },
	{ city: 'Stickins (Kildare)', zip: '544105' },
	{ city: 'Stifyans (Louth)', zip: '885585' },
	{ city: 'Stilebawn (Wicklow)', zip: '737917' },
	{ city: 'Stillimity (Tipperary)', zip: '989167' },
	{ city: 'Stillorgan (Dublin)', zip: '912114' },
	{ city: 'Stillorgan Grove (Dublin)', zip: '193649' },
	{ city: 'Stillorgan North (Dublin)', zip: '397013' },
	{ city: 'Stillorgan Park (Dublin)', zip: '641865' },
	{ city: 'Stillorgan South (Dublin)', zip: '702103' },
	{ city: 'Stirrupstown (Meath)', zip: '660876' },
	{ city: 'Stirue (Louth)', zip: '739767' },
	{ city: 'Stockhole (Dublin)', zip: '513892' },
	{ city: 'Stocks (Meath)', zip: '999964' },
	{ city: 'Stokaun (Tipperary)', zip: '941074' },
	{ city: 'Stokesfield (Limerick)', zip: '763608' },
	{ city: 'Stokesquarter (Meath)', zip: '236252' },
	{ city: 'Stokestown (Meath)', zip: '585041' },
	{ city: 'Stokestown (Westmeath)', zip: '453532' },
	{ city: 'Stokestown (Wexford)', zip: '384252' },
	{ city: 'Stonecarthy East (Kilkenny)', zip: '117062' },
	{ city: 'Stonecarthy West (Kilkenny)', zip: '444202' },
	{ city: 'Stoneen (Kilkenny)', zip: '486609' },
	{ city: 'Stonefield (Meath)', zip: '476002' },
	{ city: 'Stonehall (Clare)', zip: '141869' },
	{ city: 'Stonehall (Limerick)', zip: '941947' },
	{ city: 'Stonehall (Mayo)', zip: '670894' },
	{ city: 'Stonehall (Meath)', zip: '764375' },
	{ city: 'Stonehall (Sligo)', zip: '303263' },
	{ city: 'Stonehall (Westmeath)', zip: '890172' },
	{ city: 'Stonehouse (Louth)', zip: '374680' },
	{ city: 'Stonehouse (Offaly)', zip: '388873' },
	{ city: 'Stonehouse (Waterford)', zip: '102973' },
	{ city: 'Stonehouse (Wexford)', zip: '317986' },
	{ city: 'Stonehousefarm (Westmeath)', zip: '515287' },
	{ city: 'Stonepark (Cavan)', zip: '939631' },
	{ city: 'Stonepark (Clare)', zip: '233138' },
	{ city: 'Stonepark (Galway)', zip: '749235' },
	{ city: 'Stonepark (Leitrim)', zip: '440929' },
	{ city: 'Stonepark (Limerick)', zip: '439221' },
	{ city: 'Stonepark (Longford)', zip: '425824' },
	{ city: 'Stonepark (Mayo)', zip: '372629' },
	{ city: 'Stonepark (Roscommon)', zip: '971669' },
	{ city: 'Stonepark (Sligo)', zip: '231354' },
	{ city: 'Stonepark (Tipperary)', zip: '859776' },
	{ city: 'Stonepark (Wexford)', zip: '727442' },
	{ city: 'Stone Park (Tipperary)', zip: '604907' },
	{ city: 'Stonepark North (Roscommon)', zip: '106689' },
	{ city: 'Stoneparks (Sligo)', zip: '705521' },
	{ city: 'Stonepark South (Roscommon)', zip: '275894' },
	{ city: 'Stonestown (Meath)', zip: '876933' },
	{ city: 'Stonestown (Offaly)', zip: '523239' },
	{ city: 'Stonestown (Tipperary)', zip: '647496' },
	{ city: 'Stonestown (Westmeath)', zip: '694504' },
	{ city: 'Stonetown (Galway)', zip: '654671' },
	{ city: 'Stonetown Lower (Louth)', zip: '230798' },
	{ city: 'Stonetown Upper (Louth)', zip: '249982' },
	{ city: 'Stoneville (Limerick)', zip: '794122' },
	{ city: 'Stoneyford (Kilkenny)', zip: '194717' },
	{ city: 'Stongaluggaun (Westmeath)', zip: '205156' },
	{ city: 'Stonyacre (Tipperary)', zip: '848419' },
	{ city: 'Stonybatter (Wexford)', zip: '665936' },
	{ city: 'Stonyford (Wexford)', zip: '432494' },
	{ city: 'Stonyisland (Galway)', zip: '687342' },
	{ city: 'Stonylane (Louth)', zip: '660265' },
	{ city: 'Stooagh (Laois)', zip: '449440' },
	{ city: 'Stooey (Donegal)', zip: '329475' },
	{ city: 'Stook (Tipperary)', zip: '957146' },
	{ city: 'Stookeen (Cork)', zip: '315927' },
	{ city: 'Stookeens (Limerick)', zip: '731245' },
	{ city: 'Stoops (Wicklow)', zip: '765283' },
	{ city: 'Stormanstown (Louth)', zip: '825072' },
	{ city: 'Stormhill (Donegal)', zip: '919294' },
	{ city: 'Stouke (Cork)', zip: '271112' },
	{ city: 'Stowelodge (Galway)', zip: '984402' },
	{ city: 'Stowlin (Galway)', zip: '722816' },
	{ city: 'Stowney (Donegal)', zip: '487816' },
	{ city: 'Straboe (Carlow)', zip: '559519' },
	{ city: 'Straboe (Laois)', zip: '820859' },
	{ city: 'Straboy (Donegal)', zip: '667409' },
	{ city: 'Strabrinna Lower (Donegal)', zip: '878389' },
	{ city: 'Strabrinna Upper (Donegal)', zip: '505402' },
	{ city: 'Stracashel (Donegal)', zip: '973242' },
	{ city: 'Straclevan (Monaghan)', zip: '842544' },
	{ city: 'Stracrunnion (Monaghan)', zip: '463642' },
	{ city: 'Stradavoher (Tipperary)', zip: '967054' },
	{ city: 'Stradbally (Kerry)', zip: '118720' },
	{ city: 'Stradbally (Laois)', zip: '960899' },
	{ city: 'Stradbally (Waterford)', zip: '978254' },
	{ city: 'Stradbally Beg (Waterford)', zip: '729546' },
	{ city: 'Stradbally East (Galway)', zip: '461757' },
	{ city: 'Stradbally More (Waterford)', zip: '792309' },
	{ city: 'Stradbally-Mountain (Kerry)', zip: '777503' },
	{ city: 'Stradbally North (Galway)', zip: '237327' },
	{ city: 'Stradbally North (Limerick)', zip: '434738' },
	{ city: 'Stradbally South (Galway)', zip: '512619' },
	{ city: 'Stradbally South (Limerick)', zip: '323060' },
	{ city: 'Stradbally West (Galway)', zip: '163056' },
	{ city: 'Stradbrook (Dublin)', zip: '993931' },
	{ city: 'Strade (Mayo)', zip: '654604' },
	{ city: 'Stradeen (Monaghan)', zip: '105640' },
	{ city: 'Stradermot (Leitrim)', zip: '151756' },
	{ city: 'Stradone (Cavan)', zip: '137164' },
	{ city: 'Straduff (Carlow)', zip: '138577' },
	{ city: 'Straduff (Offaly)', zip: '349670' },
	{ city: 'Straduff (Sligo)', zip: '824104' },
	{ city: 'Straffan (Kildare)', zip: '673444' },
	{ city: 'Straffan Demesne (Kildare)', zip: '215081' },
	{ city: 'Stragally (Donegal)', zip: '126595' },
	{ city: 'Stragar (Donegal)', zip: '907978' },
	{ city: 'Stragelliff (Cavan)', zip: '574469' },
	{ city: 'Straghan (Monaghan)', zip: '386125' },
	{ city: 'Stragraddy (Donegal)', zip: '215221' },
	{ city: 'Strahard (Laois)', zip: '282303' },
	{ city: 'Strahart (Wexford)', zip: '554581' },
	{ city: 'Straheglin (Cavan)', zip: '784022' },
	{ city: 'Straid (Donegal)', zip: '150262' },
	{ city: 'Straid (Galway)', zip: '109491' },
	{ city: 'Strake (Mayo)', zip: '957559' },
	{ city: 'Strakeenagh (Donegal)', zip: '748524' },
	{ city: 'Straleek (Kildare)', zip: '193864' },
	{ city: 'Straleel (Donegal)', zip: '155759' },
	{ city: 'Straleel Glebe (Donegal)', zip: '334303' },
	{ city: 'Straleel North (Donegal)', zip: '245534' },
	{ city: 'Straleel South (Donegal)', zip: '651986' },
	{ city: 'Straleeny (Donegal)', zip: '148747' },
	{ city: 'Stralinchy (Donegal)', zip: '567842' },
	{ city: 'Stralongford (Donegal)', zip: '800096' },
	{ city: 'Stralongford (Leitrim)', zip: '757155' },
	{ city: 'Stralusky (Carlow)', zip: '249071' },
	{ city: 'Stramackilmartin (Donegal)', zip: '723203' },
	{ city: 'Stramackilroy (Monaghan)', zip: '841877' },
	{ city: 'Stramaquerty (Cavan)', zip: '941107' },
	{ city: 'Stramatt (Cavan)', zip: '739969' },
	{ city: 'Stramillian (Kildare)', zip: '899427' },
	{ city: 'Stramore (Donegal)', zip: '418298' },
	{ city: 'Stramore (Monaghan)', zip: '946943' },
	{ city: 'Stramore Upper (Donegal)', zip: '784139' },
	{ city: 'Stranabrattoge (Donegal)', zip: '864419' },
	{ city: 'Stranabrooey (Donegal)', zip: '394974' },
	{ city: 'Stranacarry (Louth)', zip: '889274' },
	{ city: 'Stranaclea (Donegal)', zip: '573494' },
	{ city: 'Stranacorcragh (Donegal)', zip: '367228' },
	{ city: 'Stranadarragh (Cavan)', zip: '500749' },
	{ city: 'Stranagap (Cavan)', zip: '917188' },
	{ city: 'Stranagartan (Donegal)', zip: '269331' },
	{ city: 'Stranagarvagh (Monaghan)', zip: '285893' },
	{ city: 'Stranaglogh (Donegal)', zip: '525351' },
	{ city: 'Stranagoppoge (Donegal)', zip: '921273' },
	{ city: 'Stranahely (Wicklow)', zip: '751114' },
	{ city: 'Stranakelly (Wicklow)', zip: '505511' },
	{ city: 'Stranakirk (Donegal)', zip: '398329' },
	{ city: 'Stranamart (Cavan)', zip: '136920' },
	{ city: 'Stranamuck (Donegal)', zip: '622623' },
	{ city: 'Stranasaggart (Donegal)', zip: '504409' },
	{ city: 'Stranatona (Monaghan)', zip: '354154' },
	{ city: 'Strancally (Waterford)', zip: '671471' },
	{ city: 'Strancally Demesne (Waterford)', zip: '508496' },
	{ city: 'Strand (Limerick)', zip: '333806' },
	{ city: 'Strandfield (Wexford)', zip: '760172' },
	{ city: 'Strandhill (Mayo)', zip: '191766' },
	{ city: 'Strandhill (Sligo)', zip: '635563' },
	{ city: 'Strandsend (Kerry)', zip: '519730' },
	{ city: 'Straness (Donegal)', zip: '338563' },
	{ city: 'Strangsmill (Kilkenny)', zip: '367702' },
	{ city: 'Stranoodan (Monaghan)', zip: '451481' },
	{ city: 'Stranorlaghan (Donegal)', zip: '853505' },
	{ city: 'Stranorlar (Donegal)', zip: '481879' },
	{ city: 'Strany Beg (Meath)', zip: '429443' },
	{ city: 'Strany More (Meath)', zip: '906438' },
	{ city: 'Strasallagh (Donegal)', zip: '417785' },
	{ city: 'Stratford (Wicklow)', zip: '919787' },
	{ city: 'Stratford Lodge (Wicklow)', zip: '594420' },
	{ city: 'Straths (Donegal)', zip: '112721' },
	{ city: 'Strattonstown (Westmeath)', zip: '536101' },
	{ city: 'Stravally (Donegal)', zip: '136704' },
	{ city: 'Stravicnabo (Cavan)', zip: '762636' },
	{ city: 'Strawhall (Carlow)', zip: '618239' },
	{ city: 'Strawhall (Cork)', zip: '624507' },
	{ city: 'Strawhall (Kildare)', zip: '156531' },
	{ city: 'Strawickeen (Clare)', zip: '483892' },
	{ city: 'Straw Island (Galway)', zip: '425904' },
	{ city: 'Strawoaghter Glebe (Donegal)', zip: '104830' },
	{ city: 'Stream (Galway)', zip: '563501' },
	{ city: 'Streamhill East (Cork)', zip: '218198' },
	{ city: 'Streamhill West (Cork)', zip: '276767' },
	{ city: 'Streamsford (Galway)', zip: '720198' },
	{ city: 'Streamstown (Dublin)', zip: '648102' },
	{ city: 'Streamstown (Galway)', zip: '904943' },
	{ city: 'Streamstown (Longford)', zip: '610502' },
	{ city: 'Streamstown (Louth)', zip: '694098' },
	{ city: 'Streamstown (Mayo)', zip: '214646' },
	{ city: 'Streamstown (Offaly)', zip: '184597' },
	{ city: 'Streamstown (Sligo)', zip: '547099' },
	{ city: 'Streamstown (Westmeath)', zip: '250684' },
	{ city: 'Streamstown (Wexford)', zip: '185542' },
	{ city: 'Streanduff (Monaghan)', zip: '451788' },
	{ city: 'Streedagh (Sligo)', zip: '638877' },
	{ city: 'Street (Westmeath)', zip: '591853' },
	{ city: 'Strifeland (Dublin)', zip: '344614' },
	{ city: 'Strike Lower (Tipperary)', zip: '187250' },
	{ city: 'Strike Upper (Tipperary)', zip: '389493' },
	{ city: 'String (Cork)', zip: '435903' },
	{ city: 'Stripe (Galway)', zip: '142315' },
	{ city: 'Stripe (Mayo)', zip: '342815' },
	{ city: 'Stripe North (Galway)', zip: '877600' },
	{ city: 'Stripes (Kilkenny)', zip: '360611' },
	{ city: 'Stripe South (Galway)', zip: '214571' },
	{ city: 'Stroan (Kilkenny)', zip: '488495' },
	{ city: 'Stroane (Cavan)', zip: '241260' },
	{ city: 'Stroangarrow (Donegal)', zip: '321022' },
	{ city: 'Stroangibbagh (Donegal)', zip: '482051' },
	{ city: 'Strogue (Tipperary)', zip: '277498' },
	{ city: 'Stroke (Leitrim)', zip: '813533' },
	{ city: 'Strokestown (Roscommon)', zip: '847260' },
	{ city: 'Stroove (Donegal)', zip: '439654' },
	{ city: 'Struaun (Mayo)', zip: '306091' },
	{ city: 'Stuccolane (Waterford)', zip: '896128' },
	{ city: 'Stuck (Leitrim)', zip: '290413' },
	{ city: 'Stuckeen (Mayo)', zip: '255164' },
	{ city: 'Studfield North (Wicklow)', zip: '680939' },
	{ city: 'Studfield South (Wicklow)', zip: '760641' },
	{ city: 'Stumpa (Louth)', zip: '806717' },
	{ city: 'Stumphill (Cork)', zip: '195871' },
	{ city: 'Stump Of The Castle (Wicklow)', zip: '294179' },
	{ city: 'Sturrakeen (Galway)', zip: '816044' },
	{ city: 'Subulter (Cork)', zip: '621593' },
	{ city: 'Suckfield (Roscommon)', zip: '963909' },
	{ city: 'Sugarhill (Limerick)', zip: '956078' },
	{ city: 'Sugarloaf (Wicklow)', zip: '871552' },
	{ city: 'Sugarloafhill (Kilkenny)', zip: '427055' },
	{ city: 'Sugarstown (Kilkenny)', zip: '735880' },
	{ city: 'Suirville (Tipperary)', zip: '723874' },
	{ city: 'Summerfield (Cork)', zip: '352923' },
	{ city: 'Summerhill (Clare)', zip: '723131' },
	{ city: 'Summerhill (Donegal)', zip: '182305' },
	{ city: 'Summerhill (Galway)', zip: '931896' },
	{ city: 'Summerhill (Laois)', zip: '107262' },
	{ city: 'Summerhill (Louth)', zip: '873547' },
	{ city: 'Summerhill (Meath)', zip: '910082' },
	{ city: 'Summerhill (Tipperary)', zip: '197423' },
	{ city: 'Summerhill Demesne (Meath)', zip: '236978' },
	{ city: 'Summerhill Lower (Meath)', zip: '637434' },
	{ city: 'Summerhill North (Mayo)', zip: '382079' },
	{ city: 'Summerhill South (Mayo)', zip: '889162' },
	{ city: 'Summerhill Upper (Meath)', zip: '156715' },
	{ city: 'Summerslane (Kilkenny)', zip: '916953' },
	{ city: 'Summerstown (Meath)', zip: '203182' },
	{ city: 'Summerstown (Wexford)', zip: '953313' },
	{ city: 'Summertown (Wexford)', zip: '858817' },
	{ city: 'Summerville (Galway)', zip: '619626' },
	{ city: 'Summerville (Limerick)', zip: '247097' },
	{ city: 'Summerville (Waterford)', zip: '998107' },
	{ city: 'Summy (Donegal)', zip: '333157' },
	{ city: 'Suncroft (Kildare)', zip: '372914' },
	{ city: 'Sunfort (Cork)', zip: '837678' },
	{ city: 'Sunglen (Limerick)', zip: '373133' },
	{ city: 'Sunhill (Galway)', zip: '512214' },
	{ city: 'Sunhill (Kilkenny)', zip: '859302' },
	{ city: 'Sunlawn (Waterford)', zip: '622930' },
	{ city: 'Sunnagh (Clare)', zip: '610421' },
	{ city: 'Sunnagh Beg (Leitrim)', zip: '761671' },
	{ city: 'Sunnaghconner (Leitrim)', zip: '833313' },
	{ city: 'Sunnagh More (Leitrim)', zip: '758839' },
	{ city: 'Sunnyhill (Kildare)', zip: '913096' },
	{ city: 'Sunville (Cork)', zip: '702028' },
	{ city: 'Sunville (Limerick)', zip: '780385' },
	{ city: 'Sunville Lower (Limerick)', zip: '483020' },
	{ city: 'Sunville Upper (Limerick)', zip: '271736' },
	{ city: 'Surgalstown North (Dublin)', zip: '901537' },
	{ city: 'Surgalstown South (Dublin)', zip: '516893' },
	{ city: 'Sussa (Kerry)', zip: '676483' },
	{ city: 'Sutherland (Meath)', zip: '971562' },
	{ city: 'Sutton (Dublin)', zip: '894495' },
	{ city: 'Sutton North (Dublin)', zip: '716902' },
	{ city: 'Suttonrath (Tipperary)', zip: '145155' },
	{ city: 'Sutton South (Dublin)', zip: '657841' },
	{ city: 'Suttonsrath (Kilkenny)', zip: '975973' },
	{ city: 'Swainstown (Meath)', zip: '264222' },
	{ city: 'Swan (Laois)', zip: '523125' },
	{ city: 'Swanlinbar (Cavan)', zip: '967994' },
	{ city: 'Sweetfarm (Wexford)', zip: '636343' },
	{ city: 'Sweetfields (Cork)', zip: '189516' },
	{ city: 'Sweethill (Kilkenny)', zip: '948730' },
	{ city: 'Sweetwood Little (Leitrim)', zip: '941877' },
	{ city: 'Sweetwood Lower (Leitrim)', zip: '433110' },
	{ city: 'Sweetwood Upper (Leitrim)', zip: '375777' },
	{ city: 'Swellan Lower (Cavan)', zip: '259290' },
	{ city: 'Swellan Upper (Cavan)', zip: '348931' },
	{ city: 'Swiftsacre (Galway)', zip: '669082' },
	{ city: 'Swiftsheath (Kilkenny)', zip: '288498' },
	{ city: 'Swilly (Donegal)', zip: '710576' },
	{ city: 'Swillybrin (Donegal)', zip: '183629' },
	{ city: 'Swinefield (Roscommon)', zip: '720466' },
	{ city: 'Swineford (Mayo)', zip: '536789' },
	{ city: 'Swinestown (Louth)', zip: '738201' },
	{ city: 'Swinford (Mayo)', zip: '633163' },
	{ city: 'Swordlestown North (Kildare)', zip: '674693' },
	{ city: 'Swordlestown South (Kildare)', zip: '144148' },
	{ city: 'Swords (Dublin)', zip: '833094' },
	{ city: 'Swords Demesne (Dublin)', zip: '393422' },
	{ city: 'Swords Glebe (Dublin)', zip: '705999' },
	{ city: 'Sycamore (Cork)', zip: '825908' },
	{ city: 'Sycamorehill (Galway)', zip: '174506' },
	{ city: 'Sylaun (Galway)', zip: '675120' },
	{ city: 'Sylaun East (Galway)', zip: '780966' },
	{ city: 'Sylaunnagran (Galway)', zip: '170269' },
	{ city: 'Sylaun West (Galway)', zip: '607231' },
	{ city: 'Synone (Tipperary)', zip: '964434' },
	{ city: 'Syonan (Westmeath)', zip: '103814' },
	{ city: 'Taash (Leitrim)', zip: '781330' },
	{ city: 'Table Mountain (Wicklow)', zip: '222336' },
	{ city: 'Tacumshin (Wexford)', zip: '492402' },
	{ city: 'Taduff East (Roscommon)', zip: '734486' },
	{ city: 'Taduff West (Roscommon)', zip: '219698' },
	{ city: 'Taghadoe (Kildare)', zip: '702370' },
	{ city: 'Taghart North (Cavan)', zip: '857069' },
	{ city: 'Taghart South (Cavan)', zip: '588014' },
	{ city: 'Taghboy (Roscommon)', zip: '569528' },
	{ city: 'Taghboyne (Westmeath)', zip: '109048' },
	{ city: 'Tagheen East (Mayo)', zip: '917383' },
	{ city: 'Tagheen West (Mayo)', zip: '572381' },
	{ city: 'Taghmaconnell (Roscommon)', zip: '412752' },
	{ city: 'Taghmon (Westmeath)', zip: '885253' },
	{ city: 'Taghmon (Wexford)', zip: '384266' },
	{ city: 'Taghnafearagh (Westmeath)', zip: '334958' },
	{ city: 'Taghnarra (Roscommon)', zip: '760180' },
	{ city: 'Taghnoose (Roscommon)', zip: '800205' },
	{ city: 'Taghsheenod Glebe (Longford)', zip: '596099' },
	{ city: 'Taghshinny (Longford)', zip: '758294' },
	{ city: 'Tagoat (Wexford)', zip: '870255' },
	{ city: 'Tahilla (Kerry)', zip: '631502' },
	{ city: 'Talbotshill (Kilkenny)', zip: '249270' },
	{ city: 'Talbotsinch (Kilkenny)', zip: '190673' },
	{ city: 'Talbotstown (Wexford)', zip: '959836' },
	{ city: 'Talbotstown Lower (Wicklow)', zip: '589186' },
	{ city: 'Talbotstown Upper (Wicklow)', zip: '807851' },
	{ city: 'Tallacoolbeg (Waterford)', zip: '865333' },
	{ city: 'Tallacoolmore (Waterford)', zip: '326705' },
	{ city: 'Tallagh (Mayo)', zip: '930070' },
	{ city: 'Tallaght (Dublin)', zip: '693379' },
	{ city: 'Tallanstown (Louth)', zip: '220880' },
	{ city: 'Tallavbaun (Mayo)', zip: '397433' },
	{ city: 'Tallavnamraher (Galway)', zip: '480914' },
	{ city: 'Tallow (Waterford)', zip: '483795' },
	{ city: 'Tallowbridge Lands (Waterford)', zip: '110125' },
	{ city: 'Tallowroe (Galway)', zip: '470202' },
	{ city: 'Tallyho (Westmeath)', zip: '530845' },
	{ city: 'Tamlaghtavally (Leitrim)', zip: '772232' },
	{ city: 'Tamlaght Beg (Leitrim)', zip: '843002' },
	{ city: 'Tamlaght More (Leitrim)', zip: '425041' },
	{ city: 'Tamlat (Monaghan)', zip: '817586' },
	{ city: 'Tamnawood (Donegal)', zip: '801298' },
	{ city: 'Tamur (Donegal)', zip: '755607' },
	{ city: 'Tanderagee (Cavan)', zip: '267802' },
	{ city: 'Tanderagee (Kildare)', zip: '117168' },
	{ city: 'Tanderagee (Meath)', zip: '240261' },
	{ city: 'Tanderagee (Monaghan)', zip: '393320' },
	{ city: 'Tanderageebane (Monaghan)', zip: '381492' },
	{ city: 'Tanderageebrack (Monaghan)', zip: '542006' },
	{ city: 'Tang (Westmeath)', zip: '419437' },
	{ city: 'Tangaveane (Donegal)', zip: '901409' },
	{ city: 'Tangincartoor (Mayo)', zip: '261941' },
	{ city: 'Tankardrath (Meath)', zip: '648376' },
	{ city: 'Tankardsgarden (Kildare)', zip: '883088' },
	{ city: 'Tankardsrock (Louth)', zip: '459241' },
	{ city: 'Tankardstown (Carlow)', zip: '708839' },
	{ city: 'Tankardstown (Cork)', zip: '964779' },
	{ city: 'Tankardstown (Dublin)', zip: '487762' },
	{ city: 'Tankardstown (Kildare)', zip: '251230' },
	{ city: 'Tankardstown (Laois)', zip: '839325' },
	{ city: 'Tankardstown (Limerick)', zip: '456473' },
	{ city: 'Tankardstown (Meath)', zip: '705033' },
	{ city: 'Tankardstown (Waterford)', zip: '905889' },
	{ city: 'Tankardstown North (Limerick)', zip: '400108' },
	{ city: 'Tankardstown South (Limerick)', zip: '243271' },
	{ city: 'Tankerstown (Tipperary)', zip: '828264' },
	{ city: 'Tanmacnally (Monaghan)', zip: '154289' },
	{ city: 'Tannersrath (Tipperary)', zip: '923532' },
	{ city: 'Tanrego East (Sligo)', zip: '771040' },
	{ city: 'Tanrego Intake (Sligo)', zip: '693158' },
	{ city: 'Tanrego West (Sligo)', zip: '111972' },
	{ city: 'Tanseyclose (Wicklow)', zip: '403709' },
	{ city: 'Tansyfield (Roscommon)', zip: '260662' },
	{ city: 'Tap (Sligo)', zip: '795515' },
	{ city: 'Taplagh (Monaghan)', zip: '767570' },
	{ city: 'Tara (Meath)', zip: '464808' },
	{ city: 'Tara (Offaly)', zip: '657926' },
	{ city: 'Tarahill (Wexford)', zip: '845793' },
	{ city: 'Tarbert (Kerry)', zip: '970764' },
	{ city: 'Tarbert (Laois)', zip: '405944' },
	{ city: 'Tarbert Island (Kerry)', zip: '344283' },
	{ city: 'Tarmon (Clare)', zip: '284662' },
	{ city: 'Tarmon East (Kerry)', zip: '768026' },
	{ city: 'Tarmonhill (Kerry)', zip: '698189' },
	{ city: 'Tarmon West (Kerry)', zip: '194434' },
	{ city: 'Tarramud (Galway)', zip: '296773' },
	{ city: 'Tarrea (Galway)', zip: '856451' },
	{ city: 'Tarsaghaun Beg North (Mayo)', zip: '601693' },
	{ city: 'Tarsaghaun Beg South (Mayo)', zip: '681685' },
	{ city: 'Tarsaghaun More (Mayo)', zip: '139399' },
	{ city: 'Tarsna (Tipperary)', zip: '602949' },
	{ city: 'Tartan (Roscommon)', zip: '618152' },
	{ city: 'Tassan (Monaghan)', zip: '241185' },
	{ city: 'Tatebane (Louth)', zip: '263262' },
	{ city: 'Tateetra (Louth)', zip: '388670' },
	{ city: 'Tates And Carrans Park (Louth)', zip: '362657' },
	{ city: 'Tatestown (Meath)', zip: '214570' },
	{ city: 'Tatnadarra (Louth)', zip: '393189' },
	{ city: 'Tattincake (Monaghan)', zip: '897046' },
	{ city: 'Tattindonagh (Monaghan)', zip: '518192' },
	{ city: 'Tattintlieve (Monaghan)', zip: '297250' },
	{ city: 'Tattyboy (Monaghan)', zip: '292231' },
	{ city: 'Tattyboys (Louth)', zip: '586539' },
	{ city: 'Tattybrack (Monaghan)', zip: '644217' },
	{ city: 'Tattygare (Monaghan)', zip: '993807' },
	{ city: 'Tattynagall (Monaghan)', zip: '838565' },
	{ city: 'Tattynaskeagh (Louth)', zip: '874450' },
	{ city: 'Tattyreagh (Cavan)', zip: '927249' },
	{ city: 'Tattyreagh North (Monaghan)', zip: '396949' },
	{ city: 'Tattyreagh South (Monaghan)', zip: '436380' },
	{ city: 'Taughboy (Donegal)', zip: '935100' },
	{ city: 'Taulaght (Wexford)', zip: '754793' },
	{ city: 'Taurbeg (Cork)', zip: '329753' },
	{ city: 'Taurmore (Cork)', zip: '126347' },
	{ city: 'Tavanagh (Monaghan)', zip: '442985' },
	{ city: 'Tavanaskea (Monaghan)', zip: '108657' },
	{ city: 'Tavraun (Mayo)', zip: '558029' },
	{ city: 'Tawin East (Galway)', zip: '793422' },
	{ city: 'Tawin West (Galway)', zip: '716823' },
	{ city: 'Tawlaght (Cavan)', zip: '611204' },
	{ city: 'Tawlaght (Donegal)', zip: '492521' },
	{ city: 'Tawlaght (Kerry)', zip: '655077' },
	{ city: 'Tawlaght (Roscommon)', zip: '851788' },
	{ city: 'Tawly (Leitrim)', zip: '431732' },
	{ city: 'Tawnacrom (Donegal)', zip: '257798' },
	{ city: 'Tawnadremira (Sligo)', zip: '465430' },
	{ city: 'Tawnagh (Cavan)', zip: '275382' },
	{ city: 'Tawnagh (Donegal)', zip: '385918' },
	{ city: 'Tawnagh (Longford)', zip: '922363' },
	{ city: 'Tawnagh (Mayo)', zip: '489746' },
	{ city: 'Tawnagh (Roscommon)', zip: '692544' },
	{ city: 'Tawnagh (Sligo)', zip: '592419' },
	{ city: 'Tawnaghaknaff (Mayo)', zip: '537947' },
	{ city: 'Tawnaghbaun (Galway)', zip: '120492' },
	{ city: 'Tawnaghbaun (Mayo)', zip: '897020' },
	{ city: 'Tawnaghbeg (Galway)', zip: '145308' },
	{ city: 'Tawnaghbeg (Mayo)', zip: '891607' },
	{ city: 'Tawnagh Beg (Mayo)', zip: '836149' },
	{ city: 'Tawnagh East (Galway)', zip: '513927' },
	{ city: 'Tawnagh East (Mayo)', zip: '700886' },
	{ city: 'Tawnaghgorm (Donegal)', zip: '546169' },
	{ city: 'Tawnaghlahan (Donegal)', zip: '368716' },
	{ city: 'Tawnaghlahard (Mayo)', zip: '743659' },
	{ city: 'Tawnaghmore (Galway)', zip: '219233' },
	{ city: 'Tawnaghmore (Mayo)', zip: '528736' },
	{ city: 'Tawnaghmore (Sligo)', zip: '408725' },
	{ city: 'Tawnagh More (Leitrim)', zip: '389306' },
	{ city: 'Tawnagh More (Mayo)', zip: '243469' },
	{ city: 'Tawnagh More (Roscommon)', zip: '854285' },
	{ city: 'Tawnaghmore Lower (Mayo)', zip: '346074' },
	{ city: 'Tawnaghmore Upper (Mayo)', zip: '989784' },
	{ city: 'Tawnaghs (Mayo)', zip: '855817' },
	{ city: 'Tawnagh West (Galway)', zip: '574746' },
	{ city: 'Tawnaglass (Mayo)', zip: '110139' },
	{ city: 'Tawnagrania (Mayo)', zip: '183215' },
	{ city: 'Tawnahoney (Leitrim)', zip: '907339' },
	{ city: 'Tawnakeel (Mayo)', zip: '779644' },
	{ city: 'Tawnalaghta (Sligo)', zip: '404771' },
	{ city: 'Tawnalary (Donegal)', zip: '172948' },
	{ city: 'Tawnaleck (Leitrim)', zip: '454112' },
	{ city: 'Tawnaleen (Galway)', zip: '483271' },
	{ city: 'Tawnalion (Sligo)', zip: '169070' },
	{ city: 'Tawnamachugh (Leitrim)', zip: '870173' },
	{ city: 'Tawnamartola (Mayo)', zip: '146145' },
	{ city: 'Tawnamore (Louth)', zip: '897245' },
	{ city: 'Tawnamore (Sligo)', zip: '464753' },
	{ city: 'Tawnamullagh (Mayo)', zip: '919043' },
	{ city: 'Tawnanameeltoge (Mayo)', zip: '215758' },
	{ city: 'Tawnanasheffin (Mayo)', zip: '562367' },
	{ city: 'Tawnanasool (Mayo)', zip: '611261' },
	{ city: 'Tawnaneilleen (Sligo)', zip: '444524' },
	{ city: 'Tawnasligo (Donegal)', zip: '592679' },
	{ city: 'Tawnatrohaun (Sligo)', zip: '997331' },
	{ city: 'Tawnatruffaun (Sligo)', zip: '640132' },
	{ city: 'Tawnavoultry (Sligo)', zip: '978111' },
	{ city: 'Tawnawoggaun (Mayo)', zip: '495770' },
	{ city: 'Tawnawully Mountains (Donegal)', zip: '187046' },
	{ city: 'Tawnies Lower (Cork)', zip: '780370' },
	{ city: 'Tawnies Upper (Cork)', zip: '260099' },
	{ city: 'Tawnrush (Kildare)', zip: '349129' },
	{ city: 'Tawny (Donegal)', zip: '960858' },
	{ city: 'Tawnyard (Mayo)', zip: '490596' },
	{ city: 'Tawnycoolawee (Mayo)', zip: '971431' },
	{ city: 'Tawnycorragh (Leitrim)', zip: '775702' },
	{ city: 'Tawnycrower (Mayo)', zip: '817130' },
	{ city: 'Tawnycurry (Leitrim)', zip: '624844' },
	{ city: 'Tawnydoogan (Mayo)', zip: '983715' },
	{ city: 'Tawnyeely (Leitrim)', zip: '574129' },
	{ city: 'Tawnyeeny (Mayo)', zip: '497083' },
	{ city: 'Tawnyemon (Mayo)', zip: '501256' },
	{ city: 'Tawnyfeacle (Leitrim)', zip: '266837' },
	{ city: 'Tawnygorm (Donegal)', zip: '512842' },
	{ city: 'Tawnyhoosy (Leitrim)', zip: '742339' },
	{ city: 'Tawnyinah Lower (Mayo)', zip: '152479' },
	{ city: 'Tawnyinah Middle (Mayo)', zip: '713052' },
	{ city: 'Tawnyinah Upper (Mayo)', zip: '189394' },
	{ city: 'Tawnyinlough (Mayo)', zip: '187988' },
	{ city: 'Tawnykinaff (Mayo)', zip: '743171' },
	{ city: 'Tawnylaheen (Mayo)', zip: '552242' },
	{ city: 'Tawnylea (Leitrim)', zip: '352152' },
	{ city: 'Tawnylough (Mayo)', zip: '903523' },
	{ city: 'Tawny Lower (Donegal)', zip: '272273' },
	{ city: 'Tawnylust (Leitrim)', zip: '344700' },
	{ city: 'Tawnylust Barr (Leitrim)', zip: '506806' },
	{ city: 'Tawnylust Barr Upper (Leitrim)', zip: '909336' },
	{ city: 'Tawnymackan (Mayo)', zip: '907825' },
	{ city: 'Tawnymakelly (Cavan)', zip: '266248' },
	{ city: 'Tawnymanus (Leitrim)', zip: '491756' },
	{ city: 'Tawny Middle (Donegal)', zip: '297522' },
	{ city: 'Tawnymoyle (Leitrim)', zip: '559966' },
	{ city: 'Tawnymucklagh (Sligo)', zip: '649860' },
	{ city: 'Tawnynaboll (Mayo)', zip: '555410' },
	{ city: 'Tawnynagry (Mayo)', zip: '322842' },
	{ city: 'Tawnynahulty (Mayo)', zip: '574261' },
	{ city: 'Tawnynameeltoge (Mayo)', zip: '225814' },
	{ city: 'Tawnyneden (Roscommon)', zip: '756352' },
	{ city: 'Tawnynoran (Mayo)', zip: '321048' },
	{ city: 'Tawnyrover (Roscommon)', zip: '918393' },
	{ city: 'Tawnyshane (Mayo)', zip: '801871' },
	{ city: 'Tawnyslinnaun (Mayo)', zip: '855732' },
	{ city: 'Tawnytallan (Leitrim)', zip: '230021' },
	{ city: 'Tawnytaskin (Roscommon)', zip: '807102' },
	{ city: 'Tawnyunshinagh (Leitrim)', zip: '890881' },
	{ city: 'Tawny Upper (Donegal)', zip: '913627' },
	{ city: 'Tawnyvorgal (Donegal)', zip: '903765' },
	{ city: 'Tawnywaddyduff (Mayo)', zip: '511166' },
	{ city: 'Tawran (Sligo)', zip: '884846' },
	{ city: 'Taylorsgrange (Dublin)', zip: '684397' },
	{ city: 'Taylorstown (Galway)', zip: '680464' },
	{ city: 'Taylorstown (Roscommon)', zip: '736375' },
	{ city: 'Taylorstown (Wexford)', zip: '652830' },
	{ city: 'Tead Beg (Cork)', zip: '153226' },
	{ city: 'Teadies Lower (Cork)', zip: '356863' },
	{ city: 'Teadies Upper (Cork)', zip: '360747' },
	{ city: 'Tead More (Cork)', zip: '794312' },
	{ city: 'Teangue (Donegal)', zip: '852954' },
	{ city: 'Tearaght Island (Kerry)', zip: '893554' },
	{ city: 'Tedagh (Cork)', zip: '240589' },
	{ city: 'Tedavnet (Monaghan)', zip: '342091' },
	{ city: 'Tedeehan Lower (Cavan)', zip: '203470' },
	{ city: 'Tedeehan Middle (Cavan)', zip: '544649' },
	{ city: 'Tedeehan Upper (Cavan)', zip: '420645' },
	{ city: 'Tedwards (Wexford)', zip: '699364' },
	{ city: 'Teebane (Cavan)', zip: '452678' },
	{ city: 'Teeboy (Cavan)', zip: '659939' },
	{ city: 'Teehill (Monaghan)', zip: '521042' },
	{ city: 'Teelough (Kildare)', zip: '367720' },
	{ city: 'Teemore (Cavan)', zip: '702031' },
	{ city: 'Teemore (Longford)', zip: '181592' },
	{ city: 'Teenah (Cork)', zip: '959564' },
	{ city: 'Teer (Kerry)', zip: '978976' },
	{ city: 'Teer (Monaghan)', zip: '617516' },
	{ city: 'Teeracurra (Cork)', zip: '138445' },
	{ city: 'Teeraghbeg (Clare)', zip: '437512' },
	{ city: 'Teeraha (Kerry)', zip: '675532' },
	{ city: 'Teeranassig (Cork)', zip: '929397' },
	{ city: 'Teeranea (Galway)', zip: '325563' },
	{ city: 'Teeravane (Kerry)', zip: '158033' },
	{ city: 'Teerbeg (Cork)', zip: '606403' },
	{ city: 'Teerbrin (Kerry)', zip: '931107' },
	{ city: 'Teereeven (Cork)', zip: '198786' },
	{ city: 'Teerelton (Cork)', zip: '858148' },
	{ city: 'Teergay (Cork)', zip: '404900' },
	{ city: 'Teergonean (Clare)', zip: '538278' },
	{ city: 'Teerleheen (Clare)', zip: '142983' },
	{ city: 'Teermaclane (Clare)', zip: '217762' },
	{ city: 'Teermena (Limerick)', zip: '138119' },
	{ city: 'Teermore (Limerick)', zip: '749523' },
	{ city: 'Teermore (Roscommon)', zip: '743703' },
	{ city: 'Teermore (Westmeath)', zip: '464425' },
	{ city: 'Teermulmoney (Clare)', zip: '639019' },
	{ city: 'Teernaboul (Kerry)', zip: '596537' },
	{ city: 'Teernacreeve (Westmeath)', zip: '276017' },
	{ city: 'Teernagloghane (Clare)', zip: '380133' },
	{ city: 'Teernahila (Kerry)', zip: '411145' },
	{ city: 'Teernahilla (Limerick)', zip: '166101' },
	{ city: 'Teernahillane (Cork)', zip: '906866' },
	{ city: 'Teernakill North (Galway)', zip: '191962' },
	{ city: 'Teernakill South (Galway)', zip: '758960' },
	{ city: 'Teernea (Clare)', zip: '183261' },
	{ city: 'Teernea Commons (Clare)', zip: '900134' },
	{ city: 'Teeromoyle (Kerry)', zip: '354131' },
	{ city: 'Teeronaun (Clare)', zip: '700458' },
	{ city: 'Teeronea (Clare)', zip: '605946' },
	{ city: 'Teeroneer (Clare)', zip: '853808' },
	{ city: 'Teerovannan (Clare)', zip: '343648' },
	{ city: 'Teervarna (Clare)', zip: '111697' },
	{ city: 'Teervena (Limerick)', zip: '929083' },
	{ city: 'Teesan (Sligo)', zip: '322036' },
	{ city: 'Teeskagh (Clare)', zip: '955110' },
	{ city: 'Teevaloughan (Mayo)', zip: '180908' },
	{ city: 'Teeveeny (Cork)', zip: '946723' },
	{ city: 'Teevenacroaghy (Mayo)', zip: '165375' },
	{ city: 'Teevickmoy (Donegal)', zip: '487558' },
	{ city: 'Teevinish East (Mayo)', zip: '995024' },
	{ city: 'Teevinish West (Mayo)', zip: '201806' },
	{ city: 'Teevmore (Mayo)', zip: '924038' },
	{ city: 'Teevnabinnia (Mayo)', zip: '704710' },
	{ city: 'Teevnacreeva (Roscommon)', zip: '504175' },
	{ city: 'Teevrevagh (Westmeath)', zip: '895151' },
	{ city: 'Teevurcher (Meath)', zip: '660084' },
	{ city: 'Telaydan (Monaghan)', zip: '187836' },
	{ city: 'Tellarought (Wexford)', zip: '917483' },
	{ city: 'Telton (Roscommon)', zip: '425852' },
	{ city: 'Teltown (Meath)', zip: '871019' },
	{ city: 'Temora (Offaly)', zip: '550188' },
	{ city: 'Templanstown (Westmeath)', zip: '893959' },
	{ city: 'Temple (Galway)', zip: '712165' },
	{ city: 'Temple (Mayo)', zip: '826585' },
	{ city: 'Templeathea East (Limerick)', zip: '219491' },
	{ city: 'Templeathea West (Limerick)', zip: '109888' },
	{ city: 'Templebannagh (Clare)', zip: '565965' },
	{ city: 'Templebodan (Cork)', zip: '849067' },
	{ city: 'Templeboy (Sligo)', zip: '501792' },
	{ city: 'Templebredon (Limerick)', zip: '375820' },
	{ city: 'Templebryan North (Cork)', zip: '348609' },
	{ city: 'Templebryan South (Cork)', zip: '948792' },
	{ city: 'Templecarrig Lower (Wicklow)', zip: '868532' },
	{ city: 'Templecarrig Upper (Wicklow)', zip: '255008' },
	{ city: 'Templeconnell (Cork)', zip: '521428' },
	{ city: 'Templederry (Tipperary)', zip: '980700' },
	{ city: 'Templederry (Wexford)', zip: '316868' },
	{ city: 'Templedouglas (Donegal)', zip: '210462' },
	{ city: 'Temple-Etney (Tipperary)', zip: '397304' },
	{ city: 'Templeglentan East (Limerick)', zip: '294811' },
	{ city: 'Templeglentan West (Limerick)', zip: '374274' },
	{ city: 'Templehouse Demesne (Sligo)', zip: '330530' },
	{ city: 'Templeludigan (Wexford)', zip: '664453' },
	{ city: 'Templelusk (Wicklow)', zip: '249703' },
	{ city: 'Templelyon Lower (Wicklow)', zip: '764555' },
	{ city: 'Templelyon Upper (Wicklow)', zip: '255827' },
	{ city: 'Templemacateer (Westmeath)', zip: '370268' },
	{ city: 'Templemartin (Cork)', zip: '851941' },
	{ city: 'Templemartin (Galway)', zip: '389712' },
	{ city: 'Templemartin (Kilkenny)', zip: '296482' },
	{ city: 'Templemary (Cork)', zip: '701910' },
	{ city: 'Templemichael (Cork)', zip: '451725' },
	{ city: 'Templemichael (Limerick)', zip: '210274' },
	{ city: 'Templemichael (Tipperary)', zip: '492949' },
	{ city: 'Templemichael (Waterford)', zip: '352003' },
	{ city: 'Templemichael (Wicklow)', zip: '672906' },
	{ city: 'Templemichael Glebe (Longford)', zip: '200139' },
	{ city: 'Templemore (Tipperary)', zip: '917765' },
	{ city: 'Templemore Demesne (Tipperary)', zip: '964993' },
	{ city: 'Templemoyle (Donegal)', zip: '285107' },
	{ city: 'Templemoyle (Galway)', zip: '131447' },
	{ city: 'Templenaboe (Carlow)', zip: '604399' },
	{ city: 'Templenabree (Sligo)', zip: '428490' },
	{ city: 'Templenacarriga North (Cork)', zip: '292540' },
	{ city: 'Templenacarriga South (Cork)', zip: '857053' },
	{ city: 'Templenacroha (Wexford)', zip: '514186' },
	{ city: 'Templenahurney (Tipperary)', zip: '127307' },
	{ city: 'Templenew (Donegal)', zip: '823036' },
	{ city: 'Templenoe (Cork)', zip: '516295' },
	{ city: 'Templenoe (Tipperary)', zip: '486699' },
	{ city: 'Templeogue (Dublin)', zip: '824841' },
	{ city: 'Templeoran North (Westmeath)', zip: '382445' },
	{ city: 'Templeoran South (Westmeath)', zip: '874494' },
	{ city: 'Templeorum (Kilkenny)', zip: '326428' },
	{ city: 'Templeowen (Carlow)', zip: '229203' },
	{ city: 'Templepark (Galway)', zip: '204236' },
	{ city: 'Templepatrick (Westmeath)', zip: '333791' },
	{ city: 'Templepeter (Carlow)', zip: '770508' },
	{ city: 'Templequain (Laois)', zip: '839855' },
	{ city: 'Templerainy (Wicklow)', zip: '102123' },
	{ city: 'Templescoby (Wexford)', zip: '752890' },
	{ city: 'Templeshanbo (Wexford)', zip: '529959' },
	{ city: 'Templeshannon (Wexford)', zip: '350540' },
	{ city: 'Templeshelin (Wexford)', zip: '562692' },
	{ city: 'Templetate (Monaghan)', zip: '602866' },
	{ city: 'Templeton Glebe (Longford)', zip: '408763' },
	{ city: 'Templetouhy (Tipperary)', zip: '165507' },
	{ city: 'Templetown (Louth)', zip: '906787' },
	{ city: 'Templetown (Wexford)', zip: '799201' },
	{ city: 'Templeusque (Cork)', zip: '757128' },
	{ city: 'Templevally (Cork)', zip: '998606' },
	{ city: 'Templevanny (Sligo)', zip: '186175' },
	{ city: 'Templeyvrick (Waterford)', zip: '737361' },
	{ city: 'Tenacre (Wexford)', zip: '897816' },
	{ city: 'Tenchspit (Wexford)', zip: '376971' },
	{ city: 'Tennalick (Longford)', zip: '280913' },
	{ city: 'Tennalough (Longford)', zip: '268483' },
	{ city: 'Tennyphobble (Longford)', zip: '632612' },
	{ city: 'Tentore (Kilkenny)', zip: '475531' },
	{ city: 'Tents (Cavan)', zip: '237077' },
	{ city: 'Tents (Leitrim)', zip: '282348' },
	{ city: 'Teraverty (Monaghan)', zip: '138893' },
	{ city: 'Terenure (Dublin)', zip: '426498' },
	{ city: 'Termon (Cavan)', zip: '310478' },
	{ city: 'Termon (Clare)', zip: '344990' },
	{ city: 'Termon (Donegal)', zip: '842256' },
	{ city: 'Termon (Galway)', zip: '108714' },
	{ city: 'Termon (Mayo)', zip: '767899' },
	{ city: 'Termon (Roscommon)', zip: '106034' },
	{ city: 'Termonbarry (Roscommon)', zip: '506794' },
	{ city: 'Termon Beg (Roscommon)', zip: '282170' },
	{ city: 'Termoncarragh (Mayo)', zip: '343057' },
	{ city: 'Termon East (Clare)', zip: '162662' },
	{ city: 'Termonfeckin (Louth)', zip: '433331' },
	{ city: 'Termon More (Roscommon)', zip: '131404' },
	{ city: 'Termons (Kerry)', zip: '382536' },
	{ city: 'Termon West (Clare)', zip: '560932' },
	{ city: 'Terramount (Cork)', zip: '668769' },
	{ city: 'Terrybaun (Mayo)', zip: '246239' },
	{ city: 'Terrycaffe (Monaghan)', zip: '592471' },
	{ city: 'Terryduff (Mayo)', zip: '613193' },
	{ city: 'Terrygeely (Monaghan)', zip: '305574' },
	{ city: 'Terryglass (Tipperary)', zip: '421955' },
	{ city: 'Terrygreeghan (Monaghan)', zip: '877217' },
	{ city: 'Terryland (Galway)', zip: '462231' },
	{ city: "Terry's-Land (Cork)", zip: '585705' },
	{ city: 'Terrysstang (Waterford)', zip: '836905' },
	{ city: 'Terrytole (Monaghan)', zip: '995328' },
	{ city: 'Tervoe (Limerick)', zip: '310496' },
	{ city: 'Tetoppa (Monaghan)', zip: '869394' },
	{ city: 'Tevrin (Westmeath)', zip: '764919' },
	{ city: 'The Butts (Carlow)', zip: '397134' },
	{ city: 'The Derries (Laois)', zip: '544447' },
	{ city: 'The Division (Tipperary)', zip: '804538' },
	{ city: 'The Downs (Westmeath)', zip: '431761' },
	{ city: 'The Heath (Laois)', zip: '253205' },
	{ city: 'The Heath (Tipperary)', zip: '860079' },
	{ city: 'The League (Cork)', zip: '553754' },
	{ city: 'Theoil (Wexford)', zip: '604138' },
	{ city: 'The Pigeons (Westmeath)', zip: '877305' },
	{ city: 'The Pike (Cork)', zip: '784286' },
	{ city: 'The Raven (Wexford)', zip: '804124' },
	{ city: 'The Rogue (Waterford)', zip: '427437' },
	{ city: 'The Rower (Kilkenny)', zip: '749121' },
	{ city: 'Thesheehys (Tipperary)', zip: '727691' },
	{ city: 'The Walk (Offaly)', zip: '679200' },
	{ city: 'The-Wood (Kerry)', zip: '641716' },
	{ city: 'Thole Islands (Donegal)', zip: '354227' },
	{ city: 'Thomascourt (Cavan)', zip: '980407' },
	{ city: 'Thomastown (Clare)', zip: '454780' },
	{ city: 'Thomastown (Dublin)', zip: '870328' },
	{ city: 'Thomastown (Galway)', zip: '194660' },
	{ city: 'Thomastown (Kildare)', zip: '230880' },
	{ city: 'Thomastown (Kilkenny)', zip: '571811' },
	{ city: 'Thomastown (Limerick)', zip: '563734' },
	{ city: 'Thomastown (Louth)', zip: '589399' },
	{ city: 'Thomastown (Mayo)', zip: '551842' },
	{ city: 'Thomastown (Meath)', zip: '549341' },
	{ city: 'Thomastown (Offaly)', zip: '273800' },
	{ city: 'Thomastown (Tipperary)', zip: '486916' },
	{ city: 'Thomastown (Westmeath)', zip: '725723' },
	{ city: 'Thomastown (Wicklow)', zip: '314862' },
	{ city: 'Thomastown Demesne (Offaly)', zip: '918501' },
	{ city: 'Thomastown Demesne (Roscommon)', zip: '615406' },
	{ city: 'Thomastown Demesne (Tipperary)', zip: '267773' },
	{ city: 'Thomastown Demesne North (Tipperary)', zip: '400034' },
	{ city: 'Thomastown Demesne South (Tipperary)', zip: '434089' },
	{ city: 'Thomastown East (Kildare)', zip: '571532' },
	{ city: 'Thomastown West (Kildare)', zip: '954618' },
	{ city: 'Thomondtown (Dublin)', zip: '395117' },
	{ city: 'Thornberry (Kildare)', zip: '377253' },
	{ city: 'Thornfield (Galway)', zip: '223051' },
	{ city: 'Thornfield (Limerick)', zip: '974489' },
	{ city: 'Thornhill (Cavan)', zip: '939051' },
	{ city: 'Thornhill (Cork)', zip: '466737' },
	{ city: 'Thornhill (Kildare)', zip: '320254' },
	{ city: 'Thornhill (Mayo)', zip: '743692' },
	{ city: 'Thornhill (Monaghan)', zip: '493809' },
	{ city: 'Thornhill (Tipperary)', zip: '515292' },
	{ city: 'Thorntown (Dublin)', zip: '134696' },
	{ city: 'Thornwell (Offaly)', zip: '652525' },
	{ city: 'Threeacres (Wexford)', zip: '529595' },
	{ city: 'Three Carvaghs (Cavan)', zip: '146307' },
	{ city: 'Threecastles (Kilkenny)', zip: '922629' },
	{ city: 'Threecastles (Wicklow)', zip: '420953' },
	{ city: 'Threecastles Demesne (Kilkenny)', zip: '635339' },
	{ city: 'Three-Gneeves (Cork)', zip: '726386' },
	{ city: 'Three Mile House (Monaghan)', zip: '703417' },
	{ city: 'Threemilewater (Wicklow)', zip: '366307' },
	{ city: 'Three Trees (Donegal)', zip: '105425' },
	{ city: 'Threewells (Wicklow)', zip: '767813' },
	{ city: 'Thunder Rock (Kerry)', zip: '180000' },
	{ city: 'Thurles (Tipperary)', zip: '484420' },
	{ city: 'Thurlesbeg (Tipperary)', zip: '192267' },
	{ city: 'Thurles Townparks (Tipperary)', zip: '408111' },
	{ city: 'Thurstianstown (Meath)', zip: '918011' },
	{ city: 'Tiaquin Demesne (Galway)', zip: '706938' },
	{ city: 'Tibarney (Roscommon)', zip: '546328' },
	{ city: 'Tibberaghny (Kilkenny)', zip: '672794' },
	{ city: 'Tibbotstown (Cork)', zip: '582072' },
	{ city: 'Tibohine (Roscommon)', zip: '303981' },
	{ city: 'Tibradden (Dublin)', zip: '512627' },
	{ city: 'Ticknevin (Kildare)', zip: '669362' },
	{ city: 'Ticlash (Wicklow)', zip: '970587' },
	{ city: 'Ticooly (Galway)', zip: '872483' },
	{ city: 'Ticosker (Cavan)', zip: '836941' },
	{ city: 'Ticosker Glebe (Cavan)', zip: '735865' },
	{ city: 'Ticroghan (Meath)', zip: '411003' },
	{ city: 'Tiduff (Kerry)', zip: '431980' },
	{ city: 'Tieraclea Lower (Kerry)', zip: '500569' },
	{ city: 'Tieraclea Upper (Kerry)', zip: '191075' },
	{ city: 'Tiermore (Kilkenny)', zip: '641364' },
	{ city: 'Tiermore (Limerick)', zip: '735290' },
	{ city: 'Tiermoyle (Tipperary)', zip: '800956' },
	{ city: 'Tiershanaghan (Kerry)', zip: '167487' },
	{ city: 'Tievachorky (Donegal)', zip: '881378' },
	{ city: 'Tievaleny (Monaghan)', zip: '978306' },
	{ city: 'Tievebane (Donegal)', zip: '346028' },
	{ city: 'Tievebaun (Galway)', zip: '399504' },
	{ city: 'Tieveboy (Donegal)', zip: '749227' },
	{ city: 'Tieveboy (Sligo)', zip: '863959' },
	{ city: 'Tievebrack (Donegal)', zip: '196908' },
	{ city: 'Tievebreen (Galway)', zip: '858297' },
	{ city: 'Tievecloghoge (Donegal)', zip: '500774' },
	{ city: 'Tievedeevan (Donegal)', zip: '593997' },
	{ city: 'Tievedooly (Donegal)', zip: '439486' },
	{ city: 'Tievegarriff (Galway)', zip: '831290' },
	{ city: 'Tievegarvlagh (Donegal)', zip: '131792' },
	{ city: 'Tievelough (Donegal)', zip: '772521' },
	{ city: 'Tievemore (Donegal)', zip: '318378' },
	{ city: 'Tievemore (Galway)', zip: '905518' },
	{ city: 'Tievenaman (Cavan)', zip: '790630' },
	{ city: 'Tievenanass (Cavan)', zip: '212195' },
	{ city: 'Tievenaveagh (Cavan)', zip: '100849' },
	{ city: 'Tievereagh (Donegal)', zip: '741771' },
	{ city: 'Tieveskeelta (Donegal)', zip: '309169' },
	{ city: 'Tievetooey (Donegal)', zip: '655104' },
	{ city: 'Tifeaghna (Kilkenny)', zip: '671322' },
	{ city: 'Tiglin (Wicklow)', zip: '291678' },
	{ city: 'Tigreenaun (Galway)', zip: '748248' },
	{ city: 'Tigroe (Waterford)', zip: '481359' },
	{ city: 'Tigroney East (Wicklow)', zip: '496670' },
	{ city: 'Tigroney West (Wicklow)', zip: '300942' },
	{ city: 'Tikerlevan (Kilkenny)', zip: '577304' },
	{ city: 'Tikillin (Wexford)', zip: '747534' },
	{ city: 'Tikincor Lower (Waterford)', zip: '338942' },
	{ city: 'Tikincor Upper (Waterford)', zip: '883712' },
	{ city: 'Tiknick (Dublin)', zip: '888456' },
	{ city: 'Tiknock (Carlow)', zip: '518454' },
	{ city: 'Tiknock (Cork)', zip: '891358' },
	{ city: 'Tiknock (Dublin)', zip: '608803' },
	{ city: 'Tiknock (Waterford)', zip: '655793' },
	{ city: 'Tiknock (Wexford)', zip: '799935' },
	{ city: 'Tiknock (Wicklow)', zip: '644793' },
	{ city: 'Tilickafinna (Cork)', zip: '685168' },
	{ city: 'Tilladavin (Wexford)', zip: '904704' },
	{ city: 'Timacat (Galway)', zip: '121247' },
	{ city: 'Timadooaun (Galway)', zip: '201248' },
	{ city: 'Timahoe (Laois)', zip: '714214' },
	{ city: 'Timahoe East (Kildare)', zip: '530396' },
	{ city: 'Timahoe West (Kildare)', zip: '271387' },
	{ city: 'Timanagh (Roscommon)', zip: '280743' },
	{ city: 'Timard (Galway)', zip: '199732' },
	{ city: 'Timard (Kildare)', zip: '376271' },
	{ city: 'Timeighter (Tipperary)', zip: '236088' },
	{ city: 'Timlins (Meath)', zip: '207951' },
	{ city: 'Timmore (Wicklow)', zip: '794311' },
	{ city: 'Timogue (Laois)', zip: '982404' },
	{ city: 'Timoleague (Cork)', zip: '286216' },
	{ city: 'Timolin (Kildare)', zip: '446502' },
	{ city: 'Timolin (Offaly)', zip: '353448' },
	{ city: 'Timoney (Tipperary)', zip: '383768' },
	{ city: 'Timoneyhills (Tipperary)', zip: '110838' },
	{ city: 'Timoole (Meath)', zip: '373708' },
	{ city: 'Timpaun (Roscommon)', zip: '383971' },
	{ city: 'Timsallagh (Galway)', zip: '762849' },
	{ city: 'Timullen (Louth)', zip: '407827' },
	{ city: 'Timullin (Wicklow)', zip: '100461' },
	{ city: 'Tinacarra (Roscommon)', zip: '984939' },
	{ city: 'Tinacrannagh (Offaly)', zip: '580139' },
	{ city: 'Tinageeragh (Galway)', zip: '236009' },
	{ city: 'Tinageragh (Cork)', zip: '894239' },
	{ city: 'Tinahask Lower (Wicklow)', zip: '193088' },
	{ city: 'Tinahask Upper (Wicklow)', zip: '986012' },
	{ city: 'Tinahely (Wicklow)', zip: '176522' },
	{ city: 'Tinakelly (Wicklow)', zip: '991442' },
	{ city: 'Tinakelly Murragh (Wicklow)', zip: '958871' },
	{ city: 'Tinalintan (Kilkenny)', zip: '870752' },
	{ city: 'Tinalira (Waterford)', zip: '229401' },
	{ city: 'Tinamuck East (Offaly)', zip: '284030' },
	{ city: 'Tinamuck South (Offaly)', zip: '434886' },
	{ city: 'Tinamuck West (Offaly)', zip: '715067' },
	{ city: 'Tinary (Monaghan)', zip: '496672' },
	{ city: 'Tincarraun (Kilkenny)', zip: '920791' },
	{ city: 'Tincashel (Kilkenny)', zip: '516645' },
	{ city: 'Tincone (Wexford)', zip: '940005' },
	{ city: 'Tincoon (Wexford)', zip: '574198' },
	{ city: 'Tincouse (Kilkenny)', zip: '701897' },
	{ city: 'Tincurra (Wexford)', zip: '915318' },
	{ city: 'Tincurragh (Wexford)', zip: '839892' },
	{ city: 'Tincurry (Tipperary)', zip: '470120' },
	{ city: 'Tincurry (Wexford)', zip: '530766' },
	{ city: 'Tinderry (Tipperary)', zip: '202758' },
	{ city: 'Ting (Wexford)', zip: '229911' },
	{ city: 'Tingar (Wexford)', zip: '321884' },
	{ city: 'Tingarran (Kilkenny)', zip: '740141' },
	{ city: 'Tinhalla (Tipperary)', zip: '300425' },
	{ city: 'Tinhalla (Waterford)', zip: '849446' },
	{ city: 'Tinkershill (Galway)', zip: '468319' },
	{ city: 'Tinklersford (Donegal)', zip: '351593' },
	{ city: 'Tinlough (Tipperary)', zip: '173904' },
	{ city: 'Tinnabaun (Wexford)', zip: '710387' },
	{ city: 'Tinnaberna (Wexford)', zip: '925720' },
	{ city: 'Tinnabinna (Waterford)', zip: '521897' },
	{ city: 'Tinnacarrick (Wexford)', zip: '327316' },
	{ city: 'Tinnacarrig (Carlow)', zip: '324527' },
	{ city: 'Tinnaclash (Carlow)', zip: '720096' },
	{ city: 'Tinnaclohy (Laois)', zip: '610819' },
	{ city: 'Tinnacree (Wexford)', zip: '887871' },
	{ city: 'Tinnacross (Offaly)', zip: '481579' },
	{ city: 'Tinnacross (Wexford)', zip: '599330' },
	{ city: 'Tinnacullia (Limerick)', zip: '597258' },
	{ city: 'Tinnagarney (Carlow)', zip: '628243' },
	{ city: 'Tinnagroun (Waterford)', zip: '730220' },
	{ city: 'Tinnahally (Kerry)', zip: '886572' },
	{ city: 'Tinnahask (Wexford)', zip: '607099' },
	{ city: 'Tinnahinch (Carlow)', zip: '919485' },
	{ city: 'Tinnahinch (Laois)', zip: '815987' },
	{ city: 'Tinnahinch (Wicklow)', zip: '616790' },
	{ city: 'Tinnahinchy (Tipperary)', zip: '853389' },
	{ city: 'Tinnakeenly (Kilkenny)', zip: '505060' },
	{ city: 'Tinnakill (Kildare)', zip: '206717' },
	{ city: 'Tinnakill (Laois)', zip: '276391' },
	{ city: 'Tinnakilla (Limerick)', zip: '558942' },
	{ city: 'Tinnakilla (Wexford)', zip: '972130' },
	{ city: 'Tinnakilly (Kilkenny)', zip: '539648' },
	{ city: 'Tinnakilly (Tipperary)', zip: '218362' },
	{ city: 'Tinnakilly Big (Kilkenny)', zip: '909808' },
	{ city: 'Tinnakilly Little (Kilkenny)', zip: '369160' },
	{ city: 'Tinnakilly Lower (Wicklow)', zip: '826161' },
	{ city: 'Tinnakilly Upper (Wicklow)', zip: '724576' },
	{ city: 'Tinnalintan (Kilkenny)', zip: '267748' },
	{ city: 'Tinnalyra (Waterford)', zip: '426213' },
	{ city: 'Tinnamoona (Kilkenny)', zip: '864608' },
	{ city: 'Tinnapark (Kilkenny)', zip: '952047' },
	{ city: 'Tinnapark Demesne (Wicklow)', zip: '953348' },
	{ city: 'Tinnaragh (Laois)', zip: '213307' },
	{ city: 'Tinnaraheen (Laois)', zip: '107676' },
	{ city: 'Tinnaranny (Kilkenny)', zip: '163279' },
	{ city: 'Tinnarath (Wexford)', zip: '703466' },
	{ city: 'Tinnascart (Cork)', zip: '529627' },
	{ city: 'Tinnascart (Waterford)', zip: '733362' },
	{ city: 'Tinnascarty (Kilkenny)', zip: '136982' },
	{ city: 'Tinnascolly (Kilkenny)', zip: '120471' },
	{ city: 'Tinnashinnagh (Wexford)', zip: '970182' },
	{ city: 'Tinnashrule (Wexford)', zip: '385294' },
	{ city: 'Tinnaslatty (Kilkenny)', zip: '188997' },
	{ city: 'Tinnasragh (Laois)', zip: '636786' },
	{ city: 'Tinnatarriff (Limerick)', zip: '171042' },
	{ city: 'Tinneel (Cork)', zip: '937087' },
	{ city: 'Tinneel (Laois)', zip: '762563' },
	{ city: 'Tinnehinch (Wicklow)', zip: '533047' },
	{ city: 'Tinnick (Wexford)', zip: '526687' },
	{ city: 'Tinnies Lower East (Kerry)', zip: '251114' },
	{ city: 'Tinnies Lower West (Kerry)', zip: '136884' },
	{ city: 'Tinnies Upper (Kerry)', zip: '529530' },
	{ city: 'Tinnock (Wexford)', zip: '504496' },
	{ city: 'Tinnock Lower (Wexford)', zip: '547051' },
	{ city: 'Tinnock Upper (Wexford)', zip: '191330' },
	{ city: 'Tinnybeg (Leitrim)', zip: '107364' },
	{ city: 'Tinnycahil (Donegal)', zip: '987356' },
	{ city: 'Tinnycross (Kildare)', zip: '277395' },
	{ city: 'Tinnynarr (Longford)', zip: '893603' },
	{ city: 'Tinock (Tipperary)', zip: '141312' },
	{ city: 'Tinode (Westmeath)', zip: '184619' },
	{ city: 'Tinode (Wicklow)', zip: '196387' },
	{ city: 'Tinoranhill North (Wicklow)', zip: '834992' },
	{ city: 'Tinoranhill South (Wicklow)', zip: '572912' },
	{ city: 'Tinraheen (Wexford)', zip: '386202' },
	{ city: 'Tinriland (Carlow)', zip: '483824' },
	{ city: 'Tinryland (Carlow)', zip: '218847' },
	{ city: 'Tintagh (Roscommon)', zip: '806409' },
	{ city: 'Tintern (Wexford)', zip: '928201' },
	{ city: 'Tinteskin (Wexford)', zip: '883745' },
	{ city: 'Tintine (Kilkenny)', zip: '629446' },
	{ city: 'Tintore (Laois)', zip: '776893' },
	{ city: 'Tintrim (Clare)', zip: '657007' },
	{ city: 'Tintur (Waterford)', zip: '952529' },
	{ city: 'Tinure (Louth)', zip: '888371' },
	{ city: 'Tinvane (Tipperary)', zip: '713794' },
	{ city: 'Tinvaucoosh (Kilkenny)', zip: '357108' },
	{ city: 'Tinvaun (Kilkenny)', zip: '568373' },
	{ city: 'Tinvoher (Tipperary)', zip: '580719' },
	{ city: 'Tinwear (Laois)', zip: '332174' },
	{ city: 'Tippeenan Lower (Kildare)', zip: '173878' },
	{ city: 'Tippeenan Upper (Kildare)', zip: '160454' },
	{ city: 'Tipper (Longford)', zip: '210986' },
	{ city: 'Tipperary (Tipperary)', zip: '182885' },
	{ city: 'Tipperaryhills (Tipperary)', zip: '864207' },
	{ city: 'Tipper East (Kildare)', zip: '132559' },
	{ city: 'Tipperkevin (Kildare)', zip: '525711' },
	{ city: 'Tipper North (Kildare)', zip: '153700' },
	{ city: 'Tipper South (Kildare)', zip: '102979' },
	{ city: 'Tipperstown (Dublin)', zip: '342398' },
	{ city: 'Tipperstown (Kildare)', zip: '106326' },
	{ city: 'Tipper West (Kildare)', zip: '886002' },
	{ city: 'Tirachorka (Meath)', zip: '449692' },
	{ city: 'Tiragarvan (Monaghan)', zip: '712679' },
	{ city: 'Tiraloughan (Galway)', zip: '596502' },
	{ city: 'Tiramoan (Monaghan)', zip: '334702' },
	{ city: 'Tiranascragh (Galway)', zip: '606006' },
	{ city: 'Tiraninny (Mayo)', zip: '145987' },
	{ city: 'Tirardan (Monaghan)', zip: '507815' },
	{ city: 'Tiraree (Sligo)', zip: '220602' },
	{ city: 'Tirargus (Donegal)', zip: '284128' },
	{ city: 'Tiratick (Sligo)', zip: '979520' },
	{ city: 'Tiraun (Mayo)', zip: '391914' },
	{ city: 'Tiravera (Monaghan)', zip: '443524' },
	{ city: 'Tiravray (Monaghan)', zip: '485271' },
	{ city: 'Tirawinnea (Meath)', zip: '469722' },
	{ city: 'Tirboy (Galway)', zip: '221854' },
	{ city: 'Tircahan (Cavan)', zip: '707547' },
	{ city: 'Tircallan (Donegal)', zip: '484751' },
	{ city: 'Tirconeen (Donegal)', zip: '167275' },
	{ city: 'Tirconnelbeg (Roscommon)', zip: '332985' },
	{ city: 'Tircooney (Monaghan)', zip: '924536' },
	{ city: 'Tircullen (Cavan)', zip: '878226' },
	{ city: 'Tircullen Lower (Waterford)', zip: '233599' },
	{ city: 'Tircullen Upper (Waterford)', zip: '270052' },
	{ city: 'Tiredigan (Monaghan)', zip: '777171' },
	{ city: 'Tireran (Monaghan)', zip: '239708' },
	{ city: 'Tirernan (Laois)', zip: '541923' },
	{ city: 'Tirevlin (Donegal)', zip: '553591' },
	{ city: 'Tirfinnog (Monaghan)', zip: '985608' },
	{ city: 'Tirgormly (Cavan)', zip: '449257' },
	{ city: 'Tirharon (Donegal)', zip: '144838' },
	{ city: 'Tirhogar (Laois)', zip: '731292' },
	{ city: 'Tirhomin (Donegal)', zip: '667198' },
	{ city: 'Tirinisk (Donegal)', zip: '127182' },
	{ city: 'Tirkeenan (Monaghan)', zip: '227065' },
	{ city: 'Tirkeeran (Donegal)', zip: '765370' },
	{ city: 'Tirkillin (Donegal)', zip: '972026' },
	{ city: 'Tirlahode Lower (Cavan)', zip: '854740' },
	{ city: 'Tirlahode Upper (Cavan)', zip: '857290' },
	{ city: 'Tirlaydan (Donegal)', zip: '156097' },
	{ city: 'Tirlickeen (Longford)', zip: '954328' },
	{ city: 'Tirliffin (Cavan)', zip: '756571' },
	{ city: 'Tirlin (Donegal)', zip: '822652' },
	{ city: 'Tirloughan (Donegal)', zip: '472097' },
	{ city: 'Tirmacmoe (Monaghan)', zip: '537766' },
	{ city: 'Tirmacroragh (Donegal)', zip: '696642' },
	{ city: 'Tirmactiernan (Leitrim)', zip: '885072' },
	{ city: 'Tirmadown (Monaghan)', zip: '409502' },
	{ city: 'Tirmoghan Common (Kildare)', zip: '727881' },
	{ city: 'Tirnadrola (Monaghan)', zip: '859608' },
	{ city: 'Tirnagushoge (Donegal)', zip: '866443' },
	{ city: 'Tirnahinch Far (Monaghan)', zip: '138852' },
	{ city: 'Tirnahinch Near (Monaghan)', zip: '394641' },
	{ city: 'Tirnamona (Monaghan)', zip: '441687' },
	{ city: 'Tirnanean (Cork)', zip: '563803' },
	{ city: 'Tirnaneill (Monaghan)', zip: '946472' },
	{ city: 'Tirnaskea North (Monaghan)', zip: '673401' },
	{ city: 'Tirnaskea South (Monaghan)', zip: '909465' },
	{ city: 'Tirnawannagh (Cavan)', zip: '678037' },
	{ city: 'Tirneevin (Galway)', zip: '387911' },
	{ city: 'Tiroe (Kilkenny)', zip: '615835' },
	{ city: 'Tiroe (Tipperary)', zip: '224337' },
	{ city: 'Tiromedan (Monaghan)', zip: '370764' },
	{ city: 'Tironeill (Donegal)', zip: '760976' },
	{ city: 'Tirourkan (Cavan)', zip: '320247' },
	{ city: 'Tirquin (Cavan)', zip: '470744' },
	{ city: 'Tirroddy (Donegal)', zip: '283842' },
	{ city: 'Tirrooaun (Galway)', zip: '114053' },
	{ city: 'Tirur (Galway)', zip: '148974' },
	{ city: 'Tiryrone (Donegal)', zip: '392101' },
	{ city: 'Tisaxon (Galway)', zip: '848543' },
	{ city: 'Tisaxon Beg (Cork)', zip: '461002' },
	{ city: 'Tisaxon More (Cork)', zip: '846043' },
	{ city: 'Titeskin (Cork)', zip: '960351' },
	{ city: 'Tithewer (Wicklow)', zip: '229914' },
	{ city: 'Tivannagh (Roscommon)', zip: '633264' },
	{ city: 'Toanreagh (Kerry)', zip: '284898' },
	{ city: 'Tobeen (Dublin)', zip: '878746' },
	{ city: 'Tober (Cork)', zip: '673774' },
	{ city: 'Tober (Donegal)', zip: '332180' },
	{ city: 'Tober (Kerry)', zip: '953900' },
	{ city: 'Tober (Longford)', zip: '510985' },
	{ city: 'Tober (Mayo)', zip: '445942' },
	{ city: 'Tober (Offaly)', zip: '555085' },
	{ city: 'Tober (Tipperary)', zip: '631354' },
	{ city: 'Tober (Waterford)', zip: '859473' },
	{ city: 'Tober (Westmeath)', zip: '487918' },
	{ city: 'Toberacreggaun (Galway)', zip: '856062' },
	{ city: 'Toberadora (Tipperary)', zip: '675072' },
	{ city: 'Toberagarriff (Limerick)', zip: '898891' },
	{ city: 'Toberagoole (Waterford)', zip: '507455' },
	{ city: 'Toberaheena (Tipperary)', zip: '749477' },
	{ city: 'Toberanania (Sligo)', zip: '606264' },
	{ city: 'Toberaneague (Cork)', zip: '960621' },
	{ city: 'Toberaniddaun (Clare)', zip: '369246' },
	{ city: 'Toberanierin Lower (Wexford)', zip: '377512' },
	{ city: 'Toberanierin Upper (Wexford)', zip: '913239' },
	{ city: 'Toberaquill (Westmeath)', zip: '339659' },
	{ city: 'Toberataravan (Roscommon)', zip: '130788' },
	{ city: 'Toberatooreen (Kerry)', zip: '257328' },
	{ city: 'Toberavaddy (Roscommon)', zip: '573122' },
	{ city: 'Toberaviller (Wicklow)', zip: '637418' },
	{ city: 'Toberawnaun (Sligo)', zip: '745783' },
	{ city: 'Toberbeg (Wexford)', zip: '201769' },
	{ city: 'Toberbeg (Wicklow)', zip: '181905' },
	{ city: 'Toberbiroge (Galway)', zip: '581703' },
	{ city: 'Toberboe (Laois)', zip: '861232' },
	{ city: 'Toberbrackan (Galway)', zip: '423040' },
	{ city: 'Toberbreedia (Kilkenny)', zip: '448605' },
	{ city: 'Toberbride (Carlow)', zip: '557937' },
	{ city: 'Toberbride (Sligo)', zip: '756793' },
	{ city: 'Toberbunny (Dublin)', zip: '643438' },
	{ city: 'Toberburr (Dublin)', zip: '448271' },
	{ city: 'Toberclare (Westmeath)', zip: '167028' },
	{ city: 'Tobercocka (Kildare)', zip: '272552' },
	{ city: 'Toberconnelly (Galway)', zip: '124052' },
	{ city: 'Toberconor (Roscommon)', zip: '491572' },
	{ city: 'Tobercormick (Westmeath)', zip: '374694' },
	{ city: 'Tobercrossaun (Galway)', zip: '381192' },
	{ city: 'Tobercurry (Sligo)', zip: '632681' },
	{ city: 'Toberdaly (Offaly)', zip: '307419' },
	{ city: 'Toberdan (Roscommon)', zip: '913593' },
	{ city: 'Tober Demesne (Wicklow)', zip: '427374' },
	{ city: 'Toberdoney (Louth)', zip: '467041' },
	{ city: 'Toberduff (Wexford)', zip: '771197' },
	{ city: 'Toberelva (Roscommon)', zip: '858343' },
	{ city: 'Toberfelim (Longford)', zip: '585427' },
	{ city: 'Toberfinnick (Wexford)', zip: '545737' },
	{ city: 'Tobergal (Wexford)', zip: '892599' },
	{ city: 'Tobergregan (Dublin)', zip: '664464' },
	{ city: 'Tobergrellan (Galway)', zip: '238245' },
	{ city: 'Toberiheen (Roscommon)', zip: '460350' },
	{ city: 'Toberjarlath (Galway)', zip: '420943' },
	{ city: 'Toberkeagh (Roscommon)', zip: '334462' },
	{ city: 'Toberkeen (Donegal)', zip: '909865' },
	{ city: 'Toberleheen (Offaly)', zip: '843299' },
	{ city: 'Toberlomina (Wexford)', zip: '176255' },
	{ city: 'Tober Lower (Wicklow)', zip: '397724' },
	{ city: 'Toberlownagh (Wicklow)', zip: '815377' },
	{ city: 'Toberlyan (Cavan)', zip: '136881' },
	{ city: 'Toberlyan Duffin (Cavan)', zip: '600773' },
	{ city: 'Tobermacloughlin (Roscommon)', zip: '598557' },
	{ city: 'Tobermaclugg (Dublin)', zip: '689679' },
	{ city: 'Tobermaing (Kerry)', zip: '987176' },
	{ city: 'Tobermakee (Roscommon)', zip: '179741' },
	{ city: 'Tobermalug (Limerick)', zip: '687970' },
	{ city: 'Tobermina (Galway)', zip: '398684' },
	{ city: 'Tobermore (Mayo)', zip: '313131' },
	{ city: 'Tobermurry (Limerick)', zip: '732272' },
	{ city: 'Tobernabrone (Kilkenny)', zip: '824368' },
	{ city: 'Tobernaclug (Galway)', zip: '337082' },
	{ city: 'Tobernadarry (Mayo)', zip: '745815' },
	{ city: 'Tobernagat (Clare)', zip: '994456' },
	{ city: 'Tobernagauhoge (Westmeath)', zip: '486521' },
	{ city: 'Tobernaglashy (Sligo)', zip: '969645' },
	{ city: 'Tobernahoory (Donegal)', zip: '778709' },
	{ city: 'Tobernahulla (Waterford)', zip: '869957' },
	{ city: 'Tobernamoodane (Kerry)', zip: '674216' },
	{ city: 'Tobernapeastia (Kilkenny)', zip: '371375' },
	{ city: 'Tobernashee (Mayo)', zip: '563860' },
	{ city: 'Tobernavean (Galway)', zip: '529385' },
	{ city: 'Tobernaveen (Mayo)', zip: '466001' },
	{ city: 'Tobernaveen (Sligo)', zip: '102449' },
	{ city: 'Tobernea (Limerick)', zip: '456798' },
	{ city: 'Tobernea East (Limerick)', zip: '412096' },
	{ city: 'Tobernea Middle (Limerick)', zip: '624205' },
	{ city: 'Tobernea West (Limerick)', zip: '494017' },
	{ city: 'Toberogan (Kildare)', zip: '619833' },
	{ city: 'Toberona (Wexford)', zip: '377045' },
	{ city: 'Toberoneill (Donegal)', zip: '940187' },
	{ city: 'Toberpatrick (Roscommon)', zip: '379759' },
	{ city: 'Toberpatrick (Sligo)', zip: '783777' },
	{ city: 'Toberpatrick (Wicklow)', zip: '324173' },
	{ city: 'Toberreeoge (Roscommon)', zip: '185868' },
	{ city: 'Toberroddy (Sligo)', zip: '357990' },
	{ city: 'Toberroe (Galway)', zip: '624497' },
	{ city: 'Toberroe East (Galway)', zip: '920051' },
	{ city: 'Toberroe West (Galway)', zip: '537435' },
	{ city: 'Toberronan (Offaly)', zip: '645612' },
	{ city: 'Toberrooaun (Mayo)', zip: '232230' },
	{ city: 'Toberrory (Roscommon)', zip: '309146' },
	{ city: 'Toberscardan (Sligo)', zip: '547849' },
	{ city: 'Toberslane (Donegal)', zip: '286660' },
	{ city: 'Tobersool (Dublin)', zip: '815698' },
	{ city: 'Tobertaskin (Dublin)', zip: '618723' },
	{ city: 'Tobertelly (Sligo)', zip: '885246' },
	{ city: 'Toberton (Kildare)', zip: '776616' },
	{ city: 'Tobertown (Dublin)', zip: '689277' },
	{ city: 'Tobertynan (Meath)', zip: '385077' },
	{ city: 'Toberultan (Meath)', zip: '862816' },
	{ city: 'Tober Upper (Wicklow)', zip: '254862' },
	{ city: 'Toberyquin (Limerick)', zip: '764285' },
	{ city: 'Tobinsgarden (Tipperary)', zip: '312597' },
	{ city: 'Tobinstown (Carlow)', zip: '961035' },
	{ city: 'Tobinstown (Galway)', zip: '598835' },
	{ city: 'Toehead (Cork)', zip: '794202' },
	{ city: 'Toem (Tipperary)', zip: '410497' },
	{ city: 'Togan (Monaghan)', zip: '428400' },
	{ city: 'Togher (Cavan)', zip: '194780' },
	{ city: 'Togher (Cork)', zip: '924988' },
	{ city: 'Togher (Laois)', zip: '560354' },
	{ city: 'Togher (Louth)', zip: '479724' },
	{ city: 'Togher (Mayo)', zip: '784220' },
	{ city: 'Togher (Offaly)', zip: '264001' },
	{ city: 'Togher (Roscommon)', zip: '253438' },
	{ city: 'Togher (Tipperary)', zip: '681045' },
	{ city: 'Togher (Westmeath)', zip: '302374' },
	{ city: 'Togher (Wicklow)', zip: '215286' },
	{ city: 'Togherbane (Kerry)', zip: '307036' },
	{ city: 'Togher Beg (Galway)', zip: '646021' },
	{ city: 'Togher Beg (Wicklow)', zip: '214890' },
	{ city: 'Toghereen (Kildare)', zip: '423505' },
	{ city: 'Toghergar (Galway)', zip: '291040' },
	{ city: 'Togher More (Galway)', zip: '116790' },
	{ city: 'Togher More (Wicklow)', zip: '812121' },
	{ city: 'Toghernaross (Cavan)', zip: '917964' },
	{ city: 'Togherorymore (Kildare)', zip: '156268' },
	{ city: 'Togherstown (Westmeath)', zip: '237365' },
	{ city: 'Tomacork (Wicklow)', zip: '606289' },
	{ city: 'Tomacurry (Wexford)', zip: '788894' },
	{ city: 'Tomadilly (Wexford)', zip: '354971' },
	{ city: 'Tomagaddy (Wexford)', zip: '820622' },
	{ city: 'Tomagaddy Little (Wexford)', zip: '398434' },
	{ city: 'Tomakeany (Kilkenny)', zip: '856939' },
	{ city: 'Tomanierin Lower (Wicklow)', zip: '105597' },
	{ city: 'Tomanierin Upper (Wicklow)', zip: '312116' },
	{ city: 'Tomanine (Wexford)', zip: '528253' },
	{ city: 'Tomanoole (Wexford)', zip: '288524' },
	{ city: 'Tomany (Monaghan)', zip: '607033' },
	{ city: 'Tomany Beg (Galway)', zip: '757777' },
	{ city: 'Tomany More (Galway)', zip: '451526' },
	{ city: 'Tomanynambraher (Galway)', zip: '508760' },
	{ city: 'Tomard (Kildare)', zip: '262540' },
	{ city: 'Tomard Lower (Carlow)', zip: '707019' },
	{ city: 'Tomard Upper (Carlow)', zip: '462352' },
	{ city: 'Tomascotha (Kilkenny)', zip: '258519' },
	{ city: 'Tomassan (Cavan)', zip: '234347' },
	{ city: 'Tomatee (Wexford)', zip: '865114' },
	{ city: 'Tomathone Lower (Wexford)', zip: '976355' },
	{ city: 'Tomathone Upper (Wexford)', zip: '880907' },
	{ city: 'Tombay (Wexford)', zip: '408643' },
	{ city: 'Tombeagh (Carlow)', zip: '232645' },
	{ city: 'Tomboholla (Mayo)', zip: '726475' },
	{ city: 'Tombrack (Wexford)', zip: '332563' },
	{ city: 'Tombrackwood (Wexford)', zip: '252011' },
	{ city: 'Tombreen (Wicklow)', zip: '550217' },
	{ city: 'Tombrick (Wexford)', zip: '581365' },
	{ city: 'Tombrickane (Tipperary)', zip: '370570' },
	{ city: 'Tomcool (Wexford)', zip: '838427' },
	{ city: 'Tomcool Big (Wexford)', zip: '446561' },
	{ city: 'Tomcool Little (Wexford)', zip: '937985' },
	{ city: 'Tomcoyle (Wexford)', zip: '260111' },
	{ city: 'Tomcoyle (Wicklow)', zip: '990579' },
	{ city: 'Tomcoylehill (Wexford)', zip: '821888' },
	{ city: 'Tomcoyle Lower (Wicklow)', zip: '153552' },
	{ city: 'Tomcoyle Upper (Wicklow)', zip: '644730' },
	{ city: 'Tomdarragh (Wicklow)', zip: '239659' },
	{ city: 'Tomdeely North (Limerick)', zip: '810372' },
	{ city: 'Tomdeely South (Limerick)', zip: '949172' },
	{ city: 'Tomduff (Carlow)', zip: '126651' },
	{ city: 'Tomduff (Wexford)', zip: '464899' },
	{ city: 'Tome (Clare)', zip: '723024' },
	{ city: 'Tomfarney (Wexford)', zip: '986436' },
	{ city: 'Tomfarney Lower (Wexford)', zip: '982430' },
	{ city: 'Tomfarney Upper (Wexford)', zip: '639149' },
	{ city: 'Tomgar (Wexford)', zip: '882397' },
	{ city: 'Tomgarrow (Wexford)', zip: '567591' },
	{ city: 'Tomgraney (Clare)', zip: '896825' },
	{ city: 'Tomhaggard (Wexford)', zip: '784419' },
	{ city: 'Tomies East (Kerry)', zip: '328667' },
	{ city: 'Tomies West (Kerry)', zip: '178973' },
	{ city: 'Tomies Wood (Kerry)', zip: '903773' },
	{ city: 'Tominearly (Wexford)', zip: '203355' },
	{ city: 'Tomiska (Monaghan)', zip: '558201' },
	{ city: 'Tomisky (Longford)', zip: '126857' },
	{ city: 'Tomkinroad (Cavan)', zip: '183090' },
	{ city: 'Tomlane (Wexford)', zip: '845560' },
	{ city: 'Tomloskan (Leitrim)', zip: '233856' },
	{ city: 'Tommyscroft (Donegal)', zip: '401940' },
	{ city: 'Tomnaboley Lower (Wexford)', zip: '856969' },
	{ city: 'Tomnaboley Upper (Wexford)', zip: '114999' },
	{ city: 'Tomnafinnoge (Wicklow)', zip: '897501' },
	{ city: 'Tomnafunshoge (Wexford)', zip: '298760' },
	{ city: 'Tomnahaha (Kilkenny)', zip: '547668' },
	{ city: 'Tomnahealy (Wexford)', zip: '157070' },
	{ city: 'Tomnahealy Little (Wexford)', zip: '305949' },
	{ city: 'Tomnahulla (Galway)', zip: '540156' },
	{ city: 'Tomnakippeen (Wexford)', zip: '108367' },
	{ city: 'Tomnalossett (Wexford)', zip: '247830' },
	{ city: 'Tomnamuck (Wexford)', zip: '593158' },
	{ city: 'Tomnaskela (Wicklow)', zip: '642558' },
	{ city: 'Tomnaslough (Carlow)', zip: '216517' },
	{ city: 'Tomnasock (Carlow)', zip: '466688' },
	{ city: 'Tomoclavin (Laois)', zip: '933658' },
	{ city: 'Tomogrow (Monaghan)', zip: '845024' },
	{ city: 'Tomona (Tipperary)', zip: '565725' },
	{ city: 'Tomona (Wexford)', zip: '848990' },
	{ city: 'Tomree (Galway)', zip: '475639' },
	{ city: 'Tomriland (Wicklow)', zip: '831503' },
	{ city: 'Tomrud (Leitrim)', zip: '649680' },
	{ city: 'Tomsallagh (Wexford)', zip: '390443' },
	{ city: 'Tomsilla Lower (Wexford)', zip: '712187' },
	{ city: 'Tomsilla Upper (Wexford)', zip: '688856' },
	{ city: 'Tonabrocky (Galway)', zip: '598561' },
	{ city: 'Tonabuska (Cork)', zip: '474384' },
	{ city: 'Tonacartron (Mayo)', zip: '852527' },
	{ city: 'Tonacooleen (Galway)', zip: '472096' },
	{ city: 'Tonacrick (Galway)', zip: '928516' },
	{ city: 'Tonacrock (Mayo)', zip: '949980' },
	{ city: 'Tonacurra (Galway)', zip: '763308' },
	{ city: 'Tonacurragh (Galway)', zip: '647465' },
	{ city: 'Tonaderrew (Mayo)', zip: '982305' },
	{ city: 'Tonadooravaun (Galway)', zip: '172695' },
	{ city: 'Tonafarna (Laois)', zip: '939287' },
	{ city: 'Tonafora (Cork)', zip: '146978' },
	{ city: 'Tonafortes (Sligo)', zip: '789280' },
	{ city: 'Tonagarraun (Galway)', zip: '712077' },
	{ city: 'Tonagh (Cavan)', zip: '213669' },
	{ city: 'Tonagh (Donegal)', zip: '744793' },
	{ city: 'Tonagh (Monaghan)', zip: '732942' },
	{ city: 'Tonagh (Offaly)', zip: '787768' },
	{ city: 'Tonagh (Westmeath)', zip: '336575' },
	{ city: 'Tonaghbane (Cavan)', zip: '637139' },
	{ city: 'Tonagimsy (Monaghan)', zip: '521280' },
	{ city: 'Tonaglanna (Mayo)', zip: '337411' },
	{ city: 'Tonakilly (Kerry)', zip: '489904' },
	{ city: 'Tonaknick (Roscommon)', zip: '295216' },
	{ city: 'Tonaknock (Kerry)', zip: '341678' },
	{ city: 'Tonaleeaun (Mayo)', zip: '198079' },
	{ city: 'Tonalig (Roscommon)', zip: '338831' },
	{ city: 'Tonaloy (Cavan)', zip: '352761' },
	{ city: 'Tonamace (Galway)', zip: '642060' },
	{ city: 'Tonamace (Mayo)', zip: '855853' },
	{ city: 'Tonamace Common (Mayo)', zip: '539723' },
	{ city: 'Tonamaddy (Roscommon)', zip: '284562' },
	{ city: 'Tonaneeve (Monaghan)', zip: '521602' },
	{ city: 'Tonanilt (Cavan)', zip: '631689' },
	{ city: 'Tonaphort (Westmeath)', zip: '963053' },
	{ city: 'Tonaphubble (Sligo)', zip: '463379' },
	{ city: 'Tonaponra (Sligo)', zip: '119834' },
	{ city: 'Tonaraha East (Mayo)', zip: '345272' },
	{ city: 'Tonaraha West (Mayo)', zip: '979766' },
	{ city: 'Tonaree (Limerick)', zip: '664140' },
	{ city: 'Tonaroasty (Galway)', zip: '761965' },
	{ city: 'Tonarussa (Clare)', zip: '902891' },
	{ city: 'Tonashammer (Westmeath)', zip: '109307' },
	{ city: 'Tonatanvally (Mayo)', zip: '394659' },
	{ city: 'Tonatleva (Mayo)', zip: '382341' },
	{ city: 'Tonavane (Kerry)', zip: '946101' },
	{ city: 'Tonavoher (Clare)', zip: '996974' },
	{ city: 'Tonbane Glebe (Donegal)', zip: '681732' },
	{ city: 'Tonbaun (Galway)', zip: '499612' },
	{ city: 'Tonbaun (Limerick)', zip: '784818' },
	{ city: 'Tonbaun (Mayo)', zip: '151268' },
	{ city: 'Tonbaun (Roscommon)', zip: '211208' },
	{ city: 'Tonbwee (Kerry)', zip: '150000' },
	{ city: 'Tonduff (Donegal)', zip: '182231' },
	{ city: 'Tonduff (Laois)', zip: '525517' },
	{ city: 'Toneagh (Cork)', zip: '793756' },
	{ city: 'Toneen (Longford)', zip: '315459' },
	{ city: 'Tonereagh (Roscommon)', zip: '255000' },
	{ city: 'Tonintlieve (Monaghan)', zip: '753121' },
	{ city: 'Toniscoffy (Monaghan)', zip: '161347' },
	{ city: 'Tonlegee (Cavan)', zip: '101209' },
	{ city: 'Tonlegee (Clare)', zip: '150276' },
	{ city: 'Tonlegee (Dublin)', zip: '426634' },
	{ city: 'Tonlegee (Galway)', zip: '902990' },
	{ city: 'Tonlegee (Kildare)', zip: '272746' },
	{ city: 'Tonlegee (Leitrim)', zip: '209302' },
	{ city: 'Tonlegee (Limerick)', zip: '744537' },
	{ city: 'Tonlegee (Mayo)', zip: '714994' },
	{ city: 'Tonlegee (Roscommon)', zip: '786230' },
	{ city: 'Tonlegee (Westmeath)', zip: '757466' },
	{ city: 'Tonlegee (Wicklow)', zip: '696725' },
	{ city: 'Tonlemone (Offaly)', zip: '328606' },
	{ city: 'Tonlemone (Roscommon)', zip: '506032' },
	{ city: 'Tonlemony (Westmeath)', zip: '828611' },
	{ city: 'Tonmore (Mayo)', zip: '879598' },
	{ city: 'Tonmoyle (Galway)', zip: '141637' },
	{ city: 'Tonnagh (Leitrim)', zip: '614143' },
	{ city: 'Tonnagh (Mayo)', zip: '303051' },
	{ city: 'Tonnagh (Monaghan)', zip: '299466' },
	{ city: 'Tonranny (Galway)', zip: '218387' },
	{ city: 'Tonranny (Mayo)', zip: '291867' },
	{ city: 'Tonranny Mountain (Galway)', zip: '485729' },
	{ city: 'Tonreagh (Kerry)', zip: '829448' },
	{ city: 'Tonreagh Lower (Kerry)', zip: '871875' },
	{ city: 'Tonreagh Upper (Kerry)', zip: '511101' },
	{ city: 'Tonree (Mayo)', zip: '175439' },
	{ city: 'Tonregee (Donegal)', zip: '377320' },
	{ city: 'Tonregee (Mayo)', zip: '145133' },
	{ city: 'Tonregee (Roscommon)', zip: '502920' },
	{ city: 'Tonregee East (Mayo)', zip: '232924' },
	{ city: 'Tonregee West (Mayo)', zip: '218003' },
	{ city: 'Tonrevagh (Galway)', zip: '376983' },
	{ city: 'Tonrevagh (Roscommon)', zip: '906121' },
	{ city: 'Tonroe (Galway)', zip: '261916' },
	{ city: 'Tonroe (Mayo)', zip: '704462' },
	{ city: 'Tonroe (Roscommon)', zip: '795927' },
	{ city: 'Tonroe Lower (Mayo)', zip: '643153' },
	{ city: 'Tonroe Upper (Mayo)', zip: '960431' },
	{ city: 'Tonteeheige (Waterford)', zip: '671716' },
	{ city: 'Tonteere (Limerick)', zip: '361631' },
	{ city: 'Tonvey (Roscommon)', zip: '989882' },
	{ city: 'Tonwee (Galway)', zip: '783270' },
	{ city: 'Tonweeroe (Galway)', zip: '406600' },
	{ city: 'Tonyarraher (Cavan)', zip: '820752' },
	{ city: 'Tonybaun (Mayo)', zip: '231990' },
	{ city: 'Tonyclea (Monaghan)', zip: '210908' },
	{ city: 'Tonyconnelly (Cavan)', zip: '619470' },
	{ city: 'Tonycoogan (Monaghan)', zip: '967207' },
	{ city: 'Tonycurneen (Roscommon)', zip: '991153' },
	{ city: 'Tonyduff (Cavan)', zip: '219273' },
	{ city: 'Tonyellida (Monaghan)', zip: '789254' },
	{ city: 'Tonyfinnigan (Monaghan)', zip: '224535' },
	{ city: 'Tonyfohanan (Monaghan)', zip: '436095' },
	{ city: 'Tonyfoyle (Cavan)', zip: '232572' },
	{ city: 'Tonygarrow (Wicklow)', zip: '306836' },
	{ city: 'Tonygarvey (Monaghan)', zip: '229141' },
	{ city: 'Tonyglassan (Monaghan)', zip: '292407' },
	{ city: 'Tonyhabboc (Donegal)', zip: '663977' },
	{ city: 'Tonyhallagh (Cavan)', zip: '782977' },
	{ city: 'Tonyhamigan (Monaghan)', zip: '966579' },
	{ city: 'Tonyhull (Cavan)', zip: '900132' },
	{ city: 'Tonyin (Cavan)', zip: '407720' },
	{ city: 'Tonylion (Cavan)', zip: '194538' },
	{ city: 'Tonymacgilduff (Cavan)', zip: '483345' },
	{ city: 'Tonymore (Cavan)', zip: '764643' },
	{ city: 'Tonymore North (Longford)', zip: '982872' },
	{ city: 'Tonymore South (Longford)', zip: '292314' },
	{ city: 'Tonynumery (Monaghan)', zip: '582014' },
	{ city: 'Tonyowen Lower (Westmeath)', zip: '602690' },
	{ city: 'Tonyowen Upper (Westmeath)', zip: '494198' },
	{ city: 'Tonyquin (Cavan)', zip: '474131' },
	{ city: 'Tonyrevan (Cavan)', zip: '858850' },
	{ city: 'Tonyscallan (Monaghan)', zip: '810078' },
	{ city: 'Tonyshandeny (Monaghan)', zip: '476612' },
	{ city: 'Tonysillogagh (Monaghan)', zip: '948960' },
	{ city: 'Tonystackan (Monaghan)', zip: '697553' },
	{ city: 'Tonytallagh (Monaghan)', zip: '952225' },
	{ city: 'Tonywardan (Longford)', zip: '290197' },
	{ city: 'Tooa (Monaghan)', zip: '476940' },
	{ city: 'Toobrackan (Roscommon)', zip: '360559' },
	{ city: 'Toocananagh (Mayo)', zip: '892617' },
	{ city: 'Toohana (Kerry)', zip: '262311' },
	{ city: 'Toolestown (Kildare)', zip: '959742' },
	{ city: 'Toolestown (Wicklow)', zip: '379261' },
	{ city: 'Tooloobaunbeg (Galway)', zip: '272313' },
	{ city: 'Tooloobauntemple (Galway)', zip: '432750' },
	{ city: 'Tooloone (Tipperary)', zip: '380524' },
	{ city: 'Tooloscan (Roscommon)', zip: '828609' },
	{ city: 'Toom (Cork)', zip: '929075' },
	{ city: 'Toom (Wexford)', zip: '566069' },
	{ city: 'Tooma (Leitrim)', zip: '474644' },
	{ city: 'Toomaline Lower (Limerick)', zip: '698675' },
	{ city: 'Toomaline Upper (Limerick)', zip: '439111' },
	{ city: 'Tooman (Dublin)', zip: '594839' },
	{ city: 'Tooman (Leitrim)', zip: '507769' },
	{ city: 'Tooman (Wicklow)', zip: '281520' },
	{ city: 'Toomanagh (Roscommon)', zip: '414759' },
	{ city: 'Toomans (Leitrim)', zip: '962769' },
	{ city: 'Toomard (Galway)', zip: '707077' },
	{ city: 'Toombeola (Galway)', zip: '286144' },
	{ city: 'Toome (Donegal)', zip: '753302' },
	{ city: 'Toome (Leitrim)', zip: '541841' },
	{ city: 'Toome (Longford)', zip: '790551' },
	{ city: 'Toome (Monaghan)', zip: '210817' },
	{ city: 'Toomes (Louth)', zip: '646854' },
	{ city: 'Toomona (Roscommon)', zip: '579243' },
	{ city: 'Toomore (Mayo)', zip: '443841' },
	{ city: 'Toomore (Roscommon)', zip: '274932' },
	{ city: 'Toomour (Sligo)', zip: '644119' },
	{ city: 'Tooms (Cork)', zip: '688482' },
	{ city: 'Toomsbog (Cork)', zip: '805394' },
	{ city: 'Tooms East (Cork)', zip: '927069' },
	{ city: 'Tooms West (Cork)', zip: '288632' },
	{ city: 'Toomullin (Clare)', zip: '641987' },
	{ city: 'Toomyvara (Tipperary)', zip: '229328' },
	{ city: 'Toon (Kerry)', zip: '566838' },
	{ city: 'Toonagh (Clare)', zip: '141811' },
	{ city: 'Toonagh Commons (Clare)', zip: '270594' },
	{ city: 'Toonlane (Cork)', zip: '238665' },
	{ city: 'Toor (Clare)', zip: '381716' },
	{ city: 'Toor (Cork)', zip: '669436' },
	{ city: 'Toor (Kerry)', zip: '234533' },
	{ city: 'Toor (Limerick)', zip: '256749' },
	{ city: 'Toor (Meath)', zip: '409162' },
	{ city: 'Toor (Tipperary)', zip: '963603' },
	{ city: 'Toor (Waterford)', zip: '553421' },
	{ city: 'Toor (Wicklow)', zip: '569892' },
	{ city: 'Toora (Offaly)', zip: '237225' },
	{ city: 'Tooracappul (Mayo)', zip: '154780' },
	{ city: 'Tooracladane (Kerry)', zip: '675679' },
	{ city: 'Tooracurragh (Waterford)', zip: '340998' },
	{ city: 'Tooradoo (Limerick)', zip: '857849' },
	{ city: 'Tooradoo (Waterford)', zip: '681579' },
	{ city: 'Toorala (Waterford)', zip: '641113' },
	{ city: 'Tooraleagan (Limerick)', zip: '643133' },
	{ city: 'Tooranaraheen (Waterford)', zip: '413706' },
	{ city: 'Tooraneena (Waterford)', zip: '822893' },
	{ city: 'Toorard (Cork)', zip: '789080' },
	{ city: 'Toorard (Mayo)', zip: '192243' },
	{ city: 'Toorard (Sligo)', zip: '797775' },
	{ city: 'Tooraree (Mayo)', zip: '121298' },
	{ city: 'Tooraree Lower (Limerick)', zip: '646035' },
	{ city: 'Tooraree Upper (Limerick)', zip: '527832' },
	{ city: 'Tooraskeheen (Galway)', zip: '279229' },
	{ city: 'Toorataggart (Tipperary)', zip: '292342' },
	{ city: 'Toorbeg (Westmeath)', zip: '526389' },
	{ city: 'Toor Beg (Kilkenny)', zip: '938725' },
	{ city: 'Toor Beg (Tipperary)', zip: '786350' },
	{ city: 'Toorboney (Cork)', zip: '974825' },
	{ city: 'Toorboy (Sligo)', zip: '436103' },
	{ city: 'Toorboy (Wicklow)', zip: '182989' },
	{ city: 'Toorbuck (Mayo)', zip: '728520' },
	{ city: 'Toorclogher (Galway)', zip: '395257' },
	{ city: 'Toorcoffey (Westmeath)', zip: '113239' },
	{ city: 'Toor Commons (Westmeath)', zip: '921103' },
	{ city: 'Tooreagh (Laois)', zip: '881826' },
	{ city: 'Tooreagh (Tipperary)', zip: '535851' },
	{ city: 'Tooree (Galway)', zip: '557774' },
	{ city: 'Tooreen (Clare)', zip: '978258' },
	{ city: 'Tooreen (Cork)', zip: '991080' },
	{ city: 'Tooreen (Galway)', zip: '789805' },
	{ city: 'Tooreen (Kerry)', zip: '570174' },
	{ city: 'Tooreen (Limerick)', zip: '489475' },
	{ city: 'Tooreen (Mayo)', zip: '716638' },
	{ city: 'Tooreen (Offaly)', zip: '339486' },
	{ city: 'Tooreen (Roscommon)', zip: '312640' },
	{ city: 'Tooreen (Tipperary)', zip: '707416' },
	{ city: 'Tooreena (Galway)', zip: '827753' },
	{ city: 'Tooreenacoona (Galway)', zip: '556512' },
	{ city: 'Tooreenagowan (Kerry)', zip: '273896' },
	{ city: 'Tooreenalour (Cork)', zip: '219202' },
	{ city: 'Tooreenard (Galway)', zip: '737499' },
	{ city: 'Tooreenard (Kerry)', zip: '635676' },
	{ city: 'Tooreenavuscaun (Cork)', zip: '462704' },
	{ city: 'Tooreenbane (Cork)', zip: '872622' },
	{ city: 'Tooreen Beg (Cork)', zip: '819796' },
	{ city: 'Tooreenbreanla (Kerry)', zip: '874700' },
	{ city: 'Tooreenbrien Lower (Tipperary)', zip: '920560' },
	{ city: 'Tooreenbrien Upper (Tipperary)', zip: '756745' },
	{ city: 'Tooreencahill (Kerry)', zip: '225397' },
	{ city: 'Tooreenclassagh (Cork)', zip: '456225' },
	{ city: 'Tooreencormack (Cork)', zip: '491123' },
	{ city: 'Tooreencullinagh (Tipperary)', zip: '866477' },
	{ city: 'Tooreendermot (Cork)', zip: '830450' },
	{ city: 'Tooreendonnell (Limerick)', zip: '298352' },
	{ city: 'Tooreen Donnell (Cork)', zip: '681963' },
	{ city: 'Tooreenduff (Cork)', zip: '402111' },
	{ city: 'Tooreenealagh (Kerry)', zip: '901739' },
	{ city: 'Tooreen East (Clare)', zip: '552701' },
	{ city: 'Tooreen East (Galway)', zip: '700499' },
	{ city: 'Tooreen East (Waterford)', zip: '787088' },
	{ city: 'Tooreenfineen (Cork)', zip: '573329' },
	{ city: 'Tooreengarriv (Kerry)', zip: '465994' },
	{ city: 'Tooreenglanahee (Cork)', zip: '966983' },
	{ city: 'Tooreenlahard (Cork)', zip: '798806' },
	{ city: 'Tooreenmacauliffe (Cork)', zip: '350133' },
	{ city: 'Tooreenmore (Kerry)', zip: '407474' },
	{ city: 'Tooreen More East (Cork)', zip: '586771' },
	{ city: 'Tooreen More West (Cork)', zip: '329357' },
	{ city: 'Tooreenmountain (Waterford)', zip: '504298' },
	{ city: 'Tooreennablauha (Kerry)', zip: '457395' },
	{ city: 'Tooreennafersha (Kerry)', zip: '697011' },
	{ city: 'Tooreennagreana (Limerick)', zip: '957312' },
	{ city: 'Tooreennagrena (Cork)', zip: '871286' },
	{ city: 'Tooreennaguppoge (Cork)', zip: '551277' },
	{ city: 'Tooreennahone (Kerry)', zip: '551844' },
	{ city: 'Tooreennamire (Cork)', zip: '166746' },
	{ city: 'Tooreennamult (Kerry)', zip: '228568' },
	{ city: 'Tooreennanean (Cork)', zip: '824697' },
	{ city: 'Tooreennascarty (Kerry)', zip: '311404' },
	{ city: 'Tooreennasillane (Cork)', zip: '206756' },
	{ city: 'Tooreennasliggaun (Kerry)', zip: '853847' },
	{ city: 'Tooreennastooka (Kerry)', zip: '601828' },
	{ city: 'Tooreen North (Cork)', zip: '504900' },
	{ city: 'Tooreen North (Galway)', zip: '896717' },
	{ city: 'Tooreenphilip (Mayo)', zip: '227210' },
	{ city: 'Tooreenreaghy (Cork)', zip: '978552' },
	{ city: 'Tooreens (Kerry)', zip: '445353' },
	{ city: 'Tooreen South (Cork)', zip: '756341' },
	{ city: 'Tooreen South (Galway)', zip: '827402' },
	{ city: 'Tooreen West (Clare)', zip: '625394' },
	{ city: 'Tooreen West (Galway)', zip: '885915' },
	{ city: 'Tooreen West (Waterford)', zip: '537949' },
	{ city: 'Tooreeny (Galway)', zip: '483667' },
	{ city: 'Tooreenyduneen (Kerry)', zip: '871654' },
	{ city: 'Tooreigh (Tipperary)', zip: '830983' },
	{ city: 'Toorevagh (Westmeath)', zip: '102521' },
	{ city: 'Toorfelim (Westmeath)', zip: '385634' },
	{ city: 'Toorfiba (Tipperary)', zip: '842119' },
	{ city: 'Toorfin (Longford)', zip: '629365' },
	{ city: 'Toorfune (Tipperary)', zip: '592349' },
	{ city: 'Toorgarriff (Cork)', zip: '160013' },
	{ city: 'Toorgarve (Mayo)', zip: '683456' },
	{ city: 'Toorglass (Mayo)', zip: '568511' },
	{ city: 'Toorkeel (Galway)', zip: '648594' },
	{ city: 'Toorleitra (Galway)', zip: '770225' },
	{ city: 'Toorlestraun (Sligo)', zip: '399230' },
	{ city: 'Toorlisnamore (Westmeath)', zip: '144678' },
	{ city: 'Toorloggagh (Galway)', zip: '112348' },
	{ city: 'Toorlougher (Limerick)', zip: '557871' },
	{ city: 'Toormacleane (Galway)', zip: '591286' },
	{ city: 'Toormacnevin (Galway)', zip: '865161' },
	{ city: 'Toormakeady (Mayo)', zip: '837809' },
	{ city: 'Toormakeady East (Mayo)', zip: '511039' },
	{ city: 'Toormakeady Mountain (Mayo)', zip: '386851' },
	{ city: 'Toormakeady West (Mayo)', zip: '759739' },
	{ city: 'Toormore (Clare)', zip: '799698' },
	{ city: 'Toormore (Cork)', zip: '467887' },
	{ city: 'Toormore (Galway)', zip: '791445' },
	{ city: 'Toormore (Kerry)', zip: '387864' },
	{ city: 'Toormore (Roscommon)', zip: '134901' },
	{ city: 'Toor More (Kilkenny)', zip: '475437' },
	{ city: 'Toor More (Tipperary)', zip: '546275' },
	{ city: 'Toormore East (Mayo)', zip: '146420' },
	{ city: 'Toormore West (Mayo)', zip: '272293' },
	{ city: 'Toornafolla (Meath)', zip: '161143' },
	{ city: 'Toornafulla (Limerick)', zip: '850825' },
	{ city: 'Toornageeha (Waterford)', zip: '800702' },
	{ city: 'Toornageehy (Kerry)', zip: '166190' },
	{ city: 'Toornagoppoge (Waterford)', zip: '648886' },
	{ city: 'Toornahooan (Clare)', zip: '563802' },
	{ city: 'Toornamongan (Kilkenny)', zip: '316375' },
	{ city: 'Toornanaunagh (Kerry)', zip: '260377' },
	{ city: 'Toornaneaskagh (Kerry)', zip: '664628' },
	{ city: 'Toornanoulagh (Kerry)', zip: '959739' },
	{ city: 'Toor North (Waterford)', zip: '449351' },
	{ city: 'Tooromin (Mayo)', zip: '882289' },
	{ city: 'Toorreagh (Cork)', zip: '516946' },
	{ city: 'Toorreagh (Waterford)', zip: '442855' },
	{ city: 'Toorsaleen (Kerry)', zip: '684478' },
	{ city: 'Toorsmuttaun (Galway)', zip: '755412' },
	{ city: 'Toor South (Waterford)', zip: '165290' },
	{ city: 'Toortane (Kilkenny)', zip: '771270' },
	{ city: 'Toortane (Waterford)', zip: '986010' },
	{ city: 'Toortaun (Laois)', zip: '858545' },
	{ city: 'Toorydonnellan (Westmeath)', zip: '738970' },
	{ city: 'Toorymartin (Roscommon)', zip: '158288' },
	{ city: 'Tooslenagh (Donegal)', zip: '467171' },
	{ city: 'Tootagh (Mayo)', zip: '912901' },
	{ city: 'Tootenhill (Dublin)', zip: '956406' },
	{ city: 'Toprass (Louth)', zip: '758459' },
	{ city: 'Tops (Donegal)', zip: '348225' },
	{ city: 'Tops Demesne (Donegal)', zip: '115918' },
	{ city: 'Tor (Donegal)', zip: '464892' },
	{ city: 'Toragh (Donegal)', zip: '804960' },
	{ city: 'Toragh (Tipperary)', zip: '332934' },
	{ city: 'Toralaydan Island (Donegal)', zip: '382207' },
	{ city: 'Toratrave (Donegal)', zip: '540142' },
	{ city: 'Torbane (Donegal)', zip: '447693' },
	{ city: 'Torboy (Donegal)', zip: '129807' },
	{ city: 'Torboy (Longford)', zip: '905823' },
	{ city: 'Torc (Kerry)', zip: '312017' },
	{ city: 'Torduff (Wexford)', zip: '259095' },
	{ city: 'Torglass (Donegal)', zip: '406897' },
	{ city: 'Torglass Island (Donegal)', zip: '844962' },
	{ city: 'Tormarcus (Donegal)', zip: '125004' },
	{ city: 'Tormaun (Galway)', zip: '993817' },
	{ city: 'Tormore (Sligo)', zip: '995447' },
	{ city: 'Tor More (Donegal)', zip: '316665' },
	{ city: 'Tormore Island (Donegal)', zip: '127069' },
	{ city: 'Tornacolpagh Island (Donegal)', zip: '597909' },
	{ city: 'Tornanoon (Donegal)', zip: '110705' },
	{ city: 'Tornanstown (Westmeath)', zip: '836446' },
	{ city: 'Tornant Lower (Wicklow)', zip: '337009' },
	{ city: 'Tornant Upper (Wicklow)', zip: '145511' },
	{ city: 'Tornaweeloge (Donegal)', zip: '680932' },
	{ city: 'Tororragaun (Donegal)', zip: '624887' },
	{ city: 'Torpan Beg (Roscommon)', zip: '941971' },
	{ city: 'Torpan More (Roscommon)', zip: '817773' },
	{ city: 'Torque (Westmeath)', zip: '454478' },
	{ city: 'Torrewa (Cavan)', zip: '774315' },
	{ city: 'Toryhill (Limerick)', zip: '387194' },
	{ city: 'Tory Island (Donegal)', zip: '882360' },
	{ city: 'Tossy (Monaghan)', zip: '771558' },
	{ city: 'Tottenhamgreen (Wexford)', zip: '294318' },
	{ city: 'Toughbaun (Cork)', zip: '344388' },
	{ city: 'Toughmacdermody (Cork)', zip: '766571' },
	{ city: 'Toughraheen (Cork)', zip: '424954' },
	{ city: 'Touknockane (Tipperary)', zip: '898023' },
	{ city: 'Toulett (Donegal)', zip: '642930' },
	{ city: 'Touloure (Tipperary)', zip: '728762' },
	{ city: 'Tountinna (Tipperary)', zip: '651910' },
	{ city: 'Toureen (Tipperary)', zip: '325457' },
	{ city: 'Tourin (Waterford)', zip: '895925' },
	{ city: 'Tourin Demesne (Waterford)', zip: '594217' },
	{ city: 'Tournagee (Roscommon)', zip: '911520' },
	{ city: 'Tournore (Waterford)', zip: '532754' },
	{ city: 'Towas (Meath)', zip: '897136' },
	{ city: 'Towergare (Waterford)', zip: '348069' },
	{ city: 'Towerhill Demesne (Mayo)', zip: '625875' },
	{ city: 'Towermore Lower (Cork)', zip: '716948' },
	{ city: 'Towermore Upper (Cork)', zip: '444431' },
	{ city: 'Towlaght (Meath)', zip: '763139' },
	{ city: 'Towlerton (Laois)', zip: '538033' },
	{ city: 'Towlerton (Limerick)', zip: '152470' },
	{ city: 'Townagha (Tipperary)', zip: '640798' },
	{ city: 'Townaloughra (Galway)', zip: '741368' },
	{ city: 'Townamulloge (Wexford)', zip: '899699' },
	{ city: 'Townfields (Tipperary)', zip: '614507' },
	{ city: 'Townlands (Cork)', zip: '758547' },
	{ city: 'Townleyhall (Louth)', zip: '850526' },
	{ city: 'Town Lot (Tipperary)', zip: '297218' },
	{ city: 'Town Lots (Cork)', zip: '849473' },
	{ city: 'Townlough Lower (Tipperary)', zip: '793476' },
	{ city: 'Townlough Upper (Tipperary)', zip: '902192' },
	{ city: 'Townparks (Cavan)', zip: '516577' },
	{ city: 'Townparks (Cork)', zip: '456952' },
	{ city: 'Townparks (Donegal)', zip: '612304' },
	{ city: 'Townparks (Dublin)', zip: '362746' },
	{ city: 'Townparks (Galway)', zip: '162358' },
	{ city: 'Townparks (Kildare)', zip: '185813' },
	{ city: 'Townparks (Laois)', zip: '797359' },
	{ city: 'Townparks (Leitrim)', zip: '188343' },
	{ city: 'Townparks (Longford)', zip: '772490' },
	{ city: 'Townparks (Louth)', zip: '380083' },
	{ city: 'Townparks (Meath)', zip: '755313' },
	{ city: 'Townparks (Offaly)', zip: '711234' },
	{ city: 'Townparks (Tipperary)', zip: '188727' },
	{ city: 'Townparks (Waterford)', zip: '543119' },
	{ city: 'Townparks (Westmeath)', zip: '903286' },
	{ city: 'Townparks (Wexford)', zip: '955737' },
	{ city: 'Town Parks (Cork)', zip: '756724' },
	{ city: 'Town Parks (Meath)', zip: '769529' },
	{ city: 'Townparks East (Waterford)', zip: '360211' },
	{ city: 'Townparks North (Meath)', zip: '472091' },
	{ city: 'Townparks South (Meath)', zip: '643358' },
	{ city: 'Townparks West (Waterford)', zip: '621556' },
	{ city: 'Town-Plots (Cork)', zip: '469663' },
	{ city: 'Townplots East (Mayo)', zip: '209311' },
	{ city: 'Townplots West (Mayo)', zip: '368511' },
	{ city: 'Townrath (Louth)', zip: '513843' },
	{ city: 'Trabolgan (Cork)', zip: '121065' },
	{ city: 'Tracashel (Cork)', zip: '157238' },
	{ city: 'Tracystown East (Wexford)', zip: '246891' },
	{ city: 'Tracystown West (Wexford)', zip: '430429' },
	{ city: 'Trafrask (Cork)', zip: '312317' },
	{ city: 'Trafrask East (Cork)', zip: '120224' },
	{ city: 'Trafrask West (Cork)', zip: '113197' },
	{ city: 'Tragalee (Kerry)', zip: '751750' },
	{ city: 'Tralee (Kerry)', zip: '892090' },
	{ city: 'Tralia (Kerry)', zip: '478869' },
	{ city: 'Tralong (Cork)', zip: '982559' },
	{ city: 'Tramore (Waterford)', zip: '841969' },
	{ city: 'Tramore Burrow (Waterford)', zip: '765927' },
	{ city: 'Tramore East (Waterford)', zip: '640509' },
	{ city: 'Tramore Intake (Waterford)', zip: '773890' },
	{ city: 'Tramore West (Waterford)', zip: '396982' },
	{ city: 'Trane (Wexford)', zip: '141586' },
	{ city: 'Trantstown (Cork)', zip: '352900' },
	{ city: 'Trascan (Offaly)', zip: '778388' },
	{ city: 'Trasgarve (Sligo)', zip: '854608' },
	{ city: 'Traskernagh (Galway)', zip: '380093' },
	{ city: 'Trasternagh North (Galway)', zip: '421111' },
	{ city: 'Trasternagh South (Galway)', zip: '749507' },
	{ city: 'Traverston (Tipperary)', zip: '705438' },
	{ city: 'Trawlebane (Cork)', zip: '859638' },
	{ city: 'Trawnahaha (Cork)', zip: '171489' },
	{ city: 'Trawnamaddree (Cork)', zip: '861160' },
	{ city: 'Tray (Monaghan)', zip: '697703' },
	{ city: 'Treadstown (Kildare)', zip: '482355' },
	{ city: 'Treagh (Louth)', zip: '863849' },
	{ city: 'Trean (Galway)', zip: '939658' },
	{ city: 'Trean (Leitrim)', zip: '847076' },
	{ city: 'Trean (Louth)', zip: '370039' },
	{ city: 'Trean (Mayo)', zip: '103380' },
	{ city: 'Trean (Roscommon)', zip: '221200' },
	{ city: 'Treanacally (Mayo)', zip: '573148' },
	{ city: 'Treanaceeve (Roscommon)', zip: '583338' },
	{ city: 'Treanagh (Mayo)', zip: '407303' },
	{ city: 'Treanagry (Roscommon)', zip: '743172' },
	{ city: 'Treanakillew (Leitrim)', zip: '475879' },
	{ city: 'Treanamarly (Roscommon)', zip: '120917' },
	{ city: 'Treanamullin (Donegal)', zip: '300797' },
	{ city: 'Treananearla (Galway)', zip: '431318' },
	{ city: 'Treanaree (Kilkenny)', zip: '386477' },
	{ city: 'Treanavinny (Donegal)', zip: '366747' },
	{ city: 'Treanbaun (Galway)', zip: '826012' },
	{ city: 'Treanbeg (Donegal)', zip: '231349' },
	{ city: 'Treanbeg (Mayo)', zip: '429202' },
	{ city: 'Treanboy (Donegal)', zip: '991679' },
	{ city: 'Treanboy (Galway)', zip: '334388' },
	{ city: 'Treanboy (Limerick)', zip: '856603' },
	{ city: 'Treanboy (Longford)', zip: '155526' },
	{ city: 'Treanfohanaun (Mayo)', zip: '432224' },
	{ city: 'Treangarriv (Kerry)', zip: '924613' },
	{ city: 'Treangarrow (Mayo)', zip: '645136' },
	{ city: 'Treangarve (Mayo)', zip: '871779' },
	{ city: 'Treankeel (Donegal)', zip: '992058' },
	{ city: 'Treankeel (Mayo)', zip: '839016' },
	{ city: 'Treankyle (Galway)', zip: '198060' },
	{ city: 'Treanlaur (Galway)', zip: '299576' },
	{ city: 'Treanlaur (Mayo)', zip: '215980' },
	{ city: 'Treanlewis (Limerick)', zip: '288663' },
	{ city: 'Treanmacmurtagh (Sligo)', zip: '789100' },
	{ city: 'Treanmanagh (Clare)', zip: '924762' },
	{ city: 'Treanmanagh (Kerry)', zip: '794491' },
	{ city: 'Treanmanagh (Limerick)', zip: '389173' },
	{ city: 'Treanmore (Leitrim)', zip: '107383' },
	{ city: 'Treanmore (Sligo)', zip: '687857' },
	{ city: 'Treannadullagh (Leitrim)', zip: '726128' },
	{ city: 'Treannagleragh (Mayo)', zip: '854480' },
	{ city: 'Treannahow (Clare)', zip: '682856' },
	{ city: 'Treannaskehy (Mayo)', zip: '789140' },
	{ city: 'Treanoughter (Mayo)', zip: '567423' },
	{ city: 'Treanoughtragh (Kerry)', zip: '468096' },
	{ city: 'Treanpark (Galway)', zip: '437426' },
	{ city: 'Treanrevagh (Galway)', zip: '753754' },
	{ city: 'Treanrevagh (Mayo)', zip: '674064' },
	{ city: 'Treansallagh (Donegal)', zip: '758760' },
	{ city: 'Treanscrabbagh (Sligo)', zip: '915919' },
	{ city: 'Treantaboy (Donegal)', zip: '517561' },
	{ city: 'Treantagh (Donegal)', zip: '668564' },
	{ city: 'Treantaghmucklagh (Donegal)', zip: '984020' },
	{ city: 'Treanybrogaun (Mayo)', zip: '163754' },
	{ city: 'Treehoo (Cavan)', zip: '511704' },
	{ city: 'Treel (Longford)', zip: '813656' },
	{ city: 'Treel (Mayo)', zip: '525616' },
	{ city: 'Treenearla Commons (Waterford)', zip: '545216' },
	{ city: 'Trellick (Galway)', zip: '907496' },
	{ city: 'Tremblestown (Meath)', zip: '389242' },
	{ city: 'Trenchardstown (Kilkenny)', zip: '306162' },
	{ city: 'Trenchmore (Kilkenny)', zip: '131598' },
	{ city: 'Trevet (Meath)', zip: '544061' },
	{ city: 'Trevet Grange (Meath)', zip: '571487' },
	{ city: 'Trianglepark (Wexford)', zip: '303551' },
	{ city: 'Trien (Kerry)', zip: '641562' },
	{ city: 'Trien (Roscommon)', zip: '608962' },
	{ city: 'Trienearagh (Kerry)', zip: '428999' },
	{ city: 'Trieneens (Cork)', zip: '142227' },
	{ city: 'Trienieragh (Cork)', zip: '255911' },
	{ city: 'Trihill East (Galway)', zip: '599737' },
	{ city: 'Trihill West (Galway)', zip: '983694' },
	{ city: 'Trila (Roscommon)', zip: '672707' },
	{ city: 'Trilacroghan (Roscommon)', zip: '560792' },
	{ city: 'Trillick (Donegal)', zip: '772512' },
	{ city: 'Trillickacurry (Longford)', zip: '972981' },
	{ city: 'Trillickatemple (Longford)', zip: '302252' },
	{ city: 'Trim (Meath)', zip: '508236' },
	{ city: 'Trimleston (Dublin)', zip: '271475' },
	{ city: 'Trimmer (Wexford)', zip: '900095' },
	{ city: 'Trimragh (Donegal)', zip: '982417' },
	{ city: 'Trinity Island (Cavan)', zip: '199724' },
	{ city: 'Trippeenagh (Kerry)', zip: '676491' },
	{ city: 'Trippul East (Kerry)', zip: '410123' },
	{ city: 'Trippul West (Kerry)', zip: '634643' },
	{ city: 'Tristaun (Galway)', zip: '174326' },
	{ city: 'Tristernagh (Westmeath)', zip: '570371' },
	{ city: 'Tristernagh Demesne (Westmeath)', zip: '580453' },
	{ city: 'Tristia (Mayo)', zip: '998592' },
	{ city: 'Trohanny (Meath)', zip: '369629' },
	{ city: 'Tromaty (Donegal)', zip: '448989' },
	{ city: 'Tromaun (Roscommon)', zip: '433133' },
	{ city: 'Tromman (Meath)', zip: '971943' },
	{ city: 'Tromra (Longford)', zip: '653221' },
	{ city: 'Tromra (Westmeath)', zip: '686745' },
	{ city: 'Tromracastle (Clare)', zip: '873015' },
	{ city: 'Tromra East (Clare)', zip: '928086' },
	{ city: 'Tromra West (Clare)', zip: '716738' },
	{ city: 'Troopers-Close (Cork)', zip: '224624' },
	{ city: 'Trooperstown (Wicklow)', zip: '186146' },
	{ city: 'Trostan (Monaghan)', zip: '539737' },
	{ city: 'Trotts (Sligo)', zip: '497293' },
	{ city: 'Trough (Clare)', zip: '209901' },
	{ city: 'Trouthill (Mayo)', zip: '352498' },
	{ city: 'Troyswood (Kilkenny)', zip: '781405' },
	{ city: 'Trubley (Meath)', zip: '388811' },
	{ city: 'Trudder (Wicklow)', zip: '835059' },
	{ city: 'Trumman East (Donegal)', zip: '887201' },
	{ city: 'Trumman West (Donegal)', zip: '616779' },
	{ city: 'Trumman West Barr (Donegal)', zip: '405635' },
	{ city: 'Trumra (Laois)', zip: '294578' },
	{ city: 'Trusk (Donegal)', zip: '945253' },
	{ city: 'Truska (Galway)', zip: '177292' },
	{ city: 'Truskaunnagappul (Galway)', zip: '731356' },
	{ city: 'Trusklieve (Clare)', zip: '173706' },
	{ city: 'Trusky East (Galway)', zip: '402570' },
	{ city: 'Trusky West (Galway)', zip: '306248' },
	{ city: 'Trust (Galway)', zip: '202866' },
	{ city: 'Tuam (Cavan)', zip: '476069' },
	{ city: 'Tuam (Galway)', zip: '806799' },
	{ city: 'Tuam (Roscommon)', zip: '698436' },
	{ city: 'Tuamgraney (Clare)', zip: '561107' },
	{ city: 'Tubber (Galway)', zip: '148301' },
	{ city: 'Tubbrid (Cork)', zip: '604873' },
	{ city: 'Tubbrid (Kerry)', zip: '213083' },
	{ city: 'Tubbrid (Kilkenny)', zip: '767314' },
	{ city: 'Tubbrid (Laois)', zip: '880621' },
	{ city: 'Tubbrid (Limerick)', zip: '146996' },
	{ city: 'Tubbrid (Meath)', zip: '261244' },
	{ city: 'Tubbrid (Offaly)', zip: '769625' },
	{ city: 'Tubbrid (Tipperary)', zip: '141401' },
	{ city: 'Tubbrid (Waterford)', zip: '901375' },
	{ city: 'Tubbrid Beg (Mayo)', zip: '263803' },
	{ city: 'Tubbrid Lower (Kilkenny)', zip: '774975' },
	{ city: 'Tubbrid More (Mayo)', zip: '917581' },
	{ city: 'Tubbrid Upper (Kilkenny)', zip: '327556' },
	{ city: 'Tubbrit (Westmeath)', zip: '398359' },
	{ city: 'Tubrid Beg (Kerry)', zip: '287141' },
	{ city: 'Tubride (Meath)', zip: '481875' },
	{ city: 'Tubrid More (Kerry)', zip: '142608' },
	{ city: 'Tuckamine (Carlow)', zip: '741473' },
	{ city: 'Tuckmill Hill (Wicklow)', zip: '827091' },
	{ city: 'Tuckmill Lower (Wicklow)', zip: '522269' },
	{ city: 'Tuckmillpark (Leitrim)', zip: '186675' },
	{ city: 'Tuckmilltate (Monaghan)', zip: '675497' },
	{ city: 'Tuckmilltown (Kildare)', zip: '338924' },
	{ city: 'Tuckmill Upper (Wicklow)', zip: '970478' },
	{ city: 'Tuiterath (Meath)', zip: '118710' },
	{ city: 'Tuitestown (Kilkenny)', zip: '342001' },
	{ city: 'Tuitestown (Westmeath)', zip: '990857' },
	{ city: 'Tuitestown Little (Kilkenny)', zip: '634635' },
	{ city: 'Tulcon (Leitrim)', zip: '534475' },
	{ city: 'Tulfarris (Wicklow)', zip: '282225' },
	{ city: 'Tulla (Clare)', zip: '675306' },
	{ city: 'Tulla (Galway)', zip: '709790' },
	{ city: 'Tulla (Limerick)', zip: '687309' },
	{ city: 'Tulla (Tipperary)', zip: '992224' },
	{ city: 'Tulla And Crumlin (Offaly)', zip: '989642' },
	{ city: 'Tullabards Great (Wexford)', zip: '688563' },
	{ city: 'Tullabards Little (Wexford)', zip: '744296' },
	{ city: 'Tullabeg (Limerick)', zip: '858296' },
	{ city: 'Tullabeg (Wexford)', zip: '739481' },
	{ city: 'Tulla Beg (Kerry)', zip: '733666' },
	{ city: 'Tullabrack (Clare)', zip: '889814' },
	{ city: 'Tullabrack East (Clare)', zip: '342611' },
	{ city: 'Tullabrack West (Clare)', zip: '267144' },
	{ city: 'Tullabracky (Limerick)', zip: '670806' },
	{ city: 'Tullacommon (Laois)', zip: '369164' },
	{ city: 'Tullacondra (Cork)', zip: '994650' },
	{ city: 'Tullacrimeen (Kerry)', zip: '144789' },
	{ city: 'Tulladuff (Cork)', zip: '960516' },
	{ city: 'Tullagee (Louth)', zip: '157621' },
	{ city: 'Tullagh (Clare)', zip: '958009' },
	{ city: 'Tullagh (Cork)', zip: '637314' },
	{ city: 'Tullagh (Donegal)', zip: '245482' },
	{ city: 'Tullaghaboy (Clare)', zip: '534628' },
	{ city: 'Tullaghaboy (Galway)', zip: '997572' },
	{ city: 'Tullaghacullion (Donegal)', zip: '797181' },
	{ city: 'Tullaghaglass (Sligo)', zip: '768551' },
	{ city: 'Tullaghaloyst (Monaghan)', zip: '735977' },
	{ city: 'Tullaghan (Laois)', zip: '318117' },
	{ city: 'Tullaghan (Leitrim)', zip: '178277' },
	{ city: 'Tullaghan (Monaghan)', zip: '812546' },
	{ city: 'Tullaghan (Roscommon)', zip: '278692' },
	{ city: 'Tullaghan (Sligo)', zip: '934290' },
	{ city: 'Tullaghan (Westmeath)', zip: '370847' },
	{ city: 'Tullaghanbaun (Mayo)', zip: '922426' },
	{ city: 'Tullaghanduff (Mayo)', zip: '209688' },
	{ city: 'Tullaghanmore (Roscommon)', zip: '718097' },
	{ city: 'Tullaghanmore (Westmeath)', zip: '932310' },
	{ city: 'Tullaghanoge (Meath)', zip: '202251' },
	{ city: 'Tullaghanrock (Roscommon)', zip: '162323' },
	{ city: 'Tullaghans (Leitrim)', zip: '154256' },
	{ city: 'Tullaghanshanlin (Westmeath)', zip: '813884' },
	{ city: 'Tullaghansleek (Westmeath)', zip: '285905' },
	{ city: 'Tullaghanstown (Meath)', zip: '234420' },
	{ city: 'Tullaghaun (Galway)', zip: '995642' },
	{ city: 'Tullaghaun (Mayo)', zip: '461855' },
	{ city: 'Tullaghaunnashammer (Mayo)', zip: '716180' },
	{ city: 'Tullaghbeg (Offaly)', zip: '825203' },
	{ city: 'Tullaghcullion (Donegal)', zip: '201984' },
	{ city: 'Tullagher (Kilkenny)', zip: '536447' },
	{ city: 'Tullagh Lower (Clare)', zip: '335473' },
	{ city: 'Tullagh Lower (Galway)', zip: '321498' },
	{ city: 'Tullaghlumman Beg (Galway)', zip: '990428' },
	{ city: 'Tullaghlumman More (Galway)', zip: '833310' },
	{ city: 'Tullaghmedan (Meath)', zip: '372689' },
	{ city: 'Tullaghmelan (Tipperary)', zip: '452519' },
	{ city: 'Tullaghmore (Galway)', zip: '321247' },
	{ city: 'Tullaghna (Kerry)', zip: '884401' },
	{ city: 'Tullaghnacrossan (Westmeath)', zip: '413017' },
	{ city: 'Tullaghnageeragh (Westmeath)', zip: '292000' },
	{ city: 'Tullaghobegly Irish (Donegal)', zip: '771678' },
	{ city: 'Tullaghobegly Scotch (Donegal)', zip: '215611' },
	{ city: 'Tullaghomeath (Louth)', zip: '119916' },
	{ city: 'Tullagh Upper (Clare)', zip: '492112' },
	{ city: 'Tullagh Upper (Galway)', zip: '487121' },
	{ city: 'Tullagh Upper (Westmeath)', zip: '667978' },
	{ city: 'Tullaghyrory (Cavan)', zip: '830685' },
	{ city: 'Tullagower (Clare)', zip: '729730' },
	{ city: 'Tullagreen (Cork)', zip: '213809' },
	{ city: 'Tullagroe (Clare)', zip: '174258' },
	{ city: 'Tullagubbeen (Kerry)', zip: '741015' },
	{ city: 'Tullaha (Kerry)', zip: '657963' },
	{ city: 'Tullaha (Limerick)', zip: '345188' },
	{ city: 'Tullahedy (Tipperary)', zip: '145637' },
	{ city: 'Tullaheen Beg (Cork)', zip: '338491' },
	{ city: 'Tullaheen More (Cork)', zip: '156471' },
	{ city: 'Tullahennel North (Kerry)', zip: '884120' },
	{ city: 'Tullahennel South (Kerry)', zip: '818423' },
	{ city: 'Tullaher (Clare)', zip: '474187' },
	{ city: 'Tullaherin (Kilkenny)', zip: '256317' },
	{ city: 'Tullahought (Kilkenny)', zip: '919128' },
	{ city: 'Tullakeel (Kerry)', zip: '574387' },
	{ city: 'Tullakeel (Louth)', zip: '121467' },
	{ city: 'Tullaloughaun (Clare)', zip: '312234' },
	{ city: 'Tullamain (Tipperary)', zip: '364694' },
	{ city: 'Tullamaine (Kilkenny)', zip: '368098' },
	{ city: 'Tullamore (Clare)', zip: '865892' },
	{ city: 'Tullamore (Kerry)', zip: '173319' },
	{ city: 'Tullamore (Offaly)', zip: '660857' },
	{ city: 'Tullamore (Tipperary)', zip: '768935' },
	{ city: 'Tulla More (Kerry)', zip: '387032' },
	{ city: 'Tullamoylin (Tipperary)', zip: '421110' },
	{ city: 'Tullanacorra (Mayo)', zip: '905873' },
	{ city: 'Tullanacrunat (Monaghan)', zip: '159394' },
	{ city: 'Tullanacrunat North (Monaghan)', zip: '842419' },
	{ city: 'Tullanacrunat South (Monaghan)', zip: '415087' },
	{ city: 'Tullanaglug (Sligo)', zip: '320490' },
	{ city: 'Tullanascreen (Donegal)', zip: '635061' },
	{ city: 'Tullandreen (Cavan)', zip: '837942' },
	{ city: 'Tullanierin (Cavan)', zip: '107657' },
	{ city: 'Tullanisky (Westmeath)', zip: '620816' },
	{ city: 'Tullanree (Donegal)', zip: '472021' },
	{ city: 'Tullantanty (Cavan)', zip: '476520' },
	{ city: 'Tullanteen (Cavan)', zip: '386476' },
	{ city: 'Tullantintin (Cavan)', zip: '875416' },
	{ city: 'Tullanvoolty (Kilkenny)', zip: '915939' },
	{ city: 'Tullaree (Kerry)', zip: '137659' },
	{ city: 'Tullaroan (Kilkenny)', zip: '448721' },
	{ city: 'Tullaroe (Clare)', zip: '899882' },
	{ city: 'Tullaroe (Offaly)', zip: '760593' },
	{ city: 'Tullaskeagh (Tipperary)', zip: '917037' },
	{ city: 'Tullassa (Clare)', zip: '894937' },
	{ city: 'Tullatreada (Cork)', zip: '479551' },
	{ city: 'Tullavally (Cavan)', zip: '801378' },
	{ city: 'Tullavane (Donegal)', zip: '758115' },
	{ city: 'Tullawicky (Galway)', zip: '433702' },
	{ city: 'Tullcoe (Cavan)', zip: '683782' },
	{ city: 'Tulleague (Mayo)', zip: '493566' },
	{ city: 'Tulleevin (Monaghan)', zip: '974070' },
	{ city: 'Tullen (Roscommon)', zip: '419170' },
	{ city: 'Tullequane (Tipperary)', zip: '378197' },
	{ city: 'Tullerboy (Limerick)', zip: '431712' },
	{ city: 'Tullerstown (Wexford)', zip: '250795' },
	{ city: 'Tullig (Clare)', zip: '520184' },
	{ city: 'Tullig (Cork)', zip: '597974' },
	{ city: 'Tullig (Kerry)', zip: '840523' },
	{ city: 'Tullig Beg (Cork)', zip: '195518' },
	{ city: 'Tullig Beg (Kerry)', zip: '951547' },
	{ city: 'Tulligealane (Kerry)', zip: '801087' },
	{ city: 'Tulligee (Cork)', zip: '361789' },
	{ city: 'Tulligmacthomas (Limerick)', zip: '385828' },
	{ city: 'Tullig More (Cork)', zip: '742135' },
	{ city: 'Tullig More (Kerry)', zip: '203012' },
	{ city: 'Tulligoline North (Limerick)', zip: '787132' },
	{ city: 'Tulligoline South (Limerick)', zip: '556310' },
	{ city: 'Tullin (Westmeath)', zip: '689494' },
	{ city: 'Tullinearly (Monaghan)', zip: '639776' },
	{ city: 'Tullinlagan (Donegal)', zip: '412407' },
	{ city: 'Tullinlicky (Galway)', zip: '387384' },
	{ city: 'Tullinlough (Donegal)', zip: '664178' },
	{ city: 'Tullinloughan (Leitrim)', zip: '330762' },
	{ city: 'Tullintaggart (Leitrim)', zip: '489302' },
	{ city: 'Tullinteane (Donegal)', zip: '612634' },
	{ city: 'Tullintlisny (Monaghan)', zip: '892458' },
	{ city: 'Tullintloy (Leitrim)', zip: '452268' },
	{ city: 'Tullintowell (Leitrim)', zip: '330712' },
	{ city: 'Tullintrat (Monaghan)', zip: '830584' },
	{ city: 'Tullintuppeen (Roscommon)', zip: '169065' },
	{ city: 'Tullinwannia (Leitrim)', zip: '413816' },
	{ city: 'Tullinwillin (Leitrim)', zip: '680277' },
	{ city: 'Tullira (Galway)', zip: '904919' },
	{ city: 'Tullispark (Wexford)', zip: '971488' },
	{ city: 'Tullog (Meath)', zip: '945883' },
	{ city: 'Tullohea (Tipperary)', zip: '104701' },
	{ city: 'Tullokyne (Galway)', zip: '650930' },
	{ city: 'Tullomoy (Laois)', zip: '202846' },
	{ city: 'Tullore (Laois)', zip: '153126' },
	{ city: 'Tullorum (Kerry)', zip: '267818' },
	{ city: 'Tullovin (Limerick)', zip: '927620' },
	{ city: 'Tullow (Carlow)', zip: '520789' },
	{ city: 'Tullow (Tipperary)', zip: '345138' },
	{ city: 'Tullowbeg (Carlow)', zip: '771461' },
	{ city: 'Tullowbrin (Kilkenny)', zip: '318013' },
	{ city: 'Tullowclay (Wicklow)', zip: '248649' },
	{ city: 'Tullowcossaun (Tipperary)', zip: '748448' },
	{ city: 'Tullowglass (Kilkenny)', zip: '983769' },
	{ city: 'Tullowmacjames (Tipperary)', zip: '528161' },
	{ city: 'Tullowphelim (Carlow)', zip: '722113' },
	{ city: 'Tully (Cavan)', zip: '121358' },
	{ city: 'Tully (Donegal)', zip: '238226' },
	{ city: 'Tully (Galway)', zip: '144682' },
	{ city: 'Tully (Leitrim)', zip: '742812' },
	{ city: 'Tully (Longford)', zip: '109181' },
	{ city: 'Tully (Louth)', zip: '989042' },
	{ city: 'Tully (Mayo)', zip: '567301' },
	{ city: 'Tully (Meath)', zip: '317275' },
	{ city: 'Tully (Monaghan)', zip: '990594' },
	{ city: 'Tully (Offaly)', zip: '733510' },
	{ city: 'Tully (Roscommon)', zip: '654590' },
	{ city: 'Tully (Sligo)', zip: '873307' },
	{ city: 'Tully (Westmeath)', zip: '670623' },
	{ city: 'Tullyagan (Cavan)', zip: '882338' },
	{ city: 'Tullyallen (Louth)', zip: '816146' },
	{ city: 'Tullyallen (Monaghan)', zip: '203616' },
	{ city: 'Tullyally (Donegal)', zip: '876901' },
	{ city: 'Tullyalt (Cavan)', zip: '597860' },
	{ city: 'Tullyannan (Donegal)', zip: '377117' },
	{ city: 'Tullyannan Glebe (Donegal)', zip: '419981' },
	{ city: 'Tullyanog (Cavan)', zip: '174176' },
	{ city: 'Tullyard (Cavan)', zip: '194951' },
	{ city: 'Tullyard (Donegal)', zip: '143589' },
	{ city: 'Tullyard (Louth)', zip: '904599' },
	{ city: 'Tullyard (Meath)', zip: '589349' },
	{ city: 'Tullyard (Monaghan)', zip: '264415' },
	{ city: 'Tullyarran (Meath)', zip: '854934' },
	{ city: 'Tullyarvan (Donegal)', zip: '352852' },
	{ city: 'Tullyattin (Meath)', zip: '124744' },
	{ city: 'Tullybane (Westmeath)', zip: '852565' },
	{ city: 'Tullybaun (Longford)', zip: '668282' },
	{ city: 'Tullybeg (Offaly)', zip: '947908' },
	{ city: 'Tully Beg (Donegal)', zip: '522497' },
	{ city: 'Tully Beg (Galway)', zip: '525303' },
	{ city: 'Tully Beg (Mayo)', zip: '558111' },
	{ city: 'Tully Beg (Sligo)', zip: '263953' },
	{ city: 'Tullybeg Glebe (Mayo)', zip: '750245' },
	{ city: 'Tullybeg North (Galway)', zip: '638313' },
	{ city: 'Tullybeg South (Galway)', zip: '176232' },
	{ city: 'Tullybogly (Donegal)', zip: '715848' },
	{ city: 'Tullyboy (Cavan)', zip: '973580' },
	{ city: 'Tullyboy (Roscommon)', zip: '722797' },
	{ city: 'Tullybrack (Cavan)', zip: '583601' },
	{ city: 'Tullybradan (Leitrim)', zip: '636240' },
	{ city: 'Tullybrattan (Galway)', zip: '644105' },
	{ city: 'Tullybrick (Cavan)', zip: '771176' },
	{ city: 'Tullybryan (Monaghan)', zip: '906527' },
	{ city: 'Tullybuck (Cavan)', zip: '387776' },
	{ city: 'Tullybuck (Monaghan)', zip: '300892' },
	{ city: 'Tullycaghny (Monaghan)', zip: '388884' },
	{ city: 'Tullycahan (Louth)', zip: '764578' },
	{ city: 'Tullycallick (Monaghan)', zip: '197433' },
	{ city: 'Tullycanna (Wexford)', zip: '592342' },
	{ city: 'Tullycarn (Donegal)', zip: '554091' },
	{ city: 'Tullycarragh (Monaghan)', zip: '898557' },
	{ city: 'Tullycartron (Roscommon)', zip: '460085' },
	{ city: 'Tullychullion (Donegal)', zip: '165202' },
	{ city: 'Tullycleave Beg (Donegal)', zip: '357364' },
	{ city: 'Tullycleave More (Donegal)', zip: '550876' },
	{ city: 'Tullyclevaun (Leitrim)', zip: '116436' },
	{ city: 'Tullycoe (Cavan)', zip: '729101' },
	{ city: 'Tullycollive (Monaghan)', zip: '325904' },
	{ city: 'Tullycoly (Leitrim)', zip: '122342' },
	{ city: 'Tullycommon (Clare)', zip: '465346' },
	{ city: 'Tully Commons (Mayo)', zip: '807125' },
	{ city: 'Tullyconnell (Donegal)', zip: '226901' },
	{ city: 'Tullyconor (Galway)', zip: '262058' },
	{ city: 'Tullycoora (Monaghan)', zip: '588242' },
	{ city: 'Tullycorka (Leitrim)', zip: '167761' },
	{ city: 'Tullycrafton (Cavan)', zip: '730881' },
	{ city: 'Tullycreen Lower (Clare)', zip: '181558' },
	{ city: 'Tullycreen Upper (Clare)', zip: '162772' },
	{ city: 'Tullycreevy (Leitrim)', zip: '713797' },
	{ city: 'Tullycroman (Monaghan)', zip: '909636' },
	{ city: 'Tullycross (Westmeath)', zip: '640162' },
	{ city: 'Tullycumasky (Monaghan)', zip: '897942' },
	{ city: 'Tullycumber (Donegal)', zip: '924183' },
	{ city: 'Tullycusheen Beg (Sligo)', zip: '375167' },
	{ city: 'Tullycusheen More (Sligo)', zip: '923726' },
	{ city: 'Tullydermot (Cavan)', zip: '377439' },
	{ city: 'Tullyderrin (Leitrim)', zip: '526965' },
	{ city: 'Tullydonnell (Louth)', zip: '432683' },
	{ city: 'Tullydonnell Lower (Donegal)', zip: '935133' },
	{ city: 'Tullydonnell Upper (Donegal)', zip: '241657' },
	{ city: 'Tullydrum (Louth)', zip: '418754' },
	{ city: 'Tullyduff (Mayo)', zip: '764009' },
	{ city: 'Tullydush Lower (Donegal)', zip: '968571' },
	{ city: 'Tullydush Upper (Donegal)', zip: '654103' },
	{ city: 'Tullyearl (Donegal)', zip: '686757' },
	{ city: 'Tully East (Kildare)', zip: '238451' },
	{ city: 'Tullyegan (Mayo)', zip: '547179' },
	{ city: 'Tullyeskar (Louth)', zip: '471462' },
	{ city: 'Tullygallan (Donegal)', zip: '241077' },
	{
		city: 'Tullygallan Tullywee And Oughtnadrin Barr (Donegal)',
		zip: '310228',
	},
	{ city: 'Tullyganny (Mayo)', zip: '393561' },
	{ city: 'Tullygarran (Kerry)', zip: '324009' },
	{ city: 'Tullygarvan East (Clare)', zip: '421388' },
	{ city: 'Tullygarvan West (Clare)', zip: '144912' },
	{ city: 'Tullygay (Donegal)', zip: '503690' },
	{ city: 'Tullygillen (Monaghan)', zip: '329936' },
	{ city: 'Tullyglass (Clare)', zip: '233530' },
	{ city: 'Tullyglass (Cork)', zip: '808337' },
	{ city: 'Tullyglass (Limerick)', zip: '251838' },
	{ city: 'Tullyglass (Monaghan)', zip: '691141' },
	{ city: 'Tullygony (Monaghan)', zip: '488614' },
	{ city: 'Tullygorey (Kildare)', zip: '503234' },
	{ city: 'Tullygowan (Louth)', zip: '721318' },
	{ city: 'Tullygrimes (Monaghan)', zip: '190067' },
	{ city: 'Tullygullin (Cavan)', zip: '114974' },
	{ city: 'Tully Hall (Donegal)', zip: '305387' },
	{ city: 'Tullyharnet (Monaghan)', zip: '267540' },
	{ city: 'Tullyhill (Westmeath)', zip: '399480' },
	{ city: 'Tullyhirm (Monaghan)', zip: '857686' },
	{ city: 'Tullyhogan (Westmeath)', zip: '799025' },
	{ city: 'Tullyhonour (Donegal)', zip: '983438' },
	{ city: 'Tullyhonwar (Donegal)', zip: '207582' },
	{ city: 'Tullyhorky (Donegal)', zip: '485472' },
	{ city: 'Tullyhugh (Sligo)', zip: '408684' },
	{ city: 'Tullyhumphry (Monaghan)', zip: '575636' },
	{ city: 'Tullyhumphrys (Westmeath)', zip: '750906' },
	{ city: 'Tullyillan (Donegal)', zip: '848823' },
	{ city: 'Tullykane (Meath)', zip: '839042' },
	{ city: 'Tullykenny (Monaghan)', zip: '702580' },
	{ city: 'Tullylackan Beg (Leitrim)', zip: '449943' },
	{ city: 'Tullylackan More (Leitrim)', zip: '956539' },
	{ city: 'Tullyland (Cork)', zip: '645826' },
	{ city: 'Tullylanesborough (Westmeath)', zip: '174386' },
	{ city: 'Tullylannan (Leitrim)', zip: '669149' },
	{ city: 'Tullylark (Donegal)', zip: '433773' },
	{ city: 'Tullyleague (Donegal)', zip: '828913' },
	{ city: 'Tullyleague (Limerick)', zip: '106460' },
	{ city: 'Tullyleague (Roscommon)', zip: '220372' },
	{ city: 'Tullyleak (Limerick)', zip: '271567' },
	{ city: 'Tullylease (Cork)', zip: '120608' },
	{ city: 'Tullyleer (Monaghan)', zip: '316052' },
	{ city: 'Tullylin (Sligo)', zip: '639598' },
	{ city: 'Tullylish (Monaghan)', zip: '704605' },
	{ city: 'Tullylone (Monaghan)', zip: '279429' },
	{ city: 'Tullylorcan (Cavan)', zip: '202727' },
	{ city: 'Tullyloskan (Donegal)', zip: '171610' },
	{ city: 'Tullylost (Kildare)', zip: '530392' },
	{ city: 'Tullylough (Cavan)', zip: '304708' },
	{ city: 'Tullylougherny (Monaghan)', zip: '618707' },
	{ city: 'Tullyloughfin (Cavan)', zip: '116265' },
	{ city: 'Tullyloyd (Roscommon)', zip: '223915' },
	{ city: 'Tullylusk (Wicklow)', zip: '987722' },
	{ city: 'Tullymackan (Clare)', zip: '518137' },
	{ city: 'Tullymackilmartin (Monaghan)', zip: '910769' },
	{ city: 'Tullyminister (Cavan)', zip: '934516' },
	{ city: 'Tullymongan Lower (Cavan)', zip: '953411' },
	{ city: 'Tullymongan Upper (Cavan)', zip: '482341' },
	{ city: 'Tullymore (Donegal)', zip: '363397' },
	{ city: 'Tully More (Donegal)', zip: '349981' },
	{ city: 'Tully More (Galway)', zip: '805073' },
	{ city: 'Tully More (Mayo)', zip: '766097' },
	{ city: 'Tully More (Sligo)', zip: '810890' },
	{ city: 'Tullymorerahan (Offaly)', zip: '639825' },
	{ city: 'Tullymornin (Donegal)', zip: '385731' },
	{ city: 'Tully Mountain (Donegal)', zip: '238701' },
	{ city: 'Tullymoy (Sligo)', zip: '742458' },
	{ city: 'Tullymurray (Leitrim)', zip: '816203' },
	{ city: 'Tullymurrihy (Cork)', zip: '811538' },
	{ city: 'Tullynabeherny (Cavan)', zip: '321901' },
	{ city: 'Tullynabratilly (Donegal)', zip: '538381' },
	{ city: 'Tullynacleigh (Cavan)', zip: '945899' },
	{ city: 'Tullynaconspod (Cavan)', zip: '323380' },
	{ city: 'Tullynacross (Cavan)', zip: '597364' },
	{ city: 'Tullynacross (Leitrim)', zip: '795107' },
	{ city: 'Tullynacross (Monaghan)', zip: '526490' },
	{ city: 'Tullynadall (Donegal)', zip: '779786' },
	{ city: 'Tullynafreave (Cavan)', zip: '860937' },
	{ city: 'Tullynageer (Monaghan)', zip: '192254' },
	{ city: 'Tullynaglack (Donegal)', zip: '695619' },
	{ city: 'Tullynaglaggan (Donegal)', zip: '328024' },
	{ city: 'Tullynagracken North (Sligo)', zip: '111127' },
	{ city: 'Tullynagracken South (Sligo)', zip: '216932' },
	{ city: 'Tullynagreana (Donegal)', zip: '419555' },
	{ city: 'Tullynagrow (Monaghan)', zip: '772065' },
	{ city: 'Tullynaha (Donegal)', zip: '198658' },
	{ city: 'Tullynahaia (Leitrim)', zip: '200125' },
	{ city: 'Tullynahattina (Monaghan)', zip: '147529' },
	{ city: 'Tullynahaw (Roscommon)', zip: '955137' },
	{ city: 'Tullynahearka (Roscommon)', zip: '750643' },
	{ city: 'Tullynahinnera (Monaghan)', zip: '408968' },
	{ city: 'Tullynahoo (Mayo)', zip: '804474' },
	{ city: 'Tullynamalra (Monaghan)', zip: '723621' },
	{ city: 'Tullynamoltra (Cavan)', zip: '626807' },
	{ city: 'Tullynamoyle (Cavan)', zip: '700442' },
	{ city: 'Tullynamoyle (Leitrim)', zip: '746743' },
	{ city: 'Tullynample (Monaghan)', zip: '107413' },
	{ city: 'Tullynamuckduff (Leitrim)', zip: '799389' },
	{ city: 'Tullynanegish (Monaghan)', zip: '446190' },
	{ city: 'Tullynanure (Monaghan)', zip: '531830' },
	{ city: 'Tullynapurtlin (Leitrim)', zip: '595856' },
	{ city: 'Tullynarney (Monaghan)', zip: '881359' },
	{ city: 'Tullynaroog (Leitrim)', zip: '675013' },
	{ city: 'Tullynascreen (Leitrim)', zip: '452047' },
	{ city: 'Tullynasharragh (Leitrim)', zip: '628866' },
	{ city: 'Tullynaskeagh (Cavan)', zip: '530990' },
	{ city: 'Tullynaskeagh East (Monaghan)', zip: '372105' },
	{ city: 'Tullynaskeagh West (Monaghan)', zip: '984687' },
	{ city: 'Tullynavinn (Donegal)', zip: '819937' },
	{ city: 'Tullyneasky East (Cork)', zip: '734921' },
	{ city: 'Tullyneasky West (Cork)', zip: '162149' },
	{ city: 'Tullyneeny (Roscommon)', zip: '622332' },
	{ city: 'Tully North (Leitrim)', zip: '749204' },
	{ city: 'Tullynure (Sligo)', zip: '509347' },
	{ city: 'Tullyodea (Clare)', zip: '224074' },
	{ city: 'Tullyoran (Leitrim)', zip: '663299' },
	{ city: 'Tullyoscar (Leitrim)', zip: '423792' },
	{ city: 'Tullyowen (Donegal)', zip: '903014' },
	{ city: 'Tullypole (Meath)', zip: '862325' },
	{ city: 'Tullyrahan (Monaghan)', zip: '154857' },
	{ city: 'Tullyrain (Monaghan)', zip: '294997' },
	{ city: 'Tullyraine (Louth)', zip: '778418' },
	{ city: 'Tullyrap (Donegal)', zip: '204023' },
	{ city: 'Tullyreas (Monaghan)', zip: '196674' },
	{ city: 'Tullyree (Monaghan)', zip: '537893' },
	{ city: 'Tullyroane (Cavan)', zip: '850700' },
	{ city: 'Tullyroe (Galway)', zip: '320070' },
	{ city: 'Tullyroe (Laois)', zip: '328366' },
	{ city: 'Tullyroe (Mayo)', zip: '386810' },
	{ city: 'Tullyroe (Roscommon)', zip: '794006' },
	{ city: 'Tullyshelferty (Monaghan)', zip: '161622' },
	{ city: 'Tullyskeherny (Leitrim)', zip: '228518' },
	{ city: 'Tullyskerry (Monaghan)', zip: '552057' },
	{ city: 'Tullysleva (Mayo)', zip: '517974' },
	{ city: 'Tully South (Leitrim)', zip: '360154' },
	{ city: 'Tullystown (Westmeath)', zip: '326561' },
	{ city: 'Tullytawen (Roscommon)', zip: '200893' },
	{ city: 'Tullytiernan (Cavan)', zip: '340926' },
	{ city: 'Tullytrasna (Cavan)', zip: '318855' },
	{ city: 'Tullytrasna (Donegal)', zip: '908053' },
	{ city: 'Tullytreane (Cavan)', zip: '597681' },
	{ city: 'Tullyunshin (Cavan)', zip: '303285' },
	{ city: 'Tullyval (Roscommon)', zip: '521665' },
	{ city: 'Tullyvanus (Monaghan)', zip: '179653' },
	{ city: 'Tullyvaragh Lower (Monaghan)', zip: '619387' },
	{ city: 'Tullyvaragh Upper (Monaghan)', zip: '704132' },
	{ city: 'Tullyvarraga (Clare)', zip: '672822' },
	{ city: 'Tullyvarran (Roscommon)', zip: '407035' },
	{ city: 'Tullyveacan (Leitrim)', zip: '374690' },
	{ city: 'Tullyvealnaslee (Galway)', zip: '770820' },
	{ city: 'Tullyveame (Leitrim)', zip: '658737' },
	{ city: 'Tullyveela (Cavan)', zip: '709232' },
	{ city: 'Tullyvellia (Sligo)', zip: '733006' },
	{ city: 'Tullyvin (Cavan)', zip: '627458' },
	{ city: 'Tullyvin (Monaghan)', zip: '951107' },
	{ city: 'Tullyvinny (Donegal)', zip: '489711' },
	{ city: 'Tullyvoghan (Clare)', zip: '668684' },
	{ city: 'Tullyvogy (Monaghan)', zip: '613163' },
	{ city: 'Tullyvohaun (Roscommon)', zip: '423151' },
	{ city: 'Tullyvoheen (Galway)', zip: '781699' },
	{ city: 'Tullyvoos (Donegal)', zip: '381715' },
	{ city: 'Tullyvrane (Longford)', zip: '652156' },
	{ city: 'Tullyvrick (Galway)', zip: '456549' },
	{ city: 'Tullywaltry (Cavan)', zip: '310901' },
	{ city: 'Tullywana (Leitrim)', zip: '226616' },
	{ city: 'Tullywaum (Cavan)', zip: '245483' },
	{ city: 'Tullywee (Donegal)', zip: '381068' },
	{ city: 'Tullyweel (Meath)', zip: '901463' },
	{ city: 'Tully West (Kildare)', zip: '166133' },
	{ city: 'Tullywood (Westmeath)', zip: '621707' },
	{ city: 'Tulrohaun (Mayo)', zip: '492393' },
	{ city: 'Tulrush (Galway)', zip: '750100' },
	{ city: 'Tulrush (Roscommon)', zip: '889984' },
	{ city: 'Tulrusk (Leitrim)', zip: '938307' },
	{ city: 'Tulsk (Roscommon)', zip: '212320' },
	{ city: 'Tumbeagh (Offaly)', zip: '938739' },
	{ city: 'Tumgesh (Mayo)', zip: '814994' },
	{ city: 'Tummerillaun (Galway)', zip: '538199' },
	{ city: 'Tumna (Roscommon)', zip: '406137' },
	{ city: 'Tumnasrah (Galway)', zip: '898716' },
	{ city: 'Tumneenaun (Galway)', zip: '918748' },
	{ city: 'Tunker (Cavan)', zip: '688472' },
	{ city: 'Tunnagh (Sligo)', zip: '771386' },
	{ city: 'Tuocusheen (Cork)', zip: '812625' },
	{ city: 'Tuogh (Limerick)', zip: '739498' },
	{ city: 'Tuosist (Kerry)', zip: '981113' },
	{ city: 'Turagh (Limerick)', zip: '891690' },
	{ city: 'Turavaghla (Galway)', zip: '585701' },
	{ city: 'Turavoggaun (Tipperary)', zip: '769851' },
	{ city: 'Turbeagh (Cork)', zip: '125156' },
	{ city: 'Turbeha (Waterford)', zip: '397285' },
	{ city: 'Turbot Island (Galway)', zip: '553396' },
	{ city: 'Turbotstown (Westmeath)', zip: '833170' },
	{ city: 'Ture (Cavan)', zip: '418867' },
	{ city: 'Ture (Donegal)', zip: '864381' },
	{ city: 'Ture (Monaghan)', zip: '119353' },
	{ city: 'Turfad (Cavan)', zip: '952330' },
	{ city: 'Turfarney (Laois)', zip: '156453' },
	{ city: 'Turin (Cavan)', zip: '220726' },
	{ city: 'Turin (Mayo)', zip: '905683' },
	{ city: 'Turkenagh (Clare)', zip: '873328' },
	{ city: 'Turkenagh Mountain (Clare)', zip: '389032' },
	{ city: 'Turkhead (Cork)', zip: '718337' },
	{ city: 'Turkinstown (Dublin)', zip: '182380' },
	{ city: 'Turksland (Galway)', zip: '309300' },
	{ city: 'Turksland (Roscommon)', zip: '361589' },
	{ city: 'Turkstown (Kilkenny)', zip: '611534' },
	{ city: 'Turkstown (Meath)', zip: '152581' },
	{ city: 'Turkyle (Wexford)', zip: '695781' },
	{ city: 'Turlagh (Roscommon)', zip: '381138' },
	{ city: 'Turlagharee (Roscommon)', zip: '588528' },
	{ city: 'Turlaghmore (Roscommon)', zip: '989383' },
	{ city: 'Turlaghnamaddy (Roscommon)', zip: '273882' },
	{ city: 'Turlaghyraun (Sligo)', zip: '515025' },
	{ city: 'Turlough (Clare)', zip: '246157' },
	{ city: 'Turlough (Galway)', zip: '506368' },
	{ city: 'Turlough (Mayo)', zip: '965997' },
	{ city: 'Turloughalanger (Galway)', zip: '347650' },
	{ city: 'Turloughanbaun (Mayo)', zip: '170857' },
	{ city: 'Turloughbeg (Galway)', zip: '454562' },
	{ city: 'Turloughcartron (Galway)', zip: '591273' },
	{ city: 'Turloughcor (Galway)', zip: '584287' },
	{ city: 'Turloughgarve (Galway)', zip: '914788' },
	{ city: 'Turloughkeeloge (Galway)', zip: '541617' },
	{ city: 'Turloughmartin (Galway)', zip: '191525' },
	{ city: 'Turloughmore (Clare)', zip: '469277' },
	{ city: 'Turloughmore (Galway)', zip: '584534' },
	{ city: 'Turloughmore Common (Galway)', zip: '402234' },
	{ city: 'Turloughnacloghdoo Commons (Galway)', zip: '940598' },
	{ city: 'Turloughour (Galway)', zip: '333043' },
	{ city: 'Turloughrevagh (Galway)', zip: '466953' },
	{ city: 'Turnalaydan (Sligo)', zip: '443265' },
	{ city: 'Turnamucka (Kerry)', zip: '773158' },
	{ city: 'Turnapin Great (Dublin)', zip: '213258' },
	{ city: 'Turnapin Little (Dublin)', zip: '335519' },
	{ city: 'Turnaspidogy (Cork)', zip: '500154' },
	{ city: 'Turnersglaster (Offaly)', zip: '370085' },
	{ city: 'Turnerstown (Kildare)', zip: '925235' },
	{ city: 'Turnings (Kildare)', zip: '727888' },
	{ city: 'Turnings Lower (Kildare)', zip: '351333' },
	{ city: 'Turnings Upper (Kildare)', zip: '117269' },
	{ city: 'Turoe (Galway)', zip: '206067' },
	{ city: 'Turpaun (Leitrim)', zip: '971728' },
	{ city: 'Turra (Carlow)', zip: '502824' },
	{ city: 'Turra (Laois)', zip: '939961' },
	{ city: 'Turra Beg (Galway)', zip: '751916' },
	{ city: 'Turraheen Lower (Tipperary)', zip: '814938' },
	{ city: 'Turraheen Upper (Tipperary)', zip: '396004' },
	{ city: 'Turra More (Galway)', zip: '886118' },
	{ city: 'Turraun (Offaly)', zip: '489675' },
	{ city: 'Turreen (Longford)', zip: '247115' },
	{ city: 'Turrock (Roscommon)', zip: '693761' },
	{ city: 'Tursalla (Laois)', zip: '870284' },
	{ city: 'Tursillagh (Kerry)', zip: '995208' },
	{ city: 'Turtane (Carlow)', zip: '550802' },
	{ city: 'Turtulla (Tipperary)', zip: '779108' },
	{ city: 'Turvey (Dublin)', zip: '270737' },
	{ city: 'Tusker (Monaghan)', zip: '423807' },
	{ city: 'Twelveacre (Wexford)', zip: '765032' },
	{ city: 'Twenties (Louth)', zip: '348437' },
	{ city: 'Twentyacres (Galway)', zip: '403742' },
	{ city: 'Twentyacres (Longford)', zip: '787307' },
	{ city: 'Twentyacres (Wexford)', zip: '614178' },
	{ city: 'Twentypark (Meath)', zip: '133013' },
	{ city: 'Twigspark (Leitrim)', zip: '185414' },
	{ city: 'Two Gneeves (Cork)', zip: '424552' },
	{ city: 'Twomileborris (Tipperary)', zip: '741754' },
	{ city: 'Twomilebridge (Tipperary)', zip: '279832' },
	{ city: 'Twomilebridge (Waterford)', zip: '571747' },
	{ city: 'Two Mile House (Kildare)', zip: '700951' },
	{ city: 'Twomilestone (Donegal)', zip: '203950' },
	{ city: 'Twopothouse (Cork)', zip: '152748' },
	{ city: 'Twyford (Westmeath)', zip: '923103' },
	{ city: 'Tyfarnham (Westmeath)', zip: '270711' },
	{ city: 'Tylagh (Kerry)', zip: '878997' },
	{ city: 'Tyleford (Donegal)', zip: '494595' },
	{ city: 'Tymon North (Dublin)', zip: '746760' },
	{ city: 'Tymon South (Dublin)', zip: '986522' },
	{ city: 'Tynacocka (Limerick)', zip: '933336' },
	{ city: 'Tynagh (Galway)', zip: '426297' },
	{ city: 'Tyone (Tipperary)', zip: '801412' },
	{ city: 'Tyredagh Lower (Clare)', zip: '990051' },
	{ city: 'Tyredagh Upper (Clare)', zip: '254634' },
	{ city: 'Tyrone (Galway)', zip: '631853' },
	{ city: 'Tyrrellspass (Westmeath)', zip: '747941' },
	{ city: 'Tyrrellstown (Kildare)', zip: '971846' },
	{ city: 'Tyrrellstown (Westmeath)', zip: '124137' },
	{ city: 'Tyrrelstown (Dublin)', zip: '509311' },
	{ city: 'Tyrrelstown Big (Dublin)', zip: '695686' },
	{ city: 'Tyrrelstown Little (Dublin)', zip: '134268' },
	{ city: 'Uggool (Galway)', zip: '385020' },
	{ city: 'Uggool (Mayo)', zip: '972614' },
	{ city: 'Uggoon Lower (Clare)', zip: '761715' },
	{ city: 'Uggoon Upper (Clare)', zip: '554833' },
	{ city: 'Ughtyneill (Meath)', zip: '397642' },
	{ city: 'Ulicksmountain (Galway)', zip: '317603' },
	{ city: 'Ullagha (Kerry)', zip: '164360' },
	{ city: 'Ullanes East (Cork)', zip: '370182' },
	{ city: 'Ullanes West (Cork)', zip: '386183' },
	{ city: 'Ullard (Kilkenny)', zip: '864800' },
	{ city: 'Ullard (Laois)', zip: '590119' },
	{ city: 'Ullard Beg (Carlow)', zip: '900829' },
	{ city: 'Ullard More (Carlow)', zip: '948922' },
	{ city: 'Ullauns (Kerry)', zip: '737886' },
	{ city: 'Ullid (Kilkenny)', zip: '550634' },
	{ city: 'Ullinagh (Monaghan)', zip: '783885' },
	{ city: 'Ulrith (Galway)', zip: '753634' },
	{ city: 'Ulusker (Cork)', zip: '622416' },
	{ city: 'Umberstown Great (Meath)', zip: '578916' },
	{ city: 'Umberstown Little (Meath)', zip: '777546' },
	{ city: 'Umfin Island (Donegal)', zip: '959234' },
	{ city: 'Umgall (Donegal)', zip: '198555' },
	{ city: 'Umlagh (Donegal)', zip: '431299' },
	{ city: 'Umma Beg (Westmeath)', zip: '562532' },
	{ city: 'Umma More (Westmeath)', zip: '504517' },
	{ city: 'Ummera (Cork)', zip: '527527' },
	{ city: 'Ummera (Leitrim)', zip: '611987' },
	{ city: 'Ummera (Tipperary)', zip: '928481' },
	{ city: 'Ummeraboy East (Cork)', zip: '791970' },
	{ city: 'Ummeraboy West (Cork)', zip: '106453' },
	{ city: 'Ummeracly East (Galway)', zip: '118485' },
	{ city: 'Ummeracly West (Galway)', zip: '889135' },
	{ city: 'Ummerafad (Donegal)', zip: '873571' },
	{ city: 'Ummerafree (Monaghan)', zip: '195000' },
	{ city: 'Ummerantarry (Mayo)', zip: '282589' },
	{ city: 'Ummeras Beg (Kildare)', zip: '810514' },
	{ city: 'Ummeras More (Kildare)', zip: '676486' },
	{ city: 'Ummerawirrinan (Donegal)', zip: '121763' },
	{ city: 'Ummeryroe (Sligo)', zip: '122887' },
	{ city: 'Ummoon (Mayo)', zip: '250363' },
	{ city: 'Umrycam (Donegal)', zip: '305582' },
	{ city: 'Umrygar (Wicklow)', zip: '172459' },
	{ city: 'Umuskan (Donegal)', zip: '995787' },
	{ city: 'Underhill (Cork)', zip: '683258' },
	{ city: 'Ungwee (Galway)', zip: '954899' },
	{ city: 'Union (Sligo)', zip: '187656' },
	{ city: 'Unionhall (Cork)', zip: '138223' },
	{ city: 'Unshinagh (Cavan)', zip: '742487' },
	{ city: 'Unshinagh (Leitrim)', zip: '863565' },
	{ city: 'Unshinagh (Monaghan)', zip: '773076' },
	{ city: 'Unshinagh Lower (Donegal)', zip: '482587' },
	{ city: 'Unshinagh Upper (Donegal)', zip: '831224' },
	{ city: 'Unshogagh (Cavan)', zip: '326904' },
	{ city: 'Upperchurch (Tipperary)', zip: '324065' },
	{ city: 'Upper Maymore (Donegal)', zip: '427645' },
	{ city: 'Uppertown (Wicklow)', zip: '330438' },
	{ city: 'Upperwood Demesne (Kilkenny)', zip: '519417' },
	{ city: 'Upton (Carlow)', zip: '455319' },
	{ city: 'Upton (Wexford)', zip: '870413' },
	{ city: 'Uragh (Cavan)', zip: '400232' },
	{ city: 'Uragh (Kerry)', zip: '569181' },
	{ city: 'Uragh (Leitrim)', zip: '112824' },
	{ city: 'Urard (Tipperary)', zip: '287227' },
	{ city: 'Urbal (Cavan)', zip: '689527' },
	{ city: 'Urbal (Donegal)', zip: '229260' },
	{ city: 'Urbal (Leitrim)', zip: '774087' },
	{ city: 'Urbal Barr (Leitrim)', zip: '526112' },
	{ city: 'Urbaldeevan (Donegal)', zip: '292970' },
	{ city: 'Urbalkirk (Monaghan)', zip: '797221' },
	{ city: 'Urbalreagh (Donegal)', zip: '345406' },
	{ city: 'Urbalshinny (Donegal)', zip: '447722' },
	{ city: 'Urcher (Cavan)', zip: '975290' },
	{ city: 'Urcher (Monaghan)', zip: '695750' },
	{ city: 'Uregare (Limerick)', zip: '860983' },
	{ city: 'Urglin (Carlow)', zip: '449881' },
	{ city: 'Urhannagh (Cavan)', zip: '584595' },
	{ city: 'Urhin (Cork)', zip: '831950' },
	{ city: 'Urlan Beg (Clare)', zip: '754725' },
	{ city: 'Urlan More (Clare)', zip: '701148' },
	{ city: 'Urlar (Sligo)', zip: '989157' },
	{ city: 'Urlaur (Mayo)', zip: '601612' },
	{ city: 'Urlee (Kerry)', zip: '166341' },
	{ city: 'Urlingford (Kilkenny)', zip: '392104' },
	{ city: 'Urlish (Monaghan)', zip: '843294' },
	{ city: 'Urney (Cavan)', zip: '802654' },
	{ city: 'Urney (Offaly)', zip: '920629' },
	{ city: 'Urra (Tipperary)', zip: '818762' },
	{ city: 'Urracly (Galway)', zip: '898792' },
	{ city: 'Urraghilbeg (Cork)', zip: '556682' },
	{ city: 'Urraghilmore (Cork)', zip: '637573' },
	{ city: 'Urraghry (Galway)', zip: '888750' },
	{ city: 'Urrasaun (Roscommon)', zip: '865758' },
	{ city: 'Urrismenagh (Donegal)', zip: '489444' },
	{ city: 'Urrohogal (Kerry)', zip: '571056' },
	{ city: 'Ushnagh Hill (Westmeath)', zip: '381468' },
	{ city: 'Usk (Kildare)', zip: '932088' },
	{ city: 'Uskane (Tipperary)', zip: '705173' },
	{ city: 'Uskerty (Kilkenny)', zip: '415355' },
	{ city: 'Usk Little (Kildare)', zip: '453378' },
	{ city: 'Usna (Roscommon)', zip: '271602' },
	{ city: 'Ussaun (Leitrim)', zip: '643522' },
	{ city: 'Ussey (Galway)', zip: '670661' },
	{ city: 'Valencia Island (Kerry)', zip: '910362' },
	{ city: 'Valleymount (Wicklow)', zip: '770534' },
	{ city: "Varley's Island (Galway)", zip: '266323' },
	{ city: 'Veagh (Donegal)', zip: '434857' },
	{ city: 'Veldonstown (Meath)', zip: '888160' },
	{ city: 'Velvetstown (Cork)', zip: '149761' },
	{ city: 'Ventry (Kerry)', zip: '671686' },
	{ city: 'Verdanthill (Tipperary)', zip: '917356' },
	{ city: 'Verdonstown (Louth)', zip: '331510' },
	{ city: 'Vermount (Carlow)', zip: '313362' },
	{ city: 'Vernegly (Wexford)', zip: '756411' },
	{ city: 'Verosland (Wexford)', zip: '857201' },
	{ city: 'Vesingstown (Meath)', zip: '516563' },
	{ city: 'Vesnoy (Roscommon)', zip: '587960' },
	{ city: 'Vessingtown (Meath)', zip: '643208' },
	{ city: 'Vicarschoral Land (Galway)', zip: '143839' },
	{ city: 'Vicarsfield Glebe (Longford)', zip: '793176' },
	{ city: 'Vicarstown (Cork)', zip: '694720' },
	{ city: 'Vicarstown (Kerry)', zip: '262558' },
	{ city: 'Vicarstown (Laois)', zip: '273327' },
	{ city: 'Vicarstown (Longford)', zip: '999186' },
	{ city: 'Vicarstown (Offaly)', zip: '300931' },
	{ city: 'Vicarstown North (Waterford)', zip: '480483' },
	{ city: 'Vicarstown South (Waterford)', zip: '461251' },
	{ city: 'Vilanstown (Westmeath)', zip: '664881' },
	{ city: 'Villierstown (Waterford)', zip: '576305' },
	{ city: 'Vinepark (Cork)', zip: '710262' },
	{ city: 'Vinesgrove (Kilkenny)', zip: '593629' },
	{ city: 'Violethill (Clare)', zip: '568512' },
	{ city: 'Viperkells (Kilkenny)', zip: '253465' },
	{ city: 'Virginia (Cavan)', zip: '749611' },
	{ city: 'Volvenstown (Meath)', zip: '640257' },
	{ city: 'Waddingsland (Wexford)', zip: '953964' },
	{ city: 'Waddingstown (Kilkenny)', zip: '746911' },
	{ city: 'Waddingtown (Wexford)', zip: '627848' },
	{ city: 'Wadestown (Westmeath)', zip: '565385' },
	{ city: 'Walderstown (Westmeath)', zip: '257945' },
	{ city: 'Walkinslough (Kilkenny)', zip: '455117' },
	{ city: 'Walkinstown (Dublin)', zip: '531663' },
	{ city: "Waller's-Lot (Tipperary)", zip: '711168' },
	{ city: 'Wallingstown (Cork)', zip: '997981' },
	{ city: 'Wallscourt (Galway)', zip: '298227' },
	{ city: 'Wallslough (Kilkenny)', zip: '946506' },
	{ city: 'Wallstown (Cork)', zip: '802012' },
	{ city: 'Wallstown (Kilkenny)', zip: '836780' },
	{ city: 'Walsheslough (Wexford)', zip: '417482' },
	{ city: 'Walshestown (Cork)', zip: '665708' },
	{ city: 'Walshestown (Dublin)', zip: '792925' },
	{ city: 'Walshestown (Kildare)', zip: '357296' },
	{ city: 'Walshestown (Limerick)', zip: '708040' },
	{ city: 'Walshestown (Louth)', zip: '990322' },
	{ city: 'Walshestown (Wexford)', zip: '962907' },
	{ city: 'Walshestown North (Westmeath)', zip: '842131' },
	{ city: 'Walshestown South (Westmeath)', zip: '627013' },
	{ city: 'Walshgraigue (Wexford)', zip: '390788' },
	{ city: 'Walshisland (Offaly)', zip: '764012' },
	{ city: 'Walshpark (Tipperary)', zip: '137948' },
	{ city: 'Walshpool (Mayo)', zip: '480891' },
	{ city: 'Walshsbog (Tipperary)', zip: '431171' },
	{ city: "Walsh's Island (Galway)", zip: '320160' },
	{ city: 'Walshstown (Carlow)', zip: '609979' },
	{ city: 'Walshtown (Galway)', zip: '289220' },
	{ city: 'Walshtown Beg (Cork)', zip: '628230' },
	{ city: 'Walshtown More (Cork)', zip: '490436' },
	{ city: 'Walshtown More East (Cork)', zip: '651953' },
	{ city: 'Walshtown More West (Cork)', zip: '326768' },
	{ city: 'Waltersland (Dublin)', zip: '695876' },
	{ city: 'Walterstown (Cork)', zip: '351091' },
	{ city: 'Walterstown (Kildare)', zip: '177416' },
	{ city: 'Walterstown (Louth)', zip: '324901' },
	{ city: 'Walterstown (Meath)', zip: '100700' },
	{ city: 'Walterstown (Westmeath)', zip: '357384' },
	{ city: 'Walterstown (Wicklow)', zip: '831304' },
	{ city: 'Walterstown Lower (Kildare)', zip: '517664' },
	{ city: "Walton's Grove (Kilkenny)", zip: '147456' },
	{ city: 'Warblestown (Dublin)', zip: '596700' },
	{ city: 'Wardenstown (Westmeath)', zip: '798371' },
	{ city: 'Wardhouse (Leitrim)', zip: '309201' },
	{ city: 'Ward Lower (Dublin)', zip: '775021' },
	{ city: 'Wards Of Tober (Wicklow)', zip: '610339' },
	{ city: 'Wardstown (Meath)', zip: '583377' },
	{ city: 'Ward Upper (Dublin)', zip: '182991' },
	{ city: 'Warren (Roscommon)', zip: '150130' },
	{ city: 'Warren High (Westmeath)', zip: '508035' },
	{ city: 'Warren Lower (Westmeath)', zip: '177006' },
	{ city: 'Warren Lower (Wexford)', zip: '353956' },
	{ city: 'Warren Middle (Wexford)', zip: '779924' },
	{ city: 'Warrens Fields (Westmeath)', zip: '654113' },
	{ city: 'Warrensgrove (Cork)', zip: '152482' },
	{ city: 'Warrenstown (Kilkenny)', zip: '915264' },
	{ city: 'Warrenstown (Meath)', zip: '725662' },
	{ city: 'Warrentown (Donegal)', zip: '146832' },
	{ city: 'Warrentown Mountain North (Donegal)', zip: '153440' },
	{ city: 'Warrentown Mountain South (Donegal)', zip: '891939' },
	{ city: 'Warrington (Kilkenny)', zip: '291669' },
	{ city: 'Washers Bog (Kilkenny)', zip: '636886' },
	{ city: 'Waste (Wexford)', zip: '649593' },
	{ city: 'Watercastle (Laois)', zip: '759433' },
	{ city: 'Waterdale (Galway)', zip: '101036' },
	{ city: 'Waterdyke (Cork)', zip: '616904' },
	{ city: 'Waterford (Waterford)', zip: '307021' },
	{ city: 'Watergrange (Kildare)', zip: '300151' },
	{ city: 'Watergrasshill (Cork)', zip: '667423' },
	{ city: 'Waterhouse (Cork)', zip: '339229' },
	{ city: 'Waterland (Kilkenny)', zip: '842461' },
	{ city: 'Waterpark (Cork)', zip: '154799' },
	{ city: 'Waterpark (Limerick)', zip: '395111' },
	{ city: 'Water-Rock (Cork)', zip: '150787' },
	{ city: 'Waterside Great (Meath)', zip: '405007' },
	{ city: 'Waterside Little (Meath)', zip: '616775' },
	{ city: 'Waters-Land North (Cork)', zip: '736525' },
	{ city: 'Waters-Land South (Cork)', zip: '418513' },
	{ city: 'Waterstown (Carlow)', zip: '874532' },
	{ city: 'Waterstown (Kildare)', zip: '192604' },
	{ city: 'Waterstown (Westmeath)', zip: '216302' },
	{ city: 'Waterville (Kerry)', zip: '261553' },
	{ city: 'Watree (Kilkenny)', zip: '338007' },
	{ city: 'Wattstown (Westmeath)', zip: '527347' },
	{ city: 'Waynestown (Meath)', zip: '489826' },
	{ city: 'Weatherfort (Mayo)', zip: '271036' },
	{ city: 'Weatherstown (Kilkenny)', zip: '665848' },
	{ city: 'Weatherstown (Meath)', zip: '754713' },
	{ city: 'Webbsborough (Kilkenny)', zip: '307618' },
	{ city: 'Welchtown (Donegal)', zip: '898086' },
	{ city: 'Wellfield (Limerick)', zip: '742621' },
	{ city: 'Wellington (Tipperary)', zip: '303598' },
	{ city: 'Wellingtonbridge (Wexford)', zip: '339096' },
	{ city: 'Wellpark (Galway)', zip: '993953' },
	{ city: 'Wells (Carlow)', zip: '920038' },
	{ city: 'Wells (Wexford)', zip: '800207' },
	{ city: 'Wellshill (Wexford)', zip: '441845' },
	{ city: 'Weneytown (Wexford)', zip: '616343' },
	{ city: 'Westaston Demesne (Wicklow)', zip: '434477' },
	{ city: 'Westaston Hill (Wicklow)', zip: '879889' },
	{ city: 'Westcourt Commons (Kilkenny)', zip: '570097' },
	{ city: 'Westcourt Demesne (Kilkenny)', zip: '367576' },
	{ city: 'Westcourt North (Kilkenny)', zip: '407573' },
	{ city: 'Westcourt South (Kilkenny)', zip: '487936' },
	{ city: 'Westereave (Dublin)', zip: '971864' },
	{ city: 'Westland (Mayo)', zip: '665666' },
	{ city: 'Westmanstown (Dublin)', zip: '469294' },
	{ city: 'Westmoreland (Kilkenny)', zip: '783848' },
	{ city: 'Weston (Galway)', zip: '777042' },
	{ city: 'Westonslot (Tipperary)', zip: '575256' },
	{ city: 'Westown (Dublin)', zip: '381274' },
	{ city: 'Westown (Kildare)', zip: '279827' },
	{ city: 'Westpalstown (Dublin)', zip: '334113' },
	{ city: 'Westport (Mayo)', zip: '619781' },
	{ city: 'Westport Demesne (Mayo)', zip: '929779' },
	{ city: 'Westquarter (Galway)', zip: '291021' },
	{ city: 'Westtown (Waterford)', zip: '373182' },
	{ city: 'Wetland (Kilkenny)', zip: '346000' },
	{ city: 'Wetmeadows (Wexford)', zip: '697688' },
	{ city: 'Wevil (Kildare)', zip: '328319' },
	{ city: 'Wexford (Wexford)', zip: '393631' },
	{ city: 'Wheatfield Lower (Kildare)', zip: '445775' },
	{ city: 'Wheatfield Upper (Kildare)', zip: '116749' },
	{ city: 'Wheelagower (Wexford)', zip: '335977' },
	{ city: 'Wheelam (Kildare)', zip: '744733' },
	{ city: 'Wheery (Offaly)', zip: '764557' },
	{ city: 'Wherrew (Mayo)', zip: '487743' },
	{ city: 'Whiddy Island (Cork)', zip: '206707' },
	{ city: 'Whigsborough (Offaly)', zip: '706051' },
	{ city: 'Whinning (Westmeath)', zip: '391752' },
	{ city: 'Whistlemount (Meath)', zip: '509569' },
	{ city: 'Whitebarn (Cork)', zip: '663353' },
	{ city: 'Whitebog (Cork)', zip: '595631' },
	{ city: 'Whitebog (Laois)', zip: '649220' },
	{ city: 'Whitecastle (Donegal)', zip: '585544' },
	{ city: 'Whitechurch (Cork)', zip: '821847' },
	{ city: 'Whitechurch (Dublin)', zip: '218614' },
	{ city: 'Whitechurch (Kildare)', zip: '352315' },
	{ city: 'Whitechurch (Kilkenny)', zip: '746313' },
	{ city: 'Whitechurch (Tipperary)', zip: '129944' },
	{ city: 'Whitechurch (Waterford)', zip: '355346' },
	{ city: 'Whitechurch (Wexford)', zip: '811158' },
	{ city: 'Whitecommons (Meath)', zip: '810892' },
	{ city: 'Whitecross (Louth)', zip: '647341' },
	{ city: 'Whitecross (Meath)', zip: '483899' },
	{ city: 'Whitecross Glebe (Meath)', zip: '380886' },
	{ city: 'Whitefield (Kerry)', zip: '321899' },
	{ city: 'Whitefield (Laois)', zip: '305460' },
	{ city: 'Whitefield (Tipperary)', zip: '544496' },
	{ city: 'Whitefield (Waterford)', zip: '512328' },
	{ city: 'Whitefield (Wicklow)', zip: '471496' },
	{ city: 'Whitefort (Tipperary)', zip: '988512' },
	{ city: 'Whitefort (Wexford)', zip: '770218' },
	{ city: 'Whitegate (Clare)', zip: '860143' },
	{ city: 'Whitegate (Cork)', zip: '175481' },
	{ city: 'Whitegates (Galway)', zip: '739580' },
	{ city: 'Whitegoat Rock (Galway)', zip: '358101' },
	{ city: 'Whitehall (Cork)', zip: '279544' },
	{ city: 'Whitehall (Dublin)', zip: '879647' },
	{ city: 'Whitehall (Limerick)', zip: '101226' },
	{ city: 'Whitehall (Meath)', zip: '733751' },
	{ city: 'Whitehall (Roscommon)', zip: '508576' },
	{ city: 'Whitehall (Tipperary)', zip: '575997' },
	{ city: 'Whitehill (Donegal)', zip: '204058' },
	{ city: 'Whitehill (Sligo)', zip: '545523' },
	{ city: 'Whitehills (Wicklow)', zip: '278433' },
	{ city: 'Whitehouse (Donegal)', zip: '427726' },
	{ city: 'Whitehouse (Kildare)', zip: '812223' },
	{ city: 'Whitehouse (Kilkenny)', zip: '550573' },
	{ city: 'Whitehouse (Wexford)', zip: '678638' },
	{ city: 'Whitehousequarter (Waterford)', zip: '661151' },
	{ city: 'White Island (Galway)', zip: '370055' },
	{ city: 'White Island (Monaghan)', zip: '321019' },
	{ city: 'Whiteland (Tipperary)', zip: '413127' },
	{ city: 'Whiteleas (Kildare)', zip: '579739' },
	{ city: 'Whiteleas (Meath)', zip: '444592' },
	{ city: 'Whitemill (Louth)', zip: '687082' },
	{ city: 'Whitemill North (Wexford)', zip: '470584' },
	{ city: 'Whitemill South (Wexford)', zip: '107706' },
	{ city: 'Whitepark (Galway)', zip: '674809' },
	{ city: 'Whitepark (Mayo)', zip: '151210' },
	{ city: 'Whitepark (Tipperary)', zip: '633514' },
	{ city: 'Whitepark (Wexford)', zip: '787257' },
	{ city: 'Whiterath (Louth)', zip: '549860' },
	{ city: 'Whiteriver (Louth)', zip: '167054' },
	{ city: 'Whiterock (Cork)', zip: '140539' },
	{ city: 'Whiterock (Leitrim)', zip: '427776' },
	{ city: 'Whiterock (Longford)', zip: '804293' },
	{ city: 'Whiterock (Wicklow)', zip: '589397' },
	{ city: 'Whiterock North (Wexford)', zip: '258827' },
	{ city: 'Whiterock South (Wexford)', zip: '535651' },
	{ city: 'Whitescastle Lower (Kilkenny)', zip: '785861' },
	{ city: 'Whitescastle Upper (Kilkenny)', zip: '830468' },
	{ city: 'Whitesfort (Waterford)', zip: '442554' },
	{ city: 'Whitesland (Kilkenny)', zip: '962371' },
	{ city: 'Whitesland (Meath)', zip: '252676' },
	{ city: 'Whitesland East (Kildare)', zip: '628377' },
	{ city: 'Whitesland West (Kildare)', zip: '814891' },
	{ city: 'Whitestown (Dublin)', zip: '842664' },
	{ city: 'Whitestown (Louth)', zip: '183535' },
	{ city: 'Whitestown (Waterford)', zip: '440970' },
	{ city: 'Whitestown (Wexford)', zip: '514845' },
	{ city: 'Whitestown East (Waterford)', zip: '436343' },
	{ city: 'Whitestown Lower (Wexford)', zip: '415270' },
	{ city: 'Whitestown Lower (Wicklow)', zip: '338806' },
	{ city: 'Whitestown Upper (Wexford)', zip: '702555' },
	{ city: 'Whitestown Upper (Wicklow)', zip: '225859' },
	{ city: 'Whitestown West (Waterford)', zip: '875499' },
	{ city: 'Whiteswall (Kilkenny)', zip: '121876' },
	{ city: 'Whitewell (Westmeath)', zip: '470232' },
	{ city: 'Whitewell (Wexford)', zip: '102571' },
	{ city: 'Whitewood (Meath)', zip: '549656' },
	{ city: 'Whitfield North (Waterford)', zip: '482971' },
	{ city: 'Whitfield South (Waterford)', zip: '536751' },
	{ city: 'Whitstone (Tipperary)', zip: '779491' },
	{ city: 'Whittyshill (Wexford)', zip: '641653' },
	{ city: 'Wicklow (Wicklow)', zip: '665643' },
	{ city: 'Wildfield (Kilkenny)', zip: '497145' },
	{ city: 'Wilford (Mayo)', zip: '760322' },
	{ city: 'Wilkinstown (Dublin)', zip: '560674' },
	{ city: 'Wilkinstown (Meath)', zip: '357168' },
	{ city: 'Wilkinstown (Wexford)', zip: '647196' },
	{ city: 'Willbrook (Dublin)', zip: '984620' },
	{ city: 'Williamstown (Carlow)', zip: '928766' },
	{ city: 'Williamstown (Cork)', zip: '764549' },
	{ city: 'Williamstown (Dublin)', zip: '244887' },
	{ city: 'Williamstown (Galway)', zip: '275584' },
	{ city: 'Williamstown (Kildare)', zip: '505162' },
	{ city: 'Williamstown (Limerick)', zip: '449411' },
	{ city: 'Williamstown (Louth)', zip: '473577' },
	{ city: 'Williamstown (Meath)', zip: '936298' },
	{ city: 'Williamstown (Tipperary)', zip: '909239' },
	{ city: 'Williamstown (Waterford)', zip: '692020' },
	{ city: 'Williamstown (Westmeath)', zip: '795867' },
	{ city: 'Williamstown New (Westmeath)', zip: '849363' },
	{ city: 'Willisson (Tipperary)', zip: '901309' },
	{ city: 'Willistown (Louth)', zip: '738469' },
	{ city: 'Willowbrook (Sligo)', zip: '320799' },
	{ city: 'Willowhill (Cork)', zip: '320449' },
	{ city: 'Willsborough (Roscommon)', zip: '963624' },
	{ city: 'Willsborough (Tipperary)', zip: '210840' },
	{ city: 'Willsbrook (Longford)', zip: '979264' },
	{ city: 'Willsbrook (Roscommon)', zip: '239778' },
	{ city: 'Willsgrove (Kildare)', zip: '742434' },
	{ city: 'Willsgrove (Roscommon)', zip: '778467' },
	{ city: 'Willville (Louth)', zip: '753558' },
	{ city: 'Wilmount (Meath)', zip: '991904' },
	{ city: 'Wilton (Offaly)', zip: '358062' },
	{ city: 'Wilton (Tipperary)', zip: '226581' },
	{ city: 'Wilton (Wexford)', zip: '925170' },
	{ city: 'Wimbletown (Dublin)', zip: '873291' },
	{ city: 'Windfield (Galway)', zip: '472892' },
	{ city: 'Windfield Demesne (Galway)', zip: '286971' },
	{ city: 'Windfield Lower (Galway)', zip: '356566' },
	{ city: 'Windfield Upper (Galway)', zip: '891592' },
	{ city: 'Windgap (Kilkenny)', zip: '790970' },
	{ city: 'Windgap (Waterford)', zip: '453130' },
	{ city: 'Windgate (Wicklow)', zip: '187940' },
	{ city: 'Windgates (Kildare)', zip: '545248' },
	{ city: 'Windmill (Kildare)', zip: '927679' },
	{ city: 'Windmill (Louth)', zip: '530276' },
	{ city: 'Windmill (Tipperary)', zip: '763923' },
	{ city: 'Windmill (Westmeath)', zip: '471255' },
	{ city: 'Windmillhill (Dublin)', zip: '251067' },
	{ city: 'Windmill Lands (Dublin)', zip: '957070' },
	{ city: 'Windsor (Cork)', zip: '318731' },
	{ city: 'Windsor (Laois)', zip: '410537' },
	{ city: 'Windtown (Meath)', zip: '344360' },
	{ city: 'Windtown (Westmeath)', zip: '171091' },
	{ city: 'Windtown North (Westmeath)', zip: '697718' },
	{ city: 'Windtown South (Westmeath)', zip: '388721' },
	{ city: 'Windy Arbour (Dublin)', zip: '495437' },
	{ city: 'Windygap (Tipperary)', zip: '456153' },
	{ city: 'Windyhall (Donegal)', zip: '878779' },
	{ city: 'Winetavern (Wicklow)', zip: '577266' },
	{ city: 'Wingfield (Tipperary)', zip: '406291' },
	{ city: 'Wingfield (Wexford)', zip: '751665' },
	{ city: 'Wingfield (Wicklow)', zip: '744920' },
	{ city: 'Winnings (Dublin)', zip: '970389' },
	{ city: 'Winningtown (Wexford)', zip: '847512' },
	{ city: 'Winnyhaw (Donegal)', zip: '170936' },
	{ city: 'Winterhill (Donegal)', zip: '958704' },
	{ city: 'Wintsmills (Cork)', zip: '405305' },
	{ city: 'Wolfesburgess East (Limerick)', zip: '818704' },
	{ city: 'Wolfesburgess West (Limerick)', zip: '632814' },
	{ city: 'Wolfestown (Kildare)', zip: '418744' },
	{ city: 'Wolfhill (Laois)', zip: '966986' },
	{ city: 'Wolganstown (Dublin)', zip: '971884' },
	{ city: 'Wonderhill (Limerick)', zip: '971805' },
	{ city: 'Wood (Donegal)', zip: '514284' },
	{ city: 'Wood (Offaly)', zip: '295490' },
	{ city: 'Woodberry (Galway)', zip: '382141' },
	{ city: 'Woodbrook (Galway)', zip: '880926' },
	{ city: 'Woodbrook (Roscommon)', zip: '330390' },
	{ city: 'Woodbrook Demesne (Wexford)', zip: '836279' },
	{ city: 'Woodcockhill (Clare)', zip: '942688' },
	{ city: 'Woodcockstown (Meath)', zip: '224412' },
	{ city: 'Wooddown (Westmeath)', zip: '408394' },
	{ city: 'Woodenboley (Wicklow)', zip: '309273' },
	{ city: 'Woodfarm (Dublin)', zip: '447707' },
	{ city: 'Woodfarm (Limerick)', zip: '556064' },
	{ city: 'Woodfield (Clare)', zip: '114800' },
	{ city: 'Woodfield (Cork)', zip: '364370' },
	{ city: 'Woodfield (Galway)', zip: '387360' },
	{ city: 'Woodfield (Limerick)', zip: '550536' },
	{ city: 'Woodfield (Mayo)', zip: '290595' },
	{ city: 'Woodfield (Offaly)', zip: '469653' },
	{ city: 'Woodfield (Roscommon)', zip: '701115' },
	{ city: 'Woodfield (Sligo)', zip: '448558' },
	{ city: 'Woodfield (Wicklow)', zip: '887985' },
	{ city: 'Woodfieldglen (Wicklow)', zip: '392221' },
	{ city: 'Woodford (Galway)', zip: '206798' },
	{ city: 'Woodford (Tipperary)', zip: '255973' },
	{ city: 'Woodford Demesne (Leitrim)', zip: '926073' },
	{ city: 'Woodgraigue (Wexford)', zip: '625474' },
	{ city: 'Woodhill (Donegal)', zip: '807511' },
	{ city: 'Woodhouse (Louth)', zip: '732046' },
	{ city: 'Woodhouse (Tipperary)', zip: '389224' },
	{ city: 'Woodhouse (Waterford)', zip: '306232' },
	{ city: 'Woodinstown (Tipperary)', zip: '456329' },
	{ city: 'Wood Island (Donegal)', zip: '808816' },
	{ city: 'Wood Island (Galway)', zip: '889569' },
	{ city: 'Woodland (Cavan)', zip: '435078' },
	{ city: 'Woodland (Donegal)', zip: '322626' },
	{ city: 'Woodland (Dublin)', zip: '389771' },
	{ city: 'Woodland (Laois)', zip: '164095' },
	{ city: 'Woodland (Louth)', zip: '781362' },
	{ city: 'Woodland (Meath)', zip: '131465' },
	{ city: 'Woodlands (Carlow)', zip: '721989' },
	{ city: 'Woodlands (Cork)', zip: '420182' },
	{ city: 'Woodlands (Donegal)', zip: '532101' },
	{ city: 'Woodlands (Dublin)', zip: '575952' },
	{ city: 'Woodlands (Kilkenny)', zip: '399389' },
	{ city: 'Woodlands (Tipperary)', zip: '651426' },
	{ city: 'Woodlands (Wexford)', zip: '116618' },
	{ city: 'Woodlands (Wicklow)', zip: '387962' },
	{ city: 'Woodlands East (Kildare)', zip: '211535' },
	{ city: 'Woodlands West (Kildare)', zip: '192557' },
	{ city: 'Woodlawn (Galway)', zip: '417669' },
	{ city: 'Woodlawn (Kerry)', zip: '433936' },
	{ city: 'Woodlawn (Longford)', zip: '578877' },
	{ city: 'Woodmount (Clare)', zip: '486071' },
	{ city: 'Wood Of O (Offaly)', zip: '951311' },
	{ city: 'Woodpark (Clare)', zip: '721212' },
	{ city: 'Woodpark (Cork)', zip: '446080' },
	{ city: 'Woodpark (Donegal)', zip: '805809' },
	{ city: 'Woodpark (Dublin)', zip: '474662' },
	{ city: 'Woodpark (Galway)', zip: '772048' },
	{ city: 'Woodpark (Limerick)', zip: '577126' },
	{ city: 'Woodpark (Mayo)', zip: '382877' },
	{ city: 'Woodpark (Meath)', zip: '911173' },
	{ city: 'Woodpark (Sligo)', zip: '548583' },
	{ city: 'Woodpark (Tipperary)', zip: '536012' },
	{ city: 'Woodpark (Wexford)', zip: '965236' },
	{ city: 'Woodpole (Meath)', zip: '586546' },
	{ city: 'Woodquarter (Donegal)', zip: '626626' },
	{ city: 'Woodquarter (Kilkenny)', zip: '127072' },
	{ city: 'Woodquay (Galway)', zip: '667959' },
	{ city: 'Woodroad (Limerick)', zip: '300013' },
	{ city: 'Woodrooff (Tipperary)', zip: '197780' },
	{ city: 'Woods (Mayo)', zip: '294057' },
	{ city: 'Woodsgift (Kilkenny)', zip: '369068' },
	{ city: 'Woodside (Carlow)', zip: '555428' },
	{ city: 'Woodside (Cork)', zip: '970620' },
	{ city: 'Woodside (Dublin)', zip: '786522' },
	{ city: 'Woodside (Meath)', zip: '474858' },
	{ city: 'Woodstock (Cork)', zip: '307474' },
	{ city: 'Woodstock (Limerick)', zip: '875112' },
	{ city: 'Woodstock (Mayo)', zip: '103543' },
	{ city: 'Woodstock (Waterford)', zip: '610337' },
	{ city: 'Woodstock Demesne (Wicklow)', zip: '856424' },
	{ city: 'Woodstock North (Kildare)', zip: '261418' },
	{ city: 'Woodstock South (Kildare)', zip: '877015' },
	{ city: 'Woodstown (Limerick)', zip: '964161' },
	{ city: 'Woodstown (Waterford)', zip: '283197' },
	{ city: 'Woodstown Lower (Waterford)', zip: '714982' },
	{ city: 'Woodstown Upper (Waterford)', zip: '889679' },
	{ city: 'Woodtown (Donegal)', zip: '698429' },
	{ city: 'Woodtown (Dublin)', zip: '480418' },
	{ city: 'Woodtown (Louth)', zip: '451910' },
	{ city: 'Woodtown (Meath)', zip: '172064' },
	{ city: 'Woodtown (Wexford)', zip: '429510' },
	{ city: 'Woodtown Lower (Meath)', zip: '567671' },
	{ city: 'Woodtown Upper (Meath)', zip: '280065' },
	{ city: 'Woodtown West (Meath)', zip: '843929' },
	{ city: 'Woodview (Cork)', zip: '344425' },
	{ city: 'Woodville (Dublin)', zip: '203695' },
	{ city: 'Woodville (Kilkenny)', zip: '371192' },
	{ city: 'Woodville (Mayo)', zip: '685085' },
	{ city: 'Woodville (Tipperary)', zip: '708840' },
	{ city: 'Woodville (Waterford)', zip: '564515' },
	{ city: 'Woolengrange (Kilkenny)', zip: '760741' },
	{ city: 'Worlough (Wexford)', zip: '453614' },
	{ city: 'Wormhole (Galway)', zip: '482818' },
	{ city: 'Woteraghy (Cavan)', zip: '999968' },
	{ city: 'Wotton (Meath)', zip: '483936' },
	{ city: 'Wottonstown (Louth)', zip: '697030' },
	{ city: 'Wranglestown (Laois)', zip: '535246' },
	{ city: 'Wrensborough (Tipperary)', zip: '373249' },
	{ city: 'Wyanstown (Dublin)', zip: '223469' },
	{ city: 'Wyanstown (Louth)', zip: '298030' },
	{ city: 'Wyestown (Dublin)', zip: '680968' },
	{ city: 'Yardland (Wicklow)', zip: '695460' },
	{ city: 'Yellowbatter (Louth)', zip: '852502' },
	{ city: 'Yellowbogcommon (Kildare)', zip: '236156' },
	{ city: 'Yellowford (Cork)', zip: '994961' },
	{ city: 'Yellow Furze (Meath)', zip: '652162' },
	{ city: 'Yellowleas (Meath)', zip: '673533' },
	{ city: 'Yellowmeadows (Dublin)', zip: '682902' },
	{ city: 'Yellowshar (Meath)', zip: '588090' },
	{ city: 'Yellow Walls (Dublin)', zip: '720770' },
	{ city: 'Yellow Walls (Meath)', zip: '839680' },
	{ city: 'Yeomanstown (Kildare)', zip: '741945' },
	{ city: 'Yewer Glebe (Cavan)', zip: '739839' },
	{ city: 'Yolegrew (Wexford)', zip: '115427' },
	{ city: 'Yoletown (Wexford)', zip: '901196' },
	{ city: 'Yorkfield (Westmeath)', zip: '428706' },
	{ city: 'Youghal (Cork)', zip: '910814' },
	{ city: 'Youghal (Tipperary)', zip: '932862' },
	{ city: 'Youghal-Lands (Cork)', zip: '843268' },
	{ city: 'Youghal Mudlands (Cork)', zip: '511441' },
	{ city: 'Youghalpark (Cork)', zip: '731671' },
	{ city: 'Youghals (Cork)', zip: '974784' },
	{ city: 'Youghalvillage (Tipperary)', zip: '233700' },
	{ city: 'Youngfield (Cork)', zip: '153097' },
	{ city: 'Young-Grove (Cork)', zip: '261112' },
	{ city: "Young's Island (Kerry)", zip: '658250' },
	{ city: 'Youngstown (Kildare)', zip: '768967' },
	{ city: 'Youngstown (Wexford)', zip: '303724}' },
];
